import * as Vr from "react";
import nc, { useCallback as ho, useEffect as hM, useLayoutEffect as bH, createContext as SH, useContext as CH, useMemo as Fd, useRef as Ya, createElement as i7, useDebugValue as a7, useState as RR, memo as o7 } from "react";
function s7(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var mE = { exports: {} }, f_ = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var AV;
function l7() {
  return AV || (AV = 1, process.env.NODE_ENV !== "production" && function() {
    "use strict";
    var e = nc, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), d = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), k = Symbol.iterator, O = "@@iterator";
    function D(U) {
      if (U === null || typeof U != "object")
        return null;
      var ke = k && U[k] || U[O];
      return typeof ke == "function" ? ke : null;
    }
    var L = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function F(U) {
      {
        for (var ke = arguments.length, ze = new Array(ke > 1 ? ke - 1 : 0), vt = 1; vt < ke; vt++)
          ze[vt - 1] = arguments[vt];
        z("error", U, ze);
      }
    }
    function z(U, ke, ze) {
      {
        var vt = L.ReactDebugCurrentFrame, It = vt.getStackAddendum();
        It !== "" && (ke += "%s", ze = ze.concat([It]));
        var Kt = ze.map(function(Nt) {
          return String(Nt);
        });
        Kt.unshift("Warning: " + ke), Function.prototype.apply.call(console[U], console, Kt);
      }
    }
    var V = !1, P = !1, j = !1, Z = !1, ee = !1, J;
    J = Symbol.for("react.module.reference");
    function he(U) {
      return !!(typeof U == "string" || typeof U == "function" || U === n || U === s || ee || U === i || U === p || U === m || Z || U === T || V || P || j || typeof U == "object" && U !== null && (U.$$typeof === S || U.$$typeof === x || U.$$typeof === l || U.$$typeof === d || U.$$typeof === h || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      U.$$typeof === J || U.getModuleId !== void 0));
    }
    function de(U, ke, ze) {
      var vt = U.displayName;
      if (vt)
        return vt;
      var It = ke.displayName || ke.name || "";
      return It !== "" ? ze + "(" + It + ")" : ze;
    }
    function Re(U) {
      return U.displayName || "Context";
    }
    function Ce(U) {
      if (U == null)
        return null;
      if (typeof U.tag == "number" && F("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof U == "function")
        return U.displayName || U.name || null;
      if (typeof U == "string")
        return U;
      switch (U) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case s:
          return "Profiler";
        case i:
          return "StrictMode";
        case p:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof U == "object")
        switch (U.$$typeof) {
          case d:
            var ke = U;
            return Re(ke) + ".Consumer";
          case l:
            var ze = U;
            return Re(ze._context) + ".Provider";
          case h:
            return de(U, U.render, "ForwardRef");
          case x:
            var vt = U.displayName || null;
            return vt !== null ? vt : Ce(U.type) || "Memo";
          case S: {
            var It = U, Kt = It._payload, Nt = It._init;
            try {
              return Ce(Nt(Kt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var le = Object.assign, me = 0, fe, Ee, Q, pe, G, se, Te;
    function Pe() {
    }
    Pe.__reactDisabledLog = !0;
    function Ie() {
      {
        if (me === 0) {
          fe = console.log, Ee = console.info, Q = console.warn, pe = console.error, G = console.group, se = console.groupCollapsed, Te = console.groupEnd;
          var U = {
            configurable: !0,
            enumerable: !0,
            value: Pe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: U,
            log: U,
            warn: U,
            error: U,
            group: U,
            groupCollapsed: U,
            groupEnd: U
          });
        }
        me++;
      }
    }
    function He() {
      {
        if (me--, me === 0) {
          var U = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: le({}, U, {
              value: fe
            }),
            info: le({}, U, {
              value: Ee
            }),
            warn: le({}, U, {
              value: Q
            }),
            error: le({}, U, {
              value: pe
            }),
            group: le({}, U, {
              value: G
            }),
            groupCollapsed: le({}, U, {
              value: se
            }),
            groupEnd: le({}, U, {
              value: Te
            })
          });
        }
        me < 0 && F("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ue = L.ReactCurrentDispatcher, Ze;
    function Qe(U, ke, ze) {
      {
        if (Ze === void 0)
          try {
            throw Error();
          } catch (It) {
            var vt = It.stack.trim().match(/\n( *(at )?)/);
            Ze = vt && vt[1] || "";
          }
        return `
` + Ze + U;
      }
    }
    var it = !1, We;
    {
      var _t = typeof WeakMap == "function" ? WeakMap : Map;
      We = new _t();
    }
    function xe(U, ke) {
      if (!U || it)
        return "";
      {
        var ze = We.get(U);
        if (ze !== void 0)
          return ze;
      }
      var vt;
      it = !0;
      var It = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Kt;
      Kt = Ue.current, Ue.current = null, Ie();
      try {
        if (ke) {
          var Nt = function() {
            throw Error();
          };
          if (Object.defineProperty(Nt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Nt, []);
            } catch (Jt) {
              vt = Jt;
            }
            Reflect.construct(U, [], Nt);
          } else {
            try {
              Nt.call();
            } catch (Jt) {
              vt = Jt;
            }
            U.call(Nt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Jt) {
            vt = Jt;
          }
          U();
        }
      } catch (Jt) {
        if (Jt && vt && typeof Jt.stack == "string") {
          for (var gt = Jt.stack.split(`
`), On = vt.stack.split(`
`), Mr = gt.length - 1, Lr = On.length - 1; Mr >= 1 && Lr >= 0 && gt[Mr] !== On[Lr]; )
            Lr--;
          for (; Mr >= 1 && Lr >= 0; Mr--, Lr--)
            if (gt[Mr] !== On[Lr]) {
              if (Mr !== 1 || Lr !== 1)
                do
                  if (Mr--, Lr--, Lr < 0 || gt[Mr] !== On[Lr]) {
                    var gi = `
` + gt[Mr].replace(" at new ", " at ");
                    return U.displayName && gi.includes("<anonymous>") && (gi = gi.replace("<anonymous>", U.displayName)), typeof U == "function" && We.set(U, gi), gi;
                  }
                while (Mr >= 1 && Lr >= 0);
              break;
            }
        }
      } finally {
        it = !1, Ue.current = Kt, He(), Error.prepareStackTrace = It;
      }
      var Hs = U ? U.displayName || U.name : "", Gh = Hs ? Qe(Hs) : "";
      return typeof U == "function" && We.set(U, Gh), Gh;
    }
    function Je(U, ke, ze) {
      return xe(U, !1);
    }
    function Pt(U) {
      var ke = U.prototype;
      return !!(ke && ke.isReactComponent);
    }
    function bt(U, ke, ze) {
      if (U == null)
        return "";
      if (typeof U == "function")
        return xe(U, Pt(U));
      if (typeof U == "string")
        return Qe(U);
      switch (U) {
        case p:
          return Qe("Suspense");
        case m:
          return Qe("SuspenseList");
      }
      if (typeof U == "object")
        switch (U.$$typeof) {
          case h:
            return Je(U.render);
          case x:
            return bt(U.type, ke, ze);
          case S: {
            var vt = U, It = vt._payload, Kt = vt._init;
            try {
              return bt(Kt(It), ke, ze);
            } catch {
            }
          }
        }
      return "";
    }
    var ir = Object.prototype.hasOwnProperty, Cr = {}, qt = L.ReactDebugCurrentFrame;
    function ur(U) {
      if (U) {
        var ke = U._owner, ze = bt(U.type, U._source, ke ? ke.type : null);
        qt.setExtraStackFrame(ze);
      } else
        qt.setExtraStackFrame(null);
    }
    function Fr(U, ke, ze, vt, It) {
      {
        var Kt = Function.call.bind(ir);
        for (var Nt in U)
          if (Kt(U, Nt)) {
            var gt = void 0;
            try {
              if (typeof U[Nt] != "function") {
                var On = Error((vt || "React class") + ": " + ze + " type `" + Nt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof U[Nt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw On.name = "Invariant Violation", On;
              }
              gt = U[Nt](ke, Nt, vt, ze, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Mr) {
              gt = Mr;
            }
            gt && !(gt instanceof Error) && (ur(It), F("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", vt || "React class", ze, Nt, typeof gt), ur(null)), gt instanceof Error && !(gt.message in Cr) && (Cr[gt.message] = !0, ur(It), F("Failed %s type: %s", ze, gt.message), ur(null));
          }
      }
    }
    var pi = Array.isArray;
    function Ri(U) {
      return pi(U);
    }
    function hn(U) {
      {
        var ke = typeof Symbol == "function" && Symbol.toStringTag, ze = ke && U[Symbol.toStringTag] || U.constructor.name || "Object";
        return ze;
      }
    }
    function fr(U) {
      try {
        return Er(U), !1;
      } catch {
        return !0;
      }
    }
    function Er(U) {
      return "" + U;
    }
    function Ji(U) {
      if (fr(U))
        return F("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", hn(U)), Er(U);
    }
    var $r = L.ReactCurrentOwner, Tn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Wo, Za, Sa;
    Sa = {};
    function Ge(U) {
      if (ir.call(U, "ref")) {
        var ke = Object.getOwnPropertyDescriptor(U, "ref").get;
        if (ke && ke.isReactWarning)
          return !1;
      }
      return U.ref !== void 0;
    }
    function ht(U) {
      if (ir.call(U, "key")) {
        var ke = Object.getOwnPropertyDescriptor(U, "key").get;
        if (ke && ke.isReactWarning)
          return !1;
      }
      return U.key !== void 0;
    }
    function Vt(U, ke) {
      if (typeof U.ref == "string" && $r.current && ke && $r.current.stateNode !== ke) {
        var ze = Ce($r.current.type);
        Sa[ze] || (F('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Ce($r.current.type), U.ref), Sa[ze] = !0);
      }
    }
    function cr(U, ke) {
      {
        var ze = function() {
          Wo || (Wo = !0, F("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ke));
        };
        ze.isReactWarning = !0, Object.defineProperty(U, "key", {
          get: ze,
          configurable: !0
        });
      }
    }
    function _r(U, ke) {
      {
        var ze = function() {
          Za || (Za = !0, F("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ke));
        };
        ze.isReactWarning = !0, Object.defineProperty(U, "ref", {
          get: ze,
          configurable: !0
        });
      }
    }
    var wn = function(U, ke, ze, vt, It, Kt, Nt) {
      var gt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: U,
        key: ke,
        ref: ze,
        props: Nt,
        // Record the component responsible for creating this element.
        _owner: Kt
      };
      return gt._store = {}, Object.defineProperty(gt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(gt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: vt
      }), Object.defineProperty(gt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: It
      }), Object.freeze && (Object.freeze(gt.props), Object.freeze(gt)), gt;
    };
    function Yr(U, ke, ze, vt, It) {
      {
        var Kt, Nt = {}, gt = null, On = null;
        ze !== void 0 && (Ji(ze), gt = "" + ze), ht(ke) && (Ji(ke.key), gt = "" + ke.key), Ge(ke) && (On = ke.ref, Vt(ke, It));
        for (Kt in ke)
          ir.call(ke, Kt) && !Tn.hasOwnProperty(Kt) && (Nt[Kt] = ke[Kt]);
        if (U && U.defaultProps) {
          var Mr = U.defaultProps;
          for (Kt in Mr)
            Nt[Kt] === void 0 && (Nt[Kt] = Mr[Kt]);
        }
        if (gt || On) {
          var Lr = typeof U == "function" ? U.displayName || U.name || "Unknown" : U;
          gt && cr(Nt, Lr), On && _r(Nt, Lr);
        }
        return wn(U, gt, On, It, vt, $r.current, Nt);
      }
    }
    var An = L.ReactCurrentOwner, Br = L.ReactDebugCurrentFrame;
    function Qt(U) {
      if (U) {
        var ke = U._owner, ze = bt(U.type, U._source, ke ? ke.type : null);
        Br.setExtraStackFrame(ze);
      } else
        Br.setExtraStackFrame(null);
    }
    var Tr;
    Tr = !1;
    function sc(U) {
      return typeof U == "object" && U !== null && U.$$typeof === t;
    }
    function Gl() {
      {
        if (An.current) {
          var U = Ce(An.current.type);
          if (U)
            return `

Check the render method of \`` + U + "`.";
        }
        return "";
      }
    }
    function lc(U) {
      {
        if (U !== void 0) {
          var ke = U.fileName.replace(/^.*[\\\/]/, ""), ze = U.lineNumber;
          return `

Check your code at ` + ke + ":" + ze + ".";
        }
        return "";
      }
    }
    var Xd = {};
    function Hh(U) {
      {
        var ke = Gl();
        if (!ke) {
          var ze = typeof U == "string" ? U : U.displayName || U.name;
          ze && (ke = `

Check the top-level render call using <` + ze + ">.");
        }
        return ke;
      }
    }
    function Ul(U, ke) {
      {
        if (!U._store || U._store.validated || U.key != null)
          return;
        U._store.validated = !0;
        var ze = Hh(ke);
        if (Xd[ze])
          return;
        Xd[ze] = !0;
        var vt = "";
        U && U._owner && U._owner !== An.current && (vt = " It was passed a child from " + Ce(U._owner.type) + "."), Qt(U), F('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ze, vt), Qt(null);
      }
    }
    function uc(U, ke) {
      {
        if (typeof U != "object")
          return;
        if (Ri(U))
          for (var ze = 0; ze < U.length; ze++) {
            var vt = U[ze];
            sc(vt) && Ul(vt, ke);
          }
        else if (sc(U))
          U._store && (U._store.validated = !0);
        else if (U) {
          var It = D(U);
          if (typeof It == "function" && It !== U.entries)
            for (var Kt = It.call(U), Nt; !(Nt = Kt.next()).done; )
              sc(Nt.value) && Ul(Nt.value, ke);
        }
      }
    }
    function jl(U) {
      {
        var ke = U.type;
        if (ke == null || typeof ke == "string")
          return;
        var ze;
        if (typeof ke == "function")
          ze = ke.propTypes;
        else if (typeof ke == "object" && (ke.$$typeof === h || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ke.$$typeof === x))
          ze = ke.propTypes;
        else
          return;
        if (ze) {
          var vt = Ce(ke);
          Fr(ze, U.props, "prop", vt, U);
        } else if (ke.PropTypes !== void 0 && !Tr) {
          Tr = !0;
          var It = Ce(ke);
          F("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", It || "Unknown");
        }
        typeof ke.getDefaultProps == "function" && !ke.getDefaultProps.isReactClassApproved && F("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function cc(U) {
      {
        for (var ke = Object.keys(U.props), ze = 0; ze < ke.length; ze++) {
          var vt = ke[ze];
          if (vt !== "children" && vt !== "key") {
            Qt(U), F("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", vt), Qt(null);
            break;
          }
        }
        U.ref !== null && (Qt(U), F("Invalid attribute `ref` supplied to `React.Fragment`."), Qt(null));
      }
    }
    function go(U, ke, ze, vt, It, Kt) {
      {
        var Nt = he(U);
        if (!Nt) {
          var gt = "";
          (U === void 0 || typeof U == "object" && U !== null && Object.keys(U).length === 0) && (gt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var On = lc(It);
          On ? gt += On : gt += Gl();
          var Mr;
          U === null ? Mr = "null" : Ri(U) ? Mr = "array" : U !== void 0 && U.$$typeof === t ? (Mr = "<" + (Ce(U.type) || "Unknown") + " />", gt = " Did you accidentally export a JSX literal instead of a component?") : Mr = typeof U, F("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Mr, gt);
        }
        var Lr = Yr(U, ke, ze, It, Kt);
        if (Lr == null)
          return Lr;
        if (Nt) {
          var gi = ke.children;
          if (gi !== void 0)
            if (vt)
              if (Ri(gi)) {
                for (var Hs = 0; Hs < gi.length; Hs++)
                  uc(gi[Hs], U);
                Object.freeze && Object.freeze(gi);
              } else
                F("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              uc(gi, U);
        }
        return U === n ? cc(Lr) : jl(Lr), Lr;
      }
    }
    function Bs(U, ke, ze) {
      return go(U, ke, ze, !0);
    }
    function ea(U, ke, ze) {
      return go(U, ke, ze, !1);
    }
    var Qa = ea, zs = Bs;
    f_.Fragment = n, f_.jsx = Qa, f_.jsxs = zs;
  }()), f_;
}
var h_ = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var OV;
function u7() {
  if (OV)
    return h_;
  OV = 1;
  var e = nc, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(d, h, p) {
    var m, x = {}, S = null, T = null;
    p !== void 0 && (S = "" + p), h.key !== void 0 && (S = "" + h.key), h.ref !== void 0 && (T = h.ref);
    for (m in h)
      n.call(h, m) && !s.hasOwnProperty(m) && (x[m] = h[m]);
    if (d && d.defaultProps)
      for (m in h = d.defaultProps, h)
        x[m] === void 0 && (x[m] = h[m]);
    return { $$typeof: t, type: d, key: S, ref: T, props: x, _owner: i.current };
  }
  return h_.Fragment = r, h_.jsx = l, h_.jsxs = l, h_;
}
var ive = mE.exports;
process.env.NODE_ENV === "production" ? mE.exports = u7() : mE.exports = l7();
var At = mE.exports;
function EH(e = "Ocean") {
  const t = {
    Lemon: "bg-gradient-to-r from-lime-500 to-green-500",
    Mountain: "bg-gradient-to-r from-teal-500 to-emerald-500",
    Ocean: "bg-gradient-to-r from-cyan-500 to-blue-500",
    Summer: "bg-gradient-to-r from-amber-500 to-orange-500"
  };
  return t[e] || t.Ocean;
}
function c7(e) {
  const {
    loading: t = !1
  } = e, r = EH(e.theme), n = ho(() => t ? "animate-pulse" : "", [t]);
  return /* @__PURE__ */ At.jsxs(
    "div",
    {
      className: `flex gap-4 max-h-[132px] cursor-pointer rounded font-bold px-4 py-8 items-center justify-center hover:from-pink-500 hover:to-yellow-500 ${r} ${n()}`,
      children: [
        e.icon && /* @__PURE__ */ At.jsx("img", { className: "w-16 h-16", src: e.icon, alt: "icon" }),
        /* @__PURE__ */ At.jsxs("div", { className: "text-2xl font-medium text-white truncate", children: [
          /* @__PURE__ */ At.jsx("div", { className: "truncate", title: e.title, children: e.title }),
          /* @__PURE__ */ At.jsx("div", { className: "min-h-[32px]", children: e.value })
        ] })
      ]
    }
  );
}
function d7(e) {
  const {
    loading: t = !1
  } = e, r = EH(e.theme), n = ho(() => t ? "animate-pulse" : "", [t]);
  return /* @__PURE__ */ At.jsxs("div", { className: "w-full p-4 flex gap-4 border rounded group cursor-pointer", children: [
    /* @__PURE__ */ At.jsx(
      "div",
      {
        className: `rounded w-16 h-16 p-2 group-hover:from-pink-500 group-hover:to-yellow-500 ${r} ${n()}`,
        children: e.icon && /* @__PURE__ */ At.jsx(
          "img",
          {
            className: "w-full h-full",
            src: e.icon,
            alt: "icon"
          }
        )
      }
    ),
    /* @__PURE__ */ At.jsxs("div", { className: "text-gray-800", children: [
      /* @__PURE__ */ At.jsx(
        "h2",
        {
          className: "text-base text-gray-400 truncate",
          title: e.title,
          children: e.title
        }
      ),
      /* @__PURE__ */ At.jsx("p", { className: "text-2xl font-bold min-h-[32px]", children: e.value })
    ] })
  ] });
}
var _E = { exports: {} }, RO, kV;
function f7() {
  if (kV)
    return RO;
  kV = 1;
  var e = 1e3, t = e * 60, r = t * 60, n = r * 24, i = n * 7, s = n * 365.25;
  RO = function(m, x) {
    x = x || {};
    var S = typeof m;
    if (S === "string" && m.length > 0)
      return l(m);
    if (S === "number" && isFinite(m))
      return x.long ? h(m) : d(m);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(m)
    );
  };
  function l(m) {
    if (m = String(m), !(m.length > 100)) {
      var x = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        m
      );
      if (x) {
        var S = parseFloat(x[1]), T = (x[2] || "ms").toLowerCase();
        switch (T) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return S * s;
          case "weeks":
          case "week":
          case "w":
            return S * i;
          case "days":
          case "day":
          case "d":
            return S * n;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return S * r;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return S * t;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return S * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return S;
          default:
            return;
        }
      }
    }
  }
  function d(m) {
    var x = Math.abs(m);
    return x >= n ? Math.round(m / n) + "d" : x >= r ? Math.round(m / r) + "h" : x >= t ? Math.round(m / t) + "m" : x >= e ? Math.round(m / e) + "s" : m + "ms";
  }
  function h(m) {
    var x = Math.abs(m);
    return x >= n ? p(m, x, n, "day") : x >= r ? p(m, x, r, "hour") : x >= t ? p(m, x, t, "minute") : x >= e ? p(m, x, e, "second") : m + " ms";
  }
  function p(m, x, S, T) {
    var k = x >= S * 1.5;
    return Math.round(m / S) + " " + T + (k ? "s" : "");
  }
  return RO;
}
function h7(e) {
  r.debug = r, r.default = r, r.coerce = h, r.disable = s, r.enable = i, r.enabled = l, r.humanize = f7(), r.destroy = p, Object.keys(e).forEach((m) => {
    r[m] = e[m];
  }), r.names = [], r.skips = [], r.formatters = {};
  function t(m) {
    let x = 0;
    for (let S = 0; S < m.length; S++)
      x = (x << 5) - x + m.charCodeAt(S), x |= 0;
    return r.colors[Math.abs(x) % r.colors.length];
  }
  r.selectColor = t;
  function r(m) {
    let x, S = null, T, k;
    function O(...D) {
      if (!O.enabled)
        return;
      const L = O, F = Number(/* @__PURE__ */ new Date()), z = F - (x || F);
      L.diff = z, L.prev = x, L.curr = F, x = F, D[0] = r.coerce(D[0]), typeof D[0] != "string" && D.unshift("%O");
      let V = 0;
      D[0] = D[0].replace(/%([a-zA-Z%])/g, (j, Z) => {
        if (j === "%%")
          return "%";
        V++;
        const ee = r.formatters[Z];
        if (typeof ee == "function") {
          const J = D[V];
          j = ee.call(L, J), D.splice(V, 1), V--;
        }
        return j;
      }), r.formatArgs.call(L, D), (L.log || r.log).apply(L, D);
    }
    return O.namespace = m, O.useColors = r.useColors(), O.color = r.selectColor(m), O.extend = n, O.destroy = r.destroy, Object.defineProperty(O, "enabled", {
      enumerable: !0,
      configurable: !1,
      get: () => S !== null ? S : (T !== r.namespaces && (T = r.namespaces, k = r.enabled(m)), k),
      set: (D) => {
        S = D;
      }
    }), typeof r.init == "function" && r.init(O), O;
  }
  function n(m, x) {
    const S = r(this.namespace + (typeof x > "u" ? ":" : x) + m);
    return S.log = this.log, S;
  }
  function i(m) {
    r.save(m), r.namespaces = m, r.names = [], r.skips = [];
    let x;
    const S = (typeof m == "string" ? m : "").split(/[\s,]+/), T = S.length;
    for (x = 0; x < T; x++)
      S[x] && (m = S[x].replace(/\*/g, ".*?"), m[0] === "-" ? r.skips.push(new RegExp("^" + m.slice(1) + "$")) : r.names.push(new RegExp("^" + m + "$")));
  }
  function s() {
    const m = [
      ...r.names.map(d),
      ...r.skips.map(d).map((x) => "-" + x)
    ].join(",");
    return r.enable(""), m;
  }
  function l(m) {
    if (m[m.length - 1] === "*")
      return !0;
    let x, S;
    for (x = 0, S = r.skips.length; x < S; x++)
      if (r.skips[x].test(m))
        return !1;
    for (x = 0, S = r.names.length; x < S; x++)
      if (r.names[x].test(m))
        return !0;
    return !1;
  }
  function d(m) {
    return m.toString().substring(2, m.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  function h(m) {
    return m instanceof Error ? m.stack || m.message : m;
  }
  function p() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }
  return r.enable(r.load()), r;
}
var v7 = h7;
var ave = _E.exports;
(function(e, t) {
  t.formatArgs = n, t.save = i, t.load = s, t.useColors = r, t.storage = l(), t.destroy = /* @__PURE__ */ (() => {
    let h = !1;
    return () => {
      h || (h = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  })(), t.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
  ];
  function r() {
    return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  function n(h) {
    if (h[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + h[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !this.useColors)
      return;
    const p = "color: " + this.color;
    h.splice(1, 0, p, "color: inherit");
    let m = 0, x = 0;
    h[0].replace(/%[a-zA-Z%]/g, (S) => {
      S !== "%%" && (m++, S === "%c" && (x = m));
    }), h.splice(x, 0, p);
  }
  t.log = console.debug || console.log || (() => {
  });
  function i(h) {
    try {
      h ? t.storage.setItem("debug", h) : t.storage.removeItem("debug");
    } catch {
    }
  }
  function s() {
    let h;
    try {
      h = t.storage.getItem("debug");
    } catch {
    }
    return !h && typeof process < "u" && "env" in process && (h = process.env.DEBUG), h;
  }
  function l() {
    try {
      return localStorage;
    } catch {
    }
  }
  e.exports = v7(t);
  const { formatters: d } = e.exports;
  d.j = function(h) {
    try {
      return JSON.stringify(h);
    } catch (p) {
      return "[UnexpectedJSONParseError]: " + p.message;
    }
  };
})(_E, _E.exports);
var p7 = _E.exports;
const g7 = /* @__PURE__ */ s7(p7), DR = (e, t) => ({
  ...e,
  ...t
}), m7 = (e) => (e == null ? void 0 : e.constructor) === Object, Ng = async (e, t) => {
  const {
    result: r = "json"
  } = t, n = new URL(e);
  if (t != null && t.parameter) {
    const d = t.parameter;
    n.search = new URLSearchParams(
      Object.keys(d).filter(
        (h) => d[h] !== void 0 && d[h] !== "undefined"
      ).reduce((h, p) => ({
        ...h,
        [p]: d[p]
      }), {})
    ).toString();
  }
  let i = DR({
    Accept: "application/json"
  }, t.headers);
  t.body && (Array.isArray(t.body) || m7(t.body)) && (i = DR({
    "Content-Type": "application/json"
  }, i), t.body = JSON.stringify(t.body));
  const s = await window.fetch(n, {
    body: t == null ? void 0 : t.body,
    cache: t == null ? void 0 : t.cache,
    headers: i,
    method: t == null ? void 0 : t.method,
    signal: t == null ? void 0 : t.signal
  }), l = await _7(r, s);
  if (!s.ok)
    throw l;
  return l;
};
async function _7(e, t) {
  return e === "text" ? await t.text() : e === "blob" ? await t.blob() : await t.json();
}
function y7(e, t) {
  let r = {};
  return t.method === "GET" && t.body && (r = t.body, t.body = void 0), Ng(e, {
    body: t.body,
    headers: t.headers,
    method: t.method,
    parameter: r,
    result: t.result,
    signal: t.signal
  });
}
function x7(e, t) {
  var r, n;
  const i = new FormData();
  i.append("entity", t.body.entity), i.append("namespace", t.body.namespace), Array.isArray(t.body.files) && t.body.files.forEach((l) => {
    i.append("files[]", l);
  }), Array.isArray(t.body.categories) && t.body.categories.forEach((l) => {
    i.append("categories[]", JSON.stringify(l));
  });
  const s = DR({
    MantumKey: (r = t == null ? void 0 : t.security) == null ? void 0 : r.key,
    MantumSecret: (n = t == null ? void 0 : t.security) == null ? void 0 : n.secret
  }, t.headers);
  return Ng(e, {
    body: i,
    headers: s,
    method: t.method,
    result: t == null ? void 0 : t.result
  });
}
function TH(e, t) {
  return Ng(e, {
    cache: t == null ? void 0 : t.cache,
    headers: t == null ? void 0 : t.headers,
    method: "GET",
    parameter: t == null ? void 0 : t.parameter,
    result: t == null ? void 0 : t.result,
    signal: t == null ? void 0 : t.signal
  });
}
let b7 = (e = 21) => crypto.getRandomValues(new Uint8Array(e)).reduce((t, r) => (r &= 63, r < 36 ? t += r.toString(36) : r < 62 ? t += (r - 26).toString(36).toUpperCase() : r > 62 ? t += "-" : t += "_", t), "");
const RV = () => b7();
function S7(e) {
  const t = RV(), r = new AbortController(), n = r.signal, i = {}, s = {}, l = () => {
    t in i && delete i[t];
  }, d = (p) => {
    r.abort(), p in s && delete s[p];
  }, h = (p) => {
    for (const [, m] of Object.entries(s))
      m(p);
  };
  return {
    subscribe: (p) => {
      const m = RV();
      return s[m] = p, () => d(m);
    },
    call: (p) => {
      Object.keys(s).length !== 0 && (() => {
        const m = TH(e, {
          parameter: p,
          signal: n
        });
        m.then((x) => {
          h(x), l();
        }), m.catch((x) => {
          h(x), l();
        });
      })();
    }
  };
}
function C7(e, t) {
  return Ng(e, {
    body: t == null ? void 0 : t.body,
    headers: t == null ? void 0 : t.headers,
    method: "POST",
    result: t == null ? void 0 : t.result
  });
}
function E7(e, t) {
  return Ng(e, {
    body: t == null ? void 0 : t.body,
    headers: t == null ? void 0 : t.headers,
    method: "PUT",
    result: t == null ? void 0 : t.result
  });
}
function T7(e, t) {
  return Ng(e, {
    headers: t == null ? void 0 : t.headers,
    method: "DELETE",
    result: t == null ? void 0 : t.result
  });
}
const w7 = {
  delete: T7,
  fetch: y7,
  file: x7,
  get: TH,
  observable: S7,
  post: C7,
  put: E7
};
var wH = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function AH(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var OH = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(wH, function() {
    var r = 1e3, n = 6e4, i = 36e5, s = "millisecond", l = "second", d = "minute", h = "hour", p = "day", m = "week", x = "month", S = "quarter", T = "year", k = "date", O = "Invalid Date", D = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, L = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, F = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(le) {
      var me = ["th", "st", "nd", "rd"], fe = le % 100;
      return "[" + le + (me[(fe - 20) % 10] || me[fe] || me[0]) + "]";
    } }, z = function(le, me, fe) {
      var Ee = String(le);
      return !Ee || Ee.length >= me ? le : "" + Array(me + 1 - Ee.length).join(fe) + le;
    }, V = { s: z, z: function(le) {
      var me = -le.utcOffset(), fe = Math.abs(me), Ee = Math.floor(fe / 60), Q = fe % 60;
      return (me <= 0 ? "+" : "-") + z(Ee, 2, "0") + ":" + z(Q, 2, "0");
    }, m: function le(me, fe) {
      if (me.date() < fe.date())
        return -le(fe, me);
      var Ee = 12 * (fe.year() - me.year()) + (fe.month() - me.month()), Q = me.clone().add(Ee, x), pe = fe - Q < 0, G = me.clone().add(Ee + (pe ? -1 : 1), x);
      return +(-(Ee + (fe - Q) / (pe ? Q - G : G - Q)) || 0);
    }, a: function(le) {
      return le < 0 ? Math.ceil(le) || 0 : Math.floor(le);
    }, p: function(le) {
      return { M: x, y: T, w: m, d: p, D: k, h, m: d, s: l, ms: s, Q: S }[le] || String(le || "").toLowerCase().replace(/s$/, "");
    }, u: function(le) {
      return le === void 0;
    } }, P = "en", j = {};
    j[P] = F;
    var Z = "$isDayjsObject", ee = function(le) {
      return le instanceof Re || !(!le || !le[Z]);
    }, J = function le(me, fe, Ee) {
      var Q;
      if (!me)
        return P;
      if (typeof me == "string") {
        var pe = me.toLowerCase();
        j[pe] && (Q = pe), fe && (j[pe] = fe, Q = pe);
        var G = me.split("-");
        if (!Q && G.length > 1)
          return le(G[0]);
      } else {
        var se = me.name;
        j[se] = me, Q = se;
      }
      return !Ee && Q && (P = Q), Q || !Ee && P;
    }, he = function(le, me) {
      if (ee(le))
        return le.clone();
      var fe = typeof me == "object" ? me : {};
      return fe.date = le, fe.args = arguments, new Re(fe);
    }, de = V;
    de.l = J, de.i = ee, de.w = function(le, me) {
      return he(le, { locale: me.$L, utc: me.$u, x: me.$x, $offset: me.$offset });
    };
    var Re = function() {
      function le(fe) {
        this.$L = J(fe.locale, null, !0), this.parse(fe), this.$x = this.$x || fe.x || {}, this[Z] = !0;
      }
      var me = le.prototype;
      return me.parse = function(fe) {
        this.$d = function(Ee) {
          var Q = Ee.date, pe = Ee.utc;
          if (Q === null)
            return /* @__PURE__ */ new Date(NaN);
          if (de.u(Q))
            return /* @__PURE__ */ new Date();
          if (Q instanceof Date)
            return new Date(Q);
          if (typeof Q == "string" && !/Z$/i.test(Q)) {
            var G = Q.match(D);
            if (G) {
              var se = G[2] - 1 || 0, Te = (G[7] || "0").substring(0, 3);
              return pe ? new Date(Date.UTC(G[1], se, G[3] || 1, G[4] || 0, G[5] || 0, G[6] || 0, Te)) : new Date(G[1], se, G[3] || 1, G[4] || 0, G[5] || 0, G[6] || 0, Te);
            }
          }
          return new Date(Q);
        }(fe), this.init();
      }, me.init = function() {
        var fe = this.$d;
        this.$y = fe.getFullYear(), this.$M = fe.getMonth(), this.$D = fe.getDate(), this.$W = fe.getDay(), this.$H = fe.getHours(), this.$m = fe.getMinutes(), this.$s = fe.getSeconds(), this.$ms = fe.getMilliseconds();
      }, me.$utils = function() {
        return de;
      }, me.isValid = function() {
        return this.$d.toString() !== O;
      }, me.isSame = function(fe, Ee) {
        var Q = he(fe);
        return this.startOf(Ee) <= Q && Q <= this.endOf(Ee);
      }, me.isAfter = function(fe, Ee) {
        return he(fe) < this.startOf(Ee);
      }, me.isBefore = function(fe, Ee) {
        return this.endOf(Ee) < he(fe);
      }, me.$g = function(fe, Ee, Q) {
        return de.u(fe) ? this[Ee] : this.set(Q, fe);
      }, me.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, me.valueOf = function() {
        return this.$d.getTime();
      }, me.startOf = function(fe, Ee) {
        var Q = this, pe = !!de.u(Ee) || Ee, G = de.p(fe), se = function(it, We) {
          var _t = de.w(Q.$u ? Date.UTC(Q.$y, We, it) : new Date(Q.$y, We, it), Q);
          return pe ? _t : _t.endOf(p);
        }, Te = function(it, We) {
          return de.w(Q.toDate()[it].apply(Q.toDate("s"), (pe ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(We)), Q);
        }, Pe = this.$W, Ie = this.$M, He = this.$D, Ue = "set" + (this.$u ? "UTC" : "");
        switch (G) {
          case T:
            return pe ? se(1, 0) : se(31, 11);
          case x:
            return pe ? se(1, Ie) : se(0, Ie + 1);
          case m:
            var Ze = this.$locale().weekStart || 0, Qe = (Pe < Ze ? Pe + 7 : Pe) - Ze;
            return se(pe ? He - Qe : He + (6 - Qe), Ie);
          case p:
          case k:
            return Te(Ue + "Hours", 0);
          case h:
            return Te(Ue + "Minutes", 1);
          case d:
            return Te(Ue + "Seconds", 2);
          case l:
            return Te(Ue + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, me.endOf = function(fe) {
        return this.startOf(fe, !1);
      }, me.$set = function(fe, Ee) {
        var Q, pe = de.p(fe), G = "set" + (this.$u ? "UTC" : ""), se = (Q = {}, Q[p] = G + "Date", Q[k] = G + "Date", Q[x] = G + "Month", Q[T] = G + "FullYear", Q[h] = G + "Hours", Q[d] = G + "Minutes", Q[l] = G + "Seconds", Q[s] = G + "Milliseconds", Q)[pe], Te = pe === p ? this.$D + (Ee - this.$W) : Ee;
        if (pe === x || pe === T) {
          var Pe = this.clone().set(k, 1);
          Pe.$d[se](Te), Pe.init(), this.$d = Pe.set(k, Math.min(this.$D, Pe.daysInMonth())).$d;
        } else
          se && this.$d[se](Te);
        return this.init(), this;
      }, me.set = function(fe, Ee) {
        return this.clone().$set(fe, Ee);
      }, me.get = function(fe) {
        return this[de.p(fe)]();
      }, me.add = function(fe, Ee) {
        var Q, pe = this;
        fe = Number(fe);
        var G = de.p(Ee), se = function(Ie) {
          var He = he(pe);
          return de.w(He.date(He.date() + Math.round(Ie * fe)), pe);
        };
        if (G === x)
          return this.set(x, this.$M + fe);
        if (G === T)
          return this.set(T, this.$y + fe);
        if (G === p)
          return se(1);
        if (G === m)
          return se(7);
        var Te = (Q = {}, Q[d] = n, Q[h] = i, Q[l] = r, Q)[G] || 1, Pe = this.$d.getTime() + fe * Te;
        return de.w(Pe, this);
      }, me.subtract = function(fe, Ee) {
        return this.add(-1 * fe, Ee);
      }, me.format = function(fe) {
        var Ee = this, Q = this.$locale();
        if (!this.isValid())
          return Q.invalidDate || O;
        var pe = fe || "YYYY-MM-DDTHH:mm:ssZ", G = de.z(this), se = this.$H, Te = this.$m, Pe = this.$M, Ie = Q.weekdays, He = Q.months, Ue = Q.meridiem, Ze = function(We, _t, xe, Je) {
          return We && (We[_t] || We(Ee, pe)) || xe[_t].slice(0, Je);
        }, Qe = function(We) {
          return de.s(se % 12 || 12, We, "0");
        }, it = Ue || function(We, _t, xe) {
          var Je = We < 12 ? "AM" : "PM";
          return xe ? Je.toLowerCase() : Je;
        };
        return pe.replace(L, function(We, _t) {
          return _t || function(xe) {
            switch (xe) {
              case "YY":
                return String(Ee.$y).slice(-2);
              case "YYYY":
                return de.s(Ee.$y, 4, "0");
              case "M":
                return Pe + 1;
              case "MM":
                return de.s(Pe + 1, 2, "0");
              case "MMM":
                return Ze(Q.monthsShort, Pe, He, 3);
              case "MMMM":
                return Ze(He, Pe);
              case "D":
                return Ee.$D;
              case "DD":
                return de.s(Ee.$D, 2, "0");
              case "d":
                return String(Ee.$W);
              case "dd":
                return Ze(Q.weekdaysMin, Ee.$W, Ie, 2);
              case "ddd":
                return Ze(Q.weekdaysShort, Ee.$W, Ie, 3);
              case "dddd":
                return Ie[Ee.$W];
              case "H":
                return String(se);
              case "HH":
                return de.s(se, 2, "0");
              case "h":
                return Qe(1);
              case "hh":
                return Qe(2);
              case "a":
                return it(se, Te, !0);
              case "A":
                return it(se, Te, !1);
              case "m":
                return String(Te);
              case "mm":
                return de.s(Te, 2, "0");
              case "s":
                return String(Ee.$s);
              case "ss":
                return de.s(Ee.$s, 2, "0");
              case "SSS":
                return de.s(Ee.$ms, 3, "0");
              case "Z":
                return G;
            }
            return null;
          }(We) || G.replace(":", "");
        });
      }, me.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, me.diff = function(fe, Ee, Q) {
        var pe, G = this, se = de.p(Ee), Te = he(fe), Pe = (Te.utcOffset() - this.utcOffset()) * n, Ie = this - Te, He = function() {
          return de.m(G, Te);
        };
        switch (se) {
          case T:
            pe = He() / 12;
            break;
          case x:
            pe = He();
            break;
          case S:
            pe = He() / 3;
            break;
          case m:
            pe = (Ie - Pe) / 6048e5;
            break;
          case p:
            pe = (Ie - Pe) / 864e5;
            break;
          case h:
            pe = Ie / i;
            break;
          case d:
            pe = Ie / n;
            break;
          case l:
            pe = Ie / r;
            break;
          default:
            pe = Ie;
        }
        return Q ? pe : de.a(pe);
      }, me.daysInMonth = function() {
        return this.endOf(x).$D;
      }, me.$locale = function() {
        return j[this.$L];
      }, me.locale = function(fe, Ee) {
        if (!fe)
          return this.$L;
        var Q = this.clone(), pe = J(fe, Ee, !0);
        return pe && (Q.$L = pe), Q;
      }, me.clone = function() {
        return de.w(this.$d, this);
      }, me.toDate = function() {
        return new Date(this.valueOf());
      }, me.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, me.toISOString = function() {
        return this.$d.toISOString();
      }, me.toString = function() {
        return this.$d.toUTCString();
      }, le;
    }(), Ce = Re.prototype;
    return he.prototype = Ce, [["$ms", s], ["$s", l], ["$m", d], ["$H", h], ["$W", p], ["$M", x], ["$y", T], ["$D", k]].forEach(function(le) {
      Ce[le[1]] = function(me) {
        return this.$g(me, le[0], le[1]);
      };
    }), he.extend = function(le, me) {
      return le.$i || (le(me, Re, he), le.$i = !0), he;
    }, he.locale = J, he.isDayjs = ee, he.unix = function(le) {
      return he(1e3 * le);
    }, he.en = j[P], he.Ls = j, he.p = {}, he;
  });
})(OH);
var A7 = OH.exports;
const kH = /* @__PURE__ */ AH(A7);
var RH = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(wH, function() {
    var r = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, n = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, i = /\d\d/, s = /\d\d?/, l = /\d*[^-_:/,()\s\d]+/, d = {}, h = function(O) {
      return (O = +O) + (O > 68 ? 1900 : 2e3);
    }, p = function(O) {
      return function(D) {
        this[O] = +D;
      };
    }, m = [/[+-]\d\d:?(\d\d)?|Z/, function(O) {
      (this.zone || (this.zone = {})).offset = function(D) {
        if (!D || D === "Z")
          return 0;
        var L = D.match(/([+-]|\d\d)/g), F = 60 * L[1] + (+L[2] || 0);
        return F === 0 ? 0 : L[0] === "+" ? -F : F;
      }(O);
    }], x = function(O) {
      var D = d[O];
      return D && (D.indexOf ? D : D.s.concat(D.f));
    }, S = function(O, D) {
      var L, F = d.meridiem;
      if (F) {
        for (var z = 1; z <= 24; z += 1)
          if (O.indexOf(F(z, 0, D)) > -1) {
            L = z > 12;
            break;
          }
      } else
        L = O === (D ? "pm" : "PM");
      return L;
    }, T = { A: [l, function(O) {
      this.afternoon = S(O, !1);
    }], a: [l, function(O) {
      this.afternoon = S(O, !0);
    }], S: [/\d/, function(O) {
      this.milliseconds = 100 * +O;
    }], SS: [i, function(O) {
      this.milliseconds = 10 * +O;
    }], SSS: [/\d{3}/, function(O) {
      this.milliseconds = +O;
    }], s: [s, p("seconds")], ss: [s, p("seconds")], m: [s, p("minutes")], mm: [s, p("minutes")], H: [s, p("hours")], h: [s, p("hours")], HH: [s, p("hours")], hh: [s, p("hours")], D: [s, p("day")], DD: [i, p("day")], Do: [l, function(O) {
      var D = d.ordinal, L = O.match(/\d+/);
      if (this.day = L[0], D)
        for (var F = 1; F <= 31; F += 1)
          D(F).replace(/\[|\]/g, "") === O && (this.day = F);
    }], M: [s, p("month")], MM: [i, p("month")], MMM: [l, function(O) {
      var D = x("months"), L = (x("monthsShort") || D.map(function(F) {
        return F.slice(0, 3);
      })).indexOf(O) + 1;
      if (L < 1)
        throw new Error();
      this.month = L % 12 || L;
    }], MMMM: [l, function(O) {
      var D = x("months").indexOf(O) + 1;
      if (D < 1)
        throw new Error();
      this.month = D % 12 || D;
    }], Y: [/[+-]?\d+/, p("year")], YY: [i, function(O) {
      this.year = h(O);
    }], YYYY: [/\d{4}/, p("year")], Z: m, ZZ: m };
    function k(O) {
      var D, L;
      D = O, L = d && d.formats;
      for (var F = (O = D.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(J, he, de) {
        var Re = de && de.toUpperCase();
        return he || L[de] || r[de] || L[Re].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(Ce, le, me) {
          return le || me.slice(1);
        });
      })).match(n), z = F.length, V = 0; V < z; V += 1) {
        var P = F[V], j = T[P], Z = j && j[0], ee = j && j[1];
        F[V] = ee ? { regex: Z, parser: ee } : P.replace(/^\[|\]$/g, "");
      }
      return function(J) {
        for (var he = {}, de = 0, Re = 0; de < z; de += 1) {
          var Ce = F[de];
          if (typeof Ce == "string")
            Re += Ce.length;
          else {
            var le = Ce.regex, me = Ce.parser, fe = J.slice(Re), Ee = le.exec(fe)[0];
            me.call(he, Ee), J = J.replace(Ee, "");
          }
        }
        return function(Q) {
          var pe = Q.afternoon;
          if (pe !== void 0) {
            var G = Q.hours;
            pe ? G < 12 && (Q.hours += 12) : G === 12 && (Q.hours = 0), delete Q.afternoon;
          }
        }(he), he;
      };
    }
    return function(O, D, L) {
      L.p.customParseFormat = !0, O && O.parseTwoDigitYear && (h = O.parseTwoDigitYear);
      var F = D.prototype, z = F.parse;
      F.parse = function(V) {
        var P = V.date, j = V.utc, Z = V.args;
        this.$u = j;
        var ee = Z[1];
        if (typeof ee == "string") {
          var J = Z[2] === !0, he = Z[3] === !0, de = J || he, Re = Z[2];
          he && (Re = Z[2]), d = this.$locale(), !J && Re && (d = L.Ls[Re]), this.$d = function(fe, Ee, Q) {
            try {
              if (["x", "X"].indexOf(Ee) > -1)
                return new Date((Ee === "X" ? 1e3 : 1) * fe);
              var pe = k(Ee)(fe), G = pe.year, se = pe.month, Te = pe.day, Pe = pe.hours, Ie = pe.minutes, He = pe.seconds, Ue = pe.milliseconds, Ze = pe.zone, Qe = /* @__PURE__ */ new Date(), it = Te || (G || se ? 1 : Qe.getDate()), We = G || Qe.getFullYear(), _t = 0;
              G && !se || (_t = se > 0 ? se - 1 : Qe.getMonth());
              var xe = Pe || 0, Je = Ie || 0, Pt = He || 0, bt = Ue || 0;
              return Ze ? new Date(Date.UTC(We, _t, it, xe, Je, Pt, bt + 60 * Ze.offset * 1e3)) : Q ? new Date(Date.UTC(We, _t, it, xe, Je, Pt, bt)) : new Date(We, _t, it, xe, Je, Pt, bt);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(P, ee, j), this.init(), Re && Re !== !0 && (this.$L = this.locale(Re).$L), de && P != this.format(ee) && (this.$d = /* @__PURE__ */ new Date("")), d = {};
        } else if (ee instanceof Array)
          for (var Ce = ee.length, le = 1; le <= Ce; le += 1) {
            Z[1] = ee[le - 1];
            var me = L.apply(this, Z);
            if (me.isValid()) {
              this.$d = me.$d, this.$L = me.$L, this.init();
              break;
            }
            le === Ce && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          z.call(this, V);
      };
    };
  });
})(RH);
var O7 = RH.exports;
const k7 = /* @__PURE__ */ AH(O7);
kH.extend(k7);
const R7 = /undefined/i, D7 = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/, M7 = (e) => !e || e === "" || e.trim().length === 0, L7 = (e) => e === !0 || e === void 0, P7 = (e) => e === void 0 || typeof e == "string" && R7.test(e), I7 = (e) => e === null, cT = (e) => Object.prototype.toString.call(e) === "[object Object]", N7 = (e, t, r) => kH(e, t, r, !0).isValid(), V7 = (e) => !(!e || e.split("@").length != 2 || !D7.test(e)), F7 = (e) => {
  if (Array.isArray(e)) {
    if (e.length === 0)
      return !0;
    const t = e[0];
    if (cT(t) && "sections" in t)
      return !0;
  }
  return !1;
}, B7 = (e) => !!(e && cT(e) && typeof e == "object" && "label" in e && "value" in e), z7 = (e) => !!(e && cT(e) && typeof e == "object" && "url" in e), H7 = (e, t) => e < t, G7 = (e, t) => e <= t, U7 = (e, t) => e > t, j7 = (e, t) => e >= t, DH = {
  isDataSource: z7,
  isDate: N7,
  isEmail: V7,
  isEmpty: M7,
  isGreaterThan: U7,
  isGreaterThanOrEqualTo: j7,
  isLessThan: H7,
  isLessThanThanOrEqualTo: G7,
  isNull: I7,
  isObject: cT,
  isSelect: B7,
  isTab: F7,
  isUndefined: P7,
  isVisible: L7
};
const $7 = (e, t) => {
  if (!MH(e, t) || !t.parameter)
    return t;
  const r = {
    ...e
  };
  r.parameter = r.parameter || {};
  for (const [n, i] of Object.entries(t.parameter))
    if (!(n in r.parameter))
      r.parameter = {
        ...r.parameter,
        [n]: i
      };
    else if (r.parameter) {
      const s = r.parameter[n];
      if (s && typeof s == "string") {
        const l = s.split(",");
        l.push(`${i}`), r.parameter[n] = l.join(",");
      }
    }
  return r;
}, MH = (e, t) => !e || !t || e.url !== t.url || e.method !== t.method || e.namespace !== t.namespace || JSON.stringify(e.parameter) !== JSON.stringify(t.parameter), Y7 = (e, t) => {
  var r, n;
  return DH.isObject(e) && ((n = (r = t == null ? void 0 : t.split(".")) == null ? void 0 : r.filter((i) => i !== "")) == null || n.forEach((i) => {
    e && (e = e[i]);
  })), e;
}, W7 = {
  diff: MH,
  extract: Y7,
  merge: $7
};
const DO = g7("kanela:request");
function LH(e) {
  return new Promise((t, r) => {
    DO("fetch %s", e.url);
    const n = w7.fetch(e.url, {
      method: e.args.method,
      body: e.args.body,
      headers: e.args.headers
    });
    n.then((i) => {
      DO("response request %o", i), t(W7.extract(i, e.args.namespace));
    }), n.catch((i) => {
      DO("error request %o", i), r(i);
    });
  });
}
var yE = { exports: {} }, MO = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var DV;
function X7() {
  return DV || (DV = 1, process.env.NODE_ENV !== "production" && function() {
    "use strict";
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = nc, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(z) {
      {
        for (var V = arguments.length, P = new Array(V > 1 ? V - 1 : 0), j = 1; j < V; j++)
          P[j - 1] = arguments[j];
        n("error", z, P);
      }
    }
    function n(z, V, P) {
      {
        var j = t.ReactDebugCurrentFrame, Z = j.getStackAddendum();
        Z !== "" && (V += "%s", P = P.concat([Z]));
        var ee = P.map(function(J) {
          return String(J);
        });
        ee.unshift("Warning: " + V), Function.prototype.apply.call(console[z], console, ee);
      }
    }
    function i(z, V) {
      return z === V && (z !== 0 || 1 / z === 1 / V) || z !== z && V !== V;
    }
    var s = typeof Object.is == "function" ? Object.is : i, l = e.useState, d = e.useEffect, h = e.useLayoutEffect, p = e.useDebugValue, m = !1, x = !1;
    function S(z, V, P) {
      m || e.startTransition !== void 0 && (m = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var j = V();
      if (!x) {
        var Z = V();
        s(j, Z) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), x = !0);
      }
      var ee = l({
        inst: {
          value: j,
          getSnapshot: V
        }
      }), J = ee[0].inst, he = ee[1];
      return h(function() {
        J.value = j, J.getSnapshot = V, T(J) && he({
          inst: J
        });
      }, [z, j, V]), d(function() {
        T(J) && he({
          inst: J
        });
        var de = function() {
          T(J) && he({
            inst: J
          });
        };
        return z(de);
      }, [z]), p(j), j;
    }
    function T(z) {
      var V = z.getSnapshot, P = z.value;
      try {
        var j = V();
        return !s(P, j);
      } catch {
        return !0;
      }
    }
    function k(z, V, P) {
      return V();
    }
    var O = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", D = !O, L = D ? k : S, F = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : L;
    MO.useSyncExternalStore = F, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), MO;
}
var LO = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var MV;
function q7() {
  if (MV)
    return LO;
  MV = 1;
  var e = nc;
  function t(x, S) {
    return x === S && (x !== 0 || 1 / x === 1 / S) || x !== x && S !== S;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useState, i = e.useEffect, s = e.useLayoutEffect, l = e.useDebugValue;
  function d(x, S) {
    var T = S(), k = n({ inst: { value: T, getSnapshot: S } }), O = k[0].inst, D = k[1];
    return s(function() {
      O.value = T, O.getSnapshot = S, h(O) && D({ inst: O });
    }, [x, T, S]), i(function() {
      return h(O) && D({ inst: O }), x(function() {
        h(O) && D({ inst: O });
      });
    }, [x]), l(T), T;
  }
  function h(x) {
    var S = x.getSnapshot;
    x = x.value;
    try {
      var T = S();
      return !r(x, T);
    } catch {
      return !0;
    }
  }
  function p(x, S) {
    return S();
  }
  var m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? p : d;
  return LO.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : m, LO;
}
var ove = yE.exports;
process.env.NODE_ENV === "production" ? yE.exports = q7() : yE.exports = X7();
var K7 = yE.exports;
const Ad = () => {
}, ga = (
  /*#__NOINLINE__*/
  Ad()
), JC = Object, sr = (e) => e === ga, Rs = (e) => typeof e == "function", tc = (e, t) => ({
  ...e,
  ...t
}), Z7 = (e) => Rs(e.then), zS = /* @__PURE__ */ new WeakMap();
let Q7 = 0;
const oy = (e) => {
  const t = typeof e, r = e && e.constructor, n = r == Date;
  let i, s;
  if (JC(e) === e && !n && r != RegExp) {
    if (i = zS.get(e), i)
      return i;
    if (i = ++Q7 + "~", zS.set(e, i), r == Array) {
      for (i = "@", s = 0; s < e.length; s++)
        i += oy(e[s]) + ",";
      zS.set(e, i);
    }
    if (r == JC) {
      i = "#";
      const l = JC.keys(e).sort();
      for (; !sr(s = l.pop()); )
        sr(e[s]) || (i += s + ":" + oy(e[s]) + ",");
      zS.set(e, i);
    }
  } else
    i = n ? e.toJSON() : t == "symbol" ? e.toString() : t == "string" ? JSON.stringify(e) : "" + e;
  return i;
}, Gu = /* @__PURE__ */ new WeakMap(), PO = {}, HS = {}, vM = "undefined", dT = typeof window != vM, MR = typeof document != vM, J7 = () => dT && typeof window.requestAnimationFrame != vM, PH = (e, t) => {
  const r = Gu.get(e);
  return [
    // Getter
    () => !sr(t) && e.get(t) || PO,
    // Setter
    (n) => {
      if (!sr(t)) {
        const i = e.get(t);
        t in HS || (HS[t] = i), r[5](t, tc(i, n), i || PO);
      }
    },
    // Subscriber
    r[6],
    // Get server cache snapshot
    () => !sr(t) && t in HS ? HS[t] : !sr(t) && e.get(t) || PO
  ];
};
let LR = !0;
const eX = () => LR, [PR, IR] = dT && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  Ad,
  Ad
], tX = () => {
  const e = MR && document.visibilityState;
  return sr(e) || e !== "hidden";
}, rX = (e) => (MR && document.addEventListener("visibilitychange", e), PR("focus", e), () => {
  MR && document.removeEventListener("visibilitychange", e), IR("focus", e);
}), nX = (e) => {
  const t = () => {
    LR = !0, e();
  }, r = () => {
    LR = !1;
  };
  return PR("online", t), PR("offline", r), () => {
    IR("online", t), IR("offline", r);
  };
}, iX = {
  isOnline: eX,
  isVisible: tX
}, aX = {
  initFocus: rX,
  initReconnect: nX
}, LV = !nc.useId, sy = !dT || "Deno" in window, oX = (e) => J7() ? window.requestAnimationFrame(e) : setTimeout(e, 1), eE = sy ? hM : bH, IO = typeof navigator < "u" && navigator.connection, PV = !sy && IO && ([
  "slow-2g",
  "2g"
].includes(IO.effectiveType) || IO.saveData), pM = (e) => {
  if (Rs(e))
    try {
      e = e();
    } catch {
      e = "";
    }
  const t = e;
  return e = typeof e == "string" ? e : (Array.isArray(e) ? e.length : e) ? oy(e) : "", [
    e,
    t
  ];
};
let sX = 0;
const NR = () => ++sX, IH = 0, NH = 1, VH = 2, lX = 3;
var v_ = {
  __proto__: null,
  ERROR_REVALIDATE_EVENT: lX,
  FOCUS_EVENT: IH,
  MUTATE_EVENT: VH,
  RECONNECT_EVENT: NH
};
async function FH(...e) {
  const [t, r, n, i] = e, s = tc({
    populateCache: !0,
    throwOnError: !0
  }, typeof i == "boolean" ? {
    revalidate: i
  } : i || {});
  let l = s.populateCache;
  const d = s.rollbackOnError;
  let h = s.optimisticData;
  const p = (S) => typeof d == "function" ? d(S) : d !== !1, m = s.throwOnError;
  if (Rs(r)) {
    const S = r, T = [], k = t.keys();
    for (const O of k)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(O) && S(t.get(O)._k) && T.push(O);
    return Promise.all(T.map(x));
  }
  return x(r);
  async function x(S) {
    const [T] = pM(S);
    if (!T)
      return;
    const [k, O] = PH(t, T), [D, L, F, z] = Gu.get(t), V = () => {
      const Ce = D[T];
      return (Rs(s.revalidate) ? s.revalidate(k().data, S) : s.revalidate !== !1) && (delete F[T], delete z[T], Ce && Ce[0]) ? Ce[0](VH).then(() => k().data) : k().data;
    };
    if (e.length < 3)
      return V();
    let P = n, j;
    const Z = NR();
    L[T] = [
      Z,
      0
    ];
    const ee = !sr(h), J = k(), he = J.data, de = J._c, Re = sr(de) ? he : de;
    if (ee && (h = Rs(h) ? h(Re, he) : h, O({
      data: h,
      _c: Re
    })), Rs(P))
      try {
        P = P(Re);
      } catch (Ce) {
        j = Ce;
      }
    if (P && Z7(P))
      if (P = await P.catch((Ce) => {
        j = Ce;
      }), Z !== L[T][0]) {
        if (j)
          throw j;
        return P;
      } else
        j && ee && p(j) && (l = !0, O({
          data: Re,
          _c: ga
        }));
    if (l && !j)
      if (Rs(l)) {
        const Ce = l(P, Re);
        O({
          data: Ce,
          error: ga,
          _c: ga
        });
      } else
        O({
          data: P,
          error: ga,
          _c: ga
        });
    if (L[T][1] = NR(), Promise.resolve(V()).then(() => {
      O({
        _c: ga
      });
    }), j) {
      if (m)
        throw j;
      return;
    }
    return P;
  }
}
const IV = (e, t) => {
  for (const r in e)
    e[r][0] && e[r][0](t);
}, BH = (e, t) => {
  if (!Gu.has(e)) {
    const r = tc(aX, t), n = {}, i = FH.bind(ga, e);
    let s = Ad;
    const l = {}, d = (m, x) => {
      const S = l[m] || [];
      return l[m] = S, S.push(x), () => S.splice(S.indexOf(x), 1);
    }, h = (m, x, S) => {
      e.set(m, x);
      const T = l[m];
      if (T)
        for (const k of T)
          k(x, S);
    }, p = () => {
      if (!Gu.has(e) && (Gu.set(e, [
        n,
        {},
        {},
        {},
        i,
        h,
        d
      ]), !sy)) {
        const m = r.initFocus(setTimeout.bind(ga, IV.bind(ga, n, IH))), x = r.initReconnect(setTimeout.bind(ga, IV.bind(ga, n, NH)));
        s = () => {
          m && m(), x && x(), Gu.delete(e);
        };
      }
    };
    return p(), [
      e,
      i,
      p,
      s
    ];
  }
  return [
    e,
    Gu.get(e)[4]
  ];
}, uX = (e, t, r, n, i) => {
  const s = r.errorRetryCount, l = i.retryCount, d = ~~((Math.random() + 0.5) * (1 << (l < 8 ? l : 8))) * r.errorRetryInterval;
  !sr(s) && l > s || setTimeout(n, d, i);
}, cX = (e, t) => oy(e) == oy(t), [gM, dX] = BH(/* @__PURE__ */ new Map()), zH = tc(
  {
    // events
    onLoadingSlow: Ad,
    onSuccess: Ad,
    onError: Ad,
    onErrorRetry: uX,
    onDiscarded: Ad,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: PV ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: PV ? 5e3 : 3e3,
    // providers
    compare: cX,
    isPaused: () => !1,
    cache: gM,
    mutate: dX,
    fallback: {}
  },
  // use web preset by default
  iX
), HH = (e, t) => {
  const r = tc(e, t);
  if (t) {
    const { use: n, fallback: i } = e, { use: s, fallback: l } = t;
    n && s && (r.use = n.concat(s)), i && l && (r.fallback = tc(i, l));
  }
  return r;
}, VR = SH({}), fX = (e) => {
  const { value: t } = e, r = CH(VR), n = Rs(t), i = Fd(() => n ? t(r) : t, [
    n,
    r,
    t
  ]), s = Fd(() => n ? i : HH(r, i), [
    n,
    r,
    i
  ]), l = i && i.provider, d = Ya(ga);
  l && !d.current && (d.current = BH(l(s.cache || gM), i));
  const h = d.current;
  return h && (s.cache = h[0], s.mutate = h[1]), eE(() => {
    if (h)
      return h[2] && h[2](), h[3];
  }, []), i7(VR.Provider, tc(e, {
    value: s
  }));
}, hX = "$inf$", GH = dT && window.__SWR_DEVTOOLS_USE__, vX = GH ? window.__SWR_DEVTOOLS_USE__ : [], pX = () => {
  GH && (window.__SWR_DEVTOOLS_REACT__ = nc);
}, gX = (e) => Rs(e[1]) ? [
  e[0],
  e[1],
  e[2] || {}
] : [
  e[0],
  null,
  (e[1] === null ? e[2] : e[1]) || {}
], mX = () => tc(zH, CH(VR));
const _X = (e) => (t, r, n) => e(t, r && ((...s) => {
  const [l] = pM(t), [, , , d] = Gu.get(gM);
  if (l.startsWith(hX))
    return r(...s);
  const h = d[l];
  return sr(h) ? r(...s) : (delete d[l], h);
}), n), yX = vX.concat(_X), xX = (e) => function(...r) {
  const n = mX(), [i, s, l] = gX(r), d = HH(n, l);
  let h = e;
  const { use: p } = d, m = (p || []).concat(yX);
  for (let x = m.length; x--; )
    h = m[x](h);
  return h(i, s || d.fetcher || null, d);
}, bX = (e, t, r) => {
  const n = t[e] || (t[e] = []);
  return n.push(r), () => {
    const i = n.indexOf(r);
    i >= 0 && (n[i] = n[n.length - 1], n.pop());
  };
};
pX();
const NV = nc.use || ((e) => {
  if (e.status === "pending")
    throw e;
  if (e.status === "fulfilled")
    return e.value;
  throw e.status === "rejected" ? e.reason : (e.status = "pending", e.then((t) => {
    e.status = "fulfilled", e.value = t;
  }, (t) => {
    e.status = "rejected", e.reason = t;
  }), e);
}), NO = {
  dedupe: !0
}, SX = (e, t, r) => {
  const { cache: n, compare: i, suspense: s, fallbackData: l, revalidateOnMount: d, revalidateIfStale: h, refreshInterval: p, refreshWhenHidden: m, refreshWhenOffline: x, keepPreviousData: S } = r, [T, k, O, D] = Gu.get(n), [L, F] = pM(e), z = Ya(!1), V = Ya(!1), P = Ya(L), j = Ya(t), Z = Ya(r), ee = () => Z.current, J = () => ee().isVisible() && ee().isOnline(), [he, de, Re, Ce] = PH(n, L), le = Ya({}).current, me = sr(l) ? r.fallback[L] : l, fe = (xe, Je) => {
    for (const Pt in le) {
      const bt = Pt;
      if (bt === "data") {
        if (!i(xe[bt], Je[bt]) && (!sr(xe[bt]) || !i(He, Je[bt])))
          return !1;
      } else if (Je[bt] !== xe[bt])
        return !1;
    }
    return !0;
  }, Ee = Fd(() => {
    const xe = !L || !t ? !1 : sr(d) ? ee().isPaused() || s ? !1 : sr(h) ? !0 : h : d, Je = (ur) => {
      const Fr = tc(ur);
      return delete Fr._k, xe ? {
        isValidating: !0,
        isLoading: !0,
        ...Fr
      } : Fr;
    }, Pt = he(), bt = Ce(), ir = Je(Pt), Cr = Pt === bt ? ir : Je(bt);
    let qt = ir;
    return [
      () => {
        const ur = Je(he());
        return fe(ur, qt) ? (qt.data = ur.data, qt.isLoading = ur.isLoading, qt.isValidating = ur.isValidating, qt.error = ur.error, qt) : (qt = ur, ur);
      },
      () => Cr
    ];
  }, [
    n,
    L
  ]), Q = K7.useSyncExternalStore(ho(
    (xe) => Re(L, (Je, Pt) => {
      fe(Pt, Je) || xe();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      n,
      L
    ]
  ), Ee[0], Ee[1]), pe = !z.current, G = T[L] && T[L].length > 0, se = Q.data, Te = sr(se) ? me : se, Pe = Q.error, Ie = Ya(Te), He = S ? sr(se) ? Ie.current : se : Te, Ue = G && !sr(Pe) ? !1 : pe && !sr(d) ? d : ee().isPaused() ? !1 : s ? sr(Te) ? !1 : h : sr(Te) || h, Ze = !!(L && t && pe && Ue), Qe = sr(Q.isValidating) ? Ze : Q.isValidating, it = sr(Q.isLoading) ? Ze : Q.isLoading, We = ho(
    async (xe) => {
      const Je = j.current;
      if (!L || !Je || V.current || ee().isPaused())
        return !1;
      let Pt, bt, ir = !0;
      const Cr = xe || {}, qt = !O[L] || !Cr.dedupe, ur = () => LV ? !V.current && L === P.current && z.current : L === P.current, Fr = {
        isValidating: !1,
        isLoading: !1
      }, pi = () => {
        de(Fr);
      }, Ri = () => {
        const fr = O[L];
        fr && fr[1] === bt && delete O[L];
      }, hn = {
        isValidating: !0
      };
      sr(he().data) && (hn.isLoading = !0);
      try {
        if (qt && (de(hn), r.loadingTimeout && sr(he().data) && setTimeout(() => {
          ir && ur() && ee().onLoadingSlow(L, r);
        }, r.loadingTimeout), O[L] = [
          Je(F),
          NR()
        ]), [Pt, bt] = O[L], Pt = await Pt, qt && setTimeout(Ri, r.dedupingInterval), !O[L] || O[L][1] !== bt)
          return qt && ur() && ee().onDiscarded(L), !1;
        Fr.error = ga;
        const fr = k[L];
        if (!sr(fr) && // case 1
        (bt <= fr[0] || // case 2
        bt <= fr[1] || // case 3
        fr[1] === 0))
          return pi(), qt && ur() && ee().onDiscarded(L), !1;
        const Er = he().data;
        Fr.data = i(Er, Pt) ? Er : Pt, qt && ur() && ee().onSuccess(Pt, L, r);
      } catch (fr) {
        Ri();
        const Er = ee(), { shouldRetryOnError: Ji } = Er;
        Er.isPaused() || (Fr.error = fr, qt && ur() && (Er.onError(fr, L, Er), (Ji === !0 || Rs(Ji) && Ji(fr)) && (!ee().revalidateOnFocus || !ee().revalidateOnReconnect || J()) && Er.onErrorRetry(fr, L, Er, ($r) => {
          const Tn = T[L];
          Tn && Tn[0] && Tn[0](v_.ERROR_REVALIDATE_EVENT, $r);
        }, {
          retryCount: (Cr.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return ir = !1, pi(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      L,
      n
    ]
  ), _t = ho(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...xe) => FH(n, P.current, ...xe),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (eE(() => {
    j.current = t, Z.current = r, sr(se) || (Ie.current = se);
  }), eE(() => {
    if (!L)
      return;
    const xe = We.bind(ga, NO);
    let Je = 0;
    const bt = bX(L, T, (ir, Cr = {}) => {
      if (ir == v_.FOCUS_EVENT) {
        const qt = Date.now();
        ee().revalidateOnFocus && qt > Je && J() && (Je = qt + ee().focusThrottleInterval, xe());
      } else if (ir == v_.RECONNECT_EVENT)
        ee().revalidateOnReconnect && J() && xe();
      else {
        if (ir == v_.MUTATE_EVENT)
          return We();
        if (ir == v_.ERROR_REVALIDATE_EVENT)
          return We(Cr);
      }
    });
    return V.current = !1, P.current = L, z.current = !0, de({
      _k: F
    }), Ue && (sr(Te) || sy ? xe() : oX(xe)), () => {
      V.current = !0, bt();
    };
  }, [
    L
  ]), eE(() => {
    let xe;
    function Je() {
      const bt = Rs(p) ? p(he().data) : p;
      bt && xe !== -1 && (xe = setTimeout(Pt, bt));
    }
    function Pt() {
      !he().error && (m || ee().isVisible()) && (x || ee().isOnline()) ? We(NO).then(Je) : Je();
    }
    return Je(), () => {
      xe && (clearTimeout(xe), xe = -1);
    };
  }, [
    p,
    m,
    x,
    L
  ]), a7(He), s && sr(Te) && L) {
    if (!LV && sy)
      throw new Error("Fallback data is required when using suspense in SSR.");
    j.current = t, Z.current = r, V.current = !1;
    const xe = D[L];
    if (!sr(xe)) {
      const Je = _t(xe);
      NV(Je);
    }
    if (sr(Pe)) {
      const Je = We(NO);
      sr(He) || (Je.status = "fulfilled", Je.value = !0), NV(Je);
    } else
      throw Pe;
  }
  return {
    mutate: _t,
    get data() {
      return le.data = !0, He;
    },
    get error() {
      return le.error = !0, Pe;
    },
    get isValidating() {
      return le.isValidating = !0, Qe;
    },
    get isLoading() {
      return le.isLoading = !0, it;
    }
  };
}, sve = JC.defineProperty(fX, "defaultValue", {
  value: zH
}), UH = xX(SX);
function CX(e) {
  const {
    advanced: t = {},
    type: r = "simple"
  } = e, {
    refresh: n = void 0,
    revalidate: i = !0
  } = t, s = {
    refreshInterval: n,
    revalidateOnFocus: i
  }, l = Fd(() => e.dataSource ? {
    url: e.dataSource.url,
    args: {
      body: e.dataSource.parameter,
      headers: e.dataSource.headers,
      method: e.dataSource.method,
      namespace: e.dataSource.namespace
    }
  } : null, [e.dataSource]), { data: d, isLoading: h } = UH(l, LH, s);
  return /* @__PURE__ */ At.jsx(At.Fragment, { children: {
    simple: /* @__PURE__ */ At.jsx(d7, { ...e, value: d, loading: h }),
    playful: /* @__PURE__ */ At.jsx(c7, { ...e, value: d, loading: h })
  }[r] || void 0 });
}
var EX = {
  "[object Array]": "array",
  "[object Date]": "date",
  "[object Object]": "object",
  "[object String]": "string"
}, Wa = function(e) {
  if (e === null)
    return "null";
  var t = Object.prototype.toString.call(e);
  return typeof e == "object" ? EX[t] || "object" : typeof e;
}, FR = function(e) {
  return typeof e == "boolean";
}, Ch = function(e) {
  return Sr(e) && e.toString().indexOf("e") !== -1;
}, Ls = function(e) {
  return Wa(e) === "date";
}, I = function(e) {
  return e != null;
}, ct = function(e) {
  return typeof e == "function";
}, lr = function(e) {
  return typeof e == "string";
}, Sr = function(e) {
  return typeof e == "number" && isFinite(e) || !isNaN(e - parseFloat(e));
}, hi = function(e) {
  return Wa(e) === "object";
}, Bd = function(e) {
  var t;
  for (t in e)
    return !1;
  return !0;
}, Qr = function(e) {
  if (!e || Wa(e) !== "object")
    return !1;
  var t = Object.getPrototypeOf(e);
  if (!t)
    return !0;
  var r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return typeof r == "function" && Object.toString.call(r) === Object.toString.call(Object);
};
var Fl = function(e) {
  return e != null && e === e.window;
}, zd = function(e) {
  return !!e && !!(e.jquery || e.dxRenderer);
}, ky = function(e) {
  return !!e && ct(e.then);
}, mM = function(e) {
  return !!e && ct(e.done) && ct(e.fail);
};
var TX = function(e, t, r) {
  e = e || {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      var i = t[n];
      (!(n in e) || r) && (e[n] = i);
    }
  return e;
}, W = function e(t) {
  t = t || {};
  var r = 1, n = !1;
  for (typeof t == "boolean" && (n = t, t = arguments[1] || {}, r++); r < arguments.length; r++) {
    var i = arguments[r];
    if (i != null)
      for (var s in i) {
        var l = t[s], d = i[s], h = !1, p = void 0;
        s === "__proto__" || s === "constructor" || t === d || (n && d && (Qr(d) || (h = Array.isArray(d))) ? (h ? p = l && Array.isArray(l) ? l : [] : p = l && Qr(l) ? l : {}, t[s] = e(n, p, d)) : d !== void 0 && (t[s] = d));
      }
  }
  return t;
}, Bl = (e, t) => {
  if (Array.isArray(e))
    return e.map(t);
  var r = [];
  for (var n in e)
    r.push(t(e[n], n));
  return r;
}, be = (e, t) => {
  if (e) {
    if ("length" in e)
      for (var r = 0; r < e.length && t.call(e[r], r, e[r]) !== !1; r++)
        ;
    else
      for (var n in e)
        if (t.call(e[n], n, e[n]) === !1)
          break;
    return e;
  }
}, jH = (e, t) => {
  if (!(!e || !("length" in e) || e.length === 0))
    for (var r = e.length - 1; r >= 0 && t.call(e[r], r, e[r]) !== !1; r--)
      ;
}, wX = function() {
}, GS = function(e) {
  return typeof console > "u" || !ct(console[e]) ? wX : console[e].bind(console);
}, kg = {
  log: GS("log"),
  info: GS("info"),
  warn: GS("warn"),
  error: GS("error")
};
var lve = function() {
  var e = [new RegExp("&", "g"), new RegExp('"', "g"), new RegExp("'", "g"), new RegExp("<", "g"), new RegExp(">", "g")];
  return function(t) {
    return String(t).replace(e[0], "&amp;").replace(e[1], "&quot;").replace(e[2], "&#39;").replace(e[3], "&lt;").replace(e[4], "&gt;");
  };
}();
function xE(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  return ct(e) ? e(...r) : (r.forEach((i, s) => {
    lr(i) && (i = i.replace(/\$/g, "$$$$"));
    var l = new RegExp("\\{" + s + "\\}", "gm");
    e = e.replace(l, i);
  }), e);
}
var fT = "23.2.4", AX = "https://js.devexpress.com/error/" + fT.split(".").slice(0, 2).join("_") + "/";
function hT(e, t) {
  var r = {
    ERROR_MESSAGES: W(t, e),
    Error: function() {
      return l([].slice.call(arguments));
    },
    log: function(h) {
      var p = "log";
      /^E\d+$/.test(h) ? p = "error" : /^W\d+$/.test(h) && (p = "warn"), kg[p](p === "log" ? h : n([].slice.call(arguments)));
    }
  };
  function n(h) {
    var p = h[0];
    return h = h.slice(1), s(p, i(p, h));
  }
  function i(h, p) {
    return p = [r.ERROR_MESSAGES[h]].concat(p), xE.apply(this, p).replace(/\.*\s*?$/, "");
  }
  function s(h, p) {
    var m = h != null && h.startsWith("W") ? "warning" : "error";
    return xE.apply(this, [`{0} - {1}.

For additional information on this {2} message, see: {3}`, h, p, m, d(h)]);
  }
  function l(h) {
    var p = h[0];
    h = h.slice(1);
    var m = i(p, h), x = d(p), S = s(p, m);
    return W(new Error(S), {
      __id: p,
      __details: m,
      url: x
    });
  }
  function d(h) {
    return AX + h;
  }
  return r;
}
const Dr = hT({
  E0001: "Method is not implemented",
  E0002: "Member name collision: {0}",
  E0003: "A class must be instantiated using the 'new' keyword",
  E0004: "The NAME property of the component is not specified",
  E0005: "Unknown device",
  E0006: "Unknown endpoint key is requested",
  E0007: "'Invalidate' method is called outside the update transaction",
  E0008: "Type of the option name is not appropriate to create an action",
  E0009: "Component '{0}' has not been initialized for an element",
  E0010: "Animation configuration with the '{0}' type requires '{1}' configuration as {2}",
  E0011: "Unknown animation type '{0}'",
  E0012: "jQuery version is too old. Please upgrade jQuery to 1.10.0 or later",
  E0013: "KnockoutJS version is too old. Please upgrade KnockoutJS to 2.3.0 or later",
  E0014: "The 'release' method shouldn't be called for an unlocked Lock object",
  E0015: "Queued task returned an unexpected result",
  E0017: "Event namespace is not defined",
  E0018: "DevExpress.ui.DevExpressPopup widget is required",
  E0020: "Template engine '{0}' is not supported",
  E0021: "Unknown theme is set: {0}",
  E0022: "LINK[rel=DevExpress-theme] tags must go before DevExpress included scripts",
  E0023: "Template name is not specified",
  E0024: "DevExtreme bundle already included",
  E0025: "Unexpected argument type",
  E0100: "Unknown validation type is detected",
  E0101: "Misconfigured range validation rule is detected",
  E0102: "Misconfigured comparison validation rule is detected",
  E0103: "validationCallback of an asynchronous rule should return a jQuery or a native promise",
  E0110: "Unknown validation group is detected",
  E0120: "Adapter for a DevExpressValidator component cannot be configured",
  E0121: "The 'customItem' parameter of the 'onCustomItemCreating' function is empty or contains invalid data. Assign a custom object or a Promise that is resolved after the item is created.",
  W0000: "'{0}' is deprecated in {1}. {2}",
  W0001: "{0} - '{1}' option is deprecated in {2}. {3}",
  W0002: "{0} - '{1}' method is deprecated in {2}. {3}",
  W0003: "{0} - '{1}' property is deprecated in {2}. {3}",
  W0004: "Timeout for theme loading is over: {0}",
  W0005: "'{0}' event is deprecated in {1}. {2}",
  W0006: "Invalid recurrence rule: '{0}'",
  W0007: "'{0}' Globalize culture is not defined",
  W0008: "Invalid view name: '{0}'",
  W0009: "Invalid time zone name: '{0}'",
  W0010: "{0} is deprecated in {1}. {2}",
  W0011: "Number parsing is invoked while the parser is not defined",
  W0012: "Date parsing is invoked while the parser is not defined",
  W0013: "'{0}' file is deprecated in {1}. {2}",
  W0014: "{0} - '{1}' type is deprecated in {2}. {3}",
  W0015: "Instead of returning a value from the '{0}' function, write it into the '{1}' field of the function's parameter.",
  W0016: 'The "{0}" option does not accept the "{1}" value since v{2}. {3}.',
  W0017: 'Setting the "{0}" property with a function is deprecated since v21.2',
  W0018: 'Setting the "position" property with a function is deprecated since v21.2',
  W0019: `DevExtreme: Unable to Locate a Valid License Key.

If you are using a 30-day trial version of DevExtreme, you must uninstall all copies of DevExtreme once your 30-day trial period expires. For terms and conditions that govern use of DevExtreme UI components/libraries, please refer to the DevExtreme End User License Agreement: https://js.devexpress.com/EULAs/DevExtremeComplete.

To use DevExtreme in a commercial project, you must purchase a license. For pricing/licensing options, please visit: https://js.devexpress.com/Buy.

If you have licensing-related questions or need help with a purchase, please email clientservices@devexpress.com.

`,
  W0020: `DevExtreme: License Key Has Expired.

A mismatch exists between the license key used and the DevExtreme version referenced in this project.

To proceed, you can:
• use a version of DevExtreme linked to your license key: https://www.devexpress.com/ClientCenter/DownloadManager
• renew your DevExpress Subscription: https://www.devexpress.com/buy/renew (once you renew your subscription, you will be entitled to product updates and support service as defined in the DevExtreme End User License Agreement)

If you have licensing-related questions or need help with a renewal, please email clientservices@devexpress.com.

`,
  W0021: `DevExtreme: License Key Verification Has Failed.

To verify your DevExtreme license, make certain to specify a correct key in the GlobalConfig. If you continue to encounter this error, please visit https://www.devexpress.com/ClientCenter/DownloadManager to obtain a valid license key.

If you have a valid license and this problem persists, please submit a support ticket via the DevExpress Support Center. We will be happy to follow-up: https://supportcenter.devexpress.com/ticket/create.

`,
  W0022: `DevExtreme: Pre-release software. Not suitable for commercial use.

Pre-release software may contain deficiencies and as such, should not be considered for use or integrated in any mission critical application.

`
});
var OX = function(e, t, r) {
  return function() {
    var n = this.callBase;
    this.callBase = e[t];
    try {
      return r.apply(this, arguments);
    } finally {
      this.callBase = n;
    }
  };
}, kX = function(e) {
  var t = function() {
  };
  return t.prototype = e.prototype, new t();
}, RX = function(e) {
  var t, r, n;
  if (!e)
    return this;
  for (r in e)
    n = e[r], t = typeof this.prototype[r] == "function" && typeof n == "function", this.prototype[r] = t ? OX(this.parent.prototype, r, n) : n;
  return this;
}, DX = function() {
  var e = this, t, r, n, i = Object.prototype.hasOwnProperty.bind(e), s = !i("_includedCtors") && !i("_includedPostCtors");
  for (s && (e._includedCtors = e._includedCtors.slice(0), e._includedPostCtors = e._includedPostCtors.slice(0)), n = 0; n < arguments.length; n++) {
    t = arguments[n], t.ctor && e._includedCtors.push(t.ctor), t.postCtor && e._includedPostCtors.push(t.postCtor);
    for (r in t)
      r === "ctor" || r === "postCtor" || r === "default" || (e.prototype[r] = t[r]);
  }
  return e;
}, MX = function(e) {
  var t = Object.prototype.hasOwnProperty.bind(this)("parent"), r = !t && this.parent;
  if (r) {
    var n = Object.getPrototypeOf(this);
    return n === e || n.subclassOf(e);
  } else
    return this.parent === e ? !0 : !this.parent || !this.parent.subclassOf ? !1 : this.parent.subclassOf(e);
}, $H = function() {
  throw Dr.Error("E0001");
}, LX = /* @__PURE__ */ function() {
  var e = Object.prototype.hasOwnProperty;
  return function(t, r) {
    for (var n in t) {
      if (!e.call(t, n))
        return;
      r[n] = t[n];
    }
  };
}(), Qi = function() {
};
Qi.inherit = function(e) {
  var t = function() {
    if (!this || Fl(this) || typeof this.constructor != "function")
      throw Dr.Error("E0003");
    var r = this, n = r.ctor, i = r.constructor._includedCtors, s = r.constructor._includedPostCtors, l;
    for (l = 0; l < i.length; l++)
      i[l].call(r);
    for (n && n.apply(r, arguments), l = 0; l < s.length; l++)
      s[l].call(r);
  };
  return t.prototype = kX(this), LX(this, t), t.inherit = this.inherit, t.abstract = $H, t.redefine = RX, t.include = DX, t.subclassOf = MX, t.parent = this, t._includedCtors = this._includedCtors ? this._includedCtors.slice(0) : [], t._includedPostCtors = this._includedPostCtors ? this._includedPostCtors.slice(0) : [], t.prototype.constructor = t, t.redefine(e), t;
};
Qi.abstract = $H;
function Fs(e) {
  var t = Qi.inherit(e), r = t, n = new r(e), i = {}, s = function(l, d) {
    be(l, function(h) {
      ct(n[h]) ? (d || !e[h]) && (e[h] = function() {
        return n[h].apply(e, arguments);
      }) : (d && (i[h] = e[h]), e[h] = n[h]);
    });
  };
  return s(e, !0), e.inject = function(l) {
    r = r.inherit(l), n = new r(), s(l);
  }, e.resetInjection = function() {
    W(e, i), r = t, n = new t();
  }, e;
}
function ei() {
  return ei = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ei.apply(this, arguments);
}
var VV = {
  rtlEnabled: !1,
  defaultCurrency: "USD",
  defaultUseCurrencyAccountingStyle: !0,
  oDataFilterToLower: !0,
  serverDecimalSeparator: ".",
  decimalSeparator: ".",
  thousandsSeparator: ",",
  forceIsoDateParsing: !0,
  wrapActionsBeforeExecute: !0,
  useLegacyStoreResult: !1,
  useJQuery: void 0,
  editorStylingMode: void 0,
  useLegacyVisibleIndex: !1,
  floatingActionButtonConfig: {
    icon: "add",
    closeIcon: "close",
    label: "",
    position: {
      at: "right bottom",
      my: "right bottom",
      offset: {
        x: -16,
        y: -16
      }
    },
    maxSpeedDialActionCount: 5,
    shading: !1,
    direction: "auto"
  },
  optionsParser: (e) => {
    e.trim().charAt(0) !== "{" && (e = "{" + e + "}");
    try {
      return JSON.parse(e);
    } catch (t) {
      try {
        return JSON.parse(PX(e));
      } catch {
        throw Dr.Error("E3018", t, e);
      }
    }
  }
}, PX = (e) => e.replace(/'/g, '"').replace(/,\s*([\]}])/g, "$1").replace(/([{,])\s*([^":\s]+)\s*:/g, '$1"$2":'), IX = ["decimalSeparator", "thousandsSeparator"], Zr = function() {
  if (!arguments.length)
    return VV;
  var e = arguments.length <= 0 ? void 0 : arguments[0];
  IX.forEach((t) => {
    if (e[t]) {
      var r = "Now, the ".concat(t, " is selected based on the specified locale.");
      Dr.log("W0003", "config", t, "19.2", r);
    }
  }), W(VV, e);
};
typeof DevExpress < "u" && DevExpress.config && Zr(DevExpress.config);
var NX = Qi.inherit({
  ctor: function(e) {
    e && (e = String(e)), this._value = this._normalize(e || this._generate());
  },
  _normalize: function(e) {
    for (e = e.replace(/[^a-f0-9]/gi, "").toLowerCase(); e.length < 32; )
      e += "0";
    return [e.substr(0, 8), e.substr(8, 4), e.substr(12, 4), e.substr(16, 4), e.substr(20, 12)].join("-");
  },
  _generate: function() {
    for (var e = "", t = 0; t < 32; t++)
      e += Math.round(15 * Math.random()).toString(16);
    return e;
  },
  toString: function() {
    return this._value;
  },
  valueOf: function() {
    return this._value;
  },
  toJSON: function() {
    return this._value;
  }
}), ic = function(e) {
  this._options = e || {}, this._list = [], this._queue = [], this._firing = !1, this._fired = !1, this._firingIndexes = [];
};
ic.prototype._fireCore = function(e, t) {
  var r = this._firingIndexes, n = this._list, i = this._options.stopOnFalse, s = r.length;
  for (r[s] = 0; r[s] < n.length; r[s]++) {
    var l = n[r[s]].apply(e, t);
    if (l === !1 && i)
      break;
  }
  r.pop();
};
ic.prototype.add = function(e) {
  return typeof e == "function" && (!this._options.unique || !this.has(e)) && this._list.push(e), this;
};
ic.prototype.remove = function(e) {
  var t = this._list, r = this._firingIndexes, n = t.indexOf(e);
  if (n > -1 && (t.splice(n, 1), this._firing && r.length))
    for (var i = 0; i < r.length; i++)
      n <= r[i] && r[i]--;
  return this;
};
ic.prototype.has = function(e) {
  var t = this._list;
  return e ? t.indexOf(e) > -1 : !!t.length;
};
ic.prototype.empty = function(e) {
  return this._list = [], this;
};
ic.prototype.fireWith = function(e, t) {
  var r = this._queue;
  if (t = t || [], t = t.slice ? t.slice() : t, this._options.syncStrategy)
    this._firing = !0, this._fireCore(e, t);
  else {
    if (r.push([e, t]), this._firing)
      return;
    for (this._firing = !0; r.length; ) {
      var n = r.shift();
      this._fireCore(n[0], n[1]);
    }
  }
  return this._firing = !1, this._fired = !0, this;
};
ic.prototype.fire = function() {
  this.fireWith(this, arguments);
};
ic.prototype.fired = function() {
  return this._fired;
};
var Xa = function(e) {
  return new ic(e);
}, YH = [{
  method: "resolve",
  handler: "done",
  state: "resolved"
}, {
  method: "reject",
  handler: "fail",
  state: "rejected"
}, {
  method: "notify",
  handler: "progress"
}], Rg = function() {
  var e = this;
  this._state = "pending", this._promise = {}, YH.forEach((function(t) {
    var r = t.method;
    this[r + "Callbacks"] = Xa(), this[r] = (function() {
      return this[r + "With"](this._promise, arguments);
    }).bind(this), this._promise[t.handler] = function(n) {
      if (!n)
        return this;
      var i = e[r + "Callbacks"];
      return i.fired() ? n.apply(e[r + "Context"], e[r + "Args"]) : i.add((function(s, l) {
        n.apply(s, l);
      }).bind(this)), this;
    };
  }).bind(this)), this._promise.always = function(t) {
    return this.done(t).fail(t);
  }, this._promise.catch = function(t) {
    return this.then(null, t);
  }, this._promise.then = function(t, r) {
    var n = new Rg();
    return ["done", "fail"].forEach((function(i) {
      var s = i === "done" ? t : r;
      this[i](function() {
        if (!s) {
          n[i === "done" ? "resolve" : "reject"].apply(this, arguments);
          return;
        }
        var l = s && s.apply(this, arguments);
        mM(l) ? l.done(n.resolve).fail(n.reject) : ky(l) ? l.then(n.resolve, n.reject) : n.resolve.apply(this, I(l) ? [l] : arguments);
      });
    }).bind(this)), n.promise();
  }, this._promise.state = function() {
    return e._state;
  }, this._promise.promise = function(t) {
    return t ? W(t, e._promise) : e._promise;
  }, this._promise.promise(this);
};
YH.forEach(function(e) {
  var t = e.method, r = e.state;
  Rg.prototype[t + "With"] = function(n, i) {
    var s = this[t + "Callbacks"];
    return this.state() === "pending" && (this[t + "Args"] = i, this[t + "Context"] = n, r && (this._state = r), s.fire(n, i)), this;
  };
});
function Pd(e, t) {
  if (mM(e))
    return e;
  if (ky(e)) {
    var r = new Rg();
    return e.then(function() {
      r.resolveWith.apply(r, [t].concat([
        [].slice.call(arguments)
      ]));
    }, function() {
      r.rejectWith.apply(r, [t].concat([
        [].slice.call(arguments)
      ]));
    }), r;
  }
  return new Rg().resolveWith(t, [e]);
}
var VX = function() {
  if (arguments.length === 1)
    return Pd(arguments[0]);
  for (var e = [].slice.call(arguments), t = [], r = 0, n = new Rg(), i = function(l) {
    return function(d) {
      t[l] = this, e[l] = arguments.length > 1 ? [].slice.call(arguments) : d, r++, r === e.length && n.resolveWith(t, e);
    };
  }, s = 0; s < e.length; s++)
    mM(e[s]) ? e[s].promise().done(i(s)).fail(n.reject) : r++;
  return r === e.length && n.resolveWith(t, e), n.promise();
};
function Yt() {
  return new Rg();
}
function Ps() {
  return VX.apply(this, arguments);
}
const ly = Fs({
  isWrapped: function() {
    return !1;
  },
  isWritableWrapped: function() {
    return !1;
  },
  wrap: function(e) {
    return e;
  },
  unwrap: function(e) {
    return e;
  },
  assign: function() {
    kg.error("Method 'assign' should not be used for not wrapped variables. Use 'isWrapped' method for ensuring.");
  }
});
var Vg = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    return e.prototype = t, new e();
  };
}();
var FX = function(e, t, r, n) {
  !n && ly.isWrapped(e[t]) ? ly.assign(e[t], r) : e[t] = r;
}, vT = function e(t, r, n, i) {
  var s, l;
  for (var d in r)
    if (s = t[d], l = r[d], !(d === "__proto__" || d === "constructor" || t === l)) {
      if (Qr(l)) {
        var h = n ? hi(s) : Qr(s);
        l = e(h ? s : {}, l, n, i);
      }
      l !== void 0 && s !== l && FX(t, d, l, i);
    }
  return t;
}, BX = ly.unwrap, WH = ly.isWrapped, zX = ly.assign, HX = function(e) {
  return e.replace(/\[/g, ".").replace(/\]/g, "");
}, Ry = function(e) {
  return HX(e).split(".");
}, GX = function(e, t, r) {
  return r = r || {}, uy(t === "this" ? e : e[t], r);
}, XH = function(e, t, r, n) {
  if (t === "this")
    throw new Dr.Error("E4016");
  var i = e[t];
  n.unwrapObservables && WH(i) ? zX(i, r) : e[t] = r;
}, qH = function(e) {
  return e = e || {}, e.unwrapObservables = e.unwrapObservables !== void 0 ? e.unwrapObservables : !0, e;
};
function uy(e, t) {
  return t.unwrapObservables ? BX(e) : e;
}
var ac = function(e) {
  if (arguments.length > 1 && (e = [].slice.call(arguments)), !e || e === "this")
    return function(r) {
      return r;
    };
  if (typeof e == "string") {
    var t = Ry(e);
    return function(r, n) {
      n = qH(n);
      for (var i = n.functionsAsIs, s = ("defaultValue" in n), l = uy(r, n), d = 0; d < t.length; d++) {
        if (!l) {
          if (l == null && s)
            return n.defaultValue;
          break;
        }
        var h = t[d];
        if (s && hi(l) && !(h in l))
          return n.defaultValue;
        var p = uy(l[h], n);
        !i && ct(p) && (p = p.call(l)), l = p;
      }
      return l;
    };
  }
  if (Array.isArray(e))
    return UX(e);
  if (ct(e))
    return e;
};
function UX(e) {
  for (var t = {}, r = 0, n = e.length; r < n; r++) {
    var i = e[r];
    t[i] = ac(i);
  }
  return function(s, l) {
    var d;
    return be(t, function(h) {
      var p = this(s, l);
      if (p !== void 0) {
        for (var m = d || (d = {}), x = h.split("."), S = x.length - 1, T = 0; T < S; T++) {
          var k = x[T];
          k in m || (m[k] = {}), m = m[k];
        }
        m[x[S]] = p;
      }
    }), d;
  };
}
var FV = function(e, t, r, n) {
  if (I(r))
    return r;
  var i = {};
  return XH(e, t, i, n), i;
}, jX = function(e) {
  e = Ry(e || "this");
  var t = e.length - 1;
  return function(r, n, i) {
    i = qH(i);
    var s = uy(r, i);
    e.forEach(function(l, d) {
      var h = GX(s, l, i), p = !i.functionsAsIs && ct(h) && !WH(h);
      d === t ? i.merge && Qr(n) && (!I(h) || Qr(h)) ? (h = FV(s, l, h, i), vT(h, n, !1, !0)) : p ? s[l](n) : XH(s, l, n, i) : (h = FV(s, l, h, i), p && (h = h.call(s)), s = h);
    });
  };
}, kh = function(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (e instanceof Date)
    return e.getTime();
  if (e && e instanceof Qi && e.valueOf)
    return e.valueOf();
  if (!t && typeof e == "string") {
    var n;
    if ((r == null || (n = r.collatorOptions) === null || n === void 0 ? void 0 : n.sensitivity) === "base") {
      var i = /[\u0300-\u036f]/g;
      e = e.normalize("NFD").replace(i, "");
    }
    return r != null && r.locale ? e.toLocaleLowerCase(r.locale) : e.toLowerCase();
  }
  return e;
};
var $X = function(e, t) {
  var r = new Yt(), n = t || this, i = {
    promise: r.promise(),
    abort: function() {
      clearTimeout(l), r.rejectWith(n);
    }
  }, s = function() {
    var d = e.call(n);
    d && d.done && ct(d.done) ? d.done(function() {
      r.resolveWith(n);
    }) : r.resolveWith(n);
  }, l = (arguments[2] || setTimeout)(s, typeof t == "number" ? t : 0);
  return i;
}, VO = [], BV = [], p_ = [], Ip, KH = function(e, t, r) {
  if (Ip && Ip !== e)
    return VO.push(t), BV.push(e), r = r || new Yt(), p_.push(r), r;
  var n = Ip, i = p_.length;
  Ip = e;
  var s = t();
  return s || (p_.length > i ? s = Ps.apply(this, p_.slice(i)) : r && r.resolve()), Ip = n, r && s && s.done && s.done(r.resolve).fail(r.reject), !Ip && VO.length && (BV.shift() === "render" ? YX : ZH)(VO.shift(), p_.shift()), s || Ps();
}, YX = function(e, t) {
  return KH("render", e, t);
}, ZH = function(e, t) {
  return KH("update", e, t);
};
var QH = function(e, t, r) {
  var n = [], i = 0;
  return be(t, (s, l) => {
    var d = 0, h = r ? r(l) : l;
    be(e, (p, m) => {
      var x = h[p];
      if (x !== void 0) {
        if (WX(x, m)) {
          d++;
          return;
        }
        return d = -1, !1;
      }
    }), !(d < i) && (d > i && (n.length = 0, i = d), n.push(l));
  }), n;
}, WX = function(e, t) {
  if (Array.isArray(e) && Array.isArray(t)) {
    var r = !1;
    return be(e, (n, i) => {
      if (i !== t[n])
        return r = !0, !1;
    }), !r;
  }
  return e === t;
};
var bE = function(e) {
  return e.replace(/[[\]{}\-()*+?.\\^$|\s]/g, "\\$&");
};
var Y = function() {
};
var _M = function(e, t, r) {
  for (var n = [], i, s = !r, l = 0; l < e.length; l++)
    i = !!t(e[l], l), i === s && n.push(e[l]);
  return n;
}, XX = (e, t, r, n) => e.length !== t.length ? !1 : !e.some((i, s) => !yM(i, t[s], r + 1, ei({}, n, {
  strict: !0
}))), qX = (e, t, r, n) => {
  var i = Object.keys(e), s = Object.keys(t);
  if (i.length !== s.length)
    return !1;
  var l = new Set(s);
  return !i.some((d) => !l.has(d) || !yM(e[d], t[d], r + 1, n));
}, zV = {
  maxDepth: 3,
  strict: !0
}, yM = (e, t, r, n) => {
  var {
    strict: i,
    maxDepth: s
  } = n, l = kh(e, !0), d = kh(t, !0), h = i ? l === d : l == d;
  switch (!0) {
    case h:
    case r >= s:
      return !0;
    case (hi(l) && hi(d)):
      return qX(l, d, r, n);
    case (Array.isArray(l) && Array.isArray(d)):
      return XX(l, d, r, n);
    default:
      return !1;
  }
}, BR = function(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : zV, n = ei({}, zV, r);
  return yM(e, t, 0, n);
}, FO = "dx-", US = null;
function HV(e) {
  try {
    return new CSSStyleSheet();
  } catch {
    var t = e.ownerDocument.createElement("style");
    return e.appendChild(t), t.sheet;
  }
}
function GV(e, t, r) {
  for (var n = 0; n < t.length; n++) {
    var i = t[n];
    try {
      for (var s = 0; s < i.cssRules.length; s++)
        KX(e, i.cssRules[s], r);
    } catch {
    }
  }
}
function KX(e, t, r) {
  var n, i, s, l, d, h, p = r || ((n = t.selectorText) === null || n === void 0 ? void 0 : n.includes(FO)) || ((i = t.cssRules) === null || i === void 0 || (s = i[0]) === null || s === void 0 || (l = s.selectorText) === null || l === void 0 ? void 0 : l.includes(FO)) || ((d = t.name) === null || d === void 0 ? void 0 : d.startsWith(FO)) || ((h = t.style) === null || h === void 0 ? void 0 : h.fontFamily) === "DXIcons";
  p && e.insertRule(t.cssText, e.cssRules.length);
}
function ZX(e) {
  var t, r = e.get(0), n = (t = r.getRootNode) === null || t === void 0 ? void 0 : t.call(r);
  if (n != null && n.host) {
    US || (US = HV(n), GV(US, r.ownerDocument.styleSheets, !1));
    var i = HV(n);
    GV(i, n.styleSheets, !0), n.adoptedStyleSheets = [US, i];
  }
}
function QX(e, t, r) {
  var n = e.getBoundingClientRect();
  return n && t >= n.left && t < n.right && r >= n.top && r < n.bottom;
}
function JX() {
  var e = 0, t = [];
  return {
    push(r) {
      return t.push(r), this;
    },
    shift() {
      return e++, t[e - 1];
    },
    get length() {
      return t.length - e;
    },
    get items() {
      return t;
    }
  };
}
function eq(e, t, r) {
  for (var n = JX().push(r); n.length; )
    for (var i = n.shift(), s = 0; s < i.childNodes.length; s++) {
      var l = i.childNodes[s];
      l.nodeType === Node.ELEMENT_NODE && QX(l, e, t) && getComputedStyle(l).pointerEvents !== "none" && n.push(l);
    }
  var d = n.items.reverse();
  return d.pop(), d;
}
var tq = 1, rq = 3, nq = 9, iq = 11, aq = {
  querySelectorAll: (e, t) => e.querySelectorAll(t),
  elementMatches(e, t) {
    var r = e.matches || e.matchesSelector || e.mozMatchesSelector || e.msMatchesSelector || e.oMatchesSelector || e.webkitMatchesSelector || ((n) => {
      var i = e.document || e.ownerDocument;
      if (!i)
        return !1;
      for (var s = this.querySelectorAll(i, n), l = 0; l < s.length; l++)
        if (s[l] === e)
          return !0;
    });
    return r.call(e, t);
  },
  createElement(e, t) {
    return t = t || this._document, t.createElement(e);
  },
  createElementNS(e, t, r) {
    return r = r || this._document, r.createElementNS(e, t);
  },
  createTextNode(e, t) {
    return t = t || this._document, t.createTextNode(e);
  },
  createAttribute(e, t) {
    return t = t || this._document, t.createAttribute(e);
  },
  isNode: (e) => e && typeof e == "object" && "nodeType" in e && "nodeName" in e,
  isElementNode: (e) => e && e.nodeType === tq,
  isTextNode: (e) => e && e.nodeType === rq,
  isDocument: (e) => e && e.nodeType === nq,
  isDocumentFragment: (e) => e && e.nodeType === iq,
  removeElement(e) {
    var t = e && e.parentNode;
    t && t.removeChild(e);
  },
  insertElement(e, t, r) {
    e && t && e !== t && (r ? e.insertBefore(t, r) : e.appendChild(t));
  },
  getAttribute: (e, t) => e.getAttribute(t),
  setAttribute(e, t, r) {
    t === "style" ? e.style.cssText = r : e.setAttribute(t, r);
  },
  removeAttribute(e, t) {
    e.removeAttribute(t);
  },
  setProperty(e, t, r) {
    e[t] = r;
  },
  setText(e, t) {
    e && (e.textContent = t);
  },
  setClass(e, t, r) {
    e.nodeType === 1 && t && (r ? e.classList.add(t) : e.classList.remove(t));
  },
  setStyle(e, t, r) {
    e.style[t] = r || "";
  },
  _document: typeof document > "u" ? void 0 : document,
  getDocument() {
    return this._document;
  },
  getActiveElement(e) {
    var t = this.getRootNode(e);
    return t.activeElement;
  },
  getRootNode(e) {
    var t, r;
    return (t = e == null || (r = e.getRootNode) === null || r === void 0 ? void 0 : r.call(e)) !== null && t !== void 0 ? t : this._document;
  },
  getBody() {
    return this._document.body;
  },
  createDocumentFragment() {
    return this._document.createDocumentFragment();
  },
  getDocumentElement() {
    return this._document.documentElement;
  },
  getLocation() {
    return this._document.location;
  },
  getSelection() {
    return this._document.selection;
  },
  getReadyState() {
    return this._document.readyState;
  },
  getHead() {
    return this._document.head;
  },
  hasDocumentProperty(e) {
    return e in this._document;
  },
  listen(e, t, r, n) {
    return !e || !("addEventListener" in e) ? Y : (e.addEventListener(t, r, n), () => {
      e.removeEventListener(t, r);
    });
  },
  elementsFromPoint(e, t, r) {
    var n = this.getRootNode(r);
    return n.host ? eq(e, t, n) : n.elementsFromPoint(e, t);
  }
};
const we = Fs(aq);
class xM {
  constructor() {
    this.memory = [], this.callbacks = Xa();
  }
  add(t) {
    be(this.memory, (r, n) => t.apply(t, n)), this.callbacks.add(t);
  }
  remove(t) {
    this.callbacks.remove(t);
  }
  fire() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    this.memory.push(r), this.callbacks.fire.apply(this.callbacks, r);
  }
}
const bM = new xM();
var oq = typeof window < "u", fn = () => oq, gh = fn() ? window : void 0;
gh || (gh = {}, gh.window = gh);
var jr = () => gh;
var SM = (e) => fn() && e in gh;
var Dy = () => fn() ? gh.navigator : {
  userAgent: ""
}, sq = ["pageX", "pageY", "screenX", "screenY", "clientX", "clientY"], lq = function(e, t) {
  if (t[e] && !t.touches || !t.touches)
    return t[e];
  var r = t.touches.length ? t.touches : t.changedTouches;
  if (r.length)
    return r[0][e];
};
function uq(e) {
  sq.forEach(function(t) {
    e(t, function(r) {
      return lq(t, r);
    });
  }, this);
}
var zl = function(e) {
  var t, r = function() {
    return t = e.apply(this, arguments), r = function() {
      return t;
    }, t;
  };
  return function() {
    return r.apply(this, arguments);
  };
}, CM = jr(), jS = "dxEmptyEventType", UV = {
  mouseenter: "mouseover",
  mouseleave: "mouseout",
  pointerenter: "pointerover",
  pointerleave: "pointerout"
}, cq = {
  focusin: "focus",
  focusout: "blur"
}, dq = ["blur", "focus", "load"], JH = ["touchmove", "wheel", "mousewheel", "touchstart"], fq = ["target", "relatedTarget", "delegateTarget", "altKey", "bubbles", "cancelable", "changedTouches", "ctrlKey", "detail", "eventPhase", "metaKey", "shiftKey", "view", "char", "code", "charCode", "key", "keyCode", "button", "buttons", "offsetX", "offsetY", "pointerId", "pointerType", "targetTouches", "toElement", "touches"];
function hq(e, t) {
  return !Fl(e) && e.nodeName !== "#document" && we.elementMatches(e, t);
}
var BO = /* @__PURE__ */ new WeakMap(), eG = 0, SE, Cd = function() {
  var e = {};
  return bM.add(function(t, r) {
    e[t] = r;
  }), {
    getField: function(t, r) {
      return e[t] && e[t][r];
    },
    callMethod: function(t, r, n, i) {
      return e[t] && e[t][r] && e[t][r].apply(n, i);
    }
  };
}(), Ve = Fs({
  on: g_(zR(YV(function(e, t, r, n, i) {
    var s = ug(e, t);
    s.addHandler(i, r, n);
  }))),
  one: g_(zR(function(e, t, r, n, i) {
    Ve.on(e, t, r, n, function s() {
      Ve.off(e, t, r, s), i.apply(this, arguments);
    });
  })),
  off: g_(gq(YV(function(e, t, r, n) {
    var i = ug(e, t);
    i.removeHandler(n, r);
  }))),
  trigger: g_($V(function(e, t, r) {
    var n = t.type, i = ug(e, t.type);
    Cd.callMethod(n, "trigger", e, [t, r]), i.callHandlers(t, r);
    var s = Cd.getField(n, "noBubble") || t.isPropagationStopped() || dq.indexOf(n) !== -1;
    if (!s) {
      var l = [];
      (function p(m) {
        var x, S = (x = m.parentNode) !== null && x !== void 0 ? x : hi(m.host) ? m.host : null;
        S && (l.push(S), p(S));
      })(e), l.push(CM);
      for (var d = 0; l[d] && !t.isPropagationStopped(); ) {
        var h = ug(l[d], t.type);
        h.callHandlers(W(t, {
          currentTarget: l[d]
        }), r), d++;
      }
    }
    (e.nodeType || Fl(e)) && (Cd.callMethod(n, "_default", e, [t, r]), _q(n, e));
  })),
  triggerHandler: g_($V(function(e, t, r) {
    var n = ug(e, t.type);
    n.callHandlers(t, r);
  }))
});
function EM(e, t) {
  var r = e[0];
  if (r)
    if (we.isNode(r) || Fl(r))
      t.apply(Ve, e);
    else if (!lr(r) && "length" in r) {
      var n = Array.prototype.slice.call(e, 0);
      Array.prototype.forEach.call(r, function(i) {
        n[0] = i, EM(n, t);
      });
    } else
      throw Dr.Error("E0025");
}
function g_(e) {
  return function() {
    EM(arguments, e);
  };
}
function vq() {
  var e = !1;
  try {
    var t = Object.defineProperty({}, "passive", {
      get: function() {
        return e = !0, !0;
      }
    });
    CM.addEventListener("test", null, t);
  } catch {
  }
  return e;
}
var tG = zl(vq), rG = (e, t) => Fl(e) ? rG(e.document, t) : e.contains ? e.contains(t) : !!(t.compareDocumentPosition(e) & t.DOCUMENT_POSITION_CONTAINS);
function ug(e, t) {
  var r = BO.get(e);
  t = t || "";
  var n = t.split("."), i = n.slice(1), s = !!n[0];
  t = n[0] || jS, r || (r = {}, BO.set(e, r)), r[t] || (r[t] = {
    handleObjects: [],
    nativeHandler: null
  });
  var l = r[t];
  return {
    addHandler: function(d, h, p) {
      var m = function(O, D) {
        var L = [O], F = O.currentTarget, z = O.relatedTarget, V, P;
        t in UV && (V = z && F && (z === F || rG(F, z))), D !== void 0 && L.push(D), Cd.callMethod(t, "handle", e, [O, p]), V || (P = d.apply(F, L)), P === !1 && (O.preventDefault(), O.stopPropagation());
      }, x = {
        handler: d,
        wrappedHandler: function(O, D) {
          if (!(SE && O.type === SE))
            if (O.data = p, O.delegateTarget = e, h)
              for (var L = O.target; L && L !== e; )
                hq(L, h) && (O.currentTarget = L, m(O, D)), L = L.parentNode;
            else
              O.currentTarget = O.delegateTarget || O.target, m(O, D);
        },
        selector: h,
        type: t,
        data: p,
        namespace: i.join("."),
        namespaces: i,
        guid: ++eG
      };
      l.handleObjects.push(x);
      var S = l.handleObjects.length === 1, T = S && s, k;
      T && (T = !Cd.callMethod(t, "setup", e, [p, i, d])), T && (l.nativeHandler = pq(t), tG() && JH.indexOf(t) > -1 && (k = {
        passive: !1
      }), l.removeListener = we.listen(e, UV[t] || t, l.nativeHandler, k)), Cd.callMethod(t, "add", e, [x]);
    },
    removeHandler: function(d, h) {
      var p = function(S) {
        var T = r[S];
        if (!T.handleObjects.length) {
          delete r[S];
          return;
        }
        var k;
        T.handleObjects = T.handleObjects.filter(function(L) {
          var F = i.length && !jV(L.namespaces, i) || d && L.handler !== d || h && L.selector !== h;
          return F || (k = L.handler, Cd.callMethod(S, "remove", e, [L])), F;
        });
        var O = !T.handleObjects.length, D = O && S !== jS;
        D && (Cd.callMethod(S, "teardown", e, [i, k]), T.nativeHandler && T.removeListener(), delete r[S]);
      };
      if (s)
        p(t);
      else
        for (var m in r)
          p(m);
      var x = Object.keys(r).length === 0;
      x && BO.delete(e);
    },
    callHandlers: function(d, h) {
      var p = !1, m = function(x) {
        p || (!i.length || jV(x.namespaces, i)) && (x.wrappedHandler(d, h), p = d.isImmediatePropagationStopped());
      };
      l.handleObjects.forEach(m), i.length && r[jS] && r[jS].handleObjects.forEach(m);
    }
  };
}
function pq(e) {
  return function(t, r) {
    var n = ug(this, e);
    t = Ve.Event(t), n.callHandlers(t, r);
  };
}
function jV(e, t) {
  for (var r = 0; r < t.length; r++)
    if (e.indexOf(t[r]) < 0)
      return !1;
  return !0;
}
function zR(e) {
  return function(t, r, n, i, s) {
    s || (s = i, i = void 0), typeof n != "string" && (i = n, n = void 0), !s && typeof r == "string" && (s = i || n, n = void 0, i = void 0), e(t, r, n, i, s);
  };
}
function gq(e) {
  return function(t, r, n, i) {
    typeof n == "function" && (i = n, n = void 0), e(t, r, n, i);
  };
}
function $V(e) {
  return function(t, r, n) {
    typeof r == "string" && (r = {
      type: r
    }), r.target || (r.target = t), r.currentTarget = t, r.delegateTarget || (r.delegateTarget = t), !r.type && r.originalEvent && (r.type = r.originalEvent.type), e(t, r instanceof Ve.Event ? r : Ve.Event(r), n);
  };
}
function mq(e) {
  return Ve.Event = function(t, r) {
    if (!(this instanceof Ve.Event))
      return new Ve.Event(t, r);
    t || (t = {}), typeof t == "string" && (t = {
      type: t
    }), r || (r = {}), e.call(this, t, r);
  }, ei(Ve.Event.prototype, {
    _propagationStopped: !1,
    _immediatePropagationStopped: !1,
    _defaultPrevented: !1,
    isPropagationStopped: function() {
      return !!(this._propagationStopped || this.originalEvent && this.originalEvent.propagationStopped);
    },
    stopPropagation: function() {
      this._propagationStopped = !0, this.originalEvent && this.originalEvent.stopPropagation();
    },
    isImmediatePropagationStopped: function() {
      return this._immediatePropagationStopped;
    },
    stopImmediatePropagation: function() {
      this.stopPropagation(), this._immediatePropagationStopped = !0, this.originalEvent && this.originalEvent.stopImmediatePropagation();
    },
    isDefaultPrevented: function() {
      return !!(this._defaultPrevented || this.originalEvent && this.originalEvent.defaultPrevented);
    },
    preventDefault: function() {
      this._defaultPrevented = !0, this.originalEvent && this.originalEvent.preventDefault();
    }
  }), Ve.Event;
}
function YV(e) {
  var t = function(r, n) {
    if (n && n.indexOf(" ") > -1) {
      var i = Array.prototype.slice.call(arguments, 0);
      n.split(" ").forEach(function(s) {
        i[1] = s, e.apply(this, i);
      });
    } else
      e.apply(this, arguments);
  };
  return function(r, n) {
    if (typeof n == "object") {
      var i = Array.prototype.slice.call(arguments, 0);
      for (var s in n)
        i[1] = s, i[i.length - 1] = n[s], t.apply(this, i);
    } else
      t.apply(this, arguments);
  };
}
function _q(e, t) {
  var r = cq[e] || e;
  (function(n, i) {
    return n === "click" && i.localName === "a";
  })(e, t) || ct(t[r]) && (SE = e, t[r](), SE = void 0);
}
function yq(e) {
  return function(t) {
    return t.which == null && t.type.indexOf("key") === 0;
  }(e) ? e.charCode != null ? e.charCode : e.keyCode : function(t) {
    return !t.which && t.button !== void 0 && /^(?:mouse|pointer|contextmenu|drag|drop)|click/.test(t.type);
  }(e) ? {
    1: 1,
    2: 3,
    3: 1,
    4: 2
  }[e.button] : e.which;
}
function nG(e) {
  e && (Ve.Event = e, Ve.Event.prototype = e.prototype);
}
nG(mq(function(e, t) {
  var r, n = e instanceof Ve.Event || fn() && e instanceof CM.Event || ((r = e.view) === null || r === void 0 ? void 0 : r.Event) && e instanceof e.view.Event;
  n ? (this.originalEvent = e, this.type = e.type, this.currentTarget = void 0, Object.prototype.hasOwnProperty.call(e, "isTrusted") && (this.isTrusted = e.isTrusted), this.timeStamp = e.timeStamp || Date.now()) : ei(this, e), TM("which", yq, this), e.type.indexOf("touch") === 0 && (delete t.pageX, delete t.pageY), ei(this, t), this.guid = ++eG;
}));
function TM(e, t, r) {
  Object.defineProperty(r || Ve.Event.prototype, e, {
    enumerable: !0,
    configurable: !0,
    get: function() {
      return this.originalEvent && t(this.originalEvent);
    },
    set: function(n) {
      Object.defineProperty(this, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
      });
    }
  });
}
fq.forEach((e) => TM(e, (t) => t[e]));
uq(TM);
var iG = Xa(), aG = Xa();
Ve.set = function(e) {
  iG.fire(), Ve.inject(e), nG(e.Event), aG.fire();
};
Ve.subscribeGlobal = function() {
  EM(arguments, zR(function() {
    var e = arguments;
    Ve.on.apply(this, e), iG.add(function() {
      var t = Array.prototype.slice.call(e, 0);
      t.splice(3, 1), Ve.off.apply(this, t);
    }), aG.add(function() {
      Ve.on.apply(this, e);
    });
  }));
};
Ve.forcePassiveFalseEventNames = JH;
Ve.passiveEventHandlersSupported = tG;
var m_ = /* @__PURE__ */ new WeakMap(), Eh, xq = new xM(), oG = function() {
}, bq = function() {
}, Sq = function(e) {
  xq.fire(e), Eh = e;
  var t = Eh.cleanData;
  Eh.cleanData = function(r) {
    oG(r);
    var n = t.call(this, r);
    return bq(r), n;
  };
};
Sq({
  data: function() {
    var e = arguments[0], t = arguments[1], r = arguments[2];
    if (e) {
      var n = m_.get(e);
      return n || (n = {}, m_.set(e, n)), t === void 0 ? n : arguments.length === 2 ? n[t] : (n[t] = r, r);
    }
  },
  removeData: function(e, t) {
    if (e)
      if (t === void 0)
        m_.delete(e);
      else {
        var r = m_.get(e);
        r && delete r[t];
      }
  },
  cleanData: function(e) {
    for (var t = 0; t < e.length; t++)
      Ve.off(e[t]), m_.delete(e[t]);
  }
});
function di() {
  return Eh.data.apply(this, arguments);
}
function Cq(e) {
  oG = e;
}
function wM(e, t) {
  return Eh.removeData.call(this, e, t);
}
function pT(e, t) {
  if (we.isElementNode(e)) {
    var r = e.getElementsByTagName("*");
    Eh.cleanData(r), t && Eh.cleanData([e]);
  }
}
var sG = function(e) {
  return e == null ? "" : String(e);
}, lG = function(e) {
  return sG(e).charAt(0).toUpperCase() + e.substr(1);
}, uG = function(e) {
  return sG(e).replace(/([a-z\d])([A-Z])/g, "$1 $2").split(/[\s_-]+/);
}, Eq = function(e) {
  return Bl(uG(e), function(t) {
    return t.toLowerCase();
  }).join("-");
};
var Dg = function(e, t) {
  return Bl(uG(e), function(r, n) {
    return r = r.toLowerCase(), (t || n > 0) && (r = lG(r)), r;
  }).join("");
}, Tq = function(e) {
  return lG(Eq(e).replace(/-/g, " "));
};
var CE = ["", "Webkit", "Moz", "O", "Ms"], wq = {
  "": "",
  Webkit: "-webkit-",
  Moz: "-moz-",
  O: "-o-",
  ms: "-ms-"
}, HR = zl(function() {
  return we.createElement("dx").style;
}), Aq = function(e, t) {
  e = Dg(e, !0);
  for (var r, n = 0, i = CE.length; n < i; n++) {
    var s = CE[n], l = s + e, d = Dg(l);
    if (r = t(d, s), r === void 0 && (r = t(l, s)), r !== void 0)
      break;
  }
  return r || "";
}, Fg = function(e) {
  if (e in HR())
    return e;
  var t = e;
  e = e.charAt(0).toUpperCase() + e.substr(1);
  for (var r = 1; r < CE.length; r++) {
    var n = CE[r].toLowerCase() + e;
    if (n in HR())
      return n;
  }
  return t;
}, Oq = function(e) {
  return Aq(e, function(t, r) {
    if (t in HR())
      return wq[r];
  });
}, kq = ["fillOpacity", "columnCount", "flexGrow", "flexShrink", "fontWeight", "lineHeight", "opacity", "zIndex", "zoom"];
var Rq = function(e, t) {
  return Sr(t) && kq.indexOf(e) === -1 && (t += "px"), t;
};
var Dq = jr();
var zO = function(e, t) {
  var r = 0;
  return t.forEach(function(n) {
    r += parseFloat(e[n]) || 0;
  }), r;
}, Mq = function(e, t) {
  var r = e === "width" ? "Left" : "Top", n = e === "width" ? "Right" : "Bottom";
  return {
    padding: zO(t, ["padding" + r, "padding" + n]),
    border: zO(t, ["border" + r + "Width", "border" + n + "Width"]),
    margin: zO(t, ["margin" + r, "margin" + n])
  };
}, cG = function(e) {
  var t, r = (e == null || (t = e.ownerDocument) === null || t === void 0 ? void 0 : t.defaultView) || Dq;
  return r.getComputedStyle && r.getComputedStyle(e);
}, GR = function(e, t, r, n) {
  var i;
  return (t == null ? void 0 : t[r]) || ((i = e.style) === null || i === void 0 ? void 0 : i[r]) || n;
}, Np = {
  content: 0,
  padding: 1,
  border: 2,
  margin: 3,
  "content-box": 0,
  "border-box": 2
}, WV = {
  width: ["left", "right"],
  height: ["top", "bottom"]
};
function __(e, t, r, n) {
  var i = (l, d, h) => parseFloat(GR(l, d, h, "0")) || 0, s = r === "border" ? "-width" : "";
  return i(e, n, "".concat(r, "-").concat(WV[t][0]).concat(s)) + i(e, n, "".concat(r, "-").concat(WV[t][1]).concat(s));
}
var Lq = function(e, t, r) {
  var n = t === "width" ? "offsetWidth" : "offsetHeight", i = cG(e), s = GR(e, i, t);
  (s === "" || s === "auto") && (s = e[n]), s = parseFloat(s) || 0;
  var l = GR(e, i, "boxSizing", "content-box"), d = r || l, h = Np[d], p = Np[l];
  if (h === void 0 || p === void 0)
    throw new Error();
  if (p === h)
    return s;
  var m = Math.sign(h - p), x = !1, S = !1, T = !1, k = !1;
  m === 1 && (h += 1, p += 1);
  for (var O = p; O !== h; O += m)
    switch (O) {
      case Np.content:
        break;
      case Np.padding:
        x = m * __(e, t, "padding", i);
        break;
      case Np.border:
        S = m * __(e, t, "border", i);
        break;
      case Np.margin:
        T = m * __(e, t, "margin", i);
    }
  if (x || S) {
    var D = (x === !1 ? m * __(e, t, "padding", i) : x) + (S === !1 ? m * __(e, t, "border", i) : S);
    k = m * Math.max(0, Math.floor(e[n] - s - m * D)) || 0;
  }
  return s + T + x + S + k;
};
var AM = {
  getWidth: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return Do("width", ...t);
  },
  setWidth: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return Do("width", ...t);
  },
  getHeight: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return Do("height", ...t);
  },
  setHeight: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return Do("height", ...t);
  },
  getOuterWidth: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return Do("outerWidth", ...t);
  },
  setOuterWidth: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return Do("outerWidth", ...t);
  },
  getOuterHeight: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return Do("outerHeight", ...t);
  },
  setOuterHeight: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return Do("outerHeight", ...t);
  },
  getInnerWidth: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return Do("innerWidth", ...t);
  },
  setInnerWidth: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return Do("innerWidth", ...t);
  },
  getInnerHeight: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return Do("innerHeight", ...t);
  },
  setInnerHeight: function() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return Do("innerHeight", ...t);
  }
};
function Do(e, t, r) {
  return arguments.length === 2 ? XV(t, e) : XV(t, e, r);
}
var Mg = (e) => AM.getWidth(e);
var gT = (e) => AM.getHeight(e);
var Pq = (e, t) => AM.getOuterHeight(e, t || !1);
var XV = function e(t, r, n) {
  var i = r.toLowerCase().indexOf("width") >= 0 ? "Width" : "Height", s = i.toLowerCase(), l = r.indexOf("outer") === 0, d = r.indexOf("inner") === 0, h = arguments.length === 2 || typeof n == "boolean";
  if (zd(t)) {
    if (t.length > 1 && !h) {
      for (var p = 0; p < t.length; p++)
        e(t[p], r, n);
      return;
    }
    t = t[0];
  }
  if (t) {
    if (Fl(t))
      return l ? t["inner" + i] : we.getDocumentElement()["client" + i];
    if (we.isDocument(t)) {
      var m = we.getDocumentElement(), x = we.getBody();
      return Math.max(x["scroll" + i], x["offset" + i], m["scroll" + i], m["offset" + i], m["client" + i]);
    }
    if (h) {
      var S = "content";
      return l && (S = n ? "margin" : "border"), d && (S = "padding"), Lq(t, s, S);
    }
    if (Sr(n)) {
      var T = cG(t), k = Mq(s, T), O = T.boxSizing === "border-box";
      n = Number(n), l ? n -= O ? 0 : k.border + k.padding : d ? n += O ? k.border : -k.padding : O && (n += k.border + k.padding);
    }
    return n += Sr(n) ? "px" : "", we.setStyle(t, s, n), null;
  }
}, dG = (e) => Fl(e) ? e : e.defaultView, Iq = (e) => {
  if (!e.getClientRects().length)
    return {
      top: 0,
      left: 0
    };
  var t = e.getBoundingClientRect(), r = dG(e.ownerDocument), n = e.ownerDocument.documentElement;
  return {
    top: t.top + r.pageYOffset - n.clientTop,
    left: t.left + r.pageXOffset - n.clientLeft
  };
}, fG = /<([a-z][^/\0>\x20\t\r\n\f]+)/i, Dl = {
  default: {
    tagsCount: 0,
    startTags: "",
    endTags: ""
  },
  thead: {
    tagsCount: 1,
    startTags: "<table>",
    endTags: "</table>"
  },
  td: {
    tagsCount: 3,
    startTags: "<table><tbody><tr>",
    endTags: "</tr></tbody></table>"
  },
  col: {
    tagsCount: 2,
    startTags: "<table><colgroup>",
    endTags: "</colgroup></table>"
  },
  tr: {
    tagsCount: 2,
    startTags: "<table><tbody>",
    endTags: "</tbody></table>"
  }
};
Dl.tbody = Dl.colgroup = Dl.caption = Dl.tfoot = Dl.thead;
Dl.th = Dl.td;
var OM = function(e) {
  if (typeof e != "string")
    return null;
  var t = we.createDocumentFragment(), r = t.appendChild(we.createElement("div")), n = fG.exec(e), i = n && n[1].toLowerCase(), s = Dl[i] || Dl.default;
  r.innerHTML = s.startTags + e + s.endTags;
  for (var l = 0; l < s.tagsCount; l++)
    r = r.lastChild;
  return [...r.childNodes];
}, Nq = function(e) {
  var t = fG.exec(e);
  return t && t[1] in Dl;
}, Vq = jr(), Lt, lt = function(e, t) {
  return e ? typeof e == "string" ? e === "body" ? (this[0] = t ? t.body : we.getBody(), this.length = 1, this) : (t = t || we.getDocument(), e[0] === "<" ? (this[0] = we.createElement(e.slice(1, -1), t), this.length = 1, this) : ([].push.apply(this, we.querySelectorAll(t, e)), this)) : we.isNode(e) || Fl(e) ? (this[0] = e, this.length = 1, this) : Array.isArray(e) ? ([].push.apply(this, e), this) : Lt(e.toArray ? e.toArray() : [e]) : (this.length = 0, this);
};
Lt = function(e, t) {
  return new lt(e, t);
};
Lt.fn = {
  dxRenderer: !0
};
lt.prototype = Lt.fn;
var Bg = function(e, t) {
  for (var r = 0; r < this.length; r++) {
    var n = Lt(this[r]);
    n[e].apply(n, t);
  }
  return this;
}, UR = function(e, t, r) {
  r != null && r !== !1 ? we.setAttribute(e, t, r) : we.removeAttribute(e, t);
};
lt.prototype.show = function() {
  return this.toggle(!0);
};
lt.prototype.hide = function() {
  return this.toggle(!1);
};
lt.prototype.toggle = function(e) {
  return this[0] && this.toggleClass("dx-state-invisible", !e), this;
};
lt.prototype.attr = function(e, t) {
  if (this.length > 1 && arguments.length > 1)
    return Bg.call(this, "attr", arguments);
  if (!this[0])
    return hi(e) || t !== void 0 ? this : void 0;
  if (!this[0].getAttribute)
    return this.prop(e, t);
  if (typeof e == "string" && arguments.length === 1) {
    var r = this[0].getAttribute(e);
    return r ?? void 0;
  } else if (Qr(e))
    for (var n in e)
      this.attr(n, e[n]);
  else
    UR(this[0], e, t);
  return this;
};
lt.prototype.removeAttr = function(e) {
  return this[0] && we.removeAttribute(this[0], e), this;
};
lt.prototype.prop = function(e, t) {
  if (!this[0])
    return this;
  if (typeof e == "string" && arguments.length === 1)
    return this[0][e];
  if (Qr(e))
    for (var r in e)
      this.prop(r, e[r]);
  else
    we.setProperty(this[0], e, t);
  return this;
};
lt.prototype.addClass = function(e) {
  return this.toggleClass(e, !0);
};
lt.prototype.removeClass = function(e) {
  return this.toggleClass(e, !1);
};
lt.prototype.hasClass = function(e) {
  if (!this[0] || this[0].className === void 0)
    return !1;
  for (var t = e.split(" "), r = 0; r < t.length; r++)
    if (this[0].classList) {
      if (this[0].classList.contains(t[r]))
        return !0;
    } else {
      var n = lr(this[0].className) ? this[0].className : we.getAttribute(this[0], "class");
      if ((n || "").split(" ").indexOf(t[r]) >= 0)
        return !0;
    }
  return !1;
};
lt.prototype.toggleClass = function(e, t) {
  if (this.length > 1)
    return Bg.call(this, "toggleClass", arguments);
  if (!this[0] || !e)
    return this;
  t = t === void 0 ? !this.hasClass(e) : t;
  for (var r = e.split(" "), n = 0; n < r.length; n++)
    we.setClass(this[0], r[n], t);
  return this;
};
lt.prototype.html = function(e) {
  return arguments.length ? (this.empty(), typeof e == "string" && !Nq(e) || typeof e == "number" ? (this[0].innerHTML = e, this) : this.append(OM(e))) : this[0].innerHTML;
};
var hG = function(e, t) {
  if (!(!this[0] || !e)) {
    typeof e == "string" ? e = OM(e) : e.nodeType ? e = [e] : Sr(e) && (e = [we.createTextNode(e)]);
    for (var r = 0; r < e.length; r++) {
      var n = e[r], i = this[0], s = i.tagName === "TABLE" && n.tagName === "TR";
      s && i.tBodies && i.tBodies.length && (i = i.tBodies[0]), we.insertElement(i, n.nodeType ? n : n[0], t);
    }
  }
}, qV = function(e, t) {
  if (!(!this[0] || !this[0].style) && !(t === null || typeof t == "number" && isNaN(t))) {
    e = Fg(e);
    for (var r = 0; r < this.length; r++)
      this[r].style[e] = Rq(e, t);
  }
};
lt.prototype.css = function(e, t) {
  if (lr(e))
    if (arguments.length === 2)
      qV.call(this, e, t);
    else {
      if (!this[0])
        return;
      e = Fg(e);
      var r = Vq.getComputedStyle(this[0])[e] || this[0].style[e];
      return Sr(r) ? r.toString() : r;
    }
  else if (Qr(e))
    for (var n in e)
      qV.call(this, n, e[n]);
  return this;
};
lt.prototype.prepend = function(e) {
  if (arguments.length > 1) {
    for (var t = 0; t < arguments.length; t++)
      this.prepend(arguments[t]);
    return this;
  }
  return hG.apply(this, [e, this[0].firstChild]), this;
};
lt.prototype.append = function(e) {
  if (arguments.length > 1) {
    for (var t = 0; t < arguments.length; t++)
      this.append(arguments[t]);
    return this;
  }
  return hG.apply(this, [e]), this;
};
lt.prototype.prependTo = function(e) {
  if (this.length > 1) {
    for (var t = this.length - 1; t >= 0; t--)
      Lt(this[t]).prependTo(e);
    return this;
  }
  return e = Lt(e), e[0] && we.insertElement(e[0], this[0], e[0].firstChild), this;
};
lt.prototype.appendTo = function(e) {
  return this.length > 1 ? Bg.call(this, "appendTo", arguments) : (we.insertElement(Lt(e)[0], this[0]), this);
};
lt.prototype.insertBefore = function(e) {
  return e && e[0] && we.insertElement(e[0].parentNode, this[0], e[0]), this;
};
lt.prototype.insertAfter = function(e) {
  return e && e[0] && we.insertElement(e[0].parentNode, this[0], e[0].nextSibling), this;
};
lt.prototype.before = function(e) {
  return this[0] && we.insertElement(this[0].parentNode, e[0], this[0]), this;
};
lt.prototype.after = function(e) {
  return this[0] && we.insertElement(this[0].parentNode, e[0], this[0].nextSibling), this;
};
lt.prototype.wrap = function(e) {
  if (this[0]) {
    var t = Lt(e);
    t.insertBefore(this), t.append(this);
  }
  return this;
};
lt.prototype.wrapInner = function(e) {
  var t = this.contents();
  return t.length ? t.wrap(e) : this.append(e), this;
};
lt.prototype.replaceWith = function(e) {
  if (e && e[0])
    return e.is(this) ? this : (e.insertBefore(this), this.remove(), e);
};
lt.prototype.remove = function() {
  return this.length > 1 ? Bg.call(this, "remove", arguments) : (pT(this[0], !0), we.removeElement(this[0]), this);
};
lt.prototype.detach = function() {
  return this.length > 1 ? Bg.call(this, "detach", arguments) : (we.removeElement(this[0]), this);
};
lt.prototype.empty = function() {
  return this.length > 1 ? Bg.call(this, "empty", arguments) : (pT(this[0]), we.setText(this[0], ""), this);
};
lt.prototype.clone = function() {
  for (var e = [], t = 0; t < this.length; t++)
    e.push(this[t].cloneNode(!0));
  return Lt(e);
};
lt.prototype.text = function(e) {
  if (!arguments.length) {
    for (var t = "", r = 0; r < this.length; r++)
      t += this[r] && this[r].textContent || "";
    return t;
  }
  var n = ct(e) ? e() : e;
  return pT(this[0], !1), we.setText(this[0], I(n) ? n : ""), this;
};
lt.prototype.val = function(e) {
  return arguments.length === 1 ? this.prop("value", I(e) ? e : "") : this.prop("value");
};
lt.prototype.contents = function() {
  if (!this[0])
    return Lt();
  var e = [];
  return e.push.apply(e, this[0].childNodes), Lt(e);
};
lt.prototype.find = function(e) {
  var t = Lt();
  if (!e)
    return t;
  var r = [], n;
  if (typeof e == "string")
    for (e = e.trim(), n = 0; n < this.length; n++) {
      var i = this[n];
      if (we.isElementNode(i)) {
        var s = i.getAttribute("id"), l = s || "dx-query-children";
        s || UR(i, "id", l), l = "[id='" + l + "'] ";
        var d = l + e.replace(/([^\\])(,)/g, "$1, " + l);
        r.push.apply(r, we.querySelectorAll(i, d)), UR(i, "id", s);
      } else
        (we.isDocument(i) || we.isDocumentFragment(i)) && r.push.apply(r, we.querySelectorAll(i, e));
    }
  else
    for (n = 0; n < this.length; n++)
      e = we.isNode(e) ? e : e[0], this[n] !== e && this[n].contains(e) && r.push(e);
  return t.add(r);
};
var KV = function(e, t) {
  var r;
  return t = (r = t.host) !== null && r !== void 0 ? r : t, t.nodeType ? !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length) : !0;
};
lt.prototype.filter = function(e) {
  if (!e)
    return Lt();
  if (e === ":visible")
    return this.filter(KV);
  if (e === ":hidden")
    return this.filter(function(s, l) {
      return !KV(s, l);
    });
  for (var t = [], r = 0; r < this.length; r++) {
    var n = this[r];
    if (we.isElementNode(n) && Wa(e) === "string")
      we.elementMatches(n, e) && t.push(n);
    else if (we.isNode(e) || Fl(e))
      e === n && t.push(n);
    else if (ct(e))
      e.call(n, r, n) && t.push(n);
    else
      for (var i = 0; i < e.length; i++)
        e[i] === n && t.push(n);
  }
  return Lt(t);
};
lt.prototype.not = function(e) {
  for (var t = [], r = this.filter(e).toArray(), n = 0; n < this.length; n++)
    r.indexOf(this[n]) === -1 && t.push(this[n]);
  return Lt(t);
};
lt.prototype.is = function(e) {
  return !!this.filter(e).length;
};
lt.prototype.children = function(e) {
  for (var t = [], r = 0; r < this.length; r++)
    for (var n = this[r] ? this[r].childNodes : [], i = 0; i < n.length; i++)
      we.isElementNode(n[i]) && t.push(n[i]);
  return t = Lt(t), e ? t.filter(e) : t;
};
lt.prototype.siblings = function() {
  var e = this[0];
  if (!e || !e.parentNode)
    return Lt();
  for (var t = [], r = e.parentNode.childNodes || [], n = 0; n < r.length; n++) {
    var i = r[n];
    we.isElementNode(i) && i !== e && t.push(i);
  }
  return Lt(t);
};
lt.prototype.each = function(e) {
  for (var t = 0; t < this.length && e.call(this[t], t, this[t]) !== !1; t++)
    ;
};
lt.prototype.index = function(e) {
  return e ? (e = Lt(e), this.toArray().indexOf(e[0])) : this.parent().children().index(this);
};
lt.prototype.get = function(e) {
  return this[e < 0 ? this.length + e : e];
};
lt.prototype.eq = function(e) {
  return e = e < 0 ? this.length + e : e, Lt(this[e]);
};
lt.prototype.first = function() {
  return this.eq(0);
};
lt.prototype.last = function() {
  return this.eq(-1);
};
lt.prototype.select = function() {
  for (var e = 0; e < this.length; e += 1)
    this[e].select && this[e].select();
  return this;
};
lt.prototype.parent = function(e) {
  if (!this[0])
    return Lt();
  var t = Lt(this[0].parentNode);
  return !e || t.is(e) ? t : Lt();
};
lt.prototype.parents = function(e) {
  for (var t = [], r = this.parent(); r && r[0] && !we.isDocument(r[0]); )
    we.isElementNode(r[0]) && (!e || r.is(e)) && t.push(r.get(0)), r = r.parent();
  return Lt(t);
};
lt.prototype.closest = function(e) {
  if (this.is(e))
    return this;
  for (var t = this.parent(); t && t.length; ) {
    if (t.is(e))
      return t;
    t = t.parent();
  }
  return Lt();
};
lt.prototype.next = function(e) {
  if (!this[0])
    return Lt();
  var t = Lt(this[0].nextSibling);
  if (!arguments.length)
    return t;
  for (; t && t.length; ) {
    if (t.is(e))
      return t;
    t = t.next();
  }
  return Lt();
};
lt.prototype.prev = function() {
  return this[0] ? Lt(this[0].previousSibling) : Lt();
};
lt.prototype.add = function(e) {
  for (var t = Lt(e), r = this.toArray(), n = 0; n < t.length; n++) {
    var i = t[n];
    r.indexOf(i) === -1 && r.push(i);
  }
  return Lt(r);
};
var kM = [];
lt.prototype.splice = function() {
  return Lt(kM.splice.apply(this, arguments));
};
lt.prototype.slice = function() {
  return Lt(kM.slice.apply(this, arguments));
};
lt.prototype.toArray = function() {
  return kM.slice.call(this);
};
lt.prototype.offset = function() {
  if (this[0])
    return Iq(this[0]);
};
lt.prototype.offsetParent = function() {
  if (!this[0])
    return Lt();
  for (var e = Lt(this[0].offsetParent); e[0] && e.css("position") === "static"; )
    e = Lt(e[0].offsetParent);
  return e = e[0] ? e : Lt(we.getDocumentElement()), e;
};
lt.prototype.position = function() {
  if (this[0]) {
    var e, t = parseFloat(this.css("marginTop")), r = parseFloat(this.css("marginLeft"));
    if (this.css("position") === "fixed")
      return e = this[0].getBoundingClientRect(), {
        top: e.top - t,
        left: e.left - r
      };
    e = this.offset();
    var n = this.offsetParent(), i = {
      top: 0,
      left: 0
    };
    return n[0].nodeName !== "HTML" && (i = n.offset()), i = {
      top: i.top + parseFloat(n.css("borderTopWidth")),
      left: i.left + parseFloat(n.css("borderLeftWidth"))
    }, {
      top: e.top - i.top - t,
      left: e.left - i.left - r
    };
  }
};
[{
  name: "scrollLeft",
  offsetProp: "pageXOffset",
  scrollWindow: function(e, t) {
    e.scrollTo(t, e.pageYOffset);
  }
}, {
  name: "scrollTop",
  offsetProp: "pageYOffset",
  scrollWindow: function(e, t) {
    e.scrollTo(e.pageXOffset, t);
  }
}].forEach(function(e) {
  var t = e.name;
  lt.prototype[t] = function(r) {
    if (this[0]) {
      var n = dG(this[0]);
      return r === void 0 ? n ? n[e.offsetProp] : this[0][t] : (n ? e.scrollWindow(n, r) : this[0][t] = r, this);
    }
  };
});
lt.prototype.data = function(e, t) {
  if (this[0])
    return arguments.length < 2 ? di.call(Lt, this[0], e) : (di.call(Lt, this[0], e, t), this);
};
lt.prototype.removeData = function(e) {
  return this[0] && wM(this[0], e), this;
};
var vG = function() {
  return Lt.apply(this, arguments);
};
Object.defineProperty(vG, "fn", {
  enumerable: !0,
  configurable: !0,
  get: function() {
    return Lt.fn;
  },
  set: function(e) {
    Lt.fn = e;
  }
});
const Fq = {
  set: function(e) {
    Lt = e;
  },
  get: function() {
    return vG;
  }
}, je = Fq.get(), pG = new xM();
var Hl = function(e, t) {
  var r = {};
  "noBubble" in t && (r.noBubble = t.noBubble), "bindType" in t && (r.bindType = t.bindType), "delegateType" in t && (r.delegateType = t.delegateType), be(["setup", "teardown", "add", "remove", "trigger", "handle", "_default", "dispose"], function(n, i) {
    t[i] && (r[i] = function() {
      var s = [].slice.call(arguments);
      return s.unshift(this), t[i].apply(t, s);
    });
  }), bM.fire(e, r);
};
Hl.callbacks = bM;
var My = "dxremove", jR = "dxRemoveEvent";
Cq(function(e) {
  e = [].slice.call(e);
  for (var t = 0; t < e.length; t++) {
    var r = je(e[t]);
    r.prop(jR) && (r[0][jR] = null, Ve.triggerHandler(r, My));
  }
});
Hl(My, {
  noBubble: !0,
  setup: function(e) {
    je(e).prop(jR, !0);
  }
});
var HO = "dxComponents", Bq = "dxPrivateComponent", $S = /* @__PURE__ */ new WeakMap(), zq = 0, mT = function(e, t) {
  if (I(t)) {
    $S.set(e, t);
    return;
  }
  if (!$S.has(e)) {
    var r = Bq + zq++;
    return $S.set(e, r), r;
  }
  return $S.get(e);
};
function Hq(e, t, r) {
  var n = di(e.get(0)), i = mT(t.constructor);
  n[i] = t, r && Ve.one(e, My, function() {
    r.call(t);
  }), n[HO] || (n[HO] = []), n[HO].push(i);
}
function Gq(e, t) {
  var r = mT(t);
  return di(e.get(0), r);
}
var gG = function(e, t, r) {
  r ? t[e] = r : r = t, mT(r, e), pG.fire(e, r);
}, Uq = function(e, t) {
  je.fn[e] = function(r) {
    var n = typeof r == "string", i;
    if (n) {
      var s = r, l = [].slice.call(arguments).slice(1);
      this.each(function() {
        var d = t.getInstance(this);
        if (!d)
          throw Dr.Error("E0009", e);
        var h = d[s], p = h.apply(d, l);
        i === void 0 && (i = p);
      });
    } else
      this.each(function() {
        var d = t.getInstance(this);
        d ? d.option(r) : new t(this, r);
      }), i = this;
    return i;
  };
};
pG.add(Uq);
var Hd = function(e) {
  return e === 0 ? 0 : e / Math.abs(e);
}, mG = function(e, t, r) {
  var n = !t && t !== 0, i = !r && r !== 0;
  return n && (t = i ? e : Math.min(e, r)), i && (r = n ? e : Math.max(e, t)), Math.min(Math.max(e, t), r);
};
function X_(e) {
  return Math.abs(parseInt(e.toExponential().split("e")[1]));
}
function jq(e) {
  var t = e.toExponential().split("e"), r = parseFloat(t[0]), n = parseInt(t[1]);
  return {
    exponent: n,
    mantissa: r
  };
}
function _G(e, t) {
  var r = jq(e);
  return parseFloat("".concat(r.mantissa, "e").concat(r.exponent + t));
}
function $q() {
  return 3e-4.toPrecision(3) !== "0.000300";
}
function rr(e, t) {
  var r = EE(t || 0) + 2, n = e.toString().split("."), i = e, s = Math.abs(e), l, d = Ch(e), h = s > 1 ? 10 : 0;
  return n.length === 1 ? e : (d || (Ch(t) && (r = n[0].length + X_(t)), e = s, e = e - Math.floor(e) + h), r = $q() && X_(e) > 6 || r > 7 ? 15 : 7, !d && (l = parseFloat(e.toPrecision(r)).toString().split("."), l[0] === h.toString()) ? parseFloat(n[0] + "." + l[1]) : parseFloat(i.toPrecision(r)));
}
function EE(e) {
  var t = e.toString();
  if (t.indexOf(".") < 0)
    return 0;
  var r = t.split("."), n = r[1].indexOf("e");
  return n >= 0 ? n : r[1].length;
}
function ZV(e, t) {
  if (e < 0 && t % 2 !== 1)
    return NaN;
  var r = Math.pow(Math.abs(e), 1 / t);
  return t % 2 === 1 && e < 0 ? -r : r;
}
function Yq(e, t, r, n) {
  if (Math.abs(e) < 1e-8) {
    if (e = t, t = r, r = n, Math.abs(e) < 1e-8)
      return e = t, t = r, Math.abs(e) < 1e-8 ? [] : [-t / e];
    var i = t * t - 4 * e * r;
    return Math.abs(i) < 1e-8 ? [-t / (2 * e)] : i > 0 ? [(-t + Math.sqrt(i)) / (2 * e), (-t - Math.sqrt(i)) / (2 * e)] : [];
  }
  var s = (3 * e * r - t * t) / (3 * e * e), l = (2 * t * t * t - 9 * e * t * r + 27 * e * e * n) / (27 * e * e * e), d, h;
  if (Math.abs(s) < 1e-8)
    d = [ZV(-l, 3)];
  else if (Math.abs(l) < 1e-8)
    d = [0].concat(s < 0 ? [Math.sqrt(-s), -Math.sqrt(-s)] : []);
  else {
    var p = l * l / 4 + s * s * s / 27;
    if (Math.abs(p) < 1e-8)
      d = [-1.5 * l / s, 3 * l / s];
    else if (p > 0)
      h = ZV(-l / 2 - Math.sqrt(p), 3), d = [h - s / (3 * h)];
    else {
      h = 2 * Math.sqrt(-s / 3);
      var m = Math.acos(3 * l / s / h) / 3, x = 2 * Math.PI / 3;
      d = [h * Math.cos(m), h * Math.cos(m - x), h * Math.cos(m - 2 * x)];
    }
  }
  for (var S = 0; S < d.length; S++)
    d[S] -= t / (3 * e);
  return d;
}
function Wq(e) {
  return Math.trunc ? Math.trunc(e) : e > 0 ? Math.floor(e) : Math.ceil(e);
}
var Xq = {
  millisecond: 1,
  second: 1e3,
  minute: 6e4,
  hour: 36e5,
  day: 864e5,
  week: 6048e5,
  month: 2592e6,
  quarter: 7776e6,
  year: 31536e6
};
function _T(e) {
  return Xq[e];
}
var cy = 7, QV = 4, JV = 7, eF = 52, B_ = ["millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year"], qq = function(e, t, r) {
  var n = t.getTime() - e.getTime(), i = _T(r) || 1;
  return Math.floor(n / i);
}, Kq = function(e, t) {
  var r = yT(e);
  switch (r) {
    case "millisecond":
      return "second";
    case "second":
      return "minute";
    case "minute":
      return "hour";
    case "hour":
      return "day";
    case "day":
      return t ? "week" : "month";
    case "week":
      return "month";
    case "month":
      return "quarter";
    case "quarter":
    case "year":
      return "year";
    default:
      return 0;
  }
}, yG = function(e) {
  var t, r, n, i = ["millisecond", "second", "minute", "hour", "day", "month", "year"], s = {};
  for (t = i.length - 1; t >= 0; t--)
    n = i[t], r = Math.floor(e / _T(n)), r > 0 && (s[n + "s"] = r, e -= TE(n, r));
  return s;
}, Zq = function(e) {
  var t = 0;
  return hi(e) && be(e, function(r, n) {
    t += TE(r.substr(0, r.length - 1), n);
  }), lr(e) && (t = TE(e, 1)), t;
};
function TE(e, t) {
  return _T(e) * t;
}
function yT(e) {
  var t = -1, r;
  return lr(e) ? e : hi(e) ? (be(e, function(n, i) {
    for (r = 0; r < B_.length; r++)
      i && (n === B_[r] + "s" || n === B_[r]) && t < r && (t = r);
  }), B_[t]) : "";
}
var Qq = {
  millisecond: "millisecond",
  second: "longtime",
  minute: "shorttime",
  hour: "shorttime",
  day: "day",
  week: "day",
  month: "month",
  quarter: "quarter",
  year: "year"
};
function Jq(e) {
  return Qq[yT(e)] || "";
}
var xG = function(e) {
  return Math.floor(e / 3);
}, bG = function(e) {
  return 3 * xG(e);
};
function SG(e, t, r, n) {
  e = new Date(e.getTime());
  var i = new Date(e.getTime()), s, l, d = yT(t);
  switch (d) {
    case "second":
      e = new Date(1e3 * Math.floor(i.getTime() / 1e3));
      break;
    case "minute":
      e = new Date(6e4 * Math.floor(i.getTime() / 6e4));
      break;
    case "hour":
      e = new Date(36e5 * Math.floor(i.getTime() / 36e5));
      break;
    case "year":
      e.setMonth(0);
    case "month":
      e.setDate(1);
    case "day":
      e.setHours(0, 0, 0, 0);
      break;
    case "week":
      e = OG(e, n || 0), e.setHours(0, 0, 0, 0);
      break;
    case "quarter":
      s = bG(e.getMonth()), l = e.getMonth(), e.setDate(1), e.setHours(0, 0, 0, 0), l !== s && e.setMonth(s);
  }
  return r && d !== "hour" && d !== "minute" && d !== "second" && DG(i, e), e;
}
function CG(e) {
  return SG(e, "day");
}
var eK = function(e) {
  var t = CG(e);
  return t.setDate(t.getDate() + 1), new Date(t.getTime() - 1);
}, tK = function(e, t) {
  var r = 0, n = {
    year: e.getFullYear() !== t.getFullYear(),
    month: e.getMonth() !== t.getMonth(),
    day: e.getDate() !== t.getDate(),
    hour: e.getHours() !== t.getHours(),
    minute: e.getMinutes() !== t.getMinutes(),
    second: e.getSeconds() !== t.getSeconds(),
    millisecond: e.getMilliseconds() !== t.getMilliseconds()
  };
  return be(n, function(i, s) {
    s && r++;
  }), r === 0 && MG(e, t) !== 0 && (n.hour = !0, r++), n.count = r, n;
};
function EG(e, t, r) {
  var n = new Date(e.getTime()), i = lr(t) ? wG(t.toLowerCase()) : Sr(t) ? yG(t) : t;
  return i.years && n.setFullYear(n.getFullYear() + i.years * r), i.quarters && n.setMonth(n.getMonth() + 3 * i.quarters * r), i.months && n.setMonth(n.getMonth() + i.months * r), i.weeks && n.setDate(n.getDate() + 7 * i.weeks * r), i.days && n.setDate(n.getDate() + i.days * r), i.hours && n.setTime(n.getTime() + 36e5 * i.hours * r), i.minutes && n.setTime(n.getTime() + 6e4 * i.minutes * r), i.seconds && n.setTime(n.getTime() + 1e3 * i.seconds * r), i.milliseconds && n.setTime(n.getTime() + i.milliseconds * r), n;
}
var TG = function(e, t, r) {
  var n = r ? -1 : 1;
  return Ls(e) ? EG(e, t, n) : rr(e + t * n, t);
}, rK = function(e, t, r) {
  var n = [], i;
  for (n.push(Ls(e) ? new Date(e.getTime()) : e), i = e; i < t; )
    i = TG(i, r), n.push(i);
  return n;
}, nK = function(e, t) {
  if (e === "month")
    return vo(t.getFullYear(), t.getMonth(), 1);
  if (e === "year")
    return vo(t.getFullYear(), 0, t.getDate());
  if (e === "decade")
    return vo(Py(t), t.getMonth(), t.getDate());
  if (e === "century")
    return vo(Ly(t), t.getMonth(), t.getDate());
}, iK = function(e, t) {
  if (e === "month")
    return vo(t.getFullYear(), t.getMonth(), wE(t));
  if (e === "year")
    return vo(t.getFullYear(), 11, t.getDate());
  if (e === "decade")
    return vo(Py(t) + 9, t.getMonth(), t.getDate());
  if (e === "century")
    return vo(Ly(t) + 90, t.getMonth(), t.getDate());
}, aK = function(e, t) {
  var r = vo(t.getFullYear(), t.getMonth(), 1);
  return e === "month" || (r.setMonth(0), e === "year") || (e === "decade" && r.setFullYear(Py(t)), e === "century" && r.setFullYear(Ly(t))), r;
}, oK = function(e, t) {
  var r = new Date(t);
  return r.setDate(wE(t)), e === "month" || (r.setMonth(11), r.setDate(wE(r)), e === "year") || (e === "decade" && r.setFullYear(Py(t) + 9), e === "century" && r.setFullYear(Ly(t) + 99)), r;
};
function wE(e) {
  var t = vo(e.getFullYear(), e.getMonth() + 1, 0);
  return t.getDate();
}
var sK = function(e) {
  switch (e) {
    case "month":
      return "year";
    case "year":
      return "decade";
    case "decade":
      return "century";
  }
}, lK = function(e) {
  switch (e) {
    case "century":
      return "decade";
    case "decade":
      return "year";
    case "year":
      return "month";
  }
}, uK = function(e) {
  var t = 1;
  return e === "year" && (t = 12), e === "decade" && (t = 120), e === "century" && (t = 1200), t;
}, cK = function(e) {
  var t = 1;
  return e === "decade" && (t = 12), e === "century" && (t = 120), t;
};
function wG(e) {
  var t = {};
  switch (e) {
    case "year":
      t.years = 1;
      break;
    case "month":
      t.months = 1;
      break;
    case "quarter":
      t.months = 3;
      break;
    case "week":
      t.weeks = 1;
      break;
    case "day":
      t.days = 1;
      break;
    case "hour":
      t.hours = 1;
      break;
    case "minute":
      t.minutes = 1;
      break;
    case "second":
      t.seconds = 1;
      break;
    case "millisecond":
      t.milliseconds = 1;
  }
  return t;
}
function dK(e, t) {
  return $R(e, t) && e.getDate() === t.getDate();
}
function $R(e, t) {
  return AG(e, t) && e.getMonth() === t.getMonth();
}
function AG(e, t) {
  return e && t && e.getFullYear() === t.getFullYear();
}
function fK(e, t) {
  return e && t && e.getHours() === t.getHours() && e.getMinutes() === t.getMinutes();
}
var hK = function(e, t) {
  if (!(!I(e) || !I(t))) {
    var r = e.getFullYear() - e.getFullYear() % 10, n = t.getFullYear() - t.getFullYear() % 10;
    return e && t && r === n;
  }
}, vK = function(e, t) {
  if (!(!I(e) || !I(t))) {
    var r = e.getFullYear() - e.getFullYear() % 100, n = t.getFullYear() - t.getFullYear() % 100;
    return e && t && r === n;
  }
};
function Ly(e) {
  return e && e.getFullYear() - e.getFullYear() % 100;
}
function Py(e) {
  return e && e.getFullYear() - e.getFullYear() % 10;
}
var pK = function() {
  return "yyyy/MM/dd";
}, gK = function(e) {
  if (I(e))
    return vo(e.getFullYear(), e.getMonth(), 1);
}, mK = function(e) {
  if (I(e))
    return vo(e.getFullYear(), e.getMonth() + 1, 0);
};
function OG(e, t) {
  var r = (e.getDay() - t + cy) % cy, n = new Date(e);
  return n.setDate(e.getDate() - r), n;
}
function tF(e) {
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate());
}
function _K(e) {
  var t = tF(e) - tF(kG(e.getFullYear()));
  return 1 + Math.floor(t / _T("day"));
}
function kG(e) {
  return new Date(e, 0, 1);
}
function GO(e) {
  return new Date(e, 11, 31);
}
function rF(e, t) {
  var r = e.getDay() - t + 1;
  return r <= 0 && (r += cy), r;
}
function YR(e, t, r) {
  var n = rF(kG(e.getFullYear()), t), i = rF(GO(e.getFullYear()), t), s = cy - n + 1, l = Math.ceil((_K(e) - s) / 7);
  switch (r) {
    case "fullWeek":
      if (s === cy && l++, l === 0) {
        var d = GO(e.getFullYear() - 1);
        return YR(d, t, r);
      }
      return l;
    case "firstDay":
      s > 0 && l++;
      var h = n === JV || i === JV;
      return (l > eF && !h || l === 54) && (l = 1), l;
    case "firstFourDays":
      s > 3 && l++;
      var p = n === QV || i === QV;
      if (l > eF && !p && (l = 1), l === 0) {
        var m = GO(e.getFullYear() - 1);
        return YR(m, t, r);
      }
      return l;
  }
}
var yK = function(e, t) {
  var r = Et.getDatesInterval(e, t, "day"), n = new Date(e);
  return r >= 6 && (n = new Date(n.setDate(n.getDate() + 7))), n;
}, xK = function(e, t, r, n) {
  return n === "date" && (t = t && Et.correctDateWithUnitBeginning(t, "day"), r = r && Et.correctDateWithUnitBeginning(r, "day"), e = e && Et.correctDateWithUnitBeginning(e, "day")), RG(e, t, r) === e;
}, bK = function(e) {
  var {
    firstMin: t,
    firstMax: r,
    secondMin: n,
    secondMax: i
  } = e;
  return t <= n && n <= r || t > n && t < i || t < i && r > i;
}, SK = function(e) {
  var t = Math.floor(e), r = e % 1 * 60;
  return {
    hours: t,
    minutes: r
  };
}, CK = function(e, t) {
  var r = this.dateTimeFromDecimal(t), n = new Date(e);
  return (e.getHours() === r.hours && e.getMinutes() < r.minutes || e.getHours() < r.hours) && n.setHours(r.hours, r.minutes, 0, 0), n;
};
function RG(e, t, r) {
  var n = e;
  return I(e) ? (I(t) && e < t && (n = t), I(r) && e > r && (n = r), n) : e;
}
function DG(e, t) {
  if (I(e)) {
    var r = t.getHours() - e.getHours();
    if (r !== 0) {
      var n = r === 1 || r === -23 ? -1 : 1, i = new Date(t.getTime() + 36e5 * n);
      (n > 0 || i.getDate() === t.getDate()) && t.setTime(i.getTime());
    }
  }
}
var EK = function(e) {
  var t = new Date(e.getTime());
  return t.setHours(t.getHours() + 1), t.setMinutes(0), t;
};
function MG(e, t) {
  return 60 * (t.getTimezoneOffset() - e.getTimezoneOffset()) * 1e3;
}
var TK = function(e) {
  return new Date(e);
}, wK = function(e, t, r) {
  for (var n = [], i = new Date(e.getTime()); i < t; )
    n.push(new Date(i.getTime())), i = this.addInterval(i, r);
  return n;
}, vo = function(e) {
  var t = new Date(...arguments);
  return t.setFullYear(e), t;
}, AK = () => {
  var e = typeof Intl < "u";
  return e ? Intl.DateTimeFormat().resolvedOptions().timeZone : null;
}, Et = {
  dateUnitIntervals: B_,
  convertMillisecondsToDateUnits: yG,
  dateToMilliseconds: Zq,
  getNextDateUnit: Kq,
  convertDateUnitToMilliseconds: TE,
  getDateUnitInterval: yT,
  getDateFormatByTickInterval: Jq,
  getDatesDifferences: tK,
  correctDateWithUnitBeginning: SG,
  trimTime: CG,
  setToDayEnd: eK,
  roundDateByStartDayHour: CK,
  dateTimeFromDecimal: SK,
  addDateInterval: EG,
  addInterval: TG,
  getSequenceByInterval: rK,
  getDateIntervalByString: wG,
  sameHoursAndMinutes: fK,
  sameDate: dK,
  sameMonthAndYear: $R,
  sameMonth: $R,
  sameYear: AG,
  sameDecade: hK,
  sameCentury: vK,
  getDifferenceInMonth: uK,
  getDifferenceInMonthForCells: cK,
  getFirstYearInDecade: Py,
  getFirstDecadeInCentury: Ly,
  getShortDateFormat: pK,
  getViewFirstCellDate: nK,
  getViewLastCellDate: iK,
  getViewDown: lK,
  getViewUp: sK,
  getLastMonthDay: wE,
  getLastMonthDate: mK,
  getFirstMonthDate: gK,
  getFirstWeekDate: OG,
  getWeekNumber: YR,
  normalizeDateByWeek: yK,
  getQuarter: xG,
  getFirstQuarterMonth: bG,
  dateInRange: xK,
  intervalsOverlap: bK,
  roundToHour: EK,
  normalizeDate: RG,
  getViewMinBoundaryDate: aK,
  getViewMaxBoundaryDate: oK,
  fixTimezoneGap: DG,
  getTimezonesDifference: MG,
  makeDate: TK,
  getDatesInterval: qq,
  getDatesOfInterval: wK,
  createDateWithFullYear: vo,
  getMachineTimezoneName: AK
};
Et.sameView = function(e, t, r) {
  return Et[Dg("same " + e)](t, r);
};
var nF = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  feldspar: "d19275",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslateblue: "8470ff",
  lightslategray: "778899",
  lightslategrey: "778899",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "00ff00",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "ff00ff",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370d8",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "d87093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "ff0000",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  violetred: "d02090",
  wheat: "f5deb3",
  white: "ffffff",
  whitesmoke: "f5f5f5",
  yellow: "ffff00",
  yellowgreen: "9acd32"
}, UO = [{
  re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
  process: function(e) {
    return [parseInt(e[1], 10), parseInt(e[2], 10), parseInt(e[3], 10)];
  }
}, {
  re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*(\d*\.*\d+)\)$/,
  process: function(e) {
    return [parseInt(e[1], 10), parseInt(e[2], 10), parseInt(e[3], 10), parseFloat(e[4])];
  }
}, {
  re: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/,
  process: function(e) {
    return [parseInt(e[1], 16), parseInt(e[2], 16), parseInt(e[3], 16)];
  }
}, {
  re: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/,
  process: function(e) {
    return [parseInt(e[1], 16), parseInt(e[2], 16), parseInt(e[3], 16), Number((parseInt(e[4], 16) / 255).toFixed(2))];
  }
}, {
  re: /^#([a-f0-9]{1})([a-f0-9]{1})([a-f0-9]{1})([a-f0-9]{1})$/,
  process: function(e) {
    return [parseInt(e[1] + e[1], 16), parseInt(e[2] + e[2], 16), parseInt(e[3] + e[3], 16), Number((parseInt(e[4] + e[4], 16) / 255).toFixed(2))];
  }
}, {
  re: /^#([a-f0-9]{1})([a-f0-9]{1})([a-f0-9]{1})$/,
  process: function(e) {
    return [parseInt(e[1] + e[1], 16), parseInt(e[2] + e[2], 16), parseInt(e[3] + e[3], 16)];
  }
}, {
  re: /^hsv\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
  process: function(e) {
    var t = parseInt(e[1], 10), r = parseInt(e[2], 10), n = parseInt(e[3], 10), i = LG(t, r, n);
    return [i[0], i[1], i[2], 1, [t, r, n]];
  }
}, {
  re: /^hsl\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
  process: function(e) {
    var t = parseInt(e[1], 10), r = parseInt(e[2], 10), n = parseInt(e[3], 10), i = PG(t, r, n);
    return [i[0], i[1], i[2], 1, null, [t, r, n]];
  }
}], qu = Math.round;
function Jn(e) {
  this.baseColor = e;
  var t;
  e && (t = String(e).toLowerCase().replace(/ /g, ""), t = nF[t] ? "#" + nF[t] : t, t = OK(t)), t || (this.colorIsInvalid = !0), t = t || {}, this.r = Ol(t[0]), this.g = Ol(t[1]), this.b = Ol(t[2]), this.a = Ol(t[3], 1, 1), t[4] ? this.hsv = {
    h: t[4][0],
    s: t[4][1],
    v: t[4][2]
  } : this.hsv = RK(this.r, this.g, this.b), t[5] ? this.hsl = {
    h: t[5][0],
    s: t[5][1],
    l: t[5][2]
  } : this.hsl = MK(this.r, this.g, this.b);
}
function OK(e) {
  if (e === "transparent")
    return [0, 0, 0, 0];
  for (var t = 0, r = UO.length, n; t < r; ++t)
    if (n = UO[t].re.exec(e), n)
      return UO[t].process(n);
  return null;
}
function Ol(e, t, r) {
  return t = t || 0, r = r || 255, e < 0 || isNaN(e) ? t : e > r ? r : e;
}
function kK(e, t, r) {
  return "#" + (16777216 | e << 16 | t << 8 | r).toString(16).slice(1);
}
function RK(e, t, r) {
  var n = Math.max(e, t, r), i = Math.min(e, t, r), s = n - i, l, d, h = n;
  if (d = n === 0 ? 0 : 1 - i / n, n === i)
    l = 0;
  else
    switch (n) {
      case e:
        l = (t - r) / s * 60, t < r && (l += 360);
        break;
      case t:
        l = (r - e) / s * 60 + 120;
        break;
      case r:
        l = (e - t) / s * 60 + 240;
    }
  return d *= 100, h *= 100 / 255, {
    h: Math.round(l),
    s: Math.round(d),
    v: Math.round(h)
  };
}
function LG(e, t, r) {
  var n = Math.floor(e % 360 / 60), i = (100 - t) * r / 100, s = e % 60 / 60 * (r - i), l = i + s, d = r - s, h, p, m;
  switch (n) {
    case 0:
      h = r, p = l, m = i;
      break;
    case 1:
      h = d, p = r, m = i;
      break;
    case 2:
      h = i, p = r, m = l;
      break;
    case 3:
      h = i, p = d, m = r;
      break;
    case 4:
      h = l, p = i, m = r;
      break;
    case 5:
      h = r, p = i, m = d;
  }
  return [Math.round(2.55 * h), Math.round(2.55 * p), Math.round(2.55 * m)];
}
function DK(e, t, r, n) {
  var i = Math.max(e, t, r);
  switch (i) {
    case e:
      return (t - r) / n + (t < r ? 6 : 0);
    case t:
      return (r - e) / n + 2;
    case r:
      return (e - t) / n + 4;
  }
}
function MK(e, t, r) {
  e = Sg(e, 255), t = Sg(t, 255), r = Sg(r, 255);
  var n = Math.max(e, t, r), i = Math.min(e, t, r), s = n + i, l, d, h = s / 2;
  if (n === i)
    l = d = 0;
  else {
    var p = n - i;
    h > 0.5 ? d = p / (2 - s) : d = p / s, l = DK(e, t, r, p), l /= 6;
  }
  return {
    h: qu(360 * l),
    s: qu(100 * d),
    l: qu(100 * h)
  };
}
function jO(e, t) {
  var r = t;
  return e === "r" && (r = t + 1 / 3), e === "b" && (r = t - 1 / 3), r;
}
function LK(e) {
  return e < 0 && (e += 1), e > 1 && (e -= 1), e;
}
function $O(e, t, r) {
  return r = LK(r), r < 1 / 6 ? e + 6 * (t - e) * r : r < 0.5 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
}
function PG(e, t, r) {
  var n, i, s;
  if (e = Sg(e, 360), t = Sg(t, 100), r = Sg(r, 100), t === 0)
    n = i = s = r;
  else {
    var l = r < 0.5 ? r * (1 + t) : r + t - r * t, d = 2 * r - l;
    n = $O(d, l, jO("r", e)), i = $O(d, l, jO("g", e)), s = $O(d, l, jO("b", e));
  }
  return [qu(255 * n), qu(255 * i), qu(255 * s)];
}
function Sg(e, t) {
  return e = Math.min(t, Math.max(0, parseFloat(e))), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function YO(e, t, r) {
  return t = t || 0, r = r || 255, !(e % 1 !== 0 || e < t || e > r || typeof e != "number" || isNaN(e));
}
Jn.prototype = {
  constructor: Jn,
  highlight: function(e) {
    return e = e || 10, this.alter(e).toHex();
  },
  darken: function(e) {
    return e = e || 10, this.alter(-e).toHex();
  },
  alter: function(e) {
    var t = new Jn();
    return t.r = Ol(this.r + e), t.g = Ol(this.g + e), t.b = Ol(this.b + e), t;
  },
  blend: function(e, t) {
    var r = e instanceof Jn ? e : new Jn(e), n = new Jn();
    return n.r = Ol(qu(this.r * (1 - t) + r.r * t)), n.g = Ol(qu(this.g * (1 - t) + r.g * t)), n.b = Ol(qu(this.b * (1 - t) + r.b * t)), n;
  },
  toHex: function() {
    return kK(this.r, this.g, this.b);
  },
  getPureColor: function() {
    var e = LG(this.hsv.h, 100, 100);
    return new Jn("rgb(" + e.join(",") + ")");
  },
  isValidHex: function(e) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(e);
  },
  isValidRGB: function(e, t, r) {
    return !(!YO(e) || !YO(t) || !YO(r));
  },
  isValidAlpha: function(e) {
    return !(isNaN(e) || e < 0 || e > 1 || typeof e != "number");
  },
  colorIsInvalid: !1,
  fromHSL: function(e) {
    var t = new Jn(), r = PG(e.h, e.s, e.l);
    return t.r = r[0], t.g = r[1], t.b = r[2], t;
  }
};
var {
  PI: xT,
  LN10: uve,
  abs: Ms,
  log: iF,
  floor: WR,
  ceil: aF,
  pow: RM,
  sqrt: IG,
  atan2: PK
} = Math;
var oF = Math.max, NG = Math.cos, VG = Math.sin, Rh = Math.round, IK = Et.dateToMilliseconds, sF = 1e10, AE = xT / 180;
var OE = Number, NK = NaN, VK = 1, XR = 10, Gd = function(e, t) {
  return e ? iF(e) / iF(t) : NK;
}, qR = function(e) {
  return rr(Gd(e, 10));
}, KR = function(e, t) {
  return RM(t, e);
}, Ll = function(e) {
  return (e % 360 + 360) % 360;
};
var FG = function(e) {
  return xT * e / 180;
}, ya = function(e) {
  var t = FG(e);
  return {
    cos: NG(t),
    sin: VG(t)
  };
};
var bT = function(e, t, r, n) {
  var i = r - e, s = n - t;
  return IG(s * s + i * i);
};
var lF = function(e, t) {
  if (t > 20 && (t = 20), Sr(e))
    return Ch(e) ? OE(e.toExponential(t)) : OE(e.toFixed(t));
}, uF = function(e) {
  return e.toExponential().split("e")[1];
};
function ti(e, t) {
  for (var r = 0, n = e.length, i = [], s; r < n; )
    s = t(e[r], r), s !== null && i.push(s), r++;
  return i;
}
function Wt(e) {
  return String(e).toLowerCase();
}
function q_(e) {
  return e && (e.originalTop = e.top, e.originalBottom = e.bottom, e.originalLeft = e.left, e.originalRight = e.right), e;
}
function YS(e) {
  return -sF < e && e < +sF ? e : 0;
}
function BG(e) {
  var t = YS(WR(e.x)), r = YS(WR(e.y)), n = YS(aF(e.width + e.x)), i = YS(aF(e.height + e.y)), s = {
    x: t,
    y: r,
    width: n - t,
    height: i - r
  };
  return s.isEmpty = !s.x && !s.y && !s.width && !s.height, s;
}
function kE(e, t, r) {
  var n = OE(NG(r * AE).toFixed(3)), i = OE(VG(r * AE).toFixed(3)), s = e.width / 2, l = e.height / 2, d = e.x + s, h = e.y + l, p = Ms(s * n) + Ms(l * i), m = Ms(s * i) + Ms(l * n), x = t[0] + (d - t[0]) * n + (h - t[1]) * i, S = t[1] - (d - t[0]) * i + (h - t[1]) * n;
  return BG({
    x: x - p,
    y: S - m,
    width: 2 * p,
    height: 2 * m
  });
}
var zG = function(e, t) {
  return e !== void 0 ? e : t;
}, ST = function(e) {
  var t = {}, r, n;
  for (r = 0, n = e.length; r < n; ++r)
    t[Wt(e[r])] = 1;
  return function(i, s) {
    var l = Wt(i);
    return t[l] ? l : s;
  };
}, Oi = function(e) {
  var t = {};
  return be(e || {}, function(r, n) {
    if (!/^(cursor)$/i.test(r))
      if (r === "opacity")
        n = null;
      else if (r === "color") {
        if (r = "fill", "opacity" in e) {
          var i = new Jn(n);
          n = "rgba(".concat(i.r, ",").concat(i.g, ",").concat(i.b, ",").concat(e.opacity, ")");
        }
      } else
        r = "font-" + r;
    t[r] = n;
  }), t;
};
function CT(e, t, r, n) {
  var i = n > 0 ? n : 0;
  r = I(r) ? r + t - 90 : 0;
  var s = ya(r);
  return {
    x: Rh(e.x + i * s.cos),
    y: Rh(e.y + i * s.sin)
  };
}
var DM = function(e, t, r) {
  var n = bT(e.x, e.y, t, r), i = PK(r - e.y, t - e.x);
  return {
    phi: Rh(Ll(180 * i / xT)),
    r: Rh(n)
  };
}, FK = function(e, t) {
  var r = ct(e.customizeSeries) ? e.customizeSeries : Y, n = e.nameField, i = {}, s = [], l, d = 0, h, p;
  for (t = t || [], h = t.length; d < h; d++)
    p = t[d], n in p && (l = i[p[n]], l || (l = i[p[n]] = {
      name: p[n],
      nameFieldValue: p[n]
    }, s.push(l.name)));
  return ti(s, function(m) {
    var x = i[m];
    return W(x, r.call(null, x.name));
  });
}, Xu = function(e, t, r) {
  if (e.length === 0)
    return {
      categories: []
    };
  t = I(t) ? t : e[0], r = I(r) ? r : e[e.length - 1];
  var n = ti(e, (m) => m == null ? void 0 : m.valueOf()), i = n.indexOf(t.valueOf()), s = n.indexOf(r.valueOf()), l, d = !1;
  i < 0 && (i = 0), s < 0 && (s = e.length - 1), s < i && (l = s, s = i, i = l, d = !0);
  var h = e.slice(i, s + 1), p = h.length - 1;
  return {
    categories: h,
    start: h[d ? p : 0],
    end: h[d ? 0 : p],
    inverted: d
  };
};
function dy(e) {
  return !(e.unit % 2);
}
function BK(e) {
  e.forEach((h) => {
    var p = h.height, m = 0, x = parseFloat(p) || void 0;
    (lr(p) && p.indexOf("px") > -1 || Sr(p) && p > 1) && (x = Rh(x), m = 1), !m && x && (lr(p) && p.indexOf("%") > -1 ? (x /= 100, m = 2) : x < 0 && (x = x < -1 ? 1 : Ms(x))), h.height = x, h.unit = m;
  });
  var t = e.filter(dy), r = t.reduce((h, p) => h + (p.height || 0), 0), n = t.length, i = t.filter((h) => !h.height), s = i.length;
  if (r < 1 && s)
    i.forEach((h) => h.height = (1 - r) / s);
  else if (r > 1 || r < 1 && !s || r === 1 && s) {
    if (s) {
      var l = r / n, d = s * l;
      t.filter((h) => h.height).forEach((h) => h.height *= (r - d) / r), i.forEach((h) => h.height = l);
    }
    t.forEach((h) => h.height *= 1 / r);
  }
}
function zK(e, t, r) {
  var n = 0, i = XR, s = r ? t.width - t.left - t.right : t.height - t.top - t.bottom, l = e.reduce((m, x) => m + (dy(x) ? 0 : x.height), 0), d = s - i * (e.length - 1) - l, h = r ? "left" : "top", p = r ? "right" : "bottom";
  e.forEach((m) => {
    var x = dy(m) ? Rh(m.height * d) : m.height;
    m.canvas = m.canvas || {}, W(m.canvas, t), m.canvas[h] = t[h] + n, m.canvas[p] = t[p] + (s - x - n), n = n + x + i, q_(m.canvas);
  });
}
var MM = function(e) {
  var t = {};
  return ti(e, function(r) {
    var n = t[r] ? null : r;
    return t[r] = !0, n;
  });
}, HG = function(e, t, r) {
  var n = e.x + e.width / 2 >= r.x, i = (n ? e.x : e.x + e.width) - r.x, s = e.y - r.y, l = s + t, d = Rh(IG(i * i + s * s - l * l)), h = (n ? +d : -d) || i;
  return {
    x: r.x + (n ? h : h - e.width),
    y: e.y + t
  };
};
function cF(e, t) {
  return {
    checkInterval: e.checkInterval || t.checkInterval,
    size: oF(e.size || 0, t.size || 0),
    percentStick: e.percentStick || t.percentStick,
    sizePointNormalState: oF(e.sizePointNormalState || 0, t.sizePointNormalState || 0)
  };
}
function bd(e) {
  return Array.isArray(e) ? {
    startValue: e[0],
    endValue: e[1]
  } : e || {};
}
function HK(e, t, r, n, i, s) {
  var l, d = !0, h = lF(s, 3) - lF(i, 3);
  return h && (Ms(h) % 360 === 0 && (i = 0, s = 360, l = !0, s -= 0.01), i > 360 && (i %= 360), s > 360 && (s %= 360), i > s && (i -= 360), d = !1), i *= AE, s *= AE, [e, t, Math.min(n, r), Math.max(n, r), Math.cos(i), Math.sin(i), Math.cos(s), Math.sin(s), l, WR(Ms(s - i) / xT) % 2 ? "1" : "0", d];
}
function LM(e, t) {
  return t ? e : [e.startValue, e.endValue];
}
function PM(e, t) {
  return e.dataType === "datetime" ? function(r, n) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    return new Date(r.getTime() + i * n);
  } : e.axisType === "logarithmic" ? function(r, n) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, s = Ai(r, e.base) + i * n;
    return Dh(s, e.base);
  } : function(r, n) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, s = r + i * n;
    return t && s * r <= 0 ? 0 : s;
  };
}
function GK(e, t, r, n) {
  var i = I(t.startValue), s = I(t.endValue), l = e.axisType !== "discrete";
  n = n || r;
  var d = PM(e, !1), h = i ? t.startValue : n.min, p = s ? t.endValue : n.max, m = t.length, x = n.categories;
  if (l && !I(h) && !I(p))
    return {
      startValue: h,
      endValue: p
    };
  if (I(m)) {
    if (l)
      e.dataType === "datetime" && !Sr(m) && (m = IK(m)), s && !i || !s && !i ? (I(r.max) && (p = p > r.max ? r.max : p), h = d(p, m, -1)) : i && !s && (I(r.min) && (h = h < r.min ? r.min : h), p = d(h, m));
    else if (m = parseInt(m), !isNaN(m) && isFinite(m)) {
      if (m--, !s && !i)
        p = x[x.length - 1], h = x[x.length - 1 - m];
      else if (i && !s) {
        var S = Xu(x, h, void 0);
        p = S.categories[m];
      } else if (!i && s) {
        var T = Xu(x, void 0, p);
        h = T.categories[T.categories.length - 1 - m];
      }
    }
  }
  return l && (I(r.max) && p > r.max && (p = r.max), I(r.min) && h < r.min && (h = r.min)), {
    startValue: h,
    endValue: p
  };
}
function Ai(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = arguments.length > 3 ? arguments[3] : void 0;
  if (!r)
    return Gd(e, t);
  if (e === 0)
    return 0;
  var i = Gd(Ms(e), t) - (n - 1);
  return i < 0 ? 0 : rr(Hd(e) * i, Number(RM(t, n - 1).toFixed(Ms(n))));
}
function Dh(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = arguments.length > 3 ? arguments[3] : void 0;
  if (!r)
    return KR(e, t);
  if (e === 0)
    return 0;
  var i = KR(Ms(e) + (n - 1), t);
  return i < 0 ? 0 : rr(Hd(e) * i, Number(RM(t, n).toFixed(Ms(n))));
}
function GG(e, t) {
  return Array.isArray(t) ? e.length === t.length && e.every((r, n) => qi(r) === qi(t[n])) : qi(e.startValue) === qi(t.startValue) && qi(e.endValue) === qi(t.endValue);
}
function qi(e) {
  return e && e.valueOf();
}
function UG(e, t, r) {
  return t >= e.left && t <= e.right && r >= e.top && r <= e.bottom;
}
var ih = () => "DevExpress_".concat(VK++);
function xa(e, t) {
  return lr(e) || !e ? e : t ? e.base : e.fillId || e.base;
}
var ET = Math, dF = ET.abs, fF = ET.min, hF = ET.max, vF = ET.floor, UK = "horizontal", jK = "vertical", ZR = 8, QR = 4, $K = "center", pF = "right", YK = "left", WK = "top", jG = "bottom";
function XK() {
  return {
    x: ZR,
    y: QR
  };
}
function $G(e) {
  return {
    x: e.x - ZR,
    y: e.y - QR,
    width: e.width + 2 * ZR,
    height: e.height + 2 * QR
  };
}
function gF(e, t, r, n) {
  var i = r ? ["x", "width", "y", "height", t, 0] : ["y", "height", "x", "width", e, 1];
  return function(s, l, d) {
    var h = {
      x: d.x,
      y: d.y
    }, p = $G(s), m = r ? d.y - s.y - s.height / 2 : d.y - s.y;
    return h.y = r || !r && l === jG ? d.y + m : d.y, p[i[0]] < 0 ? h[i[0]] -= p[i[0]] : p[i[0]] + p[i[1]] + m * i[5] > n[i[1]] && (h[i[0]] -= p[i[0]] + p[i[1]] + m * i[5] - n[i[1]]), i[4] - p[i[3]] / 2 < 0 ? h[i[2]] -= i[4] - p[i[3]] / 2 : i[4] + p[i[3]] / 2 > n[i[3]] && (h[i[2]] -= i[4] + p[i[3]] / 2 - n[i[3]]), h;
  };
}
function JR(e, t, r, n) {
  this._renderer = e, this._crosshairGroup = n, this._options = {}, this.update(t, r);
}
JR.prototype = {
  constructor: JR,
  update: function(e, t) {
    var r = t.canvas;
    this._canvas = {
      top: r.top,
      bottom: r.height - r.bottom,
      left: r.left,
      right: r.width - r.right,
      width: r.width,
      height: r.height
    }, this._axes = t.axes, this._panes = t.panes, this._prepareOptions(e, UK), this._prepareOptions(e, jK);
  },
  dispose: function() {
    this._renderer = this._crosshairGroup = this._options = this._axes = this._canvas = this._horizontalGroup = this._verticalGroup = this._horizontal = this._vertical = this._circle = this._panes = null;
  },
  _prepareOptions: function(e, t) {
    var r = e[t + "Line"];
    this._options[t] = {
      visible: r.visible,
      line: {
        stroke: r.color || e.color,
        "stroke-width": r.width || e.width,
        dashStyle: r.dashStyle || e.dashStyle,
        opacity: r.opacity || e.opacity,
        "stroke-linecap": "butt"
      },
      label: W(!0, {}, e.label, r.label)
    };
  },
  _createLines: function(e, t, r) {
    for (var n = [], i = this._canvas, s = [i.left, i.top, i.left, i.top], l = 0; l < 2; l++)
      n.push(this._renderer.path(s, "line").attr(e).sharp(t).append(r));
    return n;
  },
  render: function() {
    var e = this._renderer, t = this._options, r = t.vertical, n = t.horizontal, i = n.visible ? n.line : r.line, s = {
      stroke: i.stroke,
      "stroke-width": i["stroke-width"],
      dashStyle: i.dashStyle,
      opacity: i.opacity
    }, l = this._canvas;
    this._horizontal = {}, this._vertical = {}, this._circle = e.circle(l.left, l.top, 0).attr(s).append(this._crosshairGroup), this._horizontalGroup = e.g().append(this._crosshairGroup), this._verticalGroup = e.g().append(this._crosshairGroup), r.visible && (this._vertical.lines = this._createLines(r.line, "h", this._verticalGroup), this._vertical.labels = this._createLabels(this._axes[0], r, !1, this._verticalGroup)), n.visible && (this._horizontal.lines = this._createLines(n.line, "v", this._horizontalGroup), this._horizontal.labels = this._createLabels(this._axes[1], n, !0, this._horizontalGroup)), this.hide();
  },
  _createLabels: function(e, t, r, n) {
    var i = this._canvas, s = this._renderer, l, d, h, p = [], m, x, S = t.label;
    return S.visible && e.forEach(function(T) {
      var k = T.getOptions().position;
      if (!T.getTranslator().getBusinessRange().isEmpty()) {
        x = T.getLabelsPosition(), r ? (d = i.top, l = x) : (l = i.left, d = x);
        var O = k === WK || k === jG ? $K : k === pF ? YK : pF;
        m = s.rect(0, 0, 0, 0).attr({
          fill: S.backgroundColor || t.line.stroke
        }).append(n), h = s.text("0", 0, 0).css(Oi(t.label.font)).attr({
          align: O,
          class: S.cssClass
        }).append(n), p.push({
          text: h,
          background: m,
          axis: T,
          options: S,
          pos: {
            coord: x,
            side: k
          },
          startXY: {
            x: l,
            y: d
          }
        });
      }
    }), p;
  },
  _updateText: function(e, t, r, n, i) {
    var s = this;
    r.forEach(function(l) {
      var d = l.axis, h = l.startXY, p = l.text, m = l.background, x = "";
      (!d.name || d.name === t) && (x = d.getFormattedValue(e, l.options, n)), x ? (p.attr({
        text: x,
        x: h.x,
        y: h.y
      }), p.attr(i(p.getBBox(), l.pos.side, h)), s._updateLinesCanvas(l), m.attr($G(p.getBBox()))) : (p.attr({
        text: ""
      }), m.attr({
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }));
    });
  },
  hide: function() {
    this._crosshairGroup.attr({
      visibility: "hidden"
    });
  },
  _updateLinesCanvas: function(e) {
    var t = e.pos.side, r = e.pos.coord, n = this._linesCanvas, i = this._canvas;
    n[t] = n[t] !== i[t] && dF(n[t] - i[t]) < dF(r - i[t]) ? n[t] : r;
  },
  _updateLines: function(e, t, r, n, i) {
    for (var s = this._linesCanvas, l = this._canvas, d = i ? [
      [fF(t - n, s.left), l.top, t - n, l.top],
      [t + n, l.top, hF(s.right, t + n), l.top]
    ] : [
      [l.left, fF(s.top, r - n), l.left, r - n],
      [l.left, r + n, l.left, hF(s.bottom, r + n)]
    ], h = 0; h < 2; h++)
      e[h].attr({
        points: d[h]
      }).sharp(i ? "v" : "h", i ? r === l.bottom ? -1 : 1 : t === l.right ? -1 : 1);
  },
  _resetLinesCanvas: function() {
    var e = this._canvas;
    this._linesCanvas = {
      left: e.left,
      right: e.right,
      top: e.top,
      bottom: e.bottom
    };
  },
  _getClipRectForPane: function(e, t) {
    var r = this._panes, n, i;
    for (n = 0; n < r.length; n++)
      if (i = r[n].coords, i.left <= e && i.right >= e && i.top <= t && i.bottom >= t)
        return r[n].clipRect;
    return {
      id: null
    };
  },
  show: function(e) {
    var t = e.point, r = t.getCrosshairData(e.x, e.y), n = t.getPointRadius(), i = this._horizontal, s = this._vertical, l = n ? n + 3 : 0, d = this._canvas, h = vF(r.x), p = vF(r.y);
    h >= d.left && h <= d.right && p >= d.top && p <= d.bottom ? (this._crosshairGroup.attr({
      visibility: "visible"
    }), this._resetLinesCanvas(), this._circle.attr({
      cx: h,
      cy: p,
      r: l,
      "clip-path": this._getClipRectForPane(h, p).id
    }), i.lines && (this._updateText(r.yValue, r.axis, i.labels, t, gF(h, p, !0, d)), this._updateLines(i.lines, h, p, l, !0), this._horizontalGroup.attr({
      translateY: p - d.top
    })), s.lines && (this._updateText(r.xValue, r.axis, s.labels, t, gF(h, p, !1, d)), this._updateLines(s.lines, h, p, l, !1), this._verticalGroup.attr({
      translateX: h - d.left
    }))) : this.hide();
  }
};
const Is = {
  events: {
    mouseover: "mouseover",
    mouseout: "mouseout",
    mousemove: "mousemove",
    touchstart: "touchstart",
    touchmove: "touchmove",
    touchend: "touchend",
    mousedown: "mousedown",
    mouseup: "mouseup",
    click: "click",
    selectSeries: "selectseries",
    deselectSeries: "deselectseries",
    selectPoint: "selectpoint",
    deselectPoint: "deselectpoint",
    showPointTooltip: "showpointtooltip",
    hidePointTooltip: "hidepointtooltip"
  },
  states: {
    hover: "hover",
    normal: "normal",
    selection: "selection",
    normalMark: 0,
    hoverMark: 1,
    selectedMark: 2,
    applyHover: "applyHover",
    applySelected: "applySelected",
    resetItem: "resetItem"
  },
  radialLabelIndent: 30,
  pieLabelSpacing: 10,
  pieSeriesSpacing: 4
};
var RE = Math.round, qK = {
  horizontal: 0,
  vertical: 0
}, WS = {
  center: 0.5,
  right: 1,
  bottom: 1,
  left: 0,
  top: 0
};
function fy(e) {
  this._options = e;
}
fy.prototype = {
  constructor: fy,
  position: function(e) {
    var t = e.of.getLayoutOptions(), r = this.getLayoutOptions(), n = e.at, i = e.my, s = e.offset || qK, l = -WS[i.horizontal] * r.width + t.x + WS[n.horizontal] * t.width + parseInt(s.horizontal), d = -WS[i.vertical] * r.height + t.y + WS[n.vertical] * t.height + parseInt(s.vertical);
    this.shift(RE(l), RE(d));
  },
  getLayoutOptions: Y
};
function hy(e, t) {
  this._renderElement = e, this._cacheBBox = t;
}
var IM = hy.prototype = Vg(fy.prototype);
IM.constructor = hy;
IM.getLayoutOptions = function() {
  return this._cacheBBox || this._renderElement.getBBox();
};
IM.shift = function(e, t) {
  var r = this.getLayoutOptions();
  this._renderElement.move(RE(e - r.x), RE(t - r.y));
};
var {
  floor: As,
  sqrt: KK
} = Math, K_ = Math.min, eD = Math.max, ZK = 0.5, Lg = Is.radialLabelIndent;
function mF(e, t, r) {
  var n;
  return r < e ? n = e : t < r ? n = t : n = r, n;
}
function YG(e) {
  if (e._label.isVisible() && e._label.getLayoutOptions().position !== "inside")
    return e._label.getBoundingRect();
}
function QK(e, t, r, n, i) {
  return e.some(function(s) {
    return s.getVisiblePoints().reduce(function(l, d) {
      var h = YG(d);
      if (h) {
        var p = mF(h.x, h.x + h.width, t), m = mF(h.y, h.y + h.height, r);
        n = K_(eD(JK(p, m, t, r) - Lg, i), n), l = !0;
      }
      return l;
    }, !1);
  }), n;
}
function WG(e) {
  return e.reduce(function(t, r) {
    var n = r.getVisiblePoints().reduce(function(s, l) {
      var d = YG(l);
      return d && d.width > s && (s = d.width), s;
    }, 0), i = n;
    return n && (t.outerLabelsCount++, t.outerLabelsCount > 1 && (n += Is.pieLabelSpacing), i += Is.pieLabelSpacing), t.sizes.push(n), t.rSizes.push(i), t.common += n, t;
  }, {
    sizes: [],
    rSizes: [],
    common: 0,
    outerLabelsCount: 0
  });
}
function XG(e, t, r, n, i, s) {
  var l, d, h = 0, p = e.sizes, m = e.rSizes;
  for (d = 0; d < r.length; d++) {
    if (p[d] === 0) {
      l && (l += m[d - 1]);
      continue;
    }
    l = As(l ? l + m[d - 1] : t), r[d].correctLabelRadius(l), h += i || p[d], m[d] = i || m[d], r[d].setVisibleArea({
      left: As(s - t - h),
      right: As(n.width - (s + t + h)),
      top: n.top,
      bottom: n.bottom,
      width: n.width,
      height: n.height
    });
  }
}
function JK(e, t, r, n) {
  return KK((e - r) * (e - r) + (t - n) * (t - n));
}
function _F(e) {
  var {
    type: t,
    innerRadius: r
  } = e;
  return t === "pie" ? 0 : Sr(r) ? Number(r) : ZK;
}
function DE() {
}
function qG(e, t, r, n) {
  return (e - t - Lg - r.left) / n.outerLabelsCount;
}
function eZ(e, t, r) {
  return e - t.left - (r.outerLabelsCount > 0 ? r.common + Lg : 0);
}
function tZ(e, t, r, n, i, s) {
  var l = WG(r), d, h = eZ(i, t, l);
  return h < n ? (e = n, d = qG(i, e, t, l)) : e = K_(QK(r, i, s, e, n), h), XG(l, e + Lg, r, t, d, i), e;
}
function rZ(e) {
  return new hy(null, {
    x: e.left,
    y: e.top,
    width: e.width - e.left - e.right,
    height: e.height - e.top - e.bottom
  });
}
DE.prototype = {
  constructor: DE,
  setOptions: function(e) {
    this._options = e;
  },
  applyPieChartSeriesLayout: function(e, t, r) {
    var n = e.height - e.top - e.bottom, i = e.width - e.left - e.right, s = i / 2 + e.left, l = n / 2 + e.top, d = this._options.piePercentage, h, p;
    return Sr(d) ? h = p = d * K_(e.height, e.width) / 2 : (h = K_(i, n) / 2, p = this._options.minPiePercentage * h), r || (h = tZ(h, e, t, p, s, l)), {
      centerX: As(s),
      centerY: As(l),
      radiusInner: As(h * _F(t[0])),
      radiusOuter: As(h)
    };
  },
  applyEqualPieChartLayout: function(e, t) {
    var r = t.radius;
    return {
      centerX: As(t.x),
      centerY: As(t.y),
      radiusInner: As(r * _F(e[0])),
      radiusOuter: As(r)
    };
  },
  correctPieLabelRadius: function(e, t, r) {
    var n = WG(e), i, s = t.radiusOuter + Lg, l = t.centerX - r.left - s;
    n.common + Lg > l && (i = qG(t.centerX, t.radiusOuter, r, n)), XG(n, s, e, r, i, t.centerX);
  },
  needMoreSpaceForPanesCanvas(e, t, r) {
    var n = this._options, i = n.width, s = n.height, l = n.piePercentage, d = Sr(l), h = 0, p = 0;
    return e.forEach((m) => {
      var x = m.canvas, S = d ? K_(x.width, x.height) * l : void 0, T = r ? r(m) : {
        width: !1,
        height: !1
      }, k = T.width ? 0 : (d ? S : i) - (x.width - x.left - x.right), O = T.height ? 0 : (d ? S : s) - (x.height - x.top - x.bottom);
      t ? (h += k > 0 ? k : 0, p = eD(O > 0 ? O : 0, p)) : (h = eD(k > 0 ? k : 0, h), p += O > 0 ? O : 0);
    }), h > 0 || p > 0 ? {
      width: h,
      height: p
    } : !1;
  },
  layoutInsideLegend: function(e, t) {
    var r = e.getLayoutOptions();
    if (r) {
      var n = r.position, i = r.cutSide, s = {
        horizontal: n.horizontal,
        vertical: n.vertical
      };
      t[r.cutLayoutSide] += r.cutSide === "horizontal" ? r.width : r.height, s[i] = {
        left: "right",
        right: "left",
        top: "bottom",
        bottom: "top",
        center: "center"
      }[s[i]], e.position({
        of: rZ(t),
        my: s,
        at: n
      });
    }
  }
};
var TT = Math, tE = TT.floor, tD = TT.max, KG = TT.abs;
function nZ(e) {
  var t = {};
  return e.forEach((r) => {
    var n = r.pane;
    t[n] || (t[n] = []), t[n].push(r);
  }), t;
}
var iZ = (e) => ({
  transform: function(t, r) {
    return rr(Ai(t, r, e.allowNegatives, e.linearThreshold));
  },
  getTicks: function(t, r, n) {
    for (var i = [], s = this.transform(r[0], n); i.length < r.length; )
      i.push(s), s = rr(s + t);
    return i;
  }
}), aZ = (e) => ({
  transform: function(t, r) {
    return rr(Dh(t, r, e.allowNegatives, e.linearThreshold));
  },
  getTicks: function(t, r, n) {
    for (var i = [], s, l = 0; l < r.length; l += 1)
      s = this.transform(r[l], n), i.push(s);
    return i;
  }
});
function ZG(e, t) {
  if (e.isLogarithmic) {
    var r = e.logarithmicBase, n = e.tickValues;
    e.minValue = t.transform(e.minValue, r), e.oldMinValue = t.transform(e.oldMinValue, r), e.maxValue = t.transform(e.maxValue, r), e.oldMaxValue = t.transform(e.oldMaxValue, r), e.tickInterval = TT.round(e.tickInterval), e.tickInterval < 1 && (e.tickInterval = 1);
    var i = t.getTicks(e.tickInterval, n, r);
    i.tickInterval = e.tickInterval, e.tickValues = i;
  }
}
function oZ(e) {
  return e.reduce(function(t, r) {
    var n = r.getTicksValues(), i = n.majorTicksValues, s = r.getOptions(), l = r.getTranslator().getBusinessRange(), d = r.getVisibleArea(), h, p = r._tickInterval, m = s.synchronizedValue, x = r.getViewport().action;
    if (i && i.length > 0 && Sr(i[0]) && s.type !== "discrete" && !l.isEmpty() && !(l.breaks && l.breaks.length) && x !== "zoom" && x !== "pan") {
      r.applyMargins();
      var S = r.getTranslator().from(d[0]), T = r.getTranslator().from(d[1]), k = S < T ? S : T, O = S < T ? T : S;
      k === O && I(m) && (p = KG(i[0] - m) || 1, k = i[0] - p, O = i[0] + p), h = {
        axis: r,
        isLogarithmic: s.type === "logarithmic",
        logarithmicBase: l.base,
        tickValues: i,
        minorValues: n.minorTicksValues,
        minorTickInterval: r._minorTickInterval,
        minValue: k,
        oldMinValue: k,
        maxValue: O,
        oldMaxValue: O,
        inverted: l.invert,
        tickInterval: p,
        synchronizedValue: m
      }, ZG(h, iZ(r.getTranslator().getBusinessRange())), t.push(h);
    }
    return t;
  }, []);
}
function sZ(e) {
  var t = e.reduce((r, n) => tD(r, n.tickValues.length), 0);
  e.forEach((r) => {
    var n, i, s = 0, l = r.synchronizedValue, d = r.tickValues, h = r.tickInterval;
    if (I(l))
      r.baseTickValue = r.invertedBaseTickValue = l, r.tickValues = [r.baseTickValue];
    else {
      if (d.length > 1 && h) {
        for (n = tE((t + 1) / d.length), i = n > 1 ? tE((t + 1) / n) : t, s = tE((i - d.length) / 2); s > 0 && d[0] !== 0; )
          d.unshift(rr(d[0] - h)), s--;
        for (; d.length < i; )
          d.push(rr(d[d.length - 1] + h));
        r.tickInterval = h / n;
      }
      r.baseTickValue = d[0], r.invertedBaseTickValue = d[d.length - 1];
    }
  });
}
function Ed(e) {
  return e.maxValue - e.minValue || 1;
}
function QG(e) {
  for (var t = 0; t < e.length; t++)
    if (!e[t].stubData)
      return e[t];
  return null;
}
function lZ(e) {
  var t = QG(e), r = t.tickInterval;
  e.forEach((n) => {
    var i, s, l, d;
    n !== t && (r && n.tickInterval && (n.stubData && I(n.synchronizedValue) && (n.oldMinValue = n.minValue = n.baseTickValue - (t.baseTickValue - t.minValue) / r * n.tickInterval, n.oldMaxValue = n.maxValue = n.baseTickValue - (t.baseTickValue - t.maxValue) / r * n.tickInterval), i = r / Ed(t) / n.tickInterval * Ed(n), n.maxValue = n.minValue + Ed(n) / i), t.inverted && !n.inverted || !t.inverted && n.inverted ? l = t.maxValue - t.invertedBaseTickValue : l = t.baseTickValue - t.minValue, d = Ed(n), s = (l / Ed(t) - (n.baseTickValue - n.minValue) / d) * d, n.minValue -= s, n.maxValue -= s);
  });
}
function uZ(e) {
  var t, r, n = 0, i = 0;
  return e.forEach((s) => {
    var l = s.inverted;
    t = s.minValue > s.oldMinValue ? (s.minValue - s.oldMinValue) / Ed(s) : 0, r = s.maxValue < s.oldMaxValue ? (s.oldMaxValue - s.maxValue) / Ed(s) : 0, n = tD(n, l ? r : t), i = tD(i, l ? t : r);
  }), {
    start: n,
    end: i
  };
}
function cZ(e, t) {
  e.forEach((r) => {
    var n = Ed(r), i = r.inverted;
    r.minValue = rr(r.minValue - t[i ? "end" : "start"] * n), r.maxValue = rr(r.maxValue + t[i ? "start" : "end"] * n);
  });
}
function dZ(e) {
  var t = !1;
  e.forEach((r) => {
    t = t || I(r.synchronizedValue);
  }), e.forEach((r) => {
    var n = r.tickInterval, i = r.tickValues, s = r.maxValue, l = r.minValue, d;
    if (t && n) {
      for (; (d = rr(i[0] - n)) >= l; )
        i.unshift(d);
      for (d = i[i.length - 1]; (d = rr(d + n)) <= s; )
        i.push(d);
    }
    for (; i[0] + n / 10 < l; )
      i.shift();
    for (; i[i.length - 1] - n / 10 > s; )
      i.pop();
  });
}
function fZ(e) {
  e.forEach((t) => {
    var r = t.axis, n = r.getTranslator().getBusinessRange();
    n.min === n.minVisible && (n.min = t.minValue), n.max === n.maxVisible && (n.max = t.maxValue), n.minVisible = t.minValue, n.maxVisible = t.maxValue, n.min > n.minVisible && (n.min = n.minVisible), n.max < n.maxVisible && (n.max = n.maxVisible), r.getTranslator().updateBusinessRange(n), r.setTicks({
      majorTicks: t.tickValues,
      minorTicks: t.minorValues
    });
  });
}
function hZ(e) {
  var t = [], r;
  e.forEach((n) => {
    n.oldMaxValue - n.oldMinValue === 0 ? t.push(n) : !I(r) && !I(n.synchronizedValue) && (r = KG((n.maxValue - n.minValue) / (n.tickValues[tE(n.tickValues.length / 2)] - n.minValue || n.maxValue)));
  }), I(r) && t.forEach((n) => {
    var i = n.tickValues[0], s = i * r;
    i > 0 ? (n.maxValue = s, n.minValue = 0) : i < 0 && (n.minValue = s, n.maxValue = 0);
  });
}
function vZ(e) {
  e.forEach(function(t) {
    if (t.minorTickInterval) {
      for (var r = [], n = t.minorTickInterval, i = t.tickInterval / n - 1, s = 1; s < t.tickValues.length; s++)
        for (var l = t.tickValues[s - 1], d = 0; d < i; d++)
          l += n, r.push(l);
      t.minorValues = r;
    }
  });
}
function pZ(e) {
  var t = !0, r = !0;
  return e.forEach((n) => {
    (n.oldMinValue > 0 || n.oldMaxValue > 0) && (r = !1), (n.oldMinValue < 0 || n.oldMaxValue < 0) && (t = !1);
  }), t || r;
}
function gZ(e, t) {
  return pZ(e) ? e.reduce((r, n) => {
    var i = n.inverted, {
      start: s,
      end: l
    } = n.axis.getCorrectedValuesToZero(n.minValue, n.maxValue);
    return I(s) || I(l) ? i ? {
      start: r.start,
      end: Math.min(r.end, l)
    } : {
      start: Math.min(r.start, s),
      end: r.end
    } : r;
  }, t) : t;
}
var mZ = {
  synchronize: function(e) {
    be(nZ(e), function(t, r) {
      var n, i;
      if (r.length > 1) {
        if (n = oZ(r), n.length < 2 || !QG(n))
          return;
        sZ(n), lZ(n), i = uZ(n), i = gZ(n, i), cZ(n, i), hZ(n), dZ(n), vZ(n), n.forEach((s) => {
          ZG(s, aZ(s.axis.getTranslator().getBusinessRange()));
        }), fZ(n);
      }
    });
  }
}, rD = (e, t) => {
  if (!t)
    throw Dr.Error("E0017");
  return Array.isArray(e) ? e.map((r) => rD(r, t)).join(" ") : e.indexOf(" ") !== -1 ? rD(e.split(/\s+/g), t) : "".concat(e, ".").concat(t);
};
var _Z = function(e) {
  var t = je(e).get(0);
  return we.getActiveElement(t) === t;
}, yZ = {
  backspace: "backspace",
  tab: "tab",
  enter: "enter",
  escape: "escape",
  pageup: "pageUp",
  pagedown: "pageDown",
  end: "end",
  home: "home",
  arrowleft: "leftArrow",
  arrowup: "upArrow",
  arrowright: "rightArrow",
  arrowdown: "downArrow",
  delete: "del",
  " ": "space",
  f: "F",
  a: "A",
  "*": "asterisk",
  "-": "minus",
  alt: "alt",
  control: "control",
  shift: "shift"
}, xZ = {
  8: "backspace",
  9: "tab",
  13: "enter",
  27: "escape",
  33: "pageUp",
  34: "pageDown",
  35: "end",
  36: "home",
  37: "leftArrow",
  38: "upArrow",
  39: "rightArrow",
  40: "downArrow",
  46: "del",
  32: "space",
  70: "F",
  65: "A",
  106: "asterisk",
  109: "minus",
  189: "minus",
  173: "minus",
  16: "shift",
  17: "control",
  18: "alt"
}, bZ = {
  dx: /^dx/i,
  mouse: /(mouse|wheel)/i,
  touch: /^touch/i,
  keyboard: /^key/i,
  pointer: /^(ms)?pointer/i
}, SZ = (e) => e, CZ = (e) => SZ(Ve.Event(e, e), e), NM = (e) => Iy(e) === "dx", EZ = (e) => Iy(e) === "mouse", JG = (e) => Iy(e) === "touch", Iy = (e) => {
  var {
    type: t
  } = e, r = "other";
  return be(bZ, function(n) {
    if (this.test(t))
      return r = n, !1;
  }), r;
}, VM = (e) => Iy(e) === "pointer", ME = (e) => EZ(e) || (VM(e) || NM(e)) && e.pointerType === "mouse", LE = (e) => e && e.type === "dxmousewheel", wT = (e) => JG(e) || (VM(e) || NM(e)) && e.pointerType === "touch";
var Z_ = (e) => {
  var {
    pageX: t,
    pageY: r,
    timeStamp: n
  } = e;
  return {
    x: t,
    y: r,
    time: n
  };
}, yF = (e, t) => ({
  x: t.x - e.x,
  y: t.y - e.y,
  time: t.time - e.time || 1
}), e3 = (e) => {
  var {
    originalEvent: t,
    pointers: r
  } = e;
  return JG(e) ? (t.touches || []).length : NM(e) ? (r || []).length : 0;
}, TZ = !1;
var wZ = (e) => {
  if (TZ)
    return !0;
  var {
    target: t
  } = e, r = je(t), n = (t == null ? void 0 : t.isContentEditable) || (t == null ? void 0 : t.hasAttribute("contenteditable")), i = r.is("input, textarea, select") || n;
  if (LE(e)) {
    var s = r.is("textarea") && r.hasClass("dx-texteditor-input");
    if (s || n)
      return !1;
    var l = r.is("input[type='number'], textarea, select") && r.is(":focus");
    return l;
  }
  if (ME(e))
    return i || e.which > 1;
  if (wT(e))
    return i && _Z(r);
};
var t3 = (e, t) => {
  var r = CZ(e);
  return t && W(r, t), r;
}, Ku = (e) => {
  var {
    originalEvent: t,
    delegateTarget: r
  } = e, n = t3(t, e);
  return Ve.trigger(r || n.target, n), n;
}, AZ = (e) => {
  var {
    key: t,
    which: r
  } = e, n = yZ[t == null ? void 0 : t.toLowerCase()] || t, i = xZ[r];
  return i && n === t ? i : !n && r ? String.fromCharCode(r) : n;
};
var En = rD;
var Q_ = I, xF = Ls, OZ = ct, Vp = "min", Fp = "max", y_ = "minVisible", x_ = "maxVisible", bF = "base", XS = "axisType";
function Bp(e, t) {
  return t < e;
}
function qS(e, t) {
  return t > e;
}
function SF(e, t, r, n) {
  var i = Q_(t);
  Q_(e) ? i && n(e, t) && r(t) : i && r(t);
}
var _a = function(e) {
  e && W(this, e);
}, CF = _a;
CF.prototype = {
  constructor: CF,
  addRange: function(e) {
    var t = this, r = t.categories, n = e.categories, i = t[XS] === "discrete", s = function(h, p) {
      SF(t[h], e[h], function(m) {
        t[h] = m;
      }, p);
    }, l = function(h, p, m) {
      SF(t[h], t[p], function(x) {
        Q_(t[h]) && (t[h] = x);
      }, m);
    }, d = function(h) {
      t[h] = t[h] || e[h];
    };
    return d("invert"), d("containsConstantLine"), d(XS), d("dataType"), d("isSpacedMargin"), t[XS] === "logarithmic" ? d(bF) : t[bF] = void 0, s(Vp, Bp), s(Fp, qS), i ? (d(y_), d(x_)) : (s(y_, Bp), s(x_, qS)), s("interval", Bp), i || (l(Vp, y_, Bp), l(Vp, x_, Bp), l(Fp, x_, qS), l(Fp, y_, qS)), r === void 0 ? t.categories = n : t.categories = n ? MM(r.concat(n)) : r, t[XS] === "logarithmic" && (d("allowNegatives"), s("linearThreshold", Bp)), t;
  },
  isEmpty: function() {
    return (!Q_(this[Vp]) || !Q_(this[Fp])) && (!this.categories || this.categories.length === 0);
  },
  correctValueZeroLevel: function() {
    var e = this;
    if (xF(e[Fp]) || xF(e[Vp]))
      return e;
    function t(r, n) {
      e[r] < 0 && e[n] < 0 && (e[n] = 0), e[r] > 0 && e[n] > 0 && (e[r] = 0);
    }
    return t(Vp, Fp), t(y_, x_), e;
  },
  sortCategories(e) {
    if (!(e === !1 || !this.categories))
      if (Array.isArray(e)) {
        var t = e.map((i) => i.valueOf()), r = this.categories.filter((i) => t.indexOf(i.valueOf()) === -1);
        this.categories = e.concat(r);
      } else {
        var n = !OZ(e);
        n && this.dataType !== "string" ? e = (i, s) => i.valueOf() - s.valueOf() : n && (e = !1), e && this.categories.sort(e);
      }
  }
};
var KS = Math.round;
function EF(e) {
  return e;
}
const kZ = {
  translate: function(e, t) {
    var r = this._canvasOptions, n = this._categoriesToPoints[e == null ? void 0 : e.valueOf()], i = this.translateSpecialCase(e), s = r.startPointIndex || 0, l = this._options.stick ? 0 : 0.5;
    if (I(i))
      return KS(i);
    if (!n && n !== 0)
      return null;
    t = t || 0;
    var d = n + l - s + 0.5 * t;
    return KS(this._calculateProjection(r.interval * d));
  },
  getInterval: function() {
    return this._canvasOptions.interval;
  },
  getEventScale: function(e) {
    var t = e.deltaScale || 1;
    return 1 - (1 - t) / (0.75 + this.visibleCategories.length / this._categories.length);
  },
  zoom: function(e, t) {
    var r = this._categories, n = this._canvasOptions, i = this._options.stick, s = n.invert, l = n.interval * t, d = e / l, h = (this.visibleCategories || []).length, p = parseInt((n.startPointIndex || 0) + d + 0.5), m = parseInt(rr(n.canvasLength / l) + (i ? 1 : 0)) || 1, x;
    s && (p = parseInt((n.startPointIndex || 0) + h - d + 0.5) - m), p < 0 && (p = 0), x = p + m, x > r.length && (x = r.length, p = x - m, p < 0 && (p = 0));
    var S = r.slice(parseInt(p), parseInt(x)), T = this._getDiscreteInterval(S.length, n);
    return t = T / n.interval, e = this.translate(s ? S[S.length - 1] : S[0]) * t - (n.startPoint + (i ? 0 : T / 2)), {
      min: S[0],
      max: S[S.length - 1],
      translate: e,
      scale: t
    };
  },
  getMinScale: function(e) {
    var t = this._canvasOptions, r = (this.visibleCategories || this._categories).length;
    return r += (parseInt(0.1 * r) || 1) * (e ? -2 : 2), t.canvasLength / (Math.max(r, 1) * t.interval);
  },
  getScale: function(e, t) {
    var r = this._canvasOptions, n = this.getCanvasVisibleArea(), i = !this._options.stick && 1, s = I(e) ? this.translate(e, -i) : null, l = I(t) ? this.translate(t, +i) : null;
    return s === null && (s = r.invert ? n.max : n.min), l === null && (l = r.invert ? n.min : n.max), this.canvasLength / Math.abs(l - s);
  },
  isValid: function(e) {
    return I(e) ? this._categoriesToPoints[e.valueOf()] >= 0 : !1;
  },
  getCorrectValue: EF,
  to: function(e, t) {
    var r = this._canvasOptions, n = this._categoriesToPoints[e == null ? void 0 : e.valueOf()], i = r.startPointIndex || 0, s = n + (this._options.stick ? 0 : 0.5) - i + (this._businessRange.invert ? -1 : 1) * t * 0.5;
    return KS(this._calculateProjection(r.interval * s));
  },
  from: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._canvasOptions, n = r.startPoint, i = this.visibleCategories || this._categories, s = i.length, l = this._options.stick ? 0.5 : 0, d = KS((e - n) / r.interval + l - 0.5 - 0.5 * t);
    return d >= s && (d = s - 1), d < 0 && (d = 0), r.invert && (d = s - d - 1), i[d];
  },
  _add: function() {
    return NaN;
  },
  toValue: EF,
  isValueProlonged: !0,
  getRangeByMinZoomValue(e, t) {
    var r = this._categories, n = r.indexOf(t.minVisible), i = r.indexOf(t.maxVisible), s = n + e - 1, l = i - e + 1;
    return r[s] ? [t.minVisible, r[s]] : [r[l], t.maxVisible];
  }
};
var TF = Math.floor;
const RZ = {
  _intervalize: function(e, t) {
    if (I(e))
      return this._businessRange.dataType === "datetime" ? (Sr(e) ? e = new Date(e) : e = new Date(e.getTime()), e = Et.correctDateWithUnitBeginning(e, t, null, this._options.firstDayOfWeek)) : e = rr(TF(rr(e / t)) * t, t), e;
  },
  translate: function(e, t, r) {
    var n = this.translateSpecialCase(e);
    return I(n) ? Math.round(n) : (r = r || this._options.interval, this.isValid(e, r) ? this.to(e, t, r) : null);
  },
  getInterval: function() {
    return Math.round(this._canvasOptions.ratioOfCanvasRange * (this._businessRange.interval || Math.abs(this._canvasOptions.rangeMax - this._canvasOptions.rangeMin)));
  },
  zoom: function() {
  },
  getMinScale: function() {
  },
  getScale: function() {
  },
  _parse: function(e) {
    return this._businessRange.dataType === "datetime" ? new Date(e) : Number(e);
  },
  fromValue: function(e) {
    return this._parse(e);
  },
  toValue: function(e) {
    return this._parse(e);
  },
  isValid: function(e, t) {
    var r = this._canvasOptions, n = r.rangeMin, i = r.rangeMax;
    return t = t || this._options.interval, !(e === null || isNaN(e) || (e = this._businessRange.dataType === "datetime" && Sr(e) ? new Date(e) : e, t !== this._options.interval && (n = this._intervalize(n, t), i = this._intervalize(i, t)), e.valueOf() < n || e.valueOf() >= Et.addInterval(i, t)));
  },
  to: function(e, t, r) {
    r = r || this._options.interval;
    var n = this._intervalize(e, r), i = Et.addInterval(n, r), s = this._to(n), l = this._to(i);
    return t ? t > 0 && (s = l) : s = TF((s + l) / 2), s;
  },
  _to: function(e) {
    var t = this._canvasOptions, r = t.rangeMinVisible, n = t.rangeMaxVisible, i = e - r;
    return e < r ? i = 0 : e > n && (i = Et.addInterval(n, this._options.interval) - r), this._conversionValue(this._calculateProjection(i * this._canvasOptions.ratioOfCanvasRange));
  },
  from: function(e, t) {
    var r = this._options.interval, n = r, i = this._canvasOptions, s = i.rangeMinVisible, l = i.rangeMaxVisible, d;
    return this._businessRange.dataType === "datetime" && (n = Et.dateToMilliseconds(r)), d = this._calculateUnProjection((e - this._canvasOptions.startPoint) / this._canvasOptions.ratioOfCanvasRange), d = this._intervalize(Et.addInterval(d, n / 2, t > 0), r), d < s ? d = s : d > l && (d = l), d;
  },
  _add: function() {
    return NaN;
  },
  isValueProlonged: !0
};
function wF(e) {
  return e !== null ? new Date(e) : e;
}
const DZ = {
  fromValue: wF,
  toValue: wF,
  _add: Et.addDateInterval,
  convert: Et.dateToMilliseconds
}, MZ = {
  fromValue: function(e) {
    return e !== null ? Ai(e, this._canvasOptions.base, this._businessRange.allowNegatives, this._businessRange.linearThreshold) : e;
  },
  toValue: function(e) {
    return e !== null ? Dh(e, this._canvasOptions.base, this._businessRange.allowNegatives, this._businessRange.linearThreshold) : e;
  },
  getMinBarSize: function(e) {
    var t = this.getCanvasVisibleArea(), r = this.from(t.min + e), n = this._canvasOptions, i = this.fromValue(this.from(t.min)), s = this.fromValue(r ?? this.from(t.max)), l = Math.abs(i - s);
    return Math.pow(n.base, l);
  },
  checkMinBarSize: function(e, t, r) {
    var n = this._canvasOptions, i = r ? r - e : 0, s = this.constructor.prototype.checkMinBarSize, l, d;
    return I(t) && i > 0 ? (l = s(this.fromValue(r / i), this.fromValue(t) - n.rangeMinVisible), d = Math.pow(n.base, this.fromValue(i) + l) - i) : d = s(e, t), d;
  }
};
var WO = Math.abs, LZ = ["width", "height", "left", "top", "bottom", "right"], PZ = {
  to(e) {
    var t = this._canvasOptions.startPoint + (this._options.conversionValue ? e : Math.round(e));
    return t > this._canvasOptions.endPoint ? this._canvasOptions.endPoint : t;
  },
  from(e) {
    return e - this._canvasOptions.startPoint;
  }
}, AF = function(e) {
  return be(LZ, function(t, r) {
    e[r] = parseInt(e[r]) || 0;
  }), e;
}, IZ = function(e) {
  var t = {};
  return e.forEach(function(r, n) {
    t[r.valueOf()] = n;
  }), t;
}, NZ = function(e) {
  e instanceof _a || (e = new _a(e));
  function t(r, n) {
    !I(e[r]) && I(e[n]) && (e[r] = e[n]);
  }
  return t("minVisible", "min"), t("maxVisible", "max"), e;
};
function VZ(e, t) {
  var r = t.axisType === "logarithmic" ? function(m) {
    return Ai(m, t.base);
  } : function(m) {
    return m;
  }, n = [], i, s, l, d, h = e.length, p = 0;
  for (d = 0; d < h; d++)
    i = e[d], s = r(i.from), l = r(i.to), p += l - s, n.push({
      trFrom: s,
      trTo: l,
      from: i.from,
      to: i.to,
      length: p,
      cumulativeWidth: i.cumulativeWidth
    });
  return n;
}
function FZ(e) {
  var t = e.min, r = e.max, n = e.minVisible, i = e.maxVisible, s = e.axisType === "logarithmic";
  return s && (i = Ai(i, e.base, e.allowNegatives, e.linearThreshold), n = Ai(n, e.base, e.allowNegatives, e.linearThreshold), t = Ai(t, e.base, e.allowNegatives, e.linearThreshold), r = Ai(r, e.base, e.allowNegatives, e.linearThreshold)), {
    base: e.base,
    rangeMin: t,
    rangeMax: r,
    rangeMinVisible: n,
    rangeMaxVisible: i
  };
}
function OF(e) {
  return {
    isStartSide: e ? function(t, r, n, i) {
      return t <= r[r.length - 1][i];
    } : function(t, r, n, i) {
      return t < r[0][n];
    },
    isEndSide: e ? function(t, r, n, i) {
      return t > r[0][n];
    } : function(t, r, n, i) {
      return t >= r[r.length - 1][i];
    },
    isInBreak: e ? function(t, r, n, i) {
      return t > r[i] && t <= r[n];
    } : function(t, r, n, i) {
      return t >= r[n] && t < r[i];
    },
    isBetweenBreaks: e ? function(t, r, n, i, s) {
      return t >= r[s] && t < n[i];
    } : function(t, r, n, i, s) {
      return t < r[i] && t >= n[s];
    },
    getLength: e ? function(t, r) {
      return r.length - t.length;
    } : function(t) {
      return t.length;
    },
    getBreaksSize: e ? function(t, r) {
      return r.cumulativeWidth - t.cumulativeWidth;
    } : function(t) {
      return t.cumulativeWidth;
    }
  };
}
var PE = function(e, t, r) {
  this.update(e, t, r);
};
PE.prototype = {
  constructor: PE,
  reinit: function() {
    var e = this, t = e._options, r = e._businessRange, n = r.categories || [], i = {}, s = e._prepareCanvasOptions(), l = Xu(n, r.minVisible, r.maxVisible).categories, d = l.length;
    if (r.isEmpty())
      i = PZ;
    else
      switch (r.axisType) {
        case "logarithmic":
          i = MZ;
          break;
        case "semidiscrete":
          i = RZ, s.ratioOfCanvasRange = s.canvasLength / (Et.addInterval(s.rangeMaxVisible, t.interval) - s.rangeMinVisible);
          break;
        case "discrete":
          i = kZ, e._categories = n, s.interval = e._getDiscreteInterval(t.addSpiderCategory ? d + 1 : d, s), e._categoriesToPoints = IZ(n), d && (s.startPointIndex = e._categoriesToPoints[l[0].valueOf()], e.visibleCategories = l);
          break;
        default:
          r.dataType === "datetime" && (i = DZ);
      }
    (e._oldMethods || []).forEach(function(h) {
      delete e[h];
    }), e._oldMethods = Object.keys(i), W(e, i), e._conversionValue = t.conversionValue ? (h) => h : (h, p) => p ? h : Math.round(h), e.sc = {}, e._checkingMethodsAboutBreaks = [OF(!1), OF(e.isInverted())], e._translateBreaks(), e._calculateSpecialValues();
  },
  _translateBreaks: function() {
    var e = this._breaks, t = this._options.breaksSize, r, n, i, s;
    if (e !== void 0)
      for (r = 0, s = e.length; r < s; r++)
        n = e[r], i = this.translate(n.to), n.end = i, n.start = n.gapSize ? i : this.isInverted() ? i + t : i - t;
  },
  _checkValueAboutBreaks: function(e, t, r, n, i) {
    var s, l, d = {
      length: 0,
      breaksSize: void 0,
      inBreak: !1
    }, h, p, m = e[e.length - 1];
    if (i.isStartSide(t, e, r, n))
      return d;
    if (i.isEndSide(t, e, r, n))
      return {
        length: m.length,
        breaksSize: m.cumulativeWidth,
        inBreak: !1
      };
    for (s = 0, l = e.length; s < l; s++) {
      if (h = e[s], p = e[s - 1], i.isInBreak(t, h, r, n)) {
        d.inBreak = !0, d.break = h;
        break;
      }
      if (p && i.isBetweenBreaks(t, h, p, r, n)) {
        d = {
          length: i.getLength(p, m),
          breaksSize: i.getBreaksSize(p, m),
          inBreak: !1
        };
        break;
      }
    }
    return d;
  },
  isInverted: function() {
    return !(this._options.isHorizontal ^ this._businessRange.invert);
  },
  _getDiscreteInterval: function(e, t) {
    var r = e - (this._options.stick ? 1 : 0);
    return r > 0 ? t.canvasLength / r : t.canvasLength;
  },
  _prepareCanvasOptions() {
    var e = this._businessRange, t = this._canvasOptions = FZ(e), r = this._canvas, n = this._breaks, i;
    return t.startPadding = r.startPadding || 0, t.endPadding = r.endPadding || 0, this._options.isHorizontal ? (t.startPoint = r.left + t.startPadding, i = r.width, t.endPoint = r.width - r.right - t.endPadding, t.invert = e.invert) : (t.startPoint = r.top + t.startPadding, i = r.height, t.endPoint = r.height - r.bottom - t.endPadding, t.invert = !e.invert), this.canvasLength = t.canvasLength = t.endPoint - t.startPoint, t.rangeDoubleError = Math.pow(10, uF(t.rangeMax - t.rangeMin) - uF(i) - 2), t.ratioOfCanvasRange = t.canvasLength / (t.rangeMaxVisible - t.rangeMinVisible), n !== void 0 && (t.ratioOfCanvasRange = (t.canvasLength - n[n.length - 1].cumulativeWidth) / (t.rangeMaxVisible - t.rangeMinVisible - n[n.length - 1].length)), t;
  },
  updateCanvas: function(e) {
    this._canvas = AF(e), this.reinit();
  },
  updateBusinessRange: function(e) {
    var t = e.breaks || [];
    this._userBreaks = e.userBreaks || [], this._businessRange = NZ(e), this._breaks = t.length ? VZ(t, this._businessRange) : void 0, this.reinit();
  },
  update: function(e, t, r) {
    this._options = W(this._options || {}, r), this._canvas = AF(t), this.updateBusinessRange(e);
  },
  getBusinessRange: function() {
    return this._businessRange;
  },
  getEventScale: function(e) {
    return e.deltaScale || 1;
  },
  getCanvasVisibleArea: function() {
    return {
      min: this._canvasOptions.startPoint,
      max: this._canvasOptions.endPoint
    };
  },
  _calculateSpecialValues: function() {
    var e = this._canvasOptions, t = e.startPoint - e.startPadding, r = e.endPoint + e.endPadding, n = this._businessRange, i = n.minVisible, s = n.maxVisible, l = t + e.canvasLength / 2, d;
    if (i < 0 && s > 0 && i !== s && (d = this.translate(0, 1)), !I(d)) {
      var h = n.invert ^ (i < 0 && s <= 0);
      this._options.isHorizontal ? d = h ? r : t : d = h ? t : r;
    }
    this.sc = {
      canvas_position_default: d,
      canvas_position_left: t,
      canvas_position_top: t,
      canvas_position_center: l,
      canvas_position_middle: l,
      canvas_position_right: r,
      canvas_position_bottom: r,
      canvas_position_start: e.invert ? r : t,
      canvas_position_end: e.invert ? t : r
    };
  },
  translateSpecialCase(e) {
    return this.sc[e];
  },
  _calculateProjection: function(e) {
    var t = this._canvasOptions;
    return t.invert ? t.endPoint - e : t.startPoint + e;
  },
  _calculateUnProjection: function(e) {
    var t = this._canvasOptions;
    return this._businessRange.dataType === "datetime" && (e = Math.round(e)), t.invert ? t.rangeMaxVisible.valueOf() - e : t.rangeMinVisible.valueOf() + e;
  },
  getMinBarSize: function(e) {
    var t = this.getCanvasVisibleArea(), r = this.from(t.min + e);
    return WO(this.from(t.min) - (I(r) ? r : this.from(t.max)));
  },
  checkMinBarSize: function(e, t) {
    return WO(e) < t ? e >= 0 ? t : -t : e;
  },
  translate(e, t, r) {
    var n = this.translateSpecialCase(e);
    return I(n) ? Math.round(n) : isNaN(e) ? null : this.to(e, t, r);
  },
  getInterval: function(e) {
    var t, r = this._canvasOptions;
    return e = (t = e) !== null && t !== void 0 ? t : this._businessRange.interval, Math.round(e ? r.ratioOfCanvasRange * e : r.endPoint - r.startPoint);
  },
  zoom(e, t, r) {
    var n = this._canvasOptions;
    if (n.rangeMinVisible.valueOf() === n.rangeMaxVisible.valueOf() && e !== 0)
      return this.zoomZeroLengthRange(e, t);
    var i = n.startPoint, s = n.endPoint, l = this.isInverted(), d = (i + e) / t, h = (s + e) / t;
    r = r || {};
    var p = this.to(l ? r.endValue : r.startValue), m = this.to(l ? r.startValue : r.endValue), x, S;
    return p > d && (h -= d - p, d = p, x = l ? r.endValue : r.startValue), m < h && (d -= h - m, h = m, S = l ? r.startValue : r.endValue), m - p < h - d && (d = p, h = m), e = (s - i) * d / (h - d) - i, t = (i + e) / d || 1, x = I(x) ? x : rr(this.from(d, 1)), S = I(S) ? S : rr(this.from(h, -1)), t <= 1 && (x = this._correctValueAboutBreaks(x, t === 1 ? e : -1), S = this._correctValueAboutBreaks(S, t === 1 ? e : 1)), x > S ? (x = x > r.endValue ? r.endValue : x, S = S < r.startValue ? r.startValue : S) : (x = x < r.startValue ? r.startValue : x, S = S > r.endValue ? r.endValue : S), {
      min: x,
      max: S,
      translate: rr(e),
      scale: rr(t)
    };
  },
  _correctValueAboutBreaks(e, t) {
    var r = this._userBreaks.filter((n) => e >= n.from && e <= n.to);
    return r.length ? t > 0 ? r[0].to : r[0].from : e;
  },
  zoomZeroLengthRange(e, t) {
    var r = this._canvasOptions, n = r.rangeMin, i = r.rangeMax, s = (i.valueOf() !== n.valueOf() ? i.valueOf() - n.valueOf() : WO(r.rangeMinVisible.valueOf() - n.valueOf())) / r.canvasLength, l = Ls(i) || Ls(n), d = this._businessRange.axisType === "logarithmic", h = r.rangeMinVisible.valueOf() - s, p = r.rangeMaxVisible.valueOf() + s;
    return h = d ? rr(Dh(h, r.base)) : l ? new Date(h) : h, p = d ? rr(Dh(p, r.base)) : l ? new Date(p) : p, {
      min: h,
      max: p,
      translate: e,
      scale: t
    };
  },
  getMinScale: function(e) {
    var {
      dataType: t,
      interval: r
    } = this._businessRange;
    return t === "datetime" && r === 1 ? this.getDateTimeMinScale(e) : e ? 1.1 : 0.9;
  },
  getDateTimeMinScale(e) {
    var t = this._canvasOptions, r = t.canvasLength / t.ratioOfCanvasRange;
    return r += (parseInt(0.1 * r) || 1) * (e ? -2 : 2), t.canvasLength / (Math.max(r, 1) * t.ratioOfCanvasRange);
  },
  getScale: function(e, t) {
    var r = this._canvasOptions;
    return r.rangeMax === r.rangeMin ? 1 : (e = I(e) ? this.fromValue(e) : r.rangeMin, t = I(t) ? this.fromValue(t) : r.rangeMax, (r.rangeMax - r.rangeMin) / Math.abs(e - t));
  },
  isValid: function(e) {
    var t = this._canvasOptions;
    return e = this.fromValue(e), e !== null && !isNaN(e) && e.valueOf() + t.rangeDoubleError >= t.rangeMin && e.valueOf() - t.rangeDoubleError <= t.rangeMax;
  },
  getCorrectValue: function(e, t) {
    var r = this._breaks, n;
    return e = this.fromValue(e), this._breaks && (n = this._checkValueAboutBreaks(r, e, "trFrom", "trTo", this._checkingMethodsAboutBreaks[0]), n.inBreak === !0) ? this.toValue(t > 0 ? n.break.trTo : n.break.trFrom) : this.toValue(e);
  },
  to: function(e, t, r) {
    var n = this.getBusinessRange();
    if (I(n.maxVisible) && I(n.minVisible) && n.maxVisible.valueOf() === n.minVisible.valueOf())
      return !I(e) || n.maxVisible.valueOf() !== e.valueOf() ? null : this.translateSpecialCase(e === 0 && this._options.shiftZeroValue ? "canvas_position_default" : "canvas_position_middle");
    e = this.fromValue(e);
    var i = this._canvasOptions, s = this._breaks, l = {
      length: 0
    }, d = 0;
    return s !== void 0 && (l = this._checkValueAboutBreaks(s, e, "trFrom", "trTo", this._checkingMethodsAboutBreaks[0]), d = I(l.breaksSize) ? l.breaksSize : 0), l.inBreak === !0 ? t > 0 ? l.break.start : t < 0 ? l.break.end : null : this._conversionValue(this._calculateProjection((e - i.rangeMinVisible - l.length) * i.ratioOfCanvasRange + d), r);
  },
  from: function(e, t) {
    var r = this._breaks, n = {
      length: 0
    }, i = this._canvasOptions, s = i.startPoint, l = 0;
    return r !== void 0 && (n = this._checkValueAboutBreaks(r, e, "start", "end", this._checkingMethodsAboutBreaks[1]), l = I(n.breaksSize) ? n.breaksSize : 0), n.inBreak === !0 ? t > 0 ? this.toValue(n.break.trTo) : t < 0 ? this.toValue(n.break.trFrom) : null : this.toValue(this._calculateUnProjection((e - s - l) / i.ratioOfCanvasRange + n.length));
  },
  isValueProlonged: !1,
  getRange: function() {
    return [this.toValue(this._canvasOptions.rangeMin), this.toValue(this._canvasOptions.rangeMax)];
  },
  getScreenRange: function() {
    return [this._canvasOptions.startPoint, this._canvasOptions.endPoint];
  },
  add: function(e, t, r) {
    return this._add(e, t, (this._businessRange.invert ? -1 : 1) * r);
  },
  _add: function(e, t, r) {
    return this.toValue(this.fromValue(e) + t * r);
  },
  fromValue: function(e) {
    return e !== null ? Number(e) : null;
  },
  toValue: function(e) {
    return e !== null ? Number(e) : null;
  },
  ratioOfCanvasRange() {
    return this._canvasOptions.ratioOfCanvasRange;
  },
  convert: (e) => e,
  getRangeByMinZoomValue(e, t) {
    return t.minVisible + e <= this._businessRange.max ? [t.minVisible, t.minVisible + e] : [t.maxVisible - e, t.maxVisible];
  }
};
var BZ = function(e) {
  return Array.isArray(e) ? e : [e];
};
var zZ = (e, t) => e.reduce((r, n) => {
  var i, s = t(n);
  return r[s] = (i = r[s]) !== null && i !== void 0 ? i : [], r[s].push(n), r;
}, {}), HZ = jr(), GZ = (e) => {
  if (e.getRootNode) {
    var t = e.getRootNode().host;
    if (!lr(t))
      return t;
  }
}, r3 = () => {
  var e = we.getActiveElement();
  if (e && e !== we.getBody()) {
    var t;
    (t = e.blur) === null || t === void 0 || t.call(e);
  }
}, UZ = () => {
  var e = HZ.getSelection();
  if (e && e.type !== "Caret") {
    if (e.empty)
      e.empty();
    else if (e.removeAllRanges)
      try {
        e.removeAllRanges();
      } catch {
      }
  }
};
var AT = (e) => {
  var t = I(e) && (e.nodeType || zd(e)) ? je(e) : je("<div>").html(e).contents();
  return t.length === 1 && (t.is("script") ? t = AT(t.html().trim()) : t.is("table") && (t = t.children("tbody").contents())), t;
};
var vy = (e, t) => t ? Fl(e) ? vy(e.document, t) : e.contains(t) || vy(e, GZ(t)) : !1;
var jZ = (e, t) => (t && we.insertElement(e.parentNode, t, e), e), $Z = (e, t) => {
  if (t && t[0])
    return t.is(e) ? e : (be(t, (r, n) => {
      jZ(e[0], n);
    }), e.remove(), t);
};
var XO = [], YZ = zl(() => {
  var e = we.listen(we.getDocument(), "DOMContentLoaded", () => {
    n3.fire(), e();
  });
}), n3 = {
  add: (e) => {
    var t = fn();
    t && we.getReadyState() !== "loading" ? e() : (XO.push(e), t && YZ());
  },
  fire: () => {
    XO.forEach((e) => e()), XO = [];
  }
};
const jd = Fs(n3);
var py = function() {
  var e, t = Xa(), r = t.add, n = t.remove;
  if (!fn())
    return t;
  var i = function() {
    var h = jr();
    return {
      width: h.innerWidth,
      height: h.innerHeight
    };
  }, s = function() {
    var h = i();
    if (!(h.width === e.width && h.height === e.height)) {
      var p;
      h.width === e.width && (p = "height"), h.height === e.height && (p = "width"), e = h, t.fire(p);
    }
  }, l = zl(function() {
    e = i();
  }), d;
  return t.add = function() {
    var h = r.apply(t, arguments);
    return l(), jd.add(function() {
      !d && t.has() && (d = we.listen(jr(), "resize", s));
    }), h;
  }, t.remove = function() {
    var h = n.apply(t, arguments);
    return !t.has() && d && (d(), d = void 0), h;
  }, t;
}();
class zg {
  constructor(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this._events = {}, this._owner = t, this._options = r;
  }
  static create(t, r) {
    return r ? ct(r) ? r(t) : r : new zg(t);
  }
  hasEvent(t) {
    var r = this._events[t];
    return r ? r.has() : !1;
  }
  fireEvent(t, r) {
    var n = this._events[t];
    return n && n.fireWith(this._owner, r), this._owner;
  }
  on(t, r) {
    if (Qr(t))
      be(t, (s, l) => {
        this.on(s, l);
      });
    else {
      var n = this._events[t];
      n || (n = Xa({
        syncStrategy: this._options.syncStrategy
      }), this._events[t] = n);
      var i = n.originalAdd || n.add;
      i.call(n, r);
    }
  }
  off(t, r) {
    var n = this._events[t];
    n && (ct(r) ? n.remove(r) : n.empty());
  }
  dispose() {
    be(this._events, (t, r) => {
      r.empty();
    });
  }
}
var WZ = jr(), XZ = function() {
  var e;
  try {
    e = WZ.sessionStorage;
  } catch {
  }
  return e;
}, qZ = jd.add, FM = Xa(), i3 = je(), gy = /* @__PURE__ */ function() {
  var e;
  return function(t) {
    if (!arguments.length)
      return e;
    var r = je(t);
    i3 = r;
    var n = !!r.length, i = gy();
    e = n ? r : je("body"), FM.fire(n ? gy() : je(), i);
  };
}();
qZ(function() {
  gy(".dx-viewport");
});
function KZ() {
  return i3;
}
var a3 = jr(), ZZ = {
  iPhone: "iPhone",
  iPhone5: "iPhone",
  iPhone6: "iPhone",
  iPhone6plus: "iPhone",
  iPad: "iPad",
  iPadMini: "iPad Mini",
  androidPhone: "Android Mobile",
  androidTablet: "Android",
  msSurface: "Windows ARM Tablet PC",
  desktop: "desktop"
}, kF = {
  deviceType: "desktop",
  platform: "generic",
  version: [],
  phone: !1,
  tablet: !1,
  android: !1,
  ios: !1,
  generic: !0,
  grade: "A",
  mac: !1
}, qO = {
  generic(e) {
    var t = /windows phone/i.test(e) || e.match(/WPDesktop/), r = !t && /Windows(.*)arm(.*)Tablet PC/i.test(e), n = !t && !r && /msapphost/i.test(e), i = /((intel|ppc) mac os x)/.test(e.toLowerCase());
    return t || r || n || i ? {
      deviceType: t ? "phone" : r ? "tablet" : "desktop",
      platform: "generic",
      version: [],
      grade: "A",
      mac: i
    } : null;
  },
  appleTouchDevice(e) {
    var t = Dy(), r = /Macintosh/i.test(e) && (t == null ? void 0 : t.maxTouchPoints) > 2, n = /ip(hone|od|ad)/i.test(e);
    if (!n && !r)
      return null;
    var i = /ip(hone|od)/i.test(e), s = e.match(/os\s{0,}X? (\d+)_(\d+)_?(\d+)?/i), l = s ? [parseInt(s[1], 10), parseInt(s[2], 10), parseInt(s[3] || 0, 10)] : [], d = a3.screen.height === 480, h = d ? "B" : "A";
    return {
      deviceType: i ? "phone" : "tablet",
      platform: "ios",
      version: l,
      grade: h
    };
  },
  android(e) {
    var t = /android|htc_|silk/i.test(e), r = /windows phone/i.test(e);
    if (!t || r)
      return null;
    var n = /mobile/i.test(e), i = e.match(/android (\d+)\.?(\d+)?\.?(\d+)?/i), s = i ? [parseInt(i[1], 10), parseInt(i[2] || 0, 10), parseInt(i[3] || 0, 10)] : [], l = s.length > 1 && (s[0] < 4 || s[0] === 4 && s[1] < 4), d = l ? "B" : "A";
    return {
      deviceType: n ? "phone" : "tablet",
      platform: "android",
      version: s,
      grade: d
    };
  }
}, RF = [qO.appleTouchDevice, qO.android, qO.generic];
class QZ {
  constructor(t) {
    this._window = (t == null ? void 0 : t.window) || a3, this._realDevice = this._getDevice(), this._currentDevice = void 0, this._currentOrientation = void 0, this._eventsStrategy = new zg(this), this.changed = Xa(), fn() && (jd.add(this._recalculateOrientation.bind(this)), py.add(this._recalculateOrientation.bind(this)));
  }
  current(t) {
    if (t) {
      this._currentDevice = this._getDevice(t), this._forced = !0, this.changed.fire();
      return;
    }
    if (!this._currentDevice) {
      t = void 0;
      try {
        t = this._getDeviceOrNameFromWindowScope();
      } catch {
        t = this._getDeviceNameFromSessionStorage();
      } finally {
        t || (t = this._getDeviceNameFromSessionStorage()), t && (this._forced = !0);
      }
      this._currentDevice = this._getDevice(t);
    }
    return this._currentDevice;
  }
  real(t) {
    return W({}, this._realDevice);
  }
  orientation() {
    return this._currentOrientation;
  }
  isForced() {
    return this._forced;
  }
  isRippleEmulator() {
    return !!this._window.tinyHippos;
  }
  _getCssClasses(t) {
    var r = [], n = this._realDevice;
    return t = t || this.current(), t.deviceType && (r.push("dx-device-".concat(t.deviceType)), t.deviceType !== "desktop" && r.push("dx-device-mobile")), r.push("dx-device-".concat(n.platform)), n.version && n.version.length && r.push("dx-device-".concat(n.platform, "-").concat(n.version[0])), this.isSimulator() && r.push("dx-simulator"), Zr().rtlEnabled && r.push("dx-rtl"), r;
  }
  attachCssClasses(t, r) {
    this._deviceClasses = this._getCssClasses(r).join(" "), je(t).addClass(this._deviceClasses);
  }
  detachCssClasses(t) {
    je(t).removeClass(this._deviceClasses);
  }
  isSimulator() {
    try {
      return this._isSimulator || fn() && this._window.top !== this._window.self && this._window.top["dx-force-device"] || this.isRippleEmulator();
    } catch {
      return !1;
    }
  }
  forceSimulator() {
    this._isSimulator = !0;
  }
  _getDevice(t) {
    if (t === "genericPhone" && (t = {
      deviceType: "phone",
      platform: "generic",
      generic: !0
    }), Qr(t))
      return this._fromConfig(t);
    var r;
    if (t) {
      if (r = ZZ[t], !r)
        throw Dr.Error("E0005");
    } else {
      var n = Dy();
      r = n.userAgent;
    }
    return this._fromUA(r);
  }
  _getDeviceOrNameFromWindowScope() {
    var t;
    return fn() && (this._window.top["dx-force-device-object"] || this._window.top["dx-force-device"]) && (t = this._window.top["dx-force-device-object"] || this._window.top["dx-force-device"]), t;
  }
  _getDeviceNameFromSessionStorage() {
    var t = XZ();
    if (t) {
      var r = t.getItem("dx-force-device");
      try {
        return JSON.parse(r);
      } catch {
        return r;
      }
    }
  }
  _fromConfig(t) {
    var r = W({}, kF, this._currentDevice, t), n = {
      phone: r.deviceType === "phone",
      tablet: r.deviceType === "tablet",
      android: r.platform === "android",
      ios: r.platform === "ios",
      generic: r.platform === "generic"
    };
    return W(r, n);
  }
  _fromUA(t) {
    for (var r = 0; r < RF.length; r += 1) {
      var n = RF[r], i = n(t);
      if (i)
        return this._fromConfig(i);
    }
    return kF;
  }
  _changeOrientation() {
    var t = je(this._window), r = gT(t) > Mg(t) ? "portrait" : "landscape";
    this._currentOrientation !== r && (this._currentOrientation = r, this._eventsStrategy.fireEvent("orientationChanged", [{
      orientation: r
    }]));
  }
  _recalculateOrientation() {
    var t = Mg(this._window);
    this._currentWidth !== t && (this._currentWidth = t, this._changeOrientation());
  }
  on(t, r) {
    return this._eventsStrategy.on(t, r), this;
  }
  off(t, r) {
    return this._eventsStrategy.off(t, r), this;
  }
}
var qa = new QZ(), DF = gy();
DF && qa.attachCssClasses(DF);
FM.add((e, t) => {
  qa.detachCssClasses(t), qa.attachCssClasses(e);
});
var BM = Qi.inherit({
  ctor: function(e) {
    this._$element = je(e), this._cancelCallback = Xa(), this._acceptCallback = Xa();
  },
  getElement: function() {
    return this._$element;
  },
  validate: function(e) {
    return !LE(e);
  },
  validatePointers: function(e) {
    return e3(e) === 1;
  },
  allowInterruptionByMouseWheel: function() {
    return !0;
  },
  configure: function(e) {
    W(this, e);
  },
  addCancelCallback: function(e) {
    this._cancelCallback.add(e);
  },
  removeCancelCallback: function() {
    this._cancelCallback.empty();
  },
  _cancel: function(e) {
    this._cancelCallback.fire(this, e);
  },
  addAcceptCallback: function(e) {
    this._acceptCallback.add(e);
  },
  removeAcceptCallback: function() {
    this._acceptCallback.empty();
  },
  _accept: function(e) {
    this._acceptCallback.fire(this, e);
  },
  _requestAccept: function(e) {
    this._acceptRequestEvent = e;
  },
  _forgetAccept: function() {
    this._accept(this._acceptRequestEvent), this._acceptRequestEvent = null;
  },
  start: Y,
  move: Y,
  end: Y,
  cancel: Y,
  reset: function() {
    this._acceptRequestEvent && this._accept(this._acceptRequestEvent);
  },
  _fireEvent: function(e, t, r) {
    var n = W({
      type: e,
      originalEvent: t,
      target: this._getEmitterTarget(t),
      delegateTarget: this.getElement().get(0)
    }, r);
    return t = Ku(n), t.cancel && this._cancel(t), t;
  },
  _getEmitterTarget: function(e) {
    return (this.delegateSelector ? je(e.target).closest(this.delegateSelector) : this.getElement()).get(0);
  },
  dispose: Y
}), JZ = jd.add, MF = Math.abs, KO = 0, ZO = 1, b_ = 2, IE = 10, eQ = 0, tQ = 180, rQ = function() {
  return Fg("pointer-events");
}, nQ = zl(function() {
  var e = qa.real().deviceType === "desktop";
  if (!rQ() || !e)
    return Y;
  var t = je("<div>").addClass("dx-gesture-cover").css("pointerEvents", "none");
  return Ve.subscribeGlobal(t, "dxmousewheel", function(r) {
    r.preventDefault();
  }), JZ(function() {
    t.appendTo("body");
  }), function(r, n) {
    t.css("pointerEvents", r ? "all" : "none"), r && t.css("cursor", n);
  };
}), iQ = function(e, t) {
  var r = nQ();
  r(e, t);
}, zM = BM.inherit({
  gesture: !0,
  configure: function(e) {
    this.getElement().css("msTouchAction", e.immediate ? "pinch-zoom" : ""), this.callBase(e);
  },
  allowInterruptionByMouseWheel: function() {
    return this._stage !== b_;
  },
  getDirection: function() {
    return this.direction;
  },
  _cancel: function() {
    this.callBase.apply(this, arguments), this._toggleGestureCover(!1), this._stage = KO;
  },
  start: function(e) {
    if (e._needSkipEvent || wZ(e)) {
      this._cancel(e);
      return;
    }
    this._startEvent = t3(e), this._startEventData = Z_(e), this._stage = ZO, this._init(e), this._setupImmediateTimer();
  },
  _setupImmediateTimer: function() {
    var e;
    if (clearTimeout(this._immediateTimer), this._immediateAccepted = !1, !!this.immediate) {
      if (this.immediateTimeout === 0) {
        this._immediateAccepted = !0;
        return;
      }
      this._immediateTimer = setTimeout((function() {
        this._immediateAccepted = !0;
      }).bind(this), (e = this.immediateTimeout) !== null && e !== void 0 ? e : tQ);
    }
  },
  move: function(e) {
    if (this._stage === ZO && this._directionConfirmed(e)) {
      if (this._stage = b_, this._resetActiveElement(), this._toggleGestureCover(!0), this._clearSelection(e), this._adjustStartEvent(e), this._start(this._startEvent), this._stage === KO)
        return;
      this._requestAccept(e), this._move(e), this._forgetAccept();
    } else
      this._stage === b_ && (this._clearSelection(e), this._move(e));
  },
  _directionConfirmed: function(e) {
    var t = this._getTouchBoundary(e), r = yF(this._startEventData, Z_(e)), n = MF(r.x), i = MF(r.y), s = this._validateMove(t, n, i), l = this._validateMove(t, i, n), d = this.getDirection(e), h = d === "both" && (s || l), p = d === "horizontal" && s, m = d === "vertical" && l;
    return h || p || m || this._immediateAccepted;
  },
  _validateMove: function(e, t, r) {
    return t && t >= e && (this.immediate ? t >= r : !0);
  },
  _getTouchBoundary: function(e) {
    return this.immediate || LE(e) ? eQ : IE;
  },
  _adjustStartEvent: function(e) {
    var t = this._getTouchBoundary(e), r = yF(this._startEventData, Z_(e));
    this._startEvent.pageX += Hd(r.x) * t, this._startEvent.pageY += Hd(r.y) * t;
  },
  _resetActiveElement: function() {
    qa.real().platform === "ios" && this.getElement().find(":focus").length && r3();
  },
  _toggleGestureCover: function(e) {
    this._toggleGestureCoverImpl(e);
  },
  _toggleGestureCoverImpl: function(e) {
    var t = this._stage === b_;
    t && iQ(e, this.getElement().css("cursor"));
  },
  _clearSelection: function(e) {
    LE(e) || wT(e) || UZ();
  },
  end: function(e) {
    this._toggleGestureCover(!1), this._stage === b_ ? this._end(e) : this._stage === ZO && this._stop(e), this._stage = KO;
  },
  dispose: function() {
    clearTimeout(this._immediateTimer), this.callBase.apply(this, arguments), this._toggleGestureCover(!1);
  },
  _init: Y,
  _start: Y,
  _move: Y,
  _stop: Y,
  _end: Y
});
zM.initialTouchBoundary = IE;
zM.touchBoundary = function(e) {
  if (I(e)) {
    IE = e;
    return;
  }
  return IE;
};
var {
  maxTouchPoints: o3
} = Dy(), aQ = {
  webkitTransition: "webkitTransitionEnd",
  MozTransition: "transitionend",
  OTransition: "oTransitionEnd",
  transition: "transitionend"
}, HM = function(e) {
  return !!Fg(e);
}, oQ = function() {
  var {
    platform: e,
    mac: t
  } = qa.real(), r = e === "ios" || e === "android" || t;
  return r;
}, sQ = function(e) {
  if (e === "text")
    return !0;
  var t = we.createElement("input");
  try {
    return t.setAttribute("type", e), t.value = "wrongValue", !t.value;
  } catch {
    return !1;
  }
}, lQ = function(e, t) {
  return (e("ontouchstart") || !!t) && !e("callPhantom");
}, uQ = function(e) {
  return e("PointerEvent");
}, s3 = lQ(SM, o3), l3 = uQ(SM), cQ = !!o3, dQ = s3 || l3 && cQ, fQ = zl(function() {
  return HM("transition");
}), hQ = zl(function() {
  return aQ[Fg("transition")];
}), vQ = zl(function() {
  return HM("animation");
}), pQ = oQ();
const gQ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  animation: vQ,
  inputType: sQ,
  nativeScrolling: pQ,
  pointerEvents: l3,
  styleProp: Fg,
  stylePropPrefix: Oq,
  supportProp: HM,
  touch: dQ,
  touchEvents: s3,
  transition: fQ,
  transitionEndEventName: hQ
}, Symbol.toStringTag, { value: "Module" }));
var mQ = Dy(), _Q = /(webkit)[ /]([\w.]+)/, yQ = /(mozilla)(?:.*? rv:([\w.]+))/, LF = (e) => {
  e = e.toLowerCase();
  var t = {}, r = _Q.exec(e) || e.indexOf("compatible") < 0 && yQ.exec(e) || [], n = r[1], i = r[2];
  return n === "webkit" && (t.webkit = !0, e.indexOf("chrome") >= 0 || e.indexOf("crios") >= 0 ? (n = "chrome", i = /(?:chrome|crios)\/(\d+\.\d+)/.exec(e), i = i && i[1]) : e.indexOf("fxios") >= 0 ? (n = "mozilla", i = /fxios\/(\d+\.\d+)/.exec(e), i = i && i[1]) : e.indexOf("safari") >= 0 && /version|phantomjs/.test(e) ? (n = "safari", i = /(?:version|phantomjs)\/([0-9.]+)/.exec(e), i = i && i[1]) : (n = "unknown", i = /applewebkit\/([0-9.]+)/.exec(e), i = i && i[1])), n && (t[n] = !0, t.version = i), t;
};
const xQ = W({
  _fromUA: LF
}, LF(mQ.userAgent));
var PF = "dxPointerEvents", GM = Qi.inherit({
  ctor: function(e, t) {
    this._eventName = e, this._originalEvents = En(t, PF), this._handlerCount = 0, this.noBubble = this._isNoBubble();
  },
  _isNoBubble: function() {
    var e = this._eventName;
    return e === "dxpointerenter" || e === "dxpointerleave";
  },
  _handler: function(e) {
    var t, r = this._getDelegateTarget(e), n = {
      type: this._eventName,
      pointerType: e.pointerType || Iy(e),
      originalEvent: e,
      delegateTarget: r,
      timeStamp: xQ.mozilla ? (/* @__PURE__ */ new Date()).getTime() : e.timeStamp
    }, i = e.originalEvent;
    if (i != null && (t = i.target) !== null && t !== void 0 && t.shadowRoot) {
      var s, l, d = (s = i.path) !== null && s !== void 0 ? s : (l = i.composedPath) === null || l === void 0 ? void 0 : l.call(i);
      n.target = d[0];
    }
    return this._fireEvent(n);
  },
  _getDelegateTarget: function(e) {
    var t;
    return this.noBubble && (t = e.delegateTarget), t;
  },
  _fireEvent: function(e) {
    return Ku(e);
  },
  _setSelector: function(e) {
    this._selector = this.noBubble && e ? e.selector : null;
  },
  _getSelector: function() {
    return this._selector;
  },
  setup: function() {
    return !0;
  },
  add: function(e, t) {
    if (this._handlerCount <= 0 || this.noBubble) {
      e = this.noBubble ? e : we.getDocument(), this._setSelector(t);
      var r = this;
      Ve.on(e, this._originalEvents, this._getSelector(), function(n) {
        r._handler(n);
      });
    }
    this.noBubble || this._handlerCount++;
  },
  remove: function(e) {
    this._setSelector(e), this.noBubble || this._handlerCount--;
  },
  teardown: function(e) {
    this._handlerCount && !this.noBubble || (e = this.noBubble ? e : we.getDocument(), this._originalEvents !== "." + PF && Ve.off(e, this._originalEvents, this._getSelector()));
  },
  dispose: function(e) {
    e = this.noBubble ? e : we.getDocument(), Ve.off(e, this._originalEvents);
  }
}), bQ = {
  dxpointerdown: "touchstart",
  dxpointermove: "touchmove",
  dxpointerup: "touchend",
  dxpointercancel: "touchcancel",
  dxpointerover: "",
  dxpointerout: "",
  dxpointerenter: "",
  dxpointerleave: ""
}, u3 = function(e) {
  var t = [];
  return be(e.touches, function(r, n) {
    t.push(W({
      pointerId: n.identifier
    }, n));
  }), {
    pointers: t,
    pointerId: e.changedTouches[0].identifier
  };
}, SQ = function(e) {
  return qa.real().platform === "ios" && (e === "dxpointerdown" || e === "dxpointerup");
}, Ny = GM.inherit({
  ctor: function() {
    this.callBase.apply(this, arguments), this._pointerId = 0;
  },
  _handler: function(e) {
    if (SQ(this._eventName)) {
      var t = e.changedTouches[0];
      if (this._pointerId === t.identifier && this._pointerId !== 0)
        return;
      this._pointerId = t.identifier;
    }
    return this.callBase.apply(this, arguments);
  },
  _fireEvent: function(e) {
    return this.callBase(W(u3(e.originalEvent), e));
  }
});
Ny.map = bQ;
Ny.normalize = u3;
var ZS = function(e, t) {
  jd.add(function() {
    e.split(" ").forEach(function(r) {
      we.listen(we.getDocument(), r, t, !0);
    });
  });
}, CQ = function(e, t, r) {
  r = r || function() {
  };
  var n = [], i = function(l) {
    var d = -1;
    return be(n, function(h, p) {
      return t(l, p) ? (d = h, !1) : !0;
    }), d;
  }, s = function(l) {
    var d = i(l);
    d > -1 && n.splice(d, 1);
  };
  ZS(e.dxpointerdown, function(l) {
    i(l) === -1 && (r(l), n.push(l));
  }), ZS(e.dxpointermove, function(l) {
    n[i(l)] = l;
  }), ZS(e.dxpointerup, s), ZS(e.dxpointercancel, s), this.pointers = function() {
    return n;
  }, this.reset = function() {
    n = [];
  };
}, c3 = {
  dxpointerdown: "mousedown",
  dxpointermove: "mousemove",
  dxpointerup: "mouseup",
  dxpointercancel: "",
  dxpointerover: "mouseover",
  dxpointerout: "mouseout",
  dxpointerenter: "mouseenter",
  dxpointerleave: "mouseleave"
}, d3 = function(e) {
  return e.pointerId = 1, {
    pointers: UM.pointers(),
    pointerId: 1
  };
}, UM, IF = !1, f3 = function() {
  IF || (UM = new CQ(c3, function() {
    return !0;
  }), IF = !0);
}, oc = GM.inherit({
  ctor: function() {
    this.callBase.apply(this, arguments), f3();
  },
  _fireEvent: function(e) {
    return this.callBase(W(d3(e.originalEvent), e));
  }
});
oc.map = c3;
oc.normalize = d3;
oc.activate = f3;
oc.resetObserver = function() {
  UM.reset();
};
var EQ = {
  dxpointerdown: "touchstart mousedown",
  dxpointermove: "touchmove mousemove",
  dxpointerup: "touchend mouseup",
  dxpointercancel: "touchcancel",
  dxpointerover: "mouseover",
  dxpointerout: "mouseout",
  dxpointerenter: "mouseenter",
  dxpointerleave: "mouseleave"
}, NF = !1, TQ = function() {
  NF || (oc.activate(), NF = !0);
}, OT = GM.inherit({
  EVENT_LOCK_TIMEOUT: 100,
  ctor: function() {
    this.callBase.apply(this, arguments), TQ();
  },
  _handler: function(e) {
    var t = ME(e);
    if (t || (this._skipNextEvents = !0), !(t && this._mouseLocked)) {
      if (t && this._skipNextEvents) {
        this._skipNextEvents = !1, this._mouseLocked = !0, clearTimeout(this._unlockMouseTimer);
        var r = this;
        this._unlockMouseTimer = setTimeout(function() {
          r._mouseLocked = !1;
        }, this.EVENT_LOCK_TIMEOUT);
        return;
      }
      return this.callBase(e);
    }
  },
  _fireEvent: function(e) {
    var t = ME(e.originalEvent) ? oc.normalize : Ny.normalize;
    return this.callBase(W(t(e.originalEvent), e));
  },
  dispose: function() {
    this.callBase(), this._skipNextEvents = !1, this._mouseLocked = !1, clearTimeout(this._unlockMouseTimer);
  }
});
OT.map = EQ;
OT.resetObserver = oc.resetObserver;
var wQ = (e, t) => {
  var {
    tablet: r,
    phone: n
  } = t, i = AQ();
  return i || (e.touch && !(r || n) ? OT : e.touch ? Ny : oc);
}, VF = wQ(gQ, qa.real());
be(VF.map, (e, t) => {
  Hl(e, new VF(e, t));
});
var dn = {
  down: "dxpointerdown",
  up: "dxpointerup",
  move: "dxpointermove",
  cancel: "dxpointercancel",
  enter: "dxpointerenter",
  leave: "dxpointerleave",
  over: "dxpointerover",
  out: "dxpointerout"
};
function AQ() {
  var e = Zr().pointerEventStrategy;
  return {
    "mouse-and-touch": OT,
    touch: Ny,
    mouse: oc
  }[e];
}
var kT = "dxmousewheel", FF = "dxWheel", OQ = "wheel", BF = 0, kQ = 30, nD = {
  setup: function(e) {
    var t = je(e);
    Ve.on(t, En(OQ, FF), nD._wheelHandler.bind(nD));
  },
  teardown: function(e) {
    Ve.off(e, ".".concat(FF));
  },
  _wheelHandler: function(e) {
    var {
      deltaMode: t,
      deltaY: r,
      deltaX: n,
      deltaZ: i
    } = e.originalEvent;
    Ku({
      type: kT,
      originalEvent: e,
      delta: this._normalizeDelta(r, t),
      deltaX: n,
      deltaY: r,
      deltaZ: i,
      deltaMode: t,
      pointerType: "mouse"
    }), e.stopPropagation();
  },
  _normalizeDelta(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : BF;
    return t === BF ? -e : -kQ * e;
  }
};
Hl(kT, nD);
var QS = "dxEventManager", z_ = "dxEmitter", RQ = Qi.inherit({
  ctor: function() {
    this._attachHandlers(), this.reset(), this._proxiedCancelHandler = this._cancelHandler.bind(this), this._proxiedAcceptHandler = this._acceptHandler.bind(this);
  },
  _attachHandlers: function() {
    jd.add((function() {
      var e = we.getDocument();
      Ve.subscribeGlobal(e, En(dn.down, QS), this._pointerDownHandler.bind(this)), Ve.subscribeGlobal(e, En(dn.move, QS), this._pointerMoveHandler.bind(this)), Ve.subscribeGlobal(e, En([dn.up, dn.cancel].join(" "), QS), this._pointerUpHandler.bind(this)), Ve.subscribeGlobal(e, En(kT, QS), this._mouseWheelHandler.bind(this));
    }).bind(this));
  },
  _eachEmitter: function(e) {
    for (var t = this._activeEmitters || [], r = 0; t.length > r; ) {
      var n = t[r];
      if (e(n) === !1)
        break;
      t[r] === n && r++;
    }
  },
  _applyToEmitters: function(e, t) {
    this._eachEmitter(function(r) {
      r[e].call(r, t);
    });
  },
  reset: function() {
    this._eachEmitter(this._proxiedCancelHandler), this._activeEmitters = [];
  },
  resetEmitter: function(e) {
    this._proxiedCancelHandler(e);
  },
  _pointerDownHandler: function(e) {
    ME(e) && e.which > 1 || this._updateEmitters(e);
  },
  _updateEmitters: function(e) {
    this._isSetChanged(e) && (this._cleanEmitters(e), this._fetchEmitters(e));
  },
  _isSetChanged: function(e) {
    var t = this._closestEmitter(e), r = this._emittersSet || [], n = t.length !== r.length;
    return be(t, function(i, s) {
      return n = n || r[i] !== s, !n;
    }), this._emittersSet = t, n;
  },
  _closestEmitter: function(e) {
    var t = this, r = [], n = je(e.target);
    function i(l, d) {
      d && d.validatePointers(e) && d.validate(e) && (d.addCancelCallback(t._proxiedCancelHandler), d.addAcceptCallback(t._proxiedAcceptHandler), r.push(d));
    }
    for (; n.length; ) {
      var s = di(n.get(0), z_) || [];
      be(s, i), n = n.parent();
    }
    return r;
  },
  _acceptHandler: function(e, t) {
    var r = this;
    this._eachEmitter(function(n) {
      n !== e && r._cancelEmitter(n, t);
    });
  },
  _cancelHandler: function(e, t) {
    this._cancelEmitter(e, t);
  },
  _cancelEmitter: function(e, t) {
    var r = this._activeEmitters;
    t ? e.cancel(t) : e.reset(), e.removeCancelCallback(), e.removeAcceptCallback();
    var n = r.indexOf(e);
    n > -1 && r.splice(n, 1);
  },
  _cleanEmitters: function(e) {
    this._applyToEmitters("end", e), this.reset(e);
  },
  _fetchEmitters: function(e) {
    this._activeEmitters = this._emittersSet.slice(), this._applyToEmitters("start", e);
  },
  _pointerMoveHandler: function(e) {
    this._applyToEmitters("move", e);
  },
  _pointerUpHandler: function(e) {
    this._updateEmitters(e);
  },
  _mouseWheelHandler: function(e) {
    this._allowInterruptionByMouseWheel() && (e.pointers = [null], this._pointerDownHandler(e), this._adjustWheelEvent(e), this._pointerMoveHandler(e), e.pointers = [], this._pointerUpHandler(e));
  },
  _allowInterruptionByMouseWheel: function() {
    var e = !0;
    return this._eachEmitter(function(t) {
      return e = t.allowInterruptionByMouseWheel() && e, e;
    }), e;
  },
  _adjustWheelEvent: function(e) {
    var t = null;
    if (this._eachEmitter(function(s) {
      if (s.gesture) {
        var l = s.getDirection(e);
        if (l !== "horizontal" && !e.shiftKey || l !== "vertical" && e.shiftKey)
          return t = s, !1;
      }
    }), !!t) {
      var r = t.getDirection(e), n = r === "both" && !e.shiftKey || r === "vertical", i = n ? "pageY" : "pageX";
      e[i] += e.delta;
    }
  },
  isActive: function(e) {
    var t = !1;
    return this._eachEmitter(function(r) {
      t = t || r.getElement().is(e);
    }), t;
  }
}), zF = new RQ(), QO = "dxEmitterSubscription", jM = function(e) {
  var t = e.emitter, r = e.events[0], n = e.events;
  be(n, function(i, s) {
    Hl(s, {
      noBubble: !e.bubble,
      setup: function(l) {
        var d = di(l, QO) || {}, h = di(l, z_) || {}, p = h[r] || new t(l);
        d[s] = !0, h[r] = p, di(l, z_, h), di(l, QO, d);
      },
      add: function(l, d) {
        var h = di(l, z_), p = h[r];
        p.configure(W({
          delegateSelector: d.selector
        }, d.data), d.type);
      },
      teardown: function(l) {
        var d = di(l, QO), h = di(l, z_), p = h[r];
        delete d[s];
        var m = !0;
        be(n, function(x, S) {
          return m = m && !d[S], m;
        }), m && (zF.isActive(l) && zF.resetEmitter(p), p && p.dispose(), delete h[r]);
      }
    });
  });
}, Hg = "dxdragstart", Gg = "dxdrag", Ug = "dxdragend", $M = "dxdragenter", YM = "dxdragleave", WM = "dxdrop", JS = "dxDragEventsCount", Uu = [], vg = [], iD = [], XM = {
  setup: function(e, t) {
    var r = Uu.includes(e);
    r || (Uu.push(e), vg.push([]), iD.push(t || {}));
  },
  add: function(e, t) {
    var r = Uu.indexOf(e);
    this.updateEventsCounter(e, t.type, 1);
    var n = t.selector;
    vg[r].includes(n) || vg[r].push(n);
  },
  updateEventsCounter: function(e, t, r) {
    if ([$M, YM, WM].indexOf(t) > -1) {
      var n = di(e, JS) || 0;
      di(e, JS, Math.max(0, n + r));
    }
  },
  remove: function(e, t) {
    this.updateEventsCounter(e, t.type, -1);
  },
  teardown: function(e) {
    var t = di(e, JS);
    if (!t) {
      var r = Uu.indexOf(e);
      Uu.splice(r, 1), vg.splice(r, 1), iD.splice(r, 1), wM(e, JS);
    }
  }
};
Hl($M, XM);
Hl(YM, XM);
Hl(WM, XM);
var DQ = function(e) {
  var t = Uu.indexOf(e.get(0)), r = vg[t].filter((i) => i), n = e.find(r.join(", "));
  return vg[t].includes(void 0) && (n = n.add(e)), n;
}, MQ = function(e) {
  var t = Uu.indexOf(e.get(0));
  return iD[t];
}, LQ = function(e, t) {
  return e.itemPositionFunc ? e.itemPositionFunc(t) : t.offset();
}, PQ = function(e, t) {
  return e.itemSizeFunc ? e.itemSizeFunc(t) : {
    width: t.get(0).getBoundingClientRect().width,
    height: t.get(0).getBoundingClientRect().height
  };
}, IQ = zM.inherit({
  ctor: function(e) {
    this.callBase(e), this.direction = "both";
  },
  _init: function(e) {
    this._initEvent = e;
  },
  _start: function(e) {
    if (e = this._fireEvent(Hg, this._initEvent), this._maxLeftOffset = e.maxLeftOffset, this._maxRightOffset = e.maxRightOffset, this._maxTopOffset = e.maxTopOffset, this._maxBottomOffset = e.maxBottomOffset, e.targetElements || e.targetElements === null) {
      var t = BZ(e.targetElements || []);
      this._dropTargets = Bl(t, function(r) {
        return je(r).get(0);
      });
    } else
      this._dropTargets = Uu;
  },
  _move: function(e) {
    var t = Z_(e), r = this._calculateOffset(t);
    e = this._fireEvent(Gg, e, {
      offset: r
    }), this._processDropTargets(e), e._cancelPreventDefault || e.preventDefault();
  },
  _calculateOffset: function(e) {
    return {
      x: this._calculateXOffset(e),
      y: this._calculateYOffset(e)
    };
  },
  _calculateXOffset: function(e) {
    if (this.direction !== "vertical") {
      var t = e.x - this._startEventData.x;
      return this._fitOffset(t, this._maxLeftOffset, this._maxRightOffset);
    }
    return 0;
  },
  _calculateYOffset: function(e) {
    if (this.direction !== "horizontal") {
      var t = e.y - this._startEventData.y;
      return this._fitOffset(t, this._maxTopOffset, this._maxBottomOffset);
    }
    return 0;
  },
  _fitOffset: function(e, t, r) {
    return t != null && (e = Math.max(e, -t)), r != null && (e = Math.min(e, r)), e;
  },
  _processDropTargets: function(e) {
    var t = this._findDropTarget(e), r = t === this._currentDropTarget;
    r || (this._fireDropTargetEvent(e, YM), this._currentDropTarget = t, this._fireDropTargetEvent(e, $M));
  },
  _fireDropTargetEvent: function(e, t) {
    if (this._currentDropTarget) {
      var r = {
        type: t,
        originalEvent: e,
        draggingElement: this._$element.get(0),
        target: this._currentDropTarget
      };
      Ku(r);
    }
  },
  _findDropTarget: function(e) {
    var t = this, r;
    return be(Uu, function(n, i) {
      if (t._checkDropTargetActive(i)) {
        var s = je(i);
        be(DQ(s), function(l, d) {
          var h = je(d);
          t._checkDropTarget(MQ(s), h, je(r), e) && (r = d);
        });
      }
    }), r;
  },
  _checkDropTargetActive: function(e) {
    var t = !1;
    return be(this._dropTargets, function(r, n) {
      return t = t || n === e || vy(n, e), !t;
    }), t;
  },
  _checkDropTarget: function(e, t, r, n) {
    var i = t.get(0) === je(n.target).get(0);
    if (i)
      return !1;
    var s = LQ(e, t);
    if (n.pageX < s.left || n.pageY < s.top)
      return !1;
    var l = PQ(e, t);
    return n.pageX > s.left + l.width || n.pageY > s.top + l.height || r.length && r.closest(t).length || e.checkDropTarget && !e.checkDropTarget(t, n) ? !1 : t;
  },
  _end: function(e) {
    var t = Z_(e);
    this._fireEvent(Ug, e, {
      offset: this._calculateOffset(t)
    }), this._fireDropTargetEvent(e, WM), delete this._currentDropTarget;
  }
});
jM({
  emitter: IQ,
  events: [Hg, Gg, Ug]
});
var eC = Math.min, JO = Math.max, HF = 2, h3 = function(e, t) {
  this._translator = new PE({}, {}, {}), this._scroll = e.rect().append(t), this._addEvents();
};
function NQ(e, t, r, n) {
  var i = 0;
  return t === "right" ? i = e.width - e.right + r : t === "left" && (i = e.left - r - n), i;
}
function VQ(e, t, r, n) {
  var i = 0;
  return t === "top" ? i = e.top - r : t === "bottom" && (i = e.height - e.bottom + n + r), i;
}
h3.prototype = {
  _addEvents: function() {
    var e = this._scroll.element;
    Ve.on(e, Hg, (t) => {
      Ku({
        type: "dxc-scroll-start",
        originalEvent: t,
        target: e
      });
    }), Ve.on(e, Gg, (t) => {
      var r = -t.offset.x * this._scale, n = -t.offset.y * this._scale, i = this._offset - (this._layoutOptions.vertical ? n : r) / this._scale;
      this._applyPosition(i, i + this._translator.canvasLength / this._scale), Ku({
        type: "dxc-scroll-move",
        originalEvent: t,
        target: e,
        offset: {
          x: r,
          y: n
        }
      });
    }), Ve.on(e, Ug, (t) => {
      Ku({
        type: "dxc-scroll-end",
        originalEvent: t,
        target: e,
        offset: {
          x: -t.offset.x * this._scale,
          y: -t.offset.y * this._scale
        }
      });
    });
  },
  update: function(e) {
    var t = e.position, r = e.rotated, n = r ? "right" : "top", i = r ? "left" : "bottom";
    return t !== n && t !== i && (t = n), this._scroll.attr({
      rotate: e.rotated ? 0 : -90,
      rotateX: 0,
      rotateY: 0,
      fill: e.color,
      width: e.width,
      opacity: e.opacity
    }), this._layoutOptions = {
      width: e.width,
      offset: e.offset,
      vertical: r,
      position: t
    }, this;
  },
  init: function(e, t) {
    var r = e.axisType === "discrete";
    return this._translateWithOffset = r && !t ? 1 : 0, this._translator.update(W({}, e, {
      minVisible: null,
      maxVisible: null,
      visibleCategories: null
    }, r && {
      min: null,
      max: null
    } || {}), this._canvas, {
      isHorizontal: !this._layoutOptions.vertical,
      stick: t
    }), this;
  },
  getOptions: function() {
    return this._layoutOptions;
  },
  setPane: function(e) {
    var t = this._layoutOptions.position, r;
    return t === "left" || t === "top" ? r = e[0] : r = e[e.length - 1], this.pane = r.name, this;
  },
  updateSize: function(e) {
    this._canvas = W({}, e);
    var t = this._layoutOptions, r = t.position, n = t.offset, i = t.width;
    this._scroll.attr({
      translateX: NQ(e, r, n, i),
      translateY: VQ(e, r, n, i)
    });
  },
  getMultipleAxesSpacing: function() {
    return 0;
  },
  estimateMargins: function() {
    return this.getMargins();
  },
  getMargins: function() {
    var e = this._layoutOptions, t = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return t[e.position] = e.width + e.offset, t;
  },
  shift: function(e) {
    var t, r, n = this._layoutOptions, i = n.position, s = n.vertical, l = {
      translateX: (t = this._scroll.attr("translateX")) !== null && t !== void 0 ? t : 0,
      translateY: (r = this._scroll.attr("translateY")) !== null && r !== void 0 ? r : 0
    }, d = e[i];
    l[s ? "translateX" : "translateY"] += (i === "left" || i === "top" ? -1 : 1) * d, this._scroll.attr(l);
  },
  hideTitle: Y,
  hideOuterElements: Y,
  setPosition: function(e, t) {
    var r = this._translator, n = I(e) ? r.translate(e, -this._translateWithOffset) : r.translate("canvas_position_start"), i = I(t) ? r.translate(t, this._translateWithOffset) : r.translate("canvas_position_end");
    this._offset = eC(n, i), this._scale = r.getScale(e, t), this._applyPosition(eC(n, i), JO(n, i));
  },
  customPositionIsAvailable: () => !1,
  dispose: function() {
    this._scroll.dispose(), this._scroll = this._translator = null;
  },
  _applyPosition: function(e, t) {
    var r = this._translator.getCanvasVisibleArea();
    e = JO(e, r.min), e = eC(e, r.max), t = eC(t, r.max), t = JO(t, r.min);
    var n = Math.abs(t - e);
    this._scroll.attr({
      y: e,
      height: n < HF ? HF : n
    });
  }
};
var my = ".shutter-zoom", FQ = Hg + my, BQ = Gg + my, zQ = Ug + my;
function v3(e, t, r, n) {
  var i = Math.floor(r ? n.pageY - e.top : n.pageX - e.left), s = r ? t.y1 : t.x1, l = r ? t.y2 : t.x2;
  return i < s ? i = s : i > l && (i = l), i;
}
function HQ(e, t, r) {
  var n = r.pageX - e.left, i = r.pageY - e.top;
  return n >= t.x1 && n <= t.x2 && i >= t.y1 && i <= t.y2;
}
function GQ(e) {
  return function(t) {
    var r = e.getRootOffset(), n = e.getCanvas();
    if (!HQ(r, n, t)) {
      t.cancel = !0;
      return;
    }
    e.rootOffset = r, e.canvas = n, e.startCoord = v3(r, n, e.rotated, t), e.triggerStart(), e.rect.attr({
      x: n.x1,
      y: n.y1,
      width: n.width,
      height: n.height
    }).append(e.root);
  };
}
function UQ(e) {
  return function(t) {
    var r = v3(e.rootOffset, e.canvas, e.rotated, t), n = {};
    e.curCoord = r, n[e.rotated ? "y" : "x"] = Math.min(e.startCoord, r), n[e.rotated ? "height" : "width"] = Math.abs(e.startCoord - r), e.rect.attr(n);
  };
}
function jQ(e) {
  return function(t) {
    e.triggerEnd(), e.rect.remove();
  };
}
function $Q(e) {
  var t = e.chart, r = e.renderer, n = e.rotated, i = r.rect(0, 0, 0, 0).attr(e.shutterOptions), s = {
    rect: i,
    root: r.root,
    rotated: n,
    triggerStart: function() {
      t._eventTrigger("zoomStart");
    },
    triggerEnd: function() {
      var l = t._argumentAxes[0].getTranslator(), d = Math.min(this.startCoord, this.curCoord), h = Math.max(this.startCoord, this.curCoord);
      t._eventTrigger("zoomEnd", {
        rangeStart: l.from(d),
        rangeEnd: l.from(h)
      });
    },
    dispose: function() {
      r.root.off(my), i.dispose();
    },
    getRootOffset: function() {
      return r.getRootOffset();
    },
    getCanvas: function() {
      var l = t._canvas, d = t.panes, h = d[0].canvas, p = d[d.length - 1].canvas;
      return {
        x1: h.left,
        y1: h.top,
        x2: l.width - p.right,
        y2: l.height - p.bottom,
        width: l.width - h.left - p.right,
        height: l.height - h.top - p.bottom
      };
    }
  };
  return r.root.off(my).on(FQ, {
    direction: n ? "vertical" : "horizontal",
    immediate: !0
  }, GQ(s)).on(BQ, UQ(s)).on(zQ, jQ(s)), s;
}
const YQ = {
  name: "shutter_zoom",
  init: function() {
    var e = this.option("shutterZoom") || {};
    e.enabled && (this._shutterZoom = $Q({
      chart: this,
      renderer: this._renderer,
      rotated: this.option("rotated"),
      shutterOptions: e
    }));
  },
  dispose: function() {
    this._shutterZoom && this._shutterZoom.dispose();
  }
};
var qM = "dx", WQ = "transform", XQ = "translate", qQ = "pinch", KQ = "rotate", p3 = "start", g3 = "", m3 = "end", KM = [], RT = function(e, t) {
  KM.push({
    name: e,
    args: t
  });
};
RT(WQ, {
  scale: !0,
  deltaScale: !0,
  rotation: !0,
  deltaRotation: !0,
  translation: !0,
  deltaTranslation: !0
});
RT(XQ, {
  translation: !0,
  deltaTranslation: !0
});
RT(qQ, {
  scale: !0,
  deltaScale: !0
});
RT(KQ, {
  rotation: !0,
  deltaRotation: !0
});
var ZQ = function(e, t) {
  return {
    x: t.pageX - e.pageX,
    y: -t.pageY + e.pageY,
    centerX: 0.5 * (t.pageX + e.pageX),
    centerY: 0.5 * (t.pageY + e.pageY)
  };
}, GF = function(e) {
  var t = e.pointers;
  return ZQ(t[0], t[1]);
}, NE = function(e) {
  return Math.sqrt(e.x * e.x + e.y * e.y);
}, UF = function(e, t) {
  return NE(e) / NE(t);
}, jF = function(e, t) {
  var r = e.x * t.x + e.y * t.y, n = NE(e) * NE(t);
  if (n === 0)
    return 0;
  var i = Hd(e.x * t.y - t.x * e.y), s = Math.acos(mG(r / n, -1, 1));
  return i * s;
}, $F = function(e, t) {
  return {
    x: e.centerX - t.centerX,
    y: e.centerY - t.centerY
  };
}, QQ = BM.inherit({
  validatePointers: function(e) {
    return e3(e) > 1;
  },
  start: function(e) {
    this._accept(e);
    var t = GF(e);
    this._startVector = t, this._prevVector = t, this._fireEventAliases(p3, e);
  },
  move: function(e) {
    var t = GF(e), r = this._getEventArgs(t);
    this._fireEventAliases(g3, e, r), this._prevVector = t;
  },
  end: function(e) {
    var t = this._getEventArgs(this._prevVector);
    this._fireEventAliases(m3, e, t);
  },
  _getEventArgs: function(e) {
    return {
      scale: UF(e, this._startVector),
      deltaScale: UF(e, this._prevVector),
      rotation: jF(e, this._startVector),
      deltaRotation: jF(e, this._prevVector),
      translation: $F(e, this._startVector),
      deltaTranslation: $F(e, this._prevVector)
    };
  },
  _fireEventAliases: function(e, t, r) {
    r = r || {}, be(KM, (function(n, i) {
      var s = {};
      be(i.args, function(l) {
        l in r && (s[l] = r[l]);
      }), this._fireEvent(qM + i.name + e, t, s);
    }).bind(this));
  }
}), _3 = KM.reduce((e, t) => ([p3, g3, m3].forEach((r) => {
  e.push(qM + t.name + r);
}), e), []);
jM({
  emitter: QQ,
  events: _3
});
var y3 = {};
be(_3, function(e, t) {
  y3[t.substring(qM.length)] = t;
});
var {
  transformstart: cve,
  transform: dve,
  transformend: fve,
  translatestart: hve,
  translate: vve,
  translateend: pve,
  zoomstart: gve,
  zoom: mve,
  zoomend: _ve,
  pinchstart: JQ,
  pinch: eJ,
  pinchend: tJ,
  rotatestart: yve,
  rotate: xve,
  rotateend: bve
} = y3, Ns = ".zoomAndPanNS", rJ = Hg + Ns, nJ = Gg + Ns, iJ = Ug + Ns, aJ = JQ + Ns, oJ = eJ + Ns, sJ = tJ + Ns, YF = "dxc-scroll-start" + Ns, lJ = "dxc-scroll-move" + Ns, uJ = "dxc-scroll-end" + Ns, cJ = 300, ek = 5, zp = Math.min, WF = Math.max, S_ = Math.abs;
function Hp(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width - e.left - e.right,
    height: e.height - e.top - e.bottom
  };
}
function C_(e, t) {
  var r = t.x, n = t.y;
  return r >= e.x && r <= e.width + e.x && n >= e.y && n <= e.height + e.y;
}
function dJ(e, t) {
  return t && (e = e.sort((r, n) => r === t ? -1 : n === t ? 1 : 0)), e;
}
function H_(e) {
  return e.filter((t) => !t.getTranslator().getBusinessRange().isEmpty());
}
function tk(e) {
  return e.some((t) => !t.isExtremePosition(!1) || !t.isExtremePosition(!0));
}
function x3(e, t, r, n, i, s, l) {
  var d = t && e !== t, h = r(e), {
    stopInteraction: p,
    correctedRange: m
  } = e.checkZoomingLowerLimitOvercome(i, s, h), x = e.handleZooming(p ? null : m, n(d), l, i);
  return p && e.handleZoomEnd(), {
    stopInteraction: p,
    result: x
  };
}
function tC(e, t, r, n, i, s) {
  t = dJ(t, s);
  var l = !1, d = (h) => ({
    start: !!h,
    end: !!h
  });
  return H_(t).some((h) => {
    var p = h.getTranslator(), m = p.getMinScale(n), {
      stopInteraction: x,
      result: S
    } = x3(h, s, r(ei({
      scale: m,
      translator: p,
      axis: h
    }, i)), d, "zoom", m, e);
    return l = !x, s && S.isPrevented;
  }), l;
}
function rE(e) {
  e.originalEvent && rE(e.originalEvent), e.cancelable !== !1 && (e.cancel = !0);
}
const fJ = {
  name: "zoom_and_pan",
  init: function() {
    var e = this, t = this._renderer;
    function r(T, k) {
      var O = [], D = T.options, L = T.actionData;
      return D.argumentAxis[k] && O.push(e.getArgumentAxis()), D.valueAxis[k] && (O = O.concat(L.valueAxes)), O;
    }
    function n(T, k, O) {
      var D = r(T, k);
      H_(D).some((L) => L.handleZooming(null, {
        end: !0
      }, O, k).isPrevented) && rE(O);
    }
    function i(T, k, O, D, L) {
      function F(de, Re, Ce, le, me) {
        var fe = {
          zoomed: !1
        };
        return Re && H_(de).forEach((Ee) => {
          var Q = Ee.getOptions(), pe = Ee.visualRange(), G = Ee.getTranslator().getEventScale(le), se = -D(le, me, Ce, G);
          fe = W(!0, fe, Ee.getTranslator().zoom(se, G, Ee.getZoomBounds()));
          var Te = Ee.adjustRange(bd([fe.min, fe.max])), {
            stopInteraction: Pe,
            correctedRange: Ie
          } = Ee.checkZoomingLowerLimitOvercome(k, G, Te);
          if (!I(pe) || pe.startValue.valueOf() !== Ie.startValue.valueOf() || pe.endValue.valueOf() !== Ie.endValue.valueOf())
            Ee.handleZooming(Pe ? null : Ie, {
              start: !0,
              end: !0
            }, le, k), Pe || (fe.zoomed = !0, fe.deltaTranslate = se - fe.translate);
          else if (le.pointerType === "touch" && Q.type === "discrete") {
            var He = Ee.isExtremePosition(!1), Ue = Ee.isExtremePosition(!0), Ze = G > 1 && !Pe, Qe = G < 1 && (!He || !Ue), it = G === 1 && !(He && (se < 0 && !Q.inverted || se > 0 && Q.inverted) || Ue && (se > 0 && !Q.inverted || se < 0 && Q.inverted));
            fe.enabled = Ze || Qe || it;
          }
        }), fe;
      }
      function z(de, Re, Ce, le) {
        Ce.zoomed && (Re.offset[le] = (de.offset ? de.offset[le] : Re.offset[le]) + Ce.deltaTranslate);
      }
      function V(de, Re, Ce, le) {
        Ce.zoomed && (Re.center[le] = de[le] + Ce.deltaTranslate);
      }
      var P = e.option("rotated"), j = T.actionData, Z = T.options, ee = {}, J = {};
      j.fallback || (ee = F(e._argumentAxes, Z.argumentAxis[k], P ? "y" : "x", O, j), J = F(j.valueAxes, Z.valueAxis[k], P ? "x" : "y", O, j), e._requestChange(["VISUAL_RANGE"]), z(O, j, ee, P ? "y" : "x"), z(O, j, J, P ? "x" : "y"));
      var he = L(O);
      return V(he, j, ee, P ? "y" : "x"), V(he, j, J, P ? "x" : "y"), !ee.zoomed && !J.zoomed && (j.center = he), ee.zoomed || J.zoomed || j.fallback || ee.enabled || J.enabled;
    }
    function s(T, k, O, D) {
      function L(Z, ee, J, he) {
        var de = !1, Re = O.scale || 1, Ce = (me) => {
          var fe = me.getTranslator().zoom(-D(O, J, ee, Re), Re, me.getZoomBounds());
          return {
            startValue: fe.min,
            endValue: fe.max
          };
        }, le = (me) => ({
          start: !0,
          end: me
        });
        return H_(Z).forEach((me) => {
          de = !x3(me, he, Ce, le, k, Re, O).stopInteraction;
        }), de;
      }
      var F = e.option("rotated"), z = T.actionData, V = T.options, P = !0;
      if (z.fallback)
        P &= V.argumentAxis[k] && L(e._argumentAxes, F ? "y" : "x", z, e.getArgumentAxis()), P |= V.valueAxis[k] && L(z.valueAxes, F ? "x" : "y", z);
      else {
        var j = r(T, k);
        H_(j).forEach((Z) => {
          Z.handleZooming(null, {
            start: !0
          }, O, k);
        }), P = j.length;
      }
      P && e._requestChange(["VISUAL_RANGE"]);
    }
    function l(T, k) {
      var O = e._argumentAxes.filter((D) => C_(Hp(D.getCanvas()), T));
      return {
        fallback: e._lastRenderingTime > cJ,
        cancel: !O.length || !I(k),
        action: k,
        curAxisRect: O.length && Hp(O[0].getCanvas()),
        valueAxes: O.length && e._valueAxes.filter((D) => C_(Hp(D.getCanvas()), T)),
        offset: {
          x: 0,
          y: 0
        },
        center: T,
        startCenter: T
      };
    }
    function d(T, k) {
      var O = t.getRootOffset();
      return {
        x: zp(WF(k.pageX - O.left, T.x), T.width + T.x),
        y: zp(WF(k.pageY - O.top, T.y), T.height + T.y)
      };
    }
    function h(T) {
      var k = t.getRootOffset(), O = T.pointers[0].pageX, D = T.pointers[1].pageX, L = T.pointers[0].pageY, F = T.pointers[1].pageY;
      return {
        x: zp(O, D) + S_(D - O) / 2 - k.left,
        y: zp(L, F) + S_(F - L) / 2 - k.top
      };
    }
    function p(T) {
      var k = t.getRootOffset();
      return {
        x: T.pageX - k.left,
        y: T.pageY - k.top
      };
    }
    function m(T, k, O) {
      return T.offset[O] - k.offset[O];
    }
    function x(T) {
      T.cancelable !== !1 && (T.preventDefault(), T.stopPropagation()), e._stopCurrentHandling();
    }
    var S = {
      dragStartHandler: function(T) {
        var k = S.options, O = T.pointerType === "touch", D = k.argumentAxis.pan || k.valueAxis.pan, L = k.argumentAxis.zoom || k.valueAxis.zoom, F = I(k.panKey) && T[Wt(k.panKey) + "Key"], z = k.dragToZoom, V;
        if (T._cancelPreventDefault = !0, O) {
          if (k.allowTouchGestures && D) {
            var P = !S.panningVisualRangeEnabled() || S.skipEvent;
            V = P ? null : "pan";
          }
        } else
          z && D && F || !z && D ? V = "pan" : z && L && (V = "zoom");
        var j = l(p(T), V);
        if (j.cancel) {
          S.skipEvent = !1, T.cancelable !== !1 && (T.cancel = !0);
          return;
        }
        S.actionData = j, V === "zoom" ? (j.startCoords = d(j.curAxisRect, T), j.rect = t.rect(0, 0, 0, 0).attr(k.dragBoxStyle).append(t.root)) : n(S, "pan", T);
      },
      dragHandler: function(T) {
        var k = e.option("rotated"), O = S.options, D = S.actionData, L = T.pointerType === "touch";
        if (T._cancelPreventDefault = !0, !(!D || L && !S.panningVisualRangeEnabled())) {
          if (D.action === "zoom") {
            x(T);
            var F = D.curAxisRect, z = D.startCoords, V = d(F, T), P = O.argumentAxis.zoom, j = O.valueAxis.zoom, Z = {
              x: zp(z.x, V.x),
              y: zp(z.y, V.y),
              width: S_(z.x - V.x),
              height: S_(z.y - V.y)
            };
            (!P || !j) && (!P && !k || !j && k ? (Z.x = F.x, Z.width = F.width) : (Z.y = F.y, Z.height = F.height)), D.rect.attr(Z);
          } else if (D.action === "pan") {
            i(S, "pan", T, m, (he) => he.offset);
            var ee = Math.abs(T.offset.y - D.offset.y), J = Math.abs(T.offset.x - D.offset.x);
            if (L && (ee > ek && ee > Math.abs(D.offset.x) || J > ek && J > Math.abs(D.offset.y)))
              return;
            x(T);
          }
        }
      },
      dragEndHandler: function(T) {
        var k = e.option("rotated"), O = S.options, D = S.actionData, L = T.pointerType === "touch", F = (de) => {
          var {
            translator: Re,
            startCoord: Ce,
            curCoord: le
          } = de;
          return () => [Re.from(Ce), Re.from(le)];
        }, z = (de, Re, Ce) => ({
          curCoord: de[Ce],
          startCoord: Re[Ce]
        }), V = (de, Re) => de.zoom && S_(Re.curCoord - Re.startCoord) > ek, P = D && D.action === "pan" && !D.fallback && D.offset.x === 0 && D.offset.y === 0;
        if (!(!D || L && !S.panningVisualRangeEnabled() || P)) {
          if (!L && x(T), D.action === "zoom") {
            var j = d(D.curAxisRect, T), Z = z(j, D.startCoords, k ? "y" : "x"), ee = z(j, D.startCoords, k ? "x" : "y"), J = V(O.argumentAxis, Z) && tC(T, e._argumentAxes, F, !0, Z, e.getArgumentAxis()), he = V(O.valueAxis, ee) && tC(T, D.valueAxes, F, !0, ee);
            (he || J) && e._requestChange(["VISUAL_RANGE"]), D.rect.dispose();
          } else
            D.action === "pan" && s(S, "pan", T, m);
          S.actionData = null;
        }
      },
      pinchStartHandler: function(T) {
        var k = l(h(T), "zoom");
        if (k.cancel) {
          rE(T);
          return;
        }
        S.actionData = k, n(S, "zoom", T);
      },
      pinchHandler: function(T) {
        S.actionData && (i(S, "zoom", T, (k, O, D, L) => h(k)[D] - O.center[D] + (O.center[D] - O.center[D] * L), h), x(T));
      },
      pinchEndHandler: function(T) {
        S.actionData && (s(S, "zoom", T, (k, O, D, L) => O.center[D] - O.startCenter[D] + (O.startCenter[D] - O.startCenter[D] * L)), S.actionData = null);
      },
      mouseWheelHandler: function(T) {
        var k = S.options, O = e.option("rotated"), D = (j) => {
          var {
            translator: Z,
            coord: ee,
            scale: J,
            axis: he
          } = j;
          return () => {
            var de = Z.zoom(-(ee - ee * J), J, he.getZoomBounds());
            return {
              startValue: de.min,
              endValue: de.max
            };
          };
        }, L = p(T), F = !1, z;
        if (k.valueAxis.zoom) {
          if (z = e._valueAxes.filter((j) => C_(Hp(j.getCanvas()), L)), z.length === 0) {
            var V = e._valueAxes.reduce((j, Z) => (!j && Z.coordsIn(L.x, L.y) && (j = Z.getCanvas()), j), null);
            V && (z = e._valueAxes.filter((j) => C_(Hp(j.getCanvas()), {
              x: V.left,
              y: V.top
            })));
          }
          F |= tC(T, z, D, T.delta > 0, {
            coord: O ? L.x : L.y
          });
        }
        if (k.argumentAxis.zoom) {
          var P = e._argumentAxes.some((j) => !!(C_(Hp(j.getCanvas()), L) || j.coordsIn(L.x, L.y)));
          F |= P && tC(T, e._argumentAxes, D, T.delta > 0, {
            coord: O ? L.y : L.x
          }, e.getArgumentAxis());
        }
        F && (e._requestChange(["VISUAL_RANGE"]), (z && tk(z) || !z && S.panningVisualRangeEnabled()) && x(T));
      },
      cleanup: function() {
        t.root.off(Ns), S.actionData && S.actionData.rect && S.actionData.rect.dispose(), S.actionData = null, t.root.css({
          "touch-action": ""
        });
      },
      setup: function(T) {
        S.cleanup(), T.argumentAxis.pan || t.root.on(YF, rE), !(T.argumentAxis.none && T.valueAxis.none) && (S.options = T, (T.argumentAxis.zoom || T.valueAxis.zoom) && T.allowMouseWheel && t.root.on(kT + Ns, S.mouseWheelHandler), (T.argumentAxis.zoom || T.valueAxis.zoom) && T.allowTouchGestures && t.root.on(aJ, {
          passive: !1
        }, S.pinchStartHandler).on(oJ, {
          passive: !1
        }, S.pinchHandler).on(sJ, S.pinchEndHandler), t.root.on(rJ, {
          immediate: !0,
          passive: !1
        }, S.dragStartHandler).on(nJ, {
          immediate: !0,
          passive: !1
        }, S.dragHandler).on(iJ, S.dragEndHandler), t.root.on(YF, function(k) {
          S.actionData = {
            valueAxes: [],
            offset: {
              x: 0,
              y: 0
            },
            center: {
              x: 0,
              y: 0
            }
          }, x(k), n(S, "pan", k);
        }).on(lJ, function(k) {
          x(k), i(S, "pan", k, m, (O) => O.offset);
        }).on(uJ, function(k) {
          x(k), s(S, "pan", k, m), S.actionData = null;
        }));
      },
      panningVisualRangeEnabled: function() {
        return tk(e._valueAxes) || tk(e._argumentAxes);
      }
    };
    this._zoomAndPan = S;
  },
  members: {
    _setupZoomAndPan: function() {
      this._zoomAndPan.setup(this._themeManager.getOptions("zoomAndPan"));
    }
  },
  dispose: function() {
    this._zoomAndPan.cleanup();
  },
  customize: function(e) {
    e.addChange({
      code: "ZOOM_AND_PAN",
      handler: function() {
        this._setupZoomAndPan();
      },
      isThemeDependent: !0,
      isOptionChange: !0,
      option: "zoomAndPan"
    });
  }
};
var hJ = jr();
function vJ(e, t) {
  var r = we.createElement("div"), n = e.cloneNode(!0);
  return t && je(n).css("backgroundColor", t), r.appendChild(n), r.innerHTML;
}
function pJ(e) {
  var t = !0;
  return e.indexOf("xmlns:xlink") === -1 && (e = e.replace("<svg", '<svg xmlns:xlink="http://www.w3.org/1999/xlink"')), e = e.replace(/xmlns="[\s\S]*?"/gi, function(r) {
    return t ? (t = !1, r) : "";
  }), e.replace(/xmlns:NS1="[\s\S]*?"/gi, "").replace(/NS1:xmlns:xlink="([\s\S]*?)"/gi, 'xmlns:xlink="$1"');
}
function gJ(e) {
  return e.replace(/&quot;/gi, "&#34;").replace(/&amp;/gi, "&#38;").replace(/&apos;/gi, "&#39;").replace(/&lt;/gi, "&#60;").replace(/&gt;/gi, "&#62;").replace(/&nbsp;/gi, "&#160;").replace(/&shy;/gi, "&#173;");
}
var ZM = "hidden-for-export";
function b3(e, t) {
  return pJ(gJ(vJ(e, t)));
}
function S3(e) {
  return we.isNode(e) ? e : new hJ.DOMParser().parseFromString(e, "image/svg+xml").childNodes[0];
}
var No = fn() ? jr() : {}, mJ = 1e3 / 60, C3 = function(e) {
  return setTimeout(e, mJ);
}, E3 = function(e) {
  clearTimeout(e);
}, T3 = zl(function() {
  var e = No.requestAnimationFrame || No.webkitRequestAnimationFrame || No.mozRequestAnimationFrame || No.oRequestAnimationFrame || No.msRequestAnimationFrame, t = No.cancelAnimationFrame || No.webkitCancelAnimationFrame || No.mozCancelAnimationFrame || No.oCancelAnimationFrame || No.msCancelAnimationFrame;
  e && t && (C3 = e, E3 = t);
});
function w3() {
  return T3(), C3.apply(No, arguments);
}
function _J() {
  T3(), E3.apply(No, arguments);
}
var A3 = function() {
}, XF = {
  easeOutCubic: function(e, t, r) {
    return e === 1 ? r : (1 - Math.pow(1 - e, 3)) * (r - t) + +t;
  },
  linear: function(e, t, r) {
    return e === 1 ? r : e * (r - t) + +t;
  }
}, yJ = {
  segments: function(e, t, r, n, i) {
    var s = t.from, l = t.to, d, h, p, m, x = [];
    for (p = 0; p < s.length; p++) {
      if (d = s[p], h = [d[0]], d.length > 1)
        for (m = 1; m < d.length; m++)
          h.push(n(r, d[m], l[p][m]));
      x.push(h);
    }
    i.segments = t.end && r === 1 ? t.end : x, e.attr({
      segments: x
    });
  },
  arc: function(e, t, r, n) {
    var i = t.from, s = t.to, l = {};
    for (var d in i)
      l[d] = n(r, i[d], s[d]);
    e.attr(l);
  },
  transform: function(e, t, r, n, i) {
    var s = t.from, l = t.to, d = {};
    for (var h in s)
      d[h] = i[h] = n(r, s[h], l[h]);
    e.attr(d);
  },
  base: function(e, t, r, n, i, s) {
    var l = {};
    l[s] = i[s] = n(r, t.from, t.to), e.attr(l);
  },
  _: A3,
  complete: function(e, t) {
    e.attr(t);
  }
};
function O3(e) {
  var t = this._animateStep, r;
  this._progress = this._calcProgress(e);
  for (r in this.params) {
    var n = t[r] || t.base;
    n(this.element, this.params[r], this._progress, this._easing, this._currentParams, r);
  }
  return this.options.step && this.options.step(this._easing(this._progress, 0, 1), this._progress), this._progress === 1 ? this.stop() : !0;
}
function xJ(e) {
  return e - this._startTime >= this.delay && (this.tick = O3), !0;
}
function bJ(e) {
  return this._startTime = e, this.tick = this.delay ? xJ : O3, !0;
}
function k3(e, t, r) {
  this._progress = 0, this.element = e, this.params = t, this.options = r, this.duration = r.partitionDuration ? r.duration * r.partitionDuration : r.duration, this.delay = r.delay && r.duration * r.delay || 0, this._animateStep = r.animateStep || yJ, this._easing = XF[r.easing] || XF.easeOutCubic, this._currentParams = {}, this.tick = bJ;
}
k3.prototype = {
  _calcProgress: function(e) {
    return Math.min(1, (e - this.delay - this._startTime) / this.duration);
  },
  stop: function(e) {
    var t = this.options, r = this._animateStep;
    this.stop = this.tick = A3, r.complete && r.complete(this.element, this._currentParams), t.complete && !e && t.complete();
  }
};
function R3(e) {
  this._animationCount = 0, this._timerId = null, this._animations = {}, this.element = e;
}
R3.prototype = {
  _loop: function() {
    var e = this, t = e._animations, r = 0, n = (/* @__PURE__ */ new Date()).getTime(), i, s = e._endAnimation;
    for (i in t)
      t[i].tick(n) || delete t[i], r++;
    if (r === 0) {
      e.stop(), e._endAnimationTimer = s && setTimeout(function() {
        e._animationCount === 0 && (s(), e._endAnimation = null);
      });
      return;
    }
    e._timerId = w3.call(null, function() {
      e._loop();
    }, e.element);
  },
  addAnimation: function(e) {
    var t = this;
    t._animations[t._animationCount++] = e, clearTimeout(t._endAnimationTimer), t._timerId || (clearTimeout(t._startDelay), t._startDelay = setTimeout(function() {
      t._timerId = 1, t._loop();
    }, 0));
  },
  animateElement: function(e, t, r) {
    e && t && r && (e.animation && e.animation.stop(), this.addAnimation(e.animation = new k3(e, t, r)));
  },
  onEndAnimation: function(e) {
    this._animationCount ? this._endAnimation = e : e();
  },
  dispose: function() {
    this.stop(), this.element = null;
  },
  stop: function() {
    this._animations = {}, this._animationCount = 0, _J(this._timerId), clearTimeout(this._startDelay), clearTimeout(this._endAnimationTimer), this._timerId = null;
  },
  lock: function() {
    var e, t = this._animations, r, n;
    for (e in t)
      r = t[e].options.unstoppable, n = n || r, r || (t[e].stop(!0), delete t[e]);
    !n && this.stop();
  }
};
var SJ = jr(), {
  max: CJ,
  round: EJ
} = Math, qF = 0.5, Cs = 5, TJ = "@filter::lightening", wJ = {
  "column-count": !0,
  "fill-opacity": !0,
  "flex-grow": !0,
  "flex-shrink": !0,
  "font-weight": !0,
  "line-height": !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  widows: !0,
  "z-index": !0,
  zoom: !0
}, E_ = "text", Hu = "stroke", ma = "stroke-width", pg = "stroke-opacity", _y = "font-size", KF = "font-style", ZF = "font-weight", QF = "text-decoration", rk = "textsAlignment", mh = "none", aD = 12, yy = "...", DT = /* @__PURE__ */ function() {
  return Object.create ? function(e) {
    return Object.create(e);
  } : function(e) {
    var t = function() {
    };
    return t.prototype = e, new t();
  };
}(), JF = {
  scaleX: 1,
  scaleY: 1,
  "pointer-events": null
}, _h = zl(function() {
  var e = we.createElement("div");
  return e.style.left = "-9999px", e.style.position = "absolute", {
    backupContainer: e,
    backupCounter: 0
  };
});
function AJ(e) {
  _h().backupCounter === 0 && we.getBody().appendChild(_h().backupContainer), ++_h().backupCounter, e.append({
    element: _h().backupContainer
  });
}
function OJ(e, t) {
  e.append({
    element: t
  }), --_h().backupCounter, _h().backupCounter === 0 && we.getBody().removeChild(_h().backupContainer);
}
function Vy(e) {
  return e && typeof e != "string";
}
function QM(e) {
  return we.createElementNS("http://www.w3.org/2000/svg", e);
}
function JM(e, t) {
  return e !== null ? "url(" + (t ? SJ.location.href.split("#")[0] : "") + "#" + e + ")" : e;
}
function ki(e, t) {
  var r;
  for (r in t)
    e[r] = t[r];
  return e;
}
var kJ = {
  full: mh,
  lefttop: "xMinYMin",
  leftcenter: "xMinYMid",
  leftbottom: "xMinYMax",
  centertop: "xMidYMin",
  center: "xMidYMid",
  centerbottom: "xMidYMax",
  righttop: "xMaxYMin",
  rightcenter: "xMaxYMid",
  rightbottom: "xMaxYMax"
};
function D3(e, t) {
  return t.hatching && Wt(t.hatching.direction) !== "none" ? (t = ki({}, t), t.fill = e._hatching = e.renderer.lockDefsElements({
    color: t.fill,
    hatching: t.hatching
  }, e._hatching, "pattern"), delete t.filter) : e._hatching ? (e.renderer.releaseDefsElements(e._hatching), e._hatching = null, delete t.filter) : t.filter ? (t = ki({}, t), t.filter = e._filter = e.renderer.lockDefsElements({}, e._filter, "filter")) : e._filter && (e.renderer.releaseDefsElements(e._filter), e._filter = null), delete t.hatching, t;
}
var RJ = function(e, t, r, n, i, s, l, d, h, p) {
  return ["M", (e + n * i).toFixed(Cs), (t - n * s).toFixed(Cs), "A", n.toFixed(Cs), n.toFixed(Cs), 0, p, 0, (e + n * l).toFixed(Cs), (t - n * d).toFixed(Cs), h ? "M" : "L", (e + r * l).toFixed(5), (t - r * d).toFixed(Cs), "A", r.toFixed(Cs), r.toFixed(Cs), 0, p, 1, (e + r * i).toFixed(Cs), (t - r * s).toFixed(Cs), "Z"].join(" ");
};
function M3(e, t) {
  var r = [
    ["M", 0, 0]
  ];
  switch (t) {
    case "line":
      r = eB(e);
      break;
    case "area":
      r = eB(e, !0);
      break;
    case "bezier":
      r = tB(e);
      break;
    case "bezierarea":
      r = tB(e, !0);
  }
  return r;
}
function eB(e, t) {
  return L3(e, DJ, t);
}
function tB(e, t) {
  return L3(e, MJ, t);
}
function L3(e, t, r) {
  var n, i, s, l = [];
  if ((n = e[0]) !== null && n !== void 0 && n.length)
    for (i = 0, s = e.length; i < s; ++i)
      t(e[i], r, l);
  else
    t(e, r, l);
  return l;
}
function DJ(e, t, r) {
  var n = 0, i = r.length, s = i, l = (e || []).length;
  if (l) {
    if (e[0].x !== void 0)
      for (; n < l; )
        r[s++] = ["L", e[n].x, e[n++].y];
    else
      for (; n < l; )
        r[s++] = ["L", e[n++], e[n++]];
    r[i][0] = "M";
  } else
    r[s] = ["M", 0, 0];
  return t && r.push(["Z"]), r;
}
function MJ(e, t, r) {
  var n, i = r.length, s = (e || []).length;
  if (s)
    if (e[0].x !== void 0)
      for (r[i++] = ["M", e[0].x, e[0].y], n = 1; n < s; )
        r[i++] = ["C", e[n].x, e[n++].y, e[n].x, e[n++].y, e[n].x, e[n++].y];
    else
      for (r[i++] = ["M", e[0], e[1]], n = 2; n < s; )
        r[i++] = ["C", e[n++], e[n++], e[n++], e[n++], e[n++], e[n++]];
  else
    r[i] = ["M", 0, 0];
  return t && r.push(["Z"]), r;
}
function LJ(e) {
  var t = [], r = 0, n, i = e.length, s, l, d;
  for (n = 0; n < i; ++n)
    for (s = e[n], l = 0, d = s.length; l < d; ++l)
      t[r++] = s[l];
  return t.join(" ");
}
function PJ(e, t, r) {
  var n = e.length, i = t.length, s, l, d = r.indexOf("area") !== -1 ? NJ : IJ;
  if (n === 0)
    for (s = 0; s < i; s++)
      e.push(t[s].slice(0));
  else
    n < i ? d(e, t, r) : n > i && (l = t.slice(0), d(t, e, r));
  return l;
}
function oD(e, t) {
  var r = e[e.length - 2], n = e[e.length - 1];
  switch (t) {
    case "line":
    case "area":
      e[0] = "L";
      break;
    case "bezier":
    case "bezierarea":
      e[0] = "C", e[1] = e[3] = e[5] = r, e[2] = e[4] = e[6] = n;
  }
}
function IJ(e, t, r) {
  var n = e[e.length - 1].slice(), i = e.length;
  for (oD(n, r); i < t.length; i++)
    e[i] = n.slice(0);
}
function NJ(e, t, r) {
  var n, i, s = e.length, l = t.length, d, h;
  if ((s - 1) % 2 === 0 && (l - 1) % 2 === 0) {
    n = (s - 1) / 2 - 1, i = e.slice(0, n + 1), d = i[i.length - 1].slice(0), h = e.slice(n + 1)[0].slice(0), oD(d, r), oD(h, r);
    for (var p = n; p < (l - 1) / 2 - 1; p++)
      e.splice(p + 1, 0, d), e.splice(p + 3, 0, h);
  }
}
function eL(e, t) {
  var r = e._styles, n, i;
  t = t || {};
  for (n in t)
    i = t[n], I(i) && (i += typeof i == "number" && !wJ[n] ? "px" : "", r[n] = i !== "" ? i : null);
  for (n in r)
    i = r[n], i ? e.element.style[n] = i : i === null && (e.element.style[n] = "");
  return e;
}
function nk(e, t) {
  var r = e.element, n = e.attr(t);
  n && n.indexOf("DevExpress") !== -1 && (r.removeAttribute(t), r.setAttribute(t, JM(n, e.renderer.pathModified)));
}
function Mh(e, t) {
  t = t || {};
  var r = e._settings, n = {}, i, s, l = e.element, d = e.renderer, h = d.rtl, p, m, x, S;
  if (!Vy(t))
    return t in r ? r[t] : t in JF ? JF[t] : 0;
  ki(n, t);
  for (i in n)
    if (s = n[i], s !== void 0) {
      if (r[i] = s, i === "align")
        i = "text-anchor", s = {
          left: h ? "end" : "start",
          center: "middle",
          right: h ? "start" : "end"
        }[s] || null;
      else if (i === "dashStyle") {
        m = !0;
        continue;
      } else if (i === ma)
        m = !0;
      else if (s && (i === "fill" || i === "clip-path" || i === "filter") && s.indexOf("DevExpress") === 0)
        e._addFixIRICallback(), s = JM(s, d.pathModified);
      else if (/^(translate(X|Y)|rotate[XY]?|scale(X|Y)|sharp|sharpDirection)$/i.test(i)) {
        p = !0;
        continue;
      } else
        /^(x|y|d)$/i.test(i) && (p = !0);
      s === null ? l.removeAttribute(i) : l.setAttribute(i, s);
    }
  if (m && "dashStyle" in r)
    if (s = r.dashStyle, x = ("_originalSW" in e ? e._originalSW : r[ma]) || 1, i = "stroke-dasharray", s = s === null ? "" : Wt(s), s === "" || s === "solid" || s === mh)
      e.element.removeAttribute(i);
    else {
      for (s = s.replace(/longdash/g, "8,3,").replace(/dash/g, "4,3,").replace(/dot/g, "1,3,").replace(/,$/, "").split(","), S = s.length; S--; )
        s[S] = parseInt(s[S]) * x;
      e.element.setAttribute(i, s.join(","));
    }
  return p && e._applyTransformation(), e;
}
function VJ(e) {
  var t;
  return Vy(e) && (e = ki({}, e), t = e.segments, "points" in e && (t = M3(e.points, this.type), delete e.points), t && (e.d = LJ(t), this.segments = t, delete e.segments)), Mh(this, e);
}
function FJ(e) {
  var t = this._settings, r, n, i, s, l, d;
  return Vy(e) && (e = ki({}, e), ("x" in e || "y" in e || "innerRadius" in e || "outerRadius" in e || "startAngle" in e || "endAngle" in e) && (t.x = r = "x" in e ? e.x : t.x, delete e.x, t.y = n = "y" in e ? e.y : t.y, delete e.y, t.innerRadius = i = "innerRadius" in e ? e.innerRadius : t.innerRadius, delete e.innerRadius, t.outerRadius = s = "outerRadius" in e ? e.outerRadius : t.outerRadius, delete e.outerRadius, t.startAngle = l = "startAngle" in e ? e.startAngle : t.startAngle, delete e.startAngle, t.endAngle = d = "endAngle" in e ? e.endAngle : t.endAngle, delete e.endAngle, e.d = RJ.apply(null, HK(r, n, i, s, l, d)))), Mh(this, e);
}
function BJ(e) {
  var t, r, n, i, s, l, d;
  return Vy(e) && (e = ki({}, e), (e.x !== void 0 || e.y !== void 0 || e.width !== void 0 || e.height !== void 0 || e[ma] !== void 0) && (e.x !== void 0 ? t = this._originalX = e.x : t = this._originalX || 0, e.y !== void 0 ? r = this._originalY = e.y : r = this._originalY || 0, e.width !== void 0 ? n = this._originalWidth = e.width : n = this._originalWidth || 0, e.height !== void 0 ? i = this._originalHeight = e.height : i = this._originalHeight || 0, e[ma] !== void 0 ? s = this._originalSW = e[ma] : s = this._originalSW, l = ~~((n < i ? n : i) / 2), d = (s || 0) < l ? s || 0 : l, e.x = t + d / 2, e.y = r + d / 2, e.width = n - d, e.height = i - d, ((s || 0) !== d || !(d === 0 && s === void 0)) && (e[ma] = d)), "sharp" in e && delete e.sharp), Mh(this, e);
}
function zJ(e) {
  var t;
  if (!Vy(e))
    return Mh(this, e);
  e = ki({}, e);
  var r = this._settings, n = I(r[Hu]) && I(r[ma]);
  e[E_] !== void 0 && (r[E_] = e[E_], delete e[E_], t = !0), e[Hu] !== void 0 && (r[Hu] = e[Hu], delete e[Hu]), e[ma] !== void 0 && (r[ma] = e[ma], delete e[ma]), e[pg] !== void 0 && (r[pg] = e[pg], delete e[pg]), e[rk] !== void 0 && (ree(this, e[rk]), delete e[rk]);
  var i = I(r[Hu]) && I(r[ma]);
  return Mh(this, e), t = t || i !== n && r[E_], t && (tee(this, r.text, i), this._hasEllipsis = !1), (t || e.x !== void 0 || e.y !== void 0) && rL(this), i && nee(this), this;
}
function HJ(e) {
  return e = e || {}, eL(this, e), _y in e && rL(this), this;
}
function P3(e, t, r, n, i) {
  var s, l, d, h, p;
  if (r.wholeText !== void 0)
    e.push({
      value: r.wholeText,
      style: n,
      className: i,
      line: t,
      height: n[_y] || 0
    });
  else if (r.tagName === "BR")
    ++t;
  else if (we.isElementNode(r)) {
    switch (ki(s = {}, n), r.tagName) {
      case "B":
      case "STRONG":
        s[ZF] = "bold";
        break;
      case "I":
      case "EM":
        s[KF] = "italic";
        break;
      case "U":
        s[QF] = "underline";
    }
    for (l = r.style, l.color && (s.fill = l.color), l.fontSize && (s[_y] = l.fontSize), l.fontStyle && (s[KF] = l.fontStyle), l.fontWeight && (s[ZF] = l.fontWeight), l.textDecoration && (s[QF] = l.textDecoration), d = 0, p = r.childNodes, h = p.length; d < h; ++d)
      t = P3(e, t, p[d], s, r.className || i);
  }
  return t;
}
function GJ(e) {
  var t, r, n = e[0], i;
  for (t = 1, r = e.length; t < r; ++t)
    i = e[t], i.line === n.line ? (n.height = z3(n.height, i.height), n.inherits = n.inherits || parseFloat(i.height) === 0, i.height = NaN) : n = i;
}
function UJ(e) {
  var t = /(style|class)\s*=\s*(["'])(?:(?!\2).)*\2\s?/gi;
  return e.replace(/(?:(<[a-z0-9]+\s*))([\s\S]*?)(>|\/>)/gi, function(r, n, i, s) {
    return i = (i && i.match(t) || []).map(function(l) {
      return l;
    }).join(" "), n + i + s;
  });
}
function jJ(e) {
  var t = [], r = we.createElement("div");
  return r.innerHTML = e.replace(/\r/g, "").replace(/\n/g, "<br/>").replace(/style=/g, "data-style="), r.querySelectorAll("[data-style]").forEach((n) => {
    n.style = n.getAttribute("data-style"), n.removeAttribute("data-style");
  }), P3(t, 0, r, {}, ""), GJ(t), t;
}
function $J(e) {
  for (var t = e.replace(/\r/g, "").split(/\n/g), r = 0, n = []; r < t.length; r++)
    n.push({
      value: t[r].trim(),
      height: 0,
      line: r
    });
  return n;
}
function sD(e, t, r) {
  var n, i, s;
  for (n = 0, i = e.length; n < i; ++n)
    s = e[n], s[r] = QM("tspan"), s[r].appendChild(we.createTextNode(s.value)), s.style && eL({
      element: s[r],
      _styles: {}
    }, s.style), s.className && s[r].setAttribute("class", s.className), t.appendChild(s[r]);
}
function tL() {
  this._hasEllipsis && this.attr({
    text: this._settings.text
  });
}
function YJ(e) {
  var t, r = !1, n, i, s, l, d, h;
  tL.call(this);
  var p = this.renderer.text(yy).attr(this._styles).append(this.renderer.root), m = p.getBBox().width;
  if (this._getElementBBox().width > e) {
    for (e - m < 0 ? e = 0 : e -= m, t = qJ(this.element, this._texts, e), n = 0, i = t.length; n < i; ++n)
      if (s = t[n].parts, t[n].commonLength !== 1)
        for (l = 0, d = s.length; l < d; ++l)
          h = s[l], I(h.endIndex) ? (xy(h, h.endIndex), r = !0) : h.startBox > e && FE(h);
  }
  return p.remove(), this._hasEllipsis = r, r;
}
function rB(e) {
  var t;
  return e && (t = e.cloneNode(), t.removeAttribute("y"), t.removeAttribute("x")), t || e;
}
function I3(e) {
  for (var t = we.querySelectorAll(e, "title"), r = 0; r < t.length; r++)
    e.removeChild(t[r]);
  return t;
}
function WJ(e) {
  var t = I3(e);
  return () => {
    for (var r = 0; r < t.length; r++)
      e.appendChild(t[r]);
  };
}
function XJ(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = this, i = [], s = !1, l = !1, d = e;
  tL.call(n);
  var h = WJ(this.element), p = n.renderer.text(yy).attr(n._styles).append(n.renderer.root), m = p.getBBox().width, {
    width: x,
    height: S
  } = n._getElementBBox();
  return (x || S) && (x > e || t && S > t) && (e - m < 0 ? d = 0 : d -= m, i = eee(n.element, n._texts, e, d, r), i = JJ(i, d, r, t, parseFloat(this._getLineHeight())), this._texts = i.reduce((T, k) => T.concat(k.parts), []).filter((T) => T.value !== "").map((T) => (T.stroke && T.tspan.parentNode.appendChild(T.stroke), T)).map((T) => (T.tspan.parentNode.appendChild(T.tspan), T)), !this._texts.length && (this._texts = null), s = !0, this._texts ? rL(this) : (this.element.textContent = "", l = !0)), p.remove(), n._hasEllipsis = s, h(), {
    rowCount: i.length,
    textChanged: s,
    textIsEmpty: l
  };
}
function nB(e, t, r, n) {
  var i, s;
  if (r <= t && n > t) {
    for (i = 1, s = e.value.length; i <= s; ++i)
      if (r + e.tspan.getSubStringLength(0, i) > t)
        return i - 1;
  }
}
function VE(e) {
  return e.value.length ? e.tspan.getSubStringLength(0, e.value.length) : 0;
}
function qJ(e, t, r) {
  var n = [], i, s, l, d, h;
  if (t)
    for (i = 0, s = t.length; i < s; ++i)
      l = t[i], n[l.line] ? (l.startBox = d, n[l.line].parts.push(l), n[l.line].commonLength += l.value.length) : (l.startBox = d = 0, n.push({
        commonLength: l.value.length,
        parts: [l]
      })), h = d + l.tspan.getSubStringLength(0, l.value.length), l.endIndex = nB(l, r, d, h), d = h;
  else
    l = {
      value: e.textContent,
      tspan: e
    }, l.startBox = d = 0, h = d + VE(l), l.endIndex = nB(l, r, d, h), n = [{
      commonLength: e.textContent.length,
      parts: [l]
    }];
  return n;
}
function KJ(e, t) {
  for (var r = e.startBox > 0 ? [0] : [], n = e.value.split("").reduce((s, l, d) => (l === " " && s.push(d), s), r), i = 0; n[i + 1] !== void 0 && e.startBox + e.tspan.getSubStringLength(0, n[i + 1]) < t; )
    i++;
  return n[i];
}
function ZJ(e, t) {
  for (var r = 0; r < e.value.length - 1; r++)
    if (e.startBox + e.tspan.getSubStringLength(0, r + 1) > t)
      return r;
}
function N3(e, t) {
  var {
    hideOverflowEllipsis: r
  } = t;
  return r && e === 0 ? "" : yy;
}
function V3(e, t, r) {
  var n = N3(t, r);
  if (e.value.length && e.tspan.parentNode)
    for (var i = e.value.length - 1; i >= 1; i--)
      if (e.startBox + e.tspan.getSubStringLength(0, i) < t) {
        xy(e, i, n);
        break;
      } else
        i === 1 && xy(e, 0, n);
}
function F3(e, t, r, n, i) {
  var s = e.value, l;
  n.wordWrap !== "none" && (l = n.wordWrap === "normal" ? KJ(e, t) : ZJ(e, t));
  var d = [], h;
  if (isFinite(l) && !(i === 0 && l === 0)) {
    xy(e, l, "");
    var p = s[l] === " " ? 1 : 0, m = s.slice(l + p);
    if (m.length) {
      var x = rB(e.tspan);
      if (x.textContent = m, e.tspan.parentNode.appendChild(x), h = ki(ki({}, e), {
        value: m,
        startBox: 0,
        height: 0,
        tspan: x,
        stroke: rB(e.stroke),
        endBox: x.getSubStringLength(0, m.length)
      }), h.stroke && (h.stroke.textContent = m), h.endBox > t && (d = F3(h, t, r, n, l), !d.length))
        return [];
    }
  }
  if (e.value.length) {
    if (n.textOverflow === "ellipsis" && e.tspan.getSubStringLength(0, e.value.length) > t && V3(e, r, n), n.textOverflow === "hide" && e.tspan.getSubStringLength(0, e.value.length) > t)
      return [];
  } else
    e.tspan.parentNode.removeChild(e.tspan);
  var S = [];
  return h && S.push(h), [{
    commonLength: s.length,
    parts: S
  }].concat(d);
}
function QJ(e, t) {
  return e.parts.reduce((r, n) => CJ(r, B3(n, t)), 0);
}
function JJ(e, t, r, n, i) {
  var s = r.textOverflow;
  if (!isFinite(n) || Number(n) === 0 || s === "none")
    return e;
  var l = e.reduce((d, h, p, m) => {
    var [x, S] = d, T = QJ(h, i);
    if (S += T, S < n)
      x.push(h);
    else if (h.parts.forEach((D) => {
      FE(D);
    }), s === "ellipsis") {
      var k = m[p - 1];
      if (k) {
        var O = k.parts[k.parts.length - 1];
        O.hasEllipsis || (t === 0 || O.endBox < t ? xy(O, O.value.length, N3(t, r)) : V3(O, t, r));
      }
    }
    return [x, S];
  }, [
    [],
    0
  ]);
  return s === "hide" && l[1] > n ? (l[0].forEach((d) => {
    d.parts.forEach((h) => {
      FE(h);
    });
  }), []) : l[0];
}
function eee(e, t, r, n, i) {
  if (!t) {
    var s = e.textContent, l = {
      value: s,
      height: 0,
      line: 0
    };
    e.textContent = "", sD([l], e, "tspan"), t = [l];
  }
  return t.reduce((d, h) => {
    var [p, m, x, S, T] = d, k = p[p.length - 1];
    if (S)
      return [p, m, x, S];
    if (!k || h.line !== T)
      h.startBox = m = 0, p.push({
        commonLength: h.value.length,
        parts: [h]
      });
    else {
      if (h.startBox = m, m > n && i.wordWrap === "none" && i.textOverflow === "ellipsis")
        return FE(h), [p, m, x, S, T];
      k.parts.push(h), k.commonLength += h.value.length;
    }
    if (h.endBox = x = m + VE(h), m = x, I(r) && x > r) {
      var O = F3(h, r, n, i);
      O.length ? p = p.concat(O.filter((D) => D.parts.length > 0)) : (p = [], S = !0);
    }
    return [p, m, x, S, h.line];
  }, [
    [],
    0,
    0,
    !1,
    0
  ])[0];
}
function xy(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : yy, n = e.value.substr(0, t) + r;
  e.value = e.tspan.textContent = n, e.stroke && (e.stroke.textContent = n), r === yy && (e.hasEllipsis = !0);
}
function FE(e) {
  e.tspan.parentNode && e.tspan.parentNode.removeChild(e.tspan), e.stroke && e.stroke.parentNode && e.stroke.parentNode.removeChild(e.stroke);
}
function tee(e, t, r) {
  var n, i;
  e._texts = null, e.clear(), t !== null && (t = "" + t, !e.renderer.encodeHtml && (/<[a-z][\s\S]*>/i.test(t) || t.indexOf("&") !== -1) ? (i = UJ(t), n = jJ(i)) : /\n/g.test(t) ? n = $J(t) : r && (n = [{
    value: t.trim(),
    height: 0
  }]), n ? n.length && (e._texts = n, r && sD(n, e.element, Hu), sD(n, e.element, "tspan")) : e.element.appendChild(we.createTextNode(t)));
}
function G_(e, t, r) {
  e.tspan.setAttribute(t, r), e.stroke && e.stroke.setAttribute(t, r);
}
function B3(e, t) {
  return e.inherits ? z3(e.height, t) : e.height || t;
}
function rL(e) {
  if (e._texts) {
    var t = e._texts, r = e._settings.x, n = e._getLineHeight(), i, s, l = t[0];
    for (G_(l, "x", r), G_(l, "y", e._settings.y), i = 1, s = t.length; i < s; ++i)
      if (l = t[i], parseFloat(l.height) >= 0) {
        G_(l, "x", r);
        var d = B3(l, n);
        G_(l, "dy", d);
      }
  }
}
function ree(e, t) {
  if (!(!e._texts || t === "center"))
    for (var r = e._texts, n = t === "left" ? -1 : 1, i = Math.max.apply(Math, r.map((h) => VE(h))), s = 0; s < r.length; s++) {
      var l = r[s], d = VE(l);
      i !== 0 && i !== d && G_(l, "dx", n * EJ((i - d) / 2 * 10) / 10);
    }
}
function z3(e, t) {
  var r = parseFloat(e), n = parseFloat(t), i = r || aD, s = n || aD;
  return i > s ? isNaN(r) ? i : e : isNaN(n) ? s : t;
}
function nee(e) {
  if (e._texts) {
    var t = e._texts, r = e._settings[Hu], n = e._settings[ma], i = e._settings[pg] || 1, s, l, d;
    for (l = 0, d = t.length; l < d; ++l)
      s = t[l].stroke, s.setAttribute(Hu, r), s.setAttribute(ma, n), s.setAttribute(pg, i), s.setAttribute("stroke-linejoin", "round");
  }
}
function nL(e, t, r, n) {
  r = r || {};
  var i, s, l = e.renderer, d = e._settings, h = {}, p = {
    translateX: 0,
    translateY: 0,
    scaleX: 1,
    scaleY: 1,
    rotate: 0,
    rotateX: 0,
    rotateY: 0
  };
  if (n && (r.complete = n), l.animationEnabled()) {
    for (i in t)
      s = t[i], /^(translate(X|Y)|rotate[XY]?|scale(X|Y))$/i.test(i) ? (h.transform = h.transform || {
        from: {},
        to: {}
      }, h.transform.from[i] = i in d ? Number(d[i].toFixed(3)) : p[i], h.transform.to[i] = s) : i === "arc" || i === "segments" ? h[i] = s : h[i] = {
        from: i in d ? d[i] : parseFloat(e.element.getAttribute(i) || 0),
        to: s
      };
    l.animateElement(e, h, ki(ki({}, l._animation), r));
  } else
    r.step && r.step.call(e, 1, 1), r.complete && r.complete.call(e), e.attr(t);
  return e;
}
function iee(e, t, r) {
  var n = this.segments || [], i, s;
  return this.renderer.animationEnabled() && "points" in e && (i = M3(e.points, this.type), s = PJ(n, i, this.type), e.segments = {
    from: n,
    to: i,
    end: s
  }, delete e.points), nL(this, e, t, r);
}
function aee(e, t, r) {
  var n = this._settings, i = {
    from: {},
    to: {}
  };
  return this.renderer.animationEnabled() && ("x" in e || "y" in e || "innerRadius" in e || "outerRadius" in e || "startAngle" in e || "endAngle" in e) && (i.from.x = n.x || 0, i.from.y = n.y || 0, i.from.innerRadius = n.innerRadius || 0, i.from.outerRadius = n.outerRadius || 0, i.from.startAngle = n.startAngle || 0, i.from.endAngle = n.endAngle || 0, i.to.x = "x" in e ? e.x : n.x, delete e.x, i.to.y = "y" in e ? e.y : n.y, delete e.y, i.to.innerRadius = "innerRadius" in e ? e.innerRadius : n.innerRadius, delete e.innerRadius, i.to.outerRadius = "outerRadius" in e ? e.outerRadius : n.outerRadius, delete e.outerRadius, i.to.startAngle = "startAngle" in e ? e.startAngle : n.startAngle, delete e.startAngle, i.to.endAngle = "endAngle" in e ? e.endAngle : n.endAngle, delete e.endAngle, e.arc = i), nL(this, e, t, r);
}
function iB(e, t) {
  var r = {
    is: !1,
    name: t.name || t,
    after: t.after
  };
  return e ? r.to = e : r.virtual = !0, r;
}
var Vs = function(e, t, r) {
  this.renderer = e, this.element = QM(t), this._settings = {}, this._styles = {}, t === "path" && (this.type = r || "line");
};
function aB(e) {
  iL.remove(e);
}
Vs.prototype = {
  constructor: Vs,
  _getJQElement: function() {
    return this._$element || (this._$element = je(this.element));
  },
  _addFixIRICallback: function() {
    var e = this, t = function() {
      nk(e, "fill"), nk(e, "clip-path"), nk(e, "filter");
    };
    e.element._fixFuncIri = t, t.renderer = e.renderer, iL.add(t), e._addFixIRICallback = function() {
    };
  },
  _clearChildrenFuncIri: function() {
    (function e(t) {
      var r;
      for (r = 0; r < t.childNodes.length; r++)
        aB(t.childNodes[r]._fixFuncIri), e(t.childNodes[r]);
    })(this.element);
  },
  dispose: function() {
    return aB(this.element._fixFuncIri), this._clearChildrenFuncIri(), this._getJQElement().remove(), this;
  },
  append: function(e) {
    return (e || this.renderer.root).element.appendChild(this.element), this;
  },
  remove: function() {
    var e = this.element;
    return e.parentNode && e.parentNode.removeChild(e), this;
  },
  enableLinks: function() {
    return this._links = [], this;
  },
  virtualLink: function(e) {
    return oB({
      _link: iB(null, e)
    }, this), this;
  },
  linkAfter: function(e) {
    return this._linkAfter = e, this;
  },
  linkOn: function(e, t) {
    return this._link = iB(e, t), oB(this, e), this;
  },
  linkOff: function() {
    return oee(this), this._link = null, this;
  },
  linkAppend: function() {
    var e = this._link, t = e.to._links, r, n;
    for (r = e.i + 1; (n = t[r]) && !n._link.is; ++r)
      ;
    return this._insert(e.to, n), e.is = !0, this;
  },
  _insert: function(e, t) {
    e.element.insertBefore(this.element, t ? t.element : null);
  },
  linkRemove: function() {
    return this.remove(), this._link.is = !1, this;
  },
  clear: function() {
    return this._clearChildrenFuncIri(), this._getJQElement().empty(), this;
  },
  toBackground: function() {
    var e = this.element, t = e.parentNode;
    return t && t.insertBefore(e, t.firstChild), this;
  },
  toForeground: function() {
    var e = this.element, t = e.parentNode;
    return t && t.appendChild(e), this;
  },
  attr: function(e) {
    return Mh(this, e);
  },
  smartAttr: function(e) {
    return this.attr(D3(this, e));
  },
  css: function(e) {
    return eL(this, e);
  },
  animate: function(e, t, r) {
    return nL(this, e, t, r);
  },
  sharp(e, t) {
    return this.attr({
      sharp: e || !0,
      sharpDirection: t
    });
  },
  _applyTransformation() {
    var e = this._settings, t, r, n = [], i = e.sharp, s = e.sharpDirection || 1, l = e[ma] % 2, d = l && (i === "h" || i === !0) ? qF * s : 0, h = l && (i === "v" || i === !0) ? qF * s : 0;
    n.push("translate(" + ((e.translateX || 0) + d) + "," + ((e.translateY || 0) + h) + ")"), e.rotate && ("rotateX" in e ? t = e.rotateX : t = e.x, "rotateY" in e ? r = e.rotateY : r = e.y, n.push("rotate(" + e.rotate + "," + (t || 0) + "," + (r || 0) + ")"));
    var p = I(e.scaleX), m = I(e.scaleY);
    (p || m) && n.push("scale(" + (p ? e.scaleX : 1) + "," + (m ? e.scaleY : 1) + ")"), n.length && this.element.setAttribute("transform", n.join(" "));
  },
  move: function(e, t, r, n) {
    var i = {};
    return I(e) && (i.translateX = e), I(t) && (i.translateY = t), r ? this.animate(i, n) : this.attr(i), this;
  },
  rotate: function(e, t, r, n, i) {
    var s = {
      rotate: e || 0
    };
    return I(t) && (s.rotateX = t), I(r) && (s.rotateY = r), n ? this.animate(s, i) : this.attr(s), this;
  },
  _getElementBBox: function() {
    var e = this.element, t;
    try {
      t = e.getBBox && e.getBBox();
    } catch {
    }
    return t || {
      x: 0,
      y: 0,
      width: e.offsetWidth || 0,
      height: e.offsetHeight || 0
    };
  },
  getBBox: function() {
    var e = this._settings, t = this._getElementBBox();
    return e.rotate ? t = kE(t, [("rotateX" in e ? e.rotateX : e.x) || 0, ("rotateY" in e ? e.rotateY : e.y) || 0], -e.rotate) : t = BG(t), t;
  },
  markup: function() {
    return b3(this.element);
  },
  getOffset: function() {
    return this._getJQElement().offset();
  },
  stopAnimation: function(e) {
    var t = this.animation;
    return t && t.stop(e), this;
  },
  setTitle: function(e) {
    var t = QM("title");
    t.textContent = e || "", this.element.appendChild(t);
  },
  removeTitle() {
    I3(this.element);
  },
  data: function(e, t) {
    var r = this.element, n;
    if (t !== void 0)
      r[e] = t;
    else
      for (n in e)
        r[n] = e[n];
    return this;
  },
  on: function() {
    var e = [this._getJQElement()];
    return e.push.apply(e, arguments), Ve.on.apply(Ve, e), this;
  },
  off: function() {
    var e = [this._getJQElement()];
    return e.push.apply(e, arguments), Ve.off.apply(Ve, e), this;
  },
  trigger: function() {
    var e = [this._getJQElement()];
    return e.push.apply(e, arguments), Ve.trigger.apply(Ve, e), this;
  }
};
var by = function(e, t) {
  Vs.call(this, e, "path", t);
};
by.prototype = DT(Vs.prototype);
ki(by.prototype, {
  constructor: by,
  attr: VJ,
  animate: iee
});
var BE = function(e) {
  Vs.call(this, e, "path", "arc");
};
BE.prototype = DT(Vs.prototype);
ki(BE.prototype, {
  constructor: BE,
  attr: FJ,
  animate: aee
});
var zE = function(e) {
  Vs.call(this, e, "rect");
};
zE.prototype = DT(Vs.prototype);
ki(zE.prototype, {
  constructor: zE,
  attr: BJ
});
var HE = function(e) {
  Vs.call(this, e, "text"), this.css({
    "white-space": "pre"
  });
};
HE.prototype = DT(Vs.prototype);
ki(HE.prototype, {
  constructor: HE,
  attr: zJ,
  css: HJ,
  applyEllipsis: YJ,
  setMaxSize: XJ,
  restoreText: tL,
  _getLineHeight() {
    return isNaN(parseFloat(this._styles[_y])) ? aD : this._styles[_y];
  }
});
function H3(e, t) {
  var r, n;
  for (r = t; n = e[r]; ++r)
    n._link.i = r;
}
function oB(e, t) {
  var r = t._links, n = e._link.after = e._link.after || t._linkAfter, i, s;
  if (n) {
    for (i = 0; (s = r[i]) && s._link.name !== n; ++i)
      ;
    if (s)
      for (++i; (s = r[i]) && s._link.after === n; ++i)
        ;
  } else
    i = r.length;
  r.splice(i, 0, e), H3(r, i);
}
function oee(e) {
  var t, r = e._link.to._links;
  for (t = 0; r[t] !== e; ++t)
    ;
  r.splice(t, 1), H3(r, t);
}
function GE(e) {
  this.root = this._createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    fill: mh,
    stroke: mh,
    "stroke-width": 0
  }).attr({
    class: e.cssClass
  }).css({
    "line-height": "normal",
    "-moz-user-select": mh,
    "-webkit-user-select": mh,
    "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)",
    display: "block",
    overflow: "hidden"
  }), this._init(), this.pathModified = !!e.pathModified, this._$container = je(e.container), this.root.append({
    element: e.container
  }), this._locker = 0, this._backed = !1;
}
GE.prototype = {
  constructor: GE,
  _init: function() {
    this._defs = this._createElement("defs").append(this.root), this._animationController = new R3(this.root.element), this._animation = {
      enabled: !0,
      duration: 1e3,
      easing: "easeOutCubic"
    };
  },
  setOptions: function(e) {
    return this.rtl = !!e.rtl, this.encodeHtml = !!e.encodeHtml, this.updateAnimationOptions(e.animation || {}), this.root.attr({
      direction: this.rtl ? "rtl" : "ltr"
    }), this;
  },
  _createElement: function(e, t, r) {
    var n = new Vs(this, e, r);
    return t && n.attr(t), n;
  },
  lock: function() {
    return this._locker === 0 && (this._backed = !this._$container.is(":visible"), this._backed && AJ(this.root)), ++this._locker, this;
  },
  unlock: function() {
    return --this._locker, this._locker === 0 && (this._backed && OJ(this.root, this._$container[0]), this._backed = !1), this;
  },
  resize: function(e, t) {
    return e >= 0 && t >= 0 && this.root.attr({
      width: e,
      height: t
    }), this;
  },
  dispose: function() {
    var e;
    this.root.dispose(), this._defs.dispose(), this._animationController.dispose(), iL.removeByRenderer(this);
    for (e in this)
      this[e] = null;
    return this;
  },
  animationEnabled: function() {
    return !!this._animation.enabled;
  },
  updateAnimationOptions: function(e) {
    return ki(this._animation, e), this;
  },
  stopAllAnimations: function(e) {
    return this._animationController[e ? "lock" : "stop"](), this;
  },
  animateElement: function(e, t, r) {
    return this._animationController.animateElement(e, t, r), this;
  },
  svg: function() {
    return this.root.markup();
  },
  getRootOffset: function() {
    return this.root.getOffset();
  },
  onEndAnimation: function(e) {
    this._animationController.onEndAnimation(e);
  },
  rect: function(e, t, r, n) {
    var i = new zE(this);
    return i.attr({
      x: e || 0,
      y: t || 0,
      width: r || 0,
      height: n || 0
    });
  },
  simpleRect: function() {
    return this._createElement("rect");
  },
  circle: function(e, t, r) {
    return this._createElement("circle", {
      cx: e || 0,
      cy: t || 0,
      r: r || 0
    });
  },
  g: function() {
    return this._createElement("g");
  },
  image: function(e, t, r, n, i, s) {
    var l = this._createElement("image", {
      x: e || 0,
      y: t || 0,
      width: r || 0,
      height: n || 0,
      preserveAspectRatio: kJ[Wt(s)] || mh
    });
    return l.element.setAttributeNS("http://www.w3.org/1999/xlink", "href", i || ""), l;
  },
  path: function(e, t) {
    var r = new by(this, t);
    return r.attr({
      points: e || []
    });
  },
  arc: function(e, t, r, n, i, s) {
    var l = new BE(this);
    return l.attr({
      x: e || 0,
      y: t || 0,
      innerRadius: r || 0,
      outerRadius: n || 0,
      startAngle: i || 0,
      endAngle: s || 0
    });
  },
  text: function(e, t, r) {
    var n = new HE(this);
    return n.attr({
      text: e,
      x: t || 0,
      y: r || 0
    });
  },
  linearGradient: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ih(), r = arguments.length > 2 ? arguments[2] : void 0, n = this._createElement("linearGradient", {
      id: t,
      gradientTransform: "rotate(".concat(r || 0, ")")
    }).append(this._defs);
    return n.id = t, this._createGradientStops(e, n), n;
  },
  radialGradient: function(e, t) {
    var r = this._createElement("radialGradient", {
      id: t
    }).append(this._defs);
    return this._createGradientStops(e, r), r;
  },
  _createGradientStops: function(e, t) {
    e.forEach((r) => {
      var n;
      this._createElement("stop", {
        offset: r.offset,
        "stop-color": (n = r["stop-color"]) !== null && n !== void 0 ? n : r.color,
        "stop-opacity": r.opacity
      }).append(t);
    });
  },
  pattern: function(e, t, r) {
    t = t || {};
    var n = t.step || 6, i = n / 2, s = 1.5 * n, l = r || ih(), d = Wt(t.direction) === "right" ? "M " + i + " " + -i + " L " + -i + " " + i + " M 0 " + n + " L " + n + " 0 M " + s + " " + i + " L " + i + " " + s : "M 0 0 L " + n + " " + n + " M " + -i + " " + i + " L " + i + " " + s + " M " + i + " " + -i + " L " + s + " " + i, h = this._createElement("pattern", {
      id: l,
      width: n,
      height: n,
      patternUnits: "userSpaceOnUse"
    }).append(this._defs);
    return h.id = l, this.rect(0, 0, n, n).attr({
      fill: e,
      opacity: t.opacity
    }).append(h), new by(this).attr({
      d,
      "stroke-width": t.width || 1,
      stroke: e
    }).append(h), h;
  },
  customPattern: function(e, t, r, n) {
    var i = {
      id: e,
      width: r,
      height: n,
      patternContentUnits: "userSpaceOnUse",
      patternUnits: this._getPatternUnits(r, n)
    }, s = this._createElement("pattern", i).append(this._defs);
    return t.render({
      container: s.element
    }), s;
  },
  _getPatternUnits: function(e, t) {
    if (Number(e) && Number(t))
      return "userSpaceOnUse";
  },
  _getPointsWithYOffset: function(e, t) {
    return e.map(function(r, n) {
      return n % 2 !== 0 ? r + t : r;
    });
  },
  clipShape: function(e, t) {
    var r = ih(), n = this._createElement("clipPath", {
      id: r
    }).append(this._defs), i = e.apply(this, t).append(n);
    return i.id = r, i.remove = function() {
      throw "Not implemented";
    }, i.dispose = function() {
      return n.dispose(), n = null, this;
    }, i;
  },
  clipRect(e, t, r, n) {
    return this.clipShape(this.rect, arguments);
  },
  clipCircle(e, t, r) {
    return this.clipShape(this.circle, arguments);
  },
  shadowFilter: function(e, t, r, n, i, s, l, d, h) {
    var p = ih(), m = this._createElement("filter", {
      id: p,
      x: e || 0,
      y: t || 0,
      width: r || 0,
      height: n || 0
    }).append(this._defs), x = this._createElement("feGaussianBlur", {
      in: "SourceGraphic",
      result: "gaussianBlurResult",
      stdDeviation: l || 0
    }).append(m), S = this._createElement("feOffset", {
      in: "gaussianBlurResult",
      result: "offsetResult",
      dx: i || 0,
      dy: s || 0
    }).append(m), T = this._createElement("feFlood", {
      result: "floodResult",
      "flood-color": d || "",
      "flood-opacity": h
    }).append(m), k = this._createElement("feComposite", {
      in: "floodResult",
      in2: "offsetResult",
      operator: "in",
      result: "compositeResult"
    }).append(m), O = this._createElement("feComposite", {
      in: "SourceGraphic",
      in2: "compositeResult",
      operator: "over"
    }).append(m);
    return m.id = p, m.gaussianBlur = x, m.offset = S, m.flood = T, m.composite = k, m.finalComposite = O, m.attr = function(D) {
      var L = {}, F = {}, z = {};
      return "x" in D && (L.x = D.x), "y" in D && (L.y = D.y), "width" in D && (L.width = D.width), "height" in D && (L.height = D.height), Mh(this, L), "blur" in D && this.gaussianBlur.attr({
        stdDeviation: D.blur
      }), "offsetX" in D && (F.dx = D.offsetX), "offsetY" in D && (F.dy = D.offsetY), this.offset.attr(F), "color" in D && (z["flood-color"] = D.color), "opacity" in D && (z["flood-opacity"] = D.opacity), this.flood.attr(z), this;
    }, m;
  },
  brightFilter: function(e, t) {
    var r = ih(), n = this._createElement("filter", {
      id: r
    }).append(this._defs), i = this._createElement("feComponentTransfer").append(n), s = {
      type: e,
      slope: t
    };
    return n.id = r, this._createElement("feFuncR", s).append(i), this._createElement("feFuncG", s).append(i), this._createElement("feFuncB", s).append(i), n;
  },
  getGrayScaleFilter: function() {
    if (this._grayScaleFilter)
      return this._grayScaleFilter;
    var e = ih(), t = this._createElement("filter", {
      id: e
    }).append(this._defs);
    return this._createElement("feColorMatrix").attr({
      type: "matrix",
      values: "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 0.6 0"
    }).append(t), t.id = e, this._grayScaleFilter = t, t;
  },
  lightenFilter: function(e) {
    var t = this._createElement("filter", {
      id: e
    }).append(this._defs);
    return this._createElement("feColorMatrix", {
      type: "matrix",
      values: "".concat(1.3, " 0 0 0 0 0 ").concat(1.3, " 0 0 0 0 0 ").concat(1.3, " 0 0 0 0 0 1 0")
    }).append(t), t.id = e, t;
  },
  initDefsElements: function() {
    var e = this._defsElementsStorage = this._defsElementsStorage || {
      byHash: {},
      baseId: ih()
    }, t = e.byHash, r;
    for (r in t)
      t[r].pattern.dispose();
    e.byHash = {}, e.refToHash = {}, e.nextId = 0;
  },
  drawPattern: function(e, t, r) {
    var {
      color: n,
      hatching: i
    } = e;
    return this.pattern(n, i, "".concat(t, "-hatching-").concat(r++));
  },
  drawFilter: function(e, t, r) {
    return this.lightenFilter("".concat(t, "-lightening-").concat(r++));
  },
  lockDefsElements: function(e, t, r) {
    var n = this._defsElementsStorage, i, s = r === "pattern" ? see(e) : TJ, l = r === "pattern" ? this.drawPattern : this.drawFilter, d;
    return n.refToHash[t] !== s && (t && this.releaseDefsElements(t), i = n.byHash[s], i || (d = l.call(this, e, n.baseId, n.nextId++), i = n.byHash[s] = {
      pattern: d,
      count: 0
    }, n.refToHash[d.id] = s), ++i.count, t = i.pattern.id), t;
  },
  releaseDefsElements: function(e) {
    var t = this._defsElementsStorage, r = t.refToHash[e], n = t.byHash[r];
    n && --n.count === 0 && (n.pattern.dispose(), delete t.byHash[r], delete t.refToHash[e]);
  }
};
function see(e) {
  var {
    color: t,
    hatching: r
  } = e;
  return "@" + t + "::" + r.step + ":" + r.width + ":" + r.opacity + ":" + r.direction;
}
var iL = /* @__PURE__ */ function() {
  var e = [];
  return {
    add: function(t) {
      e.push(t);
    },
    remove: function(t) {
      e = e.filter(function(r) {
        return r !== t;
      });
    },
    removeByRenderer: function(t) {
      e = e.filter(function(r) {
        return r.renderer !== t;
      });
    },
    fire: function() {
      e.forEach(function(t) {
        t();
      });
    }
  };
}();
var lee = 10;
function uee(e) {
  var t = Hd(e);
  return t * Math.round(Math.abs(e));
}
function cee(e, t) {
  var r = Math.pow(lee, t), n = _G(e, t);
  return uee(n) / r;
}
function G3(e, t) {
  var r = t || 0, n = r > 0 ? cee(...arguments) : e;
  return n.toFixed(r);
}
var dee = {
  thousandsSeparator: ",",
  decimalSeparator: "."
}, sB = "'", fee = 15, hee = 2;
function vee(e) {
  return e.split(",").slice(1).map(function(t) {
    var r = 0;
    return t.split("").filter(function(n, i) {
      r += n === "'";
      var s = n === "#" || n === "0", l = r % 2;
      return s && !l;
    }).length;
  });
}
function pee(e) {
  var t = e.split(";");
  return t.length === 1 && t.push("-" + t[0]), t;
}
function ik(e) {
  return e.toString().split("").reverse().join("");
}
function gee(e) {
  return e.indexOf("%") !== -1 && !e.match(/'[^']*%[^']*'/g);
}
function U3(e) {
  return e.replace(/'.+'/g, "");
}
function lB(e) {
  if (!e)
    return 0;
  var t = U3(e);
  return t.length - t.replace(/[#]/g, "").length;
}
function uB(e) {
  if (!e)
    return 0;
  var t = U3(e);
  return t.length - t.replace(/[0]/g, "").length;
}
function cB(e, t, r) {
  if (!e)
    return "";
  for (e.length > r && (e = e.substr(0, r)); e.length > t && e.slice(-1) === "0"; )
    e = e.substr(0, e.length - 1);
  for (; e.length < t; )
    e += "0";
  return e;
}
function mee(e, t, r) {
  if (!t.length)
    return e;
  for (var n = [], i = 0; e; ) {
    var s = t[i];
    if (!s)
      break;
    n.push(e.slice(0, s)), e = e.slice(s), i < t.length - 1 && i++;
  }
  return n.join(r);
}
function dB(e, t) {
  return e.split(sB).map(function(r, n) {
    var i = n % 2;
    return !r && i ? sB : i ? r : r.replace(/[,#0]+/, t);
  }).join("");
}
function _ee(e) {
  for (var t = !1, r = 0; r < e.length; r++)
    if (e[r] === "'" && (t = !t), e[r] === "." && !t)
      return r;
  return e.length;
}
function yee(e, t) {
  return t = t || dee, function(r) {
    if (typeof r != "number" || isNaN(r))
      return "";
    var n = pee(e), i = 1 / r === 1 / 0, s = r > 0 || i, l = n[s ? 0 : 1], d = _ee(l), h = [l.substr(0, d), l.substr(d + 1)], p = uB(h[1]), m = p + lB(h[1]);
    gee(l) && (r = _G(r, hee)), s || (r = -r);
    var x = uB(h[0]), S = lB(h[0]) || t.unlimitedIntegerDigits ? void 0 : x, T = Math.floor(r).toString().length, k = mG(m, 0, fee - T), O = vee(h[0]).reverse(), D = G3(r, k < 0 ? 0 : k).split("."), L = cB(ik(D[0]), x, S), F = cB(D[1], p, m);
    L = mee(L, O, t.thousandsSeparator);
    var z = ik(dB(ik(h[0]), L)), V = m ? dB(h[1], F) : "", P = z + (V.match(/\d/) ? t.decimalSeparator : "") + V;
    return P;
  };
}
const xee = {
  _formatNumberCore: function(e, t, r) {
    if (t === "currency") {
      r.precision = r.precision || 0;
      var n = this.format(e, W({}, r, {
        type: "fixedpoint"
      })), i = this.getCurrencySymbol().symbol.replace(/\$/g, "$$$$");
      return n = n.replace(/^(\D*)(\d.*)/, "$1" + i + "$2"), n;
    }
    return this.callBase.apply(this, arguments);
  },
  getCurrencySymbol: function() {
    return {
      symbol: "$"
    };
  },
  getOpenXmlCurrencyFormat: function() {
    return "$#,##0{0}_);\\($#,##0{0}\\)";
  }
}, bee = {
  "en-150": "en-001",
  "en-AG": "en-001",
  "en-AI": "en-001",
  "en-AU": "en-001",
  "en-BB": "en-001",
  "en-BM": "en-001",
  "en-BS": "en-001",
  "en-BW": "en-001",
  "en-BZ": "en-001",
  "en-CC": "en-001",
  "en-CK": "en-001",
  "en-CM": "en-001",
  "en-CX": "en-001",
  "en-CY": "en-001",
  "en-DG": "en-001",
  "en-DM": "en-001",
  "en-ER": "en-001",
  "en-FJ": "en-001",
  "en-FK": "en-001",
  "en-FM": "en-001",
  "en-GB": "en-001",
  "en-GD": "en-001",
  "en-GG": "en-001",
  "en-GH": "en-001",
  "en-GI": "en-001",
  "en-GM": "en-001",
  "en-GY": "en-001",
  "en-HK": "en-001",
  "en-IE": "en-001",
  "en-IL": "en-001",
  "en-IM": "en-001",
  "en-IN": "en-001",
  "en-IO": "en-001",
  "en-JE": "en-001",
  "en-JM": "en-001",
  "en-KE": "en-001",
  "en-KI": "en-001",
  "en-KN": "en-001",
  "en-KY": "en-001",
  "en-LC": "en-001",
  "en-LR": "en-001",
  "en-LS": "en-001",
  "en-MG": "en-001",
  "en-MO": "en-001",
  "en-MS": "en-001",
  "en-MT": "en-001",
  "en-MU": "en-001",
  "en-MV": "en-001",
  "en-MW": "en-001",
  "en-MY": "en-001",
  "en-NA": "en-001",
  "en-NF": "en-001",
  "en-NG": "en-001",
  "en-NR": "en-001",
  "en-NU": "en-001",
  "en-NZ": "en-001",
  "en-PG": "en-001",
  "en-PK": "en-001",
  "en-PN": "en-001",
  "en-PW": "en-001",
  "en-RW": "en-001",
  "en-SB": "en-001",
  "en-SC": "en-001",
  "en-SD": "en-001",
  "en-SG": "en-001",
  "en-SH": "en-001",
  "en-SL": "en-001",
  "en-SS": "en-001",
  "en-SX": "en-001",
  "en-SZ": "en-001",
  "en-TC": "en-001",
  "en-TK": "en-001",
  "en-TO": "en-001",
  "en-TT": "en-001",
  "en-TV": "en-001",
  "en-TZ": "en-001",
  "en-UG": "en-001",
  "en-VC": "en-001",
  "en-VG": "en-001",
  "en-VU": "en-001",
  "en-WS": "en-001",
  "en-ZA": "en-001",
  "en-ZM": "en-001",
  "en-ZW": "en-001",
  "en-AT": "en-150",
  "en-BE": "en-150",
  "en-CH": "en-150",
  "en-DE": "en-150",
  "en-DK": "en-150",
  "en-FI": "en-150",
  "en-NL": "en-150",
  "en-SE": "en-150",
  "en-SI": "en-150",
  "hi-Latn": "en-IN",
  "es-AR": "es-419",
  "es-BO": "es-419",
  "es-BR": "es-419",
  "es-BZ": "es-419",
  "es-CL": "es-419",
  "es-CO": "es-419",
  "es-CR": "es-419",
  "es-CU": "es-419",
  "es-DO": "es-419",
  "es-EC": "es-419",
  "es-GT": "es-419",
  "es-HN": "es-419",
  "es-MX": "es-419",
  "es-NI": "es-419",
  "es-PA": "es-419",
  "es-PE": "es-419",
  "es-PR": "es-419",
  "es-PY": "es-419",
  "es-SV": "es-419",
  "es-US": "es-419",
  "es-UY": "es-419",
  "es-VE": "es-419",
  nb: "no",
  nn: "no",
  "pt-AO": "pt-PT",
  "pt-CH": "pt-PT",
  "pt-CV": "pt-PT",
  "pt-FR": "pt-PT",
  "pt-GQ": "pt-PT",
  "pt-GW": "pt-PT",
  "pt-LU": "pt-PT",
  "pt-MO": "pt-PT",
  "pt-MZ": "pt-PT",
  "pt-ST": "pt-PT",
  "pt-TL": "pt-PT",
  "az-Arab": "und",
  "az-Cyrl": "und",
  "bal-Latn": "und",
  "blt-Latn": "und",
  "bm-Nkoo": "und",
  "bs-Cyrl": "und",
  "byn-Latn": "und",
  "cu-Glag": "und",
  "dje-Arab": "und",
  "dyo-Arab": "und",
  "en-Dsrt": "und",
  "en-Shaw": "und",
  "ff-Adlm": "und",
  "ff-Arab": "und",
  "ha-Arab": "und",
  "iu-Latn": "und",
  "kk-Arab": "und",
  "ks-Deva": "und",
  "ku-Arab": "und",
  "ky-Arab": "und",
  "ky-Latn": "und",
  "ml-Arab": "und",
  "mn-Mong": "und",
  "mni-Mtei": "und",
  "ms-Arab": "und",
  "pa-Arab": "und",
  "sat-Deva": "und",
  "sd-Deva": "und",
  "sd-Khoj": "und",
  "sd-Sind": "und",
  "shi-Latn": "und",
  "so-Arab": "und",
  "sr-Latn": "und",
  "sw-Arab": "und",
  "tg-Arab": "und",
  "ug-Cyrl": "und",
  "uz-Arab": "und",
  "uz-Cyrl": "und",
  "vai-Latn": "und",
  "wo-Arab": "und",
  "yo-Arab": "und",
  "yue-Hans": "und",
  "zh-Hant": "und",
  "zh-Hant-MO": "zh-Hant-HK"
};
var See = "-";
const Cee = (e, t) => {
  var r = e[t];
  return r ? r !== "root" && r : t.substr(0, t.lastIndexOf(See));
};
var ak = "en";
const Ka = Fs({
  locale: /* @__PURE__ */ (() => {
    var e = ak;
    return (t) => {
      if (!t)
        return e;
      e = t;
    };
  })(),
  getValueByClosestLocale: function(e) {
    for (var t = this.locale(), r = e(t), n; !r && !n; )
      t = Cee(bee, t), t ? r = e(t) : n = !0;
    return r === void 0 && t !== ak ? e(ak) : r;
  }
}), Eee = (e, t) => {
  if (t) {
    var r = e;
    if (typeof e == "string") {
      r = "";
      for (var n = 0; n < e.length; n++)
        e[n] !== "$" && (r += "\\"), r += e[n];
    }
    for (var i = {
      ".00": "{0}",
      "'": "\\'",
      "\\(": "\\(",
      "\\)": "\\)",
      " ": "\\ ",
      '"': "&quot;",
      "\\¤": r
    }, s = t.split(";"), l = 0; l < s.length; l++)
      for (var d in i)
        Object.prototype.hasOwnProperty.call(i, d) && (s[l] = s[l].replace(new RegExp(d, "g"), i[d]));
    return s.length === 2 ? s[0] + "_);" + s[1] : s[0];
  }
}, Tee = {
  af: "¤#,##0.00;(¤#,##0.00)",
  "af-NA": "¤#,##0.00;(¤#,##0.00)",
  agq: "#,##0.00¤",
  ak: "¤#,##0.00",
  am: "¤#,##0.00;(¤#,##0.00)",
  ar: "¤#,##0.00;(¤#,##0.00)",
  "ar-AE": "¤#,##0.00;(¤#,##0.00)",
  "ar-BH": "¤#,##0.00;(¤#,##0.00)",
  "ar-DJ": "¤#,##0.00;(¤#,##0.00)",
  "ar-DZ": "¤#,##0.00;(¤#,##0.00)",
  "ar-EG": "¤#,##0.00;(¤#,##0.00)",
  "ar-EH": "¤#,##0.00;(¤#,##0.00)",
  "ar-ER": "¤#,##0.00;(¤#,##0.00)",
  "ar-IL": "¤#,##0.00;(¤#,##0.00)",
  "ar-IQ": "¤#,##0.00;(¤#,##0.00)",
  "ar-JO": "¤#,##0.00;(¤#,##0.00)",
  "ar-KM": "¤#,##0.00;(¤#,##0.00)",
  "ar-KW": "¤#,##0.00;(¤#,##0.00)",
  "ar-LB": "¤#,##0.00;(¤#,##0.00)",
  "ar-LY": "¤#,##0.00;(¤#,##0.00)",
  "ar-MA": "¤#,##0.00;(¤#,##0.00)",
  "ar-MR": "¤#,##0.00;(¤#,##0.00)",
  "ar-OM": "¤#,##0.00;(¤#,##0.00)",
  "ar-PS": "¤#,##0.00;(¤#,##0.00)",
  "ar-QA": "¤#,##0.00;(¤#,##0.00)",
  "ar-SA": "¤#,##0.00;(¤#,##0.00)",
  "ar-SD": "¤#,##0.00;(¤#,##0.00)",
  "ar-SO": "¤#,##0.00;(¤#,##0.00)",
  "ar-SS": "¤#,##0.00;(¤#,##0.00)",
  "ar-SY": "¤#,##0.00;(¤#,##0.00)",
  "ar-TD": "¤#,##0.00;(¤#,##0.00)",
  "ar-TN": "¤#,##0.00;(¤#,##0.00)",
  "ar-YE": "¤#,##0.00;(¤#,##0.00)",
  as: "¤ #,##,##0.00",
  asa: "#,##0.00 ¤",
  ast: "#,##0.00 ¤",
  az: "#,##0.00 ¤",
  "az-Cyrl": "#,##0.00 ¤",
  "az-Latn": "#,##0.00 ¤",
  bas: "#,##0.00 ¤",
  be: "#,##0.00 ¤",
  "be-tarask": "#,##0.00 ¤",
  bem: "¤#,##0.00;(¤#,##0.00)",
  bez: "#,##0.00¤",
  bg: "0.00 ¤;(0.00 ¤)",
  bm: "¤#,##0.00;(¤#,##0.00)",
  bn: "#,##,##0.00¤;(#,##,##0.00¤)",
  "bn-IN": "#,##,##0.00¤;(#,##,##0.00¤)",
  bo: "¤ #,##0.00",
  "bo-IN": "¤ #,##0.00",
  br: "#,##0.00 ¤",
  brx: "¤ #,##,##0.00",
  bs: "#,##0.00 ¤",
  "bs-Cyrl": "#,##0.00 ¤",
  "bs-Latn": "#,##0.00 ¤",
  ca: "#,##0.00 ¤;(#,##0.00 ¤)",
  "ca-AD": "#,##0.00 ¤;(#,##0.00 ¤)",
  "ca-ES-valencia": "#,##0.00 ¤;(#,##0.00 ¤)",
  "ca-FR": "#,##0.00 ¤;(#,##0.00 ¤)",
  "ca-IT": "#,##0.00 ¤;(#,##0.00 ¤)",
  ccp: "#,##,##0.00¤;(#,##,##0.00¤)",
  "ccp-IN": "#,##,##0.00¤;(#,##,##0.00¤)",
  ce: "#,##0.00 ¤",
  ceb: "¤#,##0.00;(¤#,##0.00)",
  cgg: "¤#,##0.00",
  chr: "¤#,##0.00;(¤#,##0.00)",
  ckb: "¤ #,##0.00",
  "ckb-IR": "¤ #,##0.00",
  cs: "#,##0.00 ¤",
  cy: "¤#,##0.00;(¤#,##0.00)",
  da: "#,##0.00 ¤",
  "da-GL": "#,##0.00 ¤",
  dav: "¤#,##0.00;(¤#,##0.00)",
  de: "#,##0.00 ¤",
  "de-AT": "#,##0.00 ¤",
  "de-BE": "#,##0.00 ¤",
  "de-CH": "#,##0.00 ¤",
  "de-IT": "#,##0.00 ¤",
  "de-LI": "#,##0.00 ¤",
  "de-LU": "#,##0.00 ¤",
  dje: "#,##0.00¤",
  doi: "¤#,##0.00",
  dsb: "#,##0.00 ¤",
  dua: "#,##0.00 ¤",
  dyo: "#,##0.00 ¤",
  dz: "¤#,##,##0.00",
  ebu: "¤#,##0.00;(¤#,##0.00)",
  ee: "¤#,##0.00;(¤#,##0.00)",
  "ee-TG": "¤#,##0.00;(¤#,##0.00)",
  el: "#,##0.00 ¤",
  "el-CY": "#,##0.00 ¤",
  en: "¤#,##0.00;(¤#,##0.00)",
  "en-001": "¤#,##0.00;(¤#,##0.00)",
  "en-150": "#,##0.00 ¤",
  "en-AE": "¤#,##0.00;(¤#,##0.00)",
  "en-AG": "¤#,##0.00;(¤#,##0.00)",
  "en-AI": "¤#,##0.00;(¤#,##0.00)",
  "en-AS": "¤#,##0.00;(¤#,##0.00)",
  "en-AT": "¤ #,##0.00",
  "en-AU": "¤#,##0.00;(¤#,##0.00)",
  "en-BB": "¤#,##0.00;(¤#,##0.00)",
  "en-BE": "#,##0.00 ¤",
  "en-BI": "¤#,##0.00;(¤#,##0.00)",
  "en-BM": "¤#,##0.00;(¤#,##0.00)",
  "en-BS": "¤#,##0.00;(¤#,##0.00)",
  "en-BW": "¤#,##0.00;(¤#,##0.00)",
  "en-BZ": "¤#,##0.00;(¤#,##0.00)",
  "en-CA": "¤#,##0.00;(¤#,##0.00)",
  "en-CC": "¤#,##0.00;(¤#,##0.00)",
  "en-CH": "¤ #,##0.00;¤-#,##0.00",
  "en-CK": "¤#,##0.00;(¤#,##0.00)",
  "en-CM": "¤#,##0.00;(¤#,##0.00)",
  "en-CX": "¤#,##0.00;(¤#,##0.00)",
  "en-CY": "¤#,##0.00;(¤#,##0.00)",
  "en-DE": "#,##0.00 ¤",
  "en-DG": "¤#,##0.00;(¤#,##0.00)",
  "en-DK": "#,##0.00 ¤",
  "en-DM": "¤#,##0.00;(¤#,##0.00)",
  "en-ER": "¤#,##0.00;(¤#,##0.00)",
  "en-FI": "#,##0.00 ¤",
  "en-FJ": "¤#,##0.00;(¤#,##0.00)",
  "en-FK": "¤#,##0.00;(¤#,##0.00)",
  "en-FM": "¤#,##0.00;(¤#,##0.00)",
  "en-GB": "¤#,##0.00;(¤#,##0.00)",
  "en-GD": "¤#,##0.00;(¤#,##0.00)",
  "en-GG": "¤#,##0.00;(¤#,##0.00)",
  "en-GH": "¤#,##0.00;(¤#,##0.00)",
  "en-GI": "¤#,##0.00;(¤#,##0.00)",
  "en-GM": "¤#,##0.00;(¤#,##0.00)",
  "en-GU": "¤#,##0.00;(¤#,##0.00)",
  "en-GY": "¤#,##0.00;(¤#,##0.00)",
  "en-HK": "¤#,##0.00;(¤#,##0.00)",
  "en-IE": "¤#,##0.00;(¤#,##0.00)",
  "en-IL": "¤#,##0.00;(¤#,##0.00)",
  "en-IM": "¤#,##0.00;(¤#,##0.00)",
  "en-IN": "¤#,##0.00;(¤#,##0.00)",
  "en-IO": "¤#,##0.00;(¤#,##0.00)",
  "en-JE": "¤#,##0.00;(¤#,##0.00)",
  "en-JM": "¤#,##0.00;(¤#,##0.00)",
  "en-KE": "¤#,##0.00;(¤#,##0.00)",
  "en-KI": "¤#,##0.00;(¤#,##0.00)",
  "en-KN": "¤#,##0.00;(¤#,##0.00)",
  "en-KY": "¤#,##0.00;(¤#,##0.00)",
  "en-LC": "¤#,##0.00;(¤#,##0.00)",
  "en-LR": "¤#,##0.00;(¤#,##0.00)",
  "en-LS": "¤#,##0.00;(¤#,##0.00)",
  "en-MG": "¤#,##0.00;(¤#,##0.00)",
  "en-MH": "¤#,##0.00;(¤#,##0.00)",
  "en-MO": "¤#,##0.00;(¤#,##0.00)",
  "en-MP": "¤#,##0.00;(¤#,##0.00)",
  "en-MS": "¤#,##0.00;(¤#,##0.00)",
  "en-MT": "¤#,##0.00;(¤#,##0.00)",
  "en-MU": "¤#,##0.00;(¤#,##0.00)",
  "en-MV": "¤ #,##0.00",
  "en-MW": "¤#,##0.00;(¤#,##0.00)",
  "en-MY": "¤#,##0.00;(¤#,##0.00)",
  "en-NA": "¤#,##0.00;(¤#,##0.00)",
  "en-NF": "¤#,##0.00;(¤#,##0.00)",
  "en-NG": "¤#,##0.00;(¤#,##0.00)",
  "en-NL": "¤ #,##0.00;(¤ #,##0.00)",
  "en-NR": "¤#,##0.00;(¤#,##0.00)",
  "en-NU": "¤#,##0.00;(¤#,##0.00)",
  "en-NZ": "¤#,##0.00;(¤#,##0.00)",
  "en-PG": "¤#,##0.00;(¤#,##0.00)",
  "en-PH": "¤#,##0.00;(¤#,##0.00)",
  "en-PK": "¤#,##0.00;(¤#,##0.00)",
  "en-PN": "¤#,##0.00;(¤#,##0.00)",
  "en-PR": "¤#,##0.00;(¤#,##0.00)",
  "en-PW": "¤#,##0.00;(¤#,##0.00)",
  "en-RW": "¤#,##0.00;(¤#,##0.00)",
  "en-SB": "¤#,##0.00;(¤#,##0.00)",
  "en-SC": "¤#,##0.00;(¤#,##0.00)",
  "en-SD": "¤#,##0.00;(¤#,##0.00)",
  "en-SE": "#,##0.00 ¤",
  "en-SG": "¤#,##0.00;(¤#,##0.00)",
  "en-SH": "¤#,##0.00;(¤#,##0.00)",
  "en-SI": "#,##0.00 ¤;(#,##0.00 ¤)",
  "en-SL": "¤#,##0.00;(¤#,##0.00)",
  "en-SS": "¤#,##0.00;(¤#,##0.00)",
  "en-SX": "¤#,##0.00;(¤#,##0.00)",
  "en-SZ": "¤#,##0.00;(¤#,##0.00)",
  "en-TC": "¤#,##0.00;(¤#,##0.00)",
  "en-TK": "¤#,##0.00;(¤#,##0.00)",
  "en-TO": "¤#,##0.00;(¤#,##0.00)",
  "en-TT": "¤#,##0.00;(¤#,##0.00)",
  "en-TV": "¤#,##0.00;(¤#,##0.00)",
  "en-TZ": "¤#,##0.00;(¤#,##0.00)",
  "en-UG": "¤#,##0.00;(¤#,##0.00)",
  "en-UM": "¤#,##0.00;(¤#,##0.00)",
  "en-VC": "¤#,##0.00;(¤#,##0.00)",
  "en-VG": "¤#,##0.00;(¤#,##0.00)",
  "en-VI": "¤#,##0.00;(¤#,##0.00)",
  "en-VU": "¤#,##0.00;(¤#,##0.00)",
  "en-WS": "¤#,##0.00;(¤#,##0.00)",
  "en-ZA": "¤#,##0.00;(¤#,##0.00)",
  "en-ZM": "¤#,##0.00;(¤#,##0.00)",
  "en-ZW": "¤#,##0.00;(¤#,##0.00)",
  eo: "¤ #,##0.00",
  es: "#,##0.00 ¤",
  "es-419": "¤#,##0.00",
  "es-AR": "¤ #,##0.00;(¤ #,##0.00)",
  "es-BO": "¤#,##0.00",
  "es-BR": "¤#,##0.00",
  "es-BZ": "¤#,##0.00",
  "es-CL": "¤#,##0.00",
  "es-CO": "¤#,##0.00",
  "es-CR": "¤#,##0.00",
  "es-CU": "¤#,##0.00",
  "es-DO": "¤#,##0.00;(¤#,##0.00)",
  "es-EA": "#,##0.00 ¤",
  "es-EC": "¤#,##0.00",
  "es-GQ": "#,##0.00 ¤",
  "es-GT": "¤#,##0.00",
  "es-HN": "¤#,##0.00",
  "es-IC": "#,##0.00 ¤",
  "es-MX": "¤#,##0.00",
  "es-NI": "¤#,##0.00",
  "es-PA": "¤#,##0.00",
  "es-PE": "¤#,##0.00",
  "es-PH": "#,##0.00 ¤",
  "es-PR": "¤#,##0.00",
  "es-PY": "¤#,##0.00",
  "es-SV": "¤#,##0.00",
  "es-US": "¤#,##0.00",
  "es-UY": "¤ #,##0.00;(¤ #,##0.00)",
  "es-VE": "¤#,##0.00",
  et: "#,##0.00 ¤;(#,##0.00 ¤)",
  eu: "#,##0.00 ¤;(#,##0.00 ¤)",
  ewo: "#,##0.00 ¤",
  fa: "‎¤ #,##0.00;‎(¤ #,##0.00)",
  "fa-AF": "¤ #,##0.00;‎(¤ #,##0.00)",
  ff: "#,##0.00 ¤",
  "ff-Adlm": "¤ #,##0.00",
  "ff-Adlm-BF": "¤ #,##0.00",
  "ff-Adlm-CM": "¤ #,##0.00",
  "ff-Adlm-GH": "¤ #,##0.00",
  "ff-Adlm-GM": "¤ #,##0.00",
  "ff-Adlm-GW": "¤ #,##0.00",
  "ff-Adlm-LR": "¤ #,##0.00",
  "ff-Adlm-MR": "¤ #,##0.00",
  "ff-Adlm-NE": "¤ #,##0.00",
  "ff-Adlm-NG": "¤ #,##0.00",
  "ff-Adlm-SL": "¤ #,##0.00",
  "ff-Adlm-SN": "¤ #,##0.00",
  "ff-Latn": "#,##0.00 ¤",
  "ff-Latn-BF": "#,##0.00 ¤",
  "ff-Latn-CM": "#,##0.00 ¤",
  "ff-Latn-GH": "#,##0.00 ¤",
  "ff-Latn-GM": "#,##0.00 ¤",
  "ff-Latn-GN": "#,##0.00 ¤",
  "ff-Latn-GW": "#,##0.00 ¤",
  "ff-Latn-LR": "#,##0.00 ¤",
  "ff-Latn-MR": "#,##0.00 ¤",
  "ff-Latn-NE": "#,##0.00 ¤",
  "ff-Latn-NG": "#,##0.00 ¤",
  "ff-Latn-SL": "#,##0.00 ¤",
  fi: "#,##0.00 ¤",
  fil: "¤#,##0.00;(¤#,##0.00)",
  fo: "#,##0.00 ¤;(#,##0.00 ¤)",
  "fo-DK": "#,##0.00 ¤;(#,##0.00 ¤)",
  fr: "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-BE": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-BF": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-BI": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-BJ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-BL": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CA": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CD": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CF": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CG": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CH": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CI": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-CM": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-DJ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-DZ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-GA": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-GF": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-GN": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-GP": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-GQ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-HT": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-KM": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-LU": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MA": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MC": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MF": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MG": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-ML": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MQ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MR": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-MU": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-NC": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-NE": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-PF": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-PM": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-RE": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-RW": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-SC": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-SN": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-SY": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-TD": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-TG": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-TN": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-VU": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-WF": "#,##0.00 ¤;(#,##0.00 ¤)",
  "fr-YT": "#,##0.00 ¤;(#,##0.00 ¤)",
  fur: "¤ #,##0.00",
  fy: "¤ #,##0.00;(¤ #,##0.00)",
  ga: "¤#,##0.00;(¤#,##0.00)",
  "ga-GB": "¤#,##0.00;(¤#,##0.00)",
  gd: "¤#,##0.00;(¤#,##0.00)",
  gl: "#,##0.00 ¤",
  gsw: "#,##0.00 ¤",
  "gsw-FR": "#,##0.00 ¤",
  "gsw-LI": "#,##0.00 ¤",
  gu: "¤#,##,##0.00;(¤#,##,##0.00)",
  guz: "¤#,##0.00;(¤#,##0.00)",
  gv: "¤#,##0.00",
  ha: "¤ #,##0.00",
  "ha-GH": "¤ #,##0.00",
  "ha-NE": "¤ #,##0.00",
  haw: "¤#,##0.00;(¤#,##0.00)",
  he: "#,##0.00 ¤",
  hi: "¤#,##,##0.00",
  "hi-Latn": "¤#,##,##0.00",
  hr: "#,##0.00 ¤",
  "hr-BA": "#,##0.00 ¤",
  hsb: "#,##0.00 ¤",
  hu: "#,##0.00 ¤",
  hy: "#,##0.00 ¤",
  ia: "¤ #,##0.00;(¤ #,##0.00)",
  id: "¤#,##0.00",
  ig: "¤#,##0.00;(¤#,##0.00)",
  ii: "¤ #,##0.00",
  is: "#,##0.00 ¤",
  it: "#,##0.00 ¤",
  "it-CH": "#,##0.00 ¤",
  "it-SM": "#,##0.00 ¤",
  "it-VA": "#,##0.00 ¤",
  ja: "¤#,##0.00;(¤#,##0.00)",
  jgo: "¤ #,##0.00",
  jmc: "¤#,##0.00",
  jv: "¤ #,##0.00",
  ka: "#,##0.00 ¤",
  kab: "#,##0.00¤",
  kam: "¤#,##0.00;(¤#,##0.00)",
  kde: "¤#,##0.00;(¤#,##0.00)",
  kea: "#,##0.00 ¤;(#,##0.00 ¤)",
  kgp: "¤ #,##0.00",
  khq: "#,##0.00¤",
  ki: "¤#,##0.00;(¤#,##0.00)",
  kk: "#,##0.00 ¤",
  kkj: "¤ #,##0.00",
  kl: "¤#,##0.00;¤-#,##0.00",
  kln: "¤#,##0.00;(¤#,##0.00)",
  km: "#,##0.00¤;(#,##0.00¤)",
  kn: "¤#,##0.00;(¤#,##0.00)",
  ko: "¤#,##0.00;(¤#,##0.00)",
  "ko-KP": "¤#,##0.00;(¤#,##0.00)",
  kok: "¤#,##0.00;(¤#,##0.00)",
  ks: "¤#,##0.00",
  "ks-Arab": "¤#,##0.00",
  "ks-Deva": "¤ #,##0.00",
  ksb: "#,##0.00¤",
  ksf: "#,##0.00 ¤",
  ksh: "#,##0.00 ¤",
  ku: "#,##0.00 ¤;(#,##0.00 ¤)",
  kw: "¤#,##0.00",
  ky: "#,##0.00 ¤",
  lag: "¤ #,##0.00",
  lb: "#,##0.00 ¤",
  lg: "#,##0.00¤",
  lkt: "¤ #,##0.00",
  ln: "#,##0.00 ¤",
  "ln-AO": "#,##0.00 ¤",
  "ln-CF": "#,##0.00 ¤",
  "ln-CG": "#,##0.00 ¤",
  lo: "¤#,##0.00;¤-#,##0.00",
  lrc: "¤ #,##0.00",
  "lrc-IQ": "¤ #,##0.00",
  lt: "#,##0.00 ¤",
  lu: "#,##0.00¤",
  luo: "#,##0.00¤",
  luy: "¤#,##0.00;¤- #,##0.00",
  lv: "#,##0.00 ¤",
  mai: "¤ #,##0.00",
  mas: "¤#,##0.00;(¤#,##0.00)",
  "mas-TZ": "¤#,##0.00;(¤#,##0.00)",
  mer: "¤#,##0.00;(¤#,##0.00)",
  mfe: "¤ #,##0.00",
  mg: "¤#,##0.00",
  mgh: "¤ #,##0.00",
  mgo: "¤ #,##0.00",
  mi: "¤ #,##0.00",
  mk: "#,##0.00 ¤",
  ml: "¤#,##0.00;(¤#,##0.00)",
  mn: "¤ #,##0.00",
  mni: "¤ #,##0.00",
  "mni-Beng": "¤ #,##0.00",
  mr: "¤#,##0.00;(¤#,##0.00)",
  ms: "¤#,##0.00;(¤#,##0.00)",
  "ms-BN": "¤#,##0.00;(¤#,##0.00)",
  "ms-ID": "¤#,##0.00",
  "ms-SG": "¤#,##0.00;(¤#,##0.00)",
  mt: "¤#,##0.00",
  mua: "¤#,##0.00;(¤#,##0.00)",
  my: "¤ #,##0.00",
  mzn: "¤ #,##0.00",
  naq: "¤#,##0.00",
  nb: "¤ #,##0.00;(¤ #,##0.00)",
  "nb-SJ": "¤ #,##0.00;(¤ #,##0.00)",
  nd: "¤#,##0.00;(¤#,##0.00)",
  nds: "¤ #,##0.00",
  "nds-NL": "¤ #,##0.00",
  ne: "¤ #,##,##0.00",
  "ne-IN": "¤ #,##,##0.00",
  nl: "¤ #,##0.00;(¤ #,##0.00)",
  "nl-AW": "¤ #,##0.00;(¤ #,##0.00)",
  "nl-BE": "¤ #,##0.00;(¤ #,##0.00)",
  "nl-BQ": "¤ #,##0.00;(¤ #,##0.00)",
  "nl-CW": "¤ #,##0.00;(¤ #,##0.00)",
  "nl-SR": "¤ #,##0.00;(¤ #,##0.00)",
  "nl-SX": "¤ #,##0.00;(¤ #,##0.00)",
  nmg: "#,##0.00 ¤",
  nn: "#,##0.00 ¤",
  nnh: "¤ #,##0.00",
  no: "¤ #,##0.00;(¤ #,##0.00)",
  nus: "¤#,##0.00;(¤#,##0.00)",
  nyn: "¤#,##0.00",
  om: "¤#,##0.00",
  "om-KE": "¤#,##0.00",
  or: "¤#,##0.00;(¤#,##0.00)",
  os: "¤ #,##0.00",
  "os-RU": "¤ #,##0.00",
  pa: "¤ #,##0.00",
  "pa-Arab": "¤ #,##0.00",
  "pa-Guru": "¤ #,##0.00",
  pcm: "¤#,##0.00",
  pl: "#,##0.00 ¤;(#,##0.00 ¤)",
  ps: "¤#,##0.00;(¤#,##0.00)",
  "ps-PK": "¤#,##0.00;(¤#,##0.00)",
  pt: "¤ #,##0.00",
  "pt-AO": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-CH": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-CV": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-GQ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-GW": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-LU": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-MO": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-MZ": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-PT": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-ST": "#,##0.00 ¤;(#,##0.00 ¤)",
  "pt-TL": "#,##0.00 ¤;(#,##0.00 ¤)",
  qu: "¤ #,##0.00",
  "qu-BO": "¤ #,##0.00",
  "qu-EC": "¤ #,##0.00",
  rm: "#,##0.00 ¤",
  rn: "#,##0.00¤",
  ro: "#,##0.00 ¤;(#,##0.00 ¤)",
  "ro-MD": "#,##0.00 ¤;(#,##0.00 ¤)",
  rof: "¤#,##0.00",
  ru: "#,##0.00 ¤",
  "ru-BY": "#,##0.00 ¤",
  "ru-KG": "#,##0.00 ¤",
  "ru-KZ": "#,##0.00 ¤",
  "ru-MD": "#,##0.00 ¤",
  "ru-UA": "#,##0.00 ¤",
  rw: "¤ #,##0.00",
  rwk: "#,##0.00¤",
  sa: "¤ #,##0.00",
  sah: "#,##0.00 ¤",
  saq: "¤#,##0.00;(¤#,##0.00)",
  sat: "¤ #,##0.00",
  "sat-Olck": "¤ #,##0.00",
  sbp: "#,##0.00¤",
  sc: "#,##0.00 ¤",
  sd: "¤ #,##0.00",
  "sd-Arab": "¤ #,##0.00",
  "sd-Deva": "¤ #,##0.00",
  se: "#,##0.00 ¤",
  "se-FI": "#,##0.00 ¤",
  "se-SE": "#,##0.00 ¤",
  seh: "#,##0.00¤",
  ses: "#,##0.00¤",
  sg: "¤#,##0.00;¤-#,##0.00",
  shi: "#,##0.00¤",
  "shi-Latn": "#,##0.00¤",
  "shi-Tfng": "#,##0.00¤",
  si: "¤#,##0.00;(¤#,##0.00)",
  sk: "#,##0.00 ¤;(#,##0.00 ¤)",
  sl: "#,##0.00 ¤;(#,##0.00 ¤)",
  smn: "#,##0.00 ¤",
  sn: "¤#,##0.00;(¤#,##0.00)",
  so: "¤#,##0.00;(¤#,##0.00)",
  "so-DJ": "¤#,##0.00;(¤#,##0.00)",
  "so-ET": "¤#,##0.00;(¤#,##0.00)",
  "so-KE": "¤#,##0.00;(¤#,##0.00)",
  sq: "#,##0.00 ¤;(#,##0.00 ¤)",
  "sq-MK": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sq-XK": "#,##0.00 ¤;(#,##0.00 ¤)",
  sr: "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Cyrl": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Cyrl-BA": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Cyrl-ME": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Cyrl-XK": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Latn": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Latn-BA": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Latn-ME": "#,##0.00 ¤;(#,##0.00 ¤)",
  "sr-Latn-XK": "#,##0.00 ¤;(#,##0.00 ¤)",
  su: "¤#,##0.00",
  "su-Latn": "¤#,##0.00",
  sv: "#,##0.00 ¤",
  "sv-AX": "#,##0.00 ¤",
  "sv-FI": "#,##0.00 ¤",
  sw: "¤ #,##0.00",
  "sw-CD": "¤ #,##0.00",
  "sw-KE": "¤ #,##0.00",
  "sw-UG": "¤ #,##0.00",
  ta: "¤#,##0.00;(¤#,##0.00)",
  "ta-LK": "¤#,##0.00;(¤#,##0.00)",
  "ta-MY": "¤#,##0.00;(¤#,##0.00)",
  "ta-SG": "¤#,##0.00;(¤#,##0.00)",
  te: "¤#,##0.00;(¤#,##0.00)",
  teo: "¤#,##0.00;(¤#,##0.00)",
  "teo-KE": "¤#,##0.00;(¤#,##0.00)",
  tg: "#,##0.00 ¤",
  th: "¤#,##0.00;(¤#,##0.00)",
  ti: "¤#,##0.00",
  "ti-ER": "¤#,##0.00",
  tk: "#,##0.00 ¤",
  to: "¤ #,##0.00",
  tr: "¤#,##0.00;(¤#,##0.00)",
  "tr-CY": "¤#,##0.00;(¤#,##0.00)",
  tt: "#,##0.00 ¤",
  twq: "#,##0.00¤",
  tzm: "#,##0.00 ¤",
  ug: "¤#,##0.00;(¤#,##0.00)",
  uk: "#,##0.00 ¤",
  und: "¤ #,##0.00",
  ur: "¤#,##0.00;(¤#,##0.00)",
  "ur-IN": "¤#,##0.00;(¤#,##0.00)",
  uz: "#,##0.00 ¤",
  "uz-Arab": "¤ #,##0.00",
  "uz-Cyrl": "#,##0.00 ¤",
  "uz-Latn": "#,##0.00 ¤",
  vai: "¤#,##0.00;(¤#,##0.00)",
  "vai-Latn": "¤#,##0.00;(¤#,##0.00)",
  "vai-Vaii": "¤#,##0.00;(¤#,##0.00)",
  vi: "#,##0.00 ¤",
  vun: "¤#,##0.00",
  wae: "¤ #,##0.00",
  wo: "¤ #,##0.00",
  xh: "¤#,##0.00",
  xog: "#,##0.00 ¤",
  yav: "#,##0.00 ¤;(#,##0.00 ¤)",
  yi: "¤ #,##0.00",
  yo: "¤#,##0.00;(¤#,##0.00)",
  "yo-BJ": "¤#,##0.00;(¤#,##0.00)",
  yrl: "¤ #,##0.00",
  "yrl-CO": "¤ #,##0.00",
  "yrl-VE": "¤ #,##0.00",
  yue: "¤#,##0.00;(¤#,##0.00)",
  "yue-Hans": "¤#,##0.00;(¤#,##0.00)",
  "yue-Hant": "¤#,##0.00;(¤#,##0.00)",
  zgh: "#,##0.00¤",
  zh: "¤#,##0.00;(¤#,##0.00)",
  "zh-Hans": "¤#,##0.00;(¤#,##0.00)",
  "zh-Hans-HK": "¤#,##0.00;(¤#,##0.00)",
  "zh-Hans-MO": "¤#,##0.00;(¤#,##0.00)",
  "zh-Hans-SG": "¤#,##0.00;(¤#,##0.00)",
  "zh-Hant": "¤#,##0.00;(¤#,##0.00)",
  "zh-Hant-HK": "¤#,##0.00;(¤#,##0.00)",
  "zh-Hant-MO": "¤#,##0.00;(¤#,##0.00)",
  zu: "¤#,##0.00;(¤#,##0.00)"
};
var wee = ["standard", "accounting"], Aee = 20, Oee = /([^\s0]+)?(\s*)0*[.,]*0*(\s*)([^\s0]+)?/, ok = {}, fB = (e) => {
  var t = Ka.locale() + "/" + JSON.stringify(e);
  return ok[t] || (ok[t] = new Intl.NumberFormat(Ka.locale(), e).format), ok[t];
}, kee = (e) => new Intl.NumberFormat(Ka.locale(), {
  style: "currency",
  currency: e
});
const Ree = {
  engine: function() {
    return "intl";
  },
  _formatNumberCore: function(e, t, r) {
    return t === "exponential" ? this.callBase.apply(this, arguments) : fB(this._normalizeFormatConfig(t, r, e))(e);
  },
  _normalizeFormatConfig: function(e, t, r) {
    var n;
    if (e === "decimal") {
      var i = String(r).split(".")[1];
      n = {
        minimumIntegerDigits: t.precision || void 0,
        useGrouping: !1,
        maximumFractionDigits: i && i.length,
        round: r < 0 ? "ceil" : "floor"
      };
    } else
      n = this._getPrecisionConfig(t.precision);
    if (e === "percent")
      n.style = "percent";
    else if (e === "currency") {
      var s, l = (s = t.useCurrencyAccountingStyle) !== null && s !== void 0 ? s : Zr().defaultUseCurrencyAccountingStyle;
      n.style = "currency", n.currency = t.currency || Zr().defaultCurrency, n.currencySign = wee[+l];
    }
    return n;
  },
  _getPrecisionConfig: function(e) {
    var t;
    return e === null ? t = {
      minimumFractionDigits: 0,
      maximumFractionDigits: Aee
    } : t = {
      minimumFractionDigits: e || 0,
      maximumFractionDigits: e || 0
    }, t;
  },
  format: function(e, t) {
    return typeof e != "number" ? e : (t = this._normalizeFormat(t), t.currency === "default" && (t.currency = Zr().defaultCurrency), !t || typeof t != "function" && !t.type && !t.formatter ? fB(t)(e) : this.callBase.apply(this, arguments));
  },
  _getCurrencySymbolInfo: function(e) {
    var t = kee(e);
    return this._extractCurrencySymbolInfo(t.format(0));
  },
  _extractCurrencySymbolInfo: function(e) {
    var t = Oee.exec(e) || [], r = t[1] ? "before" : "after", n = t[1] || t[4] || "", i = t[2] || t[3] || "";
    return {
      position: r,
      symbol: n,
      delimiter: i
    };
  },
  getCurrencySymbol: function(e) {
    e || (e = Zr().defaultCurrency);
    var t = this._getCurrencySymbolInfo(e);
    return {
      symbol: t.symbol
    };
  },
  getOpenXmlCurrencyFormat: function(e) {
    var t = e || Zr().defaultCurrency, r = this._getCurrencySymbolInfo(t).symbol, n = Ka.getValueByClosestLocale((i) => Tee[i]);
    return Eee(r, n);
  }
};
var Dee = typeof Intl < "u", Mee = 4, rC = 10, hB = ["currency", "fixedpoint", "exponential", "percent", "decimal"], sk = {
  1: "K",
  2: "M",
  3: "B",
  4: "T"
}, vB = {
  largenumber: "auto",
  thousands: 1,
  millions: 2,
  billions: 3,
  trillions: 4
}, Ho = Fs({
  engine: function() {
    return "base";
  },
  numericFormats: hB,
  defaultLargeNumberFormatPostfixes: sk,
  _parseNumberFormatString: function(e) {
    var t = {};
    if (!(!e || typeof e != "string")) {
      var r = e.toLowerCase().split(" ");
      if (be(r, (n, i) => {
        hB.includes(i) ? t.formatType = i : i in vB && (t.power = vB[i]);
      }), t.power && !t.formatType && (t.formatType = "fixedpoint"), t.formatType)
        return t;
    }
  },
  _calculateNumberPower: function(e, t, r, n) {
    var i = Math.abs(e), s = 0;
    if (i > 1)
      for (; i && i >= t && (n === void 0 || s < n); )
        s++, i /= t;
    else if (i > 0 && i < 1)
      for (; i < 1 && (r === void 0 || s > r); )
        s--, i *= t;
    return s;
  },
  _getNumberByPower: function(e, t, r) {
    for (var n = e; t > 0; )
      n /= r, t--;
    for (; t < 0; )
      n *= r, t++;
    return n;
  },
  _formatNumber: function(e, t, r) {
    t.power === "auto" && (t.power = this._calculateNumberPower(e, 1e3, 0, Mee)), t.power && (e = this._getNumberByPower(e, t.power, 1e3));
    var n = this.defaultLargeNumberFormatPostfixes[t.power] || "", i = this._formatNumberCore(e, t.formatType, r);
    return i = i.replace(/(\d|.$)(\D*)$/, "$1" + n + "$2"), i;
  },
  _formatNumberExponential: function(e, t) {
    var r = this._calculateNumberPower(e, rC), n = this._getNumberByPower(e, r, rC);
    t.precision === void 0 && (t.precision = 1), n.toFixed(t.precision || 0) >= rC && (r++, n /= rC);
    var i = (r >= 0 ? "+" : "") + r.toString();
    return this._formatNumberCore(n, "fixedpoint", t) + "E" + i;
  },
  _addZeroes: function(e, t) {
    var r = Math.pow(10, t), n = e < 0 ? "-" : "";
    e = (Math.abs(e) * r >>> 0) / r;
    for (var i = e.toString(); i.length < t; )
      i = "0" + i;
    return n + i;
  },
  _addGroupSeparators: function(e) {
    var t = e.toString().split(".");
    return t[0].replace(/\B(?=(\d{3})+(?!\d))/g, Zr().thousandsSeparator) + (t[1] ? Zr().decimalSeparator + t[1] : "");
  },
  _formatNumberCore: function(e, t, r) {
    return t === "exponential" ? this._formatNumberExponential(e, r) : (t !== "decimal" && r.precision !== null && (r.precision = r.precision || 0), t === "percent" && (e *= 100), r.precision !== void 0 && (t === "decimal" ? e = this._addZeroes(e, r.precision) : e = r.precision === null ? e.toPrecision() : G3(e, r.precision)), t !== "decimal" ? e = this._addGroupSeparators(e) : e = e.toString().replace(".", Zr().decimalSeparator), t === "percent" && (e += "%"), e);
  },
  _normalizeFormat: function(e) {
    return e ? (typeof e == "function" || Qr(e) || (e = {
      type: e
    }), e) : {};
  },
  _getSeparators: function() {
    return {
      decimalSeparator: this.getDecimalSeparator(),
      thousandsSeparator: this.getThousandsSeparator()
    };
  },
  getThousandsSeparator: function() {
    return this.format(1e4, "fixedPoint")[2];
  },
  getDecimalSeparator: function() {
    return this.format(1.2, {
      type: "fixedPoint",
      precision: 1
    })[1];
  },
  convertDigits: function(e, t) {
    var r = this.format(90, "decimal");
    if (typeof e != "string" || r[1] === "0")
      return e;
    var n = t ? r[1] : "0", i = t ? "0" : r[1], s = t ? r[0] : "9", l = new RegExp("[" + n + "-" + s + "]", "g");
    return e.replace(l, (d) => String.fromCharCode(d.charCodeAt(0) + (i.charCodeAt(0) - n.charCodeAt(0))));
  },
  getNegativeEtalonRegExp: function(e) {
    var t = this._getSeparators(), r = new RegExp("[0-9" + bE(t.decimalSeparator + t.thousandsSeparator) + "]+", "g"), n = this.format(-1, e).replace(r, "1");
    return ["\\", "(", ")", "[", "]", "*", "+", "$", "^", "?", "|", "{", "}"].forEach((i) => {
      n = n.replace(new RegExp("\\".concat(i), "g"), "\\".concat(i));
    }), n = n.replace(/ /g, "\\s"), n = n.replace(/1/g, ".*"), new RegExp(n, "g");
  },
  getSign: function(e, t) {
    if (!t)
      return e.replace(/[^0-9-]/g, "").charAt(0) === "-" ? -1 : 1;
    var r = this.getNegativeEtalonRegExp(t);
    return e.match(r) ? -1 : 1;
  },
  format: function(e, t) {
    if (typeof e != "number" || typeof t == "number")
      return e;
    if (t = t && t.formatter || t, typeof t == "function")
      return t(e);
    t = this._normalizeFormat(t), t.type || (t.type = "decimal");
    var r = this._parseNumberFormatString(t.type);
    if (!r) {
      var n = this._getSeparators();
      return n.unlimitedIntegerDigits = t.unlimitedIntegerDigits, this.convertDigits(yee(t.type, n)(e));
    }
    return this._formatNumber(e, r, t);
  },
  parse: function(e, t) {
    if (e) {
      if (t && t.parser)
        return t.parser(e);
      e = this.convertDigits(e, !0), t && typeof t != "string" && Dr.log("W0011");
      var r = this.getDecimalSeparator(), n = new RegExp("[^0-9" + bE(r) + "]", "g"), i = e.replace(n, "").replace(r, ".").replace(/\.$/g, "");
      if (i === "." || i === "")
        return null;
      if (this._calcSignificantDigits(i) > 15)
        return NaN;
      var s = +i * this.getSign(e, t);
      t = this._normalizeFormat(t);
      var l = this._parseNumberFormatString(t.type), d = l == null ? void 0 : l.power;
      if (d) {
        if (d === "auto") {
          var h = e.match(/\d(K|M|B|T)/);
          h && (d = Object.keys(sk).find((p) => sk[p] === h[1]));
        }
        s *= Math.pow(10, 3 * d);
      }
      return (l == null ? void 0 : l.formatType) === "percent" && (s /= 100), s;
    }
  },
  _calcSignificantDigits: function(e) {
    var [t, r] = e.split("."), n = (s) => {
      for (var l = -1, d = 0; d < s.length; d++)
        if (s[d] !== "0") {
          l = d;
          break;
        }
      return l > -1 ? s.length - l : 0;
    }, i = 0;
    return t && (i += n(t.split(""))), r && (i += n(r.split("").reverse())), i;
  }
});
Ho.inject(xee);
Dee && Ho.inject(Ree);
function Mo(e, t) {
  for (; e.length < t; )
    e = "0" + e;
  return e;
}
var T_ = {
  3: "abbreviated",
  4: "wide",
  5: "narrow"
}, lD = {
  y: function(e, t, r) {
    var n = e[r ? "getUTCFullYear" : "getFullYear"]();
    return t === 2 && (n %= 100), Mo(n.toString(), t);
  },
  M: function(e, t, r, n) {
    var i = e[r ? "getUTCMonth" : "getMonth"](), s = T_[t];
    return s ? n.getMonthNames(s, "format")[i] : Mo((i + 1).toString(), Math.min(t, 2));
  },
  L: function(e, t, r, n) {
    var i = e[r ? "getUTCMonth" : "getMonth"](), s = T_[t];
    return s ? n.getMonthNames(s, "standalone")[i] : Mo((i + 1).toString(), Math.min(t, 2));
  },
  Q: function(e, t, r, n) {
    var i = e[r ? "getUTCMonth" : "getMonth"](), s = Math.floor(i / 3), l = T_[t];
    return l ? n.getQuarterNames(l)[s] : Mo((s + 1).toString(), Math.min(t, 2));
  },
  E: function(e, t, r, n) {
    var i = e[r ? "getUTCDay" : "getDay"](), s = T_[t < 3 ? 3 : t];
    return n.getDayNames(s)[i];
  },
  a: function(e, t, r, n) {
    var i = e[r ? "getUTCHours" : "getHours"](), s = i < 12 ? 0 : 1, l = T_[t];
    return n.getPeriodNames(l)[s];
  },
  d: function(e, t, r) {
    return Mo(e[r ? "getUTCDate" : "getDate"]().toString(), Math.min(t, 2));
  },
  H: function(e, t, r) {
    return Mo(e[r ? "getUTCHours" : "getHours"]().toString(), Math.min(t, 2));
  },
  h: function(e, t, r) {
    var n = e[r ? "getUTCHours" : "getHours"]();
    return Mo((n % 12 || 12).toString(), Math.min(t, 2));
  },
  m: function(e, t, r) {
    return Mo(e[r ? "getUTCMinutes" : "getMinutes"]().toString(), Math.min(t, 2));
  },
  s: function(e, t, r) {
    return Mo(e[r ? "getUTCSeconds" : "getSeconds"]().toString(), Math.min(t, 2));
  },
  S: function(e, t, r) {
    return Mo(e[r ? "getUTCMilliseconds" : "getMilliseconds"]().toString(), 3).substr(0, t);
  },
  x: function(e, t, r) {
    var n = r ? 0 : e.getTimezoneOffset(), i = n > 0 ? "-" : "+", s = Math.abs(n), l = Math.floor(s / 60), d = s % 60, h = Mo(l.toString(), 2), p = Mo(d.toString(), 2);
    return i + h + (t >= 3 ? ":" : "") + (t > 1 || d ? p : "");
  },
  X: function(e, t, r) {
    return r || !e.getTimezoneOffset() ? "Z" : lD.x(e, t, r);
  },
  Z: function(e, t, r) {
    return lD.X(e, t >= 5 ? 3 : 2, r);
  }
}, j3 = function(e, t) {
  return function(r) {
    var n, i, s, l = 0, d = !1, h, p = "";
    if (!r)
      return null;
    if (!e)
      return r;
    var m = e[e.length - 1] === "Z" || e.slice(-3) === "'Z'";
    for (n = 0; n < e.length; n++)
      s = e[n], i = lD[s], h = s === e[n + 1], l++, h || (i && !d && (p += i(r, l, m, t)), l = 0), s === "'" && !h ? d = !d : (d || !i) && (p += s), s === "'" && h && n++;
    return p;
  };
}, Lee = "،", $3 = " .,:;/\\<>()-[]" + Lee, Pee = ". m.", Id = function(e) {
  var t = e && Ho.convertDigits(e, !1).charCodeAt(0), r = Ho.convertDigits("0", !1).charCodeAt(0);
  return r <= t && t < r + 10;
}, Iee = function(e, t, r, n) {
  var i = e[r], s = e[r + 1];
  if (!n && (i === "." || i === " " && e.slice(r - 1, r + 3) === Pee || i === "-" && !Id(s)))
    return !0;
  var l = n && t.some((d) => e[r] !== d[r]);
  return $3.indexOf(i) < 0 && n === Id(i) && (!n || l);
}, Nee = function(e, t) {
  if (!Id(e[t]))
    for (; t > 0 && !Id(e[t - 1]) && (e[t - 1] === "." || $3.indexOf(e[t - 1]) < 0); )
      t--;
  return t;
}, Vee = function(e, t, r, n) {
  var i = 0, s = [], l = function(d) {
    return e[i] !== d[i] && (n === void 0 || Id(e[i]) === n);
  };
  for (Array.isArray(t) || (t = [t]), i = 0; i < e.length; i++)
    if (r.indexOf(i) < 0 && t.filter(l).length) {
      i = Nee(e, i);
      do {
        if (n = Id(e[i]), !s.length && !n && Id(t[0][i]))
          break;
        s.push(i), r.unshift(i), i++;
      } while (e[i] && Iee(e, t, i, n));
      break;
    }
  return s.length === 1 && (e[r[0] - 1] === "0" || e[r[0] - 1] === "٠") && r.unshift(r[0] - 1), s;
}, Fee = function(e, t, r, n) {
  var i = t[0], s = i < n.length ? n[i] : i;
  return t.forEach(function(l, d) {
    e = e.substr(0, s + d) + (r.length > 1 ? r[d] : r) + e.substr(s + d + 1);
  }), t.length === 1 && (e = e.replace("0" + r, r + r), e = e.replace("٠" + r, r + r)), e;
}, Bee = function(e, t, r, n) {
  var i, s, l;
  if (!Id(e[t[0]] || "0")) {
    for (var d = Math.max(t.length <= 3 ? 3 : 4, r.length); t.length > d; ) {
      for (s = t.pop(), l = n[s], n[s] = -1, i = s + 1; i < n.length; i++)
        n[i]--;
      e = e.substr(0, l) + e.substr(l + 1);
    }
    for (s = t[t.length - 1] + 1, l = s < n.length ? n[s] : s; t.length < d; ) {
      for (t.push(t[t.length - 1] + 1), i = s; i < n.length; i++)
        n[i]++;
      e = e.substr(0, l) + " " + e.substr(l);
    }
  }
  return e = Fee(e, t, r, n), e;
}, pB = function(e, t) {
  return Array.isArray(e) ? e.map(function(r) {
    return (t(r) || "").toString();
  }) : (t(e) || "").toString();
}, zee = /[a-zA-Z]/g, Hee = function(e, t, r, n) {
  var i = t.split("").map(function(s, l) {
    return r.indexOf(l) < 0 && (s.match(zee) || s === "'") ? n[l] : -1;
  });
  return e = e.split("").map(function(s, l) {
    var d = s, h = i.indexOf(l) >= 0, p = l > 0 && i.indexOf(l - 1) >= 0, m = i.indexOf(l + 1) >= 0;
    return h && (p || (d = "'" + d), m || (d += "'")), d;
  }).join(""), e;
}, Gee = function(e) {
  var t = [], r = pB(new Date(2009, 8, 8, 6, 5, 4), e), n = r.split("").map(function(d, h) {
    return h;
  }), i = r, s = {}, l = [{
    date: new Date(2009, 8, 8, 6, 5, 4, 111),
    pattern: "S"
  }, {
    date: new Date(2009, 8, 8, 6, 5, 2),
    pattern: "s"
  }, {
    date: new Date(2009, 8, 8, 6, 2, 4),
    pattern: "m"
  }, {
    date: new Date(2009, 8, 8, 18, 5, 4),
    pattern: "H",
    isDigit: !0
  }, {
    date: new Date(2009, 8, 8, 2, 5, 4),
    pattern: "h",
    isDigit: !0
  }, {
    date: new Date(2009, 8, 8, 18, 5, 4),
    pattern: "a",
    isDigit: !1
  }, {
    date: new Date(2009, 8, 1, 6, 5, 4),
    pattern: "d"
  }, {
    date: [new Date(2009, 8, 2, 6, 5, 4), new Date(2009, 8, 3, 6, 5, 4), new Date(2009, 8, 4, 6, 5, 4)],
    pattern: "E"
  }, {
    date: new Date(2009, 9, 6, 6, 5, 4),
    pattern: "M"
  }, {
    date: new Date(1998, 8, 8, 6, 5, 4),
    pattern: "y"
  }];
  if (i && (l.forEach(function(d) {
    var h = Vee(r, pB(d.date, e), t, d.isDigit), p = d.pattern === "M" && !s.d ? "L" : d.pattern;
    i = Bee(i, h, p, n), s[p] = h.length;
  }), i = Hee(i, r, t, n), t.length))
    return i;
}, Zu = {
  3: "abbreviated",
  4: "wide",
  5: "narrow"
}, gB = function(e, t) {
  return e > 2 ? Object.keys(Zu).map(function(r) {
    return ["format", "standalone"].map(function(n) {
      return t.getMonthNames(Zu[r], n).join("|");
    }).join("|");
  }).join("|") : e === 2 ? "1[012]|0?[1-9]" : "0??[1-9]|1[012]";
}, Uee = {
  ":": function(e, t) {
    var r = e > 1 ? "{".concat(e, "}") : "", n = bE(t.getTimeSeparator());
    return n !== ":" && (n = "".concat(n, "|:")), "".concat(n).concat(r);
  },
  y: function(e) {
    return e === 2 ? "[0-9]{".concat(e, "}") : "[0-9]+?";
  },
  M: gB,
  L: gB,
  Q: function(e, t) {
    return e > 2 ? t.getQuarterNames(Zu[e], "format").join("|") : "0?[1-4]";
  },
  E: function(e, t) {
    return "\\D*";
  },
  a: function(e, t) {
    return t.getPeriodNames(Zu[e < 3 ? 3 : e], "format").join("|");
  },
  d: function(e) {
    return e === 2 ? "3[01]|[12][0-9]|0?[1-9]" : "0??[1-9]|[12][0-9]|3[01]";
  },
  H: function(e) {
    return e === 2 ? "2[0-3]|1[0-9]|0?[0-9]" : "0??[0-9]|1[0-9]|2[0-3]";
  },
  h: function(e) {
    return e === 2 ? "1[012]|0?[1-9]" : "0??[1-9]|1[012]";
  },
  m: function(e) {
    return e === 2 ? "[1-5][0-9]|0?[0-9]" : "0??[0-9]|[1-5][0-9]";
  },
  s: function(e) {
    return e === 2 ? "[1-5][0-9]|0?[0-9]" : "0??[0-9]|[1-5][0-9]";
  },
  S: function(e) {
    return "[0-9]{1,".concat(e, "}");
  },
  w: function(e) {
    return e === 2 ? "[1-5][0-9]|0?[0-9]" : "0??[0-9]|[1-5][0-9]";
  }
}, Fu = Number, uD = function(e, t) {
  return e.map((r) => r.toLowerCase()).indexOf(t.toLowerCase());
}, mB = function(e, t, r) {
  return t > 2 ? ["format", "standalone"].map(function(n) {
    return Object.keys(Zu).map(function(i) {
      var s = r.getMonthNames(Zu[i], n);
      return uD(s, e);
    });
  }).reduce(function(n, i) {
    return n.concat(i);
  }).filter(function(n) {
    return n >= 0;
  })[0] : Fu(e) - 1;
}, jee = {
  y: function(e, t) {
    var r = Fu(e);
    return t === 2 ? r < 30 ? 2e3 + r : 1900 + r : r;
  },
  M: mB,
  L: mB,
  Q: function(e, t, r) {
    return t > 2 ? r.getQuarterNames(Zu[t], "format").indexOf(e) : Fu(e) - 1;
  },
  E: function(e, t, r) {
    var n = r.getDayNames(Zu[t < 3 ? 3 : t], "format");
    return uD(n, e);
  },
  a: function(e, t, r) {
    var n = r.getPeriodNames(Zu[t < 3 ? 3 : t], "format");
    return uD(n, e);
  },
  d: Fu,
  H: Fu,
  h: Fu,
  m: Fu,
  s: Fu,
  S: function(e, t) {
    for (t = Math.max(t, 3), e = e.slice(0, 3); t < 3; )
      e += "0", t++;
    return Fu(e);
  }
}, UE = ["y", "M", "d", "h", "m", "s", "S"], Y3 = {
  y: "setFullYear",
  M: "setMonth",
  L: "setMonth",
  a: function(e, t, r) {
    var n = e.getHours(), i = r.h;
    i !== void 0 && i !== n && n--, !t && n === 12 ? n = 0 : t && n !== 12 && (n += 12), e.setHours(n);
  },
  d: "setDate",
  H: "setHours",
  h: "setHours",
  m: "setMinutes",
  s: "setSeconds",
  S: "setMilliseconds"
}, $ee = function(e, t) {
  var r = e[t];
  if (!r)
    return 0;
  var n = 0;
  do
    t++, n++;
  while (e[t] === r);
  return n;
}, Yee = function(e, t) {
  for (var r = "", n = 0; n < t; n++)
    r += e;
  return r;
}, Wee = function(e, t) {
  for (var r = "", n = "", i, s = [], l = function() {
    n && (s.push("'".concat(n, "'")), r += "".concat(bE(n), ")"), n = "");
  }, d = 0; d < e.length; d++) {
    var h = e[d], p = h === "'", m = Uee[h];
    if (!(p && (i = !i, e[d - 1] !== "'")))
      if (m && !i) {
        var x = $ee(e, d), S = Yee(h, x);
        l(), s.push(S), r += "(".concat(m(x, t), ")"), d += x - 1;
      } else
        n || (r += "("), n += h;
  }
  return l(), qee(s) || kg.warn("The following format may be parsed incorrectly: ".concat(e, ".")), {
    patterns: s,
    regexp: new RegExp("^".concat(r, "$"), "i")
  };
}, Xee = ["d", "H", "h", "m", "s", "w", "M", "L", "Q"], qee = function(e) {
  var t = (i) => {
    if (!i)
      return !1;
    var s = i[0];
    return ["y", "S"].includes(s) || Xee.includes(s) && i.length < 3;
  }, r = !0, n = 0;
  return e.every((i, s, l) => (t(i) && (((d) => d[0] !== "S" && d.length !== 2)(i) && (r = ++n < 2), t(l[s + 1]) || (n = 0)), r));
};
var Kee = function(e, t, r, n, i) {
  var s = t[0], l = Y3[s], d = jee[s];
  if (l && d) {
    var h = d(r, t.length, n);
    i[t] = h, e[l] ? e[l](h) : l(e, h, i);
  }
}, Zee = function(e, t, r) {
  var n = Y3[t], i = "g" + n.substr(1), s = r[i]();
  e[n](s);
}, Qee = function(e) {
  return e.map(function(t) {
    return t[0] === "'" ? "" : t[0] === "H" ? "h" : t[0];
  });
}, Jee = function(e) {
  var t = e.map(function(r) {
    return UE.indexOf(r);
  });
  return Math.max.apply(Math, t);
}, ete = function(e) {
  var t = e.filter(function(r) {
    return UE.indexOf(r) < 0;
  });
  return UE.concat(t);
}, tte = function(e, t) {
  var r = Wee(e, t);
  return function(n) {
    var i = r.regexp.exec(n);
    if (i) {
      var s = /* @__PURE__ */ new Date(), l = new Date(s.getFullYear(), 0, 1), d = Qee(r.patterns), h = Jee(d), p = ete(d), m = {};
      return p.forEach(function(x, S) {
        if (!(!x || S < UE.length && S > h)) {
          var T = d.indexOf(x);
          if (T >= 0) {
            var k = r.patterns[T], O = i[T + 1];
            Kee(l, k, O, t, m);
          } else
            Zee(l, x, s);
        }
      }), l;
    }
    return null;
  };
}, rte = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], nte = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], ite = ["AM", "PM"], ate = ["Q1", "Q2", "Q3", "Q4"], _B = (e, t) => {
  var r = {
    abbreviated: 3,
    short: 2,
    narrow: 1
  };
  return Bl(e, (n) => n.substr(0, r[t]));
};
const U_ = {
  getMonthNames: function(e) {
    return _B(rte, e);
  },
  getDayNames: function(e) {
    return _B(nte, e);
  },
  getQuarterNames: function(e) {
    return ate;
  },
  getPeriodNames: function(e) {
    return ite;
  }
}, ote = {
  "af-NA": 1,
  agq: 1,
  ak: 1,
  ar: 6,
  "ar-EH": 1,
  "ar-ER": 1,
  "ar-KM": 1,
  "ar-LB": 1,
  "ar-MA": 1,
  "ar-MR": 1,
  "ar-PS": 1,
  "ar-SO": 1,
  "ar-SS": 1,
  "ar-TD": 1,
  "ar-TN": 1,
  asa: 1,
  ast: 1,
  az: 1,
  "az-Cyrl": 1,
  bas: 1,
  be: 1,
  bem: 1,
  bez: 1,
  bg: 1,
  bm: 1,
  br: 1,
  bs: 1,
  "bs-Cyrl": 1,
  ca: 1,
  ce: 1,
  cgg: 1,
  ckb: 6,
  cs: 1,
  cy: 1,
  da: 1,
  de: 1,
  dje: 1,
  dsb: 1,
  dua: 1,
  dyo: 1,
  ee: 1,
  el: 1,
  "en-001": 1,
  "en-AE": 6,
  "en-BI": 1,
  "en-MP": 1,
  "en-MV": 5,
  "en-SD": 6,
  eo: 1,
  es: 1,
  et: 1,
  eu: 1,
  ewo: 1,
  fa: 6,
  ff: 1,
  "ff-Adlm": 1,
  fi: 1,
  fo: 1,
  fr: 1,
  "fr-DJ": 6,
  "fr-DZ": 6,
  "fr-SY": 6,
  fur: 1,
  fy: 1,
  ga: 1,
  gd: 1,
  gl: 1,
  gsw: 1,
  gv: 1,
  ha: 1,
  hr: 1,
  hsb: 1,
  hu: 1,
  hy: 1,
  ia: 1,
  ig: 1,
  is: 1,
  it: 1,
  jgo: 1,
  jmc: 1,
  ka: 1,
  kab: 6,
  kde: 1,
  kea: 1,
  khq: 1,
  kk: 1,
  kkj: 1,
  kl: 1,
  "ko-KP": 1,
  ksb: 1,
  ksf: 1,
  ksh: 1,
  ku: 1,
  kw: 1,
  ky: 1,
  lag: 1,
  lb: 1,
  lg: 1,
  ln: 1,
  lrc: 6,
  lt: 1,
  lu: 1,
  lv: 1,
  "mas-TZ": 1,
  mfe: 1,
  mg: 1,
  mgo: 1,
  mi: 1,
  mk: 1,
  mn: 1,
  ms: 1,
  mua: 1,
  mzn: 6,
  naq: 1,
  nds: 1,
  nl: 1,
  nmg: 1,
  nnh: 1,
  no: 1,
  nus: 1,
  nyn: 1,
  os: 1,
  pcm: 1,
  pl: 1,
  ps: 6,
  "pt-AO": 1,
  "pt-CH": 1,
  "pt-CV": 1,
  "pt-GQ": 1,
  "pt-GW": 1,
  "pt-LU": 1,
  "pt-ST": 1,
  "pt-TL": 1,
  "qu-BO": 1,
  "qu-EC": 1,
  rm: 1,
  rn: 1,
  ro: 1,
  rof: 1,
  ru: 1,
  rw: 1,
  rwk: 1,
  sah: 1,
  sbp: 1,
  sc: 1,
  se: 1,
  ses: 1,
  sg: 1,
  shi: 1,
  "shi-Latn": 1,
  si: 1,
  sk: 1,
  sl: 1,
  smn: 1,
  so: 1,
  "so-DJ": 6,
  sq: 1,
  sr: 1,
  "sr-Latn": 1,
  sv: 1,
  sw: 1,
  "ta-LK": 1,
  "ta-MY": 1,
  teo: 1,
  tg: 1,
  "ti-ER": 1,
  tk: 1,
  to: 1,
  tr: 1,
  tt: 1,
  twq: 1,
  tzm: 1,
  uk: 1,
  uz: 1,
  "uz-Arab": 6,
  "uz-Cyrl": 1,
  vai: 1,
  "vai-Latn": 1,
  vi: 1,
  vun: 1,
  wae: 1,
  wo: 1,
  xog: 1,
  yav: 1,
  yi: 1,
  yo: 1,
  zgh: 1
};
var ste = /[\u200E\u200F]/g, lte = /[\u202F]/g, vh = (e) => (t) => {
  if (!e.timeZoneName) {
    var r = t.getFullYear(), n = String(r).length < 3, i = n ? r + 400 : r, s = new Date(Date.UTC(i, t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
    n && s.setFullYear(r);
    var l = W({
      timeZone: "UTC"
    }, e);
    return cD(s, l);
  }
  return cD(t, e);
}, lk = {}, ute = (e) => {
  var t = Ka.locale() + "/" + JSON.stringify(e);
  return lk[t] || (lk[t] = new Intl.DateTimeFormat(Ka.locale(), e).format), lk[t];
};
function cD(e, t) {
  return ute(t)(e).replace(ste, "").replace(lte, " ");
}
var dD = (e) => new Intl.NumberFormat(Ka.locale()).format(e), cte = /* @__PURE__ */ (() => {
  var e = {};
  return (t) => {
    if (!(t in e)) {
      if (dD(0) === "0")
        return e[t] = !1, !1;
      e[t] = {};
      for (var r = 0; r < 10; ++r)
        e[t][dD(r)] = r;
    }
    return e[t];
  };
})(), nC = (e) => {
  var t = cte(Ka.locale());
  return t ? e.split("").map((r) => r in t ? String(t[r]) : r).join("") : e;
}, yB = (e) => e.replace(/(\D)0+(\d)/g, "$1$2"), dte = (e, t) => yB(e) === yB(t), fD = (e) => e.replace("d’", "de "), aL = {
  day: {
    day: "numeric"
  },
  dayofweek: {
    weekday: "long"
  },
  longdate: {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  },
  longdatelongtime: {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  longtime: {
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  },
  month: {
    month: "long"
  },
  monthandday: {
    month: "long",
    day: "numeric"
  },
  monthandyear: {
    year: "numeric",
    month: "long"
  },
  shortdate: {},
  shorttime: {
    hour: "numeric",
    minute: "numeric"
  },
  shortyear: {
    year: "2-digit"
  },
  year: {
    year: "numeric"
  }
};
Object.defineProperty(aL, "shortdateshorttime", {
  get: function() {
    var e = Intl.DateTimeFormat(Ka.locale()).resolvedOptions();
    return {
      year: e.year,
      month: e.month,
      day: e.day,
      hour: "numeric",
      minute: "numeric"
    };
  }
});
var fte = (e) => typeof e == "string" && aL[e.toLowerCase()], W3 = {
  standalone: function(e, t) {
    var r = new Date(1999, e, 13, 1), n = vh({
      month: t
    })(r);
    return n;
  },
  format: function(e, t) {
    var r = new Date(0, e, 13, 1), n = fD(vh({
      day: "numeric",
      month: t
    })(r)), i = n.split(" ").filter((s) => s.indexOf("13") < 0);
    return i.length === 1 ? i[0] : i.length === 2 ? i[0].length > i[1].length ? i[0] : i[1] : W3.standalone(e, t);
  }
};
const hte = {
  engine: function() {
    return "intl";
  },
  getMonthNames: function(e, t) {
    var r = {
      wide: "long",
      abbreviated: "short",
      narrow: "narrow"
    }[e || "wide"];
    return t = t === "format" ? t : "standalone", Array.apply(null, new Array(12)).map((n, i) => W3[t](i, r));
  },
  getDayNames: function(e) {
    var t = ((r) => Array.apply(null, new Array(7)).map((n, i) => vh({
      weekday: r
    })(new Date(0, 0, i))))({
      wide: "long",
      abbreviated: "short",
      short: "narrow",
      narrow: "narrow"
    }[e || "wide"]);
    return t;
  },
  getPeriodNames: function() {
    var e = vh({
      hour: "numeric",
      hour12: !0
    });
    return [1, 13].map((t) => {
      var r = dD(1), n = e(new Date(0, 0, 1, t)).split(r);
      if (n.length !== 2)
        return "";
      var i = n[0].length > n[1].length ? n[0] : n[1];
      return i.trim();
    });
  },
  format: function(e, t) {
    if (e) {
      if (!t)
        return e;
      typeof t != "function" && !t.formatter && (t = t.type || t);
      var r = fte(t);
      if (r)
        return vh(r)(e);
      var n = typeof t;
      return t.formatter || n === "function" || n === "string" ? this.callBase.apply(this, arguments) : vh(t)(e);
    }
  },
  parse: function(e, t) {
    var r;
    return t && !t.parser && typeof e == "string" && (e = fD(e), r = (n) => fD(this.format(n, t))), this.callBase(e, r || t);
  },
  _parseDateBySimpleFormat: function(e, t) {
    e = nC(e);
    var r = this.getFormatParts(t), n = e.split(/\D+/).filter((l) => l.length > 0);
    if (r.length === n.length) {
      var i = this._generateDateArgs(r, n), s = (l) => {
        var d = ((h, p) => {
          var m = p ? 12 : 0;
          return new Date(h.year, h.month, h.day, (h.hours + m) % 24, h.minutes, h.seconds);
        })(i, l);
        if (dte(nC(this.format(d, t)), e))
          return d;
      };
      return s(!1) || s(!0);
    }
  },
  _generateDateArgs: function(e, t) {
    var r = /* @__PURE__ */ new Date(), n = {
      year: r.getFullYear(),
      month: r.getMonth(),
      day: r.getDate(),
      hours: 0,
      minutes: 0,
      seconds: 0
    };
    return e.forEach((i, s) => {
      var l = t[s], d = parseInt(l, 10);
      i === "month" && (d -= 1), n[i] = d;
    }), n;
  },
  formatUsesMonthName: function(e) {
    return typeof e == "object" && !(e.type || e.format) ? e.month === "long" : this.callBase.apply(this, arguments);
  },
  formatUsesDayName: function(e) {
    return typeof e == "object" && !(e.type || e.format) ? e.weekday === "long" : this.callBase.apply(this, arguments);
  },
  getTimeSeparator: function() {
    return nC(cD(new Date(2001, 1, 1, 11, 11), {
      hour: "numeric",
      minute: "numeric",
      hour12: !1
    })).replace(/\d/g, "");
  },
  getFormatParts: function(e) {
    if (typeof e == "string")
      return this.callBase(e);
    var t = W({}, aL[e.toLowerCase()]), r = new Date(2001, 2, 4, 5, 6, 7), n = vh(t)(r);
    return n = nC(n), [{
      name: "year",
      value: 1
    }, {
      name: "month",
      value: 3
    }, {
      name: "day",
      value: 4
    }, {
      name: "hours",
      value: 5
    }, {
      name: "minutes",
      value: 6
    }, {
      name: "seconds",
      value: 7
    }].map((i) => ({
      name: i.name,
      index: n.indexOf(i.value)
    })).filter((i) => i.index > -1).sort((i, s) => i.index - s.index).map((i) => i.name);
  }
};
var vte = 0, pte = typeof Intl < "u", uk = {
  shortdate: "M/d/y",
  shorttime: "h:mm a",
  longdate: "EEEE, MMMM d, y",
  longtime: "h:mm:ss a",
  monthandday: "MMMM d",
  monthandyear: "MMMM y",
  quarterandyear: "QQQ y",
  day: "d",
  year: "y",
  shortdateshorttime: "M/d/y, h:mm a",
  longdatelongtime: "EEEE, MMMM d, y, h:mm:ss a",
  month: "LLLL",
  shortyear: "yy",
  dayofweek: "EEEE",
  quarter: "QQQ",
  hour: "HH",
  minute: "mm",
  second: "ss",
  millisecond: "SSS",
  "datetime-local": "yyyy-MM-ddTHH':'mm':'ss"
}, gte = {
  year: ["y", "yy", "yyyy"],
  day: ["d", "dd"],
  month: ["M", "MM", "MMM", "MMMM"],
  hours: ["H", "HH", "h", "hh", "ah"],
  minutes: ["m", "mm"],
  seconds: ["s", "ss"],
  milliseconds: ["S", "SS", "SSS"]
}, Os = Fs({
  engine: function() {
    return "base";
  },
  _getPatternByFormat: function(e) {
    return uk[e.toLowerCase()];
  },
  _expandPattern: function(e) {
    return this._getPatternByFormat(e) || e;
  },
  formatUsesMonthName: function(e) {
    return this._expandPattern(e).indexOf("MMMM") !== -1;
  },
  formatUsesDayName: function(e) {
    return this._expandPattern(e).indexOf("EEEE") !== -1;
  },
  getFormatParts: function(e) {
    var t = this._getPatternByFormat(e) || e, r = [];
    return be(t.split(/\W+/), (n, i) => {
      be(gte, (s, l) => {
        l.includes(i) && r.push(s);
      });
    }), r;
  },
  getMonthNames: function(e) {
    return U_.getMonthNames(e);
  },
  getDayNames: function(e) {
    return U_.getDayNames(e);
  },
  getQuarterNames: function(e) {
    return U_.getQuarterNames(e);
  },
  getPeriodNames: function(e) {
    return U_.getPeriodNames(e);
  },
  getTimeSeparator: function() {
    return ":";
  },
  is24HourFormat: function(e) {
    for (var t = new Date(2017, 0, 20, 11, 0, 0, 0), r = new Date(2017, 0, 20, 23, 0, 0, 0), n = this.format(t, e), i = this.format(r, e), s = 0; s < n.length; s++)
      if (n[s] !== i[s])
        return !isNaN(parseInt(n[s]));
  },
  format: function(e, t) {
    if (e) {
      if (!t)
        return e;
      var r;
      if (typeof t == "function")
        r = t;
      else if (t.formatter)
        r = t.formatter;
      else if (t = t.type || t, lr(t))
        return t = uk[t.toLowerCase()] || t, Ho.convertDigits(j3(t, this)(e));
      if (r)
        return r(e);
    }
  },
  parse: function(e, t) {
    var r = this, n, i;
    if (e) {
      if (!t)
        return this.parse(e, "shortdate");
      if (t.parser)
        return t.parser(e);
      if (typeof t == "string" && !uk[t.toLowerCase()])
        n = t;
      else {
        i = (l) => {
          var d = r.format(l, t);
          return Ho.convertDigits(d, !0);
        };
        try {
          n = Gee(i);
        } catch {
        }
      }
      if (n)
        return e = Ho.convertDigits(e, !0), tte(n, this)(e);
      Dr.log("W0012");
      var s = new Date(e);
      if (!(!s || isNaN(s.getTime())))
        return s;
    }
  },
  firstDayOfWeekIndex: function() {
    var e = Ka.getValueByClosestLocale((t) => ote[t]);
    return e === void 0 ? vte : e;
  }
});
pte && Os.inject(hte);
const Nl = Fs({
  format: function(e, t) {
    var r = lr(t) && t !== "" || Qr(t) || ct(t), n = Sr(e) || Ls(e);
    if (!r || !n)
      return I(e) ? e.toString() : "";
    if (ct(t))
      return t(e);
    if (lr(t) && (t = {
      type: t
    }), Sr(e))
      return Ho.format(e, t);
    if (Ls(e))
      return Os.format(e, t);
  },
  getTimeFormat: function(e) {
    return e ? "longtime" : "shorttime";
  },
  _normalizeFormat: function(e) {
    return Array.isArray(e) ? e.length === 1 ? e[0] : function(t) {
      return e.map(function(r) {
        return Os.format(t, r);
      }).join(" ");
    } : e;
  },
  getDateFormatByDifferences: function(e, t) {
    var r = [], n = t && e.millisecond && !(e.year || e.month || e.day);
    return n ? r.push(function(i) {
      return i.getSeconds() + i.getMilliseconds() / 1e3 + "s";
    }) : e.millisecond && r.push("millisecond"), (e.hour || e.minute || !n && e.second) && r.unshift(this.getTimeFormat(e.second)), e.year && e.month && e.day ? t && t === "month" ? "monthandyear" : (r.unshift("shortdate"), this._normalizeFormat(r)) : e.year && e.month ? "monthandyear" : e.year && e.quarter ? "quarterandyear" : e.year ? "year" : e.quarter ? "quarter" : e.month && e.day ? (t ? r.unshift(function(i) {
      return Os.getMonthNames("abbreviated")[i.getMonth()] + " " + Os.format(i, "day");
    }) : r.unshift("monthandday"), this._normalizeFormat(r)) : e.month ? "month" : e.day ? (t ? r.unshift("day") : r.unshift(function(i) {
      return Os.format(i, "dayofweek") + ", " + Os.format(i, "day");
    }), this._normalizeFormat(r)) : this._normalizeFormat(r);
  },
  getDateFormatByTicks: function(e) {
    var t, r, n;
    if (e.length > 1)
      for (t = Et.getDatesDifferences(e[0], e[1]), n = 1; n < e.length - 1; n++)
        r = Et.getDatesDifferences(e[n], e[n + 1]), t.count < r.count && (t = r);
    else
      t = {
        year: !0,
        month: !0,
        day: !0,
        hour: e[0].getHours() > 0,
        minute: e[0].getMinutes() > 0,
        second: e[0].getSeconds() > 0,
        millisecond: e[0].getMilliseconds() > 0
      };
    var i = this.getDateFormatByDifferences(t);
    return i;
  },
  getDateFormatByTickInterval: function(e, t, r) {
    var n, i = function(d, h, p) {
      switch (h) {
        case "year":
        case "quarter":
          d.month = p;
        case "month":
          d.day = p;
        case "week":
        case "day":
          d.hour = p;
        case "hour":
          d.minute = p;
        case "minute":
          d.second = p;
        case "second":
          d.millisecond = p;
      }
    };
    r = lr(r) ? r.toLowerCase() : r;
    var s = Et.getDatesDifferences(e, t);
    e !== t && function(d, h, p) {
      !p.getMilliseconds() && p.getSeconds() ? p.getSeconds() - h.getSeconds() === 1 && (d.millisecond = !0, d.second = !1) : !p.getSeconds() && p.getMinutes() ? p.getMinutes() - h.getMinutes() === 1 && (d.second = !0, d.minute = !1) : !p.getMinutes() && p.getHours() ? p.getHours() - h.getHours() === 1 && (d.minute = !0, d.hour = !1) : !p.getHours() && p.getDate() > 1 ? p.getDate() - h.getDate() === 1 && (d.hour = !0, d.day = !1) : p.getDate() === 1 && p.getMonth() ? p.getMonth() - h.getMonth() === 1 && (d.day = !0, d.month = !1) : !p.getMonth() && p.getFullYear() && p.getFullYear() - h.getFullYear() === 1 && (d.month = !0, d.year = !1);
    }(s, e > t ? t : e, e > t ? e : t), n = Et.getDateUnitInterval(s), i(s, n, !0), n = Et.getDateUnitInterval(r || "second"), i(s, n, !1), s[{
      week: "day"
    }[n] || n] = !0;
    var l = this.getDateFormatByDifferences(s);
    return l;
  }
});
function X3(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), i, s;
  for (s = 0; s < n.length; s++)
    i = n[s], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
var mte = ["x", "y", "canvas", "offsetX", "offsetY", "offset"], Fh = Math, ju = Fh.round, zu = Fh.max, q3 = Fh.min, Wi = Fh.sin, Xi = Fh.cos, w_ = Fh.asin, nE = Fh.PI, Lo = function() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.join("");
};
function Nn(e, t, r) {
  return "a ".concat(e, " ").concat(e, " 0 0 1 ").concat(t * e, " ").concat(r * e);
}
function A_(e, t, r) {
  return "A ".concat(e, " ").concat(e, " 0 0 1 ").concat(t, " ").concat(r);
}
function _te(e, t, r, n, i) {
  return (e - n) * ju(Xi(r)) + (t - i) * ju(Wi(r)) + n;
}
function yte(e, t, r, n, i) {
  return -(e - n) * ju(Wi(r)) + (t - i) * ju(Xi(r)) + i;
}
function xte(e, t) {
  return t % 90 === 0 && t % 180 !== 0 ? {
    width: e.height,
    height: e.width
  } : e;
}
function xB(e, t, r, n, i) {
  var {
    width: s,
    height: l
  } = e, d = s / 2, h = l / 2, p = Math.ceil(t + d), m = Math.floor(t - d), x = Math.floor(r - h), S = Math.ceil(r + h);
  return n < m && i < x || n >= m && n <= p && i < x ? 270 : n > p && i > S || n >= m && n <= p && i > S ? 90 : n < m && i > S || n < m && i >= x && i <= S ? 180 : 0;
}
function bte(e, t, r, n, i, s, l) {
  var {
    width: d,
    height: h
  } = e, {
    arrowWidth: p,
    cornerRadius: m = 0
  } = s, x = p / 2, S = d / 2, T = h / 2, k = Math.ceil(t + S), O = Math.floor(t - S), D = Math.floor(r - T), L = Math.ceil(r + T), F = [O, D], z = [k, D], V = [k, L], P = [O, L], j = n <= O ? O : k <= n ? k : n, Z = i <= D ? D : L <= i ? L : i, ee = q3(Z + x, L), J = zu(Z - x, D), he = zu(j - x, O);
  m = Math.min(d / 2, h / 2, m);
  var de;
  if (F[1] += m, z[0] -= m, V[1] -= m, P[0] += m, !l || O <= n && n <= k && D <= i && i <= L)
    de = Lo(F, Nn(m, 1, -1), "L", z, Nn(m, 1, 1), "L", V, Nn(m, -1, 1), "L", P, Nn(m, -1, -1));
  else if (n > k && i < D) {
    var Re = p / m || 0, Ce = nE / 4 + Re / 2, le = nE / 4 - Re / 2, me = z[0] + Xi(le) * m, fe = z[1] + (1 - Wi(le)) * m, Ee = Lo("L", z, Nn(m, Xi(Ce), 1 - Wi(Ce)), "L", [n, i, me, fe], A_(m, z[0] + m, z[1] + m));
    Math.abs(Ce) > nE / 2 && (Ee = Lo("L", [he, D, n, i, k, ee])), de = Lo(F, Nn(m, 1, -1), Ee, "L", V, Nn(m, -1, 1), "L", P, Nn(m, -1, -1));
  } else if (n > k && i >= D && i <= L) {
    var Q;
    if (J >= z[1] + m && ee <= V[1])
      Q = Lo(Nn(m, 1, 1), "L", [k, J, n, i, k, ee], "L", V, Nn(m, -1, 1));
    else if (J < z[1] + m && ee >= z[1] + m && ee <= V[1]) {
      var pe = z[1] + m - J, G = pe / m, se = z[0] + Xi(G) * m, Te = z[1] + (1 - Wi(G)) * m;
      Q = Lo(Nn(m, Xi(G), 1 - Wi(G)), "L", [se, Te, n, i, k, ee], "L", V, Nn(m, -1, 1));
    } else if (J < z[1] + m && ee < z[1] + m) {
      var Pe = z[1] + m - J, Ie = Pe / m, He = Ie, Ue = z[0] + Xi(He) * m, Ze = z[1] + (1 - Wi(He)) * m, Qe = Math.sin((z[1] + m - ee) / m), it = z[0] + m * Xi(Qe), We = z[1] + m * (1 - Wi(Qe));
      Q = Lo(Nn(m, Xi(He), 1 - Wi(He)), "L", [Ue, Ze, n, i, it, We], A_(m, z[0] + m, z[1] + m), "L", V, Nn(m, -1, 1));
    } else if (J <= z[1] + m && ee >= V[1]) {
      var _t = w_((z[1] + m - J) / m), xe = z[0] + m * Xi(_t), Je = z[1] + m * (1 - Wi(_t)), Pt = w_((ee - V[1]) / m), bt = V[0] + m * (Xi(Pt) - 1), ir = V[1] + m * Wi(Pt);
      Q = Lo(Nn(m, Xi(_t), 1 - Wi(_t)), "L", [xe, Je, n, i, bt, ir], A_(m, V[0] - m, V[1] + m));
    } else if (J > z[1] + m && J <= V[1] && ee > V[1]) {
      var Cr = w_((ee - V[1]) / m), qt = V[0] + m * (Xi(Cr) - 1), ur = V[1] + m * Wi(Cr);
      Q = Lo(Nn(m, 1, 1), "L", [k, J, n, i, qt, ur], A_(m, V[0] - m, V[1] + m));
    } else if (J > z[1] + m && ee > V[1]) {
      var Fr = w_((ee - V[1]) / m), pi = V[0] + m * (Xi(Fr) - 1), Ri = V[1] + m * Wi(Fr), hn = w_((J - V[1]) / m), fr = V[0] + m * (Xi(hn) - 1), Er = V[1] + m * Wi(hn);
      Q = Lo(Nn(m, 1, 1), "L", V, Nn(m, Xi(hn) - 1, Wi(hn)), "L", [fr, Er, n, i, pi, Ri], A_(m, V[0] - m, V[1] + m));
    }
    de = Lo(F, Nn(m, 1, -1), "L", z, Q, "L", P, Nn(m, -1, -1));
  }
  return Lo("M", de, "Z");
}
class K3 {
  constructor(t, r, n, i) {
    var s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, l = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (h, p) => p.getBBox(), d = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : (h, p, m, x) => p.move(m, x);
    this.widget = r, this.options = t, this.root = n, this.contentTemplate = i, this.bonded = s, this.measureContent = l, this.moveContentGroup = d;
  }
  draw(t) {
    var {
      x: r,
      y: n,
      canvas: i = {},
      offsetX: s,
      offsetY: l,
      offset: d = 0
    } = t, h = X3(t, mte), p = this.options, {
      x: m,
      y: x
    } = p, S = i.left, T = i.width - i.right, k = i.width - i.right - i.left, O = i.top, D = i.height - i.bottom, L = i.height - i.bottom - i.top;
    if (!(I(r) && I(n)) && !(I(m) && I(x)) || I(r) && (r < S || T < r || n < O || D < n))
      return !1;
    this._root || this._draw();
    var F = W({
      x: "-50%",
      y: "-50%",
      width: "200%",
      height: "200%"
    }, p.shadow), z = p.width > 0 ? p.width : null, V = p.height > 0 ? p.height : null, P = () => {
      var j, Z = this._contentBBox = this.measureContent(this.widget, this._contentGroup), ee = this._size = {
        width: zu(z, Z.width) + 2 * p.paddingLeftRight,
        height: zu(V, Z.height) + 2 * p.paddingTopBottom,
        offset: d
      }, J = F.offsetX, he = F.offsetY, de = 2 * F.blur + 1, Re = zu(de - J, 0), Ce = zu(de + J, 0), le = zu(de - he, 0), me = zu(de + he, 0);
      if (this.margins = {
        lm: Re,
        rm: Ce,
        tm: le,
        bm: me
      }, I(m) ? (m += s || 0, I(r) || (r = m)) : I(s) ? m = r + s : k < ee.width ? m = ju(S + k / 2) : m = q3(zu(r, Math.ceil(S + ee.width / 2 + Re)), Math.floor(T - ee.width / 2 - Ce)), I(x))
        x += l || 0, I(n) || (n = x + ee.height / 2);
      else if (I(l))
        x = n + l;
      else {
        var fe = n - p.arrowLength - ee.height / 2 - d, Ee = n + p.arrowLength + ee.height / 2 + d;
        L < ee.height + p.arrowLength ? x = ju(O + ee.height / 2) : fe - ee.height / 2 - le < O ? Ee + ee.height / 2 + me < D ? (x = Ee, n += d) : x = ju(O + ee.height / 2) : (x = fe, n -= d);
      }
      this.anchorX = r, this.anchorY = n, this.move(m, x), (j = this._root) === null || j === void 0 || j.append(this.root);
    };
    if (this.contentTemplate.render)
      this.contentTemplate.render({
        model: p,
        container: this._contentGroup.element,
        onRendered: P
      });
    else
      return this.contentTemplate(ei({
        group: this._contentGroup,
        onRender: P
      }, h));
    return !0;
  }
  _draw() {
    var t = this.widget._renderer, r = this.options, n = W({
      x: "-50%",
      y: "-50%",
      width: "200%",
      height: "200%"
    }, r.shadow), i = this._shadow = t.shadowFilter().attr(n), s = {
      opacity: r.opacity,
      "stroke-width": 0,
      fill: r.color
    }, l = r.border || {};
    l.visible && W(s, {
      "stroke-width": l.width,
      stroke: l.color,
      "stroke-opacity": l.opacity,
      dashStyle: l.dashStyle
    });
    var d = this._root = t.g().append(this.root);
    r.type && d.attr({
      class: "dxc-".concat(r.type, "-annotation")
    });
    var h = t.g().attr({
      filter: i.id
    }).append(d);
    this._cloud = t.path([], "area").attr(s).sharp().append(h), this._contentGroup = t.g().append(d);
  }
  getBBox() {
    var t = this._size || {}, r = this.margins || {}, n = xB(t, this.x, this.y, this.anchorX, this.anchorY);
    return {
      x: Math.floor(this.x - t.width / 2 - r.lm),
      y: Math.floor(this.y - t.height / 2 - r.tm - (n === 270 ? this.options.arrowLength : 0)),
      width: t.width + r.lm + r.rm,
      height: t.height + r.tm + r.bm + (n === 90 || n === 270 ? this.options.arrowLength : 0)
    };
  }
  clear() {
    return this._root && (this._root.remove(), this._shadow.remove(), this._root = null), this;
  }
  customizeCloud(t) {
    this._cloud && this._cloud.attr(t);
  }
  moveRoot(t, r) {
    this._root && this._root.move(t, r);
  }
  move(t, r) {
    t = ju(t), r = ju(r), this.x = t, this.y = r;
    var n = xB(this._size, t, r, this.anchorX, this.anchorY), i = n * nE / 180;
    this._cloud.attr({
      d: bte(xte(this._size, n), t, r, _te(this.anchorX, this.anchorY, i, t, r), yte(this.anchorX, this.anchorY, i, t, r), this.options, this.bonded)
    }).rotate(n, t, r), this.moveContentGroup(this.widget, this._contentGroup, t - this._contentBBox.x - this._contentBBox.width / 2, r - this._contentBBox.y - this._contentBBox.height / 2);
  }
  hitTest(t, r) {
    var {
      width: n,
      height: i
    } = this._size || {};
    return Math.abs(t - this.x) <= n / 2 && Math.abs(r - this.y) <= i / 2;
  }
}
var Ste = Nl.format, ck = Math.ceil, iC = Math.max, bB = Math.min, dk = jr(), Cte = 3e3;
function SB(e) {
  e.css({
    left: "-9999px"
  }).detach();
}
function Ete(e, t) {
  var r = e;
  switch (t) {
    case "argument":
      r = {
        format: e.argumentFormat
      };
      break;
    case "percent":
      r = {
        format: {
          type: "percent",
          precision: e.format && e.format.percentPrecision
        }
      };
  }
  return r;
}
function Z3() {
  return je("<div>").css({
    position: "relative",
    display: "inline-block",
    padding: 0,
    margin: 0,
    border: "0px solid transparent"
  });
}
function Tte(e) {
  e.forEach((t) => t.remove());
}
var jE = function(e) {
  this._eventTrigger = e.eventTrigger, this._widgetRoot = e.widgetRoot, this._widget = e.widget, this._textHtmlContainers = [], this._wrapper = je("<div>").css({
    position: "absolute",
    overflow: "hidden",
    pointerEvents: "none"
  }).addClass(e.cssClass);
  var t = this._renderer = new GE({
    pathModified: e.pathModified,
    container: this._wrapper[0]
  }), r = t.root;
  r.attr({
    "pointer-events": "none"
  }), this._text = t.text(void 0, 0, 0), this._textGroupHtml = je("<div>").css({
    position: "absolute",
    padding: 0,
    margin: 0,
    border: "0px solid transparent"
  }).appendTo(this._wrapper), this._textHtml = Z3().appendTo(this._textGroupHtml);
};
jE.prototype = {
  constructor: jE,
  dispose: function() {
    this._wrapper.remove(), this._renderer.dispose(), this._options = this._widgetRoot = null;
  },
  _getContainer: function() {
    var e = this._options, t = je(this._widgetRoot).closest(e.container);
    return t.length === 0 && (t = je(e.container)), (t.length ? t : je("body")).get(0);
  },
  setTemplate(e) {
    this._template = e ? this._widget._getTemplate(e) : null;
  },
  setOptions: function(e) {
    e = e || {};
    var t = this;
    t._options = e, t._textFontStyles = Oi(e.font), t._textFontStyles.color = t._textFontStyles.fill, t._wrapper.css({
      zIndex: e.zIndex
    }), t._customizeTooltip = e.customizeTooltip;
    var r = t._textGroupHtml;
    this.plaque && this.plaque.clear(), this.setTemplate(e.contentTemplate);
    var n = e.interactive ? "auto" : "none";
    return e.interactive && this._renderer.root.css({
      "-moz-user-select": "auto",
      "-webkit-user-select": "auto"
    }), this.plaque = new K3({
      opacity: t._options.opacity,
      color: t._options.color,
      border: t._options.border,
      paddingLeftRight: t._options.paddingLeftRight,
      paddingTopBottom: t._options.paddingTopBottom,
      arrowLength: t._options.arrowLength,
      arrowWidth: 20,
      shadow: t._options.shadow,
      cornerRadius: t._options.cornerRadius
    }, t, t._renderer.root, (i) => {
      var {
        group: s,
        onRender: l,
        eventData: d,
        isMoving: h,
        templateCallback: p = () => {
        }
      } = i, m = t._state;
      if (!h) {
        var x = t._template, S = x && !m.formatObject.skipTemplate;
        if (m.html || S)
          if (r.css({
            color: m.textColor,
            width: Cte,
            pointerEvents: n
          }), S) {
            var T = t._textHtmlContainers, k = Z3().appendTo(t._textGroupHtml);
            T.push(k), x.render({
              model: m.formatObject,
              container: k,
              onRendered: () => {
                if (Tte(T.splice(0, T.length - 1)), t._textHtml = $Z(t._textHtml, k), m.html = t._textHtml.html(), Mg(t._textHtml) === 0 && gT(t._textHtml) === 0) {
                  this.plaque.clear(), p(!1);
                  return;
                }
                l(), t._riseEvents(d), t._moveWrapper(), t.plaque.customizeCloud({
                  fill: m.color,
                  stroke: m.borderColor,
                  "pointer-events": n
                }), p(!0), t._textHtmlContainers = [];
              }
            });
            return;
          } else
            t._text.attr({
              text: ""
            }), t._textHtml.html(m.html);
        else
          t._text.css({
            fill: m.textColor
          }).attr({
            text: m.text,
            class: e.cssClass,
            "pointer-events": n
          }).append(s.attr({
            align: e.textAlignment
          }));
        t._riseEvents(d), t.plaque.customizeCloud({
          fill: m.color,
          stroke: m.borderColor,
          "pointer-events": n
        });
      }
      return l(), t._moveWrapper(), !0;
    }, !0, (i, s) => {
      var l = i._state;
      if (l.html) {
        var d = dk.getComputedStyle(t._textHtml.get(0));
        return d = {
          x: 0,
          y: 0,
          width: ck(parseFloat(d.width)),
          height: ck(parseFloat(d.height))
        }, d;
      }
      return s.getBBox();
    }, (i, s, l, d) => {
      var h = i._state;
      h.html ? t._textGroupHtml.css({
        left: l,
        top: d
      }) : s.move(l, d);
    }), t;
  },
  _riseEvents: function(e) {
    this._eventData && this._eventTrigger("tooltipHidden", this._eventData), this._eventData = e, this._eventTrigger("tooltipShown", this._eventData);
  },
  setRendererOptions: function(e) {
    return this._renderer.setOptions(e), this._textGroupHtml.css({
      direction: e.rtl ? "rtl" : "ltr"
    }), this;
  },
  update: function(e) {
    this.setOptions(e), SB(this._wrapper);
    var t = {};
    for (var r in this._textFontStyles)
      t[Dg(r)] = this._textFontStyles[r];
    return this._textGroupHtml.css(t), this._text.css(this._textFontStyles), this._eventData = null, this;
  },
  _prepare: function(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this._customizeTooltip, n = this._options, i = {};
    return ct(r) && (i = r.call(e, e), i = Qr(i) ? i : {}, "text" in i && (t.text = I(i.text) ? String(i.text) : ""), "html" in i && (t.html = I(i.html) ? String(i.html) : "")), !("text" in t) && !("html" in t) && (t.text = e.valueText || e.description || ""), t.color = i.color || n.color, t.borderColor = i.borderColor || (n.border || {}).color, t.textColor = i.fontColor || (this._textFontStyles || {}).color, !!t.text || !!t.html || !!this._template;
  },
  show: function(e, t, r, n, i) {
    if (this._options.forceEvents)
      return r.x = t.x, r.y = t.y - t.offset, this._riseEvents(r), !0;
    var s = {
      formatObject: e,
      eventData: r,
      templateCallback: i
    };
    if (!this._prepare(e, s, n))
      return !1;
    this._state = s, this._wrapper.appendTo(this._getContainer()), this._clear();
    var l = W({}, this._options, {
      canvas: this._getCanvas()
    }, s, {
      x: t.x,
      y: t.y,
      offset: t.offset
    });
    return this.plaque.clear().draw(l);
  },
  isCursorOnTooltip: function(e, t) {
    if (this._options.interactive) {
      var r = this.plaque.getBBox();
      return e > r.x && e < r.x + r.width && t > r.y && t < r.y + r.height;
    }
    return !1;
  },
  hide: function(e) {
    SB(this._wrapper), this._eventData && (this._eventTrigger("tooltipHidden", this._options.forceEvents ? W({
      isPointerOut: e
    }, this._eventData) : this._eventData), this._clear(), this._eventData = null);
  },
  _clear() {
    this._textHtml.empty();
  },
  move: function(e, t, r) {
    this.plaque.draw({
      x: e,
      y: t,
      offset: r,
      canvas: this._getCanvas(),
      isMoving: !0
    });
  },
  _moveWrapper: function() {
    var e = this.plaque.getBBox();
    this._renderer.resize(e.width, e.height);
    var t = this._wrapper.css({
      left: 0,
      top: 0
    }).offset(), r = e.x, n = e.y;
    this._wrapper.css({
      left: r - t.left,
      top: n - t.top
    }), this.plaque.moveRoot(-r, -n), this._state.html && (this._textHtml.css({
      left: -r,
      top: -n
    }), this._textGroupHtml.css({
      width: ck(Mg(this._textHtml))
    }));
  },
  formatValue: function(e, t) {
    var r = t ? Ete(this._options, t) : this._options;
    return Ste(e, r.format);
  },
  getOptions() {
    return this._options;
  },
  getLocation: function() {
    return Wt(this._options.location);
  },
  isEnabled: function() {
    return !!this._options.enabled || !!this._options.forceEvents;
  },
  isShared: function() {
    return !!this._options.shared;
  },
  _getCanvas: function() {
    var e = this._getContainer(), t = e.getBoundingClientRect(), r = we.getDocumentElement(), n = we.getDocument(), i = dk.pageXOffset || r.scrollLeft || 0, s = dk.pageYOffset || r.scrollTop || 0, l = {
      left: i,
      top: s,
      width: iC(r.clientWidth, n.body.clientWidth) + i,
      height: iC(n.body.scrollHeight, r.scrollHeight, n.body.offsetHeight, r.offsetHeight, n.body.clientHeight, r.clientHeight),
      right: 0,
      bottom: 0
    };
    return e !== we.getBody() && (i = iC(l.left, l.left + t.left), s = iC(l.top, l.top + t.top), l.width = bB(t.width, l.width) + i + l.left, l.height = bB(t.height, l.height) + s + l.top, l.left = i, l.top = s), l;
  }
};
var wte = {
  name: "tooltip",
  init: function() {
    this._initTooltip();
  },
  dispose: function() {
    this._disposeTooltip();
  },
  members: {
    _initTooltip: function() {
      this._tooltip = new jE({
        cssClass: this._rootClassPrefix + "-tooltip",
        eventTrigger: this._eventTrigger,
        pathModified: this.option("pathModified"),
        widgetRoot: this.element(),
        widget: this
      });
    },
    _disposeTooltip: function() {
      this._tooltip.dispose(), this._tooltip = null;
    },
    _setTooltipRendererOptions: function() {
      this._tooltip.setRendererOptions(this._getRendererOptions());
    },
    _setTooltipOptions: function() {
      this._tooltip.update(this._getOption("tooltip"));
    }
  },
  extenders: {
    _stopCurrentHandling() {
      this._tooltip && this._tooltip.hide();
    }
  },
  customize: function(e) {
    var t = e.prototype;
    t._eventsMap.onTooltipShown = {
      name: "tooltipShown"
    }, t._eventsMap.onTooltipHidden = {
      name: "tooltipHidden"
    }, e.addChange({
      code: "TOOLTIP_RENDERER",
      handler: function() {
        this._setTooltipRendererOptions();
      },
      isThemeDependent: !0,
      isOptionChange: !0
    }), e.addChange({
      code: "TOOLTIP",
      handler: function() {
        this._setTooltipOptions();
      },
      isThemeDependent: !0,
      isOptionChange: !0,
      option: "tooltip"
    });
  },
  fontFields: ["tooltip.font"]
}, fk = we.getDocument, oL = "annotations", Sy = "." + oL, CB = En([dn.down, dn.move], oL), Ate = En(dn.up, oL), Ote = Hg + Sy, kte = Gg + Sy, Rte = Ug + Sy;
function Dte(e, t) {
  return {
    draw: function(r, n) {
      var i = r._renderer.g().append(n).css(Oi(e.font));
      this.plaque && this.plaque.clear(), this.plaque = new K3(W(!0, {}, e, {
        cornerRadius: (e.border || {}).cornerRadius
      }), r, i, t, r._isAnnotationBounded(e)), this.plaque.draw(r._getAnnotationCoords(this)), e.allowDragging && i.on(Ote, {
        immediate: !0
      }, (s) => {
        this._dragOffsetX = this.plaque.x - s.pageX, this._dragOffsetY = this.plaque.y - s.pageY;
      }).on(kte, (s) => {
        this.plaque.move(s.pageX + this._dragOffsetX, s.pageY + this._dragOffsetY);
      }).on(Rte, (s) => {
        this.offsetX = (this.offsetX || 0) + s.offset.x, this.offsetY = (this.offsetY || 0) + s.offset.y;
      });
    },
    hitTest(r, n) {
      return this.plaque.hitTest(r, n);
    },
    showTooltip(r, n) {
      var {
        x: i,
        y: s
      } = n, l = this, d = l.options;
      if (r.annotation !== l) {
        r.setTemplate(d.tooltipTemplate);
        var h = (p) => {
          p && (r.annotation = l);
        };
        h(r.show(d, {
          x: i,
          y: s
        }, {
          target: d
        }, d.customizeTooltip, h));
      } else
        r.isCursorOnTooltip(i, s) || r.move(i, s);
    }
  };
}
function Mte(e, t) {
  var r;
  return e.type === "text" ? r = function(n, i) {
    var s = t._renderer.text(n.text).attr({
      class: n.cssClass
    }).append({
      element: i
    });
    (n.width > 0 || n.height > 0) && s.setMaxSize(n.width, n.height, {
      wordWrap: n.wordWrap,
      textOverflow: n.textOverflow
    });
  } : e.type === "image" ? r = function(n, i) {
    var {
      width: s,
      height: l,
      url: d,
      location: h
    } = n.image || {}, {
      width: p,
      height: m
    } = n, x = p > 0 ? Math.min(s, p) : s, S = m > 0 ? Math.min(l, m) : l;
    t._renderer.image(0, 0, x, S, d, h || "center").append({
      element: i
    });
  } : e.type === "custom" && (r = e.template), r;
}
function hk(e) {
  return typeof e == "string" ? {
    url: e
  } : e;
}
var Lte = function(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = arguments.length > 3 ? arguments[3] : void 0, i = arguments.length > 4 ? arguments[4] : void 0, s = hk(r.image);
  return t.reduce((l, d) => {
    var h = hk(d.image), p = ct(n) ? n(d) : {};
    p && (p.image = hk(p.image));
    var m = W(!0, {}, r, d, {
      image: s
    }, {
      image: h
    }, p), x = Mte(m, e), S = x && W(!0, i(m), Dte(m, e._getTemplate(x)));
    return S && l.push(S), l;
  }, []);
}, Bo = {
  name: "annotations_chart",
  init() {
  },
  dispose() {
  },
  members: {
    _getAnnotationCoords(e) {
      var t, r, n = {
        offsetX: e.offsetX,
        offsetY: e.offsetY
      }, i = this._options.silent("rotated") ? "y" : "x", s = this._options.silent("rotated") ? "x" : "y", l = this.getArgumentAxis(), d = l.validateUnit(e.argument), h = this.getValueAxis(e.axis), p, m = (t = h) === null || t === void 0 ? void 0 : t.pane;
      if (e.series) {
        var x;
        p = this.series.filter((D) => D.name === e.series)[0], h = (x = p) === null || x === void 0 ? void 0 : x.getValueAxis(), I(h) && (m = h.pane);
      }
      if (I(d)) {
        if (p) {
          var S = p.getPointCenterByArg(d);
          S && (n[i] = S[i]);
        } else
          n[i] = l.getTranslator().translate(d);
        !I(m) && (m = l.pane);
      }
      var T = (r = h) === null || r === void 0 ? void 0 : r.validateUnit(e.value);
      if (I(T)) {
        var k;
        n[s] = (k = h) === null || k === void 0 ? void 0 : k.getTranslator().translate(T), !I(m) && I(h) && (m = h.pane);
      }
      if (n.canvas = this._getCanvasForPane(m), I(n[i]) && !I(T)) {
        var O;
        !I(h) && !I(p) ? n[s] = l.getAxisPosition() : I(h) && !I(p) ? n[s] = this._argumentAxes.filter((D) => D.pane === h.pane)[0].getAxisPosition() : (O = p) !== null && O !== void 0 && O.checkSeriesViewportCoord(l, n[i]) && (n[s] = p.getSeriesPairCoord(n[i], !0));
      }
      return !I(d) && I(n[s]) && (I(h) && !I(p) ? n[i] = h.getAxisPosition() : I(p) && p.checkSeriesViewportCoord(h, n[s]) && (n[i] = p.getSeriesPairCoord(n[s], !1))), n;
    },
    _annotationsPointerEventHandler(e) {
      if (!this._disposed) {
        var t = e.originalEvent || {}, r = t.touches && t.touches[0] || {}, n = this._renderer.getRootOffset(), i = {
          x: r.pageX || t.pageX || e.pageX,
          y: r.pageY || t.pageY || e.pageY
        }, s = this._annotations.items.filter((l) => l.hitTest(i.x - n.left, i.y - n.top))[0];
        if (!s || !s.options.tooltipEnabled) {
          this._annotations.hideTooltip();
          return;
        }
        this._clear(), s.options.allowDragging && e.type === dn.down && (this._annotations._hideToolTipForDrag = !0), this._annotations._hideToolTipForDrag || (s.showTooltip(this._annotations.tooltip, i), e.stopPropagation());
      }
    },
    _isAnnotationBounded: (e) => I(e.value) || I(e.argument),
    _pullOptions: (e) => ({
      type: e.type,
      name: e.name,
      x: e.x,
      y: e.y,
      value: e.value,
      argument: e.argument,
      axis: e.axis,
      series: e.series,
      options: e,
      offsetX: e.offsetX,
      offsetY: e.offsetY
    }),
    _forceAnnotationRender() {
      this._change(["FORCE_RENDER"]);
    },
    _clear() {
      this.hideTooltip(), this.clearHover();
    }
  }
}, Pte = {
  name: "annotations_polar_chart",
  init() {
  },
  dispose() {
  },
  members: {
    _getAnnotationCoords(e) {
      var t = {
        offsetX: e.offsetX,
        offsetY: e.offsetY,
        canvas: this._calcCanvas()
      }, r = this.getArgumentAxis(), n = r.validateUnit(e.argument), i = this.getValueAxis().validateUnit(e.value), s = e.radius, l = e.angle, d, h;
      return e.series && (h = this.series.filter((p) => p.name === e.series)[0]), W(!0, t, this.getXYFromPolar(l, s, n, i)), I(h) && (I(t.angle) && !I(i) && !I(s) ? (I(n) || (n = r.getTranslator().from(isFinite(l) ? this.getActualAngle(l) : t.angle)), d = h.getSeriesPairCoord({
        argument: n,
        angle: -t.angle
      }, !0)) : I(t.radius) && !I(n) && !I(l) && (d = h.getSeriesPairCoord({
        radius: t.radius
      }, !1)), I(d) && (t.x = d.x, t.y = d.y)), e.series && !I(d) && (t.x = t.y = void 0), t;
    },
    _annotationsPointerEventHandler: Bo.members._annotationsPointerEventHandler,
    _isAnnotationBounded: Bo.members._isAnnotationBounded,
    _pullOptions(e) {
      var t = W({}, {
        radius: e.radius,
        angle: e.angle
      }, Bo.members._pullOptions(e));
      return delete t.axis, t;
    },
    _forceAnnotationRender: Bo.members._forceAnnotationRender,
    _clear: Bo.members._clear
  }
}, Ite = {
  name: "annotations_vector_map",
  init() {
  },
  dispose() {
    this._annotations._offTracker(), this._annotations._offTracker = null;
  },
  members: {
    _getAnnotationCoords(e) {
      var t = {
        offsetX: e.offsetX,
        offsetY: e.offsetY
      };
      if (t.canvas = this._projection.getCanvas(), e.coordinates) {
        var r = this._projection.toScreenPoint(e.coordinates);
        t.x = r[0], t.y = r[1];
      }
      return t;
    },
    _annotationsPointerEventHandler: Bo.members._annotationsPointerEventHandler,
    _isAnnotationBounded: (e) => I(e.coordinates),
    _pullOptions(e) {
      var t = W({}, {
        coordinates: e.coordinates
      }, Bo.members._pullOptions(e));
      return delete t.axis, delete t.series, delete t.argument, delete t.value, t;
    },
    _forceAnnotationRender() {
      this._change(["EXTRA_ELEMENTS"]);
    },
    _getAnnotationStyles: () => ({
      "text-anchor": "start"
    }),
    _clear() {
    }
  },
  extenders: {
    _prepareExtraElements() {
      var e = this, t = () => {
        e._renderExtraElements();
      };
      e._annotations._offTracker = e._tracker.on({
        move: t,
        zoom: t,
        end: t
      });
    }
  }
}, Nte = {
  name: "annotations_pie_chart",
  init() {
  },
  dispose() {
  },
  members: {
    _getAnnotationCoords(e) {
      var t, r = {
        offsetX: e.offsetX,
        offsetY: e.offsetY,
        canvas: this._canvas
      };
      if (e.argument) {
        e.series ? t = this.getSeriesByName(e.series) : t = this.series[0];
        var n = t.getPointsByArg(e.argument)[0], {
          x: i,
          y: s
        } = n.getAnnotationCoords(e.location);
        r.x = i, r.y = s;
      }
      return r;
    },
    _isAnnotationBounded: (e) => e.argument,
    _annotationsPointerEventHandler: Bo.members._annotationsPointerEventHandler,
    _pullOptions(e) {
      var t = W({}, {
        location: e.location
      }, Bo.members._pullOptions(e));
      return delete t.axis, t;
    },
    _clear: Bo.members._clear,
    _forceAnnotationRender: Bo.members._forceAnnotationRender
  }
}, Vte = {
  name: "annotations_core",
  init() {
    this._annotations = {
      items: [],
      _hideToolTipForDrag: !1,
      tooltip: new jE({
        cssClass: "".concat(this._rootClassPrefix, "-annotation-tooltip"),
        eventTrigger: this._eventTrigger,
        widgetRoot: this.element(),
        widget: this
      }),
      hideTooltip() {
        this.tooltip.annotation = null, this.tooltip.hide();
      },
      clearItems() {
        this.items.forEach((e) => e.plaque.clear()), this.items = [];
      }
    }, this._annotations.tooltip.setRendererOptions(this._getRendererOptions());
  },
  dispose() {
    this._annotationsGroup.linkRemove().linkOff(), Ve.off(fk(), Sy), this._annotationsGroup.off(Sy), this._annotations.tooltip && this._annotations.tooltip.dispose();
  },
  extenders: {
    _createHtmlStructure() {
      this._annotationsGroup = this._renderer.g().attr({
        class: "".concat(this._rootClassPrefix, "-annotations")
      }).css(this._getAnnotationStyles()).linkOn(this._renderer.root, "annotations").linkAppend(), Ve.on(fk(), CB, (e) => {
        this._disposed || this._annotations.tooltip.isCursorOnTooltip(e.pageX, e.pageY) || this._annotations.hideTooltip();
      }), Ve.on(fk(), Ate, (e) => {
        this._annotations._hideToolTipForDrag = !1, this._annotationsPointerEventHandler(e);
      }), this._annotationsGroup.on(CB, this._annotationsPointerEventHandler.bind(this));
    },
    _renderExtraElements() {
      this._annotationsGroup.clear(), this._annotations.items.forEach((e) => e.draw(this, this._annotationsGroup));
    },
    _stopCurrentHandling() {
      this._annotations.hideTooltip();
    }
  },
  members: {
    _buildAnnotations() {
      this._annotations.clearItems();
      var e = this._getOption("annotations", !0);
      e != null && e.length && (this._annotations.items = Lte(this, e, this._getOption("commonAnnotationSettings"), this._getOption("customizeAnnotation", !0), this._pullOptions));
    },
    _setAnnotationTooltipOptions() {
      var e = W({}, this._getOption("tooltip"));
      e.contentTemplate = e.customizeTooltip = void 0, this._annotations.tooltip.update(e);
    },
    _getAnnotationCoords: () => ({}),
    _pullOptions: () => ({}),
    _getAnnotationStyles: () => ({})
  },
  customize(e) {
    e.addChange({
      code: "ANNOTATIONITEMS",
      handler() {
        this._requestChange(["ANNOTATIONS"]);
      },
      isOptionChange: !0,
      option: "annotations"
    }), e.addChange({
      code: "ANNOTATIONSSETTINGS",
      handler() {
        this._requestChange(["ANNOTATIONS"]);
      },
      isOptionChange: !0,
      option: "commonAnnotationSettings"
    }), e.addChange({
      code: "ANNOTATIONS",
      handler() {
        this._buildAnnotations(), this._setAnnotationTooltipOptions(), this._forceAnnotationRender();
      },
      isThemeDependent: !0,
      isOptionChange: !0
    });
  },
  fontFields: ["commonAnnotationSettings.font"]
}, MT = {
  core: Vte,
  chart: Bo,
  polarChart: Pte,
  vectorMap: Ite,
  pieChart: Nte
}, $E = "discrete", {
  abs: Fte,
  floor: Bte,
  ceil: zte,
  min: Q3
} = Math;
function EB(e, t, r) {
  e.min = e.min < t ? e.min : t, e.max = e.max > r ? e.max : r;
}
function TB(e, t) {
  if (e !== "logarithmic")
    return null;
  var r = t.getOptions().logarithmBase;
  return (n) => {
    var i = Gd(Fte(n), r), s = i < 0 ? Bte : zte;
    return s(i);
  };
}
function hD(e, t, r) {
  var n = EB;
  return e === $E ? n = function(i, s, l) {
    s !== l && i.categories.push(l), i.categories.push(s);
  } : t && (n = function(i, s) {
    var l = t.calculateInterval(s, i.prevValue), d = i.interval;
    i.interval = (d < l ? d : l) || d, i.prevValue = s, EB(i, s, s);
  }), r ? (i, s, l) => {
    var d = [];
    n(i, s, l), s !== 0 && d.push(r(s)), l !== 0 && d.push(r(l));
    var h = Q3.apply(null, d);
    i.linearThreshold = i.linearThreshold < h ? i.linearThreshold : h;
  } : n;
}
function aC(e, t, r) {
  var n = {
    axisType: e,
    dataType: t
  };
  return e === $E ? n.categories = [] : (n.min = hi(r) ? r.min : r, n.max = hi(r) ? r.max : r), n;
}
function vk(e) {
  return e.categories && (e.categories = MM(e.categories)), e;
}
function Hte(e, t, r, n) {
  if (t && I(t.value)) {
    var i = e.value, s = t.value, l = e.argument, d = t.argument, h = (r - l) * (s - i) / (d - l) + i.valueOf();
    return n.dataType === "datetime" ? new Date(h) : h;
  } else
    return e.value;
}
function Gte(e, t, r, n, i) {
  var s = Hte(r, n, i, t);
  e(t, s, s);
}
function J3(e) {
  return e.type.toLowerCase().indexOf("line") >= 0 || e.type.toLowerCase().indexOf("area") >= 0;
}
function wB(e) {
  var t = hD(e.valueAxisType), r = e.getArgumentAxis(), n = r && e.getArgumentAxis().visualRange() || {}, i = J3(e) ? Gte : Y;
  if (r && r.getMarginOptions().checkInterval) {
    var s = e.getArgumentAxis().getTranslator().getBusinessRange(), l = PM(s, !1), d = s.interval;
    isFinite(d) && I(n.startValue) && I(n.endValue) && (n.startValue = l(n.startValue, d, -1), n.endValue = l(n.endValue, d));
  }
  var h = iE(n);
  return function(p, m, x, S) {
    var T = m.argument;
    return m.hasValue() && (h(T) ? (p.startCalc || (p.startCalc = !0, i(t, p, m, S[x - 1], n.startValue)), t(p, m.getMinValue(), m.getMaxValue())) : !n.categories && I(n.startValue) && T > n.startValue && (p.startCalc || i(t, p, m, S[x - 1], n.startValue), p.endCalc = !0, i(t, p, m, S[x - 1], n.endValue))), p;
  };
}
function iE(e) {
  if (e.categories) {
    var t = e.categories.reduce((r, n) => (r[n.valueOf()] = !0, r), {});
    return (r) => I(r) && t[r.valueOf()];
  }
  return !I(e.startValue) && !I(e.endValue) ? () => !0 : I(e.endValue) ? I(e.startValue) ? (r) => r >= e.startValue && r <= e.endValue : (r) => r <= e.endValue : (r) => r >= e.startValue;
}
const Nd = {
  getViewPortFilter: iE,
  getArgumentRange: function(e) {
    var t = e._data || [], r = {};
    if (t.length)
      if (e.argumentAxisType === $E)
        r = {
          categories: t.map((l) => l.argument)
        };
      else {
        var n;
        if (t.length > 1) {
          var i = e.getArgumentAxis().calculateInterval(t[0].argument, t[1].argument), s = e.getArgumentAxis().calculateInterval(t[t.length - 1].argument, t[t.length - 2].argument);
          n = Q3(i, s);
        }
        r = {
          min: t[0].argument,
          max: t[t.length - 1].argument,
          interval: n
        };
      }
    return vk(r);
  },
  getRangeData: function(e) {
    var t = e.getPoints(), r = e.useAggregation(), n = e.getArgumentAxis(), i = hD(e.argumentAxisType, t.length > 1 && n, TB(e.argumentAxisType, n)), s = hD(e.valueAxisType, null, TB(e.valueAxisType, e.getValueAxis())), l = wB(e), d = t.reduce(function(m, x, S, T) {
      var k = x.argument;
      return x.isArgumentCorrect() && (i(m.arg, k, k), x.hasValue() && (s(m.val, x.getMinValue(), x.getMaxValue()), l(m.viewport, x, S, T))), m;
    }, {
      arg: aC(e.argumentAxisType, e.argumentType, n != null && n.aggregatedPointBetweenTicks() ? void 0 : e.getArgumentRangeInitialValue()),
      val: aC(e.valueAxisType, e.valueType, t.length ? e.getValueRangeInitialValue() : void 0),
      viewport: aC(e.valueAxisType, e.valueType, t.length ? e.getValueRangeInitialValue() : void 0)
    });
    if (r) {
      var h = this.getArgumentRange(e);
      if (e.argumentAxisType === $E)
        d.arg = h;
      else {
        var p = n.getViewport();
        (I(p.startValue) || I(p.length)) && i(d.arg, h.min, h.min), (I(p.endValue) || I(p.length) && I(p.startValue)) && i(d.arg, h.max, h.max);
      }
    }
    return vk(d.arg), vk(d.val), d;
  },
  getViewport: function(e) {
    var t = e.getPoints(), r, n = wB(e);
    return r = aC(e.valueAxisType, e.valueType, t.length ? e.getValueRangeInitialValue() : void 0), t.some(function(i, s) {
      return n(r, i, s, t), r.endCalc;
    }), r;
  },
  getPointsInViewPort: function(e) {
    var t = iE(e.getArgumentAxis().visualRange() || {}), r = e.getValueAxis().visualRange() || {}, n = iE(r), i = e.getPoints(), s = function(d, h, p) {
      var m = h.getMinValue(), x = h.getMaxValue(), S = n(m), T = n(x);
      S && d.push(m), x !== m && T && d.push(x), p && !S && !T && (d.length ? d.push(r.endValue) : d.push(r.startValue));
    }, l = J3(e) ? function(d, h, p) {
      var m = h[p], x = h[p - 1], S = h[p + 1];
      S && t(S.argument) && s(d[1], m, !0), x && t(x.argument) && s(d[1], m, !0);
    } : Y;
    return i.reduce(function(d, h, p) {
      return t(h.argument) ? s(d[0], h) : l(d, i, p), d;
    }, [
      [],
      []
    ]);
  }
};
var {
  floor: AB
} = Math, Ute = function(e, t, r, n, i) {
  var s = ~~((r < n ? r : n) / 2), l = i.width || 0, d = l < s ? l : s;
  e += d / 2, t += d / 2, r -= d, n -= d;
  var h = e + r, p = t + n, m = [], x = [], S, T = 0, k = 0, O = {
    top: [
      [e, t],
      [h, t]
    ],
    right: [
      [h, t],
      [h, p]
    ],
    bottom: [
      [h, p],
      [e, p]
    ],
    left: [
      [e, p],
      [e, t]
    ]
  };
  switch (be(O, function(D) {
    var L = !!i[D];
    T = 2 * T + ~~L;
  }), T) {
    case 13:
    case 9:
      S = ["left", "top", "right", "bottom"];
      break;
    case 11:
      S = ["bottom", "left", "top", "right"];
      break;
    default:
      S = ["top", "right", "bottom", "left"];
  }
  return be(S, function(D, L) {
    var F = !!i[L];
    !k && x.length && (m.push(x), x = []), F && be(O[L].slice(k), function(z, V) {
      x = x.concat(V);
    }), k = ~~F;
  }), x.length && m.push(x), m.length === 1 && (m = m[0]), {
    points: m,
    pathType: T === 15 ? "area" : "line"
  };
}, eU = function(e, t) {
  var r = ["width", "height"].every((i) => Math.abs(e[i] - t[i]) < 1), n = ["left", "right", "top", "bottom"].every((i) => e[i] === t[i]);
  return !(r && n);
}, vD = function(e) {
  return ei({}, e, {
    height: AB(e.height),
    width: AB(e.width)
  });
}, yh = Nl.format, {
  abs: zo,
  floor: aE
} = Math, YE = "exponential", J_ = ["fixedPoint", "thousands", "millions", "billions", "trillions", YE], Lh = ["millisecond", "second", "minute", "hour", "day", "month", "year"], jte = {
  week: "day",
  quarter: "month",
  shorttime: "hour",
  longtime: "second"
};
function $te(e, t) {
  for (var r = t; r < Lh.length - 1; r++) {
    var n = Lh[r];
    if (r === t) {
      rU(e, t + (e.millisecond ? 2 : 1));
      break;
    } else if (e[n] && e.count > 1) {
      tU(e, r);
      break;
    }
  }
}
function Yte(e, t) {
  for (var r = !1, n = Lh.length - 1; n >= t; n--) {
    var i = Lh[n];
    if (e[i] && n - t > 1) {
      for (var s = 0; s <= t; s++)
        tU(e, s), r = !0;
      break;
    }
  }
  return r;
}
function oE(e, t, r, n) {
  n = jte[n] || n;
  var i = Lh.indexOf(n);
  if (r) {
    var s = Et.getDatesDifferences(t, r);
    return s[n] && $te(s, i), s;
  } else {
    var l = Et.getDatesDifferences(e, t), d = Yte(l, i);
    return !d && l.count === 1 && rU(l, i), l;
  }
}
function tU(e, t) {
  var r = Lh[t];
  e[r] && (e[r] = !1, e.count--);
}
function rU(e, t) {
  var r = Lh[t];
  e[r] === !1 && (e[r] = !0, e.count++);
}
function Wte(e) {
  return e.length - parseInt(e).toString().length;
}
function nU(e, t) {
  var r, n, i, s = 0;
  for (i = zo(t - e[0]), r = 1; r < e.length; r++)
    n = zo(t - e[r]), n < i && (i = n, s = r);
  return s;
}
function pD(e) {
  return e.toString().split(".");
}
function LT(e) {
  var t;
  return ct(e) && (t = e, e = null), {
    type: e,
    formatter: t
  };
}
function Xte(e) {
  var t = qR(zo(e)), r;
  if (t > 0)
    r = J_[aE(t / 3)] || YE;
  else if (t < -4)
    r = YE;
  else
    return yh(rr(e));
  return yh(e, {
    type: r,
    precision: 0
  });
}
function qte(e, t) {
  var {
    showTransition: r,
    ticks: n,
    tickInterval: i
  } = t, s = Et.getDateFormatByTickInterval(i), l, d;
  if (r && n.length) {
    var h = n.map(Number).indexOf(+e);
    if (n.length === 1 && h === 0)
      s = Nl.getDateFormatByTicks(n);
    else {
      h === -1 ? l = nU(n, e) : (l = h === 0 ? n.length - 1 : h - 1, d = h === 0 ? 1 : -1);
      var p = oE(n[l], e, n[d], s);
      s = Nl.getDateFormatByDifferences(p, s);
    }
  }
  return LT(s);
}
function Kte(e, t) {
  var r = zo(e).toString();
  return Ch(e) ? Math.max(zo(X_(e) - X_(t)), zo(EE(e) - EE(t))) : zo(Wte(r.split(".")[1]) - X_(t) + 1);
}
function Zte(e, t) {
  var r = aE(qR(t)), n, i = 0, s = n = aE(qR(zo(e)));
  n - r >= 2 && (s = r);
  var l = aE(s / 3), d = 3 * l;
  l < 0 && (l = 0);
  var h = J_[l] || J_[J_.length - 1];
  if (d > 0) {
    var p = pD(t / Math.pow(10, d));
    p[1] && (i = p[1].length);
  }
  return {
    precision: i,
    type: h
  };
}
function Qte(e) {
  var t = !1;
  for (var r in e)
    e[r] === !0 || r === "hour" || t ? (e[r] = !1, t = !0) : e[r] === !1 && (e[r] = !0);
  return LT(Nl.getDateFormatByDifferences(e));
}
function Jte(e, t) {
  var r = !1;
  for (var n in e)
    r ? e[n] = !1 : n === t ? r = !0 : e[n] = !0;
  return LT(Nl.getDateFormatByDifferences(e));
}
function ere(e, t, r) {
  var n = oE(e, t), i = Et.getDateFormatByTickInterval(r), s = Nl.getDateFormatByDifferences(n, i), l = LT(s), d = [];
  if (r in n) {
    var h = Jte(oE(e, t), r), p = yh(e, h);
    p && d.push(p);
  } else {
    var m = Qte(oE(e, t)), x = yh(e, m);
    x && d.push(x), d.push("".concat(yh(e, l), " - ").concat(yh(t, l)));
  }
  return d.join(", ");
}
function tre(e) {
  if (hi(e)) {
    var t = Object.keys(e), r = t.reduce((i, s) => e[s] + i, 0);
    if (r === 1) {
      var n = t.filter((i) => e[i] === 1)[0];
      return n.slice(0, n.length - 1);
    }
  }
  return e;
}
function gD(e, t) {
  var r = t.tickInterval, n = zo(e).toString(), i = t.labelOptions.format, s = t.ticks, l = t.type === "logarithmic";
  if (s.length === 1 && s.indexOf(e) === 0 && !I(r) && (r = zo(e) >= 1 ? 1 : rr(1 - zo(e), e)), Object.is(e, -0) && (e = 0), !I(i) && t.type !== "discrete" && e && (t.logarithmBase === 10 || !l))
    if (t.dataType !== "datetime" && I(r)) {
      if (s.length && s.indexOf(e) === -1) {
        var d = nU(s, e);
        r = rr(zo(e - s[d]), e);
      }
      if (l)
        return Xte(e);
      var h = pD(r);
      h < 2 && (h = pD(e)), h.length > 1 && !Ch(r) ? i = {
        type: J_[0],
        precision: h[1].length
      } : Ch(r) && (n.indexOf(".") !== -1 || Ch(e)) ? i = {
        type: YE,
        precision: Kte(e, r)
      } : i = Zte(e, r);
    } else
      t.dataType === "datetime" && (i = qte(e, t));
  return yh(e, i);
}
function rre(e) {
  var {
    startValue: t,
    endValue: r,
    tickInterval: n,
    argumentFormat: i,
    axisOptions: {
      dataType: s,
      type: l,
      logarithmBase: d
    }
  } = e;
  if (l === "discrete")
    return "";
  if (s === "datetime")
    return ere(t, r, tre(n));
  var h = {
    ticks: [],
    type: l,
    dataType: s,
    tickInterval: n,
    logarithmBase: d,
    labelOptions: {
      format: i
    }
  };
  return "".concat(gD(t, h), " - ").concat(gD(r, h));
}
const Dt = {
  logarithmic: "logarithmic",
  discrete: "discrete",
  numeric: "numeric",
  left: "left",
  right: "right",
  top: "top",
  bottom: "bottom",
  center: "center",
  horizontal: "horizontal",
  vertical: "vertical",
  convertTicksToValues: function(e) {
    return ti(e || [], function(t) {
      return t.value;
    });
  },
  validateOverlappingMode: function(e) {
    return e === "ignore" || e === "none" ? e : "hide";
  },
  getTicksCountInRange: function(e, t, r) {
    var n = 1;
    if (e.length > 1)
      for (; n < e.length && !(Math.abs(e[n].coords[t] - e[0].coords[t]) >= r); n++)
        ;
    return n;
  },
  areLabelsOverlap: function(e, t, r, n) {
    var i = e.x > t.x, s = e.y > t.y, l = e.x, d = t.x, h = e.width, p = t.width;
    n === "left" ? (l += h / 2, d += p / 2) : n === "right" && (l -= h / 2, d -= p / 2);
    var m = i ? d + p + r > l : l + h + r > d, x = s ? t.y + t.height > e.y : e.y + e.height > t.y;
    return m && x;
  }
};
var iU = "number", aU = "yyyy/MM/dd", nre = "yyyy/MM/dd HH:mm:ss", oU = /^(\d{4,})(-)?(\d{2})(-)?(\d{2})(?:T(\d{2})(:)?(\d{2})?(:)?(\d{2}(?:\.(\d{1,3})\d*)?)?)?(Z|([+-])(\d{2})(:)?(\d{2})?)?$/, sU = /^(\d{2}):(\d{2})(:(\d{2}))?$/, OB = ["", "yyyy", "", "MM", "", "dd", "THH", "", "mm", "", "ss", ".SSS"], ire = /^(\d{4})\/(\d{2})\/(\d{2})$/, are = 3, lU = function(e, t) {
  var r;
  return lr(e) && !t && (r = sre(e)), r || ore(e);
};
function Ki(e) {
  return +e || 0;
}
function ore(e) {
  var t = uU(e) === aU, r = !Ls(e) && Date.parse(e);
  if (!r && t) {
    var n = e.match(ire);
    if (n) {
      var i = new Date(Ki(n[1]), Ki(n[2]), Ki(n[3]));
      return i.setFullYear(Ki(n[1])), i.setMonth(Ki(n[2]) - 1), i.setDate(Ki(n[3])), i;
    }
  }
  return Sr(r) ? new Date(r) : e;
}
function sre(e) {
  var t = e.match(oU);
  if (!t)
    return t = e.match(sU), t ? new Date(0, 0, 0, Ki(t[1]), Ki(t[2]), Ki(t[4])) : void 0;
  var r = Ki(t[1]), n = --t[3], i = t[5], s = 0, l = 0, d = (S) => (r < 100 && S.setFullYear(r), S);
  s = Ki(t[14]), l = Ki(t[16]), t[13] === "-" && (s = -s, l = -l);
  var h = Ki(t[6]) - s, p = Ki(t[8]) - l, m = Ki(t[10]), x = function(S) {
    return S = S || "", Ki(S) * Math.pow(10, are - S.length);
  }(t[11]);
  return t[12] ? d(new Date(Date.UTC(r, n, i, h, p, m, x))) : d(new Date(r, n, i, h, p, m, x));
}
var lre = function(e, t) {
  var r = e.match(oU), n = "";
  if (!r)
    return r = e.match(sU), r ? r[3] ? "HH:mm:ss" : "HH:mm" : void 0;
  for (var i = 1; i < OB.length; i++)
    r[i] && (n += OB[i] || r[i]);
  return r[12] === "Z" && (n += "'Z'"), r[14] && (r[15] ? n += "xxx" : r[16] ? n += "xx" : n += "x"), n;
}, ure = function(e) {
  return typeof e == "number" ? new Date(e) : lU(e, !Zr().forceIsoDateParsing);
}, cre = function(e, t) {
  return t ? Ls(e) ? t === iU ? e && e.valueOf ? e.valueOf() : null : j3(t, U_)(e) : null : e;
}, uU = function(e) {
  if (typeof e == "number")
    return iU;
  if (lr(e)) {
    var t;
    return Zr().forceIsoDateParsing && (t = lre(e)), t || (e.indexOf(":") >= 0 ? nre : aU);
  } else if (e)
    return null;
};
const dre = {
  dateParser: lU,
  deserializeDate: ure,
  serializeDate: cre,
  getDateSerializationFormat: uU
};
var fre = {
  string: function(e) {
    return I(e) ? "" + e : e;
  },
  numeric: function(e) {
    if (!I(e))
      return e;
    var t = Number(e);
    return isNaN(t) && (t = void 0), t;
  },
  datetime: function(e) {
    if (!I(e))
      return e;
    var t, r = Number(e);
    return isNaN(r) ? t = dre.deserializeDate(e) : t = new Date(r), isNaN(Number(t)) && (t = void 0), t;
  }
};
function hre(e) {
  return e === "numeric" || e === "datetime" || e === "string" ? e : "";
}
var cU = function(e) {
  return fre[hre(e)] || Y;
}, dU = Et.convertDateUnitToMilliseconds, Od = Et.dateToMilliseconds, Th = Math, Ud = Th.abs, Ph = Th.floor, wh = Th.ceil, vre = Th.pow, fU = [1, 2, 2.5, 5], pre = [1, 2, 3, 5], hU = {
  millisecond: [1, 2, 5, 10, 25, 50, 100, 250, 500],
  second: [1, 2, 3, 5, 10, 15, 20, 30],
  minute: [1, 2, 3, 5, 10, 15, 20, 30],
  hour: [1, 2, 3, 4, 6, 8, 12],
  day: [1, 2],
  week: [1, 2],
  month: [1, 2, 3, 6]
}, gre = W({}, hU, {
  day: [1]
}), mre = {
  millisecond: [1, 2, 5, 10, 25, 50, 100, 250, 500],
  second: [1, 2, 3, 5, 10, 15, 20, 30],
  minute: [1, 2, 3, 5, 10, 15, 20, 30],
  hour: [1, 2, 3, 4, 6, 8, 12],
  day: [1, 2, 3, 7, 14],
  month: [1, 2, 3, 6]
}, _re = [2, 4, 5, 8, 10], yre = 3, kB = 6e4;
function xre(e) {
  return function(t, r, n, i) {
    var s = Ph(r / e.axisDivisionFactor);
    s = s < 1 ? 1 : s;
    var l = r / s;
    return {
      ticks: l > 0 ? Array.apply(null, new Array(s + 1)).map((d, h) => l * h) : [],
      tickInterval: l
    };
  };
}
function bre(e) {
  return function(t, r, n, i) {
    var s = Xu(t.categories, t.min, t.max).categories;
    return {
      ticks: s,
      tickInterval: wh(s.length * e.axisDivisionFactor / r)
    };
  };
}
var Kr = (e) => e, vU = (e, t, r) => (n) => Ai(n, e, t, r), Sre = (e, t, r) => (n) => Dh(n, e, t, r), Cre = (e) => (t) => KR(t, e), Ere = (e) => (t) => t === 0 ? 0 : Gd(Ud(t), e), WE = (e, t, r) => (n, i) => rr(e(t(rr(r(n) / i)) * i));
function sL(e, t, r, n) {
  return I(n) ? n ? e : t : function(i, s, l, d) {
    var h = e(i, s);
    return i - h === 0 || !I(l) || r(i, h, s, l) || d ? h : t(i, s);
  };
}
function XE(e, t, r, n) {
  var i = r - Ud(t - e), s = Th.max(wh(n.businessDelta / r), 2), l = n.screenDelta / (s * r), d = Th.round(l * i), h = Ai(l * r / n.axisDivisionFactor, 2) + 1, p = (n.isSpacedMargin ? 2 : 1) * h, m = Th.round(yre * p);
  return n.businessDelta > n.interval && d >= m;
}
function RB(e) {
  return function(t, r, n, i) {
    return XE(Ai(t, e), Ai(r, e), n, i);
  };
}
function DB(e, t, r, n) {
  return XE(e.valueOf(), t.valueOf(), Od(r), n);
}
function pU(e, t) {
  var r = 0;
  return t && (r = t.reduce((n, i) => n + (i.to - i.from), 0)), Ud(e.max - e.min - r);
}
function Tre(e, t, r) {
  var n = vU(e, t, r);
  return function(i, s) {
    var l = 0;
    return s && (l = s.reduce((d, h) => d + Ud(n(h.to / h.from)), 0)), wh(Ud(n(i.max) - n(i.min)) - l);
  };
}
function PT(e, t, r, n) {
  var i = t / r - (n || 0);
  return i = i < 1 ? 1 : i, e / i;
}
function gU(e, t) {
  return vre(10, Ph(Ai(e, 10)) + (t || 0));
}
function wre(e, t, r, n, i, s, l, d, h, p) {
  var m = PT(e, t, i, d), x = 1, S = l === !1;
  return (!n || !r) && ((m >= 1 || !S && m > 0) && (x = mD(m, s, S)), (!r || !n && r < x) && (r = x)), !n && p && (p = mD(p, s, S), p > r && (r = p)), r;
}
function mD(e, t, r) {
  var n = gU(e, -1), i = 1;
  return t = t || fU, e > 0 && (e /= n, i = t.concat(10 * t[0]).map((s) => 10 * s).reduce((s, l) => n === 0.1 && r && l === 25 ? s : s < e ? l : s, 0), i = rr(i * n, n)), i;
}
function mU(e, t, r, n) {
  var i = PT(e, t, n);
  return r || _re.reduce((s, l) => {
    var d = e / l;
    return d >= i ? d : s;
  }, 0);
}
function Are(e) {
  return function(t, r, n, i, s, l, d, h, p, m) {
    var x = PT(t, r, s), S = 0, T = _U(e);
    return (!i || !n) && (x > 0 && (S = T(x, l)), (!n || !i && n < S) && (n = S)), !i && m && (m = T(m, l), m > n && (n = m)), n;
  };
}
function _U(e) {
  return function(t, r) {
    var n = gU(t);
    return r = r || pre, !e && n < 1 && (n = 1), r.concat(10 * r[0]).reduce((i, s) => i < t ? s * n : i, 0);
  };
}
function Ore(e) {
  return e && e > 2 ? gre : hU;
}
function kre(e, t) {
  return function(r, n) {
    return !r && e <= dU(t, n) && (r = {}, r[t + "s"] = n), r;
  };
}
function Rre(e, t) {
  return function(r, n) {
    var i = t * n;
    return !r && e <= dU("year", i) && i !== 2.5 && (r = {
      years: i
    }), r;
  };
}
function yU(e, t, r, n, i, s, l, d, h, p) {
  if (!n || !r) {
    var m = qE(PT(e, t, i), s, null, h);
    (!r || !n && Od(r) <= Od(m)) && (r = m);
  }
  return !n && p && (p = qE(p, s, null, h), Od(p) > Od(r) && (r = p)), r;
}
function qE(e, t, r, n) {
  var i;
  t = t || Ore(n);
  for (var s in t)
    if (i = t[s].reduce(kre(e, s), i), i)
      break;
  if (!i)
    for (var l = 1; i = fU.reduce(Rre(e, l), i), !i; l *= 10)
      ;
  return i;
}
function Dre(e, t, r, n) {
  return yU(e, t, r, !0, n, mre);
}
function KE(e, t) {
  return (r) => r && t(Ud(rr(e(r[1]) - e(r[0])))) || void 0;
}
function Cg(e, t, r) {
  return Et.addInterval(e, t, r);
}
function Mre(e, t) {
  return (r, n, i) => t(Cg(e(r), n, i));
}
function oC(e, t, r) {
  return Cg(e, t, r);
}
function xU(e, t, r) {
  return t = t.filter((n) => !n.gapSize), function(n, i, s) {
    var l;
    return n = e(n, i, s), t.every((d) => (n >= e(d.from, i) && e(n, i) < d.to && (l = d.to - d.from - 2 * (e(d.from, i) - d.from)), !l)) || (n = r(e(n, l), i)), n;
  };
}
function lL(e, t, r, n) {
  return function(i, s, l, d, h, p, m, x, S) {
    var T = Lre(e, d), k = i.min, O = i.max, D = {
      screenDelta: m,
      businessDelta: p,
      axisDivisionFactor: x,
      isSpacedMargin: i.isSpacedMargin,
      interval: s
    }, L = t(k, s, D), F = [];
    h != null && h.length && (e = xU(e, h, t)), L > O && (L = t(k, r(p / 2), D), L > O && (l = !0, L = t(k, s, D, l))), L = T(L);
    for (var z; L < O && L !== z || S && L <= O; )
      F.push(L), z = L, L = T(e(L, s));
    return (l || L - O === 0 || !I(l) && n(O, L, s, D)) && F.push(L), F;
  };
}
function uL(e, t, r, n, i) {
  return function(s, l, d, h, p, m, x) {
    var S = p / h, T = d[d.length - 1], k = d[0], O = x - 1;
    if (m != null && m.length && (t = xU(t, m, r)), h = e(h, k, k, S), h === 0)
      return [];
    var D = n(r(s, p, s), h);
    h = e(h, k, D, S);
    for (var L = []; D < k && (!O || O > 0); )
      D >= s && L.push(D), O--, D = t(D, h);
    var F = d.reduce((P, j) => {
      if (O = x - 1, P.prevTick === null)
        return P.prevTick = j, P;
      h = e(h, j, P.prevTick, S);
      for (var Z = n(P.prevTick, h); Z < j && (!O || O > 0); )
        Z !== P.prevTick && P.minors.push(Z), O--, Z = t(Z, h);
      return P.prevTick = j, P;
    }, {
      prevTick: null,
      minors: []
    });
    L = L.concat(F.minors);
    var z = i(l, p, s);
    h = e(h, z, z, S), D = n(T, h);
    for (var V; D < l && D !== V; )
      L.push(D), V = D, D = t(D, h);
    return T - l !== 0 && D - l === 0 && L.push(D), L;
  };
}
function MB(e, t) {
  if (t.length) {
    var r = t.reduce((n, i) => {
      var s = [], l;
      for (l = n[1]; l < e.length; l++) {
        var d = e[l];
        if (d < i.from && s.push(d), d >= i.to)
          break;
      }
      return [n[0].concat(s), l];
    }, [
      [],
      0
    ]);
    return r[0].concat(e.slice(r[1]));
  }
  return e;
}
function Lre(e, t) {
  return function(r) {
    var n;
    return t.every((i) => (r >= i.from && r < i.to && (n = i.gapSize), !n)) || (r = e(r, n)), r;
  };
}
function cL(e, t, r, n, i, s, l, d, h, p) {
  function m(x, S, T) {
    return x && S / l(x) >= T + 1 && (e.incidentOccurred("W2003"), x = void 0), x;
  }
  return function(x, S, T, k, O, D, L, F) {
    O = O || {};
    var z = t(x, F), V = function(P) {
      return {
        tickInterval: i(P.majors),
        ticks: P.majors || [],
        minorTickInterval: s(P.minors),
        minorTicks: P.minors || []
      };
    }(O);
    return isNaN(z) || (z === 0 && !O.majors ? V.ticks = [x.min] : (V = function(P, j, Z, ee, J, he, de, Re) {
      if (de.majors)
        return P.breaks = Re, P;
      var Ce = Re.filter((me) => me.gapSize), le;
      return J = e.skipCalculationLimits ? J : m(J, Z, ee), J = r(Z, ee, J, he, e.axisDivisionFactor, e.numberMultipliers, e.allowDecimals, Re.length, Ce[0] && Ce[0].gapSize.days, e.minTickInterval), e.skipTickGeneration || (le = d(j, J, e.endOnTick, Ce, Re, Z, ee, e.axisDivisionFactor, e.generateExtraTick), Re = p(Re, le, J), le = MB(le, Re), P.breaks = Re, P.ticks = P.ticks.concat(le)), P.tickInterval = J, P;
    }(V, x, z, S, T, k, O, F || []), !e.skipTickGeneration && z > 0 && (V = function(P, j, Z, ee, J, he, de) {
      if (!e.calculateMinors || de.minors)
        return P;
      var Re = l(P.tickInterval), Ce = ee * Re / Z, le = P.breaks;
      return !J && he ? J = s([Re / (he + 1), Re / (he + 1) * 2]) : he = void 0, J = m(J, Re, Ce), J = n(Re, Ce, J, e.minorAxisDivisionFactor), P.minorTicks = MB(P.minorTicks.concat(h(j.min, j.max, P.ticks, J, P.tickInterval, le, he)), le), P.minorTickInterval = J, P;
    }(V, x, z, S, D, L, O)))), V;
  };
}
function LB(e, t, r, n) {
  var [i, s] = t;
  return (!I(i) || Ud(n(e) - n(i)) / r > 0.25) && (I(s) && Ud(n(s) - n(i)) / r < 2 ? i = s : I(i) || (i = e)), i;
}
function dL(e, t, r) {
  return function(n, i, s) {
    var l = e(s), d = 0.5 * l;
    return n.reduce((h, p) => {
      var m = i.filter((T) => T <= p.from), x = r(LB(p.from, [].concat(m[m.length - 1], i[m.length]), l, t), d);
      m = i.filter((T) => T >= p.to);
      var S = r(LB(p.to, [].concat(m[0], i[i.length - m.length - 1]), l, t), -d);
      return t(S) - t(x) < l && !p.gapSize ? h : p.gapSize ? h.concat([p]) : h.concat([{
        from: x,
        to: S,
        cumulativeWidth: p.cumulativeWidth
      }]);
    }, []);
  };
}
function Pre(e) {
  var t = WE(Kr, Ph, Kr), r = WE(Kr, wh, Kr), n = KE(Kr, Kr);
  return cL(e, pU, wre, mU, n, n, Kr, lL(Cg, sL(t, r, XE, e.endOnTick), mD, XE), uL(Kr, Cg, t, Cg, Kr), dL(Kr, Kr, (i, s) => i + s));
}
var PB = (e, t, r) => (n, i) => Hd(n) * rr(e(t(n)(rr(r(n) / i)) * i));
function Ire(e) {
  var t = e.logBase, r = Sre(t, e.allowNegatives, e.linearThreshold), n = vU(t, e.allowNegatives, e.linearThreshold), i = Ere(t), s = Cre(t), l = PB(s, (p) => p < 0 ? wh : Ph, i), d = PB(s, (p) => p < 0 ? Ph : wh, i), h = WE(Kr, wh, Kr);
  return cL(e, Tre(t, e.allowNegatives, e.linearThreshold), Are(e.skipCalculationLimits), mU, KE(n, Kr), KE(Kr, Kr), Kr, lL(Mre(n, r), sL(l, d, RB(t), e.endOnTick), _U(e.skipCalculationLimits), RB(t)), uL((p, m, x, S) => Math.max(Math.abs(m), Math.abs(x)) / S, Cg, l, h, d), dL(Kr, n, (p, m) => r(n(p) + m)));
}
function Nre(e) {
  function t(n, i) {
    var s = WE(Kr, Ph, Kr), l = lr(i) ? Et.getDateIntervalByString(i.toLowerCase()) : i, d = Od(i);
    (l.days % 7 === 0 || i.quarters) && (l = qE(d));
    var h = (m) => Et.correctDateWithUnitBeginning(m, l, null, e.firstDayOfWeek), p = (m) => new Date(Ph((m.getTime() - m.getTimezoneOffset() * kB) / d) * d + m.getTimezoneOffset() * kB);
    return n = h(n), "years" in l ? n.setFullYear(s(n.getFullYear(), l.years)) : "quarters" in l ? n = h(p(n)) : "months" in l ? n.setMonth(s(n.getMonth(), l.months)) : "weeks" in l || "days" in l ? n = h(p(n)) : "hours" in l ? n.setHours(s(n.getHours(), l.hours)) : "minutes" in l ? n.setMinutes(s(n.getMinutes(), l.minutes)) : "seconds" in l ? n.setSeconds(s(n.getSeconds(), l.seconds)) : "milliseconds" in l && (n = p(n)), n;
  }
  var r = KE(Kr, Et.convertMillisecondsToDateUnits);
  return cL(e, pU, yU, Dre, r, r, Od, lL(oC, sL(t, function(n, i) {
    for (var s = t(n, i); n - s > 0; )
      s = oC(s, i);
    return s;
  }, DB, e.endOnTick), qE, DB), uL(Kr, oC, t, oC, Kr), dL(Od, Kr, (n, i) => new Date(n.getTime() + i)));
}
var Vre = function(e) {
  var t;
  return e.rangeIsEmpty ? t = xre(e) : e.axisType === "discrete" ? t = bre(e) : e.axisType === "logarithmic" ? t = Ire(e) : e.dataType === "datetime" ? t = Nre(e) : t = Pre(e), t;
};
function IB(e) {
  return {
    stroke: e.color,
    "stroke-width": e.width,
    "stroke-opacity": e.opacity,
    opacity: 1
  };
}
function IT(e, t, r, n, i, s, l) {
  var d = l || e._tickOffset, h = e._axisLineGroup, p = e._axisElementsGroup, m = IB(r), x = IB(n), S = /^\s+$/, T = e.getOptions(), k = T.label, O = e._textOptions;
  function D(F) {
    var z = e._textFontStyles, V = k.customizeColor;
    return V && V.call && (z = W({}, e._textFontStyles, {
      fill: V.call(F, F)
    })), z;
  }
  function L(F, z) {
    var V = e.formatHint(F.value, k, z);
    I(V) && V !== "" && F.getContentContainer().setTitle(V);
  }
  return function(F) {
    var z = {
      value: F,
      updateValue(V) {
        this.value = F = V;
      },
      initCoords: function() {
        this.coords = e._getTranslatedValue(F, d), this.labelCoords = e._getTranslatedValue(F);
      },
      saveCoords() {
        this._lastStoredCoordinates = {
          coords: this._storedCoords,
          labelCoords: this._storedLabelsCoords
        }, this._storedCoords = this.coords, this._storedLabelsCoords = this.templateContainer ? this._getTemplateCoords() : this.labelCoords;
      },
      resetCoordinates() {
        this._lastStoredCoordinates && (this._storedCoords = this._lastStoredCoordinates.coords, this._storedLabelsCoords = this._lastStoredCoordinates.labelCoords);
      },
      drawMark(V) {
        !r.visible || i === F || e.areCoordsOutsideAxis(this.coords) || (this.mark ? (this.mark.append(h), e.sharp(this.mark, e.getSharpDirectionByCoords(this.coords)), this.updateTickPosition(V)) : (this.mark = e._createPathElement([], m, e.getSharpDirectionByCoords(this.coords)).append(h), this.updateTickPosition(V)));
      },
      setSkippedCategory(V) {
        i = V;
      },
      _updateLine(V, P, j, Z, ee) {
        if (V) {
          if (P.points === null || P.r === null) {
            V.remove();
            return;
          }
          Z && j && j.points !== null ? (P.opacity = 1, V.attr(j), V.animate(P)) : (P.opacity = Z ? 0 : 1, V.attr(P), Z && V.animate({
            opacity: 1
          }, {
            delay: 0.5,
            partitionDuration: 0.5
          })), this.coords.angle && e._rotateTick(V, this.coords, ee);
        }
      },
      updateTickPosition: function(V, P) {
        this._updateLine(this.mark, {
          points: e._getTickMarkPoints(z.coords, r.length, V)
        }, this._storedCoords && {
          points: e._getTickMarkPoints(z._storedCoords, r.length, V)
        }, P, !1);
      },
      drawLabel: function(V, P) {
        if (this.templateContainer && e.isRendered()) {
          this.updateLabelPosition();
          return;
        }
        var j = k.visible && !s && !e.getTranslator().getBusinessRange().isEmpty() && !e.areCoordsOutsideAxis(this.labelCoords);
        if (!j) {
          this.label && this.removeLabel();
          return;
        }
        var Z = k.template, ee = e.formatLabel(F, k, V);
        if (this.label) {
          this.label.attr({
            text: ee,
            rotate: 0
          }).append(p), L(this, V), this.updateLabelPosition();
          return;
        }
        Z ? (this.templateContainer = t.g().append(p), this._templateDef && this._templateDef.reject(), this._templateDef = new Yt(), P.render({
          model: {
            valueText: ee,
            value: this.value,
            labelFontStyle: D(this),
            labelStyle: O
          },
          container: this.templateContainer.element,
          onRendered: () => {
            this.updateLabelPosition(), this._templateDef && this._templateDef.resolve();
          }
        })) : I(ee) && ee !== "" && !S.test(ee) && (this.label = t.text(ee).css(D(this)).attr(O).append(p), this.updateLabelPosition(), L(this, V));
        var J = this.getContentContainer();
        J && J.data("chart-data-argument", this.value), this.templateContainer && L(this, V);
      },
      getTemplateDeferred() {
        return this._templateDef;
      },
      getContentContainer() {
        return this.templateContainer || this.label;
      },
      fadeOutElements() {
        var V = {
          opacity: 1
        }, P = {
          opacity: 0
        }, j = {
          partitionDuration: 0.5
        };
        this.getContentContainer() && this._fadeOutLabel(), this.grid && this.grid.append(e._axisGridGroup).attr(V).animate(P, j), this.mark && this.mark.append(e._axisLineGroup).attr(V).animate(P, j);
      },
      _fadeInLabel() {
        var V = e._renderer.g().attr({
          opacity: 0
        }).append(e._axisElementsGroup).animate({
          opacity: 1
        }, {
          delay: 0.5,
          partitionDuration: 0.5
        });
        this.getContentContainer().append(V);
      },
      _fadeOutLabel() {
        var V = e._renderer.g().attr({
          opacity: 1
        }).animate({
          opacity: 0
        }, {
          partitionDuration: 0.5
        }).append(e._axisElementsGroup).toBackground();
        this.getContentContainer().append(V);
      },
      _getTemplateCoords() {
        return e._getLabelAdjustedCoord(this, (e._constantLabelOffset || 0) + (z.labelOffset || 0));
      },
      updateLabelPosition: function(V) {
        var P = this.templateContainer;
        if (this.getContentContainer())
          if (V && this._storedLabelsCoords)
            if (P) {
              P.attr(this._storedLabelsCoords);
              var j = this._getTemplateCoords();
              P.animate(j);
            } else
              this.label.attr({
                x: this._storedLabelsCoords.x,
                y: this._storedLabelsCoords.y
              }), this.label.animate({
                x: this.labelCoords.x,
                y: this.labelCoords.y
              });
          else {
            if (P) {
              var Z = this._getTemplateCoords();
              P.attr(Z);
            } else
              this.label.attr({
                x: this.labelCoords.x,
                y: this.labelCoords.y
              });
            V && this._fadeInLabel();
          }
      },
      updateMultilineTextAlignment() {
        k.template || !this.label || this.label.attr({
          textsAlignment: this.labelAlignment || e.getOptions().label.alignment
        });
      },
      drawGrid: function(V) {
        n.visible && i !== this.value && (this.grid ? (this.grid.append(e._axisGridGroup), e.sharp(this.grid, e.getSharpDirectionByCoords(this.coords)), this.updateGridPosition()) : (this.grid = V(this, x), this.grid && this.grid.append(e._axisGridGroup)));
      },
      updateGridPosition: function(V) {
        this._updateLine(this.grid, e._getGridPoints(z.coords), this._storedCoords && e._getGridPoints(this._storedCoords), V, !0);
      },
      removeLabel() {
        var V = this.getContentContainer();
        V && V.remove(), this._templateDef && this._templateDef.reject(), this._templateDef = this.templateContainer = this.label = null;
      }
    };
    return z;
  };
}
var Fre = [0, 1, 2, 3, 4, 5, 6];
function Bre(e) {
  return Fre.filter(function(t) {
    return !e.some(function(r) {
      return r === t;
    });
  });
}
function Eg(e) {
  return (e + 1) % 7;
}
function zre(e, t) {
  for (var r = e.start, n = e.end; r !== n; ) {
    if (r === t)
      return !0;
    r = Eg(r);
  }
  return !1;
}
function Hre(e, t) {
  for (var r = 0; e !== t; )
    e = Eg(e), r++;
  return r;
}
function Gre(e, t) {
  var r = [], n = new Date(t);
  return n.setDate(t.getDate() + 1), t > e.from && r.push({
    from: e.from,
    to: t
  }), n < e.to && r.push({
    from: n,
    to: e.to
  }), r;
}
function Ure(e) {
  var t = Bre(e);
  if (t.length < 7)
    for (; Eg(t[t.length - 1]) === t[0]; )
      t.unshift(t.pop());
  return t;
}
function jre(e, t, r) {
  var n = e.getDate(), i = [], s = r.reduce(function(l, d) {
    var h = l[1];
    return h.start === void 0 ? (h = {
      start: d,
      end: Eg(d)
    }, l[0].push(h), [l[0], h]) : h.end === d ? (h.end = Eg(d), l) : (h = {
      start: d,
      end: Eg(d)
    }, l[0].push(h), [l[0], h]);
  }, [
    [],
    {}
  ]);
  return s[0].forEach(function(l) {
    var d = new Date(e);
    for (d = Et.trimTime(d); d < t; ) {
      n = d.getDay();
      var h = d.getDate();
      if (zre(l, n)) {
        var p = new Date(d);
        d.setDate(h + Hre(n, l.end));
        var m = new Date(d);
        i.push({
          from: p,
          to: m
        });
      }
      d.setDate(d.getDate() + 1);
    }
  }), i;
}
function $re(e, t) {
  var r = e.slice(), n, i = function(s) {
    if (s = Et.trimTime(new Date(s)), r[n].from <= s && r[n].to > s) {
      var l = Gre(r[n], s);
      l.length === 2 ? r.splice(n, 1, l[0], l[1]) : l.length === 1 ? r.splice(n, 1, l[0]) : r.splice(n, 1);
    }
  };
  for (n = 0; n < r.length; n++)
    t.forEach(i);
  return r;
}
function Yre(e, t, r, n) {
  var i, s = function(h) {
    return h === i;
  }, l = Et.trimTime(e), d = Et.trimTime(t);
  return d.setDate(t.getDate() + 1), r.reduce(function(h, p) {
    var m, x;
    return p = new Date(p), i = p.getDay(), !n.some(s) && p >= l && p <= d && (m = Et.trimTime(p), x = new Date(m), x.setDate(m.getDate() + 1), h.push({
      from: m,
      to: x
    })), h;
  }, []);
}
function Wre(e) {
  return e.map(function(t) {
    return {
      from: t.from,
      to: t.to,
      gapSize: Et.convertMillisecondsToDateUnits(t.to - t.from)
    };
  });
}
function Xre(e, t, r, n, i) {
  var s = Ure(r), l = jre(e, t, s);
  return l.push.apply(l, Yre(e, t, i || [], s)), Wre($re(l, n || []));
}
var NB = Et.getNextDateUnit, VB = Et.correctDateWithUnitBeginning, Ds = Math, gg = Ds.max, $i = Dt.top, Kn = Dt.bottom, rn = Dt.left, Yi = Dt.right, Po = Dt.center, sC = 3, FB = 0.3, qre = 2, Kre = 0, Zre = 4, BB = 24, Qre = {
  left: -1,
  top: -1,
  right: 0,
  bottom: 0,
  center: -0.5
};
function Jre(e, t) {
  var r, n;
  if (t === "week" && (t = "day"), t === "quarter" && (t = "month"), e[t])
    for (n = 0; n < Et.dateUnitIntervals.length && (r = Et.dateUnitIntervals[n], e[r] && (e[r] = !1, e.count--), r !== t); n++)
      ;
}
function bU(e) {
  return e.sort(function(t, r) {
    return t.from - r.from;
  });
}
function ene(e, t, r) {
  var n = e, i;
  return e = VB(e, r), t = VB(t, r), i = Et.getSequenceByInterval(e, t, r), i.length && n > i[0] && (i = i.slice(1)), i;
}
function tne(e) {
  var t = "start";
  return e === "center" && (t = "center"), e === "right" && (t = "end"), t;
}
function rne(e) {
  var t = "start";
  return e === "center" && (t = "center"), e === "bottom" && (t = "end"), t;
}
function nne(e) {
  var t = NB(e);
  return t === "quarter" && (t = NB(t)), t;
}
function zB(e, t, r, n) {
  var i = n, s = t && Et.getDatesDifferences(t, e);
  return t && r !== "year" && (Jre(s, r), i = Nl.getDateFormatByDifferences(s)), i;
}
function HB(e, t) {
  return t.reduce(function(r, n) {
    return gg(r, e(n));
  }, 0);
}
function ine(e, t) {
  t = Ds.abs(t), t = t % 180 >= 90 ? 90 - t % 90 : t % 90;
  var r = t * (Ds.PI / 180);
  return r >= Ds.atan(e.height / e.width) ? e.height / Ds.abs(Ds.sin(r)) : e.width;
}
function ane(e) {
  return e.reduce(function(t, r) {
    return gg(t, r.paddingTopBottom);
  }, 0);
}
function GB(e, t, r) {
  return e.some(function(n) {
    return n.label.verticalAlignment === t;
  }) && r || 0;
}
function UB(e) {
  return Ds.abs(e.x) || 0;
}
function jB(e) {
  return Ds.abs(e.width - Ds.abs(e.x)) || 0;
}
function one(e, t, r) {
  var n, i, s = null, l = [], d, h, p;
  for (n = 1, i = e.length; n < i; n++)
    d = e[n], h = e[n - 1], p = r(d, h), t.indexOf(d) >= 0 ? (!s || p > s.length) && (s = {
      start: d,
      end: h,
      length: p
    }) : (s && p < s.length ? l.push(s) : l.push({
      start: d,
      end: h,
      length: p
    }), s = null);
  return s && l.push(s), l;
}
function sne(e, t, r) {
  for (var {
    logarithmBase: n,
    type: i,
    maxAutoBreakCount: s
  } = e, {
    minVisible: l,
    maxVisible: d
  } = r, h = [], p = i === "logarithmic" ? (z, V) => Gd(V / z, n) : (z, V) => V - z, m = p(l, d), x = t.reduce((z, V) => {
    var P = V.getPointsInViewPort();
    return z[0] = z[0].concat(P[0]), z[1] = z[1].concat(P[1]), z;
  }, [
    [],
    []
  ]), S = x[0].concat(x[1]).sort((z, V) => V - z), T = x[1].filter((z) => x[0].indexOf(z) < 0), k = FB * m, O = one(S, T, p).sort((z, V) => V.length - z.length), D = Ds.min.apply(null, O.map((z) => z.length)) / 1e3, L = I(s) ? Ds.min(s, O.length) : O.length, F = 0; F < L && O[F].length >= k; F++) {
    if (m <= O[F].length)
      break;
    m -= O[F].length, (m > D || m < -D) && (h.push({
      from: O[F].start,
      to: O[F].end
    }), k = FB * m);
  }
  return bU(h), h;
}
const SU = {
  linear: {
    _getStep: function(e, t) {
      var r = this._options.label.minSpacing, n = this._isHorizontal ? function(s) {
        return s.width + r;
      } : function(s) {
        return s.height;
      }, i = HB(n, e);
      return t && (i = ine({
        width: i,
        height: this._getMaxLabelHeight(e, 0)
      }, t)), Dt.getTicksCountInRange(this._majorTicks, this._isHorizontal ? "x" : "y", i);
    },
    _getMaxLabelHeight: function(e, t) {
      return HB(function(r) {
        return r.height;
      }, e) + t;
    },
    _validateOverlappingMode: function(e, t) {
      return this._isHorizontal && (t === "rotate" || t === "stagger") || !this._isHorizontal ? Dt.validateOverlappingMode(e) : e;
    },
    _validateDisplayMode: function(e) {
      return this._isHorizontal ? e : "standard";
    },
    getMarkerTrackers: function() {
      return this._markerTrackers;
    },
    _getSharpParam: function(e) {
      return this._isHorizontal ^ e ? "h" : "v";
    },
    _createAxisElement: function() {
      return this._renderer.path([], "line");
    },
    _updateAxisElementPosition: function() {
      var e = this._axisPosition, t = this._getCanvasStartEnd();
      this._axisElement.attr({
        points: this._isHorizontal ? [t.start, e, t.end, e] : [e, t.start, e, t.end]
      });
    },
    _getTranslatedCoord: function(e, t) {
      return this._translator.translate(e, t);
    },
    _initAxisPositions() {
      this.customPositionIsAvailable() && (this._customBoundaryPosition = this.getCustomBoundaryPosition()), !this.customPositionIsAvailable() || this.customPositionIsBoundary() ? this._axisPosition = this.getPredefinedPosition(this.getResolvedBoundaryPosition()) : this._axisPosition = this.getCustomPosition();
    },
    _getTickMarkPoints(e, t, r) {
      var n = this._isHorizontal, i = this._options.tickOrientation, s = this._options.label.position, l;
      if (I(i))
        l = Qre[i] * t;
      else {
        var d = r.shift || 0;
        (!n && s === rn || n && s !== Kn) && (d = -d), l = d + this.getTickStartPositionShift(t);
      }
      return [e.x + (n ? 0 : l), e.y + (n ? l : 0), e.x + (n ? 0 : l + t), e.y + (n ? l + t : 0)];
    },
    getTickStartPositionShift(e) {
      var t = this._options.width, r = this.getResolvedBoundaryPosition();
      return e % 2 === 1 ? t % 2 === 0 && (r === rn || r === $i) || t % 2 === 1 && (r === Yi || r === Kn) && !this.hasNonBoundaryPosition() ? Math.floor(-e / 2) : -Math.floor(e / 2) : -e / 2 + (t % 2 === 0 ? 0 : r === Kn || r === Yi ? -1 : 1);
    },
    _getTitleCoords: function() {
      var e = this._isHorizontal, t = this._axisPosition, r = this._axisPosition, n = this._options.title.alignment, i = this._getCanvasStartEnd(), s = e || this._options.position === rn, l = s ? i.start : i.end, d = s ? i.end : i.start, h = n === rn ? l : n === Yi ? d : i.start + (i.end - i.start) / 2;
      return e ? t = h : r = h, {
        x: t,
        y: r
      };
    },
    _drawTitleText: function(e, t) {
      var r = this._options, n = r.title, i = {
        opacity: n.opacity,
        align: n.alignment,
        class: n.cssClass
      };
      if (!(!n.text || !e)) {
        t = t || this._getTitleCoords(), this._isHorizontal || (i.rotate = r.position === rn ? 270 : 90);
        var s = this._renderer.text(n.text, t.x, t.y).css(Oi(n.font)).attr(i).append(e);
        return this._checkTitleOverflow(s), s;
      }
    },
    _updateTitleCoords: function() {
      this._title && this._title.element.attr(this._getTitleCoords());
    },
    _drawTitle: function() {
      var e = this._drawTitleText(this._axisTitleGroup);
      e && (this._title = {
        element: e
      });
    },
    _measureTitle: function() {
      this._title && (this._title.bBox && !this._title.originalSize && (this._title.originalSize = this._title.bBox), this._title.bBox = this._title.element.getBBox());
    },
    _drawDateMarker: function(e, t, r) {
      var n = this._options.marker, i = this._translator.getBusinessRange().invert, s = n.width + n.textLeftIndent, l;
      if (t.x !== null) {
        t.withoutStick || (l = this._renderer.path([t.x, t.y, t.x, t.y + n.separatorHeight], "line").attr({
          "stroke-width": n.width,
          stroke: n.color,
          "stroke-opacity": n.opacity,
          sharp: "h"
        }).append(this._axisElementsGroup));
        var d = String(this.formatLabel(e, t.labelOptions, r));
        return {
          date: e,
          x: t.x,
          y: t.y,
          cropped: t.withoutStick,
          label: this._renderer.text(d, t.x, t.y).css(Oi(n.label.font)).append(this._axisElementsGroup),
          line: l,
          getContentContainer() {
            return this.label;
          },
          getEnd: function() {
            return this.x + (i ? -1 : 1) * (s + this.labelBBox.width);
          },
          setTitle: function() {
            this.title = d;
          },
          hideLabel: function() {
            this.label.dispose(), this.label = null, this.title = d;
          },
          hide: function() {
            l && (l.dispose(), l = null), this.label.dispose(), this.label = null, this.hidden = !0;
          }
        };
      }
    },
    _drawDateMarkers: function() {
      var e = this, t = e._options, r = e._translator, n = e._getViewportRange(), i = n.minVisible, s = [], l;
      function d(S, T, k) {
        return e._drawDateMarker(S, {
          x: r.translate(S),
          y: h,
          labelOptions: e._getLabelFormatOptions(T),
          withoutStick: k
        }, n);
      }
      if (n.isEmpty() || !t.marker.visible || t.argumentType !== "datetime" || t.type === "discrete" || e._majorTicks.length <= 1)
        return [];
      var h = e._axisPosition + t.marker.topIndent, p = Et.getDateUnitInterval(this._tickInterval), m = nne(p), x = ene(i, n.maxVisible, m);
      return (x.length > 1 || x.length === 1 && i < x[0]) && (s = x.reduce(function(S, T, k, O) {
        var D = d(T, zB(T, O[k - 1] || i < T && i, p, m));
        return D && S.push(D), S;
      }, []), i < x[0] && (l = d(i, zB(i, x[0], p, m), !0), l && s.unshift(l))), s;
    },
    _adjustDateMarkers: function(e) {
      e = e || 0;
      var t = this, r = this._options.marker, n = r.width + r.textLeftIndent, i = this._translator.getBusinessRange().invert, s = t._getCanvasStartEnd(), l = this._dateMarkers;
      if (!l.length)
        return e;
      l[0].cropped && (this._checkMarkersPosition(i, l[1], l[0]) || l[0].hideLabel());
      var d;
      return l.forEach(function(h, p, m) {
        h.cropped || ((i ? h.getEnd() < s.end : h.getEnd() > s.end) ? h.hideLabel() : t._checkMarkersPosition(i, h, d) ? d = h : h.hide());
      }), this._dateMarkers.forEach(function(h) {
        if (h.label) {
          var p = h.labelBBox, m = h.y + r.textTopIndent - p.y;
          h.label.attr({
            translateX: i ? h.x - n - p.x - p.width : h.x + n - p.x,
            translateY: m + e
          });
        }
        h.line && h.line.attr({
          translateY: e
        });
      }), t._initializeMarkersTrackers(e), e + r.topIndent + r.separatorHeight;
    },
    _checkMarkersPosition: function(e, t, r) {
      return r === void 0 ? !0 : e ? t.x < r.getEnd() : t.x > r.getEnd();
    },
    _initializeMarkersTrackers: function(e) {
      var t = this._options.marker.separatorHeight, r = this._renderer, n = this._translator.getBusinessRange(), i = this._getCanvasStartEnd(), s = this._axisElementsGroup;
      this._markerTrackers = this._dateMarkers.filter(function(l) {
        return !l.hidden;
      }).map(function(l, d, h) {
        var p = h[d + 1] || {
          x: i.end,
          date: n.max
        }, m = l.x, x = l.y + e, S = r.path([m, x, m, x + t, p.x, x + t, p.x, x, m, x], "area").attr({
          "stroke-width": 1,
          stroke: "grey",
          fill: "grey",
          opacity: 1e-4
        }).append(s);
        return S.data("range", {
          startValue: l.date,
          endValue: p.date
        }), l.title && S.setTitle(l.title), S;
      });
    },
    _getLabelFormatOptions: function(e) {
      var t = this._markerLabelOptions;
      return t || (this._markerLabelOptions = t = W(!0, {}, this._options.marker.label)), I(this._options.marker.label.format) || (t.format = e), t;
    },
    _adjustConstantLineLabels: function(e) {
      var t = this, r = t._options.position, n = t.getCanvas(), i = n.left, s = n.width - n.right, l = n.top, d = n.height - n.bottom, h = l + (d - l) / 2, p = i + (s - i) / 2, m = 0;
      return e.forEach(function(x) {
        var S = t._isHorizontal, T = x.options, k = T.paddingTopBottom, O = T.paddingLeftRight, D = T.label, L = D.verticalAlignment, F = D.horizontalAlignment, z = D.position === "inside", V = x.label, P = x.labelBBox, j, Z;
        if (!(V === null || P.isEmpty)) {
          if (S)
            if (z)
              switch (F === rn ? j = x.coord - O - P.x - P.width : j = x.coord + O - P.x, L) {
                case Po:
                  Z = h - P.y - P.height / 2;
                  break;
                case Kn:
                  Z = d - k - P.y - P.height;
                  break;
                default:
                  Z = l + k - P.y;
              }
            else
              r === L && (m = gg(m, P.height + k)), j = x.coord - P.x - P.width / 2, L === Kn ? Z = d + k - P.y : Z = l - k - P.y - P.height;
          else if (z)
            switch (L === Kn ? Z = x.coord + k - P.y : Z = x.coord - k - P.y - P.height, F) {
              case Po:
                j = p - P.x - P.width / 2;
                break;
              case Yi:
                j = s - O - P.x - P.width;
                break;
              default:
                j = i + O - P.x;
            }
          else
            r === F && (m = gg(m, P.width + O)), Z = x.coord - P.y - P.height / 2, F === Yi ? j = s + O - P.x : j = i - O - P.x - P.width;
          V.attr({
            translateX: j,
            translateY: Z
          });
        }
      }), m;
    },
    _drawConstantLinesForEstimating: function(e) {
      var t = this, r = this._renderer, n = r.g();
      return e.forEach(function(i) {
        t._drawConstantLineLabelText(i.label.text, 0, 0, i.label, n).attr({
          align: "center"
        });
      }), n.append(r.root);
    },
    _estimateLabelHeight: function(e, t) {
      var r = e.height, n = t.drawingType;
      if ((this._validateDisplayMode(n) === "stagger" || this._validateOverlappingMode(t.overlappingBehavior, n) === "stagger") && (r = 2 * r + t.staggeringSpacing), this._validateDisplayMode(n) === "rotate" || this._validateOverlappingMode(t.overlappingBehavior, n) === "rotate") {
        var i = ya(t.rotationAngle);
        r = r * i.cos + e.width * i.sin;
      }
      return r && (r + t.indentFromAxis || 0) || 0;
    },
    estimateMargins: function(e) {
      this.updateCanvas(e);
      var t = this._getViewportRange(), r = this._createTicksAndLabelFormat(t), n = r.ticks, i = r.tickInterval, s = this._options, l = this._outsideConstantLines.filter((P) => P.labelOptions.visible).map((P) => P.options), d = this._renderer.root, h = s.label.visible && !t.isEmpty() && n.length, p = h && this.formatLabel(n[n.length - 1], s.label, void 0, void 0, i, n), m = h && this._renderer.text(p, 0, 0).css(this._textFontStyles).attr(this._textOptions).append(d), x = this._drawTitleText(d, {
        x: 0,
        y: 0
      }), S = this._drawConstantLinesForEstimating(l), T = !s.label.template && m && m.getBBox() || {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }, k = x && x.getBBox() || {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }, O = S.getBBox(), D = k.height ? k.height + s.title.margin : 0, L = this._estimateLabelHeight(T, s.label), F = O.height ? O.height + ane(l) : 0, z = L + D, V = {
        left: gg(UB(T), UB(O)),
        right: gg(jB(T), jB(O)),
        top: (s.position === "top" ? z : 0) + GB(l, "top", F),
        bottom: (s.position !== "top" ? z : 0) + GB(l, "bottom", F)
      };
      return m && m.remove(), x && x.remove(), S && S.remove(), V;
    },
    _checkAlignmentConstantLineLabels: function(e) {
      var t = e.position, r = (e.verticalAlignment || "").toLowerCase(), n = (e.horizontalAlignment || "").toLowerCase();
      this._isHorizontal ? t === "outside" ? (r = r === Kn ? Kn : $i, n = Po) : (r = r === Po ? Po : r === Kn ? Kn : $i, n = n === rn ? rn : Yi) : t === "outside" ? (r = Po, n = n === rn ? rn : Yi) : (r = r === Kn ? Kn : $i, n = n === Yi ? Yi : n === Po ? Po : rn), e.verticalAlignment = r, e.horizontalAlignment = n;
    },
    _getConstantLineLabelsCoords: function(e, t) {
      var r = e, n = e;
      return this._isHorizontal ? n = this._orthogonalPositions[t.verticalAlignment === "top" ? "start" : "end"] : r = this._orthogonalPositions[t.horizontalAlignment === "right" ? "end" : "start"], {
        x: r,
        y: n
      };
    },
    _getAdjustedStripLabelCoords: function(e) {
      var t = e.options, r = t.paddingTopBottom, n = t.paddingLeftRight, i = t.label.horizontalAlignment, s = t.label.verticalAlignment, l = e.labelBBox, d = l.height, h = l.width, p = e.labelCoords, m = p.y - l.y, x = p.x - l.x;
      return s === $i ? m += r : s === Po ? m -= d / 2 : s === Kn && (m -= r + d), i === rn ? x += n : i === Po ? x -= h / 2 : i === Yi && (x -= n + h), {
        translateX: x,
        translateY: m
      };
    },
    _adjustTitle: function(e) {
      if (e = e || 0, !!this._title) {
        var t = this._options, r = t.position, n = t.title.margin, i = this._title, s = i.bBox, l = s.x, d = s.y, h = s.width, p = s.height, m = this._axisPosition, x = m - n - e, S = m + n + e, T = {};
        this._isHorizontal ? r === $i ? T.translateY = x - (d + p) : T.translateY = S - d : r === rn ? T.translateX = x - (l + h) : T.translateX = S - l, i.element.attr(T);
      }
    },
    _checkTitleOverflow: function(e) {
      if (!(!this._title && !e)) {
        var t = this._getScreenDelta(), r = e ? {
          bBox: e.getBBox(),
          element: e
        } : this._title, n = this._options.title, i = r.bBox;
        if ((this._isHorizontal ? i.width : i.height) > t)
          r.element.setMaxSize(t, void 0, {
            wordWrap: n.wordWrap || "none",
            textOverflow: n.textOverflow || "ellipsis"
          }), this._wrapped = n.wordWrap && n.wordWrap !== "none";
        else {
          var s = r.originalSize && t > (this._isHorizontal ? r.originalSize.width : r.originalSize.height);
          !this._wrapped && s && r.element.restoreText();
        }
      }
    },
    coordsIn: function(e, t) {
      var r = this.getCanvas(), n = this._options.isHorizontal, i = this._options.position, s = n ? t : e;
      return n && (e < r.left || e > r.width - r.right) || !n && (t < r.top || t > r.height - r.bottom) ? !1 : n && i === Dt.top || !n && i === Dt.left ? s < r[i] : s > r[n ? "height" : "width"] - r[i];
    },
    _boundaryTicksVisibility: {
      min: !0,
      max: !0
    },
    adjust() {
      var e = this._seriesData, t = this._series.filter((r) => r.isVisible()).reduce((r, n) => {
        var i = n.getViewport();
        return r.min = I(i.min) ? r.min < i.min ? r.min : i.min : r.min, r.max = I(i.max) ? r.max > i.max ? r.max : i.max : r.max, n.showZero && (r = new _a(r), r.correctValueZeroLevel()), r;
      }, {});
      I(t.min) && I(t.max) && (e.minVisible = t.min, e.maxVisible = t.max), e.userBreaks = this._getScaleBreaks(this._options, {
        minVisible: e.minVisible,
        maxVisible: e.maxVisible
      }, this._series, this.isArgumentAxis), this._translator.updateBusinessRange(this._getViewportRange());
    },
    hasWrap() {
      return this._wrapped;
    },
    getAxisPosition() {
      return this._axisPosition;
    },
    _getStick: function() {
      return !this._options.valueMarginsEnabled;
    },
    _getStripLabelCoords: function(e, t, r) {
      var n = this._orthogonalPositions, i = this._isHorizontal, s = r.horizontalAlignment, l = r.verticalAlignment, d, h;
      return i ? (s === Po ? d = e + (t - e) / 2 : s === rn ? d = e : s === Yi && (d = t), h = n[rne(l)]) : (d = n[tne(s)], l === $i ? h = e : l === Po ? h = t + (e - t) / 2 : l === Kn && (h = t)), {
        x: d,
        y: h
      };
    },
    _getTranslatedValue: function(e, t) {
      var r = this._translator.translate(e, t, this._options.type === "semidiscrete" && this._options.tickInterval), n = this._axisPosition, i = this._isHorizontal;
      return {
        x: i ? r : n,
        y: i ? n : r
      };
    },
    areCoordsOutsideAxis: function(e) {
      var t = this._isHorizontal ? e.x : e.y, r = this.getVisibleArea();
      return t < r[0] || t > r[1];
    },
    _getSkippedCategory: function(e) {
      var t;
      return this._options.type === Dt.discrete && this._tickOffset && e.length !== 0 && (t = e[e.length - 1]), t;
    },
    _filterBreaks: function(e, t, r) {
      var n = t.minVisible, i = t.maxVisible, s = r ? r.width : 0;
      return e.reduce(function(l, d) {
        var h = d.from, p = d.to, m = l[l.length - 1], x;
        if (!I(h) || !I(p))
          return l;
        if (h > p && (p = [h, h = p][0]), l.length && h < m.to)
          p > m.to && (m.to = p > i ? i : p, m.gapSize && (m.gapSize = void 0, m.cumulativeWidth += s));
        else if ((h >= n && h < i || p <= i && p > n) && (h = h >= n ? h : n, p = p <= i ? p : i, p - h < i - n)) {
          var S;
          if (x = {
            from: h,
            to: p,
            cumulativeWidth: ((S = m == null ? void 0 : m.cumulativeWidth) !== null && S !== void 0 ? S : 0) + s
          }, d.gapSize) {
            var T;
            x.gapSize = Et.convertMillisecondsToDateUnits(p - h), x.cumulativeWidth = (T = m == null ? void 0 : m.cumulativeWidth) !== null && T !== void 0 ? T : 0;
          }
          l.push(x);
        }
        return l;
      }, []);
    },
    _getScaleBreaks: function(e, t, r, n) {
      var i = this, s = (e.breaks || []).map(function(l) {
        return {
          from: i.parser(l.startValue),
          to: i.parser(l.endValue)
        };
      });
      return e.type !== "discrete" && e.dataType === "datetime" && e.workdaysOnly && (s = s.concat(Xre(t.minVisible, t.maxVisible, e.workWeek, e.singleWorkdays, e.holidays))), !n && e.type !== "discrete" && e.dataType !== "datetime" && e.autoBreaksEnabled && e.maxAutoBreakCount !== 0 && (s = s.concat(sne(e, r, t))), bU(s);
    },
    _drawBreak: function(e, t, r, n, i, s) {
      var l = e - (this._translator.isInverted() ? 0 : n + 1), d = {
        "stroke-width": 1,
        stroke: i.borderColor,
        sharp: i.isWaved ? void 0 : i.isHorizontal ? "h" : "v"
      }, h = {
        stroke: i.color,
        "stroke-width": n
      }, p = this._isHorizontal ? cne : function(x) {
        return x;
      }, m = lne(this._renderer, s, p, t, l, r, i.isWaved);
      m(n / 2, h), m(0, d), m(n, d);
    },
    _createBreakClipRect: function(e, t) {
      var r = this._canvas, n = t - e, i;
      return this._isHorizontal ? i = this._renderer.clipRect(r.left, e, r.width, n) : i = this._renderer.clipRect(e, r.top, n, r.height), this._breaksElements = this._breaksElements || [], this._breaksElements.push(i), i.id;
    },
    _createBreaksGroup: function(e, t) {
      var r = this._renderer.g().attr({
        class: this._axisCssPrefix + "breaks",
        "clip-path": this._createBreakClipRect(e, t)
      }).append(this._scaleBreaksGroup);
      return this._breaksElements = this._breaksElements || [], this._breaksElements.push(r), r;
    },
    _disposeBreaksGroup: function() {
      (this._breaksElements || []).forEach(function(e) {
        e.dispose();
      }), this._breaksElements = null;
    },
    drawScaleBreaks: function(e) {
      var t = this, r = t._options, n = r.breakStyle, i = r.position, s, l, d = t._translator.getBusinessRange().breaks || [], h, p, m;
      if (t._disposeBreaksGroup(), !!(d && d.length)) {
        var x = {
          color: t._options.containerColor,
          borderColor: n.color,
          isHorizontal: t._isHorizontal,
          isWaved: n.line.toLowerCase() !== "straight"
        };
        e ? (s = e.start, l = e.end) : (s = t._orthogonalPositions.start - (r.visible && !t._axisShift && (i === rn || i === $i) ? sC : 0), l = t._orthogonalPositions.end + (r.visible && (i === Yi || i === Kn) ? sC : 0));
        var S = t._createBreaksGroup(s, l);
        t._axisShift && r.visible && (p = t._axisPosition - t._axisShift - sC, m = p + 2 * sC, h = t._createBreaksGroup(p, m)), d.forEach(function(T) {
          if (!T.gapSize) {
            var k = t._getTranslatedCoord(T.to);
            t._drawBreak(k, s, l, n.width, x, S), t._axisShift && r.visible && t._drawBreak(k, p, m, n.width, x, h);
          }
        });
      }
    },
    _getSpiderCategoryOption: Y,
    shift: function(e) {
      var t = this._options, r = t.isHorizontal, n = this.getMultipleAxesSpacing(), i = this._axisConstantLineGroups;
      function s(l, d) {
        var h = {
          translateX: 0,
          translateY: 0
        }, p = e[l] ? e[l] + n : 0;
        return h[r ? "translateY" : "translateX"] = (l === rn || l === $i ? -1 : 1) * p, (d[l] || d).attr(h), p;
      }
      this._axisShift = s(t.position, this._axisGroup), s(t.position, this._axisElementsGroup), (r ? [$i, Kn] : [rn, Yi]).forEach((l) => {
        s(l, i.above), s(l, i.under);
      });
    },
    getCustomPosition(e) {
      var t = this.getOrthogonalAxis(), r = e ?? this.getResolvedPositionOption(), n = this.getOptions().offset, i = t.getTranslator(), s = t.getOptions().type, l = t.validateUnit(r), d;
      return s === "discrete" && (!i._categories || i._categories.indexOf(l) < 0) && (l = void 0), this.positionIsBoundary(r) ? d = this.getPredefinedPosition(r) : I(l) ? d = i.to(l, -1) : d = this.getPredefinedPosition(this.getOptions().position), isFinite(d) && isFinite(n) && (d += n), d;
    },
    getCustomBoundaryPosition(e) {
      var {
        customPosition: t,
        offset: r
      } = this.getOptions(), n = e ?? this.getResolvedPositionOption(), i = this.getOrthogonalAxis(), s = i.getTranslator(), l = s.getCanvasVisibleArea();
      if (!(!I(i._orthogonalPositions) || s.canvasLength === 0)) {
        var d = this.getCustomPosition(n);
        if (I(d)) {
          if (I(t)) {
            if (d <= l.min)
              return this._isHorizontal ? $i : rn;
            if (d >= l.max)
              return this._isHorizontal ? Kn : Yi;
          } else if (I(r)) {
            if (d <= this._orthogonalPositions.start)
              return this._isHorizontal ? $i : rn;
            if (d >= this._orthogonalPositions.end)
              return this._isHorizontal ? Kn : Yi;
          }
        } else
          return this.getResolvedBoundaryPosition();
        return d;
      }
    },
    getResolvedPositionOption() {
      var e, t = this.getOptions();
      return (e = t.customPosition) !== null && e !== void 0 ? e : t.position;
    },
    customPositionIsAvailable() {
      var e = this.getOptions();
      return I(this.getOrthogonalAxis()) && (I(e.customPosition) || isFinite(e.offset));
    },
    hasNonBoundaryPosition() {
      return this.customPositionIsAvailable() && !this.customPositionIsBoundary();
    },
    getResolvedBoundaryPosition() {
      return this.customPositionIsBoundary() ? this._customBoundaryPosition : this.getOptions().position;
    },
    customPositionEqualsToPredefined() {
      return this.customPositionIsBoundary() && this._customBoundaryPosition === this.getOptions().position;
    },
    customPositionIsBoundary() {
      return this.positionIsBoundary(this._customBoundaryPosition);
    },
    positionIsBoundary: (e) => [$i, rn, Kn, Yi].indexOf(e) >= 0,
    getPredefinedPosition(e) {
      var t;
      return (t = this._orthogonalPositions) === null || t === void 0 ? void 0 : t[e === $i || e === rn ? "start" : "end"];
    },
    resolveOverlappingForCustomPositioning(e) {
      var t = this;
      if (!(!t.hasNonBoundaryPosition() && !t.customPositionIsBoundary() && !e.some((n) => n.hasNonBoundaryPosition()))) {
        var r = {
          axes: [],
          ticks: []
        };
        e.filter((n) => n.pane === t.pane).forEach((n) => {
          for (var i = 0; i < t._majorTicks.length; i++) {
            var s = t._majorTicks[i], l = s.label;
            if (l) {
              r.axes.indexOf(n) < 0 && t._detectElementsOverlapping(l, n._axisElement) && (r.axes.push(n), t._shiftThroughOrthogonalAxisOverlappedTick(l, n));
              for (var d = 0; d < n._majorTicks.length; d++) {
                var h = n._majorTicks[d], p = h.label;
                if (p && t._detectElementsOverlapping(l, p)) {
                  r.ticks.push(s), t._shiftThroughAxisOverlappedTick(s), i = t._majorTicks.length;
                  break;
                }
              }
            }
            s.mark && r.ticks.indexOf(s) < 0 && (t._isHorizontal && s.mark.attr("translateY") ? s.mark.attr({
              translateY: 0
            }) : !t._isHorizontal && s.mark.attr("translateX") && s.mark.attr({
              translateX: 0
            }));
          }
        });
      }
    },
    _shiftThroughOrthogonalAxisOverlappedTick(e, t) {
      var r = e.getBBox(), n = t.getAxisPosition(), i = t.getOptions().label, s = i.position, l = i.indentFromAxis / 2, d = this._isHorizontal ? "translateX" : "translateY", h = this._isHorizontal ? rn : $i, p = e.attr(d), m = (this._isHorizontal ? r.x : r.y) + p, x = this._isHorizontal ? r.width : r.height, S = n - m, T = m + x - n, k = {};
      k[d] = p, S > 0 && T > 0 && (T - S > 1 ? k[d] += S + l : S - T > 1 ? k[d] -= T + l : k[d] += s === h ? S + l : -(T + l), e.attr(k));
    },
    _shiftThroughAxisOverlappedTick(e) {
      var t, r = e.label;
      if (r) {
        var n = r.getBBox(), i = (t = e.mark) === null || t === void 0 ? void 0 : t.getBBox(), s = this.getAxisPosition(), l = this.getOptions().label, d = l.indentFromAxis, h = l.position, p = this._isHorizontal ? $i : rn, m = this._isHorizontal ? "translateY" : "translateX", x = r.attr(m), S = (this._isHorizontal ? n.y : n.x) + x, T = this._isHorizontal ? n.height : n.width, k = {};
        if (k[m] = x + (h === p ? s - S + d : -(S - s + T + d)), r.attr(k), e.mark) {
          var O = this._isHorizontal ? i.height : i.width, D = h === p ? 1 : -1;
          k[m] = D * (O - 1), e.mark.attr(k);
        }
      }
    },
    _detectElementsOverlapping(e, t) {
      if (!e || !t)
        return !1;
      var r = e.getBBox(), n = r.x + e.attr("translateX"), i = r.y + e.attr("translateY"), s = t.getBBox(), l = s.x + t.attr("translateX"), d = s.y + t.attr("translateY");
      return (l >= n && l <= n + r.width || n >= l && n <= l + s.width) && (d >= i && d <= i + r.height || i >= d && i <= d + s.height);
    }
  }
};
function lne(e, t, r, n, i, s, l) {
  var d = l ? "bezier" : "line", h = e.g().append(t);
  return function(p, m) {
    e.path(r(une(n, i, s, p, l)), d).attr(m).append(h);
  };
}
function une(e, t, r, n, i) {
  if (!i)
    return [e, t + n, r, t + n];
  t += n;
  var s, l = t + Kre, d = t + qre, h = t + Zre, p = [
    [e, d]
  ];
  for (s = e; s < r + BB; s += BB)
    p.push([s + 6, l, s + 6, l, s + 12, d, s + 18, h, s + 18, h, s + 24, d]);
  return [].concat.apply([], p);
}
function cne(e) {
  var t = [], r;
  for (r = 0; r < e.length; r += 2)
    t.push(e[r + 1]), t.push(e[r]);
  return t;
}
var lC = Math.max, CU = function(e, t) {
  var r = t.left, n = t.top, i = t.width - t.right, s = t.height - t.bottom;
  return e.reduce(function(l, d) {
    return !d || d.isEmpty ? l : {
      left: lC(l.left, r - d.x),
      top: lC(l.top, n - d.y),
      right: lC(l.right, d.x + d.width - i),
      bottom: lC(l.bottom, d.y + d.height - s)
    };
  }, {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  });
}, ch = function(e) {
  e.forEach(function(t) {
    var r = t.getContentContainer();
    t.labelBBox = r ? r.getBBox() : {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  });
}, {
  PI: pk,
  abs: xh,
  atan: $B,
  round: kd
} = Math, dne = Math.min, _D = Math.max, YB = SU.linear, Rd = 90;
function EU(e) {
  var t;
  return e = Ll(e), e >= 315 && e <= 360 || e < 45 && e >= 0 ? t = 1 : e >= 45 && e < 135 ? t = 2 : e >= 135 && e < 225 ? t = 3 : e >= 225 && e < 315 && (t = 4), t;
}
var wl = {
  _calculateValueMargins(e) {
    var {
      minVisible: t,
      maxVisible: r
    } = this._getViewportRange();
    return e && e.length > 1 && (t = t < e[0].value ? t : e[0].value, r = t > e[e.length - 1].value ? r : e[e.length - 1].value), {
      minValue: t,
      maxValue: r
    };
  },
  applyMargins() {
    var e = this._calculateValueMargins(this._majorTicks), t = this._translator.getBusinessRange();
    t.addRange({
      minVisible: e.minValue,
      maxVisible: e.maxValue,
      interval: this._calculateRangeInterval(t.interval)
    }), this._translator.updateBusinessRange(t);
  },
  _getTranslatorOptions: function() {
    return {
      isHorizontal: !0,
      conversionValue: !0,
      addSpiderCategory: this._getSpiderCategoryOption(),
      stick: this._getStick()
    };
  },
  getCenter: function() {
    return this._center;
  },
  getRadius: function() {
    return this._radius;
  },
  getAngles: function() {
    var e = this._options;
    return [e.startAngle, e.endAngle];
  },
  _updateRadius(e) {
    var t = dne(e.width - e.left - e.right, e.height - e.top - e.bottom) / 2;
    this._radius = t < 0 ? 0 : t;
  },
  _updateCenter: function(e) {
    this._center = {
      x: e.left + (e.width - e.right - e.left) / 2,
      y: e.top + (e.height - e.top - e.bottom) / 2
    };
  },
  _processCanvas: function(e) {
    return this._updateRadius(e), this._updateCenter(e), {
      left: 0,
      right: 0,
      width: this._getScreenDelta()
    };
  },
  _createAxisElement: function() {
    return this._renderer.circle();
  },
  _updateAxisElementPosition: function() {
    var e = this.getCenter();
    this._axisElement.attr({
      cx: e.x,
      cy: e.y,
      r: this.getRadius()
    });
  },
  _boundaryTicksVisibility: {
    min: !0
  },
  _getSpiderCategoryOption: function() {
    return this._options.firstPointOnStartAngle;
  },
  _validateOptions(e) {
    var t = e.originValue, r = e.wholeRange = {}, n = e.period;
    I(t) && (t = this.validateUnit(t)), n > 0 && e.argumentType === Dt.numeric && (t = t || 0, r.endValue = t + n, this._viewport = bd([t, r.endValue])), I(t) && (r.startValue = t);
  },
  getMargins() {
    var e = this._options.tick, t = _D(e.visible ? e.length / 2 + e.shift : 0, 0), r = this.getRadius(), {
      x: n,
      y: i
    } = this._center, s = this._majorTicks.map((h) => h.label && h.label.getBBox()).filter((h) => h), l = W({}, this._canvas, {
      left: n - r,
      top: i - r,
      right: this._canvas.width - (n + r),
      bottom: this._canvas.height - (i + r)
    }), d = CU(s, l);
    return Object.keys(d).forEach((h) => d[h] = d[h] < t ? t : d[h]), d;
  },
  _updateLabelsPosition() {
    ch(this._majorTicks), this._adjustLabelsCoord(0, 0, !0), this._checkBoundedLabelsOverlapping(this._majorTicks, this._majorTicks.map((e) => e.labelBBox));
  },
  _setVisualRange: Y,
  applyVisualRangeSetter: Y,
  _getStick: function() {
    return this._options.firstPointOnStartAngle || this._options.type !== Dt.discrete;
  },
  _getTranslatedCoord: function(e, t) {
    return this._translator.translate(e, t) - Rd;
  },
  _getCanvasStartEnd: function() {
    return {
      start: 0 - Rd,
      end: 360 - Rd
    };
  },
  _getStripGraphicAttributes: function(e, t) {
    var r = this.getCenter(), n = this.getAngles()[0], i = this.getRadius();
    return {
      x: r.x,
      y: r.y,
      innerRadius: 0,
      outerRadius: i,
      startAngle: -t - n,
      endAngle: -e - n
    };
  },
  _createStrip: function(e) {
    return this._renderer.arc(e.x, e.y, e.innerRadius, e.outerRadius, e.startAngle, e.endAngle);
  },
  _getStripLabelCoords: function(e, t) {
    var r = this._getStripGraphicAttributes(e, t), n = r.startAngle + (r.endAngle - r.startAngle) / 2, i = ya(n), s = this.getRadius() / 2, l = this.getCenter(), d = kd(l.x + s * i.cos), h = kd(l.y - s * i.sin);
    return {
      x: d,
      y: h,
      align: Dt.center
    };
  },
  _getConstantLineGraphicAttributes: function(e) {
    var t = this.getCenter(), r = this.getRadius();
    return {
      points: [t.x, t.y, t.x + r, t.y]
    };
  },
  _createConstantLine: function(e, t) {
    return this._createPathElement(this._getConstantLineGraphicAttributes(e).points, t);
  },
  _rotateConstantLine(e, t) {
    var {
      x: r,
      y: n
    } = this.getCenter();
    e.rotate(t + this.getAngles()[0], r, n);
  },
  _getConstantLineLabelsCoords: function(e) {
    var t = ya(-e - this.getAngles()[0]), r = this.getRadius() / 2, n = this.getCenter(), i = kd(n.x + r * t.cos), s = kd(n.y - r * t.sin);
    return {
      x: i,
      y: s
    };
  },
  _checkAlignmentConstantLineLabels: Y,
  _adjustDivisionFactor: function(e) {
    return 180 * e / (this.getRadius() * pk);
  },
  _getScreenDelta: function() {
    var e = this.getAngles();
    return xh(e[0] - e[1]);
  },
  _getTickMarkPoints: function(e, t, r) {
    var {
      shift: n = 0
    } = r, i = this.getCenter(), s = this.getRadius() + t * {
      inside: -1,
      center: -0.5,
      outside: 0
    }[this._options.tickOrientation || "center"];
    return [i.x + s + n, i.y, i.x + s + t + n, i.y];
  },
  _getLabelAdjustedCoord: function(e, t, r, n) {
    var i = e.labelCoords, s = i.y, l = i.angle, d = ya(l), h = d.cos, p = d.sin, m = e.labelBBox, x = m.width / 2, S = m.height / 2, T = this._options.label.indentFromAxis || 0, k = i.x + T * h, O = s + (s - m.y - S) + T * p, D = 0, L = 0;
    switch (EU(l)) {
      case 1:
        D = x, L = S * p;
        break;
      case 2:
        D = x * h, L = S;
        break;
      case 3:
        D = -x, L = S * p;
        break;
      case 4:
        D = x * h, L = -S;
    }
    if (n) {
      var F = this._canvas, z = k - i.x + D, V = O - i.y + L;
      m.x + z < F.originalLeft && (D -= m.x + z - F.originalLeft), m.x + m.width + z > F.width - F.originalRight && (D -= m.x + m.width + z - (F.width - F.originalRight)), m.y + V < F.originalTop && (L -= m.y + V - F.originalTop), m.y + m.height + V > F.height - F.originalBottom && (L -= m.y + m.height + V - (F.height - F.originalBottom));
    }
    return {
      x: k + D,
      y: O + L
    };
  },
  _getGridLineDrawer: function() {
    var e = this;
    return function(t, r) {
      var n = e.getCenter();
      return e._createPathElement(e._getGridPoints().points, r).rotate(t.coords.angle, n.x, n.y);
    };
  },
  _getGridPoints: function() {
    var e = this.getRadius(), t = this.getCenter();
    return {
      points: [t.x, t.y, t.x + e, t.y]
    };
  },
  _getTranslatedValue: function(e, t) {
    var r = this.getAngles()[0], n = this._translator.translate(e, -t), i = CT(this.getCenter(), r, n, this.getRadius());
    return {
      x: i.x,
      y: i.y,
      angle: this.getTranslatedAngle(n)
    };
  },
  _getAdjustedStripLabelCoords: function(e) {
    var t = e.labelBBox;
    return {
      translateY: e.label.attr("y") - t.y - t.height / 2
    };
  },
  coordsIn: function(e, t) {
    return DM(this.getCenter(), e, t).r > this.getRadius();
  },
  _rotateTick: function(e, t) {
    var r = this.getCenter();
    e.rotate(t.angle, r.x, r.y);
  },
  _validateOverlappingMode: function(e) {
    return Dt.validateOverlappingMode(e);
  },
  _validateDisplayMode: function() {
    return "standard";
  },
  _getStep: function(e) {
    var t = this.getRadius() + (this._options.label.indentFromAxis || 0), r = e.reduce(function(s, l) {
      var d = s;
      return s.width < l.width && (d.width = l.width), s.height < l.height && (d.height = l.height), d;
    }, {
      width: 0,
      height: 0
    }), n = xh(2 * $B(r.height / (2 * t - r.width)) * 180 / pk), i = xh(2 * $B(r.width / (2 * t - r.height)) * 180 / pk);
    return Dt.getTicksCountInRange(this._majorTicks, "angle", _D(n, i));
  },
  _checkBoundedLabelsOverlapping: function(e, t, r) {
    var n = this._options.label;
    if (r = r || this._validateOverlappingMode(n.overlappingBehavior), r === "hide") {
      var i = e.reduce((s, l, d) => l.label ? d : s, null);
      i && Dt.areLabelsOverlap(t[0], t[i], n.minSpacing, Dt.center) && (n.hideFirstOrLast === "first" ? e[0].removeLabel() : e[i].removeLabel());
    }
  },
  shift: function(e) {
    this._axisGroup.attr({
      translateX: e.right,
      translateY: e.bottom
    }), this._axisElementsGroup.attr({
      translateX: e.right,
      translateY: e.bottom
    });
  },
  getTranslatedAngle(e) {
    var t = this.getAngles()[0];
    return e + t - Rd;
  }
}, fne = wl, TU = W({}, wl, {
  _createAxisElement: function() {
    return this._renderer.path([], "area");
  },
  _updateAxisElementPosition: function() {
    this._axisElement.attr({
      points: ti(this.getSpiderTicks(), function(e) {
        return {
          x: e.coords.x,
          y: e.coords.y
        };
      })
    });
  },
  _getStick: function() {
    return !0;
  },
  _getSpiderCategoryOption: function() {
    return !0;
  },
  getSpiderTicks: function() {
    var e = this.getFullTicks();
    return this._spiderTicks = e.map(IT(this, this.renderer, {}, {}, this._getSkippedCategory(e), !0)), this._spiderTicks.forEach(function(t) {
      t.initCoords();
    }), this._spiderTicks;
  },
  _getStripGraphicAttributes: function(e, t) {
    for (var r = this.getCenter(), n = this.getSpiderTicks(), i, s, l, d, h = [], p = 0, m = n.length; p < m; )
      d = n[p].coords, d.angle >= e && d.angle <= t && (i || (i = (n[p - 1] || n[n.length - 1]).coords, h.push((d.x + i.x) / 2, (d.y + i.y) / 2)), h.push(d.x, d.y), l = (n[p + 1] || n[0]).coords, s = {
        x: (d.x + l.x) / 2,
        y: (d.y + l.y) / 2
      }), p++;
    return h.push(s.x, s.y), h.push(r.x, r.y), {
      points: h
    };
  },
  _createStrip: function(e) {
    var {
      points: t
    } = e;
    return this._renderer.path(t, "area");
  },
  _getTranslatedCoord: function(e, t) {
    return this._translator.translate(e, t) - Rd;
  },
  _setTickOffset: function() {
    this._tickOffset = !1;
  }
}), wU = {
  _resetMargins() {
    this._reinitTranslator(this._getViewportRange());
  },
  _getStick: YB._getStick,
  _getSpiderCategoryOption: Y,
  _getTranslatorOptions: function() {
    return {
      isHorizontal: !0,
      stick: this._getStick()
    };
  },
  getRadius: wl.getRadius,
  getCenter: wl.getCenter,
  getAngles: wl.getAngles,
  _updateRadius: wl._updateRadius,
  _updateCenter: wl._updateCenter,
  _processCanvas(e) {
    return this._updateRadius(e), this._updateCenter(e), {
      left: 0,
      right: 0,
      startPadding: e.startPadding,
      endPadding: e.endPadding,
      width: this.getRadius()
    };
  },
  _createAxisElement: YB._createAxisElement,
  _updateAxisElementPosition: function() {
    var e = this.getCenter();
    this._axisElement.attr({
      points: [e.x, e.y, e.x + this.getRadius(), e.y]
    }).rotate(this.getAngles()[0] - Rd, e.x, e.y);
  },
  _getScreenDelta: function() {
    return this.getRadius();
  },
  _getTickMarkPoints: function(e, t) {
    return [e.x - t / 2, e.y, e.x + t / 2, e.y];
  },
  _getLabelAdjustedCoord: function(e) {
    var t = e.labelCoords, r = t.y, n = ya(t.angle), i = this._options.label.indentFromAxis || 0, s = e.labelBBox, l = t.x - xh(i * n.sin) + xh(s.width / 2 * n.cos) - s.width / 2, d = r + (r - s.y) - xh(s.height / 2 * n.sin) + xh(i * n.cos);
    return {
      x: l,
      y: d
    };
  },
  _getGridLineDrawer: function() {
    var e = this;
    return function(t, r) {
      var n = e._getGridPoints(t.coords);
      return e._renderer.circle(n.cx, n.cy, n.r).attr(r).sharp();
    };
  },
  _getGridPoints: function(e) {
    var t = this.getCenter(), r = bT(t.x, t.y, e.x, e.y);
    return r > this.getRadius() ? {
      cx: null,
      cy: null,
      r: null
    } : {
      cx: t.x,
      cy: t.y,
      r
    };
  },
  _getTranslatedValue: function(e, t) {
    var r = this.getAngles()[0], n = CT(this.getCenter(), r, 0, this._translator.translate(e, t));
    return {
      x: n.x,
      y: n.y,
      angle: r - Rd
    };
  },
  _getTranslatedCoord: function(e, t) {
    return this._translator.translate(e, t);
  },
  _getCanvasStartEnd() {
    var e = this.getTranslator().getBusinessRange().invert, t = [0, this.getRadius()];
    return e && t.reverse(), {
      start: t[0],
      end: t[1]
    };
  },
  _getStripGraphicAttributes: function(e, t) {
    var r = this.getCenter();
    return {
      x: r.x,
      y: r.y,
      innerRadius: e,
      outerRadius: t
    };
  },
  _createStrip: function(e) {
    return this._renderer.arc(e.x, e.y, e.innerRadius, e.outerRadius, 0, 360);
  },
  _getAdjustedStripLabelCoords: wl._getAdjustedStripLabelCoords,
  _getStripLabelCoords: function(e, t) {
    var r = e + (t - e) / 2, n = this.getCenter(), i = kd(n.y - r);
    return {
      x: n.x,
      y: i,
      align: Dt.center
    };
  },
  _getConstantLineGraphicAttributes: function(e) {
    var t = this.getCenter();
    return {
      cx: t.x,
      cy: t.y,
      r: e
    };
  },
  _createConstantLine: function(e, t) {
    var r = this._getConstantLineGraphicAttributes(e);
    return this._renderer.circle(r.cx, r.cy, r.r).attr(t).sharp();
  },
  _getConstantLineLabelsCoords: function(e) {
    var t = this.getCenter(), r = kd(t.y - e);
    return {
      x: t.x,
      y: r
    };
  },
  _checkAlignmentConstantLineLabels: Y,
  _rotateTick: function(e, t, r) {
    !r && e.rotate(t.angle + Rd, t.x, t.y);
  },
  _validateOverlappingMode: wl._validateOverlappingMode,
  _validateDisplayMode: wl._validateDisplayMode,
  _getStep: function(e) {
    var t = EU(this.getAngles()[0]), r = this._options.label.minSpacing, n = t === 2 || t === 4 ? function(s) {
      return s.width + r;
    } : function(s) {
      return s.height;
    }, i = e.reduce((s, l) => _D(s, n(l)), 0);
    return Dt.getTicksCountInRange(this._majorTicks, t === 2 || t === 4 ? "x" : "y", i);
  }
}, hne = W({}, wU, {
  _createPathElement: function(e, t) {
    return this._renderer.path(e, "area").attr(t).sharp();
  },
  setSpiderTicks: function(e) {
    this._spiderTicks = e;
  },
  _getGridLineDrawer: function() {
    var e = this;
    return function(t, r) {
      return e._createPathElement(e._getGridPoints(t.coords).points, r);
    };
  },
  _getGridPoints: function(e) {
    var t = this.getCenter(), r = bT(t.x, t.y, e.x, e.y);
    return this._getGridPointsByRadius(r);
  },
  _getGridPointsByRadius: function(e) {
    var t = this.getCenter();
    return e > this.getRadius() ? {
      points: null
    } : {
      points: ti(this._spiderTicks, function(r) {
        var n = ya(r.coords.angle);
        return {
          x: kd(t.x + e * n.cos),
          y: kd(t.y + e * n.sin)
        };
      })
    };
  },
  _getStripGraphicAttributes: function(e, t) {
    var r = this._getGridPointsByRadius(t).points, n = this._getGridPointsByRadius(e).points;
    return {
      points: [n, r.reverse()]
    };
  },
  _createStrip: TU._createStrip,
  _getConstantLineGraphicAttributes: function(e) {
    return this._getGridPointsByRadius(e);
  },
  _createConstantLine: function(e, t) {
    return this._createPathElement(this._getConstantLineGraphicAttributes(e).points, t);
  }
});
const vne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  circular: fne,
  circularSpider: TU,
  linear: wU,
  linearSpider: hne
}, Symbol.toStringTag, { value: "Module" }));
function pne(e, t) {
  var r = t.label || {}, n = r.position || "inside", i, s = !1, l;
  e._checkAlignmentConstantLineLabels(r);
  var d;
  return {
    options: t,
    labelOptions: r,
    labelPosition: n,
    label: null,
    line: null,
    getParsedValue() {
      return s || (i = e.validateUnit(t.value, "E2105", "constantLine"), s = !0), i;
    },
    draw() {
      if (!I(t.value) || e._translator.getBusinessRange().isEmpty())
        return this;
      var h = e._getCanvasStartEnd(), p = this.getParsedValue();
      this.coord = e._getConstantLinePos(p, h.start, h.end);
      var m = t.displayBehindSeries ? e._axisConstantLineGroups.under : e._axisConstantLineGroups.above, x = m[n];
      if (!x) {
        var S = e._isHorizontal ? r.verticalAlignment : r.horizontalAlignment;
        x = m[S];
      }
      if (!I(this.coord))
        return this;
      var T = e._createConstantLine(this.coord, {
        stroke: t.color,
        "stroke-width": t.width,
        dashStyle: t.dashStyle
      });
      return this.line = T.append(m.inside), this.label = r.visible ? e._drawConstantLineLabels(p, r, this.coord, x) : null, this.updatePosition(), this;
    },
    getContentContainer() {
      return this.label;
    },
    removeLabel() {
      this.label && this.label.remove();
    },
    updatePosition(h) {
      var p = e._getCanvasStartEnd(), m = e._getConstantLinePos(this.getParsedValue(), p.start, p.end);
      I(m) && (this.coord = m, h && d ? (this.label && this.label.attr(e._getConstantLineLabelsCoords(d, this.labelOptions)), this.line && this.line.attr(e._getConstantLineGraphicAttributes(d)), this.label && this.label.animate(e._getConstantLineLabelsCoords(this.coord, this.labelOptions)), this.line && this.line.animate(e._getConstantLineGraphicAttributes(this.coord))) : (this.label && this.label.attr(e._getConstantLineLabelsCoords(this.coord, this.labelOptions)), this.line && this.line.attr(e._getConstantLineGraphicAttributes(this.coord)), e._rotateConstantLine(this.line, this.coord)));
    },
    saveCoords() {
      l = d, d = this.coord;
    },
    resetCoordinates() {
      d = l;
    }
  };
}
function gne(e, t) {
  var r, n, i = t.label || {};
  return {
    options: t,
    label: null,
    rect: null,
    _getCoord() {
      var s = e._getCanvasStartEnd(), l = e._translator.getBusinessRange();
      return e._getStripPos(t.startValue, t.endValue, s.start, s.end, l);
    },
    _drawLabel: (s) => e._renderer.text(i.text, s.x, s.y).css(Oi(W({}, e.getOptions().label.font, i.font))).attr({
      align: "center",
      class: i.cssClass
    }).append(e._axisStripLabelGroup),
    draw() {
      if (!e._translator.getBusinessRange().isEmpty() && (I(t.startValue) || I(t.endValue)) && I(t.color)) {
        var s = this._getCoord();
        if (this.labelCoords = i.text ? e._getStripLabelCoords(s.from, s.to, i) : null, s.outOfCanvas || !I(s.to) || !I(s.from))
          return;
        this.rect = e._createStrip(e._getStripGraphicAttributes(s.from, s.to)).attr({
          fill: t.color
        }).append(e._axisStripGroup), this.label = i.text ? this._drawLabel(this.labelCoords) : null;
      }
    },
    getContentContainer() {
      return this.label;
    },
    removeLabel() {
    },
    updatePosition(s) {
      var l = this._getCoord();
      s && r ? (this.label && this.label.attr(e._getStripLabelCoords(r.from, r.to, t.label)), this.rect && this.rect.attr(e._getStripGraphicAttributes(r.from, r.to)), this.label && this.label.animate(e._getStripLabelCoords(l.from, l.to, t.label)), this.rect && this.rect.animate(e._getStripGraphicAttributes(l.from, l.to))) : (this.label && this.label.attr(e._getStripLabelCoords(l.from, l.to, t.label)), this.rect && this.rect.attr(e._getStripGraphicAttributes(l.from, l.to)));
    },
    saveCoords() {
      n = r, r = this._getCoord();
    },
    resetCoordinates() {
      r = n;
    }
  };
}
var Gp = Dt.convertTicksToValues, Cy = Math, Es = Cy.abs, bl = Cy.max, uC = Cy.min, WB = Array.isArray, mne = 5, XB = 4, bh = Dt.top, Dd = Dt.bottom, Vo = Dt.left, ks = Dt.right, Tg = Dt.center, Pu = "keep", gk = "shift", ud = "reset", O_ = "rotate", _ne = 50, yne = 15, xne = 5, qB = 5, bne = 0.8, k_ = {
  day: 864e5,
  week: 6048e5
};
function AU(e, t, r, n, i, s) {
  var l, {
    allowNegatives: d,
    linearThreshold: h
  } = s;
  return Vre({
    axisType: e.type,
    dataType: e.dataType,
    logBase: e.logarithmBase,
    allowNegatives: d,
    linearThreshold: h,
    axisDivisionFactor: i(e.axisDivisionFactor || _ne),
    minorAxisDivisionFactor: i(e.minorAxisDivisionFactor || yne),
    numberMultipliers: e.numberMultipliers,
    calculateMinors: e.minorTick.visible || e.minorGrid.visible || e.calculateMinors,
    allowDecimals: e.allowDecimals,
    endOnTick: e.endOnTick,
    incidentOccurred: t,
    firstDayOfWeek: (l = e.workWeek) === null || l === void 0 ? void 0 : l[0],
    skipTickGeneration: r,
    skipCalculationLimits: e.skipCalculationLimits,
    generateExtraTick: e.generateExtraTick,
    minTickInterval: e.minTickInterval,
    rangeIsEmpty: n
  });
}
function KB(e, t, r) {
  var n = e.getOptions();
  return IT(e, t, n.tick, n.grid, r, !1);
}
function ZB(e, t) {
  var r = e.getOptions();
  return IT(e, t, r.minorTick, r.minorGrid);
}
function QB(e, t, r) {
  var n = e.getOptions();
  return IT(e, t, W({}, n.tick, {
    visible: n.showCustomBoundaryTicks
  }), n.grid, void 0, !1, r ? -1 : 1);
}
function nn(e, t, r, n) {
  (e || []).forEach((i) => i[t](r, n));
}
function Up(e) {
  nn(e, "initCoords");
}
function mk(e, t) {
  nn(e, "drawMark", t);
}
function JB(e, t) {
  nn(e, "drawGrid", t);
}
function _k(e, t, r) {
  nn(e, "updateTickPosition", t, r);
}
function e2(e, t) {
  nn(e, "updateGridPosition", t);
}
function yk(e) {
  var t = e.length - 1;
  for (t; t >= 0 && t2(e, t); t--)
    ;
  for (t = 0; t < e.length && t2(e, t); t++)
    t--;
}
function t2(e, t) {
  return e[t].coords.x === null || e[t].coords.y === null ? (e.splice(t, 1), !0) : !1;
}
function Sne(e) {
  var t, r = e.label, n = e.position, i = e.isHorizontal ? Dd : Vo, s = e.isHorizontal ? bh : ks, l = r.position;
  n !== i && n !== s && (n = i), !l || l === "outside" ? l = n : l === "inside" && (l = {
    [bh]: Dd,
    [Dd]: bh,
    [Vo]: ks,
    [ks]: Vo
  }[n]), l !== i && l !== s && (l = n), r.alignment !== Tg && !r.userAlignment && (r.alignment = {
    [bh]: Tg,
    [Dd]: Tg,
    [Vo]: ks,
    [ks]: Vo
  }[l]), e.position = n, r.position = l, e.hoverMode = e.hoverMode ? e.hoverMode.toLowerCase() : "none", r.minSpacing = (t = r.minSpacing) !== null && t !== void 0 ? t : mne, e.type && (e.type = e.type.toLowerCase()), e.argumentType && (e.argumentType = e.argumentType.toLowerCase()), e.valueType && (e.valueType = e.valueType.toLowerCase());
}
function Cne(e, t) {
  var r = 180 * Cy.asin((e[0].height + t.minSpacing) / (e[1].x - e[0].x)) / Cy.PI;
  return r < 45 ? -45 : -90;
}
function xk(e, t, r) {
  e.forEach(function(n, i) {
    n.getContentContainer() && (i % t !== 0 ? n.removeLabel() : r && r(n, i));
  });
}
function cC(e, t) {
  return e === void 0 ? t : e === null ? void 0 : e;
}
function Ene(e, t, r, n, i) {
  var s = W({}, e, {
    endOnTick: !0,
    axisDivisionFactor: t,
    skipCalculationLimits: !0,
    generateExtraTick: !0,
    minTickInterval: i
  });
  return function(l, d, h, p, m) {
    return AU(s, Y, d, r.isEmpty(), (x) => x, r)({
      min: h,
      max: p,
      categories: r.categories,
      isSpacedMargin: r.isSpacedMargin
    }, n, l, I(l), void 0, void 0, void 0, m);
  };
}
function Tne(e, t) {
  return Math.max(t.start, t.end) !== e ? 1 : -1;
}
function wne(e, t) {
  e && t.visualRangeUpdateMode === "shift" && Dr.log("W0016", "valueAxis.visualRangeUpdateMode", "shift", "23.1", "Specify another value");
}
var yD = function(e) {
  this._renderer = e.renderer, this._incidentOccurred = e.incidentOccurred, this._eventTrigger = e.eventTrigger, this._stripsGroup = e.stripsGroup, this._stripLabelAxesGroup = e.stripLabelAxesGroup, this._labelsAxesGroup = e.labelsAxesGroup, this._constantLinesGroup = e.constantLinesGroup, this._scaleBreaksGroup = e.scaleBreaksGroup, this._axesContainerGroup = e.axesContainerGroup, this._gridContainerGroup = e.gridGroup, this._axisCssPrefix = e.widgetClass + "-" + (e.axisClass ? e.axisClass + "-" : ""), this._setType(e.axisType, e.drawingType), this._createAxisGroups(), this._translator = this._createTranslator(), this.isArgumentAxis = e.isArgumentAxis, this._viewport = {}, this._prevDataInfo = {}, this._firstDrawing = !0, this._initRange = {}, this._getTemplate = e.getTemplate;
};
yD.prototype = {
  constructor: yD,
  _drawAxis() {
    var e = this._options;
    e.visible && (this._axisElement = this._createAxisElement(), this._updateAxisElementPosition(), this._axisElement.attr({
      "stroke-width": e.width,
      stroke: e.color,
      "stroke-opacity": e.opacity
    }).sharp(this._getSharpParam(!0), this.getAxisSharpDirection()).append(this._axisLineGroup));
  },
  _createPathElement(e, t, r) {
    return this.sharp(this._renderer.path(e, "line").attr(t), r);
  },
  sharp(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    return e.sharp(this._getSharpParam(), t);
  },
  customPositionIsAvailable: () => !1,
  getOrthogonalAxis: Y,
  getCustomPosition: Y,
  getCustomBoundaryPosition: Y,
  resolveOverlappingForCustomPositioning: Y,
  hasNonBoundaryPosition: () => !1,
  customPositionIsBoundaryOrthogonalAxis: () => !1,
  getResolvedBoundaryPosition() {
    return this.getOptions().position;
  },
  getAxisSharpDirection() {
    var e = this.getResolvedBoundaryPosition();
    return this.hasNonBoundaryPosition() || e !== Dd && e !== ks ? 1 : -1;
  },
  getSharpDirectionByCoords(e) {
    var t = this._getCanvasStartEnd(), r = Math.max(t.start, t.end);
    return this.getRadius ? 0 : r !== e[this._isHorizontal ? "x" : "y"] ? 1 : -1;
  },
  _getGridLineDrawer: function() {
    var e = this;
    return function(t, r) {
      var n = e._getGridPoints(t.coords);
      return n.points ? e._createPathElement(n.points, r, e.getSharpDirectionByCoords(t.coords)) : null;
    };
  },
  _getGridPoints: function(e) {
    var t = this._isHorizontal, r = t ? "x" : "y", n = this._orthogonalPositions, i = n.start, s = n.end, l = this.borderOptions, d = t ? Vo : bh, h = t ? ks : Dd, p = this.getCanvas(), m = {
      left: p.left,
      right: p.width - p.right,
      top: p.top,
      bottom: p.height - p.bottom
    }, x = l.visible && l[d] ? m[d] : void 0, S = l.visible && l[h] ? m[h] : void 0, T = XB + x, k = S - XB;
    return this.areCoordsOutsideAxis(e) || e[r] === void 0 || e[r] < T || e[r] > k ? {
      points: null
    } : {
      points: t ? e[r] !== null ? [e[r], i, e[r], s] : null : e[r] !== null ? [i, e[r], s, e[r]] : null
    };
  },
  _getConstantLinePos: function(e, t, r) {
    var n = this._getTranslatedCoord(e);
    if (!(!I(n) || n < uC(t, r) || n > bl(t, r)))
      return n;
  },
  _getConstantLineGraphicAttributes: function(e) {
    var t = this._orthogonalPositions.start, r = this._orthogonalPositions.end;
    return {
      points: this._isHorizontal ? [e, t, e, r] : [t, e, r, e]
    };
  },
  _createConstantLine: function(e, t) {
    return this._createPathElement(this._getConstantLineGraphicAttributes(e).points, t, Tne(e, this._getCanvasStartEnd()));
  },
  _drawConstantLineLabelText: function(e, t, r, n, i) {
    var {
      font: s,
      cssClass: l
    } = n;
    return this._renderer.text(e, t, r).css(Oi(W({}, this._options.label.font, s))).attr({
      align: "center",
      class: l
    }).append(i);
  },
  _drawConstantLineLabels: function(e, t, r, n) {
    var i, s = t.text, l = this._options, d = l.label;
    this._checkAlignmentConstantLineLabels(t), s = (i = s) !== null && i !== void 0 ? i : this.formatLabel(e, d);
    var h = this._getConstantLineLabelsCoords(r, t);
    return this._drawConstantLineLabelText(s, h.x, h.y, t, n);
  },
  _getStripPos: function(e, t, r, n, i) {
    var s = !!(i.minVisible || i.maxVisible), l = (i.categories || []).reduce(function(F, z) {
      return F.push(z.valueOf()), F;
    }, []), d, h, p, m, x;
    if (!s && I(e) && I(t)) {
      var S, T, k = this.parser(e), O = this.parser(t);
      if (m = l.indexOf((S = k == null ? void 0 : k.valueOf()) !== null && S !== void 0 ? S : void 0), x = l.indexOf((T = O == null ? void 0 : O.valueOf()) !== null && T !== void 0 ? T : void 0), m === -1 || x === -1)
        return {
          from: 0,
          to: 0,
          outOfCanvas: !0
        };
      m > x && (p = t, t = e, e = p);
    }
    I(e) ? (e = this.validateUnit(e, "E2105", "strip"), d = this._getTranslatedCoord(e, -1)) : d = r, I(t) ? (t = this.validateUnit(t, "E2105", "strip"), h = this._getTranslatedCoord(t, 1)) : h = n;
    var D = d < h ? {
      from: d,
      to: h
    } : {
      from: h,
      to: d
    }, L = this.getVisibleArea();
    return (D.from <= L[0] && D.to <= L[0] || D.from >= L[1] && D.to >= L[1]) && (D.outOfCanvas = !0), D;
  },
  _getStripGraphicAttributes: function(e, t) {
    var r, n, i, s, l = this._orthogonalPositions, d = l.start, h = l.end;
    return this._isHorizontal ? (r = e, n = uC(d, h), i = t - e, s = Es(d - h)) : (r = uC(d, h), n = e, i = Es(d - h), s = Es(e - t)), {
      x: r,
      y: n,
      width: i,
      height: s
    };
  },
  _createStrip: function(e) {
    return this._renderer.rect(e.x, e.y, e.width, e.height);
  },
  _adjustStripLabels: function() {
    var e = this;
    this._strips.forEach(function(t) {
      t.label && t.label.attr(e._getAdjustedStripLabelCoords(t));
    });
  },
  _adjustLabelsCoord(e, t, r) {
    var n = (i) => this._getLabelAdjustedCoord(i, e + (i.labelOffset || 0), t, r);
    this._majorTicks.forEach(function(i) {
      i.label ? (i.updateMultilineTextAlignment(), i.label.attr(n(i))) : i.templateContainer && i.templateContainer.attr(n(i));
    });
  },
  _adjustLabels: function(e) {
    var t = this.getOptions(), r = t.position === t.label.position, n = this._majorTicks.reduce(function(s, l) {
      if (!l.getContentContainer())
        return s;
      var d = l.labelRotationAngle ? kE(l.labelBBox, [l.labelCoords.x, l.labelCoords.y], -l.labelRotationAngle) : l.labelBBox;
      return {
        width: bl(s.width || 0, d.width),
        height: bl(s.height || 0, d.height),
        offset: bl(s.offset || 0, l.labelOffset || 0)
      };
    }, {}), i = r ? this._isHorizontal ? n.height : n.width : 0;
    return this._adjustLabelsCoord(e, n.width), e + i + (i && this._options.label.indentFromAxis) + (r ? n.offset : 0);
  },
  _getLabelAdjustedCoord: function(e, t, r) {
    t = t || 0;
    var n = this._options, i = e.templateContainer && e.templateContainer.getBBox(), s = i || kE(e.labelBBox, [e.labelCoords.x, e.labelCoords.y], -e.labelRotationAngle || 0), l = e.labelAlignment || n.label.alignment, d = this._options.type === "discrete", h = e.labelRotationAngle % 90 === 0, p = n.label.indentFromAxis, m = n.label.position, x = this._axisPosition, S = e.labelCoords, T = S.x, k, O;
    return this._isHorizontal ? (m === Dd ? O = x + p - s.y + t : O = x - p - (s.y + s.height) - t, l === ks ? k = d && h ? e.coords.x - (s.x + s.width) : T - s.x - s.width : l === Vo ? k = d && h ? T - s.x - (e.coords.x - T) : T - s.x : k = T - s.x - s.width / 2) : (O = S.y - s.y - s.height / 2, m === Vo ? (l === Vo ? k = x - p - r - s.x : l === Tg ? k = x - p - r / 2 - s.x - s.width / 2 : k = x - p - s.x - s.width, k -= t) : (l === ks ? k = x + p + r - s.x - s.width : l === Tg ? k = x + p + r / 2 - s.x - s.width / 2 : k = x + p - s.x, k += t)), {
      translateX: k,
      translateY: O
    };
  },
  _createAxisConstantLineGroups: function() {
    var e = this._renderer, t = this._axisCssPrefix, r = t + "constant-lines", n = e.g().attr({
      class: r
    }), i = e.g().attr({
      class: r
    }), s = e.g().attr({
      class: r
    });
    return {
      inside: n,
      outside1: i,
      left: i,
      top: i,
      outside2: s,
      right: s,
      bottom: s,
      remove: function() {
        this.inside.remove(), this.outside1.remove(), this.outside2.remove();
      },
      clear: function() {
        this.inside.clear(), this.outside1.clear(), this.outside2.clear();
      }
    };
  },
  _createAxisGroups: function() {
    var e = this._renderer, t = this._axisCssPrefix;
    this._axisGroup = e.g().attr({
      class: t + "axis"
    }).enableLinks(), this._axisStripGroup = e.g().attr({
      class: t + "strips"
    }), this._axisGridGroup = e.g().attr({
      class: t + "grid"
    }), this._axisElementsGroup = e.g().attr({
      class: t + "elements"
    }), this._axisLineGroup = e.g().attr({
      class: t + "line"
    }).linkOn(this._axisGroup, "axisLine").linkAppend(), this._axisTitleGroup = e.g().attr({
      class: t + "title"
    }).append(this._axisGroup), this._axisConstantLineGroups = {
      above: this._createAxisConstantLineGroups(),
      under: this._createAxisConstantLineGroups()
    }, this._axisStripLabelGroup = e.g().attr({
      class: t + "axis-labels"
    });
  },
  _clearAxisGroups: function() {
    this._axisGroup.remove(), this._axisStripGroup.remove(), this._axisStripLabelGroup.remove(), this._axisConstantLineGroups.above.remove(), this._axisConstantLineGroups.under.remove(), this._axisGridGroup.remove(), this._axisTitleGroup.clear(), (!this._options.label.template || !this.isRendered()) && (this._axisElementsGroup.remove(), this._axisElementsGroup.clear()), this._axisLineGroup && this._axisLineGroup.clear(), this._axisStripGroup && this._axisStripGroup.clear(), this._axisGridGroup && this._axisGridGroup.clear(), this._axisConstantLineGroups.above.clear(), this._axisConstantLineGroups.under.clear(), this._axisStripLabelGroup && this._axisStripLabelGroup.clear();
  },
  _getLabelFormatObject: function(e, t, r, n, i, s) {
    r = r || this._getViewportRange();
    var l = {
      value: e,
      valueText: gD(e, {
        labelOptions: t,
        ticks: s || Gp(this._majorTicks),
        tickInterval: i ?? this._tickInterval,
        dataType: this._options.dataType,
        logarithmBase: this._options.logarithmBase,
        type: this._options.type,
        showTransition: !this._options.marker.visible,
        point: n
      }) || "",
      min: r.minVisible,
      max: r.maxVisible
    };
    return n && (l.point = n), l;
  },
  formatLabel: function(e, t, r, n, i, s) {
    var l = this._getLabelFormatObject(e, t, r, n, i, s);
    return ct(t.customizeText) ? t.customizeText.call(l, l) : l.valueText;
  },
  formatHint: function(e, t, r) {
    var n = this._getLabelFormatObject(e, t, r);
    return ct(t.customizeHint) ? t.customizeHint.call(n, n) : void 0;
  },
  formatRange(e, t, r, n) {
    return rre({
      startValue: e,
      endValue: t,
      tickInterval: r,
      argumentFormat: n,
      axisOptions: this.getOptions()
    });
  },
  _setTickOffset: function() {
    var e = this._options, t = e.discreteAxisDivisionMode;
    this._tickOffset = +(t !== "crossLabels" || !t);
  },
  aggregatedPointBetweenTicks() {
    return this._options.aggregatedPointsPosition === "crossTicks";
  },
  resetApplyingAnimation: function(e) {
    this._resetApplyingAnimation = !0, e && (this._firstDrawing = !0);
  },
  isFirstDrawing() {
    return this._firstDrawing;
  },
  getMargins: function() {
    var e = this, {
      position: t,
      offset: r,
      customPosition: n,
      placeholderSize: i,
      grid: s,
      tick: l,
      crosshairMargin: d
    } = e._options, h = I(n), p = e.getResolvedBoundaryPosition(), m = e.getCanvas(), x = m.left, S = m.top, T = m.width - m.right, k = m.height - m.bottom, O = bl(s.visible && s.width || 0, l.visible && l.width || 0), D = e._axisConstantLineGroups.above, L = e._axisConstantLineGroups.under, F = [e._axisElementsGroup, D.outside1, D.outside2, L.outside1, L.outside2, e._axisLineGroup].map((P) => P && P.getBBox()).concat(function(P) {
      var j = P && P.getBBox();
      return !j || j.isEmpty || (e._isHorizontal ? (j.x = x, j.width = T - x) : (j.y = S, j.height = k - S)), j;
    }(e._axisTitleGroup)), z = CU(F, m);
    if (z[t] += d, e.hasNonBoundaryPosition() && h && (z[p] = 0), i && (z[t] = i), O && (e._isHorizontal && m.right < O && z.right < O && (z.right = O), !e._isHorizontal && m.bottom < O && z.bottom < O && (z.bottom = O)), !h && I(r)) {
      var V = e.customPositionIsBoundary() && (r > 0 && (p === Vo || p === bh) || r < 0 && (p === ks || p === Dd));
      z[p] -= V ? r : 0;
    }
    return z;
  },
  validateUnit: function(e, t, r) {
    return e = this.parser(e), e === void 0 && t && this._incidentOccurred(t, [r]), e;
  },
  _setType: function(e, t) {
    var r;
    switch (e) {
      case "xyAxes":
        r = SU;
        break;
      case "polarAxes":
        r = vne;
    }
    W(this, r[t]);
  },
  _getSharpParam: function() {
    return !0;
  },
  _disposeBreaksGroup: Y,
  dispose: function() {
    [this._axisElementsGroup, this._axisStripGroup, this._axisGroup].forEach(function(e) {
      e.dispose();
    }), this._strips = this._title = null, this._axisStripGroup = this._axisConstantLineGroups = this._axisStripLabelGroup = this._axisBreaksGroup = null, this._axisLineGroup = this._axisElementsGroup = this._axisGridGroup = null, this._axisGroup = this._axisTitleGroup = null, this._axesContainerGroup = this._stripsGroup = this._constantLinesGroup = this._labelsAxesGroup = null, this._renderer = this._options = this._textOptions = this._textFontStyles = null, this._translator = null, this._majorTicks = this._minorTicks = null, this._disposeBreaksGroup(), this._templatesRendered && this._templatesRendered.reject();
  },
  getOptions: function() {
    return this._options;
  },
  setPane: function(e) {
    this.pane = e, this._options.pane = e;
  },
  setTypes: function(e, t, r) {
    this._options.type = e || this._options.type, this._options[r] = t || this._options[r], this._updateTranslator();
  },
  resetTypes: function(e) {
    this._options.type = this._initTypes.type, this._options[e] = this._initTypes[e];
  },
  getTranslator: function() {
    return this._translator;
  },
  updateOptions: function(e) {
    var t = this, r = e.label;
    Sne(e), wne(!t.isArgumentAxis, e), t._options = e, e.tick = e.tick || {}, e.minorTick = e.minorTick || {}, e.grid = e.grid || {}, e.minorGrid = e.minorGrid || {}, e.title = e.title || {}, e.marker = e.marker || {}, t._initTypes = {
      type: e.type,
      argumentType: e.argumentType,
      valueType: e.valueType
    }, t._setTickOffset(), t._isHorizontal = e.isHorizontal, t.pane = e.pane, t.name = e.name, t.priority = e.priority, t._hasLabelFormat = r.format !== "" && I(r.format), t._textOptions = {
      opacity: r.opacity,
      align: "center",
      class: r.cssClass
    }, t._textFontStyles = Oi(r.font), e.type === Dt.logarithmic && e.logarithmBaseError && (t._incidentOccurred("E2104"), delete e.logarithmBaseError), t._updateTranslator(), t._createConstantLines(), t._strips = (e.strips || []).map((n) => gne(t, n)), t._majorTicks = t._minorTicks = null, t._firstDrawing = !0;
  },
  calculateInterval: function(e, t) {
    var r = this._options;
    if (!r || r.type !== Dt.logarithmic)
      return Es(e - t);
    var {
      allowNegatives: n,
      linearThreshold: i
    } = new _a(this.getTranslator().getBusinessRange());
    return Es(Ai(e, r.logarithmBase, n, i) - Ai(t, r.logarithmBase, n, i));
  },
  getCanvasRange() {
    var e = this._translator;
    return {
      startValue: e.from(e.translate("canvas_position_start")),
      endValue: e.from(e.translate("canvas_position_end"))
    };
  },
  _processCanvas: function(e) {
    return e;
  },
  updateCanvas: function(e, t) {
    if (t)
      this._orthogonalPositions = null;
    else {
      var r = this._orthogonalPositions = {
        start: this._isHorizontal ? e.top : e.left,
        end: this._isHorizontal ? e.height - e.bottom : e.width - e.right
      };
      r.center = r.start + (r.end - r.start) / 2;
    }
    this._canvas = e, this._translator.updateCanvas(this._processCanvas(e)), this._initAxisPositions();
  },
  getCanvas: function() {
    return this._canvas;
  },
  getAxisShift() {
    return this._axisShift || 0;
  },
  hideTitle: function() {
    this._options.title.text && (this._incidentOccurred("W2105", [this._isHorizontal ? "horizontal" : "vertical"]), this._axisTitleGroup.clear());
  },
  getTitle: function() {
    return this._title;
  },
  hideOuterElements: function() {
    var e = this._options;
    (e.label.visible || this._outsideConstantLines.length) && !this._translator.getBusinessRange().isEmpty() && (this._incidentOccurred("W2106", [this._isHorizontal ? "horizontal" : "vertical"]), this._axisElementsGroup.clear(), nn(this._outsideConstantLines, "removeLabel"));
  },
  _resolveLogarithmicOptionsForRange(e) {
    var t = this._options;
    t.type === Dt.logarithmic && (e.addRange({
      allowNegatives: t.allowNegatives !== void 0 ? t.allowNegatives : e.min <= 0
    }), isNaN(t.linearThreshold) || (e.linearThreshold = t.linearThreshold));
  },
  adjustViewport(e) {
    var t = this._options, r = t.type === Dt.discrete, n = this._seriesData && this._seriesData.categories || [], i = this.adjustRange(bd(t.wholeRange)), s = this.getViewport() || {}, l = new _a(e);
    this._addConstantLinesToRange(l);
    var d = I(s.startValue), h = I(s.endValue);
    r || (d = d && (!I(i.endValue) || s.startValue < i.endValue), h = h && (!I(i.startValue) || s.endValue > i.startValue));
    var p = d ? s.startValue : l.minVisible, m = h ? s.endValue : l.maxVisible;
    if (r) {
      var T = Xu(n, i.startValue, i.endValue);
      n = T.categories, l.categories = n;
    } else {
      var x, S;
      l.min = (x = i.startValue) !== null && x !== void 0 ? x : l.min, l.max = (S = i.endValue) !== null && S !== void 0 ? S : l.max;
    }
    var k = GK({
      axisType: t.type,
      dataType: t.dataType,
      base: t.logarithmBase
    }, {
      startValue: d ? s.startValue : void 0,
      endValue: h ? s.endValue : void 0,
      length: s.length
    }, {
      categories: n,
      min: i.startValue,
      max: i.endValue
    }, {
      categories: n,
      min: p,
      max: m
    });
    return l.minVisible = k.startValue, l.maxVisible = k.endValue, !I(l.min) && (l.min = l.minVisible), !I(l.max) && (l.max = l.maxVisible), l.addRange({}), this._resolveLogarithmicOptionsForRange(l), l;
  },
  adjustRange(e) {
    e = e || {};
    var t = this._options.type === Dt.discrete, r = this._options.type === Dt.logarithmic, n = this._options.allowNegatives === !1;
    if (r && (e.startValue = n && e.startValue <= 0 ? null : e.startValue, e.endValue = n && e.endValue <= 0 ? null : e.endValue), !t && I(e.startValue) && I(e.endValue) && e.startValue > e.endValue) {
      var i = e.endValue;
      e.endValue = e.startValue, e.startValue = i;
    }
    return e;
  },
  _getVisualRangeUpdateMode(e, t, r) {
    var n = this._options.visualRangeUpdateMode, i = this._translator, s = this._seriesData, l = this._prevDataInfo;
    if (l.isEmpty && !l.containsConstantLine)
      return Pu;
    if (!this.isArgumentAxis) {
      var d = this.getViewport();
      if (!I(d.startValue) && !I(d.endValue) && !I(d.length))
        return ud;
    }
    if (this.isArgumentAxis) {
      if ([gk, Pu, ud].indexOf(n) === -1) {
        if (s.axisType === Dt.discrete) {
          var h = s.categories, p = t.categories, m = this.visualRange();
          h && p && h.length && p.map((O) => O.valueOf()).join(",").indexOf(h.map((O) => O.valueOf()).join(",")) !== -1 && (m.startValue.valueOf() !== h[0].valueOf() || m.endValue.valueOf() !== h[h.length - 1].valueOf()) ? n = Pu : n = ud;
        } else {
          var x = i.translate(s.min), S = i.translate(e.startValue), T = i.translate(s.max), k = i.translate(e.endValue);
          x === S && T === k ? n = ud : x !== S && T === k ? n = gk : n = Pu;
        }
        n === Pu && l.isEmpty && l.containsConstantLine && (n = ud);
      }
    } else
      [Pu, ud].indexOf(n) === -1 && (r === Pu ? n = Pu : n = ud);
    return n;
  },
  _handleBusinessRangeChanged(e, t, r) {
    var n = this.visualRange();
    if (!(t || this._translator.getBusinessRange().isEmpty())) {
      var i = this._lastVisualRangeUpdateMode = this._getVisualRangeUpdateMode(n, r, e);
      i === Pu ? this._setVisualRange([n.startValue, n.endValue]) : i === ud ? this._setVisualRange([null, null]) : i === gk && this._setVisualRange({
        length: this.getVisualRangeLength()
      });
    }
  },
  getVisualRangeLength(e) {
    var t = e || this._translator.getBusinessRange(), {
      type: r
    } = this._options, n;
    if (r === Dt.logarithmic)
      n = rr(this.calculateInterval(t.maxVisible, t.minVisible));
    else if (r === Dt.discrete) {
      var i = Xu(t.categories, t.minVisible, t.maxVisible);
      n = i.categories.length;
    } else
      n = t.maxVisible - t.minVisible;
    return n;
  },
  getVisualRangeCenter(e, t) {
    var r = this.getTranslator(), n = r.getBusinessRange(), i = t ? W(!0, {}, n, e || {}) : e || n, {
      type: s,
      logarithmBase: l
    } = this._options, d;
    if (!(!I(i.minVisible) || !I(i.maxVisible))) {
      if (s === Dt.logarithmic) {
        var {
          allowNegatives: h,
          linearThreshold: p,
          minVisible: m,
          maxVisible: x
        } = i;
        d = Dh(rr(Ai(x, l, h, p) + Ai(m, l, h, p)) / 2, l, h, p);
      } else if (s === Dt.discrete) {
        var S = Xu(i.categories, i.minVisible, i.maxVisible), T = Math.ceil(S.categories.length / 2) - 1;
        d = n.categories.indexOf(S.categories[T]);
      } else
        d = r.toValue((i.maxVisible.valueOf() + i.minVisible.valueOf()) / 2);
      return d;
    }
  },
  setBusinessRange(e, t, r, n) {
    var i, s, l = this._options, d = l.type === Dt.discrete;
    this._handleBusinessRangeChanged(r, t, e), this._seriesData = new _a(e);
    var h = this._seriesData.isEmpty(), p = new _a(this._seriesData);
    if (this._addConstantLinesToRange(p), this._prevDataInfo = {
      isEmpty: h,
      containsConstantLine: p.containsConstantLine
    }, this._seriesData.addRange({
      categories: l.categories,
      dataType: l.dataType,
      axisType: l.type,
      base: l.logarithmBase,
      invert: l.inverted
    }), this._resolveLogarithmicOptionsForRange(this._seriesData), !d) {
      if (!I(this._seriesData.min) && !I(this._seriesData.max)) {
        var m = this.getViewport();
        m && this._seriesData.addRange({
          min: m.startValue,
          max: m.endValue
        });
      }
      var x = l.synchronizedValue;
      I(x) && this._seriesData.addRange({
        min: x,
        max: x
      });
    }
    this._seriesData.minVisible = (i = this._seriesData.minVisible) !== null && i !== void 0 ? i : this._seriesData.min, this._seriesData.maxVisible = (s = this._seriesData.maxVisible) !== null && s !== void 0 ? s : this._seriesData.max, !this.isArgumentAxis && l.showZero && this._seriesData.correctValueZeroLevel(), this._seriesData.sortCategories(this.getCategoriesSorter(n)), this._seriesData.userBreaks = this._seriesData.isEmpty() ? [] : this._getScaleBreaks(l, this._seriesData, this._series, this.isArgumentAxis), this._translator.updateBusinessRange(this._getViewportRange());
  },
  _addConstantLinesToRange(e) {
    this._outsideConstantLines.concat(this._insideConstantLines || []).forEach((t) => {
      if (t.options.extendAxis) {
        var r = t.getParsedValue();
        e.addRange({
          containsConstantLine: !0,
          minVisible: r,
          maxVisible: r,
          min: I(e.min) ? e.min : r,
          max: I(e.max) ? e.max : r
        });
      }
    });
  },
  setGroupSeries: function(e) {
    this._series = e;
  },
  getLabelsPosition: function() {
    var e = this._options, t = e.position, r = e.label.indentFromAxis + (this._axisShift || 0) + this._constantLabelOffset, n = this._axisPosition;
    return t === bh || t === Vo ? n - r : n + r;
  },
  getFormattedValue: function(e, t, r) {
    var n = this._options.label;
    return I(e) ? this.formatLabel(e, W(!0, {}, n, t), void 0, r) : null;
  },
  _getBoundaryTicks: function(e, t) {
    var r = e.length, n = this._options, i = n.customBoundTicks, s = t.minVisible, l = t.maxVisible, d = n.showCustomBoundaryTicks ? this._boundaryTicksVisibility : {}, h = [];
    return n.type === Dt.discrete ? this._tickOffset && e.length !== 0 && (h = [e[0], e[e.length - 1]]) : i ? (d.min && I(i[0]) && h.push(i[0]), d.max && I(i[1]) && h.push(i[1])) : (d.min && (r === 0 || e[0] > s) && h.push(s), d.max && (r === 0 || e[r - 1] < l) && h.push(l)), h;
  },
  setPercentLabelFormat: function() {
    this._hasLabelFormat || (this._options.label.format = "percent");
  },
  resetAutoLabelFormat: function() {
    this._hasLabelFormat || delete this._options.label.format;
  },
  getMultipleAxesSpacing: function() {
    return this._options.multipleAxesSpacing || 0;
  },
  getTicksValues: function() {
    return {
      majorTicksValues: Gp(this._majorTicks),
      minorTicksValues: Gp(this._minorTicks)
    };
  },
  estimateTickInterval: function(e) {
    return this.updateCanvas(e), this._tickInterval !== this._getTicks(this._getViewportRange(), Y, !0).tickInterval;
  },
  setTicks: function(e) {
    var t = e.majorTicks || [];
    this._majorTicks = t.map(KB(this, this._renderer, this._getSkippedCategory(t))), this._minorTicks = (e.minorTicks || []).map(ZB(this, this._renderer)), this._isSynchronized = !0;
  },
  _adjustDivisionFactor: function(e) {
    return e;
  },
  _getTicks: function(e, t, r) {
    var n = this._options, i = n.customTicks, s = n.customMinorTicks;
    return AU(n, t || this._incidentOccurred, r, this._translator.getBusinessRange().isEmpty(), this._adjustDivisionFactor.bind(this), e)({
      min: e.minVisible,
      max: e.maxVisible,
      categories: e.categories,
      isSpacedMargin: e.isSpacedMargin
    }, this._getScreenDelta(), n.tickInterval, n.label.overlappingBehavior === "ignore" || n.forceUserTickInterval, {
      majors: i,
      minors: s
    }, n.minorTickInterval, n.minorTickCount, this._initialBreaks);
  },
  _createTicksAndLabelFormat: function(e, t) {
    var r = this._options, n = this._getTicks(e, t, !1);
    return !e.isEmpty() && r.type === Dt.discrete && r.dataType === "datetime" && !this._hasLabelFormat && n.ticks.length && (r.label.format = Nl.getDateFormatByTicks(n.ticks)), n;
  },
  getAggregationInfo(e, t) {
    var r, n, i, s = this._options, l = this._marginOptions, d = new _a(this.getTranslator().getBusinessRange()).addRange(t), h = this.getViewport(), p = (r = h == null ? void 0 : h.startValue) !== null && r !== void 0 ? r : d.minVisible, m = (n = h == null ? void 0 : h.endValue) !== null && n !== void 0 ? n : d.maxVisible, x = [];
    if (s.type === Dt.discrete && s.aggregateByCategory)
      return {
        aggregateByCategory: !0
      };
    var S = s.aggregationInterval, T = s.aggregationGroupWidth;
    !T && l && (l.checkInterval && (T = s.axisDivisionFactor), l.sizePointNormalState && (T = Math.min(l.sizePointNormalState, s.axisDivisionFactor)));
    var k = !s.aggregationGroupWidth && !S && t.interval, O = Ene(s, T, d, this._getScreenDelta(), k), D = O(S, !0, p, m, (i = this._seriesData) === null || i === void 0 ? void 0 : i.breaks).tickInterval;
    if (s.type !== Dt.discrete) {
      var L = e ? d.min : p, F = e ? d.max : m;
      if (I(L) && I(F)) {
        var z = PM({
          base: s.logarithmBase,
          axisType: s.type,
          dataType: s.dataType
        }, !1), V = L, P = F;
        if (!e && I(D)) {
          var j = Math.max(this.calculateInterval(F, L), s.dataType === "datetime" ? Et.dateToMilliseconds(D) : D);
          V = z(L, j, -1), P = z(F, j);
        }
        V = V < d.min ? d.min : V, P = P > d.max ? d.max : P;
        var Z = this._getScaleBreaks(s, {
          minVisible: V,
          maxVisible: P
        }, this._series, this.isArgumentAxis), ee = this._filterBreaks(Z, {
          minVisible: V,
          maxVisible: P
        }, s.breakStyle);
        x = O(D, !1, V, P, ee).ticks;
      }
    }
    return this._aggregationInterval = D, {
      interval: D,
      ticks: x
    };
  },
  getTickInterval() {
    return this._tickInterval;
  },
  getAggregationInterval() {
    return this._aggregationInterval;
  },
  createTicks: function(e) {
    var t = this, r = t._renderer, n = t._options;
    if (e) {
      t._isSynchronized = !1, t.updateCanvas(e);
      var i = t._getViewportRange();
      t._initialBreaks = i.breaks = this._seriesData.breaks = t._filterBreaks(this._seriesData.userBreaks, i, n.breakStyle), t._estimatedTickInterval = t._getTicks(t.adjustViewport(this._seriesData), Y, !0).tickInterval;
      var s = this._calculateValueMargins();
      i.addRange({
        minVisible: s.minValue,
        maxVisible: s.maxValue,
        isSpacedMargin: s.isSpacedMargin
      });
      var l = t._createTicksAndLabelFormat(i), d = t._getBoundaryTicks(l.ticks, t._getViewportRange());
      n.showCustomBoundaryTicks && d.length ? (t._boundaryTicks = [d[0]].map(QB(t, r, !0)), d.length > 1 && (t._boundaryTicks = t._boundaryTicks.concat([d[1]].map(QB(t, r, !1))))) : t._boundaryTicks = [];
      var h = (l.minorTicks || []).filter(function(O) {
        return !d.some(function(D) {
          return qi(D) === qi(O);
        });
      });
      t._tickInterval = l.tickInterval, t._minorTickInterval = l.minorTickInterval;
      var p = t._majorTicks || [], m = p.reduce((O, D) => (O[D.value.valueOf()] = D, O), {}), x = Wa(l.ticks[0]) === Wa(p[0] && p[0].value), S = t._getSkippedCategory(l.ticks), T = l.ticks.map((O) => {
        var D = m[O.valueOf()];
        return D && x ? (delete m[O.valueOf()], D.setSkippedCategory(S), D) : KB(t, r, S)(O);
      });
      t._majorTicks = T;
      var k = t._minorTicks || [];
      t._minorTicks = h.map((O, D) => {
        var L = k[D];
        return L ? (L.updateValue(O), L) : ZB(t, r)(O);
      }), t._ticksToRemove = Object.keys(m).map((O) => m[O]).concat(k.slice(t._minorTicks.length, k.length)), t._ticksToRemove.forEach((O) => {
        var D;
        return (D = O.label) === null || D === void 0 ? void 0 : D.removeTitle();
      }), l.breaks && (t._seriesData.breaks = l.breaks), t._reinitTranslator(t._getViewportRange());
    }
  },
  _reinitTranslator: function(e) {
    var t = this._translator;
    this._isSynchronized || t.updateBusinessRange(e);
  },
  _getViewportRange() {
    return this.adjustViewport(this._seriesData);
  },
  setMarginOptions: function(e) {
    this._marginOptions = e;
  },
  getMarginOptions() {
    var e;
    return (e = this._marginOptions) !== null && e !== void 0 ? e : {};
  },
  _calculateRangeInterval: function(e) {
    var t = this._options.dataType === "datetime", r = [], n = function(i) {
      I(i) && r.push(t ? Et.dateToMilliseconds(i) : i);
    };
    return n(this._tickInterval), n(this._estimatedTickInterval), I(e) && r.push(e), n(this._aggregationInterval), this._calculateWorkWeekInterval(uC.apply(this, r));
  },
  _calculateWorkWeekInterval(e) {
    var t = this._options;
    if (t.dataType === "datetime" && t.workdaysOnly && e) {
      var r = t.workWeek.length * k_.day, n = k_.week - r;
      if (r !== e && n < e) {
        var i = Math.ceil(e / k_.week);
        e -= n * i;
      } else
        n >= e && e > k_.day && (e = k_.day);
    }
    return e;
  },
  _getConvertIntervalCoefficient(e, t) {
    var r = this._translator.ratioOfCanvasRange();
    return r / (r * t / (e + t));
  },
  _calculateValueMargins(e) {
    this._resetMargins();
    var t = this.getMarginOptions(), r = (t.size || 0) / 2, n = this._options, i = this._getViewportRange(), s = this.getViewport(), l = this._getScreenDelta(), d = (n.type || "").indexOf(Dt.discrete) !== -1, h = n.valueMarginsEnabled && !d && !this.customPositionIsBoundaryOrthogonalAxis(), p = this._translator, m = n.minValueMargin, x = n.maxValueMargin, S = 0, T = 0, k = 0, O;
    if (i.stubData || !l)
      return {
        startPadding: 0,
        endPadding: 0
      };
    if (this.isArgumentAxis && t.checkInterval) {
      O = this._calculateRangeInterval(i.interval);
      var D = p.getInterval(O);
      isFinite(D) ? k = Math.ceil(D / (2 * this._getConvertIntervalCoefficient(D, l))) : O = 0;
    }
    var L, F, z = l * bne / 2;
    h && (I(m) ? L = isFinite(m) ? m : 0 : !this.isArgumentAxis && t.checkInterval && qi(i.minVisible) > 0 && qi(i.minVisible) === qi(i.min) ? S = qB : (S = Math.max(r, k), S = Math.min(z, S)), I(x) ? F = isFinite(x) ? x : 0 : !this.isArgumentAxis && t.checkInterval && qi(i.maxVisible) < 0 && qi(i.maxVisible) === qi(i.max) ? T = qB : (T = Math.max(r, k), T = Math.min(z, T)));
    var V = t.percentStick && !this.isArgumentAxis;
    V && (Es(i.max) === 1 && (T = 0), Es(i.min) === 1 && (S = 0));
    var P = this._getCanvasStartEnd(), j = 1 + (L || 0) + (F || 0), Z = (l - S - T) / j || l;
    (L !== void 0 || F !== void 0) && (L !== void 0 && (S = Z * L), F !== void 0 && (T = Z * F));
    var ee, J;
    if (n.type !== Dt.discrete && e && e.length > 1 && !n.skipViewportExtending && !s.action && n.endOnTick !== !1) {
      var he = e.length, de = p.translate(e[0].value), Re = p.translate(e[he - 1].value), Ce = de > Re ? -1 : 1, le = bl(Ce * (P.start - de), 0), me = bl(Ce * (Re - P.end), 0);
      if (le > S || me > T) {
        var fe = me + le, Ee = this._getConvertIntervalCoefficient(fe, l);
        le >= S && (ee = e[0].value), me >= T && (J = e[he - 1].value), S = bl(le, S) / Ee, T = bl(me, T) / Ee;
      }
    }
    if (L = L === void 0 ? S / Z : L, F = F === void 0 ? T / Z : F, !d)
      if (this._translator.isInverted()) {
        var Q, pe;
        ee = (Q = ee) !== null && Q !== void 0 ? Q : p.from(P.start + l * L, -1), J = (pe = J) !== null && pe !== void 0 ? pe : p.from(P.end - l * F, 1);
      } else {
        var G, se;
        ee = (G = ee) !== null && G !== void 0 ? G : p.from(P.start - l * L, -1), J = (se = J) !== null && se !== void 0 ? se : p.from(P.end + l * F, 1);
      }
    var {
      correctedMin: Te,
      correctedMax: Pe,
      start: Ie,
      end: He
    } = this.getCorrectedValuesToZero(ee, J);
    return S = Ie ?? S, T = He ?? T, {
      startPadding: p.isInverted() ? T : S,
      endPadding: p.isInverted() ? S : T,
      minValue: Te ?? ee,
      maxValue: Pe ?? J,
      interval: O,
      isSpacedMargin: S === T && S !== 0
    };
  },
  getCorrectedValuesToZero(e, t) {
    var r = this, n = r._translator, i = r._getCanvasStartEnd(), s = r._getViewportRange(), l = r._getScreenDelta(), d = r._options, h, p, m, x, S = (T, k) => {
      var O = Es(i.start - T), D = Es(i.end - k), L = r._getConvertIntervalCoefficient(O + D, l);
      h = O / L, p = D / L;
    };
    return !r.isArgumentAxis && d.dataType !== "datetime" && (e * s.min <= 0 && e * s.minVisible <= 0 && (S(n.translate(0), n.translate(t)), m = 0), t * s.max <= 0 && t * s.maxVisible <= 0 && (S(n.translate(e), n.translate(0)), x = 0)), {
      start: isFinite(h) ? h : null,
      end: isFinite(p) ? p : null,
      correctedMin: m,
      correctedMax: x
    };
  },
  applyMargins() {
    if (!this._isSynchronized) {
      var e = this._calculateValueMargins(this._majorTicks), t = W({}, this._canvas, {
        startPadding: e.startPadding,
        endPadding: e.endPadding
      });
      if (this._translator.updateCanvas(this._processCanvas(t)), isFinite(e.interval)) {
        var r = this._translator.getBusinessRange();
        r.addRange({
          interval: e.interval
        }), this._translator.updateBusinessRange(r);
      }
    }
  },
  _resetMargins: function() {
    this._reinitTranslator(this._getViewportRange()), this._canvas && this._translator.updateCanvas(this._processCanvas(this._canvas));
  },
  _createConstantLines() {
    var e = (this._options.constantLines || []).map((t) => pne(this, t));
    this._outsideConstantLines = e.filter((t) => t.labelPosition === "outside"), this._insideConstantLines = e.filter((t) => t.labelPosition === "inside");
  },
  draw: function(e, t) {
    var r = this, n = this._options;
    r.borderOptions = t || {
      visible: !1
    }, r._resetMargins(), r.createTicks(e), r.applyMargins(), r._clearAxisGroups(), Up(r._majorTicks), Up(r._minorTicks), Up(r._boundaryTicks), r._axisGroup.append(r._axesContainerGroup), r._drawAxis(), r._drawTitle(), mk(r._majorTicks, n.tick), mk(r._minorTicks, n.minorTick), mk(r._boundaryTicks, n.tick);
    var i = r._getGridLineDrawer();
    JB(r._majorTicks, i), JB(r._minorTicks, i), nn(r._majorTicks, "drawLabel", r._getViewportRange(), r._getTemplate(n.label.template)), r._templatesRendered && r._templatesRendered.reject(), r._templatesRendered = new Yt(), r._majorTicks.forEach(function(l) {
      l.labelRotationAngle = 0, l.labelAlignment = void 0, l.labelOffset = 0;
    }), nn(r._outsideConstantLines.concat(r._insideConstantLines), "draw"), nn(r._strips, "draw"), r._dateMarkers = r._drawDateMarkers() || [], r._stripLabelAxesGroup && r._axisStripLabelGroup.append(r._stripLabelAxesGroup), r._gridContainerGroup && r._axisGridGroup.append(r._gridContainerGroup), r._stripsGroup && r._axisStripGroup.append(r._stripsGroup), r._labelsAxesGroup && r._axisElementsGroup.append(r._labelsAxesGroup), r._constantLinesGroup && (r._axisConstantLineGroups.above.inside.append(r._constantLinesGroup.above), r._axisConstantLineGroups.above.outside1.append(r._constantLinesGroup.above), r._axisConstantLineGroups.above.outside2.append(r._constantLinesGroup.above), r._axisConstantLineGroups.under.inside.append(r._constantLinesGroup.under), r._axisConstantLineGroups.under.outside1.append(r._constantLinesGroup.under), r._axisConstantLineGroups.under.outside2.append(r._constantLinesGroup.under)), r._measureTitle(), ch(r._majorTicks), !n.label.template && r._applyWordWrap(), ch(r._outsideConstantLines), ch(r._insideConstantLines), ch(r._strips), ch(r._dateMarkers), r._adjustConstantLineLabels(r._insideConstantLines), r._adjustStripLabels();
    var s = r._constantLabelOffset = r._adjustConstantLineLabels(r._outsideConstantLines);
    r._translator.getBusinessRange().isEmpty() || (r._setLabelsPlacement(), s = r._adjustLabels(s)), Ps.apply(this, r._majorTicks.map((l) => l.getTemplateDeferred())).done(() => {
      r._templatesRendered.resolve();
    }), s = r._adjustDateMarkers(s), r._adjustTitle(s);
  },
  getTemplatesDef() {
    return this._templatesRendered;
  },
  setRenderedState(e) {
    this._drawn = e;
  },
  isRendered() {
    return this._drawn;
  },
  _applyWordWrap() {
    var e, t, r, n = this._options, i = this._tickInterval;
    I(i) && (e = this.getTranslator().getInterval(n.dataType === "datetime" ? Et.dateToMilliseconds(i) : i));
    var s = this._validateDisplayMode(n.label.displayMode), l = this._validateOverlappingMode(n.label.overlappingBehavior, s), d = n.label.wordWrap || "none", h = n.label.textOverflow || "none";
    if ((d !== "none" || h !== "none") && s !== O_ && l !== O_ && l !== "auto") {
      var p = I(n.placeholderSize) ? n.placeholderSize - n.label.indentFromAxis : void 0;
      this._isHorizontal ? (t = e, r = p) : (t = p, r = e);
      var m = !1, x = !1;
      t && this._majorTicks.some((S) => S.labelBBox.width > t) && (m = !0), r && this._majorTicks.some((S) => S.labelBBox.height > r) && (x = !0), (m || x) && (this._majorTicks.forEach((S) => {
        S.label && S.label.setMaxSize(t, r, n.label);
      }), ch(this._majorTicks));
    }
  },
  _measureTitle: Y,
  animate() {
    nn(this._majorTicks, "animateLabels");
  },
  updateSize(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
    this.updateCanvas(e), r && (this._checkTitleOverflow(), this._measureTitle(), this._updateTitleCoords()), this._reinitTranslator(this._getViewportRange()), this.applyMargins();
    var n = !this._firstDrawing && t, i = this._options;
    Up(this._majorTicks), Up(this._minorTicks), Up(this._boundaryTicks), this._resetApplyingAnimation && !this._firstDrawing && this._resetStartCoordinates(), yk(this._majorTicks), yk(this._minorTicks), yk(this._boundaryTicks), this._axisElement && this._updateAxisElementPosition(), _k(this._majorTicks, i.tick, n), _k(this._minorTicks, i.minorTick, n), _k(this._boundaryTicks, i.tick), nn(this._majorTicks, "updateLabelPosition", n), this._outsideConstantLines.concat(this._insideConstantLines || []).forEach((s) => s.updatePosition(n)), nn(this._strips, "updatePosition", n), e2(this._majorTicks, n), e2(this._minorTicks, n), n && nn(this._ticksToRemove || [], "fadeOutElements"), this.prepareAnimation(), this._ticksToRemove = null, this._translator.getBusinessRange().isEmpty() || (this._firstDrawing = !1), this._resetApplyingAnimation = !1, this._updateLabelsPosition();
  },
  _updateLabelsPosition: Y,
  prepareAnimation() {
    var e = "saveCoords";
    nn(this._majorTicks, e), nn(this._minorTicks, e), nn(this._insideConstantLines, e), nn(this._outsideConstantLines, e), nn(this._strips, e);
  },
  _resetStartCoordinates() {
    var e = "resetCoordinates";
    nn(this._majorTicks, e), nn(this._minorTicks, e), nn(this._insideConstantLines, e), nn(this._outsideConstantLines, e), nn(this._strips, e);
  },
  applyClipRects: function(e, t) {
    this._axisGroup.attr({
      "clip-path": t
    }), this._axisStripGroup.attr({
      "clip-path": e
    }), this._axisElementsGroup.attr({
      "clip-path": t
    });
  },
  _validateVisualRange(e) {
    var t = bd(e);
    return t.startValue !== void 0 && (t.startValue = this.validateUnit(t.startValue)), t.endValue !== void 0 && (t.endValue = this.validateUnit(t.endValue)), LM(t, !WB(e));
  },
  _validateOptions(e) {
    e.wholeRange = this._validateVisualRange(e.wholeRange), e.visualRange = e._customVisualRange = this._validateVisualRange(e._customVisualRange), this._setVisualRange(e._customVisualRange);
  },
  validate() {
    var e = this._options, t = this.isArgumentAxis ? e.argumentType : e.valueType, r = t ? cU(t) : function(n) {
      return n;
    };
    this.parser = r, e.dataType = t, this._validateOptions(e);
  },
  resetVisualRange(e) {
    this._seriesData.minVisible = this._seriesData.min, this._seriesData.maxVisible = this._seriesData.max, this.handleZooming([null, null], {
      start: !!e,
      end: !!e
    });
  },
  _setVisualRange(e, t) {
    var r = this.adjustRange(bd(e));
    t ? (I(r.startValue) && (this._viewport.startValue = r.startValue), I(r.endValue) && (this._viewport.endValue = r.endValue)) : this._viewport = r;
  },
  _applyZooming(e, t) {
    this._resetVisualRangeOption(), this._setVisualRange(e, t);
    var r = this.getViewport();
    this._seriesData.userBreaks = this._getScaleBreaks(this._options, {
      minVisible: r.startValue,
      maxVisible: r.endValue
    }, this._series, this.isArgumentAxis), this._translator.updateBusinessRange(this._getViewportRange());
  },
  getZoomStartEventArg(e, t) {
    return {
      axis: this,
      range: this.visualRange(),
      cancel: !1,
      event: e,
      actionType: t
    };
  },
  _getZoomEndEventArg(e, t, r, n, i) {
    var s = this.visualRange();
    return {
      axis: this,
      previousRange: e,
      range: s,
      cancel: !1,
      event: t,
      actionType: r,
      zoomFactor: n,
      shift: i,
      rangeStart: s.startValue,
      rangeEnd: s.endValue
    };
  },
  getZoomBounds() {
    var e = bd(this._options.wholeRange), t = this.getTranslator().getBusinessRange(), r = {
      startValue: cC(this._initRange.startValue, t.min),
      endValue: cC(this._initRange.endValue, t.max)
    };
    return {
      startValue: cC(e.startValue, r.startValue),
      endValue: cC(e.endValue, r.endValue)
    };
  },
  setInitRange() {
    this._initRange = {}, Object.keys(this._options.wholeRange || {}).length === 0 && (this._initRange = this.getZoomBounds());
  },
  _resetVisualRangeOption() {
    this._options._customVisualRange = {};
  },
  getTemplatesGroups() {
    var e = this._majorTicks;
    return e ? this._majorTicks.map((t) => t.templateContainer).filter((t) => I(t)) : [];
  },
  setCustomVisualRange(e) {
    this._options._customVisualRange = e;
  },
  visualRange() {
    var e = arguments, t;
    if (e.length === 0) {
      var r = this._getAdjustedBusinessRange(), n = r.minVisible, i = r.maxVisible;
      if (this._options.type === Dt.discrete) {
        var s, l;
        return n = (s = n) !== null && s !== void 0 ? s : r.categories[0], i = (l = i) !== null && l !== void 0 ? l : r.categories[r.categories.length - 1], {
          startValue: n,
          endValue: i,
          categories: Xu(r.categories, n, i).categories
        };
      }
      return {
        startValue: n,
        endValue: i
      };
    } else
      WB(e[0]) ? t = e[0] : Qr(e[0]) ? t = W({}, e[0]) : t = [e[0], e[1]];
    var d = this.handleZooming(t, e[1]);
    d.isPrevented || this._visualRange(this, d);
  },
  handleZooming(e, t, r, n) {
    t = t || {}, I(e) && (e = this._validateVisualRange(e), e.action = n);
    var i = this.getZoomStartEventArg(r, n), s = i.range;
    !t.start && this._eventTrigger("zoomStart", i);
    var l = {
      isPrevented: i.cancel,
      skipEventRising: t.skipEventRising,
      range: e || i.range
    };
    return i.cancel || (I(e) && this._applyZooming(e, t.allowPartialUpdate), I(this._storedZoomEndParams) || (this._storedZoomEndParams = {
      startRange: s,
      type: this.getOptions().type
    }), this._storedZoomEndParams.event = r, this._storedZoomEndParams.action = n, this._storedZoomEndParams.prevent = !!t.end), l;
  },
  handleZoomEnd() {
    if (I(this._storedZoomEndParams) && !this._storedZoomEndParams.prevent) {
      var e = this._storedZoomEndParams.startRange, t = this._storedZoomEndParams.event, r = this._storedZoomEndParams.action, n = {
        minVisible: e.startValue,
        maxVisible: e.endValue,
        categories: e.categories
      }, i = this.getOptions().type === this._storedZoomEndParams.type, s = i ? rr(this.getVisualRangeCenter() - this.getVisualRangeCenter(n, !1)) : NaN, l = i ? +(Math.round(this.getVisualRangeLength(n) / (this.getVisualRangeLength() || 1) + "e+2") + "e-2") : NaN, d = this._getZoomEndEventArg(e, t, r, l, s);
      d.cancel = this.checkZoomingLowerLimitOvercome(l === 1 ? "pan" : "zoom", l).stopInteraction, this._eventTrigger("zoomEnd", d), d.cancel && this._restorePreviousVisualRange(e), this._storedZoomEndParams = null;
    }
  },
  _restorePreviousVisualRange(e) {
    this._storedZoomEndParams = null, this._applyZooming(e), this._visualRange(this, e);
  },
  checkZoomingLowerLimitOvercome(e, t, r) {
    var n = this._options, i = this._translator, s = n.minVisualRangeLength, l = r, d, h = e === "zoom" && t >= 1, p = i.getBusinessRange();
    r && (d = this.adjustRange(bd(r)), d = {
      minVisible: d.startValue,
      maxVisible: d.endValue,
      categories: p.categories
    });
    var m = this.getVisualRangeLength(p), x = this.getVisualRangeLength(d);
    if (I(s) || n.type === "discrete")
      s = i.convert(s), d && s < m && s >= x ? (l = bd(i.getRangeByMinZoomValue(s, d)), h = !1) : h &= s > x;
    else {
      var S = this._translator.canvasLength, T = {
        minVisible: p.min,
        maxVisible: p.max,
        categories: p.categories
      };
      h &= this.getVisualRangeLength(T) / S >= x;
    }
    return {
      stopInteraction: !!h,
      correctedRange: l
    };
  },
  isExtremePosition(e) {
    var t, r;
    this._options.type === "discrete" ? (r = this._translator.getBusinessRange(), t = e ? r.categories[r.categories.length - 1] : r.categories[0]) : (r = this.getZoomBounds(), t = e ? r.endValue : r.startValue);
    var n = this.getTranslator(), i = n.translate(t), s = this.visualRange(), l = e ? n.translate(s.endValue) : n.translate(s.startValue);
    return Es(l - i) < xne;
  },
  getViewport() {
    return this._viewport;
  },
  getFullTicks: function() {
    var e = this._majorTicks || [];
    return this._options.type === Dt.discrete ? Gp(e) : Gp(e.concat(this._minorTicks, this._boundaryTicks)).sort(function(t, r) {
      return qi(t) - qi(r);
    });
  },
  measureLabels: function(e, t) {
    var r = this, n = r._options, i = n.visible ? n.width : 0, s, l = t ? n.label.indentFromAxis + 0.5 * n.tick.length : 0, d, h = r._getViewportRange();
    if (h.isEmpty() || !n.label.visible || !r._axisElementsGroup)
      return {
        height: i,
        width: i,
        x: 0,
        y: 0
      };
    r._majorTicks ? s = Gp(r._majorTicks) : (r.updateCanvas(e), s = r._createTicksAndLabelFormat(h, Y), d = s.tickInterval, s = s.ticks);
    var p = s.reduce(function(S, T, k) {
      var O = r.formatLabel(T, n.label, h, void 0, d, s);
      return S.length < O.length ? O : S;
    }, r.formatLabel(s[0], n.label, h, void 0, d, s)), m = r._renderer.text(p, 0, 0).css(r._textFontStyles).attr(r._textOptions).append(r._renderer.root), x = m.getBBox();
    return m.remove(), {
      x: x.x,
      y: x.y,
      width: x.width + l,
      height: x.height + l
    };
  },
  _setLabelsPlacement: function() {
    if (this._options.label.visible) {
      var e = this._options.label, t = this._validateDisplayMode(e.displayMode), r = this._validateOverlappingMode(e.overlappingBehavior, t), n = r === "none" || r === "ignore", i = {
        rotationAngle: e.rotationAngle,
        staggeringSpacing: e.staggeringSpacing
      }, s, l = this._majorTicks.map(function(h) {
        return h.labelBBox;
      }), d = this._getStep(l);
      switch (t) {
        case O_:
          n && (s = !0, d = 1), this._applyLabelMode(t, d, l, e, s);
          break;
        case "stagger":
          n && (d = 2), this._applyLabelMode(t, bl(d, 2), l, e);
          break;
        default:
          this._applyLabelOverlapping(l, r, d, i);
      }
    }
  },
  _applyLabelOverlapping: function(e, t, r, n) {
    var i = this._options.label, s = this._majorTicks;
    t === "none" || t === "ignore" || (r > 1 && e.some(function(l, d, h) {
      return d === 0 ? !1 : Dt.areLabelsOverlap(l, h[d - 1], i.minSpacing, i.alignment);
    }) && this._applyLabelMode(t, r, e, n), this._checkBoundedLabelsOverlapping(s, e, t), this._checkShiftedLabels(s, e, i.minSpacing, i.alignment));
  },
  _applyLabelMode: function(e, t, r, n, i) {
    var s = this._majorTicks, l = this._options.label, d = n.rotationAngle, h, p, m;
    switch (e) {
      case O_:
        l.userAlignment || (p = d < 0 ? ks : Vo, d % 90 === 0 && (p = Tg)), t = i ? t : this._getStep(r, d), m = function(x) {
          var S = x.getContentContainer();
          S && (S.rotate(d), x.labelRotationAngle = d, p && (x.labelAlignment = p));
        }, xk(s, t, m);
        break;
      case "stagger":
        h = this._getMaxLabelHeight(r, n.staggeringSpacing), m = function(x, S) {
          S / (t - 1) % 2 !== 0 && (x.labelOffset = h);
        }, xk(s, t - 1, m);
        break;
      case "auto":
      case "_auto":
        t === 2 ? this._applyLabelMode("stagger", t, r, n) : this._applyLabelMode(O_, t, r, {
          rotationAngle: Cne(r, l)
        });
        break;
      default:
        xk(s, t);
    }
  },
  getMarkerTrackers: Y,
  _drawDateMarkers: Y,
  _adjustDateMarkers: Y,
  coordsIn: Y,
  areCoordsOutsideAxis: Y,
  _getSkippedCategory: Y,
  _initAxisPositions: Y,
  _drawTitle: Y,
  _updateTitleCoords: Y,
  _adjustConstantLineLabels: Y,
  _createTranslator: function() {
    return new PE({}, {}, {});
  },
  _updateTranslator: function() {
    var e = this._translator;
    e.update(e.getBusinessRange(), this._canvas || {}, this._getTranslatorOptions());
  },
  _getTranslatorOptions: function() {
    var e, t, r, n = this._options;
    return {
      isHorizontal: this._isHorizontal,
      shiftZeroValue: !this.isArgumentAxis,
      interval: n.semiDiscreteInterval,
      firstDayOfWeek: (e = n.workWeek) === null || e === void 0 ? void 0 : e[0],
      stick: this._getStick(),
      breaksSize: (t = (r = n.breakStyle) === null || r === void 0 ? void 0 : r.width) !== null && t !== void 0 ? t : 0
    };
  },
  getVisibleArea() {
    var e = this._getCanvasStartEnd();
    return [e.start, e.end].sort((t, r) => t - r);
  },
  _getCanvasStartEnd: function() {
    var e = this._isHorizontal, t = this._canvas || {}, r = this._translator.getBusinessRange().invert, n = e ? [t.left, t.width - t.right] : [t.height - t.bottom, t.top];
    return r && n.reverse(), {
      start: n[0],
      end: n[1]
    };
  },
  _getScreenDelta: function() {
    var e = this._getCanvasStartEnd(), t = this._seriesData ? this._seriesData.breaks || [] : [], r = t.length, n = Es(e.start - e.end);
    return n - (r ? t[r - 1].cumulativeWidth : 0);
  },
  _getScaleBreaks: function() {
    return [];
  },
  _filterBreaks: function() {
    return [];
  },
  _adjustTitle: Y,
  _checkTitleOverflow: Y,
  getSpiderTicks: Y,
  setSpiderTicks: Y,
  _checkBoundedLabelsOverlapping: Y,
  _checkShiftedLabels: Y,
  drawScaleBreaks: Y,
  _visualRange: Y,
  _rotateConstantLine: Y,
  applyVisualRangeSetter(e) {
    this._visualRange = e;
  },
  getCategoriesSorter(e) {
    var t;
    if (this.isArgumentAxis)
      t = e;
    else {
      var r = this._options.categoriesSortingMethod;
      t = r ?? this._options.categories;
    }
    return t;
  },
  _getAdjustedBusinessRange() {
    return this.adjustViewport(this._translator.getBusinessRange());
  }
};
var {
  round: ph,
  abs: xD,
  pow: r2,
  sqrt: Ane
} = Math, OU = Math.min, One = 0.3;
function kne(e) {
  return e < 0 || e > 1 ? void 0 : e;
}
function Rne(e) {
  return e < 0 || e > 1 ? One : e;
}
function Dne(e, t) {
  return e.some(function(r) {
    return !r.getOptions().ignoreEmptyPoints || r.getPointsByArg(t, !0).some(function(n) {
      return n.hasValue();
    });
  });
}
function Mne(e, t, r, n, i, s, l) {
  e.forEach(function(d) {
    var h = l(t.indexOf(n), t.length), p = d.getPointsByArg(r, !0), m = kne(d.getOptions().barPadding), x = d.getOptions().barWidth, S = n2(h, i), T = i.width, k;
    h !== -1 && ((I(m) || I(x)) && (k = RU(s, t.length, 1 - m, x), T = k.width, d.getBarOverlapGroup() || (S = n2(h, k))), Lne(p, T, S));
  });
}
function bD(e) {
  return e.getStackName() || e.getBarOverlapGroup();
}
function kU(e, t, r) {
  var n, i, s = [], l = [], d = {}, h = t.barGroupWidth, p = (n = e[0]) === null || n === void 0 ? void 0 : n.getArgumentAxis(), m;
  if ((i = e[0]) !== null && i !== void 0 && i.useAggregation()) {
    var x, S = ((x = e[0]) === null || x === void 0 ? void 0 : x.argumentType) === "datetime", T = p.getTickInterval(), k = p.getAggregationInterval();
    T = S ? Et.dateToMilliseconds(T) : T, k = S ? Et.dateToMilliseconds(k) : k, m = k < T ? k : T;
  }
  m = p == null ? void 0 : p.getTranslator().getInterval(m);
  var O = h ? m > h ? h : m : m * (1 - Rne(t.barGroupPadding));
  e.forEach(function(D, L) {
    var F = bD(D) || L.toString(), z;
    for (z in D.pointsByArgument)
      l.indexOf(z.valueOf()) === -1 && l.push(z.valueOf());
    s.indexOf(F) === -1 && (s.push(F), d[F] = []), d[F].push(D);
  }), l.forEach(function(D) {
    var L = s.reduce((z, V) => (Dne(d[V], D) && z.push(V), z), []), F = RU(O, L.length);
    s.forEach((z) => {
      Mne(d[z], L, D, z, F, O, r);
    });
  });
}
function RU(e, t, r, n) {
  var i, s;
  return n ? (s = OU(n, e / t), i = t > 1 ? ph((e - ph(s) * t) / (t - 1)) : 0) : I(r) ? (s = e * r / t, i = t > 1 ? ph((e - e * r) / (t - 1)) : 0) : (i = ph(e / t * 0.2), s = (e - i * (t - 1)) / t), {
    width: s > 1 ? ph(s) : 1,
    spacing: i,
    middleIndex: t / 2,
    rawWidth: s
  };
}
function n2(e, t) {
  var r = t.rawWidth < 1 ? t.rawWidth : t.width;
  return (e - t.middleIndex + 0.5) * r - (t.middleIndex - e - 0.5) * t.spacing;
}
function Lne(e, t, r) {
  be(e, function(n, i) {
    i.correctCoordinates({
      width: t,
      offset: r
    });
  });
}
function Pne(e) {
  return e >= 0 ? "positive" : "negative";
}
function jg(e) {
  return e.series.filter(function(t) {
    return t.isVisible();
  });
}
function fL(e, t, r) {
  var n = (e.positive[t] || {})[r] || 0, i = -(e.negative[t] || {})[r] || 0;
  return n + i;
}
function Ine(e, t, r) {
  var n = (e.positive[t] || {})[r] || 0, i = (e.negative[t] || {})[r] || 0;
  return n + i;
}
function DU(e) {
  return e ? function(t, r) {
    return r - t - 1;
  } : function(t) {
    return t;
  };
}
function MU(e) {
  return e[0] && e[0].getArgumentAxis().getTranslator().isInverted();
}
function dC() {
  var e = jg(this);
  kU(e, this._options, DU(MU(e)));
}
function Nne(e) {
  for (var t = e.getPoints(), r, n = 0; n < t.length; n++) {
    var i = t[n];
    if (r = i.initialValue && i.initialValue.valueOf(), xD(r) > 0)
      break;
  }
  return Hd(r);
}
function R_() {
  var e = this._options.negativesAsZeroes, t = jg(this), r = {
    positive: {},
    negative: {}
  }, n = {
    left: {},
    right: {}
  }, i = {}, s = {};
  t.forEach(function(l) {
    var d = bD(l), h = !1, p = Nne(l) < 0 ? s : i;
    l._prevSeries = p[d], p[d] = l, l.holes = W(!0, {}, n), l.getPoints().forEach(function(m, x, S) {
      var T = m.initialValue && m.initialValue.valueOf(), k = m.argument.valueOf(), O = T >= 0 ? r.positive : r.negative, D = l.type !== "bar";
      e && T < 0 && (O = r.positive, T = 0, m.resetValue()), O[d] = O[d] || {};
      var L = O[d];
      if (L[k] ? (D && m.correctValue(L[k]), L[k] += T) : (L[k] = T, D && m.resetCorrection()), m.hasValue())
        h && (h = !1, n.left[k] = (n.left[k] || 0) + (m.value.valueOf() - (isFinite(m.minValue) ? m.minValue.valueOf() : 0)), m._skipSetLeftHole = !0);
      else {
        var F = S[x - 1];
        !h && F && F.hasValue() && (k = F.argument.valueOf(), F._skipSetRightHole = !0, n.right[k] = (n.right[k] || 0) + (F.value.valueOf() - (isFinite(F.minValue) ? F.minValue.valueOf() : 0))), h = !0;
      }
    });
  }), t.forEach(function(l) {
    var d = l.holes;
    l.getPoints().forEach(function(h) {
      var p = h.argument.valueOf();
      h.resetHoles(), !h._skipSetLeftHole && h.setHole(d.left[p] || n.left[p] && 0, "left"), !h._skipSetRightHole && h.setHole(d.right[p] || n.right[p] && 0, "right"), h._skipSetLeftHole = null, h._skipSetRightHole = null;
    });
  }), this._stackKeepers = r, t.forEach(function(l) {
    l.getPoints().forEach(function(d) {
      var h = d.argument.valueOf(), p = bD(l), m = fL(r, p, h), x = Ine(r, p, h);
      d.setPercentValue(m, x, n.left[h], n.right[h]);
    });
  });
}
function i2() {
  var e = this, t = jg(e), r = e._stackKeepers, n = {
    positive: {},
    negative: {}
  };
  be(t, function(i, s) {
    var l = s.getOptions().minBarSize, d = s.getValueAxis().getTranslator(), h = l && d.getMinBarSize(l), p = s.getStackName();
    be(s.getPoints(), function(m, x) {
      if (x.hasValue()) {
        var S = x.initialValue && x.initialValue.valueOf(), T = x.argument.valueOf();
        e.fullStacked && (S = S / fL(r, p, T) || 0);
        var k = d.checkMinBarSize(S, h, x.value), O = Pne(k), D = n[O][p] = n[O][p] || {};
        D[T] ? (x.minValue = D[T], D[T] += k) : D[T] = k, x.value = D[T];
      }
    });
  }), e.fullStacked && Vne(t, n);
}
function Vne(e, t) {
  be(e, function(r, n) {
    var i = n.getStackName ? n.getStackName() : "default";
    be(n.getPoints(), function(s, l) {
      var d = fL(t, i, l.argument.valueOf());
      d !== 0 && (l.value = l.value / d, Sr(l.minValue) && (l.minValue = l.minValue / d));
    });
  });
}
function Fne() {
  var e = jg(this);
  be(e, function(t, r) {
    var n = r.getOptions().minBarSize, i = r.getValueAxis().getTranslator(), s = n && i.getMinBarSize(n);
    s && be(r.getPoints(), function(l, d) {
      d.hasValue() && d.value.valueOf() - d.minValue.valueOf() < s && (d.value = d.value.valueOf() + s / 2, d.minValue = d.minValue.valueOf() - s / 2);
    });
  });
}
function Bne() {
  be(this.series, function(e, t) {
    var r = t.getOptions().minBarSize, n = t.getValueAxis().getTranslator(), i = r && n.getMinBarSize(r);
    i && be(t.getPoints(), function(s, l) {
      l.hasValue() && (l.value = n.checkMinBarSize(l.initialValue, i));
    });
  });
}
function zne() {
  var e = jg(this);
  kU(e, {
    barGroupPadding: 0.3
  }, DU(MU(e)));
}
function Hne() {
  var e = jg(this);
  if (e.length) {
    var t = this._options, r = e[0].getArgumentAxis().getVisibleArea(), n = e[0].getValueAxis().getVisibleArea(), i = OU(r[1] - r[0], n[1] - n[0]), s = r2(t.minBubbleSize, 2), l = r2(i * t.maxBubbleSize, 2), d = (i * t.maxBubbleSize + t.minBubbleSize) / 2, h = 1 / 0, p = -1 / 0, m, x, S;
    be(e, function(O, D) {
      be(D.getPoints(), function(L, F) {
        p = p > F.size ? p : F.size, h = h < F.size ? h : F.size;
      });
    });
    var T = p - h, k = xD(l - s);
    be(e, function(O, D) {
      be(D.getPoints(), function(L, F) {
        p === h ? m = ph(d) : (S = xD(F.size - h) / T, x = k * S + s, m = ph(Ane(x))), F.correctCoordinates(m);
      });
    });
  }
}
function SD(e) {
  switch (this.type = Wt(e.type), this.pane = e.pane, this.series = [], this.updateOptions(e), this.type) {
    case "bar":
      this.adjustSeriesDimensions = dC, this.updateSeriesValues = Bne, this.adjustSeriesValues = R_;
      break;
    case "rangebar":
      this.adjustSeriesDimensions = dC, this.updateSeriesValues = Fne;
      break;
    case "fullstackedbar":
      this.fullStacked = !0, this.adjustSeriesDimensions = dC, this.adjustSeriesValues = R_, this.updateSeriesValues = i2;
      break;
    case "stackedbar":
      this.adjustSeriesDimensions = dC, this.adjustSeriesValues = R_, this.updateSeriesValues = i2;
      break;
    case "fullstackedarea":
    case "fullstackedline":
    case "fullstackedspline":
    case "fullstackedsplinearea":
      this.fullStacked = !0, this.adjustSeriesValues = R_;
      break;
    case "stackedarea":
    case "stackedsplinearea":
    case "stackedline":
    case "stackedspline":
      this.adjustSeriesValues = R_;
      break;
    case "candlestick":
    case "stock":
      this.adjustSeriesDimensions = zne;
      break;
    case "bubble":
      this.adjustSeriesDimensions = Hne;
  }
}
SD.prototype = {
  constructor: SD,
  adjustSeriesDimensions: Y,
  adjustSeriesValues: Y,
  updateSeriesValues: Y,
  updateOptions: function(e) {
    this._options = e;
  },
  dispose: function() {
    this.series = null;
  },
  add: function(e) {
    var t = this.type;
    this.series = ti(e, (r) => r.type === t ? r : null);
  }
};
function LU(e) {
  return e && [e.target, e.delegateTarget, e.relatedTarget, e.currentTarget].filter((t) => !!t);
}
var Gne = (e, t) => {
  Ve.one(LU(e), My, t);
}, Une = (e, t) => {
  Ve.off(LU(e), My, t);
}, hL = "dxclick";
var CD = null, j_ = null, a2 = () => {
  j_ = null;
}, o2 = function(e) {
  var t = e.originalEvent, r = j_ === t || t && t.DXCLICK_FIRED, n = !e.which || e.which === 1;
  n && !CD && !r && (t && (t.DXCLICK_FIRED = !0), Une(j_, a2), j_ = t, Gne(j_, a2), Ku({
    type: hL,
    originalEvent: e
  }));
}, jne = BM.inherit({
  ctor: function(e) {
    this.callBase(e), Ve.on(this.getElement(), "click", o2);
  },
  start: function(e) {
    CD = null;
  },
  cancel: function() {
    CD = !0;
  },
  dispose: function() {
    Ve.off(this.getElement(), "click", o2);
  }
});
(function() {
  var e = qa.real().generic;
  if (!e) {
    var t = null, r = !1, n = we.getDocument();
    Ve.subscribeGlobal(n, En(dn.down, "NATIVE_CLICK_FIXER"), function(i) {
      t = i.target, r = i.isDefaultPrevented();
    }), Ve.subscribeGlobal(n, En("click", "NATIVE_CLICK_FIXER"), function(i) {
      var s = je(i.target);
      !r && t && !s.is(t) && !je(t).is("label") && (l = s, je(l).is("input, textarea, select, button ,:focus, :focus *")) && r3();
      var l;
      t = null, r = !1;
    });
  }
})();
jM({
  emitter: jne,
  bubble: !0,
  events: [hL]
});
var jp = Math.floor, s2 = Is.events, PU = Is.states, $ne = PU.hoverMark, Yne = PU.normalMark, mg = "dxChartTracker", fC = "." + mg, bk = En([dn.down, dn.move], mg), IU = "legendClick", ED = "seriesClick", NU = "pointClick", l2 = "chart-data-point", Sk = "chart-data-series", VU = "chart-data-argument", Wne = 100, Xne = 300, FU = "none", BU = "allargumentpoints", zU = "includepoints", qne = "excludepoints", Kne = [zU, qne, FU];
function dh(e, t, r) {
  var n = e.target;
  if (n.tagName === "tspan")
    return n.parentNode[t];
  var i = n[t];
  return r && !I(i) ? function s(l) {
    if (l.parentNode)
      return I(l.parentNode[t]) ? l.parentNode[t] : s(l.parentNode);
  }(n) : i;
}
function HU(e, t, r) {
  var {
    event: n,
    cancel: i
  } = e, s = n.cancel, l = i || s;
  return s && Dr.log("W0003", "".concat(r, "Click handler argument"), "event.cancel", "22.1", "Use the 'cancel' field instead"), l || !t.getOptions();
}
function Zne(e) {
  return Kne.indexOf(e) > -1 ? e : zU;
}
function GU(e) {
  var t = e.getOptions().hoverMode;
  return t === FU ? t : BU;
}
var Bu = {
  ctor: function(e) {
    var t = this, r = {
      tracker: t
    };
    t._renderer = e.renderer, t._legend = e.legend, t._tooltip = e.tooltip, t._eventTrigger = e.eventTrigger, t._seriesGroup = e.seriesGroup, e.seriesGroup.off(fC).on(En(s2.showPointTooltip, mg), r, t._showPointTooltip).on(En(s2.hidePointTooltip, mg), r, t._hidePointTooltip), t._renderer.root.off(fC).on(bk, r, t._pointerHandler).on(En(dn.up, mg), () => clearTimeout(t._holdTimer)).on(En(hL, mg), r, t._clickHandler);
  },
  update: function(e) {
    this._chart = e.chart;
  },
  updateSeries(e, t) {
    var r = this, n = !(e != null && e.some((i) => i === r.hoveredSeries) || r._hoveredPoint && r._hoveredPoint.series);
    r._storedSeries !== e && (r._storedSeries = e || []), n && (r._clean(), r._renderer.initDefsElements()), t && (r.clearSelection(), n || (r._hideTooltip(r.pointAtShownTooltip), r.clearHover()));
  },
  setCanvases: function(e, t) {
    this._mainCanvas = e, this._canvases = t;
  },
  repairTooltip: function() {
    var e = this.pointAtShownTooltip;
    !e || !e.series || !e.isVisible() ? this._hideTooltip(e, !0) : this._showTooltip(e);
  },
  _setHoveredPoint: function(e) {
    e !== this._hoveredPoint && (this._releaseHoveredPoint(), e.hover(), this._hoveredPoint = e);
  },
  _releaseHoveredPoint: function(e) {
    this._hoveredPoint && this._hoveredPoint.getOptions() && (this._hoveredPoint.clearHover(), this._hoveredPoint = null, this._tooltip.isEnabled() && this._hideTooltip(this._hoveredPoint, !1, e));
  },
  _setHoveredSeries: function(e, t) {
    this._releaseHoveredSeries(), this._releaseHoveredPoint(), e.hover(t), this.hoveredSeries = e;
  },
  _releaseHoveredSeries() {
    this.hoveredSeries && (this.hoveredSeries.clearHover(), this.hoveredSeries = null);
  },
  clearSelection() {
    this._storedSeries.forEach((e) => {
      e && (e.clearSelection(), e.getPoints().forEach((t) => t.clearSelection()));
    });
  },
  _clean: function() {
    this.hoveredPoint = this.hoveredSeries = this._hoveredArgumentPoints = null, this._hideTooltip(this.pointAtShownTooltip);
  },
  clearHover: function(e) {
    this._resetHoveredArgument(), this._releaseHoveredSeries(), this._releaseHoveredPoint(e);
  },
  _hideTooltip: function(e, t, r) {
    !this._tooltip || e && this.pointAtShownTooltip !== e || (!t && this.pointAtShownTooltip && (this.pointAtShownTooltip = null), this._tooltip.hide(!!r));
  },
  _showTooltip: function(e) {
    var t = this, r, n = {
      target: e
    };
    if (e != null && e.getOptions()) {
      if (r = e.getTooltipFormatObject(t._tooltip, t._tooltip.isShared() && t._chart.getStackedPoints(e)), !I(r.valueText) && !r.points || !e.isVisible())
        return;
      var i = e.getTooltipParams(t._tooltip.getLocation()), s = t._renderer.getRootOffset();
      i.x += s.left, i.y += s.top;
      var l = (d) => {
        d && (t.pointAtShownTooltip = e);
      };
      l(t._tooltip.show(r, i, n, void 0, l));
    }
  },
  _showPointTooltip: function(e, t) {
    var r = e.data.tracker, n = r.pointAtShownTooltip;
    n && n !== t && r._hideTooltip(n), r._showTooltip(t);
  },
  _hidePointTooltip: function(e, t) {
    e.data.tracker._hideTooltip(t, !1, !0);
  },
  _enableOutHandler: function() {
    if (!this._outHandler) {
      var e = this, t = function(r) {
        var n = e._renderer.getRootOffset(), i = jp(r.pageX - n.left), s = jp(r.pageY - n.top);
        !UG(e._mainCanvas, i, s) && !e._isCursorOnTooltip(r) && (e._pointerOut(), e._disableOutHandler());
      };
      Ve.on(we.getDocument(), bk, t), this._outHandler = t;
    }
  },
  _isCursorOnTooltip: function(e) {
    return this._tooltip.isEnabled() && this._tooltip.isCursorOnTooltip(e.pageX, e.pageY);
  },
  _disableOutHandler: function() {
    this._outHandler && Ve.off(we.getDocument(), bk, this._outHandler), this._outHandler = null;
  },
  stopCurrentHandling: function() {
    this._pointerOut(!0);
  },
  _pointerOut: function(e) {
    this.clearHover(!0), (e || this._tooltip.isEnabled()) && this._hideTooltip(this.pointAtShownTooltip, !1, !0);
  },
  _triggerLegendClick: function(e, t) {
    var r = this._eventTrigger;
    r(IU, e, function() {
      !HU(e, e.target, "legend") && r(t, e);
    });
  },
  _hoverLegendItem: function(e, t) {
    var r = this._legend.getItemByCoord(e, t), n, i = Zne(this._legend.getOptions().hoverMode);
    r ? (n = this._storedSeries[r.id], (!n.isHovered() || n.lastHoverMode !== i) && this._setHoveredSeries(n, i), this._tooltip.isEnabled() && this._hideTooltip(this.pointAtShownTooltip)) : this.clearHover();
  },
  _hoverArgument: function(e, t) {
    var r = this._getArgumentHoverMode();
    I(e) && (this._releaseHoveredPoint(), this._hoveredArgument = e, this._argumentIndex = t, this._notifySeries({
      action: "pointHover",
      notifyLegend: this._notifyLegendOnHoverArgument,
      target: {
        argument: e,
        fullState: $ne,
        argumentIndex: t,
        getOptions: function() {
          return {
            hoverMode: r
          };
        }
      }
    }));
  },
  _resetHoveredArgument: function() {
    var e;
    I(this._hoveredArgument) && (e = this._getArgumentHoverMode(), this._notifySeries({
      action: "clearPointHover",
      notifyLegend: this._notifyLegendOnHoverArgument,
      target: {
        fullState: Yne,
        argumentIndex: this._argumentIndex,
        argument: this._hoveredArgument,
        getOptions: function() {
          return {
            hoverMode: e
          };
        }
      }
    }), this._hoveredArgument = null);
  },
  _notifySeries: function(e) {
    this._storedSeries.forEach(function(t) {
      t.notify(e);
    });
  },
  _pointerHandler: function(e) {
    var t, r = e.data.tracker, n = r._renderer.getRootOffset(), i = jp(e.pageX - n.left), s = jp(e.pageY - n.top), l = r._getCanvas(i, s), d = dh(e, Sk), h = dh(e, l2) || ((t = d) === null || t === void 0 ? void 0 : t.getPointByCoord(i, s));
    if (r._isHolding = !1, clearTimeout(r._holdTimer), e.type === dn.down && (r._holdTimer = setTimeout(() => r._isHolding = !0, Xne)), h && !h.getMarkerVisibility() && (h = void 0), r._enableOutHandler(), r._legend.coordsIn(i, s)) {
      r._hoverLegendItem(i, s);
      return;
    }
    if (r.hoveredSeries && r.hoveredSeries !== r._stuckSeries && r._releaseHoveredSeries(), !r._hoverArgumentAxis(i, s, e) && (r._isPointerOut(l, h) && r._pointerOut(), !(!l && !h))) {
      if (d && !h) {
        if (h = d.getNeighborPoint(i, s), !r._stickyHovering && h && !h.coordsIn(i, s) && (h = null), d !== r.hoveredSeries) {
          r._setTimeout(function() {
            r._setHoveredSeries(d), r._setStuckSeries(e, d, i, s), r._pointerComplete(h, i, s);
          }, d);
          return;
        }
      } else if (h) {
        if (e.type !== dn.move && e.pointerType !== "touch")
          return;
        r.hoveredSeries ? r._setTimeout(() => r._pointerOnPoint(h, i, s, e), h) : r._pointerOnPoint(h, i, s, e);
        return;
      } else if (r._setStuckSeries(e, void 0, i, s) && r._stickyHovering) {
        var p;
        d = r._stuckSeries, h = d.getNeighborPoint(i, s), r._releaseHoveredSeries(), !((p = h) === null || p === void 0) && p.getMarkerVisibility() && r._setHoveredPoint(h);
      } else
        r._stickyHovering || r._pointerOut();
      r._pointerComplete(h, i, s);
    }
  },
  _pointerOnPoint: function(e, t, r) {
    this._resetHoveredArgument(), this._setHoveredPoint(e), this._pointerComplete(e, t, r);
  },
  _pointerComplete: function(e) {
    this.pointAtShownTooltip !== e && this._tooltip.isEnabled() && this._showTooltip(e);
  },
  _clickHandler: function(e) {
    var t, r = e.data.tracker;
    if (!r._isHolding) {
      var n = r._renderer.getRootOffset(), i = jp(e.pageX - n.left), s = jp(e.pageY - n.top), l = dh(e, l2), d = r._stuckSeries || dh(e, Sk) || ((t = l) === null || t === void 0 ? void 0 : t.series), h = r._argumentAxis;
      if (r._legend.coordsIn(i, s)) {
        var p = r._legend.getItemByCoord(i, s);
        p && r._legendClick(p, e);
      } else if (h != null && h.coordsIn(i, s)) {
        var m = dh(e, VU, !0);
        I(m) && r._eventTrigger("argumentAxisClick", {
          argument: m,
          event: e
        });
      } else if (d) {
        var x;
        l = l || d.getPointByCoord(i, s), (x = l) !== null && x !== void 0 && x.getMarkerVisibility() ? r._pointClick(l, e) : dh(e, Sk) && r._eventTrigger(ED, {
          target: d,
          event: e
        });
      }
    }
  },
  dispose: function() {
    this._disableOutHandler(), this._renderer.root.off(fC), this._seriesGroup.off(fC);
  }
}, UU = function(e) {
  this.ctor(e);
};
W(UU.prototype, Bu, {
  _pointClick: function(e, t) {
    var r = this._eventTrigger, n = e.series, i = {
      target: e,
      event: t
    };
    r(NU, i, function() {
      !HU(i, n, "point") && r(ED, {
        target: n,
        event: t
      });
    });
  },
  update: function(e) {
    Bu.update.call(this, e), this._argumentAxis = e.argumentAxis || {}, this._axisHoverEnabled = this._argumentAxis && Wt(this._argumentAxis.getOptions().hoverMode) === BU, this._rotated = e.rotated, this._crosshair = e.crosshair, this._stickyHovering = e.stickyHovering;
  },
  _getCanvas: function(e, t) {
    for (var r = this._canvases || [], n = 0; n < r.length; n++) {
      var i = r[n];
      if (UG(i, e, t))
        return i;
    }
    return null;
  },
  _isPointerOut: function(e) {
    return !e && this._stuckSeries;
  },
  _hideCrosshair: function() {
    var e;
    (e = this._crosshair) === null || e === void 0 || e.hide();
  },
  _moveCrosshair: function(e, t, r) {
    this._crosshair && e !== null && e !== void 0 && e.isVisible() && this._crosshair.show({
      point: e,
      x: t,
      y: r
    });
  },
  _clean: function() {
    Bu._clean.call(this), this._resetTimer(), this._stuckSeries = null;
  },
  _getSeriesForShared: function(e, t) {
    var r, n = [], i = null, s = 1 / 0;
    return this._tooltip.isShared() && !this.hoveredSeries && (be(this._storedSeries, function(l, d) {
      var h = d.getNeighborPoint(e, t);
      h && n.push(h);
    }), be(n, function(l, d) {
      var h = d.getCrosshairData(e, t), p = bT(e, t, h.x, h.y);
      p < s && (i = d, s = p);
    })), (r = i) === null || r === void 0 ? void 0 : r.series;
  },
  _setTimeout: function(e, t) {
    var r = this;
    r._timeoutKeeper !== t && (r._resetTimer(), r._hoverTimeout = setTimeout(function() {
      e(), r._timeoutKeeper = null;
    }, Wne), r._timeoutKeeper = t);
  },
  _resetTimer: function() {
    clearTimeout(this._hoverTimeout), this._timeoutKeeper = this._hoverTimeout = null;
  },
  _stopEvent: function(e) {
    (!I(e.cancelable) || e.cancelable) && (e.preventDefault(), e.stopPropagation());
  },
  _setStuckSeries: function(e, t, r, n) {
    return e.pointerType !== "mouse" ? this._stuckSeries = null : this._stuckSeries = t || this._stuckSeries || this._getSeriesForShared(r, n), !!this._stuckSeries;
  },
  _pointerOut: function() {
    var e = this;
    e._stuckSeries = null, e._hideCrosshair(), e._resetTimer(), Bu._pointerOut.apply(e, arguments);
  },
  _hoverArgumentAxis: function(e, t, r) {
    if (this._resetHoveredArgument(), this._axisHoverEnabled && this._argumentAxis.coordsIn(e, t))
      return this._hoverArgument(dh(r, VU, !0)), !0;
  },
  _pointerComplete: function(e, t, r) {
    this.hoveredSeries && this.hoveredSeries.updateHover(t, r), this._resetTimer(), this._moveCrosshair(e, t, r), Bu._pointerComplete.call(this, e);
  },
  _legendClick: function(e, t) {
    var r = this._storedSeries[e.id];
    this._triggerLegendClick({
      target: r,
      event: t
    }, ED);
  },
  _hoverLegendItem: function(e, t) {
    this._stuckSeries = null, this._hideCrosshair(), Bu._hoverLegendItem.call(this, e, t);
  },
  _pointerOnPoint: function(e, t, r, n) {
    this._setStuckSeries(n, e.series, t, r), this._releaseHoveredSeries(), Bu._pointerOnPoint.call(this, e, t, r, n);
  },
  _notifyLegendOnHoverArgument: !1,
  _getArgumentHoverMode: function() {
    return GU(this._argumentAxis);
  },
  dispose: function() {
    this._resetTimer(), Bu.dispose.call(this);
  }
});
var jU = function(e) {
  this.ctor(e);
};
W(jU.prototype, Bu, {
  _isPointerOut: function(e, t) {
    return !t;
  },
  _legendClick: function(e, t) {
    var r = [];
    this._storedSeries.forEach((n) => r.push.apply(r, n.getPointsByKeys(e.argument, e.argumentIndex))), this._eventTrigger(IU, {
      target: e.argument,
      points: r,
      event: t
    });
  },
  _pointClick: function(e, t) {
    this._eventTrigger(NU, {
      target: e,
      event: t
    });
  },
  _hoverLegendItem: function(e, t) {
    var r = this._legend.getItemByCoord(e, t);
    r && this._hoveredArgument !== r.argument ? (this._resetHoveredArgument(), this._hoverArgument(r.argument, r.argumentIndex)) : r || this.clearHover();
  },
  _getArgumentHoverMode: function() {
    return GU(this._legend);
  },
  _hoverArgumentAxis: Y,
  _setStuckSeries: Y,
  _getCanvas: Y,
  _notifyLegendOnHoverArgument: !0
});
const Qne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ChartTracker: UU,
  PieTracker: jU
}, Symbol.toStringTag, { value: "Module" }));
var TD = Math.floor, Jne = Math.ceil, eie = Array.isArray, tie = 50, $U = "material", rie = {
  simpleSet: ["#5f8b95", "#ba4d51", "#af8a53", "#955f71", "#859666", "#7e688c"],
  indicatingSet: ["#a3b97c", "#e1b676", "#ec7f83"],
  gradientSet: ["#5f8b95", "#ba4d51"],
  accentColor: "#ba4d51"
}, wD = {
  [$U]: {
    simpleSet: ["#1db2f5", "#f5564a", "#97c95c", "#ffc720", "#eb3573", "#a63db8"],
    indicatingSet: ["#97c95c", "#ffc720", "#f5564a"],
    gradientSet: ["#1db2f5", "#97c95c"],
    accentColor: "#1db2f5"
  },
  office: rie,
  "harmony light": {
    simpleSet: ["#fcb65e", "#679ec5", "#ad79ce", "#7abd5c", "#e18e92", "#b6d623", "#b7abea", "#85dbd5"],
    indicatingSet: ["#b6d623", "#fcb65e", "#e18e92"],
    gradientSet: ["#7abd5c", "#fcb65e"],
    accentColor: "#679ec5"
  },
  "soft pastel": {
    simpleSet: ["#60a69f", "#78b6d9", "#6682bb", "#a37182", "#eeba69", "#90ba58", "#456c68", "#7565a4"],
    indicatingSet: ["#90ba58", "#eeba69", "#a37182"],
    gradientSet: ["#78b6d9", "#eeba69"],
    accentColor: "#60a69f"
  },
  pastel: {
    simpleSet: ["#bb7862", "#70b3a1", "#bb626a", "#057d85", "#ab394b", "#dac599", "#153459", "#b1d2c6"],
    indicatingSet: ["#70b3a1", "#dac599", "#bb626a"],
    gradientSet: ["#bb7862", "#70b3a1"],
    accentColor: "#bb7862"
  },
  bright: {
    simpleSet: ["#70c92f", "#f8ca00", "#bd1550", "#e97f02", "#9d419c", "#7e4452", "#9ab57e", "#36a3a6"],
    indicatingSet: ["#70c92f", "#f8ca00", "#bd1550"],
    gradientSet: ["#e97f02", "#f8ca00"],
    accentColor: "#e97f02"
  },
  soft: {
    simpleSet: ["#cbc87b", "#9ab57e", "#e55253", "#7e4452", "#e8c267", "#565077", "#6babac", "#ad6082"],
    indicatingSet: ["#9ab57e", "#e8c267", "#e55253"],
    gradientSet: ["#9ab57e", "#e8c267"],
    accentColor: "#565077"
  },
  ocean: {
    simpleSet: ["#75c099", "#acc371", "#378a8a", "#5fa26a", "#064970", "#38c5d2", "#00a7c6", "#6f84bb"],
    indicatingSet: ["#c8e394", "#7bc59d", "#397c8b"],
    gradientSet: ["#acc371", "#38c5d2"],
    accentColor: "#378a8a"
  },
  vintage: {
    simpleSet: ["#dea484", "#efc59c", "#cb715e", "#eb9692", "#a85c4c", "#f2c0b5", "#c96374", "#dd956c"],
    indicatingSet: ["#ffe5c6", "#f4bb9d", "#e57660"],
    gradientSet: ["#efc59c", "#cb715e"],
    accentColor: "#cb715e"
  },
  violet: {
    simpleSet: ["#d1a1d1", "#eeacc5", "#7b5685", "#7e7cad", "#a13d73", "#5b41ab", "#e287e2", "#689cc1"],
    indicatingSet: ["#d8e2f6", "#d0b2da", "#d56a8a"],
    gradientSet: ["#eeacc5", "#7b5685"],
    accentColor: "#7b5685"
  },
  carmine: {
    simpleSet: ["#fb7764", "#73d47f", "#fed85e", "#d47683", "#dde392", "#757ab2"],
    indicatingSet: ["#5cb85c", "#f0ad4e", "#d9534f"],
    gradientSet: ["#fb7764", "#73d47f"],
    accentColor: "#f05b41"
  },
  "dark moon": {
    simpleSet: ["#4ddac1", "#f4c99a", "#80dd9b", "#f998b3", "#4aaaa0", "#a5aef1"],
    indicatingSet: ["#59d8a4", "#f0ad4e", "#f9517e"],
    gradientSet: ["#4ddac1", "#f4c99a"],
    accentColor: "#3debd3"
  },
  "soft blue": {
    simpleSet: ["#7ab8eb", "#97da97", "#facb86", "#e78683", "#839bda", "#4db7be"],
    indicatingSet: ["#5cb85c", "#f0ad4e", "#d9534f"],
    gradientSet: ["#7ab8eb", "#97da97"],
    accentColor: "#7ab8eb"
  },
  "dark violet": {
    simpleSet: ["#9c63ff", "#64c064", "#eead51", "#d2504b", "#4b6bbf", "#2da7b0"],
    indicatingSet: ["#5cb85c", "#f0ad4e", "#d9534f"],
    gradientSet: ["#9c63ff", "#64c064"],
    accentColor: "#9c63ff"
  },
  "green mist": {
    simpleSet: ["#3cbab2", "#8ed962", "#5b9d95", "#efcc7c", "#f1929f", "#4d8dab"],
    indicatingSet: ["#72d63c", "#ffc852", "#f74a5e"],
    gradientSet: ["#3cbab2", "#8ed962"],
    accentColor: "#3cbab2"
  }
}, AD;
function u2(e) {
  if (e === void 0)
    return AD || $U;
  e = Wt(e), AD = e in wD ? e : void 0;
}
function NT(e, t) {
  t = t || {}, e = e || (AD === void 0 ? t.themeDefault : u2());
  var r, n = t.type;
  return eie(e) ? e.slice(0) : (lr(e) && (r = wD[Wt(e)]), r || (r = wD[u2()]), n ? r[n].slice(0) : r);
}
function nie(e, t) {
  return e = NT(e, {
    themeDefault: t
  }), e.accentColor || e[0];
}
function iie(e) {
  var t = 0;
  this.next = function() {
    var r = e[t++];
    return t === e.length && this.reset(), r;
  }, this.reset = function() {
    t = 0;
  };
}
function aie(e, t) {
  var r = t.useHighlight ? tie : 0, n = new iie([0, r, -r]), i = [];
  function s() {
    var l = n.next();
    i = l ? uie(e, l) : e.slice(0);
  }
  return {
    getColor: function(l) {
      var d = i[l % e.length];
      return l % e.length === e.length - 1 && s(), d;
    },
    generateColors: function(l) {
      var d = [];
      l = l || t.count;
      for (var h = 0; h < l; h++)
        d.push(this.getColor(h));
      return d;
    },
    reset: function() {
      n.reset(), s();
    }
  };
}
function oie(e, t) {
  return {
    getColor: function(r, n) {
      var i = e.length, s = TD((n - 1) / i + 1), l = e[r % i];
      return s > 1 ? function(d, h, p) {
        var m = new Jn(d).hsl, x = m.l / 100, S = p - 1 / p, T = x - 0.5 * S, k = x + 0.5 * S, O = (p - 1) / 2, D = h - O;
        return T < Math.min(0.5, 0.9 * x) && (T = Math.min(0.5, 0.9 * x)), k > Math.max(0.8, x + 0.15 * (1 - x)) && (k = Math.max(0.8, x + 0.15 * (1 - x))), D < 0 ? x -= (T - x) * D / O : x += D / O * (k - x), m.l = 100 * x, Jn.prototype.fromHSL(m).toHex();
      }(l, TD(r / i), s) : l;
    },
    generateColors: function(r) {
      var n = [];
      r = r || t.count;
      for (var i = 0; i < r; i++)
        n.push(this.getColor(i, r));
      return n;
    },
    reset: function() {
    }
  };
}
function sie(e, t) {
  var r = e.length, n = [];
  function i(d, h, p, m) {
    for (var x = Math.floor(d / h), S = d - h * x, T = p, k, O; T < p + d; )
      O = x, S > 0 && (O += 1, S--), k = O > 2 ? Math.floor(O / 2) : 0, m.push(T + k), T += O;
    return m.sort(function(D, L) {
      return D - L;
    });
  }
  function s(d, h, p) {
    h = (p + h) % p;
    for (var m = 0, x = h; x < 2 * p; x += 1) {
      var S = (p + x) % p;
      if (d[S])
        return [d[S], m];
      m++;
    }
  }
  function l(d) {
    if (d <= r)
      return e;
    var h = [], p = r - 2, m = 0, x = [];
    t.keepLastColorInEnd ? x = i(d - 2, p, 1, [0, d - 1]) : x = i(d - 1, r - 1, 1, [0]);
    for (var S = 0; S < d; S++)
      x.indexOf(S) > -1 && (h[S] = e[m++]);
    return h = function(T, k) {
      for (var O = 0; O < k; O++) {
        var D = T[O];
        if (!D) {
          var L = T[O - 1];
          if (L) {
            var F = s(T, O, k), z = new Jn(F[0]);
            L = new Jn(L);
            for (var V = 0; V < F[1]; V++, O++)
              T[O] = L.blend(z, (V + 1) / (F[1] + 1)).toHex();
          } else
            continue;
        }
      }
      return T;
    }(h, d), h;
  }
  return {
    getColor: function(d, h) {
      return h = h || t.count || r, n.length !== h && (n = l(h)), n[d % h];
    },
    generateColors: function(d, h) {
      if (d = d || t.count || r, h && d > r) {
        for (var p = l(r), m = 0; m < d - r; m++)
          p.push(p[m]);
        return p;
      } else
        return r > 0 ? l(d).slice(0, d) : [];
    },
    reset: function() {
    }
  };
}
function lie(e, t, r) {
  var n = {
    dispose() {
      this._extensionStrategy = null;
    },
    getNextColor(l) {
      return this._extensionStrategy.getColor(this._currentColor++, l);
    },
    generateColors(l, d) {
      return this._extensionStrategy.generateColors(l, (d || {}).repeat);
    },
    reset() {
      return this._currentColor = 0, this._extensionStrategy.reset(), this;
    }
  };
  t = t || {};
  var i = (t.extensionMode || "").toLowerCase(), s = NT(e, {
    type: t.type || "simpleSet",
    themeDefault: r
  });
  return i === "alternate" ? n._extensionStrategy = aie(s, t) : i === "extrapolate" ? n._extensionStrategy = oie(s, t) : n._extensionStrategy = sie(s, t), n.reset(), n;
}
function uie(e, t) {
  var r = [], n, i = e.length;
  for (n = 0; n < i; ++n)
    r.push(cie(e[n], t));
  return r;
}
function cie(e, t) {
  var r = new Jn(e).alter(t), n = die(r);
  return (n > 200 || n < 55) && (r = new Jn(e).alter(-t / 2)), r.toHex();
}
function die(e) {
  return 0.3 * e.r + 0.59 * e.g + 0.11 * e.b;
}
function fie(e, t, r) {
  var n = t > 0 ? hie(NT(e, {
    type: "gradientSet",
    themeDefault: r
  }), t) : [];
  return {
    getColor: function(i) {
      return n[i] || null;
    }
  };
}
function hie(e, t) {
  var r = t - 1, n = e.length - 1, i = [], s = [], l;
  function d(h) {
    var p = n * h, m = TD(p), x = Jne(p);
    s.push(i[m].blend(i[x], p - m).toHex());
  }
  for (l = 0; l <= n; ++l)
    i.push(new Jn(e[l]));
  if (r > 0)
    for (l = 0; l <= r; ++l)
      d(l / r);
  else
    d(0.5);
  return s;
}
function vie(e, t) {
  var r = NT(e, {
    type: "gradientSet",
    themeDefault: t
  }), n = new Jn(r[0]), i = new Jn(r[1]);
  return {
    getColor: function(s) {
      return 0 <= s && s <= 1 ? n.blend(i, s).toHex() : null;
    }
  };
}
var _g = Xa();
const VT = hT(Dr.ERROR_MESSAGES, {
  E1001: "Module '{0}'. Controller '{1}' is already registered",
  E1002: "Module '{0}'. Controller '{1}' does not inherit from DevExpress.ui.dxDataGrid.Controller",
  E1003: "Module '{0}'. View '{1}' is already registered",
  E1004: "Module '{0}'. View '{1}' does not inherit from DevExpress.ui.dxDataGrid.View",
  E1005: "Public method '{0}' is already registered",
  E1006: "Public method '{0}.{1}' does not exist",
  E1007: "State storing cannot be provided due to the restrictions of the browser",
  E1010: "The template does not contain the TextBox widget",
  E1011: 'Items cannot be deleted from the List. Implement the "remove" function in the data store',
  E1012: "Editing type '{0}' with the name '{1}' is unsupported",
  E1016: "Unexpected type of data source is provided for a lookup column",
  E1018: "The 'collapseAll' method cannot be called if you use a remote data source",
  E1019: "Search mode '{0}' is unavailable",
  E1020: "The type cannot be changed after initialization",
  E1021: "{0} '{1}' you are trying to remove does not exist",
  E1022: 'The "markers" option is given an invalid value. Assign an array instead',
  E1023: 'The "routes" option is given an invalid value. Assign an array instead',
  E1025: "This layout is too complex to render",
  E1026: 'The "calculateCustomSummary" function is missing from a field whose "summaryType" option is set to "custom"',
  E1031: "Unknown subscription in the Scheduler widget: '{0}'",
  E1032: "Unknown start date in an appointment: '{0}'",
  E1033: "Unknown step in the date navigator: '{0}'",
  E1034: "The browser does not implement an API for saving files",
  E1035: "The editor cannot be created: {0}",
  E1037: "Invalid structure of grouped data",
  E1038: "The browser does not support local storages for local web pages",
  E1039: "A cell's position cannot be calculated",
  E1040: "The '{0}' key value is not unique within the data array",
  E1041: "The '{0}' script is referenced after the DevExtreme scripts or not referenced at all",
  E1042: "{0} requires the key field to be specified",
  E1043: "Changes cannot be processed due to the incorrectly set key",
  E1044: "The key field specified by the keyExpr option does not match the key field specified in the data store",
  E1045: "Editing requires the key field to be specified in the data store",
  E1046: "The '{0}' key field is not found in data objects",
  E1047: 'The "{0}" field is not found in the fields array',
  E1048: 'The "{0}" operation is not found in the filterOperations array',
  E1049: "Column '{0}': filtering is allowed but the 'dataField' or 'name' option is not specified",
  E1050: "The validationRules option does not apply to third-party editors defined in the editCellTemplate",
  E1051: `HtmlEditor's valueType is "{0}", but the {0} converter was not imported.`,
  E1052: '{0} should have the "dataSource" option specified',
  E1053: 'The "buttons" option accepts an array that contains only objects or string values',
  E1054: "All text editor buttons must have names",
  E1055: 'One or several text editor buttons have invalid or non-unique "name" values',
  E1056: 'The {0} widget does not support buttons of the "{1}" type',
  E1058: 'The "startDayHour" and "endDayHour" options must be integers in the [0, 24] range, with "endDayHour" being greater than "startDayHour".',
  E1059: "The following column names are not unique: {0}",
  E1060: "All editable columns must have names",
  E1061: 'The "offset" option must be an integer in the [-1440, 1440] range, divisible by 5 without a remainder.',
  E1062: 'The "cellDuration" must be a positive integer, evenly dividing the ("endDayHour" - "startDayHour") interval into minutes.',
  W1001: 'The "key" option cannot be modified after initialization',
  W1002: "An item with the key '{0}' does not exist",
  W1003: "A group with the key '{0}' in which you are trying to select items does not exist",
  W1004: "The item '{0}' you are trying to select in the group '{1}' does not exist",
  W1005: "Due to column data types being unspecified, data has been loaded twice in order to apply initial filter settings. To resolve this issue, specify data types for all grid columns.",
  W1006: "The map service returned the following error: '{0}'",
  W1007: "No item with key {0} was found in the data source, but this key was used as the parent key for item {1}",
  W1008: "Cannot scroll to the '{0}' date because it does not exist on the current view",
  W1009: "Searching works only if data is specified using the dataSource option",
  W1010: "The capability to select all items works with source data of plain structure only",
  W1011: 'The "keyExpr" option is not applied when dataSource is not an array',
  W1012: "The '{0}' key field is not found in data objects",
  W1013: 'The "message" field in the dialog component was renamed to "messageHtml". Change your code correspondingly. In addition, if you used HTML code in the message, make sure that it is secure',
  W1014: "The Floating Action Button exceeds the recommended speed dial action count. If you need to display more speed dial actions, increase the maxSpeedDialActionCount option value in the global config.",
  W1016: "The '{0}' field in the HTML Editor toolbar item configuration was renamed to '{1}'. Please make a corresponding change in your code.",
  W1017: "The 'key' property is not specified for a lookup data source. Please specify it to prevent requests for the entire dataset when users filter data.",
  W1018: "Infinite scrolling may not work properly with multiple selection. To use these features together, set 'selection.deferred' to true or set 'selection.selectAllMode' to 'page'.",
  W1019: "Filter query string exceeds maximum length limit of {0} characters.",
  W1020: "hideEvent is ignored when the shading property is true",
  W1021: `The '{0}' is not rendered because none of the DOM elements match the value of the "container" property.`,
  W1022: "{0} JSON parsing error: '{1}'",
  W1023: "Appointments require unique keys. Otherwise, the agenda view may not work correctly.",
  W1024: "The client-side export is enabled. Implement the 'onExporting' function.",
  W1025: "'scrolling.mode' is set to 'virtual' or 'infinite'. Specify the height of the component."
});
var YU = jr(), pie = jd.add, gie = gy, mie = FM, Ey = new Yt(), WU = "link[rel=dx-theme]", _ie = "data-theme", yie = "data-active", c2 = "dx-hairlines", XU = "any", Qu, OD, Ju, co, Td, d2 = 15e3, Ck = "dx.";
function vL() {
  if (!fn())
    return null;
  var e = je("<div>", Qu).addClass("dx-theme-marker").appendTo(Qu.documentElement), t;
  try {
    return t = YU.getComputedStyle(e.get(0)).fontFamily, !t || (t = t.replace(/["']/g, ""), t.substr(0, Ck.length) !== Ck) ? null : t.substr(Ck.length);
  } finally {
    e.remove();
  }
}
function f2(e) {
  var t, r, n = !0;
  Td = e;
  function i() {
    Td = null, clearInterval(r), n = !0, _g.fire(), _g.empty(), Ey.resolve();
  }
  if (h2() || !d2)
    i();
  else {
    if (!n) {
      Td && (Td = e);
      return;
    }
    t = Date.now(), n = !1, r = setInterval(function() {
      var s = h2(), l = !s && Date.now() - t > d2;
      l && VT.log("W0004", Td), (s || l) && i();
    }, 10);
  }
}
function h2() {
  if (!Td)
    return !0;
  var e = Td === XU;
  if (Ey.state() === "resolved" && e)
    return !0;
  var t = vL();
  return t && e ? !0 : t === Td;
}
function xie() {
  var e = je(WU, Qu);
  e.length && (Ju = {}, OD = je(OM("<link rel=stylesheet>"), Qu), e.each(function() {
    var t = je(this, Qu), r = t.attr(_ie), n = t.attr("href"), i = t.attr(yie) === "true";
    Ju[r] = {
      url: n,
      isActive: i
    };
  }), e.last().after(OD), e.remove());
}
function bie(e) {
  var t = e ? e.split(".") : [], r = null;
  if (Ju) {
    if (e in Ju)
      return e;
    be(Ju, function(n, i) {
      var s = n.split(".");
      if (!(t[0] && s[0] !== t[0]) && !(t[1] && t[1] !== s[1]) && !(t[2] && t[2] !== s[2]) && ((!r || i.isActive) && (r = n), i.isActive))
        return !1;
    });
  }
  return r;
}
function Sie(e) {
  try {
    e !== Qu && (Ju = null);
  } catch {
    Ju = null;
  }
  Qu = e;
}
function qU(e) {
  e = e || {}, Sie(e.context || we.getDocument()), Qu && (xie(), co = void 0, pL(e));
}
function pL(e) {
  if (!arguments.length)
    return co = co || vL(), co;
  ZU(gie()), e = e || {}, typeof e == "string" && (e = {
    theme: e
  });
  var t = e._autoInit, r = e.loadCallback, n;
  if (co = bie(e.theme || co), co && (n = Ju[co]), r && _g.add(r), n)
    OD.attr("href", Ju[co].url), (_g.has() || Ey.state() !== "resolved" || e._forceTimeout) && f2(co);
  else if (t)
    fn() && f2(XU), _g.fire(), _g.empty();
  else
    throw VT.Error("E0021", co);
  Ey.done(() => KU(KZ(), co));
}
function Cie(e) {
  e = e || pL();
  var t = [], r = e && e.split(".");
  return r && (t.push("dx-theme-" + r[0], "dx-theme-" + r[0] + "-typography"), r.length > 1 && t.push("dx-color-scheme-" + r[1] + (Eie(e) ? "-" + r[2] : ""))), t;
}
var sE;
function KU(e, t) {
  sE = Cie(t).join(" "), je(e).addClass(sE), function() {
    var r = fn() && YU.devicePixelRatio;
    if (!(!r || r < 2)) {
      var n = je("<div>");
      n.css("border", ".5px solid transparent"), je("body").append(n), Pq(n) === 1 && (je(e).addClass(c2), sE += " " + c2), n.remove();
    }
  }();
}
function ZU(e) {
  je(e).removeClass(sE);
}
function QU(e, t) {
  return t || (t = co || vL()), new RegExp(e).test(t);
}
function Eie(e) {
  return Tie(e) || wie(e);
}
function Tie(e) {
  return QU("material", e);
}
function wie(e) {
  return QU("fluent", e);
}
function v2() {
  if (qU({
    _autoInit: !0,
    _forceTimeout: !0
  }), je(WU, Qu).length)
    throw VT.Error("E0022");
}
fn() ? v2() : pie(v2);
mie.add(function(e, t) {
  Ey.done(function() {
    ZU(t), KU(e);
  });
});
qa.changed.add(function() {
  qU({
    _autoInit: !0
  });
});
var Nr = "#ffffff", Sl = "#000000", $p = "#d3d3d3", Yp = "#303030", Aie = "#2b2b2b", Ek = "#ff0000", Tk = "#232323", hC = "#767676", Ua = "none", ha = "solid", Iu = "top", Sn = "right", ah = "bottom", cd = "left", Io = "center", vC = "inside", pC = "outside";
const Oie = [{
  theme: {
    name: "generic.light",
    isDefault: !0,
    font: {
      color: hC,
      family: "'Segoe UI', 'Helvetica Neue', 'Trebuchet MS', Verdana, sans-serif",
      weight: 400,
      size: 12,
      cursor: "default"
    },
    redrawOnResize: !0,
    backgroundColor: Nr,
    primaryTitleColor: Tk,
    secondaryTitleColor: hC,
    gridColor: $p,
    axisColor: hC,
    title: {
      backgroundColor: Nr,
      font: {
        size: 28,
        family: "'Segoe UI Light', 'Helvetica Neue Light', 'Segoe UI', 'Helvetica Neue', 'Trebuchet MS', Verdana, sans-serif",
        weight: 200
      },
      subtitle: {
        font: {
          size: 16
        },
        offset: 0,
        wordWrap: "normal",
        textOverflow: "ellipsis"
      },
      wordWrap: "normal",
      textOverflow: "ellipsis"
    },
    loadingIndicator: {
      text: "Loading..."
    },
    export: {
      backgroundColor: Nr,
      margin: 10,
      font: {
        size: 14,
        color: Tk,
        weight: 400
      },
      button: {
        margin: {
          top: 8,
          left: 10,
          right: 10,
          bottom: 8
        },
        default: {
          color: "#333",
          borderColor: "#ddd",
          backgroundColor: Nr
        },
        hover: {
          color: "#333",
          borderColor: "#bebebe",
          backgroundColor: "#e6e6e6"
        },
        focus: {
          color: Sl,
          borderColor: "#9d9d9d",
          backgroundColor: "#e6e6e6"
        },
        active: {
          color: "#333",
          borderColor: "#9d9d9d",
          backgroundColor: "#d4d4d4"
        }
      },
      shadowColor: $p
    },
    tooltip: {
      enabled: !1,
      border: {
        width: 1,
        color: $p,
        dashStyle: ha,
        visible: !0
      },
      font: {
        color: Tk
      },
      color: Nr,
      arrowLength: 10,
      paddingLeftRight: 18,
      paddingTopBottom: 15,
      textAlignment: "center",
      shared: !1,
      location: Io,
      shadow: {
        opacity: 0.4,
        offsetX: 0,
        offsetY: 4,
        blur: 2,
        color: Sl
      },
      interactive: !1
    },
    legend: {
      hoverMode: "includePoints",
      verticalAlignment: Iu,
      horizontalAlignment: Sn,
      position: pC,
      visible: !0,
      margin: 10,
      markerSize: 12,
      border: {
        visible: !1,
        width: 1,
        cornerRadius: 0,
        dashStyle: ha
      },
      paddingLeftRight: 20,
      paddingTopBottom: 15,
      columnCount: 0,
      rowCount: 0,
      columnItemSpacing: 20,
      rowItemSpacing: 8,
      title: {
        backgroundColor: Nr,
        margin: {
          left: 0,
          bottom: 9,
          right: 0,
          top: 0
        },
        font: {
          size: 18,
          weight: 200
        },
        subtitle: {
          offset: 0,
          font: {
            size: 14
          },
          wordWrap: "none",
          textOverflow: "ellipsis"
        },
        wordWrap: "none",
        textOverflow: "ellipsis"
      }
    },
    "chart:common": {
      animation: {
        enabled: !0,
        duration: 1e3,
        easing: "easeOutCubic",
        maxPointCountSupported: 300
      },
      commonSeriesSettings: {
        border: {
          visible: !1,
          width: 2
        },
        showInLegend: !0,
        visible: !0,
        hoverMode: "nearestPoint",
        selectionMode: "includePoints",
        hoverStyle: {
          hatching: {
            direction: Sn,
            width: 2,
            step: 6,
            opacity: 0.75
          },
          highlight: !0,
          border: {
            visible: !1,
            width: 3
          }
        },
        selectionStyle: {
          hatching: {
            direction: Sn,
            width: 2,
            step: 6,
            opacity: 0.5
          },
          highlight: !0,
          border: {
            visible: !1,
            width: 3
          }
        },
        valueErrorBar: {
          displayMode: "auto",
          value: 1,
          color: Sl,
          lineWidth: 2,
          edgeLength: 8
        },
        label: {
          visible: !1,
          alignment: Io,
          rotationAngle: 0,
          horizontalOffset: 0,
          verticalOffset: 0,
          radialOffset: 0,
          showForZeroValues: !0,
          customizeText: void 0,
          maxLabelCount: void 0,
          position: pC,
          font: {
            color: Nr
          },
          border: {
            visible: !1,
            width: 1,
            color: $p,
            dashStyle: ha
          },
          connector: {
            visible: !1,
            width: 1
          }
        }
      },
      seriesSelectionMode: "single",
      pointSelectionMode: "single",
      equalRowHeight: !0,
      dataPrepareSettings: {
        checkTypeForAllData: !1,
        convertToAxisDataType: !0,
        sortingMethod: !0
      },
      title: {
        margin: 10
      },
      adaptiveLayout: {
        width: 80,
        height: 80,
        keepLabels: !0
      },
      _rtl: {
        legend: {
          itemTextPosition: cd
        }
      },
      resolveLabelOverlapping: Ua
    },
    "chart:common:axis": {
      visible: !0,
      valueMarginsEnabled: !0,
      placeholderSize: null,
      logarithmBase: 10,
      discreteAxisDivisionMode: "betweenLabels",
      aggregatedPointsPosition: "betweenTicks",
      width: 1,
      label: {
        visible: !0
      },
      grid: {
        visible: !1,
        width: 1
      },
      minorGrid: {
        visible: !1,
        width: 1,
        opacity: 0.3
      },
      tick: {
        visible: !0,
        width: 1,
        length: 7,
        shift: 3
      },
      minorTick: {
        visible: !1,
        width: 1,
        opacity: 0.3,
        length: 7,
        shift: 3
      },
      stripStyle: {
        paddingLeftRight: 10,
        paddingTopBottom: 5
      },
      constantLineStyle: {
        width: 1,
        color: Sl,
        dashStyle: ha,
        label: {
          visible: !0,
          position: vC
        }
      },
      marker: {
        label: {}
      }
    },
    "chart:common:annotation": {
      font: {
        color: "#333333"
      },
      tooltipEnabled: !0,
      border: {
        width: 1,
        color: "#dddddd",
        dashStyle: ha,
        visible: !0
      },
      color: Nr,
      opacity: 0.9,
      arrowLength: 14,
      arrowWidth: 14,
      paddingLeftRight: 10,
      paddingTopBottom: 10,
      shadow: {
        opacity: 0.15,
        offsetX: 0,
        offsetY: 1,
        blur: 4,
        color: Sl
      },
      image: {
        width: 30,
        height: 30
      },
      wordWrap: "normal",
      textOverflow: "ellipsis",
      allowDragging: !1
    },
    chart: {
      commonSeriesSettings: {
        type: "line",
        stack: "default",
        aggregation: {
          enabled: void 0
        },
        point: {
          visible: !0,
          symbol: "circle",
          size: 12,
          border: {
            visible: !1,
            width: 1
          },
          hoverMode: "onlyPoint",
          selectionMode: "onlyPoint",
          hoverStyle: {
            border: {
              visible: !0,
              width: 4
            }
          },
          selectionStyle: {
            border: {
              visible: !0,
              width: 4
            }
          }
        },
        scatter: {},
        line: {
          width: 2,
          dashStyle: ha,
          hoverStyle: {
            width: 3,
            hatching: {
              direction: Ua
            },
            highlight: !1
          },
          selectionStyle: {
            width: 3
          }
        },
        stackedline: {
          width: 2,
          dashStyle: ha,
          hoverStyle: {
            width: 3,
            hatching: {
              direction: Ua
            },
            highlight: !1
          },
          selectionStyle: {
            width: 3
          }
        },
        stackedspline: {
          width: 2,
          dashStyle: ha,
          hoverStyle: {
            width: 3,
            hatching: {
              direction: Ua
            },
            highlight: !1
          },
          selectionStyle: {
            width: 3
          }
        },
        fullstackedline: {
          width: 2,
          dashStyle: ha,
          hoverStyle: {
            width: 3,
            hatching: {
              direction: Ua
            },
            highlight: !1
          },
          selectionStyle: {
            width: 3
          }
        },
        fullstackedspline: {
          width: 2,
          dashStyle: ha,
          hoverStyle: {
            width: 3,
            hatching: {
              direction: Ua
            },
            highlight: !1
          },
          selectionStyle: {
            width: 3
          }
        },
        stepline: {
          width: 2,
          dashStyle: ha,
          hoverStyle: {
            width: 3,
            hatching: {
              direction: Ua
            },
            highlight: !1
          },
          selectionStyle: {
            width: 3
          }
        },
        area: {
          point: {
            visible: !1
          },
          opacity: 0.5
        },
        stackedarea: {
          point: {
            visible: !1
          },
          opacity: 0.5
        },
        fullstackedarea: {
          point: {
            visible: !1
          },
          opacity: 0.5
        },
        fullstackedsplinearea: {
          point: {
            visible: !1
          },
          opacity: 0.5
        },
        steparea: {
          border: {
            visible: !0,
            width: 2
          },
          point: {
            visible: !1
          },
          hoverStyle: {
            border: {
              visible: !0,
              width: 3
            }
          },
          selectionStyle: {
            border: {
              visible: !0,
              width: 3
            }
          },
          opacity: 0.5
        },
        spline: {
          width: 2,
          hoverStyle: {
            width: 3,
            hatching: {
              direction: Ua
            },
            highlight: !1
          },
          selectionStyle: {
            width: 3
          }
        },
        splinearea: {
          point: {
            visible: !1
          },
          opacity: 0.5
        },
        stackedsplinearea: {
          point: {
            visible: !1
          },
          opacity: 0.5
        },
        bar: {
          cornerRadius: 0,
          point: {
            hoverStyle: {
              border: {
                visible: !1
              }
            },
            selectionStyle: {
              border: {
                visible: !1
              }
            }
          }
        },
        stackedbar: {
          cornerRadius: 0,
          point: {
            hoverStyle: {
              border: {
                visible: !1
              }
            },
            selectionStyle: {
              border: {
                visible: !1
              }
            }
          },
          label: {
            position: vC
          }
        },
        fullstackedbar: {
          cornerRadius: 0,
          point: {
            hoverStyle: {
              border: {
                visible: !1
              }
            },
            selectionStyle: {
              border: {
                visible: !1
              }
            }
          },
          label: {
            position: vC
          }
        },
        rangebar: {
          cornerRadius: 0,
          point: {
            hoverStyle: {
              border: {
                visible: !1
              }
            },
            selectionStyle: {
              border: {
                visible: !1
              }
            }
          }
        },
        rangearea: {
          point: {
            visible: !1
          },
          opacity: 0.5
        },
        rangesplinearea: {
          point: {
            visible: !1
          },
          opacity: 0.5
        },
        bubble: {
          opacity: 0.5,
          point: {
            hoverStyle: {
              border: {
                visible: !1
              }
            },
            selectionStyle: {
              border: {
                visible: !1
              }
            }
          }
        },
        candlestick: {
          width: 1,
          reduction: {
            color: Ek
          },
          hoverStyle: {
            width: 3,
            hatching: {
              direction: Ua
            },
            highlight: !1
          },
          selectionStyle: {
            width: 3,
            highlight: !1
          },
          point: {
            border: {
              visible: !0
            }
          }
        },
        stock: {
          width: 1,
          reduction: {
            color: Ek
          },
          hoverStyle: {
            width: 3,
            hatching: {
              direction: Ua
            },
            highlight: !1
          },
          selectionStyle: {
            width: 3,
            highlight: !1
          },
          point: {
            border: {
              visible: !0
            }
          }
        }
      },
      crosshair: {
        enabled: !1,
        color: "#f05b41",
        width: 1,
        dashStyle: ha,
        label: {
          visible: !1,
          font: {
            color: Nr,
            size: 12
          }
        },
        verticalLine: {
          visible: !0
        },
        horizontalLine: {
          visible: !0
        }
      },
      commonAxisSettings: {
        multipleAxesSpacing: 5,
        forceUserTickInterval: !1,
        breakStyle: {
          width: 5,
          color: "#ababab",
          line: "waved"
        },
        label: {
          displayMode: "standard",
          overlappingBehavior: "hide",
          indentFromAxis: 10,
          wordWrap: "normal",
          textOverflow: "none"
        },
        title: {
          font: {
            size: 16
          },
          margin: 6,
          alignment: Io
        },
        constantLineStyle: {
          paddingLeftRight: 10,
          paddingTopBottom: 10
        }
      },
      horizontalAxis: {
        position: ah,
        axisDivisionFactor: 70,
        label: {
          rotationAngle: 90,
          staggeringSpacing: 5,
          alignment: Io
        },
        stripStyle: {
          label: {
            horizontalAlignment: Io,
            verticalAlignment: Iu
          }
        },
        constantLineStyle: {
          label: {
            horizontalAlignment: Sn,
            verticalAlignment: Iu
          }
        },
        constantLines: []
      },
      verticalAxis: {
        position: cd,
        axisDivisionFactor: 40,
        label: {
          alignment: Sn
        },
        stripStyle: {
          label: {
            horizontalAlignment: cd,
            verticalAlignment: Io
          }
        },
        constantLineStyle: {
          label: {
            horizontalAlignment: cd,
            verticalAlignment: Iu
          }
        },
        constantLines: []
      },
      argumentAxis: {
        endOnTick: !1,
        aggregateByCategory: !0,
        workWeek: [1, 2, 3, 4, 5]
      },
      valueAxis: {
        grid: {
          visible: !0
        },
        autoBreaksEnabled: !1,
        maxAutoBreakCount: 4
      },
      commonPaneSettings: {
        backgroundColor: Ua,
        border: {
          color: $p,
          width: 1,
          visible: !1,
          top: !0,
          bottom: !0,
          left: !0,
          right: !0,
          dashStyle: ha
        }
      },
      scrollBar: {
        visible: !1,
        offset: 5,
        color: "gray",
        width: 10
      },
      adjustOnZoom: !0,
      autoHidePointMarkers: !0,
      rotated: !1,
      synchronizeMultiAxes: !0,
      stickyHovering: !0,
      barGroupPadding: 0.3,
      minBubbleSize: 12,
      maxBubbleSize: 0.2,
      zoomAndPan: {
        dragBoxStyle: {
          color: "#2a2a2a",
          opacity: 0.2
        },
        panKey: "shift",
        allowMouseWheel: !0,
        allowTouchGestures: !0
      }
    },
    pie: {
      innerRadius: 0.5,
      minDiameter: 0.5,
      type: "pie",
      dataPrepareSettings: {
        _skipArgumentSorting: !0
      },
      commonSeriesSettings: {
        pie: {
          border: {
            visible: !1,
            width: 2,
            color: Nr
          },
          hoverStyle: {
            hatching: {
              direction: Sn,
              width: 4,
              step: 10,
              opacity: 0.75
            },
            highlight: !0,
            border: {
              visible: !1,
              width: 2
            }
          },
          selectionStyle: {
            hatching: {
              direction: Sn,
              width: 4,
              step: 10,
              opacity: 0.5
            },
            highlight: !0,
            border: {
              visible: !1,
              width: 2
            }
          }
        },
        doughnut: {
          border: {
            visible: !1,
            width: 2,
            color: Nr
          },
          hoverStyle: {
            hatching: {
              direction: Sn,
              width: 4,
              step: 10,
              opacity: 0.75
            },
            highlight: !0,
            border: {
              visible: !1,
              width: 2
            }
          },
          selectionStyle: {
            hatching: {
              direction: Sn,
              width: 4,
              step: 10,
              opacity: 0.5
            },
            highlight: !0,
            border: {
              visible: !1,
              width: 2
            }
          }
        },
        donut: {
          border: {
            visible: !1,
            width: 2,
            color: Nr
          },
          hoverStyle: {
            hatching: {
              direction: Sn,
              width: 4,
              step: 10,
              opacity: 0.75
            },
            highlight: !0,
            border: {
              visible: !1,
              width: 2
            }
          },
          selectionStyle: {
            hatching: {
              direction: Sn,
              width: 4,
              step: 10,
              opacity: 0.5
            },
            highlight: !0,
            border: {
              visible: !1,
              width: 2
            }
          }
        },
        label: {
          textOverflow: "ellipsis",
          wordWrap: "normal"
        }
      },
      legend: {
        hoverMode: "allArgumentPoints",
        backgroundColor: Ua
      },
      adaptiveLayout: {
        keepLabels: !1
      }
    },
    gauge: {
      scale: {
        tick: {
          visible: !0,
          length: 5,
          width: 2,
          opacity: 1
        },
        minorTick: {
          visible: !1,
          length: 3,
          width: 1,
          opacity: 1
        },
        label: {
          visible: !0,
          alignment: Io,
          hideFirstOrLast: "last",
          overlappingBehavior: "hide"
        },
        position: Iu,
        endOnTick: !1
      },
      rangeContainer: {
        offset: 0,
        width: 5,
        backgroundColor: "#808080"
      },
      valueIndicators: {
        _default: {
          color: "#c2c2c2"
        },
        rangebar: {
          space: 2,
          size: 10,
          color: "#cbc5cf",
          backgroundColor: Ua,
          text: {
            indent: 0,
            font: {
              size: 14,
              color: null
            }
          }
        },
        twocolorneedle: {
          secondColor: "#e18e92"
        },
        trianglemarker: {
          space: 2,
          length: 14,
          width: 13,
          color: "#8798a5"
        },
        textcloud: {
          arrowLength: 5,
          horizontalOffset: 6,
          verticalOffset: 3,
          color: "#679ec5",
          text: {
            font: {
              color: Nr,
              size: 18
            }
          }
        }
      },
      indicator: {
        hasPositiveMeaning: !0,
        layout: {
          horizontalAlignment: Io,
          verticalAlignment: ah
        },
        text: {
          font: {
            size: 18
          }
        }
      },
      _circular: {
        scale: {
          scaleDivisionFactor: 17,
          orientation: pC,
          label: {
            indentFromTick: 10
          }
        },
        rangeContainer: {
          orientation: pC
        },
        valueIndicatorType: "rectangleneedle",
        subvalueIndicatorType: "trianglemarker",
        valueIndicators: {
          _type: "rectangleneedle",
          _default: {
            offset: 20,
            indentFromCenter: 0,
            width: 2,
            spindleSize: 14,
            spindleGapSize: 10,
            beginAdaptingAtRadius: 50
          },
          triangleneedle: {
            width: 4
          },
          twocolorneedle: {
            space: 2,
            secondFraction: 0.4
          },
          rangebar: {
            offset: 30
          },
          trianglemarker: {
            offset: 6
          },
          textcloud: {
            offset: -6
          }
        }
      },
      _linear: {
        scale: {
          scaleDivisionFactor: 25,
          horizontalOrientation: Sn,
          verticalOrientation: ah,
          label: {
            indentFromTick: -10
          }
        },
        rangeContainer: {
          horizontalOrientation: Sn,
          verticalOrientation: ah
        },
        valueIndicatorType: "rangebar",
        subvalueIndicatorType: "trianglemarker",
        valueIndicators: {
          _type: "rectangle",
          _default: {
            offset: 2.5,
            length: 15,
            width: 15
          },
          rectangle: {
            width: 10
          },
          rangebar: {
            offset: 10,
            horizontalOrientation: Sn,
            verticalOrientation: ah
          },
          trianglemarker: {
            offset: 10,
            horizontalOrientation: cd,
            verticalOrientation: Iu
          },
          textcloud: {
            offset: -1,
            horizontalOrientation: cd,
            verticalOrientation: Iu
          }
        }
      }
    },
    barGauge: {
      backgroundColor: "#e0e0e0",
      relativeInnerRadius: 0.3,
      barSpacing: 4,
      resolveLabelOverlapping: "hide",
      label: {
        indent: 20,
        connectorWidth: 2,
        font: {
          size: 16
        }
      },
      legend: {
        visible: !1
      },
      indicator: {
        hasPositiveMeaning: !0,
        layout: {
          horizontalAlignment: Io,
          verticalAlignment: ah
        },
        text: {
          font: {
            size: 18
          }
        }
      }
    },
    rangeSelector: {
      scale: {
        valueMarginsEnabled: !0,
        width: 1,
        color: Sl,
        opacity: 0.1,
        showCustomBoundaryTicks: !0,
        aggregateByCategory: !0,
        label: {
          overlappingBehavior: "hide",
          alignment: Io,
          visible: !0,
          topIndent: 7,
          font: {
            size: 11
          }
        },
        tick: {
          width: 1,
          color: Sl,
          opacity: 0.17,
          visible: !0,
          length: 12
        },
        minorTick: {
          width: 1,
          color: Sl,
          opacity: 0.05,
          visible: !0,
          length: 12
        },
        marker: {
          width: 1,
          color: "#000000",
          opacity: 0.1,
          visible: !0,
          separatorHeight: 33,
          topIndent: 10,
          textLeftIndent: 7,
          textTopIndent: 11,
          label: {}
        },
        logarithmBase: 10,
        workWeek: [1, 2, 3, 4, 5],
        breakStyle: {
          width: 5,
          color: "#ababab",
          line: "waved"
        },
        endOnTick: !1
      },
      selectedRangeColor: "#606060",
      sliderMarker: {
        visible: !0,
        paddingTopBottom: 2,
        paddingLeftRight: 4,
        color: "#606060",
        invalidRangeColor: Ek,
        font: {
          color: Nr,
          size: 11
        }
      },
      sliderHandle: {
        width: 1,
        color: Sl,
        opacity: 0.2
      },
      shutter: {
        opacity: 0.75
      },
      background: {
        color: "#c0bae1",
        visible: !0,
        image: {
          location: "full"
        }
      },
      behavior: {
        snapToTicks: !0,
        animationEnabled: !0,
        moveSelectedRangeByClick: !0,
        manualRangeSelectionEnabled: !0,
        allowSlidersSwap: !0,
        valueChangeMode: "onHandleRelease"
      },
      redrawOnResize: !0,
      chart: {
        barGroupPadding: 0.3,
        minBubbleSize: 12,
        maxBubbleSize: 0.2,
        topIndent: 0.1,
        bottomIndent: 0,
        valueAxis: {
          inverted: !1,
          logarithmBase: 10
        },
        commonSeriesSettings: {
          type: "area",
          aggregation: {
            enabled: void 0
          },
          point: {
            visible: !1
          },
          scatter: {
            point: {
              visible: !0
            }
          }
        }
      }
    },
    map: {
      title: {
        margin: 10
      },
      background: {
        borderWidth: 1,
        borderColor: "#cacaca"
      },
      layer: {
        label: {
          enabled: !1,
          stroke: Nr,
          "stroke-width": 1,
          "stroke-opacity": 0.7,
          font: {
            color: Aie,
            size: 12
          }
        }
      },
      "layer:area": {
        borderWidth: 1,
        borderColor: Nr,
        color: "#d2d2d2",
        hoveredBorderColor: Yp,
        selectedBorderWidth: 2,
        selectedBorderColor: Yp,
        label: {
          "stroke-width": 2,
          font: {
            size: 16
          }
        }
      },
      "layer:line": {
        borderWidth: 2,
        color: "#ba8365",
        hoveredColor: "#a94813",
        selectedBorderWidth: 3,
        selectedColor: "#e55100",
        label: {
          "stroke-width": 2,
          font: {
            size: 16
          }
        }
      },
      "layer:marker": {
        label: {
          enabled: !0,
          "stroke-width": 1,
          font: {
            size: 12
          }
        }
      },
      "layer:marker:dot": {
        borderWidth: 2,
        borderColor: Nr,
        size: 8,
        selectedStep: 2,
        backStep: 18,
        backColor: Nr,
        backOpacity: 0.32,
        shadow: !0
      },
      "layer:marker:bubble": {
        minSize: 20,
        maxSize: 50,
        hoveredBorderWidth: 1,
        hoveredBorderColor: Yp,
        selectedBorderWidth: 2,
        selectedBorderColor: Yp
      },
      "layer:marker:pie": {
        size: 50,
        hoveredBorderWidth: 1,
        hoveredBorderColor: Yp,
        selectedBorderWidth: 2,
        selectedBorderColor: Yp
      },
      "layer:marker:image": {
        size: 20
      },
      legend: {
        verticalAlignment: ah,
        horizontalAlignment: Sn,
        position: vC,
        backgroundOpacity: 0.65,
        border: {
          visible: !0
        },
        paddingLeftRight: 16,
        paddingTopBottom: 12
      },
      controlBar: {
        borderColor: "#5d5d5d",
        borderWidth: 3,
        color: Nr,
        margin: 20,
        opacity: 0.3
      },
      _rtl: {
        legend: {
          itemTextPosition: cd
        }
      }
    },
    treeMap: {
      tile: {
        border: {
          width: 1,
          opacity: 0.2,
          color: "#000000"
        },
        color: "#5f8b95",
        hoverStyle: {
          hatching: {
            opacity: 0.75,
            step: 6,
            width: 2,
            direction: "right"
          },
          border: {}
        },
        selectionStyle: {
          hatching: {
            opacity: 0.5,
            step: 6,
            width: 2,
            direction: "right"
          },
          border: {
            opacity: 1
          }
        },
        label: {
          visible: !0,
          paddingLeftRight: 5,
          paddingTopBottom: 4,
          font: {
            color: "#ffffff",
            weight: 600
          },
          shadow: {
            opacity: 0.6,
            offsetX: 0,
            offsetY: 1,
            blur: 2,
            color: "#000000"
          },
          wordWrap: "normal",
          textOverflow: "ellipsis"
        }
      },
      group: {
        padding: 4,
        border: {
          width: 1
        },
        color: "#eeeeee",
        hoverStyle: {
          hatching: {
            opacity: 0,
            step: 6,
            width: 2,
            direction: "right"
          },
          border: {}
        },
        selectionStyle: {
          hatching: {
            opacity: 0,
            step: 6,
            width: 2,
            direction: "right"
          },
          border: {}
        },
        label: {
          visible: !0,
          paddingLeftRight: 5,
          paddingTopBottom: 4,
          font: {
            color: hC,
            weight: 600
          },
          textOverflow: "ellipsis"
        }
      },
      title: {
        subtitle: {}
      },
      tooltip: {},
      loadingIndicator: {}
    },
    sparkline: {
      lineColor: "#666666",
      lineWidth: 2,
      areaOpacity: 0.2,
      minColor: "#e8c267",
      maxColor: "#e55253",
      barPositiveColor: "#a9a9a9",
      barNegativeColor: "#d7d7d7",
      winColor: "#a9a9a9",
      lossColor: "#d7d7d7",
      firstLastColor: "#666666",
      pointSymbol: "circle",
      pointColor: Nr,
      pointSize: 4,
      type: "line",
      argumentField: "arg",
      valueField: "val",
      winlossThreshold: 0,
      showFirstLast: !0,
      showMinMax: !1,
      tooltip: {
        enabled: !0
      }
    },
    bullet: {
      color: "#e8c267",
      targetColor: "#666666",
      targetWidth: 4,
      showTarget: !0,
      showZeroLevel: !0,
      tooltip: {
        enabled: !0
      }
    },
    polar: {
      commonSeriesSettings: {
        type: "scatter",
        closed: !0,
        point: {
          visible: !0,
          symbol: "circle",
          size: 12,
          border: {
            visible: !1,
            width: 1
          },
          hoverMode: "onlyPoint",
          selectionMode: "onlyPoint",
          hoverStyle: {
            border: {
              visible: !0,
              width: 4
            },
            size: 12
          },
          selectionStyle: {
            border: {
              visible: !0,
              width: 4
            },
            size: 12
          }
        },
        scatter: {},
        line: {
          width: 2,
          dashStyle: ha,
          hoverStyle: {
            width: 3,
            hatching: {
              direction: Ua
            }
          },
          selectionStyle: {
            width: 3
          }
        },
        area: {
          point: {
            visible: !1
          },
          opacity: 0.5
        },
        stackedline: {
          width: 2
        },
        bar: {
          opacity: 0.8
        },
        stackedbar: {
          opacity: 0.8
        }
      },
      adaptiveLayout: {
        width: 80,
        height: 80,
        keepLabels: !0
      },
      barGroupPadding: 0.3,
      commonAxisSettings: {
        visible: !0,
        forceUserTickInterval: !1,
        label: {
          overlappingBehavior: "hide",
          indentFromAxis: 5
        },
        grid: {
          visible: !0
        },
        minorGrid: {
          visible: !0
        },
        tick: {
          visible: !0
        },
        title: {
          font: {
            size: 16
          },
          margin: 10
        }
      },
      argumentAxis: {
        startAngle: 0,
        firstPointOnStartAngle: !1,
        period: void 0
      },
      valueAxis: {
        endOnTick: !1,
        tick: {
          visible: !1
        }
      },
      horizontalAxis: {
        position: Iu,
        axisDivisionFactor: 50,
        label: {
          alignment: Io
        }
      },
      verticalAxis: {
        position: Iu,
        axisDivisionFactor: 30,
        label: {
          alignment: Sn
        }
      }
    },
    funnel: {
      sortData: !0,
      valueField: "val",
      colorField: "color",
      argumentField: "arg",
      hoverEnabled: !0,
      selectionMode: "single",
      item: {
        border: {
          visible: !1,
          width: 2,
          color: Nr
        },
        hoverStyle: {
          hatching: {
            opacity: 0.75,
            step: 6,
            width: 2,
            direction: Sn
          },
          border: {}
        },
        selectionStyle: {
          hatching: {
            opacity: 0.5,
            step: 6,
            width: 2,
            direction: Sn
          },
          border: {}
        }
      },
      title: {
        margin: 10
      },
      adaptiveLayout: {
        width: 80,
        height: 80,
        keepLabels: !0
      },
      legend: {
        visible: !1
      },
      _rtl: {
        legend: {
          itemTextPosition: cd
        }
      },
      tooltip: {
        customizeTooltip: function(e) {
          return {
            text: e.item.argument + " " + e.valueText
          };
        }
      },
      inverted: !1,
      algorithm: "dynamicSlope",
      neckWidth: 0,
      neckHeight: 0,
      resolveLabelOverlapping: "shift",
      label: {
        textOverflow: "ellipsis",
        wordWrap: "normal",
        visible: !0,
        horizontalAlignment: Sn,
        horizontalOffset: 0,
        verticalOffset: 0,
        showForZeroValues: !1,
        customizeText: function(e) {
          return e.item.argument + " " + e.valueText;
        },
        position: "columns",
        font: {
          color: Nr
        },
        border: {
          visible: !1,
          width: 1,
          color: $p,
          dashStyle: ha
        },
        connector: {
          visible: !0,
          width: 1,
          opacity: 0.5
        }
      }
    },
    sankey: {
      sourceField: "source",
      targetField: "target",
      weightField: "weight",
      hoverEnabled: !0,
      alignment: Io,
      adaptiveLayout: {
        width: 80,
        height: 80,
        keepLabels: !0
      },
      label: {
        visible: !0,
        horizontalOffset: 8,
        verticalOffset: 0,
        overlappingBehavior: "ellipsis",
        useNodeColors: !1,
        font: {
          color: Sl,
          weight: 500
        },
        border: {
          visible: !1,
          width: 2,
          color: Nr
        },
        customizeText: function(e) {
          return e.title;
        },
        shadow: {
          opacity: 0.2,
          offsetX: 0,
          offsetY: 1,
          blur: 1,
          color: Nr
        }
      },
      title: {
        margin: 10,
        font: {
          size: 28,
          weight: 200
        },
        subtitle: {
          font: {
            size: 16
          }
        }
      },
      tooltip: {
        enabled: !0
      },
      node: {
        padding: 30,
        width: 8,
        opacity: 1,
        border: {
          color: Nr,
          width: 1,
          visible: !1
        },
        hoverStyle: {
          hatching: {
            opacity: 0.75,
            step: 6,
            width: 2,
            direction: Sn
          },
          border: {}
        }
      },
      link: {
        color: "#888888",
        colorMode: "none",
        opacity: 0.3,
        border: {
          color: Nr,
          width: 1,
          visible: !1
        },
        hoverStyle: {
          opacity: 0.5,
          hatching: {
            opacity: 0.75,
            step: 6,
            width: 2,
            direction: Sn
          },
          border: {}
        }
      }
    }
  },
  baseThemeName: void 0
}, {
  theme: {
    name: "generic.light.compact"
  },
  baseThemeName: "generic.light"
}];
var Wp = "#f05b41", Xp = "#fff", dd = "#333", p2 = "#8899a8", g2 = "#707070", qp = "#dee1e3";
const kie = [{
  theme: {
    name: "generic.carmine",
    defaultPalette: "Carmine",
    backgroundColor: Xp,
    primaryTitleColor: dd,
    secondaryTitleColor: p2,
    gridColor: qp,
    axisColor: g2,
    export: {
      backgroundColor: Xp,
      font: {
        color: dd
      },
      button: {
        default: {
          color: dd,
          borderColor: "#b1b7bd",
          backgroundColor: Xp
        },
        hover: {
          color: dd,
          borderColor: "#b1b7bd",
          backgroundColor: "#faf2f0"
        },
        focus: {
          color: dd,
          borderColor: "#6d7781",
          backgroundColor: "#faf2f0"
        },
        active: {
          color: dd,
          borderColor: "#6d7781",
          backgroundColor: "#f5e7e4"
        }
      }
    },
    legend: {
      font: {
        color: g2
      }
    },
    tooltip: {
      color: Xp,
      border: {
        color: qp
      },
      font: {
        color: dd
      }
    },
    "chart:common": {
      commonSeriesSettings: {
        label: {
          border: {
            color: qp
          }
        }
      }
    },
    "chart:common:annotation": {
      font: {
        color: dd
      },
      border: {
        color: qp
      },
      color: Xp
    },
    chart: {
      commonPaneSettings: {
        border: {
          color: qp
        }
      },
      commonAxisSettings: {
        breakStyle: {
          color: "#c1c5c7"
        }
      }
    },
    rangeSelector: {
      scale: {
        breakStyle: {
          color: "#c1c5c7"
        },
        tick: {
          opacity: 0.12
        }
      },
      selectedRangeColor: Wp,
      sliderMarker: {
        color: Wp
      },
      sliderHandle: {
        color: Wp,
        opacity: 0.5
      }
    },
    sparkline: {
      pointColor: Xp,
      minColor: "#f0ad4e",
      maxColor: "#f74d61"
    },
    treeMap: {
      group: {
        color: qp,
        label: {
          font: {
            color: p2
          }
        }
      }
    },
    bullet: {
      color: Wp
    },
    gauge: {
      valueIndicators: {
        rangebar: {
          color: Wp
        },
        textcloud: {
          color: Wp
        }
      }
    }
  },
  baseThemeName: "generic.light"
}, {
  theme: {
    name: "generic.carmine.compact"
  },
  baseThemeName: "generic.carmine"
}];
var va = "#ffffff", Rie = "#000000", wk = "#2b2b2b", gC = "#b5b5b5", mC = "#303030", Die = "#686868", Ak = "#c7c7c7", Ok = "#8e8e8e", m2 = "#b8b8b8", _C = "#494949";
const Mie = [{
  theme: {
    name: "generic.dark",
    font: {
      color: "#808080"
    },
    backgroundColor: "#2a2a2a",
    primaryTitleColor: "#dedede",
    secondaryTitleColor: "#a3a3a3",
    gridColor: "#555555",
    axisColor: "#a3a3a3",
    export: {
      backgroundColor: "#2a2a2a",
      font: {
        color: "#dbdbdb"
      },
      button: {
        default: {
          color: "#dedede",
          borderColor: "#4d4d4d",
          backgroundColor: "#2e2e2e"
        },
        hover: {
          color: "#dedede",
          borderColor: "#6c6c6c",
          backgroundColor: "#444"
        },
        focus: {
          color: "#dedede",
          borderColor: "#8d8d8d",
          backgroundColor: "#444444"
        },
        active: {
          color: "#dedede",
          borderColor: "#8d8d8d",
          backgroundColor: "#555555"
        }
      },
      shadowColor: "#292929"
    },
    tooltip: {
      color: wk,
      border: {
        color: _C
      },
      font: {
        color: "#929292"
      }
    },
    "chart:common": {
      commonSeriesSettings: {
        label: {
          border: {
            color: _C
          }
        },
        valueErrorBar: {
          color: va
        }
      }
    },
    "chart:common:axis": {
      constantLineStyle: {
        color: va
      }
    },
    "chart:common:annotation": {
      font: {
        color: "#929292"
      },
      border: {
        color: _C
      },
      color: wk,
      shadow: {
        opacity: 8e-3,
        offsetY: 4,
        blur: 8
      }
    },
    chart: {
      commonPaneSettings: {
        border: {
          color: _C
        }
      },
      commonAxisSettings: {
        breakStyle: {
          color: "#818181"
        }
      },
      zoomAndPan: {
        dragBoxStyle: {
          color: va
        }
      }
    },
    gauge: {
      rangeContainer: {
        backgroundColor: gC
      },
      valueIndicators: {
        _default: {
          color: gC
        },
        rangebar: {
          color: "#84788b"
        },
        twocolorneedle: {
          secondColor: "#ba544d"
        },
        trianglemarker: {
          color: "#b7918f"
        },
        textcloud: {
          color: "#ba544d"
        }
      }
    },
    barGauge: {
      backgroundColor: "#3c3c3c"
    },
    rangeSelector: {
      scale: {
        tick: {
          color: va,
          opacity: 0.32
        },
        minorTick: {
          color: va,
          opacity: 0.1
        },
        breakStyle: {
          color: "#818181"
        }
      },
      selectedRangeColor: gC,
      sliderMarker: {
        color: gC,
        font: {
          color: mC
        }
      },
      sliderHandle: {
        color: va,
        opacity: 0.2
      },
      shutter: {
        color: wk,
        opacity: 0.9
      }
    },
    map: {
      background: {
        borderColor: "#3f3f3f"
      },
      layer: {
        label: {
          stroke: Rie,
          font: {
            color: va
          }
        }
      },
      "layer:area": {
        borderColor: mC,
        color: Die,
        hoveredBorderColor: va,
        selectedBorderColor: va
      },
      "layer:line": {
        color: "#c77244",
        hoveredColor: "#ff5d04",
        selectedColor: "#ff784f"
      },
      "layer:marker:bubble": {
        hoveredBorderColor: va,
        selectedBorderColor: va
      },
      "layer:marker:pie": {
        hoveredBorderColor: va,
        selectedBorderColor: va
      },
      legend: {
        border: {
          color: "#3f3f3f"
        },
        font: {
          color: va
        }
      },
      controlBar: {
        borderColor: Ak,
        color: mC
      }
    },
    treeMap: {
      group: {
        color: "#4c4c4c",
        label: {
          font: {
            color: "#a3a3a3"
          }
        }
      }
    },
    sparkline: {
      lineColor: Ak,
      firstLastColor: Ak,
      barPositiveColor: m2,
      barNegativeColor: Ok,
      winColor: m2,
      lossColor: Ok,
      pointColor: mC
    },
    bullet: {
      targetColor: Ok
    },
    funnel: {
      item: {
        border: {
          color: "#2a2a2a"
        }
      }
    },
    sankey: {
      label: {
        font: {
          color: va
        },
        shadow: {
          opacity: 0
        }
      },
      node: {
        border: {
          color: "#2a2a2a"
        }
      },
      link: {
        color: "#888888",
        border: {
          color: "#2a2a2a"
        },
        hoverStyle: {
          color: "#bbbbbb"
        }
      }
    }
  },
  baseThemeName: "generic.light"
}, {
  theme: {
    name: "generic.dark.compact"
  },
  baseThemeName: "generic.dark"
}];
var wt = "#ffffff", Zn = "#000000", D_ = "#cf00da", _2 = "#f8ca00", Lie = "#686868";
const Pie = [{
  theme: {
    name: "generic.contrast",
    defaultPalette: "Bright",
    font: {
      color: wt
    },
    backgroundColor: Zn,
    primaryTitleColor: wt,
    secondaryTitleColor: wt,
    gridColor: wt,
    axisColor: wt,
    export: {
      backgroundColor: Zn,
      font: {
        color: wt
      },
      button: {
        default: {
          color: wt,
          borderColor: wt,
          backgroundColor: Zn
        },
        hover: {
          color: wt,
          borderColor: wt,
          backgroundColor: "#cf00d7"
        },
        focus: {
          color: wt,
          borderColor: "#cf00d7",
          backgroundColor: Zn
        },
        active: {
          color: Zn,
          borderColor: wt,
          backgroundColor: wt
        }
      },
      borderColor: wt,
      menuButtonColor: Zn,
      activeBackgroundColor: wt,
      activeColor: Zn,
      selectedBorderColor: D_,
      selectedColor: D_,
      shadowColor: "none"
    },
    tooltip: {
      border: {
        color: wt
      },
      font: {
        color: wt
      },
      color: Zn
    },
    "chart:common": {
      commonSeriesSettings: {
        valueErrorBar: {
          color: wt
        },
        hoverStyle: {
          hatching: {
            opacity: 0.5
          }
        },
        selectionStyle: {
          hatching: {
            opacity: 0.35
          }
        },
        label: {
          font: {
            color: wt
          },
          border: {
            color: wt
          }
        }
      }
    },
    "chart:common:axis": {
      constantLineStyle: {
        color: wt
      }
    },
    "chart:common:annotation": {
      font: {
        color: wt
      },
      border: {
        color: wt
      },
      color: Zn
    },
    chart: {
      commonSeriesSettings: {},
      crosshair: {
        color: "#cf00d7"
      },
      commonPaneSettings: {
        backgroundColor: Zn,
        border: {
          color: wt
        }
      },
      scrollBar: {
        color: wt
      },
      commonAxisSettings: {
        breakStyle: {
          color: "#cf00d7"
        }
      },
      zoomAndPan: {
        dragBoxStyle: {
          color: wt,
          opacity: 0.7
        }
      }
    },
    pie: {
      commonSeriesSettings: {
        pie: {
          hoverStyle: {
            hatching: {
              opacity: 0.5
            }
          },
          selectionStyle: {
            hatching: {
              opacity: 0.35
            }
          }
        },
        doughnut: {
          hoverStyle: {
            hatching: {
              opacity: 0.5
            }
          },
          selectionStyle: {
            hatching: {
              opacity: 0.35
            }
          }
        },
        donut: {
          hoverStyle: {
            hatching: {
              opacity: 0.5
            }
          },
          selectionStyle: {
            hatching: {
              opacity: 0.35
            }
          }
        }
      }
    },
    gauge: {
      rangeContainer: {
        backgroundColor: wt
      },
      valueIndicators: {
        _default: {
          color: wt
        },
        rangebar: {
          color: wt,
          backgroundColor: Zn
        },
        twocolorneedle: {
          secondColor: wt
        },
        trianglemarker: {
          color: wt
        },
        textcloud: {
          color: wt,
          text: {
            font: {
              color: Zn
            }
          }
        }
      }
    },
    barGauge: {
      backgroundColor: "#3c3c3c"
    },
    rangeSelector: {
      scale: {
        tick: {
          color: wt,
          opacity: 0.4
        },
        minorTick: {
          color: wt,
          opacity: 0.12
        },
        breakStyle: {
          color: "#cf00d7"
        }
      },
      selectedRangeColor: D_,
      sliderMarker: {
        color: D_
      },
      sliderHandle: {
        color: D_,
        opacity: 1
      },
      shutter: {
        opacity: 0.75
      },
      background: {
        color: Zn
      }
    },
    map: {
      background: {
        borderColor: wt
      },
      layer: {
        label: {
          stroke: Zn,
          font: {
            color: wt
          }
        }
      },
      "layer:area": {
        borderColor: Zn,
        color: Lie,
        hoveredBorderColor: wt,
        selectedBorderColor: wt,
        label: {
          font: {
            opacity: 1
          }
        }
      },
      "layer:line": {
        color: "#267cff",
        hoveredColor: "#f613ff",
        selectedColor: wt
      },
      "layer:marker:dot": {
        borderColor: Zn,
        color: _2,
        backColor: Zn,
        backOpacity: 0.32
      },
      "layer:marker:bubble": {
        color: _2,
        hoveredBorderColor: wt,
        selectedBorderColor: wt
      },
      "layer:marker:pie": {
        hoveredBorderColor: wt,
        selectedBorderColor: wt
      },
      controlBar: {
        borderColor: wt,
        color: Zn,
        opacity: 0.3
      }
    },
    treeMap: {
      tile: {
        color: "#70c92f"
      },
      group: {
        color: "#797979",
        label: {
          font: {
            color: wt
          }
        }
      }
    },
    sparkline: {
      pointColor: Zn
    },
    bullet: {},
    polar: {
      commonSeriesSettings: {}
    },
    funnel: {
      label: {
        connector: {
          opacity: 1
        }
      }
    },
    sankey: {
      label: {
        font: {
          color: wt
        },
        shadow: {
          opacity: 0
        }
      },
      node: {
        border: {
          visible: !0,
          width: 1,
          color: wt
        }
      },
      link: {
        opacity: 0.5,
        border: {
          visible: !0,
          width: 1,
          color: wt
        },
        hoverStyle: {
          opacity: 0.9
        }
      }
    }
  },
  baseThemeName: "generic.light"
}, {
  theme: {
    name: "generic.contrast.compact"
  },
  baseThemeName: "generic.contrast"
}];
var Kp = "#3debd3", Cl = "#465672", Nu = "#fff", Iie = "#919bac", y2 = "#c7ccd4", oh = "#596980";
const Nie = [{
  theme: {
    name: "generic.darkmoon",
    defaultPalette: "Dark Moon",
    backgroundColor: Cl,
    primaryTitleColor: Nu,
    secondaryTitleColor: Iie,
    gridColor: oh,
    axisColor: y2,
    export: {
      backgroundColor: Cl,
      font: {
        color: Nu
      },
      button: {
        default: {
          color: Nu,
          borderColor: "#7a889e",
          backgroundColor: Cl
        },
        hover: {
          color: Nu,
          borderColor: "#9da8b8",
          backgroundColor: "#596e92"
        },
        focus: {
          color: Nu,
          borderColor: "#c4cad4",
          backgroundColor: "#596e92"
        },
        active: {
          color: Nu,
          borderColor: "#c4cad4",
          backgroundColor: "#6b80a4"
        }
      }
    },
    legend: {
      font: {
        color: y2
      }
    },
    tooltip: {
      color: "#62789e",
      border: {
        color: oh
      },
      font: {
        color: Nu
      }
    },
    "chart:common": {
      commonSeriesSettings: {
        label: {
          border: {
            color: oh
          }
        }
      }
    },
    "chart:common:annotation": {
      font: {
        color: Nu
      },
      border: {
        color: oh
      },
      color: "#62789e"
    },
    chart: {
      commonPaneSettings: {
        border: {
          color: oh
        }
      },
      commonAxisSettings: {
        breakStyle: {
          color: "#73869e"
        }
      }
    },
    gauge: {
      valueIndicators: {
        rangebar: {
          color: Kp
        },
        textcloud: {
          color: Kp,
          text: {
            font: {
              color: Cl
            }
          }
        }
      }
    },
    barGauge: {
      backgroundColor: "#526280"
    },
    funnel: {
      item: {
        border: {
          color: Cl
        }
      }
    },
    sparkline: {
      pointColor: Cl,
      minColor: "#f0ad4e",
      maxColor: "#f9517e"
    },
    treeMap: {
      group: {
        color: oh,
        label: {
          font: {
            color: Nu
          }
        }
      }
    },
    map: {
      background: {
        borderColor: oh
      },
      "layer:area": {
        color: "#97a3b6",
        borderColor: Cl
      }
    },
    rangeSelector: {
      shutter: {
        color: Cl
      },
      scale: {
        breakStyle: {
          color: "#73869e"
        },
        tick: {
          opacity: 0.2
        }
      },
      selectedRangeColor: Kp,
      sliderMarker: {
        color: Kp,
        font: {
          color: "#000"
        }
      },
      sliderHandle: {
        color: Kp,
        opacity: 0.5
      }
    },
    bullet: {
      color: Kp
    },
    sankey: {
      link: {
        border: {
          color: Cl
        }
      },
      node: {
        border: {
          color: Cl
        }
      }
    }
  },
  baseThemeName: "generic.dark"
}, {
  theme: {
    name: "generic.darkmoon.compact"
  },
  baseThemeName: "generic.darkmoon"
}];
var Zp = "#9c63ff", El = "#17171f", fd = "#f5f6f7", x2 = "#fff", b2 = "#b2b2b6", yC = "#343840";
const Vie = [{
  theme: {
    name: "generic.darkviolet",
    defaultPalette: "Dark Violet",
    backgroundColor: El,
    primaryTitleColor: fd,
    secondaryTitleColor: x2,
    gridColor: yC,
    axisColor: b2,
    export: {
      backgroundColor: El,
      font: {
        color: fd
      },
      button: {
        default: {
          color: fd,
          borderColor: "#414152",
          backgroundColor: El
        },
        hover: {
          color: fd,
          borderColor: "#5c5c74",
          backgroundColor: "#2d2d3c"
        },
        focus: {
          color: fd,
          borderColor: "#7c7c97",
          backgroundColor: "#2d2d3c"
        },
        active: {
          color: fd,
          borderColor: "#7c7c97",
          backgroundColor: "#3c3c51"
        }
      }
    },
    legend: {
      font: {
        color: b2
      }
    },
    tooltip: {
      color: El,
      border: {
        color: "#414152"
      },
      font: {
        color: fd
      }
    },
    "chart:common": {
      commonSeriesSettings: {
        label: {
          border: {
            color: yC
          }
        }
      }
    },
    "chart:common:annotation": {
      font: {
        color: fd
      },
      border: {
        color: "#414152"
      },
      color: El
    },
    chart: {
      commonPaneSettings: {
        border: {
          color: yC
        }
      },
      commonAxisSettings: {
        breakStyle: {
          color: "#575e6b"
        }
      }
    },
    funnel: {
      item: {
        border: {
          color: El
        }
      }
    },
    sparkline: {
      pointColor: El,
      minColor: "#f0ad4e",
      maxColor: "#d9534f"
    },
    treeMap: {
      group: {
        color: yC,
        label: {
          font: {
            color: x2
          }
        }
      }
    },
    rangeSelector: {
      shutter: {
        color: El
      },
      scale: {
        breakStyle: {
          color: "#575e6b"
        },
        tick: {
          opacity: 0.2
        }
      },
      selectedRangeColor: Zp,
      sliderMarker: {
        color: Zp,
        font: {
          color: "#fff"
        }
      },
      sliderHandle: {
        color: Zp,
        opacity: 0.5
      }
    },
    bullet: {
      color: Zp
    },
    gauge: {
      valueIndicators: {
        rangebar: {
          color: Zp
        },
        textcloud: {
          color: Zp
        }
      }
    },
    sankey: {
      link: {
        border: {
          color: El
        }
      },
      node: {
        border: {
          color: El
        }
      }
    }
  },
  baseThemeName: "generic.dark"
}, {
  theme: {
    name: "generic.darkviolet.compact"
  },
  baseThemeName: "generic.darkviolet"
}];
var Qp = "#3cbab2", Jp = "#f5f5f5", hd = "#28484f", S2 = "#7eb2be", C2 = "#657c80", eg = "#dedede";
const Fie = [{
  theme: {
    name: "generic.greenmist",
    defaultPalette: "Green Mist",
    backgroundColor: Jp,
    primaryTitleColor: hd,
    secondaryTitleColor: S2,
    gridColor: eg,
    axisColor: C2,
    export: {
      backgroundColor: Jp,
      font: {
        color: hd
      },
      button: {
        default: {
          color: hd,
          borderColor: "#a2b4b8",
          backgroundColor: Jp
        },
        hover: {
          color: hd,
          borderColor: "#7f989e",
          backgroundColor: "rgba(222, 222, 222, 0.4)"
        },
        focus: {
          color: hd,
          borderColor: "#5f777c",
          backgroundColor: "rgba(222, 222, 222, 0.4)"
        },
        active: {
          color: hd,
          borderColor: "#5f777c",
          backgroundColor: "rgba(222, 222, 222, 0.8)"
        }
      }
    },
    legend: {
      font: {
        color: C2
      }
    },
    tooltip: {
      color: "#fff",
      border: {
        color: eg
      },
      font: {
        color: hd
      }
    },
    "chart:common": {
      commonSeriesSettings: {
        label: {
          border: {
            color: eg
          }
        }
      }
    },
    "chart:common:annotation": {
      color: "#fff",
      border: {
        color: eg
      },
      font: {
        color: hd
      }
    },
    chart: {
      commonPaneSettings: {
        border: {
          color: eg
        }
      },
      commonAxisSettings: {
        breakStyle: {
          color: "#c1c1c1"
        }
      }
    },
    funnel: {
      item: {
        border: {
          color: Jp
        }
      }
    },
    sparkline: {
      pointColor: Jp,
      minColor: "#ffc852",
      maxColor: "#f74a5e"
    },
    treeMap: {
      group: {
        color: eg,
        label: {
          font: {
            color: S2
          }
        }
      }
    },
    rangeSelector: {
      shutter: {
        color: Jp
      },
      scale: {
        breakStyle: {
          color: "#c1c1c1"
        },
        tick: {
          opacity: 0.12
        }
      },
      selectedRangeColor: Qp,
      sliderMarker: {
        color: Qp
      },
      sliderHandle: {
        color: Qp,
        opacity: 0.5
      }
    },
    bullet: {
      color: Qp
    },
    gauge: {
      valueIndicators: {
        rangebar: {
          color: Qp
        },
        textcloud: {
          color: Qp
        }
      }
    }
  },
  baseThemeName: "generic.light"
}, {
  theme: {
    name: "generic.greenmist.compact"
  },
  baseThemeName: "generic.greenmist"
}];
var tg = "#7ab8eb", rg = "#fff", vd = "#333", E2 = "#99a1a8", T2 = "#707070", ng = "#e8eaeb";
const Bie = [{
  theme: {
    name: "generic.softblue",
    defaultPalette: "Soft Blue",
    backgroundColor: rg,
    primaryTitleColor: vd,
    secondaryTitleColor: E2,
    gridColor: ng,
    axisColor: T2,
    export: {
      backgroundColor: rg,
      font: {
        color: vd
      },
      button: {
        default: {
          color: vd,
          borderColor: "#c9d0d4",
          backgroundColor: rg
        },
        hover: {
          color: vd,
          borderColor: "#a7b2b9",
          backgroundColor: "#e6e6e6"
        },
        focus: {
          color: vd,
          borderColor: "#82929b",
          backgroundColor: "#e6e6e6"
        },
        active: {
          color: vd,
          borderColor: "#82929b",
          backgroundColor: "#d4d4d4"
        }
      }
    },
    legend: {
      font: {
        color: T2
      }
    },
    tooltip: {
      color: rg,
      border: {
        color: ng
      },
      font: {
        color: vd
      }
    },
    "chart:common": {
      commonSeriesSettings: {
        label: {
          border: {
            color: ng
          }
        }
      }
    },
    "chart:common:annotation": {
      color: rg,
      border: {
        color: ng
      },
      font: {
        color: vd
      }
    },
    chart: {
      commonPaneSettings: {
        border: {
          color: ng
        }
      },
      commonAxisSettings: {
        breakStyle: {
          color: "#cfd2d3"
        }
      }
    },
    rangeSelector: {
      scale: {
        breakStyle: {
          color: "#cfd2d3"
        },
        tick: {
          opacity: 0.12
        }
      },
      selectedRangeColor: tg,
      sliderMarker: {
        color: tg
      },
      sliderHandle: {
        color: tg,
        opacity: 0.5
      }
    },
    sparkline: {
      pointColor: rg,
      minColor: "#f0ad4e",
      maxColor: "#d9534f"
    },
    treeMap: {
      group: {
        color: ng,
        label: {
          font: {
            color: E2
          }
        }
      }
    },
    bullet: {
      color: tg
    },
    gauge: {
      valueIndicators: {
        rangebar: {
          color: tg
        },
        textcloud: {
          color: tg
        }
      }
    }
  },
  baseThemeName: "generic.light"
}, {
  theme: {
    name: "generic.softblue.compact"
  },
  baseThemeName: "generic.softblue"
}];
var w2 = "'Roboto', 'RobotoFallback', 'Helvetica', 'Arial', sans-serif", zie = "rgba(0,0,0,0.87)", A2 = "rgba(0,0,0,0.54)", O2 = "rgba(255,255,255,0.87)", k2 = "rgba(255,255,255,0.54)", pd = "#363640", ci = "#ffffff", Hie = "#000000", xC = "#b5b5b5", Gie = "#686868", kk = "#c7c7c7", Rk = "#8e8e8e", R2 = "#b8b8b8", D2 = "#494949", M2 = "#818181", JU = [{
  theme: {
    name: "material",
    defaultPalette: "Material",
    font: {
      family: w2
    },
    title: {
      margin: {
        top: 20,
        bottom: 20,
        left: 0,
        right: 0
      },
      font: {
        size: 20,
        family: w2,
        weight: 500
      },
      horizontalAlignment: "left",
      subtitle: {
        font: {
          size: 14
        },
        horizontalAlignment: "left"
      }
    },
    tooltip: {
      shadow: {
        opacity: 0
      },
      border: {
        visible: !1
      },
      paddingLeftRight: 8,
      paddingTopBottom: 6,
      arrowLength: 0,
      location: "edge",
      color: "#616161",
      font: {
        color: ci
      },
      cornerRadius: 4
    },
    chart: {
      commonAxisSettings: {
        minorTick: {
          opacity: 0.5
        },
        label: {
          font: {
            size: 11
          }
        }
      },
      commonAnnotationSettings: {
        font: {
          color: ci
        },
        border: {
          color: "#616161"
        },
        color: "#616161",
        arrowLength: 14,
        arrowWidth: 0,
        shadow: {
          opacity: 0.08,
          offsetY: 4,
          blur: 8
        },
        cornerRadius: 4
      }
    },
    pie: {
      title: {
        horizontalAlignment: "center",
        subtitle: {
          horizontalAlignment: "center"
        }
      }
    },
    polar: {
      commonAxisSettings: {
        minorTick: {
          opacity: 0.5
        }
      },
      title: {
        horizontalAlignment: "center",
        subtitle: {
          horizontalAlignment: "center"
        }
      }
    },
    funnel: {
      title: {
        horizontalAlignment: "center",
        subtitle: {
          horizontalAlignment: "center"
        }
      }
    },
    gauge: {
      title: {
        horizontalAlignment: "center",
        subtitle: {
          horizontalAlignment: "center"
        }
      }
    },
    barGauge: {
      title: {
        horizontalAlignment: "center",
        subtitle: {
          horizontalAlignment: "center"
        }
      }
    },
    rangeSelector: {
      sliderHandle: {
        opacity: 0.5
      }
    },
    treeMap: {
      group: {
        label: {
          font: {
            weight: 500
          }
        }
      }
    }
  },
  baseThemeName: "generic.light"
}, {
  theme: {
    name: "material.light",
    gridColor: "#e0e0e0",
    axisColor: A2,
    primaryTitleColor: zie,
    legend: {
      font: {
        color: A2
      }
    },
    chart: {
      scrollBar: {
        color: "#bfbfbf",
        opacity: 0.7
      }
    },
    gauge: {
      rangeContainer: {
        backgroundColor: "rgba(0,0,0,0.2)"
      }
    },
    barGauge: {
      backgroundColor: "#efefef"
    }
  },
  baseThemeName: "material"
}, {
  theme: {
    name: "material.dark",
    gridColor: "#515159",
    backgroundColor: pd,
    axisColor: k2,
    font: {
      color: k2
    },
    primaryTitleColor: O2,
    secondaryTitleColor: O2,
    tooltip: {
      color: "#000"
    },
    export: {
      backgroundColor: pd,
      font: {
        color: "#dbdbdb"
      },
      button: {
        default: {
          color: "#dedede",
          borderColor: "#4d4d4d",
          backgroundColor: pd
        },
        hover: {
          color: "#dedede",
          borderColor: "#6c6c6c",
          backgroundColor: "#3f3f4b"
        },
        focus: {
          color: "#dedede",
          borderColor: "#8d8d8d",
          backgroundColor: "#494956"
        },
        active: {
          color: "#dedede",
          borderColor: "#8d8d8d",
          backgroundColor: "#494956"
        }
      },
      shadowColor: "#292929"
    },
    "chart:common": {
      commonSeriesSettings: {
        label: {
          border: {
            color: D2
          }
        },
        valueErrorBar: {
          color: ci
        }
      }
    },
    "chart:common:axis": {
      constantLineStyle: {
        color: ci
      }
    },
    "chart:common:annotation": {
      border: {
        color: "#000"
      },
      color: "#000"
    },
    chart: {
      commonPaneSettings: {
        border: {
          color: D2
        }
      },
      commonAxisSettings: {
        breakStyle: {
          color: M2
        }
      },
      zoomAndPan: {
        dragBoxStyle: {
          color: ci
        }
      }
    },
    gauge: {
      rangeContainer: {
        backgroundColor: xC
      },
      valueIndicators: {
        _default: {
          color: xC
        },
        rangebar: {
          color: "#84788b"
        },
        twocolorneedle: {
          secondColor: "#ba544d"
        },
        trianglemarker: {
          color: "#b7918f"
        },
        textcloud: {
          color: "#ba544d"
        }
      }
    },
    barGauge: {
      backgroundColor: "#3c3c3c"
    },
    rangeSelector: {
      scale: {
        tick: {
          color: ci,
          opacity: 0.32
        },
        minorTick: {
          color: ci,
          opacity: 0.1
        },
        breakStyle: {
          color: M2
        }
      },
      selectedRangeColor: xC,
      sliderMarker: {
        color: xC,
        font: {
          color: pd
        }
      },
      sliderHandle: {
        color: ci,
        opacity: 0.2
      },
      shutter: {
        color: ci,
        opacity: 0.1
      }
    },
    map: {
      background: {
        borderColor: "#3f3f3f"
      },
      layer: {
        label: {
          stroke: Hie,
          font: {
            color: ci
          }
        }
      },
      "layer:area": {
        borderColor: pd,
        color: Gie,
        hoveredBorderColor: ci,
        selectedBorderColor: ci
      },
      "layer:line": {
        color: "#c77244",
        hoveredColor: "#ff5d04",
        selectedColor: "#ff784f"
      },
      "layer:marker:bubble": {
        hoveredBorderColor: ci,
        selectedBorderColor: ci
      },
      "layer:marker:pie": {
        hoveredBorderColor: ci,
        selectedBorderColor: ci
      },
      legend: {
        border: {
          color: "#3f3f3f"
        },
        font: {
          color: ci
        }
      },
      controlBar: {
        borderColor: kk,
        color: pd
      }
    },
    treeMap: {
      group: {
        color: "#4c4c4c",
        label: {
          font: {
            color: "#a3a3a3"
          }
        }
      }
    },
    sparkline: {
      lineColor: kk,
      firstLastColor: kk,
      barPositiveColor: R2,
      barNegativeColor: Rk,
      winColor: R2,
      lossColor: Rk,
      pointColor: pd
    },
    bullet: {
      targetColor: Rk
    },
    funnel: {
      item: {
        border: {
          color: pd
        }
      }
    },
    sankey: {
      label: {
        font: {
          color: ci
        }
      }
    }
  },
  baseThemeName: "material"
}];
function L2(e, t, r) {
  return {
    theme: {
      name: "material." + e + "." + t,
      rangeSelector: {
        selectedRangeColor: r,
        sliderMarker: {
          color: r
        },
        sliderHandle: {
          color: r
        }
      },
      map: {
        "layer:marker:dot": {
          color: r
        },
        "layer:marker:bubble": {
          color: r
        },
        legend: {
          markerColor: r
        }
      },
      bullet: {
        color: r
      },
      gauge: {
        valueIndicators: {
          rangebar: {
            color: r
          },
          textcloud: {
            color: r
          }
        }
      }
    },
    baseThemeName: "material." + t
  };
}
var Dk = {
  blue: "#03a9f4",
  lime: "#cddc39",
  orange: "#ff5722",
  purple: "#9c27b0",
  teal: "#009688"
};
for (var gd in Dk)
  if (Object.prototype.hasOwnProperty.call(Dk, gd)) {
    var P2 = Dk[gd];
    JU.push(L2(gd, "light", P2), L2(gd, "dark", P2), {
      theme: {
        name: "material.".concat(gd, ".light.compact")
      },
      baseThemeName: "material.".concat(gd, ".light")
    }, {
      theme: {
        name: "material.".concat(gd, ".dark.compact")
      },
      baseThemeName: "material.".concat(gd, ".dark")
    });
  }
var Uie = [{
  theme: {
    name: "fluent.blue.light"
  },
  baseThemeName: "material.blue.light"
}, {
  theme: {
    name: "fluent.blue.light.compact"
  },
  baseThemeName: "fluent.blue.light"
}, {
  theme: {
    name: "fluent.blue.dark"
  },
  baseThemeName: "material.blue.dark"
}, {
  theme: {
    name: "fluent.blue.dark.compact"
  },
  baseThemeName: "fluent.blue.dark"
}], ZE = {}, Md = {}, jie = {}, gL = W, $u = be, Mk = null, mL, $ie = 0, ej = {};
function tj(e) {
  var t = Wt(e);
  return ZE[t] || ZE[Md[t] || Wie()];
}
function QE(e, t) {
  return Md[e + "." + t] || jie[e + "." + t] || Md[e];
}
function Yie(e, t, r) {
  return QE(e + t, r) || QE(e, r);
}
function Wie(e, t) {
  if (!arguments.length)
    return Mk || QE(pL()) || mL;
  var r = Wt(t);
  return Mk = (e && e.platform ? Yie(Wt(e.platform), e.version, r) : QE(Wt(e), r)) || Mk, this;
}
function Xie(e, t) {
  var r = e.indexOf(t);
  return r > 0 ? {
    name: e.substring(0, r),
    scheme: e.substring(r + 1)
  } : null;
}
function qie(e, t) {
  var r = Xie(e, ".") || {
    name: e
  }, n = r.name, i = r.scheme;
  i ? (Md[n] = Md[n] || t, Md[n + "." + i] = t) : Md[n] = t;
}
function Kie(e, t) {
  var r = Wt(e && e.name);
  r && (e.isDefault && (mL = r), qie(r, r), ZE[r] = gL(!0, {}, tj(t), Zie(e)));
}
function Qn(e, t, r, n) {
  var i = r ? r[t] : n;
  i !== void 0 && e[t] === void 0 && (e[t] = i);
}
function fo(e, t, r, n) {
  var i = r ? r[t] : n;
  i !== void 0 && (e[t] = gL(!0, {}, i, e[t]));
}
function Zie(e) {
  return e = gL(!0, {
    loadingIndicator: {
      font: {}
    },
    export: {
      font: {}
    },
    legend: {
      font: {},
      border: {}
    },
    title: {
      font: {}
    },
    tooltip: {
      font: {}
    },
    "chart:common": {},
    "chart:common:axis": {
      grid: {},
      minorGrid: {},
      tick: {},
      minorTick: {},
      title: {
        font: {}
      },
      label: {
        font: {}
      }
    },
    "chart:common:annotation": {
      font: {},
      border: {}
    },
    chart: {
      commonSeriesSettings: {
        candlestick: {}
      }
    },
    pie: {},
    polar: {},
    gauge: {
      scale: {
        tick: {},
        minorTick: {},
        label: {
          font: {}
        }
      }
    },
    barGauge: {},
    funnel: {},
    sankey: {},
    map: {
      background: {}
    },
    treeMap: {
      tile: {
        selectionStyle: {
          border: {}
        }
      },
      group: {
        border: {},
        selectionStyle: {
          border: {}
        },
        label: {
          font: {}
        }
      }
    },
    rangeSelector: {
      scale: {
        tick: {},
        minorTick: {},
        label: {
          font: {}
        }
      },
      chart: {}
    },
    sparkline: {},
    bullet: {}
  }, e), Qn(e.loadingIndicator, "backgroundColor", e), Qn(e.chart.commonSeriesSettings.candlestick, "innerColor", null, e.backgroundColor), Qn(e.map.background, "color", null, e.backgroundColor), Qn(e.title.font, "color", null, e.primaryTitleColor), fo(e.title, "subtitle", null, e.title), Qn(e.legend.font, "color", null, e.secondaryTitleColor), Qn(e.legend.border, "color", null, e.gridColor), Qie(e), $u(["chart", "pie", "polar", "gauge", "barGauge", "map", "treeMap", "funnel", "rangeSelector", "sparkline", "bullet", "sankey"], function(t, r) {
    Qn(e[r], "redrawOnResize", e), Qn(e[r], "containerBackgroundColor", null, e.backgroundColor), fo(e[r], "tooltip", e), fo(e[r], "export", e);
  }), $u(["chart", "pie", "polar", "gauge", "barGauge", "map", "treeMap", "funnel", "rangeSelector", "sankey"], function(t, r) {
    fo(e[r], "loadingIndicator", e), fo(e[r], "legend", e), fo(e[r], "title", e);
  }), $u(["chart", "pie", "polar"], function(t, r) {
    fo(e, r, null, e["chart:common"]);
  }), $u(["chart", "polar"], function(t, r) {
    e[r] = e[r] || {}, fo(e[r], "commonAxisSettings", null, e["chart:common:axis"]);
  }), $u(["chart", "polar", "map", "pie"], function(t, r) {
    e[r] = e[r] || {}, fo(e[r], "commonAnnotationSettings", null, e["chart:common:annotation"]);
  }), fo(e.rangeSelector.chart, "commonSeriesSettings", e.chart), fo(e.rangeSelector.chart, "dataPrepareSettings", e.chart), Qn(e.treeMap.group.border, "color", null, e.gridColor), Qn(e.treeMap.tile.selectionStyle.border, "color", null, e.primaryTitleColor), Qn(e.treeMap.group.selectionStyle.border, "color", null, e.primaryTitleColor), Qn(e.map.legend, "backgroundColor", e), Jie(e), e;
}
function Qie(e) {
  var t = e["chart:common:axis"];
  $u([t.grid, t.minorGrid], function(r, n) {
    Qn(n, "color", null, e.gridColor);
  }), $u([t, t.tick, t.minorTick, t.label.font], function(r, n) {
    Qn(n, "color", null, e.axisColor);
  }), Qn(t.title.font, "color", null, e.secondaryTitleColor), Qn(e.gauge.scale.label.font, "color", null, e.axisColor), Qn(e.gauge.scale.tick, "color", null, e.backgroundColor), Qn(e.gauge.scale.minorTick, "color", null, e.backgroundColor), Qn(e.rangeSelector.scale.label.font, "color", null, e.axisColor);
}
function Jie(e) {
  var t = e.map;
  $u(["area", "line", "marker"], function(r, n) {
    fo(t, "layer:" + n, null, t.layer);
  }), $u(["dot", "bubble", "pie", "image"], function(r, n) {
    fo(t, "layer:marker:" + n, null, t["layer:marker"]);
  });
}
function eae(e) {
  var t = ++$ie;
  e._cache = t, ej[t] = e;
}
function tae(e) {
  delete ej[e._cache];
}
Bd(ZE) && Bd(Md) && !mL && [].concat(Oie, kie, Mie, Pie, Nie, Vie, Fie, Bie, JU, Uie).forEach((e) => {
  Kie(e.theme, e.baseThemeName);
});
var rae = tj, nae = eae, iae = tae, ig = W, kD = be;
function I2(e, t) {
  var r = e;
  return t && kD(t.split("."), function(n, i) {
    return r = r[i];
  }), r;
}
var rj = Qi.inherit({
  ctor: function(e) {
    this._themeSection = e.themeSection, this._fontFields = e.fontFields || [], nae(this);
  },
  dispose: function() {
    return iae(this), this._callback = this._theme = this._font = null, this;
  },
  setCallback: function(e) {
    return this._callback = e, this;
  },
  setTheme: function(e, t) {
    return this._current = e, this._rtl = t, this.refresh();
  },
  refresh: function() {
    var e = this._current || {}, t = rae(e.name || e);
    return this._themeName = t.name, this._defaultPalette = t.defaultPalette, this._font = ig({}, t.font, e.font), this._themeSection && kD(this._themeSection.split("."), function(r, n) {
      t = ig(!0, {}, t[n]);
    }), this._theme = ig(!0, {}, t, lr(e) ? {} : e), this._initializeTheme(), zG(this._rtl, this._theme.rtlEnabled) && ig(!0, this._theme, this._theme._rtl), this._callback(), this;
  },
  theme: function(e) {
    return I2(this._theme, e);
  },
  themeName: function() {
    return this._themeName;
  },
  createPalette: function(e, t) {
    return lie(e, t, this._defaultPalette);
  },
  createDiscretePalette: function(e, t) {
    return fie(e, t, this._defaultPalette);
  },
  createGradientPalette: function(e) {
    return vie(e, this._defaultPalette);
  },
  getAccentColor: function(e) {
    return nie(e, this._defaultPalette);
  },
  _initializeTheme: function() {
    var e = this;
    kD(e._fontFields || [], function(t, r) {
      e._initializeFont(I2(e._theme, r));
    });
  },
  _initializeFont: function(e) {
    ig(e, this._font, ig({}, e));
  }
}), aae = rj.inherit(/* @__PURE__ */ function() {
  var e = function(i) {
    if (!i)
      return {};
    i = W(!0, {}, i), i.title = (s = i.title, lr(s) ? {
      text: s
    } : s);
    var s;
    return (i.type === "logarithmic" && i.logarithmBase <= 0 || i.logarithmBase && !Sr(i.logarithmBase)) && (i.logarithmBase = void 0, i.logarithmBaseError = !0), i.label && i.label.alignment && (i.label.userAlignment = !0), i;
  }, t = function(i, s, l) {
    var d = this._theme, h = l ^ i === "valueAxis" ? "verticalAxis" : "horizontalAxis", p = e(s), m = e(this._userOptions.commonAxisSettings), x = W(!0, {}, d.commonAxisSettings, d[h], d[i], m, p);
    return x.workWeek = p.workWeek || d[i].workWeek, x.forceUserTickInterval |= I(p.tickInterval) && !I(p.axisDivisionFactor), x;
  }, r = function(i, s) {
    s = s || this._userOptions[i];
    var l = this._theme[i], d = this._mergedSettings[i];
    return d || (Qr(l) && Qr(s) ? d = W(!0, {}, l, s) : d = I(s) ? s : l, this._mergedSettings[i] = d, d);
  }, n = {
    base: r,
    argumentAxis: t,
    valueAxisRangeSelector: function() {
      return r.call(this, "valueAxis");
    },
    valueAxis: t,
    series: function(i, s, l) {
      var d = this, h = d._theme, p = d._userOptions.commonSeriesSettings || {}, m = h.commonSeriesSettings, x = d._themeSection.split(".").slice(-1)[0], S = Wt(s.type || p.type || m.type || x === "pie" && h.type), T = d.palette, k = ~S.indexOf("bar"), O = ~S.indexOf("line"), D = ~S.indexOf("area"), L = S === "bubble", F, z = d.getOptions("resolveLabelsOverlapping"), V = d.getOptions("containerBackgroundColor"), P = n.seriesTemplate.call(this), j;
      (k || L) && (s = W(!0, {}, p, p[S], s), j = s.visible, p = {
        type: {}
      }, W(!0, s, s.point), s.visible = j);
      var Z = W(!0, {
        aggregation: {}
      }, m, m[S], p, p[S], s);
      return Z.aggregation.enabled = x === "chart" && !!Z.aggregation.enabled, Z.type = S, Z.widgetType = x, Z.containerBackgroundColor = V, x !== "pie" ? F = xa(Z.color, !0) || T.getNextColor(l) : F = function(ee, J, he) {
        var de = "".concat(ee, "-").concat(J);
        return d._multiPieColors[de] || (d._multiPieColors[de] = T.getNextColor(he)), d._multiPieColors[de];
      }, Z.mainSeriesColor = F, Z.resolveLabelsOverlapping = z, Z.label && (O || D && S !== "rangearea" || S === "scatter") && (Z.label.position = "outside"), P && (Z.nameField = P.nameField), Z;
    },
    animation: function(i) {
      var s = this._userOptions[i];
      return s = Qr(s) ? s : I(s) ? {
        enabled: !!s
      } : {}, r.call(this, i, s);
    },
    seriesTemplate() {
      var i = r.call(this, "seriesTemplate");
      return i && (i.nameField = i.nameField || "series"), i;
    },
    zoomAndPan() {
      function i(l) {
        l = Wt(l);
        var d = l === "pan" || l === "both", h = l === "zoom" || l === "both";
        return {
          pan: d,
          zoom: h,
          none: !d && !h
        };
      }
      var s = r.call(this, "zoomAndPan");
      return {
        valueAxis: i(s.valueAxis),
        argumentAxis: i(s.argumentAxis),
        dragToZoom: !!s.dragToZoom,
        dragBoxStyle: {
          class: "dxc-shutter",
          fill: s.dragBoxStyle.color,
          opacity: s.dragBoxStyle.opacity
        },
        panKey: s.panKey,
        allowMouseWheel: !!s.allowMouseWheel,
        allowTouchGestures: !!s.allowTouchGestures
      };
    }
  };
  return {
    _themeSection: "chart",
    ctor: function(i) {
      var s = this;
      s.callBase.apply(s, arguments);
      var l = i.options || {};
      s._userOptions = l, s._mergeAxisTitleOptions = [], s._multiPieColors = {}, s._callback = Y;
    },
    dispose: function() {
      var i = this;
      return i.palette && i.palette.dispose(), i.palette = i._userOptions = i._mergedSettings = i._multiPieColors = null, i.callBase.apply(i, arguments);
    },
    resetPalette: function() {
      this.palette.reset(), this._multiPieColors = {};
    },
    getOptions: function(i) {
      return (n[i] || n.base).apply(this, arguments);
    },
    refresh: function() {
      return this._mergedSettings = {}, this.callBase.apply(this, arguments);
    },
    _initializeTheme: function() {
      var i = this;
      i.callBase.apply(i, arguments), i.updatePalette();
    },
    resetOptions: function(i) {
      this._mergedSettings[i] = null;
    },
    update: function(i) {
      this._userOptions = i;
    },
    updatePalette: function() {
      this.palette = this.createPalette(this.getOptions("palette"), {
        useHighlight: !0,
        extensionMode: this.getOptions("paletteExtensionMode")
      });
    }
  };
}()), Ih = "string", _L = "numeric", RD = "datetime", JE = "discrete", Lk = "semidiscrete", DD = "continuous", Pk = "logarithmic", nj = "valueType", ij = "argumentType", N2 = ST([Ih, _L, RD]), oae = Array.isArray;
function sae(e, t, r, n) {
  n >= 0 && e.slice(n).forEach(function(i) {
    I(i[r]) && (t[r] += i[r], i[r] = void 0);
  });
}
function lae(e) {
  e.forEach(function(t) {
    t.valueType = t.valueAxisType = null, t.series.forEach(function(r) {
      r.updateDataType({});
    }), t.valueAxis && t.valueAxis.resetTypes(nj);
  });
}
function aj(e, t, r) {
  var n = t ? function(i, s) {
    return i - s;
  } : function(i, s) {
    return s - i;
  };
  return e.sort(function(i, s) {
    var l = r(i), d = r(s), h = I(l) ? 1 : 0, p = I(d) ? 1 : 0;
    return h && p ? n(l, d) : n(h, p);
  }), e;
}
function uae(e) {
  e && e.forEach(function(t) {
    t.resetTypes(ij);
  });
}
function V2(e, t) {
  var r = [];
  return e.forEach(function(n) {
    var i = t(n);
    i !== void 0 && r.push(i);
  }), r;
}
function cae(e, t) {
  var r = e.argumentOptions && e.argumentOptions.categories;
  e.groups.forEach(function(n, i) {
    var s = n.valueOptions && n.valueOptions.categories;
    s && (n.valueOptions.categories = V2(s, t[i + 1]));
  }), r && (e.argumentOptions.categories = V2(r, t[0]));
}
function F2(e) {
  return e;
}
function oj(e, t) {
  var r = t;
  return t === Ih || lr(e) ? r = Ih : t === RD || Ls(e) ? r = RD : Sr(e) && (r = _L), r;
}
function B2(e, t, r, n) {
  return e === Ih && (t === DD || t === Pk || t === Lk) && n("E2002"), t === Pk ? Pk : r || t === JE || e === Ih ? JE : t === Lk ? Lk : DD;
}
function dae(e, t, r) {
  e && r(!Sr(e) && !Ls(e) && !lr(e) ? "E2003" : "E2004", [t]);
}
function Ik(e, t, r) {
  var n = e ? cU(e) : F2, i = t !== JE ? function(s) {
    return isFinite(s) || s === void 0 ? s : null;
  } : F2;
  return function(s, l) {
    var d = i(n(s));
    return d === void 0 && dae(s, l, r), d;
  };
}
function fae(e, t) {
  var r = Ik(e.argumentType, e.argumentAxisType, t), n, i, s = [r], l = {}, d = [];
  e.groups.forEach(function(p, m) {
    p.series.forEach(function(x) {
      i = Ik(p.valueType, p.valueAxisType, t), n = Ik(_L, DD, t), l[x.getArgumentField()] = r, x.getValueFields().forEach(function(S) {
        s[m + 1] = i, l[S] = i;
      }), x.getSizeField() && (l[x.getSizeField()] = n);
    });
  });
  for (var h in l)
    d.push([h, l[h]]);
  return d.length && cae(e, s), d;
}
function hae(e, t) {
  var r, n = t.length, i = W({}, e), s, l;
  for (r = 0; r < n; ++r)
    s = t[r][0], l = e[s], i[s] = t[r][1](l, s);
  return i;
}
function vae(e, t) {
  var r = [], n, i = e.length;
  for (r.length = i, n = 0; n < i; ++n)
    r[n] = hae(e[n], t);
  return r;
}
function pae(e, t, r) {
  var n, i = e.length, s;
  for (n = 0; n < i && (s = e[n][t], !(I(s) && r > s)); ++n)
    ;
  return n;
}
function gae(e, t, r, n) {
  n = n || {};
  var i = n.mode, s = {};
  if (!(!i || i === "none")) {
    s[t] = String(n.groupName || "others"), s[r] = 0;
    var l = aj(e.slice(), !1, function(d) {
      return d[r];
    });
    sae(l, s, r, i === "smallValueThreshold" ? pae(l, r, n.threshold) : n.topCount), s[r] && e.push(s);
  }
}
function mae(e, t) {
  var r = t.groups[0] && t.groups[0].series[0], n = r && (r.type === "pie" || r.type === "doughnut" || r.type === "donut");
  n && t.groups.forEach(function(i) {
    i.series.forEach(function(s) {
      gae(e, s.getArgumentField(), s.getValueFields()[0], s.getOptions().smallValuesGrouping);
    });
  });
}
function _ae(e, t, r) {
  r[e] || (t.push(e), r[e] = !0);
}
function yae(e) {
  var t = [], r = {};
  return e.groups.forEach(function(n) {
    n.series.forEach(function(i) {
      _ae(i.getArgumentField(), t, r);
    });
  }), t;
}
function sj(e, t) {
  var r = e - t;
  return isNaN(r) ? I(e) ? I(t) ? 0 : -1 : 1 : r;
}
function xae(e, t) {
  return e.slice().sort(function(r, n) {
    return sj(r[t], n[t]);
  });
}
function bae(e, t) {
  return e.slice().sort(t);
}
function Sae(e, t) {
  return e.series.forEach(function(r) {
    r.getValueFields().forEach(function(n) {
      e.valueType = oj(t[n], e.valueType);
    });
  }), e.valueType;
}
function Cae(e) {
  var t = {};
  return e.forEach(function(r, n) {
    t[r] = n;
  }), function(r, n) {
    return aj(r.slice(), !0, function(i) {
      return t[i[n]];
    });
  };
}
function Eae(e, t, r, n) {
  var i = {}, s = t.argumentAxisType === JE, l = s && t.argumentOptions && t.argumentOptions.categories, d = function(m) {
    return m;
  }, h = r.sortingMethod, p;
  return !l && ct(h) && (e = bae(e, h)), s && (t.categories = wae(e, n, l)), l || !ct(h) && t.argumentType === Ih && !r._skipArgumentSorting ? d = Cae(t.categories) : h === !0 && t.argumentType !== Ih && (d = xae, p = s), n.forEach(function(m) {
    i[m] = d(e, m);
  }), p && (t.categories = t.categories.sort(sj)), i;
}
function Tae(e, t) {
  return e.map(function(r) {
    return r.valueOf();
  }).indexOf(t.valueOf()) === -1;
}
function wae(e, t, r) {
  var n = r ? r.slice() : [];
  return t.forEach(function(i) {
    e.forEach(function(s) {
      var l = s[i];
      I(l) && Tae(n, l) && n.push(l);
    });
  }), n;
}
function Aae(e, t, r) {
  return e.forEach(function(n) {
    r.argumentType = oj(t[n.getArgumentField()], r.argumentType);
  }), r.argumentType;
}
function Oae(e, t, r) {
  var n = [], i = [], s = t.argumentOptions && N2(t.argumentOptions.argumentType), l;
  t.groups.forEach(function(d) {
    if (d.series.length) {
      var h = d.valueOptions && N2(d.valueOptions.valueType);
      d.valueType = h, t.argumentType = s, !h && n.push(d), !s && i.push(d);
    }
  }), (n.length || i.length) && (l = n.map(function(d, h) {
    return h;
  }), e.some(function(d) {
    var h;
    if (n.forEach(function(p, m) {
      Sae(p, d) && l.indexOf(m) >= 0 && l.splice(m, 1);
    }), h || i.forEach(function(p) {
      h = Aae(p.series, d, t);
    }), !r && h && l.length === 0)
      return !0;
  }));
}
function kae(e, t) {
  var r = e.argumentOptions || {}, n = r && r.categories || [], i = B2(e.argumentType, r.type, !!n.length, t);
  e.groups.forEach(function(s) {
    var l = s.valueOptions || {}, d = l.categories || [], h = B2(s.valueType, l.type, !!d.length, t);
    s.series.forEach(function(p) {
      var m = {};
      m.argumentAxisType = i, m.valueAxisType = h, e.argumentAxisType = e.argumentAxisType || m.argumentAxisType, s.valueAxisType = s.valueAxisType || m.valueAxisType, m.argumentType = e.argumentType, m.valueType = s.valueType, m.showZero = l.showZero, p.updateDataType(m);
    }), s.valueAxisType = s.valueAxisType || h, s.valueAxis && (s.valueAxis.setTypes(s.valueAxisType, s.valueType, nj), s.valueAxis.validate());
  }), e.argumentAxisType = e.argumentAxisType || i, e.argumentAxes && e.argumentAxes.forEach(function(s) {
    s.setTypes(e.argumentAxisType, e.argumentType, ij), s.validate();
  });
}
function Rae(e, t) {
  var r = [], n = I(e), i = n && !oae(e), s, l, d, h;
  if (n && !i)
    for (s = 0, l = e.length, d = 0; s < l; ++s)
      h = e[s], hi(h) ? r[d++] = h : h && (i = !0);
  return i && t("E2001"), r;
}
function Dae(e, t, r, n) {
  e = Rae(e, r), t.argumentType = t.argumentAxisType = null, lae(t.groups), uae(t.argumentAxes), Oae(e, t, n.checkTypeForAllData), kae(t, r), n.convertToAxisDataType && (e = vae(e, fae(t, r))), mae(e, t);
  var i = Eae(e, t, n, yae(t));
  return i;
}
var yg = Number, Mae = ST(["left", "center", "right"]), Lae = ST(["top", "bottom"]), Pae = 10;
function Nk(e) {
  return !!(e && String(e).length > 0);
}
function z2(e, t, r, n, i) {
  e.attr({
    text: t
  }).setMaxSize(r, i, n).textChanged && e.setTitle(t);
}
function bC(e) {
  return e >= 0 ? yg(e) : Pae;
}
function Iae(e) {
  var t;
  return e >= 0 ? t = {
    left: yg(e),
    top: yg(e),
    right: yg(e),
    bottom: yg(e)
  } : (e = e || {}, t = {
    left: bC(e.left),
    top: bC(e.top),
    right: bC(e.right),
    bottom: bC(e.bottom)
  }), t;
}
function Nae(e, t) {
  return e[2] - e[0] < t.width || e[3] - e[1] < t.height;
}
var yL = function(e) {
  this._params = e, this._group = e.renderer.g().attr({
    class: e.cssClass
  }).linkOn(e.root || e.renderer.root, "title"), this._hasText = !1;
};
W(yL.prototype, fy.prototype, {
  dispose: function() {
    this._group.linkRemove(), this._group.linkOff(), this._titleElement && (this._clipRect.dispose(), this._titleElement = this._subtitleElement = this._clipRect = null), this._params = this._group = this._options = null;
  },
  _updateOptions: function(e) {
    this._options = e, this._options.horizontalAlignment = Mae(e.horizontalAlignment, "center"), this._options.verticalAlignment = Lae(e.verticalAlignment, "top"), this._options.margin = Iae(e.margin);
  },
  _updateStructure: function() {
    var e = this._params.renderer, t = this._group, r = this._options, n = r.horizontalAlignment;
    this._titleElement || (this._titleElement = e.text().append(t), this._subtitleElement = e.text(), this._clipRect = e.clipRect(), t.attr({
      "clip-path": this._clipRect.id
    })), this._titleElement.attr({
      align: n,
      class: r.cssClass
    }), this._subtitleElement.attr({
      align: n,
      class: r.subtitle.cssClass
    }), t.linkAppend(), Nk(r.subtitle.text) ? this._subtitleElement.append(t) : this._subtitleElement.remove();
  },
  _updateTexts: function() {
    var e = this._options, t = e.subtitle, r = this._titleElement, n = this._subtitleElement, i;
    r.attr({
      text: "A",
      y: 0
    }).css(Oi(e.font)), i = r.getBBox(), this._baseLineCorrection = i.height + i.y, r.attr({
      text: e.text
    }), i = r.getBBox();
    var s = -i.y;
    r.attr({
      y: s
    }), Nk(t.text) && n.attr({
      text: t.text,
      y: 0
    }).css(Oi(t.font));
  },
  _shiftSubtitle() {
    var e = this._titleElement.getBBox(), t = this._subtitleElement, r = this._options.subtitle.offset;
    t.move(0, e.y + e.height - t.getBBox().y - r);
  },
  _updateBoundingRectAlignment: function() {
    var e = this._boundingRect, t = this._options;
    e.verticalAlignment = t.verticalAlignment, e.horizontalAlignment = t.horizontalAlignment, e.cutLayoutSide = t.verticalAlignment, e.cutSide = "vertical", e.position = {
      horizontal: t.horizontalAlignment,
      vertical: t.verticalAlignment
    };
  },
  hasText: function() {
    return this._hasText;
  },
  update: function(e, t) {
    var r = W(!0, {}, e, Vae(t)), n = Nk(r.text), i = n || n !== this._hasText;
    return this._baseLineCorrection = 0, this._updateOptions(r), this._boundingRect = {}, n ? (this._updateStructure(), this._updateTexts()) : this._group.linkRemove(), this._updateBoundingRect(), this._updateBoundingRectAlignment(), this._hasText = n, i;
  },
  draw: function(e, t) {
    return this._hasText && (this._group.linkAppend(), this._correctTitleLength(e), this._group.getBBox().height > t && this.freeSpace()), this;
  },
  _correctTitleLength: function(e) {
    var t = this._options, r = t.margin, n = e - r.left - r.right, i = t.placeholderSize;
    z2(this._titleElement, t.text, n, t, i), this._subtitleElement && (yg(i) > 0 && (i -= this._titleElement.getBBox().height), z2(this._subtitleElement, t.subtitle.text, n, t.subtitle, i), this._shiftSubtitle()), this._updateBoundingRect();
    var {
      x: s,
      y: l,
      height: d
    } = this.getCorrectedLayoutOptions();
    this._clipRect.attr({
      x: s,
      y: l,
      width: e,
      height: d
    });
  },
  getLayoutOptions: function() {
    return this._boundingRect || null;
  },
  shift: function(e, t) {
    var r = this.getLayoutOptions();
    return this._group.move(e - r.x, t - r.y), this;
  },
  _updateBoundingRect: function() {
    var e = this._options, t = e.margin, r = this._boundingRect, n = this._hasText ? this._group.getBBox() : {
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      isEmpty: !0
    };
    n.isEmpty || (n.height += t.top + t.bottom - this._baseLineCorrection, n.width += t.left + t.right, n.x -= t.left, n.y += this._baseLineCorrection - t.top), e.placeholderSize > 0 && (n.height = e.placeholderSize), r.height = n.height, r.width = n.width, r.x = n.x, r.y = n.y;
  },
  getCorrectedLayoutOptions() {
    var e = this.getLayoutOptions(), t = this._baseLineCorrection;
    return W({}, e, {
      y: e.y - t,
      height: e.height + t
    });
  },
  layoutOptions: function() {
    return this._hasText ? {
      horizontalAlignment: this._boundingRect.horizontalAlignment,
      verticalAlignment: this._boundingRect.verticalAlignment,
      priority: 0
    } : null;
  },
  measure: function(e) {
    return this.draw(e[0], e[1]), [this._boundingRect.width, this._boundingRect.height];
  },
  move: function(e, t) {
    var r = this._boundingRect;
    Nae(e, r) ? this.shift(t[0], t[1]) : this.shift(Math.round(e[0]), Math.round(e[1]));
  },
  freeSpace: function() {
    this._params.incidentOccurred("W2103"), this._group.linkRemove(), this._boundingRect.width = this._boundingRect.height = 0;
  },
  getOptions: function() {
    return this._options;
  },
  changeLink: function(e) {
    this._group.linkRemove(), this._group.linkOn(e, "title");
  }
});
function Vae(e) {
  var t = lr(e) ? {
    text: e
  } : e || {};
  return t.subtitle = lr(t.subtitle) ? {
    text: t.subtitle
  } : t.subtitle || {}, t;
}
var Fae = {
  name: "title",
  init: function() {
    this._title = new yL({
      renderer: this._renderer,
      cssClass: this._rootClassPrefix + "-title",
      incidentOccurred: this._incidentOccurred
    }), this._layout.add(this._title);
  },
  dispose: function() {
    this._title.dispose(), this._title = null;
  },
  customize: function(e) {
    e.addChange({
      code: "TITLE",
      handler: function() {
        this._title.update(this._themeManager.theme("title"), this.option("title")) && this._change(["LAYOUT"]);
      },
      isThemeDependent: !0,
      option: "title",
      isOptionChange: !0
    });
  },
  fontFields: ["title.font", "title.subtitle.font"]
}, cg = Number, FT = Math, SC = FT.round, rc = FT.max, H2 = FT.min, MD = FT.ceil, G2 = I, U2 = ct, $g = ST, lj = Wt, Bae = W, CC = 10, zae = 2, Hae = 5, fi = "center", ba = "right", Go = "left", Pl = "top", Vl = "bottom", Ty = "horizontal", uj = "vertical", cj = "inside", LD = "outside", lE = "none", j2 = "height", $2 = "width", Gae = $g([Go, fi, ba]), Uae = $g([Pl, Vl]), jae = $g([uj, Ty]), $ae = $g([Go, ba, Pl, Vl]), Yae = $g([LD, cj]), Wae = $g([Go, fi, ba]);
function Y2(e, t, r) {
  if (e) {
    var n = e.fill;
    return W({}, {
      state: r,
      fill: n === lE ? t : n,
      opacity: e.opacity,
      filter: e.filter,
      hatching: Bae({}, e.hatching, {
        step: Hae,
        width: zae
      })
    });
  }
}
function W2(e, t, r) {
  var n = D3(e, t);
  return n.fill && n.fill.indexOf("DevExpress") === 0 && (n.fill = JM(n.fill)), n.opacity = n.opacity >= 0 ? n.opacity : 1, W({}, n, {
    size: r
  });
}
function Xae(e) {
  var t = e.margin;
  t >= 0 ? (t = cg(e.margin), t = {
    top: t,
    bottom: t,
    left: t,
    right: t
  }) : t = {
    top: t.top >= 0 ? cg(t.top) : CC,
    bottom: t.bottom >= 0 ? cg(t.bottom) : CC,
    left: t.left >= 0 ? cg(t.left) : CC,
    right: t.right >= 0 ? cg(t.right) : CC
  }, e.margin = t;
}
function qae(e, t, r) {
  var n, i;
  switch (e.itemTextPosition) {
    case Go:
    case ba:
      n = t.width + 7 + r.width, i = rc(t.height, r.height);
      break;
    case Pl:
    case Vl:
      n = rc(t.width, r.width), i = t.height + 4 + r.height;
  }
  return {
    width: n,
    height: i
  };
}
function Kae(e, t) {
  var r = {};
  return r.left = H2(e.x, t.x), r.top = H2(e.y, t.y), r.right = rc(e.x + e.width, t.x + t.width), r.bottom = rc(e.y + e.height, t.y + t.height), r;
}
function Vk(e, t, r, n) {
  var i = t && r[t[e]];
  i && i.renderMarker(i.states[n]);
}
function Zae(e, t, r) {
  return e ? (Xae(e), e.horizontalAlignment = Gae(e.horizontalAlignment, ba), e.verticalAlignment = Uae(e.verticalAlignment, e.horizontalAlignment === fi ? Vl : Pl), e.orientation = jae(e.orientation, e.horizontalAlignment === fi ? Ty : uj), e.itemTextPosition = $ae(e.itemTextPosition, e.orientation === Ty ? Vl : ba), e.position = r ? Yae(e.position, LD) : LD, e.itemsAlignment = Wae(e.itemsAlignment, null), e.hoverMode = lj(e.hoverMode), e.customizeText = U2(e.customizeText) ? e.customizeText : function() {
    return this[t];
  }, e.customizeHint = U2(e.customizeHint) ? e.customizeHint : Y, e._incidentOccurred = e._incidentOccurred || Y, e) : null;
}
function Qae(e, t) {
  return e.rect(0, 0, t, t);
}
function Jae(e, t) {
  return e.circle(t / 2, t / 2, t / 2);
}
function eoe(e) {
  return lj(e) === "circle";
}
function toe(e, t, r) {
  return t >= e.left && t <= e.right && r >= e.top && r <= e.bottom;
}
function roe(e, t, r, n) {
  var i = {
    x: 0,
    y: 0
  }, s = 0, l = 0, d = 0;
  if (t.direction === "y" ? d = n.top + n.bottom : d = n.left + n.right, e.forEach(function(h, p) {
    var m = h[0], x = h.length;
    h.forEach(function(S, T) {
      var k = S.offset || t.spacing;
      i[t.direction] += S[t.measure] + (T !== x - 1 ? k : 0), s = rc(s, i[t.direction]);
    }), i[t.direction] = 0, i[t.altDirection] += m[t.altMeasure] + m.altOffset || t.altSpacing, l = rc(l, i[t.altDirection]);
  }), s + d > t.length)
    return t.countItem = noe(t, r), !0;
}
function noe(e, t) {
  return e.altCountItem++, MD(t / e.altCountItem);
}
function dj(e, t) {
  return e.reduce((r, n) => {
    var i = n.offset || t.spacing;
    return r + n[t.measure] + i;
  }, 0);
}
function ioe(e, t) {
  return e.reduce((r, n) => rc(r, dj(n, t)), 0);
}
function aoe(e, t, r) {
  var n = dj(e, t), i;
  switch (t.itemsAlignment) {
    case ba:
      i = r - n;
      break;
    case fi:
      i = (r - n) / 2;
      break;
    default:
      i = 0;
  }
  return i;
}
function ooe(e) {
  switch (e.itemTextPosition) {
    case Vl:
      return {
        horizontal: fi,
        vertical: Pl
      };
    case Pl:
      return {
        horizontal: fi,
        vertical: Vl
      };
    case Go:
      return {
        horizontal: ba,
        vertical: fi
      };
    case ba:
      return {
        horizontal: Go,
        vertical: fi
      };
  }
}
function soe(e, t, r) {
  var n = {};
  return r % t.countItem === 0 && (t.markerOffset ? e.push([], []) : e.push([])), t.markerOffset ? (n.firstLine = e[e.length - 1], n.secondLine = e[e.length - 2]) : n.firstLine = n.secondLine = e[e.length - 1], n;
}
function X2(e, t) {
  var r = e.reduce((n, i) => {
    var s = i ? i[t] : n;
    return rc(n, s);
  }, 0);
  e.forEach((n) => {
    n && (n[t] = r);
  });
}
function q2(e) {
  var t = e.length, r = e[0].length, n, i, s = [];
  for (n = 0; n < r; n++)
    for (s[n] = [], i = 0; i < t; i++)
      s[n][i] = e[i][n];
  return s;
}
function loe(e) {
  switch (e) {
    case Pl:
    case Vl:
      return fi;
    case Go:
      return ba;
    case ba:
      return Go;
  }
}
var uoe = function(e) {
  return eoe(e) ? Jae : Qae;
};
function coe(e) {
  return e.horizontalAlignment === fi ? fi : e.itemTextPosition === ba ? Go : e.itemTextPosition === Go ? ba : fi;
}
var fj = function(e) {
  this._renderer = e.renderer, this._legendGroup = e.group, this._backgroundClass = e.backgroundClass, this._itemGroupClass = e.itemGroupClass, this._textField = e.textField, this._getCustomizeObject = e.getFormatObject, this._titleGroupClass = e.titleGroupClass, this._allowInsidePosition = e.allowInsidePosition, this._widget = e.widget, this._updated = !1;
}, hj = fj, doe = hj.prototype = Vg(fy.prototype);
W(doe, {
  constructor: hj,
  getOptions: function() {
    return this._options;
  },
  update: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = this;
    t = n._options = Zae(t, n._textField, n._allowInsidePosition) || {};
    var i = t.markerSize;
    if (this._updated = !0, this._data = e.map((l) => (l.size = cg(l.size > 0 ? l.size : i), l.marker = W2(l, l.states.normal), Object.defineProperty(l.marker, "size", {
      get: () => l.size,
      set(d) {
        l.size = d;
      }
    }), Object.defineProperty(l.marker, "opacity", {
      get: () => l.states.normal.opacity,
      set(d) {
        l.states.normal.opacity = l.states.hover.opacity = l.states.selection.opacity = d;
      }
    }), l)), t.customizeItems && (n._data = t.customizeItems(e.slice()) || e), n._boundingRect = {
      width: 0,
      height: 0,
      x: 0,
      y: 0
    }, n.isVisible() && !n._title && (n._title = new yL({
      renderer: n._renderer,
      cssClass: n._titleGroupClass,
      root: n._legendGroup
    })), n._title) {
      var s = t.title;
      r.horizontalAlignment = coe(t), n._title.update(r, s);
    }
    return this.erase(), n;
  },
  isVisible: function() {
    return this._options && this._options.visible;
  },
  draw: function(e, t) {
    var r = this._getItemData();
    if (this.erase(), !(this.isVisible() && r && r.length))
      return this;
    if (this._insideLegendGroup = this._renderer.g().enableLinks().append(this._legendGroup), this._title.changeLink(this._insideLegendGroup), this._createBackground(), this._title.hasText()) {
      var n = this._background ? 2 * this._options.paddingLeftRight : 0;
      this._title.draw(e - n, t);
    }
    return this._markersGroup = this._renderer.g().attr({
      class: this._itemGroupClass
    }).append(this._insideLegendGroup), this._createItems(r), this._updateElementsPosition(e, t), this;
  },
  _measureElements: function() {
    var e = this._options, t = 0;
    this._items.forEach((r) => {
      var n = r.label.getBBox(), i = r.marker.getBBox();
      r.markerBBox = i, r.markerSize = Math.max(i.width, i.height);
      var s = qae(e, i, n);
      r.labelBBox = n, r.bBox = s, t = rc(t, s.height);
    }), e.equalRowHeight && this._items.forEach((r) => r.bBox.height = t);
  },
  _updateElementsPosition: function(e, t) {
    var r = this._options;
    this._size = {
      width: e,
      height: t
    }, this._measureElements(), this._locateElements(r), this._finalUpdate(r);
    var n = this.getLayoutOptions();
    (n.width > e || n.height > t) && this.freeSpace();
  },
  _createItems: function(e) {
    var t = this, r = t._options, n = t._renderer, i = uoe(r.markerShape);
    t._markersId = {};
    var s = r.markerTemplate ? r.markerTemplate : (h, p) => {
      var m = h.marker;
      i(n, m.size).attr({
        fill: m.fill,
        opacity: m.opacity,
        filter: m.filter
      }).append({
        element: p
      });
    }, l = t._widget._getTemplate(s), d = t._markersGroup;
    d.css(Oi(r.font)), t._deferredItems = [], t._templatesGroups = [], t._items = (e || []).map((h, p) => {
      var m = h.states, x = m.normal, S = x.fill;
      h.size = h.marker.size;
      var T = {
        normal: W(x, {
          fill: S || r.markerColor || r.defaultColor,
          state: "normal"
        }),
        hover: Y2(m.hover, S, "hovered"),
        selection: Y2(m.selection, S, "selected")
      };
      h.states = T;
      var k = n.g().append(d), O = n.g().attr({
        class: "dxl-marker"
      }).append(k);
      t._deferredItems[p] = new Yt(), t._templatesGroups.push(O);
      var D = {
        label: t._createLabel(h, k),
        marker: O,
        renderer: n,
        group: k,
        tracker: {
          id: h.id,
          argument: h.argument,
          argumentIndex: h.argumentIndex
        },
        states: T,
        itemTextPosition: r.itemTextPosition,
        markerOffset: 0,
        bBoxes: [],
        renderMarker(L) {
          h.marker = W2(D, L, h.size), O.clear(), l.render({
            model: h,
            container: O.element,
            onRendered: t._deferredItems[p].resolve
          });
        }
      };
      return D.renderMarker(T.normal), t._createHint(h, k), h.id !== void 0 && (t._markersId[h.id] = p), D;
    });
  },
  getTemplatesGroups: function() {
    return this._templatesGroups || [];
  },
  getTemplatesDef: function() {
    return this._deferredItems || [];
  },
  _getItemData: function() {
    var e = this._data || [], t = this._options || {};
    return t.inverted && (e = e.slice().reverse()), e.filter((r) => r.visible);
  },
  _finalUpdate: function(e) {
    this._adjustBackgroundSettings(e), this._setBoundingRect(e.margin);
  },
  erase: function() {
    var e = this._insideLegendGroup;
    return e && e.dispose(), this._insideLegendGroup = this._markersGroup = this._x1 = this._x2 = this._y2 = this._y2 = null, this;
  },
  _locateElements: function(e) {
    this._moveInInitialValues(), this._locateRowsColumns(e);
  },
  _moveInInitialValues: function() {
    this._title.hasText() && this._title.move([0, 0]), this._legendGroup && this._legendGroup.move(0, 0), this._background && this._background.attr({
      x: 0,
      y: 0,
      width: 0,
      height: 0
    });
  },
  applySelected: function(e) {
    return Vk(e, this._markersId, this._items, "selection"), this;
  },
  applyHover: function(e) {
    return Vk(e, this._markersId, this._items, "hover"), this;
  },
  resetItem: function(e) {
    return Vk(e, this._markersId, this._items, "normal"), this;
  },
  _createLabel: function(e, t) {
    var r = this._getCustomizeObject(e), n = this._options, i = loe(n.itemTextPosition), s = n.customizeText.call(r, r), l = G2(e.textOpacity) ? {
      color: n.font.color,
      opacity: e.textOpacity
    } : {};
    return this._renderer.text(s, 0, 0).css(Oi(l)).attr({
      align: i,
      class: n.cssClass
    }).append(t);
  },
  _createHint: function(e, t) {
    var r = this._getCustomizeObject(e), n = this._options.customizeHint.call(r, r);
    G2(n) && n !== "" && t.setTitle(n);
  },
  _createBackground: function() {
    var e = this._options.position === cj, t = this._options.backgroundColor, r = t || (e ? this._options.containerBackgroundColor : lE);
    (this._options.border.visible || (e || t) && t !== lE) && (this._background = this._renderer.rect(0, 0, 0, 0).attr({
      fill: r,
      class: this._backgroundClass
    }).append(this._insideLegendGroup));
  },
  _locateRowsColumns: function(e) {
    var t = 0, r = this._getItemsLayoutOptions(), n = this._items.length, i;
    do
      i = [], this._createLines(i, r), this._alignLines(i, r), t++;
    while (roe(i, r, n, e.margin) && t < n);
    this._applyItemPosition(i, r);
  },
  _createLines: function(e, t) {
    this._items.forEach((r, n) => {
      var i = soe(e, t, n), s = {
        width: r.labelBBox.width,
        height: r.labelBBox.height,
        element: r.label,
        bBox: r.labelBBox,
        pos: ooe(t),
        itemIndex: n
      }, l = {
        width: r.markerBBox.width,
        height: r.markerBBox.height,
        element: r.marker,
        pos: {
          horizontal: fi,
          vertical: fi
        },
        bBox: {
          width: r.markerBBox.width,
          height: r.markerBBox.height,
          x: r.markerBBox.x,
          y: r.markerBBox.y
        },
        itemIndex: n
      }, d, h, p = t.markerOffset ? "altOffset" : "offset";
      t.inverseLabelPosition ? (d = s, h = l) : (d = l, h = s), d[p] = t.labelOffset, i.secondLine.push(d), i.firstLine.push(h);
    });
  },
  _alignLines: function(e, t) {
    var r, n = t.altMeasure;
    if (e.forEach((s) => X2(s, n)), n = t.measure, t.itemsAlignment) {
      if (t.markerOffset)
        for (r = 0; r < e.length; )
          q2([e[r++], e[r++]]).forEach(i);
    } else
      q2(e).forEach(i);
    function i(s) {
      X2(s, n);
    }
  },
  _applyItemPosition: function(e, t) {
    var r = this, n = {
      x: 0,
      y: 0
    }, i = ioe(e, t);
    e.forEach((s) => {
      var l = s[0], d = l.altOffset || t.altSpacing;
      n[t.direction] = aoe(s, t, i), s.forEach((h) => {
        var p = h.offset || t.spacing, m = new hy(h.element, h.bBox), x = {
          x: n.x,
          y: n.y,
          width: h.width,
          height: h.height
        }, S = new hy(null, x), T = r._items[h.itemIndex];
        m.position({
          of: S,
          my: h.pos,
          at: h.pos
        }), T.bBoxes.push(S), n[t.direction] += h[t.measure] + p;
      }), n[t.altDirection] += l[t.altMeasure] + d;
    }), this._items.forEach((s) => {
      var l = Kae(s.bBoxes[0].getLayoutOptions(), s.bBoxes[1].getLayoutOptions()), d = r._options.columnItemSpacing / 2, h = r._options.rowItemSpacing / 2;
      s.tracker.left = l.left - d, s.tracker.right = l.right + d, s.tracker.top = l.top - h, s.tracker.bottom = l.bottom + h;
    });
  },
  _getItemsLayoutOptions: function() {
    var e = this._options, t = e.orientation, r = {
      itemsAlignment: e.itemsAlignment,
      orientation: e.orientation
    }, n = this._size.width - (this._background ? 2 * e.paddingLeftRight : 0), i = this._size.height - (this._background ? 2 * e.paddingTopBottom : 0);
    return t === Ty ? (r.length = n, r.spacing = e.columnItemSpacing, r.direction = "x", r.measure = $2, r.altMeasure = j2, r.altDirection = "y", r.altSpacing = e.rowItemSpacing, r.countItem = e.columnCount, r.altCountItem = e.rowCount, r.marginTextLabel = 4, r.labelOffset = 7, (e.itemTextPosition === Vl || e.itemTextPosition === Pl) && (r.labelOffset = 4, r.markerOffset = !0)) : (r.length = i, r.spacing = e.rowItemSpacing, r.direction = "y", r.measure = j2, r.altMeasure = $2, r.altDirection = "x", r.altSpacing = e.columnItemSpacing, r.countItem = e.rowCount, r.altCountItem = e.columnCount, r.marginTextLabel = 7, r.labelOffset = 4, (e.itemTextPosition === ba || e.itemTextPosition === Go) && (r.labelOffset = 7, r.markerOffset = !0)), r.countItem || (r.altCountItem ? r.countItem = MD(this._items.length / r.altCountItem) : r.countItem = this._items.length), (e.itemTextPosition === Pl || e.itemTextPosition === Go) && (r.inverseLabelPosition = !0), r.itemTextPosition = e.itemTextPosition, r.altCountItem = r.altCountItem || MD(this._items.length / r.countItem), r;
  },
  _adjustBackgroundSettings: function(e) {
    if (this._background) {
      var t = e.border, r = this._calculateTotalBox(), n = {
        x: SC(r.x - e.paddingLeftRight),
        y: SC(r.y - e.paddingTopBottom),
        width: SC(r.width) + 2 * e.paddingLeftRight,
        height: SC(r.height),
        opacity: e.backgroundOpacity
      };
      t.visible && t.width && t.color && t.color !== lE && (n["stroke-width"] = t.width, n.stroke = t.color, n["stroke-opacity"] = t.opacity, n.dashStyle = t.dashStyle, n.rx = t.cornerRadius || 0, n.ry = t.cornerRadius || 0), this._background.attr(n);
    }
  },
  _setBoundingRect: function(e) {
    if (this._insideLegendGroup) {
      var t = this._calculateTotalBox();
      t.height += e.top + e.bottom, t.widthWithoutMargins = t.width, t.width += e.left + e.right, t.x -= e.left, t.y -= e.top, this._boundingRect = t;
    }
  },
  _calculateTotalBox: function() {
    var e = this._markersGroup.getBBox(), t = this._title.getCorrectedLayoutOptions(), r = this._insideLegendGroup.getBBox(), n = this._background ? 2 * this._options.paddingTopBottom : 0;
    return r.height = e.height + t.height + n, t.width > r.width && (r.width = t.width), r;
  },
  getActionCallback: function(e) {
    var t = this;
    return t._options.visible ? function(r) {
      t[r](e.index);
    } : Y;
  },
  getLayoutOptions: function() {
    var e = this._options, t = this._insideLegendGroup ? this._boundingRect : {
      width: 0,
      height: 0,
      x: 0,
      y: 0
    };
    return e ? (t.verticalAlignment = e.verticalAlignment, t.horizontalAlignment = e.horizontalAlignment, e.orientation === Ty || e.horizontalAlignment === fi ? (t.cutLayoutSide = e.verticalAlignment, t.cutSide = "vertical") : (t.cutLayoutSide = e.horizontalAlignment, t.cutSide = "horizontal"), t.position = {
      horizontal: e.horizontalAlignment,
      vertical: e.verticalAlignment
    }, t) : null;
  },
  shift: function(e, t) {
    var r = {};
    return this._insideLegendGroup && this._insideLegendGroup.attr({
      translateX: e - this._boundingRect.x,
      translateY: t - this._boundingRect.y
    }), this._title && this._shiftTitle(this._boundingRect.widthWithoutMargins), this._markersGroup && this._shiftMarkers(), this._insideLegendGroup && (r = this._legendGroup.getBBox()), this._x1 = r.x, this._y1 = r.y, this._x2 = r.x + r.width, this._y2 = r.y + r.height, this;
  },
  _shiftTitle: function(e) {
    var t = this._title, r = t.getCorrectedLayoutOptions();
    if (!(!r || !t.hasText())) {
      var n = e - (this._background ? 2 * this._options.paddingLeftRight : 0), i = t.getOptions(), s = r.y + i.margin.top, l = 0;
      i.verticalAlignment === Vl && this._markersGroup && (s += this._markersGroup.getBBox().height), i.horizontalAlignment === ba ? l = n - r.width : i.horizontalAlignment === fi && (l = (n - r.width) / 2), t.shift(l, s);
    }
  },
  _shiftMarkers: function() {
    var e = this._title.getLayoutOptions(), t = this._markersGroup.getBBox(), r = this._title.getOptions() || {}, n = 0, i = 0;
    e.width > t.width && this._options.horizontalAlignment === fi && (n = e.width / 2 - t.width / 2), r.verticalAlignment === Pl && (i = e.height), (n !== 0 || i !== 0) && (this._markersGroup.attr({
      translateX: n,
      translateY: i
    }), this._items.forEach((s) => {
      s.tracker.left += n, s.tracker.right += n, s.tracker.top += i, s.tracker.bottom += i;
    }));
  },
  getPosition: function() {
    return this._options.position;
  },
  coordsIn: function(e, t) {
    return e >= this._x1 && e <= this._x2 && t >= this._y1 && t <= this._y2;
  },
  getItemByCoord: function(e, t) {
    var r = this._items, n = this._insideLegendGroup;
    e -= n.attr("translateX"), t -= n.attr("translateY");
    for (var i = 0; i < r.length; i++)
      if (toe(r[i].tracker, e, t))
        return r[i].tracker;
    return null;
  },
  dispose: function() {
    return this._title && this._title.dispose(), this._legendGroup = this._insideLegendGroup = this._title = this._renderer = this._options = this._data = this._items = null, this;
  },
  layoutOptions: function() {
    if (!this.isVisible())
      return null;
    var e = this.getLayoutOptions();
    return {
      horizontalAlignment: this._options.horizontalAlignment,
      verticalAlignment: this._options.verticalAlignment,
      side: e.cutSide,
      priority: 1,
      position: this.getPosition()
    };
  },
  measure: function(e) {
    this._updated || !this._insideLegendGroup ? (this.draw(e[0], e[1]), this._updated = !1) : (this._items.forEach((r) => {
      r.bBoxes = [];
    }), this._updateElementsPosition(e[0], e[1]));
    var t = this.getLayoutOptions();
    return [t.width, t.height];
  },
  move: function(e) {
    this.shift(e[0], e[1]);
  },
  freeSpace: function() {
    this._options._incidentOccurred("W2104"), this.erase();
  }
});
var foe = jd.add, vj = "DEVEXTREME_XHR_ERROR_UNLOAD", hoe = function(e) {
  return [e[0], e.length < 3 ? "=" : String(e[1]).toLowerCase(), e.length < 2 ? !0 : e[e.length - 1]];
}, PD = function(e) {
  return Array.isArray(e) || (e = [e]), Bl(e, function(t) {
    var r = {
      selector: ct(t) || typeof t == "string" ? t : t.getter || t.field || t.selector,
      desc: !!(t.desc || String(t.dir).charAt(0).toLowerCase() === "d")
    };
    return t.compare && (r.compare = t.compare), r;
  });
}, voe = function() {
  var e = {
    timeout: "Network connection timeout",
    error: "Unspecified network error",
    parsererror: "Unexpected server response"
  }, t;
  return foe(function() {
    var r = jr();
    we.listen(r, "beforeunload", function() {
      t = !0;
    });
  }), function(r, n) {
    return t ? vj : r.status < 400 ? function(i) {
      var s = e[i];
      return s || i;
    }(n) : r.statusText;
  };
}(), poe = {
  count: {
    seed: 0,
    step: function(e) {
      return 1 + e;
    }
  },
  sum: {
    seed: 0,
    step: function(e, t) {
      return e + t;
    }
  },
  min: {
    step: function(e, t) {
      return t < e ? t : e;
    }
  },
  max: {
    step: function(e, t) {
      return t > e ? t : e;
    }
  },
  avg: {
    seed: [0, 0],
    step: function(e, t) {
      return [e[0] + t, e[1] + 1];
    },
    finalize: function(e) {
      return e[1] ? e[0] / e[1] : NaN;
    }
  }
}, goe = /* @__PURE__ */ function() {
  var e = 0, t;
  return {
    obtain: function() {
      e === 0 && (t = new Yt()), e++;
    },
    release: function() {
      e--, e < 1 && t.resolve();
    },
    promise: function() {
      var r = e === 0 ? new Yt().resolve() : t;
      return r.promise();
    },
    reset: function() {
      e = 0, t && t.resolve();
    }
  };
}();
function moe(e) {
  return /^(and|&&|&)$/i.test(e);
}
var xL = function(e, t, r) {
  if (Array.isArray(e)) {
    for (var n = Bl(t, function(l, d) {
      return d;
    }), i, s = 0; s < n.length; s++)
      if (i = n[s], !BR(t[i], r[i], {
        strict: !1
      }))
        return !1;
    return !0;
  }
  return BR(t, r, {
    strict: !1
  });
};
var _oe = function(e) {
  return e[0] === "!" && Array.isArray(e[1]);
}, yoe = function(e) {
  return e === "and" || e === "or";
}, xoe = function(e) {
  var t = e[0], r = e[1];
  return !!(Array.isArray(t) || ct(t) && (Array.isArray(r) || ct(r) || yoe(r)));
}, wg = function() {
  var e = new Yt();
  return e.resolve.apply(e, arguments).promise();
}, pj = function() {
  var e = new Yt();
  return e.reject.apply(e, arguments).promise();
};
function boe(e, t) {
  var r;
  return function() {
    return r || (r = setTimeout(() => {
      r = void 0, e.call(this);
    }, ct(t) ? t() : t)), r;
  };
}
function Soe(e, t) {
  var r = [], n = boe(function() {
    e.call(this, r), r = [];
  }, t);
  return function(i) {
    return Array.isArray(i) && r.push(...i), n.call(this, r);
  };
}
var vi = hT(Dr.ERROR_MESSAGES, {
  E4000: "[DevExpress.data]: {0}",
  E4001: "Unknown aggregating function is detected: '{0}'",
  E4002: "Unsupported OData protocol version is used",
  E4003: "Unknown filter operation is used: {0}",
  E4004: "The thenby() method is called before the sortby() method",
  E4005: "Store requires a key expression for this operation",
  E4006: "ArrayStore 'data' option must be an array",
  E4007: "Compound keys cannot be auto-generated",
  E4008: "Attempt to insert an item with a duplicated key",
  E4009: "Data item cannot be found",
  E4010: "CustomStore does not support creating queries",
  E4011: "Custom Store method is not implemented or is not a function: {0}",
  E4012: "Custom Store method returns an invalid value: {0}",
  E4013: "Local Store requires the 'name' configuration option is specified",
  E4014: "Unknown data type is specified for ODataStore: {0}",
  E4015: "Unknown entity name or alias is used: {0}",
  E4016: "The compileSetter(expr) method is called with 'self' passed as a parameter",
  E4017: "Keys cannot be modified",
  E4018: "The server has returned a non-numeric value in a response to an item count request",
  E4019: "Mixing of group operators inside a single group of filter expression is not allowed",
  E4020: "Unknown store type is detected: {0}",
  E4021: "The server response does not provide the totalCount value",
  E4022: "The server response does not provide the groupCount value",
  E4023: "Could not parse the following XML: {0}",
  E4024: "String function {0} cannot be used with the data field {1} of type {2}.",
  W4000: "Data returned from the server has an incorrect structure",
  W4001: 'The {0} field is listed in both "keyType" and "fieldTypes". The value of "fieldTypes" is used.',
  W4002: "Data loading has failed for some cells due to the following error: {0}"
}), Coe = null, bL = function(e) {
  var t;
  (t = Coe) === null || t === void 0 || t(e);
};
function Eoe(e, t) {
  for (var r, n = typeof t == "string" ? t.split() : t.slice(); n.length; )
    if (r = n.shift(), r in e)
      return !0;
  return !1;
}
function gj(e, t, r, n) {
  var i, s;
  if (n) {
    for (var l = 0; l < t.length; l++)
      if (i = t[l].items || t[l].collapsedItems || [], s = gj(e, i || [], r, n - 1), s)
        return s;
  } else if (Fy(e, t, r) >= 0)
    return t;
}
function Toe(e, t, r, n) {
  return n ? gj(e, t, r, n) || [] : t;
}
function woe(e, t) {
  if (e.key() && (!t._dataByKeyMap || t._dataByKeyMapLength !== t.length)) {
    for (var r = {}, n = t.length, i = 0; i < n; i++)
      r[JSON.stringify(e.keyOf(t[i]))] = t[i];
    t._dataByKeyMap = r, t._dataByKeyMapLength = n;
  }
}
function Aoe(e, t) {
  if (e._dataByKeyMap)
    return e._dataByKeyMap[JSON.stringify(t)];
}
function Ooe(e, t) {
  return e._dataByKeyMap ? e._dataByKeyMap[JSON.stringify(t)] : !0;
}
function mj(e, t, r) {
  e._dataByKeyMap && (e._dataByKeyMap[JSON.stringify(t)] = r, e._dataByKeyMapLength += r ? 1 : -1);
}
function _j(e, t, r) {
  r = r || /* @__PURE__ */ new WeakMap();
  var n = e ? Object.create(Object.getPrototypeOf(e)) : {};
  e && r.set(e, n);
  var i = ei({}, e);
  vT(n, i, !0, !0);
  for (var s in i) {
    var l = i[s], d = t == null ? void 0 : t[s];
    hi(l) && !Qr(l) && hi(d) && !r.has(l) && (n[s] = _j(l, d, r));
  }
  for (var h in n) {
    var p = n[h];
    hi(p) && r.has(p) && (n[h] = r.get(p));
  }
  return n;
}
function koe(e, t) {
  var r = _j(e, t);
  return vT(r, t, !0, !0);
}
function SL(e) {
  var {
    keyInfo: t,
    data: r,
    changes: n,
    groupCount: i,
    useInsertIndex: s,
    immutable: l,
    disableCache: d,
    logError: h,
    skipCopying: p
  } = e, m = l === !0 ? [...r] : r;
  return n.forEach((x) => {
    var S = x.type === "insert" ? m : Toe(t, m, x.key, i);
    switch (!d && woe(t, S), x.type) {
      case "update":
        yj(t, S, x.key, x.data, !0, l, h);
        break;
      case "insert":
        xj(t, S, x.data, s && I(x.index) ? x.index : -1, !0, h, p);
        break;
      case "remove":
        bj(t, S, x.key, !0, h);
    }
  }), m;
}
function eT(e, t, r) {
  return e ? t && vi.log(r) : pj(vi.Error(r));
}
function yj(e, t, r, n, i, s, l) {
  var d, h = e.key();
  if (h) {
    if (Eoe(n, h) && !xL(h, r, e.keyOf(n)))
      return eT(i, l, "E4017");
    if (d = Aoe(t, r), !d) {
      var p = Fy(e, t, r);
      if (p < 0)
        return eT(i, l, "E4009");
      if (d = t[p], s === !0 && I(d)) {
        var m = koe(d, n);
        return t[p] = m, !i && wg(m, r);
      }
    }
  } else
    d = r;
  if (vT(d, n, !0), !i)
    return Zr().useLegacyStoreResult ? wg(r, n) : wg(d, r);
}
function xj(e, t, r, n, i, s, l) {
  var d, h = e.key(), p = Qr(r) && !l ? W({}, r) : r;
  if (h) {
    if (d = e.keyOf(p), d === void 0 || typeof d == "object" && Bd(d)) {
      if (Array.isArray(h))
        throw vi.Error("E4007");
      d = p[h] = String(new NX());
    } else if (t[Fy(e, t, d)] !== void 0)
      return eT(i, s, "E4008");
  } else
    d = p;
  if (n >= 0 ? t.splice(n, 0, p) : t.push(p), mj(t, d, p), !i)
    return wg(Zr().useLegacyStoreResult ? r : p, d);
}
function bj(e, t, r, n, i) {
  var s = Fy(e, t, r);
  if (s > -1 && (t.splice(s, 1), mj(t, r, null)), n) {
    if (s < 0)
      return eT(n, i, "E4009");
  } else
    return wg(r);
}
function Fy(e, t, r) {
  var n = e.key();
  if (!Ooe(t, r))
    return -1;
  for (var i = 0, s = t.length; i < s; i++)
    if (xL(n, e.keyOf(t[i]), r))
      return i;
  return -1;
}
var By = Qi.inherit({
  toArray: function() {
    var e = [];
    for (this.reset(); this.next(); )
      e.push(this.current());
    return e;
  },
  countable: function() {
    return !1;
  }
}), CL = By.inherit({
  ctor: function(e) {
    this.array = e, this.index = -1;
  },
  next: function() {
    return this.index + 1 < this.array.length ? (this.index++, !0) : !1;
  },
  current: function() {
    return this.array[this.index];
  },
  reset: function() {
    this.index = -1;
  },
  toArray: function() {
    return this.array.slice(0);
  },
  countable: function() {
    return !0;
  },
  count: function() {
    return this.array.length;
  }
}), BT = By.inherit({
  ctor: function(e) {
    this.iter = e;
  },
  next: function() {
    return this.iter.next();
  },
  current: function() {
    return this.iter.current();
  },
  reset: function() {
    return this.iter.reset();
  }
}), Fk = BT.inherit({
  ctor: function(e, t) {
    this.callBase(e), this.index = -1, this.mapper = t;
  },
  current: function() {
    return this.mapper(this.callBase(), this.index);
  },
  next: function() {
    var e = this.callBase();
    return e && this.index++, e;
  }
}), Roe = function(e, t, r) {
  return lr(e) && lr(t) && (r != null && r.locale || r != null && r.collatorOptions) ? new Intl.Collator((r == null ? void 0 : r.locale) || void 0, (r == null ? void 0 : r.collatorOptions) || void 0).compare(e, t) : (e = kh(e, !1, r), t = kh(t, !1, r), e === null && t !== null ? -1 : e !== null && t === null || e === void 0 && t !== void 0 ? 1 : e !== void 0 && t === void 0 || e < t ? -1 : e > t ? 1 : 0);
}, ID = By.inherit({
  ctor: function(e, t, r, n) {
    this.langParams = e.langParams, e instanceof Fk || (e = new Fk(e, this._wrap), e.langParams = this.langParams), this.iter = e, this.rules = [{
      getter: t,
      desc: r,
      compare: n,
      langParams: this.langParams
    }];
  },
  thenBy: function(e, t, r) {
    var n = new ID(this.sortedIter || this.iter, e, t, r);
    return this.sortedIter || (n.rules = this.rules.concat(n.rules)), n;
  },
  next: function() {
    return this._ensureSorted(), this.sortedIter.next();
  },
  current: function() {
    return this._ensureSorted(), this.sortedIter.current();
  },
  reset: function() {
    delete this.sortedIter;
  },
  countable: function() {
    return this.sortedIter || this.iter.countable();
  },
  count: function() {
    return this.sortedIter ? this.sortedIter.count() : this.iter.count();
  },
  _ensureSorted: function() {
    var e = this;
    e.sortedIter || (be(e.rules, function() {
      this.getter = ac(this.getter);
    }), e.sortedIter = new Fk(new CL(this.iter.toArray().sort(function(t, r) {
      return e._compare(t, r);
    })), e._unwrap));
  },
  _wrap: function(e, t) {
    return {
      index: t,
      value: e
    };
  },
  _unwrap: function(e) {
    return e.value;
  },
  _getDefaultCompare: (e) => (t, r) => Roe(t, r, e),
  _compare: function(e, t) {
    var r = e.index, n = t.index;
    if (e = e.value, t = t.value, e === t)
      return r - n;
    for (var i = 0, s = this.rules.length; i < s; i++) {
      var l = this.rules[i], d = l.getter(e), h = l.getter(t), p = l.compare || this._getDefaultCompare(l.langParams), m = p(d, h);
      if (m)
        return l.desc ? -m : m;
    }
    return r - n;
  }
}), ND = /* @__PURE__ */ function() {
  var e = {}, t = (i) => kh(i, !1, e), r = function(i) {
    var s;
    return I(i) ? (s = e) !== null && s !== void 0 && s.locale ? i.toLocaleString(e.locale) : i.toString() : "";
  };
  function n(i, s, l) {
    return function(d) {
      d = t(i(d));
      var h = /* @__PURE__ */ function(p) {
        return p === "" || p === 0 || p === !1;
      }(s) ? d === s : d == s;
      return l && (h = !h), h;
    };
  }
  return function(i, s) {
    return e = s || {}, ct(i) ? i : xoe(i) ? function(l) {
      var d = [], h = !1, p = !1;
      return be(l, function() {
        if (Array.isArray(this) || ct(this)) {
          if (d.length > 1 && h !== p)
            throw new vi.Error("E4019");
          d.push(ND(this, e)), h = p, p = !0;
        } else
          p = moe(this);
      }), function(m) {
        for (var x = h, S = 0; S < d.length; S++)
          if (d[S](m) !== h) {
            x = !h;
            break;
          }
        return x;
      };
    }(i) : _oe(i) ? function(l) {
      var d = l[0], h = ND(l[1], e);
      if (d === "!")
        return function(p) {
          return !h(p);
        };
      throw vi.Error("E4003", d);
    }(i) : function(l) {
      l = hoe(l);
      var d = ac(l[0]), h = l[1], p = l[2];
      p = t(p);
      var m = (x, S) => (x = t(d(x)), (p == null || x == null) && p !== x ? !1 : S(x, p));
      switch (h.toLowerCase()) {
        case "=":
          return n(d, p);
        case "<>":
          return n(d, p, !0);
        case ">":
          return (x) => m(x, (S, T) => S > T);
        case "<":
          return (x) => m(x, (S, T) => S < T);
        case ">=":
          return (x) => m(x, (S, T) => S >= T);
        case "<=":
          return (x) => m(x, (S, T) => S <= T);
        case "startswith":
          return function(x) {
            return t(r(d(x))).indexOf(p) === 0;
          };
        case "endswith":
          return function(x) {
            var S = t(r(d(x))), T = r(p);
            if (S.length < T.length)
              return !1;
            var k = S.lastIndexOf(p);
            return k !== -1 && k === S.length - p.length;
          };
        case "contains":
          return function(x) {
            return t(r(d(x))).indexOf(p) > -1;
          };
        case "notcontains":
          return function(x) {
            return t(r(d(x))).indexOf(p) === -1;
          };
      }
      throw vi.Error("E4003", h);
    }(i);
  };
}(), Doe = BT.inherit({
  ctor: function(e, t) {
    this.callBase(e), this.langParams = e.langParams, this.criteria = ND(t, this.langParams);
  },
  next: function() {
    for (; this.iter.next(); )
      if (this.criteria(this.current()))
        return !0;
    return !1;
  }
}), Moe = By.inherit({
  ctor: function(e, t) {
    this.iter = e, this.getter = t;
  },
  next: function() {
    return this._ensureGrouped(), this.groupedIter.next();
  },
  current: function() {
    return this._ensureGrouped(), this.groupedIter.current();
  },
  reset: function() {
    delete this.groupedIter;
  },
  countable: function() {
    return !!this.groupedIter;
  },
  count: function() {
    return this.groupedIter.count();
  },
  _ensureGrouped: function() {
    if (!this.groupedIter) {
      var e = {}, t = [], r = this.iter, n = ac(this.getter);
      for (r.reset(); r.next(); ) {
        var i = r.current(), s = n(i);
        s in e ? e[s].push(i) : (e[s] = [i], t.push(s));
      }
      this.groupedIter = new CL(Bl(t, function(l) {
        return {
          key: l,
          items: e[l]
        };
      }));
    }
  }
}), Loe = BT.inherit({
  ctor: function(e, t) {
    this.callBase(e), this.getter = ac(t);
  },
  current: function() {
    return this.getter(this.callBase());
  },
  countable: function() {
    return this.iter.countable();
  },
  count: function() {
    return this.iter.count();
  }
}), Poe = BT.inherit({
  ctor: function(e, t, r) {
    this.callBase(e), this.skip = Math.max(0, t), this.take = Math.max(0, r), this.pos = 0;
  },
  next: function() {
    if (this.pos >= this.skip + this.take)
      return !1;
    for (; this.pos < this.skip && this.iter.next(); )
      this.pos++;
    return this.pos++, this.iter.next();
  },
  reset: function() {
    this.callBase(), this.pos = 0;
  },
  countable: function() {
    return this.iter.countable();
  },
  count: function() {
    return Math.min(this.iter.count() - this.skip, this.take);
  }
}), zT = function e(t, r) {
  r = r || {}, t instanceof By || (t = new CL(t)), r.langParams && (t.langParams = r.langParams);
  var n = function(p) {
    var m = r.errorHandler;
    m && m(p), bL(p);
  }, i = function(p) {
    var m = new Yt().fail(n), x, S = p.step, T = p.finalize;
    try {
      t.reset(), "seed" in p ? x = p.seed : x = t.next() ? t.current() : NaN;
      for (var k = x; t.next(); )
        k = S(k, t.current());
      m.resolve(T ? T(k) : k);
    } catch (O) {
      m.reject(O);
    }
    return m.promise();
  }, s = function(p) {
    return i(poe[p]);
  }, l = function(p) {
    return !ct(p) && !Array.isArray(p) && (p = [].slice.call(arguments)), h(new Loe(t, p));
  }, d = function(p) {
    return l(ac(p));
  };
  function h(p) {
    return e(p, r);
  }
  return {
    toArray: function() {
      return t.toArray();
    },
    enumerate: function() {
      var p = new Yt().fail(n);
      try {
        p.resolve(t.toArray());
      } catch (m) {
        p.reject(m);
      }
      return p.promise();
    },
    setLangParams(p) {
      t.langParams = p;
    },
    sortBy: function(p, m, x) {
      return h(new ID(t, p, m, x));
    },
    thenBy: function(p, m, x) {
      if (t instanceof ID)
        return h(t.thenBy(p, m, x));
      throw vi.Error("E4004");
    },
    filter: function(p) {
      return Array.isArray(p) || (p = [].slice.call(arguments)), h(new Doe(t, p));
    },
    slice: function(p, m) {
      return m === void 0 && (m = Number.MAX_VALUE), h(new Poe(t, p, m));
    },
    select: l,
    groupBy: function(p) {
      return h(new Moe(t, p));
    },
    aggregate: function(p, m, x) {
      return arguments.length < 2 ? i({
        step: arguments[0]
      }) : i({
        seed: p,
        step: m,
        finalize: x
      });
    },
    count: function() {
      if (t.countable()) {
        var p = new Yt().fail(n);
        try {
          p.resolve(t.count());
        } catch (m) {
          p.reject(m);
        }
        return p.promise();
      }
      return s("count");
    },
    sum: function(p) {
      return p ? d(p).sum() : s("sum");
    },
    min: function(p) {
      return p ? d(p).min() : s("min");
    },
    max: function(p) {
      return p ? d(p).max() : s("max");
    },
    avg: function(p) {
      return p ? d(p).avg() : s("avg");
    }
  };
};
function EL(e, t) {
  return e = e.groupBy(t[0].selector), t.length > 1 && (e = e.select(function(r) {
    return W({}, r, {
      items: EL(zT(r.items), t.slice(1)).toArray()
    });
  })), e;
}
function Sj(e, t) {
  var r = [];
  return be(e, function(n, i) {
    var s = _M(t, function(l) {
      return i.selector === l.selector;
    });
    s.length < 1 && r.push(i);
  }), r.concat(t);
}
function Ioe(e, t, r) {
  var n;
  t = t || {};
  var i = t.filter;
  if ((n = t) !== null && n !== void 0 && n.langParams) {
    var s, l;
    (s = (l = e).setLangParams) === null || s === void 0 || s.call(l, t.langParams);
  }
  if (i && (e = e.filter(i)), r)
    return e;
  var d = t.sort, h = t.select, p = t.group, m = t.skip, x = t.take;
  return p && (p = PD(p), p.keepInitialKeyOrder = !!t.group.keepInitialKeyOrder), (d || p) && (d = PD(d || []), p && !p.keepInitialKeyOrder && (d = Sj(p, d)), be(d, function(S) {
    e = e[S ? "thenBy" : "sortBy"](this.selector, this.desc, this.compare);
  })), h && (e = e.select(h)), p && (e = EL(e, p)), (x || m) && (e = e.slice(m || 0, x)), e;
}
const VD = {
  multiLevelGroup: EL,
  arrangeSortingInfo: Sj,
  queryByOptions: Ioe
};
var M_ = Qi.abstract, K2 = VD.queryByOptions, FD = {}, ec = Qi.inherit({
  _langParams: {},
  ctor: function(e) {
    var t = this;
    e = e || {}, this._eventsStrategy = new zg(this), be(["onLoaded", "onLoading", "onInserted", "onInserting", "onUpdated", "onUpdating", "onPush", "onRemoved", "onRemoving", "onModified", "onModifying"], function(r, n) {
      n in e && t.on(n.slice(2).toLowerCase(), e[n]);
    }), this._key = e.key, this._errorHandler = e.errorHandler, this._useDefaultSearch = !0;
  },
  _clearCache: Y,
  _customLoadOptions: function() {
    return null;
  },
  key: function() {
    return this._key;
  },
  keyOf: function(e) {
    return this._keyGetter || (this._keyGetter = ac(this.key())), this._keyGetter(e);
  },
  _requireKey: function() {
    if (!this.key())
      throw vi.Error("E4005");
  },
  load: function(e) {
    var t = this;
    return e = e || {}, this._eventsStrategy.fireEvent("loading", [e]), this._withLock(this._loadImpl(e)).done(function(r) {
      t._eventsStrategy.fireEvent("loaded", [r, e]);
    });
  },
  _loadImpl: function(e) {
    return Bd(this._langParams) || (e = e || {}, e._langParams = ei({}, this._langParams, e._langParams)), K2(this.createQuery(e), e).enumerate();
  },
  _withLock: function(e) {
    var t = new Yt();
    return e.done(function() {
      var r = this, n = arguments;
      goe.promise().done(function() {
        t.resolveWith(r, n);
      });
    }).fail(function() {
      t.rejectWith(this, arguments);
    }), t;
  },
  createQuery: M_,
  totalCount: function(e) {
    return this._totalCountImpl(e);
  },
  _totalCountImpl: function(e) {
    return K2(this.createQuery(e), e, !0).count();
  },
  byKey: function(e, t) {
    return this._addFailHandlers(this._withLock(this._byKeyImpl(e, t)));
  },
  _byKeyImpl: M_,
  insert: function(e) {
    var t = this;
    return t._eventsStrategy.fireEvent("modifying"), t._eventsStrategy.fireEvent("inserting", [e]), t._addFailHandlers(t._insertImpl(e).done(function(r, n) {
      t._eventsStrategy.fireEvent("inserted", [r, n]), t._eventsStrategy.fireEvent("modified");
    }));
  },
  _insertImpl: M_,
  update: function(e, t) {
    var r = this;
    return r._eventsStrategy.fireEvent("modifying"), r._eventsStrategy.fireEvent("updating", [e, t]), r._addFailHandlers(r._updateImpl(e, t).done(function() {
      r._eventsStrategy.fireEvent("updated", [e, t]), r._eventsStrategy.fireEvent("modified");
    }));
  },
  _updateImpl: M_,
  push: function(e) {
    var t = {
      changes: e,
      waitFor: []
    };
    this._eventsStrategy.fireEvent("beforePushAggregation", [t]), Ps(...t.waitFor).done(() => {
      this._pushImpl(e), this._eventsStrategy.fireEvent("beforePush", [{
        changes: e
      }]), this._eventsStrategy.fireEvent("push", [e]);
    });
  },
  _pushImpl: Y,
  remove: function(e) {
    var t = this;
    return t._eventsStrategy.fireEvent("modifying"), t._eventsStrategy.fireEvent("removing", [e]), t._addFailHandlers(t._removeImpl(e).done(function(r) {
      t._eventsStrategy.fireEvent("removed", [r]), t._eventsStrategy.fireEvent("modified");
    }));
  },
  _removeImpl: M_,
  _addFailHandlers: function(e) {
    return e.fail(this._errorHandler).fail(bL);
  },
  on(e, t) {
    return this._eventsStrategy.on(e, t), this;
  },
  off(e, t) {
    return this._eventsStrategy.off(e, t), this;
  }
});
ec.create = function(e, t) {
  if (!(e in FD))
    throw vi.Error("E4020", e);
  return new FD[e](t);
};
ec.registerClass = function(e, t) {
  return t && (FD[t] = e), e;
};
ec.inherit = /* @__PURE__ */ function(e) {
  return function(t, r) {
    var n = e.apply(this, [t]);
    return ec.registerClass(n, r), n;
  };
}(ec.inherit);
var Cj = "totalCount", BD = "load", Ej = "byKey", Z2 = "insert", Q2 = "update", J2 = "remove";
function Ag(e) {
  return e && ct(e.then);
}
function Ah(e) {
  return new Yt().resolve(e).promise();
}
function ey(e, t) {
  if (!ct(t))
    throw vi.Error("E4011", e);
}
function Tj(e) {
  throw vi.Error("E4012", e);
}
function fh(e) {
  function t(r) {
    var n = r[0], i = r[1];
    return !n || !n.getResponseHeader ? null : voe(n, i);
  }
  return function(r) {
    var n;
    r instanceof Error ? n = r : n = new Error(t(arguments) || r && String(r) || "Unknown error"), n.message !== vj && e.reject(n);
  };
}
function wj(e, t) {
  var r = e._loadFunc, n;
  return ey(BD, r), n = r.apply(e, [t]), Array.isArray(n) ? n = Ah(n) : n == null ? n = Ah([]) : Ag(n) || Tj(BD), Pd(n);
}
function Noe(e, t) {
  var r = e._totalCountFunc, n;
  if (!ct(r))
    throw vi.Error("E4021");
  return n = r.apply(e, [t]), Ag(n) || (n = Number(n), isFinite(n) || Tj(Cj), n = Ah(n)), Pd(n);
}
function Voe(e, t, r) {
  var n = e._byKeyFunc, i;
  return ey(Ej, n), i = n.apply(e, [t, r]), Ag(i) || (i = Ah(i)), Pd(i);
}
function Aj(e, t, r, n) {
  if (t.__rawData)
    n(t.__rawData);
  else {
    var i = t.__rawDataPromise || wj(t, r);
    t._cacheRawData && (t.__rawDataPromise = i), i.always(function() {
      delete t.__rawDataPromise;
    }).done(function(s) {
      t._cacheRawData && (t.__rawData = s), n(s);
    }).fail(fh(e));
  }
}
function e4(e, t, r, n) {
  r = r || {};
  var i = {};
  "userData" in r && (i.userData = r.userData), Aj(e, t, i, function(s) {
    var l = zT(s, {
      errorHandler: t._errorHandler
    }), d, h, p = [], m, x;
    n || (d = VD.queryByOptions(l, r), d === l ? m = s.slice(0) : p.push(d.enumerate().done(function(S) {
      m = S;
    }))), (r.requireTotalCount || n) && (h = VD.queryByOptions(l, r, !0), h === l ? x = s.length : p.push(h.count().done(function(S) {
      x = S;
    }))), Ps.apply(je, p).done(function() {
      n ? e.resolve(x) : r.requireTotalCount ? e.resolve(m, {
        totalCount: x
      }) : e.resolve(m);
    }).fail(function(S) {
      e.reject(S);
    });
  });
}
function Foe(e, t, r) {
  Aj(e, t, {}, function(n) {
    for (var i = t.key(), s, l = 0, d = n.length; l < d; l++)
      if (s = n[l], xL(i, t.keyOf(n[l]), r)) {
        e.resolve(s);
        return;
      }
    e.reject(vi.Error("E4009"));
  });
}
var TL = ec.inherit({
  ctor: function(e) {
    e = e || {}, this.callBase(e), this._useDefaultSearch = !!e.useDefaultSearch || e.loadMode === "raw", this._loadMode = e.loadMode, this._cacheRawData = e.cacheRawData !== !1, this._loadFunc = e[BD], this._totalCountFunc = e[Cj], this._byKeyFunc = e[Ej], this._insertFunc = e[Z2], this._updateFunc = e[Q2], this._removeFunc = e[J2];
  },
  _clearCache() {
    delete this.__rawData;
  },
  createQuery: function() {
    throw vi.Error("E4010");
  },
  clearRawDataCache: function() {
    this._clearCache();
  },
  _totalCountImpl: function(e) {
    var t = new Yt();
    return this._loadMode === "raw" && !this._totalCountFunc ? e4(t, this, e, !0) : (Noe(this, e).done(function(r) {
      t.resolve(Number(r));
    }).fail(fh(t)), t = this._addFailHandlers(t)), t.promise();
  },
  _pushImpl: function(e) {
    this.__rawData && SL({
      keyInfo: this,
      data: this.__rawData,
      changes: e
    });
  },
  _loadImpl: function(e) {
    var t = new Yt();
    return this._loadMode === "raw" ? e4(t, this, e, !1) : (wj(this, e).done(function(r, n) {
      t.resolve(r, n);
    }).fail(fh(t)), t = this._addFailHandlers(t)), t.promise();
  },
  _byKeyImpl: function(e, t) {
    var r = new Yt();
    return this._byKeyViaLoad() ? (this._requireKey(), Foe(r, this, e)) : Voe(this, e, t).done(function(n) {
      r.resolve(n);
    }).fail(fh(r)), r.promise();
  },
  _byKeyViaLoad: function() {
    return this._loadMode === "raw" && !this._byKeyFunc;
  },
  _insertImpl: function(e) {
    var t = this, r = t._insertFunc, n, i = new Yt();
    return ey(Z2, r), n = r.apply(t, [e]), Ag(n) || (n = Ah(n)), Pd(n).done(function(s) {
      Zr().useLegacyStoreResult ? i.resolve(e, s) : i.resolve(s || e, t.keyOf(s));
    }).fail(fh(i)), i.promise();
  },
  _updateImpl: function(e, t) {
    var r = this._updateFunc, n, i = new Yt();
    return ey(Q2, r), n = r.apply(this, [e, t]), Ag(n) || (n = Ah(n)), Pd(n).done(function(s) {
      Zr().useLegacyStoreResult ? i.resolve(e, t) : i.resolve(s || t, e);
    }).fail(fh(i)), i.promise();
  },
  _removeImpl: function(e) {
    var t = this._removeFunc, r, n = new Yt();
    return ey(J2, t), r = t.apply(this, [e]), Ag(r) || (r = Ah()), Pd(r).done(function() {
      n.resolve(e);
    }).fail(fh(n)), n.promise();
  }
});
function Oj(e) {
  var t = [], r = !1;
  function n() {
    for (; t.length; ) {
      r = !0;
      var i = t.shift(), s = i();
      if (s !== void 0) {
        if (s.then) {
          Ps(s).always(n);
          return;
        }
        throw Dr.Error("E0015");
      }
    }
    r = !1;
  }
  return {
    add: function(i, s) {
      e ? (t[0] && s && s(t[0]), t = [i]) : t.push(i), r || n();
    },
    busy: function() {
      return r;
    }
  };
}
var Sve = Oj().add, Boe = jr(), zoe = {
  getXhr: function() {
    return new Boe.XMLHttpRequest();
  }
};
const Hoe = Fs(zoe);
var wL = jr(), ty = "success", Bk = "error", Goe = "timeout", Uoe = "nocontent", joe = "parsererror", $oe = function(e) {
  return 200 <= e && e < 300;
}, Yoe = function(e) {
  return e !== 204;
}, Woe = function(e) {
  var t = [];
  for (var r in e) {
    var n = e[r];
    n !== void 0 && (n === null && (n = ""), typeof n == "function" && (n = n()), t.push(encodeURIComponent(r) + "=" + encodeURIComponent(n)));
  }
  return t.join("&");
}, kj = function(e) {
  var t = we.createElement("script");
  for (var r in e)
    t[r] = e[r];
  return t;
}, Rj = function(e) {
  e.parentNode.removeChild(e);
}, Dj = function(e) {
  return we.getHead().appendChild(e);
}, t4 = function(e) {
  var t = kj({
    text: e
  });
  Dj(t), Rj(t);
}, Xoe = function(e) {
  var t = kj({
    src: e
  });
  return new Promise(function(r, n) {
    var i = {
      load: r,
      error: n
    }, s = function(d) {
      i[d.type](), Rj(t);
    };
    for (var l in i)
      we.listen(t, l, s);
    Dj(t);
  });
}, qoe = function(e) {
  var t = e.dataType || "*", r = "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript", n = {
    "*": "*/*",
    text: "text/plain",
    html: "text/html",
    xml: "application/xml, text/xml",
    json: "application/json, text/javascript",
    jsonp: r,
    script: r
  };
  return TX(n, e.accepts, !0), n[t] ? n[t] + (t !== "*" ? ", */*; q=0.01" : "") : n["*"];
}, Koe = function(e) {
  var t;
  return e.data && !e.upload && AL(e) !== "GET" && (t = "application/x-www-form-urlencoded;charset=utf-8"), e.contentType || t;
}, Zoe = function(e) {
  return e.responseType && e.responseType !== "text" || typeof e.responseText != "string" ? e.response : e.responseText;
}, Qoe = function(e, t, r) {
  var n = Zoe(t);
  switch (r) {
    case "jsonp":
      t4(n);
      break;
    case "script":
      t4(n), e.resolve(n, ty, t);
      break;
    case "json":
      try {
        e.resolve(JSON.parse(n), ty, t);
      } catch (i) {
        e.reject(t, joe, i);
      }
      break;
    default:
      e.resolve(n, ty, t);
  }
}, Joe = function(e) {
  if (!fn())
    return !0;
  var t = !1, r = we.createElement("a"), n = we.createElement("a");
  r.href = wL.location.href;
  try {
    n.href = e, n.href = n.href, t = r.protocol + "//" + r.host != n.protocol + "//" + n.host;
  } catch {
    t = !0;
  }
  return t;
}, ese = function(e, t) {
  return e && setTimeout(function() {
    t.customStatus = Goe, t.abort();
  }, e);
}, tse = function(e) {
  if (e.dataType === "jsonp") {
    var t = Math.random().toString().replace(/\D/g, ""), r = e.jsonpCallback || "dxCallback" + Date.now() + "_" + t, n = e.jsonp || "callback";
    return e.data = e.data || {}, e.data[n] = r, r;
  }
}, rse = function(e, t) {
  var r = e.data, n = typeof r == "string", i = e.url || wL.location.href;
  return !n && !e.cache && (r = r || {}, r._ = Date.now()), r && !e.upload && (n || (r = Woe(r)), AL(e) === "GET" ? (r !== "" && (i += (i.indexOf("?") > -1 ? "&" : "?") + r), r = null) : t["Content-Type"] && t["Content-Type"].indexOf("application/x-www-form-urlencoded") > -1 && (r = r.replace(/%20/g, "+"))), {
    url: i,
    parameters: r
  };
};
function AL(e) {
  return (e.method || "GET").toUpperCase();
}
var nse = function(e) {
  var t = e.headers || {};
  return t["Content-Type"] = t["Content-Type"] || Koe(e), t.Accept = t.Accept || qoe(e), !e.crossDomain && !t["X-Requested-With"] && (t["X-Requested-With"] = "XMLHttpRequest"), t;
}, ise = function(e) {
  var t = Hoe.getXhr(), r = new Yt(), n = r.promise(), i = I(e.async) ? e.async : !0, s = e.dataType, l = e.timeout || 0, d;
  e.crossDomain = Joe(e.url);
  var h = s === "jsonp" || s === "script";
  e.cache === void 0 && (e.cache = !h);
  var p = tse(e), m = nse(e), x = rse(e, m), S = x.url, T = x.parameters;
  if (p && (wL[p] = function(D) {
    r.resolve(D, ty, t);
  }), e.crossDomain && h)
    return Xoe(S).then(function() {
      s !== "jsonp" && r.resolve(null, ty, t);
    }, function() {
      r.reject(t, Bk);
    }), n;
  if (e.crossDomain && !("withCredentials" in t))
    return r.reject(t, Bk), n;
  if (t.open(AL(e), S, i, e.username, e.password), i && (t.timeout = l, d = ese(l, t)), t.onreadystatechange = function(D) {
    t.readyState === 4 && (clearTimeout(d), $oe(t.status) ? Yoe(t.status) ? Qoe(r, t, s) : r.resolve(null, Uoe, t) : r.reject(t, t.customStatus || Bk));
  }, e.upload && (t.upload.onprogress = e.upload.onprogress, t.upload.onloadstart = e.upload.onloadstart, t.upload.onabort = e.upload.onabort), e.xhrFields)
    for (var k in e.xhrFields)
      t[k] = e.xhrFields[k];
  e.responseType === "arraybuffer" && (t.responseType = e.responseType);
  for (var O in m)
    Object.prototype.hasOwnProperty.call(m, O) && I(m[O]) && t.setRequestHeader(O, m[O]);
  return e.beforeSend && e.beforeSend(t), t.send(T), n.abort = function() {
    t.abort();
  }, n;
};
const Mj = Fs({
  sendRequest: ise
}), ase = {};
var ose = function e(t, r, n) {
  n = n || [], r = r || {};
  var i = function(d, h) {
    return {
      name: d,
      args: h
    };
  }, s = function(d) {
    var h = new Yt(), p, m, x, S, T, k = function(L) {
      var F = r.errorHandler;
      F && F(L), bL(L), h.reject(L);
    };
    function O(L) {
      switch (L.name) {
        case "sortBy":
          return T = [L.args], !0;
        case "thenBy":
          if (!T)
            throw vi.Error("E4004");
          return T.push(L.args), !0;
      }
      return !1;
    }
    try {
      p = r.adapter, ct(p) || (p = ase[p]), m = p(r), x = [].concat(n).concat(d);
      var D = m.optimize;
      for (D && D(x); x.length; ) {
        if (S = x[0], !O(S)) {
          if (T) {
            x.unshift(i("multiSort", [T])), T = null;
            continue;
          }
          if (String(S.name) !== "enumerate" && (!m[S.name] || m[S.name].apply(m, S.args) === !1))
            break;
        }
        x.shift();
      }
      (function() {
        var L = x[0], F = [];
        L && L.name === "multiSort" && (x.shift(), be(L.args[0], function() {
          F.push(i(F.length ? "thenBy" : "sortBy", this));
        })), x = F.concat(x);
      })(), m.exec(t).done(function(L, F) {
        if (!x.length)
          h.resolve(L, F);
        else {
          var z = zT(L, {
            errorHandler: r.errorHandler
          });
          be(x, function() {
            z = z[this.name].apply(z, this.args);
          }), z.done(h.resolve).fail(h.reject);
        }
      }).fail(k);
    } catch (L) {
      k(L);
    }
    return h.promise();
  }, l = {};
  return be(["sortBy", "thenBy", "filter", "slice", "select", "groupBy"], function() {
    var d = String(this);
    l[d] = function() {
      return e(t, r, n.concat(i(d, arguments)));
    };
  }), be(["count", "min", "max", "sum", "avg", "aggregate", "enumerate"], function() {
    var d = String(this);
    l[d] = function() {
      return s.call(this, i(d, arguments));
    };
  }), l;
}, sse = {
  array: zT,
  remote: ose
}, lse = function() {
  var e = Array.isArray(arguments[0]) ? "array" : "remote";
  return sse[e].apply(this, arguments);
}, use = ec.inherit({
  ctor: function(e) {
    Array.isArray(e) ? e = {
      data: e
    } : e = e || {}, this.callBase(e);
    var t = e.data;
    if (t && !Array.isArray(t))
      throw vi.Error("E4006");
    this._array = t || [];
  },
  createQuery: function() {
    return lse(this._array, {
      errorHandler: this._errorHandler
    });
  },
  _byKeyImpl: function(e) {
    var t = Fy(this, this._array, e);
    return t === -1 ? pj(vi.Error("E4009")) : wg(this._array[t]);
  },
  _insertImpl: function(e) {
    return xj(this, this._array, e);
  },
  _pushImpl: function(e) {
    SL({
      keyInfo: this,
      data: this._array,
      changes: e
    });
  },
  _updateImpl: function(e, t) {
    return yj(this, this._array, e, t);
  },
  _removeImpl: function(e) {
    return bj(this, this._array, e);
  },
  clear: function() {
    this._eventsStrategy.fireEvent("modifying"), this._array = [], this._eventsStrategy.fireEvent("modified");
  }
}, "array"), cse = ["items"], Lj = "canceled", r4 = (e) => e.state() === "pending", n4 = (e) => {
  switch (e.length) {
    case 0:
      return;
    case 1:
      return e[0];
  }
  return [].slice.call(e);
}, dse = (e, t, r) => Bl(e, (n) => {
  var i = X3(n, cse);
  return ei({}, i, {
    items: Pj(n.items, t - 1, r)
  });
}), Pj = (e, t, r) => Array.isArray(e) ? t ? dse(e, t, r) : Bl(e, r) : e, fse = (e, t, r) => {
  var n = r ? PD(r).length : 0;
  return Pj(e, n, t);
}, hse = (e, t) => {
  var r;
  return (r = e) !== null && r !== void 0 && r.data && (t = e, e = e.data), Array.isArray(e) || (e = [e]), {
    data: e,
    extra: t
  };
}, vse = (e) => {
  var t = {};
  return be(["useDefaultSearch", "key", "load", "loadMode", "cacheRawData", "byKey", "lookup", "totalCount", "insert", "update", "remove"], function() {
    t[this] = e[this], delete e[this];
  }), new TL(t);
}, pse = (e) => {
  var t = e.type;
  return delete e.type, ec.create(t, e);
}, gse = (e, t) => new TL({
  load: () => Mj.sendRequest({
    url: e,
    dataType: "json"
  }),
  loadMode: t == null ? void 0 : t.fromUrlLoadMode
}), Ij = (e, t) => {
  var r;
  return typeof e == "string" && (e = {
    paginate: !1,
    store: gse(e, t)
  }), e === void 0 && (e = []), Array.isArray(e) || e instanceof ec ? e = {
    store: e
  } : e = W({}, e), e.store === void 0 && (e.store = []), r = e.store, "load" in e ? r = vse(e) : Array.isArray(r) ? r = new use(r) : Qr(r) && (r = pse(W({}, r))), e.store = r, e;
};
class mse {
  constructor() {
    this._counter = -1, this._deferreds = {};
  }
  add(t) {
    return this._counter++, this._deferreds[this._counter] = t, this._counter;
  }
  remove(t) {
    return delete this._deferreds[t];
  }
  cancel(t) {
    return t in this._deferreds ? (this._deferreds[t].reject(Lj), !0) : !1;
  }
  cancelAll() {
    for (; this._counter > -1; )
      this.cancel(this._counter), this._counter--;
  }
}
var i4 = Qi.inherit({
  ctor(e) {
    var t;
    e = Ij(e), this._eventsStrategy = new zg(this, {
      syncStrategy: !0
    }), this._store = e.store, this._changedTime = 0;
    var r = e.pushAggregationTimeout !== 0;
    if (r) {
      var n = e.pushAggregationTimeout === void 0 ? () => 5 * this._changedTime : e.pushAggregationTimeout, i, s, l = Soe((d) => {
        i.resolve();
        var h = Ps(...s);
        h.done(() => this._onPush(d)), s = void 0, i = void 0;
      }, n);
      this._onPushHandler = (d) => {
        this._aggregationTimeoutId = l(d.changes), i || (i = new Yt()), s = d.waitFor, d.waitFor.push(i.promise());
      }, this._store.on("beforePushAggregation", this._onPushHandler);
    } else
      this._onPushHandler = (d) => this._onPush(d), this._store.on("push", this._onPushHandler);
    this._storeLoadOptions = this._extractLoadOptions(e), this._mapFunc = e.map, this._postProcessFunc = e.postProcess, this._pageIndex = e.pageIndex !== void 0 ? e.pageIndex : 0, this._pageSize = e.pageSize !== void 0 ? e.pageSize : 20, this._loadingCount = 0, this._loadQueue = this._createLoadQueue(), this._searchValue = "searchValue" in e ? e.searchValue : null, this._searchOperation = e.searchOperation || "contains", this._searchExpr = e.searchExpr, this._paginate = e.paginate, this._reshapeOnPush = (t = e.reshapeOnPush) !== null && t !== void 0 ? t : !1, be(["onChanged", "onLoadError", "onLoadingChanged", "onCustomizeLoadResult", "onCustomizeStoreLoadOptions"], (d, h) => {
      h in e && this.on(h.substr(2, 1).toLowerCase() + h.substr(3), e[h]);
    }), this._operationManager = new mse(), this._init();
  },
  _init() {
    this._items = [], this._userData = {}, this._totalCount = -1, this._isLoaded = !1, I(this._paginate) || (this._paginate = !this.group()), this._isLastPage = !this._paginate;
  },
  dispose() {
    var e;
    this._store.off("beforePushAggregation", this._onPushHandler), this._store.off("push", this._onPushHandler), this._eventsStrategy.dispose(), clearTimeout(this._aggregationTimeoutId), (e = this._delayedLoadTask) === null || e === void 0 || e.abort(), this._operationManager.cancelAll(), delete this._store, delete this._items, delete this._delayedLoadTask, this._disposed = !0;
  },
  _extractLoadOptions(e) {
    var t = {}, r = ["sort", "filter", "langParams", "select", "group", "requireTotalCount"], n = this._store._customLoadOptions();
    return n && (r = r.concat(n)), be(r, function() {
      t[this] = e[this];
    }), t;
  },
  loadOptions() {
    return this._storeLoadOptions;
  },
  items() {
    return this._items;
  },
  pageIndex(e) {
    if (!Sr(e))
      return this._pageIndex;
    this._pageIndex = e, this._isLastPage = !this._paginate;
  },
  paginate(e) {
    if (!FR(e))
      return this._paginate;
    this._paginate !== e && (this._paginate = e, this.pageIndex(0));
  },
  pageSize(e) {
    if (!Sr(e))
      return this._pageSize;
    this._pageSize = e;
  },
  isLastPage() {
    return this._isLastPage;
  },
  generateStoreLoadOptionAccessor(e) {
    return (t) => {
      var r = n4(t);
      if (r === void 0)
        return this._storeLoadOptions[e];
      this._storeLoadOptions[e] = r;
    };
  },
  sort() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.generateStoreLoadOptionAccessor("sort")(t);
  },
  filter() {
    var e = n4(arguments);
    if (e === void 0)
      return this._storeLoadOptions.filter;
    this._storeLoadOptions.filter = e, this.pageIndex(0);
  },
  group() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.generateStoreLoadOptionAccessor("group")(t);
  },
  select() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return this.generateStoreLoadOptionAccessor("select")(t);
  },
  requireTotalCount(e) {
    if (!FR(e))
      return this._storeLoadOptions.requireTotalCount;
    this._storeLoadOptions.requireTotalCount = e;
  },
  searchValue(e) {
    if (arguments.length < 1)
      return this._searchValue;
    this._searchValue = e, this.pageIndex(0);
  },
  searchOperation(e) {
    if (!lr(e))
      return this._searchOperation;
    this._searchOperation = e, this.pageIndex(0);
  },
  searchExpr(e) {
    var t = arguments.length;
    if (t === 0)
      return this._searchExpr;
    t > 1 && (e = [].slice.call(arguments)), this._searchExpr = e, this.pageIndex(0);
  },
  store() {
    return this._store;
  },
  key() {
    var e;
    return (e = this._store) === null || e === void 0 ? void 0 : e.key();
  },
  totalCount() {
    return this._totalCount;
  },
  isLoaded() {
    return this._isLoaded;
  },
  isLoading() {
    return this._loadingCount > 0;
  },
  beginLoading() {
    this._changeLoadingCount(1);
  },
  endLoading() {
    this._changeLoadingCount(-1);
  },
  _createLoadQueue: () => Oj(),
  _changeLoadingCount(e) {
    var t = this.isLoading();
    this._loadingCount += e;
    var r = this.isLoading();
    t ^ r && this._eventsStrategy.fireEvent("loadingChanged", [r]);
  },
  _scheduleLoadCallbacks(e) {
    this.beginLoading(), e.always(() => {
      this.endLoading();
    });
  },
  _scheduleFailCallbacks(e) {
    var t = this;
    e.fail(function() {
      for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++)
        n[i] = arguments[i];
      n[0] !== Lj && t._eventsStrategy.fireEvent("loadError", n);
    });
  },
  _fireChanged(e) {
    var t = /* @__PURE__ */ new Date();
    this._eventsStrategy.fireEvent("changed", e), this._changedTime = /* @__PURE__ */ new Date() - t;
  },
  _scheduleChangedCallbacks(e) {
    e.done(() => this._fireChanged());
  },
  loadSingle(e, t) {
    var r = new Yt(), n = this.key(), i = this._store, s = this._createStoreLoadOptions();
    return this._scheduleFailCallbacks(r), arguments.length < 2 && (t = e, e = n), delete s.skip, delete s.group, delete s.refresh, delete s.pageIndex, delete s.searchString, (e === n || i instanceof TL && !i._byKeyViaLoad() ? i.byKey(t, s) : (s.take = 1, s.filter = s.filter ? [s.filter, [e, t]] : [e, t], i.load(s))).fail(r.reject).done((l) => {
      var d = Array.isArray(l) && !l.length;
      !I(l) || d ? r.reject(new vi.Error("E4009")) : (Array.isArray(l) || (l = [l]), r.resolve(this._applyMapFunction(l)[0]));
    }), r.promise();
  },
  load() {
    var e = new Yt(), t = () => {
      if (!this._disposed && r4(e))
        return this._loadFromStore(r, e);
    };
    this._scheduleLoadCallbacks(e), this._scheduleFailCallbacks(e), this._scheduleChangedCallbacks(e);
    var r = this._createLoadOperation(e);
    return this._eventsStrategy.fireEvent("customizeStoreLoadOptions", [r]), this._loadQueue.add(() => (typeof r.delay == "number" ? this._delayedLoadTask = $X(t, r.delay) : t(), e.promise())), e.promise({
      operationId: r.operationId
    });
  },
  _onPush(e) {
    if (this._reshapeOnPush)
      this.load();
    else {
      var t = {
        changes: e
      };
      this._eventsStrategy.fireEvent("changing", [t]);
      var r = this.group(), n = this.items(), i = 0, s = this.paginate() || r ? e.filter((l) => l.type === "update") : e;
      r && (i = Array.isArray(r) ? r.length : 1), this._mapFunc && s.forEach((l) => {
        l.type === "insert" && (l.data = this._mapFunc(l.data));
      }), t.postProcessChanges && (s = t.postProcessChanges(s)), SL({
        keyInfo: this.store(),
        data: n,
        changes: s,
        groupCount: i,
        useInsertIndex: !0
      }), this._fireChanged([{
        changes: e
      }]);
    }
  },
  _createLoadOperation(e) {
    var t = this._operationManager.add(e), r = this._createStoreLoadOptions();
    return this._store && !Bd(r == null ? void 0 : r.langParams) && (this._store._langParams = ei({}, this._store._langParams, r.langParams)), e.always(() => this._operationManager.remove(t)), {
      operationId: t,
      storeLoadOptions: r
    };
  },
  reload() {
    var e = this.store();
    return e._clearCache(), this._init(), this.load();
  },
  cancel(e) {
    return this._operationManager.cancel(e);
  },
  cancelAll() {
    return this._operationManager.cancelAll();
  },
  _addSearchOptions(e) {
    this._disposed || (this.store()._useDefaultSearch ? this._addSearchFilter(e) : (e.searchOperation = this._searchOperation, e.searchValue = this._searchValue, e.searchExpr = this._searchExpr));
  },
  _createStoreLoadOptions() {
    var e = W({}, this._storeLoadOptions);
    return this._addSearchOptions(e), this._paginate && this._pageSize && (e.skip = this._pageIndex * this._pageSize, e.take = this._pageSize), e.userData = this._userData, e;
  },
  _addSearchFilter(e) {
    var t = this._searchValue, r = this._searchOperation, n = this._searchExpr, i = [];
    t && (n || (n = "this"), Array.isArray(n) || (n = [n]), be(n, function(s, l) {
      i.length && i.push("or"), i.push([l, r, t]);
    }), e.filter ? e.filter = [i, e.filter] : e.filter = i);
  },
  _loadFromStore(e, t) {
    var r = (n, i) => {
      if (!this._disposed && r4(t)) {
        var s = W(hse(n, i), e);
        this._eventsStrategy.fireEvent("customizeLoadResult", [s]), Ps(s.data).done((l) => {
          s.data = l, this._processStoreLoadResult(s, t);
        }).fail(t.reject);
      }
    };
    return e.data ? new Yt().resolve(e.data).done(r) : this.store().load(e.storeLoadOptions).done(r).fail(t.reject);
  },
  _processStoreLoadResult(e, t) {
    var r = e.data, n = e.extra, i = e.storeLoadOptions, s = () => (this._isLoaded = !0, this._totalCount = isFinite(n.totalCount) ? n.totalCount : -1, t.resolve(r, n));
    this._disposed || (r = this._applyPostProcessFunction(this._applyMapFunction(r)), hi(n) || (n = {}), this._items = r, (!r.length || !this._paginate || this._pageSize && r.length < this._pageSize) && (this._isLastPage = !0), i.requireTotalCount && !isFinite(n.totalCount) ? this.store().totalCount(i).done(function(l) {
      n.totalCount = l, s();
    }).fail(t.reject) : s());
  },
  _applyMapFunction(e) {
    return this._mapFunc ? fse(e, this._mapFunc, this.group()) : e;
  },
  _applyPostProcessFunction(e) {
    return this._postProcessFunc ? this._postProcessFunc(e) : e;
  },
  on(e, t) {
    return this._eventsStrategy.on(e, t), this;
  },
  off(e, t) {
    return this._eventsStrategy.off(e, t), this;
  }
}), _se = {
  load: () => Yt().reject(),
  loadSingle: () => Yt().reject(),
  loadFromStore: () => Yt().reject(),
  loadNextPage: () => Yt().reject(),
  loadOptions: Y,
  userData: Y,
  cancel: Y,
  cancelAll: Y,
  filter: Y,
  addSearchFilter: Y,
  group: Y,
  paginate: Y,
  pageSize: Y,
  pageIndex: Y,
  resetDataSourcePageIndex: Y,
  totalCount: Y,
  isLastPage: Y,
  isLoading: Y,
  isLoaded: Y,
  searchValue: Y,
  searchOperation: Y,
  searchExpr: Y,
  select: Y,
  key: Y,
  keyOf: Y,
  store: Y,
  items: Y,
  applyMapFunction: Y,
  getDataSource: Y,
  reload: Y,
  on: Y,
  off: Y
};
class yse {
  constructor(t) {
    if (!t)
      return _se;
    this._dataSource = t;
  }
  load() {
    return this._dataSource.load();
  }
  loadSingle(t, r) {
    return arguments.length < 2 && (r = t, t = this.key()), this._dataSource.loadSingle(t, r);
  }
  loadFromStore(t) {
    return this.store().load(t);
  }
  loadNextPage() {
    return this.pageIndex(1 + this.pageIndex()), this.load();
  }
  loadOptions() {
    return this._dataSource.loadOptions();
  }
  userData() {
    return this._dataSource._userData;
  }
  cancel(t) {
    this._dataSource.cancel(t);
  }
  cancelAll() {
    this._dataSource.cancelAll();
  }
  filter(t) {
    return this._dataSource.filter(t);
  }
  addSearchFilter(t) {
    this._dataSource._addSearchFilter(t);
  }
  group(t) {
    return this._dataSource.group(t);
  }
  paginate() {
    return this._dataSource.paginate();
  }
  pageSize() {
    return this._dataSource._pageSize;
  }
  pageIndex(t) {
    return this._dataSource.pageIndex(t);
  }
  resetDataSourcePageIndex() {
    this.pageIndex() && (this.pageIndex(0), this.load());
  }
  totalCount() {
    return this._dataSource.totalCount();
  }
  isLastPage() {
    return this._dataSource.isLastPage() || !this._dataSource._pageSize;
  }
  isLoading() {
    return this._dataSource.isLoading();
  }
  isLoaded() {
    return this._dataSource.isLoaded();
  }
  searchValue(t) {
    return arguments.length ? this._dataSource.searchValue(t) : this._dataSource.searchValue();
  }
  searchOperation(t) {
    return this._dataSource.searchOperation(t);
  }
  searchExpr(t) {
    return arguments.length ? this._dataSource.searchExpr(t) : this._dataSource.searchExpr();
  }
  select() {
    return this._dataSource.select(...arguments);
  }
  key() {
    return this._dataSource.key();
  }
  keyOf(t) {
    return this.store().keyOf(t);
  }
  store() {
    return this._dataSource.store();
  }
  items() {
    return this._dataSource.items();
  }
  applyMapFunction(t) {
    return this._dataSource._applyMapFunction(t);
  }
  getDataSource() {
    return this._dataSource || null;
  }
  reload() {
    return this._dataSource.reload();
  }
  on(t, r) {
    this._dataSource.on(t, r);
  }
  off(t, r) {
    this._dataSource.off(t, r);
  }
}
var a4 = "_dataSourceOptions", o4 = "_dataSourceChangedHandler", s4 = "_dataSourceLoadErrorHandler", l4 = "_dataSourceLoadingChangedHandler", u4 = "_dataSourceFromUrlLoadMode", c4 = "_getSpecificDataSourceOption", d4 = "_normalizeDataSource", zD = {
  postCtor: function() {
    this.on("disposing", (function() {
      this._disposeDataSource();
    }).bind(this));
  },
  _refreshDataSource: function() {
    this._initDataSource(), this._loadDataSource();
  },
  _initDataSource: function() {
    var e = c4 in this ? this[c4]() : this.option("dataSource"), t, r;
    this._disposeDataSource(), e && (e instanceof i4 ? (this._isSharedDataSource = !0, this._dataSource = e) : (t = a4 in this ? this[a4]() : {}, r = this._dataSourceType ? this._dataSourceType() : i4, e = Ij(e, {
      fromUrlLoadMode: u4 in this && this[u4]()
    }), this._dataSource = new r(W(!0, {}, t, e))), d4 in this && (this._dataSource = this[d4](this._dataSource)), this._addDataSourceHandlers(), this._initDataController());
  },
  _initDataController: function() {
    var e, t = (e = this.option) === null || e === void 0 ? void 0 : e.call(this, "_dataController"), r = this._dataSource;
    t ? this._dataController = t : this._dataController = new yse(r);
  },
  _addDataSourceHandlers: function() {
    o4 in this && this._addDataSourceChangeHandler(), s4 in this && this._addDataSourceLoadErrorHandler(), l4 in this && this._addDataSourceLoadingChangedHandler(), this._addReadyWatcher();
  },
  _addReadyWatcher: function() {
    this.readyWatcher = (function(e) {
      this._ready && this._ready(!e);
    }).bind(this), this._dataSource.on("loadingChanged", this.readyWatcher);
  },
  _addDataSourceChangeHandler: function() {
    var e = this._dataSource;
    this._proxiedDataSourceChangedHandler = (function(t) {
      this[o4](e.items(), t);
    }).bind(this), e.on("changed", this._proxiedDataSourceChangedHandler);
  },
  _addDataSourceLoadErrorHandler: function() {
    this._proxiedDataSourceLoadErrorHandler = this[s4].bind(this), this._dataSource.on("loadError", this._proxiedDataSourceLoadErrorHandler);
  },
  _addDataSourceLoadingChangedHandler: function() {
    this._proxiedDataSourceLoadingChangedHandler = this[l4].bind(this), this._dataSource.on("loadingChanged", this._proxiedDataSourceLoadingChangedHandler);
  },
  _loadDataSource: function() {
    var e = this._dataSource;
    e && (e.isLoaded() ? this._proxiedDataSourceChangedHandler && this._proxiedDataSourceChangedHandler() : e.load());
  },
  _loadSingle: function(e, t) {
    return e = e === "this" ? this._dataSource.key() || "this" : e, this._dataSource.loadSingle(e, t);
  },
  _isLastPage: function() {
    return !this._dataSource || this._dataSource.isLastPage() || !this._dataSource._pageSize;
  },
  _isDataSourceLoading: function() {
    return this._dataSource && this._dataSource.isLoading();
  },
  _disposeDataSource: function() {
    this._dataSource && (this._isSharedDataSource ? (delete this._isSharedDataSource, this._proxiedDataSourceChangedHandler && this._dataSource.off("changed", this._proxiedDataSourceChangedHandler), this._proxiedDataSourceLoadErrorHandler && this._dataSource.off("loadError", this._proxiedDataSourceLoadErrorHandler), this._proxiedDataSourceLoadingChangedHandler && this._dataSource.off("loadingChanged", this._proxiedDataSourceLoadingChangedHandler), this._dataSource._eventsStrategy && this._dataSource._eventsStrategy.off("loadingChanged", this.readyWatcher)) : this._dataSource.dispose(), delete this._dataSource, delete this._proxiedDataSourceChangedHandler, delete this._proxiedDataSourceLoadErrorHandler, delete this._proxiedDataSourceLoadingChangedHandler);
  },
  getDataSource: function() {
    return this._dataSource || null;
  }
}, xse = zD.postCtor, EC, Nj = {
  _dataSourceLoadErrorHandler: function() {
    this._dataSourceChangedHandler();
  },
  _dataSourceOptions: function() {
    return {
      paginate: !1
    };
  },
  _updateDataSource: function() {
    this._refreshDataSource(), this.option("dataSource") || this._dataSourceChangedHandler();
  },
  _dataIsLoaded: function() {
    return !this._dataSource || this._dataSource.isLoaded();
  },
  _dataSourceItems: function() {
    return this._dataSource && this._dataSource.items();
  }
};
for (EC in zD)
  EC !== "postCtor" && (Nj[EC] = zD[EC]);
var bse = {
  name: "data_source",
  init: function() {
    xse.call(this);
  },
  dispose: Y,
  members: Nj
}, md = jr(), zk = Dy(), f4 = {
  EXCEL: "xlsx",
  CSS: "css",
  PNG: "png",
  JPEG: "jpeg",
  GIF: "gif",
  SVG: "svg",
  PDF: "pdf"
}, Sse = {
  CSS: "text/css",
  EXCEL: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  PNG: "image/png",
  JPEG: "image/jpeg",
  GIF: "image/gif",
  SVG: "image/svg+xml",
  PDF: "application/pdf"
}, Cse = {
  _revokeObjectURLTimeout: 3e4,
  _getDataUri: function(e, t) {
    var r = this._getMimeType(e);
    return "data:".concat(r, ";base64,").concat(t);
  },
  _getMimeType: function(e) {
    return Sse[e] || "application/octet-stream";
  },
  _linkDownloader: function(e, t) {
    var r = we.createElement("a");
    return r.download = e, r.href = t, r.target = "_blank", r;
  },
  _winJSBlobSave: function(e, t, r) {
    var n = new Windows.Storage.Pickers.FileSavePicker();
    n.suggestedStartLocation = Windows.Storage.Pickers.PickerLocationId.documentsLibrary;
    var i = f4[r];
    if (i) {
      var s = this._getMimeType(r);
      n.fileTypeChoices.insert(s, ["." + i]);
    }
    n.suggestedFileName = t, n.pickSaveFileAsync().then(function(l) {
      l && l.openAsync(Windows.Storage.FileAccessMode.readWrite).then(function(d) {
        var h = e.msDetachStream();
        Windows.Storage.Streams.RandomAccessStream.copyAsync(h, d).then(function() {
          d.flushAsync().done(function() {
            h.close(), d.close();
          });
        });
      });
    });
  },
  _click: function(e) {
    try {
      e.dispatchEvent(new MouseEvent("click", {
        cancelable: !0
      }));
    } catch {
      var t = we.getDocument().createEvent("MouseEvents");
      t.initMouseEvent("click", !0, !0, md, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(t);
    }
  },
  _saveBlobAs: function(e, t, r) {
    if (this._blobSaved = !1, I(zk.msSaveOrOpenBlob))
      zk.msSaveOrOpenBlob(r, e), this._blobSaved = !0;
    else if (I(md.WinJS))
      this._winJSBlobSave(r, e, t), this._blobSaved = !0;
    else {
      var n = md.URL || md.webkitURL || md.mozURL || md.msURL || md.oURL;
      if (I(n)) {
        var i = n.createObjectURL(r), s = this._linkDownloader(e, i);
        setTimeout(() => {
          n.revokeObjectURL(i), this._objectUrlRevoked = !0;
        }, this._revokeObjectURLTimeout), this._click(s);
      } else
        kg.warn("window.URL || window.webkitURL || window.mozURL || window.msURL || window.oURL is not defined");
    }
  },
  saveAs: function(e, t, r) {
    var n = f4[t];
    if (n && (e += "." + n), ct(md.Blob))
      this._saveBlobAs(e, t, r);
    else {
      I(zk.userAgent.match(/iPad/i)) || VT.log("E1034");
      var i = this._linkDownloader(e, this._getDataUri(t, r));
      this._click(i);
    }
  }
}, Oh = jr(), $d = Math, OL = $d.PI, Ese = $d.min, Tse = $d.abs, h4 = $d.sqrt, TC = $d.pow, Hk = $d.atan2, wse = $d.cos, Ase = $d.sin, Ut = Number, Ose = 1, v4 = 0.05, kse = "10px", Rse = "sans-serif", Dse = "#000", kL;
function Mse(e, t) {
  var r = e.toDataURL(t, Ose), n = Oh.atob(r.substring(("data:" + t + ";base64,").length));
  return n;
}
function p4(e, t, r, n, i, s, l, d) {
  var h = (e + r) / 2, p = (t + n) / 2, m = Hk(t - n, e - r), x = s ? 1 : -1;
  m += OL / 180 * 90 * (l ? 1 : -1);
  var S = h4(TC(r - e, 2) + TC(n - t, 2)) / 2, T = h4(Tse(TC(i, 2) - TC(S, 2))), k = h + x * (T * wse(m)), O = p + x * (T * Ase(m)), D = Hk(t - O, e - k), L = Hk(n - O, r - k);
  d.arc(k, O, i, D, L, !l);
}
function HT(e, t) {
  var r = kL(e.attributes || {}), n = W({}, r, {
    text: e.textContent.replace(/\s+/g, " "),
    textAlign: r["text-anchor"] === "middle" ? "center" : r["text-anchor"]
  }), i = r.transform, s;
  return i && (s = i.match(/translate\(-*\d+([.]\d+)*(,*\s*-*\d+([.]\d+)*)*/), s && (s = s[0].match(/-*\d+([.]\d+)*/g), n.translateX = Ut(s[0]), n.translateY = s[1] ? Ut(s[1]) : 0), s = i.match(/rotate\(-*\d+([.]\d+)*(,*\s*-*\d+([.]\d+)*,*\s*-*\d+([.]\d+)*)*/), s && (s = s[0].match(/-*\d+([.]\d+)*/g), n.rotationAngle = Ut(s[0]), n.rotationX = s[1] && Ut(s[1]), n.rotationY = s[2] && Ut(s[2])), s = i.match(/scale\(-*\d+([.]\d+)*(,*\s*-*\d+([.]\d+)*)*/), s && (s = s[0].match(/-*\d+([.]\d+)*/g), n.scaleX = Ut(s[0]), s.length > 1 ? n.scaleY = Ut(s[1]) : n.scaleY = n.scaleX)), Nse(e, n, t), n;
}
function Lse(e, t) {
  var r = t.x, n = t.y, i = t.width, s = t.height, l = t.rx;
  l ? (l = Ese(l, i / 2, s / 2), e.save(), e.translate(r, n), e.moveTo(i / 2, 0), e.arcTo(i, 0, i, s, l), e.arcTo(i, s, 0, s, l), e.arcTo(0, s, 0, 0, l), e.arcTo(0, 0, l, 0, l), e.lineTo(i / 2, 0), e.restore()) : e.rect(r, n, i, s);
}
function Pse(e, t, r) {
  var n = new Yt(), i = new Oh.Image();
  return i.onload = function() {
    e.save(), e.globalAlpha = t.globalAlpha, DL(e, t), ML(e, t, r), e.drawImage(i, t.x || 0, t.y || 0, t.width, t.height), e.restore(), n.resolve();
  }, i.onerror = function() {
    n.resolve();
  }, i.setAttribute("crossOrigin", "anonymous"), i.src = t.href || t["xlink:href"], n;
}
function Ise(e, t) {
  var r = t.replace(/,/g, " ").split(/([A-Z])/i).filter((h) => h.trim() !== ""), n = 0, i, s, l;
  do
    switch (i = (r[n + 1] || "").trim().split(" "), r[n]) {
      case "M":
        e.moveTo(Ut(i[0]), Ut(i[1])), n += 2;
        break;
      case "L":
        for (var d = 0; d < i.length / 2; d++)
          e.lineTo(Ut(i[2 * d]), Ut(i[2 * d + 1]));
        n += 2;
        break;
      case "C":
        e.bezierCurveTo(Ut(i[0]), Ut(i[1]), Ut(i[2]), Ut(i[3]), Ut(i[4]), Ut(i[5])), n += 2;
        break;
      case "a":
        s = r[n - 1].trim().split(" "), l = s.length - 1, p4(Ut(s[l - 1]), Ut(s[l]), Ut(s[l - 1]) + Ut(i[5]), Ut(s[l]) + Ut(i[6]), Ut(i[0]), Ut(i[3]), Ut(i[4]), e), n += 2;
        break;
      case "A":
        s = r[n - 1].trim().split(" "), l = s.length - 1, p4(Ut(s[l - 1]), Ut(s[l]), Ut(i[5]), Ut(i[6]), Ut(i[0]), Ut(i[3]), Ut(i[4]), e), n += 2;
        break;
      case "Z":
        e.closePath(), n += 1;
        break;
      default:
        n++;
    }
  while (n < r.length);
}
function Nse(e, t, r) {
  var n = e.style || {}, i;
  for (i in n)
    n[i] !== "" && (t[Dg(i)] = n[i]);
  r && we.isElementNode(e) && (n = Oh.getComputedStyle(e), ["fill", "stroke", "stroke-width", "font-family", "font-size", "font-style", "font-weight"].forEach(function(s) {
    s in n && n[s] !== "" && (t[Dg(s)] = n[s]);
  }), ["opacity", "fill-opacity", "stroke-opacity"].forEach(function(s) {
    s in n && n[s] !== "" && n[s] !== "1" && (t[s] = Ut(n[s]));
  })), t.textDecoration = t.textDecoration || t.textDecorationLine, t.globalAlpha = I(t.opacity) ? t.opacity : t.globalAlpha;
}
function GT(e) {
  var t = e && e.match(/url\(.*#(.*?)["']?\)/i);
  return t && t[1];
}
function Vj(e, t) {
  var r = [];
  t.fontSize = t.fontSize || kse, t.fontFamily = t.fontFamily || Rse, t.fill = t.fill || Dse, t.fontStyle && r.push(t.fontStyle), t.fontWeight && r.push(t.fontWeight), r.push(t.fontSize), r.push(t.fontFamily), e.font = r.join(" "), e.textAlign = t.textAlign, e.fillStyle = t.fill, e.globalAlpha = t.globalAlpha;
}
function Vse(e, t, r) {
  Vj(e, t), Fj(e, t, r), t.text && e.fillText(t.text, t.x || 0, t.y || 0), LL(e, t, !0), Fse(e, t, r);
}
function Fse(e, t, r) {
  if (!(!t.textDecoration || t.textDecoration === "none")) {
    var n = t.x, i = e.measureText(t.text).width, s = parseInt(t.fontSize, 10), l = s * v4 < 1 ? 1 : s * v4, d = t.y;
    switch (t.textDecoration) {
      case "line-through":
        d -= s / 3 + l / 2;
        break;
      case "overline":
        d -= s - l;
        break;
      case "underline":
        d += l;
    }
    e.rect(n, d, i, l), zj(e, t, r), LL(e, t);
  }
}
function Bse(e) {
  e.strokeOpacity = e["stroke-opacity"] !== void 0 ? e["stroke-opacity"] : 1, e.fillOpacity = e["fill-opacity"] !== void 0 ? e["fill-opacity"] : 1, e.opacity !== void 0 && (e.strokeOpacity *= e.opacity, e.fillOpacity *= e.opacity);
}
function zse(e) {
  for (var t = e.childNodes, r = 0; r < t.length; r++)
    if (t[r].tagName === "tspan")
      return !0;
  return !1;
}
function HD(e, t, r, n) {
  for (var i = [], s, l = 0, d = 0; d < e.length; d++) {
    var h = e[d];
    if (h.tagName === void 0)
      RL(h, t, r, n);
    else if (h.tagName === "tspan" || h.tagName === "text") {
      var p = HT(h, n.rootAppended), m = W({}, r, p);
      if (h.tagName === "tspan" && zse(h)) {
        HD(h.childNodes, t, m, n);
        continue;
      }
      m.textAlign = "start", (!s || p.x !== void 0) && (s = {
        elements: [],
        options: [],
        widths: [],
        offsets: []
      }, i.push(s)), p.y !== void 0 && (l = 0), p.dy !== void 0 && (l += parseFloat(p.dy)), s.elements.push(h), s.options.push(m), s.offsets.push(l), Vj(t, m), s.widths.push(t.measureText(m.text).width);
    }
  }
  i.forEach(function(x) {
    var S = x.widths.reduce(function(O, D) {
      return O + D;
    }, 0), T = 0, k = 0;
    r.textAlign === "center" && (T = S / 2), r.textAlign === "end" && (T = S), x.options.forEach(function(O, D) {
      var L = x.widths[D];
      O.x = O.x - T + k, O.y += x.offsets[D], k += L;
    }), x.elements.forEach(function(O, D) {
      HD(O.childNodes, t, x.options[D], n);
    });
  });
}
function RL(e, t, r, n) {
  var i = e.tagName, s = i === "text" || i === "tspan" || i === void 0, l = i === "image", d = e.nodeType === 8, h = W({}, r, HT(e, n.rootAppended));
  if (!(h.visibility === "hidden" || h[ZM] || d)) {
    t.save(), !l && DL(t, h), ML(t, h, n), Bse(h);
    var p;
    switch (t.beginPath(), e.tagName) {
      case void 0:
        Vse(t, h, n);
        break;
      case "text":
      case "tspan":
        HD(e.childNodes, t, h, n);
        break;
      case "image":
        p = Pse(t, h, n);
        break;
      case "path":
        Ise(t, h.d);
        break;
      case "rect":
        Lse(t, h), t.closePath();
        break;
      case "circle":
        t.arc(h.cx, h.cy, h.r, 0, 2 * OL, 1);
    }
    return s || (Fj(t, h, n), l || (p = zj(t, h, n)), LL(t, h)), g4(t, h, n, e, "linear"), g4(t, h, n, e, "radial"), t.restore(), p;
  }
}
function g4(e, t, r, n, i) {
  var {
    linearGradients: s,
    radialGradients: l
  } = r, d = i === "linear" ? s : l;
  if (Object.keys(d).length !== 0) {
    var h = GT(t.fill);
    if (h && d[h]) {
      var p = n.getBBox(), m = p.x + p.width / 2, x = p.y + p.height / 2, S = Math.max(p.height / 2, p.width / 2), T = i === "linear" ? e.createLinearGradient(p.x, 0, p.x + p.width, 0) : e.createRadialGradient(m, x, 0, m, x, S);
      if (d[h].colors.forEach((L) => {
        var F = parseInt(L.offset.replace(/%/, ""));
        T.addColorStop(F / 100, L.stopColor);
      }), i === "linear") {
        var k, O, D = (k = ((O = d[h].transform) === null || O === void 0 ? void 0 : O.replace(/\D/g, "")) * Math.PI / 180) !== null && k !== void 0 ? k : 0;
        e.translate(m, x), e.rotate(D), e.translate(-m, -x);
      }
      e.globalAlpha = t.opacity, e.fillStyle = T, e.fill();
    }
  }
}
function Fj(e, t, r) {
  var n, i = GT(t.filter);
  i && (n = r.filters[i], n || (n = {
    offsetX: 0,
    offsetY: 0,
    blur: 0,
    color: "#000"
  }), e.shadowOffsetX = n.offsetX, e.shadowOffsetY = n.offsetY, e.shadowColor = n.color, e.shadowBlur = n.blur);
}
function DL(e, t) {
  e.translate(t.translateX || 0, t.translateY || 0), t.translateX = void 0, t.translateY = void 0, t.rotationAngle && (e.translate(t.rotationX || 0, t.rotationY || 0), e.rotate(t.rotationAngle * OL / 180), e.translate(-(t.rotationX || 0), -(t.rotationY || 0)), t.rotationAngle = void 0, t.rotationX = void 0, t.rotationY = void 0), isFinite(t.scaleX) && (e.scale(t.scaleX, t.scaleY), t.scaleX = void 0, t.scaleY = void 0);
}
function ML(e, t, r) {
  t["clip-path"] && (RL(r.clipPaths[GT(t["clip-path"])], e, {}, r), e.clip(), t["clip-path"] = void 0);
}
function Hse(e, t) {
  var r = new Jn(e);
  return "rgba(" + r.r + "," + r.g + "," + r.b + "," + t + ")";
}
function m4(e) {
  var t, r = {
    colors: [],
    transform: (t = e.attributes.gradientTransform) === null || t === void 0 ? void 0 : t.textContent
  };
  return be(e.childNodes, (n, i) => {
    var {
      attributes: s
    } = i;
    r.colors.push({
      offset: s.offset.value,
      stopColor: s["stop-color"].value
    });
  }), r;
}
function Gse(e) {
  var t, r, n = {};
  return be(e.childNodes, function(i, s) {
    var l = s.attributes;
    if (l.result)
      switch (l.result.value) {
        case "gaussianBlurResult":
          n.blur = Ut(l.stdDeviation.value);
          break;
        case "offsetResult":
          n.offsetX = Ut(l.dx.value), n.offsetY = Ut(l.dy.value);
          break;
        case "floodResult":
          t = l["flood-color"] ? l["flood-color"].value : "#000", r = l["flood-opacity"] ? l["flood-opacity"].value : 1, n.color = Hse(t, r);
      }
  }), n;
}
function Bj(e, t) {
  for (var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new Yt(), n = 0; n < e.length; n++) {
    var i = t(e[n]);
    if (ky(i)) {
      i.then(() => {
        Bj(Array.prototype.slice.call(e, n + 1), t, r);
      });
      break;
    }
  }
  return n === e.length && r.resolve(), r;
}
function tT(e, t, r, n) {
  return Bj(e, function(i) {
    switch (i.tagName && i.tagName.toLowerCase()) {
      case "g":
      case "svg":
        var s = W({}, r, HT(i, n.rootAppended));
        t.save(), DL(t, s), ML(t, s, n);
        var l = () => {
          t.restore();
        }, d = tT(i.childNodes, t, s, n);
        return ky(d) ? d.then(l) : l(), d;
      case "defs":
        return tT(i.childNodes, t, {}, n);
      case "clippath":
        n.clipPaths[i.attributes.id.textContent] = i.childNodes[0];
        break;
      case "pattern":
        n.patterns[i.attributes.id.textContent] = i;
        break;
      case "filter":
        n.filters[i.id] = Gse(i);
        break;
      case "lineargradient":
        n.linearGradients[i.attributes.id.textContent] = m4(i);
        break;
      case "radialgradient":
        n.radialGradients[i.attributes.id.textContent] = m4(i);
        break;
      default:
        return RL(i, t, r, n);
    }
  });
}
function Use(e, t) {
  var r = t["stroke-dasharray"] && t["stroke-dasharray"].match(/(\d+)/g);
  r && r.length && (r = Bl(r, function(n) {
    return Ut(n);
  }), e.setLineDash(r));
}
function LL(e, t, r) {
  var n = t.stroke;
  n && n !== "none" && t["stroke-width"] !== 0 && (Use(e, t), e.lineJoin = t["stroke-linejoin"], e.lineWidth = t["stroke-width"], e.globalAlpha = t.strokeOpacity, e.strokeStyle = n, r ? e.strokeText(t.text, t.x, t.y) : e.stroke(), e.globalAlpha = 1);
}
function jse(e, t, r, n) {
  var i = HT(t, r.rootAppended), s = Bh._createCanvas(i.width, i.height, 0), l = s.getContext("2d"), d = tT(t.childNodes, l, i, r), h = () => {
    e.fillStyle = e.createPattern(s, "repeat"), e.globalAlpha = n.fillOpacity, e.fill(), e.globalAlpha = 1;
  };
  return ky(d) ? d.then(h) : h(), d;
}
function zj(e, t, r) {
  var n = t.fill, i;
  if (n && n !== "none")
    if (n.search(/url/) === -1)
      e.fillStyle = n, e.globalAlpha = t.fillOpacity, e.fill(), e.globalAlpha = 1;
    else {
      var s = r.patterns[GT(n)];
      if (!s)
        return;
      i = jse(e, s, r, t);
    }
  return i;
}
kL = function(e) {
  var t = {}, r;
  return be(e, function(n, i) {
    r = i.textContent, isFinite(r) && (r = Ut(r)), t[i.name.toLowerCase()] = r;
  }), t;
};
function $se(e, t, r, n, i) {
  e.fillStyle = n || "#ffffff", e.fillRect(-i, -i, t + 2 * i, r + 2 * i);
}
function Yse() {
  var e = we.createElement("div");
  return e.style.left = "-9999px", e.style.position = "absolute", e;
}
function Wse(e, t, r) {
  return tT(e.childNodes, t.getContext("2d"), {}, {
    clipPaths: {},
    patterns: {},
    filters: {},
    linearGradients: {},
    radialGradients: {},
    rootAppended: r
  });
}
function Xse(e, t) {
  var {
    width: r,
    height: n,
    backgroundColor: i,
    margin: s,
    svgToCanvas: l = Wse
  } = t, d = Hj(r, n), h = Bh._createCanvas(d.width, d.height, s), p = h.getContext("2d");
  p.setTransform(d.pixelRatio, 0, 0, d.pixelRatio, 0, 0);
  var m = S3(e), x, S = we.isElementNode(e);
  return p.translate(s, s), we.getBody().appendChild(h), S || (x = Yse(), x.appendChild(m), we.getBody().appendChild(x)), m.attributes.direction && (h.dir = m.attributes.direction.textContent), $se(p, r, n, i, s), Pd(l(m, h, S && vy(we.getBody(), e))).then(() => h).always(() => {
    x && we.getBody().removeChild(x), we.getBody().removeChild(h);
  });
}
var Bh = {
  getImageData: function(e, t) {
    var r = "image/" + t.format;
    return ct(t.__parseAttributesFn) && (kL = t.__parseAttributesFn), Xse(e, t).then((n) => Mse(n, r));
  },
  getData: function(e, t) {
    var r = this;
    return Bh.getImageData(e, t).then((n) => {
      var i = "image/" + t.format, s = ct(Oh.Blob) && !t.useBase64 ? r._getBlob(n, i) : r._getBase64(n);
      return s;
    });
  },
  _getBlob: function(e, t) {
    var r, n = new Uint8Array(e.length);
    for (r = 0; r < e.length; r++)
      n[r] = e.charCodeAt(r);
    return new Oh.Blob([n.buffer], {
      type: t
    });
  },
  _getBase64: function(e) {
    return Oh.btoa(e);
  },
  _createCanvas(e, t, r) {
    var n = je("<canvas>")[0];
    return n.width = e + 2 * r, n.height = t + 2 * r, n.hidden = !0, n;
  }
};
function qse(e, t) {
  return Bh.getData(e, t);
}
function Kse(e) {
  var t = Bh._createCanvas(100, 100, 0);
  return e.reduce(function(r, n) {
    var i = ("image/" + n).toLowerCase();
    return t.toDataURL(i).indexOf(i) !== -1 ? r.supported.push(n) : r.unsupported.push(n), r;
  }, {
    supported: [],
    unsupported: []
  });
}
function Hj(e, t) {
  var r = Oh.devicePixelRatio || 1;
  return {
    pixelRatio: r,
    width: e * r,
    height: t * r
  };
}
var wC = jr(), Gj = {
  _markup: "",
  _imageArray: {},
  _imageDeferreds: [],
  _getBinaryFile: function(e, t) {
    Mj.sendRequest({
      url: e,
      method: "GET",
      responseType: "arraybuffer"
    }).done(t).fail(function() {
      t(!1);
    });
  },
  _loadImages: function() {
    var e = this;
    be(e._imageArray, function(t) {
      var r = new Yt();
      e._imageDeferreds.push(r), e._getBinaryFile(t, function(n) {
        if (!n) {
          delete e._imageArray[t], r.resolve();
          return;
        }
        var i, s = "", l = new Uint8Array(n), d = l.byteLength;
        for (i = 0; i < d; i++)
          s += String.fromCharCode(l[i]);
        e._imageArray[t] = "data:image/png;base64," + wC.btoa(s), r.resolve();
      });
    });
  },
  _parseImages: function(e) {
    var t, r = this;
    e.tagName === "image" && (t = je(e).attr("href") || je(e).attr("xlink:href"), r._imageArray[t] || (r._imageArray[t] = "")), be(e.childNodes, function(n, i) {
      r._parseImages(i);
    });
  },
  _prepareImages: function(e) {
    return this._parseImages(e), this._loadImages(), Ps.apply(je, this._imageDeferreds);
  },
  getData: function(e, t) {
    var r, n = this, i = S3(e), s = je(i);
    return s.find("[".concat(ZM, "]")).remove(), r = '<?xml version="1.0" encoding="UTF-8" standalone="yes" ?>' + b3(s.get(0), t.backgroundColor), n._prepareImages(i).then(() => (be(n._imageArray, function(l, d) {
      var h = `href=['|"]`.concat(l, `['|"]`);
      r = r.replace(new RegExp(h, "gi"), 'href="'.concat(d, '"'));
    }), ct(wC.Blob) ? n._getBlob(r) : n._getBase64(r)));
  },
  _getBlob: function(e) {
    return new wC.Blob([e], {
      type: "image/svg+xml"
    });
  },
  _getBase64: function(e) {
    return wC.btoa(e);
  }
};
function Zse(e, t) {
  return Gj.getData(e, t);
}
var PL = jr(), Qse = `%PDF-1.3\r
2 0 obj\r
<</ProcSet[/PDF/ImageB/ImageC/ImageI]/XObject<</I0 5 0 R>>>>\r
endobj\r
4 0 obj\r
<</Type/Pages/Kids[1 0 R]/Count 1>>\r
endobj\r
7 0 obj\r
<</OpenAction[1 0 R /FitH null]/Type/Catalog/Pages 4 0 R/PageLayout/OneColumn>>\r
endobj\r
1 0 obj\r
<</Type/Page/Resources 2 0 R/MediaBox[0 0 _width_ _height_]/Contents 3 0 R/Parent 4 0 R>>\r
endobj\r
`, Jse = `3 0 obj\r
<</Length 52>>stream\r
0.20 w
0 G
q _width_ 0 0 _height_ 0.00 0.00 cm /I0 Do Q\r
endstream\r
endobj\r
`, ele = `6 0 obj\r
<</CreationDate _date_/Producer(DevExtreme _version_)>>\r
endobj\r
`, tle = `5 0 obj\r
<</Type/XObject/Subtype/Image/Width _width_/Height _height_/ColorSpace/DeviceRGB/BitsPerComponent 8/Filter/DCTDecode/Length _length_>>stream\r
`, rle = `\r
endstream\r
endobj\r
`, nle = `trailer\r
<<\r
/Size 8\r
/Root 7 0 R\r
/Info 6 0 R\r
>>\r
startxref\r
_length_\r
%%EOF`, ile = `xref\r
0 8\r
0000000000 65535 f\r
0000000241 00000 n\r
0000000010 00000 n\r
_main_ 00000 n\r
0000000089 00000 n\r
_image_ 00000 n\r
_info_ 00000 n\r
0000000143 00000 n\r
`, Gk = function e(t, r) {
  return t.length < r ? e("0" + t, r) : t;
}, ale = function(e, t, r) {
  var n = 2 * (t.margin || 0), {
    width: i,
    height: s
  } = Hj(t.width, t.height);
  i += n, s += n;
  var l = (0.75 * i).toFixed(2), d = (0.75 * s).toFixed(2), h = Math.floor(i), p = Math.floor(s), m = Qse.replace("_width_", l).replace("_height_", d), x = Jse.replace("_width_", l).replace("_height_", d), S = ele.replace("_date_", r).replace("_version_", fT), T = tle.replace("_width_", h).replace("_height_", p).replace("_length_", e.length) + e + rle, k = ole(m.length, x.length, S.length), O = m + x + S + T, D = nle.replace("_length_", O.length);
  return O + k + D;
};
function ole(e, t, r) {
  return ile.replace("_main_", Gk(e + "", 10)).replace("_info_", Gk(e + t + "", 10)).replace("_image_", Gk(e + t + r + "", 10));
}
var sle = function() {
  return /* @__PURE__ */ new Date();
}, lle = function(e) {
  for (var t = 0, r = new Uint8Array(e.length); t < e.length; t++)
    r[t] = e.charCodeAt(t);
  return new PL.Blob([r.buffer], {
    type: "application/pdf"
  });
}, ule = function(e) {
  return PL.btoa(e);
};
function L_(e) {
  var t = e.toString();
  return t.length === 1 ? "0".concat(e) : e;
}
function cle(e) {
  var t = [e.getUTCFullYear(), L_(e.getUTCMonth()), L_(e.getUTCDate()), L_(e.getUTCHours()), L_(e.getUTCMinutes()), L_(e.getUTCSeconds())];
  return "(D:".concat(t.join(""), "Z00'00')");
}
function dle(e, t) {
  return Bh.getImageData(e, W({}, t, {
    format: "JPEG"
  })).then((r) => {
    var n = ale(r, t, cle(sle())), i = ct(PL.Blob) ? lle(n) : ule(n);
    return i;
  });
}
function _4(e, t, r) {
  if (!e)
    return new Yt().resolve();
  var n = t.exportingAction, i = t.exportedAction, s = t.fileSavingAction, l = {
    fileName: t.fileName,
    format: t.format,
    cancel: !1
  };
  return FR(t.selectedRowsOnly) && (l.selectedRowsOnly = t.selectedRowsOnly), ct(n) && n(l), l.cancel ? new Yt().resolve() : r(e, t).then((d) => {
    if (ct(i) && i(), ct(s) && (l.data = d, s(l)), !l.cancel) {
      var h = t.format === "xlsx" ? "EXCEL" : t.format;
      Cse.saveAs(l.fileName, h, d);
    }
  });
}
var Uj = {
  creator: Bh,
  getData: qse,
  testFormats: Kse
}, fle = {
  getData: dle
}, hle = {
  creator: Gj,
  getData: Zse
}, vle = {
  en: {
    Yes: "Yes",
    No: "No",
    Cancel: "Cancel",
    Close: "Close",
    Clear: "Clear",
    Done: "Done",
    Loading: "Loading...",
    Select: "Select...",
    Search: "Search",
    Back: "Back",
    OK: "OK",
    "dxCollectionWidget-noDataText": "No data to display",
    "dxDropDownEditor-selectLabel": "Select",
    "validation-required": "Required",
    "validation-required-formatted": "{0} is required",
    "validation-numeric": "Value must be a number",
    "validation-numeric-formatted": "{0} must be a number",
    "validation-range": "Value is out of range",
    "validation-range-formatted": "{0} is out of range",
    "validation-stringLength": "The length of the value is not correct",
    "validation-stringLength-formatted": "The length of {0} is not correct",
    "validation-custom": "Value is invalid",
    "validation-custom-formatted": "{0} is invalid",
    "validation-async": "Value is invalid",
    "validation-async-formatted": "{0} is invalid",
    "validation-compare": "Values do not match",
    "validation-compare-formatted": "{0} does not match",
    "validation-pattern": "Value does not match pattern",
    "validation-pattern-formatted": "{0} does not match pattern",
    "validation-email": "Email is invalid",
    "validation-email-formatted": "{0} is invalid",
    "validation-mask": "Value is invalid",
    "dxLookup-searchPlaceholder": "Minimum character number: {0}",
    "dxList-pullingDownText": "Pull down to refresh...",
    "dxList-pulledDownText": "Release to refresh...",
    "dxList-refreshingText": "Refreshing...",
    "dxList-pageLoadingText": "Loading...",
    "dxList-nextButtonText": "More",
    "dxList-selectAll": "Select All",
    "dxListEditDecorator-delete": "Delete",
    "dxListEditDecorator-more": "More",
    "dxScrollView-pullingDownText": "Pull down to refresh...",
    "dxScrollView-pulledDownText": "Release to refresh...",
    "dxScrollView-refreshingText": "Refreshing...",
    "dxScrollView-reachBottomText": "Loading...",
    "dxDateBox-simulatedDataPickerTitleTime": "Select time",
    "dxDateBox-simulatedDataPickerTitleDate": "Select date",
    "dxDateBox-simulatedDataPickerTitleDateTime": "Select date and time",
    "dxDateBox-validation-datetime": "Value must be a date or time",
    "dxDateRangeBox-invalidStartDateMessage": "Start value must be a date",
    "dxDateRangeBox-invalidEndDateMessage": "End value must be a date",
    "dxDateRangeBox-startDateOutOfRangeMessage": "Start date is out of range",
    "dxDateRangeBox-endDateOutOfRangeMessage": "End date is out of range",
    "dxDateRangeBox-startDateLabel": "Start Date",
    "dxDateRangeBox-endDateLabel": "End Date",
    "dxFileUploader-selectFile": "Select a file",
    "dxFileUploader-dropFile": "or Drop a file here",
    "dxFileUploader-bytes": "bytes",
    "dxFileUploader-kb": "KB",
    "dxFileUploader-Mb": "MB",
    "dxFileUploader-Gb": "GB",
    "dxFileUploader-upload": "Upload",
    "dxFileUploader-uploaded": "Uploaded",
    "dxFileUploader-readyToUpload": "Ready to upload",
    "dxFileUploader-uploadAbortedMessage": "Upload cancelled",
    "dxFileUploader-uploadFailedMessage": "Upload failed",
    "dxFileUploader-invalidFileExtension": "File type is not allowed",
    "dxFileUploader-invalidMaxFileSize": "File is too large",
    "dxFileUploader-invalidMinFileSize": "File is too small",
    "dxRangeSlider-ariaFrom": "From",
    "dxRangeSlider-ariaTill": "Till",
    "dxSwitch-switchedOnText": "ON",
    "dxSwitch-switchedOffText": "OFF",
    "dxForm-optionalMark": "optional",
    "dxForm-requiredMessage": "{0} is required",
    "dxNumberBox-invalidValueMessage": "Value must be a number",
    "dxNumberBox-noDataText": "No data",
    "dxDataGrid-emptyHeaderWithColumnChooserText": "Use {0} to display columns",
    "dxDataGrid-emptyHeaderWithGroupPanelText": "Drag a column from the group panel here",
    "dxDataGrid-emptyHeaderWithColumnChooserAndGroupPanelText": "Use {0} or drag a column from the group panel",
    "dxDataGrid-emptyHeaderColumnChooserText": "column chooser",
    "dxDataGrid-columnChooserTitle": "Column Chooser",
    "dxDataGrid-columnChooserEmptyText": "Drag a column here to hide it",
    "dxDataGrid-groupContinuesMessage": "Continues on the next page",
    "dxDataGrid-groupContinuedMessage": "Continued from the previous page",
    "dxDataGrid-groupHeaderText": "Group by This Column",
    "dxDataGrid-ungroupHeaderText": "Ungroup",
    "dxDataGrid-ungroupAllText": "Ungroup All",
    "dxDataGrid-editingEditRow": "Edit",
    "dxDataGrid-editingSaveRowChanges": "Save",
    "dxDataGrid-editingCancelRowChanges": "Cancel",
    "dxDataGrid-editingDeleteRow": "Delete",
    "dxDataGrid-editingUndeleteRow": "Undelete",
    "dxDataGrid-editingConfirmDeleteMessage": "Are you sure you want to delete this record?",
    "dxDataGrid-validationCancelChanges": "Cancel changes",
    "dxDataGrid-groupPanelEmptyText": "Drag a column header here to group by that column",
    "dxDataGrid-noDataText": "No data",
    "dxDataGrid-searchPanelPlaceholder": "Search...",
    "dxDataGrid-filterRowShowAllText": "(All)",
    "dxDataGrid-filterRowResetOperationText": "Reset",
    "dxDataGrid-filterRowOperationEquals": "Equals",
    "dxDataGrid-filterRowOperationNotEquals": "Does not equal",
    "dxDataGrid-filterRowOperationLess": "Less than",
    "dxDataGrid-filterRowOperationLessOrEquals": "Less than or equal to",
    "dxDataGrid-filterRowOperationGreater": "Greater than",
    "dxDataGrid-filterRowOperationGreaterOrEquals": "Greater than or equal to",
    "dxDataGrid-filterRowOperationStartsWith": "Starts with",
    "dxDataGrid-filterRowOperationContains": "Contains",
    "dxDataGrid-filterRowOperationNotContains": "Does not contain",
    "dxDataGrid-filterRowOperationEndsWith": "Ends with",
    "dxDataGrid-filterRowOperationBetween": "Between",
    "dxDataGrid-filterRowOperationBetweenStartText": "Start",
    "dxDataGrid-filterRowOperationBetweenEndText": "End",
    "dxDataGrid-ariaSearchBox": "Search box",
    "dxDataGrid-applyFilterText": "Apply filter",
    "dxDataGrid-trueText": "true",
    "dxDataGrid-falseText": "false",
    "dxDataGrid-sortingAscendingText": "Sort Ascending",
    "dxDataGrid-sortingDescendingText": "Sort Descending",
    "dxDataGrid-sortingClearText": "Clear Sorting",
    "dxDataGrid-ariaNotSortedColumn": "Not sorted column",
    "dxDataGrid-ariaSortedAscendingColumn": "Column sorted in ascending order",
    "dxDataGrid-ariaSortedDescendingColumn": "Column sorted in descending order",
    "dxDataGrid-ariaSortIndex": "Sort index {0}",
    "dxDataGrid-editingSaveAllChanges": "Save changes",
    "dxDataGrid-editingCancelAllChanges": "Discard changes",
    "dxDataGrid-editingAddRow": "Add a row",
    "dxDataGrid-summaryMin": "Min: {0}",
    "dxDataGrid-summaryMinOtherColumn": "Min of {1} is {0}",
    "dxDataGrid-summaryMax": "Max: {0}",
    "dxDataGrid-summaryMaxOtherColumn": "Max of {1} is {0}",
    "dxDataGrid-summaryAvg": "Avg: {0}",
    "dxDataGrid-summaryAvgOtherColumn": "Avg of {1} is {0}",
    "dxDataGrid-summarySum": "Sum: {0}",
    "dxDataGrid-summarySumOtherColumn": "Sum of {1} is {0}",
    "dxDataGrid-summaryCount": "Count: {0}",
    "dxDataGrid-columnFixingFix": "Fix",
    "dxDataGrid-columnFixingUnfix": "Unfix",
    "dxDataGrid-columnFixingLeftPosition": "To the left",
    "dxDataGrid-columnFixingRightPosition": "To the right",
    "dxDataGrid-exportTo": "Export",
    "dxDataGrid-exportToExcel": "Export to Excel file",
    "dxDataGrid-exporting": "Exporting...",
    "dxDataGrid-excelFormat": "Excel file",
    "dxDataGrid-selectedRows": "Selected rows",
    "dxDataGrid-exportSelectedRows": "Export selected rows to {0}",
    "dxDataGrid-exportAll": "Export all data to {0}",
    "dxDataGrid-headerFilterLabel": "Filter options",
    "dxDataGrid-headerFilterIndicatorLabel": "Show filter options for column '{0}'",
    "dxDataGrid-headerFilterEmptyValue": "(Blanks)",
    "dxDataGrid-headerFilterOK": "OK",
    "dxDataGrid-headerFilterCancel": "Cancel",
    "dxDataGrid-ariaAdaptiveCollapse": "Hide additional data",
    "dxDataGrid-ariaAdaptiveExpand": "Display additional data",
    "dxDataGrid-ariaColumn": "Column",
    "dxDataGrid-ariaColumnHeader": "Column header",
    "dxDataGrid-ariaValue": "Value",
    "dxDataGrid-ariaError": "Error",
    "dxDataGrid-ariaRevertButton": "Press Escape to discard the changes",
    "dxDataGrid-ariaFilterCell": "Filter cell",
    "dxDataGrid-ariaCollapse": "Collapse",
    "dxDataGrid-ariaModifiedCell": "Modified",
    "dxDataGrid-ariaDeletedCell": "Deleted",
    "dxDataGrid-ariaEditableCell": "Editable",
    "dxDataGrid-ariaExpand": "Expand",
    "dxDataGrid-ariaCollapsedRow": "Collapsed row",
    "dxDataGrid-ariaExpandedRow": "Expanded row",
    "dxDataGrid-ariaDataGrid": "Data grid with {0} rows and {1} columns",
    "dxDataGrid-ariaSearchInGrid": "Search in the data grid",
    "dxDataGrid-ariaSelectAll": "Select all",
    "dxDataGrid-ariaSelectRow": "Select row",
    "dxDataGrid-ariaToolbar": "Data grid toolbar",
    "dxDataGrid-ariaEditForm": "Edit form",
    "dxDataGrid-filterBuilderPopupTitle": "Filter Builder",
    "dxDataGrid-filterPanelCreateFilter": "Create Filter",
    "dxDataGrid-filterPanelClearFilter": "Clear",
    "dxDataGrid-filterPanelFilterEnabledHint": "Enable the filter",
    "dxTreeList-ariaTreeList": "Tree list with {0} rows and {1} columns",
    "dxTreeList-ariaSearchInGrid": "Search in the tree list",
    "dxTreeList-ariaToolbar": "Tree list toolbar",
    "dxTreeList-editingAddRowToNode": "Add",
    "dxPager-infoText": "Page {0} of {1} ({2} items)",
    "dxPager-pagesCountText": "of",
    "dxPager-pageSize": "Items per page: {0}",
    "dxPager-pageSizesAllText": "All",
    "dxPager-page": "Page {0}",
    "dxPager-prevPage": "Previous Page",
    "dxPager-nextPage": "Next Page",
    "dxPager-ariaLabel": "Page Navigation",
    "dxPager-ariaPageSize": "Page size",
    "dxPager-ariaPageNumber": "Page number",
    "dxPivotGrid-grandTotal": "Grand Total",
    "dxPivotGrid-total": "{0} Total",
    "dxPivotGrid-fieldChooserTitle": "Field Chooser",
    "dxPivotGrid-showFieldChooser": "Show Field Chooser",
    "dxPivotGrid-expandAll": "Expand All",
    "dxPivotGrid-collapseAll": "Collapse All",
    "dxPivotGrid-sortColumnBySummary": 'Sort "{0}" by This Column',
    "dxPivotGrid-sortRowBySummary": 'Sort "{0}" by This Row',
    "dxPivotGrid-removeAllSorting": "Remove All Sorting",
    "dxPivotGrid-dataNotAvailable": "N/A",
    "dxPivotGrid-rowFields": "Row Fields",
    "dxPivotGrid-columnFields": "Column Fields",
    "dxPivotGrid-dataFields": "Data Fields",
    "dxPivotGrid-filterFields": "Filter Fields",
    "dxPivotGrid-allFields": "All Fields",
    "dxPivotGrid-columnFieldArea": "Drop Column Fields Here",
    "dxPivotGrid-dataFieldArea": "Drop Data Fields Here",
    "dxPivotGrid-rowFieldArea": "Drop Row Fields Here",
    "dxPivotGrid-filterFieldArea": "Drop Filter Fields Here",
    "dxScheduler-editorLabelTitle": "Subject",
    "dxScheduler-editorLabelStartDate": "Start Date",
    "dxScheduler-editorLabelEndDate": "End Date",
    "dxScheduler-editorLabelDescription": "Description",
    "dxScheduler-editorLabelRecurrence": "Repeat",
    "dxScheduler-openAppointment": "Open appointment",
    "dxScheduler-recurrenceNever": "Never",
    "dxScheduler-recurrenceMinutely": "Every minute",
    "dxScheduler-recurrenceHourly": "Hourly",
    "dxScheduler-recurrenceDaily": "Daily",
    "dxScheduler-recurrenceWeekly": "Weekly",
    "dxScheduler-recurrenceMonthly": "Monthly",
    "dxScheduler-recurrenceYearly": "Yearly",
    "dxScheduler-recurrenceRepeatEvery": "Repeat Every",
    "dxScheduler-recurrenceRepeatOn": "Repeat On",
    "dxScheduler-recurrenceEnd": "End repeat",
    "dxScheduler-recurrenceAfter": "After",
    "dxScheduler-recurrenceOn": "On",
    "dxScheduler-recurrenceRepeatMinutely": "minute(s)",
    "dxScheduler-recurrenceRepeatHourly": "hour(s)",
    "dxScheduler-recurrenceRepeatDaily": "day(s)",
    "dxScheduler-recurrenceRepeatWeekly": "week(s)",
    "dxScheduler-recurrenceRepeatMonthly": "month(s)",
    "dxScheduler-recurrenceRepeatYearly": "year(s)",
    "dxScheduler-switcherDay": "Day",
    "dxScheduler-switcherWeek": "Week",
    "dxScheduler-switcherWorkWeek": "Work Week",
    "dxScheduler-switcherMonth": "Month",
    "dxScheduler-switcherAgenda": "Agenda",
    "dxScheduler-switcherTimelineDay": "Timeline Day",
    "dxScheduler-switcherTimelineWeek": "Timeline Week",
    "dxScheduler-switcherTimelineWorkWeek": "Timeline Work Week",
    "dxScheduler-switcherTimelineMonth": "Timeline Month",
    "dxScheduler-recurrenceRepeatOnDate": "on date",
    "dxScheduler-recurrenceRepeatCount": "occurrence(s)",
    "dxScheduler-allDay": "All day",
    "dxScheduler-confirmRecurrenceEditTitle": "Edit Recurring Appointment",
    "dxScheduler-confirmRecurrenceDeleteTitle": "Delete Recurring Appointment",
    "dxScheduler-confirmRecurrenceEditMessage": "Do you want to edit only this appointment or the whole series?",
    "dxScheduler-confirmRecurrenceDeleteMessage": "Do you want to delete only this appointment or the whole series?",
    "dxScheduler-confirmRecurrenceEditSeries": "Edit series",
    "dxScheduler-confirmRecurrenceDeleteSeries": "Delete series",
    "dxScheduler-confirmRecurrenceEditOccurrence": "Edit appointment",
    "dxScheduler-confirmRecurrenceDeleteOccurrence": "Delete appointment",
    "dxScheduler-noTimezoneTitle": "No timezone",
    "dxScheduler-moreAppointments": "{0} more",
    "dxCalendar-todayButtonText": "Today",
    "dxCalendar-ariaWidgetName": "Calendar",
    "dxCalendar-previousMonthButtonLabel": "Previous month",
    "dxCalendar-previousYearButtonLabel": "Previous year",
    "dxCalendar-previousDecadeButtonLabel": "Previous decade",
    "dxCalendar-previousCenturyButtonLabel": "Previous century",
    "dxCalendar-nextMonthButtonLabel": "Next month",
    "dxCalendar-nextYearButtonLabel": "Next year",
    "dxCalendar-nextDecadeButtonLabel": "Next decade",
    "dxCalendar-nextCenturyButtonLabel": "Next century",
    "dxCalendar-captionMonthLabel": "Month selection",
    "dxCalendar-captionYearLabel": "Year selection",
    "dxCalendar-captionDecadeLabel": "Decade selection",
    "dxCalendar-captionCenturyLabel": "Century selection",
    "dxColorView-ariaRed": "Red",
    "dxColorView-ariaGreen": "Green",
    "dxColorView-ariaBlue": "Blue",
    "dxColorView-ariaAlpha": "Transparency",
    "dxColorView-ariaHex": "Color code",
    "dxTagBox-selected": "{0} selected",
    "dxTagBox-allSelected": "All selected ({0})",
    "dxTagBox-moreSelected": "{0} more",
    "vizExport-printingButtonText": "Print",
    "vizExport-titleMenuText": "Exporting/Printing",
    "vizExport-exportButtonText": "{0} file",
    "dxFilterBuilder-and": "And",
    "dxFilterBuilder-or": "Or",
    "dxFilterBuilder-notAnd": "Not And",
    "dxFilterBuilder-notOr": "Not Or",
    "dxFilterBuilder-addCondition": "Add Condition",
    "dxFilterBuilder-addGroup": "Add Group",
    "dxFilterBuilder-enterValueText": "<enter a value>",
    "dxFilterBuilder-filterOperationEquals": "Equals",
    "dxFilterBuilder-filterOperationNotEquals": "Does not equal",
    "dxFilterBuilder-filterOperationLess": "Is less than",
    "dxFilterBuilder-filterOperationLessOrEquals": "Is less than or equal to",
    "dxFilterBuilder-filterOperationGreater": "Is greater than",
    "dxFilterBuilder-filterOperationGreaterOrEquals": "Is greater than or equal to",
    "dxFilterBuilder-filterOperationStartsWith": "Starts with",
    "dxFilterBuilder-filterOperationContains": "Contains",
    "dxFilterBuilder-filterOperationNotContains": "Does not contain",
    "dxFilterBuilder-filterOperationEndsWith": "Ends with",
    "dxFilterBuilder-filterOperationIsBlank": "Is blank",
    "dxFilterBuilder-filterOperationIsNotBlank": "Is not blank",
    "dxFilterBuilder-filterOperationBetween": "Is between",
    "dxFilterBuilder-filterOperationAnyOf": "Is any of",
    "dxFilterBuilder-filterOperationNoneOf": "Is none of",
    "dxHtmlEditor-dialogColorCaption": "Change Font Color",
    "dxHtmlEditor-dialogBackgroundCaption": "Change Background Color",
    "dxHtmlEditor-dialogLinkCaption": "Add Link",
    "dxHtmlEditor-dialogLinkUrlField": "URL",
    "dxHtmlEditor-dialogLinkTextField": "Text",
    "dxHtmlEditor-dialogLinkTargetField": "Open link in new window",
    "dxHtmlEditor-dialogImageCaption": "Add Image",
    "dxHtmlEditor-dialogImageUrlField": "URL",
    "dxHtmlEditor-dialogImageAltField": "Alternate text",
    "dxHtmlEditor-dialogImageWidthField": "Width (px)",
    "dxHtmlEditor-dialogImageHeightField": "Height (px)",
    "dxHtmlEditor-dialogInsertTableRowsField": "Rows",
    "dxHtmlEditor-dialogInsertTableColumnsField": "Columns",
    "dxHtmlEditor-dialogInsertTableCaption": "Insert Table",
    "dxHtmlEditor-dialogUpdateImageCaption": "Update Image",
    "dxHtmlEditor-dialogImageUpdateButton": "Update",
    "dxHtmlEditor-dialogImageAddButton": "Add",
    "dxHtmlEditor-dialogImageSpecifyUrl": "From the Web",
    "dxHtmlEditor-dialogImageSelectFile": "From This Device",
    "dxHtmlEditor-dialogImageKeepAspectRatio": "Keep Aspect Ratio",
    "dxHtmlEditor-dialogImageEncodeToBase64": "Encode to Base64",
    "dxHtmlEditor-heading": "Heading",
    "dxHtmlEditor-normalText": "Normal text",
    "dxHtmlEditor-background": "Background Color",
    "dxHtmlEditor-bold": "Bold",
    "dxHtmlEditor-color": "Font Color",
    "dxHtmlEditor-font": "Font",
    "dxHtmlEditor-italic": "Italic",
    "dxHtmlEditor-link": "Add Link",
    "dxHtmlEditor-image": "Add Image",
    "dxHtmlEditor-size": "Size",
    "dxHtmlEditor-strike": "Strikethrough",
    "dxHtmlEditor-subscript": "Subscript",
    "dxHtmlEditor-superscript": "Superscript",
    "dxHtmlEditor-underline": "Underline",
    "dxHtmlEditor-blockquote": "Blockquote",
    "dxHtmlEditor-header": "Header",
    "dxHtmlEditor-increaseIndent": "Increase Indent",
    "dxHtmlEditor-decreaseIndent": "Decrease Indent",
    "dxHtmlEditor-orderedList": "Ordered List",
    "dxHtmlEditor-bulletList": "Bullet List",
    "dxHtmlEditor-alignLeft": "Align Left",
    "dxHtmlEditor-alignCenter": "Align Center",
    "dxHtmlEditor-alignRight": "Align Right",
    "dxHtmlEditor-alignJustify": "Align Justify",
    "dxHtmlEditor-codeBlock": "Code Block",
    "dxHtmlEditor-variable": "Add Variable",
    "dxHtmlEditor-undo": "Undo",
    "dxHtmlEditor-redo": "Redo",
    "dxHtmlEditor-clear": "Clear Formatting",
    "dxHtmlEditor-insertTable": "Insert Table",
    "dxHtmlEditor-insertHeaderRow": "Insert Header Row",
    "dxHtmlEditor-insertRowAbove": "Insert Row Above",
    "dxHtmlEditor-insertRowBelow": "Insert Row Below",
    "dxHtmlEditor-insertColumnLeft": "Insert Column Left",
    "dxHtmlEditor-insertColumnRight": "Insert Column Right",
    "dxHtmlEditor-deleteColumn": "Delete Column",
    "dxHtmlEditor-deleteRow": "Delete Row",
    "dxHtmlEditor-deleteTable": "Delete Table",
    "dxHtmlEditor-cellProperties": "Cell Properties",
    "dxHtmlEditor-tableProperties": "Table Properties",
    "dxHtmlEditor-insert": "Insert",
    "dxHtmlEditor-delete": "Delete",
    "dxHtmlEditor-border": "Border",
    "dxHtmlEditor-style": "Style",
    "dxHtmlEditor-width": "Width",
    "dxHtmlEditor-height": "Height",
    "dxHtmlEditor-borderColor": "Color",
    "dxHtmlEditor-tableBackground": "Background",
    "dxHtmlEditor-dimensions": "Dimensions",
    "dxHtmlEditor-alignment": "Alignment",
    "dxHtmlEditor-horizontal": "Horizontal",
    "dxHtmlEditor-vertical": "Vertical",
    "dxHtmlEditor-paddingVertical": "Vertical Padding",
    "dxHtmlEditor-paddingHorizontal": "Horizontal Padding",
    "dxHtmlEditor-pixels": "Pixels",
    "dxHtmlEditor-list": "List",
    "dxHtmlEditor-ordered": "Ordered",
    "dxHtmlEditor-bullet": "Bullet",
    "dxHtmlEditor-align": "Align",
    "dxHtmlEditor-center": "Center",
    "dxHtmlEditor-left": "Left",
    "dxHtmlEditor-right": "Right",
    "dxHtmlEditor-indent": "Indent",
    "dxHtmlEditor-justify": "Justify",
    "dxHtmlEditor-borderStyleNone": "none",
    "dxHtmlEditor-borderStyleHidden": "hidden",
    "dxHtmlEditor-borderStyleDotted": "dotted",
    "dxHtmlEditor-borderStyleDashed": "dashed",
    "dxHtmlEditor-borderStyleSolid": "solid",
    "dxHtmlEditor-borderStyleDouble": "double",
    "dxHtmlEditor-borderStyleGroove": "groove",
    "dxHtmlEditor-borderStyleRidge": "ridge",
    "dxHtmlEditor-borderStyleInset": "inset",
    "dxHtmlEditor-borderStyleOutset": "outset",
    "dxFileManager-newDirectoryName": "Untitled directory",
    "dxFileManager-rootDirectoryName": "Files",
    "dxFileManager-errorNoAccess": "Access Denied. Operation could not be completed.",
    "dxFileManager-errorDirectoryExistsFormat": "Directory '{0}' already exists.",
    "dxFileManager-errorFileExistsFormat": "File '{0}' already exists.",
    "dxFileManager-errorFileNotFoundFormat": "File '{0}' not found.",
    "dxFileManager-errorDirectoryNotFoundFormat": "Directory '{0}' not found.",
    "dxFileManager-errorWrongFileExtension": "File extension is not allowed.",
    "dxFileManager-errorMaxFileSizeExceeded": "File size exceeds the maximum allowed size.",
    "dxFileManager-errorInvalidSymbols": "This name contains invalid characters.",
    "dxFileManager-errorDefault": "Unspecified error.",
    "dxFileManager-errorDirectoryOpenFailed": "The directory cannot be opened",
    "dxFileManager-commandCreate": "New directory",
    "dxFileManager-commandRename": "Rename",
    "dxFileManager-commandMove": "Move to",
    "dxFileManager-commandCopy": "Copy to",
    "dxFileManager-commandDelete": "Delete",
    "dxFileManager-commandDownload": "Download",
    "dxFileManager-commandUpload": "Upload files",
    "dxFileManager-commandRefresh": "Refresh",
    "dxFileManager-commandThumbnails": "Thumbnails View",
    "dxFileManager-commandDetails": "Details View",
    "dxFileManager-commandClearSelection": "Clear selection",
    "dxFileManager-commandShowNavPane": "Toggle navigation pane",
    "dxFileManager-dialogDirectoryChooserMoveTitle": "Move to",
    "dxFileManager-dialogDirectoryChooserMoveButtonText": "Move",
    "dxFileManager-dialogDirectoryChooserCopyTitle": "Copy to",
    "dxFileManager-dialogDirectoryChooserCopyButtonText": "Copy",
    "dxFileManager-dialogRenameItemTitle": "Rename",
    "dxFileManager-dialogRenameItemButtonText": "Save",
    "dxFileManager-dialogCreateDirectoryTitle": "New directory",
    "dxFileManager-dialogCreateDirectoryButtonText": "Create",
    "dxFileManager-dialogDeleteItemTitle": "Delete",
    "dxFileManager-dialogDeleteItemButtonText": "Delete",
    "dxFileManager-dialogDeleteItemSingleItemConfirmation": "Are you sure you want to delete {0}?",
    "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "Are you sure you want to delete {0} items?",
    "dxFileManager-dialogButtonCancel": "Cancel",
    "dxFileManager-editingCreateSingleItemProcessingMessage": "Creating a directory inside {0}",
    "dxFileManager-editingCreateSingleItemSuccessMessage": "Created a directory inside {0}",
    "dxFileManager-editingCreateSingleItemErrorMessage": "Directory was not created",
    "dxFileManager-editingCreateCommonErrorMessage": "Directory was not created",
    "dxFileManager-editingRenameSingleItemProcessingMessage": "Renaming an item inside {0}",
    "dxFileManager-editingRenameSingleItemSuccessMessage": "Renamed an item inside {0}",
    "dxFileManager-editingRenameSingleItemErrorMessage": "Item was not renamed",
    "dxFileManager-editingRenameCommonErrorMessage": "Item was not renamed",
    "dxFileManager-editingDeleteSingleItemProcessingMessage": "Deleting an item from {0}",
    "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "Deleting {0} items from {1}",
    "dxFileManager-editingDeleteSingleItemSuccessMessage": "Deleted an item from {0}",
    "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "Deleted {0} items from {1}",
    "dxFileManager-editingDeleteSingleItemErrorMessage": "Item was not deleted",
    "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} items were not deleted",
    "dxFileManager-editingDeleteCommonErrorMessage": "Some items were not deleted",
    "dxFileManager-editingMoveSingleItemProcessingMessage": "Moving an item to {0}",
    "dxFileManager-editingMoveMultipleItemsProcessingMessage": "Moving {0} items to {1}",
    "dxFileManager-editingMoveSingleItemSuccessMessage": "Moved an item to {0}",
    "dxFileManager-editingMoveMultipleItemsSuccessMessage": "Moved {0} items to {1}",
    "dxFileManager-editingMoveSingleItemErrorMessage": "Item was not moved",
    "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} items were not moved",
    "dxFileManager-editingMoveCommonErrorMessage": "Some items were not moved",
    "dxFileManager-editingCopySingleItemProcessingMessage": "Copying an item to {0}",
    "dxFileManager-editingCopyMultipleItemsProcessingMessage": "Copying {0} items to {1}",
    "dxFileManager-editingCopySingleItemSuccessMessage": "Copied an item to {0}",
    "dxFileManager-editingCopyMultipleItemsSuccessMessage": "Copied {0} items to {1}",
    "dxFileManager-editingCopySingleItemErrorMessage": "Item was not copied",
    "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} items were not copied",
    "dxFileManager-editingCopyCommonErrorMessage": "Some items were not copied",
    "dxFileManager-editingUploadSingleItemProcessingMessage": "Uploading an item to {0}",
    "dxFileManager-editingUploadMultipleItemsProcessingMessage": "Uploading {0} items to {1}",
    "dxFileManager-editingUploadSingleItemSuccessMessage": "Uploaded an item to {0}",
    "dxFileManager-editingUploadMultipleItemsSuccessMessage": "Uploaded {0} items to {1}",
    "dxFileManager-editingUploadSingleItemErrorMessage": "Item was not uploaded",
    "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} items were not uploaded",
    "dxFileManager-editingUploadCanceledMessage": "Canceled",
    "dxFileManager-editingDownloadSingleItemErrorMessage": "Item was not downloaded",
    "dxFileManager-editingDownloadMultipleItemsErrorMessage": "{0} items were not downloaded",
    "dxFileManager-listDetailsColumnCaptionName": "Name",
    "dxFileManager-listDetailsColumnCaptionDateModified": "Date Modified",
    "dxFileManager-listDetailsColumnCaptionFileSize": "File Size",
    "dxFileManager-listThumbnailsTooltipTextSize": "Size",
    "dxFileManager-listThumbnailsTooltipTextDateModified": "Date Modified",
    "dxFileManager-notificationProgressPanelTitle": "Progress",
    "dxFileManager-notificationProgressPanelEmptyListText": "No operations",
    "dxFileManager-notificationProgressPanelOperationCanceled": "Canceled",
    "dxDiagram-categoryGeneral": "General",
    "dxDiagram-categoryFlowchart": "Flowchart",
    "dxDiagram-categoryOrgChart": "Org Chart",
    "dxDiagram-categoryContainers": "Containers",
    "dxDiagram-categoryCustom": "Custom",
    "dxDiagram-commandExportToSvg": "Export to SVG",
    "dxDiagram-commandExportToPng": "Export to PNG",
    "dxDiagram-commandExportToJpg": "Export to JPEG",
    "dxDiagram-commandUndo": "Undo",
    "dxDiagram-commandRedo": "Redo",
    "dxDiagram-commandFontName": "Font Name",
    "dxDiagram-commandFontSize": "Font Size",
    "dxDiagram-commandBold": "Bold",
    "dxDiagram-commandItalic": "Italic",
    "dxDiagram-commandUnderline": "Underline",
    "dxDiagram-commandTextColor": "Font Color",
    "dxDiagram-commandLineColor": "Line Color",
    "dxDiagram-commandLineWidth": "Line Width",
    "dxDiagram-commandLineStyle": "Line Style",
    "dxDiagram-commandLineStyleSolid": "Solid",
    "dxDiagram-commandLineStyleDotted": "Dotted",
    "dxDiagram-commandLineStyleDashed": "Dashed",
    "dxDiagram-commandFillColor": "Fill Color",
    "dxDiagram-commandAlignLeft": "Align Left",
    "dxDiagram-commandAlignCenter": "Align Center",
    "dxDiagram-commandAlignRight": "Align Right",
    "dxDiagram-commandConnectorLineType": "Connector Line Type",
    "dxDiagram-commandConnectorLineStraight": "Straight",
    "dxDiagram-commandConnectorLineOrthogonal": "Orthogonal",
    "dxDiagram-commandConnectorLineStart": "Connector Line Start",
    "dxDiagram-commandConnectorLineEnd": "Connector Line End",
    "dxDiagram-commandConnectorLineNone": "None",
    "dxDiagram-commandConnectorLineArrow": "Arrow",
    "dxDiagram-commandFullscreen": "Full Screen",
    "dxDiagram-commandUnits": "Units",
    "dxDiagram-commandPageSize": "Page Size",
    "dxDiagram-commandPageOrientation": "Page Orientation",
    "dxDiagram-commandPageOrientationLandscape": "Landscape",
    "dxDiagram-commandPageOrientationPortrait": "Portrait",
    "dxDiagram-commandPageColor": "Page Color",
    "dxDiagram-commandShowGrid": "Show Grid",
    "dxDiagram-commandSnapToGrid": "Snap to Grid",
    "dxDiagram-commandGridSize": "Grid Size",
    "dxDiagram-commandZoomLevel": "Zoom Level",
    "dxDiagram-commandAutoZoom": "Auto Zoom",
    "dxDiagram-commandFitToContent": "Fit to Content",
    "dxDiagram-commandFitToWidth": "Fit to Width",
    "dxDiagram-commandAutoZoomByContent": "Auto Zoom by Content",
    "dxDiagram-commandAutoZoomByWidth": "Auto Zoom by Width",
    "dxDiagram-commandSimpleView": "Simple View",
    "dxDiagram-commandCut": "Cut",
    "dxDiagram-commandCopy": "Copy",
    "dxDiagram-commandPaste": "Paste",
    "dxDiagram-commandSelectAll": "Select All",
    "dxDiagram-commandDelete": "Delete",
    "dxDiagram-commandBringToFront": "Bring to Front",
    "dxDiagram-commandSendToBack": "Send to Back",
    "dxDiagram-commandLock": "Lock",
    "dxDiagram-commandUnlock": "Unlock",
    "dxDiagram-commandInsertShapeImage": "Insert Image...",
    "dxDiagram-commandEditShapeImage": "Change Image...",
    "dxDiagram-commandDeleteShapeImage": "Delete Image",
    "dxDiagram-commandLayoutLeftToRight": "Left-to-right",
    "dxDiagram-commandLayoutRightToLeft": "Right-to-left",
    "dxDiagram-commandLayoutTopToBottom": "Top-to-bottom",
    "dxDiagram-commandLayoutBottomToTop": "Bottom-to-top",
    "dxDiagram-unitIn": "in",
    "dxDiagram-unitCm": "cm",
    "dxDiagram-unitPx": "px",
    "dxDiagram-dialogButtonOK": "OK",
    "dxDiagram-dialogButtonCancel": "Cancel",
    "dxDiagram-dialogInsertShapeImageTitle": "Insert Image",
    "dxDiagram-dialogEditShapeImageTitle": "Change Image",
    "dxDiagram-dialogEditShapeImageSelectButton": "Select image",
    "dxDiagram-dialogEditShapeImageLabelText": "or drop a file here",
    "dxDiagram-uiExport": "Export",
    "dxDiagram-uiProperties": "Properties",
    "dxDiagram-uiSettings": "Settings",
    "dxDiagram-uiShowToolbox": "Show Toolbox",
    "dxDiagram-uiSearch": "Search",
    "dxDiagram-uiStyle": "Style",
    "dxDiagram-uiLayout": "Layout",
    "dxDiagram-uiLayoutTree": "Tree",
    "dxDiagram-uiLayoutLayered": "Layered",
    "dxDiagram-uiDiagram": "Diagram",
    "dxDiagram-uiText": "Text",
    "dxDiagram-uiObject": "Object",
    "dxDiagram-uiConnector": "Connector",
    "dxDiagram-uiPage": "Page",
    "dxDiagram-shapeText": "Text",
    "dxDiagram-shapeRectangle": "Rectangle",
    "dxDiagram-shapeEllipse": "Ellipse",
    "dxDiagram-shapeCross": "Cross",
    "dxDiagram-shapeTriangle": "Triangle",
    "dxDiagram-shapeDiamond": "Diamond",
    "dxDiagram-shapeHeart": "Heart",
    "dxDiagram-shapePentagon": "Pentagon",
    "dxDiagram-shapeHexagon": "Hexagon",
    "dxDiagram-shapeOctagon": "Octagon",
    "dxDiagram-shapeStar": "Star",
    "dxDiagram-shapeArrowLeft": "Left Arrow",
    "dxDiagram-shapeArrowUp": "Up Arrow",
    "dxDiagram-shapeArrowRight": "Right Arrow",
    "dxDiagram-shapeArrowDown": "Down Arrow",
    "dxDiagram-shapeArrowUpDown": "Up Down Arrow",
    "dxDiagram-shapeArrowLeftRight": "Left Right Arrow",
    "dxDiagram-shapeProcess": "Process",
    "dxDiagram-shapeDecision": "Decision",
    "dxDiagram-shapeTerminator": "Terminator",
    "dxDiagram-shapePredefinedProcess": "Predefined Process",
    "dxDiagram-shapeDocument": "Document",
    "dxDiagram-shapeMultipleDocuments": "Multiple Documents",
    "dxDiagram-shapeManualInput": "Manual Input",
    "dxDiagram-shapePreparation": "Preparation",
    "dxDiagram-shapeData": "Data",
    "dxDiagram-shapeDatabase": "Database",
    "dxDiagram-shapeHardDisk": "Hard Disk",
    "dxDiagram-shapeInternalStorage": "Internal Storage",
    "dxDiagram-shapePaperTape": "Paper Tape",
    "dxDiagram-shapeManualOperation": "Manual Operation",
    "dxDiagram-shapeDelay": "Delay",
    "dxDiagram-shapeStoredData": "Stored Data",
    "dxDiagram-shapeDisplay": "Display",
    "dxDiagram-shapeMerge": "Merge",
    "dxDiagram-shapeConnector": "Connector",
    "dxDiagram-shapeOr": "Or",
    "dxDiagram-shapeSummingJunction": "Summing Junction",
    "dxDiagram-shapeContainerDefaultText": "Container",
    "dxDiagram-shapeVerticalContainer": "Vertical Container",
    "dxDiagram-shapeHorizontalContainer": "Horizontal Container",
    "dxDiagram-shapeCardDefaultText": "Person's Name",
    "dxDiagram-shapeCardWithImageOnLeft": "Card with Image on the Left",
    "dxDiagram-shapeCardWithImageOnTop": "Card with Image on the Top",
    "dxDiagram-shapeCardWithImageOnRight": "Card with Image on the Right",
    "dxGantt-dialogTitle": "Title",
    "dxGantt-dialogStartTitle": "Start",
    "dxGantt-dialogEndTitle": "End",
    "dxGantt-dialogProgressTitle": "Progress",
    "dxGantt-dialogResourcesTitle": "Resources",
    "dxGantt-dialogResourceManagerTitle": "Resource Manager",
    "dxGantt-dialogTaskDetailsTitle": "Task Details",
    "dxGantt-dialogEditResourceListHint": "Edit Resource List",
    "dxGantt-dialogEditNoResources": "No resources",
    "dxGantt-dialogButtonAdd": "Add",
    "dxGantt-contextMenuNewTask": "New Task",
    "dxGantt-contextMenuNewSubtask": "New Subtask",
    "dxGantt-contextMenuDeleteTask": "Delete Task",
    "dxGantt-contextMenuDeleteDependency": "Delete Dependency",
    "dxGantt-dialogTaskDeleteConfirmation": "Deleting a task also deletes all its dependencies and subtasks. Are you sure you want to delete this task?",
    "dxGantt-dialogDependencyDeleteConfirmation": "Are you sure you want to delete the dependency from the task?",
    "dxGantt-dialogResourcesDeleteConfirmation": "Deleting a resource also deletes it from tasks to which this resource is assigned. Are you sure you want to delete these resources? Resources: {0}",
    "dxGantt-dialogConstraintCriticalViolationMessage": "The task you are attempting to move is linked to a second task by a dependency relation. This change would conflict with dependency rules. How would you like to proceed?",
    "dxGantt-dialogConstraintViolationMessage": "The task you are attempting to move is linked to a second task by a dependency relation. How would you like to proceed?",
    "dxGantt-dialogCancelOperationMessage": "Cancel the operation",
    "dxGantt-dialogDeleteDependencyMessage": "Delete the dependency",
    "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "Move the task and keep the dependency",
    "dxGantt-dialogConstraintCriticalViolationSeveralTasksMessage": "The task you are attempting to move is linked to another tasks by dependency relations. This change would conflict with dependency rules. How would you like to proceed?",
    "dxGantt-dialogConstraintViolationSeveralTasksMessage": "The task you are attempting to move is linked to another tasks by dependency relations. How would you like to proceed?",
    "dxGantt-dialogDeleteDependenciesMessage": "Delete the dependency relations",
    "dxGantt-dialogMoveTaskAndKeepDependenciesMessage": "Move the task and keep the dependencies",
    "dxGantt-undo": "Undo",
    "dxGantt-redo": "Redo",
    "dxGantt-expandAll": "Expand All",
    "dxGantt-collapseAll": "Collapse All",
    "dxGantt-addNewTask": "Add New Task",
    "dxGantt-deleteSelectedTask": "Delete Selected Task",
    "dxGantt-zoomIn": "Zoom In",
    "dxGantt-zoomOut": "Zoom Out",
    "dxGantt-fullScreen": "Full Screen",
    "dxGantt-quarter": "Q{0}",
    "dxGantt-sortingAscendingText": "Sort Ascending",
    "dxGantt-sortingDescendingText": "Sort Descending",
    "dxGantt-sortingClearText": "Clear Sorting",
    "dxGantt-showResources": "Show Resources",
    "dxGantt-showDependencies": "Show Dependencies",
    "dxGantt-dialogStartDateValidation": "Start date must be after {0}",
    "dxGantt-dialogEndDateValidation": "End date must be after {0}",
    "dxGallery-itemName": "Gallery item",
    "dxMultiView-elementAriaRoleDescription": "MultiView",
    "dxMultiView-elementAriaLabel": "Use the arrow keys or swipe to navigate between views",
    "dxMultiView-itemAriaRoleDescription": "View",
    "dxMultiView-itemAriaLabel": "{0} of {1}"
  }
}, ple = W(!0, {}, vle), gle = (e, t) => {
  var r;
  return e[t] || (t == null ? void 0 : t.toLowerCase) && ((r = Object.entries(e).find((n) => {
    var [i] = n;
    return i.toLowerCase() === t.toLowerCase();
  })) === null || r === void 0 ? void 0 : r[1]) || {};
}, Uk = {}, Nh = Fs({
  engine: function() {
    return "base";
  },
  _dictionary: ple,
  load: function(e) {
    W(!0, this._dictionary, e);
  },
  _localizablePrefix: "@",
  setup: function(e) {
    this._localizablePrefix = e;
  },
  localizeString: function(e) {
    var t = this, r = new RegExp("(^|[^a-zA-Z_0-9" + t._localizablePrefix + "-]+)(" + t._localizablePrefix + "{1,2})([a-zA-Z_0-9-]+)", "g"), n = t._localizablePrefix + t._localizablePrefix;
    return e.replace(r, (i, s, l, d) => {
      var h = t._localizablePrefix + d, p;
      return l !== n && (p = t.format(d)), p || (Uk[d] = Tq(d)), s + (p || h);
    });
  },
  getMessagesByLocales: function() {
    return this._dictionary;
  },
  getDictionary: function(e) {
    return e ? Uk : W({}, Uk, this.getMessagesByLocales()[Ka.locale()]);
  },
  getFormatter: function(e) {
    return this._getFormatterBase(e) || this._getFormatterBase(e, "en");
  },
  _getFormatterBase: function(e, t) {
    var r = Ka.getValueByClosestLocale((n) => gle(this._dictionary, n)[e]);
    if (r)
      return function() {
        var n = arguments.length === 1 && Array.isArray(arguments[0]) ? arguments[0].slice(0) : Array.prototype.slice.call(arguments, 0);
        return n.unshift(r), xE.apply(this, n);
      };
  },
  format: function(e) {
    var t = this.getFormatter(e), r = Array.prototype.slice.call(arguments, 1);
    return t && t.apply(this, r) || "";
  }
}), jj = "dxHoverStart", IL = "dxhoverstart", mle = En(dn.enter, jj), $j = "dxHoverEnd", NL = "dxhoverend", _le = En(dn.leave, $j), Yj = Qi.inherit({
  noBubble: !0,
  ctor: function() {
    this._handlerArrayKeyPath = this._eventNamespace + "_HandlerStore";
  },
  setup: function(e) {
    di(e, this._handlerArrayKeyPath, {});
  },
  add: function(e, t) {
    var r = this, n = function(i) {
      r._handler(i);
    };
    Ve.on(e, this._originalEventName, t.selector, n), di(e, this._handlerArrayKeyPath)[t.guid] = n;
  },
  _handler: function(e) {
    wT(e) || qa.isSimulator() || Ku({
      type: this._eventName,
      originalEvent: e,
      delegateTarget: e.delegateTarget
    });
  },
  remove: function(e, t) {
    var r = di(e, this._handlerArrayKeyPath)[t.guid];
    Ve.off(e, this._originalEventName, t.selector, r);
  },
  teardown: function(e) {
    wM(e, this._handlerArrayKeyPath);
  }
}), yle = Yj.inherit({
  ctor: function() {
    this._eventNamespace = jj, this._eventName = IL, this._originalEventName = mle, this.callBase();
  },
  _handler: function(e) {
    var t = e.pointers || [];
    t.length || this.callBase(e);
  }
}), xle = Yj.inherit({
  ctor: function() {
    this._eventNamespace = $j, this._eventName = NL, this._originalEventName = _le, this.callBase();
  }
});
Hl(IL, new yle());
Hl(NL, new xle());
var ble = [dn.down, dn.move].join(" "), kl = 35, Sle = [
  [9, 12, 26, 12, 26, 14, 9, 14],
  [9, 17, 26, 17, 26, 19, 9, 19],
  [9, 22, 26, 22, 26, 24, 9, 24]
], Wj = 4, xg = 120, Cle = 8, y4 = 15, dg = 30, Sd = 1, Ele = 10, Xj = 2, qj = 3, Kj = "PNG", Tle = [Kj, "JPEG", "GIF"], wle = ["PDF", "SVG"], uE = "dx-export-menu", Ale = "21cm", Zj = "export-element-type", Qj = "export-element-format";
function Jj() {
  var e = Uj.testFormats(Tle);
  return {
    unsupported: e.unsupported,
    supported: e.supported.concat(wle)
  };
}
function e5(e, t, r) {
  if (r = r || Jj(), e = String(e).toUpperCase(), r.supported.indexOf(e) !== -1)
    return e;
  r.unsupported.indexOf(e) !== -1 && t && t("W2108", [e]);
}
function x4(e) {
  return e === "SVG" ? hle.getData : e === "PDF" ? fle.getData : Uj.getData;
}
function Ole(e, t) {
  var r = jr().document, n = r.createElement("iframe");
  n.onload = Rle(e, t), n.style.position = "fixed", n.style.width = "0", n.style.height = "0", n.style.right = "0", n.style.bottom = "0", r.body.appendChild(n);
}
function kle(e) {
  e.style.width = Ale;
  var t = Mg(e);
  return e.style.width = "", t;
}
function Rle(e, t) {
  return function() {
    var r = this.contentWindow, n = r.document.createElement("img");
    r.document.body.appendChild(n);
    var i = kle(r.document.body) / t.width;
    i < 1 && (r.document.body.style.transform = "scale(".concat(i, ")"), r.document.body.style["transform-origin"] = "0 0");
    var s = () => {
      this.parentElement.removeChild(this);
    };
    n.addEventListener("load", () => {
      r.focus(), r.print();
    }), n.addEventListener("error", s), r.addEventListener("afterprint", () => {
      setTimeout(s, 0);
    }), n.src = e;
  };
}
function Dle(e, t, r) {
  var n = kl - xg, i = kl + Wj + Sd + r * dg, s = {
    rect: {
      width: xg - 2 * Sd,
      height: dg,
      x: n + Sd,
      y: i
    },
    text: {
      x: n + (e.rtl ? xg - y4 : y4),
      y: i + dg - Cle
    }
  };
  return t === "printing" && (s.separator = {
    stroke: e.button.default.borderColor,
    "stroke-width": Sd,
    cursor: "pointer",
    sharp: "v",
    d: "M " + n + " " + (i + dg - Sd) + " L " + (n + xg) + " " + (i + dg - Sd)
  }), s;
}
function b4(e, t, r) {
  var n = {}, i = r.type, s = r.format, l = Dle(t, i, r.itemIndex), d = Oi(t.font);
  d["pointer-events"] = "none";
  var h = e.g().attr({
    class: uE + "-list-item"
  });
  n[Zj] = i, s && (n[Qj] = s);
  var p = e.rect();
  p.attr(l.rect).css({
    cursor: "pointer",
    "pointer-events": "all"
  }).data(n), p.on(IL + ".export", () => p.attr({
    fill: t.button.hover.backgroundColor
  })).on(NL + ".export", () => p.attr({
    fill: null
  })), p.append(h);
  var m = e.text(r.text).css(d).attr(l.text).append(h);
  return i === "printing" && e.path(null, "line").attr(l.separator).append(h), {
    g: h,
    rect: p,
    resetState: () => p.attr({
      fill: null
    }),
    fixPosition: () => {
      var x = m.getBBox();
      m.move(l.text.x - x.x - (t.rtl ? x.width : 0));
    }
  };
}
function Mle(e, t) {
  var r = [];
  return t.printingEnabled && r.push(b4(e, t, {
    type: "printing",
    text: Nh.format("vizExport-printingButtonText"),
    itemIndex: r.length
  })), r = t.formats.reduce((n, i) => (n.push(b4(e, t, {
    type: "exporting",
    text: Nh.getFormatter("vizExport-exportButtonText")(i),
    format: i,
    itemIndex: n.length
  })), n), r), r;
}
var t5 = function(e) {
  var t = this._renderer = e.renderer;
  this._incidentOccurred = e.incidentOccurred, this._exportTo = e.exportTo, this._print = e.print, this._shadow = t.shadowFilter("-50%", "-50%", "200%", "200%", Xj, 6, qj), this._shadow.attr({
    opacity: 0.8
  }), this._group = t.g().attr({
    class: uE,
    [ZM]: !0
  }).linkOn(t.root, {
    name: "export-menu",
    after: "peripheral"
  }), this._buttonGroup = t.g().attr({
    class: uE + "-button"
  }).append(this._group), this._listGroup = t.g().attr({
    class: uE + "-list"
  }).append(this._group), this._overlay = t.rect(-xg + kl, kl + Wj, xg, 0), this._overlay.attr({
    "stroke-width": Sd,
    cursor: "pointer",
    rx: 4,
    ry: 4,
    filter: this._shadow.id
  }), this._overlay.data({
    "export-element-type": "list"
  }), this.validFormats = Jj(), this._subscribeEvents();
};
W(t5.prototype, {
  getLayoutOptions() {
    if (this._hiddenDueToLayout)
      return {
        width: 0,
        height: 0,
        cutSide: "vertical",
        cutLayoutSide: "top"
      };
    var e = this._buttonGroup.getBBox();
    return e.cutSide = "vertical", e.cutLayoutSide = "top", e.height += Ele, e.position = {
      vertical: "top",
      horizontal: "right"
    }, e.verticalAlignment = "top", e.horizontalAlignment = "right", e;
  },
  shift(e, t) {
    this._group.attr({
      translateY: this._group.attr("translateY") + t
    });
  },
  draw(e, t, r) {
    this._group.move(e - kl - Xj - qj + r.left, Math.floor(t / 2 - kl / 2));
    var n = this.getLayoutOptions();
    return (n.width > e || n.height > t) && this.freeSpace(), this;
  },
  show() {
    this._group.linkAppend();
  },
  hide() {
    this._group.linkRemove();
  },
  setOptions(e) {
    this._options = e, e.formats ? e.formats = e.formats.reduce((t, r) => (r = e5(r, this._incidentOccurred, this.validFormats), r && t.push(r), t), []) : e.formats = this.validFormats.supported.slice(), e.printingEnabled = e.printingEnabled === void 0 ? !0 : e.printingEnabled, e.enabled && (e.formats.length || e.printingEnabled) ? (this.show(), this._updateButton(), this._updateList(), this._hideList()) : this.hide();
  },
  dispose() {
    this._unsubscribeEvents(), this._group.linkRemove().linkOff(), this._group.dispose(), this._shadow.dispose();
  },
  layoutOptions() {
    return this._options.enabled && {
      horizontalAlignment: "right",
      verticalAlignment: "top",
      weak: !0
    };
  },
  measure() {
    this._fillSpace();
    var e = this._options.button.margin;
    return [kl + e.left + e.right, kl + e.top + e.bottom];
  },
  move(e) {
    var t = this._options.button.margin;
    this._group.attr({
      translateX: Math.round(e[0]) + t.left,
      translateY: Math.round(e[1]) + t.top
    });
  },
  _fillSpace() {
    this._hiddenDueToLayout = !1, this.show();
  },
  freeSpace() {
    this._incidentOccurred("W2107"), this._hiddenDueToLayout = !0, this.hide();
  },
  _hideList() {
    this._listGroup.remove(), this._listShown = !1, this._setButtonState("default"), this._menuItems.forEach((e) => e.resetState());
  },
  _showList() {
    this._listGroup.append(this._group), this._listShown = !0, this._menuItems.forEach((e) => e.fixPosition());
  },
  _setButtonState(e) {
    var t = this._options.button[e];
    this._button.attr({
      stroke: t.borderColor,
      fill: t.backgroundColor
    }), this._icon.attr({
      fill: t.color
    });
  },
  _subscribeEvents() {
    this._renderer.root.on(dn.up + ".export", (e) => {
      var t = e.target[Zj];
      if (!t) {
        this._button && this._hideList();
        return;
      }
      t === "button" ? this._listShown ? (this._setButtonState("default"), this._hideList()) : (this._setButtonState("focus"), this._showList()) : t === "printing" ? (this._print(), this._hideList()) : t === "exporting" && (this._exportTo(e.target[Qj]), this._hideList());
    }), this._listGroup.on(ble, (e) => e.stopPropagation()), this._buttonGroup.on(dn.enter, () => this._setButtonState("hover")), this._buttonGroup.on(dn.leave, () => this._setButtonState(this._listShown ? "focus" : "default")), this._buttonGroup.on(dn.down + ".export", () => this._setButtonState("active"));
  },
  _unsubscribeEvents() {
    this._renderer.root.off(".export"), this._listGroup.off(), this._buttonGroup.off();
  },
  _updateButton() {
    var e = this._renderer, t = this._options, r = {
      "export-element-type": "button"
    };
    this._button || (this._button = e.rect(0, 0, kl, kl).append(this._buttonGroup), this._button.attr({
      rx: 4,
      ry: 4,
      fill: t.button.default.backgroundColor,
      stroke: t.button.default.borderColor,
      "stroke-width": 1,
      cursor: "pointer"
    }), this._button.data(r), this._icon = e.path(Sle).append(this._buttonGroup), this._icon.attr({
      fill: t.button.default.color,
      cursor: "pointer"
    }), this._icon.data(r), this._buttonGroup.setTitle(Nh.format("vizExport-titleMenuText")));
  },
  _updateList() {
    var e = this._options, t = e.button.default, r = this._listGroup, n = Mle(this._renderer, e);
    this._shadow.attr({
      color: e.shadowColor
    }), this._overlay.attr({
      height: n.length * dg + 2 * Sd,
      fill: t.backgroundColor,
      stroke: t.borderColor
    }), r.clear(), this._overlay.append(r), n.forEach((i) => i.g.append(r)), this._menuItems = n;
  }
});
function S4(e, t, r, n) {
  (n || t.format) && (n = e5(n || t.format, e._incidentOccurred));
  var {
    width: i,
    height: s
  } = e.getSize();
  return {
    format: n || Kj,
    fileName: r || t.fileName || "file",
    backgroundColor: t.backgroundColor,
    width: i,
    height: s,
    margin: t.margin,
    svgToCanvas: t.svgToCanvas,
    exportingAction: e._createActionByOption("onExporting", {
      excludeValidators: ["disabled"]
    }),
    exportedAction: e._createActionByOption("onExported", {
      excludeValidators: ["disabled"]
    }),
    fileSavingAction: e._createActionByOption("onFileSaving", {
      excludeValidators: ["disabled"]
    })
  };
}
var Lle = {
  name: "export",
  init() {
    this._exportMenu = new t5({
      renderer: this._renderer,
      incidentOccurred: this._incidentOccurred,
      print: () => this.print(),
      exportTo: (e) => this.exportTo(void 0, e)
    }), this._layout.add(this._exportMenu);
  },
  dispose() {
    this._exportMenu.dispose();
  },
  members: {
    _getExportMenuOptions() {
      return W({}, this._getOption("export"), {
        rtl: this._getOption("rtlEnabled", !0)
      });
    },
    _disablePointerEvents() {
      var e = this._renderer.root.attr("pointer-events");
      return this._renderer.root.attr({
        "pointer-events": "none"
      }), e;
    },
    exportTo(e, t) {
      var r = this._exportMenu, n = S4(this, this._getOption("export") || {}, e, t);
      r && r.hide();
      var i = this._disablePointerEvents(), s = _4(this._renderer.root.element, n, x4(n.format)).fail(kg.error).always(() => {
        this._renderer.root.attr({
          "pointer-events": i
        });
      });
      return r && r.show(), s;
    },
    print() {
      var e = this._exportMenu, t = S4(this, this._getOption("export") || {});
      t.exportingAction = null, t.exportedAction = null, t.margin = 0, t.format = "PNG", t.useBase64 = !0, t.fileSavingAction = (i) => {
        Ole("data:image/png;base64,".concat(i.data), {
          width: t.width,
          __test: t.__test
        }), i.cancel = !0;
      };
      var r = this._disablePointerEvents();
      e && e.hide();
      var n = _4(this._renderer.root.element, t, x4(t.format)).fail(kg.error).always(() => {
        this._renderer.root.attr({
          "pointer-events": r
        });
      });
      return e && e.show(), n;
    }
  },
  customize(e) {
    var t = e.prototype;
    e.addChange({
      code: "EXPORT",
      handler() {
        this._exportMenu.setOptions(this._getExportMenuOptions()), this._change(["LAYOUT"]);
      },
      isThemeDependent: !0,
      isOptionChange: !0,
      option: "export"
    }), t._optionChangesMap.onExporting = "EXPORT", t._optionChangesMap.onExported = "EXPORT", t._optionChangesMap.onFileSaving = "EXPORT";
  },
  fontFields: ["export.font"]
}, C4 = 0, Ple = 1, Ile = "linear", Nle = 400, E4 = "loadingIndicatorReady", GD = function(e) {
  var t = e.renderer;
  this._group = t.g().attr({
    class: "dx-loading-indicator"
  }).linkOn(t.root, {
    name: "loading-indicator",
    after: "peripheral"
  }), this._rect = t.rect().attr({
    opacity: 0
  }).append(this._group), this._text = t.text().attr({
    align: "center"
  }).append(this._group), this._createStates(e.eventTrigger, this._group, t.root, e.notify);
};
GD.prototype = {
  constructor: GD,
  _createStates: function(e, t, r, n) {
    this._states = [{
      opacity: 0,
      start: function() {
        n(!1);
      },
      complete: function() {
        t.linkRemove(), r.css({
          "pointer-events": ""
        }), e(E4);
      }
    }, {
      opacity: 0.85,
      start: function() {
        t.linkAppend(), r.css({
          "pointer-events": "none"
        }), n(!0);
      },
      complete: function() {
        e(E4);
      }
    }], this._state = C4;
  },
  setSize: function(e) {
    var t = e.width, r = e.height;
    this._rect.attr({
      width: t,
      height: r
    }), this._text.attr({
      x: t / 2,
      y: r / 2
    });
  },
  setOptions: function(e) {
    this._rect.attr({
      fill: e.backgroundColor
    }), this._text.css(Oi(e.font)).attr({
      text: e.text,
      class: e.cssClass
    }), this[e.show ? "show" : "hide"]();
  },
  dispose: function() {
    this._group.linkRemove().linkOff(), this._group = this._rect = this._text = this._states = null;
  },
  _transit: function(e) {
    var t;
    this._state !== e && (this._state = e, this._isHiding = !1, t = this._states[e], this._rect.stopAnimation().animate({
      opacity: t.opacity
    }, {
      complete: t.complete,
      easing: Ile,
      duration: Nle,
      unstoppable: !0
    }), this._noHiding = !0, t.start(), this._noHiding = !1);
  },
  show: function() {
    this._transit(Ple);
  },
  hide: function() {
    this._transit(C4);
  },
  scheduleHiding: function() {
    this._noHiding || (this._isHiding = !0);
  },
  fulfillHiding: function() {
    this._isHiding && this.hide();
  }
};
var Vle = {
  name: "loading_indicator",
  init: function() {
    var e = this;
    e._loadingIndicator = new GD({
      eventTrigger: e._eventTrigger,
      renderer: e._renderer,
      notify: function(t) {
        e._skipLoadingIndicatorOptions = !0, e.option("loadingIndicator", {
          show: t
        }), e._skipLoadingIndicatorOptions = !1, t && e._stopCurrentHandling();
      }
    }), e._scheduleLoadingIndicatorHiding();
  },
  dispose: function() {
    this._loadingIndicator.dispose(), this._loadingIndicator = null;
  },
  members: {
    _scheduleLoadingIndicatorHiding: function() {
      this._loadingIndicator.scheduleHiding();
    },
    _fulfillLoadingIndicatorHiding: function() {
      this._loadingIndicator.fulfillHiding();
    },
    showLoadingIndicator: function() {
      this._loadingIndicator.show();
    },
    hideLoadingIndicator: function() {
      this._loadingIndicator.hide();
    },
    _onBeginUpdate: function() {
      this._optionChangedLocker || this._scheduleLoadingIndicatorHiding();
    }
  },
  extenders: {
    _dataSourceLoadingChangedHandler(e) {
      e && (this._options.silent("loadingIndicator") || {}).enabled && this._loadingIndicator.show();
    },
    _setContentSize() {
      this._loadingIndicator.setSize(this._canvas);
    },
    endUpdate() {
      this._initialized && this._dataIsReady() && this._fulfillLoadingIndicatorHiding();
    }
  },
  customize: function(e) {
    var t = e.prototype;
    if (t._dataSourceChangedHandler) {
      var r = t._dataSourceChangedHandler;
      t._dataSourceChangedHandler = function() {
        this._scheduleLoadingIndicatorHiding(), r.apply(this, arguments);
      };
    }
    e.addChange({
      code: "LOADING_INDICATOR",
      handler: function() {
        this._skipLoadingIndicatorOptions || this._loadingIndicator.setOptions(this._getOption("loadingIndicator")), this._scheduleLoadingIndicatorHiding();
      },
      isThemeDependent: !0,
      option: "loadingIndicator",
      isOptionChange: !0
    }), t._eventsMap.onLoadingIndicatorReady = {
      name: "loadingIndicatorReady"
    };
    var n = t._drawn;
    t._drawn = function() {
      n.apply(this, arguments), this._dataIsReady() && this._fulfillLoadingIndicatorHiding();
    };
  },
  fontFields: ["loadingIndicator.font"]
}, Cve = Ka.locale.bind(Ka), Eve = Nh.load.bind(Nh), Tve = Nh.format.bind(Nh), Fle = Ho.format.bind(Ho), wve = Ho.parse.bind(Ho), Ble = Os.format.bind(Os), Ave = Os.parse.bind(Os);
var zle = "{", Hle = "}", Gle = ":";
function Ule(e, t) {
  if (t) {
    if (e instanceof Date)
      return Ble(e, t);
    if (typeof e == "number")
      return Fle(e, t);
  }
  return e;
}
function jle(e, t) {
  var r = "", n = e.indexOf(Gle);
  return n > 0 && (r = e.substr(n + 1), e = e.substr(0, n)), Ule(t[e], r);
}
function $le(e, t) {
  for (var r = e, n = !0; n; ) {
    var i = r.indexOf(zle), s = r.indexOf(Hle);
    if (i >= 0 && s > 0) {
      var l = r.substring(i + 1, s), d = jle(l, t);
      r = r.substr(0, i) + d + r.substr(s + 1);
    } else
      n = !1;
  }
  return r;
}
var Vu = Nl.format, VL = Math, Yu = VL.round, rT = VL.floor, xd = VL.abs, cE = 12, AC = 8, T4 = 4;
function r5(e, t) {
  var r = 1 / 0, n;
  return be(t, function(i, s) {
    var l = e[0] - s[0], d = e[1] - s[1], h = l * l + d * d;
    h < r && (r = h, n = s);
  }), [rT(n[0]), rT(n[1])];
}
function w4(e, t, r) {
  return (t - e[0 + r]) / (e[2 + r] - e[0 + r]) * (e[3 - r] - e[1 - r]) + e[1 - r];
}
var nT = {
  isLabelInside: function(e, t) {
    var r = e.x + e.width / 2, n = e.y + e.height / 2;
    return t.x <= r && r <= t.x + t.width && t.y <= n && n <= t.y + t.height;
  },
  prepareLabelPoints: function(e, t, r, n, i) {
    var s = t.x, l = s + t.width / 2, d = s + t.width - 1, h = t.y, p = h + t.height / 2, m = h + t.height - 1, x, S = xd(n) % 90 === 0;
    return i[0] > s && i[0] < d ? S ? x = [
      [i[0], xd(i[1] - h) < xd(i[1] - m) ? h : m]
    ] : x = [
      [i[0], w4([s, h, d, m], i[0], 0)]
    ] : i[1] > h && i[1] < m ? S ? x = [
      [xd(i[0] - s) < xd(i[0] - d) ? s : d, i[1]]
    ] : x = [
      [w4([s, h, d, m], i[1], 1), i[1]]
    ] : S ? x = [
      [s, h],
      [r ? s : l, r ? p : h],
      [d, h],
      [s, m],
      [r ? d : l, r ? p : m],
      [d, m]
    ] : x = [
      [l, p]
    ], x;
  },
  isHorizontal: function(e, t) {
    return e.x > t.x + t.width || e.x + e.width < t.x;
  },
  getFigureCenter: function(e) {
    return [rT(e.x + e.width / 2), rT(e.y + e.height / 2)];
  },
  findFigurePoint: function(e, t) {
    var r = nT.getFigureCenter(e), n = r5(t, [
      [e.x, r[1]],
      [r[0], e.y + e.height],
      [e.x + e.width, r[1]],
      [r[0], e.y]
    ]);
    return n;
  },
  adjustPoints: function(e) {
    var t = xd(e[1] - e[3]) <= 1, r = xd(e[0] - e[2]) <= 1;
    return r && (e[0] = e[2]), t && (e[1] = e[3]), e;
  }
}, n5 = {
  isLabelInside: function() {
    return !1;
  },
  prepareLabelPoints: nT.prepareLabelPoints,
  isHorizontal: function(e, t) {
    return e.x > t.x + t.r || e.x + e.width < t.x - t.r;
  },
  getFigureCenter: function(e) {
    return [e.x, e.y];
  },
  findFigurePoint: function(e, t) {
    var r = Math.atan2(e.y - t[1], t[0] - e.x);
    return [Yu(e.x + e.r * Math.cos(r)), Yu(e.y - e.r * Math.sin(r))];
  },
  adjustPoints: nT.adjustPoints
}, Yle = {
  isLabelInside: function(e, t, r) {
    return !r;
  },
  prepareLabelPoints: function(e, t, r, n) {
    var i = e.x, s = i + e.width, l = i + Yu(e.width / 2), d = e.y, h = d + e.height, p = d + Yu(e.height / 2), m = [
      [
        [i, d],
        [s, d]
      ],
      [
        [s, d],
        [s, h]
      ],
      [
        [s, h],
        [i, h]
      ],
      [
        [i, h],
        [i, d]
      ]
    ], x = ya(n);
    return n === 0 ? m = r ? [
      [i, p],
      [s, p]
    ] : [
      [l, d],
      [l, h]
    ] : m = m.map(function(S) {
      return S.map(function(T) {
        return [Yu((T[0] - l) * x.cos + (T[1] - p) * x.sin + l), Yu(-(T[0] - l) * x.sin + (T[1] - p) * x.cos + p)];
      });
    }).reduce(function(S, T) {
      var k = T[0][0], O = T[0][1], D = T[1][0], L = T[1][1];
      return r ? (O >= p && p >= L || O <= p && p <= L) && S.push([(p - O) * (D - k) / (L - O) + k, p]) : (k >= l && l >= D || k <= l && l <= D) && S.push([l, (l - k) * (L - O) / (D - k) + O]), S;
    }, []), m;
  },
  isHorizontal: function(e, t) {
    return e.x > t.x || t.x > e.x + e.width;
  },
  getFigureCenter: n5.getFigureCenter,
  findFigurePoint: function(e, t, r) {
    if (!r)
      return [e.x, e.y];
    var n = t[0], i = Yu(e.x + (e.y - t[1]) / Math.tan(FG(e.angle))), s = [e.x, e.y, i, t[1]];
    return !(e.x <= i && i <= n) && !(n <= i && i <= e.x) && (xd(e.x - n) < cE ? s = [e.x, e.y] : e.x <= n ? s[2] = e.x + cE : s[2] = e.x - cE), s;
  },
  adjustPoints: function(e) {
    return e;
  }
};
function A4(e) {
  return e.angle !== void 0 && Yle || e.r !== void 0 && n5 || nT;
}
function OC(e, t) {
  e[t] && e[t].dispose(), e[t] = null;
}
function jk(e) {
  return e && (e.fill && e.fill !== "none" || e["stroke-width"] > 0 && e.stroke && e.stroke !== "none");
}
function O4(e) {
  return e && e["stroke-width"] > 0 && e.stroke && e.stroke !== "none";
}
function Wle(e, t) {
  var r = t.format;
  return e.valueText = Vu(e.value, r), e.argumentText = Vu(e.argument, t.argumentFormat), e.percent !== void 0 && (e.percentText = Vu(e.percent, {
    type: "percent",
    precision: r && r.percentPrecision
  })), e.total !== void 0 && (e.totalText = Vu(e.total, r)), e.openValue !== void 0 && (e.openValueText = Vu(e.openValue, r)), e.closeValue !== void 0 && (e.closeValueText = Vu(e.closeValue, r)), e.lowValue !== void 0 && (e.lowValueText = Vu(e.lowValue, r)), e.highValue !== void 0 && (e.highValueText = Vu(e.highValue, r)), e.reductionValue !== void 0 && (e.reductionValueText = Vu(e.reductionValue, r)), t.customizeText ? t.customizeText.call(e, e) : t.displayFormat ? $le(t.displayFormat, e) : e.valueText;
}
function wy(e) {
  this._renderer = e.renderer, this._container = e.labelsGroup, this._point = e.point, this._strategy = e.strategy, this._rowCount = 1;
}
wy.prototype = {
  constructor: wy,
  setColor: function(e) {
    this._color = e;
  },
  setOptions: function(e) {
    this._options = e;
  },
  setData: function(e) {
    this._data = e;
  },
  setDataField: function(e, t) {
    this._data = this._data || {}, this._data[e] = t;
  },
  getData: function() {
    return this._data;
  },
  setFigureToDrawConnector: function(e) {
    this._figure = e;
  },
  dispose: function() {
    OC(this, "_group"), this._data = this._options = this._textContent = this._visible = this._insideGroup = this._text = this._background = this._connector = this._figure = null;
  },
  _setVisibility: function(e, t) {
    this._group && this._group.attr({
      visibility: e
    }), this._visible = t;
  },
  isVisible: function() {
    return this._visible;
  },
  hide: function(e) {
    this._holdVisibility = !!e, this._hide();
  },
  _hide: function() {
    this._setVisibility("hidden", !1);
  },
  show: function(e) {
    var t = !this._drawn;
    this._point.hasValue() && (this._holdVisibility = !!e, this._show(), t && this._point.correctLabelPosition(this));
  },
  _show: function() {
    var e = this._renderer, t = this._container, r = this._options || {}, n = this._textContent = Wle(this._data, r) || null;
    n ? (this._group || (this._group = e.g().append(t), this._insideGroup = e.g().append(this._group), this._text = e.text("", 0, 0).append(this._insideGroup)), this._text.css(r.attributes ? Oi(r.attributes.font) : {}), jk(r.background) ? (this._background = this._background || e.rect().append(this._insideGroup).toBackground(), this._background.attr(r.background), this._color && this._background.attr({
      fill: this._color
    })) : OC(this, "_background"), O4(r.connector) ? (this._connector = this._connector || e.path([], "line").sharp().append(this._group).toBackground(), this._connector.attr(r.connector), this._color && this._connector.attr({
      stroke: this._color
    })) : OC(this, "_connector"), this._text.attr({
      text: n,
      align: r.textAlignment,
      class: r.cssClass
    }), this._updateBackground(this._text.getBBox()), this._setVisibility("visible", !0), this._drawn = !0) : this._hide();
  },
  _getLabelVisibility: function(e) {
    return this._holdVisibility ? this.isVisible() : e;
  },
  draw: function(e) {
    return this._getLabelVisibility(e) ? (this._show(), this._point && this._point.correctLabelPosition(this)) : (this._drawn = !1, this._hide()), this;
  },
  _updateBackground: function(e) {
    this._background && (e.x -= AC, e.y -= T4, e.width += 2 * AC, e.height += 2 * T4, this._background.attr(e)), this._bBoxWithoutRotation = W({}, e);
    var t = this._options.rotationAngle || 0;
    this._insideGroup.rotate(t, e.x + e.width / 2, e.y + e.height / 2), e = kE(e, [e.x + e.width / 2, e.y + e.height / 2], -t), this._bBox = e;
  },
  getFigureCenter() {
    var e = this._figure, t = this._strategy || A4(e);
    return t.getFigureCenter(e);
  },
  _getConnectorPoints: function() {
    var e = this._figure, t = this._options, r = this._strategy || A4(e), n = this._shiftBBox(this._bBoxWithoutRotation), i = this.getBoundingRect(), s, l = [], d;
    if (!r.isLabelInside(n, e, t.position !== "inside")) {
      d = r.isHorizontal(n, e);
      var h = this.getFigureCenter();
      l = r.prepareLabelPoints(n, i, d, -t.rotationAngle || 0, h), s = r5(h, l), l = r.findFigurePoint(e, s, d), l = l.concat(s);
    }
    return r.adjustPoints(l);
  },
  fit: function(e) {
    var t = this._background ? 2 * AC : 0, r = !1;
    if (this._text) {
      var n = this._text.setMaxSize(e - t, void 0, this._options), i = n.rowCount;
      i === 0 && (i = 1), i !== this._rowCount && (r = !0, this._rowCount = i), n.textIsEmpty && OC(this, "_background");
    }
    return this._updateBackground(this._text.getBBox()), r;
  },
  resetEllipsis: function() {
    this._text && this._text.restoreText(), this._updateBackground(this._text.getBBox());
  },
  setTrackerData: function(e) {
    this._text.data({
      "chart-data-point": e
    }), this._background && this._background.data({
      "chart-data-point": e
    });
  },
  hideInsideLabel: function(e) {
    return this._point.hideInsideLabel(this, e);
  },
  getPoint() {
    return this._point;
  },
  shift: function(e, t) {
    return this._textContent && (this._insideGroup.attr({
      translateX: this._x = Yu(e - this._bBox.x),
      translateY: this._y = Yu(t - this._bBox.y)
    }), this._connector && this._connector.attr({
      points: this._getConnectorPoints()
    })), this;
  },
  getBoundingRect: function() {
    return this._shiftBBox(this._bBox);
  },
  _shiftBBox: function(e) {
    return this._textContent ? {
      x: e.x + this._x,
      y: e.y + this._y,
      width: e.width,
      height: e.height
    } : {};
  },
  getLayoutOptions: function() {
    var e = this._options;
    return {
      alignment: e.alignment,
      background: jk(e.background),
      horizontalOffset: e.horizontalOffset,
      verticalOffset: e.verticalOffset,
      radialOffset: e.radialOffset,
      position: e.position,
      connectorOffset: (O4(e.connector) ? cE : 0) + (jk(e.background) ? AC : 0)
    };
  }
};
var Xle = jr(), kC = W, FL = Math, ag = FL.round, UD = FL.floor, jD = FL.ceil, $k = 20, Yk = 20, k4 = 10, RC = "canvas_position_default";
function qle(e) {
  return [-e, -e, e, -e, e, e, -e, e, -e, -e];
}
function Kle(e) {
  var t = jD(e);
  return [-t, 0, 0, -t, t, 0, 0, t, -t, 0];
}
function Zle(e) {
  var t = jD(e), r = UD(t / 2), n = jD(t / 2);
  return [-t, -r, -r, -t, 0, -n, r, -t, t, -r, n, 0, t, r, r, t, 0, n, -r, t, -t, r, -n, 0];
}
function Qle(e) {
  return [-e, -e, e, -e, 0, e, -e, -e];
}
function Jle(e) {
  return [-e, e, e, e, 0, -e, -e, e];
}
const Cn = {
  deleteLabel: function() {
    this._label.dispose(), this._label = null;
  },
  _hasGraphic: function() {
    return this.graphic;
  },
  clearVisibility: function() {
    var e = this.graphic;
    e && e.attr("visibility") && e.attr({
      visibility: null
    });
  },
  isVisible: function() {
    return this.inVisibleArea && this.series.isVisible();
  },
  setInvisibility: function() {
    var e = this.graphic;
    e && e.attr("visibility") !== "hidden" && e.attr({
      visibility: "hidden"
    }), this._errorBar && this._errorBar.attr({
      visibility: "hidden"
    }), this._label.draw(!1);
  },
  clearMarker: function() {
    var e = this.graphic;
    e && e.attr(this._emptySettings);
  },
  _createLabel: function() {
    this._label = new wy({
      renderer: this.series._renderer,
      labelsGroup: this.series._labelsGroup,
      point: this
    });
  },
  _calculateVisibility: function(e, t) {
    var {
      minX: r,
      maxX: n,
      minY: i,
      maxY: s
    } = this._getVisibleArea();
    this.inVisibleArea = r <= e && n >= e && i <= t && s >= t;
  },
  _updateLabelData: function() {
    this._label.setData(this._getLabelFormatObject());
  },
  _updateLabelOptions: function() {
    !this._label && this._createLabel(), this._label.setOptions(this._options.label);
  },
  _checkImage: function(e) {
    return I(e) && (typeof e == "string" || I(e.url));
  },
  _fillStyle: function() {
    this._styles = this._options.styles;
  },
  _checkSymbol: function(e, t) {
    var r = e.symbol, n = t.symbol, i = r === "circle" && n !== "circle" || r !== "circle" && n === "circle", s = this._checkImage(e.image) !== this._checkImage(t.image);
    return !!(i || s);
  },
  _populatePointShape: function(e, t) {
    switch (e) {
      case "square":
        return qle(t);
      case "polygon":
        return Kle(t);
      case "triangle":
      case "triangleDown":
        return Qle(t);
      case "triangleUp":
        return Jle(t);
      case "cross":
        return Zle(t);
    }
  },
  hasCoords: function() {
    return this.x !== null && this.y !== null;
  },
  correctValue: function(e) {
    var t = this.series.getValueAxis();
    this.hasValue() && (this.value = this.properValue = t.validateUnit(this.initialValue.valueOf() + e.valueOf()), this.minValue = t.validateUnit(e));
  },
  resetCorrection: function() {
    this.value = this.properValue = this.initialValue, this.minValue = RC;
  },
  resetValue: function() {
    this.hasValue() && (this.value = this.properValue = this.initialValue = 0, this.minValue = 0, this._label.setDataField("value", this.value));
  },
  _getTranslates: function(e) {
    var t = this.x, r = this.y;
    return e && (this._options.rotated ? t = this.defaultX : r = this.defaultY), {
      x: t,
      y: r
    };
  },
  _createImageMarker: function(e, t, r) {
    var n = r.width || $k, i = r.height || Yk;
    return e.image(-ag(0.5 * n), -ag(0.5 * i), n, i, r.url ? r.url.toString() : r.toString(), "center").attr({
      translateX: t.translateX,
      translateY: t.translateY,
      visibility: t.visibility
    });
  },
  _createSymbolMarker: function(e, t) {
    var r, n = this._options.symbol;
    return n === "circle" ? (delete t.points, r = e.circle().attr(t)) : (n === "square" || n === "polygon" || n === "triangle" || n === "triangleDown" || n === "triangleUp" || n === "cross") && (r = e.path([], "area").attr(t).sharp()), r;
  },
  _createMarker: function(e, t, r, n) {
    var i = this._checkImage(r) ? this._createImageMarker(e, n, r) : this._createSymbolMarker(e, n);
    return i && i.data({
      "chart-data-point": this
    }).append(t), i;
  },
  _getSymbolBBox: function(e, t, r) {
    return {
      x: e - r,
      y: t - r,
      width: 2 * r,
      height: 2 * r
    };
  },
  _getImageBBox: function(e, t) {
    var r = this._options.image, n = r.width || $k, i = r.height || Yk;
    return {
      x: e - ag(n / 2),
      y: t - ag(i / 2),
      width: n,
      height: i
    };
  },
  _getGraphicBBox: function() {
    var e = this._options, t = this.x, r = this.y, n;
    return e.visible ? n = this._checkImage(e.image) ? this._getImageBBox(t, r) : this._getSymbolBBox(t, r, e.styles.normal.r) : n = {
      x: t,
      y: r,
      width: 0,
      height: 0
    }, n;
  },
  hideInsideLabel: Y,
  _getShiftLabelCoords: function(e) {
    var t = this._addLabelAlignmentAndOffset(e, this._getLabelCoords(e));
    return this._checkLabelPosition(e, t);
  },
  _drawLabel: function() {
    var e = this._getCustomLabelVisibility(), t = this._label, r = this._showForZeroValues() && this.hasValue() && e !== !1 && (this.series.getLabelVisibility() || e);
    t.draw(!!r);
  },
  correctLabelPosition: function(e) {
    var t = this._getShiftLabelCoords(e);
    this.hideInsideLabel(e, t) || (e.setFigureToDrawConnector(this._getLabelConnector(e.pointPosition)), e.shift(ag(t.x), ag(t.y)));
  },
  _showForZeroValues: function() {
    return !0;
  },
  _getLabelConnector: function(e) {
    var t = this._getGraphicBBox(e), r = t.width / 2, n = t.height / 2;
    return {
      x: t.x + r,
      y: t.y + n,
      r: this._options.visible ? Math.max(r, n) : 0
    };
  },
  _getPositionFromLocation: function() {
    return {
      x: this.x,
      y: this.y
    };
  },
  _isPointInVisibleArea: function(e, t) {
    return e.minX <= t.x + t.width && e.maxX >= t.x && e.minY <= t.y + t.height && e.maxY >= t.y;
  },
  _checkLabelPosition: function(e, t) {
    var r = this._getVisibleArea(), n = e.getBoundingRect(), i = this._getGraphicBBox(e.pointPosition), s = this._getGraphicBBox(), l = e.getLayoutOptions().position === "inside", d = k4;
    return this._isPointInVisibleArea(r, s) && (this._options.rotated ? (r.minX > t.x && (t.x = l ? r.minX : i.x + i.width + d), r.maxX < t.x + n.width && (t.x = l ? r.maxX - n.width : i.x - d - n.width), r.minY > t.y && (t.y = r.minY), r.maxY < t.y + n.height && (t.y = r.maxY - n.height)) : (r.minX > t.x && (t.x = r.minX), r.maxX < t.x + n.width && (t.x = r.maxX - n.width), r.minY > t.y && (t.y = l ? r.minY : i.y + i.height + d), r.maxY < t.y + n.height && (t.y = l ? r.maxY - n.height : i.y - n.height - d))), t;
  },
  _addLabelAlignmentAndOffset: function(e, t) {
    var r = e.getBoundingRect(), n = e.getLayoutOptions();
    return this._options.rotated || (n.alignment === "left" ? t.x += r.width / 2 : n.alignment === "right" && (t.x -= r.width / 2)), t.x += n.horizontalOffset, t.y += n.verticalOffset, t;
  },
  _getLabelCoords: function(e) {
    return this._getLabelCoordOfPosition(e, this._getLabelPosition(e.pointPosition));
  },
  _getLabelCoordOfPosition: function(e, t) {
    var r = e.getBoundingRect(), n = this._getGraphicBBox(e.pointPosition), i = k4, s = n.height / 2 - r.height / 2, l = n.width / 2 - r.width / 2, d = n.x, h = n.y;
    switch (t) {
      case "left":
        d -= r.width + i, h += s;
        break;
      case "right":
        d += n.width + i, h += s;
        break;
      case "top":
        d += l, h -= r.height + i;
        break;
      case "bottom":
        d += l, h += n.height + i;
        break;
      case "inside":
        d += l, h += s;
    }
    return {
      x: d,
      y: h
    };
  },
  _drawMarker: function(e, t, r) {
    var n = this._options, i = this._getTranslates(r), s = this._getStyle();
    this.graphic = this._createMarker(e, t, n.image, kC({
      translateX: i.x,
      translateY: i.y,
      points: this._populatePointShape(n.symbol, s.r)
    }, s));
  },
  _getErrorBarSettings: function() {
    return {
      visibility: "visible"
    };
  },
  _getErrorBarBaseEdgeLength() {
    return 2 * this.getPointRadius();
  },
  _drawErrorBar: function(e, t) {
    if (this._options.errorBars) {
      var r = this._options, n = r.errorBars, i = [], s, l = this._errorBarPos, d = this._highErrorCoord, h = this._lowErrorCoord, p = Wt(n.displayMode), m = p === "high", x = p === "low", S = (m || !I(h)) && I(d) && !x, T = (x || !I(d)) && I(h) && !m, k = n.edgeLength;
      k <= 1 && k > 0 && (k = this._getErrorBarBaseEdgeLength() * n.edgeLength), k = UD(parseInt(k) / 2), S && (h = this._baseErrorBarPos), T && (d = this._baseErrorBarPos), p !== "none" && I(d) && I(h) && I(l) ? (!T && i.push([l - k, d, l + k, d]), i.push([l, d, l, h]), !S && i.push([l + k, h, l - k, h]), r.rotated && be(i, function(O, D) {
        D.reverse();
      }), s = this._getErrorBarSettings(n), this._errorBar ? (s.points = i, this._errorBar.attr(s)) : this._errorBar = e.path(i, "line").attr(s).append(t)) : this._errorBar && this._errorBar.attr({
        visibility: "hidden"
      });
    }
  },
  getTooltipParams: function() {
    var e = this.graphic;
    return {
      x: this.x,
      y: this.y,
      offset: e ? e.getBBox().height / 2 : 0
    };
  },
  setPercentValue: function(e, t, r, n) {
    var i = this.value / e || 0, s = this.minValue / e || 0, l = i - s;
    this._label.setDataField("percent", l), this._label.setDataField("total", t), this.series.isFullStackedSeries() && this.hasValue() && (this.leftHole && (this.leftHole /= e - r, this.minLeftHole /= e - r), this.rightHole && (this.rightHole /= e - n, this.minRightHole /= e - n), this.value = this.properValue = i, this.minValue = s || this.minValue);
  },
  _storeTrackerR: function() {
    var e = Xle.navigator, t = this._options.styles.normal.r, r = SM("ontouchstart") || e.msPointerEnabled && e.msMaxTouchPoints || e.pointerEnabled && e.maxTouchPoints ? 20 : 6;
    return this._options.trackerR = t < r ? r : t, this._options.trackerR;
  },
  _translateErrorBars: function() {
    var e = this._options, t = e.rotated, r = e.errorBars, n = this._getValTranslator();
    r && (I(this.lowError) && (this._lowErrorCoord = n.translate(this.lowError)), I(this.highError) && (this._highErrorCoord = n.translate(this.highError)), this._errorBarPos = UD(t ? this.vy : this.vx), this._baseErrorBarPos = r.type === "stdDeviation" ? this._lowErrorCoord + (this._highErrorCoord - this._lowErrorCoord) / 2 : t ? this.vx : this.vy);
  },
  _translate: function() {
    var e = this._getValTranslator(), t = this._getArgTranslator();
    this._options.rotated ? (this.vx = this.x = e.translate(this.value, void 0, !0), this.vy = this.y = t.translate(this.argument, void 0, !0), this.minX = e.translate(this.minValue, void 0, !0), this.defaultX = e.translate(RC)) : (this.vy = this.y = e.translate(this.value, void 0, !0), this.vx = this.x = t.translate(this.argument, void 0, !0), this.minY = e.translate(this.minValue, void 0, !0), this.defaultY = e.translate(RC)), this._translateErrorBars(), this._calculateVisibility(this.x, this.y);
  },
  _updateData: function(e) {
    this.value = this.properValue = this.initialValue = this.originalValue = e.value, this.minValue = this.initialMinValue = this.originalMinValue = I(e.minValue) ? e.minValue : RC;
  },
  _getImageSettings: function(e) {
    return {
      href: e.url || e.toString(),
      width: e.width || $k,
      height: e.height || Yk
    };
  },
  getCrosshairData: function() {
    var e = this._options.rotated, t = this.properValue, r = this.argument;
    return {
      x: this.vx,
      y: this.vy,
      xValue: e ? t : r,
      yValue: e ? r : t,
      axis: this.series.axis
    };
  },
  getPointRadius: function() {
    var e = this._getStyle(), t = this._options, r = e.r, n, i = t.symbol, s = i === "square", l = i === "triangle" || i === "triangleDown" || i === "triangleUp";
    return t.visible && !t.image && r ? (n = e["stroke-width"] / 2, (s || l ? 1.4 * r : r) + n) : 0;
  },
  _updateMarker: function(e, t) {
    var r = this._options, n, i = r.image, s = this.isVisible() ? {} : {
      visibility: "hidden"
    };
    this._checkImage(i) ? n = kC({}, {
      visibility: t.visibility
    }, s, this._getImageSettings(i)) : n = kC({}, t, s, {
      points: this._populatePointShape(r.symbol, t.r)
    }), e || (n.translateX = this.x, n.translateY = this.y), this.graphic.attr(n).sharp();
  },
  _getLabelFormatObject: function() {
    return {
      argument: this.initialArgument,
      value: this.initialValue,
      originalArgument: this.originalArgument,
      originalValue: this.originalValue,
      seriesName: this.series.name,
      lowErrorValue: this.lowError,
      highErrorValue: this.highError,
      point: this
    };
  },
  _getLabelPosition: function() {
    var e = this._options.rotated;
    return this.initialValue > 0 ? e ? "right" : "top" : e ? "left" : "bottom";
  },
  _getFormatObject: function(e) {
    var t = this._label.getData();
    return kC({}, t, {
      argumentText: e.formatValue(this.initialArgument, "argument"),
      valueText: e.formatValue(this.initialValue)
    }, I(t.percent) ? {
      percentText: e.formatValue(t.percent, "percent")
    } : {}, I(t.total) ? {
      totalText: e.formatValue(t.total)
    } : {});
  },
  getMarkerVisibility: function() {
    return this._options.visible;
  },
  coordsIn: function(e, t) {
    var r = this._storeTrackerR();
    return e >= this.x - r && e <= this.x + r && t >= this.y - r && t <= this.y + r;
  },
  getMinValue: function(e) {
    var t = this._options.errorBars;
    if (t && !e) {
      var r = t.displayMode, n = r !== "high" && I(this.lowError) ? this.lowError : this.value, i = r !== "low" && I(this.highError) ? this.highError : this.value;
      return n < i ? n : i;
    } else
      return this.value;
  },
  getMaxValue: function(e) {
    var t = this._options.errorBars;
    if (t && !e) {
      var r = t.displayMode, n = r !== "high" && I(this.lowError) ? this.lowError : this.value, i = r !== "low" && I(this.highError) ? this.highError : this.value;
      return n > i ? n : i;
    } else
      return this.value;
  }
};
var R4 = W, i5 = Math, eue = i5.floor, tue = i5.abs, rue = "canvas_position_default", D4 = 9, M4 = 4, L4 = "right", nue = "left", $D = "top", iue = "bottom";
function P4(e) {
  var t = e.initialValue, r = e._getValTranslator().getBusinessRange().invert, n = e.series.valueAxisType === "discrete", i = e.series.isFullStackedSeries(), s = !n && (t >= 0 && !r || t < 0 && r) || n && !r || i;
  return s ? $D : iue;
}
const Ay = R4({}, Cn, {
  correctCoordinates(e) {
    var t = eue(e.offset - e.width / 2);
    this._options.rotated ? (this.height = e.width, this.yCorrection = t, this.xCorrection = null) : (this.width = e.width, this.xCorrection = t, this.yCorrection = null);
  },
  _calculateVisibility: function(e, t, r, n) {
    var {
      minX: i,
      maxX: s,
      minY: l,
      maxY: d
    } = this._getVisibleArea();
    this.inVisibleArea = i <= e + r && s >= e && l <= t + n && d >= t;
  },
  _cacheVisibility: function(e, t, r, n) {
    var i = Math.abs(t - r);
    t = Math.min(t, r), n ? this._calculateVisibility(t, e, i, this.height) : this._calculateVisibility(e, t, this.width, i);
  },
  _getGraphicBBox: function(e) {
    var t = {
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height
    };
    if (e) {
      var r = e === "top";
      this._options.rotated ? (t.x = r ? t.x + t.width : t.x, t.width = 0) : (t.y = r ? t.y : t.y + t.height, t.height = 0);
    }
    return t;
  },
  _getLabelConnector: function(e) {
    return this._getGraphicBBox(e);
  },
  _getLabelPosition: function() {
    var e = P4(this);
    return this._options.rotated && (e = e === $D ? L4 : nue), e;
  },
  _getLabelCoords: function(e) {
    var t;
    return this.initialValue === 0 && this.series.isFullStackedSeries() ? this._options.rotated ? t = this._getLabelCoordOfPosition(e, L4) : t = this._getLabelCoordOfPosition(e, $D) : e.getLayoutOptions().position === "inside" ? t = this._getLabelCoordOfPosition(e, "inside") : t = Cn._getLabelCoords.call(this, e), t;
  },
  _drawLabel: function() {
    this._label.pointPosition = this._label.getLayoutOptions().position !== "inside" && P4(this), Cn._drawLabel.call(this);
  },
  hideInsideLabel: function(e, t) {
    var r = this._getGraphicBBox(), n = e.getBoundingRect();
    return this._options.resolveLabelsOverlapping && (t.y <= r.y && t.y + n.height >= r.y + r.height || t.x <= r.x && t.x + n.width >= r.x + r.width) && !(t.y > r.y + r.height || t.y + n.height < r.y || t.x > r.x + r.width || t.x + n.width < r.x) ? (e.draw(!1), !0) : !1;
  },
  _showForZeroValues: function() {
    return this._options.label.showForZeroValues || this.initialValue;
  },
  _drawMarker(e, t, r) {
    var n = this._getStyle(), i = this._options.cornerRadius, s = this._options.rotated, {
      x: l,
      y: d,
      width: h,
      height: p
    } = this.getMarkerCoords();
    r && (s ? (h = 0, l = this.defaultX) : (p = 0, d = this.defaultY)), this.graphic = e.rect(l, d, h, p).attr({
      rx: i,
      ry: i
    }).smartAttr(n).data({
      "chart-data-point": this
    }).append(t);
  },
  _getSettingsForTracker: function() {
    var e = this.y, t = this.height, r = this.x, n = this.width;
    return this._options.rotated ? n === 1 && (n = D4, r -= M4) : t === 1 && (t = D4, e -= M4), {
      x: r,
      y: e,
      width: n,
      height: t
    };
  },
  getGraphicSettings: function() {
    var e = this.graphic;
    return {
      x: e.attr("x"),
      y: e.attr("y"),
      height: e.attr("height"),
      width: e.attr("width")
    };
  },
  _getEdgeTooltipParams() {
    var e = this.value >= 0, t, r, n = this._getValTranslator().getBusinessRange().invert, {
      x: i,
      y: s,
      width: l,
      height: d
    } = this;
    return this._options.rotated ? (r = s + d / 2, n ? t = e ? i : i + l : t = e ? i + l : i) : (t = i + l / 2, n ? r = e ? s + d : s : r = e ? s : s + d), {
      x: t,
      y: r,
      offset: 0
    };
  },
  getTooltipParams: function(e) {
    if (e === "edge")
      return this._getEdgeTooltipParams();
    var t = this.getCenterCoord();
    return t.offset = 0, t;
  },
  getCenterCoord() {
    var {
      width: e,
      height: t,
      x: r,
      y: n
    } = this;
    return {
      x: r + e / 2,
      y: n + t / 2
    };
  },
  _truncateCoord: function(e, t) {
    return e === null ? e : e < t[0] ? t[0] : e > t[1] ? t[1] : e;
  },
  _getErrorBarBaseEdgeLength() {
    return this._options.rotated ? this.height : this.width;
  },
  _translateErrorBars: function(e) {
    Cn._translateErrorBars.call(this), (this._errorBarPos < e[0] || this._errorBarPos > e[1]) && (this._errorBarPos = void 0);
  },
  _translate: function() {
    var e = this._options.rotated, t = e ? "x" : "y", r = e ? "y" : "x", n = e ? "width" : "height", i = e ? "height" : "width", s = this._getArgTranslator(), l = this._getValTranslator(), d = this.series.getArgumentAxis().getVisibleArea(), h = this.series.getValueAxis().getVisibleArea(), p = s.translate(this.argument), m = l.translate(this.value, 1), x = l.translate(this.minValue, -1);
    this[r] = p = p === null ? p : p + (this[r + "Correction"] || 0), this["v" + t] = m, this["v" + r] = p + this[i] / 2, this._cacheVisibility(p, m, x, e), m = this._truncateCoord(m, h), x = this._truncateCoord(x, h), this[n] = tue(m - x), m = m < x ? m : x, this[t] = m === null ? m : m + (this[t + "Correction"] || 0), this["min" + t.toUpperCase()] = x === null ? x : x + (this[t + "Correction"] || 0), this["default" + t.toUpperCase()] = l.translate(rue), this._translateErrorBars(d), this.inVisibleArea && this[r] !== null && (this[r] < d[0] && (this[i] = this[i] - (d[0] - this[r]), this[r] = d[0]), this[r] + this[i] > d[1] && (this[i] = d[1] - this[r]));
  },
  _updateMarker: function(e, t) {
    this.graphic.smartAttr(R4({}, t, e ? {} : this.getMarkerCoords()));
  },
  getMarkerCoords: function() {
    var e = this.x, t = this.y, r = this.width, n = this.height, i = this.series.getArgumentAxis(), s = this._options.rotated;
    if (i.getAxisPosition) {
      var l = i.getOptions(), d = Math.round(l.width / 2), h = i.getAxisPosition();
      if (l.visible)
        if (!s)
          n -= this.minY === this.defaultY && this.minY === h - i.getAxisShift() ? d : 0, n < 0 && (n = 0);
        else {
          var p = this.minX === this.defaultX && this.minX === h - i.getAxisShift();
          e += p ? d : 0, r -= p ? d : 0, r < 0 && (r = 0);
        }
    }
    return {
      x: e,
      y: t,
      width: r,
      height: n
    };
  },
  coordsIn: function(e, t) {
    return e >= this.x && e <= this.x + this.width && t >= this.y && t <= this.y + this.height;
  }
});
var Wk = W, aue = 20;
const oue = Wk({}, Cn, {
  correctCoordinates: function(e) {
    this.bubbleSize = e / 2;
  },
  _drawMarker: function(e, t, r) {
    var n = Wk({
      translateX: this.x,
      translateY: this.y
    }, this._getStyle());
    this.graphic = e.circle(0, 0, r ? 0 : this.bubbleSize).smartAttr(n).data({
      "chart-data-point": this
    }).append(t);
  },
  getTooltipParams: function(e) {
    var t = this.graphic;
    if (t) {
      var r = t.getBBox().height;
      return {
        x: this.x,
        y: this.y,
        offset: r < aue || e === "edge" ? r / 2 : 0
      };
    }
  },
  _getLabelFormatObject: function() {
    var e = Cn._getLabelFormatObject.call(this);
    return e.size = this.initialSize, e;
  },
  _updateData: function(e) {
    Cn._updateData.call(this, e), this.size = this.initialSize = e.size;
  },
  _getGraphicBBox: function() {
    return this._getSymbolBBox(this.x, this.y, this.bubbleSize);
  },
  _updateMarker: function(e, t) {
    e || (t = Wk({
      r: this.bubbleSize,
      translateX: this.x,
      translateY: this.y
    }, t)), this.graphic.smartAttr(t);
  },
  _getFormatObject: function(e) {
    var t = Cn._getFormatObject.call(this, e);
    return t.sizeText = e.formatValue(this.initialSize), t;
  },
  _storeTrackerR: function() {
    return this.bubbleSize;
  },
  _getLabelCoords: function(e) {
    var t;
    return e.getLayoutOptions().position === "inside" ? t = this._getLabelCoordOfPosition(e, "inside") : t = Cn._getLabelCoords.call(this, e), t;
  }
});
var I4 = W, _d = Math.round, sue = Math.sqrt, lue = Math.acos, uue = 180 / Math.PI, cue = Math.abs, due = Is.radialLabelIndent;
const wd = I4({}, Cn, {
  _updateData: function(e, t) {
    Cn._updateData.call(this, e), (t || !I(this._visible)) && (this._visible = !0), this.minValue = this.initialMinValue = this.originalMinValue = I(e.minValue) ? e.minValue : 0;
  },
  animate: function(e, t, r) {
    this.graphic.animate({
      x: this.centerX,
      y: this.centerY,
      outerRadius: this.radiusOuter,
      innerRadius: this.radiusInner,
      startAngle: this.toAngle,
      endAngle: this.fromAngle
    }, {
      delay: r,
      partitionDuration: t
    }, e);
  },
  correctPosition: function(e) {
    this.correctRadius(e), this.correctLabelRadius(e.radiusOuter + due), this.centerX = e.centerX, this.centerY = e.centerY;
  },
  correctRadius: function(e) {
    this.radiusInner = e.radiusInner, this.radiusOuter = e.radiusOuter;
  },
  correctLabelRadius: function(e) {
    this.radiusLabels = e;
  },
  correctValue: function(e, t, r) {
    this.value = (r || this.normalInitialValue) + e, this.minValue = e, this.percent = t, this._label.setDataField("percent", t);
  },
  _updateLabelData: function() {
    this._label.setData(this._getLabelFormatObject());
  },
  _getShiftLabelCoords: function() {
    var e = this._label.getBoundingRect(), t = this._getLabelCoords(this._label), r = this._getVisibleArea();
    return this._isLabelDrawingWithoutPoints ? this._checkLabelPosition(t, e, r) : this._getLabelExtraCoord(t, this._checkVerticalLabelPosition(t, e, r), e);
  },
  _getLabelPosition: function(e) {
    return e.position;
  },
  getAnnotationCoords: function(e) {
    return this._getElementCoords(e !== "edge" ? "inside" : "outside", this.radiusOuter, 0);
  },
  _getElementCoords: function(e, t, r) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    }, i = this, s = ya(i.middleAngle), l = i.radiusInner, d = i.radiusOuter, h = e === "columns", p, m;
    return e === "inside" ? (p = l + (d - l) / 2 + r, m = i.centerX + p * s.cos - n.width / 2) : (p = t + r, s.cos > 0.1 || h && s.cos >= 0 ? m = i.centerX + p * s.cos : s.cos < -0.1 || h && s.cos < 0 ? m = i.centerX + p * s.cos - n.width : m = i.centerX + p * s.cos - n.width / 2), {
      x: m,
      y: _d(i.centerY - p * s.sin - n.height / 2)
    };
  },
  _getLabelCoords: function(e) {
    var t = e.getBoundingRect(), r = e.getLayoutOptions(), n = this._getLabelPosition(r);
    return this._getElementCoords(n, this.radiusLabels, r.radialOffset, t);
  },
  _correctLabelCoord: function(e, t) {
    var r = this._label, n = r.getBoundingRect(), i = n.width, s = r.getLayoutOptions(), l = this._getVisibleArea(), d = l.maxX - i, h = l.minX, p = Ll(this.middleAngle), m = this.centerX, x = s.connectorOffset, S = e.x;
    return s.position === "columns" ? (p <= 90 || p >= 270 ? S = d : S = h, e.x = S) : s.position !== "inside" && t && (p <= 90 || p >= 270 ? S - x < m && (S = m + x) : S + i + x > m && (S = m - i - x), e.x = S), e;
  },
  drawLabel: function() {
    this.translate(), this._isLabelDrawingWithoutPoints = !0, this._drawLabel(), this._isLabelDrawingWithoutPoints = !1;
  },
  updateLabelCoord: function(e) {
    var t = this._label.getBoundingRect(), r = this._correctLabelCoord(t, e);
    r = this._checkHorizontalLabelPosition(r, t, this._getVisibleArea()), this._label.shift(_d(r.x), _d(t.y));
  },
  _checkVerticalLabelPosition: function(e, t, r) {
    var n = e.x, i = e.y;
    return e.y + t.height > r.maxY ? i = r.maxY - t.height : e.y < r.minY && (i = r.minY), {
      x: n,
      y: i
    };
  },
  _getLabelExtraCoord: function(e, t, r) {
    return e.y !== t.y ? HG({
      x: e.x,
      y: e.y,
      width: r.width,
      height: r.height
    }, t.y - e.y, {
      x: this.centerX,
      y: this.centerY
    }) : e;
  },
  _checkHorizontalLabelPosition: function(e, t, r) {
    var n = e.x, i = e.y;
    return e.x + t.width > r.maxX ? n = r.maxX - t.width : e.x < r.minX && (n = r.minX), {
      x: n,
      y: i
    };
  },
  applyWordWrap: function(e) {
    var t = this._label, r = t.getBoundingRect(), n = this._getVisibleArea(), i = t.getLayoutOptions().position, s = r.width, l = !1;
    return i === "columns" && this.series.index > 0 ? s = n.maxX - this.centerX - this.radiusLabels : i === "inside" ? s > n.maxX - n.minX && (s = n.maxX - n.minX) : e && r.x < this.centerX && r.width + r.x > this.centerX ? s = Math.floor((n.maxX - n.minX) / 2) : r.x + s > n.maxX ? s = n.maxX - r.x : r.x < n.minX && (s = r.x + s - n.minX), s < r.width && (l = t.fit(s)), l;
  },
  setLabelTrackerData: function() {
    this._label.setTrackerData(this);
  },
  _checkLabelPosition: function(e, t, r) {
    return e = this._checkHorizontalLabelPosition(e, t, r), this._checkVerticalLabelPosition(e, t, r);
  },
  _getLabelConnector: function() {
    var e = this.radiusOuter, t = this._options.styles.normal, r = t["stroke-width"] / 2, n = this.series.getOptions().containerBackgroundColor === t.stroke ? _d(r) : _d(-r), i = ya(_d(this.middleAngle));
    return {
      x: _d(this.centerX + (e - n) * i.cos),
      y: _d(this.centerY - (e - n) * i.sin),
      angle: this.middleAngle
    };
  },
  _drawMarker: function(e, t, r, n) {
    var i = this.radiusOuter, s = this.radiusInner, l = this.fromAngle, d = this.toAngle;
    r && (s = i = 0, n || (l = d = this.shiftedAngle)), this.graphic = e.arc(this.centerX, this.centerY, s, i, d, l).attr({
      "stroke-linejoin": "round"
    }).smartAttr(this._getStyle()).data({
      "chart-data-point": this
    }).sharp().append(t);
  },
  getTooltipParams: function() {
    var e = ya(this.middleAngle), t = this.radiusInner, r = this.radiusOuter;
    return {
      x: this.centerX + (t + (r - t) / 2) * e.cos,
      y: this.centerY - (t + (r - t) / 2) * e.sin,
      offset: 0
    };
  },
  _translate: function() {
    var e = this.shiftedAngle || 0, t = this.value, r = this.minValue, n = this._getValTranslator();
    this.fromAngle = n.translate(r) + e, this.toAngle = n.translate(t) + e, this.middleAngle = n.translate((t - r) / 2 + r) + e, this.isVisible() || (this.middleAngle = this.toAngle = this.fromAngle = this.fromAngle || e);
  },
  getMarkerVisibility: function() {
    return !0;
  },
  _updateMarker: function(e, t, r, n) {
    e || (t = I4({
      x: this.centerX,
      y: this.centerY,
      outerRadius: this.radiusOuter,
      innerRadius: this.radiusInner,
      startAngle: this.toAngle,
      endAngle: this.fromAngle
    }, t)), this.graphic.smartAttr(t).sharp(), n && n();
  },
  getLegendStyles: function() {
    return this._styles.legendStyles;
  },
  isInVisibleArea: function() {
    return !0;
  },
  hide: function() {
    this._visible && (this._visible = !1, this.hideTooltip(), this._options.visibilityChanged());
  },
  show: function() {
    this._visible || (this._visible = !0, this._options.visibilityChanged());
  },
  setInvisibility: function() {
    this._label.draw(!1);
  },
  isVisible: function() {
    return this._visible;
  },
  _getFormatObject: function(e) {
    var t = Cn._getFormatObject.call(this, e), r = this.percent;
    return t.percent = r, t.percentText = e.formatValue(r, "percent"), t;
  },
  getColor: function() {
    return this._styles.normal.fill;
  },
  coordsIn: function(e, t) {
    var r = e - this.centerX, n = t - this.centerY, i = sue(r * r + n * n), s = this.fromAngle % 360, l = this.toAngle % 360, d;
    return i < this.radiusInner || i > this.radiusOuter || i === 0 ? !1 : (d = lue(r / i) * uue * (n > 0 ? -1 : 1), d < 0 && (d += 360), s === l && cue(this.toAngle - this.fromAngle) > 1e-4 ? !0 : s >= l ? d <= s && d >= l : !(d >= s && d <= l));
  }
});
var Xk = W, UT = Math, og = UT.abs, Ts = UT.min, P_ = UT.max, fue = UT.round, hue = 20, vue = 20;
const Vn = Xk({}, Cn, {
  deleteLabel: function() {
    this._topLabel.dispose(), this._topLabel = null, this._bottomLabel.dispose(), this._bottomLabel = null;
  },
  hideMarker: function(e) {
    var t = this.graphic, r = t && t[e + "Marker"], n = this["_" + e + "Label"];
    r && r.attr("visibility") !== "hidden" && r.attr({
      visibility: "hidden"
    }), n.draw(!1);
  },
  setInvisibility: function() {
    this.hideMarker("top"), this.hideMarker("bottom");
  },
  clearVisibility: function() {
    var e = this.graphic, t = e && e.topMarker, r = e && e.bottomMarker;
    t && t.attr("visibility") && t.attr({
      visibility: null
    }), r && r.attr("visibility") && r.attr({
      visibility: null
    });
  },
  clearMarker: function() {
    var e = this.graphic, t = e && e.topMarker, r = e && e.bottomMarker, n = this._emptySettings;
    t && t.attr(n), r && r.attr(n);
  },
  _getLabelPosition: function(e) {
    var t, r = this._options.label.position === "inside";
    return this._options.rotated ? t = e === "top" ^ r ? "right" : "left" : t = e === "top" ^ r ? "top" : "bottom", t;
  },
  _getLabelMinFormatObject: function() {
    return {
      index: 0,
      argument: this.initialArgument,
      value: this.initialMinValue,
      seriesName: this.series.name,
      originalValue: this.originalMinValue,
      originalArgument: this.originalArgument,
      point: this
    };
  },
  _updateLabelData: function() {
    var e = this._getLabelFormatObject();
    e.index = 1, this._topLabel.setData(e), this._bottomLabel.setData(this._getLabelMinFormatObject());
  },
  _updateLabelOptions: function() {
    var e = this._options.label;
    (!this._topLabel || !this._bottomLabel) && this._createLabel(), this._topLabel.setOptions(e), this._bottomLabel.setOptions(e);
  },
  _createLabel: function() {
    var e = {
      renderer: this.series._renderer,
      labelsGroup: this.series._labelsGroup,
      point: this
    };
    this._topLabel = new wy(e), this._bottomLabel = new wy(e);
  },
  _getGraphicBBox: function(e) {
    var t = this._options, r = this._getImage(t.image), n = e === "top" ? this._checkImage(r.top) : this._checkImage(r.bottom), i, s = this._getPositionFromLocation(e);
    return t.visible ? i = n ? this._getImageBBox(s.x, s.y) : this._getSymbolBBox(s.x, s.y, t.styles.normal.r) : i = {
      x: s.x,
      y: s.y,
      width: 0,
      height: 0
    }, i;
  },
  _getPositionFromLocation: function(e) {
    var t, r, n = e === "top";
    return this._options.rotated ? (t = n ? P_(this.x, this.minX) : Ts(this.x, this.minX), r = this.y) : (t = this.x, r = n ? Ts(this.y, this.minY) : P_(this.y, this.minY)), {
      x: t,
      y: r
    };
  },
  _checkOverlay: function(e, t, r) {
    return e < t + r;
  },
  _getOverlayCorrections: function(e, t) {
    var r = this._options.rotated, n = r ? "x" : "y", i = r ? "width" : "height", s = this.series.getValueAxis().getVisibleArea(), l = s[0], d = s[1], h = fue((e[n] + e[i] - t[n]) / 2), p = e[n] - h, m = t[n] + h;
    return p < l ? (h = l - p, p += h, m += h) : m + t[i] > d && (h = d - m - t[i], p += h, m += h), {
      coord1: p,
      coord2: m
    };
  },
  _checkLabelsOverlay: function(e) {
    var t = this._topLabel.getBoundingRect(), r = this._bottomLabel.getBoundingRect(), n = {};
    this._options.rotated ? e === "top" ? this._checkOverlay(t.x, r.x, r.width) && (n = this._getOverlayCorrections(r, t), this._topLabel.shift(n.coord2, t.y), this._bottomLabel.shift(n.coord1, r.y)) : this._checkOverlay(r.x, t.x, t.width) && (n = this._getOverlayCorrections(t, r), this._topLabel.shift(n.coord1, t.y), this._bottomLabel.shift(n.coord2, r.y)) : e === "top" ? this._checkOverlay(r.y, t.y, t.height) && (n = this._getOverlayCorrections(t, r), this._topLabel.shift(t.x, n.coord1), this._bottomLabel.shift(r.x, n.coord2)) : this._checkOverlay(t.y, r.y, r.height) && (n = this._getOverlayCorrections(r, t), this._topLabel.shift(t.x, n.coord2), this._bottomLabel.shift(r.x, n.coord1));
  },
  _drawLabel: function() {
    var e = [], t = this._options.rotated ? this.x >= this.minX : this.y < this.minY, r = this._getCustomLabelVisibility(), n = this._topLabel, i = this._bottomLabel;
    n.pointPosition = t ? "top" : "bottom", i.pointPosition = t ? "bottom" : "top", (this.series.getLabelVisibility() || r) && this.hasValue() && r !== !1 ? (this.visibleTopMarker !== !1 && e.push(n), this.visibleBottomMarker !== !1 && e.push(i), be(e, function(s, l) {
      l.draw(!0);
    }), this._checkLabelsOverlay(this._topLabel.pointPosition)) : (n.draw(!1), i.draw(!1));
  },
  _getImage: function(e) {
    var t = {};
    return I(e) && (typeof e == "string" ? t.top = t.bottom = e : (t.top = {
      url: typeof e.url == "string" ? e.url : e.url && e.url.rangeMaxPoint,
      width: typeof e.width == "number" ? e.width : e.width && e.width.rangeMaxPoint,
      height: typeof e.height == "number" ? e.height : e.height && e.height.rangeMaxPoint
    }, t.bottom = {
      url: typeof e.url == "string" ? e.url : e.url && e.url.rangeMinPoint,
      width: typeof e.width == "number" ? e.width : e.width && e.width.rangeMinPoint,
      height: typeof e.height == "number" ? e.height : e.height && e.height.rangeMinPoint
    })), t;
  },
  _checkSymbol: function(e, t) {
    var r = e.symbol, n = t.symbol, i = r === "circle" && n !== "circle" || r !== "circle" && n === "circle", s = this._getImage(e.image), l = this._getImage(t.image), d = this._checkImage(s.top) !== this._checkImage(l.top), h = this._checkImage(s.bottom) !== this._checkImage(l.bottom);
    return i || d || h;
  },
  _getSettingsForTwoMarkers: function(e) {
    var t = this._options, r = {}, n = t.rotated ? Ts(this.x, this.minX) : this.x, i = t.rotated ? this.y : Ts(this.y, this.minY), s = e.r, l = this._populatePointShape(t.symbol, s);
    return r.top = Xk({
      translateX: n + this.width,
      translateY: i,
      r: s
    }, e), r.bottom = Xk({
      translateX: n,
      translateY: i + this.height,
      r: s
    }, e), l && (r.top.points = r.bottom.points = l), r;
  },
  _hasGraphic: function() {
    return this.graphic && this.graphic.topMarker && this.graphic.bottomMarker;
  },
  _drawOneMarker: function(e, t, r, n) {
    var i = this.graphic;
    i[t] ? this._updateOneMarker(t, n) : i[t] = this._createMarker(e, i, r, n);
  },
  _drawMarker: function(e, t, r, n, i) {
    var s = this._getSettingsForTwoMarkers(i || this._getStyle()), l = this._getImage(this._options.image);
    this._checkImage(l.top) && (s.top = this._getImageSettings(s.top, l.top)), this._checkImage(l.bottom) && (s.bottom = this._getImageSettings(s.bottom, l.bottom)), this.graphic = this.graphic || e.g().append(t), this.visibleTopMarker && this._drawOneMarker(e, "topMarker", l.top, s.top), this.visibleBottomMarker && this._drawOneMarker(e, "bottomMarker", l.bottom, s.bottom);
  },
  _getSettingsForTracker: function(e) {
    var t = this._options.rotated;
    return {
      translateX: t ? Ts(this.x, this.minX) - e : this.x - e,
      translateY: t ? this.y - e : Ts(this.y, this.minY) - e,
      width: this.width + 2 * e,
      height: this.height + 2 * e
    };
  },
  isInVisibleArea: function() {
    var e = this._options.rotated, t = e ? this.y : this.x, r = e ? P_(this.minX, this.x) : P_(this.minY, this.y), n = e ? Ts(this.minX, this.x) : Ts(this.minY, this.y), i, s, l, d = !0, h = this.series.getArgumentAxis().getVisibleArea(), p = this.series.getValueAxis().getVisibleArea(), m = h[1] < t || h[0] > t, x = p[0] > n && p[0] > r || p[1] < n && p[1] < r;
    return m || x ? s = l = d = !1 : (s = p[0] <= n && p[1] > n, l = p[0] < r && p[1] >= r, e && (i = s, s = l, l = i)), this.visibleTopMarker = s, this.visibleBottomMarker = l, d;
  },
  getTooltipParams: function() {
    var e, t, r = this._options.rotated, n = r ? Ts(this.x, this.minX) : Ts(this.y, this.minY), i = r ? "width" : "height", s = this._getVisibleArea(), l = r ? s.minX : s.minY, d = r ? s.maxX : s.maxY, h = P_(l, n), p = Ts(d, n + this[i]);
    return r ? (t = this.y, e = h + (p - h) / 2) : (e = this.x, t = h + (p - h) / 2), {
      x: e,
      y: t,
      offset: 0
    };
  },
  _translate: function() {
    var e = this._options.rotated;
    Cn._translate.call(this), this.height = e ? 0 : og(this.minY - this.y), this.width = e ? og(this.x - this.minX) : 0;
  },
  hasCoords: function() {
    return Cn.hasCoords.call(this) && !(this.minX === null || this.minY === null);
  },
  _updateData: function(e) {
    Cn._updateData.call(this, e), this.minValue = this.initialMinValue = this.originalMinValue = e.minValue;
  },
  _getImageSettings: function(e, t) {
    return {
      href: t.url || t.toString(),
      width: t.width || hue,
      height: t.height || vue,
      translateX: e.translateX,
      translateY: e.translateY
    };
  },
  getCrosshairData: function(e, t) {
    var r = this._options.rotated, n = this.minX, i = this.minY, s = this.vx, l = this.vy, d = this.value, h = this.minValue, p = this.argument, m = {
      axis: this.series.axis,
      x: s,
      y: l,
      yValue: d,
      xValue: p
    };
    return r ? (m.yValue = p, og(s - e) < og(n - e) ? m.xValue = d : (m.x = n, m.xValue = h)) : og(l - t) >= og(i - t) && (m.y = i, m.yValue = h), m;
  },
  _updateOneMarker: function(e, t) {
    this.graphic && this.graphic[e] && this.graphic[e].attr(t);
  },
  _updateMarker: function(e, t) {
    this._drawMarker(void 0, void 0, !1, !1, t);
  },
  _getFormatObject: function(e) {
    var t = this.initialMinValue, r = this.initialValue, n = this.initialArgument, i = e.formatValue(t), s = e.formatValue(r);
    return {
      argument: n,
      argumentText: e.formatValue(n, "argument"),
      valueText: i + " - " + s,
      rangeValue1Text: i,
      rangeValue2Text: s,
      rangeValue1: t,
      rangeValue2: r,
      seriesName: this.series.name,
      point: this,
      originalMinValue: this.originalMinValue,
      originalValue: this.originalValue,
      originalArgument: this.originalArgument
    };
  },
  getLabel: function() {
    return [this._topLabel, this._bottomLabel];
  },
  getLabels: function() {
    return [this._topLabel, this._bottomLabel];
  },
  getBoundingRect: Y,
  coordsIn: function(e, t) {
    var r = this._storeTrackerR(), n = e >= this.x - r && e <= this.x + r, i = t >= this.y - r && t <= this.y + r;
    return this._options.rotated ? i && (n || e >= this.minX - r && e <= this.minX + r) : n && (i || t >= this.minY - r && t <= this.minY + r);
  },
  getMaxValue: function() {
    return this.series.valueAxisType !== "discrete" ? this.minValue > this.value ? this.minValue : this.value : this.value;
  },
  getMinValue: function() {
    return this.series.valueAxisType !== "discrete" ? this.minValue < this.value ? this.minValue : this.value : this.minValue;
  }
});
var pue = W;
const gue = pue({}, Ay, {
  deleteLabel: Vn.deleteLabel,
  _getFormatObject: Vn._getFormatObject,
  clearVisibility: function() {
    var e = this.graphic;
    e && e.attr("visibility") && e.attr({
      visibility: null
    });
  },
  setInvisibility: function() {
    var e = this.graphic;
    e && e.attr("visibility") !== "hidden" && e.attr({
      visibility: "hidden"
    }), this._topLabel.draw(!1), this._bottomLabel.draw(!1);
  },
  getTooltipParams: function(e) {
    var t = e === "edge", r, n;
    return this._options.rotated ? (r = t ? this.x + this.width : this.x + this.width / 2, n = this.y + this.height / 2) : (r = this.x + this.width / 2, n = t ? this.y : this.y + this.height / 2), {
      x: r,
      y: n,
      offset: 0
    };
  },
  _translate: function() {
    var e = Ay;
    e._translate.call(this), this._options.rotated ? this.width = this.width || 1 : this.height = this.height || 1;
  },
  hasCoords: Vn.hasCoords,
  _updateData: Vn._updateData,
  _getLabelPosition: Vn._getLabelPosition,
  _getLabelMinFormatObject: Vn._getLabelMinFormatObject,
  _updateLabelData: Vn._updateLabelData,
  _updateLabelOptions: Vn._updateLabelOptions,
  getCrosshairData: Vn.getCrosshairData,
  _createLabel: Vn._createLabel,
  _checkOverlay: Vn._checkOverlay,
  _checkLabelsOverlay: Vn._checkLabelsOverlay,
  _getOverlayCorrections: Vn._getOverlayCorrections,
  _drawLabel: Vn._drawLabel,
  _getLabelCoords: Vn._getLabelCoords,
  getLabel: Vn.getLabel,
  getLabels: Vn.getLabels,
  getBoundingRect: Y,
  getMinValue: Vn.getMinValue,
  getMaxValue: Vn.getMaxValue
});
var jT = Math, ws = jT.abs, sh = jT.min, DC = jT.max, N4 = jT.round, MC = 2;
const a5 = W({}, Ay, {
  _calculateVisibility: Cn._calculateVisibility,
  _getContinuousPoints: function(e, t) {
    var r = this.x, n = this._options.rotated ? function(p, m) {
      return [m, p];
    } : function(p, m) {
      return [p, m];
    }, i = this.width, s = this.highY, l = ws(s - e) < ws(s - t) ? e : t, d = l === t ? e : t, h;
    return d === l ? h = [].concat(n(r, this.highY)).concat(n(r, this.lowY)).concat(n(r, this.closeY)).concat(n(r - i / 2, this.closeY)).concat(n(r + i / 2, this.closeY)).concat(n(r, this.closeY)) : h = [].concat(n(r, this.highY)).concat(n(r, l)).concat(n(r + i / 2, l)).concat(n(r + i / 2, d)).concat(n(r, d)).concat(n(r, this.lowY)).concat(n(r, d)).concat(n(r - i / 2, d)).concat(n(r - i / 2, l)).concat(n(r, l)), h;
  },
  _getCrockPoints: function(e) {
    var t = this.x, r = this._options.rotated ? function(n, i) {
      return [i, n];
    } : function(n, i) {
      return [n, i];
    };
    return [].concat(r(t, this.highY)).concat(r(t, this.lowY)).concat(r(t, e)).concat(r(t - this.width / 2, e)).concat(r(t + this.width / 2, e)).concat(r(t, e));
  },
  _getPoints: function() {
    var e, t = this.closeY, r = this.openY;
    return t !== null && r !== null ? e = this._getContinuousPoints(r, t) : r === t ? e = [this.x, this.highY, this.x, this.lowY] : e = this._getCrockPoints(r !== null ? r : t), e;
  },
  getColor: function() {
    return this._isReduction ? this._options.reduction.color : this._styles.normal.stroke || this.series.getColor();
  },
  _drawMarkerInGroup: function(e, t, r) {
    this.graphic = r.path(this._getPoints(), "area").attr({
      "stroke-linecap": "square"
    }).attr(t).data({
      "chart-data-point": this
    }).sharp().append(e);
  },
  _fillStyle: function() {
    var e = this._options.styles;
    this._isReduction && this._isPositive ? this._styles = e.reductionPositive : this._isReduction ? this._styles = e.reduction : this._isPositive ? this._styles = e.positive : this._styles = e;
  },
  _getMinTrackerWidth: function() {
    return 2 + 2 * this._styles.normal["stroke-width"];
  },
  correctCoordinates: function(e) {
    var t = this._getMinTrackerWidth(), r = e.width;
    r = r < t ? t : r > 10 ? 10 : r, this.width = r + r % 2, this.xCorrection = e.offset;
  },
  _getMarkerGroup: function(e) {
    var t;
    return this._isReduction && this._isPositive ? t = e.reductionPositiveMarkersGroup : this._isReduction ? t = e.reductionMarkersGroup : this._isPositive ? t = e.defaultPositiveMarkersGroup : t = e.defaultMarkersGroup, t;
  },
  _drawMarker: function(e, t) {
    this._drawMarkerInGroup(this._getMarkerGroup(t), this._getStyle(), e);
  },
  _getSettingsForTracker: function() {
    var e = this.highY, t = this.lowY, r = this._options.rotated, n, i, s, l;
    return e === t && (e = r ? e + MC : e - MC, t = r ? t - MC : t + MC), r ? (n = sh(t, e), i = this.x - this.width / 2, s = ws(t - e), l = this.width) : (n = this.x - this.width / 2, i = sh(t, e), s = this.width, l = ws(t - e)), {
      x: n,
      y: i,
      width: s,
      height: l
    };
  },
  _getGraphicBBox: function(e) {
    var t = this._options.rotated, r = this.x, n = this.width, i = this.lowY, s = this.highY;
    if (e) {
      var l = this.series.getValueAxis().getVisibleArea();
      s = this._truncateCoord(s, l), i = this._truncateCoord(i, l);
    }
    var d = {
      x: t ? i : r - N4(n / 2),
      y: t ? r - N4(n / 2) : s,
      width: t ? s - i : n,
      height: t ? n : i - s
    };
    if (e) {
      var h = e === "top";
      this._options.rotated ? (d.x = h ? d.x + d.width : d.x, d.width = 0) : (d.y = h ? d.y : d.y + d.height, d.height = 0);
    }
    return d;
  },
  getTooltipParams: function(e) {
    if (this.graphic) {
      var t = sh(this.lowY, this.highY), r = DC(this.lowY, this.highY), n = this._getVisibleArea(), i = this._options.rotated, s = i ? n.minX : n.minY, l = i ? n.maxX : n.maxY, d = DC(s, t), h = sh(l, r), p = this.getCenterCoord();
      return e === "edge" && (p[i ? "x" : "y"] = i ? h : d), p.offset = 0, p;
    }
  },
  getCenterCoord() {
    if (this.graphic) {
      var e, t, r = sh(this.lowY, this.highY), n = DC(this.lowY, this.highY), i = this._getVisibleArea(), s = this._options.rotated, l = s ? i.minX : i.minY, d = s ? i.maxX : i.maxY, h = DC(l, r), p = sh(d, n), m = h + (p - h) / 2;
      return s ? (t = this.x, e = m) : (e = this.x, t = m), {
        x: e,
        y: t
      };
    }
  },
  hasValue: function() {
    return this.highValue !== null && this.lowValue !== null;
  },
  hasCoords: function() {
    return this.x !== null && this.lowY !== null && this.highY !== null;
  },
  _translate: function() {
    var e = this._options.rotated, t = this._getValTranslator(), r = this._getArgTranslator().translate(this.argument);
    this.vx = this.vy = this.x = r === null ? r : r + (this.xCorrection || 0), this.openY = this.openValue !== null ? t.translate(this.openValue) : null, this.highY = t.translate(this.highValue), this.lowY = t.translate(this.lowValue), this.closeY = this.closeValue !== null ? t.translate(this.closeValue) : null;
    var n = sh(this.lowY, this.highY) + ws(this.lowY - this.highY) / 2;
    this._calculateVisibility(e ? n : this.x, e ? this.x : n);
  },
  getCrosshairData: function(e, t) {
    var r = this._options.rotated, n = r ? e : t, i, s = this.argument, l, d = "low";
    return ws(this.lowY - n) < ws(this.closeY - n) ? i = this.lowY : (i = this.closeY, d = "close"), ws(i - n) >= ws(this.openY - n) && (i = this.openY, d = "open"), ws(i - n) >= ws(this.highY - n) && (i = this.highY, d = "high"), r ? l = {
      y: this.vy,
      x: i,
      xValue: this[d + "Value"],
      yValue: s
    } : l = {
      x: this.vx,
      y: i,
      xValue: s,
      yValue: this[d + "Value"]
    }, l.axis = this.series.axis, l;
  },
  _updateData: function(e) {
    var t = this._label, r = this._options.reduction.color;
    this.value = this.initialValue = e.reductionValue, this.originalValue = e.value, this.lowValue = this.originalLowValue = e.lowValue, this.highValue = this.originalHighValue = e.highValue, this.openValue = this.originalOpenValue = e.openValue, this.closeValue = this.originalCloseValue = e.closeValue, this._isPositive = e.openValue < e.closeValue, this._isReduction = e.isReduction, this._isReduction && t.setColor(r);
  },
  _updateMarker: function(e, t, r) {
    var n = this.graphic;
    n.attr({
      points: this._getPoints()
    }).smartAttr(t).sharp(), r && n.append(this._getMarkerGroup(r));
  },
  _getLabelFormatObject: function() {
    return {
      openValue: this.openValue,
      highValue: this.highValue,
      lowValue: this.lowValue,
      closeValue: this.closeValue,
      reductionValue: this.initialValue,
      argument: this.initialArgument,
      value: this.initialValue,
      seriesName: this.series.name,
      originalOpenValue: this.originalOpenValue,
      originalCloseValue: this.originalCloseValue,
      originalLowValue: this.originalLowValue,
      originalHighValue: this.originalHighValue,
      originalArgument: this.originalArgument,
      point: this
    };
  },
  _getFormatObject: function(e) {
    var t = e.formatValue(this.highValue), r = e.formatValue(this.openValue), n = e.formatValue(this.closeValue), i = e.formatValue(this.lowValue), s = Cn, l = s._getFormatObject.call(this, e);
    return W({}, l, {
      valueText: "h: " + t + (r !== "" ? " o: " + r : "") + (n !== "" ? " c: " + n : "") + " l: " + i,
      highValueText: t,
      openValueText: r,
      closeValueText: n,
      lowValueText: i
    });
  },
  getMaxValue: function() {
    return this.highValue;
  },
  getMinValue: function() {
    return this.lowValue;
  }
});
var mue = W, V4 = Sr;
const _ue = mue({}, a5, {
  _getPoints: function() {
    var e = this._options.rotated ? function(l, d) {
      return [d, l];
    } : function(l, d) {
      return [l, d];
    }, t = V4(this.openY), r = V4(this.closeY), n = this.x, i = this.width, s = [].concat(e(n, this.highY));
    return t && (s = s.concat(e(n, this.openY))), t && (s = s.concat(e(n - i / 2, this.openY))), t && (s = s.concat(e(n, this.openY))), r && (s = s.concat(e(n, this.closeY))), r && (s = s.concat(e(n + i / 2, this.closeY))), r && (s = s.concat(e(n, this.closeY))), s = s.concat(e(n, this.lowY)), s;
  },
  _drawMarkerInGroup: function(e, t, r) {
    this.graphic = r.path(this._getPoints(), "line").attr({
      "stroke-linecap": "square"
    }).attr(t).data({
      "chart-data-point": this
    }).sharp().append(e);
  },
  _getMinTrackerWidth: function() {
    var e = 2 + this._styles.normal["stroke-width"];
    return e + e % 2;
  }
});
var o5 = W, dE = Math, yue = dE.max, s5 = Is.radialLabelIndent, xue = 90, l5 = "canvas_position_start", u5 = "canvas_position_end", c5 = "canvas_position_default", fg = o5({}, Cn, {
  _getLabelCoords: wd._getLabelCoords,
  _getElementCoords: wd._getElementCoords,
  _moveLabelOnCanvas: function(e, t, r) {
    var n = e.x, i = e.y;
    return t.minX > n && (n = t.minX), t.maxX < n + r.width && (n = t.maxX - r.width), t.minY > i && (i = t.minY), t.maxY < i + r.height && (i = t.maxY - r.height), {
      x: n,
      y: i
    };
  },
  _getLabelPosition: function() {
    return "outside";
  },
  _getCoords: function(e, t) {
    var r = this.series.getValueAxis(), n = r.getAngles()[0], i = this._getArgTranslator().translate(e), s = this._getValTranslator().translate(t), l = CT(r.getCenter(), r.getAngles()[0], i, s);
    return l.angle = i + n - 90, l.radius = s, l;
  },
  _translate() {
    var e = this.series.getValueAxis().getCenter(), t = this._getCoords(this.argument, this.value), r = this._getValTranslator(), n = r.isInverted() ? r.translate(l5) : r.translate(u5), i = I(t.radius) && t.radius >= 0 ? t.radius : null;
    this.vx = Ll(t.angle), this.vy = this.radiusOuter = this.radiusLabels = i, this.radiusLabels += s5, this.radius = i, this.middleAngle = -t.angle, this.angle = -t.angle, this.x = t.x, this.y = t.y, this.defaultX = this.centerX = e.x, this.defaultY = this.centerY = e.y, this._translateErrorBars(), this.inVisibleArea = this._checkRadiusForVisibleArea(i, n);
  },
  _checkRadiusForVisibleArea: (e, t) => I(e) && e <= t,
  _translateErrorBars: function() {
    var e = this._options.errorBars, t = this._getValTranslator();
    e && (I(this.lowError) && (this._lowErrorCoord = this.centerY - t.translate(this.lowError)), I(this.highError) && (this._highErrorCoord = this.centerY - t.translate(this.highError)), this._errorBarPos = this.centerX, this._baseErrorBarPos = e.type === "stdDeviation" ? this._lowErrorCoord + (this._highErrorCoord - this._lowErrorCoord) / 2 : this.centerY - this.radius);
  },
  _getTranslates: function(e) {
    return e ? this.getDefaultCoords() : {
      x: this.x,
      y: this.y
    };
  },
  getDefaultCoords: function() {
    var e = ya(-this.angle), t = this._getValTranslator().translate(c5), r = this.defaultX + t * e.cos, n = this.defaultY + t * e.sin;
    return {
      x: r,
      y: n
    };
  },
  _addLabelAlignmentAndOffset: function(e, t) {
    return t;
  },
  _checkLabelPosition: function(e, t) {
    var r = this._getVisibleArea(), n = this._getGraphicBBox();
    return this._isPointInVisibleArea(r, n) && (t = this._moveLabelOnCanvas(t, r, e.getBoundingRect())), t;
  },
  _getErrorBarSettings: function(e, t) {
    var r = Cn._getErrorBarSettings.call(this, e, t);
    return r.rotate = xue - this.angle, r.rotateX = this.centerX, r.rotateY = this.centerY, r;
  },
  getCoords: function(e) {
    return e ? this.getDefaultCoords() : {
      x: this.x,
      y: this.y
    };
  }
}), bue = o5({}, Ay, {
  _translateErrorBars: fg._translateErrorBars,
  _getErrorBarSettings: fg._getErrorBarSettings,
  _moveLabelOnCanvas: fg._moveLabelOnCanvas,
  _getLabelCoords: wd._getLabelCoords,
  _getElementCoords: wd._getElementCoords,
  _getLabelConnector: wd._getLabelConnector,
  getTooltipParams: wd.getTooltipParams,
  _getLabelPosition: wd._getLabelPosition,
  _getCoords: fg._getCoords,
  _translate() {
    var e = this._getValTranslator(), t = e.getBusinessRange(), r = e.isInverted() ? e.translate(l5) : e.translate(u5);
    this.radiusInner = e.translate(this.minValue), fg._translate.call(this), this.radiusInner === null ? this.radiusInner = this.radius = r : this.radius === null ? this.radius = this.value >= t.minVisible ? r : 0 : this.radius > r && (this.radius = r), this.radiusOuter = this.radiusLabels = yue(this.radiusInner, this.radius), this.radiusLabels += s5, this.radiusInner = this.defaultRadius = dE.min(this.radiusInner, this.radius), this.middleAngle = this.angle = -Ll(this.middleAngleCorrection - this.angle);
  },
  _checkRadiusForVisibleArea(e) {
    return I(e) || this._getValTranslator().translate(this.minValue) > 0;
  },
  _getErrorBarBaseEdgeLength() {
    var e = this.getMarkerCoords();
    return dE.PI * e.outerRadius * dE.abs(e.startAngle - e.endAngle) / 180;
  },
  getMarkerCoords: function() {
    return {
      x: this.centerX,
      y: this.centerY,
      outerRadius: this.radiusOuter,
      innerRadius: this.defaultRadius,
      startAngle: this.middleAngle - this.interval / 2,
      endAngle: this.middleAngle + this.interval / 2
    };
  },
  _drawMarker: function(e, t, r) {
    var n = this._getStyle(), i = this.getMarkerCoords(), s = i.innerRadius, l = i.outerRadius, d = this._getCoords(this.argument, c5), h = i.x, p = i.y;
    r && (s = 0, l = 0, h = d.x, p = d.y), this.graphic = e.arc(h, p, s, l, i.startAngle, i.endAngle).attr(n).data({
      "chart-data-point": this
    }).append(t);
  },
  _checkLabelPosition: function(e, t) {
    var r = this._getVisibleArea(), n = ya(this.middleAngle), i = this.centerX + this.defaultRadius * n.cos, s = this.centerY - this.defaultRadius * n.sin;
    return i > r.minX && i < r.maxX && s > r.minY && s < r.maxY && (t = this._moveLabelOnCanvas(t, r, e.getBoundingRect())), t;
  },
  _addLabelAlignmentAndOffset: function(e, t) {
    return t;
  },
  correctCoordinates: function(e) {
    this.middleAngleCorrection = e.offset, this.interval = e.width;
  },
  coordsIn: function(e, t) {
    var r = DM(this.series.getValueAxis().getCenter(), e, t), n = this.getMarkerCoords(), i = n.startAngle < n.endAngle ? -r.phi >= n.startAngle && -r.phi <= n.endAngle : -r.phi <= n.startAngle && -r.phi >= n.endAngle;
    return r.r >= n.innerRadius && r.r <= n.outerRadius && i;
  }
}), Uo = {}, Sue = W, Yg = Is.states, pa = "symbolPoint", qk = "polarSymbolPoint", Kk = "barPoint", F4 = "polarBarPoint", Zk = "piePoint", Qk = Yg.selectedMark, Jk = Yg.hoverMark, d5 = Yg.normalMark, eR = Yg.hover, Cue = Yg.normal, LC = Yg.selection, B4 = {
  chart: {
    scatter: pa,
    line: pa,
    spline: pa,
    stepline: pa,
    stackedline: pa,
    fullstackedline: pa,
    stackedspline: pa,
    fullstackedspline: pa,
    stackedsplinearea: pa,
    fullstackedsplinearea: pa,
    area: pa,
    splinearea: pa,
    steparea: pa,
    stackedarea: pa,
    fullstackedarea: pa,
    rangearea: "rangeSymbolPoint",
    bar: Kk,
    stackedbar: Kk,
    fullstackedbar: Kk,
    rangebar: "rangeBarPoint",
    bubble: "bubblePoint",
    stock: "stockPoint",
    candlestick: "candlestickPoint"
  },
  pie: {
    pie: Zk,
    doughnut: Zk,
    donut: Zk
  },
  polar: {
    scatter: qk,
    line: qk,
    area: qk,
    bar: F4,
    stackedbar: F4
  }
};
function z4(e) {
  return Wt(e) === "none";
}
function YD(e, t, r) {
  this.fullState = d5, this.series = e, this.update(t, r), this._viewCounters = {
    hover: 0,
    selection: 0
  }, this._emptySettings = {
    fill: null,
    stroke: null,
    dashStyle: null,
    filter: null
  };
}
Uo.symbolPoint = Cn;
Uo.barPoint = Ay;
Uo.bubblePoint = oue;
Uo.piePoint = wd;
Uo.rangeSymbolPoint = Vn;
Uo.rangeBarPoint = gue;
Uo.candlestickPoint = a5;
Uo.stockPoint = _ue;
Uo.polarSymbolPoint = fg;
Uo.polarBarPoint = bue;
YD.prototype = {
  constructor: YD,
  getColor: function() {
    return !this.hasValue() && !this._styles.usePointCustomOptions && this.series.customizePoint(this, this._dataItem), this._styles.normal.fill || this.series.getColor();
  },
  _getStyle: function() {
    return this._styles[this._currentStyle || "normal"];
  },
  update: function(e, t) {
    this.updateOptions(t), this.updateData(e);
  },
  updateData: function(e) {
    var t = this.argument !== e.argument;
    this.argument = this.initialArgument = this.originalArgument = e.argument, this.tag = e.tag, this.index = e.index, this._dataItem = e, this.data = e.data, this.lowError = e.lowError, this.highError = e.highError, this.aggregationInfo = e.aggregationInfo, this._updateData(e, t), !this.hasValue() && this.setInvisibility(), this._fillStyle(), this._updateLabelData();
  },
  deleteMarker: function() {
    this.graphic && this.graphic.dispose(), this.graphic = null;
  },
  draw: function(e, t, r, n) {
    return (this._needDeletingOnDraw || this.series.autoHidePointMarkers && !this.isSelected()) && (this.deleteMarker(), this._needDeletingOnDraw = !1), this._needClearingOnDraw && (this.clearMarker(), this._needClearingOnDraw = !1), this._hasGraphic() ? this._updateMarker(r, this._getStyle(), t.markers) : this.getMarkerVisibility() && !this.series.autoHidePointMarkers && this._drawMarker(e, t.markers, r, n), this._drawLabel(), this._drawErrorBar(e, t.errorBars, r), this;
  },
  _getViewStyle: function() {
    var e = d5, t = this.fullState, r = [Cue, eR, LC, LC];
    return this._viewCounters.hover && (e |= Jk), this._viewCounters.selection && (e |= Qk), z4(this.getOptions().selectionMode) && (t &= ~Qk), z4(this.getOptions().hoverMode) && (t &= ~Jk), e |= t, r[e];
  },
  applyView: function(e) {
    var t = this._getViewStyle();
    this._currentStyle = t, !this.graphic && this.getMarkerVisibility() && this.series.autoHidePointMarkers && (t === LC || t === eR) && this._drawMarker(this.series.getRenderer(), this.series.getMarkersGroup()), this.graphic && (this.series.autoHidePointMarkers && t !== LC && t !== eR ? this.deleteMarker() : (t === "normal" ? this.clearMarker() : this.graphic.toForeground(), this._updateMarker(!0, this._styles[t], void 0, e)));
  },
  setView: function(e) {
    this._viewCounters[e]++, this.applyView();
  },
  resetView: function(e) {
    var t = this._viewCounters;
    --t[e], t[e] < 0 && (t[e] = 0), this.applyView();
  },
  releaseHoverState: function() {
    this.graphic && !this.isSelected() && this.graphic.toBackground();
  },
  select: function() {
    this.series.selectPoint(this);
  },
  clearSelection: function() {
    this.series.deselectPoint(this);
  },
  hover: function() {
    this.series.hoverPoint(this);
  },
  clearHover: function() {
    this.series.clearPointHover();
  },
  showTooltip: function() {
    this.series.showPointTooltip(this);
  },
  hideTooltip: function() {
    this.series.hidePointTooltip(this);
  },
  _checkLabelsChanging: function(e, t) {
    var r = ~t.indexOf("range"), n = ~e.indexOf("range");
    return n && !r || !n && r;
  },
  updateOptions: function(e) {
    if (e) {
      var t = this._options, r = e.widgetType, n = t && t.type, i = e.type, s = B4[r][i];
      n !== i ? (this._needDeletingOnDraw = !0, this._needClearingOnDraw = !1, n && (this._checkLabelsChanging(n, i) && this.deleteLabel(), this._resetType(Uo[B4[n]])), this._setType(Uo[s])) : (this._needDeletingOnDraw = this._checkSymbol(t, e), this._needClearingOnDraw = this._checkCustomize(t, e)), this._options = e, this._fillStyle(), this._updateLabelOptions(s);
    }
  },
  translate: function() {
    this.hasValue() && (this._translate(), this.translated = !0);
  },
  _checkCustomize: function(e, t) {
    return e.styles.usePointCustomOptions && !t.styles.usePointCustomOptions;
  },
  _getCustomLabelVisibility: function() {
    return this._styles.useLabelCustomOptions ? !!this._options.label.visible : null;
  },
  getBoundingRect: function() {
    return this._getGraphicBBox();
  },
  _resetType: function(e) {
    for (var t in e)
      delete this[t];
  },
  _setType: function(e) {
    for (var t in e)
      this[t] = e[t];
  },
  isInVisibleArea: function() {
    return this.inVisibleArea;
  },
  isSelected: function() {
    return !!(this.fullState & Qk);
  },
  isHovered: function() {
    return !!(this.fullState & Jk);
  },
  getOptions: function() {
    return this._options;
  },
  animate: function(e, t, r) {
    if (!this.graphic) {
      e && e();
      return;
    }
    this.graphic.animate(t, {
      partitionDuration: r
    }, e);
  },
  getCoords: function(e) {
    return e ? this._options.rotated ? {
      x: this.minX - (this.x - this.minX ? 0 : 1),
      y: this.y
    } : {
      x: this.x,
      y: this.minY + (this.y - this.minY ? 0 : 1)
    } : {
      x: this.x,
      y: this.y
    };
  },
  getDefaultCoords: function() {
    return this._options.rotated ? {
      x: this.defaultX,
      y: this.y
    } : {
      x: this.x,
      y: this.defaultY
    };
  },
  setDefaultCoords() {
    var e = this.getDefaultCoords();
    this.x = e.x, this.y = e.y;
  },
  _getVisibleArea: function() {
    return this.series.getVisibleArea();
  },
  _getArgTranslator: function() {
    return this.series.getArgumentAxis().getTranslator();
  },
  _getValTranslator: function() {
    return this.series.getValueAxis().getTranslator();
  },
  isArgumentCorrect() {
    return this.series._argumentChecker(this.argument);
  },
  isValueCorrect() {
    var e = this.series._valueChecker;
    return e(this.getMinValue()) && e(this.getMaxValue());
  },
  hasValue: function() {
    return this.value !== null && this.minValue !== null && this.isArgumentCorrect() && this.isValueCorrect();
  },
  hasCoords: Y,
  correctPosition: Y,
  correctRadius: Y,
  correctLabelRadius: Y,
  getCrosshairData: Y,
  getPointRadius: Y,
  _populatePointShape: Y,
  _checkSymbol: Y,
  getMarkerCoords: Y,
  hide: Y,
  show: Y,
  hideMarker: Y,
  setInvisibility: Y,
  clearVisibility: Y,
  isVisible: Y,
  resetCorrection: Y,
  correctValue: Y,
  resetValue: Y,
  setPercentValue: Y,
  correctCoordinates: Y,
  coordsIn: Y,
  getTooltipParams: Y,
  applyWordWrap: Y,
  setLabelTrackerData: Y,
  updateLabelCoord: Y,
  drawLabel: Y,
  correctLabelPosition: Y,
  getMinValue: Y,
  getMaxValue: Y,
  _drawErrorBar: Y,
  getMarkerVisibility: Y,
  dispose: function() {
    this.deleteMarker(), this.deleteLabel(), this._errorBar && this._errorBar.dispose(), this._options = this._styles = this.series = this._errorBar = null;
  },
  getTooltipFormatObject: function(e, t) {
    var r = this._getFormatObject(e), n = [], i = [];
    t && (t.forEach((h) => {
      if (h.isVisible()) {
        var p = h._getFormatObject(e);
        i.push(p), n.push(p.seriesName + ": " + p.valueText);
      }
    }), Sue(r, {
      points: i,
      valueText: n.join(`
`),
      stackName: this.series.getStackName() || null
    }));
    var s = this.aggregationInfo;
    if (s) {
      var l = this.series.getArgumentAxis(), d = l.formatRange(s.intervalStart, s.intervalEnd, s.aggregationInterval, e.getOptions().argumentFormat);
      d && (r.valueText += `
`.concat(d));
    }
    return r;
  },
  setHole: function(e, t) {
    var r = isFinite(this.minValue) ? this.minValue : 0;
    I(e) && (t === "left" ? (this.leftHole = this.value - e, this.minLeftHole = r - e) : (this.rightHole = this.value - e, this.minRightHole = r - e));
  },
  resetHoles: function() {
    this.leftHole = null, this.minLeftHole = null, this.rightHole = null, this.minRightHole = null;
  },
  getLabel: function() {
    return this._label;
  },
  getLabels: function() {
    return [this._label];
  },
  getCenterCoord() {
    return {
      x: this.x,
      y: this.y
    };
  }
};
var BL = Math, H4 = BL.abs, G4 = BL.sqrt, Eue = BL.max, Tue = 12, wue = 400, iT = "highError", aT = "lowError", f5 = "variance", h5 = "stddeviation", v5 = "stderror", p5 = "percent", g5 = "fixed", Aue = "undefined", Oue = "discrete", kue = "logarithmic", Rue = "datetime", cn = {}, $T = {};
function fE(e) {
  var t = 0;
  return be(e, function(r, n) {
    t += n;
  }), t;
}
function Due(e) {
  return [g5, p5, f5, h5, v5].includes(e);
}
function tR(e, t) {
  return fE(ti(e, function(r) {
    return (r - t) * (r - t);
  })) / e.length;
}
function Mue(e, t, r) {
  var n = r.getOptions().valueErrorBar, i = r.getValueFields()[0], s = n.lowValueField || aT, l = n.highValueField || iT;
  if (r.areErrorBarsVisible() && n.type === void 0) {
    var d = t.reduce(function(h, p) {
      return I(p[s]) && (h[0] += p[i] - p[s], h[1]++), I(p[l]) && (h[2] += p[l] - p[i], h[3]++), h;
    }, [0, 0, 0, 0]);
    d[1] && (e[s] = e[i] - d[0] / d[1]), d[2] && (e[l] = e[i] + d[2] / d[3]);
  }
  return e;
}
function Lue(e, t, r) {
  var n = r.getOptions().valueErrorBar, i = n.lowValueField || aT, s = n.highValueField || iT;
  return r.areErrorBarsVisible() && n.type === void 0 && (e[i] = 0, e[s] = 0, e = t.reduce(function(l, d) {
    return l[i] += d[i], l[s] += d[s], l;
  }, e)), e;
}
function U4(e) {
  return (t, r) => {
    var {
      intervalStart: n,
      intervalEnd: i,
      data: s
    } = t, l = r.getValueFields()[0], d = s[0];
    return d = s.reduce((h, p) => {
      var m = p[l];
      return h[l] === null && (h = p), m !== null && e(m, h[l]) ? p : h;
    }, d), W({}, d, {
      [r.getArgumentField()]: r._getIntervalCenter(n, i)
    });
  };
}
function Pue(e, t, r) {
  var n = !0;
  for (var i in t) {
    var s = i === "argument";
    if (s || i === "size" ? !I(e[i]) : e[i] === void 0) {
      var l = t[i];
      s || (r[l] = (r[l] || 0) + 1), n = !1;
    }
  }
  return n;
}
var m5 = {
  _defaultDuration: wue,
  _defaultTrackerWidth: Tue,
  _applyStyle: Y,
  _updateOptions: Y,
  _parseStyle: Y,
  _prepareSegment: Y,
  _drawSegment: Y,
  _appendInGroup: function() {
    this._group.append(this._extGroups.seriesGroup);
  },
  _createLegendState: function(e, t) {
    return {
      fill: xa(e.color, !0) || t,
      hatching: e.hatching ? W({}, e.hatching, {
        direction: "right"
      }) : void 0
    };
  },
  _getColorId: Y,
  _applyElementsClipRect: function(e) {
    e["clip-path"] = this._paneClipRectID;
  },
  _applyMarkerClipRect: function(e) {
    e["clip-path"] = this._forceClipping ? this._paneClipRectID : null;
  },
  _createGroup: function(e, t, r, n) {
    var i = t[e] = t[e] || this._renderer.g();
    r && i.append(r), n && i.attr(n);
  },
  _applyClearingSettings: function(e) {
    e.opacity = null, e.scale = null, this._options.rotated ? e.translateX = null : e.translateY = null;
  },
  _createGroups: function() {
    this._createGroup("_markersGroup", this, this._group), this._createGroup("_labelsGroup", this);
  },
  _setMarkerGroupSettings: function() {
    var e = this._createPointStyles(this._getMarkerGroupOptions()).normal;
    e.class = "dxc-markers", e.opacity = 1, this._applyMarkerClipRect(e), this._markersGroup.attr(e);
  },
  getVisibleArea: function() {
    return this._visibleArea;
  },
  areErrorBarsVisible: function() {
    var e = this._options.valueErrorBar;
    return e && this._errorBarsEnabled() && e.displayMode !== "none" && (Due(Wt(e.type)) || I(e.lowValueField) || I(e.highValueField));
  },
  groupPointsByCoords(e) {
    var t = [];
    return be(this.getVisiblePoints(), function(r, n) {
      var i = parseInt(e ? n.vy : n.vx);
      t[i] ? Array.isArray(t[i]) ? t[i].push(n) : t[i] = [t[i], n] : t[i] = n;
    }), t;
  },
  _createErrorBarGroup: function(e) {
    var t = this._options.valueErrorBar, r;
    this.areErrorBarsVisible() && (r = {
      class: "dxc-error-bars",
      stroke: t.color,
      "stroke-width": t.lineWidth,
      opacity: e ? 1e-3 : t.opacity || 1,
      "stroke-linecap": "square",
      sharp: !0,
      "clip-path": this._forceClipping ? this._paneClipRectID : this._widePaneClipRectID
    }, this._createGroup("_errorBarGroup", this, this._group, r));
  },
  _setGroupsSettings: function(e) {
    this._setMarkerGroupSettings(), this._setLabelGroupSettings(e), this._createErrorBarGroup(e);
  },
  _getCreatingPointOptions: function() {
    var e, t = this._predefinedPointOptions, r;
    return t || (e = this._getPointOptions(), this._predefinedPointOptions = t = W(!0, {
      styles: {}
    }, e), r = e.styles && e.styles.normal || {}, t.styles = t.styles || {}, t.styles.normal = {
      "stroke-width": r["stroke-width"],
      r: r.r,
      opacity: r.opacity
    }), t;
  },
  _getPointOptions: function() {
    return this._parsePointOptions(this._preparePointOptions(), this._options.label);
  },
  _getOptionsForPoint: function() {
    return this._options.point;
  },
  _parsePointStyle: function(e, t, r, n) {
    var i = e.border || {}, s = e.size !== void 0 ? e.size : n;
    return {
      fill: xa(e.color, !0) || t,
      stroke: i.color || r,
      "stroke-width": i.visible ? i.width : 0,
      r: s / 2 + (i.visible && s !== 0 && ~~(i.width / 2) || 0)
    };
  },
  _createPointStyles: function(e) {
    var t = xa(e.color, !0) || this._options.mainSeriesColor, r = this._options.containerBackgroundColor, n = this._parsePointStyle(e, t, t);
    return n.visibility = e.visible ? "visible" : "hidden", {
      labelColor: t,
      normal: n,
      hover: this._parsePointStyle(e.hoverStyle, r, t, e.size),
      selection: this._parsePointStyle(e.selectionStyle, r, t, e.size)
    };
  },
  _checkData: function(e, t, r) {
    return r = r || {
      value: this.getValueFields()[0]
    }, r.argument = this.getArgumentField(), Pue(e, r, t || {}) && e.value === e.value;
  },
  getArgumentRangeInitialValue() {
    var e = this.getPoints();
    if (this.useAggregation() && e.length) {
      var t, r;
      return {
        min: (t = e[0].aggregationInfo) === null || t === void 0 ? void 0 : t.intervalStart,
        max: (r = e[e.length - 1].aggregationInfo) === null || r === void 0 ? void 0 : r.intervalEnd
      };
    }
  },
  getValueRangeInitialValue: function() {
  },
  _getRangeData: function() {
    return Nd.getRangeData(this);
  },
  _getPointDataSelector: function() {
    var e = this.getValueFields()[0], t = this.getArgumentField(), r = this.getTagField(), n = this.areErrorBarsVisible(), i, s;
    if (n) {
      var l = this._options.valueErrorBar;
      i = l.lowValueField || aT, s = l.highValueField || iT;
    }
    return (d) => {
      var h = {
        value: this._processEmptyValue(d[e]),
        argument: d[t],
        tag: d[r],
        data: d
      };
      return n && (h.lowError = d[i], h.highError = d[s]), h;
    };
  },
  _errorBarsEnabled: function() {
    return this.valueAxisType !== Oue && this.valueAxisType !== kue && this.valueType !== Rue;
  },
  _drawPoint: function(e) {
    var t = e.point;
    t.isInVisibleArea() ? (t.clearVisibility(), t.draw(this._renderer, e.groups, e.hasAnimation, e.firstDrawing), this._drawnPoints.push(t)) : t.setInvisibility();
  },
  _animateComplete: function() {
    var e = {
      duration: this._defaultDuration
    };
    this._labelsGroup && this._labelsGroup.animate({
      opacity: 1
    }, e), this._errorBarGroup && this._errorBarGroup.animate({
      opacity: this._options.valueErrorBar.opacity || 1
    }, e);
  },
  _animate: function() {
    var e = this, t = e._drawnPoints.length - 1;
    be(e._drawnPoints || [], function(r, n) {
      n.animate(r === t ? function() {
        e._animateComplete();
      } : void 0, {
        translateX: n.x,
        translateY: n.y
      });
    });
  },
  _getIntervalCenter(e, t) {
    var r = this.getArgumentAxis(), n = r.getOptions();
    return r.aggregatedPointBetweenTicks() ? e : n.type !== "discrete" ? r.getVisualRangeCenter({
      minVisible: e,
      maxVisible: t
    }, !0) : e;
  },
  _defaultAggregator: "avg",
  _aggregators: {
    avg(e, t) {
      var {
        data: r,
        intervalStart: n,
        intervalEnd: i
      } = e;
      if (r.length) {
        var s = t.getValueFields()[0], l = r.reduce((d, h) => {
          var p = h[s];
          return I(p) ? (d[0] += p, d[1]++) : p === null && d[2]++, d;
        }, [0, 0, 0]);
        return Mue({
          [s]: l[2] === r.length ? null : l[0] / l[1],
          [t.getArgumentField()]: t._getIntervalCenter(n, i)
        }, r, t);
      }
    },
    sum(e, t) {
      var {
        intervalStart: r,
        intervalEnd: n,
        data: i
      } = e;
      if (i.length) {
        var s = t.getValueFields()[0], l = i.reduce((h, p) => {
          var m = p[s];
          return m !== void 0 && (h[0] += m), m === null ? h[1]++ : m === void 0 && h[2]++, h;
        }, [0, 0, 0]), d = l[0];
        if (l[1] === i.length && (d = null), l[2] !== i.length)
          return Lue({
            [s]: d,
            [t.getArgumentField()]: t._getIntervalCenter(r, n)
          }, i, t);
      }
    },
    count(e, t) {
      var {
        data: r,
        intervalStart: n,
        intervalEnd: i
      } = e, s = t.getValueFields()[0];
      return {
        [t.getArgumentField()]: t._getIntervalCenter(n, i),
        [s]: r.filter((l) => l[s] !== void 0).length
      };
    },
    min: U4((e, t) => e < t),
    max: U4((e, t) => e > t)
  },
  _endUpdateData: function() {
    delete this._predefinedPointOptions;
  },
  getArgumentField: function() {
    return this._options.argumentField || "arg";
  },
  getValueFields: function() {
    var e = this._options, t = e.valueErrorBar, r = [e.valueField || "val"], n, i;
    return t && (n = t.lowValueField, i = t.highValueField, lr(n) && r.push(n), lr(i) && r.push(i)), r;
  },
  _calculateErrorBars: function(e) {
    if (this.areErrorBarsVisible()) {
      var t = this._options, r = t.valueErrorBar, n = Wt(r.type), i = parseFloat(r.value), s = this.getValueFields()[0], l, d = r.lowValueField || aT, h = r.highValueField || iT, p, m, x, S, T = function(k, O) {
        l = O.value, O.lowError = l - i, O.highError = l + i;
      };
      switch (n) {
        case g5:
          S = T;
          break;
        case p5:
          S = function(k, O) {
            l = O.value;
            var D = l * i / 100;
            O.lowError = l - D, O.highError = l + D;
          };
          break;
        case Aue:
          S = function(k, O) {
            O.lowError = O.data[d], O.highError = O.data[h];
          };
          break;
        default:
          switch (p = ti(e, function(k) {
            return I(k.data[s]) ? k.data[s] : null;
          }), m = p.length, i = i || 1, n) {
            case f5:
              i = tR(p, fE(p) / m) * i, S = T;
              break;
            case h5:
              x = fE(p) / m, i = G4(tR(p, x)) * i, S = function(k, O) {
                O.lowError = x - i, O.highError = x + i;
              };
              break;
            case v5:
              i = G4(tR(p, fE(p) / m) / m) * i, S = T;
          }
      }
      S && be(e, S);
    }
  },
  _patchMarginOptions: function(e) {
    var t = this._getCreatingPointOptions(), r = t.styles, n = [r.normal, r.hover, r.selection].reduce(function(i, s) {
      return Eue(i, 2 * s.r + s["stroke-width"]);
    }, 0);
    return e.size = t.visible ? n : 0, e.sizePointNormalState = t.visible ? 2 * r.normal.r + r.normal["stroke-width"] : 2, e;
  },
  usePointsToDefineAutoHiding: () => !0
};
cn = W({}, m5, {
  drawTrackers: function() {
    var e = this, t, r, n = e._segments || [], i = e._options.rotated;
    e.isVisible() && (n.length && (t = e._trackers = e._trackers || [], r = e._trackersGroup = (e._trackersGroup || e._renderer.g().attr({
      fill: "gray",
      opacity: 1e-3,
      stroke: "gray",
      class: "dxc-trackers"
    })).attr({
      "clip-path": this._paneClipRectID || null
    }).append(e._group), be(n, function(s, l) {
      t[s] ? e._updateTrackerElement(l, t[s]) : t[s] = e._drawTrackerElement(l).data({
        "chart-data-series": e
      }).append(r);
    })), e._trackersTranslator = e.groupPointsByCoords(i));
  },
  _checkAxisVisibleAreaCoord(e, t) {
    var r = e ? this.getArgumentAxis() : this.getValueAxis(), n = r.getVisibleArea();
    return I(t) && n[0] <= t && n[1] >= t;
  },
  checkSeriesViewportCoord(e, t) {
    return this.getPoints().length && this.isVisible();
  },
  getSeriesPairCoord(e, t) {
    for (var r = null, n = !t && !this._options.rotated || t && this._options.rotated, i = n ? "vy" : "vx", s = n ? "vx" : "vy", l = this.getVisiblePoints(), d = 0; d < l.length; d++) {
      var h = l[d], p = h[i] === e ? h[s] : void 0;
      if (this._checkAxisVisibleAreaCoord(!t, p)) {
        r = p;
        break;
      }
    }
    return r;
  },
  _getNearestPoints: (e, t) => [e, t],
  _getBezierPoints: () => [],
  _getNearestPointsByCoord(e, t) {
    var r = this, n = r.getOptions().rotated, i = !t && !n || t && n, s = i ? "vy" : "vx", l = r.getPoints(), d = r._getBezierPoints(), h = [];
    return l.length > 1 ? l.forEach((p, m) => {
      var x = l[m + 1];
      x && (p[s] <= e && x[s] >= e || p[s] >= e && x[s] <= e) && h.push(r._getNearestPoints(p, x, d));
    }) : h.push([l[0], l[0]]), h;
  },
  getNeighborPoint: function(e, t) {
    var r = this._options.rotated ? t : e, n = r, i = this._trackersTranslator, s = null, l, d = this._options.rotated ? e : t, h = this._options.rotated ? "vx" : "vy";
    if (this.isVisible() && i) {
      s = i[r];
      do
        s = i[n] || i[r], r--, n++;
      while ((r >= 0 || n < i.length) && !s);
      Array.isArray(s) && (l = H4(s[0][h] - d), be(s, function(p, m) {
        var x = H4(m[h] - d);
        l >= x && (l = x, s = m);
      }));
    }
    return s;
  },
  _applyVisibleArea: function() {
    var e = this._options.rotated, t = (e ? this.getValueAxis() : this.getArgumentAxis()).getVisibleArea(), r = (e ? this.getArgumentAxis() : this.getValueAxis()).getVisibleArea();
    this._visibleArea = {
      minX: t[0],
      maxX: t[1],
      minY: r[0],
      maxY: r[1]
    };
  },
  getPointCenterByArg(e) {
    var t = this.getPointsByArg(e)[0];
    return t ? t.getCenterCoord() : void 0;
  }
});
$T = W({}, m5, {
  drawTrackers: function() {
    cn.drawTrackers.call(this);
    var e = this._trackersTranslator, t;
    this.isVisible() && (be(e, function(r, n) {
      if (n)
        return t = r, !1;
    }), e[t + 360] = e[t]);
  },
  getNeighborPoint: function(e, t) {
    var r = DM(this.getValueAxis().getCenter(), e, t);
    return cn.getNeighborPoint.call(this, r.phi, r.r);
  },
  _applyVisibleArea: function() {
    var e = this.getValueAxis().getCanvas();
    this._visibleArea = {
      minX: e.left,
      maxX: e.width - e.right,
      minY: e.top,
      maxY: e.height - e.bottom
    };
  },
  getSeriesPairCoord(e, t) {
    for (var r = null, n = t ? "argument" : "radius", i = this.getVisiblePoints(), s = 0; s < i.length; s++) {
      var l = i[s], d = I(l[n]) && I(e[n]) && l[n].valueOf() === e[n].valueOf() ? {
        x: l.x,
        y: l.y
      } : void 0;
      if (I(d)) {
        r = d;
        break;
      }
    }
    return r;
  }
});
var PC = "discrete", {
  round: j4,
  sqrt: rR,
  pow: I_,
  min: $4,
  max: Y4,
  abs: Iue
} = Math, Fn = {}, YT = {};
function Og(e, t, r, n) {
  var i = Vg(e);
  return i.x = t, i.y = r, i.angle = n, i;
}
function nR(e, t, r, n, i) {
  var s = e.angle + i, l = ya(s), d = r.x + (e.radius + n * i) * l.cos, h = r.y - (e.radius + n * i) * l.sin;
  return Og(t, d, h, s);
}
function Nue(e, t, r, n, i) {
  var s = t - e, l = 3 * r - 3 * t, d = 3 * n - 6 * r + 3 * t, h = i - 3 * n + 3 * r - t;
  return Yq(h, d, l, s);
}
var _5 = {
  autoHidePointMarkersEnabled: () => !0,
  _applyGroupSettings: function(e, t, r) {
    t = W(t, e), this._applyElementsClipRect(t), r.attr(t);
  },
  _setGroupsSettings: function(e) {
    var t = this._styles.normal;
    this._applyGroupSettings(t.elements, {
      class: "dxc-elements"
    }, this._elementsGroup), this._bordersGroup && this._applyGroupSettings(t.border, {
      class: "dxc-borders"
    }, this._bordersGroup), cn._setGroupsSettings.call(this, e), e && this._markersGroup && this._markersGroup.attr({
      opacity: 1e-3
    });
  },
  _createGroups: function() {
    this._createGroup("_elementsGroup", this, this._group), this._areBordersVisible() && this._createGroup("_bordersGroup", this, this._group), cn._createGroups.call(this);
  },
  _areBordersVisible: function() {
    return !1;
  },
  _getDefaultSegment: function(e) {
    return {
      line: ti(e.line || [], function(t) {
        return t.getDefaultCoords();
      })
    };
  },
  _prepareSegment: function(e) {
    return {
      line: e
    };
  },
  _parseLineOptions: function(e, t) {
    return {
      stroke: xa(e.color, !0) || t,
      "stroke-width": e.width,
      dashStyle: e.dashStyle || "solid"
    };
  },
  _parseStyle: function(e, t) {
    return {
      elements: this._parseLineOptions(e, t)
    };
  },
  _applyStyle: function(e) {
    this._elementsGroup && this._elementsGroup.attr(e.elements), be(this._graphics || [], function(t, r) {
      r.line && r.line.attr({
        "stroke-width": e.elements["stroke-width"]
      }).sharp();
    });
  },
  _drawElement: function(e, t) {
    return {
      line: this._createMainElement(e.line, {
        "stroke-width": this._styles.normal.elements["stroke-width"]
      }).append(t)
    };
  },
  _removeElement: function(e) {
    e.line.remove();
  },
  _updateElement: function(e, t, r, n) {
    var i = {
      points: t.line
    }, s = e.line;
    r ? s.animate(i, {}, n) : s.attr(i);
  },
  _animateComplete: function() {
    cn._animateComplete.call(this), this._markersGroup && this._markersGroup.animate({
      opacity: 1
    }, {
      duration: this._defaultDuration
    });
  },
  _animate: function() {
    var e = this, t = e._graphics.length - 1;
    be(e._graphics || [], function(r, n) {
      var i;
      r === t && (i = function() {
        e._animateComplete();
      }), e._updateElement(n, e._segments[r], !0, i);
    });
  },
  _drawPoint: function(e) {
    cn._drawPoint.call(this, {
      point: e.point,
      groups: e.groups
    });
  },
  _createMainElement: function(e, t) {
    return this._renderer.path(e, "line").attr(t);
  },
  _sortPoints: function(e, t) {
    return t ? e.sort(function(r, n) {
      return n.y - r.y;
    }) : e.sort(function(r, n) {
      return r.x - n.x;
    });
  },
  _drawSegment: function(e, t, r, n) {
    var i = this._options.rotated, s = this._prepareSegment(e, i, n);
    this._segments.push(s), this._graphics[r] ? t || this._updateElement(this._graphics[r], s) : this._graphics[r] = this._drawElement(t ? this._getDefaultSegment(s) : s, this._elementsGroup);
  },
  _getTrackerSettings: function() {
    var e = this._defaultTrackerWidth, t = this._styles.normal.elements["stroke-width"];
    return {
      "stroke-width": t > e ? t : e,
      fill: "none"
    };
  },
  _getMainPointsFromSegment: function(e) {
    return e.line;
  },
  _drawTrackerElement: function(e) {
    return this._createMainElement(this._getMainPointsFromSegment(e), this._getTrackerSettings(e));
  },
  _updateTrackerElement: function(e, t) {
    var r = this._getTrackerSettings(e);
    r.points = this._getMainPointsFromSegment(e), t.attr(r);
  },
  checkSeriesViewportCoord(e, t) {
    if (!cn.checkSeriesViewportCoord.call(this))
      return !1;
    var r = e.isArgumentAxis ? this.getArgumentRange() : this.getViewport(), n = e.getTranslator().translate(r.categories ? r.categories[0] : r.min), i = e.getTranslator().translate(r.categories ? r.categories[r.categories.length - 1] : r.max), s = this.getOptions().rotated, l = e.getOptions().inverted;
    return e.isArgumentAxis && (!s && !l || s && l) || !e.isArgumentAxis && (s && !l || !s && l) ? t >= n && t <= i : t >= i && t <= n;
  }
}, Oy = Fn.line = W({}, cn, _5, {
  getPointCenterByArg(e) {
    var t = this.getArgumentAxis().getTranslator().translate(e);
    return {
      x: t,
      y: t
    };
  },
  getSeriesPairCoord(e, t) {
    for (var r = null, n = this._getNearestPointsByCoord(e, t), i = t && !this._options.rotated || !t && this._options.rotated, s = 0; s < n.length; s++) {
      var l = n[s], d = (l[1].vy - l[0].vy) / (l[1].vx - l[0].vx), h = l[0].vy - l[0].vx * d, p = void 0;
      if (l[1].vx - l[0].vx === 0 ? p = i ? l[0].vy : l[0].vx : p = i ? d * e + h : (e - h) / d, this._checkAxisVisibleAreaCoord(!t, p)) {
        r = p;
        break;
      }
    }
    return r;
  }
});
Fn.stepline = W({}, Oy, {
  _calculateStepLinePoints(e) {
    var t = [], r = this._options.rotated ? "x" : "y";
    return be(e, function(n, i) {
      var s;
      if (!n) {
        t.push(i);
        return;
      }
      var l = t[t.length - 1][r];
      l !== i[r] && (s = Vg(i), s[r] = l, t.push(s)), t.push(i);
    }), t;
  },
  _prepareSegment: function(e) {
    return Oy._prepareSegment(this._calculateStepLinePoints(e));
  },
  getSeriesPairCoord(e, t) {
    for (var r, n = this._options.rotated, i = !t && !n || t && n, s = i ? "vy" : "vx", l = i ? "vx" : "vy", d = this._getNearestPointsByCoord(e, t), h = 0; h < d.length; h++) {
      var p = d[h], m = void 0;
      if (t ? m = e !== p[1][s] ? p[0][l] : p[1][l] : m = e === p[0][s] ? p[0][l] : p[1][l], this._checkAxisVisibleAreaCoord(!t, m)) {
        r = m;
        break;
      }
    }
    return r;
  }
});
Fn.spline = W({}, Oy, {
  _calculateBezierPoints: function(e, t) {
    var r = [], n = e, i = function(s, l, d) {
      return s > l && d > s || s < l && d < s ? s : d;
    };
    return n.length !== 1 ? n.forEach(function(s, l) {
      var d, h, p, m, x = n[l - 1], S = n[l + 1], T, k, O, D, L, F, z, V, P, j;
      if (!l || l === n.length - 1) {
        r.push(s, s);
        return;
      }
      var Z = s.x, ee = s.y;
      T = x.x, k = S.x, O = x.y, D = S.y;
      var J = !!(!t && (ee <= x.y && ee <= S.y || ee >= x.y && ee >= S.y) || t && (Z <= x.x && Z <= S.x || Z >= x.x && Z >= S.x));
      if (J)
        t ? (p = d = Z, m = (ee + S.y) / 2, h = (ee + x.y) / 2) : (m = h = ee, p = (Z + S.x) / 2, d = (Z + x.x) / 2);
      else {
        if (L = D - O, F = T - k, z = O * k - T * D, t) {
          if (!L) {
            r.push(s, s, s);
            return;
          }
          P = ee, V = -1 * (F * P + z) / L, j = V - Z, T -= j, k -= j;
        } else {
          if (!F) {
            r.push(s, s, s);
            return;
          }
          V = Z, P = -1 * (L * V + z) / F, j = P - ee, O -= j, D -= j;
        }
        p = (Z + 0.5 * k) / 1.5, m = (ee + 0.5 * D) / 1.5, d = (Z + 0.5 * T) / 1.5, h = (ee + 0.5 * O) / 1.5;
      }
      t ? (d = i(x.x, Z, d), p = i(S.x, Z, p)) : (h = i(x.y, ee, h), m = i(S.y, ee, m));
      var he = Og(s, d, h), de = Og(s, p, m);
      r.push(he, s, de);
    }) : r.push(n[0]), r;
  },
  _prepareSegment: function(e, t) {
    return Oy._prepareSegment(this._calculateBezierPoints(e, t));
  },
  _createMainElement: function(e, t) {
    return this._renderer.path(e, "bezier").attr(t);
  },
  getSeriesPairCoord(e, t) {
    for (var r = null, n = !t && !this._options.rotated || t && this._options.rotated, i = n ? "vy" : "vx", s = n ? "y" : "x", l = n ? "vx" : "vy", d = n ? "x" : "y", h = t ? this.getValueAxis() : this.getArgumentAxis(), p = h.getVisibleArea(), m = this._getNearestPointsByCoord(e, t), x = function() {
      var T = m[S];
      if (T.length === 1)
        p[0] <= T[0][l] && p[1] >= T[0][l] && (r = T[0][l]);
      else {
        var k = Nue(e, T[0][i], T[1][s], T[2][s], T[3][i]);
        k.forEach((O) => {
          if (O >= 0 && O <= 1) {
            var D = Math.pow(1 - O, 3) * T[0][l] + 3 * Math.pow(1 - O, 2) * O * T[1][d] + 3 * (1 - O) * O * O * T[2][d] + O * O * O * T[3][l];
            p[0] <= D && p[1] >= D && (r = D);
          }
        });
      }
      if (r !== null)
        return 1;
    }, S = 0; S < m.length && !x(); S++)
      ;
    return r;
  },
  _getNearestPoints(e, t, r) {
    var n = r.indexOf(e);
    return [e, r[n + 1], r[n + 2], t];
  },
  _getBezierPoints() {
    return this._segments.length > 0 ? this._segments.reduce((e, t) => e.concat(t.line), []) : [];
  }
});
YT.line = W({}, $T, _5, {
  _sortPoints: function(e) {
    return e;
  },
  _prepareSegment: function(e, t, r) {
    var n = [], i = this.getValueAxis().getCenter(), s;
    if (r && this._closeSegment(e), this.argumentAxisType !== PC && this.valueAxisType !== PC) {
      for (s = 1; s < e.length; s++)
        n = n.concat(this._getTangentPoints(e[s], e[s - 1], i, s === e.length - 1));
      n.length || (n = e);
    } else
      return Oy._prepareSegment.call(this, e);
    return {
      line: n
    };
  },
  _getRemainingAngle: function(e) {
    var t = Ll(e);
    return e >= 0 ? 360 - t : -t;
  },
  _closeSegment(e) {
    var t = this._segments.length ? this._segments[0].line[0] : e[0], r = Og(t, t.x, t.y, t.angle);
    r = this._modifyReflectedPoint(r, e.at(-1)), r && e.push(r);
  },
  _modifyReflectedPoint(e, t) {
    if (t.angle !== e.angle) {
      if (Ll(j4(t.angle)) === Ll(j4(e.angle)))
        e.angle = t.angle;
      else {
        var r = t.angle - e.angle;
        e.angle = t.angle + this._getRemainingAngle(r);
      }
      return e;
    }
  },
  _getTangentPoints: function(e, t, r, n) {
    var i = [], s = Math.round(t.angle - e.angle), l = (t.radius - e.radius) / s, d;
    if (s === 0)
      i = [t, e];
    else if (s > 0) {
      var h = n ? s : s - 1;
      for (d = h; d >= 0; d--)
        i.push(nR(e, t, r, l, d));
    } else {
      var p = n ? s : s + 1;
      for (d = 0; d >= p; d--)
        i.push(nR(e, t, r, l, s - d));
    }
    return i;
  },
  getSeriesPairCoord(e, t) {
    var r = this.getArgumentAxis(), n = t ? "angle" : "radius", i = e[n], s = r.getCenter(), l = (me, fe, Ee) => {
      var {
        x: Q,
        y: pe
      } = Ee;
      return G = {
        x: Q,
        y: pe
      }, se = s, rR(I_(G.x - se.x, 2) + I_(G.y - se.y, 2)) <= r.getRadius() && $4(me.x, fe.x) <= Q && Y4(me.x, fe.x) >= Q && $4(me.y, fe.y) <= pe && Y4(me.y, fe.y) >= pe;
      var G, se;
    }, d, h = this.getNeighborPoints(i, n);
    if (h.length === 1)
      d = h[0];
    else if (h.length > 1) {
      var p = h[0], m = h[1];
      if (this.argumentAxisType !== PC && this.valueAxisType !== PC) {
        var x, S;
        t ? (x = (p.radius - m.radius) / (p.angle - m.angle), S = i - m.angle) : (x = (p.radius - m.radius) / (p.angle - m.angle), S = (i - m.radius) / x), d = nR(m, p, s, x, S);
      } else if (t) {
        var T = ya(-i), k = (m.y - p.y) / (m.x - p.x), O = p.y - p.x * k, D = T.sin / T.cos, L = s.y - D * s.x, F = (L - O) / (k - D), z = k * F + O;
        if (l(p, m, {
          x: F,
          y: z
        })) {
          var V = Iue(Wq((360 + i) / 90) % 4);
          (V === 0 && F >= s.x && z <= s.y || V === 1 && F <= s.x && z <= s.y || V === 2 && F <= s.x && z >= s.y || V === 3 && F >= s.x && z >= s.y) && (d = {
            x: F,
            y: z
          });
        }
      } else {
        var P = (m.y - p.y) / (m.x - p.x), j = p.y - p.x * P, Z = 1 + P * P, ee = -2 * s.x + 2 * P * j - 2 * P * s.y, J = -I_(i, 2) + I_(j - s.y, 2) + I_(s.x, 2), he = ee * ee - 4 * Z * J;
        if (he >= 0) {
          var de = (-ee - rR(he)) / (2 * Z), Re = (-ee + rR(he)) / (2 * Z), Ce = P * de + j, le = P * Re + j;
          d = l(p, m, {
            x: de,
            y: Ce
          }) ? {
            x: de,
            y: Ce
          } : l(p, m, {
            x: Re,
            y: le
          }) ? {
            x: Re,
            y: le
          } : void 0;
        }
      }
    }
    return d;
  },
  getNeighborPoints(e, t) {
    var r = this.getPoints(), n = [];
    if (this.getOptions().closed) {
      r = W(!0, [], r);
      var i = r[r.length - 1], s = Og(r[0], r[0].x, r[0].y, r[0].angle), l = Og(i, i.x, i.y, i.angle), d = this._modifyReflectedPoint(s, i), h = this._modifyReflectedPoint(l, r[0]);
      h && r.unshift(h), d && r.push(d);
    }
    for (var p = 1; p < r.length && (r[p - 1][t] === e ? n.push(r[p - 1]) : r[p][t] === e ? n.push(r[p]) : (r[p][t] > e && r[p - 1][t] < e || r[p - 1][t] > e && r[p][t] < e) && (n.push(r[p - 1]), n.push(r[p])), !(n.length > 0)); p++)
      ;
    return n;
  }
});
var hE = Fn.line, W4 = YT.line, WT = W, Vue = Fn.spline._calculateBezierPoints, po = {}, y5 = {}, x5 = {
  _createBorderElement: hE._createMainElement,
  _createLegendState: function(e, t) {
    return {
      fill: xa(e.color) || t,
      opacity: e.opacity,
      hatching: e.hatching,
      filter: e.highlight
    };
  },
  _getColorId: function(e) {
    var t;
    return (t = e.color) === null || t === void 0 ? void 0 : t.fillId;
  },
  getValueRangeInitialValue: function() {
    return this.valueAxisType !== "logarithmic" && this.valueType !== "datetime" && this.showZero !== !1 ? 0 : cn.getValueRangeInitialValue.call(this);
  },
  _getDefaultSegment: function(e) {
    var t = hE._getDefaultSegment(e);
    return t.area = t.line.concat(t.line.slice().reverse()), t;
  },
  _updateElement: function(e, t, r, n) {
    var i = {
      points: t.line
    }, s = {
      points: t.area
    }, l = e.line;
    r ? (l && l.animate(i), e.area.animate(s, {}, n)) : (l && l.attr(i), e.area.attr(s));
  },
  _removeElement: function(e) {
    e.line && e.line.remove(), e.area.remove();
  },
  _drawElement: function(e) {
    return {
      line: this._bordersGroup && this._createBorderElement(e.line, {
        "stroke-width": this._styles.normal.border["stroke-width"]
      }).append(this._bordersGroup),
      area: this._createMainElement(e.area).append(this._elementsGroup)
    };
  },
  _applyStyle: function(e) {
    this._elementsGroup && this._elementsGroup.smartAttr(e.elements), this._bordersGroup && this._bordersGroup.attr(e.border), (this._graphics || []).forEach(function(t) {
      t.line && t.line.attr({
        "stroke-width": e.border["stroke-width"]
      }).sharp();
    });
  },
  _parseStyle: function(e, t, r) {
    var n, i = e.border || {}, s = hE._parseLineOptions(i, r);
    return s.stroke = i.visible && s["stroke-width"] ? s.stroke : "none", s["stroke-width"] = s["stroke-width"] || 1, {
      border: s,
      elements: {
        stroke: "none",
        fill: xa(e.color) || t,
        hatching: e.hatching,
        opacity: e.opacity,
        filter: (n = e.highlight) !== null && n !== void 0 ? n : null
      }
    };
  },
  _areBordersVisible: function() {
    var e = this._options;
    return e.border.visible || e.hoverStyle.border.visible || e.selectionStyle.border.visible;
  },
  _createMainElement: function(e, t) {
    return this._renderer.path(e, "area").attr(t);
  },
  _getTrackerSettings: function(e) {
    return {
      "stroke-width": e.singlePointSegment ? this._defaultTrackerWidth : 0
    };
  },
  _getMainPointsFromSegment: function(e) {
    return e.area;
  }
};
function Fue(e) {
  return ti(e, function(t) {
    return t.getCoords();
  }).concat(ti(e.slice().reverse(), function(t) {
    return t.getCoords(!0);
  }));
}
var Ld = po.area = WT({}, hE, x5, {
  _prepareSegment(e, t) {
    var r = this._processSinglePointsAreaSegment(e, t), n = Fue(r), i = this.getArgumentAxis();
    if (i.getAxisPosition) {
      var s = i.getAxisPosition(), l = i.getOptions(), d = (t ? 1 : -1) * Math.round(l.width / 2);
      l.visible && n.forEach((h, p) => {
        if (h) {
          var m = e.length === 1 ? 0 : p < e.length ? p : n.length - 1 - p;
          t && h.x === e[m].defaultX && h.x === s - i.getAxisShift() && (h.x += d), !t && h.y === e[m].defaultY && h.y === s - i.getAxisShift() && (h.y += d);
        }
      });
    }
    return {
      line: r,
      area: n,
      singlePointSegment: r !== e
    };
  },
  _processSinglePointsAreaSegment: function(e, t) {
    if (e && e.length === 1) {
      var r = e[0], n = Vg(r);
      return n[t ? "y" : "x"] += 1, n.argument = null, [r, n];
    }
    return e;
  }
});
y5.area = WT({}, W4, x5, {
  _prepareSegment: function(e, t, r) {
    return r && W4._closeSegment.call(this, e), Ld._prepareSegment.call(this, e);
  },
  _processSinglePointsAreaSegment: function(e) {
    return YT.line._prepareSegment.call(this, e).line;
  }
});
po.steparea = WT({}, Ld, {
  _prepareSegment: function(e, t) {
    var r = Fn.stepline;
    return e = Ld._processSinglePointsAreaSegment(e, t), Ld._prepareSegment.call(this, r._calculateStepLinePoints.call(this, e), t);
  },
  getSeriesPairCoord: Fn.stepline.getSeriesPairCoord
});
po.splinearea = WT({}, Ld, {
  _areaPointsToSplineAreaPoints: function(e) {
    var t = e[e.length / 2 - 1], r = e[e.length / 2];
    e.splice(e.length / 2, 0, {
      x: t.x,
      y: t.y
    }, {
      x: r.x,
      y: r.y
    });
  },
  _prepareSegment: function(e, t) {
    var r = Ld._processSinglePointsAreaSegment(e, t), n = Ld._prepareSegment.call(this, Vue(r, t));
    return this._areaPointsToSplineAreaPoints(n.area), n.singlePointSegment = r !== e, n;
  },
  _getDefaultSegment: function(e) {
    var t = Ld._getDefaultSegment(e);
    return this._areaPointsToSplineAreaPoints(t.area), t;
  },
  _createMainElement: function(e, t) {
    return this._renderer.path(e, "bezierarea").attr(t);
  },
  _createBorderElement: Fn.spline._createMainElement,
  getSeriesPairCoord: Fn.spline.getSeriesPairCoord,
  _getNearestPoints: Fn.spline._getNearestPoints,
  _getBezierPoints: Fn.spline._getBezierPoints,
  obtainCubicBezierTCoef: Fn.spline.obtainCubicBezierTCoef
});
var WD = po.area, Vd = cn, Bue = $T, XD = W, zue = be, zh = {}, XT = {}, qD = {
  _createLegendState: function(e, t) {
    return {
      fill: xa(e.color) || t,
      hatching: e.hatching,
      filter: e.highlight
    };
  },
  _getColorId: WD._getColorId,
  _parsePointStyle: function(e, t, r) {
    var n = xa(e.color) || t, i = Vd._parsePointStyle.call(this, e, n, r);
    return i.fill = n, i.hatching = e.hatching, i.filter = e.highlight, i.dashStyle = e.border && e.border.dashStyle || "solid", delete i.r, i;
  },
  _applyMarkerClipRect: function(e) {
    e["clip-path"] = null;
  },
  _setGroupsSettings: function(e, t) {
    var r = this, n = {};
    Vd._setGroupsSettings.apply(r, arguments), e && t ? n = this._getAffineCoordOptions() : e || (n = {
      scaleX: 1,
      scaleY: 1,
      translateX: 0,
      translateY: 0
    }), r._markersGroup.attr(n);
  },
  _drawPoint: function(e) {
    e.hasAnimation = e.hasAnimation && !e.firstDrawing, e.firstDrawing = !1, Vd._drawPoint.call(this, e);
  },
  _getMainColor: function() {
    return this._options.mainSeriesColor;
  },
  _createPointStyles: function(e) {
    var t, r = xa(e.color, !0) || this._getMainColor(), n = (t = e.color) === null || t === void 0 ? void 0 : t.fillId, i = e.hoverStyle || {}, s = e.selectionStyle || {};
    return n && this._turnOffHatching(i, s), {
      labelColor: r,
      normal: this._parsePointStyle(e, r, r),
      hover: this._parsePointStyle(i, n || r, r),
      selection: this._parsePointStyle(s, n || r, r)
    };
  },
  _updatePointsVisibility: function() {
    var e = this._options.visible;
    be(this._points, function(t, r) {
      r._options.visible = e;
    });
  },
  _getOptionsForPoint: function() {
    return this._options;
  },
  _animate: function(e) {
    var t = this;
    t._animatePoints(e, function() {
      t._animateComplete();
    }, function(r, n) {
      var i = r.length - 1;
      zue(r || [], function(s, l) {
        l.animate(s === i ? n : void 0, l.getMarkerCoords());
      });
    });
  },
  getValueRangeInitialValue: WD.getValueRangeInitialValue,
  _patchMarginOptions: function(e) {
    var t;
    return e.checkInterval = !this.useAggregation() || ((t = this.getArgumentAxis()) === null || t === void 0 ? void 0 : t.aggregatedPointBetweenTicks()), e;
  },
  _defaultAggregator: "sum",
  _defineDrawingState() {
  },
  usePointsToDefineAutoHiding: () => !1
};
zh.bar = XD({}, Vd, qD, {
  _getAffineCoordOptions: function() {
    var e = this._options.rotated, t = e ? "X" : "Y", r = {
      scaleX: e ? 1e-3 : 1,
      scaleY: e ? 1 : 1e-3
    };
    return r["translate" + t] = this.getValueAxis().getTranslator().translate("canvas_position_default"), r;
  },
  _animatePoints: function(e, t, r) {
    this._markersGroup.animate({
      scaleX: 1,
      scaleY: 1,
      translateY: 0,
      translateX: 0
    }, void 0, t), e || r(this._drawnPoints, t);
  },
  checkSeriesViewportCoord(e, t) {
    if (!Vd.checkSeriesViewportCoord.call(this))
      return !1;
    if (e.isArgumentAxis)
      return !0;
    var r = e.getTranslator(), n = this.getViewport(), i = r.translate(n.categories ? n.categories[0] : n.min), s = r.translate(n.categories ? n.categories[n.categories.length - 1] : n.max), l = this.getOptions().rotated, d = e.getOptions().inverted;
    return l && !d || !l && d ? t >= i && t <= s : t >= s && t <= i;
  },
  getSeriesPairCoord(e, t) {
    for (var r = null, {
      rotated: n
    } = this._options, i = !t && !n || t && n, s = i ? "vy" : "vx", l = i ? "vx" : "vy", d = this.getPoints(), h = 0; h < d.length; h++) {
      var p = d[h], m = void 0;
      if (t ? m = p.getCenterCoord()[s[1]] === e ? p[l] : void 0 : m = p[s] === e ? p[l] : void 0, this._checkAxisVisibleAreaCoord(!t, m)) {
        r = m;
        break;
      }
    }
    return r;
  }
});
XT.bar = XD({}, Bue, qD, {
  _animatePoints: function(e, t, r) {
    r(this._drawnPoints, t);
  },
  _setGroupsSettings: Vd._setGroupsSettings,
  _drawPoint: function(e, t, r) {
    Vd._drawPoint.call(this, e, t, r);
  },
  _parsePointStyle: function(e) {
    var t = qD._parsePointStyle.apply(this, arguments);
    return t.opacity = e.opacity, t;
  },
  _createGroups: Vd._createGroups,
  _setMarkerGroupSettings: function() {
    var e = this._createPointStyles(this._getMarkerGroupOptions()).normal;
    e.class = "dxc-markers", this._applyMarkerClipRect(e);
    var t = XD({}, e);
    delete t.opacity, this._markersGroup.attr(t);
  },
  getSeriesPairCoord(e, t) {
    for (var r = null, n = t ? "argument" : "radius", i = this.getVisiblePoints(), s = this.getArgumentAxis(), l = s.getAngles()[0], d = 0; d < i.length; d++) {
      var h = i[d], p = I(h[n]) && I(e[n]) && h[n].valueOf() === e[n].valueOf() ? CT(s.getCenter(), l, -s.getTranslatedAngle(h.angle), h.radius) : void 0;
      if (I(p)) {
        r = p;
        break;
      }
    }
    return r;
  },
  _createLegendState: WD._createLegendState
});
var b5 = W, Hue = zh.bar, N_ = po.area, zL = {}, S5 = {
  areErrorBarsVisible: Y,
  _createErrorBarGroup: Y,
  _checkData: function(e, t) {
    var r = this.getValueFields();
    return cn._checkData.call(this, e, t, {
      minValue: r[0],
      value: r[1]
    }) && e.minValue === e.minValue;
  },
  getValueRangeInitialValue: cn.getValueRangeInitialValue,
  _getPointDataSelector: function(e) {
    var t = this.getValueFields(), r = t[0], n = t[1], i = this.getTagField(), s = this.getArgumentField();
    return (l) => ({
      tag: l[i],
      minValue: this._processEmptyValue(l[r]),
      value: this._processEmptyValue(l[n]),
      argument: l[s],
      data: l
    });
  },
  _defaultAggregator: "range",
  _aggregators: {
    range(e, t) {
      var {
        intervalStart: r,
        intervalEnd: n,
        data: i
      } = e;
      if (i.length) {
        var s = t.getValueFields(), l = s[0], d = s[1], h = i.reduce((p, m) => {
          var x = m[l], S = m[d];
          return !I(x) || !I(S) || (p[l] = Math.min(p[l], Math.min(x, S)), p[d] = Math.max(p[d], Math.max(x, S))), p;
        }, {
          [l]: 1 / 0,
          [d]: -1 / 0,
          [t.getArgumentField()]: t._getIntervalCenter(r, n)
        });
        if (!isFinite(h[l]) || !isFinite(h[d]))
          if (i.filter((p) => p[l] === null && p[d] === null).length === i.length)
            h[l] = h[d] = null;
          else
            return;
        return h;
      }
    }
  },
  getValueFields: function() {
    return [this._options.rangeValue1Field || "val1", this._options.rangeValue2Field || "val2"];
  },
  getSeriesPairCoord(e, t) {
    for (var r = null, {
      rotated: n
    } = this._options, i = !t && !n || t && n, s = i ? "vy" : "vx", l = n ? "minX" : "minY", d = i ? "vx" : "vy", h = this.getPoints(), p = 0; p < h.length; p++) {
      var m = h[p], x = void 0;
      if (t)
        x = m.getCenterCoord()[s[1]] === e ? m[d] : void 0;
      else {
        var S = [Math.min(m[s], m[l]), Math.max(m[s], m[l])];
        x = e >= S[0] && e <= S[1] ? m[d] : void 0;
      }
      if (this._checkAxisVisibleAreaCoord(!t, x)) {
        r = x;
        break;
      }
    }
    return r;
  }
};
zL.rangebar = b5({}, Hue, S5);
zL.rangearea = b5({}, N_, {
  _drawPoint: function(e) {
    var t = e.point;
    t.isInVisibleArea() ? (t.clearVisibility(), t.draw(this._renderer, e.groups), this._drawnPoints.push(t), t.visibleTopMarker || t.hideMarker("top"), t.visibleBottomMarker || t.hideMarker("bottom")) : t.setInvisibility();
  },
  _prepareSegment: function(e, t) {
    var r = this._processSinglePointsAreaSegment(e, t), n = ti(r, function(i) {
      return i.getCoords(!0);
    });
    return {
      line: r,
      bottomLine: n,
      area: ti(r, function(i) {
        return i.getCoords();
      }).concat(n.slice().reverse()),
      singlePointSegment: r !== e
    };
  },
  _getDefaultSegment: function(e) {
    var t = N_._getDefaultSegment.call(this, e);
    return t.bottomLine = t.line, t;
  },
  _removeElement: function(e) {
    N_._removeElement.call(this, e), e.bottomLine && e.bottomLine.remove();
  },
  _drawElement: function(e, t) {
    var r = N_._drawElement.call(this, e, t);
    return r.bottomLine = this._bordersGroup && this._createBorderElement(e.bottomLine, {
      "stroke-width": this._styles.normal.border["stroke-width"]
    }).append(this._bordersGroup), r;
  },
  _applyStyle: function(e) {
    var t = this._elementsGroup, r = this._bordersGroup;
    t && t.smartAttr(e.elements), r && r.attr(e.border), (this._graphics || []).forEach(function(n) {
      n.line && n.line.attr({
        "stroke-width": e.border["stroke-width"]
      }), n.bottomLine && n.bottomLine.attr({
        "stroke-width": e.border["stroke-width"]
      });
    });
  },
  _updateElement: function(e, t, r, n) {
    var i = {
      points: t.bottomLine
    }, s = e.bottomLine;
    N_._updateElement.apply(this, arguments), s && (r ? s.animate(i) : s.attr(i));
  }
}, S5);
var Gue = Fn.line, X4 = po.area, IC = zh.bar, q4 = XT.bar, Uue = W, jue = be, iR = Y, C5 = {};
C5.bubble = Uue({}, cn, {
  _calculateErrorBars: iR,
  _getMainColor: IC._getMainColor,
  _createPointStyles: IC._createPointStyles,
  _updatePointsVisibility: IC._updatePointsVisibility,
  _getOptionsForPoint: IC._getOptionsForPoint,
  _applyMarkerClipRect: Gue._applyElementsClipRect,
  _parsePointStyle: q4._parsePointStyle,
  _createLegendState: X4._createLegendState,
  _getColorId: X4._getColorId,
  _setMarkerGroupSettings: q4._setMarkerGroupSettings,
  areErrorBarsVisible: iR,
  _createErrorBarGroup: iR,
  _checkData: function(e, t) {
    return cn._checkData.call(this, e, t, {
      value: this.getValueFields()[0],
      size: this.getSizeField()
    });
  },
  _getPointDataSelector: function(e, t) {
    var r = this.getSizeField(), n = cn._getPointDataSelector.call(this);
    return (i) => {
      var s = n(i);
      return s.size = i[r], s;
    };
  },
  _aggregators: {
    avg(e, t) {
      var {
        data: r,
        intervalStart: n,
        intervalEnd: i
      } = e;
      if (r.length) {
        var s = t.getValueFields()[0], l = t.getSizeField(), d = r.reduce((h, p) => (h[0] += p[s], h[1] += p[l], h[2]++, h), [0, 0, 0]);
        return {
          [s]: d[0] / d[2],
          [l]: d[1] / d[2],
          [t.getArgumentField()]: t._getIntervalCenter(n, i)
        };
      }
    }
  },
  getValueFields: function() {
    return [this._options.valueField || "val"];
  },
  getSizeField: function() {
    return this._options.sizeField || "size";
  },
  _animate: function() {
    var e = this, t = e._drawnPoints.length - 1, r = e._labelsGroup, n = function() {
      r && r.animate({
        opacity: 1
      }, {
        duration: e._defaultDuration
      });
    };
    jue(e._drawnPoints || [], function(i, s) {
      s.animate(i === t ? n : void 0, {
        r: s.bubbleSize,
        translateX: s.x,
        translateY: s.y
      });
    });
  },
  _patchMarginOptions: function(e) {
    return e.processBubbleSize = !0, e;
  }
});
var aR = cn, K4 = zh.bar, $ue = W, oR = be, V_ = Y, Z4 = ti, Yue = isFinite, Wue = Math.max, Q4 = 0.7, Xue = "inside", HL = $ue({}, K4, {
  _setGroupsSettings: function() {
    aR._setGroupsSettings.apply(this, arguments), this._labelsGroup.attr({
      "pointer-events": null
    });
  },
  _createErrorBarGroup: V_,
  _drawPoint: function(e) {
    var t = e.point, r = this._legendCallback;
    aR._drawPoint.call(this, e), !t.isVisible() && t.setInvisibility(), t.isSelected() && r();
  },
  _getOldPoint: function(e, t, r) {
    var n = (this._points || [])[r];
    return n && (t[n.argument.valueOf()] = t[n.argument.valueOf()].filter((i) => i !== n)), n;
  },
  adjustLabels: function(e) {
    return (this._points || []).reduce((t, r) => {
      if (r._label.isVisible())
        return r.setLabelTrackerData(), t = r.applyWordWrap(e) || t, r.updateLabelCoord(e), t;
    }, !1);
  },
  _applyElementsClipRect: V_,
  getColor: V_,
  areErrorBarsVisible: V_,
  drawLabelsWOPoints: function() {
    return this._options.label.position === Xue ? !1 : (this._labelsGroup.append(this._extGroups.labelsGroup), (this._points || []).forEach(function(e) {
      e.drawLabel();
    }), !0);
  },
  getPointsCount: function() {
    return this._data.filter((e) => this._checkData(e)).length;
  },
  setMaxPointsCount: function(e) {
    this._pointsCount = e;
  },
  _getCreatingPointOptions: function(e, t) {
    return this._getPointOptions(e, t);
  },
  _updateOptions: function(e) {
    this.labelSpace = 0, this.innerRadius = this.type === "pie" ? 0 : e.innerRadius;
  },
  _checkData: function(e, t) {
    var r = K4._checkData.call(this, e, t, {
      value: this.getValueFields()[0]
    });
    return this._options.paintNullPoints ? r : r && e.value !== null;
  },
  _createGroups: aR._createGroups,
  _setMarkerGroupSettings: function() {
    this._markersGroup.attr({
      class: "dxc-markers"
    });
  },
  _getMainColor(e, t) {
    var r = this.getPointsByArg(e.argument), n = t ? r.indexOf(t) : r.length;
    return this._options.mainSeriesColor(e.argument, n, this._pointsCount);
  },
  _getPointOptions: function(e) {
    return this._parsePointOptions(this._preparePointOptions(), this._options.label, e);
  },
  _getRangeData: function() {
    return this._rangeData;
  },
  _createPointStyles: function(e, t, r) {
    var n, i = xa(e.color, !0) || this._getMainColor(t, r), s = (n = e.color) === null || n === void 0 ? void 0 : n.fillId, l = e.hoverStyle || {}, d = e.selectionStyle || {};
    return s && this._turnOffHatching(l, d), {
      labelColor: i,
      normal: this._parsePointStyle(e, i, i),
      hover: this._parsePointStyle(l, s || i, i),
      selection: this._parsePointStyle(d, s || i, i),
      legendStyles: {
        normal: this._createLegendState(e, i),
        hover: this._createLegendState(l, s || i),
        selection: this._createLegendState(d, s || i)
      }
    };
  },
  _getArrangeMinShownValue: function(e, t) {
    var r = this._options.minSegmentSize, n = 0, i = 0;
    return t = t || e.length, oR(e, function(s, l) {
      l.isVisible() && (l.normalInitialValue < r * t / 360 ? n += r : i += l.normalInitialValue);
    }), n < 360 ? r * i / (360 - n) : 0;
  },
  _applyArrangeCorrection: function(e, t, r) {
    var n = this._options, i = n.segmentsDirection !== "anticlockwise", s = Yue(n.startAngle) ? Ll(n.startAngle) : 0, l = n.minSegmentSize, d, h = 0, p = 0;
    r === 0 && (r = e.filter(function(m) {
      return m.isVisible();
    }).length, p = 1), oR(i ? e : e.concat([]).reverse(), function(m, x) {
      var S = x.isVisible() ? p || x.normalInitialValue : 0, T;
      l && x.isVisible() && S < t && (T = t), d = S / r, x.correctValue(h, d, p + (T || 0)), x.shiftedAngle = s, h += T || S;
    }), this._rangeData = {
      val: {
        min: 0,
        max: h
      }
    };
  },
  _removePoint: function(e) {
    var t = this.getPointsByArg(e.argument);
    t.splice(t.indexOf(e), 1), e.dispose();
  },
  arrangePoints: function() {
    for (var e = this, t = e._points || [], r = e._options.minSegmentSize, n, i = !0, s = 0, l = t.length; s < l && i; )
      i = t[s].value <= 0, s++;
    var d = e._points = Z4(t, function(m) {
      return m.value === null || !i && m.value < 0 ? (e._removePoint(m), null) : m;
    }), h = d.reduce(function(m, x) {
      return Wue(m, Math.abs(x.initialValue));
    }, 0);
    d.forEach(function(m) {
      m.normalInitialValue = m.initialValue / (h !== 0 ? h : 1);
    });
    var p = d.reduce(function(m, x) {
      return m + (x.isVisible() ? x.normalInitialValue : 0);
    }, 0);
    r && (n = this._getArrangeMinShownValue(d, p)), e._applyArrangeCorrection(d, n, p);
  },
  correctPosition: function(e, t) {
    oR(this._points, function(r, n) {
      n.correctPosition(e);
    }), this.setVisibleArea(t);
  },
  correctRadius: function(e) {
    this._points.forEach(function(t) {
      t.correctRadius(e);
    });
  },
  correctLabelRadius: function(e) {
    this._points.forEach(function(t) {
      t.correctLabelRadius(e);
    });
  },
  setVisibleArea: function(e) {
    this._visibleArea = {
      minX: e.left,
      maxX: e.width - e.right,
      minY: e.top,
      maxY: e.height - e.bottom
    };
  },
  _applyVisibleArea: V_,
  _animate: function(e) {
    var t = this, r = t._points, n = r && r.length, i = function() {
      t._animateComplete();
    }, s;
    e ? s = function(l, d) {
      l.animate(d === n - 1 ? i : void 0, Q4, (1 - Q4) * d / (n - 1));
    } : s = function(l, d) {
      l.animate(d === n - 1 ? i : void 0);
    }, r.forEach(s);
  },
  getVisiblePoints: function() {
    return Z4(this._points, function(e) {
      return e.isVisible() ? e : null;
    });
  },
  getPointsByKeys: function(e, t) {
    var r = this.getPointsByArg(e);
    return r[t] && [r[t]] || [];
  }
}), que = HL, Kue = HL;
const Zue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  donut: Kue,
  doughnut: que,
  pie: HL
}, Symbol.toStringTag, { value: "Module" }));
var J4 = zh.bar, ez = 10, KD = W({}, cn, {
  _animate: Y,
  _applyMarkerClipRect: function(e) {
    e["clip-path"] = this._forceClipping ? this._paneClipRectID : this._widePaneClipRectID;
  },
  _updatePointsVisibility: J4._updatePointsVisibility,
  _getOptionsForPoint: J4._getOptionsForPoint,
  _createErrorBarGroup: Y,
  areErrorBarsVisible: Y,
  _createGroups: cn._createGroups,
  _setMarkerGroupSettings: function() {
    var e = this._markersGroup, t = this._createPointStyles(this._getMarkerGroupOptions()), r = W(t.normal, {
      class: "default-markers"
    }), n = W(t.positive.normal, {
      class: "default-positive-markers"
    }), i = W(t.reduction.normal, {
      class: "reduction-markers"
    }), s = W(t.reductionPositive.normal, {
      class: "reduction-positive-markers"
    }), l = {
      class: "dxc-markers"
    };
    this._applyMarkerClipRect(l), e.attr(l), this._createGroup("defaultMarkersGroup", e, e, r), this._createGroup("reductionMarkersGroup", e, e, i), this._createGroup("defaultPositiveMarkersGroup", e, e, n), this._createGroup("reductionPositiveMarkersGroup", e, e, s);
  },
  _setGroupsSettings: function() {
    cn._setGroupsSettings.call(this, !1);
  },
  _getCreatingPointOptions: function() {
    var e, t = this._predefinedPointOptions;
    return t || (e = this._getPointOptions(), this._predefinedPointOptions = t = W(!0, {
      styles: {}
    }, e), t.styles.normal = t.styles.positive.normal = t.styles.reduction.normal = t.styles.reductionPositive.normal = {
      "stroke-width": e.styles && e.styles.normal && e.styles.normal["stroke-width"]
    }), t;
  },
  _checkData: function(e, t) {
    var r = this.getValueFields();
    return cn._checkData.call(this, e, t, {
      openValue: r[0],
      highValue: r[1],
      lowValue: r[2],
      closeValue: r[3]
    }) && e.highValue === e.highValue && e.lowValue === e.lowValue;
  },
  _getPointDataSelector: function(e, t) {
    var r = this, n, i = r.getValueFields(), s = r.getArgumentField(), l = i[0], d = i[1], h = i[2], p = i[3];
    switch (r.level = r._options.reduction.level, Wt(r.level)) {
      case "open":
        n = l;
        break;
      case "high":
        n = d;
        break;
      case "low":
        n = h;
        break;
      default:
        n = p, r.level = "close";
    }
    var m;
    return (x) => {
      var S = x[n], T = !1;
      return I(S) && (I(m) && (T = S < m), m = S), {
        argument: x[s],
        highValue: this._processEmptyValue(x[d]),
        lowValue: this._processEmptyValue(x[h]),
        closeValue: this._processEmptyValue(x[p]),
        openValue: this._processEmptyValue(x[l]),
        reductionValue: S,
        tag: x[r.getTagField()],
        isReduction: T,
        data: x
      };
    };
  },
  _parsePointStyle: function(e, t, r) {
    var n = xa(e.color, !0);
    return {
      stroke: n || t,
      "stroke-width": e.width,
      fill: n || r
    };
  },
  _getDefaultStyle: function(e) {
    var t = xa(e.color, !0) || this._options.mainSeriesColor;
    return {
      normal: this._parsePointStyle(e, t, t),
      hover: this._parsePointStyle(e.hoverStyle, t, t),
      selection: this._parsePointStyle(e.selectionStyle, t, t)
    };
  },
  _getReductionStyle: function(e) {
    var t = e.reduction.color;
    return {
      normal: this._parsePointStyle({
        color: t,
        width: e.width,
        hatching: e.hatching
      }, t, t),
      hover: this._parsePointStyle(e.hoverStyle, t, t),
      selection: this._parsePointStyle(e.selectionStyle, t, t)
    };
  },
  _createPointStyles: function(e) {
    var t = this._options.innerColor, r = this._getDefaultStyle(e), n = W(!0, {}, r), i = this._getReductionStyle(e), s = W(!0, {}, i);
    return n.normal.fill = n.hover.fill = n.selection.fill = t, s.normal.fill = s.hover.fill = s.selection.fill = t, r.positive = n, r.reduction = i, r.reductionPositive = s, r.labelColor = this._options.mainSeriesColor, r;
  },
  _endUpdateData: function() {
    delete this._predefinedPointOptions;
  },
  _defaultAggregator: "ohlc",
  _aggregators: {
    ohlc: (e, t) => {
      var {
        intervalStart: r,
        intervalEnd: n,
        data: i
      } = e;
      if (i.length) {
        var s = {}, l = t.getValueFields(), d = l[1], h = l[2];
        return s[d] = -1 / 0, s[h] = 1 / 0, s = i.reduce(function(p, m) {
          return m[d] !== null && (p[d] = Math.max(p[d], m[d])), m[h] !== null && (p[h] = Math.min(p[h], m[h])), p;
        }, s), s[l[0]] = i[0][l[0]], s[l[3]] = i[i.length - 1][l[3]], isFinite(s[d]) || (s[d] = null), isFinite(s[h]) || (s[h] = null), s[t.getArgumentField()] = t._getIntervalCenter(r, n), s;
      }
    }
  },
  getValueFields: function() {
    var e = this._options;
    return [e.openValueField || "open", e.highValueField || "high", e.lowValueField || "low", e.closeValueField || "close"];
  },
  getArgumentField: function() {
    return this._options.argumentField || "date";
  },
  _patchMarginOptions: function(e) {
    var t = this._getCreatingPointOptions(), r = t.styles, n = [r.normal, r.hover, r.selection].reduce(function(i, s) {
      return Math.max(i, s["stroke-width"]);
    }, 0);
    return e.size = ez + n, e.sizePointNormalState = ez, e;
  },
  getSeriesPairCoord(e, t) {
    for (var r = null, n = this.getVisiblePoints(), i = 0; i < n.length; i++) {
      var s = n[i], l = void 0;
      if (t)
        l = s.vx === e ? (s.openY + s.closeY) / 2 : void 0;
      else {
        var d = [Math.min(s.lowY, s.highY), Math.max(s.lowY, s.highY)];
        l = e >= d[0] && e <= d[1] ? s.vx : void 0;
      }
      if (this._checkAxisVisibleAreaCoord(!t, l)) {
        r = l;
        break;
      }
    }
    return r;
  },
  usePointsToDefineAutoHiding: () => !1
}), Que = W({}, KD, {
  _parsePointStyle: function(e, t, r) {
    var n = xa(e.color, !0) || r, i = KD._parsePointStyle.call(this, e, t, n);
    return i.fill = n, i.hatching = e.hatching, i;
  }
});
const Jue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  candlestick: Que,
  stock: KD
}, Symbol.toStringTag, { value: "Module" }));
var ZD = po.area, E5 = zh.bar, jo = {
  _calculateErrorBars: Y,
  _updateOptions: function(e) {
    this._stackName = "axis_" + (e.axis || "default");
  }
}, Zi = {}, T5 = {};
Zi.stackedline = W({}, Fn.line, jo, {});
Zi.stackedspline = W({}, Fn.spline, jo, {});
Zi.fullstackedline = W({}, Fn.line, jo, {
  getValueRangeInitialValue: po.area.getValueRangeInitialValue
});
Zi.fullstackedspline = W({}, Fn.spline, jo, {
  getValueRangeInitialValue: po.area.getValueRangeInitialValue
});
var ece = Zi.stackedbar = W({}, E5, jo, {
  _updateOptions: function(e) {
    jo._updateOptions.call(this, e), this._stackName = this._stackName + "_stack_" + (e.stack || "default");
  }
});
Zi.fullstackedbar = W({}, E5, jo, {
  _updateOptions: ece._updateOptions
});
function tz(e, t, r, n) {
  return e = Vg(e), e.value = t, e.minValue = r, e.translate(), e.argument = e.argument + n, e;
}
function w5(e) {
  for (var t = 0, r, n = [], i, s = e.length; t < s; )
    r = e[t], i = [r], r.leftHole && (i = [tz(r, r.leftHole, r.minLeftHole, "left"), r]), r.rightHole && i.push(tz(r, r.rightHole, r.minRightHole, "right")), n.push(i), t++;
  return [].concat.apply([], n);
}
Zi.stackedarea = W({}, ZD, jo, {
  _prepareSegment: function(e, t) {
    return ZD._prepareSegment.call(this, w5(e), t);
  },
  _appendInGroup: function() {
    this._group.append(this._extGroups.seriesGroup).toBackground();
  }
});
function tce(e, t) {
  for (var r; !r && e; )
    r = e._segmentByArg && e._segmentByArg[t], e = e._prevSeries;
  return r;
}
Zi.stackedsplinearea = W({}, po.splinearea, jo, {
  _prepareSegment: function(e, t) {
    var r = this, n;
    if (e = w5(e), !this._prevSeries || e.length === 1)
      n = po.splinearea._prepareSegment.call(this, e, t);
    else {
      for (var i = Fn.spline._calculateBezierPoints(e, t), s = ti(e, function(m) {
        var x = m.getCoords(!0);
        return x.argument = m.argument, x;
      }), l = [], d = {}, h = 0, p = r._prevSeries._segments.length; h < p; )
        l = l.concat(r._prevSeries._segments[h].line), h++;
      be(l, function(m, x) {
        if (x.argument !== null) {
          var S = x.argument.valueOf();
          d[S] ? d[S].push(x) : d[S] = [x];
        }
      }), r._prevSeries._segmentByArg = d, s = Fn.spline._calculateBezierPoints(s, t), be(s, function(m, x) {
        var S = x.argument.valueOf(), T;
        m % 3 === 0 && (T = d[S] || tce(r._prevSeries, S), T && (s[m - 1] && T[0] && (s[m - 1] = T[0]), s[m + 1] && (s[m + 1] = T[2] || x)));
      }), n = {
        line: i,
        area: i.concat(s.reverse())
      }, r._areaPointsToSplineAreaPoints(n.area);
    }
    return n;
  },
  _appendInGroup: Zi.stackedarea._appendInGroup
});
Zi.fullstackedarea = W({}, ZD, jo, {
  _prepareSegment: Zi.stackedarea._prepareSegment,
  _appendInGroup: Zi.stackedarea._appendInGroup
});
Zi.fullstackedsplinearea = W({}, po.splinearea, jo, {
  _prepareSegment: Zi.stackedsplinearea._prepareSegment,
  _appendInGroup: Zi.stackedarea._appendInGroup
});
T5.stackedbar = W({}, XT.bar, jo, {});
var Il = {}, Yd = Is.states, NC = "discrete", ry = Yd.selectedMark, ny = Yd.hoverMark, Tl = Yd.hover, rce = Yd.normal, yd = Yd.selection, rz = Yd.applySelected, nce = Yd.applyHover, ice = Yd.resetItem, sg = "none", ace = "includepoints", oce = "nearestpoint", nz = "seriesSelectionChanged", iz = "pointSelectionChanged", az = "seriesHoverChanged", oz = "pointHoverChanged", $_ = "allseriespoints", VC = "allargumentpoints", sz = "pointHover", lz = "clearPointHover", uz = "seriesSelect", cz = "pointSelect", dz = "pointDeselect", fz = function() {
  return {
    arg: {},
    val: {}
  };
};
function hz(e, t, r) {
  e && e.trigger(t, r);
}
Il.mixins = {
  chart: {},
  pie: {},
  polar: {}
};
Il.mixins.chart.scatter = cn;
Il.mixins.polar.scatter = $T;
W(Il.mixins.pie, Zue);
W(Il.mixins.chart, Fn, po, zh, zL, C5, Jue, Zi);
W(Il.mixins.polar, YT, y5, XT, T5);
function FC(e) {
  return e = Wt(e), e === ace || e === $_;
}
function sce(e, t) {
  var r = e || {}, n = W({}, r.font) || {}, i = r.border || {}, s = r.connector || {}, l = {
    fill: r.backgroundColor || t,
    "stroke-width": i.visible && i.width || 0,
    stroke: i.visible && i.width ? i.color : "none",
    dashStyle: i.dashStyle
  }, d = {
    stroke: s.visible && s.width ? s.color || t : "none",
    "stroke-width": s.visible && s.width || 0
  };
  return n.color = r.backgroundColor === "none" && Wt(n.color) === "#ffffff" && r.position !== "inside" ? t : n.color, {
    alignment: r.alignment,
    format: r.format,
    argumentFormat: r.argumentFormat,
    customizeText: ct(r.customizeText) ? r.customizeText : void 0,
    attributes: {
      font: n
    },
    visible: n.size !== 0 ? r.visible : !1,
    showForZeroValues: r.showForZeroValues,
    horizontalOffset: r.horizontalOffset,
    verticalOffset: r.verticalOffset,
    radialOffset: r.radialOffset,
    background: l,
    position: r.position,
    connector: d,
    rotationAngle: r.rotationAngle,
    wordWrap: r.wordWrap,
    textOverflow: r.textOverflow,
    cssClass: r.cssClass,
    displayFormat: r.displayFormat
  };
}
function lce(e, t) {
  e.fullState |= ny, e.applyView(t);
}
function uce(e, t) {
  e.fullState &= ~ny, e.applyView(t), e.releaseHoverState();
}
function cce(e, t) {
  e.fullState |= ry, e.applyView(t);
}
function dce(e, t) {
  e.fullState &= ~ry, e.applyView(t);
}
function sR(e, t) {
  var r = W({}, e, t);
  return r.border = W({}, e && e.border, t && t.border), r;
}
function fce(e, t) {
  var r = sR(e, t);
  return r.image = W(!0, {}, e.image, t.image), r.selectionStyle = sR(e.selectionStyle, t.selectionStyle), r.hoverStyle = sR(e.hoverStyle, t.hoverStyle), r;
}
function QD(e, t) {
  this.fullState = 0, this._extGroups = e, this._renderer = e.renderer, this._group = e.renderer.g().attr({
    class: "dxc-series"
  }), this._eventTrigger = e.eventTrigger, this._eventPipe = e.eventPipe, this._incidentOccurred = e.incidentOccurred, this._legendCallback = Y, this.updateOptions(t, e);
}
function BC(e) {
  return e.data;
}
function vz(e, t) {
  return !t || e !== "logarithmic" || t.getOptions().allowNegatives !== !1 ? () => !0 : (r) => r > 0;
}
QD.prototype = {
  constructor: QD,
  _createLegendState: Y,
  getLegendStyles: function() {
    return this._styles.legendStyles;
  },
  _createStyles: function(e) {
    var t = e.mainSeriesColor, r = this._getColorId(e), n = e.hoverStyle || {}, i = e.selectionStyle || {};
    r && this._turnOffHatching(n, i), this._styles = {
      labelColor: t,
      normal: this._parseStyle(e, t, t),
      hover: this._parseStyle(n, r || t, t),
      selection: this._parseStyle(i, r || t, t),
      legendStyles: {
        normal: this._createLegendState(e, r || t),
        hover: this._createLegendState(n, r || t),
        selection: this._createLegendState(i, r || t)
      }
    };
  },
  setClippingParams(e, t, r) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
    this._paneClipRectID = e, this._widePaneClipRectID = t, this._forceClipping = r, this._clipLabels = n;
  },
  applyClip: function() {
    this._group.attr({
      "clip-path": this._paneClipRectID
    });
  },
  resetClip: function() {
    this._group.attr({
      "clip-path": null
    });
  },
  getTagField: function() {
    return this._options.tagField || "tag";
  },
  getValueFields: Y,
  getSizeField: Y,
  getArgumentField: Y,
  getPoints: function() {
    return this._points;
  },
  getPointsInViewPort: function() {
    return Nd.getPointsInViewPort(this);
  },
  _createPoint: function(e, t, r) {
    e.index = t;
    var n = this.pointsByArgument, i = this._getCreatingPointOptions(e), s = e.argument.valueOf(), l = r;
    l ? l.update(e, i) : (l = new YD(this, e, i), this.isSelected() && FC(this.lastSelectionMode) && l.setView(yd));
    var d = n[s];
    return d ? d.push(l) : n[s] = [l], l.hasValue() && this.customizePoint(l, e), l;
  },
  getRangeData: function() {
    return this._visible ? this._getRangeData() : fz();
  },
  getArgumentRange: function() {
    return this._visible ? Nd.getArgumentRange(this) : fz();
  },
  getViewport: function() {
    return Nd.getViewport(this);
  },
  _deleteGroup: function(e) {
    var t = this[e];
    t && (t.dispose(), this[e] = null);
  },
  updateOptions(e, t) {
    var r = e.widgetType, n = this.type, i = e.type;
    if (this.type = i && Wt(i.toString()), !this._checkType(r) || this._checkPolarBarType(r, e)) {
      this.dispose(), this.isUpdated = !1;
      return;
    }
    n !== this.type ? (this._firstDrawing = !0, this._resetType(n, r), this._setType(this.type, r)) : this._defineDrawingState(), this._options = e, this._pointOptions = null, this.name = e.name, this.pane = e.pane, this.tag = e.tag, t && (this._seriesModes = t.commonSeriesModes || this._seriesModes, this._valueAxis = t.valueAxis || this._valueAxis, this.axis = this._valueAxis && this._valueAxis.name, this._argumentAxis = t.argumentAxis || this._argumentAxis), this._createStyles(e), this._stackName = null, this._updateOptions(e), this._visible = e.visible, this.isUpdated = !0, this.stack = e.stack, this.barOverlapGroup = e.barOverlapGroup, this._createGroups(), this._processEmptyValue = e.ignoreEmptyPoints ? (s) => s === null ? void 0 : s : (s) => s;
  },
  _defineDrawingState() {
    this._firstDrawing = !0;
  },
  _disposePoints: function(e) {
    be(e || [], function(t, r) {
      r.dispose();
    });
  },
  updateDataType: function(e) {
    return this.argumentType = e.argumentType, this.valueType = e.valueType, this.argumentAxisType = e.argumentAxisType, this.valueAxisType = e.valueAxisType, this.showZero = e.showZero, this._argumentChecker = vz(e.argumentAxisType, this.getArgumentAxis()), this._valueChecker = vz(e.valueAxisType, this.getValueAxis()), this;
  },
  _argumentChecker: function() {
    return !0;
  },
  _valueChecker: function() {
    return !0;
  },
  getOptions: function() {
    return this._options;
  },
  _getOldPoint: function(e, t, r) {
    var n = e.argument && e.argument.valueOf(), i = (t[n] || [])[0];
    return i && t[n].splice(0, 1), i;
  },
  updateData: function(e) {
    var t = this._options, r = t.nameField;
    e = e || [], e.length && (this._canRenderCompleteHandle = !0);
    var n = this._getPointDataSelector(), i = 0;
    this._data = e.reduce((s, l, d) => {
      var h = n(l);
      return I(h.argument) ? (!r || l[r] === t.nameFieldValue) && (h.index = d, s.push(h)) : i++, s;
    }, []), i && i === e.length && this._incidentOccurred("W2002", [this.name, this.getArgumentField()]), this._endUpdateData();
  },
  _getData() {
    var e = this._data || [];
    if (this.useAggregation()) {
      var t = this.argumentAxisType !== NC ? this.getArgumentRange() : {}, r = this.getArgumentAxis().getAggregationInfo(this._useAllAggregatedPoints, t);
      e = this._resample(r, e);
    }
    return e;
  },
  useAggregation: function() {
    var e = this.getOptions().aggregation;
    return e && e.enabled;
  },
  autoHidePointMarkersEnabled: Y,
  usePointsToDefineAutoHiding: Y,
  createPoints(e) {
    this._normalizeUsingAllAggregatedPoints(e), this._createPoints();
  },
  _normalizeUsingAllAggregatedPoints: function(e) {
    this._useAllAggregatedPoints = this.useAggregation() && (this.argumentAxisType === NC || (this._data || []).length > 1 && !!e);
  },
  _createPoints: function() {
    var e = this, t = e.pointsByArgument || {}, r = e._getData();
    e.pointsByArgument = {}, e._calculateErrorBars(r);
    var n = {}, i = r.reduce((l, d) => {
      if (e._checkData(d, n)) {
        var h = l.length, p = e._getOldPoint(d, t, h), m = e._createPoint(d, h, p);
        l.push(m);
      }
      return l;
    }, []);
    for (var s in n)
      n[s] === r.length && e._incidentOccurred("W2002", [e.name, s]);
    Object.keys(t).forEach((l) => e._disposePoints(t[l])), e._points = i;
  },
  _removeOldSegments: function() {
    var e = this, t = e._segments.length;
    be(e._graphics.splice(t, e._graphics.length) || [], function(r, n) {
      e._removeElement(n);
    }), e._trackers && be(e._trackers.splice(t, e._trackers.length) || [], function(r, n) {
      n.remove();
    });
  },
  _prepareSegmentsPosition() {
    var e = this._points || [], t = e[0] && e[0].hasValue() && this._options.closed, r = e.reduce(function(n, i) {
      var s = n.at(-1);
      return i.translated || i.setDefaultCoords(), i.hasValue() && i.hasCoords() ? s.push(i) : !i.hasValue() && s.length && n.push([]), n;
    }, [
      []
    ]);
    this._drawSegments(r, t, !1);
  },
  _drawElements(e, t) {
    var r = this, n = r._points || [], i = n[0] && n[0].hasValue() && r._options.closed, s = {
      markers: r._markersGroup,
      errorBars: r._errorBarGroup
    };
    r._drawnPoints = [], r._graphics = r._graphics || [], r._segments = [];
    var l = n.reduce(function(d, h) {
      var p = d.at(-1);
      return h.hasValue() && h.hasCoords() ? (r._drawPoint({
        point: h,
        groups: s,
        hasAnimation: e,
        firstDrawing: t
      }), p.push(h)) : h.hasValue() ? h.setInvisibility() : p.length && d.push([]), d;
    }, [
      []
    ]);
    r._drawSegments(l, i, e), r._firstDrawing = !n.length, r._removeOldSegments(), e && r._animate(t);
  },
  _drawSegments(e, t, r) {
    e.forEach((n, i) => {
      if (n.length) {
        var s = t && i === e.length - 1;
        this._drawSegment(n, r, i, s);
      }
    });
  },
  draw(e, t, r) {
    var n = this._firstDrawing;
    if (this._legendCallback = r || this._legendCallback, !this._visible) {
      this._group.remove();
      return;
    }
    this._appendInGroup(), this._isAllPointsTranslated || this.prepareCoordinatesForPoints(), this._setGroupsSettings(e, n), !n && !this._resetApplyingAnimation && this._prepareSegmentsPosition(), this._drawElements(e, n), t && this.hideLabels(), this.isSelected() ? this._changeStyle(this.lastSelectionMode, void 0, !0) : this.isHovered() ? this._changeStyle(this.lastHoverMode, void 0, !0) : this._applyStyle(this._styles.normal), this._isAllPointsTranslated = !1, this._resetApplyingAnimation = !1;
  },
  _translatePoints() {
    var e, t = (e = this._points) !== null && e !== void 0 ? e : [];
    t.forEach((r) => {
      r.translate();
    });
  },
  prepareCoordinatesForPoints() {
    this._applyVisibleArea(), this._translatePoints(), this._isAllPointsTranslated = !0;
  },
  _setLabelGroupSettings: function(e) {
    var t = {
      class: "dxc-labels",
      "pointer-events": "none"
    };
    this._clipLabels && this._applyElementsClipRect(t), this._applyClearingSettings(t), e && (t.opacity = 1e-3), this._labelsGroup.attr(t).append(this._extGroups.labelsGroup);
  },
  _checkType: function(e) {
    return !!Il.mixins[e][this.type];
  },
  _checkPolarBarType: function(e, t) {
    return e === "polar" && t.spiderWidget && this.type.indexOf("bar") !== -1;
  },
  _resetType: function(e, t) {
    var r, n;
    if (e) {
      n = Il.mixins[t][e];
      for (r in n)
        delete this[r];
    }
  },
  _setType: function(e, t) {
    var r, n = Il.mixins[t][e];
    for (r in n)
      this[r] = n[r];
  },
  _setPointsView: function(e, t) {
    this.getPoints().forEach(function(r) {
      t !== r && r.setView(e);
    });
  },
  _resetPointsView: function(e, t) {
    this.getPoints().forEach(function(r) {
      t !== r && r.resetView(e);
    });
  },
  _resetNearestPoint: function() {
    this._nearestPoint && this._nearestPoint.series !== null && this._nearestPoint.resetView(Tl), this._nearestPoint = null;
  },
  _setSelectedState: function(e) {
    this.lastSelectionMode = Wt(e || this._options.selectionMode), this.fullState = this.fullState | ry, this._resetNearestPoint(), this._changeStyle(this.lastSelectionMode), this.lastSelectionMode !== sg && this.isHovered() && FC(this.lastHoverMode) && this._resetPointsView(Tl);
  },
  _releaseSelectedState: function() {
    this.fullState = this.fullState & ~ry, this._changeStyle(this.lastSelectionMode, yd), this.lastSelectionMode !== sg && this.isHovered() && FC(this.lastHoverMode) && this._setPointsView(Tl);
  },
  isFullStackedSeries: function() {
    return this.type.indexOf("fullstacked") === 0;
  },
  isStackedSeries: function() {
    return this.type.indexOf("stacked") === 0;
  },
  resetApplyingAnimation: function(e) {
    this._resetApplyingAnimation = !0, e && (this._firstDrawing = !0);
  },
  isFinancialSeries: function() {
    return this.type === "stock" || this.type === "candlestick";
  },
  _canChangeView: function() {
    return !this.isSelected() && Wt(this._options.hoverMode) !== sg;
  },
  _changeStyle: function(e, t, r) {
    var n = this.fullState, i = [rce, Tl, yd, yd];
    this.lastHoverMode === "none" && (n &= ~ny), this.lastSelectionMode === "none" && (n &= ~ry), FC(e) && !r && (t ? this._resetPointsView(t) : this._setPointsView(i[n])), this._legendCallback([ice, nce, rz, rz][n]), this._applyStyle(this._styles[i[n]]);
  },
  updateHover: function(e, t) {
    var r = this._nearestPoint, n = this.isHovered() && this.lastHoverMode === oce && this.getNeighborPoint(e, t);
    n !== r && !(this.isSelected() && this.lastSelectionMode !== sg) && (this._resetNearestPoint(), n && (n.setView(Tl), this._nearestPoint = n));
  },
  _getMainAxisName: function() {
    return this._options.rotated ? "X" : "Y";
  },
  areLabelsVisible: function() {
    return !I(this._options.maxLabelCount) || this._points.length <= this._options.maxLabelCount;
  },
  getLabelVisibility: function() {
    return this.areLabelsVisible() && this._options.label && this._options.label.visible;
  },
  customizePoint: function(e, t) {
    var r = this._options, n = r.customizePoint, i, s, l, d, h = r.customizeLabel, p, m;
    h && h.call && (i = W({
      seriesName: this.name
    }, t), i.series = this, l = h.call(i, i), p = l && !Bd(l), l = p ? W(!0, {}, r.label, l) : null), n && n.call && (i = i || W({
      seriesName: this.name
    }, t), i.series = this, d = n.call(i, i), m = d && !Bd(d)), (p || m) && (s = this._parsePointOptions(this._preparePointOptions(d), l || r.label, t, e), s.styles.useLabelCustomOptions = p, s.styles.usePointCustomOptions = m, e.updateOptions(s));
  },
  show: function() {
    this._visible || this._changeVisibility(!0);
  },
  hide: function() {
    this._visible && this._changeVisibility(!1);
  },
  _changeVisibility: function(e) {
    this._visible = this._options.visible = e, this._updatePointsVisibility(), this.hidePointTooltip(), this._options.visibilityChanged(this);
  },
  _updatePointsVisibility: Y,
  hideLabels: function() {
    be(this._points, function(e, t) {
      t._label.draw(!1);
    });
  },
  _turnOffHatching(e, t) {
    e.hatching && (e.hatching.direction = "none"), t.hatching && (t.hatching.direction = "none");
  },
  _parsePointOptions: function(e, t, r, n) {
    var i = this._options, s = this._createPointStyles(e, r, n), l = W({}, e, {
      type: i.type,
      rotated: i.rotated,
      styles: s,
      widgetType: i.widgetType,
      visibilityChanged: i.visibilityChanged
    });
    return l.label = sce(t, s.labelColor), this.areErrorBarsVisible() && (l.errorBars = i.valueErrorBar), l;
  },
  _preparePointOptions: function(e) {
    var t = this._getOptionsForPoint();
    return e ? fce(t, e) : t;
  },
  _getMarkerGroupOptions: function() {
    return W(!1, {}, this._getOptionsForPoint(), {
      hoverStyle: {},
      selectionStyle: {}
    });
  },
  _getAggregationMethod: function(e, t) {
    var r = this.getOptions().aggregation, n = Wt(r.method), i = n === "custom" && r.calculate, s;
    return e && !t ? s = (l) => {
      var {
        data: d
      } = l;
      return d[0];
    } : s = this._aggregators[n] || this._aggregators[this._defaultAggregator], i || s;
  },
  _resample(e, t) {
    var {
      interval: r,
      ticks: n,
      aggregateByCategory: i
    } = e, s = this, l = s.argumentAxisType === NC || s.valueAxisType === NC, d = 0, h = this._getPointDataSelector(), p = s.getOptions(), m = (P, j, Z) => {
      if (j) {
        var ee = (J) => {
          var he = J && h(J, p);
          he && s._checkData(he) && (he.aggregationInfo = Z, P.push(he));
        };
        Array.isArray(j) ? j.forEach(ee) : ee(j);
      }
    }, x = this._getAggregationMethod(l, i);
    if (l)
      if (i) {
        var S = this.getArgumentAxis().getTranslator().getBusinessRange().categories, T = S.reduce((P, j) => (P[j.valueOf()] = [], P), {});
        return t.forEach((P) => {
          T[P.argument.valueOf()].push(P);
        }), S.reduce((P, j) => (m(P, x({
          aggregationInterval: null,
          intervalStart: j,
          intervalEnd: j,
          data: T[j.valueOf()].map(BC)
        }, s)), P), []);
      } else
        return t.reduce((P, j, Z, ee) => {
          if (P[1].push(j), Z === ee.length - 1 || (Z + 1) % r === 0) {
            var J = P[1], he = {
              aggregationInterval: r,
              data: J.map(BC)
            };
            m(P[0], x(he, s)), P[1] = [];
          }
          return P;
        }, [
          [],
          []
        ])[0];
    var k = [];
    if (n.length === 1) {
      var O = {
        intervalStart: n[0],
        intervalEnd: n[0],
        aggregationInterval: null,
        data: t.map(BC)
      };
      m(k, x(O, s), O);
    } else
      for (var D = 1; D < n.length; D++) {
        for (var L = n[D], F = n[D - 1], z = []; t[d] && t[d].argument < L; )
          t[d].argument >= F && z.push(t[d]), d++;
        var V = {
          intervalStart: F,
          intervalEnd: L,
          aggregationInterval: r,
          data: z.map(BC)
        };
        m(k, x(V, s), V);
      }
    return s._endUpdateData(), k;
  },
  canRenderCompleteHandle: function() {
    var e = this._canRenderCompleteHandle;
    return delete this._canRenderCompleteHandle, !!e;
  },
  isHovered: function() {
    return !!(1 & this.fullState);
  },
  isSelected: function() {
    return !!(2 & this.fullState);
  },
  isVisible: function() {
    return this._visible;
  },
  getAllPoints: function() {
    return this._createAllAggregatedPoints(), (this._points || []).slice();
  },
  getPointByPos: function(e) {
    return this._createAllAggregatedPoints(), (this._points || [])[e];
  },
  getVisiblePoints: function() {
    return (this._drawnPoints || []).slice();
  },
  selectPoint: function(e) {
    e.isSelected() || (cce(e, this._legendCallback), this._eventPipe({
      action: cz,
      target: e
    }), this._eventTrigger(iz, {
      target: e
    }));
  },
  deselectPoint: function(e) {
    e.isSelected() && (dce(e, this._legendCallback), this._eventPipe({
      action: dz,
      target: e
    }), this._eventTrigger(iz, {
      target: e
    }));
  },
  hover: function(e) {
    var t = this._eventTrigger;
    this.isHovered() || (this.lastHoverMode = Wt(e || this._options.hoverMode), this.fullState = this.fullState | ny, this._changeStyle(this.lastHoverMode, void 0, this.isSelected() && this.lastSelectionMode !== sg), t(az, {
      target: this
    }));
  },
  clearHover: function() {
    var e = this._eventTrigger;
    this.isHovered() && (this._resetNearestPoint(), this.fullState = this.fullState & ~ny, this._changeStyle(this.lastHoverMode, Tl, this.isSelected() && this.lastSelectionMode !== sg), e(az, {
      target: this
    }));
  },
  hoverPoint: function(e) {
    e.isHovered() || (e.clearHover(), lce(e, this._legendCallback), this._canChangeView() && this._applyStyle(this._styles.hover), this._eventPipe({
      action: sz,
      target: e
    }), this._eventTrigger(oz, {
      target: e
    }));
  },
  clearPointHover: function() {
    var e = this;
    e.getPoints().some(function(t) {
      return t.isHovered() ? (uce(t, e._legendCallback), e._canChangeView() && e._applyStyle(e._styles.normal), e._eventPipe({
        action: lz,
        target: t
      }), e._eventTrigger(oz, {
        target: t
      }), !0) : !1;
    });
  },
  showPointTooltip: function(e) {
    hz(this._extGroups.seriesGroup, "showpointtooltip", e);
  },
  hidePointTooltip: function(e) {
    hz(this._extGroups.seriesGroup, "hidepointtooltip", e);
  },
  select: function() {
    this.isSelected() || (this._setSelectedState(this._options.selectionMode), this._eventPipe({
      action: uz,
      target: this
    }), this._group.toForeground(), this._eventTrigger(nz, {
      target: this
    }));
  },
  clearSelection: function() {
    this.isSelected() && (this._releaseSelectedState(), this._eventTrigger(nz, {
      target: this
    }));
  },
  getPointsByArg: function(e, t) {
    var r = e.valueOf(), n = this.pointsByArgument[r];
    return !n && !t && this._createAllAggregatedPoints() && (n = this.pointsByArgument[r]), n || [];
  },
  _createAllAggregatedPoints: function() {
    return this.useAggregation() && !this._useAllAggregatedPoints ? (this.createPoints(!0), !0) : !1;
  },
  getPointsByKeys: function(e) {
    return this.getPointsByArg(e);
  },
  notify: function(e) {
    var t = this, r = e.action, n = t._seriesModes, i = e.target, s = i.getOptions(), l = Wt(s.hoverMode), d = Wt(s.selectionMode);
    r === sz ? t._hoverPointHandler(i, l, e.notifyLegend) : r === lz ? t._clearPointHoverHandler(i, l, e.notifyLegend) : r === uz ? i !== t && n.seriesSelectionMode === "single" && t.clearSelection() : r === cz ? (n.pointSelectionMode === "single" && t.getPoints().some(function(h) {
      return h !== i && h.isSelected() ? (t.deselectPoint(h), !0) : !1;
    }), t._selectPointHandler(i, d)) : r === dz && t._deselectPointHandler(i, d);
  },
  _selectPointHandler: function(e, t) {
    t === $_ ? e.series === this && this._setPointsView(yd, e) : t === VC && this.getPointsByKeys(e.argument, e.argumentIndex).forEach(function(r) {
      r !== e && r.setView(yd);
    });
  },
  _deselectPointHandler: function(e, t) {
    t === $_ ? e.series === this && this._resetPointsView(yd, e) : t === VC && this.getPointsByKeys(e.argument, e.argumentIndex).forEach(function(r) {
      r !== e && r.resetView(yd);
    });
  },
  _hoverPointHandler: function(e, t, r) {
    e.series !== this && t === VC ? (this.getPointsByKeys(e.argument, e.argumentIndex).forEach(function(n) {
      n.setView(Tl);
    }), r && this._legendCallback(e)) : t === $_ && e.series === this && this._setPointsView(Tl, e);
  },
  _clearPointHoverHandler: function(e, t, r) {
    t === VC ? (e.series !== this && this.getPointsByKeys(e.argument, e.argumentIndex).forEach(function(n) {
      n.resetView(Tl);
    }), r && this._legendCallback(e)) : t === $_ && e.series === this && this._resetPointsView(Tl, e);
  },
  _deletePoints: function() {
    this._disposePoints(this._points), this._points = this._drawnPoints = null;
  },
  _deleteTrackers: function() {
    be(this._trackers || [], function(e, t) {
      t.remove();
    }), this._trackersGroup && this._trackersGroup.dispose(), this._trackers = this._trackersGroup = null;
  },
  dispose: function() {
    this._deletePoints(), this._group.dispose(), this._labelsGroup && this._labelsGroup.dispose(), this._errorBarGroup && this._errorBarGroup.dispose(), this._deleteTrackers(), this._group = this._extGroups = this._markersGroup = this._elementsGroup = this._bordersGroup = this._labelsGroup = this._errorBarGroup = this._graphics = this._rangeData = this._renderer = this._styles = this._options = this._pointOptions = this._drawnPoints = this.pointsByArgument = this._segments = this._prevSeries = null;
  },
  correctPosition: Y,
  drawTrackers: Y,
  getNeighborPoint: Y,
  areErrorBarsVisible: Y,
  _getColorId: Y,
  getMarginOptions: function() {
    return this._patchMarginOptions({
      percentStick: this.isFullStackedSeries()
    });
  },
  getColor: function() {
    return this.getLegendStyles().normal.fill;
  },
  getOpacity: function() {
    return this._options.opacity;
  },
  getStackName: function() {
    return this._stackName;
  },
  getBarOverlapGroup: function() {
    return this._options.barOverlapGroup;
  },
  getPointByCoord: function(e, t) {
    var r = this.getNeighborPoint(e, t);
    return r != null && r.coordsIn(e, t) ? r : null;
  },
  getValueAxis: function() {
    return this._valueAxis;
  },
  getArgumentAxis: function() {
    return this._argumentAxis;
  },
  getMarkersGroup() {
    return this._markersGroup;
  },
  getRenderer() {
    return this._renderer;
  },
  removePointElements() {
    this._markersGroup && (be(this._points, (e, t) => t.deleteMarker()), this._markersGroup.dispose(), this._markersGroup = null);
  },
  removeGraphicElements() {
    var e = this;
    e._elementsGroup && (e._elementsGroup.dispose(), e._elementsGroup = null), be(e._graphics || [], (t, r) => {
      e._removeElement(r);
    }), e._graphics = null;
  },
  removeBordersGroup() {
    this._bordersGroup && (this._bordersGroup.dispose(), this._bordersGroup = null);
  }
};
var Ove = Il.mixins, hce = function(e, t) {
  return 1 / e === 1 / t;
}, vce = function(e, t) {
  if (e = kh(e, !0), t = kh(t, !0), e && t && zd(e) && zd(t))
    return t.is(e);
  var r = e !== e, n = t !== t;
  return r && n ? !0 : e === 0 && t === 0 ? hce(e, t) : e === null || typeof e != "object" || we.isElementNode(e) ? e === t : !1;
}, lR = {}, A5 = (e) => {
  var t = qa.current();
  return e.reduce((r, n) => {
    var {
      device: i,
      options: s
    } = n, l = i || {}, d = ct(l) ? l(t) : gce(t, l);
    return d && W(!0, r, s), r;
  }, {});
}, pce = (e, t) => typeof e != "string" ? e : {
  [e]: t
}, gce = (e, t) => Bd(t) || QH(e, [t]).length > 0, pz = (e) => e.substr(e.lastIndexOf(".") + 1), gz = (e) => e.substr(0, e.lastIndexOf(".")), mce = function(e, t) {
  return lR[t] = lR[t] || ac(t), lR[t](e, {
    functionsAsIs: !0
  });
};
var uR = {}, cR = {};
class _ce {
  constructor(t, r) {
    this._options = t, this._optionsByReference = r, this._changingCallback, this._changedCallback, this._namePreparedCallbacks;
  }
  _setByReference(t, r) {
    W(!0, t, r);
    for (var n in this._optionsByReference)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }
  _setPreparedValue(t, r, n, i) {
    var s = this.get(this._options, t, !1);
    if (!vce(s, r)) {
      var l = Ry(t);
      !i && this._changingCallback(t, s, r), cR[t] = cR[t] || jX(t), cR[t](this._options, r, {
        functionsAsIs: !0,
        merge: I(n) ? n : !this._optionsByReference[t],
        unwrapObservables: l.length > 1 && !!this._optionsByReference[l[0]]
      }), !i && this._changedCallback(t, r, s);
    }
  }
  _prepareRelevantNames(t, r, n, i) {
    if (Qr(n))
      for (var s in n)
        this._prepareRelevantNames(t, "".concat(r, ".").concat(s), n[s]);
    this._namePreparedCallbacks(t, r, n, i);
  }
  get() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._options, r = arguments.length > 1 ? arguments[1] : void 0, n = arguments.length > 2 ? arguments[2] : void 0;
    return uR[r] = uR[r] || ac(r), uR[r](t, {
      functionsAsIs: !0,
      unwrapObservables: n
    });
  }
  set(t, r, n, i) {
    t = pce(t, r);
    for (var s in t)
      this._prepareRelevantNames(t, s, t[s], i);
    for (var l in t)
      this._setPreparedValue(l, t[l], n, i);
  }
  onRelevantNamesPrepared(t) {
    this._namePreparedCallbacks = t;
  }
  onChanging(t) {
    this._changingCallback = t;
  }
  onChanged(t) {
    this._changedCallback = t;
  }
  dispose() {
    this._changingCallback = Y, this._changedCallback = Y;
  }
}
class yce {
  constructor(t, r, n, i) {
    this._deprecatedCallback, this._startChangeCallback, this._endChangeCallback, this._default = r, this._deprecated = i, this._deprecatedNames = [], this._initDeprecatedNames(), this._optionManager = new _ce(t, n), this._optionManager.onRelevantNamesPrepared((s, l, d, h) => this._setRelevantNames(s, l, d, h)), this._cachedOptions = {}, this._rules = [];
  }
  set _initial(t) {
    this._initialOptions = t;
  }
  get _initial() {
    if (!this._initialOptions) {
      var t = this._getByRules(this.silent("defaultOptionsRules"));
      this._initialOptions = this._default, this._optionManager._setByReference(this._initialOptions, t);
    }
    return this._initialOptions;
  }
  _initDeprecatedNames() {
    for (var t in this._deprecated)
      this._deprecatedNames.push(t);
  }
  _getByRules(t) {
    return t = Array.isArray(t) ? this._rules.concat(t) : this._rules, A5(t);
  }
  _notifyDeprecated(t) {
    var r = this._deprecated[t];
    r && this._deprecatedCallback(t, r);
  }
  _setRelevantNames(t, r, n, i) {
    if (r) {
      var s = this._normalizeName(r, i);
      s && s !== r && (this._setField(t, s, n), this._clearField(t, r));
    }
  }
  _setField(t, r, n) {
    var i = "", s = null;
    do
      i = i ? ".".concat(i) : "", i = pz(r) + i, r = gz(r), s = r ? this._optionManager.get(t, r, !1) : t;
    while (!s);
    s[i] = n;
  }
  _clearField(t, r) {
    delete t[r];
    var n = gz(r), i = n ? this._optionManager.get(t, n, !1) : t;
    i && delete i[pz(r)];
  }
  _normalizeName(t, r) {
    if (this._deprecatedNames.length && t) {
      for (var n = 0; n < this._deprecatedNames.length; n++)
        if (this._deprecatedNames[n] === t) {
          var i = this._deprecated[t];
          if (i)
            return !r && this._notifyDeprecated(t), i.alias || t;
        }
    }
    return t;
  }
  addRules(t) {
    this._rules = t.concat(this._rules);
  }
  applyRules(t) {
    var r = this._getByRules(t);
    this.silent(r);
  }
  dispose() {
    this._deprecatedCallback = Y, this._startChangeCallback = Y, this._endChangeCallback = Y, this._optionManager.dispose();
  }
  onChanging(t) {
    this._optionManager.onChanging(t);
  }
  onChanged(t) {
    this._optionManager.onChanged(t);
  }
  onDeprecated(t) {
    this._deprecatedCallback = t;
  }
  onStartChange(t) {
    this._startChangeCallback = t;
  }
  onEndChange(t) {
    this._endChangeCallback = t;
  }
  isInitial(t) {
    var r = this.silent(t), n = this.initial(t), i = ct(r) && ct(n);
    return i ? r.toString() === n.toString() : BR(r, n);
  }
  initial(t) {
    return mce(this._initial, t);
  }
  option(t, r) {
    var n = arguments.length < 2 && Wa(t) !== "object";
    if (n)
      return this._optionManager.get(void 0, this._normalizeName(t));
    this._startChangeCallback();
    try {
      this._optionManager.set(t, r);
    } finally {
      this._endChangeCallback();
    }
  }
  silent(t, r) {
    var n = arguments.length < 2 && Wa(t) !== "object";
    if (n)
      return this._optionManager.get(void 0, t, void 0, !0);
    this._optionManager.set(t, r, void 0, !0);
  }
  reset(t) {
    if (t) {
      var r = Ry(t), n = r.reduce((s, l) => s ? s[l] : this.initial(l), null), i = hi(n) ? ei({}, n) : n;
      this._optionManager.set(t, i, !1);
    }
  }
  getAliasesByName(t) {
    return Object.keys(this._deprecated).filter((r) => t === this._deprecated[r].alias);
  }
  isDeprecated(t) {
    return Object.prototype.hasOwnProperty.call(this._deprecated, t);
  }
  cache(t, r) {
    var n = arguments.length < 2;
    if (n)
      return this._cachedOptions[t];
    this._cachedOptions[t] = W(this._cachedOptions[t], r);
  }
}
class Wu {
  constructor(t, r) {
    r = r || {}, this._action = t, this._context = r.context || jr(), this._beforeExecute = r.beforeExecute, this._afterExecute = r.afterExecute, this._component = r.component, this._validatingTargetName = r.validatingTargetName;
    var n = this._excludeValidators = {};
    if (r.excludeValidators)
      for (var i = 0; i < r.excludeValidators.length; i++)
        n[r.excludeValidators[i]] = !0;
  }
  execute() {
    var t = {
      action: this._action,
      args: Array.prototype.slice.call(arguments),
      context: this._context,
      component: this._component,
      validatingTargetName: this._validatingTargetName,
      cancel: !1,
      handled: !1
    }, r = this._beforeExecute, n = this._afterExecute, i = t.args[0] || {};
    if (this._validateAction(t) && (r == null || r.call(this._context, t), !t.cancel)) {
      var s = this._executeAction(t);
      if (!i.cancel)
        return n == null || n.call(this._context, t), s;
    }
  }
  _validateAction(t) {
    var r = this._excludeValidators, {
      executors: n
    } = Wu;
    for (var i in n)
      if (!r[i]) {
        var s, l = n[i];
        if ((s = l.validate) === null || s === void 0 || s.call(l, t), t.cancel)
          return !1;
      }
    return !0;
  }
  _executeAction(t) {
    var r, {
      executors: n
    } = Wu;
    for (var i in n) {
      var s, l = n[i];
      if ((s = l.execute) === null || s === void 0 || s.call(l, t), t.handled) {
        r = t.result;
        break;
      }
    }
    return r;
  }
  static registerExecutor(t, r) {
    if (Qr(t)) {
      be(t, Wu.registerExecutor);
      return;
    }
    Wu.executors[t] = r;
  }
  static unregisterExecutor() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    be(r, function() {
      delete Wu.executors[this];
    });
  }
}
Wu.executors = {};
var mz = (e) => (t) => {
  if (t.args.length) {
    var r = t.args[0], n = r[t.validatingTargetName] || r.element;
    n && e(je(n)) && (t.cancel = !0);
  }
};
Wu.registerExecutor({
  disabled: {
    validate: mz((e) => e.is(".dx-state-disabled, .dx-state-disabled *"))
  },
  readOnly: {
    validate: mz((e) => e.is(".dx-state-readonly, .dx-state-readonly *:not(.dx-state-independent)"))
  },
  undefined: {
    execute: (e) => {
      e.action || (e.result = void 0, e.handled = !0);
    }
  },
  func: {
    execute: (e) => {
      ct(e.action) && (e.result = e.action.call(e.context, e.args[0]), e.handled = !0);
    }
  }
});
class xce {
  constructor() {
    this._postponedOperations = {};
  }
  add(t, r, n) {
    if (t in this._postponedOperations)
      n && this._postponedOperations[t].promises.push(n);
    else {
      var i = new Yt();
      this._postponedOperations[t] = {
        fn: r,
        completePromise: i,
        promises: n ? [n] : []
      };
    }
    return this._postponedOperations[t].completePromise.promise();
  }
  callPostponedOperations() {
    for (var t in this._postponedOperations) {
      var r = this._postponedOperations[t];
      I(r) && (r.promises && r.promises.length ? Ps(...r.promises).done(r.fn).then(r.completePromise.resolve) : r.fn().done(r.completePromise.resolve));
    }
    this._postponedOperations = {};
  }
}
var _z = (e) => e.charAt(2).toLowerCase() + e.substr(3), bce = (e) => e.indexOf("_", 0) === 0, O5 = Qi.inherit({
  _setDeprecatedOptions() {
    this._deprecatedOptions = {};
  },
  _getDeprecatedOptions() {
    return this._deprecatedOptions;
  },
  _getDefaultOptions: () => ({
    onInitialized: null,
    onOptionChanged: null,
    onDisposing: null,
    defaultOptionsRules: null
  }),
  _defaultOptionsRules: () => [],
  _setOptionsByDevice(e) {
    this._options.applyRules(e);
  },
  _convertRulesToOptions: (e) => A5(e),
  _isInitialOptionValue(e) {
    return this._options.isInitial(e);
  },
  _setOptionsByReference() {
    this._optionsByReference = {};
  },
  _getOptionsByReference() {
    return this._optionsByReference;
  },
  ctor() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, {
      _optionChangedCallbacks: t,
      _disposingCallbacks: r
    } = e;
    this.NAME = mT(this.constructor), this._eventsStrategy = zg.create(this, e.eventsStrategy), this._updateLockCount = 0, this._optionChangedCallbacks = t || Xa(), this._disposingCallbacks = r || Xa(), this.postponedOperations = new xce(), this._createOptions(e);
  },
  _createOptions(e) {
    this.beginUpdate();
    try {
      this._setOptionsByReference(), this._setDeprecatedOptions(), this._options = new yce(this._getDefaultOptions(), this._getDefaultOptions(), this._getOptionsByReference(), this._getDeprecatedOptions()), this._options.onChanging((t, r, n) => this._initialized && this._optionChanging(t, r, n)), this._options.onDeprecated((t, r) => this._logDeprecatedOptionWarning(t, r)), this._options.onChanged((t, r, n) => this._notifyOptionChanged(t, r, n)), this._options.onStartChange(() => this.beginUpdate()), this._options.onEndChange(() => this.endUpdate()), this._options.addRules(this._defaultOptionsRules()), e && e.onInitializing && e.onInitializing.apply(this, [e]), this._setOptionsByDevice(e.defaultOptionsRules), this._initOptions(e);
    } finally {
      this.endUpdate();
    }
  },
  _initOptions(e) {
    this.option(e);
  },
  _init() {
    this._createOptionChangedAction(), this.on("disposing", (e) => {
      this._disposingCallbacks.fireWith(this, [e]);
    });
  },
  _logDeprecatedOptionWarning(e, t) {
    var r = t.message || "Use the '".concat(t.alias, "' option instead");
    Dr.log("W0001", this.NAME, e, t.since, r);
  },
  _logDeprecatedComponentWarning(e, t) {
    Dr.log("W0000", this.NAME, e, "Use the '".concat(t, "' widget instead"));
  },
  _createOptionChangedAction() {
    this._optionChangedAction = this._createActionByOption("onOptionChanged", {
      excludeValidators: ["disabled", "readOnly"]
    });
  },
  _createDisposingAction() {
    this._disposingAction = this._createActionByOption("onDisposing", {
      excludeValidators: ["disabled", "readOnly"]
    });
  },
  _optionChanged(e) {
    switch (e.name) {
      case "onDisposing":
      case "onInitialized":
        break;
      case "onOptionChanged":
        this._createOptionChangedAction();
    }
  },
  _dispose() {
    this._optionChangedCallbacks.empty(), this._createDisposingAction(), this._disposingAction(), this._eventsStrategy.dispose(), this._options.dispose(), this._disposed = !0;
  },
  _lockUpdate() {
    this._updateLockCount++;
  },
  _unlockUpdate() {
    this._updateLockCount = Math.max(this._updateLockCount - 1, 0);
  },
  _isUpdateAllowed() {
    return this._updateLockCount === 0;
  },
  _isInitializingRequired() {
    return !this._initializing && !this._initialized;
  },
  isInitialized() {
    return this._initialized;
  },
  _commitUpdate() {
    this.postponedOperations.callPostponedOperations(), this._isInitializingRequired() && this._initializeComponent();
  },
  _initializeComponent() {
    this._initializing = !0;
    try {
      this._init();
    } finally {
      this._initializing = !1, this._lockUpdate(), this._createActionByOption("onInitialized", {
        excludeValidators: ["disabled", "readOnly"]
      })(), this._unlockUpdate(), this._initialized = !0;
    }
  },
  instance() {
    return this;
  },
  beginUpdate: function() {
    this._lockUpdate();
  },
  endUpdate: function() {
    this._unlockUpdate(), this._isUpdateAllowed() && this._commitUpdate();
  },
  _optionChanging: Y,
  _notifyOptionChanged(e, t, r) {
    if (this._initialized)
      for (var n = [e].concat(this._options.getAliasesByName(e)), i = 0; i < n.length; i++) {
        var s = n[i], l = {
          name: Ry(s)[0],
          fullName: s,
          value: t,
          previousValue: r
        };
        bce(s) || (this._optionChangedCallbacks.fireWith(this, [W(this._defaultActionArgs(), l)]), this._optionChangedAction(W({}, l))), !this._disposed && this._cancelOptionChange !== s && this._optionChanged(l);
      }
  },
  initialOption(e) {
    return this._options.initial(e);
  },
  _defaultActionConfig() {
    return {
      context: this,
      component: this
    };
  },
  _defaultActionArgs() {
    return {
      component: this
    };
  },
  _createAction(e, t) {
    var r;
    return (n) => (I(n) || (n = {}), Qr(n) || (n = {
      actionValue: n
    }), r = r || new Wu(e, W({}, t, this._defaultActionConfig())), r.execute.call(r, W(n, this._defaultActionArgs())));
  },
  _createActionByOption(e, t) {
    var r = this, n, i, s;
    t = W({}, t);
    var l = function() {
      if (!i) {
        if (t = t || {}, typeof e != "string")
          throw Dr.Error("E0008");
        e.indexOf("on") === 0 && (i = _z(e)), s = r.option(e);
      }
      if (!(!n && !s && !t.beforeExecute && !t.afterExecute && !r._eventsStrategy.hasEvent(i))) {
        if (!n) {
          var h = t.beforeExecute;
          t.beforeExecute = function() {
            for (var k = arguments.length, O = new Array(k), D = 0; D < k; D++)
              O[D] = arguments[D];
            h && h.apply(r, O), r._eventsStrategy.fireEvent(i, O[0].args);
          }, n = r._createAction(s, t);
        }
        for (var p = arguments.length, m = new Array(p), x = 0; x < p; x++)
          m[x] = arguments[x];
        if (Zr().wrapActionsBeforeExecute) {
          var S = r.option("beforeActionExecute") || Y, T = S(r, n, t) || n;
          return T.apply(r, m);
        }
        return n.apply(r, m);
      }
    };
    if (Zr().wrapActionsBeforeExecute)
      return l;
    var d = this.option("onActionCreated") || Y;
    return d(this, l, t) || l;
  },
  on(e, t) {
    return this._eventsStrategy.on(e, t), this;
  },
  off(e, t) {
    return this._eventsStrategy.off(e, t), this;
  },
  hasActionSubscription: function(e) {
    return !!this._options.silent(e) || this._eventsStrategy.hasEvent(_z(e));
  },
  isOptionDeprecated(e) {
    return this._options.isDeprecated(e);
  },
  _setOptionWithoutOptionChange(e, t) {
    this._cancelOptionChange = e, this.option(e, t), this._cancelOptionChange = !1;
  },
  _getOptionValue(e, t) {
    var r = this.option(e);
    return ct(r) ? r.bind(t)() : r;
  },
  option() {
    return this._options.option(...arguments);
  },
  resetOption(e) {
    this.beginUpdate(), this._options.reset(e), this.endUpdate();
  }
}), GL = function(e) {
  return function(t) {
    for (var r = je(t || "body"), n = r.filter(".dx-visibility-change-handler").add(r.find(".dx-visibility-change-handler")), i = 0; i < n.length; i++)
      Ve.triggerHandler(n[i], e);
  };
}, Sce = GL("dxshown"), kve = GL("dxhiding"), Rve = GL("dxresize"), Cce = Xa({
  syncStrategy: !0
});
class Wg {
  render(t) {
    t = t || {};
    var r = t.onRendered;
    delete t.onRendered;
    var n;
    return t.renovated && t.transclude && this._element ? n = je("<div>").append(this._element).contents() : n = this._renderCore(t), this._ensureResultInContainer(n, t.container), Cce.fire(n, t.container), r && r(), n;
  }
  _ensureResultInContainer(t, r) {
    if (r) {
      var n = je(r), i = vy(n.get(0), t.get(0));
      if (n.append(t), !i) {
        var s = we.getBody().contains(n.get(0));
        s && Sce(t);
      }
    }
  }
  _renderCore() {
    throw Dr.Error("E0001");
  }
}
class JD extends Wg {
  constructor(t) {
    super(), this._render = t;
  }
  _renderCore(t) {
    return AT(this._render(t));
  }
}
class k5 extends Wg {
  _renderCore() {
    return je();
  }
}
var Ece = function(e) {
  return e && e.get(0);
};
function R5(e) {
  return Ece(e);
}
class Tce extends Wg {
  constructor(t) {
    super(), this.name = t;
  }
}
var D5 = {}, vE;
function wce(e, t) {
  D5[e] = t;
}
function Ace(e) {
  if (lr(e)) {
    if (vE = D5[e], !vE)
      throw Dr.Error("E0020", e);
  } else
    vE = e;
}
function yz() {
  return vE;
}
wce("default", {
  compile: (e) => AT(e),
  render: (e, t, r) => e.clone()
});
Ace("default");
let Oce = class extends Wg {
  constructor(t) {
    super(), this._element = t;
  }
  _renderCore(t) {
    var r = t.transclude;
    return !r && !this._compiledTemplate && (this._compiledTemplate = yz().compile(this._element)), je("<div>").append(r ? this._element : yz().render(this._compiledTemplate, t.model, t.index)).contents();
  }
  source() {
    return je(this._element).clone();
  }
};
var kce = (e, t) => {
  var r = je(e).contents().filter("[".concat("data-options", '*="').concat(t, '"]'));
  return [].slice.call(r).map((n) => {
    var i = je(n).attr("data-options") || "";
    return {
      element: n,
      options: Zr().optionsParser(i)[t]
    };
  }).filter((n) => !!n.options);
}, Rce = (e) => {
  var t = zZ(e, (n) => n.options.name);
  if (t[void 0])
    throw Dr.Error("E0023");
  var r = {};
  return Object.keys(t).forEach((n) => {
    var i, s = (i = QH(qa.current(), t[n], (l) => l.options)[0]) === null || i === void 0 ? void 0 : i.element;
    s && (r[n] = s);
  }), r;
}, M5 = (e) => {
  var t = e.render.bind(e);
  return W({}, e, {
    render(r) {
      var n = t(r);
      return r && r.onRendered && r.onRendered(), n;
    }
  });
}, Dce = (e) => {
  var t = e.render.bind(e);
  return W({}, e, {
    render(r) {
      var n = je(r.container);
      return t(ei({}, r, {
        container: R5(n)
      }));
    }
  });
}, Mce = (e) => {
  var t = [];
  return "model" in e && t.push(e.model), "index" in e && t.push(e.index), t.push(e.container), t;
}, Lce = (e) => typeof e == "string" ? AT(e) : e, xz = (e) => zd(e) && e[0] || e, Pce = (e) => new Oce(e), Ice = (e, t, r, n) => {
  var i = null;
  return (!n || n.indexOf(e) === -1) && (i = t[e], i && !(i instanceof Wg) && (ct(i.render) && (i = Dce(i)), r || (i = M5(i)))), i;
}, bz = (e, t, r, n, i, s) => e == null ? new k5() : e instanceof Tce ? s[e.name] : e instanceof Wg ? e : ct(e.render) && !zd(e) ? n ? e : M5(e) : e.nodeType || zd(e) ? t(je(e)) : Ice(e, r, n, i) || s[e] || t(e), Nce = 3, Vce = "template", Fce = "dxTemplate", Bce = "dx-template-wrapper", zce = new JD((e) => {
  var {
    model: t,
    parent: r
  } = e, n = t.widget;
  if (!n)
    return je();
  var i = je("<div>"), s = t.options || {};
  return r ? r._createComponent(i, n, s) : i[n](s), i;
});
let Sz = class {
  constructor(t, r) {
    this._tempTemplates = [], this._defaultTemplates = {}, this._anonymousTemplateName = r || Vce, this._createElement = t || Pce, this._createTemplateIfNeeded = this._createTemplateIfNeeded.bind(this);
  }
  static createDefaultOptions() {
    return {
      integrationOptions: {
        watchMethod: function(t, r) {
          var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return n.skipImmediate || r(t()), Y;
        },
        templates: {
          "dx-polymorph-widget": zce
        },
        useDeferUpdateForTemplates: !0
      }
    };
  }
  get anonymousTemplateName() {
    return this._anonymousTemplateName;
  }
  addDefaultTemplates(t) {
    this._defaultTemplates = W({}, this._defaultTemplates, t);
  }
  dispose() {
    this._tempTemplates.forEach((t) => {
      t.template.dispose && t.template.dispose();
    }), this._tempTemplates = [];
  }
  extractTemplates(t) {
    var r = this._extractTemplates(t), n = this._extractAnonymousTemplate(t);
    return {
      templates: r,
      anonymousTemplateMeta: n
    };
  }
  _extractTemplates(t) {
    var r = kce(t, Fce), n = Rce(r);
    return r.forEach((i) => {
      var {
        element: s,
        options: {
          name: l
        }
      } = i;
      s === n[l] ? je(s).addClass(Bce).detach() : je(s).remove();
    }), Object.keys(n).map((i) => ({
      name: i,
      template: this._createTemplate(n[i])
    }));
  }
  _extractAnonymousTemplate(t) {
    var r = t.contents().detach(), n = r.filter((i, s) => {
      var l = s.nodeType === Nce, d = je(s).text().trim().length < 1;
      return !(l && d);
    });
    return n.length > 0 ? {
      template: this._createTemplate(r),
      name: this._anonymousTemplateName
    } : {};
  }
  _createTemplateIfNeeded(t) {
    var r = this._tempTemplates.filter((i) => i.source === xz(t))[0];
    if (r)
      return r.template;
    var n = this._createTemplate(t);
    return this._tempTemplates.push({
      template: n,
      source: xz(t)
    }), n;
  }
  _createTemplate(t) {
    return this._createElement(Lce(t));
  }
  getTemplate(t, r, n, i) {
    var {
      isAsyncTemplate: s,
      skipTemplates: l
    } = n;
    return ct(t) ? new JD((d) => {
      var h = t.apply(i, Mce(d));
      if (!I(h))
        return new k5();
      var p = !1, m = bz(h, (S) => S.nodeType || zd(S) && !je(S).is("script") ? new JD(() => S) : (p = !0, this._createTemplate(S)), r, s, l, this._defaultTemplates), x = m.render(d);
      return p && m.dispose && m.dispose(), x;
    }) : bz(t, this._createTemplateIfNeeded, r, s, l, this._defaultTemplates);
  }
};
var Cz = "compositionstart", Hce = "compositionend", Gce = "keydown", dR = "KeyboardProcessor", L5 = (e) => ({
  keyName: AZ(e),
  key: e.key,
  code: e.code,
  ctrl: e.ctrlKey,
  location: e.location,
  metaKey: e.metaKey,
  shift: e.shiftKey,
  alt: e.altKey,
  which: e.which,
  originalEvent: e
}), Uce = Qi.inherit({
  _keydown: En(Gce, dR),
  _compositionStart: En(Cz, dR),
  _compositionEnd: En(Hce, dR),
  ctor: function(e) {
    e = e || {}, e.element && (this._element = je(e.element)), e.focusTarget && (this._focusTarget = e.focusTarget), this._handler = e.handler, this._element && (this._processFunction = (t) => {
      var r = je(this._focusTarget).toArray(), n = this._focusTarget && this._focusTarget !== t.target && !r.includes(t.target), i = this._isComposingJustFinished && t.which === 229 || this._isComposing || n;
      this._isComposingJustFinished = !1, i || this.process(t);
    }, this._toggleProcessingWithContext = this.toggleProcessing.bind(this), Ve.on(this._element, this._keydown, this._processFunction), Ve.on(this._element, this._compositionStart, this._toggleProcessingWithContext), Ve.on(this._element, this._compositionEnd, this._toggleProcessingWithContext));
  },
  dispose: function() {
    this._element && (Ve.off(this._element, this._keydown, this._processFunction), Ve.off(this._element, this._compositionStart, this._toggleProcessingWithContext), Ve.off(this._element, this._compositionEnd, this._toggleProcessingWithContext)), this._element = void 0, this._handler = void 0;
  },
  process: function(e) {
    this._handler(L5(e));
  },
  toggleProcessing: function(e) {
    var {
      type: t
    } = e;
    this._isComposing = t === Cz, this._isComposingJustFinished = !this._isComposing;
  }
});
Uce.createKeyDownOptions = L5;
function bg(e, t) {
  return t ? En(e, t) : e;
}
var Ez = {
  on: function(e, t) {
    var {
      namespace: r
    } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    Ve.on(e, bg("dxresize", r), t);
  },
  off: function(e) {
    var {
      namespace: t
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Ve.off(e, bg("dxresize", t));
  }
};
var Tz = {
  on: (e, t, r, n) => {
    var {
      namespace: i
    } = n;
    Ve.on(e, bg("dxhiding", i), r), Ve.on(e, bg("dxshown", i), t);
  },
  off: (e, t) => {
    var {
      namespace: r
    } = t;
    Ve.off(e, bg("dxhiding", r)), Ve.off(e, bg("dxshown", r));
  }
};
function jce(e) {
  return new Uint8Array(atob(e).split("").map((t) => t.charCodeAt(0)));
}
function $ce(e) {
  var t, r;
  return new Uint8Array((r = (t = e.match(/.{1,2}/g)) === null || t === void 0 ? void 0 : t.map((n) => parseInt(n, 16))) !== null && r !== void 0 ? r : []);
}
function Yce(e) {
  for (var t = new Uint8Array(e.length), r = 0; r < e.length; r += 1)
    t[r] = 255 & e.charCodeAt(r);
  return t;
}
function Wce(e) {
  for (var t = new Uint8Array(4 * e.length), r = 0; r < t.length; r += 1)
    t[r] = e[r >> 2] >>> 8 * (3 - r % 4);
  return t;
}
function Xce(e) {
  for (var t = new Uint32Array(1 + (e.length - 1 >> 2)), r = 0; r < e.length; r += 1)
    t[r >> 2] |= e[r] << 8 * (3 - r % 4);
  return t;
}
function wz(e, t) {
  return (e << t | e >>> 32 - t) >>> 0;
}
function Az(e, t) {
  var r = new Uint8Array(e.length + t.length);
  return r.set(e, 0), r.set(t, e.length), r;
}
var P5 = {
  e: 65537,
  n: new Uint8Array([200, 219, 153, 203, 140, 7, 228, 253, 193, 243, 62, 137, 139, 60, 68, 242, 48, 142, 113, 88, 185, 235, 253, 105, 80, 74, 32, 170, 96, 74, 111, 250, 7, 205, 154, 3, 146, 115, 153, 53, 45, 132, 123, 56, 61, 208, 184, 201, 63, 24, 109, 223, 0, 179, 169, 102, 139, 224, 73, 233, 45, 173, 138, 66, 98, 88, 69, 76, 177, 111, 113, 218, 192, 33, 101, 152, 25, 134, 34, 173, 32, 82, 230, 44, 247, 200, 253, 170, 192, 246, 30, 12, 96, 205, 100, 249, 181, 93, 0, 231])
}, qce = "2D293FRQFEus9BTrBCkD5A", Kce = "3021300906052b0e03021a05000414";
function Zce(e) {
  var t = (8 * P5.n.length + 6) / 8, r = Az($ce(Kce), e);
  if (r.length + 10 > t)
    throw Error("Key is too short for SHA1 signing algorithm");
  var n = new Uint8Array(t - r.length);
  return n.fill(255, 0, n.length - 1), n[0] = 0, n[1] = 1, n[n.length - 1] = 0, Az(n, r);
}
function Qce(e) {
  try {
    var t = BigInt(0), r = BigInt(1), n = BigInt(8), i = (m) => m.reduce((x, S) => (x << n) + BigInt(S), t), s = i(e.actual), l = i(e.signature), d = BigInt(e.key.e), h = i(e.key.n), p = ((m, x, S) => {
      for (var T = r, k = m, O = x; O; )
        O & r && (T = T * k % S), k = k * k % S, O >>= r;
      return T;
    })(l, d, h);
    return p === s;
  } catch {
    return !0;
  }
}
function Jce(e) {
  var t = new Uint8Array(e.length + 1);
  t.set(Yce(e)), t[t.length - 1] = 128;
  var r = Xce(new Uint8Array(t)), n = new Uint32Array(16 * Math.ceil((r.length + 2) / 16));
  return n.set(r, 0), n[n.length - 1] = 8 * (t.length - 1), n;
}
function ede(e) {
  for (var t = Jce(e), r = new Uint32Array([1732584193, 4023233417, 2562383102, 271733878, 3285377520]), n = 0; n < t.length; n += 16) {
    for (var i = new Uint32Array(80), s = 0; s < 16; s += 1)
      i[s] = t[n + s];
    for (var l = 16; l < 80; l += 1) {
      var d = i[l - 3] ^ i[l - 8] ^ i[l - 14] ^ i[l - 16];
      i[l] = d << 1 | d >>> 31;
    }
    for (var h = r[0], p = r[1], m = r[2], x = r[3], S = r[4], T = 0; T < 80; T += 1) {
      var [k, O] = T < 20 ? [p & m | ~p & x, 1518500249] : T < 40 ? [p ^ m ^ x, 1859775393] : T < 60 ? [p & m | p & x | m & x, 2400959708] : [p ^ m ^ x, 3395469782], D = wz(h, 5) + k + S + O + i[T];
      S = x, x = m, m = wz(p, 30), p = h, h = D;
    }
    r[0] += h, r[1] += p, r[2] += m, r[3] += x, r[4] += S;
  }
  return Wce(r);
}
var $o;
(function(e) {
  e.corrupted = "corrupted", e.verified = "verified", e.internal = "internal";
})($o || ($o = {}));
var tde = function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var i = 0;
    for (n = Object.getOwnPropertySymbols(e); i < n.length; i++)
      t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
  }
  return r;
}, rde = ".", nde = 1, ide = 3, Oz = {
  kind: $o.corrupted,
  error: "general"
}, ade = {
  kind: $o.corrupted,
  error: "verification"
}, ode = {
  kind: $o.corrupted,
  error: "decoding"
}, sde = {
  kind: $o.corrupted,
  error: "deserialization"
}, lde = {
  kind: $o.corrupted,
  error: "payload"
}, ude = {
  kind: $o.corrupted,
  error: "version"
}, eM = !1;
function cde(e) {
  var {
    text: t,
    signature: r
  } = e;
  return Qce({
    key: P5,
    signature: jce(r),
    actual: Zce(ede(t))
  });
}
function dde(e) {
  if (e === void 0)
    return Oz;
  var t = e.split(rde);
  if (t.length !== 2 || t[0].length === 0 || t[1].length === 0)
    return Oz;
  if (!cde({
    text: t[0],
    signature: t[1]
  }))
    return ade;
  var r = "";
  try {
    r = atob(t[0]);
  } catch {
    return ode;
  }
  var n = {};
  try {
    n = JSON.parse(r);
  } catch {
    return sde;
  }
  var {
    customerId: i,
    maxVersionAllowed: s,
    format: l,
    internalUsageId: d
  } = n, h = tde(n, ["customerId", "maxVersionAllowed", "format", "internalUsageId"]);
  return d !== void 0 ? {
    kind: $o.internal,
    internalUsageId: d
  } : i === void 0 || s === void 0 || l === void 0 ? lde : l !== nde ? ude : {
    kind: $o.verified,
    payload: ei({
      customerId: i,
      maxVersionAllowed: s
    }, h)
  };
}
function fde(e) {
  var {
    licenseKey: t,
    version: r
  } = e, n = !1;
  try {
    var [i, s, l] = r.split(".").map(Number);
    if (n = isNaN(l) || l < ide, !t)
      return {
        preview: n,
        error: "W0019"
      };
    var d = dde(t);
    return d.kind === $o.corrupted ? {
      preview: n,
      error: "W0021"
    } : d.kind === $o.internal ? {
      preview: n,
      internal: !0,
      error: d.internalUsageId === qce ? void 0 : "W0020"
    } : i && s ? 10 * i + s > d.payload.maxVersionAllowed ? {
      preview: n,
      error: "W0020"
    } : {
      preview: n,
      error: void 0
    } : {
      preview: n,
      error: "W0021"
    };
  } catch {
    return {
      preview: n,
      error: "W0021"
    };
  }
}
function hde(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : fT;
  if (!eM) {
    eM = !0;
    var {
      preview: r,
      internal: n,
      error: i
    } = fde({
      licenseKey: e,
      version: t
    });
    if (i) {
      Dr.log(r ? "W0022" : i);
      return;
    }
    r && !n && Dr.log("W0022");
  }
}
function kz() {
  return eM;
}
const vde = {
  validateLicense: hde
};
var {
  abstract: zC
} = O5, zy = O5.inherit({
  _getDefaultOptions() {
    return W(this.callBase(), {
      width: void 0,
      height: void 0,
      rtlEnabled: Zr().rtlEnabled,
      elementAttr: {},
      disabled: !1,
      integrationOptions: {}
    }, this._useTemplates() ? Sz.createDefaultOptions() : {});
  },
  ctor(e, t) {
    this._customClass = null, this._createElement(e), Hq(this._$element, this, this._dispose), this.callBase(t);
    var r = kz();
    vde.validateLicense(Zr().licenseKey), !r && kz() && Zr({
      licenseKey: ""
    });
  },
  _createElement(e) {
    this._$element = je(e);
  },
  _getSynchronizableOptionsForCreateComponent: () => ["rtlEnabled", "disabled", "templatesRenderAsynchronously"],
  _checkFunctionValueDeprecation: function(e) {
    this.option("_ignoreFunctionValueDeprecation") || e.forEach((t) => {
      ct(this.option(t)) && Dr.log("W0017", t);
    });
  },
  _visibilityChanged: zC,
  _dimensionChanged: zC,
  _init() {
    this.callBase(), this._checkFunctionValueDeprecation(["width", "height", "maxHeight", "maxWidth", "minHeight", "minWidth", "popupHeight", "popupWidth"]), this._attachWindowResizeCallback(), this._initTemplateManager();
  },
  _setOptionsByDevice(e) {
    this.callBase([].concat(this.constructor._classCustomRules || [], e || []));
  },
  _isInitialOptionValue(e) {
    var t = this.constructor._classCustomRules && Object.prototype.hasOwnProperty.call(this._convertRulesToOptions(this.constructor._classCustomRules), e);
    return !t && this.callBase(e);
  },
  _attachWindowResizeCallback() {
    if (this._isDimensionChangeSupported()) {
      var e = this._windowResizeCallBack = this._dimensionChanged.bind(this);
      py.add(e);
    }
  },
  _isDimensionChangeSupported() {
    return this._dimensionChanged !== zC;
  },
  _renderComponent() {
    this._initMarkup(), fn() && this._render();
  },
  _initMarkup() {
    var {
      rtlEnabled: e
    } = this.option() || {};
    this._renderElementAttributes(), this._toggleRTLDirection(e), this._renderVisibilityChange(), this._renderDimensions();
  },
  _render() {
    this._attachVisibilityChangeHandlers(), ZX(this.$element());
  },
  _renderElementAttributes() {
    var {
      elementAttr: e
    } = this.option() || {}, t = W({}, e), r = t.class;
    delete t.class, this.$element().attr(t).removeClass(this._customClass).addClass(r), this._customClass = r;
  },
  _renderVisibilityChange() {
    if (this._isDimensionChangeSupported() && this._attachDimensionChangeHandlers(), this._isVisibilityChangeSupported()) {
      var e = this.$element();
      e.addClass("dx-visibility-change-handler");
    }
  },
  _renderDimensions() {
    var e = this.$element(), t = e.get(0), r = this._getOptionValue("width", t), n = this._getOptionValue("height", t);
    this._isCssUpdateRequired(t, n, r) && e.css({
      width: r === null ? "" : r,
      height: n === null ? "" : n
    });
  },
  _isCssUpdateRequired: (e, t, r) => !!(I(r) || I(t) || e.style.width || e.style.height),
  _attachDimensionChangeHandlers() {
    var e = this.$element(), t = "".concat(this.NAME, "VisibilityChange");
    Ez.off(e, {
      namespace: t
    }), Ez.on(e, () => this._dimensionChanged(), {
      namespace: t
    });
  },
  _attachVisibilityChangeHandlers() {
    if (this._isVisibilityChangeSupported()) {
      var e = this.$element(), t = "".concat(this.NAME, "VisibilityChange");
      this._isHidden = !this._isVisible(), Tz.off(e, {
        namespace: t
      }), Tz.on(e, () => this._checkVisibilityChanged("shown"), () => this._checkVisibilityChanged("hiding"), {
        namespace: t
      });
    }
  },
  _isVisible() {
    var e = this.$element();
    return e.is(":visible");
  },
  _checkVisibilityChanged(e) {
    var t = this._isVisible();
    t && (e === "hiding" && !this._isHidden ? (this._visibilityChanged(!1), this._isHidden = !0) : e === "shown" && this._isHidden && (this._isHidden = !1, this._visibilityChanged(!0)));
  },
  _isVisibilityChangeSupported() {
    return this._visibilityChanged !== zC && fn();
  },
  _clean: Y,
  _modelByElement() {
    var {
      modelByElement: e
    } = this.option(), t = this.$element();
    return e ? e(t) : void 0;
  },
  _invalidate() {
    if (this._isUpdateAllowed())
      throw Dr.Error("E0007");
    this._requireRefresh = !0;
  },
  _refresh() {
    this._clean(), this._renderComponent();
  },
  _dispose() {
    this._templateManager && this._templateManager.dispose(), this.callBase(), this._clean(), this._detachWindowResizeCallback();
  },
  _detachWindowResizeCallback() {
    this._isDimensionChangeSupported() && py.remove(this._windowResizeCallBack);
  },
  _toggleRTLDirection(e) {
    var t = this.$element();
    t.toggleClass("dx-rtl", e);
  },
  _createComponent(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = _M(this._getSynchronizableOptionsForCreateComponent(), (m) => !(m in r)), {
      integrationOptions: i
    } = this.option(), {
      nestedComponentOptions: s
    } = this.option();
    s = s || Y;
    var l = W({
      integrationOptions: i
    }, s(this));
    n.forEach((m) => l[m] = this.option(m)), this._extendConfig(r, l);
    var d = void 0;
    if (lr(t)) {
      var h = je(e)[t](r);
      d = h[t]("instance");
    } else
      e && (d = t.getInstance(e), d ? d.option(r) : d = new t(e, r));
    if (d) {
      var p = (m) => {
        var {
          name: x,
          value: S
        } = m;
        n.includes(x) && d.option(x, S);
      };
      this.on("optionChanged", p), d.on("disposing", () => this.off("optionChanged", p));
    }
    return d;
  },
  _extendConfig(e, t) {
    be(t, (r, n) => {
      !Object.prototype.hasOwnProperty.call(e, r) && (e[r] = n);
    });
  },
  _defaultActionConfig() {
    var e = this.$element(), t = this._modelByElement(e);
    return W(this.callBase(), {
      context: t
    });
  },
  _defaultActionArgs() {
    var e = this.$element(), t = this._modelByElement(e), r = this.element();
    return W(this.callBase(), {
      element: r,
      model: t
    });
  },
  _optionChanged(e) {
    switch (e.name) {
      case "width":
      case "height":
        this._renderDimensions();
        break;
      case "rtlEnabled":
        this._invalidate();
        break;
      case "elementAttr":
        this._renderElementAttributes();
        break;
      case "disabled":
      case "integrationOptions":
        break;
      default:
        this.callBase(e);
    }
  },
  _removeAttributes(e) {
    for (var t = e.attributes, r = t.length - 1; r >= 0; r--) {
      var n = t[r];
      if (n) {
        var {
          name: i
        } = n;
        (!i.indexOf("aria-") || i.indexOf("dx-") !== -1 || i === "role" || i === "style" || i === "tabindex") && e.removeAttribute(i);
      }
    }
  },
  _removeClasses(e) {
    e.className = e.className.split(" ").filter((t) => t.lastIndexOf("dx-", 0) !== 0).join(" ");
  },
  _updateDOMComponent(e) {
    e ? this._renderComponent() : this._requireRefresh && (this._requireRefresh = !1, this._refresh());
  },
  endUpdate() {
    var e = this._isInitializingRequired();
    this.callBase(), this._isUpdateAllowed() && this._updateDOMComponent(e);
  },
  $element() {
    return this._$element;
  },
  element() {
    var e = this.$element();
    return R5(e);
  },
  dispose() {
    var e = this.$element().get(0);
    pT(e, !0), e.textContent = "", this._removeAttributes(e), this._removeClasses(e);
  },
  resetOption(e) {
    if (this.callBase(e), e === "width" || e === "height") {
      var t = this.initialOption(e);
      !I(t) && this.$element().css(e, "");
    }
  },
  _getAnonymousTemplateName() {
  },
  _initTemplateManager() {
    if (!(this._templateManager || !this._useTemplates())) {
      var {
        integrationOptions: e = {}
      } = this.option(), {
        createTemplate: t
      } = e;
      this._templateManager = new Sz(t, this._getAnonymousTemplateName()), this._initTemplates();
    }
  },
  _initTemplates() {
    var {
      templates: e,
      anonymousTemplateMeta: t
    } = this._templateManager.extractTemplates(this.$element()), r = this.option("integrationOptions.templates.".concat(t.name));
    e.forEach((n) => {
      var {
        name: i,
        template: s
      } = n;
      this._options.silent("integrationOptions.templates.".concat(i), s);
    }), t.name && !r && (this._options.silent("integrationOptions.templates.".concat(t.name), t.template), this._options.silent("_hasAnonymousTemplateContent", !0));
  },
  _getTemplateByOption(e) {
    return this._getTemplate(this.option(e));
  },
  _getTemplate(e) {
    var t = this.option("integrationOptions.templates"), r = this.option("templatesRenderAsynchronously"), n = this.option("integrationOptions.skipTemplates");
    return this._templateManager.getTemplate(e, t, {
      isAsyncTemplate: r,
      skipTemplates: n
    }, this);
  },
  _saveTemplate(e, t) {
    this._setOptionWithoutOptionChange("integrationOptions.templates." + e, this._templateManager._createTemplate(t));
  },
  _useTemplates: () => !0
});
zy.getInstance = function(e) {
  return Gq(je(e), this);
};
zy.defaultOptions = function(e) {
  this._classCustomRules = this._classCustomRules || [], this._classCustomRules.push(e);
};
const I5 = hT(Dr.ERROR_MESSAGES, {
  E2001: "Invalid data source",
  E2002: "Axis type and data type are incompatible",
  E2003: 'The "{0}" data source field contains data of unsupported type',
  E2004: 'The "{0}" data source field is inconsistent',
  E2005: 'The value field "{0}" is absent in the data source or all its values are negative',
  E2006: "A cycle is detected in provided data",
  E2007: 'The value field "{0}" is absent in the data source',
  E2008: 'The value field "{0}" must be a string',
  E2009: 'The value field "{0}" must be a positive numeric value',
  E2101: "Unknown series type: {0}",
  E2102: "Ambiguity occurred between two value axes with the same name",
  E2103: 'The "{0}" option is given an invalid value. Assign a function instead',
  E2104: "Invalid logarithm base",
  E2105: 'Invalid value of a "{0}"',
  E2202: "Invalid {0} scale value",
  E2203: "The range you are trying to set is invalid",
  W2002: "The {0} series cannot be drawn because the {1} data field is missing",
  W2003: "Tick interval is too small",
  W2101: 'The "{0}" pane does not exist; the last pane is used by default',
  W2102: 'A value axis with the "{0}" name was created automatically',
  W2103: "The chart title was hidden due to the container size",
  W2104: "The legend was hidden due to the container size",
  W2105: 'The title of the "{0}" axis was hidden due to the container size',
  W2106: 'The labels of the "{0}" axis were hidden due to the container size',
  W2107: "The export menu was hidden due to the container size",
  W2108: "The browser does not support exporting images to {0} format.",
  W2301: "Invalid value range"
});
var Rz = jr(), pde = {
  observe: Y,
  unobserve: Y,
  disconnect: Y
};
class gde {
  constructor() {
    if (!fn() || !Rz.ResizeObserver)
      return pde;
    this._callbacksMap = /* @__PURE__ */ new Map(), this._observer = new Rz.ResizeObserver((t) => {
      t.forEach((r) => {
        var n;
        (n = this._callbacksMap.get(r.target)) === null || n === void 0 || n(r);
      });
    });
  }
  observe(t, r) {
    this._callbacksMap.set(t, r), this._observer.observe(t);
  }
  unobserve(t) {
    this._callbacksMap.delete(t), this._observer.unobserve(t);
  }
  disconnect() {
    this._callbacksMap.clear(), this._observer.disconnect();
  }
}
var Dz = new gde(), mde = I5.ERROR_MESSAGES;
function _de(e, t) {
  var r = {};
  be(e, function(l, d) {
    d.name && i(l);
  });
  var n;
  return s.change = function(l) {
    var d = e[l];
    return d && ((n = n || {})[l] = d), !!d;
  }, s.applyChanges = function() {
    n && (be(n, function(l, d) {
      i(d.newName || l);
    }), n = null);
  }, s.dispose = function() {
    e = t = r = null;
  }, s;
  function i(l) {
    var d = e[l];
    r[d.name] = t(l, d.actionSettings);
  }
  function s(l, d, h) {
    r[l](d), h && h();
  }
}
var yde = function(e, t) {
  return function(r, n) {
    t("incidentOccurred", {
      target: {
        id: r,
        type: r[0] === "E" ? "error" : "warning",
        args: n,
        text: xE.apply(null, [mde[r]].concat(n || [])),
        widget: e,
        version: fT
      }
    });
  };
};
function xde(e) {
  return (t, r) => {
    var {
      handler: n,
      dispose: i
    } = bde(e, r);
    return t(n), i;
  };
}
function bde(e, t) {
  var r, n = function() {
    clearTimeout(r), r = setTimeout(e, 100);
  };
  return {
    handler: n,
    dispose() {
      clearTimeout(r), t(n);
    }
  };
}
function Sde(e, t, r) {
  var n, i = xde(r);
  return Wt(t) === "windowonly" ? n = i((s) => py.add(s), (s) => py.remove(s)) : t === !0 && (n = i((s) => Dz.observe(e, s), () => Dz.unobserve(e))), n;
}
var Cde = !fn();
function tM() {
  this.reset();
}
tM.prototype = {
  constructor: tM,
  add: function(e) {
    var t, r = e.length, n = this._flags;
    for (t = 0; t < r; ++t)
      n[e[t]] = 1;
  },
  has: function(e) {
    return this._flags[e] > 0;
  },
  count: function() {
    return Object.keys(this._flags).length;
  },
  reset: function() {
    this._flags = {};
  }
};
function HC(e, t) {
  return e !== t ? W({}, e, t) : W({}, e);
}
function lh(e, t) {
  return e !== t ? e.concat(t) : e.slice();
}
function N5(e) {
  e._totalChangesOrder = e._optionChangesOrder.concat(e._layoutChangesOrder, e._customChangesOrder);
}
function Ede(e) {
  var t = this.prototype, r = e.code;
  t["_change_" + r] = e.handler, e.isThemeDependent && t._themeDependentChanges.push(r), e.option && (t._optionChangesMap[e.option] = r), (e.isOptionChange ? t._optionChangesOrder : t._customChangesOrder).push(r), N5(t);
}
function Mz() {
  var e = function t() {
    var r, n = t._chain.length, i;
    for (r = 0; r < n; ++r)
      i = t._chain[r].apply(this, arguments);
    return i;
  };
  return e._chain = [], e.add = function(t) {
    e._chain.push(t);
  }, e.copy = function(t) {
    e._chain = t._chain.slice();
  }, e;
}
function Tde(e, t, r) {
  var n = e[t];
  n ? n.add ? (Object.prototype.hasOwnProperty.call(e, t) === !1 && (n = Mz(), n.copy(e[t])), n.add(r)) : (n = Mz(), n.add(e[t]), n.add(r)) : n = r, e[t] = n;
}
function Lz(e) {
  var t = this.prototype;
  t._plugins.push(e), e.fontFields && t._fontFields.push.apply(t._fontFields, e.fontFields), e.members && W(this.prototype, e.members), e.customize && e.customize(this), e.extenders && Object.keys(e.extenders).forEach(function(r) {
    var n = e.extenders[r];
    Tde(t, r, n);
  }, this);
}
var wde = Cde ? function(e) {
  var t = e.inherit;
  e.inherit = function() {
    var r = t.apply(this, arguments), n = r.prototype;
    return ["_plugins", "_eventsMap", "_initialChanges", "_themeDependentChanges", "_optionChangesMap", "_optionChangesOrder", "_layoutChangesOrder", "_customChangesOrder", "_totalChangesOrder"].forEach(function(i) {
      n[i] = {};
    }), r.addPlugin = Y, r;
  }, e.addChange = Y, e.addPlugin = Y;
} : function(e) {
  var t = e.inherit;
  e.inherit = function() {
    var r = this.prototype, n = r._plugins, i = r._fontFields, s = r._eventsMap, l = r._initialChanges, d = r._themeDependentChanges, h = r._optionChangesMap, p = r._partialOptionChangesMap, m = r._partialOptionChangesPath, x = r._optionChangesOrder, S = r._layoutChangesOrder, T = r._customChangesOrder, k = t.apply(this, arguments);
    return r = k.prototype, r._plugins = lh(n, r._plugins), r._fontFields = lh(i, r._fontFields), r._eventsMap = HC(s, r._eventsMap), r._initialChanges = lh(l, r._initialChanges), r._themeDependentChanges = lh(d, r._themeDependentChanges), r._optionChangesMap = HC(h, r._optionChangesMap), r._partialOptionChangesMap = HC(p, r._partialOptionChangesMap), r._partialOptionChangesPath = HC(m, r._partialOptionChangesPath), r._optionChangesOrder = lh(x, r._optionChangesOrder), r._layoutChangesOrder = lh(S, r._layoutChangesOrder), r._customChangesOrder = lh(T, r._customChangesOrder), N5(r), k.addPlugin = Lz, k;
  }, e.prototype._plugins = [], e.prototype._fontFields = [], e.addChange = Ede, e.addPlugin = Lz;
};
function Ade() {
  return new tM();
}
var V5 = Math.min, F5 = Math.max, GC = Math.round, qT = 0, KT = 1, UL = 2, Ode = {
  left: qT,
  center: KT,
  right: UL
}, kde = {
  top: qT,
  center: KT,
  bottom: UL
}, Rde = {
  horizontal: 0,
  vertical: 1
}, ZT = {}, Dde = 2;
ZT[qT] = function(e, t, r) {
  return [e, V5(t, e + r)];
};
ZT[KT] = function(e, t, r) {
  return [F5(e, (e + t - r) / 2), V5(t, (e + t + r) / 2)];
};
ZT[UL] = function(e, t, r) {
  return [F5(e, t - r), t];
};
function fR(e, t, r) {
  var n = Wt(e);
  return n in t ? t[n] : r;
}
function Mde(e) {
  var t = fR(e.side, Rde, 1), r = [fR(e.horizontalAlignment, Ode, KT), fR(e.verticalAlignment, kde, qT)];
  return {
    side: t,
    primary: Lde(r[t]),
    secondary: r[1 - t],
    weak: e.weak,
    priority: e.priority || 0,
    header: e.header,
    position: e.position
  };
}
function Lde(e) {
  return e < 2 ? 0 : 2;
}
function Pde(e) {
  return 1 - e;
}
function Ide(e, t, r, n) {
  return ZT[e](t, r, n);
}
function rM(e, t) {
  return (e > 0 ? -1 : 1) * t;
}
function Nde(e, t, r) {
  var n = e.side, i = e.element.measure([t[2] - t[0], t[3] - t[1]]), s = e.position === "indside" ? 0 : r[n], l = i[n] < t[2 + n] - t[n] - s;
  return l && (e.position !== "inside" && (t[e.primary + n] += rM(e.primary, i[n])), e.size = i), l;
}
function nM(e, t, r) {
  var n = e.side, i = Pde(n), s = [], l = Ide(e.secondary, r[i], r[2 + i], e.size[i]);
  return s[n] = GC(s[2 + n] = t[e.primary + n] + (e.position === "inside" ? rM(e.primary, e.size[n]) : 0)), s[e.primary + n] = GC(t[e.primary + n] - rM(e.primary, e.size[n])), e.position !== "inside" && (t[e.primary + n] = s[e.primary + n]), s[i] = GC(l[0]), s[2 + i] = GC(l[1]), s;
}
function Vde(e, t, r, n, i, s) {
  var l = nM(e, t, r), d = nM(e, n, n);
  i[e.side] > 0 ? (i[e.side] -= e.size[e.side], s[e.primary + e.side] = l[e.primary + e.side], e.element.freeSpace()) : e.element.move(l, d);
}
function iM() {
  this._targets = [];
}
iM.prototype = {
  constructor: iM,
  dispose: function() {
    this._targets = null;
  },
  add: function(e) {
    this._targets.push(e);
  },
  forward: function(e, t) {
    var r = e.slice(), n = Fde(this._targets), i, s = n.length, l = [];
    for (i = 0; i < s; ++i)
      Nde(n[i], r, t) ? l.push(n[i]) : n[i].element.freeSpace();
    return this._cache = l.reverse(), r;
  },
  backward: function(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [0, 0], n = e.slice(), i = e.slice(), s = this._cache, l = 0, d, h, p = s.length;
    for (h = 0; h < p; ++h)
      d = s[h], d.side !== l && (n = e.slice()), Vde(d, n, t, i, r, e), l = d.side;
    return r;
  }
};
function Fde(e) {
  var t, r = e.length, n = [], i;
  for (t = 0; t < r; ++t)
    i = e[t].layoutOptions(), i && (i = Mde(i), i.element = e[t], n.push(i));
  return n.sort(function(s, l) {
    return l.side - s.side || s.priority - l.priority;
  }), n = Bde(n), n;
}
function Bde(e) {
  var t = e.filter(function(n) {
    return n.weak === !0;
  })[0], r;
  return t && (r = e.filter(function(n) {
    return t.primary === n.primary && n.side === t.side && n !== t;
  })[0]), t && r ? [zde(r, t)].concat(e.filter(function(n) {
    return !(n === r || n === t);
  })) : e;
}
function UC(e, t) {
  var r = t.slice(), n = nM(e, r, r);
  return n[e.side] = t[e.side], n[2 + e.side] = t[2 + e.side], n;
}
function zde(e, t) {
  var r = e.side, n = e.primary, i = e.secondary;
  return {
    side: r,
    primary: n,
    secondary: i,
    priority: 0,
    element: {
      measure: function(s) {
        var l = s.slice(), d = t.element.measure(s.slice());
        s[n] -= d[n];
        var h = e.element.measure(s.slice());
        return l[r] = d[r] = h[r] = Math.max(h[r], d[r]), t.size = d, e.size = h, l;
      },
      move: function(s, l) {
        if (l[2] - l[0] < e.size[0] + t.size[0] - Dde) {
          this.freeSpace();
          return;
        }
        var d = UC(t, l);
        l[2 + t.primary] = d[t.primary];
        var h = UC(e, l);
        l[2 + t.primary] < s[2 + t.primary] && e.size[e.primary] > s[2 + e.primary] - s[e.primary] && (s[2 + t.primary] = l[2 + t.primary]);
        var p = UC(e, s);
        p[2 + t.primary] > l[2 + t.primary] && (s[2 + t.primary] = l[2 + t.primary], p = UC(e, s)), t.element.move(d), e.element.move(p, h);
      },
      freeSpace: function() {
        e.element.freeSpace(), t.element.freeSpace();
      }
    }
  };
}
var Hde = {};
var Gde = () => Hde;
const Ude = {
  getGraphicObjects: Gde
};
var {
  log: jde
} = I5, Pz = "rtlEnabled", B5 = "dx-sized-element", Iz = zy.prototype.option;
function Nz() {
  return !0;
}
function hR() {
  return !1;
}
function $de(e) {
  e.component._eventsStrategy.hasEvent("incidentOccurred") || jde.apply(null, [e.target.id].concat(e.target.args || []));
}
function lg(e) {
  return e.reduce((t, r) => r > 0 && !t ? r : t, 0);
}
var Yde = function() {
  var e = {
    _initTemplates() {
    },
    ctor(n, i) {
      this.callBase(n, i);
      var s = we.createElement("div"), l = i && Sr(i.width) ? "".concat(i.width, "px") : "100%", d = i && Sr(i.height) ? "".concat(i.height, "px") : "".concat(this._getDefaultSize().height, "px");
      we.setStyle(s, "width", l), we.setStyle(s, "height", d), we.setClass(s, B5, !1), we.insertElement(n, s);
    }
  }, t = zy.inherit(e), r = t.inherit;
  return t.inherit = function(n) {
    return Object.keys(n).forEach((i) => {
      (ct(n[i]) && i.substr(0, 1) !== "_" && i !== "option" || i === "_dispose" || i === "_optionChanged") && (n[i] = Y);
    }), r.call(this, n);
  }, t;
};
function Vz(e) {
  e.forEach((t) => t());
}
var Wde = !fn();
function Xde(e) {
  return I(e) && e > 0;
}
var z5 = Wde ? Yde() : zy.inherit({
  _eventsMap: {
    onIncidentOccurred: {
      name: "incidentOccurred",
      actionSettings: {
        excludeValidators: ["disabled"]
      }
    },
    onDrawn: {
      name: "drawn",
      actionSettings: {
        excludeValidators: ["disabled"]
      }
    }
  },
  _getDefaultOptions() {
    return W(this.callBase(), {
      onIncidentOccurred: $de
    });
  },
  _useLinks: !0,
  _init() {
    this._$element.children(".".concat(B5)).remove(), this._graphicObjects = {}, this.callBase(...arguments), this._changesLocker = 0, this._optionChangedLocker = 0, this._asyncFirstDrawing = !0, this._changes = Ade(), this._suspendChanges(), this._themeManager = this._createThemeManager(), this._themeManager.setCallback(() => {
      this._requestChange(this._themeDependentChanges);
    }), this._renderElementAttributes(), this._initRenderer();
    var e = this._useLinks;
    e && this._renderer.root.enableLinks().virtualLink("core").virtualLink("peripheral"), this._renderVisibilityChange(), this._attachVisibilityChangeHandlers(), this._toggleParentsScrollSubscription(this._isVisible()), this._initEventTrigger(), this._incidentOccurred = yde(this.NAME, this._eventTrigger), this._layout = new iM(), e && this._renderer.root.linkAfter("core"), this._initPlugins(), this._initCore(), e && this._renderer.root.linkAfter(), this._change(this._initialChanges);
  },
  _createThemeManager() {
    return new rj(this._getThemeManagerOptions());
  },
  _getThemeManagerOptions() {
    return {
      themeSection: this._themeSection,
      fontFields: this._fontFields
    };
  },
  _initialChanges: ["LAYOUT", "RESIZE_HANDLER", "THEME", "DISABLED"],
  _initPlugins() {
    be(this._plugins, (e, t) => {
      t.init.call(this);
    });
  },
  _disposePlugins() {
    be(this._plugins.slice().reverse(), (e, t) => {
      t.dispose.call(this);
    });
  },
  _change(e) {
    this._changes.add(e);
  },
  _suspendChanges() {
    this._changesLocker += 1;
  },
  _resumeChanges() {
    --this._changesLocker === 0 && this._changes.count() > 0 && !this._applyingChanges && (this._renderer.lock(), this._applyingChanges = !0, this._applyChanges(), this._changes.reset(), this._applyingChanges = !1, this._changesApplied(), this._renderer.unlock(), this._optionsQueue && this._applyQueuedOptions(), this.resolveItemsDeferred(this._legend ? [this._legend] : []), this._optionChangedLocker += 1, this._notify(), this._optionChangedLocker -= 1);
  },
  resolveItemsDeferred(e) {
    this._resolveDeferred(this._getTemplatesItems(e));
  },
  _collectTemplatesFromItems: (e) => e.reduce((t, r) => ({
    items: t.items.concat(r.getTemplatesDef()),
    groups: t.groups.concat(r.getTemplatesGroups())
  }), {
    items: [],
    groups: []
  }),
  _getTemplatesItems(e) {
    var t = this._collectTemplatesFromItems(e), r = this._getExtraTemplatesItems();
    return {
      items: r.items.concat(t.items),
      groups: r.groups.concat(t.groups),
      launchRequest: [r.launchRequest],
      doneRequest: [r.doneRequest]
    };
  },
  _getExtraTemplatesItems: () => ({
    items: [],
    groups: [],
    launchRequest: () => {
    },
    doneRequest: () => {
    }
  }),
  _resolveDeferred(e) {
    var {
      items: t,
      launchRequest: r,
      doneRequest: n,
      groups: i
    } = e;
    if (this._setGroupsVisibility(i, "hidden"), this._changesApplying) {
      this._changesApplying = !1, Vz(n);
      return;
    }
    var s = !0;
    Ps.apply(this, t).done(() => {
      if (s) {
        this._setGroupsVisibility(i, "visible");
        return;
      }
      Vz(r), this._changesApplying = !0;
      var l = ["LAYOUT", "FULL_RENDER"];
      this._asyncFirstDrawing ? (l.push("FORCE_FIRST_DRAWING"), this._asyncFirstDrawing = !1) : l.push("FORCE_DRAWING"), this._requestChange(l), this._setGroupsVisibility(i, "visible");
    }), s = !1;
  },
  _setGroupsVisibility(e, t) {
    e.forEach((r) => r.attr({
      visibility: t
    }));
  },
  _applyQueuedOptions() {
    var e = this._optionsQueue;
    this._optionsQueue = null, this.beginUpdate(), be(e, (t, r) => {
      r();
    }), this.endUpdate();
  },
  _requestChange(e) {
    this._suspendChanges(), this._change(e), this._resumeChanges();
  },
  _applyChanges() {
    for (var e = this._changes, t = this._totalChangesOrder, r = t.length, n = 0; n < r; n += 1)
      e.has(t[n]) && this["_change_".concat(t[n])]();
  },
  _optionChangesOrder: ["EVENTS", "THEME", "RENDERER", "RESIZE_HANDLER"],
  _layoutChangesOrder: ["ELEMENT_ATTR", "CONTAINER_SIZE", "LAYOUT"],
  _customChangesOrder: ["DISABLED"],
  _change_EVENTS() {
    this._eventTrigger.applyChanges();
  },
  _change_THEME() {
    this._setThemeAndRtl();
  },
  _change_RENDERER() {
    this._setRendererOptions();
  },
  _change_RESIZE_HANDLER() {
    this._setupResizeHandler();
  },
  _change_ELEMENT_ATTR() {
    this._renderElementAttributes(), this._change(["CONTAINER_SIZE"]);
  },
  _change_CONTAINER_SIZE() {
    this._updateSize();
  },
  _change_LAYOUT() {
    this._setContentSize();
  },
  _change_DISABLED() {
    var e = this._renderer, {
      root: t
    } = e;
    this.option("disabled") ? (this._initDisabledState = t.attr("pointer-events"), t.attr({
      "pointer-events": "none",
      filter: e.getGrayScaleFilter().id
    })) : t.attr("pointer-events") === "none" && t.attr({
      "pointer-events": I(this._initDisabledState) ? this._initDisabledState : null,
      filter: null
    });
  },
  _themeDependentChanges: ["RENDERER"],
  _initRenderer() {
    var e = this._calculateRawCanvas();
    this._canvas = vD(e), this._renderer = new GE({
      cssClass: "".concat(this._rootClassPrefix, " ").concat(this._rootClass),
      pathModified: this.option("pathModified"),
      container: this._$element[0]
    }), this._renderer.resize(this._canvas.width, this._canvas.height);
  },
  _disposeRenderer() {
    this._renderer.dispose();
  },
  _disposeGraphicObjects() {
    Object.keys(this._graphicObjects).forEach((e) => {
      this._graphicObjects[e].dispose();
    }), this._graphicObjects = null;
  },
  _getAnimationOptions: Y,
  render() {
    this._requestChange(["CONTAINER_SIZE"]);
    var e = this._isVisible();
    this._toggleParentsScrollSubscription(e), !e && this._stopCurrentHandling();
  },
  _toggleParentsScrollSubscription(e) {
    var t = je(this._renderer.root.element).parents();
    qa.real().platform === "generic" && (t = t.add(jr())), this._proxiedTargetParentsScrollHandler = this._proxiedTargetParentsScrollHandler || (function() {
      this._stopCurrentHandling();
    }).bind(this), Ve.off(je("").add(this._$prevRootParents), "scroll.viz_widgets", this._proxiedTargetParentsScrollHandler), e && (Ve.on(t, "scroll.viz_widgets", this._proxiedTargetParentsScrollHandler), this._$prevRootParents = t);
  },
  _stopCurrentHandling: Y,
  _dispose() {
    this._disposed || (this.callBase(...arguments), this._toggleParentsScrollSubscription(!1), this._removeResizeHandler(), this._layout.dispose(), this._eventTrigger.dispose(), this._disposeCore(), this._disposePlugins(), this._disposeGraphicObjects(), this._disposeRenderer(), this._themeManager.dispose(), this._themeManager = null, this._renderer = null, this._eventTrigger = null);
  },
  _initEventTrigger() {
    this._eventTrigger = _de(this._eventsMap, (e, t) => this._createActionByOption(e, t));
  },
  _calculateRawCanvas() {
    var e = this.option("size") || {}, t = this.option("margin") || {}, r = this._getDefaultSize() || {}, n = (d, h, p) => {
      if (Xde(d[h]) || !fn())
        return 0;
      var m = p(this._$element);
      return m <= 1 ? 0 : m;
    }, i = n(e, "width", (d) => Mg(d)), s = n(e, "height", (d) => gT(d)), l = {
      width: e.width <= 0 ? 0 : lg([e.width, i, r.width]),
      height: e.height <= 0 ? 0 : lg([e.height, s, r.height]),
      left: lg([t.left, r.left]),
      top: lg([t.top, r.top]),
      right: lg([t.right, r.right]),
      bottom: lg([t.bottom, r.bottom])
    };
    return (l.width - l.left - l.right <= 0 || l.height - l.top - l.bottom <= 0) && (l = {
      width: 0,
      height: 0
    }), l;
  },
  _updateSize() {
    var e = this._calculateRawCanvas();
    (eU(this._canvas, e) || this.__forceRender) && (this._canvas = vD(e), this._recreateSizeDependentObjects(!0), this._renderer.resize(this._canvas.width, this._canvas.height), this._change(["LAYOUT"]));
  },
  _recreateSizeDependentObjects: Y,
  _getMinSize: () => [0, 0],
  _getAlignmentRect: Y,
  _setContentSize() {
    var e = this._canvas, t = this._layout, r = e.width > 0 && e.height > 0 ? [e.left, e.top, e.width - e.right, e.height - e.bottom] : [0, 0, 0, 0];
    r = t.forward(r, this._getMinSize());
    var n = this._applySize(r) || r;
    t.backward(n, this._getAlignmentRect() || n);
  },
  _getOption(e, t) {
    var r = this._themeManager.theme(e), n = this.option(e);
    return t ? n !== void 0 ? n : r : W(!0, {}, r, n);
  },
  _setupResizeHandler() {
    var e = zG(this._getOption("redrawOnResize", !0), !0);
    this._disposeResizeHandler && this._removeResizeHandler(), this._disposeResizeHandler = Sde(this._$element[0], e, () => this._requestChange(["CONTAINER_SIZE"]));
  },
  _removeResizeHandler() {
    this._disposeResizeHandler && (this._disposeResizeHandler(), this._disposeResizeHandler = null);
  },
  _onBeginUpdate: Y,
  beginUpdate() {
    return this._initialized && this._isUpdateAllowed() && (this._onBeginUpdate(), this._suspendChanges()), this.callBase(...arguments), this;
  },
  endUpdate() {
    return this.callBase(), this._isUpdateAllowed() && this._resumeChanges(), this;
  },
  option(e) {
    if (this._initialized && this._applyingChanges && (arguments.length > 1 || hi(e)))
      this._optionsQueue = this._optionsQueue || [], this._optionsQueue.push(this._getActionForUpdating(arguments));
    else
      return Iz.apply(this, arguments);
  },
  _getActionForUpdating(e) {
    return () => {
      Iz.apply(this, e);
    };
  },
  _clean: Y,
  _render: Y,
  _optionChanged(e) {
    if (!this._optionChangedLocker) {
      var t = this.getPartialChangeOptionsName(e), r = [];
      t.length > 0 ? t.forEach((n) => r.push(this._partialOptionChangesMap[n])) : r.push(this._optionChangesMap[e.name]), r = r.filter((n) => !!n), this._eventTrigger.change(e.name) ? this._change(["EVENTS"]) : r.length > 0 ? this._change(r) : this.callBase.apply(this, arguments);
    }
  },
  _notify: Y,
  _changesApplied: Y,
  _optionChangesMap: {
    size: "CONTAINER_SIZE",
    margin: "CONTAINER_SIZE",
    redrawOnResize: "RESIZE_HANDLER",
    theme: "THEME",
    rtlEnabled: "THEME",
    encodeHtml: "THEME",
    elementAttr: "ELEMENT_ATTR",
    disabled: "DISABLED"
  },
  _partialOptionChangesMap: {},
  _partialOptionChangesPath: {},
  getPartialChangeOptionsName(e) {
    var {
      fullName: t
    } = e, r = t.split(/[.]/), {
      name: n
    } = e, {
      value: i
    } = e, s = this._partialOptionChangesPath[n], l = [];
    return s && (s === !0 ? l.push(n) : (s.forEach((d) => {
      t.indexOf(d) >= 0 && l.push(d);
    }), r.length === 1 && (Wa(i) === "object" ? this._addOptionsNameForPartialUpdate(i, s, l) : Wa(i) === "array" && i.length > 0 && i.every((d) => this._checkOptionsForPartialUpdate(d, s)) && i.forEach((d) => {
      this._addOptionsNameForPartialUpdate(d, s, l);
    })))), l.filter((d, h, p) => p.indexOf(d) === h);
  },
  _checkOptionsForPartialUpdate: (e, t) => !Object.keys(e).some((r) => t.indexOf(r) === -1),
  _addOptionsNameForPartialUpdate(e, t, r) {
    var n = Object.keys(e);
    this._checkOptionsForPartialUpdate(e, t) && n.forEach((i) => t.indexOf(i) > -1 && r.push(i));
  },
  _visibilityChanged() {
    this.render();
  },
  _setThemeAndRtl() {
    this._themeManager.setTheme(this.option("theme"), this.option(Pz));
  },
  _getRendererOptions() {
    return {
      rtl: this.option(Pz),
      encodeHtml: this.option("encodeHtml"),
      animation: this._getAnimationOptions()
    };
  },
  _setRendererOptions() {
    this._renderer.setOptions(this._getRendererOptions());
  },
  svg() {
    return this._renderer.svg();
  },
  getSize() {
    var e = this._canvas || {};
    return {
      width: e.width,
      height: e.height
    };
  },
  isReady: hR,
  _dataIsReady: Nz,
  _resetIsReady() {
    this.isReady = hR;
  },
  _renderGraphicObjects() {
    var e = this._renderer, t = Ude.getGraphicObjects();
    Object.keys(t).forEach((r) => {
      if (!this._graphicObjects[r]) {
        var {
          type: n,
          colors: i,
          rotationAngle: s,
          template: l,
          width: d,
          height: h
        } = t[r];
        switch (n) {
          case "linear":
            this._graphicObjects[r] = e.linearGradient(i, r, s);
            break;
          case "radial":
            this._graphicObjects[r] = e.radialGradient(i, r);
            break;
          case "pattern":
            this._graphicObjects[r] = e.customPattern(r, this._getTemplate(l), d, h);
        }
      }
    });
  },
  _drawn() {
    this.isReady = hR, this._dataIsReady() && this._renderer.onEndAnimation(() => {
      this.isReady = Nz;
    }), this._eventTrigger("drawn", {});
  }
});
wde(z5);
class qde {
  constructor(t, r, n) {
    var i = t.getBoundingRect(), {
      x: s
    } = i, {
      y: l
    } = i, d = i.x + i.width, h = i.y + i.height;
    this.labels = [t], this.shiftFunction = n, this.bBox = {
      start: r ? s : l,
      width: r ? i.width : i.height,
      end: r ? d : h,
      oppositeStart: r ? l : s,
      oppositeEnd: r ? h : d
    }, this.initialPosition = r ? i.x : i.y;
  }
  toChain(t) {
    var r = t.getBoundingRect();
    t.shift(r.start - this.bBox.end), this.changeBoxWidth(r.width), this.labels = this.labels.concat(t.labels);
  }
  getBoundingRect() {
    return this.bBox;
  }
  shift(t) {
    this.labels.forEach((r) => {
      var n = r.getBoundingRect(), i = this.shiftFunction(n, t);
      r.hideInsideLabel(i) || r.shift(i.x, i.y);
    }), this.bBox.end -= t, this.bBox.start -= t;
  }
  setRollingStockInCanvas(t) {
    this.bBox.end > t.end && this.shift(this.bBox.end - t.end);
  }
  getLabels() {
    return this.labels;
  }
  value() {
    return this.labels[0].getData().value;
  }
  getInitialPosition() {
    return this.initialPosition;
  }
  changeBoxWidth(t) {
    this.bBox.end += t, this.bBox.width += t;
  }
}
var {
  isArray: Kde
} = Array, H5 = "_reinit", Zde = "_updateDataSource", Qde = "_dataInit", pE = "_forceRender", G5 = "_resize", Fz = [H5, Zde, Qde, pE, G5], vR = 0.3, Jde = ["series", "commonSeriesSettings", "dataPrepareSettings", "seriesSelectionMode", "pointSelectionMode", "synchronizeMultiAxes", "resolveLabelsOverlapping"], efe = ["minBubbleSize", "maxBubbleSize", "barGroupPadding", "barGroupWidth", "negativesAsZeroes", "negativesAsZeros"], tfe = ["adaptiveLayout", "crosshair", "resolveLabelOverlapping", "adjustOnZoom", "stickyHovering"], jC = "font";
function rfe(e, t) {
  var r = t.end - t.start, n = 0;
  for (e.forEach((i) => {
    n += i.getBoundingRect().width;
  }); r < n; )
    n -= nfe(e);
}
function nfe(e) {
  var t = e.reduce((n, i, s) => {
    if (!i)
      return n;
    var l = i.value();
    return l < n.value ? {
      value: l,
      rollingStock: i,
      index: s
    } : n;
  }, {
    rollingStock: void 0,
    value: 1 / 0,
    index: void 0
  });
  t.rollingStock.getLabels()[0].draw(!1);
  var {
    width: r
  } = t.rollingStock.getBoundingRect();
  return e[t.index] = null, r;
}
function ife(e) {
  var t, r, n, i, s = !1;
  for (t = 0, n = e.length - 1; t < n; t++) {
    for (r = t + 1, i = e.length; r < i; r++)
      if (t !== r && U5(e[t], e[r], !0)) {
        s = !0;
        break;
      }
    if (s)
      break;
  }
  return s;
}
function afe(e, t, r, n, i) {
  var s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : () => 0, l = [], d = {
    start: r ? t.left : t.top,
    end: r ? t.width - t.right : t.height - t.bottom
  }, h = !1, p;
  if (e.forEach((x) => {
    x && (h = h || x.series.isStackedSeries() || x.series.isFullStackedSeries(), x.getLabels().forEach((S) => {
      S.isVisible() && l.push(new qde(S, r, i));
    }));
  }), h)
    +!r ^ Number(n) && l.reverse(), p = n ? l : ofe(l);
  else {
    var m = l.slice();
    p = l.sort((x, S) => s(x, S) || x.getInitialPosition() - S.getInitialPosition() || m.indexOf(x) - m.indexOf(S));
  }
  return ife(p) ? (rfe(p, d), sfe(p), p.reverse(), ufe(p, d), !0) : !1;
}
function U5(e, t, r) {
  if (!(!e || !t)) {
    var n = e.getBoundingRect(), i = t.getBoundingRect(), s = r ? n.oppositeStart <= i.oppositeStart && n.oppositeEnd > i.oppositeStart || i.oppositeStart <= n.oppositeStart && i.oppositeEnd > n.oppositeStart : !0;
    return n.end > i.start && s;
  }
}
function ofe(e) {
  var t = [], r = [];
  return e.forEach((n) => {
    n.value() > 0 ? t.push(n) : r.unshift(n);
  }), t.concat(r);
}
function sfe(e) {
  for (var t, r = 0; r < e.length - 1; r += 1) {
    var n = t || e[r];
    U5(n, e[r + 1]) ? (n.toChain(e[r + 1]), e[r + 1] = null, t = n) : t = e[r + 1] || n;
  }
}
function lfe(e, t) {
  return e.getBoundingRect().end > t.end;
}
function ufe(e, t) {
  for (var r = 0; r < e.length; r += 1) {
    var n = e[r], i = !0;
    if (n !== null && lfe(n, t))
      for (var s = n.getBoundingRect(), l = r + 1; l < e.length; l += 1) {
        var d = e[l];
        if (d) {
          var h = d.getBoundingRect();
          if (h.end > s.start - (s.end - t.end)) {
            d.toChain(n), i = !1;
            break;
          }
        }
      }
    i && (n == null || n.setRollingStockInCanvas(t));
  }
}
function cfe(e) {
  return {
    nameField: "".concat(e, "Name"),
    colorField: "".concat(e, "Color"),
    indexField: "".concat(e, "Index")
  };
}
function dfe(e) {
  var t = cfe(e);
  return {
    getFormatObject(r) {
      var n = {};
      return n[t.indexField] = r.id, n[t.colorField] = r.states.normal.fill, n[t.nameField] = r.text, n;
    },
    textField: t.nameField
  };
}
function ffe(e, t) {
  return (e.x <= t.x && t.x <= e.x + e.width || e.x >= t.x && e.x <= t.x + t.width) && (e.y <= t.y && t.y <= e.y + e.height || e.y >= t.y && e.y <= t.y + t.height);
}
var aM = {
  resolveLabelOverlappingInOneDirection: afe
}, Yo = z5.inherit({
  _eventsMap: {
    onSeriesClick: {
      name: "seriesClick"
    },
    onPointClick: {
      name: "pointClick"
    },
    onArgumentAxisClick: {
      name: "argumentAxisClick"
    },
    onLegendClick: {
      name: "legendClick"
    },
    onSeriesSelectionChanged: {
      name: "seriesSelectionChanged"
    },
    onPointSelectionChanged: {
      name: "pointSelectionChanged"
    },
    onSeriesHoverChanged: {
      name: "seriesHoverChanged"
    },
    onPointHoverChanged: {
      name: "pointHoverChanged"
    },
    onDone: {
      name: "done",
      actionSettings: {
        excludeValidators: ["disabled"]
      }
    },
    onZoomStart: {
      name: "zoomStart"
    },
    onZoomEnd: {
      name: "zoomEnd"
    }
  },
  _fontFields: ["legend.".concat(jC), "legend.title.".concat(jC), "legend.title.subtitle.".concat(jC), "commonSeriesSettings.label.".concat(jC)],
  _rootClassPrefix: "dxc",
  _rootClass: "dxc-chart",
  _initialChanges: ["INIT"],
  _themeDependentChanges: ["REFRESH_SERIES_REINIT"],
  _getThemeManagerOptions() {
    var e = this.callBase.apply(this, arguments);
    return e.options = this.option(), e;
  },
  _createThemeManager() {
    var e = this.option(), t = new aae(this._getThemeManagerOptions());
    return t.setTheme(e.theme, e.rtlEnabled), t;
  },
  _initCore() {
    this._canvasClipRect = this._renderer.clipRect(), this._createHtmlStructure(), this._createLegend(), this._createTracker(), this._needHandleRenderComplete = !0, this.layoutManager = new DE(), this._createScrollBar(), Ve.on(this._$element, "contextmenu", (e) => {
      (wT(e) || VM(e)) && e.preventDefault();
    }), Ve.on(this._$element, "MSHoldVisual", (e) => {
      e.preventDefault();
    });
  },
  _getLayoutItems: Y,
  _layoutManagerOptions() {
    return this._themeManager.getOptions("adaptiveLayout");
  },
  _reinit() {
    q_(this._canvas), this._reinitAxes(), this._requestChange(["DATA_SOURCE", "DATA_INIT", "CORRECT_AXIS", "FULL_RENDER"]);
  },
  _correctAxes: Y,
  _createHtmlStructure() {
    var e = this._renderer, {
      root: t
    } = e, r = function() {
      return e.g().attr({
        class: "dxc-constant-lines-group"
      }).linkOn(t, "constant-lines");
    };
    this._constantLinesGroup = {
      dispose() {
        this.under.dispose(), this.above.dispose();
      },
      linkOff() {
        this.under.linkOff(), this.above.linkOff();
      },
      clear() {
        this.under.linkRemove().clear(), this.above.linkRemove().clear();
      },
      linkAppend() {
        this.under.linkAppend(), this.above.linkAppend();
      }
    }, this._labelsAxesGroup = e.g().attr({
      class: "dxc-elements-axes-group"
    });
    var n = () => {
      this._labelsAxesGroup.linkOn(t, "elements");
    };
    this._backgroundRect = e.rect().attr({
      fill: "gray",
      opacity: 1e-4
    }).append(t), this._panesBackgroundGroup = e.g().attr({
      class: "dxc-background"
    }).append(t), this._stripsGroup = e.g().attr({
      class: "dxc-strips-group"
    }).linkOn(t, "strips"), this._gridGroup = e.g().attr({
      class: "dxc-grids-group"
    }).linkOn(t, "grids"), this._panesBorderGroup = e.g().attr({
      class: "dxc-border"
    }).linkOn(t, "border"), this._axesGroup = e.g().attr({
      class: "dxc-axes-group"
    }).linkOn(t, "axes"), this._executeAppendBeforeSeries(n), this._stripLabelAxesGroup = e.g().attr({
      class: "dxc-strips-labels-group"
    }).linkOn(t, "strips-labels"), this._constantLinesGroup.under = r(), this._seriesGroup = e.g().attr({
      class: "dxc-series-group"
    }).linkOn(t, "series"), this._executeAppendAfterSeries(n), this._constantLinesGroup.above = r(), this._scaleBreaksGroup = e.g().attr({
      class: "dxc-scale-breaks"
    }).linkOn(t, "scale-breaks"), this._labelsGroup = e.g().attr({
      class: "dxc-labels-group"
    }).linkOn(t, "labels"), this._crosshairCursorGroup = e.g().attr({
      class: "dxc-crosshair-cursor"
    }).linkOn(t, "crosshair"), this._legendGroup = e.g().attr({
      class: "dxc-legend",
      "clip-path": this._getCanvasClipRectID()
    }).linkOn(t, "legend").linkAppend(t).enableLinks(), this._scrollBarGroup = e.g().attr({
      class: "dxc-scroll-bar"
    }).linkOn(t, "scroll-bar");
  },
  _executeAppendBeforeSeries() {
  },
  _executeAppendAfterSeries() {
  },
  _disposeObjectsInArray(e, t) {
    (this[e] || []).forEach((r) => {
      t && r ? t.forEach((n) => {
        var i;
        (i = r[n]) === null || i === void 0 || i.dispose();
      }) : r == null || r.dispose();
    }), this[e] = null;
  },
  _disposeCore() {
    var e = (n) => {
      this[n] && (this[n].dispose(), this[n] = null);
    }, t = (n) => {
      this[n].linkOff();
    }, r = this._disposeObjectsInArray;
    this._renderer.stopAllAnimations(), r.call(this, "series"), e("_tracker"), e("_crosshair"), this.layoutManager = this._userOptions = this._canvas = this._groupsData = null, t("_stripsGroup"), t("_gridGroup"), t("_axesGroup"), t("_constantLinesGroup"), t("_stripLabelAxesGroup"), t("_panesBorderGroup"), t("_seriesGroup"), t("_labelsGroup"), t("_crosshairCursorGroup"), t("_legendGroup"), t("_scrollBarGroup"), t("_scaleBreaksGroup"), e("_canvasClipRect"), e("_panesBackgroundGroup"), e("_backgroundRect"), e("_stripsGroup"), e("_gridGroup"), e("_axesGroup"), e("_constantLinesGroup"), e("_stripLabelAxesGroup"), e("_panesBorderGroup"), e("_seriesGroup"), e("_labelsGroup"), e("_crosshairCursorGroup"), e("_legendGroup"), e("_scrollBarGroup"), e("_scaleBreaksGroup");
  },
  _getAnimationOptions() {
    return this._themeManager.getOptions("animation");
  },
  _getDefaultSize: () => ({
    width: 400,
    height: 400
  }),
  _getOption(e) {
    return this._themeManager.getOptions(e);
  },
  _applySize(e) {
    this._rect = e.slice(), this._changes.has("FULL_RENDER") || this._processRefreshData(G5);
  },
  _resize() {
    this._doRender(this.__renderOptions || {
      animate: !1,
      isResize: !0
    });
  },
  _trackerType: "ChartTracker",
  _createTracker() {
    this._tracker = new Qne[this._trackerType]({
      seriesGroup: this._seriesGroup,
      renderer: this._renderer,
      tooltip: this._tooltip,
      legend: this._legend,
      eventTrigger: this._eventTrigger
    });
  },
  _getTrackerSettings() {
    return W({
      chart: this
    }, this._getSelectionModes());
  },
  _getSelectionModes() {
    var e = this._themeManager;
    return {
      seriesSelectionMode: e.getOptions("seriesSelectionMode"),
      pointSelectionMode: e.getOptions("pointSelectionMode")
    };
  },
  _updateTracker(e) {
    this._tracker.update(this._getTrackerSettings()), this._tracker.setCanvases({
      left: 0,
      right: this._canvas.width,
      top: 0,
      bottom: this._canvas.height
    }, e);
  },
  _createCanvasFromRect(e) {
    var t = this._canvas;
    return q_({
      left: e[0],
      top: e[1],
      right: t.width - e[2],
      bottom: t.height - e[3],
      width: t.width,
      height: t.height
    });
  },
  _doRender(e) {
    if (!(this._canvas.width === 0 && this._canvas.height === 0)) {
      this._resetIsReady();
      var t = this._prepareDrawOptions(e), {
        recreateCanvas: r
      } = t;
      this._preserveOriginalCanvas(), r ? this.__currentCanvas = this._canvas : this._canvas = this.__currentCanvas, r && this._updateCanvasClipRect(this._canvas), this._canvas = this._createCanvasFromRect(this._rect), this._renderer.stopAllAnimations(!0), this._cleanGroups();
      var n = /* @__PURE__ */ new Date();
      this._renderElements(t), this._lastRenderingTime = Number(/* @__PURE__ */ new Date()) - Number(n);
    }
  },
  _preserveOriginalCanvas() {
    this.__originalCanvas = this._canvas, this._canvas = W({}, this._canvas);
  },
  _layoutAxes: Y,
  _renderElements(e) {
    var t = this._prepareToRender(e), r = this._isRotated(), n = this._isLegendInside(), i = [];
    W({}, this._canvas);
    var s, l, d;
    this._renderer.lock(), e.drawLegend && this._legend && this._legendGroup.linkAppend(), this.layoutManager.setOptions(this._layoutManagerOptions());
    var h = this._getLayoutTargets();
    this._layoutAxes((p) => {
      var m = p ? W({}, e, {
        animate: !1,
        recreateCanvas: !0
      }) : e, x = this._renderAxes(m, t);
      this._shrinkAxes(p, x);
    }), this._applyClipRects(t), this._appendSeriesGroups(), this._createCrosshairCursor(), h.forEach((p) => {
      var {
        canvas: m
      } = p;
      i.push({
        left: m.left,
        right: m.width - m.right,
        top: m.top,
        bottom: m.height - m.bottom
      });
    }), this._scrollBar && (s = this._argumentAxes[0].getTranslator().getBusinessRange(), s.axisType === "discrete" && s.categories && s.categories.length <= 1 || s.axisType !== "discrete" && s.min === s.max ? l = d = void 0 : (l = s.minVisible, d = s.maxVisible), this._scrollBar.init(s, !this._argumentAxes[0].getOptions().valueMarginsEnabled).setPosition(l, d)), this._updateTracker(i), this._updateLegendPosition(e, n), this._applyPointMarkersAutoHiding(), this._renderSeries(e, r, n), this._renderGraphicObjects(), this._renderer.unlock();
  },
  _updateLegendPosition: Y,
  _createCrosshairCursor: Y,
  _appendSeriesGroups() {
    this._seriesGroup.linkAppend(), this._labelsGroup.linkAppend(), this._appendAdditionalSeriesGroups();
  },
  _renderSeries(e, t, r) {
    this._calculateSeriesLayout(e, t), this._renderSeriesElements(e, r);
  },
  _calculateSeriesLayout(e, t) {
    e.hideLayoutLabels = this.layoutManager.needMoreSpaceForPanesCanvas(this._getLayoutTargets(), t) && !this._themeManager.getOptions("adaptiveLayout").keepLabels, this._updateSeriesDimensions(e);
  },
  _getArgFilter: () => () => !0,
  _getValFilter: () => () => !0,
  _getPointsToAnimation(e) {
    var t = this._getArgFilter();
    return e.map((r) => {
      var n = this._getValFilter(r);
      return r.getPoints().filter((i) => i.getOptions().visible && t(i.argument) && (n(i.getMinValue(!0)) || n(i.getMaxValue(!0)))).length;
    });
  },
  _renderSeriesElements(e, t) {
    var {
      series: r
    } = this, n = this._themeManager.getOptions("resolveLabelOverlapping"), i = this._getPointsToAnimation(r);
    r.forEach((s, l) => {
      this._applyExtraSettings(s, e);
      var d = e.animate && i[l] <= e.animationPointsLimit && this._renderer.animationEnabled();
      s.draw(d, e.hideLayoutLabels, this._getLegendCallBack(s));
    }), n === "none" ? this._adjustSeriesLabels(!1) : this._locateLabels(n), this._renderTrackers(t), this._tracker.repairTooltip(), this._renderExtraElements(), this._clearCanvas(), this._seriesElementsDrawn = !0;
  },
  _changesApplied() {
    this._seriesElementsDrawn && (this._seriesElementsDrawn = !1, this._drawn(), this._renderCompleteHandler());
  },
  _locateLabels(e) {
    this._resolveLabelOverlapping(e);
  },
  _renderExtraElements() {
  },
  _clearCanvas() {
    this._canvas = this.__originalCanvas;
  },
  _resolveLabelOverlapping(e) {
    var t;
    switch (e) {
      case "stack":
        t = this._resolveLabelOverlappingStack;
        break;
      case "hide":
        t = this._resolveLabelOverlappingHide;
        break;
      case "shift":
        t = this._resolveLabelOverlappingShift;
    }
    return ct(t) && t.call(this);
  },
  _getVisibleSeries() {
    return _M(this.getAllSeries(), (e) => e.isVisible());
  },
  _resolveLabelOverlappingHide() {
    var e = [], t, r, n, i, s, l, d, h = this._getVisibleSeries();
    for (s = 0; s < h.length; s++)
      for (d = h[s].getVisiblePoints(), l = 0; l < d.length; l++)
        e.push.apply(e, d[l].getLabels());
    for (s = 0; s < e.length; s++)
      if (t = e[s], !!t.isVisible())
        for (n = t.getBoundingRect(), l = s + 1; l < e.length; l++)
          r = e[l], i = r.getBoundingRect(), ffe(n, i) && r.draw(!1);
  },
  _cleanGroups() {
    this._stripsGroup.linkRemove().clear(), this._gridGroup.linkRemove().clear(), this._axesGroup.linkRemove().clear(), this._constantLinesGroup.clear(), this._stripLabelAxesGroup.linkRemove().clear(), this._labelsGroup.linkRemove().clear(), this._crosshairCursorGroup.linkRemove().clear(), this._scaleBreaksGroup.linkRemove().clear();
  },
  _allowLegendInsidePosition: () => !1,
  _createLegend() {
    var e = dfe(this._legendDataField);
    this._legend = new fj({
      renderer: this._renderer,
      widget: this,
      group: this._legendGroup,
      backgroundClass: "dxc-border",
      itemGroupClass: "dxc-item",
      titleGroupClass: "dxc-title",
      textField: e.textField,
      getFormatObject: e.getFormatObject,
      allowInsidePosition: this._allowLegendInsidePosition()
    }), this._updateLegend(), this._layout.add(this._legend);
  },
  _updateLegend() {
    var e = this._themeManager, t = e.getOptions("legend"), r = this._getLegendData();
    t.containerBackgroundColor = e.getOptions("containerBackgroundColor"), t._incidentOccurred = this._incidentOccurred, this._legend.update(r, t, e.theme("legend").title), this._change(["LAYOUT"]);
  },
  _prepareDrawOptions(e) {
    var t = this._getAnimationOptions(), r = W({}, {
      force: !1,
      adjustAxes: !0,
      drawLegend: !0,
      drawTitle: !0,
      animate: t.enabled,
      animationPointsLimit: t.maxPointCountSupported
    }, e, this.__renderOptions);
    return I(r.recreateCanvas) || (r.recreateCanvas = r.adjustAxes && r.drawLegend && r.drawTitle), r;
  },
  _processRefreshData(e) {
    var t = Fz.indexOf(this._currentRefreshData), r = Fz.indexOf(e);
    (!this._currentRefreshData || t >= 0 && r < t) && (this._currentRefreshData = e), this._requestChange(["REFRESH"]);
  },
  _getLegendData() {
    return ti(this._getLegendTargets(), (e) => {
      var {
        legendData: t
      } = e, r = e.getLegendStyles, {
        opacity: n
      } = r.normal;
      e.visible || ((!I(n) || n > vR) && (n = vR), t.textOpacity = vR);
      var i = {
        opacity: n
      };
      return t.states = {
        hover: W({}, r.hover, i),
        selection: W({}, r.selection, i),
        normal: W({}, r.normal, i)
      }, t;
    });
  },
  _getLegendOptions(e) {
    return {
      legendData: {
        text: e[this._legendItemTextField],
        id: e.index,
        visible: !0
      },
      getLegendStyles: e.getLegendStyles(),
      visible: e.isVisible()
    };
  },
  _disposeSeries(e) {
    var t;
    this.series && (I(e) ? (this.series[e].dispose(), this.series.splice(e, 1)) : (this.series.forEach((r) => r.dispose()), this.series.length = 0)), !((t = this.series) === null || t === void 0) && t.length || (this.series = []);
  },
  _disposeSeriesFamilies() {
    (this.seriesFamilies || []).forEach((e) => {
      e.dispose();
    }), this.seriesFamilies = null, this._needHandleRenderComplete = !0;
  },
  _optionChanged(e) {
    this._themeManager.resetOptions(e.name), this.callBase.apply(this, arguments);
  },
  _applyChanges() {
    this._themeManager.update(this._options.silent()), this.callBase(...arguments);
  },
  _optionChangesMap: {
    animation: "ANIMATION",
    dataSource: "DATA_SOURCE",
    palette: "PALETTE",
    paletteExtensionMode: "PALETTE",
    legend: "FORCE_DATA_INIT",
    seriesTemplate: "FORCE_DATA_INIT",
    export: "FORCE_RENDER",
    valueAxis: "AXES_AND_PANES",
    argumentAxis: "AXES_AND_PANES",
    commonAxisSettings: "AXES_AND_PANES",
    panes: "AXES_AND_PANES",
    commonPaneSettings: "AXES_AND_PANES",
    defaultPane: "AXES_AND_PANES",
    containerBackgroundColor: "AXES_AND_PANES",
    rotated: "ROTATED",
    autoHidePointMarkers: "REFRESH_SERIES_REINIT",
    customizePoint: "REFRESH_SERIES_REINIT",
    customizeLabel: "REFRESH_SERIES_REINIT",
    scrollBar: "SCROLL_BAR"
  },
  _optionChangesOrder: ["ROTATED", "PALETTE", "REFRESH_SERIES_REINIT", "USE_SPIDER_WEB", "AXES_AND_PANES", "INIT", "REINIT", "DATA_SOURCE", "REFRESH_SERIES_DATA_INIT", "DATA_INIT", "FORCE_DATA_INIT", "REFRESH_AXES", "CORRECT_AXIS"],
  _customChangesOrder: ["ANIMATION", "REFRESH_SERIES_FAMILIES", "FORCE_FIRST_DRAWING", "FORCE_DRAWING", "FORCE_RENDER", "VISUAL_RANGE", "SCROLL_BAR", "REINIT", "REFRESH", "FULL_RENDER"],
  _change_ANIMATION() {
    this._renderer.updateAnimationOptions(this._getAnimationOptions());
  },
  _change_DATA_SOURCE() {
    this._needHandleRenderComplete = !0, this._updateDataSource();
  },
  _change_PALETTE() {
    this._themeManager.updatePalette(), this._refreshSeries("DATA_INIT");
  },
  _change_REFRESH_SERIES_DATA_INIT() {
    this._refreshSeries("DATA_INIT");
  },
  _change_DATA_INIT() {
    (!this.series || this.needToPopulateSeries) && !this._changes.has("FORCE_DATA_INIT") && this._dataInit();
  },
  _change_FORCE_DATA_INIT() {
    this._dataInit();
  },
  _change_REFRESH_SERIES_FAMILIES() {
    this._processSeriesFamilies(), this._populateBusinessRange(), this._processRefreshData(pE);
  },
  _change_FORCE_RENDER() {
    this._processRefreshData(pE);
  },
  _change_AXES_AND_PANES() {
    this._refreshSeries("INIT");
  },
  _change_ROTATED() {
    this._createScrollBar(), this._refreshSeries("INIT");
  },
  _change_REFRESH_SERIES_REINIT() {
    this._refreshSeries("INIT");
  },
  _change_REFRESH_AXES() {
    q_(this._canvas), this._reinitAxes(), this._requestChange(["CORRECT_AXIS", "FULL_RENDER"]);
  },
  _change_SCROLL_BAR() {
    this._createScrollBar(), this._processRefreshData(pE);
  },
  _change_REINIT() {
    this._processRefreshData(H5);
  },
  _change_FORCE_DRAWING() {
    this._resetComponentsAnimation();
  },
  _change_FORCE_FIRST_DRAWING() {
    this._resetComponentsAnimation(!0);
  },
  _resetComponentsAnimation(e) {
    this.series.forEach((t) => {
      t.resetApplyingAnimation(e);
    }), this._resetAxesAnimation(e);
  },
  _resetAxesAnimation: Y,
  _refreshSeries(e) {
    this.needToPopulateSeries = !0, this._requestChange([e]);
  },
  _change_CORRECT_AXIS() {
    this._correctAxes();
  },
  _doRefresh() {
    var e = this._currentRefreshData;
    e && (this._currentRefreshData = null, this._renderer.stopAllAnimations(!0), this[e]());
  },
  _updateCanvasClipRect(e) {
    var t = Math.max(e.width - e.left - e.right, 0), r = Math.max(e.height - e.top - e.bottom, 0);
    this._canvasClipRect.attr({
      x: e.left,
      y: e.top,
      width: t,
      height: r
    }), this._backgroundRect.attr({
      x: e.left,
      y: e.top,
      width: t,
      height: r
    });
  },
  _getCanvasClipRectID() {
    return this._canvasClipRect.id;
  },
  _dataSourceChangedHandler() {
    this._changes.has("INIT") ? this._requestChange(["DATA_INIT"]) : this._requestChange(["FORCE_DATA_INIT"]);
  },
  _dataInit() {
    this._dataSpecificInit(!0);
  },
  _processSingleSeries(e) {
    e.createPoints(!1);
  },
  _handleSeriesDataUpdated() {
    this._getVisibleSeries().some((e) => e.useAggregation()) && this._populateMarginOptions(), this.series.forEach((e) => this._processSingleSeries(e), this);
  },
  _dataSpecificInit(e) {
    (!this.series || this.needToPopulateSeries) && (this.series = this._populateSeries()), this._repopulateSeries(), this._seriesPopulatedHandlerCore(), this._populateBusinessRange(), this._tracker.updateSeries(this.series, this._changes.has("INIT")), this._updateLegend(), e && this._requestChange(["FULL_RENDER"]);
  },
  _forceRender() {
    this._doRender({
      force: !0
    });
  },
  _repopulateSeries() {
    var e = this._themeManager, t = this._dataSourceItems(), r = e.getOptions("dataPrepareSettings"), n = e.getOptions("seriesTemplate");
    n && this._populateSeries(t), this._groupSeries();
    var i = Dae(t, this._groupsData, this._incidentOccurred, r);
    e.resetPalette(), this.series.forEach((s) => {
      s.updateData(i[s.getArgumentField()]);
    }), this._handleSeriesDataUpdated();
  },
  _renderCompleteHandler() {
    var e = !0;
    this._needHandleRenderComplete && (this.series.forEach((t) => {
      e = e && t.canRenderCompleteHandle();
    }), e && (this._needHandleRenderComplete = !1, this._eventTrigger("done", {
      target: this
    })));
  },
  _dataIsReady() {
    return I(this.option("dataSource")) && this._dataIsLoaded();
  },
  _populateSeriesOptions(e) {
    for (var t = this._themeManager, r = t.getOptions("seriesTemplate"), n = r ? FK(r, e || []) : this.option("series"), i = Kde(n) ? n : n ? [n] : [], s = this._getExtraOptions(), l, d, h = [], p = (x) => {
      this._specialProcessSeries(), this._populateBusinessRange(x && x.getValueAxis(), !0), this._renderer.stopAllAnimations(!0), this._updateLegend(), this._requestChange(["FULL_RENDER"]);
    }, m = 0; m < i.length; m++)
      l = W(!0, {}, i[m], s), (!I(l.name) || l.name === "") && (l.name = "Series ".concat((m + 1).toString())), l.rotated = this._isRotated(), l.customizePoint = t.getOptions("customizePoint"), l.customizeLabel = t.getOptions("customizeLabel"), l.visibilityChanged = p, l.incidentOccurred = this._incidentOccurred, d = t.getOptions("series", l, i.length), this._checkPaneName(d) && h.push(d);
    return h;
  },
  _populateSeries(e) {
    var t, r = [], n = this._incidentOccurred, i = this._populateSeriesOptions(e), s, l = !1;
    this.needToPopulateSeries = !1, i.forEach((h) => {
      var p, m = (p = this.series) === null || p === void 0 ? void 0 : p.find((x) => x.name === h.name && !r.map((S) => S.series).includes(x));
      m && m.type === h.type ? r.push({
        series: m,
        options: h
      }) : (r.push({
        options: h
      }), l = !0);
    }), ((t = this.series) === null || t === void 0 ? void 0 : t.length) !== 0 && this._tracker.clearHover(), jH(this.series, (h, p) => {
      r.some((m) => p === m.series) || (this._disposeSeries(h), l = !0);
    }), !l && (l = r.some((h) => h.series.name !== i[h.series.index].name)), this.series = [], l && this._disposeSeriesFamilies(), this._themeManager.resetPalette();
    var d = (h) => {
      this.series.forEach((p) => {
        p.notify(h);
      });
    };
    return r.forEach((h) => {
      var p, m, x = h.options, S = (m = (p = this._argumentAxes) === null || p === void 0 ? void 0 : p.filter((k) => k.pane === x.pane)[0]) !== null && m !== void 0 ? m : this.getArgumentAxis(), T = {
        commonSeriesModes: this._getSelectionModes(),
        argumentAxis: S,
        valueAxis: this._getValueAxis(x.pane, x.axis)
      };
      h.series ? (s = h.series, s.updateOptions(x, T)) : s = new QD(W({
        renderer: this._renderer,
        seriesGroup: this._seriesGroup,
        labelsGroup: this._labelsGroup,
        eventTrigger: this._eventTrigger,
        eventPipe: d,
        incidentOccurred: n
      }, T), x), s.isUpdated ? (s.index = this.series.length, this.series.push(s)) : n("E2101", [x.type]);
    }), this.series;
  },
  getStackedPoints(e) {
    var t = e.series.getStackName();
    return this._getVisibleSeries().reduce((r, n) => ((!I(n.getStackName()) || !I(t) || t === n.getStackName()) && (r = r.concat(n.getPointsByArg(e.argument))), r), []);
  },
  getAllSeries: function() {
    return (this.series || []).slice();
  },
  getSeriesByName: function(e) {
    var t = (this.series || []).find((r) => r.name === e);
    return t || null;
  },
  getSeriesByPos: function(e) {
    return (this.series || [])[e];
  },
  clearSelection: function() {
    this._tracker.clearSelection();
  },
  hideTooltip() {
    this._tracker._hideTooltip();
  },
  clearHover() {
    this._tracker.clearHover();
  },
  render(e) {
    return this.__renderOptions = e, this.__forceRender = e && e.force, this.callBase.apply(this, arguments), this.__renderOptions = this.__forceRender = null, this;
  },
  refresh() {
    this._disposeSeries(), this._disposeSeriesFamilies(), this._requestChange(["CONTAINER_SIZE", "REFRESH_SERIES_REINIT"]);
  },
  _getMinSize() {
    var e = this._layoutManagerOptions();
    return [e.width, e.height];
  },
  _change_REFRESH() {
    this._changes.has("INIT") ? this._currentRefreshData = null : this._doRefresh();
  },
  _change_FULL_RENDER() {
    this._forceRender();
  },
  _change_INIT() {
    this._reinit();
  },
  _stopCurrentHandling() {
    this._disposed || this._tracker.stopCurrentHandling();
  }
});
Jde.forEach((e) => {
  Yo.prototype._optionChangesMap[e] = "REFRESH_SERIES_DATA_INIT";
});
tfe.forEach((e) => {
  Yo.prototype._optionChangesMap[e] = "FORCE_RENDER";
});
efe.forEach((e) => {
  Yo.prototype._optionChangesMap[e] = "REFRESH_SERIES_FAMILIES";
});
Yo.addPlugin(Lle);
Yo.addPlugin(Fae);
Yo.addPlugin(bse);
Yo.addPlugin(wte);
Yo.addPlugin(Vle);
var {
  _change_TITLE: hfe
} = Yo.prototype;
Yo.prototype._change_TITLE = function() {
  hfe.apply(this, arguments), this._change(["FORCE_RENDER"]);
};
var {
  isArray: hh
} = Array, vfe = "defaultAxisName", Bz = "font", zz = "commonAxisSettings", Hz = "default", $C = "VISUAL_RANGE";
function Gz(e) {
  return hh(e) ? e.length === 0 ? [{}] : e : [e];
}
function pfe(e, t) {
  return e.processBubbleSize && (e.size = t), e;
}
function gfe(e, t, r, n) {
  var i = n ? e.width / t : e.width, s = n ? e.height : e.height / t;
  return Math.min(i, s) * r;
}
function Uz(e, t, r, n) {
  var i, s;
  if (r) {
    s = e.value, i = {
      skipEventRising: !0
    };
    var l = j5(e.fullName, s);
    l && (i = {
      allowPartialUpdate: !0
    }, s = l);
  } else
    s = (I(n) ? e.value[n] : e.value).visualRange;
  t.visualRange(s, i);
}
function mfe(e, t, r) {
  if (r)
    return {
      argumentAxisType: e.argumentAxisType,
      argumentType: e.argumentType
    };
  var {
    valueAxisType: n,
    valueType: i
  } = e.groups.find((s) => s.valueAxis === t);
  return {
    valueAxisType: n,
    valueType: i
  };
}
function j5(e, t) {
  var r = e.split("."), n = r.at(-1);
  if (n === "endValue" || n === "startValue")
    return {
      [n]: t
    };
}
var _fe = Yo.inherit({
  _fontFields: ["".concat(zz, ".label.").concat(Bz), "".concat(zz, ".title.").concat(Bz)],
  _partialOptionChangesMap: {
    visualRange: $C,
    _customVisualRange: $C,
    strips: "REFRESH_AXES",
    constantLines: "REFRESH_AXES"
  },
  _partialOptionChangesPath: {
    argumentAxis: ["strips", "constantLines", "visualRange", "_customVisualRange"],
    valueAxis: ["strips", "constantLines", "visualRange", "_customVisualRange"]
  },
  _initCore() {
    this._panesClipRects = {}, this.callBase();
  },
  _disposeCore() {
    var e = this._disposeObjectsInArray, t = this._panesClipRects;
    this.callBase(), e.call(t, "fixed"), e.call(t, "base"), e.call(t, "wide"), this._panesClipRects = null, this._labelsAxesGroup.linkOff(), this._labelsAxesGroup.dispose(), this._labelsAxesGroup = null;
  },
  _dispose() {
    var e = this._disposeObjectsInArray;
    this.callBase(), this.panes = null, this._legend && (this._legend.dispose(), this._legend = null), e.call(this, "panesBackground"), e.call(this, "seriesFamilies"), this._disposeAxes();
  },
  _createPanes() {
    this._cleanPanesClipRects("fixed"), this._cleanPanesClipRects("base"), this._cleanPanesClipRects("wide");
  },
  _cleanPanesClipRects(e) {
    var t = this._panesClipRects[e];
    (t || []).forEach((r) => {
      r == null || r.dispose();
    }), this._panesClipRects[e] = [];
  },
  _getElementsClipRectID(e) {
    var t = this._panesClipRects.fixed[this._getPaneIndex(e)];
    return t == null ? void 0 : t.id;
  },
  _getPaneIndex(e) {
    var t = e || Hz;
    return this.panes.findIndex((r) => r.name === t);
  },
  _updateSize(e) {
    this.callBase(), e && eU(this.__currentCanvas, this._canvas) && (this.__currentCanvas = vD(this._canvas)), q_(this._canvas);
  },
  _reinitAxes() {
    this.panes = this._createPanes(), this._populateAxes(), this._axesReinitialized = !0;
  },
  _populateAxes() {
    var {
      panes: e
    } = this, t = this._isRotated(), r = Gz(this.option("argumentAxis") || {})[0], n = this.option("valueAxis"), i = Gz(n || {}), s, l = [], d = [], h = 0, p, m = this._getCrosshairMargins();
    function x() {
      var S = vfe + String(h);
      return h += 1, S;
    }
    t ? p = r.position === "right" ? e[e.length - 1].name : e[0].name : p = r.position === "top" ? e[0].name : e[e.length - 1].name, s = ti(e, (S) => {
      var T = S.name !== p;
      return this._populateAxesOptions("argumentAxis", r, {
        pane: S.name,
        name: null,
        optionPath: "argumentAxis",
        crosshairMargin: t ? m.x : m.y
      }, t, T);
    }), i.forEach((S, T) => {
      var k, O = [], {
        name: D
      } = S;
      if (D && d.includes(D)) {
        this._incidentOccurred("E2102");
        return;
      }
      D && d.push(D), S.pane && O.push(S.pane), !((k = S.panes) === null || k === void 0) && k.length && (O = O.concat(S.panes.slice(0))), O = MM(O), O.length || O.push(void 0), O.forEach((L) => {
        var F = hh(n) ? "valueAxis[".concat(String(T), "]") : "valueAxis";
        l.push(this._populateAxesOptions("valueAxis", S, {
          name: D || x(),
          pane: L,
          priority: T,
          optionPath: F,
          crosshairMargin: t ? m.y : m.x
        }, t));
      });
    }), this._redesignAxes(s, !0, p), this._redesignAxes(l, !1);
  },
  _redesignAxes(e, t, r) {
    var n = [], i = t ? this._argumentAxes : this._valueAxes;
    e.forEach((s) => {
      var l = i == null ? void 0 : i.filter((d) => d.name === s.name && (!I(s.pane) && this.panes.some((h) => h.name === d.pane) || d.pane === s.pane));
      l != null && l.length ? l.forEach((d) => {
        var h = mfe(this._groupsData, d, t);
        d.updateOptions(s), t ? d.setTypes(h.argumentAxisType, h.argumentType, "argumentType") : d.setTypes(h.valueAxisType, h.valueType, "valueType"), d.validate(), n.push({
          axis: d
        });
      }) : n.push({
        options: s
      });
    }), i ? jH(i, (s, l) => {
      n.some((d) => d.axis && d.axis === l) || this._disposeAxis(s, t);
    }) : t ? i = this._argumentAxes = [] : i = this._valueAxes = [], n.forEach((s) => {
      var {
        axis: l
      } = s;
      s.axis && t ? s.axis.isVirtual = s.axis.pane !== r : s.options && (l = this._createAxis(t, s.options, t ? s.options.pane !== r : void 0), i.push(l)), l.applyVisualRangeSetter(this._getVisualRangeSetter());
    });
  },
  _disposeAxis(e, t) {
    var r = t ? this._argumentAxes : this._valueAxes, n = r[e];
    n && (n.dispose(), r.splice(e, 1));
  },
  _disposeAxes() {
    var e = this._disposeObjectsInArray;
    e.call(this, "_argumentAxes"), e.call(this, "_valueAxes");
  },
  _appendAdditionalSeriesGroups() {
    this._crosshairCursorGroup.linkAppend(), this._scrollBar && this._scrollBarGroup.linkAppend();
  },
  _getLegendTargets() {
    return (this.series || []).map((e) => {
      var t = this._getLegendOptions(e);
      return t.legendData.series = e, e.getOptions().showInLegend || (t.legendData.visible = !1), t;
    });
  },
  _legendItemTextField: "name",
  _seriesPopulatedHandlerCore() {
    this._processSeriesFamilies(), this._processValueAxisFormat();
  },
  _renderTrackers() {
    for (var e = 0; e < this.series.length; e += 1)
      this.series[e].drawTrackers();
  },
  _specialProcessSeries() {
    this._processSeriesFamilies();
  },
  _processSeriesFamilies() {
    var e, t = [], r = [], n, i = this._themeManager, s = i.getOptions("negativesAsZeroes"), l = i.getOptions("negativesAsZeros"), d = {
      minBubbleSize: i.getOptions("minBubbleSize"),
      maxBubbleSize: i.getOptions("maxBubbleSize"),
      barGroupPadding: i.getOptions("barGroupPadding"),
      barGroupWidth: i.getOptions("barGroupWidth"),
      negativesAsZeroes: I(s) ? s : l
    };
    if (!((e = this.seriesFamilies) === null || e === void 0) && e.length) {
      this.seriesFamilies.forEach((h) => {
        h.updateOptions(d), h.adjustSeriesValues();
      });
      return;
    }
    this.series.forEach((h) => {
      t.includes(h.type) || t.push(h.type);
    }), this._getLayoutTargets().forEach((h) => {
      n = this._getSeriesForPane(h.name), t.forEach((p) => {
        var m = new SD({
          type: p,
          pane: h.name,
          minBubbleSize: d.minBubbleSize,
          maxBubbleSize: d.maxBubbleSize,
          barGroupPadding: d.barGroupPadding,
          barGroupWidth: d.barGroupWidth,
          negativesAsZeroes: d.negativesAsZeroes,
          rotated: this._isRotated()
        });
        m.add(n), m.adjustSeriesValues(), r.push(m);
      });
    }), this.seriesFamilies = r;
  },
  _updateSeriesDimensions() {
    for (var e = this.seriesFamilies || [], t = 0; t < e.length; t += 1) {
      var r = e[t];
      r.updateSeriesValues(), r.adjustSeriesDimensions();
    }
  },
  _getLegendCallBack(e) {
    var t;
    return (t = this._legend) === null || t === void 0 ? void 0 : t.getActionCallback(e);
  },
  _appendAxesGroups() {
    this._stripsGroup.linkAppend(), this._gridGroup.linkAppend(), this._axesGroup.linkAppend(), this._labelsAxesGroup.linkAppend(), this._constantLinesGroup.linkAppend(), this._stripLabelAxesGroup.linkAppend(), this._scaleBreaksGroup.linkAppend();
  },
  _populateMarginOptions() {
    var e = gfe(this.getSize(), this.panes.length, this._themeManager.getOptions("maxBubbleSize"), this._isRotated()), t = {};
    this._valueAxes.forEach((r) => {
      var n = this.series.filter((s) => s.getValueAxis() === r), i = {};
      n.forEach((s) => {
        if (s.isVisible()) {
          var l = pfe(s.getMarginOptions(), e);
          i = cF(i, l), t = cF(t, l);
        }
      }), r.setMarginOptions(i);
    }), this._argumentAxes.forEach((r) => r.setMarginOptions(t));
  },
  _populateBusinessRange(e, t) {
    var r = this._isRotated(), n = this._getVisibleSeries(), i = {}, s = new _a({
      rotated: !!r
    }), l = (h) => h.pane || Hz;
    if (this.panes.forEach((h) => {
      i[h.name] = new _a({
        rotated: !!r
      });
    }), this._valueAxes.forEach((h) => {
      var p = new _a({
        rotated: !!r,
        pane: h.pane,
        axis: h.name
      }), m = n.filter((x) => x.getValueAxis() === h);
      m.forEach((x) => {
        var S = x.getRangeData();
        p.addRange(S.val), i[l(h)].addRange(S.arg);
      }), (!e || e && m.length && h === e) && (h.setGroupSeries(m), h.setBusinessRange(p, this._axesReinitialized || t, this._argumentAxes[0]._lastVisualRangeUpdateMode));
    }), !e || e && n.length) {
      Object.keys(i).forEach((h) => s.addRange(i[h]));
      var d = s.interval;
      this._argumentAxes.forEach((h) => {
        var p, m = (p = i[l(h)].interval) !== null && p !== void 0 ? p : d;
        h.setBusinessRange(new _a(ei(ei({}, s), {
          interval: m
        })), this._axesReinitialized, void 0, this._groupsData.categories);
      });
    }
    this._populateMarginOptions();
  },
  getArgumentAxis() {
    return (this._argumentAxes || []).find((e) => !e.isVirtual);
  },
  getValueAxis(e) {
    return (this._valueAxes || []).find(I(e) ? (t) => t.name === e : (t) => t.pane === this.defaultPane);
  },
  _getGroupsData() {
    var e = [];
    return this._valueAxes.forEach((t) => {
      e.push({
        series: this.series.filter((r) => r.getValueAxis() === t),
        valueAxis: t,
        valueOptions: t.getOptions()
      });
    }), {
      groups: e,
      argumentAxes: this._argumentAxes,
      argumentOptions: this._argumentAxes[0].getOptions()
    };
  },
  _groupSeries() {
    this._correctValueAxes(!1), this._groupsData = this._getGroupsData();
  },
  _processValueAxisFormat() {
    var e = [];
    this.series.forEach((t) => {
      var r = t.getValueAxis();
      t.isFullStackedSeries() && (r.setPercentLabelFormat(), e.push(r));
    }), this._valueAxes.forEach((t) => {
      e.includes(t) || t.resetAutoLabelFormat();
    });
  },
  _populateAxesOptions(e, t, r, n, i) {
    var s = this._prepareStripsAndConstantLines(e, t, n), l = W(!0, {}, s, r, this._prepareAxisOptions(e, s, n));
    return i && (l.visible = !1, l.tick.visible = !1, l.minorTick.visible = !1, l.label.visible = !1, l.title = {}), l;
  },
  _getValFilter: (e) => Nd.getViewPortFilter(e.getValueAxis().visualRange() || {}),
  _createAxis(e, t, r) {
    var n = e ? "argumentAxis" : "valueAxis", i = W({
      renderer: this._renderer,
      incidentOccurred: this._incidentOccurred,
      eventTrigger: this._eventTrigger,
      axisClass: e ? "arg" : "val",
      widgetClass: "dxc",
      stripsGroup: this._stripsGroup,
      stripLabelAxesGroup: this._stripLabelAxesGroup,
      constantLinesGroup: this._constantLinesGroup,
      scaleBreaksGroup: this._scaleBreaksGroup,
      axesContainerGroup: this._axesGroup,
      labelsAxesGroup: this._labelsAxesGroup,
      gridGroup: this._gridGroup,
      isArgumentAxis: e,
      getTemplate: (l) => this._getTemplate(l)
    }, this._getAxisRenderingOptions(n)), s = new yD(i);
    return s.updateOptions(t), s.isVirtual = r, s;
  },
  _applyVisualRangeByVirtualAxes: () => !1,
  _applyCustomVisualRangeOption(e, t) {
    e.getOptions().optionPath && this._parseVisualRangeOption("".concat(e.getOptions().optionPath, ".visualRange"), t);
  },
  _getVisualRangeSetter() {
    return (e, t) => {
      var {
        skipEventRising: r,
        range: n
      } = t;
      this._applyCustomVisualRangeOption(e, n), e.setCustomVisualRange(n), e.skipEventRising = r, this._applyVisualRangeByVirtualAxes(e, n) || (this._applyingChanges ? this._change_VISUAL_RANGE() : this._requestChange([$C]));
    };
  },
  _getTrackerSettings() {
    return W(this.callBase(), {
      argumentAxis: this.getArgumentAxis()
    });
  },
  _prepareStripsAndConstantLines(e, t, r) {
    return t = this._themeManager.getOptions(e, t, r), t.strips && t.strips.forEach((n, i) => {
      t.strips[i] = W(!0, {}, t.stripStyle, n);
    }), t.constantLines && t.constantLines.forEach((n, i) => {
      t.constantLines[i] = W(!0, {}, t.constantLineStyle, n);
    }), t;
  },
  refresh() {
    this._disposeAxes(), this.callBase();
  },
  _layoutAxes(e) {
    e();
    var t = this.checkForMoreSpaceForPanesCanvas();
    if (t) {
      var r = this._rect.slice(), n = this._layout.backward(r, r, [t.width, t.height]);
      t.width = Math.max(0, n[0]), t.height = Math.max(0, n[1]), this._canvas = this._createCanvasFromRect(r), e(t);
    }
  },
  checkForMoreSpaceForPanesCanvas() {
    return this.layoutManager.needMoreSpaceForPanesCanvas(this._getLayoutTargets(), this._isRotated());
  },
  _parseVisualRangeOption(e, t) {
    var r, n = e.split(/[.[]/)[0], i = e.match(/\d+/g);
    i = I(i) ? parseInt(i[0], 10) : i, e.indexOf("visualRange") > 0 ? (Wa(t) !== "object" && (t = (r = j5(e, t)) !== null && r !== void 0 ? r : t), this._setCustomVisualRange(n, i, t)) : (Wa(t) === "object" || hh(t)) && n.indexOf("Axis") > 0 && JSON.stringify(t).indexOf("visualRange") > 0 && (I(t.visualRange) ? this._setCustomVisualRange(n, i, t.visualRange) : hh(t) && t.forEach((s, l) => {
      I(s.visualRange) && this._setCustomVisualRange(n, l, s.visualRange);
    }));
  },
  _setCustomVisualRange(e, t, r) {
    var n = this._options.silent(e);
    n && (I(t) ? n[t]._customVisualRange = r : n._customVisualRange = r, this._axesReinitialized = !0);
  },
  _raiseZoomEndHandlers() {
    this._valueAxes.forEach((e) => e.handleZoomEnd());
  },
  _setOptionsByReference() {
    this.callBase(), W(this._optionsByReference, {
      "valueAxis.visualRange": !0
    });
  },
  _notifyOptionChanged(e, t) {
    this.callBase.apply(this, arguments), this._optionChangedLocker || this._parseVisualRangeOption(e, t);
  },
  _notifyVisualRange() {
    this._valueAxes.forEach((e) => {
      var t = e.getOptions().optionPath;
      if (t) {
        var r = "".concat(t, ".visualRange"), n = LM(e.visualRange(), !hh(this.option(r)));
        !e.skipEventRising || !GG(n, this.option(r)) ? !this.option(t) && t !== "valueAxis" ? this.option(t, {
          name: e.name,
          visualRange: n
        }) : this.option(r, n) : e.skipEventRising = null;
      }
    });
  },
  _notify() {
    this.callBase(), this._axesReinitialized = !1, this.option("disableTwoWayBinding") !== !0 && (this.skipOptionsRollBack = !0, this._notifyVisualRange(), this.skipOptionsRollBack = !1);
  },
  _getAxesForScaling() {
    return this._valueAxes;
  },
  _getAxesByOptionPath(e, t, r) {
    var n = this._getAxesForScaling(), i = [];
    if (t) {
      var s;
      e.fullName && (s = e.fullName.slice(0, e.fullName.indexOf("."))), i = n.filter((l) => l.getOptions().optionPath === s);
    } else
      Wa(e.value) === "object" ? i = n.filter((l) => l.getOptions().optionPath === e.name) : hh(e.value) && e.value.forEach((l, d) => {
        var h = n.filter((p) => p.getOptions().optionPath === "".concat(e.name, "[").concat(d, "]"))[0];
        I(l[r]) && I(h) && (i[d] = h);
      });
    return i;
  },
  _optionChanged(e) {
    if (!this._optionChangedLocker) {
      var t, r = e.fullName.indexOf("visualRange") > 0 ? !0 : this.getPartialChangeOptionsName(e).indexOf("visualRange") > -1 ? !1 : void 0;
      I(r) && (t = this._getAxesByOptionPath(e, r, "visualRange"), t && (t.length > 1 || hh(e.value) ? t.forEach((n, i) => Uz(e, n, r, i)) : t.length === 1 && Uz(e, t[0], r)));
    }
    this.callBase(e);
  },
  _change_VISUAL_RANGE() {
    if (this._recreateSizeDependentObjects(!1), !this._changes.has("FULL_RENDER")) {
      var e = this.option("resizePanesOnZoom");
      this._doRender({
        force: !0,
        drawTitle: !1,
        drawLegend: !1,
        adjustAxes: e ?? (this.option("adjustAxesOnZoom") || !1),
        animate: !1
      }), this._raiseZoomEndHandlers();
    }
  },
  resetVisualRange() {
    this._valueAxes.forEach((e) => {
      e.resetVisualRange(!1), this._applyCustomVisualRangeOption(e);
    }), this._requestChange([$C]);
  },
  _getCrosshairMargins: () => ({
    x: 0,
    y: 0
  }),
  _legendDataField: "series",
  _adjustSeriesLabels: Y,
  _correctValueAxes: Y
}), $5 = "default", yfe = "VISUAL_RANGE", xfe = [{
  name: $5,
  border: {}
}], pR = "discrete", {
  isArray: F_
} = Array;
function bfe(e, t, r) {
  for (var n, i = 0; i < e.length; i += 1)
    if (e[i].pane === t || e[i].pane === void 0 && t === r) {
      n = e[i].name;
      break;
    }
  return n || (n = e[0].name), n;
}
function YC(e, t, r) {
  var n = e.getOptions().grid, i = e.getOptions().minorGrid;
  n.visible = t, i && (i.visible = r);
}
function Sfe(e) {
  var t = !1, r = [], n = e.some((s) => {
    var l = s.getOptions().minorGrid;
    return l == null ? void 0 : l.visible;
  }), i = e.some((s) => {
    var l = s.getOptions().grid;
    return l == null ? void 0 : l.visible;
  });
  e.length > 1 && (e.forEach((s) => {
    var l = s.getOptions().grid;
    t ? YC(s, !1, !1) : l != null && l.visible && (s.getTranslator().getBusinessRange().isEmpty() ? (YC(s, !1, !1), r.push(s)) : (t = !0, YC(s, i, n)));
  }), !t && r.length && YC(r[0], i, n));
}
function Cfe(e, t, r) {
  var n, i;
  for (i = 0; i < t.length; i += 1)
    if (t[i].name === r) {
      n = t[i], n.priority = i;
      break;
    }
  if (!n) {
    for (i = 0; i < e.length; i += 1)
      if (e[i].name === r) {
        n = e[i].getOptions(), n.priority = e[i].priority;
        break;
      }
  }
  return n;
}
function Y5(e, t, r) {
  var n = r.find((i) => i.name === t && i.pane === e);
  if (n)
    return n;
  if (e)
    return Y5(void 0, t, r);
}
function Efe(e, t) {
  return e.priority - t.priority;
}
function jz(e, t) {
  var r = !1;
  return be(e, (n, i) => {
    if (i.name === t)
      return r = !0, !1;
  }), r;
}
function Pg(e, t, r, n) {
  var i = t[e] || 0, s = r[e] || 0;
  return i + s + (i && s ? n : 0);
}
function Fo(e, t, r) {
  return W5(t[e], r[e]);
}
function W5(e, t) {
  return Math.max(e || 0, t || 0);
}
function oT(e) {
  return e.getMargins();
}
function WC(e, t) {
  return e.reduce((r, n) => {
    var i, s = t(n), l = r.panes[n.pane] = r.panes[n.pane] || {}, d = n.getMultipleAxesSpacing();
    l.top = Pg("top", l, s, d), l.bottom = Pg("bottom", l, s, d), l.left = Fo("left", l, s), l.right = Fo("right", l, s), r.top = Fo("top", l, r), r.bottom = Fo("bottom", l, r), r.left = Fo("left", l, r), r.right = Fo("right", l, r);
    var h = (i = n.getOrthogonalAxis) === null || i === void 0 ? void 0 : i.call(n), p = (h == null ? void 0 : h.customPositionIsAvailable()) && (!n.customPositionIsBoundaryOrthogonalAxis() || !h.customPositionEqualsToPredefined());
    return p && (r[h.getResolvedBoundaryPosition()] = 0), r;
  }, {
    panes: {}
  });
}
function gR(e) {
  return e.reduce((t, r) => {
    var n = r.getMargins(), i = t.panes[r.pane] = t.panes[r.pane] || {}, s = r.getMultipleAxesSpacing();
    return i.top = Fo("top", i, n), i.bottom = Fo("bottom", i, n), i.left = Pg("left", i, n, s), i.right = Pg("right", i, n, s), t.top = Fo("top", i, t), t.bottom = Fo("bottom", i, t), t.left = Fo("left", i, t), t.right = Fo("right", i, t), t;
  }, {
    panes: {}
  });
}
function Rl(e, t, r, n, i) {
  e.forEach((s) => {
    s[t](r == null ? void 0 : r[s.pane], (n == null ? void 0 : n[s.pane]) || n, i);
  });
}
function XC(e, t, r, n, i) {
  function s(m, x, S) {
    var T = (e ? ["left", "right"] : ["top", "bottom"]).includes(m) ? x.panes[S] || {} : x;
    return T[m];
  }
  function l(m, x, S, T) {
    return W5(s(m, x, T), s(m, S, T));
  }
  var d = (m) => "original".concat(m[0].toUpperCase()).concat(m.slice(1));
  function h(m, x, S, T, k, O) {
    x = x.sort((V, P) => m[P][T] - m[V][T]), x.forEach((V) => {
      var P = m[V];
      O.forEach((j) => {
        P[j] = P[d(j)] + l(j, n, i, V);
      });
    });
    var D = m[x[0]], L = D[S] - D[d(k)] - m[x.at(-1)][d(T)], F = x.reduce((V, P) => {
      var j = l(T, n, i, P), Z = l(k, n, i, P);
      return V - j - Z;
    }, L) - XR * (x.length - 1);
    F -= Object.keys(r).reduce((V, P) => {
      var j = dy(r[P]) ? 0 : r[P].height;
      return V + j;
    }, 0);
    var z = D[S] - D[d(k)] - (F < 0 ? F : 0);
    x.reduce((V, P) => {
      var j = m[P], Z = r[P];
      return V -= l(k, n, i, P), j[k] = D[S] - V, V -= dy(Z) ? Math.floor(F * Z.height) : Z.height, j[T] = V, V -= l(T, n, i, P) + XR, V;
    }, z);
  }
  var p = Object.keys(t);
  return e ? h(t, p, "width", "left", "right", ["top", "bottom"]) : h(t, p, "height", "top", "bottom", ["left", "right"]), t;
}
function mR(e, t, r, n) {
  t && (Rl(e, "createTicks", r), mZ.synchronize(e)), Rl(e, "draw", !t && r, n);
}
function qC(e, t) {
  var r = {};
  return function(n) {
    if (!n.customPositionIsAvailable() || n.customPositionEqualsToPredefined()) {
      var i = r[n.pane] = r[n.pane] || {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
      }, s = n.getMultipleAxesSpacing(), l = n.getMargins();
      n.shift(i), i[e] = Pg(e, i, l, s), i[t] = Pg(t, i, l, s);
    } else
      n.shift({
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
      });
  };
}
function $z(e, t) {
  var r = 0, n;
  return Object.keys(t.panes).forEach((i) => {
    n = t.panes[i], r += e === "height" ? n.top + n.bottom : n.left + n.right;
  }), r;
}
function Yz(e, t, r, n) {
  var i = 0;
  e[t] > 0 && (i = $z(t, n(r, oT)), Rl(r, "hideTitle"), e[t] -= i - $z(t, n(r, oT))), e[t] > 0 && Rl(r, "hideOuterElements");
}
function Tfe(e, t) {
  var r = t.reduce((n, i) => n + i, 0) / t.length;
  return e.animate && r <= e.animationPointsLimit;
}
function wfe(e, t, r) {
  var n = [], i = {}, s = r.visualRange(), l = r.getTranslator(), d = Nd.getViewPortFilter(s || {});
  return t.forEach((h) => {
    var p = h.getValueAxis(), m = p.getCanvasRange(), x = p.getTranslator(), S = e.indexOf(h), T = Nd.getViewPortFilter(m || {});
    i[S] = {}, t.forEach((D) => {
      i[S][e.indexOf(D)] = 0;
    });
    var k = [], O = h.getPoints().filter((D) => D.getOptions().visible && d(D.argument) && (T(D.getMinValue(!0)) || T(D.getMaxValue(!0))));
    O.forEach((D) => {
      var L = {
        seriesIndex: S,
        argument: D.argument,
        value: D.getMaxValue(!0),
        size: D.bubbleSize || D.getOptions().size,
        x: void 0,
        y: void 0
      };
      if (D.getMinValue(!0) !== D.getMaxValue(!0)) {
        var F = W({}, L);
        F.value = D.getMinValue(!0), F.x = l.to(F.argument, 1), F.y = x.to(F.value, 1), k.push(F);
      }
      L.x = l.to(L.argument, 1), L.y = x.to(L.value, 1), k.push(L);
    }), i[S].pointsCount = k.length, i[S].total = 0, i[S].continuousSeries = 0, n.push({
      name: h.name,
      index: S,
      points: k
    });
  }), {
    series: n,
    overloadedSeries: i
  };
}
var Afe = (e, t, r) => {
  var n = t.x - r <= e.x, i = t.x + r >= e.x, s = t.y - r <= e.y, l = t.y + r >= e.y, d = n && i, h = s && l;
  return d && h;
}, Wz = (e, t, r) => {
  for (var n = e.getOptions().size / 2, i = 0; i < t.length; i += 1) {
    if (!r) {
      var s = t[i].x === e.x, l = t[i].y === e.y;
      if (s && l)
        continue;
    }
    if (Afe(e, t[i], n))
      return !0;
  }
  return !1;
};
function Ofe(e, t, r) {
  for (var n = e.width * e.height, i = t.series, s = function(d) {
    var h = r.filter((T) => T.name === i[d].name)[0], {
      points: p
    } = i[d], m = p.length ? p[0].size : 0, x = m * m * p.length;
    if (h.autoHidePointMarkersEnabled() && x >= n / i.length) {
      var {
        index: S
      } = i[d];
      h.autoHidePointMarkers = !0, i.splice(d, 1), r.splice(r.indexOf(h), 1), t.overloadedSeries[S] = null;
    }
  }, l = i.length - 1; l >= 0; l -= 1)
    s(l);
}
function kfe(e, t) {
  for (var r = !1, n = 0; n < e.length - 1; n += 1) {
    var i = e[n], {
      size: s
    } = i;
    if (I(i.x) && I(i.y))
      for (var l = n + 1; l < e.length; l += 1) {
        var d = e[l], h = d == null ? void 0 : d.x, p = d == null ? void 0 : d.y;
        if (!I(h) || Math.abs(i.x - h) >= s) {
          r = r && l !== n + 1;
          break;
        } else {
          var m = I(h) && I(p) && Math.sqrt((i.x - h) ** 2 + (i.y - p) ** 2);
          m && m < s && (t[i.seriesIndex][d.seriesIndex] += 1, t[i.seriesIndex].total += 1, r || (t[i.seriesIndex].continuousSeries += 1, r = !0));
        }
      }
  }
}
var Xg = _fe.inherit({
  _themeSection: "chart",
  _fontFields: ["crosshair.label.font"],
  _initCore() {
    this.paneAxis = {}, this.callBase();
  },
  _init() {
    this._containerInitialHeight = fn() ? gT(this._$element) : 0, this.callBase();
  },
  _correctAxes() {
    this._correctValueAxes(!0);
  },
  _setDeprecatedOptions() {
    this.callBase(), W(this._deprecatedOptions, {
      "argumentAxis.aggregateByCategory": {
        since: "23.1",
        message: "Use the aggregation.enabled property"
      }
    });
  },
  _getExtraOptions: Y,
  _createPanes() {
    var e = this.option("panes"), t = 0, r;
    return (!e || F_(e) && !e.length) && (e = xfe), this.callBase(), r = this.option("defaultPane"), e = W(!0, [], F_(e) ? e : [e]), be(e, (n, i) => {
      i.name = I(i.name) ? i.name : $5 + t++;
    }), I(r) ? jz(e, r) || (this._incidentOccurred("W2101", [r]), r = e[e.length - 1].name) : r = e[e.length - 1].name, this.defaultPane = r, e = this._isRotated() ? e.reverse() : e, e;
  },
  _getAxisRenderingOptions: () => ({
    axisType: "xyAxes",
    drawingType: "linear"
  }),
  _prepareAxisOptions(e, t, r) {
    return {
      isHorizontal: e === "argumentAxis" !== r,
      containerColor: this._themeManager.getOptions("containerBackgroundColor")
    };
  },
  _checkPaneName(e) {
    var t = ti(this.panes, (r) => r.name);
    return e.pane = e.pane || this.defaultPane, t.includes(e.pane);
  },
  _initCustomPositioningAxes() {
    var e = this.getArgumentAxis(), t = e.getOptions().customPositionAxis, r = this._valueAxes.find((n) => n.pane === e.pane && (!t || t === n.name));
    this._valueAxes.forEach((n) => {
      e !== n.getOrthogonalAxis() && (n.getOrthogonalAxis = () => e, n.customPositionIsBoundaryOrthogonalAxis = () => e.customPositionIsBoundary());
    }), I(r) && r !== e.getOrthogonalAxis() ? (e.getOrthogonalAxis = () => r, e.customPositionIsBoundaryOrthogonalAxis = () => this._valueAxes.some((n) => n.customPositionIsBoundary())) : I(e.getOrthogonalAxis()) && !I(r) && (e.getOrthogonalAxis = Y);
  },
  _getAllAxes() {
    return this._argumentAxes.concat(this._valueAxes);
  },
  _resetAxesAnimation(e, t) {
    var r;
    I(t) ? r = t ^ this._isRotated() ? this._argumentAxes : this._valueAxes : r = this._getAllAxes(), r.forEach((n) => {
      n.resetApplyingAnimation(e);
    });
  },
  _axesBoundaryPositioning() {
    var e = this._getAllAxes(), t = !1;
    return e.forEach((r) => {
      if (r.customPositionIsAvailable()) {
        var n = r.customPositionIsBoundary();
        r._customBoundaryPosition = r.getCustomBoundaryPosition(), t = t || n !== r.customPositionIsBoundary();
      }
    }), t;
  },
  _getCrosshairMargins() {
    var e = this._getCrosshairOptions() || {}, t = e.enabled, r = XK(), n = W(!0, {}, e.label, e.horizontalLine.label), i = W(!0, {}, e.label, e.verticalLine.label);
    return {
      x: t && e.horizontalLine.visible && n.visible ? r.x : 0,
      y: t && e.verticalLine.visible && i.visible ? r.y : 0
    };
  },
  _getValueAxis(e, t) {
    var r = this._valueAxes, n = this.option("valueAxis") || {}, i = F_(n) ? n : [n], s = this._isRotated(), l = this._getCrosshairMargins(), d, h;
    return t = t || bfe(r, e, this.defaultPane), h = Y5(e, t, r), h || (d = Cfe(r, i, t), d || (this._incidentOccurred("W2102", [t]), d = {
      name: t,
      priority: r.length
    }), h = this._createAxis(!1, this._populateAxesOptions("valueAxis", d, {
      pane: e,
      name: t,
      optionPath: F_(n) ? "valueAxis[".concat(d.priority, "]") : "valueAxis",
      crosshairMargin: s ? l.y : l.x
    }, s)), h.applyVisualRangeSetter(this._getVisualRangeSetter()), r.push(h)), h.setPane(e), h;
  },
  _correctValueAxes(e) {
    var t = this._themeManager.getOptions("synchronizeMultiAxes"), r = this._valueAxes, n = {};
    this.series.forEach((s) => {
      var l = s.getValueAxis();
      n[l.pane] = !0;
    }), this.panes.forEach((s) => {
      var l = s.name;
      n[l] || this._getValueAxis(l), e && t && Sfe(r.filter((d) => d.pane === l));
    }), this._valueAxes = r.filter((s) => {
      s.pane || s.setPane(this.defaultPane);
      var l = jz(this.panes, s.pane);
      return l || (s.dispose(), s = null), l;
    }).sort(Efe);
    var i = this.getValueAxis();
    this._valueAxes.forEach((s) => {
      var {
        optionPath: l
      } = s.getOptions();
      if (l) {
        var d = this._valueAxes.filter((h) => h.getOptions().optionPath === l);
        d.length > 1 && (d.some((h) => h === i) ? d.forEach((h) => {
          h !== i && (h.getOptions().optionPath = null);
        }) : d.forEach((h, p) => {
          p !== 0 && (h.getOptions().optionPath = null);
        }));
      }
    });
  },
  _getSeriesForPane(e) {
    var t = [];
    return be(this.series, (r, n) => {
      n.pane === e && t.push(n);
    }), t;
  },
  _createPanesBorderOptions() {
    var e = this._themeManager.getOptions("commonPaneSettings").border, t = {};
    return this.panes.forEach((r) => {
      t[r.name] = W(!0, {}, e, r.border);
    }), t;
  },
  _createScrollBar() {
    var e, t = this._themeManager.getOptions("scrollBar") || {}, r = this._scrollBarGroup;
    t.visible ? (t.rotated = this._isRotated(), this._scrollBar = (this._scrollBar || new h3(this._renderer, r)).update(t)) : (r.linkRemove(), (e = this._scrollBar) === null || e === void 0 || e.dispose(), this._scrollBar = null);
  },
  _executeAppendAfterSeries(e) {
    e();
  },
  _prepareToRender() {
    var e = this._createPanesBorderOptions();
    return this._createPanesBackground(), this._appendAxesGroups(), this._adjustViewport(), e;
  },
  _adjustViewport() {
    var e = this._themeManager.getOptions("adjustOnZoom");
    e && this._valueAxes.forEach((t) => t.adjust());
  },
  _recreateSizeDependentObjects(e) {
    var t = this._getVisibleSeries(), r = t.some((i) => i.useAggregation()), n = this._isZooming();
    r && (this._argumentAxes.forEach((i) => {
      i.updateCanvas(this._canvas, !0);
    }), t.forEach((i) => {
      i.useAggregation() && (e || n || !i._useAllAggregatedPoints) && i.createPoints();
    }), this._processSeriesFamilies());
  },
  _isZooming() {
    var e = this.getArgumentAxis();
    if (!(e != null && e.getTranslator()))
      return !1;
    var t = e.getTranslator().getBusinessRange(), r = e.getViewport(), n = r ? r.min : 0, i = r ? r.max : 0;
    t.axisType === "logarithmic" && (n = Gd(n, t.base), i = Gd(i, t.base));
    var s = t.axisType === pR ? Xu(t.categories, n, i).categories.length : Math.abs(i - n), l = EE(s);
    l = l > 1 ? 10 ** (l - 2) : 1;
    var d = Math.round((this._zoomLength - s) * l) / l !== 0;
    return this._zoomLength = s, d;
  },
  _handleSeriesDataUpdated() {
    var e = new _a();
    this.series.forEach((t) => {
      e.addRange(t.getArgumentRange());
    }), this._argumentAxes.forEach((t) => {
      t.updateCanvas(this._canvas, !0), t.setBusinessRange(e, this._axesReinitialized);
    }), this.callBase();
  },
  _isLegendInside() {
    return this._legend && this._legend.getPosition() === "inside";
  },
  _isRotated() {
    return this._themeManager.getOptions("rotated");
  },
  _getLayoutTargets() {
    return this.panes;
  },
  _applyClipRects(e) {
    this._drawPanesBorders(e), this._createClipRectsForPanes(), this._applyClipRectsForAxes(), this._fillPanesBackground();
  },
  _updateLegendPosition(e, t) {
    if (e.drawLegend && this._legend && t) {
      var {
        panes: r
      } = this, n = W({}, r[0].canvas), i = new DE();
      n.right = r[r.length - 1].canvas.right, n.bottom = r[r.length - 1].canvas.bottom, i.layoutInsideLegend(this._legend, n);
    }
  },
  _allowLegendInsidePosition: () => !0,
  _applyExtraSettings(e) {
    var t = this._getPaneIndex(e.pane), r = this._panesClipRects, n = r.wide[t];
    e.setClippingParams(r.base[t].id, n == null ? void 0 : n.id, this._getPaneBorderVisibility(t));
  },
  _updatePanesCanvases(e) {
    e.recreateCanvas && zK(this.panes, this._canvas, this._isRotated());
  },
  _normalizePanesHeight() {
    BK(this.panes);
  },
  _renderScaleBreaks() {
    this._valueAxes.concat(this._argumentAxes).forEach((e) => {
      e.drawScaleBreaks();
    });
  },
  _getArgFilter() {
    return Nd.getViewPortFilter(this.getArgumentAxis().visualRange() || {});
  },
  _hidePointsForSingleSeriesIfNeeded(e) {
    for (var t = e.getPoints(), r = 0, n = 0; n < t.length; n += 1) {
      var i = t[n], s = t.slice(n + 1);
      if (r += Number(Wz(i, s)), r > t.length / 2) {
        e.autoHidePointMarkers = !0;
        break;
      }
    }
  },
  _applyAutoHidePointMarkers(e) {
    for (var t = [], r = (d, h) => d + Wz(h, t, !0), n = e.length - 1; n >= 0; n -= 1) {
      var i = e[n];
      if (i.autoHidePointMarkersEnabled() && (i.autoHidePointMarkers = !1, this._hidePointsForSingleSeriesIfNeeded(i), !i.autoHidePointMarkers)) {
        var s = i.getPoints(), l = s.reduce(r, 0);
        l < s.length ? t = t.concat(s) : i.autoHidePointMarkers = !0;
      }
    }
  },
  _applyPointMarkersAutoHiding() {
    var e = this.series;
    if (!this._themeManager.getOptions("autoHidePointMarkers")) {
      e.forEach((t) => {
        t.autoHidePointMarkers = !1;
      });
      return;
    }
    this.panes.forEach((t) => {
      var {
        borderCoords: r,
        name: n
      } = t, i = e.filter((x) => x.pane === n && x.usePointsToDefineAutoHiding());
      i.forEach((x) => {
        x.prepareCoordinatesForPoints();
      });
      var s = this.getArgumentAxis(), l = wfe(e, i, s);
      if (Ofe(r, l, i), l.series.length) {
        var d = s.visualRange(), h = s.getOptions().type === pR, p = h ? (x, S) => d.categories.indexOf(x.argument) - d.categories.indexOf(S.argument) : (x, S) => x.argument - S.argument, m = [];
        l.series.forEach((x) => {
          m = m.concat(x.points);
        }), m.sort(p), kfe(m, l.overloadedSeries), this._applyAutoHidePointMarkers(i);
      }
    });
  },
  _renderAxes(e, t) {
    function r(J) {
      return J.map((he) => {
        if (!he.getTitle)
          return 0;
        var de = he.getTitle();
        return de ? de.bBox.width : 0;
      });
    }
    var n = this._isRotated(), i = this._themeManager.getOptions("synchronizeMultiAxes"), s = this._scrollBar ? [this._scrollBar] : [], l = this._isArgumentAxisBeforeScrollBar() ? this._argumentAxes.concat(s) : s.concat(this._argumentAxes), d = n ? this._argumentAxes : this._valueAxes, h = n ? l : this._valueAxes, p = n ? this._valueAxes : this._argumentAxes, m = n ? this._valueAxes : l, x = d.concat(p), S = x.concat(s), T = d.some((J) => J.isFirstDrawing());
    this._normalizePanesHeight(), this._updatePanesCanvases(e);
    var k = this.panes.reduce((J, he) => (J[he.name] = W({}, he.canvas), J), {}), O = this.panes.reduce((J, he) => (J[he.name] = {
      height: he.height,
      unit: he.unit
    }, J), {}), D = W(!0, {}, k);
    this._initCustomPositioningAxes();
    var L = this._axesBoundaryPositioning();
    if (!e.adjustAxes && !L)
      return mR(d, !n && i, k, t), mR(p, n && i, k, t), Rl(x, "prepareAnimation"), this._renderScaleBreaks(), p.forEach((J) => J.resolveOverlappingForCustomPositioning(d)), d.forEach((J) => J.resolveOverlappingForCustomPositioning(p)), !1;
    L && x.forEach((J) => J.customPositionIsAvailable() && J.shift({
      top: 0,
      left: 0,
      bottom: 0,
      right: 0
    })), this._scrollBar && this._scrollBar.setPane(this.panes);
    var F = {
      panes: {},
      left: 0,
      right: 0
    }, z = WC(m, (J) => J.estimateMargins(k[J.pane]));
    k = XC(n, k, O, F, z);
    var V = (J) => {
      var he = J ? p : d, de = (J ? n : !n) && i;
      mR(he, de, k, t), J ? z = WC(m, oT) : F = gR(h), k = XC(n, k, O, F, z);
    };
    V(!1), V(!0), !this._changesApplying && this._estimateTickIntervals(d, k) && V(!1);
    var P = r(d), j = this._getVisibleSeries(), Z = this._getPointsToAnimation(j), ee = Tfe(e, Z);
    return Rl(S, "updateSize", k, ee), m.forEach(qC("top", "bottom")), h.forEach(qC("left", "right")), this._renderScaleBreaks(), this.panes.forEach((J) => {
      W(J.canvas, k[J.name]);
    }), this._valueAxes.forEach((J) => {
      J.setInitRange();
    }), d.forEach((J, he) => {
      var de;
      if (!((de = J.hasWrap) === null || de === void 0) && de.call(J)) {
        var Re = J.getTitle(), Ce = Re ? Re.bBox.width : 0, le = Ce - P[he];
        J.getOptions().position === "right" ? F.right += le : (F.left += le, this.panes.forEach((me) => {
          var {
            name: fe
          } = me;
          F.panes[fe].left += le;
        })), k = XC(n, k, O, F, z), Rl(S, "updateSize", k, !1, !1), P = r(d);
      }
    }), d.some((J) => J.customPositionIsAvailable() && J.getCustomPosition() !== J._axisPosition) && (ee && this._resetAxesAnimation(T, !1), Rl(d, "updateSize", k, ee)), p.forEach((J) => J.resolveOverlappingForCustomPositioning(d)), d.forEach((J) => J.resolveOverlappingForCustomPositioning(p)), D;
  },
  _getExtraTemplatesItems() {
    var e = (this._argumentAxes || []).concat(this._valueAxes || []), t = this._collectTemplatesFromItems(e);
    return {
      items: t.items,
      groups: t.groups,
      launchRequest() {
        e.forEach((r) => {
          r.setRenderedState(!0);
        });
      },
      doneRequest() {
        e.forEach((r) => {
          r.setRenderedState(!1);
        });
      }
    };
  },
  _estimateTickIntervals: (e, t) => e.some((r) => r.estimateTickInterval(t[r.pane])),
  checkForMoreSpaceForPanesCanvas() {
    var e = this._isRotated(), t = this.panes.filter((T) => T.unit).length === this.panes.length, r = !1;
    if (t) {
      var n = 0, i = 0;
      if (e) {
        var s = this.getArgumentAxis().getMargins().right, l = Math.min(...this.panes.map((T) => T.canvas.right));
        n = this._canvas.right + s - l;
      } else {
        var d = this.getArgumentAxis().getMargins().bottom, h = Math.min(...this.panes.map((T) => T.canvas.bottom));
        i = this._canvas.bottom + d - h;
      }
      if (r = n > 0 || i > 0 ? {
        width: n,
        height: i
      } : !1, i !== 0) {
        var p = this.getSize(), m = this.option("size"), x = this._$element[0], S = !!parseInt(x.style.height, 10) || this._containerInitialHeight !== 0;
        !e && !(m != null && m.height) && !S && (this._forceResize(p.width, p.height + i), r = !1);
      }
    } else
      r = this.layoutManager.needMoreSpaceForPanesCanvas(this._getLayoutTargets(), e, (T) => ({
        width: e && !!T.unit,
        height: !e && !!T.unit
      }));
    return r;
  },
  _forceResize(e, t) {
    this._renderer.resize(e, t), this._updateSize(!0), this._setContentSize(), this._preserveOriginalCanvas(), this._updateCanvasClipRect(this._canvas);
  },
  _shrinkAxes(e, t) {
    if (!(!e || !t)) {
      this._renderer.stopAllAnimations(!0);
      var r = this._isRotated(), n = this._scrollBar ? [this._scrollBar] : [], i = this._isArgumentAxisBeforeScrollBar() ? this._argumentAxes.concat(n) : n.concat(this._argumentAxes), s = r ? i : this._valueAxes, l = r ? this._valueAxes : i, d = s.concat(l);
      if (e.width || e.height) {
        Yz(e, "height", l, WC), Yz(e, "width", s, gR), Rl(d, "updateSize", t);
        var h = this.panes.reduce((p, m) => (p[m.name] = {
          height: m.height,
          unit: m.unit
        }, p), {});
        t = XC(r, t, h, gR(s), WC(l, oT)), Rl(d, "updateSize", t), l.forEach(qC("top", "bottom")), s.forEach(qC("left", "right")), this.panes.forEach((p) => W(p.canvas, t[p.name]));
      }
    }
  },
  _isArgumentAxisBeforeScrollBar() {
    var e, t = this.getArgumentAxis();
    if (this._scrollBar) {
      var r = t.getResolvedBoundaryPosition(), n = (e = t.getOptions().label) === null || e === void 0 ? void 0 : e.position, i = this._scrollBar.getOptions().position;
      return t.hasNonBoundaryPosition() || i === r && n !== i;
    }
    return !1;
  },
  _getPanesParameters() {
    for (var {
      panes: e
    } = this, t = [], r = 0; r < e.length; r += 1)
      this._getPaneBorderVisibility(r) && t.push({
        coords: e[r].borderCoords,
        clipRect: this._panesClipRects.fixed[r]
      });
    return t;
  },
  _createCrosshairCursor() {
    var e = this._themeManager.getOptions("crosshair") || {}, t = this.getArgumentAxis(), r = this._isRotated() ? [this._valueAxes, [t]] : [
      [t],
      this._valueAxes
    ], n = {
      canvas: this._getCommonCanvas(),
      panes: this._getPanesParameters(),
      axes: r
    };
    e != null && e.enabled && (this._crosshair ? this._crosshair.update(e, n) : this._crosshair = new JR(this._renderer, e, n, this._crosshairCursorGroup), this._crosshair.render());
  },
  _getCommonCanvas() {
    for (var e, {
      panes: t
    } = this, r = 0; r < t.length; r += 1) {
      var {
        canvas: n
      } = t[r];
      e ? (e.right = n.right, e.bottom = n.bottom) : e = W({}, n);
    }
    return e;
  },
  _createPanesBackground() {
    var e = this._themeManager.getOptions("commonPaneSettings").backgroundColor, t = this._renderer, r = [];
    this._panesBackgroundGroup.clear();
    for (var n = 0; n < this.panes.length; n += 1) {
      var i = this.panes[n].backgroundColor || e;
      if (!i || i === "none") {
        r.push(null);
        continue;
      }
      var s = t.rect(0, 0, 0, 0).attr({
        fill: xa(i),
        "stroke-width": 0
      }).append(this._panesBackgroundGroup);
      r.push(s);
    }
    this.panesBackground = r;
  },
  _fillPanesBackground() {
    be(this.panes, (e, t) => {
      var r = t.borderCoords;
      this.panesBackground[e] !== null && this.panesBackground[e].attr({
        x: r.left,
        y: r.top,
        width: r.width,
        height: r.height
      });
    });
  },
  _calcPaneBorderCoords(e) {
    var {
      canvas: t
    } = e, r = e.borderCoords = e.borderCoords || {};
    r.left = t.left, r.top = t.top, r.right = t.width - t.right, r.bottom = t.height - t.bottom, r.width = Math.max(r.right - r.left, 0), r.height = Math.max(r.bottom - r.top, 0);
  },
  _drawPanesBorders(e) {
    var t = this._isRotated();
    this._panesBorderGroup.linkRemove().clear(), be(this.panes, (r, n) => {
      var i = e[n.name], s = {
        fill: "none",
        stroke: i.color,
        "stroke-opacity": i.opacity,
        "stroke-width": i.width,
        dashStyle: i.dashStyle,
        "stroke-linecap": "square"
      };
      if (this._calcPaneBorderCoords(n, t), !!i.visible) {
        var l = n.borderCoords, d = Ute(l.left, l.top, l.width, l.height, i);
        this._renderer.path(d.points, d.pathType).attr(s).append(this._panesBorderGroup);
      }
    }), this._panesBorderGroup.linkAppend();
  },
  _createClipRect(e, t, r, n, i, s) {
    var l = e[t];
    l ? l.attr({
      x: r,
      y: n,
      width: i,
      height: s
    }) : (l = this._renderer.clipRect(r, n, i, s), e[t] = l);
  },
  _createClipRectsForPanes() {
    var e = this._canvas;
    be(this.panes, (t, r) => {
      var n = !1, i = r.borderCoords, {
        left: s
      } = i, {
        top: l
      } = i, {
        width: d
      } = i, {
        height: h
      } = i, p = this._panesClipRects;
      this._createClipRect(p.fixed, t, s, l, d, h), this._createClipRect(p.base, t, s, l, d, h), be(this.series, (m, x) => {
        x.pane === r.name && (x.isFinancialSeries() || x.areErrorBarsVisible()) && (n = !0);
      }), n ? (this._isRotated() ? (l = 0, h = e.height) : (s = 0, d = e.width), this._createClipRect(p.wide, t, s, l, d, h)) : p.wide[t] = null;
    });
  },
  _applyClipRectsForAxes() {
    for (var e = this._getAllAxes(), t = this._getCanvasClipRectID(), r = 0; r < e.length; r += 1) {
      var n = this._getElementsClipRectID(e[r].pane);
      e[r].applyClipRects(n, t);
    }
  },
  _getPaneBorderVisibility(e) {
    var t, r = this._themeManager.getOptions("commonPaneSettings").border.visible, n = this.panes[e], i = (t = n == null ? void 0 : n.border) === null || t === void 0 ? void 0 : t.visible;
    return i === void 0 ? r : i;
  },
  _getCanvasForPane(e) {
    var t;
    return (t = this.panes.find((r) => r.name === e)) === null || t === void 0 ? void 0 : t.canvas;
  },
  _getTrackerSettings() {
    return W(this.callBase(), {
      chart: this,
      rotated: this._isRotated(),
      crosshair: this._getCrosshairOptions().enabled ? this._crosshair : null,
      stickyHovering: this._themeManager.getOptions("stickyHovering")
    });
  },
  _resolveLabelOverlappingStack() {
    var e = this._isRotated(), t = e ? (n, i) => ({
      x: n.x - i,
      y: n.y
    }) : (n, i) => ({
      x: n.x,
      y: n.y - i
    }), r = (n, i) => {
      var s = e ? 1 : 0, l = n.labels[0].getFigureCenter()[s], d = i.labels[0].getFigureCenter()[s];
      if (l - d === 0) {
        var h = n.labels[0].getPoint().series.getValueAxis().getTranslator(), p = h.isInverted() ? -1 : 1;
        return (n.value() - i.value()) * p;
      }
      return 0;
    };
    be(this._getStackPoints(), (n, i) => {
      be(i, (s, l) => {
        var d = l[0].series.getValueAxis().getOptions().inverted;
        aM.resolveLabelOverlappingInOneDirection(l, this._getCommonCanvas(), e, d, t, r);
      });
    });
  },
  _getStackPoints() {
    var e = {}, t = this._getVisibleSeries();
    return be(t, (r, n) => {
      var i = n.getPoints(), s = n.getStackName() || null;
      be(i, (l, d) => {
        var {
          argument: h
        } = d;
        e[h] || (e[h] = {}), e[h][s] || (e[h][s] = []), e[h][s].push(d);
      });
    }), e;
  },
  _getCrosshairOptions() {
    return this._getOption("crosshair");
  },
  zoomArgument(e, t) {
    !this._initialized || !I(e) && !I(t) || this.getArgumentAxis().visualRange([e, t]);
  },
  resetVisualRange() {
    var e = this._argumentAxes, t = this.getArgumentAxis();
    e.forEach((r) => {
      r.resetVisualRange(t !== r), this._applyCustomVisualRangeOption(r);
    }), this.callBase();
  },
  getVisibleArgumentBounds() {
    var e = this._argumentAxes[0].getTranslator(), t = e.getBusinessRange(), r = t.axisType === pR, {
      categories: n
    } = t;
    return {
      minVisible: r ? t.minVisible || n[0] : t.minVisible,
      maxVisible: r ? t.maxVisible || n[n.length - 1] : t.maxVisible
    };
  },
  _change_FULL_RENDER() {
    this.callBase(), this._changes.has(yfe) && this._raiseZoomEndHandlers();
  },
  _getAxesForScaling() {
    return [this.getArgumentAxis()].concat(this._valueAxes);
  },
  _applyVisualRangeByVirtualAxes(e, t) {
    if (e.isArgumentAxis) {
      if (e !== this.getArgumentAxis())
        return !0;
      this._argumentAxes.filter((r) => r !== e).forEach((r) => r.visualRange(t, {
        start: !0,
        end: !0
      }));
    }
    return !1;
  },
  _raiseZoomEndHandlers() {
    this._argumentAxes.forEach((e) => e.handleZoomEnd()), this.callBase();
  },
  _setOptionsByReference() {
    this.callBase(), W(this._optionsByReference, {
      "argumentAxis.visualRange": !0
    });
  },
  option() {
    var e = this.callBase(...arguments), t = this._options.silent("valueAxis");
    if (Wa(t) === "array")
      for (var r = 0; r < t.length; r += 1) {
        var n = "valueAxis[".concat(r, "].visualRange");
        this._optionsByReference[n] = !0;
      }
    return e;
  },
  _notifyVisualRange() {
    var e = this._argumentAxes[0], t = LM(e.visualRange(), !F_(this.option("argumentAxis.visualRange")));
    !e.skipEventRising || !GG(t, this.option("argumentAxis.visualRange")) ? this.option("argumentAxis.visualRange", t) : e.skipEventRising = null, this.callBase();
  }
});
Xg.addPlugin(YQ);
Xg.addPlugin(fJ);
Xg.addPlugin(MT.core);
Xg.addPlugin(MT.chart);
gG("dxChart", Xg);
var sT = { exports: {} }, _R, Xz;
function jL() {
  if (Xz)
    return _R;
  Xz = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return _R = e, _R;
}
var yR, qz;
function Rfe() {
  if (qz)
    return yR;
  qz = 1;
  var e = jL();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, yR = function() {
    function n(l, d, h, p, m, x) {
      if (x !== e) {
        var S = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw S.name = "Invariant Violation", S;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var s = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, yR;
}
var Y_ = { exports: {} }, gr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kz;
function Dfe() {
  return Kz || (Kz = 1, process.env.NODE_ENV !== "production" && function() {
    "use strict";
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, d = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, x = e ? Symbol.for("react.suspense") : 60113, S = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, k = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, L = e ? Symbol.for("react.responder") : 60118, F = e ? Symbol.for("react.scope") : 60119;
    function z(xe) {
      return typeof xe == "string" || typeof xe == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      xe === n || xe === p || xe === s || xe === i || xe === x || xe === S || typeof xe == "object" && xe !== null && (xe.$$typeof === k || xe.$$typeof === T || xe.$$typeof === l || xe.$$typeof === d || xe.$$typeof === m || xe.$$typeof === D || xe.$$typeof === L || xe.$$typeof === F || xe.$$typeof === O);
    }
    function V(xe) {
      if (typeof xe == "object" && xe !== null) {
        var Je = xe.$$typeof;
        switch (Je) {
          case t:
            var Pt = xe.type;
            switch (Pt) {
              case h:
              case p:
              case n:
              case s:
              case i:
              case x:
                return Pt;
              default:
                var bt = Pt && Pt.$$typeof;
                switch (bt) {
                  case d:
                  case m:
                  case k:
                  case T:
                  case l:
                    return bt;
                  default:
                    return Je;
                }
            }
          case r:
            return Je;
        }
      }
    }
    var P = h, j = p, Z = d, ee = l, J = t, he = m, de = n, Re = k, Ce = T, le = r, me = s, fe = i, Ee = x, Q = !1;
    function pe(xe) {
      return Q || (Q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), G(xe) || V(xe) === h;
    }
    function G(xe) {
      return V(xe) === p;
    }
    function se(xe) {
      return V(xe) === d;
    }
    function Te(xe) {
      return V(xe) === l;
    }
    function Pe(xe) {
      return typeof xe == "object" && xe !== null && xe.$$typeof === t;
    }
    function Ie(xe) {
      return V(xe) === m;
    }
    function He(xe) {
      return V(xe) === n;
    }
    function Ue(xe) {
      return V(xe) === k;
    }
    function Ze(xe) {
      return V(xe) === T;
    }
    function Qe(xe) {
      return V(xe) === r;
    }
    function it(xe) {
      return V(xe) === s;
    }
    function We(xe) {
      return V(xe) === i;
    }
    function _t(xe) {
      return V(xe) === x;
    }
    gr.AsyncMode = P, gr.ConcurrentMode = j, gr.ContextConsumer = Z, gr.ContextProvider = ee, gr.Element = J, gr.ForwardRef = he, gr.Fragment = de, gr.Lazy = Re, gr.Memo = Ce, gr.Portal = le, gr.Profiler = me, gr.StrictMode = fe, gr.Suspense = Ee, gr.isAsyncMode = pe, gr.isConcurrentMode = G, gr.isContextConsumer = se, gr.isContextProvider = Te, gr.isElement = Pe, gr.isForwardRef = Ie, gr.isFragment = He, gr.isLazy = Ue, gr.isMemo = Ze, gr.isPortal = Qe, gr.isProfiler = it, gr.isStrictMode = We, gr.isSuspense = _t, gr.isValidElementType = z, gr.typeOf = V;
  }()), gr;
}
var mr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zz;
function Mfe() {
  if (Zz)
    return mr;
  Zz = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, d = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, p = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, x = e ? Symbol.for("react.suspense") : 60113, S = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, k = e ? Symbol.for("react.lazy") : 60116, O = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, L = e ? Symbol.for("react.responder") : 60118, F = e ? Symbol.for("react.scope") : 60119;
  function z(P) {
    if (typeof P == "object" && P !== null) {
      var j = P.$$typeof;
      switch (j) {
        case t:
          switch (P = P.type, P) {
            case h:
            case p:
            case n:
            case s:
            case i:
            case x:
              return P;
            default:
              switch (P = P && P.$$typeof, P) {
                case d:
                case m:
                case k:
                case T:
                case l:
                  return P;
                default:
                  return j;
              }
          }
        case r:
          return j;
      }
    }
  }
  function V(P) {
    return z(P) === p;
  }
  return mr.AsyncMode = h, mr.ConcurrentMode = p, mr.ContextConsumer = d, mr.ContextProvider = l, mr.Element = t, mr.ForwardRef = m, mr.Fragment = n, mr.Lazy = k, mr.Memo = T, mr.Portal = r, mr.Profiler = s, mr.StrictMode = i, mr.Suspense = x, mr.isAsyncMode = function(P) {
    return V(P) || z(P) === h;
  }, mr.isConcurrentMode = V, mr.isContextConsumer = function(P) {
    return z(P) === d;
  }, mr.isContextProvider = function(P) {
    return z(P) === l;
  }, mr.isElement = function(P) {
    return typeof P == "object" && P !== null && P.$$typeof === t;
  }, mr.isForwardRef = function(P) {
    return z(P) === m;
  }, mr.isFragment = function(P) {
    return z(P) === n;
  }, mr.isLazy = function(P) {
    return z(P) === k;
  }, mr.isMemo = function(P) {
    return z(P) === T;
  }, mr.isPortal = function(P) {
    return z(P) === r;
  }, mr.isProfiler = function(P) {
    return z(P) === s;
  }, mr.isStrictMode = function(P) {
    return z(P) === i;
  }, mr.isSuspense = function(P) {
    return z(P) === x;
  }, mr.isValidElementType = function(P) {
    return typeof P == "string" || typeof P == "function" || P === n || P === p || P === s || P === i || P === x || P === S || typeof P == "object" && P !== null && (P.$$typeof === k || P.$$typeof === T || P.$$typeof === l || P.$$typeof === d || P.$$typeof === m || P.$$typeof === D || P.$$typeof === L || P.$$typeof === F || P.$$typeof === O);
  }, mr.typeOf = z, mr;
}
var Lve = Y_.exports, Qz;
function X5() {
  return Qz || (Qz = 1, process.env.NODE_ENV === "production" ? Y_.exports = Mfe() : Y_.exports = Dfe()), Y_.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var xR, Jz;
function Lfe() {
  if (Jz)
    return xR;
  Jz = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var l = {}, d = 0; d < 10; d++)
        l["_" + String.fromCharCode(d)] = d;
      var h = Object.getOwnPropertyNames(l).map(function(m) {
        return l[m];
      });
      if (h.join("") !== "0123456789")
        return !1;
      var p = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        p[m] = m;
      }), Object.keys(Object.assign({}, p)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return xR = i() ? Object.assign : function(s, l) {
    for (var d, h = n(s), p, m = 1; m < arguments.length; m++) {
      d = Object(arguments[m]);
      for (var x in d)
        t.call(d, x) && (h[x] = d[x]);
      if (e) {
        p = e(d);
        for (var S = 0; S < p.length; S++)
          r.call(d, p[S]) && (h[p[S]] = d[p[S]]);
      }
    }
    return h;
  }, xR;
}
var bR, eH;
function q5() {
  return eH || (eH = 1, bR = Function.call.bind(Object.prototype.hasOwnProperty)), bR;
}
var SR, tH;
function Pfe() {
  if (tH)
    return SR;
  tH = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = jL(), r = {}, n = q5();
    e = function(s) {
      var l = "Warning: " + s;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function i(s, l, d, h, p) {
    if (process.env.NODE_ENV !== "production") {
      for (var m in s)
        if (n(s, m)) {
          var x;
          try {
            if (typeof s[m] != "function") {
              var S = Error(
                (h || "React class") + ": " + d + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw S.name = "Invariant Violation", S;
            }
            x = s[m](l, m, h, d, null, t);
          } catch (k) {
            x = k;
          }
          if (x && !(x instanceof Error) && e(
            (h || "React class") + ": type specification of " + d + " `" + m + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof x + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), x instanceof Error && !(x.message in r)) {
            r[x.message] = !0;
            var T = p ? p() : "";
            e(
              "Failed " + d + " type: " + x.message + (T ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, SR = i, SR;
}
var CR, rH;
function Ife() {
  if (rH)
    return CR;
  rH = 1;
  var e = X5(), t = Lfe(), r = jL(), n = q5(), i = Pfe(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(d) {
    var h = "Warning: " + d;
    typeof console < "u" && console.error(h);
    try {
      throw new Error(h);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return CR = function(d, h) {
    var p = typeof Symbol == "function" && Symbol.iterator, m = "@@iterator";
    function x(G) {
      var se = G && (p && G[p] || G[m]);
      if (typeof se == "function")
        return se;
    }
    var S = "<<anonymous>>", T = {
      array: L("array"),
      bigint: L("bigint"),
      bool: L("boolean"),
      func: L("function"),
      number: L("number"),
      object: L("object"),
      string: L("string"),
      symbol: L("symbol"),
      any: F(),
      arrayOf: z,
      element: V(),
      elementType: P(),
      instanceOf: j,
      node: he(),
      objectOf: ee,
      oneOf: Z,
      oneOfType: J,
      shape: Re,
      exact: Ce
    };
    function k(G, se) {
      return G === se ? G !== 0 || 1 / G === 1 / se : G !== G && se !== se;
    }
    function O(G, se) {
      this.message = G, this.data = se && typeof se == "object" ? se : {}, this.stack = "";
    }
    O.prototype = Error.prototype;
    function D(G) {
      if (process.env.NODE_ENV !== "production")
        var se = {}, Te = 0;
      function Pe(He, Ue, Ze, Qe, it, We, _t) {
        if (Qe = Qe || S, We = We || Ze, _t !== r) {
          if (h) {
            var xe = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw xe.name = "Invariant Violation", xe;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Je = Qe + ":" + Ze;
            !se[Je] && // Avoid spamming the console because they are often not actionable except for lib authors
            Te < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + We + "` prop on `" + Qe + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), se[Je] = !0, Te++);
          }
        }
        return Ue[Ze] == null ? He ? Ue[Ze] === null ? new O("The " + it + " `" + We + "` is marked as required " + ("in `" + Qe + "`, but its value is `null`.")) : new O("The " + it + " `" + We + "` is marked as required in " + ("`" + Qe + "`, but its value is `undefined`.")) : null : G(Ue, Ze, Qe, it, We);
      }
      var Ie = Pe.bind(null, !1);
      return Ie.isRequired = Pe.bind(null, !0), Ie;
    }
    function L(G) {
      function se(Te, Pe, Ie, He, Ue, Ze) {
        var Qe = Te[Pe], it = fe(Qe);
        if (it !== G) {
          var We = Ee(Qe);
          return new O(
            "Invalid " + He + " `" + Ue + "` of type " + ("`" + We + "` supplied to `" + Ie + "`, expected ") + ("`" + G + "`."),
            { expectedType: G }
          );
        }
        return null;
      }
      return D(se);
    }
    function F() {
      return D(l);
    }
    function z(G) {
      function se(Te, Pe, Ie, He, Ue) {
        if (typeof G != "function")
          return new O("Property `" + Ue + "` of component `" + Ie + "` has invalid PropType notation inside arrayOf.");
        var Ze = Te[Pe];
        if (!Array.isArray(Ze)) {
          var Qe = fe(Ze);
          return new O("Invalid " + He + " `" + Ue + "` of type " + ("`" + Qe + "` supplied to `" + Ie + "`, expected an array."));
        }
        for (var it = 0; it < Ze.length; it++) {
          var We = G(Ze, it, Ie, He, Ue + "[" + it + "]", r);
          if (We instanceof Error)
            return We;
        }
        return null;
      }
      return D(se);
    }
    function V() {
      function G(se, Te, Pe, Ie, He) {
        var Ue = se[Te];
        if (!d(Ue)) {
          var Ze = fe(Ue);
          return new O("Invalid " + Ie + " `" + He + "` of type " + ("`" + Ze + "` supplied to `" + Pe + "`, expected a single ReactElement."));
        }
        return null;
      }
      return D(G);
    }
    function P() {
      function G(se, Te, Pe, Ie, He) {
        var Ue = se[Te];
        if (!e.isValidElementType(Ue)) {
          var Ze = fe(Ue);
          return new O("Invalid " + Ie + " `" + He + "` of type " + ("`" + Ze + "` supplied to `" + Pe + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return D(G);
    }
    function j(G) {
      function se(Te, Pe, Ie, He, Ue) {
        if (!(Te[Pe] instanceof G)) {
          var Ze = G.name || S, Qe = pe(Te[Pe]);
          return new O("Invalid " + He + " `" + Ue + "` of type " + ("`" + Qe + "` supplied to `" + Ie + "`, expected ") + ("instance of `" + Ze + "`."));
        }
        return null;
      }
      return D(se);
    }
    function Z(G) {
      if (!Array.isArray(G))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), l;
      function se(Te, Pe, Ie, He, Ue) {
        for (var Ze = Te[Pe], Qe = 0; Qe < G.length; Qe++)
          if (k(Ze, G[Qe]))
            return null;
        var it = JSON.stringify(G, function(_t, xe) {
          var Je = Ee(xe);
          return Je === "symbol" ? String(xe) : xe;
        });
        return new O("Invalid " + He + " `" + Ue + "` of value `" + String(Ze) + "` " + ("supplied to `" + Ie + "`, expected one of " + it + "."));
      }
      return D(se);
    }
    function ee(G) {
      function se(Te, Pe, Ie, He, Ue) {
        if (typeof G != "function")
          return new O("Property `" + Ue + "` of component `" + Ie + "` has invalid PropType notation inside objectOf.");
        var Ze = Te[Pe], Qe = fe(Ze);
        if (Qe !== "object")
          return new O("Invalid " + He + " `" + Ue + "` of type " + ("`" + Qe + "` supplied to `" + Ie + "`, expected an object."));
        for (var it in Ze)
          if (n(Ze, it)) {
            var We = G(Ze, it, Ie, He, Ue + "." + it, r);
            if (We instanceof Error)
              return We;
          }
        return null;
      }
      return D(se);
    }
    function J(G) {
      if (!Array.isArray(G))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var se = 0; se < G.length; se++) {
        var Te = G[se];
        if (typeof Te != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Q(Te) + " at index " + se + "."
          ), l;
      }
      function Pe(Ie, He, Ue, Ze, Qe) {
        for (var it = [], We = 0; We < G.length; We++) {
          var _t = G[We], xe = _t(Ie, He, Ue, Ze, Qe, r);
          if (xe == null)
            return null;
          xe.data && n(xe.data, "expectedType") && it.push(xe.data.expectedType);
        }
        var Je = it.length > 0 ? ", expected one of type [" + it.join(", ") + "]" : "";
        return new O("Invalid " + Ze + " `" + Qe + "` supplied to " + ("`" + Ue + "`" + Je + "."));
      }
      return D(Pe);
    }
    function he() {
      function G(se, Te, Pe, Ie, He) {
        return le(se[Te]) ? null : new O("Invalid " + Ie + " `" + He + "` supplied to " + ("`" + Pe + "`, expected a ReactNode."));
      }
      return D(G);
    }
    function de(G, se, Te, Pe, Ie) {
      return new O(
        (G || "React class") + ": " + se + " type `" + Te + "." + Pe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Ie + "`."
      );
    }
    function Re(G) {
      function se(Te, Pe, Ie, He, Ue) {
        var Ze = Te[Pe], Qe = fe(Ze);
        if (Qe !== "object")
          return new O("Invalid " + He + " `" + Ue + "` of type `" + Qe + "` " + ("supplied to `" + Ie + "`, expected `object`."));
        for (var it in G) {
          var We = G[it];
          if (typeof We != "function")
            return de(Ie, He, Ue, it, Ee(We));
          var _t = We(Ze, it, Ie, He, Ue + "." + it, r);
          if (_t)
            return _t;
        }
        return null;
      }
      return D(se);
    }
    function Ce(G) {
      function se(Te, Pe, Ie, He, Ue) {
        var Ze = Te[Pe], Qe = fe(Ze);
        if (Qe !== "object")
          return new O("Invalid " + He + " `" + Ue + "` of type `" + Qe + "` " + ("supplied to `" + Ie + "`, expected `object`."));
        var it = t({}, Te[Pe], G);
        for (var We in it) {
          var _t = G[We];
          if (n(G, We) && typeof _t != "function")
            return de(Ie, He, Ue, We, Ee(_t));
          if (!_t)
            return new O(
              "Invalid " + He + " `" + Ue + "` key `" + We + "` supplied to `" + Ie + "`.\nBad object: " + JSON.stringify(Te[Pe], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(G), null, "  ")
            );
          var xe = _t(Ze, We, Ie, He, Ue + "." + We, r);
          if (xe)
            return xe;
        }
        return null;
      }
      return D(se);
    }
    function le(G) {
      switch (typeof G) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !G;
        case "object":
          if (Array.isArray(G))
            return G.every(le);
          if (G === null || d(G))
            return !0;
          var se = x(G);
          if (se) {
            var Te = se.call(G), Pe;
            if (se !== G.entries) {
              for (; !(Pe = Te.next()).done; )
                if (!le(Pe.value))
                  return !1;
            } else
              for (; !(Pe = Te.next()).done; ) {
                var Ie = Pe.value;
                if (Ie && !le(Ie[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function me(G, se) {
      return G === "symbol" ? !0 : se ? se["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && se instanceof Symbol : !1;
    }
    function fe(G) {
      var se = typeof G;
      return Array.isArray(G) ? "array" : G instanceof RegExp ? "object" : me(se, G) ? "symbol" : se;
    }
    function Ee(G) {
      if (typeof G > "u" || G === null)
        return "" + G;
      var se = fe(G);
      if (se === "object") {
        if (G instanceof Date)
          return "date";
        if (G instanceof RegExp)
          return "regexp";
      }
      return se;
    }
    function Q(G) {
      var se = Ee(G);
      switch (se) {
        case "array":
        case "object":
          return "an " + se;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + se;
        default:
          return se;
      }
    }
    function pe(G) {
      return !G.constructor || !G.constructor.name ? S : G.constructor.name;
    }
    return T.checkPropTypes = i, T.resetWarningCache = i.resetWarningCache, T.PropTypes = T, T;
  }, CR;
}
var Pve = sT.exports;
if (process.env.NODE_ENV !== "production") {
  var Nfe = X5(), Vfe = !0;
  sT.exports = Ife()(Nfe.isElement, Vfe);
} else
  sT.exports = Rfe()();
var re = sT.exports;
var oM = Ve.on, Ive = Ve.one, hg = Ve.off, Nve = Ve.trigger, Ffe = Ve.triggerHandler, Vve = Ve.Event, lT = { exports: {} }, ja = {}, W_ = { exports: {} }, ER = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nH;
function Bfe() {
  return nH || (nH = 1, function(e) {
    "use strict";
    process.env.NODE_ENV !== "production" && function() {
      "use strict";
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var t = !1, r = !1, n = 5;
      function i(Ge, ht) {
        var Vt = Ge.length;
        Ge.push(ht), d(Ge, ht, Vt);
      }
      function s(Ge) {
        return Ge.length === 0 ? null : Ge[0];
      }
      function l(Ge) {
        if (Ge.length === 0)
          return null;
        var ht = Ge[0], Vt = Ge.pop();
        return Vt !== ht && (Ge[0] = Vt, h(Ge, Vt, 0)), ht;
      }
      function d(Ge, ht, Vt) {
        for (var cr = Vt; cr > 0; ) {
          var _r = cr - 1 >>> 1, wn = Ge[_r];
          if (p(wn, ht) > 0)
            Ge[_r] = ht, Ge[cr] = wn, cr = _r;
          else
            return;
        }
      }
      function h(Ge, ht, Vt) {
        for (var cr = Vt, _r = Ge.length, wn = _r >>> 1; cr < wn; ) {
          var Yr = (cr + 1) * 2 - 1, An = Ge[Yr], Br = Yr + 1, Qt = Ge[Br];
          if (p(An, ht) < 0)
            Br < _r && p(Qt, An) < 0 ? (Ge[cr] = Qt, Ge[Br] = ht, cr = Br) : (Ge[cr] = An, Ge[Yr] = ht, cr = Yr);
          else if (Br < _r && p(Qt, ht) < 0)
            Ge[cr] = Qt, Ge[Br] = ht, cr = Br;
          else
            return;
        }
      }
      function p(Ge, ht) {
        var Vt = Ge.sortIndex - ht.sortIndex;
        return Vt !== 0 ? Vt : Ge.id - ht.id;
      }
      var m = 1, x = 2, S = 3, T = 4, k = 5;
      function O(Ge, ht) {
      }
      var D = typeof performance == "object" && typeof performance.now == "function";
      if (D) {
        var L = performance;
        e.unstable_now = function() {
          return L.now();
        };
      } else {
        var F = Date, z = F.now();
        e.unstable_now = function() {
          return F.now() - z;
        };
      }
      var V = 1073741823, P = -1, j = 250, Z = 5e3, ee = 1e4, J = V, he = [], de = [], Re = 1, Ce = null, le = S, me = !1, fe = !1, Ee = !1, Q = typeof setTimeout == "function" ? setTimeout : null, pe = typeof clearTimeout == "function" ? clearTimeout : null, G = typeof setImmediate < "u" ? setImmediate : null, se = typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
      function Te(Ge) {
        for (var ht = s(de); ht !== null; ) {
          if (ht.callback === null)
            l(de);
          else if (ht.startTime <= Ge)
            l(de), ht.sortIndex = ht.expirationTime, i(he, ht);
          else
            return;
          ht = s(de);
        }
      }
      function Pe(Ge) {
        if (Ee = !1, Te(Ge), !fe)
          if (s(he) !== null)
            fe = !0, $r(Ie);
          else {
            var ht = s(de);
            ht !== null && Tn(Pe, ht.startTime - Ge);
          }
      }
      function Ie(Ge, ht) {
        fe = !1, Ee && (Ee = !1, Wo()), me = !0;
        var Vt = le;
        try {
          if (r)
            try {
              return He(Ge, ht);
            } catch (_r) {
              if (Ce !== null) {
                var cr = e.unstable_now();
                Ce.isQueued = !1;
              }
              throw _r;
            }
          else
            return He(Ge, ht);
        } finally {
          Ce = null, le = Vt, me = !1;
        }
      }
      function He(Ge, ht) {
        var Vt = ht;
        for (Te(Vt), Ce = s(he); Ce !== null && !t && !(Ce.expirationTime > Vt && (!Ge || Fr())); ) {
          var cr = Ce.callback;
          if (typeof cr == "function") {
            Ce.callback = null, le = Ce.priorityLevel;
            var _r = Ce.expirationTime <= Vt, wn = cr(_r);
            Vt = e.unstable_now(), typeof wn == "function" ? Ce.callback = wn : Ce === s(he) && l(he), Te(Vt);
          } else
            l(he);
          Ce = s(he);
        }
        if (Ce !== null)
          return !0;
        var Yr = s(de);
        return Yr !== null && Tn(Pe, Yr.startTime - Vt), !1;
      }
      function Ue(Ge, ht) {
        switch (Ge) {
          case m:
          case x:
          case S:
          case T:
          case k:
            break;
          default:
            Ge = S;
        }
        var Vt = le;
        le = Ge;
        try {
          return ht();
        } finally {
          le = Vt;
        }
      }
      function Ze(Ge) {
        var ht;
        switch (le) {
          case m:
          case x:
          case S:
            ht = S;
            break;
          default:
            ht = le;
            break;
        }
        var Vt = le;
        le = ht;
        try {
          return Ge();
        } finally {
          le = Vt;
        }
      }
      function Qe(Ge) {
        var ht = le;
        return function() {
          var Vt = le;
          le = ht;
          try {
            return Ge.apply(this, arguments);
          } finally {
            le = Vt;
          }
        };
      }
      function it(Ge, ht, Vt) {
        var cr = e.unstable_now(), _r;
        if (typeof Vt == "object" && Vt !== null) {
          var wn = Vt.delay;
          typeof wn == "number" && wn > 0 ? _r = cr + wn : _r = cr;
        } else
          _r = cr;
        var Yr;
        switch (Ge) {
          case m:
            Yr = P;
            break;
          case x:
            Yr = j;
            break;
          case k:
            Yr = J;
            break;
          case T:
            Yr = ee;
            break;
          case S:
          default:
            Yr = Z;
            break;
        }
        var An = _r + Yr, Br = {
          id: Re++,
          callback: ht,
          priorityLevel: Ge,
          startTime: _r,
          expirationTime: An,
          sortIndex: -1
        };
        return _r > cr ? (Br.sortIndex = _r, i(de, Br), s(he) === null && Br === s(de) && (Ee ? Wo() : Ee = !0, Tn(Pe, _r - cr))) : (Br.sortIndex = An, i(he, Br), !fe && !me && (fe = !0, $r(Ie))), Br;
      }
      function We() {
      }
      function _t() {
        !fe && !me && (fe = !0, $r(Ie));
      }
      function xe() {
        return s(he);
      }
      function Je(Ge) {
        Ge.callback = null;
      }
      function Pt() {
        return le;
      }
      var bt = !1, ir = null, Cr = -1, qt = n, ur = -1;
      function Fr() {
        var Ge = e.unstable_now() - ur;
        return !(Ge < qt);
      }
      function pi() {
      }
      function Ri(Ge) {
        if (Ge < 0 || Ge > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        Ge > 0 ? qt = Math.floor(1e3 / Ge) : qt = n;
      }
      var hn = function() {
        if (ir !== null) {
          var Ge = e.unstable_now();
          ur = Ge;
          var ht = !0, Vt = !0;
          try {
            Vt = ir(ht, Ge);
          } finally {
            Vt ? fr() : (bt = !1, ir = null);
          }
        } else
          bt = !1;
      }, fr;
      if (typeof G == "function")
        fr = function() {
          G(hn);
        };
      else if (typeof MessageChannel < "u") {
        var Er = new MessageChannel(), Ji = Er.port2;
        Er.port1.onmessage = hn, fr = function() {
          Ji.postMessage(null);
        };
      } else
        fr = function() {
          Q(hn, 0);
        };
      function $r(Ge) {
        ir = Ge, bt || (bt = !0, fr());
      }
      function Tn(Ge, ht) {
        Cr = Q(function() {
          Ge(e.unstable_now());
        }, ht);
      }
      function Wo() {
        pe(Cr), Cr = -1;
      }
      var Za = pi, Sa = null;
      e.unstable_IdlePriority = k, e.unstable_ImmediatePriority = m, e.unstable_LowPriority = T, e.unstable_NormalPriority = S, e.unstable_Profiling = Sa, e.unstable_UserBlockingPriority = x, e.unstable_cancelCallback = Je, e.unstable_continueExecution = _t, e.unstable_forceFrameRate = Ri, e.unstable_getCurrentPriorityLevel = Pt, e.unstable_getFirstCallbackNode = xe, e.unstable_next = Ze, e.unstable_pauseExecution = We, e.unstable_requestPaint = Za, e.unstable_runWithPriority = Ue, e.unstable_scheduleCallback = it, e.unstable_shouldYield = Fr, e.unstable_wrapCallback = Qe, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(ER)), ER;
}
var TR = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var iH;
function zfe() {
  return iH || (iH = 1, function(e) {
    "use strict";
    function t(Q, pe) {
      var G = Q.length;
      Q.push(pe);
      e:
        for (; 0 < G; ) {
          var se = G - 1 >>> 1, Te = Q[se];
          if (0 < i(Te, pe))
            Q[se] = pe, Q[G] = Te, G = se;
          else
            break e;
        }
    }
    function r(Q) {
      return Q.length === 0 ? null : Q[0];
    }
    function n(Q) {
      if (Q.length === 0)
        return null;
      var pe = Q[0], G = Q.pop();
      if (G !== pe) {
        Q[0] = G;
        e:
          for (var se = 0, Te = Q.length, Pe = Te >>> 1; se < Pe; ) {
            var Ie = 2 * (se + 1) - 1, He = Q[Ie], Ue = Ie + 1, Ze = Q[Ue];
            if (0 > i(He, G))
              Ue < Te && 0 > i(Ze, He) ? (Q[se] = Ze, Q[Ue] = G, se = Ue) : (Q[se] = He, Q[Ie] = G, se = Ie);
            else if (Ue < Te && 0 > i(Ze, G))
              Q[se] = Ze, Q[Ue] = G, se = Ue;
            else
              break e;
          }
      }
      return pe;
    }
    function i(Q, pe) {
      var G = Q.sortIndex - pe.sortIndex;
      return G !== 0 ? G : Q.id - pe.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var s = performance;
      e.unstable_now = function() {
        return s.now();
      };
    } else {
      var l = Date, d = l.now();
      e.unstable_now = function() {
        return l.now() - d;
      };
    }
    var h = [], p = [], m = 1, x = null, S = 3, T = !1, k = !1, O = !1, D = typeof setTimeout == "function" ? setTimeout : null, L = typeof clearTimeout == "function" ? clearTimeout : null, F = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function z(Q) {
      for (var pe = r(p); pe !== null; ) {
        if (pe.callback === null)
          n(p);
        else if (pe.startTime <= Q)
          n(p), pe.sortIndex = pe.expirationTime, t(h, pe);
        else
          break;
        pe = r(p);
      }
    }
    function V(Q) {
      if (O = !1, z(Q), !k)
        if (r(h) !== null)
          k = !0, fe(P);
        else {
          var pe = r(p);
          pe !== null && Ee(V, pe.startTime - Q);
        }
    }
    function P(Q, pe) {
      k = !1, O && (O = !1, L(ee), ee = -1), T = !0;
      var G = S;
      try {
        for (z(pe), x = r(h); x !== null && (!(x.expirationTime > pe) || Q && !de()); ) {
          var se = x.callback;
          if (typeof se == "function") {
            x.callback = null, S = x.priorityLevel;
            var Te = se(x.expirationTime <= pe);
            pe = e.unstable_now(), typeof Te == "function" ? x.callback = Te : x === r(h) && n(h), z(pe);
          } else
            n(h);
          x = r(h);
        }
        if (x !== null)
          var Pe = !0;
        else {
          var Ie = r(p);
          Ie !== null && Ee(V, Ie.startTime - pe), Pe = !1;
        }
        return Pe;
      } finally {
        x = null, S = G, T = !1;
      }
    }
    var j = !1, Z = null, ee = -1, J = 5, he = -1;
    function de() {
      return !(e.unstable_now() - he < J);
    }
    function Re() {
      if (Z !== null) {
        var Q = e.unstable_now();
        he = Q;
        var pe = !0;
        try {
          pe = Z(!0, Q);
        } finally {
          pe ? Ce() : (j = !1, Z = null);
        }
      } else
        j = !1;
    }
    var Ce;
    if (typeof F == "function")
      Ce = function() {
        F(Re);
      };
    else if (typeof MessageChannel < "u") {
      var le = new MessageChannel(), me = le.port2;
      le.port1.onmessage = Re, Ce = function() {
        me.postMessage(null);
      };
    } else
      Ce = function() {
        D(Re, 0);
      };
    function fe(Q) {
      Z = Q, j || (j = !0, Ce());
    }
    function Ee(Q, pe) {
      ee = D(function() {
        Q(e.unstable_now());
      }, pe);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(Q) {
      Q.callback = null;
    }, e.unstable_continueExecution = function() {
      k || T || (k = !0, fe(P));
    }, e.unstable_forceFrameRate = function(Q) {
      0 > Q || 125 < Q ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : J = 0 < Q ? Math.floor(1e3 / Q) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return S;
    }, e.unstable_getFirstCallbackNode = function() {
      return r(h);
    }, e.unstable_next = function(Q) {
      switch (S) {
        case 1:
        case 2:
        case 3:
          var pe = 3;
          break;
        default:
          pe = S;
      }
      var G = S;
      S = pe;
      try {
        return Q();
      } finally {
        S = G;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(Q, pe) {
      switch (Q) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          Q = 3;
      }
      var G = S;
      S = Q;
      try {
        return pe();
      } finally {
        S = G;
      }
    }, e.unstable_scheduleCallback = function(Q, pe, G) {
      var se = e.unstable_now();
      switch (typeof G == "object" && G !== null ? (G = G.delay, G = typeof G == "number" && 0 < G ? se + G : se) : G = se, Q) {
        case 1:
          var Te = -1;
          break;
        case 2:
          Te = 250;
          break;
        case 5:
          Te = 1073741823;
          break;
        case 4:
          Te = 1e4;
          break;
        default:
          Te = 5e3;
      }
      return Te = G + Te, Q = { id: m++, callback: pe, priorityLevel: Q, startTime: G, expirationTime: Te, sortIndex: -1 }, G > se ? (Q.sortIndex = G, t(p, Q), r(h) === null && Q === r(p) && (O ? (L(ee), ee = -1) : O = !0, Ee(V, G - se))) : (Q.sortIndex = Te, t(h, Q), k || T || (k = !0, fe(P))), Q;
    }, e.unstable_shouldYield = de, e.unstable_wrapCallback = function(Q) {
      var pe = S;
      return function() {
        var G = S;
        S = pe;
        try {
          return Q.apply(this, arguments);
        } finally {
          S = G;
        }
      };
    };
  }(TR)), TR;
}
var Fve = W_.exports, aH;
function K5() {
  return aH || (aH = 1, process.env.NODE_ENV === "production" ? W_.exports = zfe() : W_.exports = Bfe()), W_.exports;
}
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var oH;
function Hfe() {
  return oH || (oH = 1, process.env.NODE_ENV !== "production" && function() {
    "use strict";
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = nc, t = K5(), r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, n = !1;
    function i(a) {
      n = a;
    }
    function s(a) {
      if (!n) {
        for (var o = arguments.length, f = new Array(o > 1 ? o - 1 : 0), v = 1; v < o; v++)
          f[v - 1] = arguments[v];
        d("warn", a, f);
      }
    }
    function l(a) {
      if (!n) {
        for (var o = arguments.length, f = new Array(o > 1 ? o - 1 : 0), v = 1; v < o; v++)
          f[v - 1] = arguments[v];
        d("error", a, f);
      }
    }
    function d(a, o, f) {
      {
        var v = r.ReactDebugCurrentFrame, _ = v.getStackAddendum();
        _ !== "" && (o += "%s", f = f.concat([_]));
        var b = f.map(function(E) {
          return String(E);
        });
        b.unshift("Warning: " + o), Function.prototype.apply.call(console[a], console, b);
      }
    }
    var h = 0, p = 1, m = 2, x = 3, S = 4, T = 5, k = 6, O = 7, D = 8, L = 9, F = 10, z = 11, V = 12, P = 13, j = 14, Z = 15, ee = 16, J = 17, he = 18, de = 19, Re = 21, Ce = 22, le = 23, me = 24, fe = 25, Ee = !0, Q = !1, pe = !1, G = !1, se = !1, Te = !0, Pe = !1, Ie = !1, He = !0, Ue = !0, Ze = !0, Qe = /* @__PURE__ */ new Set(), it = {}, We = {};
    function _t(a, o) {
      xe(a, o), xe(a + "Capture", o);
    }
    function xe(a, o) {
      it[a] && l("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", a), it[a] = o;
      {
        var f = a.toLowerCase();
        We[f] = a, a === "onDoubleClick" && (We.ondblclick = a);
      }
      for (var v = 0; v < o.length; v++)
        Qe.add(o[v]);
    }
    var Je = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Pt = Object.prototype.hasOwnProperty;
    function bt(a) {
      {
        var o = typeof Symbol == "function" && Symbol.toStringTag, f = o && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return f;
      }
    }
    function ir(a) {
      try {
        return Cr(a), !1;
      } catch {
        return !0;
      }
    }
    function Cr(a) {
      return "" + a;
    }
    function qt(a, o) {
      if (ir(a))
        return l("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", o, bt(a)), Cr(a);
    }
    function ur(a) {
      if (ir(a))
        return l("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", bt(a)), Cr(a);
    }
    function Fr(a, o) {
      if (ir(a))
        return l("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", o, bt(a)), Cr(a);
    }
    function pi(a, o) {
      if (ir(a))
        return l("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", o, bt(a)), Cr(a);
    }
    function Ri(a) {
      if (ir(a))
        return l("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", bt(a)), Cr(a);
    }
    function hn(a) {
      if (ir(a))
        return l("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", bt(a)), Cr(a);
    }
    var fr = 0, Er = 1, Ji = 2, $r = 3, Tn = 4, Wo = 5, Za = 6, Sa = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Ge = Sa + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", ht = new RegExp("^[" + Sa + "][" + Ge + "]*$"), Vt = {}, cr = {};
    function _r(a) {
      return Pt.call(cr, a) ? !0 : Pt.call(Vt, a) ? !1 : ht.test(a) ? (cr[a] = !0, !0) : (Vt[a] = !0, l("Invalid attribute name: `%s`", a), !1);
    }
    function wn(a, o, f) {
      return o !== null ? o.type === fr : f ? !1 : a.length > 2 && (a[0] === "o" || a[0] === "O") && (a[1] === "n" || a[1] === "N");
    }
    function Yr(a, o, f, v) {
      if (f !== null && f.type === fr)
        return !1;
      switch (typeof o) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (v)
            return !1;
          if (f !== null)
            return !f.acceptsBooleans;
          var _ = a.toLowerCase().slice(0, 5);
          return _ !== "data-" && _ !== "aria-";
        }
        default:
          return !1;
      }
    }
    function An(a, o, f, v) {
      if (o === null || typeof o > "u" || Yr(a, o, f, v))
        return !0;
      if (v)
        return !1;
      if (f !== null)
        switch (f.type) {
          case $r:
            return !o;
          case Tn:
            return o === !1;
          case Wo:
            return isNaN(o);
          case Za:
            return isNaN(o) || o < 1;
        }
      return !1;
    }
    function Br(a) {
      return Tr.hasOwnProperty(a) ? Tr[a] : null;
    }
    function Qt(a, o, f, v, _, b, E) {
      this.acceptsBooleans = o === Ji || o === $r || o === Tn, this.attributeName = v, this.attributeNamespace = _, this.mustUseProperty = f, this.propertyName = a, this.type = o, this.sanitizeURL = b, this.removeEmptyString = E;
    }
    var Tr = {}, sc = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    sc.forEach(function(a) {
      Tr[a] = new Qt(
        a,
        fr,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
      var o = a[0], f = a[1];
      Tr[o] = new Qt(
        o,
        Er,
        !1,
        // mustUseProperty
        f,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
      Tr[a] = new Qt(
        a,
        Ji,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
      Tr[a] = new Qt(
        a,
        Ji,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(a) {
      Tr[a] = new Qt(
        a,
        $r,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      Tr[a] = new Qt(
        a,
        $r,
        !0,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      Tr[a] = new Qt(
        a,
        Tn,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      Tr[a] = new Qt(
        a,
        Za,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(a) {
      Tr[a] = new Qt(
        a,
        Wo,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Gl = /[\-\:]([a-z])/g, lc = function(a) {
      return a[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      var o = a.replace(Gl, lc);
      Tr[o] = new Qt(
        o,
        Er,
        !1,
        // mustUseProperty
        a,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      var o = a.replace(Gl, lc);
      Tr[o] = new Qt(
        o,
        Er,
        !1,
        // mustUseProperty
        a,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      var o = a.replace(Gl, lc);
      Tr[o] = new Qt(
        o,
        Er,
        !1,
        // mustUseProperty
        a,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(a) {
      Tr[a] = new Qt(
        a,
        Er,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var Xd = "xlinkHref";
    Tr[Xd] = new Qt(
      "xlinkHref",
      Er,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(a) {
      Tr[a] = new Qt(
        a,
        Er,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var Hh = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Ul = !1;
    function uc(a) {
      !Ul && Hh.test(a) && (Ul = !0, l("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(a)));
    }
    function jl(a, o, f, v) {
      if (v.mustUseProperty) {
        var _ = v.propertyName;
        return a[_];
      } else {
        qt(f, o), v.sanitizeURL && uc("" + f);
        var b = v.attributeName, E = null;
        if (v.type === Tn) {
          if (a.hasAttribute(b)) {
            var A = a.getAttribute(b);
            return A === "" ? !0 : An(o, f, v, !1) ? A : A === "" + f ? f : A;
          }
        } else if (a.hasAttribute(b)) {
          if (An(o, f, v, !1))
            return a.getAttribute(b);
          if (v.type === $r)
            return f;
          E = a.getAttribute(b);
        }
        return An(o, f, v, !1) ? E === null ? f : E : E === "" + f ? f : E;
      }
    }
    function cc(a, o, f, v) {
      {
        if (!_r(o))
          return;
        if (!a.hasAttribute(o))
          return f === void 0 ? void 0 : null;
        var _ = a.getAttribute(o);
        return qt(f, o), _ === "" + f ? f : _;
      }
    }
    function go(a, o, f, v) {
      var _ = Br(o);
      if (!wn(o, _, v)) {
        if (An(o, f, _, v) && (f = null), v || _ === null) {
          if (_r(o)) {
            var b = o;
            f === null ? a.removeAttribute(b) : (qt(f, o), a.setAttribute(b, "" + f));
          }
          return;
        }
        var E = _.mustUseProperty;
        if (E) {
          var A = _.propertyName;
          if (f === null) {
            var R = _.type;
            a[A] = R === $r ? !1 : "";
          } else
            a[A] = f;
          return;
        }
        var N = _.attributeName, B = _.attributeNamespace;
        if (f === null)
          a.removeAttribute(N);
        else {
          var K = _.type, X;
          K === $r || K === Tn && f === !0 ? X = "" : (qt(f, N), X = "" + f, _.sanitizeURL && uc(X.toString())), B ? a.setAttributeNS(B, N, X) : a.setAttribute(N, X);
        }
      }
    }
    var Bs = Symbol.for("react.element"), ea = Symbol.for("react.portal"), Qa = Symbol.for("react.fragment"), zs = Symbol.for("react.strict_mode"), U = Symbol.for("react.profiler"), ke = Symbol.for("react.provider"), ze = Symbol.for("react.context"), vt = Symbol.for("react.forward_ref"), It = Symbol.for("react.suspense"), Kt = Symbol.for("react.suspense_list"), Nt = Symbol.for("react.memo"), gt = Symbol.for("react.lazy"), On = Symbol.for("react.scope"), Mr = Symbol.for("react.debug_trace_mode"), Lr = Symbol.for("react.offscreen"), gi = Symbol.for("react.legacy_hidden"), Hs = Symbol.for("react.cache"), Gh = Symbol.for("react.tracing_marker"), Jt = Symbol.iterator, QT = "@@iterator";
    function Xo(a) {
      if (a === null || typeof a != "object")
        return null;
      var o = Jt && a[Jt] || a[QT];
      return typeof o == "function" ? o : null;
    }
    var Bt = Object.assign, Gs = 0, Hy, Kg, qd, Ja, Gy, Ca, Uy;
    function jy() {
    }
    jy.__reactDisabledLog = !0;
    function JT() {
      {
        if (Gs === 0) {
          Hy = console.log, Kg = console.info, qd = console.warn, Ja = console.error, Gy = console.group, Ca = console.groupCollapsed, Uy = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: jy,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        Gs++;
      }
    }
    function Uh() {
      {
        if (Gs--, Gs === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Bt({}, a, {
              value: Hy
            }),
            info: Bt({}, a, {
              value: Kg
            }),
            warn: Bt({}, a, {
              value: qd
            }),
            error: Bt({}, a, {
              value: Ja
            }),
            group: Bt({}, a, {
              value: Gy
            }),
            groupCollapsed: Bt({}, a, {
              value: Ca
            }),
            groupEnd: Bt({}, a, {
              value: Uy
            })
          });
        }
        Gs < 0 && l("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var dc = r.ReactCurrentDispatcher, $l;
    function eo(a, o, f) {
      {
        if ($l === void 0)
          try {
            throw Error();
          } catch (_) {
            var v = _.stack.trim().match(/\n( *(at )?)/);
            $l = v && v[1] || "";
          }
        return `
` + $l + a;
      }
    }
    var Zg = !1, jh;
    {
      var Qg = typeof WeakMap == "function" ? WeakMap : Map;
      jh = new Qg();
    }
    function $h(a, o) {
      if (!a || Zg)
        return "";
      {
        var f = jh.get(a);
        if (f !== void 0)
          return f;
      }
      var v;
      Zg = !0;
      var _ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var b;
      b = dc.current, dc.current = null, JT();
      try {
        if (o) {
          var E = function() {
            throw Error();
          };
          if (Object.defineProperty(E.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(E, []);
            } catch (oe) {
              v = oe;
            }
            Reflect.construct(a, [], E);
          } else {
            try {
              E.call();
            } catch (oe) {
              v = oe;
            }
            a.call(E.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (oe) {
            v = oe;
          }
          a();
        }
      } catch (oe) {
        if (oe && v && typeof oe.stack == "string") {
          for (var A = oe.stack.split(`
`), R = v.stack.split(`
`), N = A.length - 1, B = R.length - 1; N >= 1 && B >= 0 && A[N] !== R[B]; )
            B--;
          for (; N >= 1 && B >= 0; N--, B--)
            if (A[N] !== R[B]) {
              if (N !== 1 || B !== 1)
                do
                  if (N--, B--, B < 0 || A[N] !== R[B]) {
                    var K = `
` + A[N].replace(" at new ", " at ");
                    return a.displayName && K.includes("<anonymous>") && (K = K.replace("<anonymous>", a.displayName)), typeof a == "function" && jh.set(a, K), K;
                  }
                while (N >= 1 && B >= 0);
              break;
            }
        }
      } finally {
        Zg = !1, dc.current = b, Uh(), Error.prepareStackTrace = _;
      }
      var X = a ? a.displayName || a.name : "", ce = X ? eo(X) : "";
      return typeof a == "function" && jh.set(a, ce), ce;
    }
    function Jg(a, o, f) {
      return $h(a, !0);
    }
    function Yl(a, o, f) {
      return $h(a, !1);
    }
    function e1(a) {
      var o = a.prototype;
      return !!(o && o.isReactComponent);
    }
    function Kd(a, o, f) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return $h(a, e1(a));
      if (typeof a == "string")
        return eo(a);
      switch (a) {
        case It:
          return eo("Suspense");
        case Kt:
          return eo("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case vt:
            return Yl(a.render);
          case Nt:
            return Kd(a.type, o, f);
          case gt: {
            var v = a, _ = v._payload, b = v._init;
            try {
              return Kd(b(_), o, f);
            } catch {
            }
          }
        }
      return "";
    }
    function dr(a) {
      var o = a._debugOwner ? a._debugOwner.type : null, f = a._debugSource;
      switch (a.tag) {
        case T:
          return eo(a.type);
        case ee:
          return eo("Lazy");
        case P:
          return eo("Suspense");
        case de:
          return eo("SuspenseList");
        case h:
        case m:
        case Z:
          return Yl(a.type);
        case z:
          return Yl(a.type.render);
        case p:
          return Jg(a.type);
        default:
          return "";
      }
    }
    function em(a) {
      try {
        var o = "", f = a;
        do
          o += dr(f), f = f.return;
        while (f);
        return o;
      } catch (v) {
        return `
Error generating stack: ` + v.message + `
` + v.stack;
      }
    }
    function $y(a, o, f) {
      var v = a.displayName;
      if (v)
        return v;
      var _ = o.displayName || o.name || "";
      return _ !== "" ? f + "(" + _ + ")" : f;
    }
    function Yh(a) {
      return a.displayName || "Context";
    }
    function yr(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && l("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case Qa:
          return "Fragment";
        case ea:
          return "Portal";
        case U:
          return "Profiler";
        case zs:
          return "StrictMode";
        case It:
          return "Suspense";
        case Kt:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case ze:
            var o = a;
            return Yh(o) + ".Consumer";
          case ke:
            var f = a;
            return Yh(f._context) + ".Provider";
          case vt:
            return $y(a, a.render, "ForwardRef");
          case Nt:
            var v = a.displayName || null;
            return v !== null ? v : yr(a.type) || "Memo";
          case gt: {
            var _ = a, b = _._payload, E = _._init;
            try {
              return yr(E(b));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function Yy(a, o, f) {
      var v = o.displayName || o.name || "";
      return a.displayName || (v !== "" ? f + "(" + v + ")" : f);
    }
    function tm(a) {
      return a.displayName || "Context";
    }
    function kt(a) {
      var o = a.tag, f = a.type;
      switch (o) {
        case me:
          return "Cache";
        case L:
          var v = f;
          return tm(v) + ".Consumer";
        case F:
          var _ = f;
          return tm(_._context) + ".Provider";
        case he:
          return "DehydratedFragment";
        case z:
          return Yy(f, f.render, "ForwardRef");
        case O:
          return "Fragment";
        case T:
          return f;
        case S:
          return "Portal";
        case x:
          return "Root";
        case k:
          return "Text";
        case ee:
          return yr(f);
        case D:
          return f === zs ? "StrictMode" : "Mode";
        case Ce:
          return "Offscreen";
        case V:
          return "Profiler";
        case Re:
          return "Scope";
        case P:
          return "Suspense";
        case de:
          return "SuspenseList";
        case fe:
          return "TracingMarker";
        case p:
        case h:
        case J:
        case m:
        case j:
        case Z:
          if (typeof f == "function")
            return f.displayName || f.name || null;
          if (typeof f == "string")
            return f;
          break;
      }
      return null;
    }
    var Zd = r.ReactDebugCurrentFrame, an = null, Ea = !1;
    function Ta() {
      {
        if (an === null)
          return null;
        var a = an._debugOwner;
        if (a !== null && typeof a < "u")
          return kt(a);
      }
      return null;
    }
    function Qd() {
      return an === null ? "" : em(an);
    }
    function vn() {
      Zd.getCurrentStack = null, an = null, Ea = !1;
    }
    function hr(a) {
      Zd.getCurrentStack = a === null ? null : Qd, an = a, Ea = !1;
    }
    function t1() {
      return an;
    }
    function to(a) {
      Ea = a;
    }
    function ri(a) {
      return "" + a;
    }
    function Us(a) {
      switch (typeof a) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return a;
        case "object":
          return hn(a), a;
        default:
          return "";
      }
    }
    var Wy = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function fc(a, o) {
      Wy[o.type] || o.onChange || o.onInput || o.readOnly || o.disabled || o.value == null || l("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), o.onChange || o.readOnly || o.disabled || o.checked == null || l("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function rm(a) {
      var o = a.type, f = a.nodeName;
      return f && f.toLowerCase() === "input" && (o === "checkbox" || o === "radio");
    }
    function Xy(a) {
      return a._valueTracker;
    }
    function Jd(a) {
      a._valueTracker = null;
    }
    function ef(a) {
      var o = "";
      return a && (rm(a) ? o = a.checked ? "true" : "false" : o = a.value), o;
    }
    function hc(a) {
      var o = rm(a) ? "checked" : "value", f = Object.getOwnPropertyDescriptor(a.constructor.prototype, o);
      hn(a[o]);
      var v = "" + a[o];
      if (!(a.hasOwnProperty(o) || typeof f > "u" || typeof f.get != "function" || typeof f.set != "function")) {
        var _ = f.get, b = f.set;
        Object.defineProperty(a, o, {
          configurable: !0,
          get: function() {
            return _.call(this);
          },
          set: function(A) {
            hn(A), v = "" + A, b.call(this, A);
          }
        }), Object.defineProperty(a, o, {
          enumerable: f.enumerable
        });
        var E = {
          getValue: function() {
            return v;
          },
          setValue: function(A) {
            hn(A), v = "" + A;
          },
          stopTracking: function() {
            Jd(a), delete a[o];
          }
        };
        return E;
      }
    }
    function Wl(a) {
      Xy(a) || (a._valueTracker = hc(a));
    }
    function qy(a) {
      if (!a)
        return !1;
      var o = Xy(a);
      if (!o)
        return !0;
      var f = o.getValue(), v = ef(a);
      return v !== f ? (o.setValue(v), !0) : !1;
    }
    function Wh(a) {
      if (a = a || (typeof document < "u" ? document : void 0), typeof a > "u")
        return null;
      try {
        return a.activeElement || a.body;
      } catch {
        return a.body;
      }
    }
    var Xh = !1, tf = !1, qh = !1, nm = !1;
    function qo(a) {
      var o = a.type === "checkbox" || a.type === "radio";
      return o ? a.checked != null : a.value != null;
    }
    function rf(a, o) {
      var f = a, v = o.checked, _ = Bt({}, o, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: v ?? f._wrapperState.initialChecked
      });
      return _;
    }
    function nf(a, o) {
      fc("input", o), o.checked !== void 0 && o.defaultChecked !== void 0 && !tf && (l("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Ta() || "A component", o.type), tf = !0), o.value !== void 0 && o.defaultValue !== void 0 && !Xh && (l("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Ta() || "A component", o.type), Xh = !0);
      var f = a, v = o.defaultValue == null ? "" : o.defaultValue;
      f._wrapperState = {
        initialChecked: o.checked != null ? o.checked : o.defaultChecked,
        initialValue: Us(o.value != null ? o.value : v),
        controlled: qo(o)
      };
    }
    function im(a, o) {
      var f = a, v = o.checked;
      v != null && go(f, "checked", v, !1);
    }
    function vc(a, o) {
      var f = a;
      {
        var v = qo(o);
        !f._wrapperState.controlled && v && !nm && (l("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), nm = !0), f._wrapperState.controlled && !v && !qh && (l("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), qh = !0);
      }
      im(a, o);
      var _ = Us(o.value), b = o.type;
      if (_ != null)
        b === "number" ? (_ === 0 && f.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        f.value != _) && (f.value = ri(_)) : f.value !== ri(_) && (f.value = ri(_));
      else if (b === "submit" || b === "reset") {
        f.removeAttribute("value");
        return;
      }
      o.hasOwnProperty("value") ? js(f, o.type, _) : o.hasOwnProperty("defaultValue") && js(f, o.type, Us(o.defaultValue)), o.checked == null && o.defaultChecked != null && (f.defaultChecked = !!o.defaultChecked);
    }
    function af(a, o, f) {
      var v = a;
      if (o.hasOwnProperty("value") || o.hasOwnProperty("defaultValue")) {
        var _ = o.type, b = _ === "submit" || _ === "reset";
        if (b && (o.value === void 0 || o.value === null))
          return;
        var E = ri(v._wrapperState.initialValue);
        f || E !== v.value && (v.value = E), v.defaultValue = E;
      }
      var A = v.name;
      A !== "" && (v.name = ""), v.defaultChecked = !v.defaultChecked, v.defaultChecked = !!v._wrapperState.initialChecked, A !== "" && (v.name = A);
    }
    function Ky(a, o) {
      var f = a;
      vc(f, o), ta(f, o);
    }
    function ta(a, o) {
      var f = o.name;
      if (o.type === "radio" && f != null) {
        for (var v = a; v.parentNode; )
          v = v.parentNode;
        qt(f, "name");
        for (var _ = v.querySelectorAll("input[name=" + JSON.stringify("" + f) + '][type="radio"]'), b = 0; b < _.length; b++) {
          var E = _[b];
          if (!(E === a || E.form !== a.form)) {
            var A = wb(E);
            if (!A)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            qy(E), vc(E, A);
          }
        }
      }
    }
    function js(a, o, f) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (o !== "number" || Wh(a.ownerDocument) !== a) && (f == null ? a.defaultValue = ri(a._wrapperState.initialValue) : a.defaultValue !== ri(f) && (a.defaultValue = ri(f)));
    }
    var Kh = !1, pc = !1, Zy = !1;
    function Zh(a, o) {
      o.value == null && (typeof o.children == "object" && o.children !== null ? e.Children.forEach(o.children, function(f) {
        f != null && (typeof f == "string" || typeof f == "number" || pc || (pc = !0, l("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : o.dangerouslySetInnerHTML != null && (Zy || (Zy = !0, l("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), o.selected != null && !Kh && (l("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), Kh = !0);
    }
    function am(a, o) {
      o.value != null && a.setAttribute("value", ri(Us(o.value)));
    }
    var of = Array.isArray;
    function kn(a) {
      return of(a);
    }
    var Qh;
    Qh = !1;
    function Qy() {
      var a = Ta();
      return a ? `

Check the render method of \`` + a + "`." : "";
    }
    var Jy = ["value", "defaultValue"];
    function r1(a) {
      {
        fc("select", a);
        for (var o = 0; o < Jy.length; o++) {
          var f = Jy[o];
          if (a[f] != null) {
            var v = kn(a[f]);
            a.multiple && !v ? l("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", f, Qy()) : !a.multiple && v && l("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", f, Qy());
          }
        }
      }
    }
    function $s(a, o, f, v) {
      var _ = a.options;
      if (o) {
        for (var b = f, E = {}, A = 0; A < b.length; A++)
          E["$" + b[A]] = !0;
        for (var R = 0; R < _.length; R++) {
          var N = E.hasOwnProperty("$" + _[R].value);
          _[R].selected !== N && (_[R].selected = N), N && v && (_[R].defaultSelected = !0);
        }
      } else {
        for (var B = ri(Us(f)), K = null, X = 0; X < _.length; X++) {
          if (_[X].value === B) {
            _[X].selected = !0, v && (_[X].defaultSelected = !0);
            return;
          }
          K === null && !_[X].disabled && (K = _[X]);
        }
        K !== null && (K.selected = !0);
      }
    }
    function om(a, o) {
      return Bt({}, o, {
        value: void 0
      });
    }
    function ex(a, o) {
      var f = a;
      r1(o), f._wrapperState = {
        wasMultiple: !!o.multiple
      }, o.value !== void 0 && o.defaultValue !== void 0 && !Qh && (l("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Qh = !0);
    }
    function n1(a, o) {
      var f = a;
      f.multiple = !!o.multiple;
      var v = o.value;
      v != null ? $s(f, !!o.multiple, v, !1) : o.defaultValue != null && $s(f, !!o.multiple, o.defaultValue, !0);
    }
    function i1(a, o) {
      var f = a, v = f._wrapperState.wasMultiple;
      f._wrapperState.wasMultiple = !!o.multiple;
      var _ = o.value;
      _ != null ? $s(f, !!o.multiple, _, !1) : v !== !!o.multiple && (o.defaultValue != null ? $s(f, !!o.multiple, o.defaultValue, !0) : $s(f, !!o.multiple, o.multiple ? [] : "", !1));
    }
    function a1(a, o) {
      var f = a, v = o.value;
      v != null && $s(f, !!o.multiple, v, !1);
    }
    var sm = !1;
    function lm(a, o) {
      var f = a;
      if (o.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var v = Bt({}, o, {
        value: void 0,
        defaultValue: void 0,
        children: ri(f._wrapperState.initialValue)
      });
      return v;
    }
    function tx(a, o) {
      var f = a;
      fc("textarea", o), o.value !== void 0 && o.defaultValue !== void 0 && !sm && (l("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", Ta() || "A component"), sm = !0);
      var v = o.value;
      if (v == null) {
        var _ = o.children, b = o.defaultValue;
        if (_ != null) {
          l("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (b != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (kn(_)) {
              if (_.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              _ = _[0];
            }
            b = _;
          }
        }
        b == null && (b = ""), v = b;
      }
      f._wrapperState = {
        initialValue: Us(v)
      };
    }
    function rx(a, o) {
      var f = a, v = Us(o.value), _ = Us(o.defaultValue);
      if (v != null) {
        var b = ri(v);
        b !== f.value && (f.value = b), o.defaultValue == null && f.defaultValue !== b && (f.defaultValue = b);
      }
      _ != null && (f.defaultValue = ri(_));
    }
    function nx(a, o) {
      var f = a, v = f.textContent;
      v === f._wrapperState.initialValue && v !== "" && v !== null && (f.value = v);
    }
    function um(a, o) {
      rx(a, o);
    }
    var Ko = "http://www.w3.org/1999/xhtml", o1 = "http://www.w3.org/1998/Math/MathML", cm = "http://www.w3.org/2000/svg";
    function Jh(a) {
      switch (a) {
        case "svg":
          return cm;
        case "math":
          return o1;
        default:
          return Ko;
      }
    }
    function dm(a, o) {
      return a == null || a === Ko ? Jh(o) : a === cm && o === "foreignObject" ? Ko : a;
    }
    var s1 = function(a) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(o, f, v, _) {
        MSApp.execUnsafeLocalFunction(function() {
          return a(o, f, v, _);
        });
      } : a;
    }, ev, ix = s1(function(a, o) {
      if (a.namespaceURI === cm && !("innerHTML" in a)) {
        ev = ev || document.createElement("div"), ev.innerHTML = "<svg>" + o.valueOf().toString() + "</svg>";
        for (var f = ev.firstChild; a.firstChild; )
          a.removeChild(a.firstChild);
        for (; f.firstChild; )
          a.appendChild(f.firstChild);
        return;
      }
      a.innerHTML = o;
    }), Di = 1, Zo = 3, on = 8, ro = 9, Xl = 11, tv = function(a, o) {
      if (o) {
        var f = a.firstChild;
        if (f && f === a.lastChild && f.nodeType === Zo) {
          f.nodeValue = o;
          return;
        }
      }
      a.textContent = o;
    }, ax = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, gc = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function ox(a, o) {
      return a + o.charAt(0).toUpperCase() + o.substring(1);
    }
    var sx = ["Webkit", "ms", "Moz", "O"];
    Object.keys(gc).forEach(function(a) {
      sx.forEach(function(o) {
        gc[ox(o, a)] = gc[a];
      });
    });
    function rv(a, o, f) {
      var v = o == null || typeof o == "boolean" || o === "";
      return v ? "" : !f && typeof o == "number" && o !== 0 && !(gc.hasOwnProperty(a) && gc[a]) ? o + "px" : (pi(o, a), ("" + o).trim());
    }
    var mc = /([A-Z])/g, l1 = /^ms-/;
    function u1(a) {
      return a.replace(mc, "-$1").toLowerCase().replace(l1, "-ms-");
    }
    var lx = function() {
    };
    {
      var ux = /^(?:webkit|moz|o)[A-Z]/, cx = /^-ms-/, sf = /-(.)/g, _c = /;\s*$/, yc = {}, xc = {}, dx = !1, fm = !1, hm = function(a) {
        return a.replace(sf, function(o, f) {
          return f.toUpperCase();
        });
      }, vm = function(a) {
        yc.hasOwnProperty(a) && yc[a] || (yc[a] = !0, l(
          "Unsupported style property %s. Did you mean %s?",
          a,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          hm(a.replace(cx, "ms-"))
        ));
      }, fx = function(a) {
        yc.hasOwnProperty(a) && yc[a] || (yc[a] = !0, l("Unsupported vendor-prefixed style property %s. Did you mean %s?", a, a.charAt(0).toUpperCase() + a.slice(1)));
      }, hx = function(a, o) {
        xc.hasOwnProperty(o) && xc[o] || (xc[o] = !0, l(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, a, o.replace(_c, "")));
      }, vx = function(a, o) {
        dx || (dx = !0, l("`NaN` is an invalid value for the `%s` css style property.", a));
      }, c1 = function(a, o) {
        fm || (fm = !0, l("`Infinity` is an invalid value for the `%s` css style property.", a));
      };
      lx = function(a, o) {
        a.indexOf("-") > -1 ? vm(a) : ux.test(a) ? fx(a) : _c.test(o) && hx(a, o), typeof o == "number" && (isNaN(o) ? vx(a, o) : isFinite(o) || c1(a, o));
      };
    }
    var d1 = lx;
    function f1(a) {
      {
        var o = "", f = "";
        for (var v in a)
          if (a.hasOwnProperty(v)) {
            var _ = a[v];
            if (_ != null) {
              var b = v.indexOf("--") === 0;
              o += f + (b ? v : u1(v)) + ":", o += rv(v, _, b), f = ";";
            }
          }
        return o || null;
      }
    }
    function px(a, o) {
      var f = a.style;
      for (var v in o)
        if (o.hasOwnProperty(v)) {
          var _ = v.indexOf("--") === 0;
          _ || d1(v, o[v]);
          var b = rv(v, o[v], _);
          v === "float" && (v = "cssFloat"), _ ? f.setProperty(v, b) : f[v] = b;
        }
    }
    function h1(a) {
      return a == null || typeof a == "boolean" || a === "";
    }
    function wa(a) {
      var o = {};
      for (var f in a)
        for (var v = ax[f] || [f], _ = 0; _ < v.length; _++)
          o[v[_]] = f;
      return o;
    }
    function lf(a, o) {
      {
        if (!o)
          return;
        var f = wa(a), v = wa(o), _ = {};
        for (var b in f) {
          var E = f[b], A = v[b];
          if (A && E !== A) {
            var R = E + "," + A;
            if (_[R])
              continue;
            _[R] = !0, l("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", h1(a[E]) ? "Removing" : "Updating", E, A);
          }
        }
      }
    }
    var gx = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, mx = Bt({
      menuitem: !0
    }, gx), _x = "__html";
    function nv(a, o) {
      if (o) {
        if (mx[a] && (o.children != null || o.dangerouslySetInnerHTML != null))
          throw new Error(a + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (o.dangerouslySetInnerHTML != null) {
          if (o.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof o.dangerouslySetInnerHTML != "object" || !(_x in o.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!o.suppressContentEditableWarning && o.contentEditable && o.children != null && l("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), o.style != null && typeof o.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function Qo(a, o) {
      if (a.indexOf("-") === -1)
        return typeof o.is == "string";
      switch (a) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var iv = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, yx = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, no = {}, pm = new RegExp("^(aria)-[" + Ge + "]*$"), uf = new RegExp("^(aria)[A-Z][" + Ge + "]*$");
    function gm(a, o) {
      {
        if (Pt.call(no, o) && no[o])
          return !0;
        if (uf.test(o)) {
          var f = "aria-" + o.slice(4).toLowerCase(), v = yx.hasOwnProperty(f) ? f : null;
          if (v == null)
            return l("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", o), no[o] = !0, !0;
          if (o !== v)
            return l("Invalid ARIA attribute `%s`. Did you mean `%s`?", o, v), no[o] = !0, !0;
        }
        if (pm.test(o)) {
          var _ = o.toLowerCase(), b = yx.hasOwnProperty(_) ? _ : null;
          if (b == null)
            return no[o] = !0, !1;
          if (o !== b)
            return l("Unknown ARIA attribute `%s`. Did you mean `%s`?", o, b), no[o] = !0, !0;
        }
      }
      return !0;
    }
    function xx(a, o) {
      {
        var f = [];
        for (var v in o) {
          var _ = gm(a, v);
          _ || f.push(v);
        }
        var b = f.map(function(E) {
          return "`" + E + "`";
        }).join(", ");
        f.length === 1 ? l("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", b, a) : f.length > 1 && l("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", b, a);
      }
    }
    function av(a, o) {
      Qo(a, o) || xx(a, o);
    }
    var ql = !1;
    function mm(a, o) {
      {
        if (a !== "input" && a !== "textarea" && a !== "select")
          return;
        o != null && o.value === null && !ql && (ql = !0, a === "select" && o.multiple ? l("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", a) : l("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", a));
      }
    }
    var _m = function() {
    };
    {
      var Rn = {}, ym = /^on./, bx = /^on[^A-Z]/, Sx = new RegExp("^(aria)-[" + Ge + "]*$"), Cx = new RegExp("^(aria)[A-Z][" + Ge + "]*$");
      _m = function(a, o, f, v) {
        if (Pt.call(Rn, o) && Rn[o])
          return !0;
        var _ = o.toLowerCase();
        if (_ === "onfocusin" || _ === "onfocusout")
          return l("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Rn[o] = !0, !0;
        if (v != null) {
          var b = v.registrationNameDependencies, E = v.possibleRegistrationNames;
          if (b.hasOwnProperty(o))
            return !0;
          var A = E.hasOwnProperty(_) ? E[_] : null;
          if (A != null)
            return l("Invalid event handler property `%s`. Did you mean `%s`?", o, A), Rn[o] = !0, !0;
          if (ym.test(o))
            return l("Unknown event handler property `%s`. It will be ignored.", o), Rn[o] = !0, !0;
        } else if (ym.test(o))
          return bx.test(o) && l("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", o), Rn[o] = !0, !0;
        if (Sx.test(o) || Cx.test(o))
          return !0;
        if (_ === "innerhtml")
          return l("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Rn[o] = !0, !0;
        if (_ === "aria")
          return l("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Rn[o] = !0, !0;
        if (_ === "is" && f !== null && f !== void 0 && typeof f != "string")
          return l("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof f), Rn[o] = !0, !0;
        if (typeof f == "number" && isNaN(f))
          return l("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", o), Rn[o] = !0, !0;
        var R = Br(o), N = R !== null && R.type === fr;
        if (iv.hasOwnProperty(_)) {
          var B = iv[_];
          if (B !== o)
            return l("Invalid DOM property `%s`. Did you mean `%s`?", o, B), Rn[o] = !0, !0;
        } else if (!N && o !== _)
          return l("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", o, _), Rn[o] = !0, !0;
        return typeof f == "boolean" && Yr(o, f, R, !1) ? (f ? l('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', f, o, o, f, o) : l('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', f, o, o, f, o, o, o), Rn[o] = !0, !0) : N ? !0 : Yr(o, f, R, !1) ? (Rn[o] = !0, !1) : ((f === "false" || f === "true") && R !== null && R.type === $r && (l("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", f, o, f === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', o, f), Rn[o] = !0), !0);
      };
    }
    var Ex = function(a, o, f) {
      {
        var v = [];
        for (var _ in o) {
          var b = _m(a, _, o[_], f);
          b || v.push(_);
        }
        var E = v.map(function(A) {
          return "`" + A + "`";
        }).join(", ");
        v.length === 1 ? l("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", E, a) : v.length > 1 && l("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", E, a);
      }
    };
    function Tx(a, o, f) {
      Qo(a, o) || Ex(a, o, f);
    }
    var Jo = 1, cf = 2, Kl = 4, v1 = Jo | cf | Kl, df = null;
    function ff(a) {
      df !== null && l("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), df = a;
    }
    function p1() {
      df === null && l("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), df = null;
    }
    function wx(a) {
      return a === df;
    }
    function ov(a) {
      var o = a.target || a.srcElement || window;
      return o.correspondingUseElement && (o = o.correspondingUseElement), o.nodeType === Zo ? o.parentNode : o;
    }
    var xr = null, Ys = null, es = null;
    function bc(a) {
      var o = Wc(a);
      if (o) {
        if (typeof xr != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var f = o.stateNode;
        if (f) {
          var v = wb(f);
          xr(o.stateNode, o.type, v);
        }
      }
    }
    function Ax(a) {
      xr = a;
    }
    function sv(a) {
      Ys ? es ? es.push(a) : es = [a] : Ys = a;
    }
    function hf() {
      return Ys !== null || es !== null;
    }
    function vf() {
      if (Ys) {
        var a = Ys, o = es;
        if (Ys = null, es = null, bc(a), o)
          for (var f = 0; f < o.length; f++)
            bc(o[f]);
      }
    }
    var Zl = function(a, o) {
      return a(o);
    }, xm = function() {
    }, bm = !1;
    function g1() {
      var a = hf();
      a && (xm(), vf());
    }
    function Sm(a, o, f) {
      if (bm)
        return a(o, f);
      bm = !0;
      try {
        return Zl(a, o, f);
      } finally {
        bm = !1, g1();
      }
    }
    function lv(a, o, f) {
      Zl = a, xm = f;
    }
    function uv(a) {
      return a === "button" || a === "input" || a === "select" || a === "textarea";
    }
    function Cm(a, o, f) {
      switch (a) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(f.disabled && uv(o));
        default:
          return !1;
      }
    }
    function Ql(a, o) {
      var f = a.stateNode;
      if (f === null)
        return null;
      var v = wb(f);
      if (v === null)
        return null;
      var _ = v[o];
      if (Cm(o, a.type, v))
        return null;
      if (_ && typeof _ != "function")
        throw new Error("Expected `" + o + "` listener to be a function, instead got a value of `" + typeof _ + "` type.");
      return _;
    }
    var pf = !1;
    if (Je)
      try {
        var Jl = {};
        Object.defineProperty(Jl, "passive", {
          get: function() {
            pf = !0;
          }
        }), window.addEventListener("test", Jl, Jl), window.removeEventListener("test", Jl, Jl);
      } catch {
        pf = !1;
      }
    function Ox(a, o, f, v, _, b, E, A, R) {
      var N = Array.prototype.slice.call(arguments, 3);
      try {
        o.apply(f, N);
      } catch (B) {
        this.onError(B);
      }
    }
    var Em = Ox;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var Tm = document.createElement("react");
      Em = function(o, f, v, _, b, E, A, R, N) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var B = document.createEvent("Event"), K = !1, X = !0, ce = window.event, oe = Object.getOwnPropertyDescriptor(window, "event");
        function ve() {
          Tm.removeEventListener(ge, ft, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = ce);
        }
        var Ye = Array.prototype.slice.call(arguments, 3);
        function ft() {
          K = !0, ve(), f.apply(v, Ye), X = !1;
        }
        var ot, Ht = !1, Gt = !1;
        function ne(ie) {
          if (ot = ie.error, Ht = !0, ot === null && ie.colno === 0 && ie.lineno === 0 && (Gt = !0), ie.defaultPrevented && ot != null && typeof ot == "object")
            try {
              ot._suppressLogging = !0;
            } catch {
            }
        }
        var ge = "react-" + (o || "invokeguardedcallback");
        if (window.addEventListener("error", ne), Tm.addEventListener(ge, ft, !1), B.initEvent(ge, !1, !1), Tm.dispatchEvent(B), oe && Object.defineProperty(window, "event", oe), K && X && (Ht ? Gt && (ot = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : ot = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(ot)), window.removeEventListener("error", ne), !K)
          return ve(), Ox.apply(this, arguments);
      };
    }
    var m1 = Em, Ws = !1, io = null, gf = !1, Xs = null, mo = {
      onError: function(a) {
        Ws = !0, io = a;
      }
    };
    function eu(a, o, f, v, _, b, E, A, R) {
      Ws = !1, io = null, m1.apply(mo, arguments);
    }
    function ts(a, o, f, v, _, b, E, A, R) {
      if (eu.apply(this, arguments), Ws) {
        var N = Am();
        gf || (gf = !0, Xs = N);
      }
    }
    function wm() {
      if (gf) {
        var a = Xs;
        throw gf = !1, Xs = null, a;
      }
    }
    function _1() {
      return Ws;
    }
    function Am() {
      if (Ws) {
        var a = io;
        return Ws = !1, io = null, a;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Aa(a) {
      return a._reactInternals;
    }
    function mf(a) {
      return a._reactInternals !== void 0;
    }
    function Sc(a, o) {
      a._reactInternals = o;
    }
    var dt = (
      /*                      */
      0
    ), qs = (
      /*                */
      1
    ), wr = (
      /*                    */
      2
    ), Mt = (
      /*                       */
      4
    ), nr = (
      /*                */
      16
    ), ar = (
      /*                 */
      32
    ), _o = (
      /*                     */
      64
    ), St = (
      /*                   */
      128
    ), Wr = (
      /*            */
      256
    ), Mi = (
      /*                          */
      512
    ), Oa = (
      /*                     */
      1024
    ), Pr = (
      /*                      */
      2048
    ), ka = (
      /*                    */
      4096
    ), Ks = (
      /*                   */
      8192
    ), _f = (
      /*             */
      16384
    ), cv = Pr | Mt | _o | Mi | Oa | _f, kx = (
      /*               */
      32767
    ), ra = (
      /*                   */
      32768
    ), Dn = (
      /*                */
      65536
    ), yf = (
      /* */
      131072
    ), Om = (
      /*                       */
      1048576
    ), km = (
      /*                    */
      2097152
    ), Li = (
      /*                 */
      4194304
    ), Zs = (
      /*                */
      8388608
    ), Pi = (
      /*               */
      16777216
    ), tu = (
      /*              */
      33554432
    ), Cc = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      Mt | Oa | 0
    ), Ii = wr | Mt | nr | ar | Mi | ka | Ks, ni = Mt | _o | Mi | Ks, Ra = Pr | nr, Bn = Li | Zs | km, rs = r.ReactCurrentOwner;
    function na(a) {
      var o = a, f = a;
      if (a.alternate)
        for (; o.return; )
          o = o.return;
      else {
        var v = o;
        do
          o = v, (o.flags & (wr | ka)) !== dt && (f = o.return), v = o.return;
        while (v);
      }
      return o.tag === x ? f : null;
    }
    function Rm(a) {
      if (a.tag === P) {
        var o = a.memoizedState;
        if (o === null) {
          var f = a.alternate;
          f !== null && (o = f.memoizedState);
        }
        if (o !== null)
          return o.dehydrated;
      }
      return null;
    }
    function dv(a) {
      return a.tag === x ? a.stateNode.containerInfo : null;
    }
    function Dm(a) {
      return na(a) === a;
    }
    function ia(a) {
      {
        var o = rs.current;
        if (o !== null && o.tag === p) {
          var f = o, v = f.stateNode;
          v._warnedAboutRefsInRender || l("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", kt(f) || "A component"), v._warnedAboutRefsInRender = !0;
        }
      }
      var _ = Aa(a);
      return _ ? na(_) === _ : !1;
    }
    function Ni(a) {
      if (na(a) !== a)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Ar(a) {
      var o = a.alternate;
      if (!o) {
        var f = na(a);
        if (f === null)
          throw new Error("Unable to find node on an unmounted component.");
        return f !== a ? null : a;
      }
      for (var v = a, _ = o; ; ) {
        var b = v.return;
        if (b === null)
          break;
        var E = b.alternate;
        if (E === null) {
          var A = b.return;
          if (A !== null) {
            v = _ = A;
            continue;
          }
          break;
        }
        if (b.child === E.child) {
          for (var R = b.child; R; ) {
            if (R === v)
              return Ni(b), a;
            if (R === _)
              return Ni(b), o;
            R = R.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (v.return !== _.return)
          v = b, _ = E;
        else {
          for (var N = !1, B = b.child; B; ) {
            if (B === v) {
              N = !0, v = b, _ = E;
              break;
            }
            if (B === _) {
              N = !0, _ = b, v = E;
              break;
            }
            B = B.sibling;
          }
          if (!N) {
            for (B = E.child; B; ) {
              if (B === v) {
                N = !0, v = E, _ = b;
                break;
              }
              if (B === _) {
                N = !0, _ = E, v = b;
                break;
              }
              B = B.sibling;
            }
            if (!N)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (v.alternate !== _)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (v.tag !== x)
        throw new Error("Unable to find node on an unmounted component.");
      return v.stateNode.current === v ? a : o;
    }
    function Da(a) {
      var o = Ar(a);
      return o !== null ? Mm(o) : null;
    }
    function Mm(a) {
      if (a.tag === T || a.tag === k)
        return a;
      for (var o = a.child; o !== null; ) {
        var f = Mm(o);
        if (f !== null)
          return f;
        o = o.sibling;
      }
      return null;
    }
    function Rx(a) {
      var o = Ar(a);
      return o !== null ? fv(o) : null;
    }
    function fv(a) {
      if (a.tag === T || a.tag === k)
        return a;
      for (var o = a.child; o !== null; ) {
        if (o.tag !== S) {
          var f = fv(o);
          if (f !== null)
            return f;
        }
        o = o.sibling;
      }
      return null;
    }
    var hv = t.unstable_scheduleCallback, Dx = t.unstable_cancelCallback, vv = t.unstable_shouldYield, Mx = t.unstable_requestPaint, zr = t.unstable_now, Lm = t.unstable_getCurrentPriorityLevel, pv = t.unstable_ImmediatePriority, aa = t.unstable_UserBlockingPriority, yo = t.unstable_NormalPriority, gv = t.unstable_LowPriority, Qs = t.unstable_IdlePriority, Pm = t.unstable_yieldValue, Im = t.unstable_setDisableYieldValue, ns = null, pn = null, Fe = null, Jr = !1, zn = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function Nm(a) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var o = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (o.isDisabled)
        return !0;
      if (!o.supportsFiber)
        return l("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        He && (a = Bt({}, a, {
          getLaneLabelMap: el,
          injectProfilingHooks: as
        })), ns = o.inject(a), pn = o;
      } catch (f) {
        l("React instrumentation encountered an error: %s.", f);
      }
      return !!o.checkDCE;
    }
    function Lx(a, o) {
      if (pn && typeof pn.onScheduleFiberRoot == "function")
        try {
          pn.onScheduleFiberRoot(ns, a, o);
        } catch (f) {
          Jr || (Jr = !0, l("React instrumentation encountered an error: %s", f));
        }
    }
    function is(a, o) {
      if (pn && typeof pn.onCommitFiberRoot == "function")
        try {
          var f = (a.current.flags & St) === St;
          if (Ue) {
            var v;
            switch (o) {
              case ii:
                v = pv;
                break;
              case Hn:
                v = aa;
                break;
              case ss:
                v = yo;
                break;
              case Of:
                v = Qs;
                break;
              default:
                v = yo;
                break;
            }
            pn.onCommitFiberRoot(ns, a, v, f);
          } else
            pn.onCommitFiberRoot(ns, a, void 0, f);
        } catch (_) {
          Jr || (Jr = !0, l("React instrumentation encountered an error: %s", _));
        }
    }
    function Js(a) {
      if (pn && typeof pn.onPostCommitFiberRoot == "function")
        try {
          pn.onPostCommitFiberRoot(ns, a);
        } catch (o) {
          Jr || (Jr = !0, l("React instrumentation encountered an error: %s", o));
        }
    }
    function Vm(a) {
      if (pn && typeof pn.onCommitFiberUnmount == "function")
        try {
          pn.onCommitFiberUnmount(ns, a);
        } catch (o) {
          Jr || (Jr = !0, l("React instrumentation encountered an error: %s", o));
        }
    }
    function gn(a) {
      if (typeof Pm == "function" && (Im(a), i(a)), pn && typeof pn.setStrictMode == "function")
        try {
          pn.setStrictMode(ns, a);
        } catch (o) {
          Jr || (Jr = !0, l("React instrumentation encountered an error: %s", o));
        }
    }
    function as(a) {
      Fe = a;
    }
    function el() {
      {
        for (var a = /* @__PURE__ */ new Map(), o = 1, f = 0; f < Or; f++) {
          var v = y1(o);
          a.set(o, v), o *= 2;
        }
        return a;
      }
    }
    function mv(a) {
      Fe !== null && typeof Fe.markCommitStarted == "function" && Fe.markCommitStarted(a);
    }
    function Fm() {
      Fe !== null && typeof Fe.markCommitStopped == "function" && Fe.markCommitStopped();
    }
    function tl(a) {
      Fe !== null && typeof Fe.markComponentRenderStarted == "function" && Fe.markComponentRenderStarted(a);
    }
    function ru() {
      Fe !== null && typeof Fe.markComponentRenderStopped == "function" && Fe.markComponentRenderStopped();
    }
    function Px(a) {
      Fe !== null && typeof Fe.markComponentPassiveEffectMountStarted == "function" && Fe.markComponentPassiveEffectMountStarted(a);
    }
    function Bm() {
      Fe !== null && typeof Fe.markComponentPassiveEffectMountStopped == "function" && Fe.markComponentPassiveEffectMountStopped();
    }
    function _v(a) {
      Fe !== null && typeof Fe.markComponentPassiveEffectUnmountStarted == "function" && Fe.markComponentPassiveEffectUnmountStarted(a);
    }
    function Ix() {
      Fe !== null && typeof Fe.markComponentPassiveEffectUnmountStopped == "function" && Fe.markComponentPassiveEffectUnmountStopped();
    }
    function Nx(a) {
      Fe !== null && typeof Fe.markComponentLayoutEffectMountStarted == "function" && Fe.markComponentLayoutEffectMountStarted(a);
    }
    function Vx() {
      Fe !== null && typeof Fe.markComponentLayoutEffectMountStopped == "function" && Fe.markComponentLayoutEffectMountStopped();
    }
    function yv(a) {
      Fe !== null && typeof Fe.markComponentLayoutEffectUnmountStarted == "function" && Fe.markComponentLayoutEffectUnmountStarted(a);
    }
    function Ec() {
      Fe !== null && typeof Fe.markComponentLayoutEffectUnmountStopped == "function" && Fe.markComponentLayoutEffectUnmountStopped();
    }
    function xv(a, o, f) {
      Fe !== null && typeof Fe.markComponentErrored == "function" && Fe.markComponentErrored(a, o, f);
    }
    function Fx(a, o, f) {
      Fe !== null && typeof Fe.markComponentSuspended == "function" && Fe.markComponentSuspended(a, o, f);
    }
    function Bx(a) {
      Fe !== null && typeof Fe.markLayoutEffectsStarted == "function" && Fe.markLayoutEffectsStarted(a);
    }
    function Tc() {
      Fe !== null && typeof Fe.markLayoutEffectsStopped == "function" && Fe.markLayoutEffectsStopped();
    }
    function zx(a) {
      Fe !== null && typeof Fe.markPassiveEffectsStarted == "function" && Fe.markPassiveEffectsStarted(a);
    }
    function xf() {
      Fe !== null && typeof Fe.markPassiveEffectsStopped == "function" && Fe.markPassiveEffectsStopped();
    }
    function ao(a) {
      Fe !== null && typeof Fe.markRenderStarted == "function" && Fe.markRenderStarted(a);
    }
    function bf() {
      Fe !== null && typeof Fe.markRenderYielded == "function" && Fe.markRenderYielded();
    }
    function wc() {
      Fe !== null && typeof Fe.markRenderStopped == "function" && Fe.markRenderStopped();
    }
    function nu(a) {
      Fe !== null && typeof Fe.markRenderScheduled == "function" && Fe.markRenderScheduled(a);
    }
    function zm(a, o) {
      Fe !== null && typeof Fe.markForceUpdateScheduled == "function" && Fe.markForceUpdateScheduled(a, o);
    }
    function rl(a, o) {
      Fe !== null && typeof Fe.markStateUpdateScheduled == "function" && Fe.markStateUpdateScheduled(a, o);
    }
    var pt = (
      /*                         */
      0
    ), Ft = (
      /*                 */
      1
    ), mt = (
      /*                    */
      2
    ), Hr = (
      /*               */
      8
    ), Ma = (
      /*              */
      16
    ), bv = Math.clz32 ? Math.clz32 : iu, Sv = Math.log, Hm = Math.LN2;
    function iu(a) {
      var o = a >>> 0;
      return o === 0 ? 32 : 31 - (Sv(o) / Hm | 0) | 0;
    }
    var Or = 31, ye = (
      /*                        */
      0
    ), jt = (
      /*                          */
      0
    ), yt = (
      /*                        */
      1
    ), xo = (
      /*    */
      2
    ), oa = (
      /*             */
      4
    ), au = (
      /*            */
      8
    ), kr = (
      /*                     */
      16
    ), ou = (
      /*                */
      32
    ), nl = (
      /*                       */
      4194240
    ), su = (
      /*                        */
      64
    ), La = (
      /*                        */
      128
    ), Vi = (
      /*                        */
      256
    ), lu = (
      /*                        */
      512
    ), Sf = (
      /*                        */
      1024
    ), Cf = (
      /*                        */
      2048
    ), Cv = (
      /*                        */
      4096
    ), Ev = (
      /*                        */
      8192
    ), Tv = (
      /*                        */
      16384
    ), wv = (
      /*                       */
      32768
    ), Av = (
      /*                       */
      65536
    ), Ov = (
      /*                       */
      131072
    ), kv = (
      /*                       */
      262144
    ), Rv = (
      /*                       */
      524288
    ), uu = (
      /*                       */
      1048576
    ), Dv = (
      /*                       */
      2097152
    ), cu = (
      /*                            */
      130023424
    ), os = (
      /*                             */
      4194304
    ), Mv = (
      /*                             */
      8388608
    ), Ef = (
      /*                             */
      16777216
    ), Lv = (
      /*                             */
      33554432
    ), Pv = (
      /*                             */
      67108864
    ), Gm = os, Ac = (
      /*          */
      134217728
    ), Iv = (
      /*                          */
      268435455
    ), Oc = (
      /*               */
      268435456
    ), il = (
      /*                        */
      536870912
    ), Fi = (
      /*                   */
      1073741824
    );
    function y1(a) {
      {
        if (a & yt)
          return "Sync";
        if (a & xo)
          return "InputContinuousHydration";
        if (a & oa)
          return "InputContinuous";
        if (a & au)
          return "DefaultHydration";
        if (a & kr)
          return "Default";
        if (a & ou)
          return "TransitionHydration";
        if (a & nl)
          return "Transition";
        if (a & cu)
          return "Retry";
        if (a & Ac)
          return "SelectiveHydration";
        if (a & Oc)
          return "IdleHydration";
        if (a & il)
          return "Idle";
        if (a & Fi)
          return "Offscreen";
      }
    }
    var br = -1, Nv = su, Vv = os;
    function kc(a) {
      switch (sn(a)) {
        case yt:
          return yt;
        case xo:
          return xo;
        case oa:
          return oa;
        case au:
          return au;
        case kr:
          return kr;
        case ou:
          return ou;
        case su:
        case La:
        case Vi:
        case lu:
        case Sf:
        case Cf:
        case Cv:
        case Ev:
        case Tv:
        case wv:
        case Av:
        case Ov:
        case kv:
        case Rv:
        case uu:
        case Dv:
          return a & nl;
        case os:
        case Mv:
        case Ef:
        case Lv:
        case Pv:
          return a & cu;
        case Ac:
          return Ac;
        case Oc:
          return Oc;
        case il:
          return il;
        case Fi:
          return Fi;
        default:
          return l("Should have found matching lanes. This is a bug in React."), a;
      }
    }
    function Tf(a, o) {
      var f = a.pendingLanes;
      if (f === ye)
        return ye;
      var v = ye, _ = a.suspendedLanes, b = a.pingedLanes, E = f & Iv;
      if (E !== ye) {
        var A = E & ~_;
        if (A !== ye)
          v = kc(A);
        else {
          var R = E & b;
          R !== ye && (v = kc(R));
        }
      } else {
        var N = f & ~_;
        N !== ye ? v = kc(N) : b !== ye && (v = kc(b));
      }
      if (v === ye)
        return ye;
      if (o !== ye && o !== v && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (o & _) === ye) {
        var B = sn(v), K = sn(o);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          B >= K || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          B === kr && (K & nl) !== ye
        )
          return o;
      }
      (v & oa) !== ye && (v |= f & kr);
      var X = a.entangledLanes;
      if (X !== ye)
        for (var ce = a.entanglements, oe = v & X; oe > 0; ) {
          var ve = al(oe), Ye = 1 << ve;
          v |= ce[ve], oe &= ~Ye;
        }
      return v;
    }
    function Hx(a, o) {
      for (var f = a.eventTimes, v = br; o > 0; ) {
        var _ = al(o), b = 1 << _, E = f[_];
        E > v && (v = E), o &= ~b;
      }
      return v;
    }
    function Fv(a, o) {
      switch (a) {
        case yt:
        case xo:
        case oa:
          return o + 250;
        case au:
        case kr:
        case ou:
        case su:
        case La:
        case Vi:
        case lu:
        case Sf:
        case Cf:
        case Cv:
        case Ev:
        case Tv:
        case wv:
        case Av:
        case Ov:
        case kv:
        case Rv:
        case uu:
        case Dv:
          return o + 5e3;
        case os:
        case Mv:
        case Ef:
        case Lv:
        case Pv:
          return br;
        case Ac:
        case Oc:
        case il:
        case Fi:
          return br;
        default:
          return l("Should have found matching lanes. This is a bug in React."), br;
      }
    }
    function x1(a, o) {
      for (var f = a.pendingLanes, v = a.suspendedLanes, _ = a.pingedLanes, b = a.expirationTimes, E = f; E > 0; ) {
        var A = al(E), R = 1 << A, N = b[A];
        N === br ? ((R & v) === ye || (R & _) !== ye) && (b[A] = Fv(R, o)) : N <= o && (a.expiredLanes |= R), E &= ~R;
      }
    }
    function b1(a) {
      return kc(a.pendingLanes);
    }
    function Um(a) {
      var o = a.pendingLanes & ~Fi;
      return o !== ye ? o : o & Fi ? Fi : ye;
    }
    function Rc(a) {
      return (a & yt) !== ye;
    }
    function wf(a) {
      return (a & Iv) !== ye;
    }
    function Bv(a) {
      return (a & cu) === a;
    }
    function S1(a) {
      var o = yt | oa | kr;
      return (a & o) === ye;
    }
    function Gx(a) {
      return (a & nl) === a;
    }
    function Af(a, o) {
      var f = xo | oa | au | kr;
      return (o & f) !== ye;
    }
    function Ux(a, o) {
      return (o & a.expiredLanes) !== ye;
    }
    function jm(a) {
      return (a & nl) !== ye;
    }
    function $m() {
      var a = Nv;
      return Nv <<= 1, (Nv & nl) === ye && (Nv = su), a;
    }
    function C1() {
      var a = Vv;
      return Vv <<= 1, (Vv & cu) === ye && (Vv = os), a;
    }
    function sn(a) {
      return a & -a;
    }
    function mn(a) {
      return sn(a);
    }
    function al(a) {
      return 31 - bv(a);
    }
    function zv(a) {
      return al(a);
    }
    function Bi(a, o) {
      return (a & o) !== ye;
    }
    function du(a, o) {
      return (a & o) === o;
    }
    function Rt(a, o) {
      return a | o;
    }
    function Dc(a, o) {
      return a & ~o;
    }
    function Ym(a, o) {
      return a & o;
    }
    function jx(a) {
      return a;
    }
    function $x(a, o) {
      return a !== jt && a < o ? a : o;
    }
    function Hv(a) {
      for (var o = [], f = 0; f < Or; f++)
        o.push(a);
      return o;
    }
    function fu(a, o, f) {
      a.pendingLanes |= o, o !== il && (a.suspendedLanes = ye, a.pingedLanes = ye);
      var v = a.eventTimes, _ = zv(o);
      v[_] = f;
    }
    function Wm(a, o) {
      a.suspendedLanes |= o, a.pingedLanes &= ~o;
      for (var f = a.expirationTimes, v = o; v > 0; ) {
        var _ = al(v), b = 1 << _;
        f[_] = br, v &= ~b;
      }
    }
    function Xm(a, o, f) {
      a.pingedLanes |= a.suspendedLanes & o;
    }
    function qm(a, o) {
      var f = a.pendingLanes & ~o;
      a.pendingLanes = o, a.suspendedLanes = ye, a.pingedLanes = ye, a.expiredLanes &= o, a.mutableReadLanes &= o, a.entangledLanes &= o;
      for (var v = a.entanglements, _ = a.eventTimes, b = a.expirationTimes, E = f; E > 0; ) {
        var A = al(E), R = 1 << A;
        v[A] = ye, _[A] = br, b[A] = br, E &= ~R;
      }
    }
    function Mc(a, o) {
      for (var f = a.entangledLanes |= o, v = a.entanglements, _ = f; _; ) {
        var b = al(_), E = 1 << b;
        // Is this one of the newly entangled lanes?
        E & o | // Is this lane transitively entangled with the newly entangled lanes?
        v[b] & o && (v[b] |= o), _ &= ~E;
      }
    }
    function E1(a, o) {
      var f = sn(o), v;
      switch (f) {
        case oa:
          v = xo;
          break;
        case kr:
          v = au;
          break;
        case su:
        case La:
        case Vi:
        case lu:
        case Sf:
        case Cf:
        case Cv:
        case Ev:
        case Tv:
        case wv:
        case Av:
        case Ov:
        case kv:
        case Rv:
        case uu:
        case Dv:
        case os:
        case Mv:
        case Ef:
        case Lv:
        case Pv:
          v = ou;
          break;
        case il:
          v = Oc;
          break;
        default:
          v = jt;
          break;
      }
      return (v & (a.suspendedLanes | o)) !== jt ? jt : v;
    }
    function Km(a, o, f) {
      if (zn)
        for (var v = a.pendingUpdatersLaneMap; f > 0; ) {
          var _ = zv(f), b = 1 << _, E = v[_];
          E.add(o), f &= ~b;
        }
    }
    function Gv(a, o) {
      if (zn)
        for (var f = a.pendingUpdatersLaneMap, v = a.memoizedUpdaters; o > 0; ) {
          var _ = zv(o), b = 1 << _, E = f[_];
          E.size > 0 && (E.forEach(function(A) {
            var R = A.alternate;
            (R === null || !v.has(R)) && v.add(A);
          }), E.clear()), o &= ~b;
        }
    }
    function Zm(a, o) {
      return null;
    }
    var ii = yt, Hn = oa, ss = kr, Of = il, hu = jt;
    function Pa() {
      return hu;
    }
    function _n(a) {
      hu = a;
    }
    function kf(a, o) {
      var f = hu;
      try {
        return hu = a, o();
      } finally {
        hu = f;
      }
    }
    function ai(a, o) {
      return a !== 0 && a < o ? a : o;
    }
    function T1(a, o) {
      return a === 0 || a > o ? a : o;
    }
    function Qm(a, o) {
      return a !== 0 && a < o;
    }
    function Rf(a) {
      var o = sn(a);
      return Qm(ii, o) ? Qm(Hn, o) ? wf(o) ? ss : Of : Hn : ii;
    }
    function yn(a) {
      var o = a.current.memoizedState;
      return o.isDehydrated;
    }
    var Yx;
    function et(a) {
      Yx = a;
    }
    function Lc(a) {
      Yx(a);
    }
    var Df;
    function Wx(a) {
      Df = a;
    }
    var Xx;
    function Mf(a) {
      Xx = a;
    }
    var Lf;
    function Jm(a) {
      Lf = a;
    }
    var e0;
    function qx(a) {
      e0 = a;
    }
    var Uv = !1, Pc = [], bo = null, Ir = null, Mn = null, Ia = /* @__PURE__ */ new Map(), Ic = /* @__PURE__ */ new Map(), ls = [], oo = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function Kx(a) {
      return oo.indexOf(a) > -1;
    }
    function So(a, o, f, v, _) {
      return {
        blockedOn: a,
        domEventName: o,
        eventSystemFlags: f,
        nativeEvent: _,
        targetContainers: [v]
      };
    }
    function Zx(a, o) {
      switch (a) {
        case "focusin":
        case "focusout":
          bo = null;
          break;
        case "dragenter":
        case "dragleave":
          Ir = null;
          break;
        case "mouseover":
        case "mouseout":
          Mn = null;
          break;
        case "pointerover":
        case "pointerout": {
          var f = o.pointerId;
          Ia.delete(f);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var v = o.pointerId;
          Ic.delete(v);
          break;
        }
      }
    }
    function Nc(a, o, f, v, _, b) {
      if (a === null || a.nativeEvent !== b) {
        var E = So(o, f, v, _, b);
        if (o !== null) {
          var A = Wc(o);
          A !== null && Df(A);
        }
        return E;
      }
      a.eventSystemFlags |= v;
      var R = a.targetContainers;
      return _ !== null && R.indexOf(_) === -1 && R.push(_), a;
    }
    function Qx(a, o, f, v, _) {
      switch (o) {
        case "focusin": {
          var b = _;
          return bo = Nc(bo, a, o, f, v, b), !0;
        }
        case "dragenter": {
          var E = _;
          return Ir = Nc(Ir, a, o, f, v, E), !0;
        }
        case "mouseover": {
          var A = _;
          return Mn = Nc(Mn, a, o, f, v, A), !0;
        }
        case "pointerover": {
          var R = _, N = R.pointerId;
          return Ia.set(N, Nc(Ia.get(N) || null, a, o, f, v, R)), !0;
        }
        case "gotpointercapture": {
          var B = _, K = B.pointerId;
          return Ic.set(K, Nc(Ic.get(K) || null, a, o, f, v, B)), !0;
        }
      }
      return !1;
    }
    function t0(a) {
      var o = Gf(a.target);
      if (o !== null) {
        var f = na(o);
        if (f !== null) {
          var v = f.tag;
          if (v === P) {
            var _ = Rm(f);
            if (_ !== null) {
              a.blockedOn = _, e0(a.priority, function() {
                Xx(f);
              });
              return;
            }
          } else if (v === x) {
            var b = f.stateNode;
            if (yn(b)) {
              a.blockedOn = dv(f);
              return;
            }
          }
        }
      }
      a.blockedOn = null;
    }
    function Jx(a) {
      for (var o = Lf(), f = {
        blockedOn: null,
        target: a,
        priority: o
      }, v = 0; v < ls.length && Qm(o, ls[v].priority); v++)
        ;
      ls.splice(v, 0, f), v === 0 && t0(f);
    }
    function jv(a) {
      if (a.blockedOn !== null)
        return !1;
      for (var o = a.targetContainers; o.length > 0; ) {
        var f = o[0], v = vu(a.domEventName, a.eventSystemFlags, f, a.nativeEvent);
        if (v === null) {
          var _ = a.nativeEvent, b = new _.constructor(_.type, _);
          ff(b), _.target.dispatchEvent(b), p1();
        } else {
          var E = Wc(v);
          return E !== null && Df(E), a.blockedOn = v, !1;
        }
        o.shift();
      }
      return !0;
    }
    function Pf(a, o, f) {
      jv(a) && f.delete(o);
    }
    function r0() {
      Uv = !1, bo !== null && jv(bo) && (bo = null), Ir !== null && jv(Ir) && (Ir = null), Mn !== null && jv(Mn) && (Mn = null), Ia.forEach(Pf), Ic.forEach(Pf);
    }
    function oi(a, o) {
      a.blockedOn === o && (a.blockedOn = null, Uv || (Uv = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, r0)));
    }
    function zt(a) {
      if (Pc.length > 0) {
        oi(Pc[0], a);
        for (var o = 1; o < Pc.length; o++) {
          var f = Pc[o];
          f.blockedOn === a && (f.blockedOn = null);
        }
      }
      bo !== null && oi(bo, a), Ir !== null && oi(Ir, a), Mn !== null && oi(Mn, a);
      var v = function(A) {
        return oi(A, a);
      };
      Ia.forEach(v), Ic.forEach(v);
      for (var _ = 0; _ < ls.length; _++) {
        var b = ls[_];
        b.blockedOn === a && (b.blockedOn = null);
      }
      for (; ls.length > 0; ) {
        var E = ls[0];
        if (E.blockedOn !== null)
          break;
        t0(E), E.blockedOn === null && ls.shift();
      }
    }
    var Gr = r.ReactCurrentBatchConfig, Xr = !0;
    function Ln(a) {
      Xr = !!a;
    }
    function sa() {
      return Xr;
    }
    function Vc(a, o, f) {
      var v = mi(o), _;
      switch (v) {
        case ii:
          _ = xn;
          break;
        case Hn:
          _ = If;
          break;
        case ss:
        default:
          _ = us;
          break;
      }
      return _.bind(null, o, f, a);
    }
    function xn(a, o, f, v) {
      var _ = Pa(), b = Gr.transition;
      Gr.transition = null;
      try {
        _n(ii), us(a, o, f, v);
      } finally {
        _n(_), Gr.transition = b;
      }
    }
    function If(a, o, f, v) {
      var _ = Pa(), b = Gr.transition;
      Gr.transition = null;
      try {
        _n(Hn), us(a, o, f, v);
      } finally {
        _n(_), Gr.transition = b;
      }
    }
    function us(a, o, f, v) {
      Xr && $v(a, o, f, v);
    }
    function $v(a, o, f, v) {
      var _ = vu(a, o, f, v);
      if (_ === null) {
        $1(a, o, v, Fc, f), Zx(a, v);
        return;
      }
      if (Qx(_, a, o, f, v)) {
        v.stopPropagation();
        return;
      }
      if (Zx(a, v), o & Kl && Kx(a)) {
        for (; _ !== null; ) {
          var b = Wc(_);
          b !== null && Lc(b);
          var E = vu(a, o, f, v);
          if (E === null && $1(a, o, v, Fc, f), E === _)
            break;
          _ = E;
        }
        _ !== null && v.stopPropagation();
        return;
      }
      $1(a, o, v, null, f);
    }
    var Fc = null;
    function vu(a, o, f, v) {
      Fc = null;
      var _ = ov(v), b = Gf(_);
      if (b !== null) {
        var E = na(b);
        if (E === null)
          b = null;
        else {
          var A = E.tag;
          if (A === P) {
            var R = Rm(E);
            if (R !== null)
              return R;
            b = null;
          } else if (A === x) {
            var N = E.stateNode;
            if (yn(N))
              return dv(E);
            b = null;
          } else
            E !== b && (b = null);
        }
      }
      return Fc = b, null;
    }
    function mi(a) {
      switch (a) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return ii;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Hn;
        case "message": {
          var o = Lm();
          switch (o) {
            case pv:
              return ii;
            case aa:
              return Hn;
            case yo:
            case gv:
              return ss;
            case Qs:
              return Of;
            default:
              return ss;
          }
        }
        default:
          return ss;
      }
    }
    function n0(a, o, f) {
      return a.addEventListener(o, f, !1), f;
    }
    function Bc(a, o, f) {
      return a.addEventListener(o, f, !0), f;
    }
    function cs(a, o, f, v) {
      return a.addEventListener(o, f, {
        capture: !0,
        passive: v
      }), f;
    }
    function Yv(a, o, f, v) {
      return a.addEventListener(o, f, {
        passive: v
      }), f;
    }
    var pu = null, Co = null, ol = null;
    function sl(a) {
      return pu = a, Co = Xv(), !0;
    }
    function Wv() {
      pu = null, Co = null, ol = null;
    }
    function zc() {
      if (ol)
        return ol;
      var a, o = Co, f = o.length, v, _ = Xv(), b = _.length;
      for (a = 0; a < f && o[a] === _[a]; a++)
        ;
      var E = f - a;
      for (v = 1; v <= E && o[f - v] === _[b - v]; v++)
        ;
      var A = v > 1 ? 1 - v : void 0;
      return ol = _.slice(a, A), ol;
    }
    function Xv() {
      return "value" in pu ? pu.value : pu.textContent;
    }
    function gu(a) {
      var o, f = a.keyCode;
      return "charCode" in a ? (o = a.charCode, o === 0 && f === 13 && (o = 13)) : o = f, o === 10 && (o = 13), o >= 32 || o === 13 ? o : 0;
    }
    function mu() {
      return !0;
    }
    function si() {
      return !1;
    }
    function ln(a) {
      function o(f, v, _, b, E) {
        this._reactName = f, this._targetInst = _, this.type = v, this.nativeEvent = b, this.target = E, this.currentTarget = null;
        for (var A in a)
          if (a.hasOwnProperty(A)) {
            var R = a[A];
            R ? this[A] = R(b) : this[A] = b[A];
          }
        var N = b.defaultPrevented != null ? b.defaultPrevented : b.returnValue === !1;
        return N ? this.isDefaultPrevented = mu : this.isDefaultPrevented = si, this.isPropagationStopped = si, this;
      }
      return Bt(o.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var f = this.nativeEvent;
          f && (f.preventDefault ? f.preventDefault() : typeof f.returnValue != "unknown" && (f.returnValue = !1), this.isDefaultPrevented = mu);
        },
        stopPropagation: function() {
          var f = this.nativeEvent;
          f && (f.stopPropagation ? f.stopPropagation() : typeof f.cancelBubble != "unknown" && (f.cancelBubble = !0), this.isPropagationStopped = mu);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: mu
      }), o;
    }
    var li = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(a) {
        return a.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, ui = ln(li), Hc = Bt({}, li, {
      view: 0,
      detail: 0
    }), i0 = ln(Hc), Nf, a0, Na;
    function eb(a) {
      a !== Na && (Na && a.type === "mousemove" ? (Nf = a.screenX - Na.screenX, a0 = a.screenY - Na.screenY) : (Nf = 0, a0 = 0), Na = a);
    }
    var Gc = Bt({}, Hc, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Zv,
      button: 0,
      buttons: 0,
      relatedTarget: function(a) {
        return a.relatedTarget === void 0 ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
      },
      movementX: function(a) {
        return "movementX" in a ? a.movementX : (eb(a), Nf);
      },
      movementY: function(a) {
        return "movementY" in a ? a.movementY : a0;
      }
    }), ll = ln(Gc), o0 = Bt({}, Gc, {
      dataTransfer: 0
    }), _u = ln(o0), tb = Bt({}, Hc, {
      relatedTarget: 0
    }), qv = ln(tb), s0 = Bt({}, li, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Kv = ln(s0), w1 = Bt({}, li, {
      clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
      }
    }), A1 = ln(w1), rb = Bt({}, li, {
      data: 0
    }), l0 = ln(rb), yu = l0, O1 = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, Uc = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function nb(a) {
      if (a.key) {
        var o = O1[a.key] || a.key;
        if (o !== "Unidentified")
          return o;
      }
      if (a.type === "keypress") {
        var f = gu(a);
        return f === 13 ? "Enter" : String.fromCharCode(f);
      }
      return a.type === "keydown" || a.type === "keyup" ? Uc[a.keyCode] || "Unidentified" : "";
    }
    var qr = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function k1(a) {
      var o = this, f = o.nativeEvent;
      if (f.getModifierState)
        return f.getModifierState(a);
      var v = qr[a];
      return v ? !!f[v] : !1;
    }
    function Zv(a) {
      return k1;
    }
    var R1 = Bt({}, Hc, {
      key: nb,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Zv,
      // Legacy Interface
      charCode: function(a) {
        return a.type === "keypress" ? gu(a) : 0;
      },
      keyCode: function(a) {
        return a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
      },
      which: function(a) {
        return a.type === "keypress" ? gu(a) : a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
      }
    }), D1 = ln(R1), ib = Bt({}, Gc, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), u0 = ln(ib), M1 = Bt({}, Hc, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Zv
    }), Va = ln(M1), c0 = Bt({}, li, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), L1 = ln(c0), ul = Bt({}, Gc, {
      deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in a ? -a.wheelDeltaX : 0
        );
      },
      deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in a ? -a.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in a ? -a.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), Qv = ln(ul), xu = [9, 13, 27, 32], Vf = 229, Ff = Je && "CompositionEvent" in window, bu = null;
    Je && "documentMode" in document && (bu = document.documentMode);
    var P1 = Je && "TextEvent" in window && !bu, Jv = Je && (!Ff || bu && bu > 8 && bu <= 11), ab = 32, d0 = String.fromCharCode(ab);
    function ob() {
      _t("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), _t("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), _t("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), _t("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var Bf = !1;
    function ep(a) {
      return (a.ctrlKey || a.altKey || a.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(a.ctrlKey && a.altKey);
    }
    function sb(a) {
      switch (a) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function f0(a, o) {
      return a === "keydown" && o.keyCode === Vf;
    }
    function lb(a, o) {
      switch (a) {
        case "keyup":
          return xu.indexOf(o.keyCode) !== -1;
        case "keydown":
          return o.keyCode !== Vf;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function h0(a) {
      var o = a.detail;
      return typeof o == "object" && "data" in o ? o.data : null;
    }
    function tp(a) {
      return a.locale === "ko";
    }
    var ds = !1;
    function v0(a, o, f, v, _) {
      var b, E;
      if (Ff ? b = sb(o) : ds ? lb(o, v) && (b = "onCompositionEnd") : f0(o, v) && (b = "onCompositionStart"), !b)
        return null;
      Jv && !tp(v) && (!ds && b === "onCompositionStart" ? ds = sl(_) : b === "onCompositionEnd" && ds && (E = zc()));
      var A = hb(f, b);
      if (A.length > 0) {
        var R = new l0(b, o, null, v, _);
        if (a.push({
          event: R,
          listeners: A
        }), E)
          R.data = E;
        else {
          var N = h0(v);
          N !== null && (R.data = N);
        }
      }
    }
    function rp(a, o) {
      switch (a) {
        case "compositionend":
          return h0(o);
        case "keypress":
          var f = o.which;
          return f !== ab ? null : (Bf = !0, d0);
        case "textInput":
          var v = o.data;
          return v === d0 && Bf ? null : v;
        default:
          return null;
      }
    }
    function ub(a, o) {
      if (ds) {
        if (a === "compositionend" || !Ff && lb(a, o)) {
          var f = zc();
          return Wv(), ds = !1, f;
        }
        return null;
      }
      switch (a) {
        case "paste":
          return null;
        case "keypress":
          if (!ep(o)) {
            if (o.char && o.char.length > 1)
              return o.char;
            if (o.which)
              return String.fromCharCode(o.which);
          }
          return null;
        case "compositionend":
          return Jv && !tp(o) ? null : o.data;
        default:
          return null;
      }
    }
    function I1(a, o, f, v, _) {
      var b;
      if (P1 ? b = rp(o, v) : b = ub(o, v), !b)
        return null;
      var E = hb(f, "onBeforeInput");
      if (E.length > 0) {
        var A = new yu("onBeforeInput", "beforeinput", null, v, _);
        a.push({
          event: A,
          listeners: E
        }), A.data = b;
      }
    }
    function np(a, o, f, v, _, b, E) {
      v0(a, o, f, v, _), I1(a, o, f, v, _);
    }
    var N1 = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function jc(a) {
      var o = a && a.nodeName && a.nodeName.toLowerCase();
      return o === "input" ? !!N1[a.type] : o === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function V1(a) {
      if (!Je)
        return !1;
      var o = "on" + a, f = o in document;
      if (!f) {
        var v = document.createElement("div");
        v.setAttribute(o, "return;"), f = typeof v[o] == "function";
      }
      return f;
    }
    function ip() {
      _t("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function u(a, o, f, v) {
      sv(v);
      var _ = hb(o, "onChange");
      if (_.length > 0) {
        var b = new ui("onChange", "change", null, f, v);
        a.push({
          event: b,
          listeners: _
        });
      }
    }
    var c = null, g = null;
    function y(a) {
      var o = a.nodeName && a.nodeName.toLowerCase();
      return o === "select" || o === "input" && a.type === "file";
    }
    function C(a) {
      var o = [];
      u(o, g, a, ov(a)), Sm(w, o);
    }
    function w(a) {
      iP(a, 0);
    }
    function M(a) {
      var o = cp(a);
      if (qy(o))
        return a;
    }
    function H(a, o) {
      if (a === "change")
        return o;
    }
    var $ = !1;
    Je && ($ = V1("input") && (!document.documentMode || document.documentMode > 9));
    function ue(a, o) {
      c = a, g = o, c.attachEvent("onpropertychange", De);
    }
    function Oe() {
      c && (c.detachEvent("onpropertychange", De), c = null, g = null);
    }
    function De(a) {
      a.propertyName === "value" && M(g) && C(a);
    }
    function Ae(a, o, f) {
      a === "focusin" ? (Oe(), ue(o, f)) : a === "focusout" && Oe();
    }
    function Xe(a, o) {
      if (a === "selectionchange" || a === "keyup" || a === "keydown")
        return M(g);
    }
    function tt(a) {
      var o = a.nodeName;
      return o && o.toLowerCase() === "input" && (a.type === "checkbox" || a.type === "radio");
    }
    function at(a, o) {
      if (a === "click")
        return M(o);
    }
    function en(a, o) {
      if (a === "input" || a === "change")
        return M(o);
    }
    function te(a) {
      var o = a._wrapperState;
      !o || !o.controlled || a.type !== "number" || js(a, "number", a.value);
    }
    function q(a, o, f, v, _, b, E) {
      var A = f ? cp(f) : window, R, N;
      if (y(A) ? R = H : jc(A) ? $ ? R = en : (R = Xe, N = Ae) : tt(A) && (R = at), R) {
        var B = R(o, f);
        if (B) {
          u(a, B, v, _);
          return;
        }
      }
      N && N(o, A, f), o === "focusout" && te(A);
    }
    function ae() {
      xe("onMouseEnter", ["mouseout", "mouseover"]), xe("onMouseLeave", ["mouseout", "mouseover"]), xe("onPointerEnter", ["pointerout", "pointerover"]), xe("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function Ne(a, o, f, v, _, b, E) {
      var A = o === "mouseover" || o === "pointerover", R = o === "mouseout" || o === "pointerout";
      if (A && !wx(v)) {
        var N = v.relatedTarget || v.fromElement;
        if (N && (Gf(N) || O0(N)))
          return;
      }
      if (!(!R && !A)) {
        var B;
        if (_.window === _)
          B = _;
        else {
          var K = _.ownerDocument;
          K ? B = K.defaultView || K.parentWindow : B = window;
        }
        var X, ce;
        if (R) {
          var oe = v.relatedTarget || v.toElement;
          if (X = f, ce = oe ? Gf(oe) : null, ce !== null) {
            var ve = na(ce);
            (ce !== ve || ce.tag !== T && ce.tag !== k) && (ce = null);
          }
        } else
          X = null, ce = f;
        if (X !== ce) {
          var Ye = ll, ft = "onMouseLeave", ot = "onMouseEnter", Ht = "mouse";
          (o === "pointerout" || o === "pointerover") && (Ye = u0, ft = "onPointerLeave", ot = "onPointerEnter", Ht = "pointer");
          var Gt = X == null ? B : cp(X), ne = ce == null ? B : cp(ce), ge = new Ye(ft, Ht + "leave", X, v, _);
          ge.target = Gt, ge.relatedTarget = ne;
          var ie = null, Me = Gf(_);
          if (Me === f) {
            var Ke = new Ye(ot, Ht + "enter", ce, v, _);
            Ke.target = ne, Ke.relatedTarget = Gt, ie = Ke;
          }
          M$(a, ge, ie, X, ce);
        }
      }
    }
    function st(a, o) {
      return a === o && (a !== 0 || 1 / a === 1 / o) || a !== a && o !== o;
    }
    var rt = typeof Object.is == "function" ? Object.is : st;
    function ut(a, o) {
      if (rt(a, o))
        return !0;
      if (typeof a != "object" || a === null || typeof o != "object" || o === null)
        return !1;
      var f = Object.keys(a), v = Object.keys(o);
      if (f.length !== v.length)
        return !1;
      for (var _ = 0; _ < f.length; _++) {
        var b = f[_];
        if (!Pt.call(o, b) || !rt(a[b], o[b]))
          return !1;
      }
      return !0;
    }
    function Ct(a) {
      for (; a && a.firstChild; )
        a = a.firstChild;
      return a;
    }
    function Pn(a) {
      for (; a; ) {
        if (a.nextSibling)
          return a.nextSibling;
        a = a.parentNode;
      }
    }
    function Zt(a, o) {
      for (var f = Ct(a), v = 0, _ = 0; f; ) {
        if (f.nodeType === Zo) {
          if (_ = v + f.textContent.length, v <= o && _ >= o)
            return {
              node: f,
              offset: o - v
            };
          v = _;
        }
        f = Ct(Pn(f));
      }
    }
    function cl(a) {
      var o = a.ownerDocument, f = o && o.defaultView || window, v = f.getSelection && f.getSelection();
      if (!v || v.rangeCount === 0)
        return null;
      var _ = v.anchorNode, b = v.anchorOffset, E = v.focusNode, A = v.focusOffset;
      try {
        _.nodeType, E.nodeType;
      } catch {
        return null;
      }
      return F1(a, _, b, E, A);
    }
    function F1(a, o, f, v, _) {
      var b = 0, E = -1, A = -1, R = 0, N = 0, B = a, K = null;
      e:
        for (; ; ) {
          for (var X = null; B === o && (f === 0 || B.nodeType === Zo) && (E = b + f), B === v && (_ === 0 || B.nodeType === Zo) && (A = b + _), B.nodeType === Zo && (b += B.nodeValue.length), (X = B.firstChild) !== null; )
            K = B, B = X;
          for (; ; ) {
            if (B === a)
              break e;
            if (K === o && ++R === f && (E = b), K === v && ++N === _ && (A = b), (X = B.nextSibling) !== null)
              break;
            B = K, K = B.parentNode;
          }
          B = X;
        }
      return E === -1 || A === -1 ? null : {
        start: E,
        end: A
      };
    }
    function h$(a, o) {
      var f = a.ownerDocument || document, v = f && f.defaultView || window;
      if (v.getSelection) {
        var _ = v.getSelection(), b = a.textContent.length, E = Math.min(o.start, b), A = o.end === void 0 ? E : Math.min(o.end, b);
        if (!_.extend && E > A) {
          var R = A;
          A = E, E = R;
        }
        var N = Zt(a, E), B = Zt(a, A);
        if (N && B) {
          if (_.rangeCount === 1 && _.anchorNode === N.node && _.anchorOffset === N.offset && _.focusNode === B.node && _.focusOffset === B.offset)
            return;
          var K = f.createRange();
          K.setStart(N.node, N.offset), _.removeAllRanges(), E > A ? (_.addRange(K), _.extend(B.node, B.offset)) : (K.setEnd(B.node, B.offset), _.addRange(K));
        }
      }
    }
    function YL(a) {
      return a && a.nodeType === Zo;
    }
    function WL(a, o) {
      return !a || !o ? !1 : a === o ? !0 : YL(a) ? !1 : YL(o) ? WL(a, o.parentNode) : "contains" in a ? a.contains(o) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(o) & 16) : !1;
    }
    function v$(a) {
      return a && a.ownerDocument && WL(a.ownerDocument.documentElement, a);
    }
    function p$(a) {
      try {
        return typeof a.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function XL() {
      for (var a = window, o = Wh(); o instanceof a.HTMLIFrameElement; ) {
        if (p$(o))
          a = o.contentWindow;
        else
          return o;
        o = Wh(a.document);
      }
      return o;
    }
    function B1(a) {
      var o = a && a.nodeName && a.nodeName.toLowerCase();
      return o && (o === "input" && (a.type === "text" || a.type === "search" || a.type === "tel" || a.type === "url" || a.type === "password") || o === "textarea" || a.contentEditable === "true");
    }
    function g$() {
      var a = XL();
      return {
        focusedElem: a,
        selectionRange: B1(a) ? _$(a) : null
      };
    }
    function m$(a) {
      var o = XL(), f = a.focusedElem, v = a.selectionRange;
      if (o !== f && v$(f)) {
        v !== null && B1(f) && y$(f, v);
        for (var _ = [], b = f; b = b.parentNode; )
          b.nodeType === Di && _.push({
            element: b,
            left: b.scrollLeft,
            top: b.scrollTop
          });
        typeof f.focus == "function" && f.focus();
        for (var E = 0; E < _.length; E++) {
          var A = _[E];
          A.element.scrollLeft = A.left, A.element.scrollTop = A.top;
        }
      }
    }
    function _$(a) {
      var o;
      return "selectionStart" in a ? o = {
        start: a.selectionStart,
        end: a.selectionEnd
      } : o = cl(a), o || {
        start: 0,
        end: 0
      };
    }
    function y$(a, o) {
      var f = o.start, v = o.end;
      v === void 0 && (v = f), "selectionStart" in a ? (a.selectionStart = f, a.selectionEnd = Math.min(v, a.value.length)) : h$(a, o);
    }
    var x$ = Je && "documentMode" in document && document.documentMode <= 11;
    function b$() {
      _t("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var ap = null, z1 = null, p0 = null, H1 = !1;
    function S$(a) {
      if ("selectionStart" in a && B1(a))
        return {
          start: a.selectionStart,
          end: a.selectionEnd
        };
      var o = a.ownerDocument && a.ownerDocument.defaultView || window, f = o.getSelection();
      return {
        anchorNode: f.anchorNode,
        anchorOffset: f.anchorOffset,
        focusNode: f.focusNode,
        focusOffset: f.focusOffset
      };
    }
    function C$(a) {
      return a.window === a ? a.document : a.nodeType === ro ? a : a.ownerDocument;
    }
    function qL(a, o, f) {
      var v = C$(f);
      if (!(H1 || ap == null || ap !== Wh(v))) {
        var _ = S$(ap);
        if (!p0 || !ut(p0, _)) {
          p0 = _;
          var b = hb(z1, "onSelect");
          if (b.length > 0) {
            var E = new ui("onSelect", "select", null, o, f);
            a.push({
              event: E,
              listeners: b
            }), E.target = ap;
          }
        }
      }
    }
    function E$(a, o, f, v, _, b, E) {
      var A = f ? cp(f) : window;
      switch (o) {
        case "focusin":
          (jc(A) || A.contentEditable === "true") && (ap = A, z1 = f, p0 = null);
          break;
        case "focusout":
          ap = null, z1 = null, p0 = null;
          break;
        case "mousedown":
          H1 = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          H1 = !1, qL(a, v, _);
          break;
        case "selectionchange":
          if (x$)
            break;
        case "keydown":
        case "keyup":
          qL(a, v, _);
      }
    }
    function cb(a, o) {
      var f = {};
      return f[a.toLowerCase()] = o.toLowerCase(), f["Webkit" + a] = "webkit" + o, f["Moz" + a] = "moz" + o, f;
    }
    var op = {
      animationend: cb("Animation", "AnimationEnd"),
      animationiteration: cb("Animation", "AnimationIteration"),
      animationstart: cb("Animation", "AnimationStart"),
      transitionend: cb("Transition", "TransitionEnd")
    }, G1 = {}, KL = {};
    Je && (KL = document.createElement("div").style, "AnimationEvent" in window || (delete op.animationend.animation, delete op.animationiteration.animation, delete op.animationstart.animation), "TransitionEvent" in window || delete op.transitionend.transition);
    function db(a) {
      if (G1[a])
        return G1[a];
      if (!op[a])
        return a;
      var o = op[a];
      for (var f in o)
        if (o.hasOwnProperty(f) && f in KL)
          return G1[a] = o[f];
      return a;
    }
    var ZL = db("animationend"), QL = db("animationiteration"), JL = db("animationstart"), eP = db("transitionend"), tP = /* @__PURE__ */ new Map(), rP = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function $c(a, o) {
      tP.set(a, o), _t(o, [a]);
    }
    function T$() {
      for (var a = 0; a < rP.length; a++) {
        var o = rP[a], f = o.toLowerCase(), v = o[0].toUpperCase() + o.slice(1);
        $c(f, "on" + v);
      }
      $c(ZL, "onAnimationEnd"), $c(QL, "onAnimationIteration"), $c(JL, "onAnimationStart"), $c("dblclick", "onDoubleClick"), $c("focusin", "onFocus"), $c("focusout", "onBlur"), $c(eP, "onTransitionEnd");
    }
    function w$(a, o, f, v, _, b, E) {
      var A = tP.get(o);
      if (A !== void 0) {
        var R = ui, N = o;
        switch (o) {
          case "keypress":
            if (gu(v) === 0)
              return;
          case "keydown":
          case "keyup":
            R = D1;
            break;
          case "focusin":
            N = "focus", R = qv;
            break;
          case "focusout":
            N = "blur", R = qv;
            break;
          case "beforeblur":
          case "afterblur":
            R = qv;
            break;
          case "click":
            if (v.button === 2)
              return;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            R = ll;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            R = _u;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            R = Va;
            break;
          case ZL:
          case QL:
          case JL:
            R = Kv;
            break;
          case eP:
            R = L1;
            break;
          case "scroll":
            R = i0;
            break;
          case "wheel":
            R = Qv;
            break;
          case "copy":
          case "cut":
          case "paste":
            R = A1;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            R = u0;
            break;
        }
        var B = (b & Kl) !== 0;
        {
          var K = !B && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          o === "scroll", X = R$(f, A, v.type, B, K);
          if (X.length > 0) {
            var ce = new R(A, N, null, v, _);
            a.push({
              event: ce,
              listeners: X
            });
          }
        }
      }
    }
    T$(), ae(), ip(), b$(), ob();
    function A$(a, o, f, v, _, b, E) {
      w$(a, o, f, v, _, b);
      var A = (b & v1) === 0;
      A && (Ne(a, o, f, v, _), q(a, o, f, v, _), E$(a, o, f, v, _), np(a, o, f, v, _));
    }
    var g0 = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], U1 = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(g0));
    function nP(a, o, f) {
      var v = a.type || "unknown-event";
      a.currentTarget = f, ts(v, o, void 0, a), a.currentTarget = null;
    }
    function O$(a, o, f) {
      var v;
      if (f)
        for (var _ = o.length - 1; _ >= 0; _--) {
          var b = o[_], E = b.instance, A = b.currentTarget, R = b.listener;
          if (E !== v && a.isPropagationStopped())
            return;
          nP(a, R, A), v = E;
        }
      else
        for (var N = 0; N < o.length; N++) {
          var B = o[N], K = B.instance, X = B.currentTarget, ce = B.listener;
          if (K !== v && a.isPropagationStopped())
            return;
          nP(a, ce, X), v = K;
        }
    }
    function iP(a, o) {
      for (var f = (o & Kl) !== 0, v = 0; v < a.length; v++) {
        var _ = a[v], b = _.event, E = _.listeners;
        O$(b, E, f);
      }
      wm();
    }
    function k$(a, o, f, v, _) {
      var b = ov(f), E = [];
      A$(E, a, v, f, b, o), iP(E, o);
    }
    function Ur(a, o) {
      U1.has(a) || l('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', a);
      var f = !1, v = aY(o), _ = L$(a, f);
      v.has(_) || (aP(o, a, cf, f), v.add(_));
    }
    function j1(a, o, f) {
      U1.has(a) && !o && l('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', a);
      var v = 0;
      o && (v |= Kl), aP(f, a, v, o);
    }
    var fb = "_reactListening" + Math.random().toString(36).slice(2);
    function m0(a) {
      if (!a[fb]) {
        a[fb] = !0, Qe.forEach(function(f) {
          f !== "selectionchange" && (U1.has(f) || j1(f, !1, a), j1(f, !0, a));
        });
        var o = a.nodeType === ro ? a : a.ownerDocument;
        o !== null && (o[fb] || (o[fb] = !0, j1("selectionchange", !1, o)));
      }
    }
    function aP(a, o, f, v, _) {
      var b = Vc(a, o, f), E = void 0;
      pf && (o === "touchstart" || o === "touchmove" || o === "wheel") && (E = !0), a = a;
      var A;
      v ? E !== void 0 ? A = cs(a, o, b, E) : A = Bc(a, o, b) : E !== void 0 ? A = Yv(a, o, b, E) : A = n0(a, o, b);
    }
    function oP(a, o) {
      return a === o || a.nodeType === on && a.parentNode === o;
    }
    function $1(a, o, f, v, _) {
      var b = v;
      if (!(o & Jo) && !(o & cf)) {
        var E = _;
        if (v !== null) {
          var A = v;
          e:
            for (; ; ) {
              if (A === null)
                return;
              var R = A.tag;
              if (R === x || R === S) {
                var N = A.stateNode.containerInfo;
                if (oP(N, E))
                  break;
                if (R === S)
                  for (var B = A.return; B !== null; ) {
                    var K = B.tag;
                    if (K === x || K === S) {
                      var X = B.stateNode.containerInfo;
                      if (oP(X, E))
                        return;
                    }
                    B = B.return;
                  }
                for (; N !== null; ) {
                  var ce = Gf(N);
                  if (ce === null)
                    return;
                  var oe = ce.tag;
                  if (oe === T || oe === k) {
                    A = b = ce;
                    continue e;
                  }
                  N = N.parentNode;
                }
              }
              A = A.return;
            }
        }
      }
      Sm(function() {
        return k$(a, o, f, b);
      });
    }
    function _0(a, o, f) {
      return {
        instance: a,
        listener: o,
        currentTarget: f
      };
    }
    function R$(a, o, f, v, _, b) {
      for (var E = o !== null ? o + "Capture" : null, A = v ? E : o, R = [], N = a, B = null; N !== null; ) {
        var K = N, X = K.stateNode, ce = K.tag;
        if (ce === T && X !== null && (B = X, A !== null)) {
          var oe = Ql(N, A);
          oe != null && R.push(_0(N, oe, B));
        }
        if (_)
          break;
        N = N.return;
      }
      return R;
    }
    function hb(a, o) {
      for (var f = o + "Capture", v = [], _ = a; _ !== null; ) {
        var b = _, E = b.stateNode, A = b.tag;
        if (A === T && E !== null) {
          var R = E, N = Ql(_, f);
          N != null && v.unshift(_0(_, N, R));
          var B = Ql(_, o);
          B != null && v.push(_0(_, B, R));
        }
        _ = _.return;
      }
      return v;
    }
    function sp(a) {
      if (a === null)
        return null;
      do
        a = a.return;
      while (a && a.tag !== T);
      return a || null;
    }
    function D$(a, o) {
      for (var f = a, v = o, _ = 0, b = f; b; b = sp(b))
        _++;
      for (var E = 0, A = v; A; A = sp(A))
        E++;
      for (; _ - E > 0; )
        f = sp(f), _--;
      for (; E - _ > 0; )
        v = sp(v), E--;
      for (var R = _; R--; ) {
        if (f === v || v !== null && f === v.alternate)
          return f;
        f = sp(f), v = sp(v);
      }
      return null;
    }
    function sP(a, o, f, v, _) {
      for (var b = o._reactName, E = [], A = f; A !== null && A !== v; ) {
        var R = A, N = R.alternate, B = R.stateNode, K = R.tag;
        if (N !== null && N === v)
          break;
        if (K === T && B !== null) {
          var X = B;
          if (_) {
            var ce = Ql(A, b);
            ce != null && E.unshift(_0(A, ce, X));
          } else if (!_) {
            var oe = Ql(A, b);
            oe != null && E.push(_0(A, oe, X));
          }
        }
        A = A.return;
      }
      E.length !== 0 && a.push({
        event: o,
        listeners: E
      });
    }
    function M$(a, o, f, v, _) {
      var b = v && _ ? D$(v, _) : null;
      v !== null && sP(a, o, v, b, !1), _ !== null && f !== null && sP(a, f, _, b, !0);
    }
    function L$(a, o) {
      return a + "__" + (o ? "capture" : "bubble");
    }
    var Fa = !1, y0 = "dangerouslySetInnerHTML", vb = "suppressContentEditableWarning", Yc = "suppressHydrationWarning", lP = "autoFocus", zf = "children", Hf = "style", pb = "__html", Y1, gb, x0, uP, mb, cP, dP;
    Y1 = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, gb = function(a, o) {
      av(a, o), mm(a, o), Tx(a, o, {
        registrationNameDependencies: it,
        possibleRegistrationNames: We
      });
    }, cP = Je && !document.documentMode, x0 = function(a, o, f) {
      if (!Fa) {
        var v = _b(f), _ = _b(o);
        _ !== v && (Fa = !0, l("Prop `%s` did not match. Server: %s Client: %s", a, JSON.stringify(_), JSON.stringify(v)));
      }
    }, uP = function(a) {
      if (!Fa) {
        Fa = !0;
        var o = [];
        a.forEach(function(f) {
          o.push(f);
        }), l("Extra attributes from the server: %s", o);
      }
    }, mb = function(a, o) {
      o === !1 ? l("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", a, a, a) : l("Expected `%s` listener to be a function, instead got a value of `%s` type.", a, typeof o);
    }, dP = function(a, o) {
      var f = a.namespaceURI === Ko ? a.ownerDocument.createElement(a.tagName) : a.ownerDocument.createElementNS(a.namespaceURI, a.tagName);
      return f.innerHTML = o, f.innerHTML;
    };
    var P$ = /\r\n?/g, I$ = /\u0000|\uFFFD/g;
    function _b(a) {
      Ri(a);
      var o = typeof a == "string" ? a : "" + a;
      return o.replace(P$, `
`).replace(I$, "");
    }
    function yb(a, o, f, v) {
      var _ = _b(o), b = _b(a);
      if (b !== _ && (v && (Fa || (Fa = !0, l('Text content did not match. Server: "%s" Client: "%s"', b, _))), f && Ee))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function fP(a) {
      return a.nodeType === ro ? a : a.ownerDocument;
    }
    function N$() {
    }
    function xb(a) {
      a.onclick = N$;
    }
    function V$(a, o, f, v, _) {
      for (var b in v)
        if (v.hasOwnProperty(b)) {
          var E = v[b];
          if (b === Hf)
            E && Object.freeze(E), px(o, E);
          else if (b === y0) {
            var A = E ? E[pb] : void 0;
            A != null && ix(o, A);
          } else if (b === zf)
            if (typeof E == "string") {
              var R = a !== "textarea" || E !== "";
              R && tv(o, E);
            } else
              typeof E == "number" && tv(o, "" + E);
          else
            b === vb || b === Yc || b === lP || (it.hasOwnProperty(b) ? E != null && (typeof E != "function" && mb(b, E), b === "onScroll" && Ur("scroll", o)) : E != null && go(o, b, E, _));
        }
    }
    function F$(a, o, f, v) {
      for (var _ = 0; _ < o.length; _ += 2) {
        var b = o[_], E = o[_ + 1];
        b === Hf ? px(a, E) : b === y0 ? ix(a, E) : b === zf ? tv(a, E) : go(a, b, E, v);
      }
    }
    function B$(a, o, f, v) {
      var _, b = fP(f), E, A = v;
      if (A === Ko && (A = Jh(a)), A === Ko) {
        if (_ = Qo(a, o), !_ && a !== a.toLowerCase() && l("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", a), a === "script") {
          var R = b.createElement("div");
          R.innerHTML = "<script><\/script>";
          var N = R.firstChild;
          E = R.removeChild(N);
        } else if (typeof o.is == "string")
          E = b.createElement(a, {
            is: o.is
          });
        else if (E = b.createElement(a), a === "select") {
          var B = E;
          o.multiple ? B.multiple = !0 : o.size && (B.size = o.size);
        }
      } else
        E = b.createElementNS(A, a);
      return A === Ko && !_ && Object.prototype.toString.call(E) === "[object HTMLUnknownElement]" && !Pt.call(Y1, a) && (Y1[a] = !0, l("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", a)), E;
    }
    function z$(a, o) {
      return fP(o).createTextNode(a);
    }
    function H$(a, o, f, v) {
      var _ = Qo(o, f);
      gb(o, f);
      var b;
      switch (o) {
        case "dialog":
          Ur("cancel", a), Ur("close", a), b = f;
          break;
        case "iframe":
        case "object":
        case "embed":
          Ur("load", a), b = f;
          break;
        case "video":
        case "audio":
          for (var E = 0; E < g0.length; E++)
            Ur(g0[E], a);
          b = f;
          break;
        case "source":
          Ur("error", a), b = f;
          break;
        case "img":
        case "image":
        case "link":
          Ur("error", a), Ur("load", a), b = f;
          break;
        case "details":
          Ur("toggle", a), b = f;
          break;
        case "input":
          nf(a, f), b = rf(a, f), Ur("invalid", a);
          break;
        case "option":
          Zh(a, f), b = f;
          break;
        case "select":
          ex(a, f), b = om(a, f), Ur("invalid", a);
          break;
        case "textarea":
          tx(a, f), b = lm(a, f), Ur("invalid", a);
          break;
        default:
          b = f;
      }
      switch (nv(o, b), V$(o, a, v, b, _), o) {
        case "input":
          Wl(a), af(a, f, !1);
          break;
        case "textarea":
          Wl(a), nx(a);
          break;
        case "option":
          am(a, f);
          break;
        case "select":
          n1(a, f);
          break;
        default:
          typeof b.onClick == "function" && xb(a);
          break;
      }
    }
    function G$(a, o, f, v, _) {
      gb(o, v);
      var b = null, E, A;
      switch (o) {
        case "input":
          E = rf(a, f), A = rf(a, v), b = [];
          break;
        case "select":
          E = om(a, f), A = om(a, v), b = [];
          break;
        case "textarea":
          E = lm(a, f), A = lm(a, v), b = [];
          break;
        default:
          E = f, A = v, typeof E.onClick != "function" && typeof A.onClick == "function" && xb(a);
          break;
      }
      nv(o, A);
      var R, N, B = null;
      for (R in E)
        if (!(A.hasOwnProperty(R) || !E.hasOwnProperty(R) || E[R] == null))
          if (R === Hf) {
            var K = E[R];
            for (N in K)
              K.hasOwnProperty(N) && (B || (B = {}), B[N] = "");
          } else
            R === y0 || R === zf || R === vb || R === Yc || R === lP || (it.hasOwnProperty(R) ? b || (b = []) : (b = b || []).push(R, null));
      for (R in A) {
        var X = A[R], ce = E != null ? E[R] : void 0;
        if (!(!A.hasOwnProperty(R) || X === ce || X == null && ce == null))
          if (R === Hf)
            if (X && Object.freeze(X), ce) {
              for (N in ce)
                ce.hasOwnProperty(N) && (!X || !X.hasOwnProperty(N)) && (B || (B = {}), B[N] = "");
              for (N in X)
                X.hasOwnProperty(N) && ce[N] !== X[N] && (B || (B = {}), B[N] = X[N]);
            } else
              B || (b || (b = []), b.push(R, B)), B = X;
          else if (R === y0) {
            var oe = X ? X[pb] : void 0, ve = ce ? ce[pb] : void 0;
            oe != null && ve !== oe && (b = b || []).push(R, oe);
          } else
            R === zf ? (typeof X == "string" || typeof X == "number") && (b = b || []).push(R, "" + X) : R === vb || R === Yc || (it.hasOwnProperty(R) ? (X != null && (typeof X != "function" && mb(R, X), R === "onScroll" && Ur("scroll", a)), !b && ce !== X && (b = [])) : (b = b || []).push(R, X));
      }
      return B && (lf(B, A[Hf]), (b = b || []).push(Hf, B)), b;
    }
    function U$(a, o, f, v, _) {
      f === "input" && _.type === "radio" && _.name != null && im(a, _);
      var b = Qo(f, v), E = Qo(f, _);
      switch (F$(a, o, b, E), f) {
        case "input":
          vc(a, _);
          break;
        case "textarea":
          rx(a, _);
          break;
        case "select":
          i1(a, _);
          break;
      }
    }
    function j$(a) {
      {
        var o = a.toLowerCase();
        return iv.hasOwnProperty(o) && iv[o] || null;
      }
    }
    function $$(a, o, f, v, _, b, E) {
      var A, R;
      switch (A = Qo(o, f), gb(o, f), o) {
        case "dialog":
          Ur("cancel", a), Ur("close", a);
          break;
        case "iframe":
        case "object":
        case "embed":
          Ur("load", a);
          break;
        case "video":
        case "audio":
          for (var N = 0; N < g0.length; N++)
            Ur(g0[N], a);
          break;
        case "source":
          Ur("error", a);
          break;
        case "img":
        case "image":
        case "link":
          Ur("error", a), Ur("load", a);
          break;
        case "details":
          Ur("toggle", a);
          break;
        case "input":
          nf(a, f), Ur("invalid", a);
          break;
        case "option":
          Zh(a, f);
          break;
        case "select":
          ex(a, f), Ur("invalid", a);
          break;
        case "textarea":
          tx(a, f), Ur("invalid", a);
          break;
      }
      nv(o, f);
      {
        R = /* @__PURE__ */ new Set();
        for (var B = a.attributes, K = 0; K < B.length; K++) {
          var X = B[K].name.toLowerCase();
          switch (X) {
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              R.add(B[K].name);
          }
        }
      }
      var ce = null;
      for (var oe in f)
        if (f.hasOwnProperty(oe)) {
          var ve = f[oe];
          if (oe === zf)
            typeof ve == "string" ? a.textContent !== ve && (f[Yc] !== !0 && yb(a.textContent, ve, b, E), ce = [zf, ve]) : typeof ve == "number" && a.textContent !== "" + ve && (f[Yc] !== !0 && yb(a.textContent, ve, b, E), ce = [zf, "" + ve]);
          else if (it.hasOwnProperty(oe))
            ve != null && (typeof ve != "function" && mb(oe, ve), oe === "onScroll" && Ur("scroll", a));
          else if (E && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof A == "boolean") {
            var Ye = void 0, ft = A && Pe ? null : Br(oe);
            if (f[Yc] !== !0) {
              if (!(oe === vb || oe === Yc || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              oe === "value" || oe === "checked" || oe === "selected")) {
                if (oe === y0) {
                  var ot = a.innerHTML, Ht = ve ? ve[pb] : void 0;
                  if (Ht != null) {
                    var Gt = dP(a, Ht);
                    Gt !== ot && x0(oe, ot, Gt);
                  }
                } else if (oe === Hf) {
                  if (R.delete(oe), cP) {
                    var ne = f1(ve);
                    Ye = a.getAttribute("style"), ne !== Ye && x0(oe, Ye, ne);
                  }
                } else if (A && !Pe)
                  R.delete(oe.toLowerCase()), Ye = cc(a, oe, ve), ve !== Ye && x0(oe, Ye, ve);
                else if (!wn(oe, ft, A) && !An(oe, ve, ft, A)) {
                  var ge = !1;
                  if (ft !== null)
                    R.delete(ft.attributeName), Ye = jl(a, oe, ve, ft);
                  else {
                    var ie = v;
                    if (ie === Ko && (ie = Jh(o)), ie === Ko)
                      R.delete(oe.toLowerCase());
                    else {
                      var Me = j$(oe);
                      Me !== null && Me !== oe && (ge = !0, R.delete(Me)), R.delete(oe);
                    }
                    Ye = cc(a, oe, ve);
                  }
                  var Ke = Pe;
                  !Ke && ve !== Ye && !ge && x0(oe, Ye, ve);
                }
              }
            }
          }
        }
      switch (E && // $FlowFixMe - Should be inferred as not undefined.
      R.size > 0 && f[Yc] !== !0 && uP(R), o) {
        case "input":
          Wl(a), af(a, f, !0);
          break;
        case "textarea":
          Wl(a), nx(a);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof f.onClick == "function" && xb(a);
          break;
      }
      return ce;
    }
    function Y$(a, o, f) {
      var v = a.nodeValue !== o;
      return v;
    }
    function W1(a, o) {
      {
        if (Fa)
          return;
        Fa = !0, l("Did not expect server HTML to contain a <%s> in <%s>.", o.nodeName.toLowerCase(), a.nodeName.toLowerCase());
      }
    }
    function X1(a, o) {
      {
        if (Fa)
          return;
        Fa = !0, l('Did not expect server HTML to contain the text node "%s" in <%s>.', o.nodeValue, a.nodeName.toLowerCase());
      }
    }
    function q1(a, o, f) {
      {
        if (Fa)
          return;
        Fa = !0, l("Expected server HTML to contain a matching <%s> in <%s>.", o, a.nodeName.toLowerCase());
      }
    }
    function K1(a, o) {
      {
        if (o === "" || Fa)
          return;
        Fa = !0, l('Expected server HTML to contain a matching text node for "%s" in <%s>.', o, a.nodeName.toLowerCase());
      }
    }
    function W$(a, o, f) {
      switch (o) {
        case "input":
          Ky(a, f);
          return;
        case "textarea":
          um(a, f);
          return;
        case "select":
          a1(a, f);
          return;
      }
    }
    var b0 = function() {
    }, S0 = function() {
    };
    {
      var X$ = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], hP = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], q$ = hP.concat(["button"]), K$ = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], vP = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      S0 = function(a, o) {
        var f = Bt({}, a || vP), v = {
          tag: o
        };
        return hP.indexOf(o) !== -1 && (f.aTagInScope = null, f.buttonTagInScope = null, f.nobrTagInScope = null), q$.indexOf(o) !== -1 && (f.pTagInButtonScope = null), X$.indexOf(o) !== -1 && o !== "address" && o !== "div" && o !== "p" && (f.listItemTagAutoclosing = null, f.dlItemTagAutoclosing = null), f.current = v, o === "form" && (f.formTag = v), o === "a" && (f.aTagInScope = v), o === "button" && (f.buttonTagInScope = v), o === "nobr" && (f.nobrTagInScope = v), o === "p" && (f.pTagInButtonScope = v), o === "li" && (f.listItemTagAutoclosing = v), (o === "dd" || o === "dt") && (f.dlItemTagAutoclosing = v), f;
      };
      var Z$ = function(a, o) {
        switch (o) {
          case "select":
            return a === "option" || a === "optgroup" || a === "#text";
          case "optgroup":
            return a === "option" || a === "#text";
          case "option":
            return a === "#text";
          case "tr":
            return a === "th" || a === "td" || a === "style" || a === "script" || a === "template";
          case "tbody":
          case "thead":
          case "tfoot":
            return a === "tr" || a === "style" || a === "script" || a === "template";
          case "colgroup":
            return a === "col" || a === "template";
          case "table":
            return a === "caption" || a === "colgroup" || a === "tbody" || a === "tfoot" || a === "thead" || a === "style" || a === "script" || a === "template";
          case "head":
            return a === "base" || a === "basefont" || a === "bgsound" || a === "link" || a === "meta" || a === "title" || a === "noscript" || a === "noframes" || a === "style" || a === "script" || a === "template";
          case "html":
            return a === "head" || a === "body" || a === "frameset";
          case "frameset":
            return a === "frame";
          case "#document":
            return a === "html";
        }
        switch (a) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return o !== "h1" && o !== "h2" && o !== "h3" && o !== "h4" && o !== "h5" && o !== "h6";
          case "rp":
          case "rt":
            return K$.indexOf(o) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return o == null;
        }
        return !0;
      }, Q$ = function(a, o) {
        switch (a) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return o.pTagInButtonScope;
          case "form":
            return o.formTag || o.pTagInButtonScope;
          case "li":
            return o.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return o.dlItemTagAutoclosing;
          case "button":
            return o.buttonTagInScope;
          case "a":
            return o.aTagInScope;
          case "nobr":
            return o.nobrTagInScope;
        }
        return null;
      }, pP = {};
      b0 = function(a, o, f) {
        f = f || vP;
        var v = f.current, _ = v && v.tag;
        o != null && (a != null && l("validateDOMNesting: when childText is passed, childTag should be null"), a = "#text");
        var b = Z$(a, _) ? null : v, E = b ? null : Q$(a, f), A = b || E;
        if (A) {
          var R = A.tag, N = !!b + "|" + a + "|" + R;
          if (!pP[N]) {
            pP[N] = !0;
            var B = a, K = "";
            if (a === "#text" ? /\S/.test(o) ? B = "Text nodes" : (B = "Whitespace text nodes", K = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : B = "<" + a + ">", b) {
              var X = "";
              R === "table" && a === "tr" && (X += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), l("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", B, R, K, X);
            } else
              l("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", B, R);
          }
        }
      };
    }
    var bb = "suppressHydrationWarning", Sb = "$", Cb = "/$", C0 = "$?", E0 = "$!", J$ = "style", Z1 = null, Q1 = null;
    function e6(a) {
      var o, f, v = a.nodeType;
      switch (v) {
        case ro:
        case Xl: {
          o = v === ro ? "#document" : "#fragment";
          var _ = a.documentElement;
          f = _ ? _.namespaceURI : dm(null, "");
          break;
        }
        default: {
          var b = v === on ? a.parentNode : a, E = b.namespaceURI || null;
          o = b.tagName, f = dm(E, o);
          break;
        }
      }
      {
        var A = o.toLowerCase(), R = S0(null, A);
        return {
          namespace: f,
          ancestorInfo: R
        };
      }
    }
    function t6(a, o, f) {
      {
        var v = a, _ = dm(v.namespace, o), b = S0(v.ancestorInfo, o);
        return {
          namespace: _,
          ancestorInfo: b
        };
      }
    }
    function eve(a) {
      return a;
    }
    function r6(a) {
      Z1 = sa(), Q1 = g$();
      var o = null;
      return Ln(!1), o;
    }
    function n6(a) {
      m$(Q1), Ln(Z1), Z1 = null, Q1 = null;
    }
    function i6(a, o, f, v, _) {
      var b;
      {
        var E = v;
        if (b0(a, null, E.ancestorInfo), typeof o.children == "string" || typeof o.children == "number") {
          var A = "" + o.children, R = S0(E.ancestorInfo, a);
          b0(null, A, R);
        }
        b = E.namespace;
      }
      var N = B$(a, o, f, b);
      return A0(_, N), ow(N, o), N;
    }
    function a6(a, o) {
      a.appendChild(o);
    }
    function o6(a, o, f, v, _) {
      switch (H$(a, o, f, v), o) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!f.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function s6(a, o, f, v, _, b) {
      {
        var E = b;
        if (typeof v.children != typeof f.children && (typeof v.children == "string" || typeof v.children == "number")) {
          var A = "" + v.children, R = S0(E.ancestorInfo, o);
          b0(null, A, R);
        }
      }
      return G$(a, o, f, v);
    }
    function J1(a, o) {
      return a === "textarea" || a === "noscript" || typeof o.children == "string" || typeof o.children == "number" || typeof o.dangerouslySetInnerHTML == "object" && o.dangerouslySetInnerHTML !== null && o.dangerouslySetInnerHTML.__html != null;
    }
    function l6(a, o, f, v) {
      {
        var _ = f;
        b0(null, a, _.ancestorInfo);
      }
      var b = z$(a, o);
      return A0(v, b), b;
    }
    function u6() {
      var a = window.event;
      return a === void 0 ? ss : mi(a.type);
    }
    var ew = typeof setTimeout == "function" ? setTimeout : void 0, c6 = typeof clearTimeout == "function" ? clearTimeout : void 0, tw = -1, gP = typeof Promise == "function" ? Promise : void 0, d6 = typeof queueMicrotask == "function" ? queueMicrotask : typeof gP < "u" ? function(a) {
      return gP.resolve(null).then(a).catch(f6);
    } : ew;
    function f6(a) {
      setTimeout(function() {
        throw a;
      });
    }
    function h6(a, o, f, v) {
      switch (o) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          f.autoFocus && a.focus();
          return;
        case "img": {
          f.src && (a.src = f.src);
          return;
        }
      }
    }
    function v6(a, o, f, v, _, b) {
      U$(a, o, f, v, _), ow(a, _);
    }
    function mP(a) {
      tv(a, "");
    }
    function p6(a, o, f) {
      a.nodeValue = f;
    }
    function g6(a, o) {
      a.appendChild(o);
    }
    function m6(a, o) {
      var f;
      a.nodeType === on ? (f = a.parentNode, f.insertBefore(o, a)) : (f = a, f.appendChild(o));
      var v = a._reactRootContainer;
      v == null && f.onclick === null && xb(f);
    }
    function _6(a, o, f) {
      a.insertBefore(o, f);
    }
    function y6(a, o, f) {
      a.nodeType === on ? a.parentNode.insertBefore(o, f) : a.insertBefore(o, f);
    }
    function x6(a, o) {
      a.removeChild(o);
    }
    function b6(a, o) {
      a.nodeType === on ? a.parentNode.removeChild(o) : a.removeChild(o);
    }
    function rw(a, o) {
      var f = o, v = 0;
      do {
        var _ = f.nextSibling;
        if (a.removeChild(f), _ && _.nodeType === on) {
          var b = _.data;
          if (b === Cb)
            if (v === 0) {
              a.removeChild(_), zt(o);
              return;
            } else
              v--;
          else
            (b === Sb || b === C0 || b === E0) && v++;
        }
        f = _;
      } while (f);
      zt(o);
    }
    function S6(a, o) {
      a.nodeType === on ? rw(a.parentNode, o) : a.nodeType === Di && rw(a, o), zt(a);
    }
    function C6(a) {
      a = a;
      var o = a.style;
      typeof o.setProperty == "function" ? o.setProperty("display", "none", "important") : o.display = "none";
    }
    function E6(a) {
      a.nodeValue = "";
    }
    function T6(a, o) {
      a = a;
      var f = o[J$], v = f != null && f.hasOwnProperty("display") ? f.display : null;
      a.style.display = rv("display", v);
    }
    function w6(a, o) {
      a.nodeValue = o;
    }
    function A6(a) {
      a.nodeType === Di ? a.textContent = "" : a.nodeType === ro && a.documentElement && a.removeChild(a.documentElement);
    }
    function O6(a, o, f) {
      return a.nodeType !== Di || o.toLowerCase() !== a.nodeName.toLowerCase() ? null : a;
    }
    function k6(a, o) {
      return o === "" || a.nodeType !== Zo ? null : a;
    }
    function R6(a) {
      return a.nodeType !== on ? null : a;
    }
    function _P(a) {
      return a.data === C0;
    }
    function nw(a) {
      return a.data === E0;
    }
    function D6(a) {
      var o = a.nextSibling && a.nextSibling.dataset, f, v, _;
      return o && (f = o.dgst, v = o.msg, _ = o.stck), {
        message: v,
        digest: f,
        stack: _
      };
    }
    function M6(a, o) {
      a._reactRetry = o;
    }
    function Eb(a) {
      for (; a != null; a = a.nextSibling) {
        var o = a.nodeType;
        if (o === Di || o === Zo)
          break;
        if (o === on) {
          var f = a.data;
          if (f === Sb || f === E0 || f === C0)
            break;
          if (f === Cb)
            return null;
        }
      }
      return a;
    }
    function T0(a) {
      return Eb(a.nextSibling);
    }
    function L6(a) {
      return Eb(a.firstChild);
    }
    function P6(a) {
      return Eb(a.firstChild);
    }
    function I6(a) {
      return Eb(a.nextSibling);
    }
    function N6(a, o, f, v, _, b, E) {
      A0(b, a), ow(a, f);
      var A;
      {
        var R = _;
        A = R.namespace;
      }
      var N = (b.mode & Ft) !== pt;
      return $$(a, o, f, A, v, N, E);
    }
    function V6(a, o, f, v) {
      A0(f, a);
      var _ = (f.mode & Ft) !== pt;
      return Y$(a, o);
    }
    function F6(a, o) {
      A0(o, a);
    }
    function B6(a) {
      for (var o = a.nextSibling, f = 0; o; ) {
        if (o.nodeType === on) {
          var v = o.data;
          if (v === Cb) {
            if (f === 0)
              return T0(o);
            f--;
          } else
            (v === Sb || v === E0 || v === C0) && f++;
        }
        o = o.nextSibling;
      }
      return null;
    }
    function yP(a) {
      for (var o = a.previousSibling, f = 0; o; ) {
        if (o.nodeType === on) {
          var v = o.data;
          if (v === Sb || v === E0 || v === C0) {
            if (f === 0)
              return o;
            f--;
          } else
            v === Cb && f++;
        }
        o = o.previousSibling;
      }
      return null;
    }
    function z6(a) {
      zt(a);
    }
    function H6(a) {
      zt(a);
    }
    function G6(a) {
      return a !== "head" && a !== "body";
    }
    function U6(a, o, f, v) {
      var _ = !0;
      yb(o.nodeValue, f, v, _);
    }
    function j6(a, o, f, v, _, b) {
      if (o[bb] !== !0) {
        var E = !0;
        yb(v.nodeValue, _, b, E);
      }
    }
    function $6(a, o) {
      o.nodeType === Di ? W1(a, o) : o.nodeType === on || X1(a, o);
    }
    function Y6(a, o) {
      {
        var f = a.parentNode;
        f !== null && (o.nodeType === Di ? W1(f, o) : o.nodeType === on || X1(f, o));
      }
    }
    function W6(a, o, f, v, _) {
      (_ || o[bb] !== !0) && (v.nodeType === Di ? W1(f, v) : v.nodeType === on || X1(f, v));
    }
    function X6(a, o, f) {
      q1(a, o);
    }
    function q6(a, o) {
      K1(a, o);
    }
    function K6(a, o, f) {
      {
        var v = a.parentNode;
        v !== null && q1(v, o);
      }
    }
    function Z6(a, o) {
      {
        var f = a.parentNode;
        f !== null && K1(f, o);
      }
    }
    function Q6(a, o, f, v, _, b) {
      (b || o[bb] !== !0) && q1(f, v);
    }
    function J6(a, o, f, v, _) {
      (_ || o[bb] !== !0) && K1(f, v);
    }
    function eY(a) {
      l("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", a.nodeName.toLowerCase());
    }
    function tY(a) {
      m0(a);
    }
    var lp = Math.random().toString(36).slice(2), up = "__reactFiber$" + lp, iw = "__reactProps$" + lp, w0 = "__reactContainer$" + lp, aw = "__reactEvents$" + lp, rY = "__reactListeners$" + lp, nY = "__reactHandles$" + lp;
    function iY(a) {
      delete a[up], delete a[iw], delete a[aw], delete a[rY], delete a[nY];
    }
    function A0(a, o) {
      o[up] = a;
    }
    function Tb(a, o) {
      o[w0] = a;
    }
    function xP(a) {
      a[w0] = null;
    }
    function O0(a) {
      return !!a[w0];
    }
    function Gf(a) {
      var o = a[up];
      if (o)
        return o;
      for (var f = a.parentNode; f; ) {
        if (o = f[w0] || f[up], o) {
          var v = o.alternate;
          if (o.child !== null || v !== null && v.child !== null)
            for (var _ = yP(a); _ !== null; ) {
              var b = _[up];
              if (b)
                return b;
              _ = yP(_);
            }
          return o;
        }
        a = f, f = a.parentNode;
      }
      return null;
    }
    function Wc(a) {
      var o = a[up] || a[w0];
      return o && (o.tag === T || o.tag === k || o.tag === P || o.tag === x) ? o : null;
    }
    function cp(a) {
      if (a.tag === T || a.tag === k)
        return a.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function wb(a) {
      return a[iw] || null;
    }
    function ow(a, o) {
      a[iw] = o;
    }
    function aY(a) {
      var o = a[aw];
      return o === void 0 && (o = a[aw] = /* @__PURE__ */ new Set()), o;
    }
    var bP = {}, SP = r.ReactDebugCurrentFrame;
    function Ab(a) {
      if (a) {
        var o = a._owner, f = Kd(a.type, a._source, o ? o.type : null);
        SP.setExtraStackFrame(f);
      } else
        SP.setExtraStackFrame(null);
    }
    function fs(a, o, f, v, _) {
      {
        var b = Function.call.bind(Pt);
        for (var E in a)
          if (b(a, E)) {
            var A = void 0;
            try {
              if (typeof a[E] != "function") {
                var R = Error((v || "React class") + ": " + f + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw R.name = "Invariant Violation", R;
              }
              A = a[E](o, E, v, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (N) {
              A = N;
            }
            A && !(A instanceof Error) && (Ab(_), l("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", f, E, typeof A), Ab(null)), A instanceof Error && !(A.message in bP) && (bP[A.message] = !0, Ab(_), l("Failed %s type: %s", f, A.message), Ab(null));
          }
      }
    }
    var sw = [], Ob;
    Ob = [];
    var Su = -1;
    function Xc(a) {
      return {
        current: a
      };
    }
    function zi(a, o) {
      if (Su < 0) {
        l("Unexpected pop.");
        return;
      }
      o !== Ob[Su] && l("Unexpected Fiber popped."), a.current = sw[Su], sw[Su] = null, Ob[Su] = null, Su--;
    }
    function Hi(a, o, f) {
      Su++, sw[Su] = a.current, Ob[Su] = f, a.current = o;
    }
    var lw;
    lw = {};
    var so = {};
    Object.freeze(so);
    var Cu = Xc(so), dl = Xc(!1), uw = so;
    function dp(a, o, f) {
      return f && fl(o) ? uw : Cu.current;
    }
    function CP(a, o, f) {
      {
        var v = a.stateNode;
        v.__reactInternalMemoizedUnmaskedChildContext = o, v.__reactInternalMemoizedMaskedChildContext = f;
      }
    }
    function fp(a, o) {
      {
        var f = a.type, v = f.contextTypes;
        if (!v)
          return so;
        var _ = a.stateNode;
        if (_ && _.__reactInternalMemoizedUnmaskedChildContext === o)
          return _.__reactInternalMemoizedMaskedChildContext;
        var b = {};
        for (var E in v)
          b[E] = o[E];
        {
          var A = kt(a) || "Unknown";
          fs(v, b, "context", A);
        }
        return _ && CP(a, o, b), b;
      }
    }
    function kb() {
      return dl.current;
    }
    function fl(a) {
      {
        var o = a.childContextTypes;
        return o != null;
      }
    }
    function Rb(a) {
      zi(dl, a), zi(Cu, a);
    }
    function cw(a) {
      zi(dl, a), zi(Cu, a);
    }
    function EP(a, o, f) {
      {
        if (Cu.current !== so)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        Hi(Cu, o, a), Hi(dl, f, a);
      }
    }
    function TP(a, o, f) {
      {
        var v = a.stateNode, _ = o.childContextTypes;
        if (typeof v.getChildContext != "function") {
          {
            var b = kt(a) || "Unknown";
            lw[b] || (lw[b] = !0, l("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", b, b));
          }
          return f;
        }
        var E = v.getChildContext();
        for (var A in E)
          if (!(A in _))
            throw new Error((kt(a) || "Unknown") + '.getChildContext(): key "' + A + '" is not defined in childContextTypes.');
        {
          var R = kt(a) || "Unknown";
          fs(_, E, "child context", R);
        }
        return Bt({}, f, E);
      }
    }
    function Db(a) {
      {
        var o = a.stateNode, f = o && o.__reactInternalMemoizedMergedChildContext || so;
        return uw = Cu.current, Hi(Cu, f, a), Hi(dl, dl.current, a), !0;
      }
    }
    function wP(a, o, f) {
      {
        var v = a.stateNode;
        if (!v)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (f) {
          var _ = TP(a, o, uw);
          v.__reactInternalMemoizedMergedChildContext = _, zi(dl, a), zi(Cu, a), Hi(Cu, _, a), Hi(dl, f, a);
        } else
          zi(dl, a), Hi(dl, f, a);
      }
    }
    function oY(a) {
      {
        if (!Dm(a) || a.tag !== p)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var o = a;
        do {
          switch (o.tag) {
            case x:
              return o.stateNode.context;
            case p: {
              var f = o.type;
              if (fl(f))
                return o.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          o = o.return;
        } while (o !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var qc = 0, Mb = 1, Eu = null, dw = !1, fw = !1;
    function AP(a) {
      Eu === null ? Eu = [a] : Eu.push(a);
    }
    function sY(a) {
      dw = !0, AP(a);
    }
    function OP() {
      dw && Kc();
    }
    function Kc() {
      if (!fw && Eu !== null) {
        fw = !0;
        var a = 0, o = Pa();
        try {
          var f = !0, v = Eu;
          for (_n(ii); a < v.length; a++) {
            var _ = v[a];
            do
              _ = _(f);
            while (_ !== null);
          }
          Eu = null, dw = !1;
        } catch (b) {
          throw Eu !== null && (Eu = Eu.slice(a + 1)), hv(pv, Kc), b;
        } finally {
          _n(o), fw = !1;
        }
      }
      return null;
    }
    var hp = [], vp = 0, Lb = null, Pb = 0, Eo = [], To = 0, Uf = null, Tu = 1, wu = "";
    function lY(a) {
      return $f(), (a.flags & Om) !== dt;
    }
    function uY(a) {
      return $f(), Pb;
    }
    function cY() {
      var a = wu, o = Tu, f = o & ~dY(o);
      return f.toString(32) + a;
    }
    function jf(a, o) {
      $f(), hp[vp++] = Pb, hp[vp++] = Lb, Lb = a, Pb = o;
    }
    function kP(a, o, f) {
      $f(), Eo[To++] = Tu, Eo[To++] = wu, Eo[To++] = Uf, Uf = a;
      var v = Tu, _ = wu, b = Ib(v) - 1, E = v & ~(1 << b), A = f + 1, R = Ib(o) + b;
      if (R > 30) {
        var N = b - b % 5, B = (1 << N) - 1, K = (E & B).toString(32), X = E >> N, ce = b - N, oe = Ib(o) + ce, ve = A << ce, Ye = ve | X, ft = K + _;
        Tu = 1 << oe | Ye, wu = ft;
      } else {
        var ot = A << b, Ht = ot | E, Gt = _;
        Tu = 1 << R | Ht, wu = Gt;
      }
    }
    function hw(a) {
      $f();
      var o = a.return;
      if (o !== null) {
        var f = 1, v = 0;
        jf(a, f), kP(a, f, v);
      }
    }
    function Ib(a) {
      return 32 - bv(a);
    }
    function dY(a) {
      return 1 << Ib(a) - 1;
    }
    function vw(a) {
      for (; a === Lb; )
        Lb = hp[--vp], hp[vp] = null, Pb = hp[--vp], hp[vp] = null;
      for (; a === Uf; )
        Uf = Eo[--To], Eo[To] = null, wu = Eo[--To], Eo[To] = null, Tu = Eo[--To], Eo[To] = null;
    }
    function fY() {
      return $f(), Uf !== null ? {
        id: Tu,
        overflow: wu
      } : null;
    }
    function hY(a, o) {
      $f(), Eo[To++] = Tu, Eo[To++] = wu, Eo[To++] = Uf, Tu = o.id, wu = o.overflow, Uf = a;
    }
    function $f() {
      yi() || l("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var _i = null, wo = null, hs = !1, Yf = !1, Zc = null;
    function vY() {
      hs && l("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function RP() {
      Yf = !0;
    }
    function pY() {
      return Yf;
    }
    function gY(a) {
      var o = a.stateNode.containerInfo;
      return wo = P6(o), _i = a, hs = !0, Zc = null, Yf = !1, !0;
    }
    function mY(a, o, f) {
      return wo = I6(o), _i = a, hs = !0, Zc = null, Yf = !1, f !== null && hY(a, f), !0;
    }
    function DP(a, o) {
      switch (a.tag) {
        case x: {
          $6(a.stateNode.containerInfo, o);
          break;
        }
        case T: {
          var f = (a.mode & Ft) !== pt;
          W6(
            a.type,
            a.memoizedProps,
            a.stateNode,
            o,
            // TODO: Delete this argument when we remove the legacy root API.
            f
          );
          break;
        }
        case P: {
          var v = a.memoizedState;
          v.dehydrated !== null && Y6(v.dehydrated, o);
          break;
        }
      }
    }
    function MP(a, o) {
      DP(a, o);
      var f = T9();
      f.stateNode = o, f.return = a;
      var v = a.deletions;
      v === null ? (a.deletions = [f], a.flags |= nr) : v.push(f);
    }
    function pw(a, o) {
      {
        if (Yf)
          return;
        switch (a.tag) {
          case x: {
            var f = a.stateNode.containerInfo;
            switch (o.tag) {
              case T:
                var v = o.type, _ = o.pendingProps;
                X6(f, v);
                break;
              case k:
                var b = o.pendingProps;
                q6(f, b);
                break;
            }
            break;
          }
          case T: {
            var E = a.type, A = a.memoizedProps, R = a.stateNode;
            switch (o.tag) {
              case T: {
                var N = o.type, B = o.pendingProps, K = (a.mode & Ft) !== pt;
                Q6(
                  E,
                  A,
                  R,
                  N,
                  B,
                  // TODO: Delete this argument when we remove the legacy root API.
                  K
                );
                break;
              }
              case k: {
                var X = o.pendingProps, ce = (a.mode & Ft) !== pt;
                J6(
                  E,
                  A,
                  R,
                  X,
                  // TODO: Delete this argument when we remove the legacy root API.
                  ce
                );
                break;
              }
            }
            break;
          }
          case P: {
            var oe = a.memoizedState, ve = oe.dehydrated;
            if (ve !== null)
              switch (o.tag) {
                case T:
                  var Ye = o.type, ft = o.pendingProps;
                  K6(ve, Ye);
                  break;
                case k:
                  var ot = o.pendingProps;
                  Z6(ve, ot);
                  break;
              }
            break;
          }
          default:
            return;
        }
      }
    }
    function LP(a, o) {
      o.flags = o.flags & ~ka | wr, pw(a, o);
    }
    function PP(a, o) {
      switch (a.tag) {
        case T: {
          var f = a.type, v = a.pendingProps, _ = O6(o, f);
          return _ !== null ? (a.stateNode = _, _i = a, wo = L6(_), !0) : !1;
        }
        case k: {
          var b = a.pendingProps, E = k6(o, b);
          return E !== null ? (a.stateNode = E, _i = a, wo = null, !0) : !1;
        }
        case P: {
          var A = R6(o);
          if (A !== null) {
            var R = {
              dehydrated: A,
              treeContext: fY(),
              retryLane: Fi
            };
            a.memoizedState = R;
            var N = w9(A);
            return N.return = a, a.child = N, _i = a, wo = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function gw(a) {
      return (a.mode & Ft) !== pt && (a.flags & St) === dt;
    }
    function mw(a) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function _w(a) {
      if (hs) {
        var o = wo;
        if (!o) {
          gw(a) && (pw(_i, a), mw()), LP(_i, a), hs = !1, _i = a;
          return;
        }
        var f = o;
        if (!PP(a, o)) {
          gw(a) && (pw(_i, a), mw()), o = T0(f);
          var v = _i;
          if (!o || !PP(a, o)) {
            LP(_i, a), hs = !1, _i = a;
            return;
          }
          MP(v, f);
        }
      }
    }
    function _Y(a, o, f) {
      var v = a.stateNode, _ = !Yf, b = N6(v, a.type, a.memoizedProps, o, f, a, _);
      return a.updateQueue = b, b !== null;
    }
    function yY(a) {
      var o = a.stateNode, f = a.memoizedProps, v = V6(o, f, a);
      if (v) {
        var _ = _i;
        if (_ !== null)
          switch (_.tag) {
            case x: {
              var b = _.stateNode.containerInfo, E = (_.mode & Ft) !== pt;
              U6(
                b,
                o,
                f,
                // TODO: Delete this argument when we remove the legacy root API.
                E
              );
              break;
            }
            case T: {
              var A = _.type, R = _.memoizedProps, N = _.stateNode, B = (_.mode & Ft) !== pt;
              j6(
                A,
                R,
                N,
                o,
                f,
                // TODO: Delete this argument when we remove the legacy root API.
                B
              );
              break;
            }
          }
      }
      return v;
    }
    function xY(a) {
      var o = a.memoizedState, f = o !== null ? o.dehydrated : null;
      if (!f)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      F6(f, a);
    }
    function bY(a) {
      var o = a.memoizedState, f = o !== null ? o.dehydrated : null;
      if (!f)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return B6(f);
    }
    function IP(a) {
      for (var o = a.return; o !== null && o.tag !== T && o.tag !== x && o.tag !== P; )
        o = o.return;
      _i = o;
    }
    function Nb(a) {
      if (a !== _i)
        return !1;
      if (!hs)
        return IP(a), hs = !0, !1;
      if (a.tag !== x && (a.tag !== T || G6(a.type) && !J1(a.type, a.memoizedProps))) {
        var o = wo;
        if (o)
          if (gw(a))
            NP(a), mw();
          else
            for (; o; )
              MP(a, o), o = T0(o);
      }
      return IP(a), a.tag === P ? wo = bY(a) : wo = _i ? T0(a.stateNode) : null, !0;
    }
    function SY() {
      return hs && wo !== null;
    }
    function NP(a) {
      for (var o = wo; o; )
        DP(a, o), o = T0(o);
    }
    function pp() {
      _i = null, wo = null, hs = !1, Yf = !1;
    }
    function VP() {
      Zc !== null && (MN(Zc), Zc = null);
    }
    function yi() {
      return hs;
    }
    function yw(a) {
      Zc === null ? Zc = [a] : Zc.push(a);
    }
    var CY = r.ReactCurrentBatchConfig, EY = null;
    function TY() {
      return CY.transition;
    }
    var vs = {
      recordUnsafeLifecycleWarnings: function(a, o) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(a, o) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var wY = function(a) {
        for (var o = null, f = a; f !== null; )
          f.mode & Hr && (o = f), f = f.return;
        return o;
      }, Wf = function(a) {
        var o = [];
        return a.forEach(function(f) {
          o.push(f);
        }), o.sort().join(", ");
      }, k0 = [], R0 = [], D0 = [], M0 = [], L0 = [], P0 = [], Xf = /* @__PURE__ */ new Set();
      vs.recordUnsafeLifecycleWarnings = function(a, o) {
        Xf.has(a.type) || (typeof o.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        o.componentWillMount.__suppressDeprecationWarning !== !0 && k0.push(a), a.mode & Hr && typeof o.UNSAFE_componentWillMount == "function" && R0.push(a), typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && D0.push(a), a.mode & Hr && typeof o.UNSAFE_componentWillReceiveProps == "function" && M0.push(a), typeof o.componentWillUpdate == "function" && o.componentWillUpdate.__suppressDeprecationWarning !== !0 && L0.push(a), a.mode & Hr && typeof o.UNSAFE_componentWillUpdate == "function" && P0.push(a));
      }, vs.flushPendingUnsafeLifecycleWarnings = function() {
        var a = /* @__PURE__ */ new Set();
        k0.length > 0 && (k0.forEach(function(X) {
          a.add(kt(X) || "Component"), Xf.add(X.type);
        }), k0 = []);
        var o = /* @__PURE__ */ new Set();
        R0.length > 0 && (R0.forEach(function(X) {
          o.add(kt(X) || "Component"), Xf.add(X.type);
        }), R0 = []);
        var f = /* @__PURE__ */ new Set();
        D0.length > 0 && (D0.forEach(function(X) {
          f.add(kt(X) || "Component"), Xf.add(X.type);
        }), D0 = []);
        var v = /* @__PURE__ */ new Set();
        M0.length > 0 && (M0.forEach(function(X) {
          v.add(kt(X) || "Component"), Xf.add(X.type);
        }), M0 = []);
        var _ = /* @__PURE__ */ new Set();
        L0.length > 0 && (L0.forEach(function(X) {
          _.add(kt(X) || "Component"), Xf.add(X.type);
        }), L0 = []);
        var b = /* @__PURE__ */ new Set();
        if (P0.length > 0 && (P0.forEach(function(X) {
          b.add(kt(X) || "Component"), Xf.add(X.type);
        }), P0 = []), o.size > 0) {
          var E = Wf(o);
          l(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, E);
        }
        if (v.size > 0) {
          var A = Wf(v);
          l(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, A);
        }
        if (b.size > 0) {
          var R = Wf(b);
          l(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, R);
        }
        if (a.size > 0) {
          var N = Wf(a);
          s(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, N);
        }
        if (f.size > 0) {
          var B = Wf(f);
          s(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, B);
        }
        if (_.size > 0) {
          var K = Wf(_);
          s(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, K);
        }
      };
      var Vb = /* @__PURE__ */ new Map(), FP = /* @__PURE__ */ new Set();
      vs.recordLegacyContextWarning = function(a, o) {
        var f = wY(a);
        if (f === null) {
          l("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!FP.has(a.type)) {
          var v = Vb.get(f);
          (a.type.contextTypes != null || a.type.childContextTypes != null || o !== null && typeof o.getChildContext == "function") && (v === void 0 && (v = [], Vb.set(f, v)), v.push(a));
        }
      }, vs.flushLegacyContextWarning = function() {
        Vb.forEach(function(a, o) {
          if (a.length !== 0) {
            var f = a[0], v = /* @__PURE__ */ new Set();
            a.forEach(function(b) {
              v.add(kt(b) || "Component"), FP.add(b.type);
            });
            var _ = Wf(v);
            try {
              hr(f), l(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, _);
            } finally {
              vn();
            }
          }
        });
      }, vs.discardPendingWarnings = function() {
        k0 = [], R0 = [], D0 = [], M0 = [], L0 = [], P0 = [], Vb = /* @__PURE__ */ new Map();
      };
    }
    function ps(a, o) {
      if (a && a.defaultProps) {
        var f = Bt({}, o), v = a.defaultProps;
        for (var _ in v)
          f[_] === void 0 && (f[_] = v[_]);
        return f;
      }
      return o;
    }
    var xw = Xc(null), bw;
    bw = {};
    var Fb = null, gp = null, Sw = null, Bb = !1;
    function zb() {
      Fb = null, gp = null, Sw = null, Bb = !1;
    }
    function BP() {
      Bb = !0;
    }
    function zP() {
      Bb = !1;
    }
    function HP(a, o, f) {
      Hi(xw, o._currentValue, a), o._currentValue = f, o._currentRenderer !== void 0 && o._currentRenderer !== null && o._currentRenderer !== bw && l("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), o._currentRenderer = bw;
    }
    function Cw(a, o) {
      var f = xw.current;
      zi(xw, o), a._currentValue = f;
    }
    function Ew(a, o, f) {
      for (var v = a; v !== null; ) {
        var _ = v.alternate;
        if (du(v.childLanes, o) ? _ !== null && !du(_.childLanes, o) && (_.childLanes = Rt(_.childLanes, o)) : (v.childLanes = Rt(v.childLanes, o), _ !== null && (_.childLanes = Rt(_.childLanes, o))), v === f)
          break;
        v = v.return;
      }
      v !== f && l("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function AY(a, o, f) {
      OY(a, o, f);
    }
    function OY(a, o, f) {
      var v = a.child;
      for (v !== null && (v.return = a); v !== null; ) {
        var _ = void 0, b = v.dependencies;
        if (b !== null) {
          _ = v.child;
          for (var E = b.firstContext; E !== null; ) {
            if (E.context === o) {
              if (v.tag === p) {
                var A = mn(f), R = Au(br, A);
                R.tag = Gb;
                var N = v.updateQueue;
                if (N !== null) {
                  var B = N.shared, K = B.pending;
                  K === null ? R.next = R : (R.next = K.next, K.next = R), B.pending = R;
                }
              }
              v.lanes = Rt(v.lanes, f);
              var X = v.alternate;
              X !== null && (X.lanes = Rt(X.lanes, f)), Ew(v.return, f, a), b.lanes = Rt(b.lanes, f);
              break;
            }
            E = E.next;
          }
        } else if (v.tag === F)
          _ = v.type === a.type ? null : v.child;
        else if (v.tag === he) {
          var ce = v.return;
          if (ce === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          ce.lanes = Rt(ce.lanes, f);
          var oe = ce.alternate;
          oe !== null && (oe.lanes = Rt(oe.lanes, f)), Ew(ce, f, a), _ = v.sibling;
        } else
          _ = v.child;
        if (_ !== null)
          _.return = v;
        else
          for (_ = v; _ !== null; ) {
            if (_ === a) {
              _ = null;
              break;
            }
            var ve = _.sibling;
            if (ve !== null) {
              ve.return = _.return, _ = ve;
              break;
            }
            _ = _.return;
          }
        v = _;
      }
    }
    function mp(a, o) {
      Fb = a, gp = null, Sw = null;
      var f = a.dependencies;
      if (f !== null) {
        var v = f.firstContext;
        v !== null && (Bi(f.lanes, o) && X0(), f.firstContext = null);
      }
    }
    function In(a) {
      Bb && l("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var o = a._currentValue;
      if (Sw !== a) {
        var f = {
          context: a,
          memoizedValue: o,
          next: null
        };
        if (gp === null) {
          if (Fb === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          gp = f, Fb.dependencies = {
            lanes: ye,
            firstContext: f
          };
        } else
          gp = gp.next = f;
      }
      return o;
    }
    var qf = null;
    function Tw(a) {
      qf === null ? qf = [a] : qf.push(a);
    }
    function kY() {
      if (qf !== null) {
        for (var a = 0; a < qf.length; a++) {
          var o = qf[a], f = o.interleaved;
          if (f !== null) {
            o.interleaved = null;
            var v = f.next, _ = o.pending;
            if (_ !== null) {
              var b = _.next;
              _.next = v, f.next = b;
            }
            o.pending = f;
          }
        }
        qf = null;
      }
    }
    function GP(a, o, f, v) {
      var _ = o.interleaved;
      return _ === null ? (f.next = f, Tw(o)) : (f.next = _.next, _.next = f), o.interleaved = f, Hb(a, v);
    }
    function RY(a, o, f, v) {
      var _ = o.interleaved;
      _ === null ? (f.next = f, Tw(o)) : (f.next = _.next, _.next = f), o.interleaved = f;
    }
    function DY(a, o, f, v) {
      var _ = o.interleaved;
      return _ === null ? (f.next = f, Tw(o)) : (f.next = _.next, _.next = f), o.interleaved = f, Hb(a, v);
    }
    function Ba(a, o) {
      return Hb(a, o);
    }
    var MY = Hb;
    function Hb(a, o) {
      a.lanes = Rt(a.lanes, o);
      var f = a.alternate;
      f !== null && (f.lanes = Rt(f.lanes, o)), f === null && (a.flags & (wr | ka)) !== dt && jN(a);
      for (var v = a, _ = a.return; _ !== null; )
        _.childLanes = Rt(_.childLanes, o), f = _.alternate, f !== null ? f.childLanes = Rt(f.childLanes, o) : (_.flags & (wr | ka)) !== dt && jN(a), v = _, _ = _.return;
      if (v.tag === x) {
        var b = v.stateNode;
        return b;
      } else
        return null;
    }
    var UP = 0, jP = 1, Gb = 2, ww = 3, Ub = !1, Aw, jb;
    Aw = !1, jb = null;
    function Ow(a) {
      var o = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: ye
        },
        effects: null
      };
      a.updateQueue = o;
    }
    function $P(a, o) {
      var f = o.updateQueue, v = a.updateQueue;
      if (f === v) {
        var _ = {
          baseState: v.baseState,
          firstBaseUpdate: v.firstBaseUpdate,
          lastBaseUpdate: v.lastBaseUpdate,
          shared: v.shared,
          effects: v.effects
        };
        o.updateQueue = _;
      }
    }
    function Au(a, o) {
      var f = {
        eventTime: a,
        lane: o,
        tag: UP,
        payload: null,
        callback: null,
        next: null
      };
      return f;
    }
    function Qc(a, o, f) {
      var v = a.updateQueue;
      if (v === null)
        return null;
      var _ = v.shared;
      if (jb === _ && !Aw && (l("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), Aw = !0), V8()) {
        var b = _.pending;
        return b === null ? o.next = o : (o.next = b.next, b.next = o), _.pending = o, MY(a, f);
      } else
        return DY(a, _, o, f);
    }
    function $b(a, o, f) {
      var v = o.updateQueue;
      if (v !== null) {
        var _ = v.shared;
        if (jm(f)) {
          var b = _.lanes;
          b = Ym(b, a.pendingLanes);
          var E = Rt(b, f);
          _.lanes = E, Mc(a, E);
        }
      }
    }
    function kw(a, o) {
      var f = a.updateQueue, v = a.alternate;
      if (v !== null) {
        var _ = v.updateQueue;
        if (f === _) {
          var b = null, E = null, A = f.firstBaseUpdate;
          if (A !== null) {
            var R = A;
            do {
              var N = {
                eventTime: R.eventTime,
                lane: R.lane,
                tag: R.tag,
                payload: R.payload,
                callback: R.callback,
                next: null
              };
              E === null ? b = E = N : (E.next = N, E = N), R = R.next;
            } while (R !== null);
            E === null ? b = E = o : (E.next = o, E = o);
          } else
            b = E = o;
          f = {
            baseState: _.baseState,
            firstBaseUpdate: b,
            lastBaseUpdate: E,
            shared: _.shared,
            effects: _.effects
          }, a.updateQueue = f;
          return;
        }
      }
      var B = f.lastBaseUpdate;
      B === null ? f.firstBaseUpdate = o : B.next = o, f.lastBaseUpdate = o;
    }
    function LY(a, o, f, v, _, b) {
      switch (f.tag) {
        case jP: {
          var E = f.payload;
          if (typeof E == "function") {
            BP();
            var A = E.call(b, v, _);
            {
              if (a.mode & Hr) {
                gn(!0);
                try {
                  E.call(b, v, _);
                } finally {
                  gn(!1);
                }
              }
              zP();
            }
            return A;
          }
          return E;
        }
        case ww:
          a.flags = a.flags & ~Dn | St;
        case UP: {
          var R = f.payload, N;
          if (typeof R == "function") {
            BP(), N = R.call(b, v, _);
            {
              if (a.mode & Hr) {
                gn(!0);
                try {
                  R.call(b, v, _);
                } finally {
                  gn(!1);
                }
              }
              zP();
            }
          } else
            N = R;
          return N == null ? v : Bt({}, v, N);
        }
        case Gb:
          return Ub = !0, v;
      }
      return v;
    }
    function Yb(a, o, f, v) {
      var _ = a.updateQueue;
      Ub = !1, jb = _.shared;
      var b = _.firstBaseUpdate, E = _.lastBaseUpdate, A = _.shared.pending;
      if (A !== null) {
        _.shared.pending = null;
        var R = A, N = R.next;
        R.next = null, E === null ? b = N : E.next = N, E = R;
        var B = a.alternate;
        if (B !== null) {
          var K = B.updateQueue, X = K.lastBaseUpdate;
          X !== E && (X === null ? K.firstBaseUpdate = N : X.next = N, K.lastBaseUpdate = R);
        }
      }
      if (b !== null) {
        var ce = _.baseState, oe = ye, ve = null, Ye = null, ft = null, ot = b;
        do {
          var Ht = ot.lane, Gt = ot.eventTime;
          if (du(v, Ht)) {
            if (ft !== null) {
              var ge = {
                eventTime: Gt,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: jt,
                tag: ot.tag,
                payload: ot.payload,
                callback: ot.callback,
                next: null
              };
              ft = ft.next = ge;
            }
            ce = LY(a, _, ot, ce, o, f);
            var ie = ot.callback;
            if (ie !== null && // If the update was already committed, we should not queue its
            // callback again.
            ot.lane !== jt) {
              a.flags |= _o;
              var Me = _.effects;
              Me === null ? _.effects = [ot] : Me.push(ot);
            }
          } else {
            var ne = {
              eventTime: Gt,
              lane: Ht,
              tag: ot.tag,
              payload: ot.payload,
              callback: ot.callback,
              next: null
            };
            ft === null ? (Ye = ft = ne, ve = ce) : ft = ft.next = ne, oe = Rt(oe, Ht);
          }
          if (ot = ot.next, ot === null) {
            if (A = _.shared.pending, A === null)
              break;
            var Ke = A, $e = Ke.next;
            Ke.next = null, ot = $e, _.lastBaseUpdate = Ke, _.shared.pending = null;
          }
        } while (!0);
        ft === null && (ve = ce), _.baseState = ve, _.firstBaseUpdate = Ye, _.lastBaseUpdate = ft;
        var xt = _.shared.interleaved;
        if (xt !== null) {
          var Ot = xt;
          do
            oe = Rt(oe, Ot.lane), Ot = Ot.next;
          while (Ot !== xt);
        } else
          b === null && (_.shared.lanes = ye);
        o_(oe), a.lanes = oe, a.memoizedState = ce;
      }
      jb = null;
    }
    function PY(a, o) {
      if (typeof a != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + a));
      a.call(o);
    }
    function YP() {
      Ub = !1;
    }
    function Wb() {
      return Ub;
    }
    function WP(a, o, f) {
      var v = o.effects;
      if (o.effects = null, v !== null)
        for (var _ = 0; _ < v.length; _++) {
          var b = v[_], E = b.callback;
          E !== null && (b.callback = null, PY(E, f));
        }
    }
    var Rw = {}, XP = new e.Component().refs, Dw, Mw, Lw, Pw, Iw, qP, Xb, Nw, Vw, Fw;
    {
      Dw = /* @__PURE__ */ new Set(), Mw = /* @__PURE__ */ new Set(), Lw = /* @__PURE__ */ new Set(), Pw = /* @__PURE__ */ new Set(), Nw = /* @__PURE__ */ new Set(), Iw = /* @__PURE__ */ new Set(), Vw = /* @__PURE__ */ new Set(), Fw = /* @__PURE__ */ new Set();
      var KP = /* @__PURE__ */ new Set();
      Xb = function(a, o) {
        if (!(a === null || typeof a == "function")) {
          var f = o + "_" + a;
          KP.has(f) || (KP.add(f), l("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", o, a));
        }
      }, qP = function(a, o) {
        if (o === void 0) {
          var f = yr(a) || "Component";
          Iw.has(f) || (Iw.add(f), l("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", f));
        }
      }, Object.defineProperty(Rw, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(Rw);
    }
    function Bw(a, o, f, v) {
      var _ = a.memoizedState, b = f(v, _);
      {
        if (a.mode & Hr) {
          gn(!0);
          try {
            b = f(v, _);
          } finally {
            gn(!1);
          }
        }
        qP(o, b);
      }
      var E = b == null ? _ : Bt({}, _, b);
      if (a.memoizedState = E, a.lanes === ye) {
        var A = a.updateQueue;
        A.baseState = E;
      }
    }
    var zw = {
      isMounted: ia,
      enqueueSetState: function(a, o, f) {
        var v = Aa(a), _ = ca(), b = od(v), E = Au(_, b);
        E.payload = o, f != null && (Xb(f, "setState"), E.callback = f);
        var A = Qc(v, E, b);
        A !== null && (qn(A, v, b, _), $b(A, v, b)), rl(v, b);
      },
      enqueueReplaceState: function(a, o, f) {
        var v = Aa(a), _ = ca(), b = od(v), E = Au(_, b);
        E.tag = jP, E.payload = o, f != null && (Xb(f, "replaceState"), E.callback = f);
        var A = Qc(v, E, b);
        A !== null && (qn(A, v, b, _), $b(A, v, b)), rl(v, b);
      },
      enqueueForceUpdate: function(a, o) {
        var f = Aa(a), v = ca(), _ = od(f), b = Au(v, _);
        b.tag = Gb, o != null && (Xb(o, "forceUpdate"), b.callback = o);
        var E = Qc(f, b, _);
        E !== null && (qn(E, f, _, v), $b(E, f, _)), zm(f, _);
      }
    };
    function ZP(a, o, f, v, _, b, E) {
      var A = a.stateNode;
      if (typeof A.shouldComponentUpdate == "function") {
        var R = A.shouldComponentUpdate(v, b, E);
        {
          if (a.mode & Hr) {
            gn(!0);
            try {
              R = A.shouldComponentUpdate(v, b, E);
            } finally {
              gn(!1);
            }
          }
          R === void 0 && l("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", yr(o) || "Component");
        }
        return R;
      }
      return o.prototype && o.prototype.isPureReactComponent ? !ut(f, v) || !ut(_, b) : !0;
    }
    function IY(a, o, f) {
      var v = a.stateNode;
      {
        var _ = yr(o) || "Component", b = v.render;
        b || (o.prototype && typeof o.prototype.render == "function" ? l("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", _) : l("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", _)), v.getInitialState && !v.getInitialState.isReactClassApproved && !v.state && l("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", _), v.getDefaultProps && !v.getDefaultProps.isReactClassApproved && l("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", _), v.propTypes && l("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", _), v.contextType && l("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", _), v.contextTypes && l("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", _), o.contextType && o.contextTypes && !Vw.has(o) && (Vw.add(o), l("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", _)), typeof v.componentShouldUpdate == "function" && l("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", _), o.prototype && o.prototype.isPureReactComponent && typeof v.shouldComponentUpdate < "u" && l("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", yr(o) || "A pure component"), typeof v.componentDidUnmount == "function" && l("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", _), typeof v.componentDidReceiveProps == "function" && l("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", _), typeof v.componentWillRecieveProps == "function" && l("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", _), typeof v.UNSAFE_componentWillRecieveProps == "function" && l("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", _);
        var E = v.props !== f;
        v.props !== void 0 && E && l("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", _, _), v.defaultProps && l("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", _, _), typeof v.getSnapshotBeforeUpdate == "function" && typeof v.componentDidUpdate != "function" && !Lw.has(o) && (Lw.add(o), l("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", yr(o))), typeof v.getDerivedStateFromProps == "function" && l("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", _), typeof v.getDerivedStateFromError == "function" && l("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", _), typeof o.getSnapshotBeforeUpdate == "function" && l("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", _);
        var A = v.state;
        A && (typeof A != "object" || kn(A)) && l("%s.state: must be set to an object or null", _), typeof v.getChildContext == "function" && typeof o.childContextTypes != "object" && l("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", _);
      }
    }
    function QP(a, o) {
      o.updater = zw, a.stateNode = o, Sc(o, a), o._reactInternalInstance = Rw;
    }
    function JP(a, o, f) {
      var v = !1, _ = so, b = so, E = o.contextType;
      if ("contextType" in o) {
        var A = (
          // Allow null for conditional declaration
          E === null || E !== void 0 && E.$$typeof === ze && E._context === void 0
        );
        if (!A && !Fw.has(o)) {
          Fw.add(o);
          var R = "";
          E === void 0 ? R = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof E != "object" ? R = " However, it is set to a " + typeof E + "." : E.$$typeof === ke ? R = " Did you accidentally pass the Context.Provider instead?" : E._context !== void 0 ? R = " Did you accidentally pass the Context.Consumer instead?" : R = " However, it is set to an object with keys {" + Object.keys(E).join(", ") + "}.", l("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", yr(o) || "Component", R);
        }
      }
      if (typeof E == "object" && E !== null)
        b = In(E);
      else {
        _ = dp(a, o, !0);
        var N = o.contextTypes;
        v = N != null, b = v ? fp(a, _) : so;
      }
      var B = new o(f, b);
      if (a.mode & Hr) {
        gn(!0);
        try {
          B = new o(f, b);
        } finally {
          gn(!1);
        }
      }
      var K = a.memoizedState = B.state !== null && B.state !== void 0 ? B.state : null;
      QP(a, B);
      {
        if (typeof o.getDerivedStateFromProps == "function" && K === null) {
          var X = yr(o) || "Component";
          Mw.has(X) || (Mw.add(X), l("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", X, B.state === null ? "null" : "undefined", X));
        }
        if (typeof o.getDerivedStateFromProps == "function" || typeof B.getSnapshotBeforeUpdate == "function") {
          var ce = null, oe = null, ve = null;
          if (typeof B.componentWillMount == "function" && B.componentWillMount.__suppressDeprecationWarning !== !0 ? ce = "componentWillMount" : typeof B.UNSAFE_componentWillMount == "function" && (ce = "UNSAFE_componentWillMount"), typeof B.componentWillReceiveProps == "function" && B.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? oe = "componentWillReceiveProps" : typeof B.UNSAFE_componentWillReceiveProps == "function" && (oe = "UNSAFE_componentWillReceiveProps"), typeof B.componentWillUpdate == "function" && B.componentWillUpdate.__suppressDeprecationWarning !== !0 ? ve = "componentWillUpdate" : typeof B.UNSAFE_componentWillUpdate == "function" && (ve = "UNSAFE_componentWillUpdate"), ce !== null || oe !== null || ve !== null) {
            var Ye = yr(o) || "Component", ft = typeof o.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            Pw.has(Ye) || (Pw.add(Ye), l(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Ye, ft, ce !== null ? `
  ` + ce : "", oe !== null ? `
  ` + oe : "", ve !== null ? `
  ` + ve : ""));
          }
        }
      }
      return v && CP(a, _, b), B;
    }
    function NY(a, o) {
      var f = o.state;
      typeof o.componentWillMount == "function" && o.componentWillMount(), typeof o.UNSAFE_componentWillMount == "function" && o.UNSAFE_componentWillMount(), f !== o.state && (l("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", kt(a) || "Component"), zw.enqueueReplaceState(o, o.state, null));
    }
    function eI(a, o, f, v) {
      var _ = o.state;
      if (typeof o.componentWillReceiveProps == "function" && o.componentWillReceiveProps(f, v), typeof o.UNSAFE_componentWillReceiveProps == "function" && o.UNSAFE_componentWillReceiveProps(f, v), o.state !== _) {
        {
          var b = kt(a) || "Component";
          Dw.has(b) || (Dw.add(b), l("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", b));
        }
        zw.enqueueReplaceState(o, o.state, null);
      }
    }
    function Hw(a, o, f, v) {
      IY(a, o, f);
      var _ = a.stateNode;
      _.props = f, _.state = a.memoizedState, _.refs = XP, Ow(a);
      var b = o.contextType;
      if (typeof b == "object" && b !== null)
        _.context = In(b);
      else {
        var E = dp(a, o, !0);
        _.context = fp(a, E);
      }
      {
        if (_.state === f) {
          var A = yr(o) || "Component";
          Nw.has(A) || (Nw.add(A), l("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", A));
        }
        a.mode & Hr && vs.recordLegacyContextWarning(a, _), vs.recordUnsafeLifecycleWarnings(a, _);
      }
      _.state = a.memoizedState;
      var R = o.getDerivedStateFromProps;
      if (typeof R == "function" && (Bw(a, o, R, f), _.state = a.memoizedState), typeof o.getDerivedStateFromProps != "function" && typeof _.getSnapshotBeforeUpdate != "function" && (typeof _.UNSAFE_componentWillMount == "function" || typeof _.componentWillMount == "function") && (NY(a, _), Yb(a, f, _, v), _.state = a.memoizedState), typeof _.componentDidMount == "function") {
        var N = Mt;
        N |= Li, (a.mode & Ma) !== pt && (N |= Pi), a.flags |= N;
      }
    }
    function VY(a, o, f, v) {
      var _ = a.stateNode, b = a.memoizedProps;
      _.props = b;
      var E = _.context, A = o.contextType, R = so;
      if (typeof A == "object" && A !== null)
        R = In(A);
      else {
        var N = dp(a, o, !0);
        R = fp(a, N);
      }
      var B = o.getDerivedStateFromProps, K = typeof B == "function" || typeof _.getSnapshotBeforeUpdate == "function";
      !K && (typeof _.UNSAFE_componentWillReceiveProps == "function" || typeof _.componentWillReceiveProps == "function") && (b !== f || E !== R) && eI(a, _, f, R), YP();
      var X = a.memoizedState, ce = _.state = X;
      if (Yb(a, f, _, v), ce = a.memoizedState, b === f && X === ce && !kb() && !Wb()) {
        if (typeof _.componentDidMount == "function") {
          var oe = Mt;
          oe |= Li, (a.mode & Ma) !== pt && (oe |= Pi), a.flags |= oe;
        }
        return !1;
      }
      typeof B == "function" && (Bw(a, o, B, f), ce = a.memoizedState);
      var ve = Wb() || ZP(a, o, b, f, X, ce, R);
      if (ve) {
        if (!K && (typeof _.UNSAFE_componentWillMount == "function" || typeof _.componentWillMount == "function") && (typeof _.componentWillMount == "function" && _.componentWillMount(), typeof _.UNSAFE_componentWillMount == "function" && _.UNSAFE_componentWillMount()), typeof _.componentDidMount == "function") {
          var Ye = Mt;
          Ye |= Li, (a.mode & Ma) !== pt && (Ye |= Pi), a.flags |= Ye;
        }
      } else {
        if (typeof _.componentDidMount == "function") {
          var ft = Mt;
          ft |= Li, (a.mode & Ma) !== pt && (ft |= Pi), a.flags |= ft;
        }
        a.memoizedProps = f, a.memoizedState = ce;
      }
      return _.props = f, _.state = ce, _.context = R, ve;
    }
    function FY(a, o, f, v, _) {
      var b = o.stateNode;
      $P(a, o);
      var E = o.memoizedProps, A = o.type === o.elementType ? E : ps(o.type, E);
      b.props = A;
      var R = o.pendingProps, N = b.context, B = f.contextType, K = so;
      if (typeof B == "object" && B !== null)
        K = In(B);
      else {
        var X = dp(o, f, !0);
        K = fp(o, X);
      }
      var ce = f.getDerivedStateFromProps, oe = typeof ce == "function" || typeof b.getSnapshotBeforeUpdate == "function";
      !oe && (typeof b.UNSAFE_componentWillReceiveProps == "function" || typeof b.componentWillReceiveProps == "function") && (E !== R || N !== K) && eI(o, b, v, K), YP();
      var ve = o.memoizedState, Ye = b.state = ve;
      if (Yb(o, v, b, _), Ye = o.memoizedState, E === R && ve === Ye && !kb() && !Wb() && !pe)
        return typeof b.componentDidUpdate == "function" && (E !== a.memoizedProps || ve !== a.memoizedState) && (o.flags |= Mt), typeof b.getSnapshotBeforeUpdate == "function" && (E !== a.memoizedProps || ve !== a.memoizedState) && (o.flags |= Oa), !1;
      typeof ce == "function" && (Bw(o, f, ce, v), Ye = o.memoizedState);
      var ft = Wb() || ZP(o, f, A, v, ve, Ye, K) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      pe;
      return ft ? (!oe && (typeof b.UNSAFE_componentWillUpdate == "function" || typeof b.componentWillUpdate == "function") && (typeof b.componentWillUpdate == "function" && b.componentWillUpdate(v, Ye, K), typeof b.UNSAFE_componentWillUpdate == "function" && b.UNSAFE_componentWillUpdate(v, Ye, K)), typeof b.componentDidUpdate == "function" && (o.flags |= Mt), typeof b.getSnapshotBeforeUpdate == "function" && (o.flags |= Oa)) : (typeof b.componentDidUpdate == "function" && (E !== a.memoizedProps || ve !== a.memoizedState) && (o.flags |= Mt), typeof b.getSnapshotBeforeUpdate == "function" && (E !== a.memoizedProps || ve !== a.memoizedState) && (o.flags |= Oa), o.memoizedProps = v, o.memoizedState = Ye), b.props = v, b.state = Ye, b.context = K, ft;
    }
    var Gw, Uw, jw, $w, Yw, tI = function(a, o) {
    };
    Gw = !1, Uw = !1, jw = {}, $w = {}, Yw = {}, tI = function(a, o) {
      if (!(a === null || typeof a != "object") && !(!a._store || a._store.validated || a.key != null)) {
        if (typeof a._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        a._store.validated = !0;
        var f = kt(o) || "Component";
        $w[f] || ($w[f] = !0, l('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function I0(a, o, f) {
      var v = f.ref;
      if (v !== null && typeof v != "function" && typeof v != "object") {
        if ((a.mode & Hr || Ie) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(f._owner && f._self && f._owner.stateNode !== f._self)) {
          var _ = kt(a) || "Component";
          jw[_] || (l('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', v), jw[_] = !0);
        }
        if (f._owner) {
          var b = f._owner, E;
          if (b) {
            var A = b;
            if (A.tag !== p)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            E = A.stateNode;
          }
          if (!E)
            throw new Error("Missing owner for string ref " + v + ". This error is likely caused by a bug in React. Please file an issue.");
          var R = E;
          Fr(v, "ref");
          var N = "" + v;
          if (o !== null && o.ref !== null && typeof o.ref == "function" && o.ref._stringRef === N)
            return o.ref;
          var B = function(K) {
            var X = R.refs;
            X === XP && (X = R.refs = {}), K === null ? delete X[N] : X[N] = K;
          };
          return B._stringRef = N, B;
        } else {
          if (typeof v != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!f._owner)
            throw new Error("Element ref was specified as a string (" + v + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return v;
    }
    function qb(a, o) {
      var f = Object.prototype.toString.call(o);
      throw new Error("Objects are not valid as a React child (found: " + (f === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : f) + "). If you meant to render a collection of children, use an array instead.");
    }
    function Kb(a) {
      {
        var o = kt(a) || "Component";
        if (Yw[o])
          return;
        Yw[o] = !0, l("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function rI(a) {
      var o = a._payload, f = a._init;
      return f(o);
    }
    function nI(a) {
      function o(ne, ge) {
        if (a) {
          var ie = ne.deletions;
          ie === null ? (ne.deletions = [ge], ne.flags |= nr) : ie.push(ge);
        }
      }
      function f(ne, ge) {
        if (!a)
          return null;
        for (var ie = ge; ie !== null; )
          o(ne, ie), ie = ie.sibling;
        return null;
      }
      function v(ne, ge) {
        for (var ie = /* @__PURE__ */ new Map(), Me = ge; Me !== null; )
          Me.key !== null ? ie.set(Me.key, Me) : ie.set(Me.index, Me), Me = Me.sibling;
        return ie;
      }
      function _(ne, ge) {
        var ie = nh(ne, ge);
        return ie.index = 0, ie.sibling = null, ie;
      }
      function b(ne, ge, ie) {
        if (ne.index = ie, !a)
          return ne.flags |= Om, ge;
        var Me = ne.alternate;
        if (Me !== null) {
          var Ke = Me.index;
          return Ke < ge ? (ne.flags |= wr, ge) : Ke;
        } else
          return ne.flags |= wr, ge;
      }
      function E(ne) {
        return a && ne.alternate === null && (ne.flags |= wr), ne;
      }
      function A(ne, ge, ie, Me) {
        if (ge === null || ge.tag !== k) {
          var Ke = xO(ie, ne.mode, Me);
          return Ke.return = ne, Ke;
        } else {
          var $e = _(ge, ie);
          return $e.return = ne, $e;
        }
      }
      function R(ne, ge, ie, Me) {
        var Ke = ie.type;
        if (Ke === Qa)
          return B(ne, ge, ie.props.children, Me, ie.key);
        if (ge !== null && (ge.elementType === Ke || // Keep this check inline so it only runs on the false path:
        XN(ge, ie) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof Ke == "object" && Ke !== null && Ke.$$typeof === gt && rI(Ke) === ge.type)) {
          var $e = _(ge, ie.props);
          return $e.ref = I0(ne, ge, ie), $e.return = ne, $e._debugSource = ie._source, $e._debugOwner = ie._owner, $e;
        }
        var xt = yO(ie, ne.mode, Me);
        return xt.ref = I0(ne, ge, ie), xt.return = ne, xt;
      }
      function N(ne, ge, ie, Me) {
        if (ge === null || ge.tag !== S || ge.stateNode.containerInfo !== ie.containerInfo || ge.stateNode.implementation !== ie.implementation) {
          var Ke = bO(ie, ne.mode, Me);
          return Ke.return = ne, Ke;
        } else {
          var $e = _(ge, ie.children || []);
          return $e.return = ne, $e;
        }
      }
      function B(ne, ge, ie, Me, Ke) {
        if (ge === null || ge.tag !== O) {
          var $e = ld(ie, ne.mode, Me, Ke);
          return $e.return = ne, $e;
        } else {
          var xt = _(ge, ie);
          return xt.return = ne, xt;
        }
      }
      function K(ne, ge, ie) {
        if (typeof ge == "string" && ge !== "" || typeof ge == "number") {
          var Me = xO("" + ge, ne.mode, ie);
          return Me.return = ne, Me;
        }
        if (typeof ge == "object" && ge !== null) {
          switch (ge.$$typeof) {
            case Bs: {
              var Ke = yO(ge, ne.mode, ie);
              return Ke.ref = I0(ne, null, ge), Ke.return = ne, Ke;
            }
            case ea: {
              var $e = bO(ge, ne.mode, ie);
              return $e.return = ne, $e;
            }
            case gt: {
              var xt = ge._payload, Ot = ge._init;
              return K(ne, Ot(xt), ie);
            }
          }
          if (kn(ge) || Xo(ge)) {
            var pr = ld(ge, ne.mode, ie, null);
            return pr.return = ne, pr;
          }
          qb(ne, ge);
        }
        return typeof ge == "function" && Kb(ne), null;
      }
      function X(ne, ge, ie, Me) {
        var Ke = ge !== null ? ge.key : null;
        if (typeof ie == "string" && ie !== "" || typeof ie == "number")
          return Ke !== null ? null : A(ne, ge, "" + ie, Me);
        if (typeof ie == "object" && ie !== null) {
          switch (ie.$$typeof) {
            case Bs:
              return ie.key === Ke ? R(ne, ge, ie, Me) : null;
            case ea:
              return ie.key === Ke ? N(ne, ge, ie, Me) : null;
            case gt: {
              var $e = ie._payload, xt = ie._init;
              return X(ne, ge, xt($e), Me);
            }
          }
          if (kn(ie) || Xo(ie))
            return Ke !== null ? null : B(ne, ge, ie, Me, null);
          qb(ne, ie);
        }
        return typeof ie == "function" && Kb(ne), null;
      }
      function ce(ne, ge, ie, Me, Ke) {
        if (typeof Me == "string" && Me !== "" || typeof Me == "number") {
          var $e = ne.get(ie) || null;
          return A(ge, $e, "" + Me, Ke);
        }
        if (typeof Me == "object" && Me !== null) {
          switch (Me.$$typeof) {
            case Bs: {
              var xt = ne.get(Me.key === null ? ie : Me.key) || null;
              return R(ge, xt, Me, Ke);
            }
            case ea: {
              var Ot = ne.get(Me.key === null ? ie : Me.key) || null;
              return N(ge, Ot, Me, Ke);
            }
            case gt:
              var pr = Me._payload, er = Me._init;
              return ce(ne, ge, ie, er(pr), Ke);
          }
          if (kn(Me) || Xo(Me)) {
            var bn = ne.get(ie) || null;
            return B(ge, bn, Me, Ke, null);
          }
          qb(ge, Me);
        }
        return typeof Me == "function" && Kb(ge), null;
      }
      function oe(ne, ge, ie) {
        {
          if (typeof ne != "object" || ne === null)
            return ge;
          switch (ne.$$typeof) {
            case Bs:
            case ea:
              tI(ne, ie);
              var Me = ne.key;
              if (typeof Me != "string")
                break;
              if (ge === null) {
                ge = /* @__PURE__ */ new Set(), ge.add(Me);
                break;
              }
              if (!ge.has(Me)) {
                ge.add(Me);
                break;
              }
              l("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", Me);
              break;
            case gt:
              var Ke = ne._payload, $e = ne._init;
              oe($e(Ke), ge, ie);
              break;
          }
        }
        return ge;
      }
      function ve(ne, ge, ie, Me) {
        for (var Ke = null, $e = 0; $e < ie.length; $e++) {
          var xt = ie[$e];
          Ke = oe(xt, Ke, ne);
        }
        for (var Ot = null, pr = null, er = ge, bn = 0, tr = 0, un = null; er !== null && tr < ie.length; tr++) {
          er.index > tr ? (un = er, er = null) : un = er.sibling;
          var Ui = X(ne, er, ie[tr], Me);
          if (Ui === null) {
            er === null && (er = un);
            break;
          }
          a && er && Ui.alternate === null && o(ne, er), bn = b(Ui, bn, tr), pr === null ? Ot = Ui : pr.sibling = Ui, pr = Ui, er = un;
        }
        if (tr === ie.length) {
          if (f(ne, er), yi()) {
            var wi = tr;
            jf(ne, wi);
          }
          return Ot;
        }
        if (er === null) {
          for (; tr < ie.length; tr++) {
            var uo = K(ne, ie[tr], Me);
            uo !== null && (bn = b(uo, bn, tr), pr === null ? Ot = uo : pr.sibling = uo, pr = uo);
          }
          if (yi()) {
            var da = tr;
            jf(ne, da);
          }
          return Ot;
        }
        for (var fa = v(ne, er); tr < ie.length; tr++) {
          var ji = ce(fa, ne, tr, ie[tr], Me);
          ji !== null && (a && ji.alternate !== null && fa.delete(ji.key === null ? tr : ji.key), bn = b(ji, bn, tr), pr === null ? Ot = ji : pr.sibling = ji, pr = ji);
        }
        if (a && fa.forEach(function(Pp) {
          return o(ne, Pp);
        }), yi()) {
          var Lu = tr;
          jf(ne, Lu);
        }
        return Ot;
      }
      function Ye(ne, ge, ie, Me) {
        var Ke = Xo(ie);
        if (typeof Ke != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          ie[Symbol.toStringTag] === "Generator" && (Uw || l("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), Uw = !0), ie.entries === Ke && (Gw || l("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Gw = !0);
          var $e = Ke.call(ie);
          if ($e)
            for (var xt = null, Ot = $e.next(); !Ot.done; Ot = $e.next()) {
              var pr = Ot.value;
              xt = oe(pr, xt, ne);
            }
        }
        var er = Ke.call(ie);
        if (er == null)
          throw new Error("An iterable object provided no iterator.");
        for (var bn = null, tr = null, un = ge, Ui = 0, wi = 0, uo = null, da = er.next(); un !== null && !da.done; wi++, da = er.next()) {
          un.index > wi ? (uo = un, un = null) : uo = un.sibling;
          var fa = X(ne, un, da.value, Me);
          if (fa === null) {
            un === null && (un = uo);
            break;
          }
          a && un && fa.alternate === null && o(ne, un), Ui = b(fa, Ui, wi), tr === null ? bn = fa : tr.sibling = fa, tr = fa, un = uo;
        }
        if (da.done) {
          if (f(ne, un), yi()) {
            var ji = wi;
            jf(ne, ji);
          }
          return bn;
        }
        if (un === null) {
          for (; !da.done; wi++, da = er.next()) {
            var Lu = K(ne, da.value, Me);
            Lu !== null && (Ui = b(Lu, Ui, wi), tr === null ? bn = Lu : tr.sibling = Lu, tr = Lu);
          }
          if (yi()) {
            var Pp = wi;
            jf(ne, Pp);
          }
          return bn;
        }
        for (var d_ = v(ne, un); !da.done; wi++, da = er.next()) {
          var xl = ce(d_, ne, wi, da.value, Me);
          xl !== null && (a && xl.alternate !== null && d_.delete(xl.key === null ? wi : xl.key), Ui = b(xl, Ui, wi), tr === null ? bn = xl : tr.sibling = xl, tr = xl);
        }
        if (a && d_.forEach(function(n7) {
          return o(ne, n7);
        }), yi()) {
          var r7 = wi;
          jf(ne, r7);
        }
        return bn;
      }
      function ft(ne, ge, ie, Me) {
        if (ge !== null && ge.tag === k) {
          f(ne, ge.sibling);
          var Ke = _(ge, ie);
          return Ke.return = ne, Ke;
        }
        f(ne, ge);
        var $e = xO(ie, ne.mode, Me);
        return $e.return = ne, $e;
      }
      function ot(ne, ge, ie, Me) {
        for (var Ke = ie.key, $e = ge; $e !== null; ) {
          if ($e.key === Ke) {
            var xt = ie.type;
            if (xt === Qa) {
              if ($e.tag === O) {
                f(ne, $e.sibling);
                var Ot = _($e, ie.props.children);
                return Ot.return = ne, Ot._debugSource = ie._source, Ot._debugOwner = ie._owner, Ot;
              }
            } else if ($e.elementType === xt || // Keep this check inline so it only runs on the false path:
            XN($e, ie) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof xt == "object" && xt !== null && xt.$$typeof === gt && rI(xt) === $e.type) {
              f(ne, $e.sibling);
              var pr = _($e, ie.props);
              return pr.ref = I0(ne, $e, ie), pr.return = ne, pr._debugSource = ie._source, pr._debugOwner = ie._owner, pr;
            }
            f(ne, $e);
            break;
          } else
            o(ne, $e);
          $e = $e.sibling;
        }
        if (ie.type === Qa) {
          var er = ld(ie.props.children, ne.mode, Me, ie.key);
          return er.return = ne, er;
        } else {
          var bn = yO(ie, ne.mode, Me);
          return bn.ref = I0(ne, ge, ie), bn.return = ne, bn;
        }
      }
      function Ht(ne, ge, ie, Me) {
        for (var Ke = ie.key, $e = ge; $e !== null; ) {
          if ($e.key === Ke)
            if ($e.tag === S && $e.stateNode.containerInfo === ie.containerInfo && $e.stateNode.implementation === ie.implementation) {
              f(ne, $e.sibling);
              var xt = _($e, ie.children || []);
              return xt.return = ne, xt;
            } else {
              f(ne, $e);
              break;
            }
          else
            o(ne, $e);
          $e = $e.sibling;
        }
        var Ot = bO(ie, ne.mode, Me);
        return Ot.return = ne, Ot;
      }
      function Gt(ne, ge, ie, Me) {
        var Ke = typeof ie == "object" && ie !== null && ie.type === Qa && ie.key === null;
        if (Ke && (ie = ie.props.children), typeof ie == "object" && ie !== null) {
          switch (ie.$$typeof) {
            case Bs:
              return E(ot(ne, ge, ie, Me));
            case ea:
              return E(Ht(ne, ge, ie, Me));
            case gt:
              var $e = ie._payload, xt = ie._init;
              return Gt(ne, ge, xt($e), Me);
          }
          if (kn(ie))
            return ve(ne, ge, ie, Me);
          if (Xo(ie))
            return Ye(ne, ge, ie, Me);
          qb(ne, ie);
        }
        return typeof ie == "string" && ie !== "" || typeof ie == "number" ? E(ft(ne, ge, "" + ie, Me)) : (typeof ie == "function" && Kb(ne), f(ne, ge));
      }
      return Gt;
    }
    var _p = nI(!0), iI = nI(!1);
    function BY(a, o) {
      if (a !== null && o.child !== a.child)
        throw new Error("Resuming work not yet implemented.");
      if (o.child !== null) {
        var f = o.child, v = nh(f, f.pendingProps);
        for (o.child = v, v.return = o; f.sibling !== null; )
          f = f.sibling, v = v.sibling = nh(f, f.pendingProps), v.return = o;
        v.sibling = null;
      }
    }
    function zY(a, o) {
      for (var f = a.child; f !== null; )
        x9(f, o), f = f.sibling;
    }
    var N0 = {}, Jc = Xc(N0), V0 = Xc(N0), Zb = Xc(N0);
    function Qb(a) {
      if (a === N0)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return a;
    }
    function aI() {
      var a = Qb(Zb.current);
      return a;
    }
    function Ww(a, o) {
      Hi(Zb, o, a), Hi(V0, a, a), Hi(Jc, N0, a);
      var f = e6(o);
      zi(Jc, a), Hi(Jc, f, a);
    }
    function yp(a) {
      zi(Jc, a), zi(V0, a), zi(Zb, a);
    }
    function Xw() {
      var a = Qb(Jc.current);
      return a;
    }
    function oI(a) {
      var o = Qb(Zb.current), f = Qb(Jc.current), v = t6(f, a.type);
      f !== v && (Hi(V0, a, a), Hi(Jc, v, a));
    }
    function qw(a) {
      V0.current === a && (zi(Jc, a), zi(V0, a));
    }
    var HY = 0, sI = 1, lI = 1, F0 = 2, gs = Xc(HY);
    function Kw(a, o) {
      return (a & o) !== 0;
    }
    function xp(a) {
      return a & sI;
    }
    function Zw(a, o) {
      return a & sI | o;
    }
    function GY(a, o) {
      return a | o;
    }
    function ed(a, o) {
      Hi(gs, o, a);
    }
    function bp(a) {
      zi(gs, a);
    }
    function UY(a, o) {
      var f = a.memoizedState;
      if (f !== null)
        return f.dehydrated !== null;
      var v = a.memoizedProps;
      return !0;
    }
    function Jb(a) {
      for (var o = a; o !== null; ) {
        if (o.tag === P) {
          var f = o.memoizedState;
          if (f !== null) {
            var v = f.dehydrated;
            if (v === null || _P(v) || nw(v))
              return o;
          }
        } else if (o.tag === de && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        o.memoizedProps.revealOrder !== void 0) {
          var _ = (o.flags & St) !== dt;
          if (_)
            return o;
        } else if (o.child !== null) {
          o.child.return = o, o = o.child;
          continue;
        }
        if (o === a)
          return null;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === a)
            return null;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
      return null;
    }
    var za = (
      /*   */
      0
    ), Gn = (
      /* */
      1
    ), hl = (
      /*  */
      2
    ), Un = (
      /*    */
      4
    ), xi = (
      /*   */
      8
    ), Qw = [];
    function Jw() {
      for (var a = 0; a < Qw.length; a++) {
        var o = Qw[a];
        o._workInProgressVersionPrimary = null;
      }
      Qw.length = 0;
    }
    function jY(a, o) {
      var f = o._getVersion, v = f(o._source);
      a.mutableSourceEagerHydrationData == null ? a.mutableSourceEagerHydrationData = [o, v] : a.mutableSourceEagerHydrationData.push(o, v);
    }
    var qe = r.ReactCurrentDispatcher, B0 = r.ReactCurrentBatchConfig, eA, Sp;
    eA = /* @__PURE__ */ new Set();
    var Kf = ye, vr = null, jn = null, $n = null, eS = !1, z0 = !1, H0 = 0, $Y = 0, YY = 25, Se = null, Ao = null, td = -1, tA = !1;
    function or() {
      {
        var a = Se;
        Ao === null ? Ao = [a] : Ao.push(a);
      }
    }
    function Be() {
      {
        var a = Se;
        Ao !== null && (td++, Ao[td] !== a && WY(a));
      }
    }
    function Cp(a) {
      a != null && !kn(a) && l("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", Se, typeof a);
    }
    function WY(a) {
      {
        var o = kt(vr);
        if (!eA.has(o) && (eA.add(o), Ao !== null)) {
          for (var f = "", v = 30, _ = 0; _ <= td; _++) {
            for (var b = Ao[_], E = _ === td ? a : b, A = _ + 1 + ". " + b; A.length < v; )
              A += " ";
            A += E + `
`, f += A;
          }
          l(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, o, f);
        }
      }
    }
    function Gi() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function rA(a, o) {
      if (tA)
        return !1;
      if (o === null)
        return l("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", Se), !1;
      a.length !== o.length && l(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, Se, "[" + o.join(", ") + "]", "[" + a.join(", ") + "]");
      for (var f = 0; f < o.length && f < a.length; f++)
        if (!rt(a[f], o[f]))
          return !1;
      return !0;
    }
    function Ep(a, o, f, v, _, b) {
      Kf = b, vr = o, Ao = a !== null ? a._debugHookTypes : null, td = -1, tA = a !== null && a.type !== o.type, o.memoizedState = null, o.updateQueue = null, o.lanes = ye, a !== null && a.memoizedState !== null ? qe.current = RI : Ao !== null ? qe.current = kI : qe.current = OI;
      var E = f(v, _);
      if (z0) {
        var A = 0;
        do {
          if (z0 = !1, H0 = 0, A >= YY)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          A += 1, tA = !1, jn = null, $n = null, o.updateQueue = null, td = -1, qe.current = DI, E = f(v, _);
        } while (z0);
      }
      qe.current = hS, o._debugHookTypes = Ao;
      var R = jn !== null && jn.next !== null;
      if (Kf = ye, vr = null, jn = null, $n = null, Se = null, Ao = null, td = -1, a !== null && (a.flags & Bn) !== (o.flags & Bn) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (a.mode & Ft) !== pt && l("Internal React error: Expected static flag was missing. Please notify the React team."), eS = !1, R)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return E;
    }
    function Tp() {
      var a = H0 !== 0;
      return H0 = 0, a;
    }
    function uI(a, o, f) {
      o.updateQueue = a.updateQueue, (o.mode & Ma) !== pt ? o.flags &= ~(tu | Pi | Pr | Mt) : o.flags &= ~(Pr | Mt), a.lanes = Dc(a.lanes, f);
    }
    function cI() {
      if (qe.current = hS, eS) {
        for (var a = vr.memoizedState; a !== null; ) {
          var o = a.queue;
          o !== null && (o.pending = null), a = a.next;
        }
        eS = !1;
      }
      Kf = ye, vr = null, jn = null, $n = null, Ao = null, td = -1, Se = null, CI = !1, z0 = !1, H0 = 0;
    }
    function vl() {
      var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return $n === null ? vr.memoizedState = $n = a : $n = $n.next = a, $n;
    }
    function Oo() {
      var a;
      if (jn === null) {
        var o = vr.alternate;
        o !== null ? a = o.memoizedState : a = null;
      } else
        a = jn.next;
      var f;
      if ($n === null ? f = vr.memoizedState : f = $n.next, f !== null)
        $n = f, f = $n.next, jn = a;
      else {
        if (a === null)
          throw new Error("Rendered more hooks than during the previous render.");
        jn = a;
        var v = {
          memoizedState: jn.memoizedState,
          baseState: jn.baseState,
          baseQueue: jn.baseQueue,
          queue: jn.queue,
          next: null
        };
        $n === null ? vr.memoizedState = $n = v : $n = $n.next = v;
      }
      return $n;
    }
    function dI() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function nA(a, o) {
      return typeof o == "function" ? o(a) : o;
    }
    function iA(a, o, f) {
      var v = vl(), _;
      f !== void 0 ? _ = f(o) : _ = o, v.memoizedState = v.baseState = _;
      var b = {
        pending: null,
        interleaved: null,
        lanes: ye,
        dispatch: null,
        lastRenderedReducer: a,
        lastRenderedState: _
      };
      v.queue = b;
      var E = b.dispatch = ZY.bind(null, vr, b);
      return [v.memoizedState, E];
    }
    function aA(a, o, f) {
      var v = Oo(), _ = v.queue;
      if (_ === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      _.lastRenderedReducer = a;
      var b = jn, E = b.baseQueue, A = _.pending;
      if (A !== null) {
        if (E !== null) {
          var R = E.next, N = A.next;
          E.next = N, A.next = R;
        }
        b.baseQueue !== E && l("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), b.baseQueue = E = A, _.pending = null;
      }
      if (E !== null) {
        var B = E.next, K = b.baseState, X = null, ce = null, oe = null, ve = B;
        do {
          var Ye = ve.lane;
          if (du(Kf, Ye)) {
            if (oe !== null) {
              var ot = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: jt,
                action: ve.action,
                hasEagerState: ve.hasEagerState,
                eagerState: ve.eagerState,
                next: null
              };
              oe = oe.next = ot;
            }
            if (ve.hasEagerState)
              K = ve.eagerState;
            else {
              var Ht = ve.action;
              K = a(K, Ht);
            }
          } else {
            var ft = {
              lane: Ye,
              action: ve.action,
              hasEagerState: ve.hasEagerState,
              eagerState: ve.eagerState,
              next: null
            };
            oe === null ? (ce = oe = ft, X = K) : oe = oe.next = ft, vr.lanes = Rt(vr.lanes, Ye), o_(Ye);
          }
          ve = ve.next;
        } while (ve !== null && ve !== B);
        oe === null ? X = K : oe.next = ce, rt(K, v.memoizedState) || X0(), v.memoizedState = K, v.baseState = X, v.baseQueue = oe, _.lastRenderedState = K;
      }
      var Gt = _.interleaved;
      if (Gt !== null) {
        var ne = Gt;
        do {
          var ge = ne.lane;
          vr.lanes = Rt(vr.lanes, ge), o_(ge), ne = ne.next;
        } while (ne !== Gt);
      } else
        E === null && (_.lanes = ye);
      var ie = _.dispatch;
      return [v.memoizedState, ie];
    }
    function oA(a, o, f) {
      var v = Oo(), _ = v.queue;
      if (_ === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      _.lastRenderedReducer = a;
      var b = _.dispatch, E = _.pending, A = v.memoizedState;
      if (E !== null) {
        _.pending = null;
        var R = E.next, N = R;
        do {
          var B = N.action;
          A = a(A, B), N = N.next;
        } while (N !== R);
        rt(A, v.memoizedState) || X0(), v.memoizedState = A, v.baseQueue === null && (v.baseState = A), _.lastRenderedState = A;
      }
      return [A, b];
    }
    function tve(a, o, f) {
    }
    function rve(a, o, f) {
    }
    function sA(a, o, f) {
      var v = vr, _ = vl(), b, E = yi();
      if (E) {
        if (f === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        b = f(), Sp || b !== f() && (l("The result of getServerSnapshot should be cached to avoid an infinite loop"), Sp = !0);
      } else {
        if (b = o(), !Sp) {
          var A = o();
          rt(b, A) || (l("The result of getSnapshot should be cached to avoid an infinite loop"), Sp = !0);
        }
        var R = DS();
        if (R === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Af(R, Kf) || fI(v, o, b);
      }
      _.memoizedState = b;
      var N = {
        value: b,
        getSnapshot: o
      };
      return _.queue = N, aS(vI.bind(null, v, N, a), [a]), v.flags |= Pr, G0(Gn | xi, hI.bind(null, v, N, b, o), void 0, null), b;
    }
    function tS(a, o, f) {
      var v = vr, _ = Oo(), b = o();
      if (!Sp) {
        var E = o();
        rt(b, E) || (l("The result of getSnapshot should be cached to avoid an infinite loop"), Sp = !0);
      }
      var A = _.memoizedState, R = !rt(A, b);
      R && (_.memoizedState = b, X0());
      var N = _.queue;
      if (j0(vI.bind(null, v, N, a), [a]), N.getSnapshot !== o || R || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      $n !== null && $n.memoizedState.tag & Gn) {
        v.flags |= Pr, G0(Gn | xi, hI.bind(null, v, N, b, o), void 0, null);
        var B = DS();
        if (B === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        Af(B, Kf) || fI(v, o, b);
      }
      return b;
    }
    function fI(a, o, f) {
      a.flags |= _f;
      var v = {
        getSnapshot: o,
        value: f
      }, _ = vr.updateQueue;
      if (_ === null)
        _ = dI(), vr.updateQueue = _, _.stores = [v];
      else {
        var b = _.stores;
        b === null ? _.stores = [v] : b.push(v);
      }
    }
    function hI(a, o, f, v) {
      o.value = f, o.getSnapshot = v, pI(o) && gI(a);
    }
    function vI(a, o, f) {
      var v = function() {
        pI(o) && gI(a);
      };
      return f(v);
    }
    function pI(a) {
      var o = a.getSnapshot, f = a.value;
      try {
        var v = o();
        return !rt(f, v);
      } catch {
        return !0;
      }
    }
    function gI(a) {
      var o = Ba(a, yt);
      o !== null && qn(o, a, yt, br);
    }
    function rS(a) {
      var o = vl();
      typeof a == "function" && (a = a()), o.memoizedState = o.baseState = a;
      var f = {
        pending: null,
        interleaved: null,
        lanes: ye,
        dispatch: null,
        lastRenderedReducer: nA,
        lastRenderedState: a
      };
      o.queue = f;
      var v = f.dispatch = QY.bind(null, vr, f);
      return [o.memoizedState, v];
    }
    function lA(a) {
      return aA(nA);
    }
    function uA(a) {
      return oA(nA);
    }
    function G0(a, o, f, v) {
      var _ = {
        tag: a,
        create: o,
        destroy: f,
        deps: v,
        // Circular
        next: null
      }, b = vr.updateQueue;
      if (b === null)
        b = dI(), vr.updateQueue = b, b.lastEffect = _.next = _;
      else {
        var E = b.lastEffect;
        if (E === null)
          b.lastEffect = _.next = _;
        else {
          var A = E.next;
          E.next = _, _.next = A, b.lastEffect = _;
        }
      }
      return _;
    }
    function cA(a) {
      var o = vl();
      {
        var f = {
          current: a
        };
        return o.memoizedState = f, f;
      }
    }
    function nS(a) {
      var o = Oo();
      return o.memoizedState;
    }
    function U0(a, o, f, v) {
      var _ = vl(), b = v === void 0 ? null : v;
      vr.flags |= a, _.memoizedState = G0(Gn | o, f, void 0, b);
    }
    function iS(a, o, f, v) {
      var _ = Oo(), b = v === void 0 ? null : v, E = void 0;
      if (jn !== null) {
        var A = jn.memoizedState;
        if (E = A.destroy, b !== null) {
          var R = A.deps;
          if (rA(b, R)) {
            _.memoizedState = G0(o, f, E, b);
            return;
          }
        }
      }
      vr.flags |= a, _.memoizedState = G0(Gn | o, f, E, b);
    }
    function aS(a, o) {
      return (vr.mode & Ma) !== pt ? U0(tu | Pr | Zs, xi, a, o) : U0(Pr | Zs, xi, a, o);
    }
    function j0(a, o) {
      return iS(Pr, xi, a, o);
    }
    function dA(a, o) {
      return U0(Mt, hl, a, o);
    }
    function oS(a, o) {
      return iS(Mt, hl, a, o);
    }
    function fA(a, o) {
      var f = Mt;
      return f |= Li, (vr.mode & Ma) !== pt && (f |= Pi), U0(f, Un, a, o);
    }
    function sS(a, o) {
      return iS(Mt, Un, a, o);
    }
    function mI(a, o) {
      if (typeof o == "function") {
        var f = o, v = a();
        return f(v), function() {
          f(null);
        };
      } else if (o != null) {
        var _ = o;
        _.hasOwnProperty("current") || l("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(_).join(", ") + "}");
        var b = a();
        return _.current = b, function() {
          _.current = null;
        };
      }
    }
    function hA(a, o, f) {
      typeof o != "function" && l("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", o !== null ? typeof o : "null");
      var v = f != null ? f.concat([a]) : null, _ = Mt;
      return _ |= Li, (vr.mode & Ma) !== pt && (_ |= Pi), U0(_, Un, mI.bind(null, o, a), v);
    }
    function lS(a, o, f) {
      typeof o != "function" && l("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", o !== null ? typeof o : "null");
      var v = f != null ? f.concat([a]) : null;
      return iS(Mt, Un, mI.bind(null, o, a), v);
    }
    function XY(a, o) {
    }
    var uS = XY;
    function vA(a, o) {
      var f = vl(), v = o === void 0 ? null : o;
      return f.memoizedState = [a, v], a;
    }
    function cS(a, o) {
      var f = Oo(), v = o === void 0 ? null : o, _ = f.memoizedState;
      if (_ !== null && v !== null) {
        var b = _[1];
        if (rA(v, b))
          return _[0];
      }
      return f.memoizedState = [a, v], a;
    }
    function pA(a, o) {
      var f = vl(), v = o === void 0 ? null : o, _ = a();
      return f.memoizedState = [_, v], _;
    }
    function dS(a, o) {
      var f = Oo(), v = o === void 0 ? null : o, _ = f.memoizedState;
      if (_ !== null && v !== null) {
        var b = _[1];
        if (rA(v, b))
          return _[0];
      }
      var E = a();
      return f.memoizedState = [E, v], E;
    }
    function gA(a) {
      var o = vl();
      return o.memoizedState = a, a;
    }
    function _I(a) {
      var o = Oo(), f = jn, v = f.memoizedState;
      return xI(o, v, a);
    }
    function yI(a) {
      var o = Oo();
      if (jn === null)
        return o.memoizedState = a, a;
      var f = jn.memoizedState;
      return xI(o, f, a);
    }
    function xI(a, o, f) {
      var v = !S1(Kf);
      if (v) {
        if (!rt(f, o)) {
          var _ = $m();
          vr.lanes = Rt(vr.lanes, _), o_(_), a.baseState = !0;
        }
        return o;
      } else
        return a.baseState && (a.baseState = !1, X0()), a.memoizedState = f, f;
    }
    function qY(a, o, f) {
      var v = Pa();
      _n(ai(v, Hn)), a(!0);
      var _ = B0.transition;
      B0.transition = {};
      var b = B0.transition;
      B0.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        a(!1), o();
      } finally {
        if (_n(v), B0.transition = _, _ === null && b._updatedFibers) {
          var E = b._updatedFibers.size;
          E > 10 && s("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), b._updatedFibers.clear();
        }
      }
    }
    function mA() {
      var a = rS(!1), o = a[0], f = a[1], v = qY.bind(null, f), _ = vl();
      return _.memoizedState = v, [o, v];
    }
    function bI() {
      var a = lA(), o = a[0], f = Oo(), v = f.memoizedState;
      return [o, v];
    }
    function SI() {
      var a = uA(), o = a[0], f = Oo(), v = f.memoizedState;
      return [o, v];
    }
    var CI = !1;
    function KY() {
      return CI;
    }
    function _A() {
      var a = vl(), o = DS(), f = o.identifierPrefix, v;
      if (yi()) {
        var _ = cY();
        v = ":" + f + "R" + _;
        var b = H0++;
        b > 0 && (v += "H" + b.toString(32)), v += ":";
      } else {
        var E = $Y++;
        v = ":" + f + "r" + E.toString(32) + ":";
      }
      return a.memoizedState = v, v;
    }
    function fS() {
      var a = Oo(), o = a.memoizedState;
      return o;
    }
    function ZY(a, o, f) {
      typeof arguments[3] == "function" && l("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var v = od(a), _ = {
        lane: v,
        action: f,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (EI(a))
        TI(o, _);
      else {
        var b = GP(a, o, _, v);
        if (b !== null) {
          var E = ca();
          qn(b, a, v, E), wI(b, o, v);
        }
      }
      AI(a, v);
    }
    function QY(a, o, f) {
      typeof arguments[3] == "function" && l("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var v = od(a), _ = {
        lane: v,
        action: f,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (EI(a))
        TI(o, _);
      else {
        var b = a.alternate;
        if (a.lanes === ye && (b === null || b.lanes === ye)) {
          var E = o.lastRenderedReducer;
          if (E !== null) {
            var A;
            A = qe.current, qe.current = ms;
            try {
              var R = o.lastRenderedState, N = E(R, f);
              if (_.hasEagerState = !0, _.eagerState = N, rt(N, R)) {
                RY(a, o, _, v);
                return;
              }
            } catch {
            } finally {
              qe.current = A;
            }
          }
        }
        var B = GP(a, o, _, v);
        if (B !== null) {
          var K = ca();
          qn(B, a, v, K), wI(B, o, v);
        }
      }
      AI(a, v);
    }
    function EI(a) {
      var o = a.alternate;
      return a === vr || o !== null && o === vr;
    }
    function TI(a, o) {
      z0 = eS = !0;
      var f = a.pending;
      f === null ? o.next = o : (o.next = f.next, f.next = o), a.pending = o;
    }
    function wI(a, o, f) {
      if (jm(f)) {
        var v = o.lanes;
        v = Ym(v, a.pendingLanes);
        var _ = Rt(v, f);
        o.lanes = _, Mc(a, _);
      }
    }
    function AI(a, o, f) {
      rl(a, o);
    }
    var hS = {
      readContext: In,
      useCallback: Gi,
      useContext: Gi,
      useEffect: Gi,
      useImperativeHandle: Gi,
      useInsertionEffect: Gi,
      useLayoutEffect: Gi,
      useMemo: Gi,
      useReducer: Gi,
      useRef: Gi,
      useState: Gi,
      useDebugValue: Gi,
      useDeferredValue: Gi,
      useTransition: Gi,
      useMutableSource: Gi,
      useSyncExternalStore: Gi,
      useId: Gi,
      unstable_isNewReconciler: Q
    }, OI = null, kI = null, RI = null, DI = null, pl = null, ms = null, vS = null;
    {
      var yA = function() {
        l("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, Tt = function() {
        l("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      OI = {
        readContext: function(a) {
          return In(a);
        },
        useCallback: function(a, o) {
          return Se = "useCallback", or(), Cp(o), vA(a, o);
        },
        useContext: function(a) {
          return Se = "useContext", or(), In(a);
        },
        useEffect: function(a, o) {
          return Se = "useEffect", or(), Cp(o), aS(a, o);
        },
        useImperativeHandle: function(a, o, f) {
          return Se = "useImperativeHandle", or(), Cp(f), hA(a, o, f);
        },
        useInsertionEffect: function(a, o) {
          return Se = "useInsertionEffect", or(), Cp(o), dA(a, o);
        },
        useLayoutEffect: function(a, o) {
          return Se = "useLayoutEffect", or(), Cp(o), fA(a, o);
        },
        useMemo: function(a, o) {
          Se = "useMemo", or(), Cp(o);
          var f = qe.current;
          qe.current = pl;
          try {
            return pA(a, o);
          } finally {
            qe.current = f;
          }
        },
        useReducer: function(a, o, f) {
          Se = "useReducer", or();
          var v = qe.current;
          qe.current = pl;
          try {
            return iA(a, o, f);
          } finally {
            qe.current = v;
          }
        },
        useRef: function(a) {
          return Se = "useRef", or(), cA(a);
        },
        useState: function(a) {
          Se = "useState", or();
          var o = qe.current;
          qe.current = pl;
          try {
            return rS(a);
          } finally {
            qe.current = o;
          }
        },
        useDebugValue: function(a, o) {
          return Se = "useDebugValue", or(), void 0;
        },
        useDeferredValue: function(a) {
          return Se = "useDeferredValue", or(), gA(a);
        },
        useTransition: function() {
          return Se = "useTransition", or(), mA();
        },
        useMutableSource: function(a, o, f) {
          return Se = "useMutableSource", or(), void 0;
        },
        useSyncExternalStore: function(a, o, f) {
          return Se = "useSyncExternalStore", or(), sA(a, o, f);
        },
        useId: function() {
          return Se = "useId", or(), _A();
        },
        unstable_isNewReconciler: Q
      }, kI = {
        readContext: function(a) {
          return In(a);
        },
        useCallback: function(a, o) {
          return Se = "useCallback", Be(), vA(a, o);
        },
        useContext: function(a) {
          return Se = "useContext", Be(), In(a);
        },
        useEffect: function(a, o) {
          return Se = "useEffect", Be(), aS(a, o);
        },
        useImperativeHandle: function(a, o, f) {
          return Se = "useImperativeHandle", Be(), hA(a, o, f);
        },
        useInsertionEffect: function(a, o) {
          return Se = "useInsertionEffect", Be(), dA(a, o);
        },
        useLayoutEffect: function(a, o) {
          return Se = "useLayoutEffect", Be(), fA(a, o);
        },
        useMemo: function(a, o) {
          Se = "useMemo", Be();
          var f = qe.current;
          qe.current = pl;
          try {
            return pA(a, o);
          } finally {
            qe.current = f;
          }
        },
        useReducer: function(a, o, f) {
          Se = "useReducer", Be();
          var v = qe.current;
          qe.current = pl;
          try {
            return iA(a, o, f);
          } finally {
            qe.current = v;
          }
        },
        useRef: function(a) {
          return Se = "useRef", Be(), cA(a);
        },
        useState: function(a) {
          Se = "useState", Be();
          var o = qe.current;
          qe.current = pl;
          try {
            return rS(a);
          } finally {
            qe.current = o;
          }
        },
        useDebugValue: function(a, o) {
          return Se = "useDebugValue", Be(), void 0;
        },
        useDeferredValue: function(a) {
          return Se = "useDeferredValue", Be(), gA(a);
        },
        useTransition: function() {
          return Se = "useTransition", Be(), mA();
        },
        useMutableSource: function(a, o, f) {
          return Se = "useMutableSource", Be(), void 0;
        },
        useSyncExternalStore: function(a, o, f) {
          return Se = "useSyncExternalStore", Be(), sA(a, o, f);
        },
        useId: function() {
          return Se = "useId", Be(), _A();
        },
        unstable_isNewReconciler: Q
      }, RI = {
        readContext: function(a) {
          return In(a);
        },
        useCallback: function(a, o) {
          return Se = "useCallback", Be(), cS(a, o);
        },
        useContext: function(a) {
          return Se = "useContext", Be(), In(a);
        },
        useEffect: function(a, o) {
          return Se = "useEffect", Be(), j0(a, o);
        },
        useImperativeHandle: function(a, o, f) {
          return Se = "useImperativeHandle", Be(), lS(a, o, f);
        },
        useInsertionEffect: function(a, o) {
          return Se = "useInsertionEffect", Be(), oS(a, o);
        },
        useLayoutEffect: function(a, o) {
          return Se = "useLayoutEffect", Be(), sS(a, o);
        },
        useMemo: function(a, o) {
          Se = "useMemo", Be();
          var f = qe.current;
          qe.current = ms;
          try {
            return dS(a, o);
          } finally {
            qe.current = f;
          }
        },
        useReducer: function(a, o, f) {
          Se = "useReducer", Be();
          var v = qe.current;
          qe.current = ms;
          try {
            return aA(a, o, f);
          } finally {
            qe.current = v;
          }
        },
        useRef: function(a) {
          return Se = "useRef", Be(), nS();
        },
        useState: function(a) {
          Se = "useState", Be();
          var o = qe.current;
          qe.current = ms;
          try {
            return lA(a);
          } finally {
            qe.current = o;
          }
        },
        useDebugValue: function(a, o) {
          return Se = "useDebugValue", Be(), uS();
        },
        useDeferredValue: function(a) {
          return Se = "useDeferredValue", Be(), _I(a);
        },
        useTransition: function() {
          return Se = "useTransition", Be(), bI();
        },
        useMutableSource: function(a, o, f) {
          return Se = "useMutableSource", Be(), void 0;
        },
        useSyncExternalStore: function(a, o, f) {
          return Se = "useSyncExternalStore", Be(), tS(a, o);
        },
        useId: function() {
          return Se = "useId", Be(), fS();
        },
        unstable_isNewReconciler: Q
      }, DI = {
        readContext: function(a) {
          return In(a);
        },
        useCallback: function(a, o) {
          return Se = "useCallback", Be(), cS(a, o);
        },
        useContext: function(a) {
          return Se = "useContext", Be(), In(a);
        },
        useEffect: function(a, o) {
          return Se = "useEffect", Be(), j0(a, o);
        },
        useImperativeHandle: function(a, o, f) {
          return Se = "useImperativeHandle", Be(), lS(a, o, f);
        },
        useInsertionEffect: function(a, o) {
          return Se = "useInsertionEffect", Be(), oS(a, o);
        },
        useLayoutEffect: function(a, o) {
          return Se = "useLayoutEffect", Be(), sS(a, o);
        },
        useMemo: function(a, o) {
          Se = "useMemo", Be();
          var f = qe.current;
          qe.current = vS;
          try {
            return dS(a, o);
          } finally {
            qe.current = f;
          }
        },
        useReducer: function(a, o, f) {
          Se = "useReducer", Be();
          var v = qe.current;
          qe.current = vS;
          try {
            return oA(a, o, f);
          } finally {
            qe.current = v;
          }
        },
        useRef: function(a) {
          return Se = "useRef", Be(), nS();
        },
        useState: function(a) {
          Se = "useState", Be();
          var o = qe.current;
          qe.current = vS;
          try {
            return uA(a);
          } finally {
            qe.current = o;
          }
        },
        useDebugValue: function(a, o) {
          return Se = "useDebugValue", Be(), uS();
        },
        useDeferredValue: function(a) {
          return Se = "useDeferredValue", Be(), yI(a);
        },
        useTransition: function() {
          return Se = "useTransition", Be(), SI();
        },
        useMutableSource: function(a, o, f) {
          return Se = "useMutableSource", Be(), void 0;
        },
        useSyncExternalStore: function(a, o, f) {
          return Se = "useSyncExternalStore", Be(), tS(a, o);
        },
        useId: function() {
          return Se = "useId", Be(), fS();
        },
        unstable_isNewReconciler: Q
      }, pl = {
        readContext: function(a) {
          return yA(), In(a);
        },
        useCallback: function(a, o) {
          return Se = "useCallback", Tt(), or(), vA(a, o);
        },
        useContext: function(a) {
          return Se = "useContext", Tt(), or(), In(a);
        },
        useEffect: function(a, o) {
          return Se = "useEffect", Tt(), or(), aS(a, o);
        },
        useImperativeHandle: function(a, o, f) {
          return Se = "useImperativeHandle", Tt(), or(), hA(a, o, f);
        },
        useInsertionEffect: function(a, o) {
          return Se = "useInsertionEffect", Tt(), or(), dA(a, o);
        },
        useLayoutEffect: function(a, o) {
          return Se = "useLayoutEffect", Tt(), or(), fA(a, o);
        },
        useMemo: function(a, o) {
          Se = "useMemo", Tt(), or();
          var f = qe.current;
          qe.current = pl;
          try {
            return pA(a, o);
          } finally {
            qe.current = f;
          }
        },
        useReducer: function(a, o, f) {
          Se = "useReducer", Tt(), or();
          var v = qe.current;
          qe.current = pl;
          try {
            return iA(a, o, f);
          } finally {
            qe.current = v;
          }
        },
        useRef: function(a) {
          return Se = "useRef", Tt(), or(), cA(a);
        },
        useState: function(a) {
          Se = "useState", Tt(), or();
          var o = qe.current;
          qe.current = pl;
          try {
            return rS(a);
          } finally {
            qe.current = o;
          }
        },
        useDebugValue: function(a, o) {
          return Se = "useDebugValue", Tt(), or(), void 0;
        },
        useDeferredValue: function(a) {
          return Se = "useDeferredValue", Tt(), or(), gA(a);
        },
        useTransition: function() {
          return Se = "useTransition", Tt(), or(), mA();
        },
        useMutableSource: function(a, o, f) {
          return Se = "useMutableSource", Tt(), or(), void 0;
        },
        useSyncExternalStore: function(a, o, f) {
          return Se = "useSyncExternalStore", Tt(), or(), sA(a, o, f);
        },
        useId: function() {
          return Se = "useId", Tt(), or(), _A();
        },
        unstable_isNewReconciler: Q
      }, ms = {
        readContext: function(a) {
          return yA(), In(a);
        },
        useCallback: function(a, o) {
          return Se = "useCallback", Tt(), Be(), cS(a, o);
        },
        useContext: function(a) {
          return Se = "useContext", Tt(), Be(), In(a);
        },
        useEffect: function(a, o) {
          return Se = "useEffect", Tt(), Be(), j0(a, o);
        },
        useImperativeHandle: function(a, o, f) {
          return Se = "useImperativeHandle", Tt(), Be(), lS(a, o, f);
        },
        useInsertionEffect: function(a, o) {
          return Se = "useInsertionEffect", Tt(), Be(), oS(a, o);
        },
        useLayoutEffect: function(a, o) {
          return Se = "useLayoutEffect", Tt(), Be(), sS(a, o);
        },
        useMemo: function(a, o) {
          Se = "useMemo", Tt(), Be();
          var f = qe.current;
          qe.current = ms;
          try {
            return dS(a, o);
          } finally {
            qe.current = f;
          }
        },
        useReducer: function(a, o, f) {
          Se = "useReducer", Tt(), Be();
          var v = qe.current;
          qe.current = ms;
          try {
            return aA(a, o, f);
          } finally {
            qe.current = v;
          }
        },
        useRef: function(a) {
          return Se = "useRef", Tt(), Be(), nS();
        },
        useState: function(a) {
          Se = "useState", Tt(), Be();
          var o = qe.current;
          qe.current = ms;
          try {
            return lA(a);
          } finally {
            qe.current = o;
          }
        },
        useDebugValue: function(a, o) {
          return Se = "useDebugValue", Tt(), Be(), uS();
        },
        useDeferredValue: function(a) {
          return Se = "useDeferredValue", Tt(), Be(), _I(a);
        },
        useTransition: function() {
          return Se = "useTransition", Tt(), Be(), bI();
        },
        useMutableSource: function(a, o, f) {
          return Se = "useMutableSource", Tt(), Be(), void 0;
        },
        useSyncExternalStore: function(a, o, f) {
          return Se = "useSyncExternalStore", Tt(), Be(), tS(a, o);
        },
        useId: function() {
          return Se = "useId", Tt(), Be(), fS();
        },
        unstable_isNewReconciler: Q
      }, vS = {
        readContext: function(a) {
          return yA(), In(a);
        },
        useCallback: function(a, o) {
          return Se = "useCallback", Tt(), Be(), cS(a, o);
        },
        useContext: function(a) {
          return Se = "useContext", Tt(), Be(), In(a);
        },
        useEffect: function(a, o) {
          return Se = "useEffect", Tt(), Be(), j0(a, o);
        },
        useImperativeHandle: function(a, o, f) {
          return Se = "useImperativeHandle", Tt(), Be(), lS(a, o, f);
        },
        useInsertionEffect: function(a, o) {
          return Se = "useInsertionEffect", Tt(), Be(), oS(a, o);
        },
        useLayoutEffect: function(a, o) {
          return Se = "useLayoutEffect", Tt(), Be(), sS(a, o);
        },
        useMemo: function(a, o) {
          Se = "useMemo", Tt(), Be();
          var f = qe.current;
          qe.current = ms;
          try {
            return dS(a, o);
          } finally {
            qe.current = f;
          }
        },
        useReducer: function(a, o, f) {
          Se = "useReducer", Tt(), Be();
          var v = qe.current;
          qe.current = ms;
          try {
            return oA(a, o, f);
          } finally {
            qe.current = v;
          }
        },
        useRef: function(a) {
          return Se = "useRef", Tt(), Be(), nS();
        },
        useState: function(a) {
          Se = "useState", Tt(), Be();
          var o = qe.current;
          qe.current = ms;
          try {
            return uA(a);
          } finally {
            qe.current = o;
          }
        },
        useDebugValue: function(a, o) {
          return Se = "useDebugValue", Tt(), Be(), uS();
        },
        useDeferredValue: function(a) {
          return Se = "useDeferredValue", Tt(), Be(), yI(a);
        },
        useTransition: function() {
          return Se = "useTransition", Tt(), Be(), SI();
        },
        useMutableSource: function(a, o, f) {
          return Se = "useMutableSource", Tt(), Be(), void 0;
        },
        useSyncExternalStore: function(a, o, f) {
          return Se = "useSyncExternalStore", Tt(), Be(), tS(a, o);
        },
        useId: function() {
          return Se = "useId", Tt(), Be(), fS();
        },
        unstable_isNewReconciler: Q
      };
    }
    var rd = t.unstable_now, MI = 0, pS = -1, $0 = -1, gS = -1, xA = !1, mS = !1;
    function LI() {
      return xA;
    }
    function JY() {
      mS = !0;
    }
    function eW() {
      xA = !1, mS = !1;
    }
    function tW() {
      xA = mS, mS = !1;
    }
    function PI() {
      return MI;
    }
    function II() {
      MI = rd();
    }
    function bA(a) {
      $0 = rd(), a.actualStartTime < 0 && (a.actualStartTime = rd());
    }
    function NI(a) {
      $0 = -1;
    }
    function _S(a, o) {
      if ($0 >= 0) {
        var f = rd() - $0;
        a.actualDuration += f, o && (a.selfBaseDuration = f), $0 = -1;
      }
    }
    function gl(a) {
      if (pS >= 0) {
        var o = rd() - pS;
        pS = -1;
        for (var f = a.return; f !== null; ) {
          switch (f.tag) {
            case x:
              var v = f.stateNode;
              v.effectDuration += o;
              return;
            case V:
              var _ = f.stateNode;
              _.effectDuration += o;
              return;
          }
          f = f.return;
        }
      }
    }
    function SA(a) {
      if (gS >= 0) {
        var o = rd() - gS;
        gS = -1;
        for (var f = a.return; f !== null; ) {
          switch (f.tag) {
            case x:
              var v = f.stateNode;
              v !== null && (v.passiveEffectDuration += o);
              return;
            case V:
              var _ = f.stateNode;
              _ !== null && (_.passiveEffectDuration += o);
              return;
          }
          f = f.return;
        }
      }
    }
    function ml() {
      pS = rd();
    }
    function CA() {
      gS = rd();
    }
    function EA(a) {
      for (var o = a.child; o; )
        a.actualDuration += o.actualDuration, o = o.sibling;
    }
    function Zf(a, o) {
      return {
        value: a,
        source: o,
        stack: em(o),
        digest: null
      };
    }
    function TA(a, o, f) {
      return {
        value: a,
        source: null,
        stack: f ?? null,
        digest: o ?? null
      };
    }
    function rW(a, o) {
      return !0;
    }
    function wA(a, o) {
      try {
        var f = rW(a, o);
        if (f === !1)
          return;
        var v = o.value, _ = o.source, b = o.stack, E = b !== null ? b : "";
        if (v != null && v._suppressLogging) {
          if (a.tag === p)
            return;
          console.error(v);
        }
        var A = _ ? kt(_) : null, R = A ? "The above error occurred in the <" + A + "> component:" : "The above error occurred in one of your React components:", N;
        if (a.tag === x)
          N = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var B = kt(a) || "Anonymous";
          N = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + B + ".");
        }
        var K = R + `
` + E + `

` + ("" + N);
        console.error(K);
      } catch (X) {
        setTimeout(function() {
          throw X;
        });
      }
    }
    var nW = typeof WeakMap == "function" ? WeakMap : Map;
    function VI(a, o, f) {
      var v = Au(br, f);
      v.tag = ww, v.payload = {
        element: null
      };
      var _ = o.value;
      return v.callback = function() {
        e9(_), wA(a, o);
      }, v;
    }
    function AA(a, o, f) {
      var v = Au(br, f);
      v.tag = ww;
      var _ = a.type.getDerivedStateFromError;
      if (typeof _ == "function") {
        var b = o.value;
        v.payload = function() {
          return _(b);
        }, v.callback = function() {
          qN(a), wA(a, o);
        };
      }
      var E = a.stateNode;
      return E !== null && typeof E.componentDidCatch == "function" && (v.callback = function() {
        qN(a), wA(a, o), typeof _ != "function" && Q8(this);
        var R = o.value, N = o.stack;
        this.componentDidCatch(R, {
          componentStack: N !== null ? N : ""
        }), typeof _ != "function" && (Bi(a.lanes, yt) || l("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", kt(a) || "Unknown"));
      }), v;
    }
    function FI(a, o, f) {
      var v = a.pingCache, _;
      if (v === null ? (v = a.pingCache = new nW(), _ = /* @__PURE__ */ new Set(), v.set(o, _)) : (_ = v.get(o), _ === void 0 && (_ = /* @__PURE__ */ new Set(), v.set(o, _))), !_.has(f)) {
        _.add(f);
        var b = t9.bind(null, a, o, f);
        zn && s_(a, f), o.then(b, b);
      }
    }
    function iW(a, o, f, v) {
      var _ = a.updateQueue;
      if (_ === null) {
        var b = /* @__PURE__ */ new Set();
        b.add(f), a.updateQueue = b;
      } else
        _.add(f);
    }
    function aW(a, o) {
      var f = a.tag;
      if ((a.mode & Ft) === pt && (f === h || f === z || f === Z)) {
        var v = a.alternate;
        v ? (a.updateQueue = v.updateQueue, a.memoizedState = v.memoizedState, a.lanes = v.lanes) : (a.updateQueue = null, a.memoizedState = null);
      }
    }
    function BI(a) {
      var o = a;
      do {
        if (o.tag === P && UY(o))
          return o;
        o = o.return;
      } while (o !== null);
      return null;
    }
    function zI(a, o, f, v, _) {
      if ((a.mode & Ft) === pt) {
        if (a === o)
          a.flags |= Dn;
        else {
          if (a.flags |= St, f.flags |= yf, f.flags &= ~(cv | ra), f.tag === p) {
            var b = f.alternate;
            if (b === null)
              f.tag = J;
            else {
              var E = Au(br, yt);
              E.tag = Gb, Qc(f, E, yt);
            }
          }
          f.lanes = Rt(f.lanes, yt);
        }
        return a;
      }
      return a.flags |= Dn, a.lanes = _, a;
    }
    function oW(a, o, f, v, _) {
      if (f.flags |= ra, zn && s_(a, _), v !== null && typeof v == "object" && typeof v.then == "function") {
        var b = v;
        aW(f), yi() && f.mode & Ft && RP();
        var E = BI(o);
        if (E !== null) {
          E.flags &= ~Wr, zI(E, o, f, a, _), E.mode & Ft && FI(a, b, _), iW(E, a, b);
          return;
        } else {
          if (!Rc(_)) {
            FI(a, b, _), sO();
            return;
          }
          var A = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          v = A;
        }
      } else if (yi() && f.mode & Ft) {
        RP();
        var R = BI(o);
        if (R !== null) {
          (R.flags & Dn) === dt && (R.flags |= Wr), zI(R, o, f, a, _), yw(Zf(v, f));
          return;
        }
      }
      v = Zf(v, f), j8(v);
      var N = o;
      do {
        switch (N.tag) {
          case x: {
            var B = v;
            N.flags |= Dn;
            var K = mn(_);
            N.lanes = Rt(N.lanes, K);
            var X = VI(N, B, K);
            kw(N, X);
            return;
          }
          case p:
            var ce = v, oe = N.type, ve = N.stateNode;
            if ((N.flags & St) === dt && (typeof oe.getDerivedStateFromError == "function" || ve !== null && typeof ve.componentDidCatch == "function" && !zN(ve))) {
              N.flags |= Dn;
              var Ye = mn(_);
              N.lanes = Rt(N.lanes, Ye);
              var ft = AA(N, ce, Ye);
              kw(N, ft);
              return;
            }
            break;
        }
        N = N.return;
      } while (N !== null);
    }
    function sW() {
      return null;
    }
    var Y0 = r.ReactCurrentOwner, _s = !1, OA, W0, kA, RA, DA, Qf, MA, yS;
    OA = {}, W0 = {}, kA = {}, RA = {}, DA = {}, Qf = !1, MA = {}, yS = {};
    function la(a, o, f, v) {
      a === null ? o.child = iI(o, null, f, v) : o.child = _p(o, a.child, f, v);
    }
    function lW(a, o, f, v) {
      o.child = _p(o, a.child, null, v), o.child = _p(o, null, f, v);
    }
    function HI(a, o, f, v, _) {
      if (o.type !== o.elementType) {
        var b = f.propTypes;
        b && fs(
          b,
          v,
          // Resolved props
          "prop",
          yr(f)
        );
      }
      var E = f.render, A = o.ref, R, N;
      mp(o, _), tl(o);
      {
        if (Y0.current = o, to(!0), R = Ep(a, o, E, v, A, _), N = Tp(), o.mode & Hr) {
          gn(!0);
          try {
            R = Ep(a, o, E, v, A, _), N = Tp();
          } finally {
            gn(!1);
          }
        }
        to(!1);
      }
      return ru(), a !== null && !_s ? (uI(a, o, _), Ou(a, o, _)) : (yi() && N && hw(o), o.flags |= qs, la(a, o, R, _), o.child);
    }
    function GI(a, o, f, v, _) {
      if (a === null) {
        var b = f.type;
        if (_9(b) && f.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        f.defaultProps === void 0) {
          var E = b;
          return E = Lp(b), o.tag = Z, o.type = E, IA(o, b), UI(a, o, E, v, _);
        }
        {
          var A = b.propTypes;
          A && fs(
            A,
            v,
            // Resolved props
            "prop",
            yr(b)
          );
        }
        var R = _O(f.type, null, v, o, o.mode, _);
        return R.ref = o.ref, R.return = o, o.child = R, R;
      }
      {
        var N = f.type, B = N.propTypes;
        B && fs(
          B,
          v,
          // Resolved props
          "prop",
          yr(N)
        );
      }
      var K = a.child, X = HA(a, _);
      if (!X) {
        var ce = K.memoizedProps, oe = f.compare;
        if (oe = oe !== null ? oe : ut, oe(ce, v) && a.ref === o.ref)
          return Ou(a, o, _);
      }
      o.flags |= qs;
      var ve = nh(K, v);
      return ve.ref = o.ref, ve.return = o, o.child = ve, ve;
    }
    function UI(a, o, f, v, _) {
      if (o.type !== o.elementType) {
        var b = o.elementType;
        if (b.$$typeof === gt) {
          var E = b, A = E._payload, R = E._init;
          try {
            b = R(A);
          } catch {
            b = null;
          }
          var N = b && b.propTypes;
          N && fs(
            N,
            v,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            yr(b)
          );
        }
      }
      if (a !== null) {
        var B = a.memoizedProps;
        if (ut(B, v) && a.ref === o.ref && // Prevent bailout if the implementation changed due to hot reload.
        o.type === a.type)
          if (_s = !1, o.pendingProps = v = B, HA(a, _))
            (a.flags & yf) !== dt && (_s = !0);
          else
            return o.lanes = a.lanes, Ou(a, o, _);
      }
      return LA(a, o, f, v, _);
    }
    function jI(a, o, f) {
      var v = o.pendingProps, _ = v.children, b = a !== null ? a.memoizedState : null;
      if (v.mode === "hidden" || G)
        if ((o.mode & Ft) === pt) {
          var E = {
            baseLanes: ye,
            cachePool: null,
            transitions: null
          };
          o.memoizedState = E, MS(o, f);
        } else if (Bi(f, Fi)) {
          var K = {
            baseLanes: ye,
            cachePool: null,
            transitions: null
          };
          o.memoizedState = K;
          var X = b !== null ? b.baseLanes : f;
          MS(o, X);
        } else {
          var A = null, R;
          if (b !== null) {
            var N = b.baseLanes;
            R = Rt(N, f);
          } else
            R = f;
          o.lanes = o.childLanes = Fi;
          var B = {
            baseLanes: R,
            cachePool: A,
            transitions: null
          };
          return o.memoizedState = B, o.updateQueue = null, MS(o, R), null;
        }
      else {
        var ce;
        b !== null ? (ce = Rt(b.baseLanes, f), o.memoizedState = null) : ce = f, MS(o, ce);
      }
      return la(a, o, _, f), o.child;
    }
    function uW(a, o, f) {
      var v = o.pendingProps;
      return la(a, o, v, f), o.child;
    }
    function cW(a, o, f) {
      var v = o.pendingProps.children;
      return la(a, o, v, f), o.child;
    }
    function dW(a, o, f) {
      {
        o.flags |= Mt;
        {
          var v = o.stateNode;
          v.effectDuration = 0, v.passiveEffectDuration = 0;
        }
      }
      var _ = o.pendingProps, b = _.children;
      return la(a, o, b, f), o.child;
    }
    function $I(a, o) {
      var f = o.ref;
      (a === null && f !== null || a !== null && a.ref !== f) && (o.flags |= Mi, o.flags |= km);
    }
    function LA(a, o, f, v, _) {
      if (o.type !== o.elementType) {
        var b = f.propTypes;
        b && fs(
          b,
          v,
          // Resolved props
          "prop",
          yr(f)
        );
      }
      var E;
      {
        var A = dp(o, f, !0);
        E = fp(o, A);
      }
      var R, N;
      mp(o, _), tl(o);
      {
        if (Y0.current = o, to(!0), R = Ep(a, o, f, v, E, _), N = Tp(), o.mode & Hr) {
          gn(!0);
          try {
            R = Ep(a, o, f, v, E, _), N = Tp();
          } finally {
            gn(!1);
          }
        }
        to(!1);
      }
      return ru(), a !== null && !_s ? (uI(a, o, _), Ou(a, o, _)) : (yi() && N && hw(o), o.flags |= qs, la(a, o, R, _), o.child);
    }
    function YI(a, o, f, v, _) {
      {
        switch (L9(o)) {
          case !1: {
            var b = o.stateNode, E = o.type, A = new E(o.memoizedProps, b.context), R = A.state;
            b.updater.enqueueSetState(b, R, null);
            break;
          }
          case !0: {
            o.flags |= St, o.flags |= Dn;
            var N = new Error("Simulated error coming from DevTools"), B = mn(_);
            o.lanes = Rt(o.lanes, B);
            var K = AA(o, Zf(N, o), B);
            kw(o, K);
            break;
          }
        }
        if (o.type !== o.elementType) {
          var X = f.propTypes;
          X && fs(
            X,
            v,
            // Resolved props
            "prop",
            yr(f)
          );
        }
      }
      var ce;
      fl(f) ? (ce = !0, Db(o)) : ce = !1, mp(o, _);
      var oe = o.stateNode, ve;
      oe === null ? (bS(a, o), JP(o, f, v), Hw(o, f, v, _), ve = !0) : a === null ? ve = VY(o, f, v, _) : ve = FY(a, o, f, v, _);
      var Ye = PA(a, o, f, ve, ce, _);
      {
        var ft = o.stateNode;
        ve && ft.props !== v && (Qf || l("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", kt(o) || "a component"), Qf = !0);
      }
      return Ye;
    }
    function PA(a, o, f, v, _, b) {
      $I(a, o);
      var E = (o.flags & St) !== dt;
      if (!v && !E)
        return _ && wP(o, f, !1), Ou(a, o, b);
      var A = o.stateNode;
      Y0.current = o;
      var R;
      if (E && typeof f.getDerivedStateFromError != "function")
        R = null, NI();
      else {
        tl(o);
        {
          if (to(!0), R = A.render(), o.mode & Hr) {
            gn(!0);
            try {
              A.render();
            } finally {
              gn(!1);
            }
          }
          to(!1);
        }
        ru();
      }
      return o.flags |= qs, a !== null && E ? lW(a, o, R, b) : la(a, o, R, b), o.memoizedState = A.state, _ && wP(o, f, !0), o.child;
    }
    function WI(a) {
      var o = a.stateNode;
      o.pendingContext ? EP(a, o.pendingContext, o.pendingContext !== o.context) : o.context && EP(a, o.context, !1), Ww(a, o.containerInfo);
    }
    function fW(a, o, f) {
      if (WI(o), a === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var v = o.pendingProps, _ = o.memoizedState, b = _.element;
      $P(a, o), Yb(o, v, null, f);
      var E = o.memoizedState, A = o.stateNode, R = E.element;
      if (_.isDehydrated) {
        var N = {
          element: R,
          isDehydrated: !1,
          cache: E.cache,
          pendingSuspenseBoundaries: E.pendingSuspenseBoundaries,
          transitions: E.transitions
        }, B = o.updateQueue;
        if (B.baseState = N, o.memoizedState = N, o.flags & Wr) {
          var K = Zf(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), o);
          return XI(a, o, R, f, K);
        } else if (R !== b) {
          var X = Zf(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), o);
          return XI(a, o, R, f, X);
        } else {
          gY(o);
          var ce = iI(o, null, R, f);
          o.child = ce;
          for (var oe = ce; oe; )
            oe.flags = oe.flags & ~wr | ka, oe = oe.sibling;
        }
      } else {
        if (pp(), R === b)
          return Ou(a, o, f);
        la(a, o, R, f);
      }
      return o.child;
    }
    function XI(a, o, f, v, _) {
      return pp(), yw(_), o.flags |= Wr, la(a, o, f, v), o.child;
    }
    function hW(a, o, f) {
      oI(o), a === null && _w(o);
      var v = o.type, _ = o.pendingProps, b = a !== null ? a.memoizedProps : null, E = _.children, A = J1(v, _);
      return A ? E = null : b !== null && J1(v, b) && (o.flags |= ar), $I(a, o), la(a, o, E, f), o.child;
    }
    function vW(a, o) {
      return a === null && _w(o), null;
    }
    function pW(a, o, f, v) {
      bS(a, o);
      var _ = o.pendingProps, b = f, E = b._payload, A = b._init, R = A(E);
      o.type = R;
      var N = o.tag = y9(R), B = ps(R, _), K;
      switch (N) {
        case h:
          return IA(o, R), o.type = R = Lp(R), K = LA(null, o, R, B, v), K;
        case p:
          return o.type = R = fO(R), K = YI(null, o, R, B, v), K;
        case z:
          return o.type = R = hO(R), K = HI(null, o, R, B, v), K;
        case j: {
          if (o.type !== o.elementType) {
            var X = R.propTypes;
            X && fs(
              X,
              B,
              // Resolved for outer only
              "prop",
              yr(R)
            );
          }
          return K = GI(
            null,
            o,
            R,
            ps(R.type, B),
            // The inner type can have defaults too
            v
          ), K;
        }
      }
      var ce = "";
      throw R !== null && typeof R == "object" && R.$$typeof === gt && (ce = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + R + ". " + ("Lazy element type must resolve to a class or function." + ce));
    }
    function gW(a, o, f, v, _) {
      bS(a, o), o.tag = p;
      var b;
      return fl(f) ? (b = !0, Db(o)) : b = !1, mp(o, _), JP(o, f, v), Hw(o, f, v, _), PA(null, o, f, !0, b, _);
    }
    function mW(a, o, f, v) {
      bS(a, o);
      var _ = o.pendingProps, b;
      {
        var E = dp(o, f, !1);
        b = fp(o, E);
      }
      mp(o, v);
      var A, R;
      tl(o);
      {
        if (f.prototype && typeof f.prototype.render == "function") {
          var N = yr(f) || "Unknown";
          OA[N] || (l("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", N, N), OA[N] = !0);
        }
        o.mode & Hr && vs.recordLegacyContextWarning(o, null), to(!0), Y0.current = o, A = Ep(null, o, f, _, b, v), R = Tp(), to(!1);
      }
      if (ru(), o.flags |= qs, typeof A == "object" && A !== null && typeof A.render == "function" && A.$$typeof === void 0) {
        var B = yr(f) || "Unknown";
        W0[B] || (l("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", B, B, B), W0[B] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof A == "object" && A !== null && typeof A.render == "function" && A.$$typeof === void 0
      ) {
        {
          var K = yr(f) || "Unknown";
          W0[K] || (l("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", K, K, K), W0[K] = !0);
        }
        o.tag = p, o.memoizedState = null, o.updateQueue = null;
        var X = !1;
        return fl(f) ? (X = !0, Db(o)) : X = !1, o.memoizedState = A.state !== null && A.state !== void 0 ? A.state : null, Ow(o), QP(o, A), Hw(o, f, _, v), PA(null, o, f, !0, X, v);
      } else {
        if (o.tag = h, o.mode & Hr) {
          gn(!0);
          try {
            A = Ep(null, o, f, _, b, v), R = Tp();
          } finally {
            gn(!1);
          }
        }
        return yi() && R && hw(o), la(null, o, A, v), IA(o, f), o.child;
      }
    }
    function IA(a, o) {
      {
        if (o && o.childContextTypes && l("%s(...): childContextTypes cannot be defined on a function component.", o.displayName || o.name || "Component"), a.ref !== null) {
          var f = "", v = Ta();
          v && (f += `

Check the render method of \`` + v + "`.");
          var _ = v || "", b = a._debugSource;
          b && (_ = b.fileName + ":" + b.lineNumber), DA[_] || (DA[_] = !0, l("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", f));
        }
        if (typeof o.getDerivedStateFromProps == "function") {
          var E = yr(o) || "Unknown";
          RA[E] || (l("%s: Function components do not support getDerivedStateFromProps.", E), RA[E] = !0);
        }
        if (typeof o.contextType == "object" && o.contextType !== null) {
          var A = yr(o) || "Unknown";
          kA[A] || (l("%s: Function components do not support contextType.", A), kA[A] = !0);
        }
      }
    }
    var NA = {
      dehydrated: null,
      treeContext: null,
      retryLane: jt
    };
    function VA(a) {
      return {
        baseLanes: a,
        cachePool: sW(),
        transitions: null
      };
    }
    function _W(a, o) {
      var f = null;
      return {
        baseLanes: Rt(a.baseLanes, o),
        cachePool: f,
        transitions: a.transitions
      };
    }
    function yW(a, o, f, v) {
      if (o !== null) {
        var _ = o.memoizedState;
        if (_ === null)
          return !1;
      }
      return Kw(a, F0);
    }
    function xW(a, o) {
      return Dc(a.childLanes, o);
    }
    function qI(a, o, f) {
      var v = o.pendingProps;
      P9(o) && (o.flags |= St);
      var _ = gs.current, b = !1, E = (o.flags & St) !== dt;
      if (E || yW(_, a) ? (b = !0, o.flags &= ~St) : (a === null || a.memoizedState !== null) && (_ = GY(_, lI)), _ = xp(_), ed(o, _), a === null) {
        _w(o);
        var A = o.memoizedState;
        if (A !== null) {
          var R = A.dehydrated;
          if (R !== null)
            return TW(o, R);
        }
        var N = v.children, B = v.fallback;
        if (b) {
          var K = bW(o, N, B, f), X = o.child;
          return X.memoizedState = VA(f), o.memoizedState = NA, K;
        } else
          return FA(o, N);
      } else {
        var ce = a.memoizedState;
        if (ce !== null) {
          var oe = ce.dehydrated;
          if (oe !== null)
            return wW(a, o, E, v, oe, ce, f);
        }
        if (b) {
          var ve = v.fallback, Ye = v.children, ft = CW(a, o, Ye, ve, f), ot = o.child, Ht = a.child.memoizedState;
          return ot.memoizedState = Ht === null ? VA(f) : _W(Ht, f), ot.childLanes = xW(a, f), o.memoizedState = NA, ft;
        } else {
          var Gt = v.children, ne = SW(a, o, Gt, f);
          return o.memoizedState = null, ne;
        }
      }
    }
    function FA(a, o, f) {
      var v = a.mode, _ = {
        mode: "visible",
        children: o
      }, b = BA(_, v);
      return b.return = a, a.child = b, b;
    }
    function bW(a, o, f, v) {
      var _ = a.mode, b = a.child, E = {
        mode: "hidden",
        children: o
      }, A, R;
      return (_ & Ft) === pt && b !== null ? (A = b, A.childLanes = ye, A.pendingProps = E, a.mode & mt && (A.actualDuration = 0, A.actualStartTime = -1, A.selfBaseDuration = 0, A.treeBaseDuration = 0), R = ld(f, _, v, null)) : (A = BA(E, _), R = ld(f, _, v, null)), A.return = a, R.return = a, A.sibling = R, a.child = A, R;
    }
    function BA(a, o, f) {
      return ZN(a, o, ye, null);
    }
    function KI(a, o) {
      return nh(a, o);
    }
    function SW(a, o, f, v) {
      var _ = a.child, b = _.sibling, E = KI(_, {
        mode: "visible",
        children: f
      });
      if ((o.mode & Ft) === pt && (E.lanes = v), E.return = o, E.sibling = null, b !== null) {
        var A = o.deletions;
        A === null ? (o.deletions = [b], o.flags |= nr) : A.push(b);
      }
      return o.child = E, E;
    }
    function CW(a, o, f, v, _) {
      var b = o.mode, E = a.child, A = E.sibling, R = {
        mode: "hidden",
        children: f
      }, N;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (b & Ft) === pt && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        o.child !== E
      ) {
        var B = o.child;
        N = B, N.childLanes = ye, N.pendingProps = R, o.mode & mt && (N.actualDuration = 0, N.actualStartTime = -1, N.selfBaseDuration = E.selfBaseDuration, N.treeBaseDuration = E.treeBaseDuration), o.deletions = null;
      } else
        N = KI(E, R), N.subtreeFlags = E.subtreeFlags & Bn;
      var K;
      return A !== null ? K = nh(A, v) : (K = ld(v, b, _, null), K.flags |= wr), K.return = o, N.return = o, N.sibling = K, o.child = N, K;
    }
    function xS(a, o, f, v) {
      v !== null && yw(v), _p(o, a.child, null, f);
      var _ = o.pendingProps, b = _.children, E = FA(o, b);
      return E.flags |= wr, o.memoizedState = null, E;
    }
    function EW(a, o, f, v, _) {
      var b = o.mode, E = {
        mode: "visible",
        children: f
      }, A = BA(E, b), R = ld(v, b, _, null);
      return R.flags |= wr, A.return = o, R.return = o, A.sibling = R, o.child = A, (o.mode & Ft) !== pt && _p(o, a.child, null, _), R;
    }
    function TW(a, o, f) {
      return (a.mode & Ft) === pt ? (l("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), a.lanes = yt) : nw(o) ? a.lanes = au : a.lanes = Fi, null;
    }
    function wW(a, o, f, v, _, b, E) {
      if (f)
        if (o.flags & Wr) {
          o.flags &= ~Wr;
          var ne = TA(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return xS(a, o, E, ne);
        } else {
          if (o.memoizedState !== null)
            return o.child = a.child, o.flags |= St, null;
          var ge = v.children, ie = v.fallback, Me = EW(a, o, ge, ie, E), Ke = o.child;
          return Ke.memoizedState = VA(E), o.memoizedState = NA, Me;
        }
      else {
        if (vY(), (o.mode & Ft) === pt)
          return xS(
            a,
            o,
            E,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (nw(_)) {
          var A, R, N;
          {
            var B = D6(_);
            A = B.digest, R = B.message, N = B.stack;
          }
          var K;
          R ? K = new Error(R) : K = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var X = TA(K, A, N);
          return xS(a, o, E, X);
        }
        var ce = Bi(E, a.childLanes);
        if (_s || ce) {
          var oe = DS();
          if (oe !== null) {
            var ve = E1(oe, E);
            if (ve !== jt && ve !== b.retryLane) {
              b.retryLane = ve;
              var Ye = br;
              Ba(a, ve), qn(oe, a, ve, Ye);
            }
          }
          sO();
          var ft = TA(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return xS(a, o, E, ft);
        } else if (_P(_)) {
          o.flags |= St, o.child = a.child;
          var ot = r9.bind(null, a);
          return M6(_, ot), null;
        } else {
          mY(o, _, b.treeContext);
          var Ht = v.children, Gt = FA(o, Ht);
          return Gt.flags |= ka, Gt;
        }
      }
    }
    function ZI(a, o, f) {
      a.lanes = Rt(a.lanes, o);
      var v = a.alternate;
      v !== null && (v.lanes = Rt(v.lanes, o)), Ew(a.return, o, f);
    }
    function AW(a, o, f) {
      for (var v = o; v !== null; ) {
        if (v.tag === P) {
          var _ = v.memoizedState;
          _ !== null && ZI(v, f, a);
        } else if (v.tag === de)
          ZI(v, f, a);
        else if (v.child !== null) {
          v.child.return = v, v = v.child;
          continue;
        }
        if (v === a)
          return;
        for (; v.sibling === null; ) {
          if (v.return === null || v.return === a)
            return;
          v = v.return;
        }
        v.sibling.return = v.return, v = v.sibling;
      }
    }
    function OW(a) {
      for (var o = a, f = null; o !== null; ) {
        var v = o.alternate;
        v !== null && Jb(v) === null && (f = o), o = o.sibling;
      }
      return f;
    }
    function kW(a) {
      if (a !== void 0 && a !== "forwards" && a !== "backwards" && a !== "together" && !MA[a])
        if (MA[a] = !0, typeof a == "string")
          switch (a.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              l('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', a, a.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              l('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', a, a.toLowerCase());
              break;
            }
            default:
              l('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', a);
              break;
          }
        else
          l('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', a);
    }
    function RW(a, o) {
      a !== void 0 && !yS[a] && (a !== "collapsed" && a !== "hidden" ? (yS[a] = !0, l('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', a)) : o !== "forwards" && o !== "backwards" && (yS[a] = !0, l('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', a)));
    }
    function QI(a, o) {
      {
        var f = kn(a), v = !f && typeof Xo(a) == "function";
        if (f || v) {
          var _ = f ? "array" : "iterable";
          return l("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", _, o, _), !1;
        }
      }
      return !0;
    }
    function DW(a, o) {
      if ((o === "forwards" || o === "backwards") && a !== void 0 && a !== null && a !== !1)
        if (kn(a)) {
          for (var f = 0; f < a.length; f++)
            if (!QI(a[f], f))
              return;
        } else {
          var v = Xo(a);
          if (typeof v == "function") {
            var _ = v.call(a);
            if (_)
              for (var b = _.next(), E = 0; !b.done; b = _.next()) {
                if (!QI(b.value, E))
                  return;
                E++;
              }
          } else
            l('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', o);
        }
    }
    function zA(a, o, f, v, _) {
      var b = a.memoizedState;
      b === null ? a.memoizedState = {
        isBackwards: o,
        rendering: null,
        renderingStartTime: 0,
        last: v,
        tail: f,
        tailMode: _
      } : (b.isBackwards = o, b.rendering = null, b.renderingStartTime = 0, b.last = v, b.tail = f, b.tailMode = _);
    }
    function JI(a, o, f) {
      var v = o.pendingProps, _ = v.revealOrder, b = v.tail, E = v.children;
      kW(_), RW(b, _), DW(E, _), la(a, o, E, f);
      var A = gs.current, R = Kw(A, F0);
      if (R)
        A = Zw(A, F0), o.flags |= St;
      else {
        var N = a !== null && (a.flags & St) !== dt;
        N && AW(o, o.child, f), A = xp(A);
      }
      if (ed(o, A), (o.mode & Ft) === pt)
        o.memoizedState = null;
      else
        switch (_) {
          case "forwards": {
            var B = OW(o.child), K;
            B === null ? (K = o.child, o.child = null) : (K = B.sibling, B.sibling = null), zA(
              o,
              !1,
              // isBackwards
              K,
              B,
              b
            );
            break;
          }
          case "backwards": {
            var X = null, ce = o.child;
            for (o.child = null; ce !== null; ) {
              var oe = ce.alternate;
              if (oe !== null && Jb(oe) === null) {
                o.child = ce;
                break;
              }
              var ve = ce.sibling;
              ce.sibling = X, X = ce, ce = ve;
            }
            zA(
              o,
              !0,
              // isBackwards
              X,
              null,
              // last
              b
            );
            break;
          }
          case "together": {
            zA(
              o,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            o.memoizedState = null;
        }
      return o.child;
    }
    function MW(a, o, f) {
      Ww(o, o.stateNode.containerInfo);
      var v = o.pendingProps;
      return a === null ? o.child = _p(o, null, v, f) : la(a, o, v, f), o.child;
    }
    var eN = !1;
    function LW(a, o, f) {
      var v = o.type, _ = v._context, b = o.pendingProps, E = o.memoizedProps, A = b.value;
      {
        "value" in b || eN || (eN = !0, l("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var R = o.type.propTypes;
        R && fs(R, b, "prop", "Context.Provider");
      }
      if (HP(o, _, A), E !== null) {
        var N = E.value;
        if (rt(N, A)) {
          if (E.children === b.children && !kb())
            return Ou(a, o, f);
        } else
          AY(o, _, f);
      }
      var B = b.children;
      return la(a, o, B, f), o.child;
    }
    var tN = !1;
    function PW(a, o, f) {
      var v = o.type;
      v._context === void 0 ? v !== v.Consumer && (tN || (tN = !0, l("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : v = v._context;
      var _ = o.pendingProps, b = _.children;
      typeof b != "function" && l("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), mp(o, f);
      var E = In(v);
      tl(o);
      var A;
      return Y0.current = o, to(!0), A = b(E), to(!1), ru(), o.flags |= qs, la(a, o, A, f), o.child;
    }
    function X0() {
      _s = !0;
    }
    function bS(a, o) {
      (o.mode & Ft) === pt && a !== null && (a.alternate = null, o.alternate = null, o.flags |= wr);
    }
    function Ou(a, o, f) {
      return a !== null && (o.dependencies = a.dependencies), NI(), o_(o.lanes), Bi(f, o.childLanes) ? (BY(a, o), o.child) : null;
    }
    function IW(a, o, f) {
      {
        var v = o.return;
        if (v === null)
          throw new Error("Cannot swap the root fiber.");
        if (a.alternate = null, o.alternate = null, f.index = o.index, f.sibling = o.sibling, f.return = o.return, f.ref = o.ref, o === v.child)
          v.child = f;
        else {
          var _ = v.child;
          if (_ === null)
            throw new Error("Expected parent to have a child.");
          for (; _.sibling !== o; )
            if (_ = _.sibling, _ === null)
              throw new Error("Expected to find the previous sibling.");
          _.sibling = f;
        }
        var b = v.deletions;
        return b === null ? (v.deletions = [a], v.flags |= nr) : b.push(a), f.flags |= wr, f;
      }
    }
    function HA(a, o) {
      var f = a.lanes;
      return !!Bi(f, o);
    }
    function NW(a, o, f) {
      switch (o.tag) {
        case x:
          WI(o);
          var v = o.stateNode;
          pp();
          break;
        case T:
          oI(o);
          break;
        case p: {
          var _ = o.type;
          fl(_) && Db(o);
          break;
        }
        case S:
          Ww(o, o.stateNode.containerInfo);
          break;
        case F: {
          var b = o.memoizedProps.value, E = o.type._context;
          HP(o, E, b);
          break;
        }
        case V:
          {
            var A = Bi(f, o.childLanes);
            A && (o.flags |= Mt);
            {
              var R = o.stateNode;
              R.effectDuration = 0, R.passiveEffectDuration = 0;
            }
          }
          break;
        case P: {
          var N = o.memoizedState;
          if (N !== null) {
            if (N.dehydrated !== null)
              return ed(o, xp(gs.current)), o.flags |= St, null;
            var B = o.child, K = B.childLanes;
            if (Bi(f, K))
              return qI(a, o, f);
            ed(o, xp(gs.current));
            var X = Ou(a, o, f);
            return X !== null ? X.sibling : null;
          } else
            ed(o, xp(gs.current));
          break;
        }
        case de: {
          var ce = (a.flags & St) !== dt, oe = Bi(f, o.childLanes);
          if (ce) {
            if (oe)
              return JI(a, o, f);
            o.flags |= St;
          }
          var ve = o.memoizedState;
          if (ve !== null && (ve.rendering = null, ve.tail = null, ve.lastEffect = null), ed(o, gs.current), oe)
            break;
          return null;
        }
        case Ce:
        case le:
          return o.lanes = ye, jI(a, o, f);
      }
      return Ou(a, o, f);
    }
    function rN(a, o, f) {
      if (o._debugNeedsRemount && a !== null)
        return IW(a, o, _O(o.type, o.key, o.pendingProps, o._debugOwner || null, o.mode, o.lanes));
      if (a !== null) {
        var v = a.memoizedProps, _ = o.pendingProps;
        if (v !== _ || kb() || // Force a re-render if the implementation changed due to hot reload:
        o.type !== a.type)
          _s = !0;
        else {
          var b = HA(a, f);
          if (!b && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (o.flags & St) === dt)
            return _s = !1, NW(a, o, f);
          (a.flags & yf) !== dt ? _s = !0 : _s = !1;
        }
      } else if (_s = !1, yi() && lY(o)) {
        var E = o.index, A = uY();
        kP(o, A, E);
      }
      switch (o.lanes = ye, o.tag) {
        case m:
          return mW(a, o, o.type, f);
        case ee: {
          var R = o.elementType;
          return pW(a, o, R, f);
        }
        case h: {
          var N = o.type, B = o.pendingProps, K = o.elementType === N ? B : ps(N, B);
          return LA(a, o, N, K, f);
        }
        case p: {
          var X = o.type, ce = o.pendingProps, oe = o.elementType === X ? ce : ps(X, ce);
          return YI(a, o, X, oe, f);
        }
        case x:
          return fW(a, o, f);
        case T:
          return hW(a, o, f);
        case k:
          return vW(a, o);
        case P:
          return qI(a, o, f);
        case S:
          return MW(a, o, f);
        case z: {
          var ve = o.type, Ye = o.pendingProps, ft = o.elementType === ve ? Ye : ps(ve, Ye);
          return HI(a, o, ve, ft, f);
        }
        case O:
          return uW(a, o, f);
        case D:
          return cW(a, o, f);
        case V:
          return dW(a, o, f);
        case F:
          return LW(a, o, f);
        case L:
          return PW(a, o, f);
        case j: {
          var ot = o.type, Ht = o.pendingProps, Gt = ps(ot, Ht);
          if (o.type !== o.elementType) {
            var ne = ot.propTypes;
            ne && fs(
              ne,
              Gt,
              // Resolved for outer only
              "prop",
              yr(ot)
            );
          }
          return Gt = ps(ot.type, Gt), GI(a, o, ot, Gt, f);
        }
        case Z:
          return UI(a, o, o.type, o.pendingProps, f);
        case J: {
          var ge = o.type, ie = o.pendingProps, Me = o.elementType === ge ? ie : ps(ge, ie);
          return gW(a, o, ge, Me, f);
        }
        case de:
          return JI(a, o, f);
        case Re:
          break;
        case Ce:
          return jI(a, o, f);
      }
      throw new Error("Unknown unit of work tag (" + o.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function wp(a) {
      a.flags |= Mt;
    }
    function nN(a) {
      a.flags |= Mi, a.flags |= km;
    }
    var iN, GA, aN, oN;
    iN = function(a, o, f, v) {
      for (var _ = o.child; _ !== null; ) {
        if (_.tag === T || _.tag === k)
          a6(a, _.stateNode);
        else if (_.tag !== S) {
          if (_.child !== null) {
            _.child.return = _, _ = _.child;
            continue;
          }
        }
        if (_ === o)
          return;
        for (; _.sibling === null; ) {
          if (_.return === null || _.return === o)
            return;
          _ = _.return;
        }
        _.sibling.return = _.return, _ = _.sibling;
      }
    }, GA = function(a, o) {
    }, aN = function(a, o, f, v, _) {
      var b = a.memoizedProps;
      if (b !== v) {
        var E = o.stateNode, A = Xw(), R = s6(E, f, b, v, _, A);
        o.updateQueue = R, R && wp(o);
      }
    }, oN = function(a, o, f, v) {
      f !== v && wp(o);
    };
    function q0(a, o) {
      if (!yi())
        switch (a.tailMode) {
          case "hidden": {
            for (var f = a.tail, v = null; f !== null; )
              f.alternate !== null && (v = f), f = f.sibling;
            v === null ? a.tail = null : v.sibling = null;
            break;
          }
          case "collapsed": {
            for (var _ = a.tail, b = null; _ !== null; )
              _.alternate !== null && (b = _), _ = _.sibling;
            b === null ? !o && a.tail !== null ? a.tail.sibling = null : a.tail = null : b.sibling = null;
            break;
          }
        }
    }
    function bi(a) {
      var o = a.alternate !== null && a.alternate.child === a.child, f = ye, v = dt;
      if (o) {
        if ((a.mode & mt) !== pt) {
          for (var R = a.selfBaseDuration, N = a.child; N !== null; )
            f = Rt(f, Rt(N.lanes, N.childLanes)), v |= N.subtreeFlags & Bn, v |= N.flags & Bn, R += N.treeBaseDuration, N = N.sibling;
          a.treeBaseDuration = R;
        } else
          for (var B = a.child; B !== null; )
            f = Rt(f, Rt(B.lanes, B.childLanes)), v |= B.subtreeFlags & Bn, v |= B.flags & Bn, B.return = a, B = B.sibling;
        a.subtreeFlags |= v;
      } else {
        if ((a.mode & mt) !== pt) {
          for (var _ = a.actualDuration, b = a.selfBaseDuration, E = a.child; E !== null; )
            f = Rt(f, Rt(E.lanes, E.childLanes)), v |= E.subtreeFlags, v |= E.flags, _ += E.actualDuration, b += E.treeBaseDuration, E = E.sibling;
          a.actualDuration = _, a.treeBaseDuration = b;
        } else
          for (var A = a.child; A !== null; )
            f = Rt(f, Rt(A.lanes, A.childLanes)), v |= A.subtreeFlags, v |= A.flags, A.return = a, A = A.sibling;
        a.subtreeFlags |= v;
      }
      return a.childLanes = f, o;
    }
    function VW(a, o, f) {
      if (SY() && (o.mode & Ft) !== pt && (o.flags & St) === dt)
        return NP(o), pp(), o.flags |= Wr | ra | Dn, !1;
      var v = Nb(o);
      if (f !== null && f.dehydrated !== null)
        if (a === null) {
          if (!v)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (xY(o), bi(o), (o.mode & mt) !== pt) {
            var _ = f !== null;
            if (_) {
              var b = o.child;
              b !== null && (o.treeBaseDuration -= b.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (pp(), (o.flags & St) === dt && (o.memoizedState = null), o.flags |= Mt, bi(o), (o.mode & mt) !== pt) {
            var E = f !== null;
            if (E) {
              var A = o.child;
              A !== null && (o.treeBaseDuration -= A.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return VP(), !0;
    }
    function sN(a, o, f) {
      var v = o.pendingProps;
      switch (vw(o), o.tag) {
        case m:
        case ee:
        case Z:
        case h:
        case z:
        case O:
        case D:
        case V:
        case L:
        case j:
          return bi(o), null;
        case p: {
          var _ = o.type;
          return fl(_) && Rb(o), bi(o), null;
        }
        case x: {
          var b = o.stateNode;
          if (yp(o), cw(o), Jw(), b.pendingContext && (b.context = b.pendingContext, b.pendingContext = null), a === null || a.child === null) {
            var E = Nb(o);
            if (E)
              wp(o);
            else if (a !== null) {
              var A = a.memoizedState;
              // Check if this is a client root
              (!A.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (o.flags & Wr) !== dt) && (o.flags |= Oa, VP());
            }
          }
          return GA(a, o), bi(o), null;
        }
        case T: {
          qw(o);
          var R = aI(), N = o.type;
          if (a !== null && o.stateNode != null)
            aN(a, o, N, v, R), a.ref !== o.ref && nN(o);
          else {
            if (!v) {
              if (o.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return bi(o), null;
            }
            var B = Xw(), K = Nb(o);
            if (K)
              _Y(o, R, B) && wp(o);
            else {
              var X = i6(N, v, R, B, o);
              iN(X, o, !1, !1), o.stateNode = X, o6(X, N, v, R) && wp(o);
            }
            o.ref !== null && nN(o);
          }
          return bi(o), null;
        }
        case k: {
          var ce = v;
          if (a && o.stateNode != null) {
            var oe = a.memoizedProps;
            oN(a, o, oe, ce);
          } else {
            if (typeof ce != "string" && o.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var ve = aI(), Ye = Xw(), ft = Nb(o);
            ft ? yY(o) && wp(o) : o.stateNode = l6(ce, ve, Ye, o);
          }
          return bi(o), null;
        }
        case P: {
          bp(o);
          var ot = o.memoizedState;
          if (a === null || a.memoizedState !== null && a.memoizedState.dehydrated !== null) {
            var Ht = VW(a, o, ot);
            if (!Ht)
              return o.flags & Dn ? o : null;
          }
          if ((o.flags & St) !== dt)
            return o.lanes = f, (o.mode & mt) !== pt && EA(o), o;
          var Gt = ot !== null, ne = a !== null && a.memoizedState !== null;
          if (Gt !== ne && Gt) {
            var ge = o.child;
            if (ge.flags |= Ks, (o.mode & Ft) !== pt) {
              var ie = a === null && (o.memoizedProps.unstable_avoidThisFallback !== !0 || !se);
              ie || Kw(gs.current, lI) ? U8() : sO();
            }
          }
          var Me = o.updateQueue;
          if (Me !== null && (o.flags |= Mt), bi(o), (o.mode & mt) !== pt && Gt) {
            var Ke = o.child;
            Ke !== null && (o.treeBaseDuration -= Ke.treeBaseDuration);
          }
          return null;
        }
        case S:
          return yp(o), GA(a, o), a === null && tY(o.stateNode.containerInfo), bi(o), null;
        case F:
          var $e = o.type._context;
          return Cw($e, o), bi(o), null;
        case J: {
          var xt = o.type;
          return fl(xt) && Rb(o), bi(o), null;
        }
        case de: {
          bp(o);
          var Ot = o.memoizedState;
          if (Ot === null)
            return bi(o), null;
          var pr = (o.flags & St) !== dt, er = Ot.rendering;
          if (er === null)
            if (pr)
              q0(Ot, !1);
            else {
              var bn = $8() && (a === null || (a.flags & St) === dt);
              if (!bn)
                for (var tr = o.child; tr !== null; ) {
                  var un = Jb(tr);
                  if (un !== null) {
                    pr = !0, o.flags |= St, q0(Ot, !1);
                    var Ui = un.updateQueue;
                    return Ui !== null && (o.updateQueue = Ui, o.flags |= Mt), o.subtreeFlags = dt, zY(o, f), ed(o, Zw(gs.current, F0)), o.child;
                  }
                  tr = tr.sibling;
                }
              Ot.tail !== null && zr() > kN() && (o.flags |= St, pr = !0, q0(Ot, !1), o.lanes = Gm);
            }
          else {
            if (!pr) {
              var wi = Jb(er);
              if (wi !== null) {
                o.flags |= St, pr = !0;
                var uo = wi.updateQueue;
                if (uo !== null && (o.updateQueue = uo, o.flags |= Mt), q0(Ot, !0), Ot.tail === null && Ot.tailMode === "hidden" && !er.alternate && !yi())
                  return bi(o), null;
              } else
                // The time it took to render last row is greater than the remaining
                // time we have to render. So rendering one more row would likely
                // exceed it.
                zr() * 2 - Ot.renderingStartTime > kN() && f !== Fi && (o.flags |= St, pr = !0, q0(Ot, !1), o.lanes = Gm);
            }
            if (Ot.isBackwards)
              er.sibling = o.child, o.child = er;
            else {
              var da = Ot.last;
              da !== null ? da.sibling = er : o.child = er, Ot.last = er;
            }
          }
          if (Ot.tail !== null) {
            var fa = Ot.tail;
            Ot.rendering = fa, Ot.tail = fa.sibling, Ot.renderingStartTime = zr(), fa.sibling = null;
            var ji = gs.current;
            return pr ? ji = Zw(ji, F0) : ji = xp(ji), ed(o, ji), fa;
          }
          return bi(o), null;
        }
        case Re:
          break;
        case Ce:
        case le: {
          oO(o);
          var Lu = o.memoizedState, Pp = Lu !== null;
          if (a !== null) {
            var d_ = a.memoizedState, xl = d_ !== null;
            xl !== Pp && // LegacyHidden doesn't do any hiding — it only pre-renders.
            !G && (o.flags |= Ks);
          }
          return !Pp || (o.mode & Ft) === pt ? bi(o) : Bi(yl, Fi) && (bi(o), o.subtreeFlags & (wr | Mt) && (o.flags |= Ks)), null;
        }
        case me:
          return null;
        case fe:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + o.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function FW(a, o, f) {
      switch (vw(o), o.tag) {
        case p: {
          var v = o.type;
          fl(v) && Rb(o);
          var _ = o.flags;
          return _ & Dn ? (o.flags = _ & ~Dn | St, (o.mode & mt) !== pt && EA(o), o) : null;
        }
        case x: {
          var b = o.stateNode;
          yp(o), cw(o), Jw();
          var E = o.flags;
          return (E & Dn) !== dt && (E & St) === dt ? (o.flags = E & ~Dn | St, o) : null;
        }
        case T:
          return qw(o), null;
        case P: {
          bp(o);
          var A = o.memoizedState;
          if (A !== null && A.dehydrated !== null) {
            if (o.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            pp();
          }
          var R = o.flags;
          return R & Dn ? (o.flags = R & ~Dn | St, (o.mode & mt) !== pt && EA(o), o) : null;
        }
        case de:
          return bp(o), null;
        case S:
          return yp(o), null;
        case F:
          var N = o.type._context;
          return Cw(N, o), null;
        case Ce:
        case le:
          return oO(o), null;
        case me:
          return null;
        default:
          return null;
      }
    }
    function lN(a, o, f) {
      switch (vw(o), o.tag) {
        case p: {
          var v = o.type.childContextTypes;
          v != null && Rb(o);
          break;
        }
        case x: {
          var _ = o.stateNode;
          yp(o), cw(o), Jw();
          break;
        }
        case T: {
          qw(o);
          break;
        }
        case S:
          yp(o);
          break;
        case P:
          bp(o);
          break;
        case de:
          bp(o);
          break;
        case F:
          var b = o.type._context;
          Cw(b, o);
          break;
        case Ce:
        case le:
          oO(o);
          break;
      }
    }
    var uN = null;
    uN = /* @__PURE__ */ new Set();
    var SS = !1, Si = !1, BW = typeof WeakSet == "function" ? WeakSet : Set, nt = null, Ap = null, Op = null;
    function zW(a) {
      eu(null, function() {
        throw a;
      }), Am();
    }
    var HW = function(a, o) {
      if (o.props = a.memoizedProps, o.state = a.memoizedState, a.mode & mt)
        try {
          ml(), o.componentWillUnmount();
        } finally {
          gl(a);
        }
      else
        o.componentWillUnmount();
    };
    function cN(a, o) {
      try {
        nd(Un, a);
      } catch (f) {
        Rr(a, o, f);
      }
    }
    function UA(a, o, f) {
      try {
        HW(a, f);
      } catch (v) {
        Rr(a, o, v);
      }
    }
    function GW(a, o, f) {
      try {
        f.componentDidMount();
      } catch (v) {
        Rr(a, o, v);
      }
    }
    function dN(a, o) {
      try {
        vN(a);
      } catch (f) {
        Rr(a, o, f);
      }
    }
    function kp(a, o) {
      var f = a.ref;
      if (f !== null)
        if (typeof f == "function") {
          var v;
          try {
            if (Ue && Ze && a.mode & mt)
              try {
                ml(), v = f(null);
              } finally {
                gl(a);
              }
            else
              v = f(null);
          } catch (_) {
            Rr(a, o, _);
          }
          typeof v == "function" && l("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", kt(a));
        } else
          f.current = null;
    }
    function CS(a, o, f) {
      try {
        f();
      } catch (v) {
        Rr(a, o, v);
      }
    }
    var fN = null, hN = !1;
    function UW(a, o) {
      fN = r6(a.containerInfo), nt = o, jW();
      var f = hN;
      return hN = !1, fN = null, f;
    }
    function jW() {
      for (; nt !== null; ) {
        var a = nt, o = a.child;
        (a.subtreeFlags & Cc) !== dt && o !== null ? (o.return = a, nt = o) : $W();
      }
    }
    function $W() {
      for (; nt !== null; ) {
        var a = nt;
        hr(a);
        try {
          YW(a);
        } catch (f) {
          Rr(a, a.return, f);
        }
        vn();
        var o = a.sibling;
        if (o !== null) {
          o.return = a.return, nt = o;
          return;
        }
        nt = a.return;
      }
    }
    function YW(a) {
      var o = a.alternate, f = a.flags;
      if ((f & Oa) !== dt) {
        switch (hr(a), a.tag) {
          case h:
          case z:
          case Z:
            break;
          case p: {
            if (o !== null) {
              var v = o.memoizedProps, _ = o.memoizedState, b = a.stateNode;
              a.type === a.elementType && !Qf && (b.props !== a.memoizedProps && l("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", kt(a) || "instance"), b.state !== a.memoizedState && l("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", kt(a) || "instance"));
              var E = b.getSnapshotBeforeUpdate(a.elementType === a.type ? v : ps(a.type, v), _);
              {
                var A = uN;
                E === void 0 && !A.has(a.type) && (A.add(a.type), l("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", kt(a)));
              }
              b.__reactInternalSnapshotBeforeUpdate = E;
            }
            break;
          }
          case x: {
            {
              var R = a.stateNode;
              A6(R.containerInfo);
            }
            break;
          }
          case T:
          case k:
          case S:
          case J:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        vn();
      }
    }
    function ys(a, o, f) {
      var v = o.updateQueue, _ = v !== null ? v.lastEffect : null;
      if (_ !== null) {
        var b = _.next, E = b;
        do {
          if ((E.tag & a) === a) {
            var A = E.destroy;
            E.destroy = void 0, A !== void 0 && ((a & xi) !== za ? _v(o) : (a & Un) !== za && yv(o), (a & hl) !== za && l_(!0), CS(o, f, A), (a & hl) !== za && l_(!1), (a & xi) !== za ? Ix() : (a & Un) !== za && Ec());
          }
          E = E.next;
        } while (E !== b);
      }
    }
    function nd(a, o) {
      var f = o.updateQueue, v = f !== null ? f.lastEffect : null;
      if (v !== null) {
        var _ = v.next, b = _;
        do {
          if ((b.tag & a) === a) {
            (a & xi) !== za ? Px(o) : (a & Un) !== za && Nx(o);
            var E = b.create;
            (a & hl) !== za && l_(!0), b.destroy = E(), (a & hl) !== za && l_(!1), (a & xi) !== za ? Bm() : (a & Un) !== za && Vx();
            {
              var A = b.destroy;
              if (A !== void 0 && typeof A != "function") {
                var R = void 0;
                (b.tag & Un) !== dt ? R = "useLayoutEffect" : (b.tag & hl) !== dt ? R = "useInsertionEffect" : R = "useEffect";
                var N = void 0;
                A === null ? N = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof A.then == "function" ? N = `

It looks like you wrote ` + R + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + R + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : N = " You returned: " + A, l("%s must not return anything besides a function, which is used for clean-up.%s", R, N);
              }
            }
          }
          b = b.next;
        } while (b !== _);
      }
    }
    function WW(a, o) {
      if ((o.flags & Mt) !== dt)
        switch (o.tag) {
          case V: {
            var f = o.stateNode.passiveEffectDuration, v = o.memoizedProps, _ = v.id, b = v.onPostCommit, E = PI(), A = o.alternate === null ? "mount" : "update";
            LI() && (A = "nested-update"), typeof b == "function" && b(_, A, f, E);
            var R = o.return;
            e:
              for (; R !== null; ) {
                switch (R.tag) {
                  case x:
                    var N = R.stateNode;
                    N.passiveEffectDuration += f;
                    break e;
                  case V:
                    var B = R.stateNode;
                    B.passiveEffectDuration += f;
                    break e;
                }
                R = R.return;
              }
            break;
          }
        }
    }
    function XW(a, o, f, v) {
      if ((f.flags & ni) !== dt)
        switch (f.tag) {
          case h:
          case z:
          case Z: {
            if (!Si)
              if (f.mode & mt)
                try {
                  ml(), nd(Un | Gn, f);
                } finally {
                  gl(f);
                }
              else
                nd(Un | Gn, f);
            break;
          }
          case p: {
            var _ = f.stateNode;
            if (f.flags & Mt && !Si)
              if (o === null)
                if (f.type === f.elementType && !Qf && (_.props !== f.memoizedProps && l("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", kt(f) || "instance"), _.state !== f.memoizedState && l("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", kt(f) || "instance")), f.mode & mt)
                  try {
                    ml(), _.componentDidMount();
                  } finally {
                    gl(f);
                  }
                else
                  _.componentDidMount();
              else {
                var b = f.elementType === f.type ? o.memoizedProps : ps(f.type, o.memoizedProps), E = o.memoizedState;
                if (f.type === f.elementType && !Qf && (_.props !== f.memoizedProps && l("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", kt(f) || "instance"), _.state !== f.memoizedState && l("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", kt(f) || "instance")), f.mode & mt)
                  try {
                    ml(), _.componentDidUpdate(b, E, _.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    gl(f);
                  }
                else
                  _.componentDidUpdate(b, E, _.__reactInternalSnapshotBeforeUpdate);
              }
            var A = f.updateQueue;
            A !== null && (f.type === f.elementType && !Qf && (_.props !== f.memoizedProps && l("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", kt(f) || "instance"), _.state !== f.memoizedState && l("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", kt(f) || "instance")), WP(f, A, _));
            break;
          }
          case x: {
            var R = f.updateQueue;
            if (R !== null) {
              var N = null;
              if (f.child !== null)
                switch (f.child.tag) {
                  case T:
                    N = f.child.stateNode;
                    break;
                  case p:
                    N = f.child.stateNode;
                    break;
                }
              WP(f, R, N);
            }
            break;
          }
          case T: {
            var B = f.stateNode;
            if (o === null && f.flags & Mt) {
              var K = f.type, X = f.memoizedProps;
              h6(B, K, X);
            }
            break;
          }
          case k:
            break;
          case S:
            break;
          case V: {
            {
              var ce = f.memoizedProps, oe = ce.onCommit, ve = ce.onRender, Ye = f.stateNode.effectDuration, ft = PI(), ot = o === null ? "mount" : "update";
              LI() && (ot = "nested-update"), typeof ve == "function" && ve(f.memoizedProps.id, ot, f.actualDuration, f.treeBaseDuration, f.actualStartTime, ft);
              {
                typeof oe == "function" && oe(f.memoizedProps.id, ot, Ye, ft), K8(f);
                var Ht = f.return;
                e:
                  for (; Ht !== null; ) {
                    switch (Ht.tag) {
                      case x:
                        var Gt = Ht.stateNode;
                        Gt.effectDuration += Ye;
                        break e;
                      case V:
                        var ne = Ht.stateNode;
                        ne.effectDuration += Ye;
                        break e;
                    }
                    Ht = Ht.return;
                  }
              }
            }
            break;
          }
          case P: {
            r8(a, f);
            break;
          }
          case de:
          case J:
          case Re:
          case Ce:
          case le:
          case fe:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      Si || f.flags & Mi && vN(f);
    }
    function qW(a) {
      switch (a.tag) {
        case h:
        case z:
        case Z: {
          if (a.mode & mt)
            try {
              ml(), cN(a, a.return);
            } finally {
              gl(a);
            }
          else
            cN(a, a.return);
          break;
        }
        case p: {
          var o = a.stateNode;
          typeof o.componentDidMount == "function" && GW(a, a.return, o), dN(a, a.return);
          break;
        }
        case T: {
          dN(a, a.return);
          break;
        }
      }
    }
    function KW(a, o) {
      for (var f = null, v = a; ; ) {
        if (v.tag === T) {
          if (f === null) {
            f = v;
            try {
              var _ = v.stateNode;
              o ? C6(_) : T6(v.stateNode, v.memoizedProps);
            } catch (E) {
              Rr(a, a.return, E);
            }
          }
        } else if (v.tag === k) {
          if (f === null)
            try {
              var b = v.stateNode;
              o ? E6(b) : w6(b, v.memoizedProps);
            } catch (E) {
              Rr(a, a.return, E);
            }
        } else if (!((v.tag === Ce || v.tag === le) && v.memoizedState !== null && v !== a)) {
          if (v.child !== null) {
            v.child.return = v, v = v.child;
            continue;
          }
        }
        if (v === a)
          return;
        for (; v.sibling === null; ) {
          if (v.return === null || v.return === a)
            return;
          f === v && (f = null), v = v.return;
        }
        f === v && (f = null), v.sibling.return = v.return, v = v.sibling;
      }
    }
    function vN(a) {
      var o = a.ref;
      if (o !== null) {
        var f = a.stateNode, v;
        switch (a.tag) {
          case T:
            v = f;
            break;
          default:
            v = f;
        }
        if (typeof o == "function") {
          var _;
          if (a.mode & mt)
            try {
              ml(), _ = o(v);
            } finally {
              gl(a);
            }
          else
            _ = o(v);
          typeof _ == "function" && l("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", kt(a));
        } else
          o.hasOwnProperty("current") || l("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", kt(a)), o.current = v;
      }
    }
    function ZW(a) {
      var o = a.alternate;
      o !== null && (o.return = null), a.return = null;
    }
    function pN(a) {
      var o = a.alternate;
      o !== null && (a.alternate = null, pN(o));
      {
        if (a.child = null, a.deletions = null, a.sibling = null, a.tag === T) {
          var f = a.stateNode;
          f !== null && iY(f);
        }
        a.stateNode = null, a._debugOwner = null, a.return = null, a.dependencies = null, a.memoizedProps = null, a.memoizedState = null, a.pendingProps = null, a.stateNode = null, a.updateQueue = null;
      }
    }
    function QW(a) {
      for (var o = a.return; o !== null; ) {
        if (gN(o))
          return o;
        o = o.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function gN(a) {
      return a.tag === T || a.tag === x || a.tag === S;
    }
    function mN(a) {
      var o = a;
      e:
        for (; ; ) {
          for (; o.sibling === null; ) {
            if (o.return === null || gN(o.return))
              return null;
            o = o.return;
          }
          for (o.sibling.return = o.return, o = o.sibling; o.tag !== T && o.tag !== k && o.tag !== he; ) {
            if (o.flags & wr || o.child === null || o.tag === S)
              continue e;
            o.child.return = o, o = o.child;
          }
          if (!(o.flags & wr))
            return o.stateNode;
        }
    }
    function JW(a) {
      var o = QW(a);
      switch (o.tag) {
        case T: {
          var f = o.stateNode;
          o.flags & ar && (mP(f), o.flags &= ~ar);
          var v = mN(a);
          $A(a, v, f);
          break;
        }
        case x:
        case S: {
          var _ = o.stateNode.containerInfo, b = mN(a);
          jA(a, b, _);
          break;
        }
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function jA(a, o, f) {
      var v = a.tag, _ = v === T || v === k;
      if (_) {
        var b = a.stateNode;
        o ? y6(f, b, o) : m6(f, b);
      } else if (v !== S) {
        var E = a.child;
        if (E !== null) {
          jA(E, o, f);
          for (var A = E.sibling; A !== null; )
            jA(A, o, f), A = A.sibling;
        }
      }
    }
    function $A(a, o, f) {
      var v = a.tag, _ = v === T || v === k;
      if (_) {
        var b = a.stateNode;
        o ? _6(f, b, o) : g6(f, b);
      } else if (v !== S) {
        var E = a.child;
        if (E !== null) {
          $A(E, o, f);
          for (var A = E.sibling; A !== null; )
            $A(A, o, f), A = A.sibling;
        }
      }
    }
    var Ci = null, xs = !1;
    function e8(a, o, f) {
      {
        var v = o;
        e:
          for (; v !== null; ) {
            switch (v.tag) {
              case T: {
                Ci = v.stateNode, xs = !1;
                break e;
              }
              case x: {
                Ci = v.stateNode.containerInfo, xs = !0;
                break e;
              }
              case S: {
                Ci = v.stateNode.containerInfo, xs = !0;
                break e;
              }
            }
            v = v.return;
          }
        if (Ci === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        _N(a, o, f), Ci = null, xs = !1;
      }
      ZW(f);
    }
    function id(a, o, f) {
      for (var v = f.child; v !== null; )
        _N(a, o, v), v = v.sibling;
    }
    function _N(a, o, f) {
      switch (Vm(f), f.tag) {
        case T:
          Si || kp(f, o);
        case k: {
          {
            var v = Ci, _ = xs;
            Ci = null, id(a, o, f), Ci = v, xs = _, Ci !== null && (xs ? b6(Ci, f.stateNode) : x6(Ci, f.stateNode));
          }
          return;
        }
        case he: {
          Ci !== null && (xs ? S6(Ci, f.stateNode) : rw(Ci, f.stateNode));
          return;
        }
        case S: {
          {
            var b = Ci, E = xs;
            Ci = f.stateNode.containerInfo, xs = !0, id(a, o, f), Ci = b, xs = E;
          }
          return;
        }
        case h:
        case z:
        case j:
        case Z: {
          if (!Si) {
            var A = f.updateQueue;
            if (A !== null) {
              var R = A.lastEffect;
              if (R !== null) {
                var N = R.next, B = N;
                do {
                  var K = B, X = K.destroy, ce = K.tag;
                  X !== void 0 && ((ce & hl) !== za ? CS(f, o, X) : (ce & Un) !== za && (yv(f), f.mode & mt ? (ml(), CS(f, o, X), gl(f)) : CS(f, o, X), Ec())), B = B.next;
                } while (B !== N);
              }
            }
          }
          id(a, o, f);
          return;
        }
        case p: {
          if (!Si) {
            kp(f, o);
            var oe = f.stateNode;
            typeof oe.componentWillUnmount == "function" && UA(f, o, oe);
          }
          id(a, o, f);
          return;
        }
        case Re: {
          id(a, o, f);
          return;
        }
        case Ce: {
          if (
            // TODO: Remove this dead flag
            f.mode & Ft
          ) {
            var ve = Si;
            Si = ve || f.memoizedState !== null, id(a, o, f), Si = ve;
          } else
            id(a, o, f);
          break;
        }
        default: {
          id(a, o, f);
          return;
        }
      }
    }
    function t8(a) {
      var o = a.memoizedState;
    }
    function r8(a, o) {
      var f = o.memoizedState;
      if (f === null) {
        var v = o.alternate;
        if (v !== null) {
          var _ = v.memoizedState;
          if (_ !== null) {
            var b = _.dehydrated;
            b !== null && H6(b);
          }
        }
      }
    }
    function yN(a) {
      var o = a.updateQueue;
      if (o !== null) {
        a.updateQueue = null;
        var f = a.stateNode;
        f === null && (f = a.stateNode = new BW()), o.forEach(function(v) {
          var _ = n9.bind(null, a, v);
          if (!f.has(v)) {
            if (f.add(v), zn)
              if (Ap !== null && Op !== null)
                s_(Op, Ap);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            v.then(_, _);
          }
        });
      }
    }
    function n8(a, o, f) {
      Ap = f, Op = a, hr(o), xN(o, a), hr(o), Ap = null, Op = null;
    }
    function bs(a, o, f) {
      var v = o.deletions;
      if (v !== null)
        for (var _ = 0; _ < v.length; _++) {
          var b = v[_];
          try {
            e8(a, o, b);
          } catch (R) {
            Rr(b, o, R);
          }
        }
      var E = t1();
      if (o.subtreeFlags & Ii)
        for (var A = o.child; A !== null; )
          hr(A), xN(A, a), A = A.sibling;
      hr(E);
    }
    function xN(a, o, f) {
      var v = a.alternate, _ = a.flags;
      switch (a.tag) {
        case h:
        case z:
        case j:
        case Z: {
          if (bs(o, a), _l(a), _ & Mt) {
            try {
              ys(hl | Gn, a, a.return), nd(hl | Gn, a);
            } catch (xt) {
              Rr(a, a.return, xt);
            }
            if (a.mode & mt) {
              try {
                ml(), ys(Un | Gn, a, a.return);
              } catch (xt) {
                Rr(a, a.return, xt);
              }
              gl(a);
            } else
              try {
                ys(Un | Gn, a, a.return);
              } catch (xt) {
                Rr(a, a.return, xt);
              }
          }
          return;
        }
        case p: {
          bs(o, a), _l(a), _ & Mi && v !== null && kp(v, v.return);
          return;
        }
        case T: {
          bs(o, a), _l(a), _ & Mi && v !== null && kp(v, v.return);
          {
            if (a.flags & ar) {
              var b = a.stateNode;
              try {
                mP(b);
              } catch (xt) {
                Rr(a, a.return, xt);
              }
            }
            if (_ & Mt) {
              var E = a.stateNode;
              if (E != null) {
                var A = a.memoizedProps, R = v !== null ? v.memoizedProps : A, N = a.type, B = a.updateQueue;
                if (a.updateQueue = null, B !== null)
                  try {
                    v6(E, B, N, R, A, a);
                  } catch (xt) {
                    Rr(a, a.return, xt);
                  }
              }
            }
          }
          return;
        }
        case k: {
          if (bs(o, a), _l(a), _ & Mt) {
            if (a.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var K = a.stateNode, X = a.memoizedProps, ce = v !== null ? v.memoizedProps : X;
            try {
              p6(K, ce, X);
            } catch (xt) {
              Rr(a, a.return, xt);
            }
          }
          return;
        }
        case x: {
          if (bs(o, a), _l(a), _ & Mt && v !== null) {
            var oe = v.memoizedState;
            if (oe.isDehydrated)
              try {
                z6(o.containerInfo);
              } catch (xt) {
                Rr(a, a.return, xt);
              }
          }
          return;
        }
        case S: {
          bs(o, a), _l(a);
          return;
        }
        case P: {
          bs(o, a), _l(a);
          var ve = a.child;
          if (ve.flags & Ks) {
            var Ye = ve.stateNode, ft = ve.memoizedState, ot = ft !== null;
            if (Ye.isHidden = ot, ot) {
              var Ht = ve.alternate !== null && ve.alternate.memoizedState !== null;
              Ht || G8();
            }
          }
          if (_ & Mt) {
            try {
              t8(a);
            } catch (xt) {
              Rr(a, a.return, xt);
            }
            yN(a);
          }
          return;
        }
        case Ce: {
          var Gt = v !== null && v.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            a.mode & Ft
          ) {
            var ne = Si;
            Si = ne || Gt, bs(o, a), Si = ne;
          } else
            bs(o, a);
          if (_l(a), _ & Ks) {
            var ge = a.stateNode, ie = a.memoizedState, Me = ie !== null, Ke = a;
            if (ge.isHidden = Me, Me && !Gt && (Ke.mode & Ft) !== pt) {
              nt = Ke;
              for (var $e = Ke.child; $e !== null; )
                nt = $e, a8($e), $e = $e.sibling;
            }
            KW(Ke, Me);
          }
          return;
        }
        case de: {
          bs(o, a), _l(a), _ & Mt && yN(a);
          return;
        }
        case Re:
          return;
        default: {
          bs(o, a), _l(a);
          return;
        }
      }
    }
    function _l(a) {
      var o = a.flags;
      if (o & wr) {
        try {
          JW(a);
        } catch (f) {
          Rr(a, a.return, f);
        }
        a.flags &= ~wr;
      }
      o & ka && (a.flags &= ~ka);
    }
    function i8(a, o, f) {
      Ap = f, Op = o, nt = a, bN(a, o, f), Ap = null, Op = null;
    }
    function bN(a, o, f) {
      for (var v = (a.mode & Ft) !== pt; nt !== null; ) {
        var _ = nt, b = _.child;
        if (_.tag === Ce && v) {
          var E = _.memoizedState !== null, A = E || SS;
          if (A) {
            YA(a, o, f);
            continue;
          } else {
            var R = _.alternate, N = R !== null && R.memoizedState !== null, B = N || Si, K = SS, X = Si;
            SS = A, Si = B, Si && !X && (nt = _, o8(_));
            for (var ce = b; ce !== null; )
              nt = ce, bN(
                ce,
                // New root; bubble back up to here and stop.
                o,
                f
              ), ce = ce.sibling;
            nt = _, SS = K, Si = X, YA(a, o, f);
            continue;
          }
        }
        (_.subtreeFlags & ni) !== dt && b !== null ? (b.return = _, nt = b) : YA(a, o, f);
      }
    }
    function YA(a, o, f) {
      for (; nt !== null; ) {
        var v = nt;
        if ((v.flags & ni) !== dt) {
          var _ = v.alternate;
          hr(v);
          try {
            XW(o, _, v, f);
          } catch (E) {
            Rr(v, v.return, E);
          }
          vn();
        }
        if (v === a) {
          nt = null;
          return;
        }
        var b = v.sibling;
        if (b !== null) {
          b.return = v.return, nt = b;
          return;
        }
        nt = v.return;
      }
    }
    function a8(a) {
      for (; nt !== null; ) {
        var o = nt, f = o.child;
        switch (o.tag) {
          case h:
          case z:
          case j:
          case Z: {
            if (o.mode & mt)
              try {
                ml(), ys(Un, o, o.return);
              } finally {
                gl(o);
              }
            else
              ys(Un, o, o.return);
            break;
          }
          case p: {
            kp(o, o.return);
            var v = o.stateNode;
            typeof v.componentWillUnmount == "function" && UA(o, o.return, v);
            break;
          }
          case T: {
            kp(o, o.return);
            break;
          }
          case Ce: {
            var _ = o.memoizedState !== null;
            if (_) {
              SN(a);
              continue;
            }
            break;
          }
        }
        f !== null ? (f.return = o, nt = f) : SN(a);
      }
    }
    function SN(a) {
      for (; nt !== null; ) {
        var o = nt;
        if (o === a) {
          nt = null;
          return;
        }
        var f = o.sibling;
        if (f !== null) {
          f.return = o.return, nt = f;
          return;
        }
        nt = o.return;
      }
    }
    function o8(a) {
      for (; nt !== null; ) {
        var o = nt, f = o.child;
        if (o.tag === Ce) {
          var v = o.memoizedState !== null;
          if (v) {
            CN(a);
            continue;
          }
        }
        f !== null ? (f.return = o, nt = f) : CN(a);
      }
    }
    function CN(a) {
      for (; nt !== null; ) {
        var o = nt;
        hr(o);
        try {
          qW(o);
        } catch (v) {
          Rr(o, o.return, v);
        }
        if (vn(), o === a) {
          nt = null;
          return;
        }
        var f = o.sibling;
        if (f !== null) {
          f.return = o.return, nt = f;
          return;
        }
        nt = o.return;
      }
    }
    function s8(a, o, f, v) {
      nt = o, l8(o, a, f, v);
    }
    function l8(a, o, f, v) {
      for (; nt !== null; ) {
        var _ = nt, b = _.child;
        (_.subtreeFlags & Ra) !== dt && b !== null ? (b.return = _, nt = b) : u8(a, o, f, v);
      }
    }
    function u8(a, o, f, v) {
      for (; nt !== null; ) {
        var _ = nt;
        if ((_.flags & Pr) !== dt) {
          hr(_);
          try {
            c8(o, _, f, v);
          } catch (E) {
            Rr(_, _.return, E);
          }
          vn();
        }
        if (_ === a) {
          nt = null;
          return;
        }
        var b = _.sibling;
        if (b !== null) {
          b.return = _.return, nt = b;
          return;
        }
        nt = _.return;
      }
    }
    function c8(a, o, f, v) {
      switch (o.tag) {
        case h:
        case z:
        case Z: {
          if (o.mode & mt) {
            CA();
            try {
              nd(xi | Gn, o);
            } finally {
              SA(o);
            }
          } else
            nd(xi | Gn, o);
          break;
        }
      }
    }
    function d8(a) {
      nt = a, f8();
    }
    function f8() {
      for (; nt !== null; ) {
        var a = nt, o = a.child;
        if ((nt.flags & nr) !== dt) {
          var f = a.deletions;
          if (f !== null) {
            for (var v = 0; v < f.length; v++) {
              var _ = f[v];
              nt = _, p8(_, a);
            }
            {
              var b = a.alternate;
              if (b !== null) {
                var E = b.child;
                if (E !== null) {
                  b.child = null;
                  do {
                    var A = E.sibling;
                    E.sibling = null, E = A;
                  } while (E !== null);
                }
              }
            }
            nt = a;
          }
        }
        (a.subtreeFlags & Ra) !== dt && o !== null ? (o.return = a, nt = o) : h8();
      }
    }
    function h8() {
      for (; nt !== null; ) {
        var a = nt;
        (a.flags & Pr) !== dt && (hr(a), v8(a), vn());
        var o = a.sibling;
        if (o !== null) {
          o.return = a.return, nt = o;
          return;
        }
        nt = a.return;
      }
    }
    function v8(a) {
      switch (a.tag) {
        case h:
        case z:
        case Z: {
          a.mode & mt ? (CA(), ys(xi | Gn, a, a.return), SA(a)) : ys(xi | Gn, a, a.return);
          break;
        }
      }
    }
    function p8(a, o) {
      for (; nt !== null; ) {
        var f = nt;
        hr(f), m8(f, o), vn();
        var v = f.child;
        v !== null ? (v.return = f, nt = v) : g8(a);
      }
    }
    function g8(a) {
      for (; nt !== null; ) {
        var o = nt, f = o.sibling, v = o.return;
        if (pN(o), o === a) {
          nt = null;
          return;
        }
        if (f !== null) {
          f.return = v, nt = f;
          return;
        }
        nt = v;
      }
    }
    function m8(a, o) {
      switch (a.tag) {
        case h:
        case z:
        case Z: {
          a.mode & mt ? (CA(), ys(xi, a, o), SA(a)) : ys(xi, a, o);
          break;
        }
      }
    }
    function _8(a) {
      switch (a.tag) {
        case h:
        case z:
        case Z: {
          try {
            nd(Un | Gn, a);
          } catch (f) {
            Rr(a, a.return, f);
          }
          break;
        }
        case p: {
          var o = a.stateNode;
          try {
            o.componentDidMount();
          } catch (f) {
            Rr(a, a.return, f);
          }
          break;
        }
      }
    }
    function y8(a) {
      switch (a.tag) {
        case h:
        case z:
        case Z: {
          try {
            nd(xi | Gn, a);
          } catch (o) {
            Rr(a, a.return, o);
          }
          break;
        }
      }
    }
    function x8(a) {
      switch (a.tag) {
        case h:
        case z:
        case Z: {
          try {
            ys(Un | Gn, a, a.return);
          } catch (f) {
            Rr(a, a.return, f);
          }
          break;
        }
        case p: {
          var o = a.stateNode;
          typeof o.componentWillUnmount == "function" && UA(a, a.return, o);
          break;
        }
      }
    }
    function b8(a) {
      switch (a.tag) {
        case h:
        case z:
        case Z:
          try {
            ys(xi | Gn, a, a.return);
          } catch (o) {
            Rr(a, a.return, o);
          }
      }
    }
    var S8 = 0, C8 = 1, E8 = 2, T8 = 3, w8 = 4;
    if (typeof Symbol == "function" && Symbol.for) {
      var K0 = Symbol.for;
      S8 = K0("selector.component"), C8 = K0("selector.has_pseudo_class"), E8 = K0("selector.role"), T8 = K0("selector.test_id"), w8 = K0("selector.text");
    }
    var A8 = [];
    function O8() {
      A8.forEach(function(a) {
        return a();
      });
    }
    var k8 = r.ReactCurrentActQueue;
    function R8(a) {
      {
        var o = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), f = typeof jest < "u";
        return f && o !== !1;
      }
    }
    function EN() {
      {
        var a = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !a && k8.current !== null && l("The current testing environment is not configured to support act(...)"), a;
      }
    }
    var D8 = Math.ceil, WA = r.ReactCurrentDispatcher, XA = r.ReactCurrentOwner, Ei = r.ReactCurrentBatchConfig, Ss = r.ReactCurrentActQueue, Yn = (
      /*             */
      0
    ), TN = (
      /*               */
      1
    ), Ti = (
      /*                */
      2
    ), ko = (
      /*                */
      4
    ), ku = 0, Z0 = 1, Jf = 2, ES = 3, Q0 = 4, wN = 5, qA = 6, $t = Yn, ua = null, tn = null, Wn = ye, yl = ye, KA = Xc(ye), Xn = ku, J0 = null, ZA = ye, TS = ye, e_ = ye, wS = ye, t_ = null, Ha = null, QA = 0, AN = 500, ON = 1 / 0, M8 = 500, Ru = null;
    function r_() {
      ON = zr() + M8;
    }
    function kN() {
      return ON;
    }
    var AS = !1, JA = null, Rp = null, eh = !1, ad = null, n_ = ye, eO = [], tO = null, L8 = 50, i_ = 0, rO = null, nO = !1, OS = !1, P8 = 50, Dp = 0, kS = null, a_ = br, RS = ye, RN = !1;
    function DS() {
      return ua;
    }
    function ca() {
      return ($t & (Ti | ko)) !== Yn ? zr() : (a_ !== br || (a_ = zr()), a_);
    }
    function od(a) {
      var o = a.mode;
      if ((o & Ft) === pt)
        return yt;
      if (($t & Ti) !== Yn && Wn !== ye)
        return mn(Wn);
      var f = TY() !== EY;
      if (f) {
        if (Ei.transition !== null) {
          var v = Ei.transition;
          v._updatedFibers || (v._updatedFibers = /* @__PURE__ */ new Set()), v._updatedFibers.add(a);
        }
        return RS === jt && (RS = $m()), RS;
      }
      var _ = Pa();
      if (_ !== jt)
        return _;
      var b = u6();
      return b;
    }
    function I8(a) {
      var o = a.mode;
      return (o & Ft) === pt ? yt : C1();
    }
    function qn(a, o, f, v) {
      a9(), RN && l("useInsertionEffect must not schedule updates."), nO && (OS = !0), fu(a, f, v), ($t & Ti) !== ye && a === ua ? l9(o) : (zn && Km(a, o, f), u9(o), a === ua && (($t & Ti) === Yn && (e_ = Rt(e_, f)), Xn === Q0 && sd(a, Wn)), Ga(a, v), f === yt && $t === Yn && (o.mode & Ft) === pt && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Ss.isBatchingLegacy && (r_(), OP()));
    }
    function N8(a, o, f) {
      var v = a.current;
      v.lanes = o, fu(a, o, f), Ga(a, f);
    }
    function V8(a) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        ($t & Ti) !== Yn
      );
    }
    function Ga(a, o) {
      var f = a.callbackNode;
      x1(a, o);
      var v = Tf(a, a === ua ? Wn : ye);
      if (v === ye) {
        f !== null && YN(f), a.callbackNode = null, a.callbackPriority = jt;
        return;
      }
      var _ = sn(v), b = a.callbackPriority;
      if (b === _ && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Ss.current !== null && f !== cO)) {
        f == null && b !== yt && l("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      f != null && YN(f);
      var E;
      if (_ === yt)
        a.tag === qc ? (Ss.isBatchingLegacy !== null && (Ss.didScheduleLegacyUpdate = !0), sY(LN.bind(null, a))) : AP(LN.bind(null, a)), Ss.current !== null ? Ss.current.push(Kc) : d6(function() {
          ($t & (Ti | ko)) === Yn && Kc();
        }), E = null;
      else {
        var A;
        switch (Rf(v)) {
          case ii:
            A = pv;
            break;
          case Hn:
            A = aa;
            break;
          case ss:
            A = yo;
            break;
          case Of:
            A = Qs;
            break;
          default:
            A = yo;
            break;
        }
        E = dO(A, DN.bind(null, a));
      }
      a.callbackPriority = _, a.callbackNode = E;
    }
    function DN(a, o) {
      if (eW(), a_ = br, RS = ye, ($t & (Ti | ko)) !== Yn)
        throw new Error("Should not already be working.");
      var f = a.callbackNode, v = Mu();
      if (v && a.callbackNode !== f)
        return null;
      var _ = Tf(a, a === ua ? Wn : ye);
      if (_ === ye)
        return null;
      var b = !Af(a, _) && !Ux(a, _) && !o, E = b ? W8(a, _) : LS(a, _);
      if (E !== ku) {
        if (E === Jf) {
          var A = Um(a);
          A !== ye && (_ = A, E = iO(a, A));
        }
        if (E === Z0) {
          var R = J0;
          throw th(a, ye), sd(a, _), Ga(a, zr()), R;
        }
        if (E === qA)
          sd(a, _);
        else {
          var N = !Af(a, _), B = a.current.alternate;
          if (N && !B8(B)) {
            if (E = LS(a, _), E === Jf) {
              var K = Um(a);
              K !== ye && (_ = K, E = iO(a, K));
            }
            if (E === Z0) {
              var X = J0;
              throw th(a, ye), sd(a, _), Ga(a, zr()), X;
            }
          }
          a.finishedWork = B, a.finishedLanes = _, F8(a, E, _);
        }
      }
      return Ga(a, zr()), a.callbackNode === f ? DN.bind(null, a) : null;
    }
    function iO(a, o) {
      var f = t_;
      if (yn(a)) {
        var v = th(a, o);
        v.flags |= Wr, eY(a.containerInfo);
      }
      var _ = LS(a, o);
      if (_ !== Jf) {
        var b = Ha;
        Ha = f, b !== null && MN(b);
      }
      return _;
    }
    function MN(a) {
      Ha === null ? Ha = a : Ha.push.apply(Ha, a);
    }
    function F8(a, o, f) {
      switch (o) {
        case ku:
        case Z0:
          throw new Error("Root did not complete. This is a bug in React.");
        case Jf: {
          rh(a, Ha, Ru);
          break;
        }
        case ES: {
          if (sd(a, f), Bv(f) && // do not delay if we're inside an act() scope
          !WN()) {
            var v = QA + AN - zr();
            if (v > 10) {
              var _ = Tf(a, ye);
              if (_ !== ye)
                break;
              var b = a.suspendedLanes;
              if (!du(b, f)) {
                var E = ca();
                Xm(a, b);
                break;
              }
              a.timeoutHandle = ew(rh.bind(null, a, Ha, Ru), v);
              break;
            }
          }
          rh(a, Ha, Ru);
          break;
        }
        case Q0: {
          if (sd(a, f), Gx(f))
            break;
          if (!WN()) {
            var A = Hx(a, f), R = A, N = zr() - R, B = i9(N) - N;
            if (B > 10) {
              a.timeoutHandle = ew(rh.bind(null, a, Ha, Ru), B);
              break;
            }
          }
          rh(a, Ha, Ru);
          break;
        }
        case wN: {
          rh(a, Ha, Ru);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function B8(a) {
      for (var o = a; ; ) {
        if (o.flags & _f) {
          var f = o.updateQueue;
          if (f !== null) {
            var v = f.stores;
            if (v !== null)
              for (var _ = 0; _ < v.length; _++) {
                var b = v[_], E = b.getSnapshot, A = b.value;
                try {
                  if (!rt(E(), A))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var R = o.child;
        if (o.subtreeFlags & _f && R !== null) {
          R.return = o, o = R;
          continue;
        }
        if (o === a)
          return !0;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === a)
            return !0;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
      return !0;
    }
    function sd(a, o) {
      o = Dc(o, wS), o = Dc(o, e_), Wm(a, o);
    }
    function LN(a) {
      if (tW(), ($t & (Ti | ko)) !== Yn)
        throw new Error("Should not already be working.");
      Mu();
      var o = Tf(a, ye);
      if (!Bi(o, yt))
        return Ga(a, zr()), null;
      var f = LS(a, o);
      if (a.tag !== qc && f === Jf) {
        var v = Um(a);
        v !== ye && (o = v, f = iO(a, v));
      }
      if (f === Z0) {
        var _ = J0;
        throw th(a, ye), sd(a, o), Ga(a, zr()), _;
      }
      if (f === qA)
        throw new Error("Root did not complete. This is a bug in React.");
      var b = a.current.alternate;
      return a.finishedWork = b, a.finishedLanes = o, rh(a, Ha, Ru), Ga(a, zr()), null;
    }
    function z8(a, o) {
      o !== ye && (Mc(a, Rt(o, yt)), Ga(a, zr()), ($t & (Ti | ko)) === Yn && (r_(), Kc()));
    }
    function aO(a, o) {
      var f = $t;
      $t |= TN;
      try {
        return a(o);
      } finally {
        $t = f, $t === Yn && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Ss.isBatchingLegacy && (r_(), OP());
      }
    }
    function H8(a, o, f, v, _) {
      var b = Pa(), E = Ei.transition;
      try {
        return Ei.transition = null, _n(ii), a(o, f, v, _);
      } finally {
        _n(b), Ei.transition = E, $t === Yn && r_();
      }
    }
    function Du(a) {
      ad !== null && ad.tag === qc && ($t & (Ti | ko)) === Yn && Mu();
      var o = $t;
      $t |= TN;
      var f = Ei.transition, v = Pa();
      try {
        return Ei.transition = null, _n(ii), a ? a() : void 0;
      } finally {
        _n(v), Ei.transition = f, $t = o, ($t & (Ti | ko)) === Yn && Kc();
      }
    }
    function PN() {
      return ($t & (Ti | ko)) !== Yn;
    }
    function MS(a, o) {
      Hi(KA, yl, a), yl = Rt(yl, o), ZA = Rt(ZA, o);
    }
    function oO(a) {
      yl = KA.current, zi(KA, a);
    }
    function th(a, o) {
      a.finishedWork = null, a.finishedLanes = ye;
      var f = a.timeoutHandle;
      if (f !== tw && (a.timeoutHandle = tw, c6(f)), tn !== null)
        for (var v = tn.return; v !== null; ) {
          var _ = v.alternate;
          lN(_, v), v = v.return;
        }
      ua = a;
      var b = nh(a.current, null);
      return tn = b, Wn = yl = ZA = o, Xn = ku, J0 = null, TS = ye, e_ = ye, wS = ye, t_ = null, Ha = null, kY(), vs.discardPendingWarnings(), b;
    }
    function IN(a, o) {
      do {
        var f = tn;
        try {
          if (zb(), cI(), vn(), XA.current = null, f === null || f.return === null) {
            Xn = Z0, J0 = o, tn = null;
            return;
          }
          if (Ue && f.mode & mt && _S(f, !0), He)
            if (ru(), o !== null && typeof o == "object" && typeof o.then == "function") {
              var v = o;
              Fx(f, v, Wn);
            } else
              xv(f, o, Wn);
          oW(a, f.return, f, o, Wn), BN(f);
        } catch (_) {
          o = _, tn === f && f !== null ? (f = f.return, tn = f) : f = tn;
          continue;
        }
        return;
      } while (!0);
    }
    function NN() {
      var a = WA.current;
      return WA.current = hS, a === null ? hS : a;
    }
    function VN(a) {
      WA.current = a;
    }
    function G8() {
      QA = zr();
    }
    function o_(a) {
      TS = Rt(a, TS);
    }
    function U8() {
      Xn === ku && (Xn = ES);
    }
    function sO() {
      (Xn === ku || Xn === ES || Xn === Jf) && (Xn = Q0), ua !== null && (wf(TS) || wf(e_)) && sd(ua, Wn);
    }
    function j8(a) {
      Xn !== Q0 && (Xn = Jf), t_ === null ? t_ = [a] : t_.push(a);
    }
    function $8() {
      return Xn === ku;
    }
    function LS(a, o) {
      var f = $t;
      $t |= Ti;
      var v = NN();
      if (ua !== a || Wn !== o) {
        if (zn) {
          var _ = a.memoizedUpdaters;
          _.size > 0 && (s_(a, Wn), _.clear()), Gv(a, o);
        }
        Ru = Zm(), th(a, o);
      }
      ao(o);
      do
        try {
          Y8();
          break;
        } catch (b) {
          IN(a, b);
        }
      while (!0);
      if (zb(), $t = f, VN(v), tn !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return wc(), ua = null, Wn = ye, Xn;
    }
    function Y8() {
      for (; tn !== null; )
        FN(tn);
    }
    function W8(a, o) {
      var f = $t;
      $t |= Ti;
      var v = NN();
      if (ua !== a || Wn !== o) {
        if (zn) {
          var _ = a.memoizedUpdaters;
          _.size > 0 && (s_(a, Wn), _.clear()), Gv(a, o);
        }
        Ru = Zm(), r_(), th(a, o);
      }
      ao(o);
      do
        try {
          X8();
          break;
        } catch (b) {
          IN(a, b);
        }
      while (!0);
      return zb(), VN(v), $t = f, tn !== null ? (bf(), ku) : (wc(), ua = null, Wn = ye, Xn);
    }
    function X8() {
      for (; tn !== null && !vv(); )
        FN(tn);
    }
    function FN(a) {
      var o = a.alternate;
      hr(a);
      var f;
      (a.mode & mt) !== pt ? (bA(a), f = lO(o, a, yl), _S(a, !0)) : f = lO(o, a, yl), vn(), a.memoizedProps = a.pendingProps, f === null ? BN(a) : tn = f, XA.current = null;
    }
    function BN(a) {
      var o = a;
      do {
        var f = o.alternate, v = o.return;
        if ((o.flags & ra) === dt) {
          hr(o);
          var _ = void 0;
          if ((o.mode & mt) === pt ? _ = sN(f, o, yl) : (bA(o), _ = sN(f, o, yl), _S(o, !1)), vn(), _ !== null) {
            tn = _;
            return;
          }
        } else {
          var b = FW(f, o);
          if (b !== null) {
            b.flags &= kx, tn = b;
            return;
          }
          if ((o.mode & mt) !== pt) {
            _S(o, !1);
            for (var E = o.actualDuration, A = o.child; A !== null; )
              E += A.actualDuration, A = A.sibling;
            o.actualDuration = E;
          }
          if (v !== null)
            v.flags |= ra, v.subtreeFlags = dt, v.deletions = null;
          else {
            Xn = qA, tn = null;
            return;
          }
        }
        var R = o.sibling;
        if (R !== null) {
          tn = R;
          return;
        }
        o = v, tn = o;
      } while (o !== null);
      Xn === ku && (Xn = wN);
    }
    function rh(a, o, f) {
      var v = Pa(), _ = Ei.transition;
      try {
        Ei.transition = null, _n(ii), q8(a, o, f, v);
      } finally {
        Ei.transition = _, _n(v);
      }
      return null;
    }
    function q8(a, o, f, v) {
      do
        Mu();
      while (ad !== null);
      if (o9(), ($t & (Ti | ko)) !== Yn)
        throw new Error("Should not already be working.");
      var _ = a.finishedWork, b = a.finishedLanes;
      if (mv(b), _ === null)
        return Fm(), null;
      if (b === ye && l("root.finishedLanes should not be empty during a commit. This is a bug in React."), a.finishedWork = null, a.finishedLanes = ye, _ === a.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      a.callbackNode = null, a.callbackPriority = jt;
      var E = Rt(_.lanes, _.childLanes);
      qm(a, E), a === ua && (ua = null, tn = null, Wn = ye), ((_.subtreeFlags & Ra) !== dt || (_.flags & Ra) !== dt) && (eh || (eh = !0, tO = f, dO(yo, function() {
        return Mu(), null;
      })));
      var A = (_.subtreeFlags & (Cc | Ii | ni | Ra)) !== dt, R = (_.flags & (Cc | Ii | ni | Ra)) !== dt;
      if (A || R) {
        var N = Ei.transition;
        Ei.transition = null;
        var B = Pa();
        _n(ii);
        var K = $t;
        $t |= ko, XA.current = null;
        var X = UW(a, _);
        II(), n8(a, _, b), n6(a.containerInfo), a.current = _, Bx(b), i8(_, a, b), Tc(), Mx(), $t = K, _n(B), Ei.transition = N;
      } else
        a.current = _, II();
      var ce = eh;
      if (eh ? (eh = !1, ad = a, n_ = b) : (Dp = 0, kS = null), E = a.pendingLanes, E === ye && (Rp = null), ce || UN(a.current, !1), is(_.stateNode, v), zn && a.memoizedUpdaters.clear(), O8(), Ga(a, zr()), o !== null)
        for (var oe = a.onRecoverableError, ve = 0; ve < o.length; ve++) {
          var Ye = o[ve], ft = Ye.stack, ot = Ye.digest;
          oe(Ye.value, {
            componentStack: ft,
            digest: ot
          });
        }
      if (AS) {
        AS = !1;
        var Ht = JA;
        throw JA = null, Ht;
      }
      return Bi(n_, yt) && a.tag !== qc && Mu(), E = a.pendingLanes, Bi(E, yt) ? (JY(), a === rO ? i_++ : (i_ = 0, rO = a)) : i_ = 0, Kc(), Fm(), null;
    }
    function Mu() {
      if (ad !== null) {
        var a = Rf(n_), o = T1(ss, a), f = Ei.transition, v = Pa();
        try {
          return Ei.transition = null, _n(o), Z8();
        } finally {
          _n(v), Ei.transition = f;
        }
      }
      return !1;
    }
    function K8(a) {
      eO.push(a), eh || (eh = !0, dO(yo, function() {
        return Mu(), null;
      }));
    }
    function Z8() {
      if (ad === null)
        return !1;
      var a = tO;
      tO = null;
      var o = ad, f = n_;
      if (ad = null, n_ = ye, ($t & (Ti | ko)) !== Yn)
        throw new Error("Cannot flush passive effects while already rendering.");
      nO = !0, OS = !1, zx(f);
      var v = $t;
      $t |= ko, d8(o.current), s8(o, o.current, f, a);
      {
        var _ = eO;
        eO = [];
        for (var b = 0; b < _.length; b++) {
          var E = _[b];
          WW(o, E);
        }
      }
      xf(), UN(o.current, !0), $t = v, Kc(), OS ? o === kS ? Dp++ : (Dp = 0, kS = o) : Dp = 0, nO = !1, OS = !1, Js(o);
      {
        var A = o.current.stateNode;
        A.effectDuration = 0, A.passiveEffectDuration = 0;
      }
      return !0;
    }
    function zN(a) {
      return Rp !== null && Rp.has(a);
    }
    function Q8(a) {
      Rp === null ? Rp = /* @__PURE__ */ new Set([a]) : Rp.add(a);
    }
    function J8(a) {
      AS || (AS = !0, JA = a);
    }
    var e9 = J8;
    function HN(a, o, f) {
      var v = Zf(f, o), _ = VI(a, v, yt), b = Qc(a, _, yt), E = ca();
      b !== null && (fu(b, yt, E), Ga(b, E));
    }
    function Rr(a, o, f) {
      if (zW(f), l_(!1), a.tag === x) {
        HN(a, a, f);
        return;
      }
      var v = null;
      for (v = o; v !== null; ) {
        if (v.tag === x) {
          HN(v, a, f);
          return;
        } else if (v.tag === p) {
          var _ = v.type, b = v.stateNode;
          if (typeof _.getDerivedStateFromError == "function" || typeof b.componentDidCatch == "function" && !zN(b)) {
            var E = Zf(f, a), A = AA(v, E, yt), R = Qc(v, A, yt), N = ca();
            R !== null && (fu(R, yt, N), Ga(R, N));
            return;
          }
        }
        v = v.return;
      }
      l(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, f);
    }
    function t9(a, o, f) {
      var v = a.pingCache;
      v !== null && v.delete(o);
      var _ = ca();
      Xm(a, f), c9(a), ua === a && du(Wn, f) && (Xn === Q0 || Xn === ES && Bv(Wn) && zr() - QA < AN ? th(a, ye) : wS = Rt(wS, f)), Ga(a, _);
    }
    function GN(a, o) {
      o === jt && (o = I8(a));
      var f = ca(), v = Ba(a, o);
      v !== null && (fu(v, o, f), Ga(v, f));
    }
    function r9(a) {
      var o = a.memoizedState, f = jt;
      o !== null && (f = o.retryLane), GN(a, f);
    }
    function n9(a, o) {
      var f = jt, v;
      switch (a.tag) {
        case P:
          v = a.stateNode;
          var _ = a.memoizedState;
          _ !== null && (f = _.retryLane);
          break;
        case de:
          v = a.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      v !== null && v.delete(o), GN(a, f);
    }
    function i9(a) {
      return a < 120 ? 120 : a < 480 ? 480 : a < 1080 ? 1080 : a < 1920 ? 1920 : a < 3e3 ? 3e3 : a < 4320 ? 4320 : D8(a / 1960) * 1960;
    }
    function a9() {
      if (i_ > L8)
        throw i_ = 0, rO = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Dp > P8 && (Dp = 0, kS = null, l("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function o9() {
      vs.flushLegacyContextWarning(), vs.flushPendingUnsafeLifecycleWarnings();
    }
    function UN(a, o) {
      hr(a), PS(a, Pi, x8), o && PS(a, tu, b8), PS(a, Pi, _8), o && PS(a, tu, y8), vn();
    }
    function PS(a, o, f) {
      for (var v = a, _ = null; v !== null; ) {
        var b = v.subtreeFlags & o;
        v !== _ && v.child !== null && b !== dt ? v = v.child : ((v.flags & o) !== dt && f(v), v.sibling !== null ? v = v.sibling : v = _ = v.return);
      }
    }
    var IS = null;
    function jN(a) {
      {
        if (($t & Ti) !== Yn || !(a.mode & Ft))
          return;
        var o = a.tag;
        if (o !== m && o !== x && o !== p && o !== h && o !== z && o !== j && o !== Z)
          return;
        var f = kt(a) || "ReactComponent";
        if (IS !== null) {
          if (IS.has(f))
            return;
          IS.add(f);
        } else
          IS = /* @__PURE__ */ new Set([f]);
        var v = an;
        try {
          hr(a), l("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          v ? hr(a) : vn();
        }
      }
    }
    var lO;
    {
      var s9 = null;
      lO = function(a, o, f) {
        var v = QN(s9, o);
        try {
          return rN(a, o, f);
        } catch (b) {
          if (pY() || b !== null && typeof b == "object" && typeof b.then == "function")
            throw b;
          if (zb(), cI(), lN(a, o), QN(o, v), o.mode & mt && bA(o), eu(null, rN, null, a, o, f), _1()) {
            var _ = Am();
            typeof _ == "object" && _ !== null && _._suppressLogging && typeof b == "object" && b !== null && !b._suppressLogging && (b._suppressLogging = !0);
          }
          throw b;
        }
      };
    }
    var $N = !1, uO;
    uO = /* @__PURE__ */ new Set();
    function l9(a) {
      if (Ea && !KY())
        switch (a.tag) {
          case h:
          case z:
          case Z: {
            var o = tn && kt(tn) || "Unknown", f = o;
            if (!uO.has(f)) {
              uO.add(f);
              var v = kt(a) || "Unknown";
              l("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", v, o, o);
            }
            break;
          }
          case p: {
            $N || (l("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), $N = !0);
            break;
          }
        }
    }
    function s_(a, o) {
      if (zn) {
        var f = a.memoizedUpdaters;
        f.forEach(function(v) {
          Km(a, v, o);
        });
      }
    }
    var cO = {};
    function dO(a, o) {
      {
        var f = Ss.current;
        return f !== null ? (f.push(o), cO) : hv(a, o);
      }
    }
    function YN(a) {
      if (a !== cO)
        return Dx(a);
    }
    function WN() {
      return Ss.current !== null;
    }
    function u9(a) {
      {
        if (a.mode & Ft) {
          if (!EN())
            return;
        } else if (!R8() || $t !== Yn || a.tag !== h && a.tag !== z && a.tag !== Z)
          return;
        if (Ss.current === null) {
          var o = an;
          try {
            hr(a), l(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, kt(a));
          } finally {
            o ? hr(a) : vn();
          }
        }
      }
    }
    function c9(a) {
      a.tag !== qc && EN() && Ss.current === null && l(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function l_(a) {
      RN = a;
    }
    var Ro = null, Mp = null, d9 = function(a) {
      Ro = a;
    };
    function Lp(a) {
      {
        if (Ro === null)
          return a;
        var o = Ro(a);
        return o === void 0 ? a : o.current;
      }
    }
    function fO(a) {
      return Lp(a);
    }
    function hO(a) {
      {
        if (Ro === null)
          return a;
        var o = Ro(a);
        if (o === void 0) {
          if (a != null && typeof a.render == "function") {
            var f = Lp(a.render);
            if (a.render !== f) {
              var v = {
                $$typeof: vt,
                render: f
              };
              return a.displayName !== void 0 && (v.displayName = a.displayName), v;
            }
          }
          return a;
        }
        return o.current;
      }
    }
    function XN(a, o) {
      {
        if (Ro === null)
          return !1;
        var f = a.elementType, v = o.type, _ = !1, b = typeof v == "object" && v !== null ? v.$$typeof : null;
        switch (a.tag) {
          case p: {
            typeof v == "function" && (_ = !0);
            break;
          }
          case h: {
            (typeof v == "function" || b === gt) && (_ = !0);
            break;
          }
          case z: {
            (b === vt || b === gt) && (_ = !0);
            break;
          }
          case j:
          case Z: {
            (b === Nt || b === gt) && (_ = !0);
            break;
          }
          default:
            return !1;
        }
        if (_) {
          var E = Ro(f);
          if (E !== void 0 && E === Ro(v))
            return !0;
        }
        return !1;
      }
    }
    function qN(a) {
      {
        if (Ro === null || typeof WeakSet != "function")
          return;
        Mp === null && (Mp = /* @__PURE__ */ new WeakSet()), Mp.add(a);
      }
    }
    var f9 = function(a, o) {
      {
        if (Ro === null)
          return;
        var f = o.staleFamilies, v = o.updatedFamilies;
        Mu(), Du(function() {
          vO(a.current, v, f);
        });
      }
    }, h9 = function(a, o) {
      {
        if (a.context !== so)
          return;
        Mu(), Du(function() {
          u_(o, a, null, null);
        });
      }
    };
    function vO(a, o, f) {
      {
        var v = a.alternate, _ = a.child, b = a.sibling, E = a.tag, A = a.type, R = null;
        switch (E) {
          case h:
          case Z:
          case p:
            R = A;
            break;
          case z:
            R = A.render;
            break;
        }
        if (Ro === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var N = !1, B = !1;
        if (R !== null) {
          var K = Ro(R);
          K !== void 0 && (f.has(K) ? B = !0 : o.has(K) && (E === p ? B = !0 : N = !0));
        }
        if (Mp !== null && (Mp.has(a) || v !== null && Mp.has(v)) && (B = !0), B && (a._debugNeedsRemount = !0), B || N) {
          var X = Ba(a, yt);
          X !== null && qn(X, a, yt, br);
        }
        _ !== null && !B && vO(_, o, f), b !== null && vO(b, o, f);
      }
    }
    var v9 = function(a, o) {
      {
        var f = /* @__PURE__ */ new Set(), v = new Set(o.map(function(_) {
          return _.current;
        }));
        return pO(a.current, v, f), f;
      }
    };
    function pO(a, o, f) {
      {
        var v = a.child, _ = a.sibling, b = a.tag, E = a.type, A = null;
        switch (b) {
          case h:
          case Z:
          case p:
            A = E;
            break;
          case z:
            A = E.render;
            break;
        }
        var R = !1;
        A !== null && o.has(A) && (R = !0), R ? p9(a, f) : v !== null && pO(v, o, f), _ !== null && pO(_, o, f);
      }
    }
    function p9(a, o) {
      {
        var f = g9(a, o);
        if (f)
          return;
        for (var v = a; ; ) {
          switch (v.tag) {
            case T:
              o.add(v.stateNode);
              return;
            case S:
              o.add(v.stateNode.containerInfo);
              return;
            case x:
              o.add(v.stateNode.containerInfo);
              return;
          }
          if (v.return === null)
            throw new Error("Expected to reach root first.");
          v = v.return;
        }
      }
    }
    function g9(a, o) {
      for (var f = a, v = !1; ; ) {
        if (f.tag === T)
          v = !0, o.add(f.stateNode);
        else if (f.child !== null) {
          f.child.return = f, f = f.child;
          continue;
        }
        if (f === a)
          return v;
        for (; f.sibling === null; ) {
          if (f.return === null || f.return === a)
            return v;
          f = f.return;
        }
        f.sibling.return = f.return, f = f.sibling;
      }
      return !1;
    }
    var gO;
    {
      gO = !1;
      try {
        var KN = Object.preventExtensions({});
      } catch {
        gO = !0;
      }
    }
    function m9(a, o, f, v) {
      this.tag = a, this.key = f, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = o, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = v, this.flags = dt, this.subtreeFlags = dt, this.deletions = null, this.lanes = ye, this.childLanes = ye, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !gO && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var lo = function(a, o, f, v) {
      return new m9(a, o, f, v);
    };
    function mO(a) {
      var o = a.prototype;
      return !!(o && o.isReactComponent);
    }
    function _9(a) {
      return typeof a == "function" && !mO(a) && a.defaultProps === void 0;
    }
    function y9(a) {
      if (typeof a == "function")
        return mO(a) ? p : h;
      if (a != null) {
        var o = a.$$typeof;
        if (o === vt)
          return z;
        if (o === Nt)
          return j;
      }
      return m;
    }
    function nh(a, o) {
      var f = a.alternate;
      f === null ? (f = lo(a.tag, o, a.key, a.mode), f.elementType = a.elementType, f.type = a.type, f.stateNode = a.stateNode, f._debugSource = a._debugSource, f._debugOwner = a._debugOwner, f._debugHookTypes = a._debugHookTypes, f.alternate = a, a.alternate = f) : (f.pendingProps = o, f.type = a.type, f.flags = dt, f.subtreeFlags = dt, f.deletions = null, f.actualDuration = 0, f.actualStartTime = -1), f.flags = a.flags & Bn, f.childLanes = a.childLanes, f.lanes = a.lanes, f.child = a.child, f.memoizedProps = a.memoizedProps, f.memoizedState = a.memoizedState, f.updateQueue = a.updateQueue;
      var v = a.dependencies;
      switch (f.dependencies = v === null ? null : {
        lanes: v.lanes,
        firstContext: v.firstContext
      }, f.sibling = a.sibling, f.index = a.index, f.ref = a.ref, f.selfBaseDuration = a.selfBaseDuration, f.treeBaseDuration = a.treeBaseDuration, f._debugNeedsRemount = a._debugNeedsRemount, f.tag) {
        case m:
        case h:
        case Z:
          f.type = Lp(a.type);
          break;
        case p:
          f.type = fO(a.type);
          break;
        case z:
          f.type = hO(a.type);
          break;
      }
      return f;
    }
    function x9(a, o) {
      a.flags &= Bn | wr;
      var f = a.alternate;
      if (f === null)
        a.childLanes = ye, a.lanes = o, a.child = null, a.subtreeFlags = dt, a.memoizedProps = null, a.memoizedState = null, a.updateQueue = null, a.dependencies = null, a.stateNode = null, a.selfBaseDuration = 0, a.treeBaseDuration = 0;
      else {
        a.childLanes = f.childLanes, a.lanes = f.lanes, a.child = f.child, a.subtreeFlags = dt, a.deletions = null, a.memoizedProps = f.memoizedProps, a.memoizedState = f.memoizedState, a.updateQueue = f.updateQueue, a.type = f.type;
        var v = f.dependencies;
        a.dependencies = v === null ? null : {
          lanes: v.lanes,
          firstContext: v.firstContext
        }, a.selfBaseDuration = f.selfBaseDuration, a.treeBaseDuration = f.treeBaseDuration;
      }
      return a;
    }
    function b9(a, o, f) {
      var v;
      return a === Mb ? (v = Ft, o === !0 && (v |= Hr, v |= Ma)) : v = pt, zn && (v |= mt), lo(x, null, null, v);
    }
    function _O(a, o, f, v, _, b) {
      var E = m, A = a;
      if (typeof a == "function")
        mO(a) ? (E = p, A = fO(A)) : A = Lp(A);
      else if (typeof a == "string")
        E = T;
      else
        e:
          switch (a) {
            case Qa:
              return ld(f.children, _, b, o);
            case zs:
              E = D, _ |= Hr, (_ & Ft) !== pt && (_ |= Ma);
              break;
            case U:
              return S9(f, _, b, o);
            case It:
              return C9(f, _, b, o);
            case Kt:
              return E9(f, _, b, o);
            case Lr:
              return ZN(f, _, b, o);
            case gi:
            case On:
            case Hs:
            case Gh:
            case Mr:
            default: {
              if (typeof a == "object" && a !== null)
                switch (a.$$typeof) {
                  case ke:
                    E = F;
                    break e;
                  case ze:
                    E = L;
                    break e;
                  case vt:
                    E = z, A = hO(A);
                    break e;
                  case Nt:
                    E = j;
                    break e;
                  case gt:
                    E = ee, A = null;
                    break e;
                }
              var R = "";
              {
                (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (R += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var N = v ? kt(v) : null;
                N && (R += `

Check the render method of \`` + N + "`.");
              }
              throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (a == null ? a : typeof a) + "." + R));
            }
          }
      var B = lo(E, f, o, _);
      return B.elementType = a, B.type = A, B.lanes = b, B._debugOwner = v, B;
    }
    function yO(a, o, f) {
      var v = null;
      v = a._owner;
      var _ = a.type, b = a.key, E = a.props, A = _O(_, b, E, v, o, f);
      return A._debugSource = a._source, A._debugOwner = a._owner, A;
    }
    function ld(a, o, f, v) {
      var _ = lo(O, a, v, o);
      return _.lanes = f, _;
    }
    function S9(a, o, f, v) {
      typeof a.id != "string" && l('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof a.id);
      var _ = lo(V, a, v, o | mt);
      return _.elementType = U, _.lanes = f, _.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, _;
    }
    function C9(a, o, f, v) {
      var _ = lo(P, a, v, o);
      return _.elementType = It, _.lanes = f, _;
    }
    function E9(a, o, f, v) {
      var _ = lo(de, a, v, o);
      return _.elementType = Kt, _.lanes = f, _;
    }
    function ZN(a, o, f, v) {
      var _ = lo(Ce, a, v, o);
      _.elementType = Lr, _.lanes = f;
      var b = {
        isHidden: !1
      };
      return _.stateNode = b, _;
    }
    function xO(a, o, f) {
      var v = lo(k, a, null, o);
      return v.lanes = f, v;
    }
    function T9() {
      var a = lo(T, null, null, pt);
      return a.elementType = "DELETED", a;
    }
    function w9(a) {
      var o = lo(he, null, null, pt);
      return o.stateNode = a, o;
    }
    function bO(a, o, f) {
      var v = a.children !== null ? a.children : [], _ = lo(S, v, a.key, o);
      return _.lanes = f, _.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: a.implementation
      }, _;
    }
    function QN(a, o) {
      return a === null && (a = lo(m, null, null, pt)), a.tag = o.tag, a.key = o.key, a.elementType = o.elementType, a.type = o.type, a.stateNode = o.stateNode, a.return = o.return, a.child = o.child, a.sibling = o.sibling, a.index = o.index, a.ref = o.ref, a.pendingProps = o.pendingProps, a.memoizedProps = o.memoizedProps, a.updateQueue = o.updateQueue, a.memoizedState = o.memoizedState, a.dependencies = o.dependencies, a.mode = o.mode, a.flags = o.flags, a.subtreeFlags = o.subtreeFlags, a.deletions = o.deletions, a.lanes = o.lanes, a.childLanes = o.childLanes, a.alternate = o.alternate, a.actualDuration = o.actualDuration, a.actualStartTime = o.actualStartTime, a.selfBaseDuration = o.selfBaseDuration, a.treeBaseDuration = o.treeBaseDuration, a._debugSource = o._debugSource, a._debugOwner = o._debugOwner, a._debugNeedsRemount = o._debugNeedsRemount, a._debugHookTypes = o._debugHookTypes, a;
    }
    function A9(a, o, f, v, _) {
      this.tag = o, this.containerInfo = a, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = tw, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = jt, this.eventTimes = Hv(ye), this.expirationTimes = Hv(br), this.pendingLanes = ye, this.suspendedLanes = ye, this.pingedLanes = ye, this.expiredLanes = ye, this.mutableReadLanes = ye, this.finishedLanes = ye, this.entangledLanes = ye, this.entanglements = Hv(ye), this.identifierPrefix = v, this.onRecoverableError = _, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var b = this.pendingUpdatersLaneMap = [], E = 0; E < Or; E++)
          b.push(/* @__PURE__ */ new Set());
      }
      switch (o) {
        case Mb:
          this._debugRootType = f ? "hydrateRoot()" : "createRoot()";
          break;
        case qc:
          this._debugRootType = f ? "hydrate()" : "render()";
          break;
      }
    }
    function JN(a, o, f, v, _, b, E, A, R, N) {
      var B = new A9(a, o, f, A, R), K = b9(o, b);
      B.current = K, K.stateNode = B;
      {
        var X = {
          element: v,
          isDehydrated: f,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        K.memoizedState = X;
      }
      return Ow(K), B;
    }
    var SO = "18.2.0";
    function O9(a, o, f) {
      var v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return ur(v), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: ea,
        key: v == null ? null : "" + v,
        children: a,
        containerInfo: o,
        implementation: f
      };
    }
    var CO, EO;
    CO = !1, EO = {};
    function eV(a) {
      if (!a)
        return so;
      var o = Aa(a), f = oY(o);
      if (o.tag === p) {
        var v = o.type;
        if (fl(v))
          return TP(o, v, f);
      }
      return f;
    }
    function k9(a, o) {
      {
        var f = Aa(a);
        if (f === void 0) {
          if (typeof a.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var v = Object.keys(a).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + v);
        }
        var _ = Da(f);
        if (_ === null)
          return null;
        if (_.mode & Hr) {
          var b = kt(f) || "Component";
          if (!EO[b]) {
            EO[b] = !0;
            var E = an;
            try {
              hr(_), f.mode & Hr ? l("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", o, o, b) : l("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", o, o, b);
            } finally {
              E ? hr(E) : vn();
            }
          }
        }
        return _.stateNode;
      }
    }
    function tV(a, o, f, v, _, b, E, A) {
      var R = !1, N = null;
      return JN(a, o, R, N, f, v, _, b, E);
    }
    function rV(a, o, f, v, _, b, E, A, R, N) {
      var B = !0, K = JN(f, v, B, a, _, b, E, A, R);
      K.context = eV(null);
      var X = K.current, ce = ca(), oe = od(X), ve = Au(ce, oe);
      return ve.callback = o ?? null, Qc(X, ve, oe), N8(K, oe, ce), K;
    }
    function u_(a, o, f, v) {
      Lx(o, a);
      var _ = o.current, b = ca(), E = od(_);
      nu(E);
      var A = eV(f);
      o.context === null ? o.context = A : o.pendingContext = A, Ea && an !== null && !CO && (CO = !0, l(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, kt(an) || "Unknown"));
      var R = Au(b, E);
      R.payload = {
        element: a
      }, v = v === void 0 ? null : v, v !== null && (typeof v != "function" && l("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", v), R.callback = v);
      var N = Qc(_, R, E);
      return N !== null && (qn(N, _, E, b), $b(N, _, E)), E;
    }
    function NS(a) {
      var o = a.current;
      if (!o.child)
        return null;
      switch (o.child.tag) {
        case T:
          return o.child.stateNode;
        default:
          return o.child.stateNode;
      }
    }
    function R9(a) {
      switch (a.tag) {
        case x: {
          var o = a.stateNode;
          if (yn(o)) {
            var f = b1(o);
            z8(o, f);
          }
          break;
        }
        case P: {
          Du(function() {
            var _ = Ba(a, yt);
            if (_ !== null) {
              var b = ca();
              qn(_, a, yt, b);
            }
          });
          var v = yt;
          TO(a, v);
          break;
        }
      }
    }
    function nV(a, o) {
      var f = a.memoizedState;
      f !== null && f.dehydrated !== null && (f.retryLane = $x(f.retryLane, o));
    }
    function TO(a, o) {
      nV(a, o);
      var f = a.alternate;
      f && nV(f, o);
    }
    function D9(a) {
      if (a.tag === P) {
        var o = Ac, f = Ba(a, o);
        if (f !== null) {
          var v = ca();
          qn(f, a, o, v);
        }
        TO(a, o);
      }
    }
    function M9(a) {
      if (a.tag === P) {
        var o = od(a), f = Ba(a, o);
        if (f !== null) {
          var v = ca();
          qn(f, a, o, v);
        }
        TO(a, o);
      }
    }
    function iV(a) {
      var o = Rx(a);
      return o === null ? null : o.stateNode;
    }
    var aV = function(a) {
      return null;
    };
    function L9(a) {
      return aV(a);
    }
    var oV = function(a) {
      return !1;
    };
    function P9(a) {
      return oV(a);
    }
    var sV = null, lV = null, uV = null, cV = null, dV = null, fV = null, hV = null, vV = null, pV = null;
    {
      var gV = function(a, o, f) {
        var v = o[f], _ = kn(a) ? a.slice() : Bt({}, a);
        return f + 1 === o.length ? (kn(_) ? _.splice(v, 1) : delete _[v], _) : (_[v] = gV(a[v], o, f + 1), _);
      }, mV = function(a, o) {
        return gV(a, o, 0);
      }, _V = function(a, o, f, v) {
        var _ = o[v], b = kn(a) ? a.slice() : Bt({}, a);
        if (v + 1 === o.length) {
          var E = f[v];
          b[E] = b[_], kn(b) ? b.splice(_, 1) : delete b[_];
        } else
          b[_] = _V(
            // $FlowFixMe number or string is fine here
            a[_],
            o,
            f,
            v + 1
          );
        return b;
      }, yV = function(a, o, f) {
        if (o.length !== f.length) {
          s("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var v = 0; v < f.length - 1; v++)
            if (o[v] !== f[v]) {
              s("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return _V(a, o, f, 0);
      }, xV = function(a, o, f, v) {
        if (f >= o.length)
          return v;
        var _ = o[f], b = kn(a) ? a.slice() : Bt({}, a);
        return b[_] = xV(a[_], o, f + 1, v), b;
      }, bV = function(a, o, f) {
        return xV(a, o, 0, f);
      }, wO = function(a, o) {
        for (var f = a.memoizedState; f !== null && o > 0; )
          f = f.next, o--;
        return f;
      };
      sV = function(a, o, f, v) {
        var _ = wO(a, o);
        if (_ !== null) {
          var b = bV(_.memoizedState, f, v);
          _.memoizedState = b, _.baseState = b, a.memoizedProps = Bt({}, a.memoizedProps);
          var E = Ba(a, yt);
          E !== null && qn(E, a, yt, br);
        }
      }, lV = function(a, o, f) {
        var v = wO(a, o);
        if (v !== null) {
          var _ = mV(v.memoizedState, f);
          v.memoizedState = _, v.baseState = _, a.memoizedProps = Bt({}, a.memoizedProps);
          var b = Ba(a, yt);
          b !== null && qn(b, a, yt, br);
        }
      }, uV = function(a, o, f, v) {
        var _ = wO(a, o);
        if (_ !== null) {
          var b = yV(_.memoizedState, f, v);
          _.memoizedState = b, _.baseState = b, a.memoizedProps = Bt({}, a.memoizedProps);
          var E = Ba(a, yt);
          E !== null && qn(E, a, yt, br);
        }
      }, cV = function(a, o, f) {
        a.pendingProps = bV(a.memoizedProps, o, f), a.alternate && (a.alternate.pendingProps = a.pendingProps);
        var v = Ba(a, yt);
        v !== null && qn(v, a, yt, br);
      }, dV = function(a, o) {
        a.pendingProps = mV(a.memoizedProps, o), a.alternate && (a.alternate.pendingProps = a.pendingProps);
        var f = Ba(a, yt);
        f !== null && qn(f, a, yt, br);
      }, fV = function(a, o, f) {
        a.pendingProps = yV(a.memoizedProps, o, f), a.alternate && (a.alternate.pendingProps = a.pendingProps);
        var v = Ba(a, yt);
        v !== null && qn(v, a, yt, br);
      }, hV = function(a) {
        var o = Ba(a, yt);
        o !== null && qn(o, a, yt, br);
      }, vV = function(a) {
        aV = a;
      }, pV = function(a) {
        oV = a;
      };
    }
    function I9(a) {
      var o = Da(a);
      return o === null ? null : o.stateNode;
    }
    function N9(a) {
      return null;
    }
    function V9() {
      return an;
    }
    function F9(a) {
      var o = a.findFiberByHostInstance, f = r.ReactCurrentDispatcher;
      return Nm({
        bundleType: a.bundleType,
        version: a.version,
        rendererPackageName: a.rendererPackageName,
        rendererConfig: a.rendererConfig,
        overrideHookState: sV,
        overrideHookStateDeletePath: lV,
        overrideHookStateRenamePath: uV,
        overrideProps: cV,
        overridePropsDeletePath: dV,
        overridePropsRenamePath: fV,
        setErrorHandler: vV,
        setSuspenseHandler: pV,
        scheduleUpdate: hV,
        currentDispatcherRef: f,
        findHostInstanceByFiber: I9,
        findFiberByHostInstance: o || N9,
        // React Refresh
        findHostInstancesForRefresh: v9,
        scheduleRefresh: f9,
        scheduleRoot: h9,
        setRefreshHandler: d9,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: V9,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: SO
      });
    }
    var SV = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(a) {
      console.error(a);
    };
    function AO(a) {
      this._internalRoot = a;
    }
    VS.prototype.render = AO.prototype.render = function(a) {
      var o = this._internalRoot;
      if (o === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? l("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : FS(arguments[1]) ? l("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && l("You passed a second argument to root.render(...) but it only accepts one argument.");
        var f = o.containerInfo;
        if (f.nodeType !== on) {
          var v = iV(o.current);
          v && v.parentNode !== f && l("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      u_(a, o, null, null);
    }, VS.prototype.unmount = AO.prototype.unmount = function() {
      typeof arguments[0] == "function" && l("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var a = this._internalRoot;
      if (a !== null) {
        this._internalRoot = null;
        var o = a.containerInfo;
        PN() && l("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), Du(function() {
          u_(null, a, null, null);
        }), xP(o);
      }
    };
    function B9(a, o) {
      if (!FS(a))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      CV(a);
      var f = !1, v = !1, _ = "", b = SV, E = null;
      o != null && (o.hydrate ? s("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof o == "object" && o !== null && o.$$typeof === Bs && l(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), o.unstable_strictMode === !0 && (f = !0), o.identifierPrefix !== void 0 && (_ = o.identifierPrefix), o.onRecoverableError !== void 0 && (b = o.onRecoverableError), o.transitionCallbacks !== void 0 && (E = o.transitionCallbacks));
      var A = tV(a, Mb, null, f, v, _, b);
      Tb(A.current, a);
      var R = a.nodeType === on ? a.parentNode : a;
      return m0(R), new AO(A);
    }
    function VS(a) {
      this._internalRoot = a;
    }
    function z9(a) {
      a && Jx(a);
    }
    VS.prototype.unstable_scheduleHydration = z9;
    function H9(a, o, f) {
      if (!FS(a))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      CV(a), o === void 0 && l("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var v = f ?? null, _ = f != null && f.hydratedSources || null, b = !1, E = !1, A = "", R = SV;
      f != null && (f.unstable_strictMode === !0 && (b = !0), f.identifierPrefix !== void 0 && (A = f.identifierPrefix), f.onRecoverableError !== void 0 && (R = f.onRecoverableError));
      var N = rV(o, null, a, Mb, v, b, E, A, R);
      if (Tb(N.current, a), m0(a), _)
        for (var B = 0; B < _.length; B++) {
          var K = _[B];
          jY(N, K);
        }
      return new VS(N);
    }
    function FS(a) {
      return !!(a && (a.nodeType === Di || a.nodeType === ro || a.nodeType === Xl || !Te));
    }
    function c_(a) {
      return !!(a && (a.nodeType === Di || a.nodeType === ro || a.nodeType === Xl || a.nodeType === on && a.nodeValue === " react-mount-point-unstable "));
    }
    function CV(a) {
      a.nodeType === Di && a.tagName && a.tagName.toUpperCase() === "BODY" && l("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), O0(a) && (a._reactRootContainer ? l("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : l("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var G9 = r.ReactCurrentOwner, EV;
    EV = function(a) {
      if (a._reactRootContainer && a.nodeType !== on) {
        var o = iV(a._reactRootContainer.current);
        o && o.parentNode !== a && l("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var f = !!a._reactRootContainer, v = OO(a), _ = !!(v && Wc(v));
      _ && !f && l("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), a.nodeType === Di && a.tagName && a.tagName.toUpperCase() === "BODY" && l("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function OO(a) {
      return a ? a.nodeType === ro ? a.documentElement : a.firstChild : null;
    }
    function TV() {
    }
    function U9(a, o, f, v, _) {
      if (_) {
        if (typeof v == "function") {
          var b = v;
          v = function() {
            var X = NS(E);
            b.call(X);
          };
        }
        var E = rV(
          o,
          v,
          a,
          qc,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          TV
        );
        a._reactRootContainer = E, Tb(E.current, a);
        var A = a.nodeType === on ? a.parentNode : a;
        return m0(A), Du(), E;
      } else {
        for (var R; R = a.lastChild; )
          a.removeChild(R);
        if (typeof v == "function") {
          var N = v;
          v = function() {
            var X = NS(B);
            N.call(X);
          };
        }
        var B = tV(
          a,
          qc,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          TV
        );
        a._reactRootContainer = B, Tb(B.current, a);
        var K = a.nodeType === on ? a.parentNode : a;
        return m0(K), Du(function() {
          u_(o, B, f, v);
        }), B;
      }
    }
    function j9(a, o) {
      a !== null && typeof a != "function" && l("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", o, a);
    }
    function BS(a, o, f, v, _) {
      EV(f), j9(_ === void 0 ? null : _, "render");
      var b = f._reactRootContainer, E;
      if (!b)
        E = U9(f, o, a, _, v);
      else {
        if (E = b, typeof _ == "function") {
          var A = _;
          _ = function() {
            var R = NS(E);
            A.call(R);
          };
        }
        u_(o, E, a, _);
      }
      return NS(E);
    }
    function $9(a) {
      {
        var o = G9.current;
        if (o !== null && o.stateNode !== null) {
          var f = o.stateNode._warnedAboutRefsInRender;
          f || l("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", yr(o.type) || "A component"), o.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return a == null ? null : a.nodeType === Di ? a : k9(a, "findDOMNode");
    }
    function Y9(a, o, f) {
      if (l("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !c_(o))
        throw new Error("Target container is not a DOM element.");
      {
        var v = O0(o) && o._reactRootContainer === void 0;
        v && l("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return BS(null, a, o, !0, f);
    }
    function W9(a, o, f) {
      if (l("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !c_(o))
        throw new Error("Target container is not a DOM element.");
      {
        var v = O0(o) && o._reactRootContainer === void 0;
        v && l("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return BS(null, a, o, !1, f);
    }
    function X9(a, o, f, v) {
      if (l("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !c_(f))
        throw new Error("Target container is not a DOM element.");
      if (a == null || !mf(a))
        throw new Error("parentComponent must be a valid React Component");
      return BS(a, o, f, !1, v);
    }
    function q9(a) {
      if (!c_(a))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var o = O0(a) && a._reactRootContainer === void 0;
        o && l("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (a._reactRootContainer) {
        {
          var f = OO(a), v = f && !Wc(f);
          v && l("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return Du(function() {
          BS(null, null, a, !1, function() {
            a._reactRootContainer = null, xP(a);
          });
        }), !0;
      } else {
        {
          var _ = OO(a), b = !!(_ && Wc(_)), E = a.nodeType === Di && c_(a.parentNode) && !!a.parentNode._reactRootContainer;
          b && l("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", E ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    et(R9), Wx(D9), Mf(M9), Jm(Pa), qx(kf), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && l("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), Ax(W$), lv(aO, H8, Du);
    function K9(a, o) {
      var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!FS(o))
        throw new Error("Target container is not a DOM element.");
      return O9(a, o, null, f);
    }
    function Z9(a, o, f, v) {
      return X9(a, o, f, v);
    }
    var kO = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [Wc, cp, wb, sv, vf, aO]
    };
    function Q9(a, o) {
      return kO.usingClientEntryPoint || l('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), B9(a, o);
    }
    function J9(a, o, f) {
      return kO.usingClientEntryPoint || l('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), H9(a, o, f);
    }
    function e7(a) {
      return PN() && l("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), Du(a);
    }
    var t7 = F9({
      findFiberByHostInstance: Gf,
      bundleType: 1,
      version: SO,
      rendererPackageName: "react-dom"
    });
    if (!t7 && Je && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var wV = window.location.protocol;
      /^(https?|file):$/.test(wV) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (wV === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    ja.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = kO, ja.createPortal = K9, ja.createRoot = Q9, ja.findDOMNode = $9, ja.flushSync = e7, ja.hydrate = Y9, ja.hydrateRoot = J9, ja.render = W9, ja.unmountComponentAtNode = q9, ja.unstable_batchedUpdates = aO, ja.unstable_renderSubtreeIntoContainer = Z9, ja.version = SO, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ja;
}
var $a = {};
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sH;
function Gfe() {
  if (sH)
    return $a;
  sH = 1;
  var e = nc, t = K5();
  function r(u) {
    for (var c = "https://reactjs.org/docs/error-decoder.html?invariant=" + u, g = 1; g < arguments.length; g++)
      c += "&args[]=" + encodeURIComponent(arguments[g]);
    return "Minified React error #" + u + "; visit " + c + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var n = /* @__PURE__ */ new Set(), i = {};
  function s(u, c) {
    l(u, c), l(u + "Capture", c);
  }
  function l(u, c) {
    for (i[u] = c, u = 0; u < c.length; u++)
      n.add(c[u]);
  }
  var d = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), h = Object.prototype.hasOwnProperty, p = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, m = {}, x = {};
  function S(u) {
    return h.call(x, u) ? !0 : h.call(m, u) ? !1 : p.test(u) ? x[u] = !0 : (m[u] = !0, !1);
  }
  function T(u, c, g, y) {
    if (g !== null && g.type === 0)
      return !1;
    switch (typeof c) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return y ? !1 : g !== null ? !g.acceptsBooleans : (u = u.toLowerCase().slice(0, 5), u !== "data-" && u !== "aria-");
      default:
        return !1;
    }
  }
  function k(u, c, g, y) {
    if (c === null || typeof c > "u" || T(u, c, g, y))
      return !0;
    if (y)
      return !1;
    if (g !== null)
      switch (g.type) {
        case 3:
          return !c;
        case 4:
          return c === !1;
        case 5:
          return isNaN(c);
        case 6:
          return isNaN(c) || 1 > c;
      }
    return !1;
  }
  function O(u, c, g, y, C, w, M) {
    this.acceptsBooleans = c === 2 || c === 3 || c === 4, this.attributeName = y, this.attributeNamespace = C, this.mustUseProperty = g, this.propertyName = u, this.type = c, this.sanitizeURL = w, this.removeEmptyString = M;
  }
  var D = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(u) {
    D[u] = new O(u, 0, !1, u, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(u) {
    var c = u[0];
    D[c] = new O(c, 1, !1, u[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(u) {
    D[u] = new O(u, 2, !1, u.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(u) {
    D[u] = new O(u, 2, !1, u, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(u) {
    D[u] = new O(u, 3, !1, u.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(u) {
    D[u] = new O(u, 3, !0, u, null, !1, !1);
  }), ["capture", "download"].forEach(function(u) {
    D[u] = new O(u, 4, !1, u, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(u) {
    D[u] = new O(u, 6, !1, u, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(u) {
    D[u] = new O(u, 5, !1, u.toLowerCase(), null, !1, !1);
  });
  var L = /[\-:]([a-z])/g;
  function F(u) {
    return u[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(u) {
    var c = u.replace(
      L,
      F
    );
    D[c] = new O(c, 1, !1, u, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(u) {
    var c = u.replace(L, F);
    D[c] = new O(c, 1, !1, u, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(u) {
    var c = u.replace(L, F);
    D[c] = new O(c, 1, !1, u, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(u) {
    D[u] = new O(u, 1, !1, u.toLowerCase(), null, !1, !1);
  }), D.xlinkHref = new O("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(u) {
    D[u] = new O(u, 1, !1, u.toLowerCase(), null, !0, !0);
  });
  function z(u, c, g, y) {
    var C = D.hasOwnProperty(c) ? D[c] : null;
    (C !== null ? C.type !== 0 : y || !(2 < c.length) || c[0] !== "o" && c[0] !== "O" || c[1] !== "n" && c[1] !== "N") && (k(c, g, C, y) && (g = null), y || C === null ? S(c) && (g === null ? u.removeAttribute(c) : u.setAttribute(c, "" + g)) : C.mustUseProperty ? u[C.propertyName] = g === null ? C.type === 3 ? !1 : "" : g : (c = C.attributeName, y = C.attributeNamespace, g === null ? u.removeAttribute(c) : (C = C.type, g = C === 3 || C === 4 && g === !0 ? "" : "" + g, y ? u.setAttributeNS(y, c, g) : u.setAttribute(c, g))));
  }
  var V = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, P = Symbol.for("react.element"), j = Symbol.for("react.portal"), Z = Symbol.for("react.fragment"), ee = Symbol.for("react.strict_mode"), J = Symbol.for("react.profiler"), he = Symbol.for("react.provider"), de = Symbol.for("react.context"), Re = Symbol.for("react.forward_ref"), Ce = Symbol.for("react.suspense"), le = Symbol.for("react.suspense_list"), me = Symbol.for("react.memo"), fe = Symbol.for("react.lazy");
  Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode");
  var Ee = Symbol.for("react.offscreen");
  Symbol.for("react.legacy_hidden"), Symbol.for("react.cache"), Symbol.for("react.tracing_marker");
  var Q = Symbol.iterator;
  function pe(u) {
    return u === null || typeof u != "object" ? null : (u = Q && u[Q] || u["@@iterator"], typeof u == "function" ? u : null);
  }
  var G = Object.assign, se;
  function Te(u) {
    if (se === void 0)
      try {
        throw Error();
      } catch (g) {
        var c = g.stack.trim().match(/\n( *(at )?)/);
        se = c && c[1] || "";
      }
    return `
` + se + u;
  }
  var Pe = !1;
  function Ie(u, c) {
    if (!u || Pe)
      return "";
    Pe = !0;
    var g = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (c)
        if (c = function() {
          throw Error();
        }, Object.defineProperty(c.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(c, []);
          } catch (ue) {
            var y = ue;
          }
          Reflect.construct(u, [], c);
        } else {
          try {
            c.call();
          } catch (ue) {
            y = ue;
          }
          u.call(c.prototype);
        }
      else {
        try {
          throw Error();
        } catch (ue) {
          y = ue;
        }
        u();
      }
    } catch (ue) {
      if (ue && y && typeof ue.stack == "string") {
        for (var C = ue.stack.split(`
`), w = y.stack.split(`
`), M = C.length - 1, H = w.length - 1; 1 <= M && 0 <= H && C[M] !== w[H]; )
          H--;
        for (; 1 <= M && 0 <= H; M--, H--)
          if (C[M] !== w[H]) {
            if (M !== 1 || H !== 1)
              do
                if (M--, H--, 0 > H || C[M] !== w[H]) {
                  var $ = `
` + C[M].replace(" at new ", " at ");
                  return u.displayName && $.includes("<anonymous>") && ($ = $.replace("<anonymous>", u.displayName)), $;
                }
              while (1 <= M && 0 <= H);
            break;
          }
      }
    } finally {
      Pe = !1, Error.prepareStackTrace = g;
    }
    return (u = u ? u.displayName || u.name : "") ? Te(u) : "";
  }
  function He(u) {
    switch (u.tag) {
      case 5:
        return Te(u.type);
      case 16:
        return Te("Lazy");
      case 13:
        return Te("Suspense");
      case 19:
        return Te("SuspenseList");
      case 0:
      case 2:
      case 15:
        return u = Ie(u.type, !1), u;
      case 11:
        return u = Ie(u.type.render, !1), u;
      case 1:
        return u = Ie(u.type, !0), u;
      default:
        return "";
    }
  }
  function Ue(u) {
    if (u == null)
      return null;
    if (typeof u == "function")
      return u.displayName || u.name || null;
    if (typeof u == "string")
      return u;
    switch (u) {
      case Z:
        return "Fragment";
      case j:
        return "Portal";
      case J:
        return "Profiler";
      case ee:
        return "StrictMode";
      case Ce:
        return "Suspense";
      case le:
        return "SuspenseList";
    }
    if (typeof u == "object")
      switch (u.$$typeof) {
        case de:
          return (u.displayName || "Context") + ".Consumer";
        case he:
          return (u._context.displayName || "Context") + ".Provider";
        case Re:
          var c = u.render;
          return u = u.displayName, u || (u = c.displayName || c.name || "", u = u !== "" ? "ForwardRef(" + u + ")" : "ForwardRef"), u;
        case me:
          return c = u.displayName || null, c !== null ? c : Ue(u.type) || "Memo";
        case fe:
          c = u._payload, u = u._init;
          try {
            return Ue(u(c));
          } catch {
          }
      }
    return null;
  }
  function Ze(u) {
    var c = u.type;
    switch (u.tag) {
      case 24:
        return "Cache";
      case 9:
        return (c.displayName || "Context") + ".Consumer";
      case 10:
        return (c._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return u = c.render, u = u.displayName || u.name || "", c.displayName || (u !== "" ? "ForwardRef(" + u + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return c;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Ue(c);
      case 8:
        return c === ee ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof c == "function")
          return c.displayName || c.name || null;
        if (typeof c == "string")
          return c;
    }
    return null;
  }
  function Qe(u) {
    switch (typeof u) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return u;
      case "object":
        return u;
      default:
        return "";
    }
  }
  function it(u) {
    var c = u.type;
    return (u = u.nodeName) && u.toLowerCase() === "input" && (c === "checkbox" || c === "radio");
  }
  function We(u) {
    var c = it(u) ? "checked" : "value", g = Object.getOwnPropertyDescriptor(u.constructor.prototype, c), y = "" + u[c];
    if (!u.hasOwnProperty(c) && typeof g < "u" && typeof g.get == "function" && typeof g.set == "function") {
      var C = g.get, w = g.set;
      return Object.defineProperty(u, c, { configurable: !0, get: function() {
        return C.call(this);
      }, set: function(M) {
        y = "" + M, w.call(this, M);
      } }), Object.defineProperty(u, c, { enumerable: g.enumerable }), { getValue: function() {
        return y;
      }, setValue: function(M) {
        y = "" + M;
      }, stopTracking: function() {
        u._valueTracker = null, delete u[c];
      } };
    }
  }
  function _t(u) {
    u._valueTracker || (u._valueTracker = We(u));
  }
  function xe(u) {
    if (!u)
      return !1;
    var c = u._valueTracker;
    if (!c)
      return !0;
    var g = c.getValue(), y = "";
    return u && (y = it(u) ? u.checked ? "true" : "false" : u.value), u = y, u !== g ? (c.setValue(u), !0) : !1;
  }
  function Je(u) {
    if (u = u || (typeof document < "u" ? document : void 0), typeof u > "u")
      return null;
    try {
      return u.activeElement || u.body;
    } catch {
      return u.body;
    }
  }
  function Pt(u, c) {
    var g = c.checked;
    return G({}, c, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: g ?? u._wrapperState.initialChecked });
  }
  function bt(u, c) {
    var g = c.defaultValue == null ? "" : c.defaultValue, y = c.checked != null ? c.checked : c.defaultChecked;
    g = Qe(c.value != null ? c.value : g), u._wrapperState = { initialChecked: y, initialValue: g, controlled: c.type === "checkbox" || c.type === "radio" ? c.checked != null : c.value != null };
  }
  function ir(u, c) {
    c = c.checked, c != null && z(u, "checked", c, !1);
  }
  function Cr(u, c) {
    ir(u, c);
    var g = Qe(c.value), y = c.type;
    if (g != null)
      y === "number" ? (g === 0 && u.value === "" || u.value != g) && (u.value = "" + g) : u.value !== "" + g && (u.value = "" + g);
    else if (y === "submit" || y === "reset") {
      u.removeAttribute("value");
      return;
    }
    c.hasOwnProperty("value") ? ur(u, c.type, g) : c.hasOwnProperty("defaultValue") && ur(u, c.type, Qe(c.defaultValue)), c.checked == null && c.defaultChecked != null && (u.defaultChecked = !!c.defaultChecked);
  }
  function qt(u, c, g) {
    if (c.hasOwnProperty("value") || c.hasOwnProperty("defaultValue")) {
      var y = c.type;
      if (!(y !== "submit" && y !== "reset" || c.value !== void 0 && c.value !== null))
        return;
      c = "" + u._wrapperState.initialValue, g || c === u.value || (u.value = c), u.defaultValue = c;
    }
    g = u.name, g !== "" && (u.name = ""), u.defaultChecked = !!u._wrapperState.initialChecked, g !== "" && (u.name = g);
  }
  function ur(u, c, g) {
    (c !== "number" || Je(u.ownerDocument) !== u) && (g == null ? u.defaultValue = "" + u._wrapperState.initialValue : u.defaultValue !== "" + g && (u.defaultValue = "" + g));
  }
  var Fr = Array.isArray;
  function pi(u, c, g, y) {
    if (u = u.options, c) {
      c = {};
      for (var C = 0; C < g.length; C++)
        c["$" + g[C]] = !0;
      for (g = 0; g < u.length; g++)
        C = c.hasOwnProperty("$" + u[g].value), u[g].selected !== C && (u[g].selected = C), C && y && (u[g].defaultSelected = !0);
    } else {
      for (g = "" + Qe(g), c = null, C = 0; C < u.length; C++) {
        if (u[C].value === g) {
          u[C].selected = !0, y && (u[C].defaultSelected = !0);
          return;
        }
        c !== null || u[C].disabled || (c = u[C]);
      }
      c !== null && (c.selected = !0);
    }
  }
  function Ri(u, c) {
    if (c.dangerouslySetInnerHTML != null)
      throw Error(r(91));
    return G({}, c, { value: void 0, defaultValue: void 0, children: "" + u._wrapperState.initialValue });
  }
  function hn(u, c) {
    var g = c.value;
    if (g == null) {
      if (g = c.children, c = c.defaultValue, g != null) {
        if (c != null)
          throw Error(r(92));
        if (Fr(g)) {
          if (1 < g.length)
            throw Error(r(93));
          g = g[0];
        }
        c = g;
      }
      c == null && (c = ""), g = c;
    }
    u._wrapperState = { initialValue: Qe(g) };
  }
  function fr(u, c) {
    var g = Qe(c.value), y = Qe(c.defaultValue);
    g != null && (g = "" + g, g !== u.value && (u.value = g), c.defaultValue == null && u.defaultValue !== g && (u.defaultValue = g)), y != null && (u.defaultValue = "" + y);
  }
  function Er(u) {
    var c = u.textContent;
    c === u._wrapperState.initialValue && c !== "" && c !== null && (u.value = c);
  }
  function Ji(u) {
    switch (u) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function $r(u, c) {
    return u == null || u === "http://www.w3.org/1999/xhtml" ? Ji(c) : u === "http://www.w3.org/2000/svg" && c === "foreignObject" ? "http://www.w3.org/1999/xhtml" : u;
  }
  var Tn, Wo = function(u) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(c, g, y, C) {
      MSApp.execUnsafeLocalFunction(function() {
        return u(c, g, y, C);
      });
    } : u;
  }(function(u, c) {
    if (u.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in u)
      u.innerHTML = c;
    else {
      for (Tn = Tn || document.createElement("div"), Tn.innerHTML = "<svg>" + c.valueOf().toString() + "</svg>", c = Tn.firstChild; u.firstChild; )
        u.removeChild(u.firstChild);
      for (; c.firstChild; )
        u.appendChild(c.firstChild);
    }
  });
  function Za(u, c) {
    if (c) {
      var g = u.firstChild;
      if (g && g === u.lastChild && g.nodeType === 3) {
        g.nodeValue = c;
        return;
      }
    }
    u.textContent = c;
  }
  var Sa = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Ge = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Sa).forEach(function(u) {
    Ge.forEach(function(c) {
      c = c + u.charAt(0).toUpperCase() + u.substring(1), Sa[c] = Sa[u];
    });
  });
  function ht(u, c, g) {
    return c == null || typeof c == "boolean" || c === "" ? "" : g || typeof c != "number" || c === 0 || Sa.hasOwnProperty(u) && Sa[u] ? ("" + c).trim() : c + "px";
  }
  function Vt(u, c) {
    u = u.style;
    for (var g in c)
      if (c.hasOwnProperty(g)) {
        var y = g.indexOf("--") === 0, C = ht(g, c[g], y);
        g === "float" && (g = "cssFloat"), y ? u.setProperty(g, C) : u[g] = C;
      }
  }
  var cr = G({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function _r(u, c) {
    if (c) {
      if (cr[u] && (c.children != null || c.dangerouslySetInnerHTML != null))
        throw Error(r(137, u));
      if (c.dangerouslySetInnerHTML != null) {
        if (c.children != null)
          throw Error(r(60));
        if (typeof c.dangerouslySetInnerHTML != "object" || !("__html" in c.dangerouslySetInnerHTML))
          throw Error(r(61));
      }
      if (c.style != null && typeof c.style != "object")
        throw Error(r(62));
    }
  }
  function wn(u, c) {
    if (u.indexOf("-") === -1)
      return typeof c.is == "string";
    switch (u) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Yr = null;
  function An(u) {
    return u = u.target || u.srcElement || window, u.correspondingUseElement && (u = u.correspondingUseElement), u.nodeType === 3 ? u.parentNode : u;
  }
  var Br = null, Qt = null, Tr = null;
  function sc(u) {
    if (u = mf(u)) {
      if (typeof Br != "function")
        throw Error(r(280));
      var c = u.stateNode;
      c && (c = dt(c), Br(u.stateNode, u.type, c));
    }
  }
  function Gl(u) {
    Qt ? Tr ? Tr.push(u) : Tr = [u] : Qt = u;
  }
  function lc() {
    if (Qt) {
      var u = Qt, c = Tr;
      if (Tr = Qt = null, sc(u), c)
        for (u = 0; u < c.length; u++)
          sc(c[u]);
    }
  }
  function Xd(u, c) {
    return u(c);
  }
  function Hh() {
  }
  var Ul = !1;
  function uc(u, c, g) {
    if (Ul)
      return u(c, g);
    Ul = !0;
    try {
      return Xd(u, c, g);
    } finally {
      Ul = !1, (Qt !== null || Tr !== null) && (Hh(), lc());
    }
  }
  function jl(u, c) {
    var g = u.stateNode;
    if (g === null)
      return null;
    var y = dt(g);
    if (y === null)
      return null;
    g = y[c];
    e:
      switch (c) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (y = !y.disabled) || (u = u.type, y = !(u === "button" || u === "input" || u === "select" || u === "textarea")), u = !y;
          break e;
        default:
          u = !1;
      }
    if (u)
      return null;
    if (g && typeof g != "function")
      throw Error(r(231, c, typeof g));
    return g;
  }
  var cc = !1;
  if (d)
    try {
      var go = {};
      Object.defineProperty(go, "passive", { get: function() {
        cc = !0;
      } }), window.addEventListener("test", go, go), window.removeEventListener("test", go, go);
    } catch {
      cc = !1;
    }
  function Bs(u, c, g, y, C, w, M, H, $) {
    var ue = Array.prototype.slice.call(arguments, 3);
    try {
      c.apply(g, ue);
    } catch (Oe) {
      this.onError(Oe);
    }
  }
  var ea = !1, Qa = null, zs = !1, U = null, ke = { onError: function(u) {
    ea = !0, Qa = u;
  } };
  function ze(u, c, g, y, C, w, M, H, $) {
    ea = !1, Qa = null, Bs.apply(ke, arguments);
  }
  function vt(u, c, g, y, C, w, M, H, $) {
    if (ze.apply(this, arguments), ea) {
      if (ea) {
        var ue = Qa;
        ea = !1, Qa = null;
      } else
        throw Error(r(198));
      zs || (zs = !0, U = ue);
    }
  }
  function It(u) {
    var c = u, g = u;
    if (u.alternate)
      for (; c.return; )
        c = c.return;
    else {
      u = c;
      do
        c = u, c.flags & 4098 && (g = c.return), u = c.return;
      while (u);
    }
    return c.tag === 3 ? g : null;
  }
  function Kt(u) {
    if (u.tag === 13) {
      var c = u.memoizedState;
      if (c === null && (u = u.alternate, u !== null && (c = u.memoizedState)), c !== null)
        return c.dehydrated;
    }
    return null;
  }
  function Nt(u) {
    if (It(u) !== u)
      throw Error(r(188));
  }
  function gt(u) {
    var c = u.alternate;
    if (!c) {
      if (c = It(u), c === null)
        throw Error(r(188));
      return c !== u ? null : u;
    }
    for (var g = u, y = c; ; ) {
      var C = g.return;
      if (C === null)
        break;
      var w = C.alternate;
      if (w === null) {
        if (y = C.return, y !== null) {
          g = y;
          continue;
        }
        break;
      }
      if (C.child === w.child) {
        for (w = C.child; w; ) {
          if (w === g)
            return Nt(C), u;
          if (w === y)
            return Nt(C), c;
          w = w.sibling;
        }
        throw Error(r(188));
      }
      if (g.return !== y.return)
        g = C, y = w;
      else {
        for (var M = !1, H = C.child; H; ) {
          if (H === g) {
            M = !0, g = C, y = w;
            break;
          }
          if (H === y) {
            M = !0, y = C, g = w;
            break;
          }
          H = H.sibling;
        }
        if (!M) {
          for (H = w.child; H; ) {
            if (H === g) {
              M = !0, g = w, y = C;
              break;
            }
            if (H === y) {
              M = !0, y = w, g = C;
              break;
            }
            H = H.sibling;
          }
          if (!M)
            throw Error(r(189));
        }
      }
      if (g.alternate !== y)
        throw Error(r(190));
    }
    if (g.tag !== 3)
      throw Error(r(188));
    return g.stateNode.current === g ? u : c;
  }
  function On(u) {
    return u = gt(u), u !== null ? Mr(u) : null;
  }
  function Mr(u) {
    if (u.tag === 5 || u.tag === 6)
      return u;
    for (u = u.child; u !== null; ) {
      var c = Mr(u);
      if (c !== null)
        return c;
      u = u.sibling;
    }
    return null;
  }
  var Lr = t.unstable_scheduleCallback, gi = t.unstable_cancelCallback, Hs = t.unstable_shouldYield, Gh = t.unstable_requestPaint, Jt = t.unstable_now, QT = t.unstable_getCurrentPriorityLevel, Xo = t.unstable_ImmediatePriority, Bt = t.unstable_UserBlockingPriority, Gs = t.unstable_NormalPriority, Hy = t.unstable_LowPriority, Kg = t.unstable_IdlePriority, qd = null, Ja = null;
  function Gy(u) {
    if (Ja && typeof Ja.onCommitFiberRoot == "function")
      try {
        Ja.onCommitFiberRoot(qd, u, void 0, (u.current.flags & 128) === 128);
      } catch {
      }
  }
  var Ca = Math.clz32 ? Math.clz32 : JT, Uy = Math.log, jy = Math.LN2;
  function JT(u) {
    return u >>>= 0, u === 0 ? 32 : 31 - (Uy(u) / jy | 0) | 0;
  }
  var Uh = 64, dc = 4194304;
  function $l(u) {
    switch (u & -u) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return u & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return u & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return u;
    }
  }
  function eo(u, c) {
    var g = u.pendingLanes;
    if (g === 0)
      return 0;
    var y = 0, C = u.suspendedLanes, w = u.pingedLanes, M = g & 268435455;
    if (M !== 0) {
      var H = M & ~C;
      H !== 0 ? y = $l(H) : (w &= M, w !== 0 && (y = $l(w)));
    } else
      M = g & ~C, M !== 0 ? y = $l(M) : w !== 0 && (y = $l(w));
    if (y === 0)
      return 0;
    if (c !== 0 && c !== y && !(c & C) && (C = y & -y, w = c & -c, C >= w || C === 16 && (w & 4194240) !== 0))
      return c;
    if (y & 4 && (y |= g & 16), c = u.entangledLanes, c !== 0)
      for (u = u.entanglements, c &= y; 0 < c; )
        g = 31 - Ca(c), C = 1 << g, y |= u[g], c &= ~C;
    return y;
  }
  function Zg(u, c) {
    switch (u) {
      case 1:
      case 2:
      case 4:
        return c + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return c + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function jh(u, c) {
    for (var g = u.suspendedLanes, y = u.pingedLanes, C = u.expirationTimes, w = u.pendingLanes; 0 < w; ) {
      var M = 31 - Ca(w), H = 1 << M, $ = C[M];
      $ === -1 ? (!(H & g) || H & y) && (C[M] = Zg(H, c)) : $ <= c && (u.expiredLanes |= H), w &= ~H;
    }
  }
  function Qg(u) {
    return u = u.pendingLanes & -1073741825, u !== 0 ? u : u & 1073741824 ? 1073741824 : 0;
  }
  function $h() {
    var u = Uh;
    return Uh <<= 1, !(Uh & 4194240) && (Uh = 64), u;
  }
  function Jg(u) {
    for (var c = [], g = 0; 31 > g; g++)
      c.push(u);
    return c;
  }
  function Yl(u, c, g) {
    u.pendingLanes |= c, c !== 536870912 && (u.suspendedLanes = 0, u.pingedLanes = 0), u = u.eventTimes, c = 31 - Ca(c), u[c] = g;
  }
  function e1(u, c) {
    var g = u.pendingLanes & ~c;
    u.pendingLanes = c, u.suspendedLanes = 0, u.pingedLanes = 0, u.expiredLanes &= c, u.mutableReadLanes &= c, u.entangledLanes &= c, c = u.entanglements;
    var y = u.eventTimes;
    for (u = u.expirationTimes; 0 < g; ) {
      var C = 31 - Ca(g), w = 1 << C;
      c[C] = 0, y[C] = -1, u[C] = -1, g &= ~w;
    }
  }
  function Kd(u, c) {
    var g = u.entangledLanes |= c;
    for (u = u.entanglements; g; ) {
      var y = 31 - Ca(g), C = 1 << y;
      C & c | u[y] & c && (u[y] |= c), g &= ~C;
    }
  }
  var dr = 0;
  function em(u) {
    return u &= -u, 1 < u ? 4 < u ? u & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var $y, Yh, yr, Yy, tm, kt = !1, Zd = [], an = null, Ea = null, Ta = null, Qd = /* @__PURE__ */ new Map(), vn = /* @__PURE__ */ new Map(), hr = [], t1 = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function to(u, c) {
    switch (u) {
      case "focusin":
      case "focusout":
        an = null;
        break;
      case "dragenter":
      case "dragleave":
        Ea = null;
        break;
      case "mouseover":
      case "mouseout":
        Ta = null;
        break;
      case "pointerover":
      case "pointerout":
        Qd.delete(c.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        vn.delete(c.pointerId);
    }
  }
  function ri(u, c, g, y, C, w) {
    return u === null || u.nativeEvent !== w ? (u = { blockedOn: c, domEventName: g, eventSystemFlags: y, nativeEvent: w, targetContainers: [C] }, c !== null && (c = mf(c), c !== null && Yh(c)), u) : (u.eventSystemFlags |= y, c = u.targetContainers, C !== null && c.indexOf(C) === -1 && c.push(C), u);
  }
  function Us(u, c, g, y, C) {
    switch (c) {
      case "focusin":
        return an = ri(an, u, c, g, y, C), !0;
      case "dragenter":
        return Ea = ri(Ea, u, c, g, y, C), !0;
      case "mouseover":
        return Ta = ri(Ta, u, c, g, y, C), !0;
      case "pointerover":
        var w = C.pointerId;
        return Qd.set(w, ri(Qd.get(w) || null, u, c, g, y, C)), !0;
      case "gotpointercapture":
        return w = C.pointerId, vn.set(w, ri(vn.get(w) || null, u, c, g, y, C)), !0;
    }
    return !1;
  }
  function Wy(u) {
    var c = Aa(u.target);
    if (c !== null) {
      var g = It(c);
      if (g !== null) {
        if (c = g.tag, c === 13) {
          if (c = Kt(g), c !== null) {
            u.blockedOn = c, tm(u.priority, function() {
              yr(g);
            });
            return;
          }
        } else if (c === 3 && g.stateNode.current.memoizedState.isDehydrated) {
          u.blockedOn = g.tag === 3 ? g.stateNode.containerInfo : null;
          return;
        }
      }
    }
    u.blockedOn = null;
  }
  function fc(u) {
    if (u.blockedOn !== null)
      return !1;
    for (var c = u.targetContainers; 0 < c.length; ) {
      var g = qh(u.domEventName, u.eventSystemFlags, c[0], u.nativeEvent);
      if (g === null) {
        g = u.nativeEvent;
        var y = new g.constructor(g.type, g);
        Yr = y, g.target.dispatchEvent(y), Yr = null;
      } else
        return c = mf(g), c !== null && Yh(c), u.blockedOn = g, !1;
      c.shift();
    }
    return !0;
  }
  function rm(u, c, g) {
    fc(u) && g.delete(c);
  }
  function Xy() {
    kt = !1, an !== null && fc(an) && (an = null), Ea !== null && fc(Ea) && (Ea = null), Ta !== null && fc(Ta) && (Ta = null), Qd.forEach(rm), vn.forEach(rm);
  }
  function Jd(u, c) {
    u.blockedOn === c && (u.blockedOn = null, kt || (kt = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, Xy)));
  }
  function ef(u) {
    function c(C) {
      return Jd(C, u);
    }
    if (0 < Zd.length) {
      Jd(Zd[0], u);
      for (var g = 1; g < Zd.length; g++) {
        var y = Zd[g];
        y.blockedOn === u && (y.blockedOn = null);
      }
    }
    for (an !== null && Jd(an, u), Ea !== null && Jd(Ea, u), Ta !== null && Jd(Ta, u), Qd.forEach(c), vn.forEach(c), g = 0; g < hr.length; g++)
      y = hr[g], y.blockedOn === u && (y.blockedOn = null);
    for (; 0 < hr.length && (g = hr[0], g.blockedOn === null); )
      Wy(g), g.blockedOn === null && hr.shift();
  }
  var hc = V.ReactCurrentBatchConfig, Wl = !0;
  function qy(u, c, g, y) {
    var C = dr, w = hc.transition;
    hc.transition = null;
    try {
      dr = 1, Xh(u, c, g, y);
    } finally {
      dr = C, hc.transition = w;
    }
  }
  function Wh(u, c, g, y) {
    var C = dr, w = hc.transition;
    hc.transition = null;
    try {
      dr = 4, Xh(u, c, g, y);
    } finally {
      dr = C, hc.transition = w;
    }
  }
  function Xh(u, c, g, y) {
    if (Wl) {
      var C = qh(u, c, g, y);
      if (C === null)
        sv(u, c, y, tf, g), to(u, y);
      else if (Us(C, u, c, g, y))
        y.stopPropagation();
      else if (to(u, y), c & 4 && -1 < t1.indexOf(u)) {
        for (; C !== null; ) {
          var w = mf(C);
          if (w !== null && $y(w), w = qh(u, c, g, y), w === null && sv(u, c, y, tf, g), w === C)
            break;
          C = w;
        }
        C !== null && y.stopPropagation();
      } else
        sv(u, c, y, null, g);
    }
  }
  var tf = null;
  function qh(u, c, g, y) {
    if (tf = null, u = An(y), u = Aa(u), u !== null)
      if (c = It(u), c === null)
        u = null;
      else if (g = c.tag, g === 13) {
        if (u = Kt(c), u !== null)
          return u;
        u = null;
      } else if (g === 3) {
        if (c.stateNode.current.memoizedState.isDehydrated)
          return c.tag === 3 ? c.stateNode.containerInfo : null;
        u = null;
      } else
        c !== u && (u = null);
    return tf = u, null;
  }
  function nm(u) {
    switch (u) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (QT()) {
          case Xo:
            return 1;
          case Bt:
            return 4;
          case Gs:
          case Hy:
            return 16;
          case Kg:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var qo = null, rf = null, nf = null;
  function im() {
    if (nf)
      return nf;
    var u, c = rf, g = c.length, y, C = "value" in qo ? qo.value : qo.textContent, w = C.length;
    for (u = 0; u < g && c[u] === C[u]; u++)
      ;
    var M = g - u;
    for (y = 1; y <= M && c[g - y] === C[w - y]; y++)
      ;
    return nf = C.slice(u, 1 < y ? 1 - y : void 0);
  }
  function vc(u) {
    var c = u.keyCode;
    return "charCode" in u ? (u = u.charCode, u === 0 && c === 13 && (u = 13)) : u = c, u === 10 && (u = 13), 32 <= u || u === 13 ? u : 0;
  }
  function af() {
    return !0;
  }
  function Ky() {
    return !1;
  }
  function ta(u) {
    function c(g, y, C, w, M) {
      this._reactName = g, this._targetInst = C, this.type = y, this.nativeEvent = w, this.target = M, this.currentTarget = null;
      for (var H in u)
        u.hasOwnProperty(H) && (g = u[H], this[H] = g ? g(w) : w[H]);
      return this.isDefaultPrevented = (w.defaultPrevented != null ? w.defaultPrevented : w.returnValue === !1) ? af : Ky, this.isPropagationStopped = Ky, this;
    }
    return G(c.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var g = this.nativeEvent;
      g && (g.preventDefault ? g.preventDefault() : typeof g.returnValue != "unknown" && (g.returnValue = !1), this.isDefaultPrevented = af);
    }, stopPropagation: function() {
      var g = this.nativeEvent;
      g && (g.stopPropagation ? g.stopPropagation() : typeof g.cancelBubble != "unknown" && (g.cancelBubble = !0), this.isPropagationStopped = af);
    }, persist: function() {
    }, isPersistent: af }), c;
  }
  var js = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(u) {
    return u.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Kh = ta(js), pc = G({}, js, { view: 0, detail: 0 }), Zy = ta(pc), Zh, am, of, kn = G({}, pc, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: um, button: 0, buttons: 0, relatedTarget: function(u) {
    return u.relatedTarget === void 0 ? u.fromElement === u.srcElement ? u.toElement : u.fromElement : u.relatedTarget;
  }, movementX: function(u) {
    return "movementX" in u ? u.movementX : (u !== of && (of && u.type === "mousemove" ? (Zh = u.screenX - of.screenX, am = u.screenY - of.screenY) : am = Zh = 0, of = u), Zh);
  }, movementY: function(u) {
    return "movementY" in u ? u.movementY : am;
  } }), Qh = ta(kn), Qy = G({}, kn, { dataTransfer: 0 }), Jy = ta(Qy), r1 = G({}, pc, { relatedTarget: 0 }), $s = ta(r1), om = G({}, js, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), ex = ta(om), n1 = G({}, js, { clipboardData: function(u) {
    return "clipboardData" in u ? u.clipboardData : window.clipboardData;
  } }), i1 = ta(n1), a1 = G({}, js, { data: 0 }), sm = ta(a1), lm = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, tx = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, rx = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function nx(u) {
    var c = this.nativeEvent;
    return c.getModifierState ? c.getModifierState(u) : (u = rx[u]) ? !!c[u] : !1;
  }
  function um() {
    return nx;
  }
  var Ko = G({}, pc, { key: function(u) {
    if (u.key) {
      var c = lm[u.key] || u.key;
      if (c !== "Unidentified")
        return c;
    }
    return u.type === "keypress" ? (u = vc(u), u === 13 ? "Enter" : String.fromCharCode(u)) : u.type === "keydown" || u.type === "keyup" ? tx[u.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: um, charCode: function(u) {
    return u.type === "keypress" ? vc(u) : 0;
  }, keyCode: function(u) {
    return u.type === "keydown" || u.type === "keyup" ? u.keyCode : 0;
  }, which: function(u) {
    return u.type === "keypress" ? vc(u) : u.type === "keydown" || u.type === "keyup" ? u.keyCode : 0;
  } }), o1 = ta(Ko), cm = G({}, kn, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Jh = ta(cm), dm = G({}, pc, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: um }), s1 = ta(dm), ev = G({}, js, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), ix = ta(ev), Di = G({}, kn, {
    deltaX: function(u) {
      return "deltaX" in u ? u.deltaX : "wheelDeltaX" in u ? -u.wheelDeltaX : 0;
    },
    deltaY: function(u) {
      return "deltaY" in u ? u.deltaY : "wheelDeltaY" in u ? -u.wheelDeltaY : "wheelDelta" in u ? -u.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Zo = ta(Di), on = [9, 13, 27, 32], ro = d && "CompositionEvent" in window, Xl = null;
  d && "documentMode" in document && (Xl = document.documentMode);
  var tv = d && "TextEvent" in window && !Xl, ax = d && (!ro || Xl && 8 < Xl && 11 >= Xl), gc = " ", ox = !1;
  function sx(u, c) {
    switch (u) {
      case "keyup":
        return on.indexOf(c.keyCode) !== -1;
      case "keydown":
        return c.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function rv(u) {
    return u = u.detail, typeof u == "object" && "data" in u ? u.data : null;
  }
  var mc = !1;
  function l1(u, c) {
    switch (u) {
      case "compositionend":
        return rv(c);
      case "keypress":
        return c.which !== 32 ? null : (ox = !0, gc);
      case "textInput":
        return u = c.data, u === gc && ox ? null : u;
      default:
        return null;
    }
  }
  function u1(u, c) {
    if (mc)
      return u === "compositionend" || !ro && sx(u, c) ? (u = im(), nf = rf = qo = null, mc = !1, u) : null;
    switch (u) {
      case "paste":
        return null;
      case "keypress":
        if (!(c.ctrlKey || c.altKey || c.metaKey) || c.ctrlKey && c.altKey) {
          if (c.char && 1 < c.char.length)
            return c.char;
          if (c.which)
            return String.fromCharCode(c.which);
        }
        return null;
      case "compositionend":
        return ax && c.locale !== "ko" ? null : c.data;
      default:
        return null;
    }
  }
  var lx = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function ux(u) {
    var c = u && u.nodeName && u.nodeName.toLowerCase();
    return c === "input" ? !!lx[u.type] : c === "textarea";
  }
  function cx(u, c, g, y) {
    Gl(y), c = vf(c, "onChange"), 0 < c.length && (g = new Kh("onChange", "change", null, g, y), u.push({ event: g, listeners: c }));
  }
  var sf = null, _c = null;
  function yc(u) {
    ov(u, 0);
  }
  function xc(u) {
    var c = Sc(u);
    if (xe(c))
      return u;
  }
  function dx(u, c) {
    if (u === "change")
      return c;
  }
  var fm = !1;
  if (d) {
    var hm;
    if (d) {
      var vm = "oninput" in document;
      if (!vm) {
        var fx = document.createElement("div");
        fx.setAttribute("oninput", "return;"), vm = typeof fx.oninput == "function";
      }
      hm = vm;
    } else
      hm = !1;
    fm = hm && (!document.documentMode || 9 < document.documentMode);
  }
  function hx() {
    sf && (sf.detachEvent("onpropertychange", vx), _c = sf = null);
  }
  function vx(u) {
    if (u.propertyName === "value" && xc(_c)) {
      var c = [];
      cx(c, _c, u, An(u)), uc(yc, c);
    }
  }
  function c1(u, c, g) {
    u === "focusin" ? (hx(), sf = c, _c = g, sf.attachEvent("onpropertychange", vx)) : u === "focusout" && hx();
  }
  function d1(u) {
    if (u === "selectionchange" || u === "keyup" || u === "keydown")
      return xc(_c);
  }
  function f1(u, c) {
    if (u === "click")
      return xc(c);
  }
  function px(u, c) {
    if (u === "input" || u === "change")
      return xc(c);
  }
  function h1(u, c) {
    return u === c && (u !== 0 || 1 / u === 1 / c) || u !== u && c !== c;
  }
  var wa = typeof Object.is == "function" ? Object.is : h1;
  function lf(u, c) {
    if (wa(u, c))
      return !0;
    if (typeof u != "object" || u === null || typeof c != "object" || c === null)
      return !1;
    var g = Object.keys(u), y = Object.keys(c);
    if (g.length !== y.length)
      return !1;
    for (y = 0; y < g.length; y++) {
      var C = g[y];
      if (!h.call(c, C) || !wa(u[C], c[C]))
        return !1;
    }
    return !0;
  }
  function gx(u) {
    for (; u && u.firstChild; )
      u = u.firstChild;
    return u;
  }
  function mx(u, c) {
    var g = gx(u);
    u = 0;
    for (var y; g; ) {
      if (g.nodeType === 3) {
        if (y = u + g.textContent.length, u <= c && y >= c)
          return { node: g, offset: c - u };
        u = y;
      }
      e: {
        for (; g; ) {
          if (g.nextSibling) {
            g = g.nextSibling;
            break e;
          }
          g = g.parentNode;
        }
        g = void 0;
      }
      g = gx(g);
    }
  }
  function _x(u, c) {
    return u && c ? u === c ? !0 : u && u.nodeType === 3 ? !1 : c && c.nodeType === 3 ? _x(u, c.parentNode) : "contains" in u ? u.contains(c) : u.compareDocumentPosition ? !!(u.compareDocumentPosition(c) & 16) : !1 : !1;
  }
  function nv() {
    for (var u = window, c = Je(); c instanceof u.HTMLIFrameElement; ) {
      try {
        var g = typeof c.contentWindow.location.href == "string";
      } catch {
        g = !1;
      }
      if (g)
        u = c.contentWindow;
      else
        break;
      c = Je(u.document);
    }
    return c;
  }
  function Qo(u) {
    var c = u && u.nodeName && u.nodeName.toLowerCase();
    return c && (c === "input" && (u.type === "text" || u.type === "search" || u.type === "tel" || u.type === "url" || u.type === "password") || c === "textarea" || u.contentEditable === "true");
  }
  function iv(u) {
    var c = nv(), g = u.focusedElem, y = u.selectionRange;
    if (c !== g && g && g.ownerDocument && _x(g.ownerDocument.documentElement, g)) {
      if (y !== null && Qo(g)) {
        if (c = y.start, u = y.end, u === void 0 && (u = c), "selectionStart" in g)
          g.selectionStart = c, g.selectionEnd = Math.min(u, g.value.length);
        else if (u = (c = g.ownerDocument || document) && c.defaultView || window, u.getSelection) {
          u = u.getSelection();
          var C = g.textContent.length, w = Math.min(y.start, C);
          y = y.end === void 0 ? w : Math.min(y.end, C), !u.extend && w > y && (C = y, y = w, w = C), C = mx(g, w);
          var M = mx(
            g,
            y
          );
          C && M && (u.rangeCount !== 1 || u.anchorNode !== C.node || u.anchorOffset !== C.offset || u.focusNode !== M.node || u.focusOffset !== M.offset) && (c = c.createRange(), c.setStart(C.node, C.offset), u.removeAllRanges(), w > y ? (u.addRange(c), u.extend(M.node, M.offset)) : (c.setEnd(M.node, M.offset), u.addRange(c)));
        }
      }
      for (c = [], u = g; u = u.parentNode; )
        u.nodeType === 1 && c.push({ element: u, left: u.scrollLeft, top: u.scrollTop });
      for (typeof g.focus == "function" && g.focus(), g = 0; g < c.length; g++)
        u = c[g], u.element.scrollLeft = u.left, u.element.scrollTop = u.top;
    }
  }
  var yx = d && "documentMode" in document && 11 >= document.documentMode, no = null, pm = null, uf = null, gm = !1;
  function xx(u, c, g) {
    var y = g.window === g ? g.document : g.nodeType === 9 ? g : g.ownerDocument;
    gm || no == null || no !== Je(y) || (y = no, "selectionStart" in y && Qo(y) ? y = { start: y.selectionStart, end: y.selectionEnd } : (y = (y.ownerDocument && y.ownerDocument.defaultView || window).getSelection(), y = { anchorNode: y.anchorNode, anchorOffset: y.anchorOffset, focusNode: y.focusNode, focusOffset: y.focusOffset }), uf && lf(uf, y) || (uf = y, y = vf(pm, "onSelect"), 0 < y.length && (c = new Kh("onSelect", "select", null, c, g), u.push({ event: c, listeners: y }), c.target = no)));
  }
  function av(u, c) {
    var g = {};
    return g[u.toLowerCase()] = c.toLowerCase(), g["Webkit" + u] = "webkit" + c, g["Moz" + u] = "moz" + c, g;
  }
  var ql = { animationend: av("Animation", "AnimationEnd"), animationiteration: av("Animation", "AnimationIteration"), animationstart: av("Animation", "AnimationStart"), transitionend: av("Transition", "TransitionEnd") }, mm = {}, _m = {};
  d && (_m = document.createElement("div").style, "AnimationEvent" in window || (delete ql.animationend.animation, delete ql.animationiteration.animation, delete ql.animationstart.animation), "TransitionEvent" in window || delete ql.transitionend.transition);
  function Rn(u) {
    if (mm[u])
      return mm[u];
    if (!ql[u])
      return u;
    var c = ql[u], g;
    for (g in c)
      if (c.hasOwnProperty(g) && g in _m)
        return mm[u] = c[g];
    return u;
  }
  var ym = Rn("animationend"), bx = Rn("animationiteration"), Sx = Rn("animationstart"), Cx = Rn("transitionend"), Ex = /* @__PURE__ */ new Map(), Tx = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Jo(u, c) {
    Ex.set(u, c), s(c, [u]);
  }
  for (var cf = 0; cf < Tx.length; cf++) {
    var Kl = Tx[cf], v1 = Kl.toLowerCase(), df = Kl[0].toUpperCase() + Kl.slice(1);
    Jo(v1, "on" + df);
  }
  Jo(ym, "onAnimationEnd"), Jo(bx, "onAnimationIteration"), Jo(Sx, "onAnimationStart"), Jo("dblclick", "onDoubleClick"), Jo("focusin", "onFocus"), Jo("focusout", "onBlur"), Jo(Cx, "onTransitionEnd"), l("onMouseEnter", ["mouseout", "mouseover"]), l("onMouseLeave", ["mouseout", "mouseover"]), l("onPointerEnter", ["pointerout", "pointerover"]), l("onPointerLeave", ["pointerout", "pointerover"]), s("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), s("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), s("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), s("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), s("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), s("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var ff = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), p1 = new Set("cancel close invalid load scroll toggle".split(" ").concat(ff));
  function wx(u, c, g) {
    var y = u.type || "unknown-event";
    u.currentTarget = g, vt(y, c, void 0, u), u.currentTarget = null;
  }
  function ov(u, c) {
    c = (c & 4) !== 0;
    for (var g = 0; g < u.length; g++) {
      var y = u[g], C = y.event;
      y = y.listeners;
      e: {
        var w = void 0;
        if (c)
          for (var M = y.length - 1; 0 <= M; M--) {
            var H = y[M], $ = H.instance, ue = H.currentTarget;
            if (H = H.listener, $ !== w && C.isPropagationStopped())
              break e;
            wx(C, H, ue), w = $;
          }
        else
          for (M = 0; M < y.length; M++) {
            if (H = y[M], $ = H.instance, ue = H.currentTarget, H = H.listener, $ !== w && C.isPropagationStopped())
              break e;
            wx(C, H, ue), w = $;
          }
      }
    }
    if (zs)
      throw u = U, zs = !1, U = null, u;
  }
  function xr(u, c) {
    var g = c[wm];
    g === void 0 && (g = c[wm] = /* @__PURE__ */ new Set());
    var y = u + "__bubble";
    g.has(y) || (Ax(c, u, 2, !1), g.add(y));
  }
  function Ys(u, c, g) {
    var y = 0;
    c && (y |= 4), Ax(g, u, y, c);
  }
  var es = "_reactListening" + Math.random().toString(36).slice(2);
  function bc(u) {
    if (!u[es]) {
      u[es] = !0, n.forEach(function(g) {
        g !== "selectionchange" && (p1.has(g) || Ys(g, !1, u), Ys(g, !0, u));
      });
      var c = u.nodeType === 9 ? u : u.ownerDocument;
      c === null || c[es] || (c[es] = !0, Ys("selectionchange", !1, c));
    }
  }
  function Ax(u, c, g, y) {
    switch (nm(c)) {
      case 1:
        var C = qy;
        break;
      case 4:
        C = Wh;
        break;
      default:
        C = Xh;
    }
    g = C.bind(null, c, g, u), C = void 0, !cc || c !== "touchstart" && c !== "touchmove" && c !== "wheel" || (C = !0), y ? C !== void 0 ? u.addEventListener(c, g, { capture: !0, passive: C }) : u.addEventListener(c, g, !0) : C !== void 0 ? u.addEventListener(c, g, { passive: C }) : u.addEventListener(c, g, !1);
  }
  function sv(u, c, g, y, C) {
    var w = y;
    if (!(c & 1) && !(c & 2) && y !== null)
      e:
        for (; ; ) {
          if (y === null)
            return;
          var M = y.tag;
          if (M === 3 || M === 4) {
            var H = y.stateNode.containerInfo;
            if (H === C || H.nodeType === 8 && H.parentNode === C)
              break;
            if (M === 4)
              for (M = y.return; M !== null; ) {
                var $ = M.tag;
                if (($ === 3 || $ === 4) && ($ = M.stateNode.containerInfo, $ === C || $.nodeType === 8 && $.parentNode === C))
                  return;
                M = M.return;
              }
            for (; H !== null; ) {
              if (M = Aa(H), M === null)
                return;
              if ($ = M.tag, $ === 5 || $ === 6) {
                y = w = M;
                continue e;
              }
              H = H.parentNode;
            }
          }
          y = y.return;
        }
    uc(function() {
      var ue = w, Oe = An(g), De = [];
      e: {
        var Ae = Ex.get(u);
        if (Ae !== void 0) {
          var Xe = Kh, tt = u;
          switch (u) {
            case "keypress":
              if (vc(g) === 0)
                break e;
            case "keydown":
            case "keyup":
              Xe = o1;
              break;
            case "focusin":
              tt = "focus", Xe = $s;
              break;
            case "focusout":
              tt = "blur", Xe = $s;
              break;
            case "beforeblur":
            case "afterblur":
              Xe = $s;
              break;
            case "click":
              if (g.button === 2)
                break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Xe = Qh;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Xe = Jy;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Xe = s1;
              break;
            case ym:
            case bx:
            case Sx:
              Xe = ex;
              break;
            case Cx:
              Xe = ix;
              break;
            case "scroll":
              Xe = Zy;
              break;
            case "wheel":
              Xe = Zo;
              break;
            case "copy":
            case "cut":
            case "paste":
              Xe = i1;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Xe = Jh;
          }
          var at = (c & 4) !== 0, en = !at && u === "scroll", te = at ? Ae !== null ? Ae + "Capture" : null : Ae;
          at = [];
          for (var q = ue, ae; q !== null; ) {
            ae = q;
            var Ne = ae.stateNode;
            if (ae.tag === 5 && Ne !== null && (ae = Ne, te !== null && (Ne = jl(q, te), Ne != null && at.push(hf(q, Ne, ae)))), en)
              break;
            q = q.return;
          }
          0 < at.length && (Ae = new Xe(Ae, tt, null, g, Oe), De.push({ event: Ae, listeners: at }));
        }
      }
      if (!(c & 7)) {
        e: {
          if (Ae = u === "mouseover" || u === "pointerover", Xe = u === "mouseout" || u === "pointerout", Ae && g !== Yr && (tt = g.relatedTarget || g.fromElement) && (Aa(tt) || tt[ts]))
            break e;
          if ((Xe || Ae) && (Ae = Oe.window === Oe ? Oe : (Ae = Oe.ownerDocument) ? Ae.defaultView || Ae.parentWindow : window, Xe ? (tt = g.relatedTarget || g.toElement, Xe = ue, tt = tt ? Aa(tt) : null, tt !== null && (en = It(tt), tt !== en || tt.tag !== 5 && tt.tag !== 6) && (tt = null)) : (Xe = null, tt = ue), Xe !== tt)) {
            if (at = Qh, Ne = "onMouseLeave", te = "onMouseEnter", q = "mouse", (u === "pointerout" || u === "pointerover") && (at = Jh, Ne = "onPointerLeave", te = "onPointerEnter", q = "pointer"), en = Xe == null ? Ae : Sc(Xe), ae = tt == null ? Ae : Sc(tt), Ae = new at(Ne, q + "leave", Xe, g, Oe), Ae.target = en, Ae.relatedTarget = ae, Ne = null, Aa(Oe) === ue && (at = new at(te, q + "enter", tt, g, Oe), at.target = ae, at.relatedTarget = en, Ne = at), en = Ne, Xe && tt)
              t: {
                for (at = Xe, te = tt, q = 0, ae = at; ae; ae = Zl(ae))
                  q++;
                for (ae = 0, Ne = te; Ne; Ne = Zl(Ne))
                  ae++;
                for (; 0 < q - ae; )
                  at = Zl(at), q--;
                for (; 0 < ae - q; )
                  te = Zl(te), ae--;
                for (; q--; ) {
                  if (at === te || te !== null && at === te.alternate)
                    break t;
                  at = Zl(at), te = Zl(te);
                }
                at = null;
              }
            else
              at = null;
            Xe !== null && xm(De, Ae, Xe, at, !1), tt !== null && en !== null && xm(De, en, tt, at, !0);
          }
        }
        e: {
          if (Ae = ue ? Sc(ue) : window, Xe = Ae.nodeName && Ae.nodeName.toLowerCase(), Xe === "select" || Xe === "input" && Ae.type === "file")
            var st = dx;
          else if (ux(Ae))
            if (fm)
              st = px;
            else {
              st = d1;
              var rt = c1;
            }
          else
            (Xe = Ae.nodeName) && Xe.toLowerCase() === "input" && (Ae.type === "checkbox" || Ae.type === "radio") && (st = f1);
          if (st && (st = st(u, ue))) {
            cx(De, st, g, Oe);
            break e;
          }
          rt && rt(u, Ae, ue), u === "focusout" && (rt = Ae._wrapperState) && rt.controlled && Ae.type === "number" && ur(Ae, "number", Ae.value);
        }
        switch (rt = ue ? Sc(ue) : window, u) {
          case "focusin":
            (ux(rt) || rt.contentEditable === "true") && (no = rt, pm = ue, uf = null);
            break;
          case "focusout":
            uf = pm = no = null;
            break;
          case "mousedown":
            gm = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            gm = !1, xx(De, g, Oe);
            break;
          case "selectionchange":
            if (yx)
              break;
          case "keydown":
          case "keyup":
            xx(De, g, Oe);
        }
        var ut;
        if (ro)
          e: {
            switch (u) {
              case "compositionstart":
                var Ct = "onCompositionStart";
                break e;
              case "compositionend":
                Ct = "onCompositionEnd";
                break e;
              case "compositionupdate":
                Ct = "onCompositionUpdate";
                break e;
            }
            Ct = void 0;
          }
        else
          mc ? sx(u, g) && (Ct = "onCompositionEnd") : u === "keydown" && g.keyCode === 229 && (Ct = "onCompositionStart");
        Ct && (ax && g.locale !== "ko" && (mc || Ct !== "onCompositionStart" ? Ct === "onCompositionEnd" && mc && (ut = im()) : (qo = Oe, rf = "value" in qo ? qo.value : qo.textContent, mc = !0)), rt = vf(ue, Ct), 0 < rt.length && (Ct = new sm(Ct, u, null, g, Oe), De.push({ event: Ct, listeners: rt }), ut ? Ct.data = ut : (ut = rv(g), ut !== null && (Ct.data = ut)))), (ut = tv ? l1(u, g) : u1(u, g)) && (ue = vf(ue, "onBeforeInput"), 0 < ue.length && (Oe = new sm("onBeforeInput", "beforeinput", null, g, Oe), De.push({ event: Oe, listeners: ue }), Oe.data = ut));
      }
      ov(De, c);
    });
  }
  function hf(u, c, g) {
    return { instance: u, listener: c, currentTarget: g };
  }
  function vf(u, c) {
    for (var g = c + "Capture", y = []; u !== null; ) {
      var C = u, w = C.stateNode;
      C.tag === 5 && w !== null && (C = w, w = jl(u, g), w != null && y.unshift(hf(u, w, C)), w = jl(u, c), w != null && y.push(hf(u, w, C))), u = u.return;
    }
    return y;
  }
  function Zl(u) {
    if (u === null)
      return null;
    do
      u = u.return;
    while (u && u.tag !== 5);
    return u || null;
  }
  function xm(u, c, g, y, C) {
    for (var w = c._reactName, M = []; g !== null && g !== y; ) {
      var H = g, $ = H.alternate, ue = H.stateNode;
      if ($ !== null && $ === y)
        break;
      H.tag === 5 && ue !== null && (H = ue, C ? ($ = jl(g, w), $ != null && M.unshift(hf(g, $, H))) : C || ($ = jl(g, w), $ != null && M.push(hf(g, $, H)))), g = g.return;
    }
    M.length !== 0 && u.push({ event: c, listeners: M });
  }
  var bm = /\r\n?/g, g1 = /\u0000|\uFFFD/g;
  function Sm(u) {
    return (typeof u == "string" ? u : "" + u).replace(bm, `
`).replace(g1, "");
  }
  function lv(u, c, g) {
    if (c = Sm(c), Sm(u) !== c && g)
      throw Error(r(425));
  }
  function uv() {
  }
  var Cm = null, Ql = null;
  function pf(u, c) {
    return u === "textarea" || u === "noscript" || typeof c.children == "string" || typeof c.children == "number" || typeof c.dangerouslySetInnerHTML == "object" && c.dangerouslySetInnerHTML !== null && c.dangerouslySetInnerHTML.__html != null;
  }
  var Jl = typeof setTimeout == "function" ? setTimeout : void 0, Ox = typeof clearTimeout == "function" ? clearTimeout : void 0, Em = typeof Promise == "function" ? Promise : void 0, Tm = typeof queueMicrotask == "function" ? queueMicrotask : typeof Em < "u" ? function(u) {
    return Em.resolve(null).then(u).catch(m1);
  } : Jl;
  function m1(u) {
    setTimeout(function() {
      throw u;
    });
  }
  function Ws(u, c) {
    var g = c, y = 0;
    do {
      var C = g.nextSibling;
      if (u.removeChild(g), C && C.nodeType === 8)
        if (g = C.data, g === "/$") {
          if (y === 0) {
            u.removeChild(C), ef(c);
            return;
          }
          y--;
        } else
          g !== "$" && g !== "$?" && g !== "$!" || y++;
      g = C;
    } while (g);
    ef(c);
  }
  function io(u) {
    for (; u != null; u = u.nextSibling) {
      var c = u.nodeType;
      if (c === 1 || c === 3)
        break;
      if (c === 8) {
        if (c = u.data, c === "$" || c === "$!" || c === "$?")
          break;
        if (c === "/$")
          return null;
      }
    }
    return u;
  }
  function gf(u) {
    u = u.previousSibling;
    for (var c = 0; u; ) {
      if (u.nodeType === 8) {
        var g = u.data;
        if (g === "$" || g === "$!" || g === "$?") {
          if (c === 0)
            return u;
          c--;
        } else
          g === "/$" && c++;
      }
      u = u.previousSibling;
    }
    return null;
  }
  var Xs = Math.random().toString(36).slice(2), mo = "__reactFiber$" + Xs, eu = "__reactProps$" + Xs, ts = "__reactContainer$" + Xs, wm = "__reactEvents$" + Xs, _1 = "__reactListeners$" + Xs, Am = "__reactHandles$" + Xs;
  function Aa(u) {
    var c = u[mo];
    if (c)
      return c;
    for (var g = u.parentNode; g; ) {
      if (c = g[ts] || g[mo]) {
        if (g = c.alternate, c.child !== null || g !== null && g.child !== null)
          for (u = gf(u); u !== null; ) {
            if (g = u[mo])
              return g;
            u = gf(u);
          }
        return c;
      }
      u = g, g = u.parentNode;
    }
    return null;
  }
  function mf(u) {
    return u = u[mo] || u[ts], !u || u.tag !== 5 && u.tag !== 6 && u.tag !== 13 && u.tag !== 3 ? null : u;
  }
  function Sc(u) {
    if (u.tag === 5 || u.tag === 6)
      return u.stateNode;
    throw Error(r(33));
  }
  function dt(u) {
    return u[eu] || null;
  }
  var qs = [], wr = -1;
  function Mt(u) {
    return { current: u };
  }
  function nr(u) {
    0 > wr || (u.current = qs[wr], qs[wr] = null, wr--);
  }
  function ar(u, c) {
    wr++, qs[wr] = u.current, u.current = c;
  }
  var _o = {}, St = Mt(_o), Wr = Mt(!1), Mi = _o;
  function Oa(u, c) {
    var g = u.type.contextTypes;
    if (!g)
      return _o;
    var y = u.stateNode;
    if (y && y.__reactInternalMemoizedUnmaskedChildContext === c)
      return y.__reactInternalMemoizedMaskedChildContext;
    var C = {}, w;
    for (w in g)
      C[w] = c[w];
    return y && (u = u.stateNode, u.__reactInternalMemoizedUnmaskedChildContext = c, u.__reactInternalMemoizedMaskedChildContext = C), C;
  }
  function Pr(u) {
    return u = u.childContextTypes, u != null;
  }
  function ka() {
    nr(Wr), nr(St);
  }
  function Ks(u, c, g) {
    if (St.current !== _o)
      throw Error(r(168));
    ar(St, c), ar(Wr, g);
  }
  function _f(u, c, g) {
    var y = u.stateNode;
    if (c = c.childContextTypes, typeof y.getChildContext != "function")
      return g;
    y = y.getChildContext();
    for (var C in y)
      if (!(C in c))
        throw Error(r(108, Ze(u) || "Unknown", C));
    return G({}, g, y);
  }
  function cv(u) {
    return u = (u = u.stateNode) && u.__reactInternalMemoizedMergedChildContext || _o, Mi = St.current, ar(St, u), ar(Wr, Wr.current), !0;
  }
  function kx(u, c, g) {
    var y = u.stateNode;
    if (!y)
      throw Error(r(169));
    g ? (u = _f(u, c, Mi), y.__reactInternalMemoizedMergedChildContext = u, nr(Wr), nr(St), ar(St, u)) : nr(Wr), ar(Wr, g);
  }
  var ra = null, Dn = !1, yf = !1;
  function Om(u) {
    ra === null ? ra = [u] : ra.push(u);
  }
  function km(u) {
    Dn = !0, Om(u);
  }
  function Li() {
    if (!yf && ra !== null) {
      yf = !0;
      var u = 0, c = dr;
      try {
        var g = ra;
        for (dr = 1; u < g.length; u++) {
          var y = g[u];
          do
            y = y(!0);
          while (y !== null);
        }
        ra = null, Dn = !1;
      } catch (C) {
        throw ra !== null && (ra = ra.slice(u + 1)), Lr(Xo, Li), C;
      } finally {
        dr = c, yf = !1;
      }
    }
    return null;
  }
  var Zs = [], Pi = 0, tu = null, Cc = 0, Ii = [], ni = 0, Ra = null, Bn = 1, rs = "";
  function na(u, c) {
    Zs[Pi++] = Cc, Zs[Pi++] = tu, tu = u, Cc = c;
  }
  function Rm(u, c, g) {
    Ii[ni++] = Bn, Ii[ni++] = rs, Ii[ni++] = Ra, Ra = u;
    var y = Bn;
    u = rs;
    var C = 32 - Ca(y) - 1;
    y &= ~(1 << C), g += 1;
    var w = 32 - Ca(c) + C;
    if (30 < w) {
      var M = C - C % 5;
      w = (y & (1 << M) - 1).toString(32), y >>= M, C -= M, Bn = 1 << 32 - Ca(c) + C | g << C | y, rs = w + u;
    } else
      Bn = 1 << w | g << C | y, rs = u;
  }
  function dv(u) {
    u.return !== null && (na(u, 1), Rm(u, 1, 0));
  }
  function Dm(u) {
    for (; u === tu; )
      tu = Zs[--Pi], Zs[Pi] = null, Cc = Zs[--Pi], Zs[Pi] = null;
    for (; u === Ra; )
      Ra = Ii[--ni], Ii[ni] = null, rs = Ii[--ni], Ii[ni] = null, Bn = Ii[--ni], Ii[ni] = null;
  }
  var ia = null, Ni = null, Ar = !1, Da = null;
  function Mm(u, c) {
    var g = Va(5, null, null, 0);
    g.elementType = "DELETED", g.stateNode = c, g.return = u, c = u.deletions, c === null ? (u.deletions = [g], u.flags |= 16) : c.push(g);
  }
  function Rx(u, c) {
    switch (u.tag) {
      case 5:
        var g = u.type;
        return c = c.nodeType !== 1 || g.toLowerCase() !== c.nodeName.toLowerCase() ? null : c, c !== null ? (u.stateNode = c, ia = u, Ni = io(c.firstChild), !0) : !1;
      case 6:
        return c = u.pendingProps === "" || c.nodeType !== 3 ? null : c, c !== null ? (u.stateNode = c, ia = u, Ni = null, !0) : !1;
      case 13:
        return c = c.nodeType !== 8 ? null : c, c !== null ? (g = Ra !== null ? { id: Bn, overflow: rs } : null, u.memoizedState = { dehydrated: c, treeContext: g, retryLane: 1073741824 }, g = Va(18, null, null, 0), g.stateNode = c, g.return = u, u.child = g, ia = u, Ni = null, !0) : !1;
      default:
        return !1;
    }
  }
  function fv(u) {
    return (u.mode & 1) !== 0 && (u.flags & 128) === 0;
  }
  function hv(u) {
    if (Ar) {
      var c = Ni;
      if (c) {
        var g = c;
        if (!Rx(u, c)) {
          if (fv(u))
            throw Error(r(418));
          c = io(g.nextSibling);
          var y = ia;
          c && Rx(u, c) ? Mm(y, g) : (u.flags = u.flags & -4097 | 2, Ar = !1, ia = u);
        }
      } else {
        if (fv(u))
          throw Error(r(418));
        u.flags = u.flags & -4097 | 2, Ar = !1, ia = u;
      }
    }
  }
  function Dx(u) {
    for (u = u.return; u !== null && u.tag !== 5 && u.tag !== 3 && u.tag !== 13; )
      u = u.return;
    ia = u;
  }
  function vv(u) {
    if (u !== ia)
      return !1;
    if (!Ar)
      return Dx(u), Ar = !0, !1;
    var c;
    if ((c = u.tag !== 3) && !(c = u.tag !== 5) && (c = u.type, c = c !== "head" && c !== "body" && !pf(u.type, u.memoizedProps)), c && (c = Ni)) {
      if (fv(u))
        throw Mx(), Error(r(418));
      for (; c; )
        Mm(u, c), c = io(c.nextSibling);
    }
    if (Dx(u), u.tag === 13) {
      if (u = u.memoizedState, u = u !== null ? u.dehydrated : null, !u)
        throw Error(r(317));
      e: {
        for (u = u.nextSibling, c = 0; u; ) {
          if (u.nodeType === 8) {
            var g = u.data;
            if (g === "/$") {
              if (c === 0) {
                Ni = io(u.nextSibling);
                break e;
              }
              c--;
            } else
              g !== "$" && g !== "$!" && g !== "$?" || c++;
          }
          u = u.nextSibling;
        }
        Ni = null;
      }
    } else
      Ni = ia ? io(u.stateNode.nextSibling) : null;
    return !0;
  }
  function Mx() {
    for (var u = Ni; u; )
      u = io(u.nextSibling);
  }
  function zr() {
    Ni = ia = null, Ar = !1;
  }
  function Lm(u) {
    Da === null ? Da = [u] : Da.push(u);
  }
  var pv = V.ReactCurrentBatchConfig;
  function aa(u, c) {
    if (u && u.defaultProps) {
      c = G({}, c), u = u.defaultProps;
      for (var g in u)
        c[g] === void 0 && (c[g] = u[g]);
      return c;
    }
    return c;
  }
  var yo = Mt(null), gv = null, Qs = null, Pm = null;
  function Im() {
    Pm = Qs = gv = null;
  }
  function ns(u) {
    var c = yo.current;
    nr(yo), u._currentValue = c;
  }
  function pn(u, c, g) {
    for (; u !== null; ) {
      var y = u.alternate;
      if ((u.childLanes & c) !== c ? (u.childLanes |= c, y !== null && (y.childLanes |= c)) : y !== null && (y.childLanes & c) !== c && (y.childLanes |= c), u === g)
        break;
      u = u.return;
    }
  }
  function Fe(u, c) {
    gv = u, Pm = Qs = null, u = u.dependencies, u !== null && u.firstContext !== null && (u.lanes & c && (sn = !0), u.firstContext = null);
  }
  function Jr(u) {
    var c = u._currentValue;
    if (Pm !== u)
      if (u = { context: u, memoizedValue: c, next: null }, Qs === null) {
        if (gv === null)
          throw Error(r(308));
        Qs = u, gv.dependencies = { lanes: 0, firstContext: u };
      } else
        Qs = Qs.next = u;
    return c;
  }
  var zn = null;
  function Nm(u) {
    zn === null ? zn = [u] : zn.push(u);
  }
  function Lx(u, c, g, y) {
    var C = c.interleaved;
    return C === null ? (g.next = g, Nm(c)) : (g.next = C.next, C.next = g), c.interleaved = g, is(u, y);
  }
  function is(u, c) {
    u.lanes |= c;
    var g = u.alternate;
    for (g !== null && (g.lanes |= c), g = u, u = u.return; u !== null; )
      u.childLanes |= c, g = u.alternate, g !== null && (g.childLanes |= c), g = u, u = u.return;
    return g.tag === 3 ? g.stateNode : null;
  }
  var Js = !1;
  function Vm(u) {
    u.updateQueue = { baseState: u.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function gn(u, c) {
    u = u.updateQueue, c.updateQueue === u && (c.updateQueue = { baseState: u.baseState, firstBaseUpdate: u.firstBaseUpdate, lastBaseUpdate: u.lastBaseUpdate, shared: u.shared, effects: u.effects });
  }
  function as(u, c) {
    return { eventTime: u, lane: c, tag: 0, payload: null, callback: null, next: null };
  }
  function el(u, c, g) {
    var y = u.updateQueue;
    if (y === null)
      return null;
    if (y = y.shared, zt & 2) {
      var C = y.pending;
      return C === null ? c.next = c : (c.next = C.next, C.next = c), y.pending = c, is(u, g);
    }
    return C = y.interleaved, C === null ? (c.next = c, Nm(y)) : (c.next = C.next, C.next = c), y.interleaved = c, is(u, g);
  }
  function mv(u, c, g) {
    if (c = c.updateQueue, c !== null && (c = c.shared, (g & 4194240) !== 0)) {
      var y = c.lanes;
      y &= u.pendingLanes, g |= y, c.lanes = g, Kd(u, g);
    }
  }
  function Fm(u, c) {
    var g = u.updateQueue, y = u.alternate;
    if (y !== null && (y = y.updateQueue, g === y)) {
      var C = null, w = null;
      if (g = g.firstBaseUpdate, g !== null) {
        do {
          var M = { eventTime: g.eventTime, lane: g.lane, tag: g.tag, payload: g.payload, callback: g.callback, next: null };
          w === null ? C = w = M : w = w.next = M, g = g.next;
        } while (g !== null);
        w === null ? C = w = c : w = w.next = c;
      } else
        C = w = c;
      g = { baseState: y.baseState, firstBaseUpdate: C, lastBaseUpdate: w, shared: y.shared, effects: y.effects }, u.updateQueue = g;
      return;
    }
    u = g.lastBaseUpdate, u === null ? g.firstBaseUpdate = c : u.next = c, g.lastBaseUpdate = c;
  }
  function tl(u, c, g, y) {
    var C = u.updateQueue;
    Js = !1;
    var w = C.firstBaseUpdate, M = C.lastBaseUpdate, H = C.shared.pending;
    if (H !== null) {
      C.shared.pending = null;
      var $ = H, ue = $.next;
      $.next = null, M === null ? w = ue : M.next = ue, M = $;
      var Oe = u.alternate;
      Oe !== null && (Oe = Oe.updateQueue, H = Oe.lastBaseUpdate, H !== M && (H === null ? Oe.firstBaseUpdate = ue : H.next = ue, Oe.lastBaseUpdate = $));
    }
    if (w !== null) {
      var De = C.baseState;
      M = 0, Oe = ue = $ = null, H = w;
      do {
        var Ae = H.lane, Xe = H.eventTime;
        if ((y & Ae) === Ae) {
          Oe !== null && (Oe = Oe.next = {
            eventTime: Xe,
            lane: 0,
            tag: H.tag,
            payload: H.payload,
            callback: H.callback,
            next: null
          });
          e: {
            var tt = u, at = H;
            switch (Ae = c, Xe = g, at.tag) {
              case 1:
                if (tt = at.payload, typeof tt == "function") {
                  De = tt.call(Xe, De, Ae);
                  break e;
                }
                De = tt;
                break e;
              case 3:
                tt.flags = tt.flags & -65537 | 128;
              case 0:
                if (tt = at.payload, Ae = typeof tt == "function" ? tt.call(Xe, De, Ae) : tt, Ae == null)
                  break e;
                De = G({}, De, Ae);
                break e;
              case 2:
                Js = !0;
            }
          }
          H.callback !== null && H.lane !== 0 && (u.flags |= 64, Ae = C.effects, Ae === null ? C.effects = [H] : Ae.push(H));
        } else
          Xe = { eventTime: Xe, lane: Ae, tag: H.tag, payload: H.payload, callback: H.callback, next: null }, Oe === null ? (ue = Oe = Xe, $ = De) : Oe = Oe.next = Xe, M |= Ae;
        if (H = H.next, H === null) {
          if (H = C.shared.pending, H === null)
            break;
          Ae = H, H = Ae.next, Ae.next = null, C.lastBaseUpdate = Ae, C.shared.pending = null;
        }
      } while (!0);
      if (Oe === null && ($ = De), C.baseState = $, C.firstBaseUpdate = ue, C.lastBaseUpdate = Oe, c = C.shared.interleaved, c !== null) {
        C = c;
        do
          M |= C.lane, C = C.next;
        while (C !== c);
      } else
        w === null && (C.shared.lanes = 0);
      us |= M, u.lanes = M, u.memoizedState = De;
    }
  }
  function ru(u, c, g) {
    if (u = c.effects, c.effects = null, u !== null)
      for (c = 0; c < u.length; c++) {
        var y = u[c], C = y.callback;
        if (C !== null) {
          if (y.callback = null, y = g, typeof C != "function")
            throw Error(r(191, C));
          C.call(y);
        }
      }
  }
  var Px = new e.Component().refs;
  function Bm(u, c, g, y) {
    c = u.memoizedState, g = g(y, c), g = g == null ? c : G({}, c, g), u.memoizedState = g, u.lanes === 0 && (u.updateQueue.baseState = g);
  }
  var _v = { isMounted: function(u) {
    return (u = u._reactInternals) ? It(u) === u : !1;
  }, enqueueSetState: function(u, c, g) {
    u = u._reactInternals;
    var y = si(), C = ln(u), w = as(y, C);
    w.payload = c, g != null && (w.callback = g), c = el(u, w, C), c !== null && (li(c, u, C, y), mv(c, u, C));
  }, enqueueReplaceState: function(u, c, g) {
    u = u._reactInternals;
    var y = si(), C = ln(u), w = as(y, C);
    w.tag = 1, w.payload = c, g != null && (w.callback = g), c = el(u, w, C), c !== null && (li(c, u, C, y), mv(c, u, C));
  }, enqueueForceUpdate: function(u, c) {
    u = u._reactInternals;
    var g = si(), y = ln(u), C = as(g, y);
    C.tag = 2, c != null && (C.callback = c), c = el(u, C, y), c !== null && (li(c, u, y, g), mv(c, u, y));
  } };
  function Ix(u, c, g, y, C, w, M) {
    return u = u.stateNode, typeof u.shouldComponentUpdate == "function" ? u.shouldComponentUpdate(y, w, M) : c.prototype && c.prototype.isPureReactComponent ? !lf(g, y) || !lf(C, w) : !0;
  }
  function Nx(u, c, g) {
    var y = !1, C = _o, w = c.contextType;
    return typeof w == "object" && w !== null ? w = Jr(w) : (C = Pr(c) ? Mi : St.current, y = c.contextTypes, w = (y = y != null) ? Oa(u, C) : _o), c = new c(g, w), u.memoizedState = c.state !== null && c.state !== void 0 ? c.state : null, c.updater = _v, u.stateNode = c, c._reactInternals = u, y && (u = u.stateNode, u.__reactInternalMemoizedUnmaskedChildContext = C, u.__reactInternalMemoizedMaskedChildContext = w), c;
  }
  function Vx(u, c, g, y) {
    u = c.state, typeof c.componentWillReceiveProps == "function" && c.componentWillReceiveProps(g, y), typeof c.UNSAFE_componentWillReceiveProps == "function" && c.UNSAFE_componentWillReceiveProps(g, y), c.state !== u && _v.enqueueReplaceState(c, c.state, null);
  }
  function yv(u, c, g, y) {
    var C = u.stateNode;
    C.props = g, C.state = u.memoizedState, C.refs = Px, Vm(u);
    var w = c.contextType;
    typeof w == "object" && w !== null ? C.context = Jr(w) : (w = Pr(c) ? Mi : St.current, C.context = Oa(u, w)), C.state = u.memoizedState, w = c.getDerivedStateFromProps, typeof w == "function" && (Bm(u, c, w, g), C.state = u.memoizedState), typeof c.getDerivedStateFromProps == "function" || typeof C.getSnapshotBeforeUpdate == "function" || typeof C.UNSAFE_componentWillMount != "function" && typeof C.componentWillMount != "function" || (c = C.state, typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount(), c !== C.state && _v.enqueueReplaceState(C, C.state, null), tl(u, g, C, y), C.state = u.memoizedState), typeof C.componentDidMount == "function" && (u.flags |= 4194308);
  }
  function Ec(u, c, g) {
    if (u = g.ref, u !== null && typeof u != "function" && typeof u != "object") {
      if (g._owner) {
        if (g = g._owner, g) {
          if (g.tag !== 1)
            throw Error(r(309));
          var y = g.stateNode;
        }
        if (!y)
          throw Error(r(147, u));
        var C = y, w = "" + u;
        return c !== null && c.ref !== null && typeof c.ref == "function" && c.ref._stringRef === w ? c.ref : (c = function(M) {
          var H = C.refs;
          H === Px && (H = C.refs = {}), M === null ? delete H[w] : H[w] = M;
        }, c._stringRef = w, c);
      }
      if (typeof u != "string")
        throw Error(r(284));
      if (!g._owner)
        throw Error(r(290, u));
    }
    return u;
  }
  function xv(u, c) {
    throw u = Object.prototype.toString.call(c), Error(r(31, u === "[object Object]" ? "object with keys {" + Object.keys(c).join(", ") + "}" : u));
  }
  function Fx(u) {
    var c = u._init;
    return c(u._payload);
  }
  function Bx(u) {
    function c(te, q) {
      if (u) {
        var ae = te.deletions;
        ae === null ? (te.deletions = [q], te.flags |= 16) : ae.push(q);
      }
    }
    function g(te, q) {
      if (!u)
        return null;
      for (; q !== null; )
        c(te, q), q = q.sibling;
      return null;
    }
    function y(te, q) {
      for (te = /* @__PURE__ */ new Map(); q !== null; )
        q.key !== null ? te.set(q.key, q) : te.set(q.index, q), q = q.sibling;
      return te;
    }
    function C(te, q) {
      return te = ul(te, q), te.index = 0, te.sibling = null, te;
    }
    function w(te, q, ae) {
      return te.index = ae, u ? (ae = te.alternate, ae !== null ? (ae = ae.index, ae < q ? (te.flags |= 2, q) : ae) : (te.flags |= 2, q)) : (te.flags |= 1048576, q);
    }
    function M(te) {
      return u && te.alternate === null && (te.flags |= 2), te;
    }
    function H(te, q, ae, Ne) {
      return q === null || q.tag !== 6 ? (q = Ff(ae, te.mode, Ne), q.return = te, q) : (q = C(q, ae), q.return = te, q);
    }
    function $(te, q, ae, Ne) {
      var st = ae.type;
      return st === Z ? Oe(te, q, ae.props.children, Ne, ae.key) : q !== null && (q.elementType === st || typeof st == "object" && st !== null && st.$$typeof === fe && Fx(st) === q.type) ? (Ne = C(q, ae.props), Ne.ref = Ec(te, q, ae), Ne.return = te, Ne) : (Ne = Qv(ae.type, ae.key, ae.props, null, te.mode, Ne), Ne.ref = Ec(te, q, ae), Ne.return = te, Ne);
    }
    function ue(te, q, ae, Ne) {
      return q === null || q.tag !== 4 || q.stateNode.containerInfo !== ae.containerInfo || q.stateNode.implementation !== ae.implementation ? (q = bu(ae, te.mode, Ne), q.return = te, q) : (q = C(q, ae.children || []), q.return = te, q);
    }
    function Oe(te, q, ae, Ne, st) {
      return q === null || q.tag !== 7 ? (q = xu(ae, te.mode, Ne, st), q.return = te, q) : (q = C(q, ae), q.return = te, q);
    }
    function De(te, q, ae) {
      if (typeof q == "string" && q !== "" || typeof q == "number")
        return q = Ff("" + q, te.mode, ae), q.return = te, q;
      if (typeof q == "object" && q !== null) {
        switch (q.$$typeof) {
          case P:
            return ae = Qv(q.type, q.key, q.props, null, te.mode, ae), ae.ref = Ec(te, null, q), ae.return = te, ae;
          case j:
            return q = bu(q, te.mode, ae), q.return = te, q;
          case fe:
            var Ne = q._init;
            return De(te, Ne(q._payload), ae);
        }
        if (Fr(q) || pe(q))
          return q = xu(q, te.mode, ae, null), q.return = te, q;
        xv(te, q);
      }
      return null;
    }
    function Ae(te, q, ae, Ne) {
      var st = q !== null ? q.key : null;
      if (typeof ae == "string" && ae !== "" || typeof ae == "number")
        return st !== null ? null : H(te, q, "" + ae, Ne);
      if (typeof ae == "object" && ae !== null) {
        switch (ae.$$typeof) {
          case P:
            return ae.key === st ? $(te, q, ae, Ne) : null;
          case j:
            return ae.key === st ? ue(te, q, ae, Ne) : null;
          case fe:
            return st = ae._init, Ae(
              te,
              q,
              st(ae._payload),
              Ne
            );
        }
        if (Fr(ae) || pe(ae))
          return st !== null ? null : Oe(te, q, ae, Ne, null);
        xv(te, ae);
      }
      return null;
    }
    function Xe(te, q, ae, Ne, st) {
      if (typeof Ne == "string" && Ne !== "" || typeof Ne == "number")
        return te = te.get(ae) || null, H(q, te, "" + Ne, st);
      if (typeof Ne == "object" && Ne !== null) {
        switch (Ne.$$typeof) {
          case P:
            return te = te.get(Ne.key === null ? ae : Ne.key) || null, $(q, te, Ne, st);
          case j:
            return te = te.get(Ne.key === null ? ae : Ne.key) || null, ue(q, te, Ne, st);
          case fe:
            var rt = Ne._init;
            return Xe(te, q, ae, rt(Ne._payload), st);
        }
        if (Fr(Ne) || pe(Ne))
          return te = te.get(ae) || null, Oe(q, te, Ne, st, null);
        xv(q, Ne);
      }
      return null;
    }
    function tt(te, q, ae, Ne) {
      for (var st = null, rt = null, ut = q, Ct = q = 0, Pn = null; ut !== null && Ct < ae.length; Ct++) {
        ut.index > Ct ? (Pn = ut, ut = null) : Pn = ut.sibling;
        var Zt = Ae(te, ut, ae[Ct], Ne);
        if (Zt === null) {
          ut === null && (ut = Pn);
          break;
        }
        u && ut && Zt.alternate === null && c(te, ut), q = w(Zt, q, Ct), rt === null ? st = Zt : rt.sibling = Zt, rt = Zt, ut = Pn;
      }
      if (Ct === ae.length)
        return g(te, ut), Ar && na(te, Ct), st;
      if (ut === null) {
        for (; Ct < ae.length; Ct++)
          ut = De(te, ae[Ct], Ne), ut !== null && (q = w(ut, q, Ct), rt === null ? st = ut : rt.sibling = ut, rt = ut);
        return Ar && na(te, Ct), st;
      }
      for (ut = y(te, ut); Ct < ae.length; Ct++)
        Pn = Xe(ut, te, Ct, ae[Ct], Ne), Pn !== null && (u && Pn.alternate !== null && ut.delete(Pn.key === null ? Ct : Pn.key), q = w(Pn, q, Ct), rt === null ? st = Pn : rt.sibling = Pn, rt = Pn);
      return u && ut.forEach(function(cl) {
        return c(te, cl);
      }), Ar && na(te, Ct), st;
    }
    function at(te, q, ae, Ne) {
      var st = pe(ae);
      if (typeof st != "function")
        throw Error(r(150));
      if (ae = st.call(ae), ae == null)
        throw Error(r(151));
      for (var rt = st = null, ut = q, Ct = q = 0, Pn = null, Zt = ae.next(); ut !== null && !Zt.done; Ct++, Zt = ae.next()) {
        ut.index > Ct ? (Pn = ut, ut = null) : Pn = ut.sibling;
        var cl = Ae(te, ut, Zt.value, Ne);
        if (cl === null) {
          ut === null && (ut = Pn);
          break;
        }
        u && ut && cl.alternate === null && c(te, ut), q = w(cl, q, Ct), rt === null ? st = cl : rt.sibling = cl, rt = cl, ut = Pn;
      }
      if (Zt.done)
        return g(
          te,
          ut
        ), Ar && na(te, Ct), st;
      if (ut === null) {
        for (; !Zt.done; Ct++, Zt = ae.next())
          Zt = De(te, Zt.value, Ne), Zt !== null && (q = w(Zt, q, Ct), rt === null ? st = Zt : rt.sibling = Zt, rt = Zt);
        return Ar && na(te, Ct), st;
      }
      for (ut = y(te, ut); !Zt.done; Ct++, Zt = ae.next())
        Zt = Xe(ut, te, Ct, Zt.value, Ne), Zt !== null && (u && Zt.alternate !== null && ut.delete(Zt.key === null ? Ct : Zt.key), q = w(Zt, q, Ct), rt === null ? st = Zt : rt.sibling = Zt, rt = Zt);
      return u && ut.forEach(function(F1) {
        return c(te, F1);
      }), Ar && na(te, Ct), st;
    }
    function en(te, q, ae, Ne) {
      if (typeof ae == "object" && ae !== null && ae.type === Z && ae.key === null && (ae = ae.props.children), typeof ae == "object" && ae !== null) {
        switch (ae.$$typeof) {
          case P:
            e: {
              for (var st = ae.key, rt = q; rt !== null; ) {
                if (rt.key === st) {
                  if (st = ae.type, st === Z) {
                    if (rt.tag === 7) {
                      g(te, rt.sibling), q = C(rt, ae.props.children), q.return = te, te = q;
                      break e;
                    }
                  } else if (rt.elementType === st || typeof st == "object" && st !== null && st.$$typeof === fe && Fx(st) === rt.type) {
                    g(te, rt.sibling), q = C(rt, ae.props), q.ref = Ec(te, rt, ae), q.return = te, te = q;
                    break e;
                  }
                  g(te, rt);
                  break;
                } else
                  c(te, rt);
                rt = rt.sibling;
              }
              ae.type === Z ? (q = xu(ae.props.children, te.mode, Ne, ae.key), q.return = te, te = q) : (Ne = Qv(ae.type, ae.key, ae.props, null, te.mode, Ne), Ne.ref = Ec(te, q, ae), Ne.return = te, te = Ne);
            }
            return M(te);
          case j:
            e: {
              for (rt = ae.key; q !== null; ) {
                if (q.key === rt)
                  if (q.tag === 4 && q.stateNode.containerInfo === ae.containerInfo && q.stateNode.implementation === ae.implementation) {
                    g(te, q.sibling), q = C(q, ae.children || []), q.return = te, te = q;
                    break e;
                  } else {
                    g(te, q);
                    break;
                  }
                else
                  c(te, q);
                q = q.sibling;
              }
              q = bu(ae, te.mode, Ne), q.return = te, te = q;
            }
            return M(te);
          case fe:
            return rt = ae._init, en(te, q, rt(ae._payload), Ne);
        }
        if (Fr(ae))
          return tt(te, q, ae, Ne);
        if (pe(ae))
          return at(te, q, ae, Ne);
        xv(te, ae);
      }
      return typeof ae == "string" && ae !== "" || typeof ae == "number" ? (ae = "" + ae, q !== null && q.tag === 6 ? (g(te, q.sibling), q = C(q, ae), q.return = te, te = q) : (g(te, q), q = Ff(ae, te.mode, Ne), q.return = te, te = q), M(te)) : g(te, q);
    }
    return en;
  }
  var Tc = Bx(!0), zx = Bx(!1), xf = {}, ao = Mt(xf), bf = Mt(xf), wc = Mt(xf);
  function nu(u) {
    if (u === xf)
      throw Error(r(174));
    return u;
  }
  function zm(u, c) {
    switch (ar(wc, c), ar(bf, u), ar(ao, xf), u = c.nodeType, u) {
      case 9:
      case 11:
        c = (c = c.documentElement) ? c.namespaceURI : $r(null, "");
        break;
      default:
        u = u === 8 ? c.parentNode : c, c = u.namespaceURI || null, u = u.tagName, c = $r(c, u);
    }
    nr(ao), ar(ao, c);
  }
  function rl() {
    nr(ao), nr(bf), nr(wc);
  }
  function pt(u) {
    nu(wc.current);
    var c = nu(ao.current), g = $r(c, u.type);
    c !== g && (ar(bf, u), ar(ao, g));
  }
  function Ft(u) {
    bf.current === u && (nr(ao), nr(bf));
  }
  var mt = Mt(0);
  function Hr(u) {
    for (var c = u; c !== null; ) {
      if (c.tag === 13) {
        var g = c.memoizedState;
        if (g !== null && (g = g.dehydrated, g === null || g.data === "$?" || g.data === "$!"))
          return c;
      } else if (c.tag === 19 && c.memoizedProps.revealOrder !== void 0) {
        if (c.flags & 128)
          return c;
      } else if (c.child !== null) {
        c.child.return = c, c = c.child;
        continue;
      }
      if (c === u)
        break;
      for (; c.sibling === null; ) {
        if (c.return === null || c.return === u)
          return null;
        c = c.return;
      }
      c.sibling.return = c.return, c = c.sibling;
    }
    return null;
  }
  var Ma = [];
  function bv() {
    for (var u = 0; u < Ma.length; u++)
      Ma[u]._workInProgressVersionPrimary = null;
    Ma.length = 0;
  }
  var Sv = V.ReactCurrentDispatcher, Hm = V.ReactCurrentBatchConfig, iu = 0, Or = null, ye = null, jt = null, yt = !1, xo = !1, oa = 0, au = 0;
  function kr() {
    throw Error(r(321));
  }
  function ou(u, c) {
    if (c === null)
      return !1;
    for (var g = 0; g < c.length && g < u.length; g++)
      if (!wa(u[g], c[g]))
        return !1;
    return !0;
  }
  function nl(u, c, g, y, C, w) {
    if (iu = w, Or = c, c.memoizedState = null, c.updateQueue = null, c.lanes = 0, Sv.current = u === null || u.memoizedState === null ? x1 : b1, u = g(y, C), xo) {
      w = 0;
      do {
        if (xo = !1, oa = 0, 25 <= w)
          throw Error(r(301));
        w += 1, jt = ye = null, c.updateQueue = null, Sv.current = Um, u = g(y, C);
      } while (xo);
    }
    if (Sv.current = Fv, c = ye !== null && ye.next !== null, iu = 0, jt = ye = Or = null, yt = !1, c)
      throw Error(r(300));
    return u;
  }
  function su() {
    var u = oa !== 0;
    return oa = 0, u;
  }
  function La() {
    var u = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return jt === null ? Or.memoizedState = jt = u : jt = jt.next = u, jt;
  }
  function Vi() {
    if (ye === null) {
      var u = Or.alternate;
      u = u !== null ? u.memoizedState : null;
    } else
      u = ye.next;
    var c = jt === null ? Or.memoizedState : jt.next;
    if (c !== null)
      jt = c, ye = u;
    else {
      if (u === null)
        throw Error(r(310));
      ye = u, u = { memoizedState: ye.memoizedState, baseState: ye.baseState, baseQueue: ye.baseQueue, queue: ye.queue, next: null }, jt === null ? Or.memoizedState = jt = u : jt = jt.next = u;
    }
    return jt;
  }
  function lu(u, c) {
    return typeof c == "function" ? c(u) : c;
  }
  function Sf(u) {
    var c = Vi(), g = c.queue;
    if (g === null)
      throw Error(r(311));
    g.lastRenderedReducer = u;
    var y = ye, C = y.baseQueue, w = g.pending;
    if (w !== null) {
      if (C !== null) {
        var M = C.next;
        C.next = w.next, w.next = M;
      }
      y.baseQueue = C = w, g.pending = null;
    }
    if (C !== null) {
      w = C.next, y = y.baseState;
      var H = M = null, $ = null, ue = w;
      do {
        var Oe = ue.lane;
        if ((iu & Oe) === Oe)
          $ !== null && ($ = $.next = { lane: 0, action: ue.action, hasEagerState: ue.hasEagerState, eagerState: ue.eagerState, next: null }), y = ue.hasEagerState ? ue.eagerState : u(y, ue.action);
        else {
          var De = {
            lane: Oe,
            action: ue.action,
            hasEagerState: ue.hasEagerState,
            eagerState: ue.eagerState,
            next: null
          };
          $ === null ? (H = $ = De, M = y) : $ = $.next = De, Or.lanes |= Oe, us |= Oe;
        }
        ue = ue.next;
      } while (ue !== null && ue !== w);
      $ === null ? M = y : $.next = H, wa(y, c.memoizedState) || (sn = !0), c.memoizedState = y, c.baseState = M, c.baseQueue = $, g.lastRenderedState = y;
    }
    if (u = g.interleaved, u !== null) {
      C = u;
      do
        w = C.lane, Or.lanes |= w, us |= w, C = C.next;
      while (C !== u);
    } else
      C === null && (g.lanes = 0);
    return [c.memoizedState, g.dispatch];
  }
  function Cf(u) {
    var c = Vi(), g = c.queue;
    if (g === null)
      throw Error(r(311));
    g.lastRenderedReducer = u;
    var y = g.dispatch, C = g.pending, w = c.memoizedState;
    if (C !== null) {
      g.pending = null;
      var M = C = C.next;
      do
        w = u(w, M.action), M = M.next;
      while (M !== C);
      wa(w, c.memoizedState) || (sn = !0), c.memoizedState = w, c.baseQueue === null && (c.baseState = w), g.lastRenderedState = w;
    }
    return [w, y];
  }
  function Cv() {
  }
  function Ev(u, c) {
    var g = Or, y = Vi(), C = c(), w = !wa(y.memoizedState, C);
    if (w && (y.memoizedState = C, sn = !0), y = y.queue, Ef(Av.bind(null, g, y, u), [u]), y.getSnapshot !== c || w || jt !== null && jt.memoizedState.tag & 1) {
      if (g.flags |= 2048, uu(9, wv.bind(null, g, y, C, c), void 0, null), Gr === null)
        throw Error(r(349));
      iu & 30 || Tv(g, c, C);
    }
    return C;
  }
  function Tv(u, c, g) {
    u.flags |= 16384, u = { getSnapshot: c, value: g }, c = Or.updateQueue, c === null ? (c = { lastEffect: null, stores: null }, Or.updateQueue = c, c.stores = [u]) : (g = c.stores, g === null ? c.stores = [u] : g.push(u));
  }
  function wv(u, c, g, y) {
    c.value = g, c.getSnapshot = y, Ov(c) && kv(u);
  }
  function Av(u, c, g) {
    return g(function() {
      Ov(c) && kv(u);
    });
  }
  function Ov(u) {
    var c = u.getSnapshot;
    u = u.value;
    try {
      var g = c();
      return !wa(u, g);
    } catch {
      return !0;
    }
  }
  function kv(u) {
    var c = is(u, 1);
    c !== null && li(c, u, 1, -1);
  }
  function Rv(u) {
    var c = La();
    return typeof u == "function" && (u = u()), c.memoizedState = c.baseState = u, u = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: lu, lastRenderedState: u }, c.queue = u, u = u.dispatch = Vv.bind(null, Or, u), [c.memoizedState, u];
  }
  function uu(u, c, g, y) {
    return u = { tag: u, create: c, destroy: g, deps: y, next: null }, c = Or.updateQueue, c === null ? (c = { lastEffect: null, stores: null }, Or.updateQueue = c, c.lastEffect = u.next = u) : (g = c.lastEffect, g === null ? c.lastEffect = u.next = u : (y = g.next, g.next = u, u.next = y, c.lastEffect = u)), u;
  }
  function Dv() {
    return Vi().memoizedState;
  }
  function cu(u, c, g, y) {
    var C = La();
    Or.flags |= u, C.memoizedState = uu(1 | c, g, void 0, y === void 0 ? null : y);
  }
  function os(u, c, g, y) {
    var C = Vi();
    y = y === void 0 ? null : y;
    var w = void 0;
    if (ye !== null) {
      var M = ye.memoizedState;
      if (w = M.destroy, y !== null && ou(y, M.deps)) {
        C.memoizedState = uu(c, g, w, y);
        return;
      }
    }
    Or.flags |= u, C.memoizedState = uu(1 | c, g, w, y);
  }
  function Mv(u, c) {
    return cu(8390656, 8, u, c);
  }
  function Ef(u, c) {
    return os(2048, 8, u, c);
  }
  function Lv(u, c) {
    return os(4, 2, u, c);
  }
  function Pv(u, c) {
    return os(4, 4, u, c);
  }
  function Gm(u, c) {
    if (typeof c == "function")
      return u = u(), c(u), function() {
        c(null);
      };
    if (c != null)
      return u = u(), c.current = u, function() {
        c.current = null;
      };
  }
  function Ac(u, c, g) {
    return g = g != null ? g.concat([u]) : null, os(4, 4, Gm.bind(null, c, u), g);
  }
  function Iv() {
  }
  function Oc(u, c) {
    var g = Vi();
    c = c === void 0 ? null : c;
    var y = g.memoizedState;
    return y !== null && c !== null && ou(c, y[1]) ? y[0] : (g.memoizedState = [u, c], u);
  }
  function il(u, c) {
    var g = Vi();
    c = c === void 0 ? null : c;
    var y = g.memoizedState;
    return y !== null && c !== null && ou(c, y[1]) ? y[0] : (u = u(), g.memoizedState = [u, c], u);
  }
  function Fi(u, c, g) {
    return iu & 21 ? (wa(g, c) || (g = $h(), Or.lanes |= g, us |= g, u.baseState = !0), c) : (u.baseState && (u.baseState = !1, sn = !0), u.memoizedState = g);
  }
  function y1(u, c) {
    var g = dr;
    dr = g !== 0 && 4 > g ? g : 4, u(!0);
    var y = Hm.transition;
    Hm.transition = {};
    try {
      u(!1), c();
    } finally {
      dr = g, Hm.transition = y;
    }
  }
  function br() {
    return Vi().memoizedState;
  }
  function Nv(u, c, g) {
    var y = ln(u);
    if (g = { lane: y, action: g, hasEagerState: !1, eagerState: null, next: null }, kc(u))
      Tf(c, g);
    else if (g = Lx(u, c, g, y), g !== null) {
      var C = si();
      li(g, u, y, C), Hx(g, c, y);
    }
  }
  function Vv(u, c, g) {
    var y = ln(u), C = { lane: y, action: g, hasEagerState: !1, eagerState: null, next: null };
    if (kc(u))
      Tf(c, C);
    else {
      var w = u.alternate;
      if (u.lanes === 0 && (w === null || w.lanes === 0) && (w = c.lastRenderedReducer, w !== null))
        try {
          var M = c.lastRenderedState, H = w(M, g);
          if (C.hasEagerState = !0, C.eagerState = H, wa(H, M)) {
            var $ = c.interleaved;
            $ === null ? (C.next = C, Nm(c)) : (C.next = $.next, $.next = C), c.interleaved = C;
            return;
          }
        } catch {
        } finally {
        }
      g = Lx(u, c, C, y), g !== null && (C = si(), li(g, u, y, C), Hx(g, c, y));
    }
  }
  function kc(u) {
    var c = u.alternate;
    return u === Or || c !== null && c === Or;
  }
  function Tf(u, c) {
    xo = yt = !0;
    var g = u.pending;
    g === null ? c.next = c : (c.next = g.next, g.next = c), u.pending = c;
  }
  function Hx(u, c, g) {
    if (g & 4194240) {
      var y = c.lanes;
      y &= u.pendingLanes, g |= y, c.lanes = g, Kd(u, g);
    }
  }
  var Fv = { readContext: Jr, useCallback: kr, useContext: kr, useEffect: kr, useImperativeHandle: kr, useInsertionEffect: kr, useLayoutEffect: kr, useMemo: kr, useReducer: kr, useRef: kr, useState: kr, useDebugValue: kr, useDeferredValue: kr, useTransition: kr, useMutableSource: kr, useSyncExternalStore: kr, useId: kr, unstable_isNewReconciler: !1 }, x1 = { readContext: Jr, useCallback: function(u, c) {
    return La().memoizedState = [u, c === void 0 ? null : c], u;
  }, useContext: Jr, useEffect: Mv, useImperativeHandle: function(u, c, g) {
    return g = g != null ? g.concat([u]) : null, cu(
      4194308,
      4,
      Gm.bind(null, c, u),
      g
    );
  }, useLayoutEffect: function(u, c) {
    return cu(4194308, 4, u, c);
  }, useInsertionEffect: function(u, c) {
    return cu(4, 2, u, c);
  }, useMemo: function(u, c) {
    var g = La();
    return c = c === void 0 ? null : c, u = u(), g.memoizedState = [u, c], u;
  }, useReducer: function(u, c, g) {
    var y = La();
    return c = g !== void 0 ? g(c) : c, y.memoizedState = y.baseState = c, u = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: u, lastRenderedState: c }, y.queue = u, u = u.dispatch = Nv.bind(null, Or, u), [y.memoizedState, u];
  }, useRef: function(u) {
    var c = La();
    return u = { current: u }, c.memoizedState = u;
  }, useState: Rv, useDebugValue: Iv, useDeferredValue: function(u) {
    return La().memoizedState = u;
  }, useTransition: function() {
    var u = Rv(!1), c = u[0];
    return u = y1.bind(null, u[1]), La().memoizedState = u, [c, u];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(u, c, g) {
    var y = Or, C = La();
    if (Ar) {
      if (g === void 0)
        throw Error(r(407));
      g = g();
    } else {
      if (g = c(), Gr === null)
        throw Error(r(349));
      iu & 30 || Tv(y, c, g);
    }
    C.memoizedState = g;
    var w = { value: g, getSnapshot: c };
    return C.queue = w, Mv(Av.bind(
      null,
      y,
      w,
      u
    ), [u]), y.flags |= 2048, uu(9, wv.bind(null, y, w, g, c), void 0, null), g;
  }, useId: function() {
    var u = La(), c = Gr.identifierPrefix;
    if (Ar) {
      var g = rs, y = Bn;
      g = (y & ~(1 << 32 - Ca(y) - 1)).toString(32) + g, c = ":" + c + "R" + g, g = oa++, 0 < g && (c += "H" + g.toString(32)), c += ":";
    } else
      g = au++, c = ":" + c + "r" + g.toString(32) + ":";
    return u.memoizedState = c;
  }, unstable_isNewReconciler: !1 }, b1 = {
    readContext: Jr,
    useCallback: Oc,
    useContext: Jr,
    useEffect: Ef,
    useImperativeHandle: Ac,
    useInsertionEffect: Lv,
    useLayoutEffect: Pv,
    useMemo: il,
    useReducer: Sf,
    useRef: Dv,
    useState: function() {
      return Sf(lu);
    },
    useDebugValue: Iv,
    useDeferredValue: function(u) {
      var c = Vi();
      return Fi(c, ye.memoizedState, u);
    },
    useTransition: function() {
      var u = Sf(lu)[0], c = Vi().memoizedState;
      return [u, c];
    },
    useMutableSource: Cv,
    useSyncExternalStore: Ev,
    useId: br,
    unstable_isNewReconciler: !1
  }, Um = { readContext: Jr, useCallback: Oc, useContext: Jr, useEffect: Ef, useImperativeHandle: Ac, useInsertionEffect: Lv, useLayoutEffect: Pv, useMemo: il, useReducer: Cf, useRef: Dv, useState: function() {
    return Cf(lu);
  }, useDebugValue: Iv, useDeferredValue: function(u) {
    var c = Vi();
    return ye === null ? c.memoizedState = u : Fi(c, ye.memoizedState, u);
  }, useTransition: function() {
    var u = Cf(lu)[0], c = Vi().memoizedState;
    return [u, c];
  }, useMutableSource: Cv, useSyncExternalStore: Ev, useId: br, unstable_isNewReconciler: !1 };
  function Rc(u, c) {
    try {
      var g = "", y = c;
      do
        g += He(y), y = y.return;
      while (y);
      var C = g;
    } catch (w) {
      C = `
Error generating stack: ` + w.message + `
` + w.stack;
    }
    return { value: u, source: c, stack: C, digest: null };
  }
  function wf(u, c, g) {
    return { value: u, source: null, stack: g ?? null, digest: c ?? null };
  }
  function Bv(u, c) {
    try {
      console.error(c.value);
    } catch (g) {
      setTimeout(function() {
        throw g;
      });
    }
  }
  var S1 = typeof WeakMap == "function" ? WeakMap : Map;
  function Gx(u, c, g) {
    g = as(-1, g), g.tag = 3, g.payload = { element: null };
    var y = c.value;
    return g.callback = function() {
      Yv || (Yv = !0, pu = y), Bv(u, c);
    }, g;
  }
  function Af(u, c, g) {
    g = as(-1, g), g.tag = 3;
    var y = u.type.getDerivedStateFromError;
    if (typeof y == "function") {
      var C = c.value;
      g.payload = function() {
        return y(C);
      }, g.callback = function() {
        Bv(u, c);
      };
    }
    var w = u.stateNode;
    return w !== null && typeof w.componentDidCatch == "function" && (g.callback = function() {
      Bv(u, c), typeof y != "function" && (Co === null ? Co = /* @__PURE__ */ new Set([this]) : Co.add(this));
      var M = c.stack;
      this.componentDidCatch(c.value, { componentStack: M !== null ? M : "" });
    }), g;
  }
  function Ux(u, c, g) {
    var y = u.pingCache;
    if (y === null) {
      y = u.pingCache = new S1();
      var C = /* @__PURE__ */ new Set();
      y.set(c, C);
    } else
      C = y.get(c), C === void 0 && (C = /* @__PURE__ */ new Set(), y.set(c, C));
    C.has(g) || (C.add(g), u = k1.bind(null, u, c, g), c.then(u, u));
  }
  function jm(u) {
    do {
      var c;
      if ((c = u.tag === 13) && (c = u.memoizedState, c = c !== null ? c.dehydrated !== null : !0), c)
        return u;
      u = u.return;
    } while (u !== null);
    return null;
  }
  function $m(u, c, g, y, C) {
    return u.mode & 1 ? (u.flags |= 65536, u.lanes = C, u) : (u === c ? u.flags |= 65536 : (u.flags |= 128, g.flags |= 131072, g.flags &= -52805, g.tag === 1 && (g.alternate === null ? g.tag = 17 : (c = as(-1, 1), c.tag = 2, el(g, c, 1))), g.lanes |= 1), u);
  }
  var C1 = V.ReactCurrentOwner, sn = !1;
  function mn(u, c, g, y) {
    c.child = u === null ? zx(c, null, g, y) : Tc(c, u.child, g, y);
  }
  function al(u, c, g, y, C) {
    g = g.render;
    var w = c.ref;
    return Fe(c, C), y = nl(u, c, g, y, w, C), g = su(), u !== null && !sn ? (c.updateQueue = u.updateQueue, c.flags &= -2053, u.lanes &= ~C, Hn(u, c, C)) : (Ar && g && dv(c), c.flags |= 1, mn(u, c, y, C), c.child);
  }
  function zv(u, c, g, y, C) {
    if (u === null) {
      var w = g.type;
      return typeof w == "function" && !c0(w) && w.defaultProps === void 0 && g.compare === null && g.defaultProps === void 0 ? (c.tag = 15, c.type = w, Bi(u, c, w, y, C)) : (u = Qv(g.type, null, y, c, c.mode, C), u.ref = c.ref, u.return = c, c.child = u);
    }
    if (w = u.child, !(u.lanes & C)) {
      var M = w.memoizedProps;
      if (g = g.compare, g = g !== null ? g : lf, g(M, y) && u.ref === c.ref)
        return Hn(u, c, C);
    }
    return c.flags |= 1, u = ul(w, y), u.ref = c.ref, u.return = c, c.child = u;
  }
  function Bi(u, c, g, y, C) {
    if (u !== null) {
      var w = u.memoizedProps;
      if (lf(w, y) && u.ref === c.ref)
        if (sn = !1, c.pendingProps = y = w, (u.lanes & C) !== 0)
          u.flags & 131072 && (sn = !0);
        else
          return c.lanes = u.lanes, Hn(u, c, C);
    }
    return Dc(u, c, g, y, C);
  }
  function du(u, c, g) {
    var y = c.pendingProps, C = y.children, w = u !== null ? u.memoizedState : null;
    if (y.mode === "hidden")
      if (!(c.mode & 1))
        c.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, ar(Vc, sa), sa |= g;
      else {
        if (!(g & 1073741824))
          return u = w !== null ? w.baseLanes | g : g, c.lanes = c.childLanes = 1073741824, c.memoizedState = { baseLanes: u, cachePool: null, transitions: null }, c.updateQueue = null, ar(Vc, sa), sa |= u, null;
        c.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, y = w !== null ? w.baseLanes : g, ar(Vc, sa), sa |= y;
      }
    else
      w !== null ? (y = w.baseLanes | g, c.memoizedState = null) : y = g, ar(Vc, sa), sa |= y;
    return mn(u, c, C, g), c.child;
  }
  function Rt(u, c) {
    var g = c.ref;
    (u === null && g !== null || u !== null && u.ref !== g) && (c.flags |= 512, c.flags |= 2097152);
  }
  function Dc(u, c, g, y, C) {
    var w = Pr(g) ? Mi : St.current;
    return w = Oa(c, w), Fe(c, C), g = nl(u, c, g, y, w, C), y = su(), u !== null && !sn ? (c.updateQueue = u.updateQueue, c.flags &= -2053, u.lanes &= ~C, Hn(u, c, C)) : (Ar && y && dv(c), c.flags |= 1, mn(u, c, g, C), c.child);
  }
  function Ym(u, c, g, y, C) {
    if (Pr(g)) {
      var w = !0;
      cv(c);
    } else
      w = !1;
    if (Fe(c, C), c.stateNode === null)
      ii(u, c), Nx(c, g, y), yv(c, g, y, C), y = !0;
    else if (u === null) {
      var M = c.stateNode, H = c.memoizedProps;
      M.props = H;
      var $ = M.context, ue = g.contextType;
      typeof ue == "object" && ue !== null ? ue = Jr(ue) : (ue = Pr(g) ? Mi : St.current, ue = Oa(c, ue));
      var Oe = g.getDerivedStateFromProps, De = typeof Oe == "function" || typeof M.getSnapshotBeforeUpdate == "function";
      De || typeof M.UNSAFE_componentWillReceiveProps != "function" && typeof M.componentWillReceiveProps != "function" || (H !== y || $ !== ue) && Vx(c, M, y, ue), Js = !1;
      var Ae = c.memoizedState;
      M.state = Ae, tl(c, y, M, C), $ = c.memoizedState, H !== y || Ae !== $ || Wr.current || Js ? (typeof Oe == "function" && (Bm(c, g, Oe, y), $ = c.memoizedState), (H = Js || Ix(c, g, H, y, Ae, $, ue)) ? (De || typeof M.UNSAFE_componentWillMount != "function" && typeof M.componentWillMount != "function" || (typeof M.componentWillMount == "function" && M.componentWillMount(), typeof M.UNSAFE_componentWillMount == "function" && M.UNSAFE_componentWillMount()), typeof M.componentDidMount == "function" && (c.flags |= 4194308)) : (typeof M.componentDidMount == "function" && (c.flags |= 4194308), c.memoizedProps = y, c.memoizedState = $), M.props = y, M.state = $, M.context = ue, y = H) : (typeof M.componentDidMount == "function" && (c.flags |= 4194308), y = !1);
    } else {
      M = c.stateNode, gn(u, c), H = c.memoizedProps, ue = c.type === c.elementType ? H : aa(c.type, H), M.props = ue, De = c.pendingProps, Ae = M.context, $ = g.contextType, typeof $ == "object" && $ !== null ? $ = Jr($) : ($ = Pr(g) ? Mi : St.current, $ = Oa(c, $));
      var Xe = g.getDerivedStateFromProps;
      (Oe = typeof Xe == "function" || typeof M.getSnapshotBeforeUpdate == "function") || typeof M.UNSAFE_componentWillReceiveProps != "function" && typeof M.componentWillReceiveProps != "function" || (H !== De || Ae !== $) && Vx(c, M, y, $), Js = !1, Ae = c.memoizedState, M.state = Ae, tl(c, y, M, C);
      var tt = c.memoizedState;
      H !== De || Ae !== tt || Wr.current || Js ? (typeof Xe == "function" && (Bm(c, g, Xe, y), tt = c.memoizedState), (ue = Js || Ix(c, g, ue, y, Ae, tt, $) || !1) ? (Oe || typeof M.UNSAFE_componentWillUpdate != "function" && typeof M.componentWillUpdate != "function" || (typeof M.componentWillUpdate == "function" && M.componentWillUpdate(y, tt, $), typeof M.UNSAFE_componentWillUpdate == "function" && M.UNSAFE_componentWillUpdate(y, tt, $)), typeof M.componentDidUpdate == "function" && (c.flags |= 4), typeof M.getSnapshotBeforeUpdate == "function" && (c.flags |= 1024)) : (typeof M.componentDidUpdate != "function" || H === u.memoizedProps && Ae === u.memoizedState || (c.flags |= 4), typeof M.getSnapshotBeforeUpdate != "function" || H === u.memoizedProps && Ae === u.memoizedState || (c.flags |= 1024), c.memoizedProps = y, c.memoizedState = tt), M.props = y, M.state = tt, M.context = $, y = ue) : (typeof M.componentDidUpdate != "function" || H === u.memoizedProps && Ae === u.memoizedState || (c.flags |= 4), typeof M.getSnapshotBeforeUpdate != "function" || H === u.memoizedProps && Ae === u.memoizedState || (c.flags |= 1024), y = !1);
    }
    return jx(u, c, g, y, w, C);
  }
  function jx(u, c, g, y, C, w) {
    Rt(u, c);
    var M = (c.flags & 128) !== 0;
    if (!y && !M)
      return C && kx(c, g, !1), Hn(u, c, w);
    y = c.stateNode, C1.current = c;
    var H = M && typeof g.getDerivedStateFromError != "function" ? null : y.render();
    return c.flags |= 1, u !== null && M ? (c.child = Tc(c, u.child, null, w), c.child = Tc(c, null, H, w)) : mn(u, c, H, w), c.memoizedState = y.state, C && kx(c, g, !0), c.child;
  }
  function $x(u) {
    var c = u.stateNode;
    c.pendingContext ? Ks(u, c.pendingContext, c.pendingContext !== c.context) : c.context && Ks(u, c.context, !1), zm(u, c.containerInfo);
  }
  function Hv(u, c, g, y, C) {
    return zr(), Lm(C), c.flags |= 256, mn(u, c, g, y), c.child;
  }
  var fu = { dehydrated: null, treeContext: null, retryLane: 0 };
  function Wm(u) {
    return { baseLanes: u, cachePool: null, transitions: null };
  }
  function Xm(u, c, g) {
    var y = c.pendingProps, C = mt.current, w = !1, M = (c.flags & 128) !== 0, H;
    if ((H = M) || (H = u !== null && u.memoizedState === null ? !1 : (C & 2) !== 0), H ? (w = !0, c.flags &= -129) : (u === null || u.memoizedState !== null) && (C |= 1), ar(mt, C & 1), u === null)
      return hv(c), u = c.memoizedState, u !== null && (u = u.dehydrated, u !== null) ? (c.mode & 1 ? u.data === "$!" ? c.lanes = 8 : c.lanes = 1073741824 : c.lanes = 1, null) : (M = y.children, u = y.fallback, w ? (y = c.mode, w = c.child, M = { mode: "hidden", children: M }, !(y & 1) && w !== null ? (w.childLanes = 0, w.pendingProps = M) : w = Vf(M, y, 0, null), u = xu(u, y, g, null), w.return = c, u.return = c, w.sibling = u, c.child = w, c.child.memoizedState = Wm(g), c.memoizedState = fu, u) : qm(c, M));
    if (C = u.memoizedState, C !== null && (H = C.dehydrated, H !== null))
      return E1(u, c, M, y, H, C, g);
    if (w) {
      w = y.fallback, M = c.mode, C = u.child, H = C.sibling;
      var $ = { mode: "hidden", children: y.children };
      return !(M & 1) && c.child !== C ? (y = c.child, y.childLanes = 0, y.pendingProps = $, c.deletions = null) : (y = ul(C, $), y.subtreeFlags = C.subtreeFlags & 14680064), H !== null ? w = ul(H, w) : (w = xu(w, M, g, null), w.flags |= 2), w.return = c, y.return = c, y.sibling = w, c.child = y, y = w, w = c.child, M = u.child.memoizedState, M = M === null ? Wm(g) : { baseLanes: M.baseLanes | g, cachePool: null, transitions: M.transitions }, w.memoizedState = M, w.childLanes = u.childLanes & ~g, c.memoizedState = fu, y;
    }
    return w = u.child, u = w.sibling, y = ul(w, { mode: "visible", children: y.children }), !(c.mode & 1) && (y.lanes = g), y.return = c, y.sibling = null, u !== null && (g = c.deletions, g === null ? (c.deletions = [u], c.flags |= 16) : g.push(u)), c.child = y, c.memoizedState = null, y;
  }
  function qm(u, c) {
    return c = Vf({ mode: "visible", children: c }, u.mode, 0, null), c.return = u, u.child = c;
  }
  function Mc(u, c, g, y) {
    return y !== null && Lm(y), Tc(c, u.child, null, g), u = qm(c, c.pendingProps.children), u.flags |= 2, c.memoizedState = null, u;
  }
  function E1(u, c, g, y, C, w, M) {
    if (g)
      return c.flags & 256 ? (c.flags &= -257, y = wf(Error(r(422))), Mc(u, c, M, y)) : c.memoizedState !== null ? (c.child = u.child, c.flags |= 128, null) : (w = y.fallback, C = c.mode, y = Vf({ mode: "visible", children: y.children }, C, 0, null), w = xu(w, C, M, null), w.flags |= 2, y.return = c, w.return = c, y.sibling = w, c.child = y, c.mode & 1 && Tc(c, u.child, null, M), c.child.memoizedState = Wm(M), c.memoizedState = fu, w);
    if (!(c.mode & 1))
      return Mc(u, c, M, null);
    if (C.data === "$!") {
      if (y = C.nextSibling && C.nextSibling.dataset, y)
        var H = y.dgst;
      return y = H, w = Error(r(419)), y = wf(w, y, void 0), Mc(u, c, M, y);
    }
    if (H = (M & u.childLanes) !== 0, sn || H) {
      if (y = Gr, y !== null) {
        switch (M & -M) {
          case 4:
            C = 2;
            break;
          case 16:
            C = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            C = 32;
            break;
          case 536870912:
            C = 268435456;
            break;
          default:
            C = 0;
        }
        C = C & (y.suspendedLanes | M) ? 0 : C, C !== 0 && C !== w.retryLane && (w.retryLane = C, is(u, C), li(y, u, C, -1));
      }
      return s0(), y = wf(Error(r(421))), Mc(u, c, M, y);
    }
    return C.data === "$?" ? (c.flags |= 128, c.child = u.child, c = R1.bind(null, u), C._reactRetry = c, null) : (u = w.treeContext, Ni = io(C.nextSibling), ia = c, Ar = !0, Da = null, u !== null && (Ii[ni++] = Bn, Ii[ni++] = rs, Ii[ni++] = Ra, Bn = u.id, rs = u.overflow, Ra = c), c = qm(c, y.children), c.flags |= 4096, c);
  }
  function Km(u, c, g) {
    u.lanes |= c;
    var y = u.alternate;
    y !== null && (y.lanes |= c), pn(u.return, c, g);
  }
  function Gv(u, c, g, y, C) {
    var w = u.memoizedState;
    w === null ? u.memoizedState = { isBackwards: c, rendering: null, renderingStartTime: 0, last: y, tail: g, tailMode: C } : (w.isBackwards = c, w.rendering = null, w.renderingStartTime = 0, w.last = y, w.tail = g, w.tailMode = C);
  }
  function Zm(u, c, g) {
    var y = c.pendingProps, C = y.revealOrder, w = y.tail;
    if (mn(u, c, y.children, g), y = mt.current, y & 2)
      y = y & 1 | 2, c.flags |= 128;
    else {
      if (u !== null && u.flags & 128)
        e:
          for (u = c.child; u !== null; ) {
            if (u.tag === 13)
              u.memoizedState !== null && Km(u, g, c);
            else if (u.tag === 19)
              Km(u, g, c);
            else if (u.child !== null) {
              u.child.return = u, u = u.child;
              continue;
            }
            if (u === c)
              break e;
            for (; u.sibling === null; ) {
              if (u.return === null || u.return === c)
                break e;
              u = u.return;
            }
            u.sibling.return = u.return, u = u.sibling;
          }
      y &= 1;
    }
    if (ar(mt, y), !(c.mode & 1))
      c.memoizedState = null;
    else
      switch (C) {
        case "forwards":
          for (g = c.child, C = null; g !== null; )
            u = g.alternate, u !== null && Hr(u) === null && (C = g), g = g.sibling;
          g = C, g === null ? (C = c.child, c.child = null) : (C = g.sibling, g.sibling = null), Gv(c, !1, C, g, w);
          break;
        case "backwards":
          for (g = null, C = c.child, c.child = null; C !== null; ) {
            if (u = C.alternate, u !== null && Hr(u) === null) {
              c.child = C;
              break;
            }
            u = C.sibling, C.sibling = g, g = C, C = u;
          }
          Gv(c, !0, g, null, w);
          break;
        case "together":
          Gv(c, !1, null, null, void 0);
          break;
        default:
          c.memoizedState = null;
      }
    return c.child;
  }
  function ii(u, c) {
    !(c.mode & 1) && u !== null && (u.alternate = null, c.alternate = null, c.flags |= 2);
  }
  function Hn(u, c, g) {
    if (u !== null && (c.dependencies = u.dependencies), us |= c.lanes, !(g & c.childLanes))
      return null;
    if (u !== null && c.child !== u.child)
      throw Error(r(153));
    if (c.child !== null) {
      for (u = c.child, g = ul(u, u.pendingProps), c.child = g, g.return = c; u.sibling !== null; )
        u = u.sibling, g = g.sibling = ul(u, u.pendingProps), g.return = c;
      g.sibling = null;
    }
    return c.child;
  }
  function ss(u, c, g) {
    switch (c.tag) {
      case 3:
        $x(c), zr();
        break;
      case 5:
        pt(c);
        break;
      case 1:
        Pr(c.type) && cv(c);
        break;
      case 4:
        zm(c, c.stateNode.containerInfo);
        break;
      case 10:
        var y = c.type._context, C = c.memoizedProps.value;
        ar(yo, y._currentValue), y._currentValue = C;
        break;
      case 13:
        if (y = c.memoizedState, y !== null)
          return y.dehydrated !== null ? (ar(mt, mt.current & 1), c.flags |= 128, null) : g & c.child.childLanes ? Xm(u, c, g) : (ar(mt, mt.current & 1), u = Hn(u, c, g), u !== null ? u.sibling : null);
        ar(mt, mt.current & 1);
        break;
      case 19:
        if (y = (g & c.childLanes) !== 0, u.flags & 128) {
          if (y)
            return Zm(u, c, g);
          c.flags |= 128;
        }
        if (C = c.memoizedState, C !== null && (C.rendering = null, C.tail = null, C.lastEffect = null), ar(mt, mt.current), y)
          break;
        return null;
      case 22:
      case 23:
        return c.lanes = 0, du(u, c, g);
    }
    return Hn(u, c, g);
  }
  var Of, hu, Pa, _n;
  Of = function(u, c) {
    for (var g = c.child; g !== null; ) {
      if (g.tag === 5 || g.tag === 6)
        u.appendChild(g.stateNode);
      else if (g.tag !== 4 && g.child !== null) {
        g.child.return = g, g = g.child;
        continue;
      }
      if (g === c)
        break;
      for (; g.sibling === null; ) {
        if (g.return === null || g.return === c)
          return;
        g = g.return;
      }
      g.sibling.return = g.return, g = g.sibling;
    }
  }, hu = function() {
  }, Pa = function(u, c, g, y) {
    var C = u.memoizedProps;
    if (C !== y) {
      u = c.stateNode, nu(ao.current);
      var w = null;
      switch (g) {
        case "input":
          C = Pt(u, C), y = Pt(u, y), w = [];
          break;
        case "select":
          C = G({}, C, { value: void 0 }), y = G({}, y, { value: void 0 }), w = [];
          break;
        case "textarea":
          C = Ri(u, C), y = Ri(u, y), w = [];
          break;
        default:
          typeof C.onClick != "function" && typeof y.onClick == "function" && (u.onclick = uv);
      }
      _r(g, y);
      var M;
      g = null;
      for (ue in C)
        if (!y.hasOwnProperty(ue) && C.hasOwnProperty(ue) && C[ue] != null)
          if (ue === "style") {
            var H = C[ue];
            for (M in H)
              H.hasOwnProperty(M) && (g || (g = {}), g[M] = "");
          } else
            ue !== "dangerouslySetInnerHTML" && ue !== "children" && ue !== "suppressContentEditableWarning" && ue !== "suppressHydrationWarning" && ue !== "autoFocus" && (i.hasOwnProperty(ue) ? w || (w = []) : (w = w || []).push(ue, null));
      for (ue in y) {
        var $ = y[ue];
        if (H = C != null ? C[ue] : void 0, y.hasOwnProperty(ue) && $ !== H && ($ != null || H != null))
          if (ue === "style")
            if (H) {
              for (M in H)
                !H.hasOwnProperty(M) || $ && $.hasOwnProperty(M) || (g || (g = {}), g[M] = "");
              for (M in $)
                $.hasOwnProperty(M) && H[M] !== $[M] && (g || (g = {}), g[M] = $[M]);
            } else
              g || (w || (w = []), w.push(
                ue,
                g
              )), g = $;
          else
            ue === "dangerouslySetInnerHTML" ? ($ = $ ? $.__html : void 0, H = H ? H.__html : void 0, $ != null && H !== $ && (w = w || []).push(ue, $)) : ue === "children" ? typeof $ != "string" && typeof $ != "number" || (w = w || []).push(ue, "" + $) : ue !== "suppressContentEditableWarning" && ue !== "suppressHydrationWarning" && (i.hasOwnProperty(ue) ? ($ != null && ue === "onScroll" && xr("scroll", u), w || H === $ || (w = [])) : (w = w || []).push(ue, $));
      }
      g && (w = w || []).push("style", g);
      var ue = w;
      (c.updateQueue = ue) && (c.flags |= 4);
    }
  }, _n = function(u, c, g, y) {
    g !== y && (c.flags |= 4);
  };
  function kf(u, c) {
    if (!Ar)
      switch (u.tailMode) {
        case "hidden":
          c = u.tail;
          for (var g = null; c !== null; )
            c.alternate !== null && (g = c), c = c.sibling;
          g === null ? u.tail = null : g.sibling = null;
          break;
        case "collapsed":
          g = u.tail;
          for (var y = null; g !== null; )
            g.alternate !== null && (y = g), g = g.sibling;
          y === null ? c || u.tail === null ? u.tail = null : u.tail.sibling = null : y.sibling = null;
      }
  }
  function ai(u) {
    var c = u.alternate !== null && u.alternate.child === u.child, g = 0, y = 0;
    if (c)
      for (var C = u.child; C !== null; )
        g |= C.lanes | C.childLanes, y |= C.subtreeFlags & 14680064, y |= C.flags & 14680064, C.return = u, C = C.sibling;
    else
      for (C = u.child; C !== null; )
        g |= C.lanes | C.childLanes, y |= C.subtreeFlags, y |= C.flags, C.return = u, C = C.sibling;
    return u.subtreeFlags |= y, u.childLanes = g, c;
  }
  function T1(u, c, g) {
    var y = c.pendingProps;
    switch (Dm(c), c.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return ai(c), null;
      case 1:
        return Pr(c.type) && ka(), ai(c), null;
      case 3:
        return y = c.stateNode, rl(), nr(Wr), nr(St), bv(), y.pendingContext && (y.context = y.pendingContext, y.pendingContext = null), (u === null || u.child === null) && (vv(c) ? c.flags |= 4 : u === null || u.memoizedState.isDehydrated && !(c.flags & 256) || (c.flags |= 1024, Da !== null && (Nf(Da), Da = null))), hu(u, c), ai(c), null;
      case 5:
        Ft(c);
        var C = nu(wc.current);
        if (g = c.type, u !== null && c.stateNode != null)
          Pa(u, c, g, y, C), u.ref !== c.ref && (c.flags |= 512, c.flags |= 2097152);
        else {
          if (!y) {
            if (c.stateNode === null)
              throw Error(r(166));
            return ai(c), null;
          }
          if (u = nu(ao.current), vv(c)) {
            y = c.stateNode, g = c.type;
            var w = c.memoizedProps;
            switch (y[mo] = c, y[eu] = w, u = (c.mode & 1) !== 0, g) {
              case "dialog":
                xr("cancel", y), xr("close", y);
                break;
              case "iframe":
              case "object":
              case "embed":
                xr("load", y);
                break;
              case "video":
              case "audio":
                for (C = 0; C < ff.length; C++)
                  xr(ff[C], y);
                break;
              case "source":
                xr("error", y);
                break;
              case "img":
              case "image":
              case "link":
                xr(
                  "error",
                  y
                ), xr("load", y);
                break;
              case "details":
                xr("toggle", y);
                break;
              case "input":
                bt(y, w), xr("invalid", y);
                break;
              case "select":
                y._wrapperState = { wasMultiple: !!w.multiple }, xr("invalid", y);
                break;
              case "textarea":
                hn(y, w), xr("invalid", y);
            }
            _r(g, w), C = null;
            for (var M in w)
              if (w.hasOwnProperty(M)) {
                var H = w[M];
                M === "children" ? typeof H == "string" ? y.textContent !== H && (w.suppressHydrationWarning !== !0 && lv(y.textContent, H, u), C = ["children", H]) : typeof H == "number" && y.textContent !== "" + H && (w.suppressHydrationWarning !== !0 && lv(
                  y.textContent,
                  H,
                  u
                ), C = ["children", "" + H]) : i.hasOwnProperty(M) && H != null && M === "onScroll" && xr("scroll", y);
              }
            switch (g) {
              case "input":
                _t(y), qt(y, w, !0);
                break;
              case "textarea":
                _t(y), Er(y);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof w.onClick == "function" && (y.onclick = uv);
            }
            y = C, c.updateQueue = y, y !== null && (c.flags |= 4);
          } else {
            M = C.nodeType === 9 ? C : C.ownerDocument, u === "http://www.w3.org/1999/xhtml" && (u = Ji(g)), u === "http://www.w3.org/1999/xhtml" ? g === "script" ? (u = M.createElement("div"), u.innerHTML = "<script><\/script>", u = u.removeChild(u.firstChild)) : typeof y.is == "string" ? u = M.createElement(g, { is: y.is }) : (u = M.createElement(g), g === "select" && (M = u, y.multiple ? M.multiple = !0 : y.size && (M.size = y.size))) : u = M.createElementNS(u, g), u[mo] = c, u[eu] = y, Of(u, c, !1, !1), c.stateNode = u;
            e: {
              switch (M = wn(g, y), g) {
                case "dialog":
                  xr("cancel", u), xr("close", u), C = y;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  xr("load", u), C = y;
                  break;
                case "video":
                case "audio":
                  for (C = 0; C < ff.length; C++)
                    xr(ff[C], u);
                  C = y;
                  break;
                case "source":
                  xr("error", u), C = y;
                  break;
                case "img":
                case "image":
                case "link":
                  xr(
                    "error",
                    u
                  ), xr("load", u), C = y;
                  break;
                case "details":
                  xr("toggle", u), C = y;
                  break;
                case "input":
                  bt(u, y), C = Pt(u, y), xr("invalid", u);
                  break;
                case "option":
                  C = y;
                  break;
                case "select":
                  u._wrapperState = { wasMultiple: !!y.multiple }, C = G({}, y, { value: void 0 }), xr("invalid", u);
                  break;
                case "textarea":
                  hn(u, y), C = Ri(u, y), xr("invalid", u);
                  break;
                default:
                  C = y;
              }
              _r(g, C), H = C;
              for (w in H)
                if (H.hasOwnProperty(w)) {
                  var $ = H[w];
                  w === "style" ? Vt(u, $) : w === "dangerouslySetInnerHTML" ? ($ = $ ? $.__html : void 0, $ != null && Wo(u, $)) : w === "children" ? typeof $ == "string" ? (g !== "textarea" || $ !== "") && Za(u, $) : typeof $ == "number" && Za(u, "" + $) : w !== "suppressContentEditableWarning" && w !== "suppressHydrationWarning" && w !== "autoFocus" && (i.hasOwnProperty(w) ? $ != null && w === "onScroll" && xr("scroll", u) : $ != null && z(u, w, $, M));
                }
              switch (g) {
                case "input":
                  _t(u), qt(u, y, !1);
                  break;
                case "textarea":
                  _t(u), Er(u);
                  break;
                case "option":
                  y.value != null && u.setAttribute("value", "" + Qe(y.value));
                  break;
                case "select":
                  u.multiple = !!y.multiple, w = y.value, w != null ? pi(u, !!y.multiple, w, !1) : y.defaultValue != null && pi(
                    u,
                    !!y.multiple,
                    y.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof C.onClick == "function" && (u.onclick = uv);
              }
              switch (g) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  y = !!y.autoFocus;
                  break e;
                case "img":
                  y = !0;
                  break e;
                default:
                  y = !1;
              }
            }
            y && (c.flags |= 4);
          }
          c.ref !== null && (c.flags |= 512, c.flags |= 2097152);
        }
        return ai(c), null;
      case 6:
        if (u && c.stateNode != null)
          _n(u, c, u.memoizedProps, y);
        else {
          if (typeof y != "string" && c.stateNode === null)
            throw Error(r(166));
          if (g = nu(wc.current), nu(ao.current), vv(c)) {
            if (y = c.stateNode, g = c.memoizedProps, y[mo] = c, (w = y.nodeValue !== g) && (u = ia, u !== null))
              switch (u.tag) {
                case 3:
                  lv(y.nodeValue, g, (u.mode & 1) !== 0);
                  break;
                case 5:
                  u.memoizedProps.suppressHydrationWarning !== !0 && lv(y.nodeValue, g, (u.mode & 1) !== 0);
              }
            w && (c.flags |= 4);
          } else
            y = (g.nodeType === 9 ? g : g.ownerDocument).createTextNode(y), y[mo] = c, c.stateNode = y;
        }
        return ai(c), null;
      case 13:
        if (nr(mt), y = c.memoizedState, u === null || u.memoizedState !== null && u.memoizedState.dehydrated !== null) {
          if (Ar && Ni !== null && c.mode & 1 && !(c.flags & 128))
            Mx(), zr(), c.flags |= 98560, w = !1;
          else if (w = vv(c), y !== null && y.dehydrated !== null) {
            if (u === null) {
              if (!w)
                throw Error(r(318));
              if (w = c.memoizedState, w = w !== null ? w.dehydrated : null, !w)
                throw Error(r(317));
              w[mo] = c;
            } else
              zr(), !(c.flags & 128) && (c.memoizedState = null), c.flags |= 4;
            ai(c), w = !1;
          } else
            Da !== null && (Nf(Da), Da = null), w = !0;
          if (!w)
            return c.flags & 65536 ? c : null;
        }
        return c.flags & 128 ? (c.lanes = g, c) : (y = y !== null, y !== (u !== null && u.memoizedState !== null) && y && (c.child.flags |= 8192, c.mode & 1 && (u === null || mt.current & 1 ? xn === 0 && (xn = 3) : s0())), c.updateQueue !== null && (c.flags |= 4), ai(c), null);
      case 4:
        return rl(), hu(u, c), u === null && bc(c.stateNode.containerInfo), ai(c), null;
      case 10:
        return ns(c.type._context), ai(c), null;
      case 17:
        return Pr(c.type) && ka(), ai(c), null;
      case 19:
        if (nr(mt), w = c.memoizedState, w === null)
          return ai(c), null;
        if (y = (c.flags & 128) !== 0, M = w.rendering, M === null)
          if (y)
            kf(w, !1);
          else {
            if (xn !== 0 || u !== null && u.flags & 128)
              for (u = c.child; u !== null; ) {
                if (M = Hr(u), M !== null) {
                  for (c.flags |= 128, kf(w, !1), y = M.updateQueue, y !== null && (c.updateQueue = y, c.flags |= 4), c.subtreeFlags = 0, y = g, g = c.child; g !== null; )
                    w = g, u = y, w.flags &= 14680066, M = w.alternate, M === null ? (w.childLanes = 0, w.lanes = u, w.child = null, w.subtreeFlags = 0, w.memoizedProps = null, w.memoizedState = null, w.updateQueue = null, w.dependencies = null, w.stateNode = null) : (w.childLanes = M.childLanes, w.lanes = M.lanes, w.child = M.child, w.subtreeFlags = 0, w.deletions = null, w.memoizedProps = M.memoizedProps, w.memoizedState = M.memoizedState, w.updateQueue = M.updateQueue, w.type = M.type, u = M.dependencies, w.dependencies = u === null ? null : { lanes: u.lanes, firstContext: u.firstContext }), g = g.sibling;
                  return ar(mt, mt.current & 1 | 2), c.child;
                }
                u = u.sibling;
              }
            w.tail !== null && Jt() > Bc && (c.flags |= 128, y = !0, kf(w, !1), c.lanes = 4194304);
          }
        else {
          if (!y)
            if (u = Hr(M), u !== null) {
              if (c.flags |= 128, y = !0, g = u.updateQueue, g !== null && (c.updateQueue = g, c.flags |= 4), kf(w, !0), w.tail === null && w.tailMode === "hidden" && !M.alternate && !Ar)
                return ai(c), null;
            } else
              2 * Jt() - w.renderingStartTime > Bc && g !== 1073741824 && (c.flags |= 128, y = !0, kf(w, !1), c.lanes = 4194304);
          w.isBackwards ? (M.sibling = c.child, c.child = M) : (g = w.last, g !== null ? g.sibling = M : c.child = M, w.last = M);
        }
        return w.tail !== null ? (c = w.tail, w.rendering = c, w.tail = c.sibling, w.renderingStartTime = Jt(), c.sibling = null, g = mt.current, ar(mt, y ? g & 1 | 2 : g & 1), c) : (ai(c), null);
      case 22:
      case 23:
        return o0(), y = c.memoizedState !== null, u !== null && u.memoizedState !== null !== y && (c.flags |= 8192), y && c.mode & 1 ? sa & 1073741824 && (ai(c), c.subtreeFlags & 6 && (c.flags |= 8192)) : ai(c), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(r(156, c.tag));
  }
  function Qm(u, c) {
    switch (Dm(c), c.tag) {
      case 1:
        return Pr(c.type) && ka(), u = c.flags, u & 65536 ? (c.flags = u & -65537 | 128, c) : null;
      case 3:
        return rl(), nr(Wr), nr(St), bv(), u = c.flags, u & 65536 && !(u & 128) ? (c.flags = u & -65537 | 128, c) : null;
      case 5:
        return Ft(c), null;
      case 13:
        if (nr(mt), u = c.memoizedState, u !== null && u.dehydrated !== null) {
          if (c.alternate === null)
            throw Error(r(340));
          zr();
        }
        return u = c.flags, u & 65536 ? (c.flags = u & -65537 | 128, c) : null;
      case 19:
        return nr(mt), null;
      case 4:
        return rl(), null;
      case 10:
        return ns(c.type._context), null;
      case 22:
      case 23:
        return o0(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Rf = !1, yn = !1, Yx = typeof WeakSet == "function" ? WeakSet : Set, et = null;
  function Lc(u, c) {
    var g = u.ref;
    if (g !== null)
      if (typeof g == "function")
        try {
          g(null);
        } catch (y) {
          qr(u, c, y);
        }
      else
        g.current = null;
  }
  function Df(u, c, g) {
    try {
      g();
    } catch (y) {
      qr(u, c, y);
    }
  }
  var Wx = !1;
  function Xx(u, c) {
    if (Cm = Wl, u = nv(), Qo(u)) {
      if ("selectionStart" in u)
        var g = { start: u.selectionStart, end: u.selectionEnd };
      else
        e: {
          g = (g = u.ownerDocument) && g.defaultView || window;
          var y = g.getSelection && g.getSelection();
          if (y && y.rangeCount !== 0) {
            g = y.anchorNode;
            var C = y.anchorOffset, w = y.focusNode;
            y = y.focusOffset;
            try {
              g.nodeType, w.nodeType;
            } catch {
              g = null;
              break e;
            }
            var M = 0, H = -1, $ = -1, ue = 0, Oe = 0, De = u, Ae = null;
            t:
              for (; ; ) {
                for (var Xe; De !== g || C !== 0 && De.nodeType !== 3 || (H = M + C), De !== w || y !== 0 && De.nodeType !== 3 || ($ = M + y), De.nodeType === 3 && (M += De.nodeValue.length), (Xe = De.firstChild) !== null; )
                  Ae = De, De = Xe;
                for (; ; ) {
                  if (De === u)
                    break t;
                  if (Ae === g && ++ue === C && (H = M), Ae === w && ++Oe === y && ($ = M), (Xe = De.nextSibling) !== null)
                    break;
                  De = Ae, Ae = De.parentNode;
                }
                De = Xe;
              }
            g = H === -1 || $ === -1 ? null : { start: H, end: $ };
          } else
            g = null;
        }
      g = g || { start: 0, end: 0 };
    } else
      g = null;
    for (Ql = { focusedElem: u, selectionRange: g }, Wl = !1, et = c; et !== null; )
      if (c = et, u = c.child, (c.subtreeFlags & 1028) !== 0 && u !== null)
        u.return = c, et = u;
      else
        for (; et !== null; ) {
          c = et;
          try {
            var tt = c.alternate;
            if (c.flags & 1024)
              switch (c.tag) {
                case 0:
                case 11:
                case 15:
                  break;
                case 1:
                  if (tt !== null) {
                    var at = tt.memoizedProps, en = tt.memoizedState, te = c.stateNode, q = te.getSnapshotBeforeUpdate(c.elementType === c.type ? at : aa(c.type, at), en);
                    te.__reactInternalSnapshotBeforeUpdate = q;
                  }
                  break;
                case 3:
                  var ae = c.stateNode.containerInfo;
                  ae.nodeType === 1 ? ae.textContent = "" : ae.nodeType === 9 && ae.documentElement && ae.removeChild(ae.documentElement);
                  break;
                case 5:
                case 6:
                case 4:
                case 17:
                  break;
                default:
                  throw Error(r(163));
              }
          } catch (Ne) {
            qr(c, c.return, Ne);
          }
          if (u = c.sibling, u !== null) {
            u.return = c.return, et = u;
            break;
          }
          et = c.return;
        }
    return tt = Wx, Wx = !1, tt;
  }
  function Mf(u, c, g) {
    var y = c.updateQueue;
    if (y = y !== null ? y.lastEffect : null, y !== null) {
      var C = y = y.next;
      do {
        if ((C.tag & u) === u) {
          var w = C.destroy;
          C.destroy = void 0, w !== void 0 && Df(c, g, w);
        }
        C = C.next;
      } while (C !== y);
    }
  }
  function Lf(u, c) {
    if (c = c.updateQueue, c = c !== null ? c.lastEffect : null, c !== null) {
      var g = c = c.next;
      do {
        if ((g.tag & u) === u) {
          var y = g.create;
          g.destroy = y();
        }
        g = g.next;
      } while (g !== c);
    }
  }
  function Jm(u) {
    var c = u.ref;
    if (c !== null) {
      var g = u.stateNode;
      switch (u.tag) {
        case 5:
          u = g;
          break;
        default:
          u = g;
      }
      typeof c == "function" ? c(u) : c.current = u;
    }
  }
  function e0(u) {
    var c = u.alternate;
    c !== null && (u.alternate = null, e0(c)), u.child = null, u.deletions = null, u.sibling = null, u.tag === 5 && (c = u.stateNode, c !== null && (delete c[mo], delete c[eu], delete c[wm], delete c[_1], delete c[Am])), u.stateNode = null, u.return = null, u.dependencies = null, u.memoizedProps = null, u.memoizedState = null, u.pendingProps = null, u.stateNode = null, u.updateQueue = null;
  }
  function qx(u) {
    return u.tag === 5 || u.tag === 3 || u.tag === 4;
  }
  function Uv(u) {
    e:
      for (; ; ) {
        for (; u.sibling === null; ) {
          if (u.return === null || qx(u.return))
            return null;
          u = u.return;
        }
        for (u.sibling.return = u.return, u = u.sibling; u.tag !== 5 && u.tag !== 6 && u.tag !== 18; ) {
          if (u.flags & 2 || u.child === null || u.tag === 4)
            continue e;
          u.child.return = u, u = u.child;
        }
        if (!(u.flags & 2))
          return u.stateNode;
      }
  }
  function Pc(u, c, g) {
    var y = u.tag;
    if (y === 5 || y === 6)
      u = u.stateNode, c ? g.nodeType === 8 ? g.parentNode.insertBefore(u, c) : g.insertBefore(u, c) : (g.nodeType === 8 ? (c = g.parentNode, c.insertBefore(u, g)) : (c = g, c.appendChild(u)), g = g._reactRootContainer, g != null || c.onclick !== null || (c.onclick = uv));
    else if (y !== 4 && (u = u.child, u !== null))
      for (Pc(u, c, g), u = u.sibling; u !== null; )
        Pc(u, c, g), u = u.sibling;
  }
  function bo(u, c, g) {
    var y = u.tag;
    if (y === 5 || y === 6)
      u = u.stateNode, c ? g.insertBefore(u, c) : g.appendChild(u);
    else if (y !== 4 && (u = u.child, u !== null))
      for (bo(u, c, g), u = u.sibling; u !== null; )
        bo(u, c, g), u = u.sibling;
  }
  var Ir = null, Mn = !1;
  function Ia(u, c, g) {
    for (g = g.child; g !== null; )
      Ic(u, c, g), g = g.sibling;
  }
  function Ic(u, c, g) {
    if (Ja && typeof Ja.onCommitFiberUnmount == "function")
      try {
        Ja.onCommitFiberUnmount(qd, g);
      } catch {
      }
    switch (g.tag) {
      case 5:
        yn || Lc(g, c);
      case 6:
        var y = Ir, C = Mn;
        Ir = null, Ia(u, c, g), Ir = y, Mn = C, Ir !== null && (Mn ? (u = Ir, g = g.stateNode, u.nodeType === 8 ? u.parentNode.removeChild(g) : u.removeChild(g)) : Ir.removeChild(g.stateNode));
        break;
      case 18:
        Ir !== null && (Mn ? (u = Ir, g = g.stateNode, u.nodeType === 8 ? Ws(u.parentNode, g) : u.nodeType === 1 && Ws(u, g), ef(u)) : Ws(Ir, g.stateNode));
        break;
      case 4:
        y = Ir, C = Mn, Ir = g.stateNode.containerInfo, Mn = !0, Ia(u, c, g), Ir = y, Mn = C;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!yn && (y = g.updateQueue, y !== null && (y = y.lastEffect, y !== null))) {
          C = y = y.next;
          do {
            var w = C, M = w.destroy;
            w = w.tag, M !== void 0 && (w & 2 || w & 4) && Df(g, c, M), C = C.next;
          } while (C !== y);
        }
        Ia(u, c, g);
        break;
      case 1:
        if (!yn && (Lc(g, c), y = g.stateNode, typeof y.componentWillUnmount == "function"))
          try {
            y.props = g.memoizedProps, y.state = g.memoizedState, y.componentWillUnmount();
          } catch (H) {
            qr(g, c, H);
          }
        Ia(u, c, g);
        break;
      case 21:
        Ia(u, c, g);
        break;
      case 22:
        g.mode & 1 ? (yn = (y = yn) || g.memoizedState !== null, Ia(u, c, g), yn = y) : Ia(u, c, g);
        break;
      default:
        Ia(u, c, g);
    }
  }
  function ls(u) {
    var c = u.updateQueue;
    if (c !== null) {
      u.updateQueue = null;
      var g = u.stateNode;
      g === null && (g = u.stateNode = new Yx()), c.forEach(function(y) {
        var C = D1.bind(null, u, y);
        g.has(y) || (g.add(y), y.then(C, C));
      });
    }
  }
  function oo(u, c) {
    var g = c.deletions;
    if (g !== null)
      for (var y = 0; y < g.length; y++) {
        var C = g[y];
        try {
          var w = u, M = c, H = M;
          e:
            for (; H !== null; ) {
              switch (H.tag) {
                case 5:
                  Ir = H.stateNode, Mn = !1;
                  break e;
                case 3:
                  Ir = H.stateNode.containerInfo, Mn = !0;
                  break e;
                case 4:
                  Ir = H.stateNode.containerInfo, Mn = !0;
                  break e;
              }
              H = H.return;
            }
          if (Ir === null)
            throw Error(r(160));
          Ic(w, M, C), Ir = null, Mn = !1;
          var $ = C.alternate;
          $ !== null && ($.return = null), C.return = null;
        } catch (ue) {
          qr(C, c, ue);
        }
      }
    if (c.subtreeFlags & 12854)
      for (c = c.child; c !== null; )
        Kx(c, u), c = c.sibling;
  }
  function Kx(u, c) {
    var g = u.alternate, y = u.flags;
    switch (u.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (oo(c, u), So(u), y & 4) {
          try {
            Mf(3, u, u.return), Lf(3, u);
          } catch (at) {
            qr(u, u.return, at);
          }
          try {
            Mf(5, u, u.return);
          } catch (at) {
            qr(u, u.return, at);
          }
        }
        break;
      case 1:
        oo(c, u), So(u), y & 512 && g !== null && Lc(g, g.return);
        break;
      case 5:
        if (oo(c, u), So(u), y & 512 && g !== null && Lc(g, g.return), u.flags & 32) {
          var C = u.stateNode;
          try {
            Za(C, "");
          } catch (at) {
            qr(u, u.return, at);
          }
        }
        if (y & 4 && (C = u.stateNode, C != null)) {
          var w = u.memoizedProps, M = g !== null ? g.memoizedProps : w, H = u.type, $ = u.updateQueue;
          if (u.updateQueue = null, $ !== null)
            try {
              H === "input" && w.type === "radio" && w.name != null && ir(C, w), wn(H, M);
              var ue = wn(H, w);
              for (M = 0; M < $.length; M += 2) {
                var Oe = $[M], De = $[M + 1];
                Oe === "style" ? Vt(C, De) : Oe === "dangerouslySetInnerHTML" ? Wo(C, De) : Oe === "children" ? Za(C, De) : z(C, Oe, De, ue);
              }
              switch (H) {
                case "input":
                  Cr(C, w);
                  break;
                case "textarea":
                  fr(C, w);
                  break;
                case "select":
                  var Ae = C._wrapperState.wasMultiple;
                  C._wrapperState.wasMultiple = !!w.multiple;
                  var Xe = w.value;
                  Xe != null ? pi(C, !!w.multiple, Xe, !1) : Ae !== !!w.multiple && (w.defaultValue != null ? pi(
                    C,
                    !!w.multiple,
                    w.defaultValue,
                    !0
                  ) : pi(C, !!w.multiple, w.multiple ? [] : "", !1));
              }
              C[eu] = w;
            } catch (at) {
              qr(u, u.return, at);
            }
        }
        break;
      case 6:
        if (oo(c, u), So(u), y & 4) {
          if (u.stateNode === null)
            throw Error(r(162));
          C = u.stateNode, w = u.memoizedProps;
          try {
            C.nodeValue = w;
          } catch (at) {
            qr(u, u.return, at);
          }
        }
        break;
      case 3:
        if (oo(c, u), So(u), y & 4 && g !== null && g.memoizedState.isDehydrated)
          try {
            ef(c.containerInfo);
          } catch (at) {
            qr(u, u.return, at);
          }
        break;
      case 4:
        oo(c, u), So(u);
        break;
      case 13:
        oo(c, u), So(u), C = u.child, C.flags & 8192 && (w = C.memoizedState !== null, C.stateNode.isHidden = w, !w || C.alternate !== null && C.alternate.memoizedState !== null || (n0 = Jt())), y & 4 && ls(u);
        break;
      case 22:
        if (Oe = g !== null && g.memoizedState !== null, u.mode & 1 ? (yn = (ue = yn) || Oe, oo(c, u), yn = ue) : oo(c, u), So(u), y & 8192) {
          if (ue = u.memoizedState !== null, (u.stateNode.isHidden = ue) && !Oe && u.mode & 1)
            for (et = u, Oe = u.child; Oe !== null; ) {
              for (De = et = Oe; et !== null; ) {
                switch (Ae = et, Xe = Ae.child, Ae.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    Mf(4, Ae, Ae.return);
                    break;
                  case 1:
                    Lc(Ae, Ae.return);
                    var tt = Ae.stateNode;
                    if (typeof tt.componentWillUnmount == "function") {
                      y = Ae, g = Ae.return;
                      try {
                        c = y, tt.props = c.memoizedProps, tt.state = c.memoizedState, tt.componentWillUnmount();
                      } catch (at) {
                        qr(y, g, at);
                      }
                    }
                    break;
                  case 5:
                    Lc(Ae, Ae.return);
                    break;
                  case 22:
                    if (Ae.memoizedState !== null) {
                      t0(De);
                      continue;
                    }
                }
                Xe !== null ? (Xe.return = Ae, et = Xe) : t0(De);
              }
              Oe = Oe.sibling;
            }
          e:
            for (Oe = null, De = u; ; ) {
              if (De.tag === 5) {
                if (Oe === null) {
                  Oe = De;
                  try {
                    C = De.stateNode, ue ? (w = C.style, typeof w.setProperty == "function" ? w.setProperty("display", "none", "important") : w.display = "none") : (H = De.stateNode, $ = De.memoizedProps.style, M = $ != null && $.hasOwnProperty("display") ? $.display : null, H.style.display = ht("display", M));
                  } catch (at) {
                    qr(u, u.return, at);
                  }
                }
              } else if (De.tag === 6) {
                if (Oe === null)
                  try {
                    De.stateNode.nodeValue = ue ? "" : De.memoizedProps;
                  } catch (at) {
                    qr(u, u.return, at);
                  }
              } else if ((De.tag !== 22 && De.tag !== 23 || De.memoizedState === null || De === u) && De.child !== null) {
                De.child.return = De, De = De.child;
                continue;
              }
              if (De === u)
                break e;
              for (; De.sibling === null; ) {
                if (De.return === null || De.return === u)
                  break e;
                Oe === De && (Oe = null), De = De.return;
              }
              Oe === De && (Oe = null), De.sibling.return = De.return, De = De.sibling;
            }
        }
        break;
      case 19:
        oo(c, u), So(u), y & 4 && ls(u);
        break;
      case 21:
        break;
      default:
        oo(
          c,
          u
        ), So(u);
    }
  }
  function So(u) {
    var c = u.flags;
    if (c & 2) {
      try {
        e: {
          for (var g = u.return; g !== null; ) {
            if (qx(g)) {
              var y = g;
              break e;
            }
            g = g.return;
          }
          throw Error(r(160));
        }
        switch (y.tag) {
          case 5:
            var C = y.stateNode;
            y.flags & 32 && (Za(C, ""), y.flags &= -33);
            var w = Uv(u);
            bo(u, w, C);
            break;
          case 3:
          case 4:
            var M = y.stateNode.containerInfo, H = Uv(u);
            Pc(u, H, M);
            break;
          default:
            throw Error(r(161));
        }
      } catch ($) {
        qr(u, u.return, $);
      }
      u.flags &= -3;
    }
    c & 4096 && (u.flags &= -4097);
  }
  function Zx(u, c, g) {
    et = u, Nc(u, c, g);
  }
  function Nc(u, c, g) {
    for (var y = (u.mode & 1) !== 0; et !== null; ) {
      var C = et, w = C.child;
      if (C.tag === 22 && y) {
        var M = C.memoizedState !== null || Rf;
        if (!M) {
          var H = C.alternate, $ = H !== null && H.memoizedState !== null || yn;
          H = Rf;
          var ue = yn;
          if (Rf = M, (yn = $) && !ue)
            for (et = C; et !== null; )
              M = et, $ = M.child, M.tag === 22 && M.memoizedState !== null ? Jx(C) : $ !== null ? ($.return = M, et = $) : Jx(C);
          for (; w !== null; )
            et = w, Nc(w, c, g), w = w.sibling;
          et = C, Rf = H, yn = ue;
        }
        Qx(u, c, g);
      } else
        C.subtreeFlags & 8772 && w !== null ? (w.return = C, et = w) : Qx(u, c, g);
    }
  }
  function Qx(u) {
    for (; et !== null; ) {
      var c = et;
      if (c.flags & 8772) {
        var g = c.alternate;
        try {
          if (c.flags & 8772)
            switch (c.tag) {
              case 0:
              case 11:
              case 15:
                yn || Lf(5, c);
                break;
              case 1:
                var y = c.stateNode;
                if (c.flags & 4 && !yn)
                  if (g === null)
                    y.componentDidMount();
                  else {
                    var C = c.elementType === c.type ? g.memoizedProps : aa(c.type, g.memoizedProps);
                    y.componentDidUpdate(C, g.memoizedState, y.__reactInternalSnapshotBeforeUpdate);
                  }
                var w = c.updateQueue;
                w !== null && ru(c, w, y);
                break;
              case 3:
                var M = c.updateQueue;
                if (M !== null) {
                  if (g = null, c.child !== null)
                    switch (c.child.tag) {
                      case 5:
                        g = c.child.stateNode;
                        break;
                      case 1:
                        g = c.child.stateNode;
                    }
                  ru(c, M, g);
                }
                break;
              case 5:
                var H = c.stateNode;
                if (g === null && c.flags & 4) {
                  g = H;
                  var $ = c.memoizedProps;
                  switch (c.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      $.autoFocus && g.focus();
                      break;
                    case "img":
                      $.src && (g.src = $.src);
                  }
                }
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (c.memoizedState === null) {
                  var ue = c.alternate;
                  if (ue !== null) {
                    var Oe = ue.memoizedState;
                    if (Oe !== null) {
                      var De = Oe.dehydrated;
                      De !== null && ef(De);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(r(163));
            }
          yn || c.flags & 512 && Jm(c);
        } catch (Ae) {
          qr(c, c.return, Ae);
        }
      }
      if (c === u) {
        et = null;
        break;
      }
      if (g = c.sibling, g !== null) {
        g.return = c.return, et = g;
        break;
      }
      et = c.return;
    }
  }
  function t0(u) {
    for (; et !== null; ) {
      var c = et;
      if (c === u) {
        et = null;
        break;
      }
      var g = c.sibling;
      if (g !== null) {
        g.return = c.return, et = g;
        break;
      }
      et = c.return;
    }
  }
  function Jx(u) {
    for (; et !== null; ) {
      var c = et;
      try {
        switch (c.tag) {
          case 0:
          case 11:
          case 15:
            var g = c.return;
            try {
              Lf(4, c);
            } catch ($) {
              qr(c, g, $);
            }
            break;
          case 1:
            var y = c.stateNode;
            if (typeof y.componentDidMount == "function") {
              var C = c.return;
              try {
                y.componentDidMount();
              } catch ($) {
                qr(c, C, $);
              }
            }
            var w = c.return;
            try {
              Jm(c);
            } catch ($) {
              qr(c, w, $);
            }
            break;
          case 5:
            var M = c.return;
            try {
              Jm(c);
            } catch ($) {
              qr(c, M, $);
            }
        }
      } catch ($) {
        qr(c, c.return, $);
      }
      if (c === u) {
        et = null;
        break;
      }
      var H = c.sibling;
      if (H !== null) {
        H.return = c.return, et = H;
        break;
      }
      et = c.return;
    }
  }
  var jv = Math.ceil, Pf = V.ReactCurrentDispatcher, r0 = V.ReactCurrentOwner, oi = V.ReactCurrentBatchConfig, zt = 0, Gr = null, Xr = null, Ln = 0, sa = 0, Vc = Mt(0), xn = 0, If = null, us = 0, $v = 0, Fc = 0, vu = null, mi = null, n0 = 0, Bc = 1 / 0, cs = null, Yv = !1, pu = null, Co = null, ol = !1, sl = null, Wv = 0, zc = 0, Xv = null, gu = -1, mu = 0;
  function si() {
    return zt & 6 ? Jt() : gu !== -1 ? gu : gu = Jt();
  }
  function ln(u) {
    return u.mode & 1 ? zt & 2 && Ln !== 0 ? Ln & -Ln : pv.transition !== null ? (mu === 0 && (mu = $h()), mu) : (u = dr, u !== 0 || (u = window.event, u = u === void 0 ? 16 : nm(u.type)), u) : 1;
  }
  function li(u, c, g, y) {
    if (50 < zc)
      throw zc = 0, Xv = null, Error(r(185));
    Yl(u, g, y), (!(zt & 2) || u !== Gr) && (u === Gr && (!(zt & 2) && ($v |= g), xn === 4 && Na(u, Ln)), ui(u, y), g === 1 && zt === 0 && !(c.mode & 1) && (Bc = Jt() + 500, Dn && Li()));
  }
  function ui(u, c) {
    var g = u.callbackNode;
    jh(u, c);
    var y = eo(u, u === Gr ? Ln : 0);
    if (y === 0)
      g !== null && gi(g), u.callbackNode = null, u.callbackPriority = 0;
    else if (c = y & -y, u.callbackPriority !== c) {
      if (g != null && gi(g), c === 1)
        u.tag === 0 ? km(eb.bind(null, u)) : Om(eb.bind(null, u)), Tm(function() {
          !(zt & 6) && Li();
        }), g = null;
      else {
        switch (em(y)) {
          case 1:
            g = Xo;
            break;
          case 4:
            g = Bt;
            break;
          case 16:
            g = Gs;
            break;
          case 536870912:
            g = Kg;
            break;
          default:
            g = Gs;
        }
        g = u0(g, Hc.bind(null, u));
      }
      u.callbackPriority = c, u.callbackNode = g;
    }
  }
  function Hc(u, c) {
    if (gu = -1, mu = 0, zt & 6)
      throw Error(r(327));
    var g = u.callbackNode;
    if (Uc() && u.callbackNode !== g)
      return null;
    var y = eo(u, u === Gr ? Ln : 0);
    if (y === 0)
      return null;
    if (y & 30 || y & u.expiredLanes || c)
      c = Kv(u, y);
    else {
      c = y;
      var C = zt;
      zt |= 2;
      var w = qv();
      (Gr !== u || Ln !== c) && (cs = null, Bc = Jt() + 500, _u(u, c));
      do
        try {
          A1();
          break;
        } catch (H) {
          tb(u, H);
        }
      while (!0);
      Im(), Pf.current = w, zt = C, Xr !== null ? c = 0 : (Gr = null, Ln = 0, c = xn);
    }
    if (c !== 0) {
      if (c === 2 && (C = Qg(u), C !== 0 && (y = C, c = i0(u, C))), c === 1)
        throw g = If, _u(u, 0), Na(u, y), ui(u, Jt()), g;
      if (c === 6)
        Na(u, y);
      else {
        if (C = u.current.alternate, !(y & 30) && !a0(C) && (c = Kv(u, y), c === 2 && (w = Qg(u), w !== 0 && (y = w, c = i0(u, w))), c === 1))
          throw g = If, _u(u, 0), Na(u, y), ui(u, Jt()), g;
        switch (u.finishedWork = C, u.finishedLanes = y, c) {
          case 0:
          case 1:
            throw Error(r(345));
          case 2:
            yu(u, mi, cs);
            break;
          case 3:
            if (Na(u, y), (y & 130023424) === y && (c = n0 + 500 - Jt(), 10 < c)) {
              if (eo(u, 0) !== 0)
                break;
              if (C = u.suspendedLanes, (C & y) !== y) {
                si(), u.pingedLanes |= u.suspendedLanes & C;
                break;
              }
              u.timeoutHandle = Jl(yu.bind(null, u, mi, cs), c);
              break;
            }
            yu(u, mi, cs);
            break;
          case 4:
            if (Na(u, y), (y & 4194240) === y)
              break;
            for (c = u.eventTimes, C = -1; 0 < y; ) {
              var M = 31 - Ca(y);
              w = 1 << M, M = c[M], M > C && (C = M), y &= ~w;
            }
            if (y = C, y = Jt() - y, y = (120 > y ? 120 : 480 > y ? 480 : 1080 > y ? 1080 : 1920 > y ? 1920 : 3e3 > y ? 3e3 : 4320 > y ? 4320 : 1960 * jv(y / 1960)) - y, 10 < y) {
              u.timeoutHandle = Jl(yu.bind(null, u, mi, cs), y);
              break;
            }
            yu(u, mi, cs);
            break;
          case 5:
            yu(u, mi, cs);
            break;
          default:
            throw Error(r(329));
        }
      }
    }
    return ui(u, Jt()), u.callbackNode === g ? Hc.bind(null, u) : null;
  }
  function i0(u, c) {
    var g = vu;
    return u.current.memoizedState.isDehydrated && (_u(u, c).flags |= 256), u = Kv(u, c), u !== 2 && (c = mi, mi = g, c !== null && Nf(c)), u;
  }
  function Nf(u) {
    mi === null ? mi = u : mi.push.apply(mi, u);
  }
  function a0(u) {
    for (var c = u; ; ) {
      if (c.flags & 16384) {
        var g = c.updateQueue;
        if (g !== null && (g = g.stores, g !== null))
          for (var y = 0; y < g.length; y++) {
            var C = g[y], w = C.getSnapshot;
            C = C.value;
            try {
              if (!wa(w(), C))
                return !1;
            } catch {
              return !1;
            }
          }
      }
      if (g = c.child, c.subtreeFlags & 16384 && g !== null)
        g.return = c, c = g;
      else {
        if (c === u)
          break;
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === u)
            return !0;
          c = c.return;
        }
        c.sibling.return = c.return, c = c.sibling;
      }
    }
    return !0;
  }
  function Na(u, c) {
    for (c &= ~Fc, c &= ~$v, u.suspendedLanes |= c, u.pingedLanes &= ~c, u = u.expirationTimes; 0 < c; ) {
      var g = 31 - Ca(c), y = 1 << g;
      u[g] = -1, c &= ~y;
    }
  }
  function eb(u) {
    if (zt & 6)
      throw Error(r(327));
    Uc();
    var c = eo(u, 0);
    if (!(c & 1))
      return ui(u, Jt()), null;
    var g = Kv(u, c);
    if (u.tag !== 0 && g === 2) {
      var y = Qg(u);
      y !== 0 && (c = y, g = i0(u, y));
    }
    if (g === 1)
      throw g = If, _u(u, 0), Na(u, c), ui(u, Jt()), g;
    if (g === 6)
      throw Error(r(345));
    return u.finishedWork = u.current.alternate, u.finishedLanes = c, yu(u, mi, cs), ui(u, Jt()), null;
  }
  function Gc(u, c) {
    var g = zt;
    zt |= 1;
    try {
      return u(c);
    } finally {
      zt = g, zt === 0 && (Bc = Jt() + 500, Dn && Li());
    }
  }
  function ll(u) {
    sl !== null && sl.tag === 0 && !(zt & 6) && Uc();
    var c = zt;
    zt |= 1;
    var g = oi.transition, y = dr;
    try {
      if (oi.transition = null, dr = 1, u)
        return u();
    } finally {
      dr = y, oi.transition = g, zt = c, !(zt & 6) && Li();
    }
  }
  function o0() {
    sa = Vc.current, nr(Vc);
  }
  function _u(u, c) {
    u.finishedWork = null, u.finishedLanes = 0;
    var g = u.timeoutHandle;
    if (g !== -1 && (u.timeoutHandle = -1, Ox(g)), Xr !== null)
      for (g = Xr.return; g !== null; ) {
        var y = g;
        switch (Dm(y), y.tag) {
          case 1:
            y = y.type.childContextTypes, y != null && ka();
            break;
          case 3:
            rl(), nr(Wr), nr(St), bv();
            break;
          case 5:
            Ft(y);
            break;
          case 4:
            rl();
            break;
          case 13:
            nr(mt);
            break;
          case 19:
            nr(mt);
            break;
          case 10:
            ns(y.type._context);
            break;
          case 22:
          case 23:
            o0();
        }
        g = g.return;
      }
    if (Gr = u, Xr = u = ul(u.current, null), Ln = sa = c, xn = 0, If = null, Fc = $v = us = 0, mi = vu = null, zn !== null) {
      for (c = 0; c < zn.length; c++)
        if (g = zn[c], y = g.interleaved, y !== null) {
          g.interleaved = null;
          var C = y.next, w = g.pending;
          if (w !== null) {
            var M = w.next;
            w.next = C, y.next = M;
          }
          g.pending = y;
        }
      zn = null;
    }
    return u;
  }
  function tb(u, c) {
    do {
      var g = Xr;
      try {
        if (Im(), Sv.current = Fv, yt) {
          for (var y = Or.memoizedState; y !== null; ) {
            var C = y.queue;
            C !== null && (C.pending = null), y = y.next;
          }
          yt = !1;
        }
        if (iu = 0, jt = ye = Or = null, xo = !1, oa = 0, r0.current = null, g === null || g.return === null) {
          xn = 1, If = c, Xr = null;
          break;
        }
        e: {
          var w = u, M = g.return, H = g, $ = c;
          if (c = Ln, H.flags |= 32768, $ !== null && typeof $ == "object" && typeof $.then == "function") {
            var ue = $, Oe = H, De = Oe.tag;
            if (!(Oe.mode & 1) && (De === 0 || De === 11 || De === 15)) {
              var Ae = Oe.alternate;
              Ae ? (Oe.updateQueue = Ae.updateQueue, Oe.memoizedState = Ae.memoizedState, Oe.lanes = Ae.lanes) : (Oe.updateQueue = null, Oe.memoizedState = null);
            }
            var Xe = jm(M);
            if (Xe !== null) {
              Xe.flags &= -257, $m(Xe, M, H, w, c), Xe.mode & 1 && Ux(w, ue, c), c = Xe, $ = ue;
              var tt = c.updateQueue;
              if (tt === null) {
                var at = /* @__PURE__ */ new Set();
                at.add($), c.updateQueue = at;
              } else
                tt.add($);
              break e;
            } else {
              if (!(c & 1)) {
                Ux(w, ue, c), s0();
                break e;
              }
              $ = Error(r(426));
            }
          } else if (Ar && H.mode & 1) {
            var en = jm(M);
            if (en !== null) {
              !(en.flags & 65536) && (en.flags |= 256), $m(en, M, H, w, c), Lm(Rc($, H));
              break e;
            }
          }
          w = $ = Rc($, H), xn !== 4 && (xn = 2), vu === null ? vu = [w] : vu.push(w), w = M;
          do {
            switch (w.tag) {
              case 3:
                w.flags |= 65536, c &= -c, w.lanes |= c;
                var te = Gx(w, $, c);
                Fm(w, te);
                break e;
              case 1:
                H = $;
                var q = w.type, ae = w.stateNode;
                if (!(w.flags & 128) && (typeof q.getDerivedStateFromError == "function" || ae !== null && typeof ae.componentDidCatch == "function" && (Co === null || !Co.has(ae)))) {
                  w.flags |= 65536, c &= -c, w.lanes |= c;
                  var Ne = Af(w, H, c);
                  Fm(w, Ne);
                  break e;
                }
            }
            w = w.return;
          } while (w !== null);
        }
        l0(g);
      } catch (st) {
        c = st, Xr === g && g !== null && (Xr = g = g.return);
        continue;
      }
      break;
    } while (!0);
  }
  function qv() {
    var u = Pf.current;
    return Pf.current = Fv, u === null ? Fv : u;
  }
  function s0() {
    (xn === 0 || xn === 3 || xn === 2) && (xn = 4), Gr === null || !(us & 268435455) && !($v & 268435455) || Na(Gr, Ln);
  }
  function Kv(u, c) {
    var g = zt;
    zt |= 2;
    var y = qv();
    (Gr !== u || Ln !== c) && (cs = null, _u(u, c));
    do
      try {
        w1();
        break;
      } catch (C) {
        tb(u, C);
      }
    while (!0);
    if (Im(), zt = g, Pf.current = y, Xr !== null)
      throw Error(r(261));
    return Gr = null, Ln = 0, xn;
  }
  function w1() {
    for (; Xr !== null; )
      rb(Xr);
  }
  function A1() {
    for (; Xr !== null && !Hs(); )
      rb(Xr);
  }
  function rb(u) {
    var c = ib(u.alternate, u, sa);
    u.memoizedProps = u.pendingProps, c === null ? l0(u) : Xr = c, r0.current = null;
  }
  function l0(u) {
    var c = u;
    do {
      var g = c.alternate;
      if (u = c.return, c.flags & 32768) {
        if (g = Qm(g, c), g !== null) {
          g.flags &= 32767, Xr = g;
          return;
        }
        if (u !== null)
          u.flags |= 32768, u.subtreeFlags = 0, u.deletions = null;
        else {
          xn = 6, Xr = null;
          return;
        }
      } else if (g = T1(g, c, sa), g !== null) {
        Xr = g;
        return;
      }
      if (c = c.sibling, c !== null) {
        Xr = c;
        return;
      }
      Xr = c = u;
    } while (c !== null);
    xn === 0 && (xn = 5);
  }
  function yu(u, c, g) {
    var y = dr, C = oi.transition;
    try {
      oi.transition = null, dr = 1, O1(u, c, g, y);
    } finally {
      oi.transition = C, dr = y;
    }
    return null;
  }
  function O1(u, c, g, y) {
    do
      Uc();
    while (sl !== null);
    if (zt & 6)
      throw Error(r(327));
    g = u.finishedWork;
    var C = u.finishedLanes;
    if (g === null)
      return null;
    if (u.finishedWork = null, u.finishedLanes = 0, g === u.current)
      throw Error(r(177));
    u.callbackNode = null, u.callbackPriority = 0;
    var w = g.lanes | g.childLanes;
    if (e1(u, w), u === Gr && (Xr = Gr = null, Ln = 0), !(g.subtreeFlags & 2064) && !(g.flags & 2064) || ol || (ol = !0, u0(Gs, function() {
      return Uc(), null;
    })), w = (g.flags & 15990) !== 0, g.subtreeFlags & 15990 || w) {
      w = oi.transition, oi.transition = null;
      var M = dr;
      dr = 1;
      var H = zt;
      zt |= 4, r0.current = null, Xx(u, g), Kx(g, u), iv(Ql), Wl = !!Cm, Ql = Cm = null, u.current = g, Zx(g, u, C), Gh(), zt = H, dr = M, oi.transition = w;
    } else
      u.current = g;
    if (ol && (ol = !1, sl = u, Wv = C), w = u.pendingLanes, w === 0 && (Co = null), Gy(g.stateNode, y), ui(u, Jt()), c !== null)
      for (y = u.onRecoverableError, g = 0; g < c.length; g++)
        C = c[g], y(C.value, { componentStack: C.stack, digest: C.digest });
    if (Yv)
      throw Yv = !1, u = pu, pu = null, u;
    return Wv & 1 && u.tag !== 0 && Uc(), w = u.pendingLanes, w & 1 ? u === Xv ? zc++ : (zc = 0, Xv = u) : zc = 0, Li(), null;
  }
  function Uc() {
    if (sl !== null) {
      var u = em(Wv), c = oi.transition, g = dr;
      try {
        if (oi.transition = null, dr = 16 > u ? 16 : u, sl === null)
          var y = !1;
        else {
          if (u = sl, sl = null, Wv = 0, zt & 6)
            throw Error(r(331));
          var C = zt;
          for (zt |= 4, et = u.current; et !== null; ) {
            var w = et, M = w.child;
            if (et.flags & 16) {
              var H = w.deletions;
              if (H !== null) {
                for (var $ = 0; $ < H.length; $++) {
                  var ue = H[$];
                  for (et = ue; et !== null; ) {
                    var Oe = et;
                    switch (Oe.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Mf(8, Oe, w);
                    }
                    var De = Oe.child;
                    if (De !== null)
                      De.return = Oe, et = De;
                    else
                      for (; et !== null; ) {
                        Oe = et;
                        var Ae = Oe.sibling, Xe = Oe.return;
                        if (e0(Oe), Oe === ue) {
                          et = null;
                          break;
                        }
                        if (Ae !== null) {
                          Ae.return = Xe, et = Ae;
                          break;
                        }
                        et = Xe;
                      }
                  }
                }
                var tt = w.alternate;
                if (tt !== null) {
                  var at = tt.child;
                  if (at !== null) {
                    tt.child = null;
                    do {
                      var en = at.sibling;
                      at.sibling = null, at = en;
                    } while (at !== null);
                  }
                }
                et = w;
              }
            }
            if (w.subtreeFlags & 2064 && M !== null)
              M.return = w, et = M;
            else
              e:
                for (; et !== null; ) {
                  if (w = et, w.flags & 2048)
                    switch (w.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Mf(9, w, w.return);
                    }
                  var te = w.sibling;
                  if (te !== null) {
                    te.return = w.return, et = te;
                    break e;
                  }
                  et = w.return;
                }
          }
          var q = u.current;
          for (et = q; et !== null; ) {
            M = et;
            var ae = M.child;
            if (M.subtreeFlags & 2064 && ae !== null)
              ae.return = M, et = ae;
            else
              e:
                for (M = q; et !== null; ) {
                  if (H = et, H.flags & 2048)
                    try {
                      switch (H.tag) {
                        case 0:
                        case 11:
                        case 15:
                          Lf(9, H);
                      }
                    } catch (st) {
                      qr(H, H.return, st);
                    }
                  if (H === M) {
                    et = null;
                    break e;
                  }
                  var Ne = H.sibling;
                  if (Ne !== null) {
                    Ne.return = H.return, et = Ne;
                    break e;
                  }
                  et = H.return;
                }
          }
          if (zt = C, Li(), Ja && typeof Ja.onPostCommitFiberRoot == "function")
            try {
              Ja.onPostCommitFiberRoot(qd, u);
            } catch {
            }
          y = !0;
        }
        return y;
      } finally {
        dr = g, oi.transition = c;
      }
    }
    return !1;
  }
  function nb(u, c, g) {
    c = Rc(g, c), c = Gx(u, c, 1), u = el(u, c, 1), c = si(), u !== null && (Yl(u, 1, c), ui(u, c));
  }
  function qr(u, c, g) {
    if (u.tag === 3)
      nb(u, u, g);
    else
      for (; c !== null; ) {
        if (c.tag === 3) {
          nb(c, u, g);
          break;
        } else if (c.tag === 1) {
          var y = c.stateNode;
          if (typeof c.type.getDerivedStateFromError == "function" || typeof y.componentDidCatch == "function" && (Co === null || !Co.has(y))) {
            u = Rc(g, u), u = Af(c, u, 1), c = el(c, u, 1), u = si(), c !== null && (Yl(c, 1, u), ui(c, u));
            break;
          }
        }
        c = c.return;
      }
  }
  function k1(u, c, g) {
    var y = u.pingCache;
    y !== null && y.delete(c), c = si(), u.pingedLanes |= u.suspendedLanes & g, Gr === u && (Ln & g) === g && (xn === 4 || xn === 3 && (Ln & 130023424) === Ln && 500 > Jt() - n0 ? _u(u, 0) : Fc |= g), ui(u, c);
  }
  function Zv(u, c) {
    c === 0 && (u.mode & 1 ? (c = dc, dc <<= 1, !(dc & 130023424) && (dc = 4194304)) : c = 1);
    var g = si();
    u = is(u, c), u !== null && (Yl(u, c, g), ui(u, g));
  }
  function R1(u) {
    var c = u.memoizedState, g = 0;
    c !== null && (g = c.retryLane), Zv(u, g);
  }
  function D1(u, c) {
    var g = 0;
    switch (u.tag) {
      case 13:
        var y = u.stateNode, C = u.memoizedState;
        C !== null && (g = C.retryLane);
        break;
      case 19:
        y = u.stateNode;
        break;
      default:
        throw Error(r(314));
    }
    y !== null && y.delete(c), Zv(u, g);
  }
  var ib;
  ib = function(u, c, g) {
    if (u !== null)
      if (u.memoizedProps !== c.pendingProps || Wr.current)
        sn = !0;
      else {
        if (!(u.lanes & g) && !(c.flags & 128))
          return sn = !1, ss(u, c, g);
        sn = !!(u.flags & 131072);
      }
    else
      sn = !1, Ar && c.flags & 1048576 && Rm(c, Cc, c.index);
    switch (c.lanes = 0, c.tag) {
      case 2:
        var y = c.type;
        ii(u, c), u = c.pendingProps;
        var C = Oa(c, St.current);
        Fe(c, g), C = nl(null, c, y, u, C, g);
        var w = su();
        return c.flags |= 1, typeof C == "object" && C !== null && typeof C.render == "function" && C.$$typeof === void 0 ? (c.tag = 1, c.memoizedState = null, c.updateQueue = null, Pr(y) ? (w = !0, cv(c)) : w = !1, c.memoizedState = C.state !== null && C.state !== void 0 ? C.state : null, Vm(c), C.updater = _v, c.stateNode = C, C._reactInternals = c, yv(c, y, u, g), c = jx(null, c, y, !0, w, g)) : (c.tag = 0, Ar && w && dv(c), mn(null, c, C, g), c = c.child), c;
      case 16:
        y = c.elementType;
        e: {
          switch (ii(u, c), u = c.pendingProps, C = y._init, y = C(y._payload), c.type = y, C = c.tag = L1(y), u = aa(y, u), C) {
            case 0:
              c = Dc(null, c, y, u, g);
              break e;
            case 1:
              c = Ym(null, c, y, u, g);
              break e;
            case 11:
              c = al(null, c, y, u, g);
              break e;
            case 14:
              c = zv(null, c, y, aa(y.type, u), g);
              break e;
          }
          throw Error(r(
            306,
            y,
            ""
          ));
        }
        return c;
      case 0:
        return y = c.type, C = c.pendingProps, C = c.elementType === y ? C : aa(y, C), Dc(u, c, y, C, g);
      case 1:
        return y = c.type, C = c.pendingProps, C = c.elementType === y ? C : aa(y, C), Ym(u, c, y, C, g);
      case 3:
        e: {
          if ($x(c), u === null)
            throw Error(r(387));
          y = c.pendingProps, w = c.memoizedState, C = w.element, gn(u, c), tl(c, y, null, g);
          var M = c.memoizedState;
          if (y = M.element, w.isDehydrated)
            if (w = { element: y, isDehydrated: !1, cache: M.cache, pendingSuspenseBoundaries: M.pendingSuspenseBoundaries, transitions: M.transitions }, c.updateQueue.baseState = w, c.memoizedState = w, c.flags & 256) {
              C = Rc(Error(r(423)), c), c = Hv(u, c, y, g, C);
              break e;
            } else if (y !== C) {
              C = Rc(Error(r(424)), c), c = Hv(u, c, y, g, C);
              break e;
            } else
              for (Ni = io(c.stateNode.containerInfo.firstChild), ia = c, Ar = !0, Da = null, g = zx(c, null, y, g), c.child = g; g; )
                g.flags = g.flags & -3 | 4096, g = g.sibling;
          else {
            if (zr(), y === C) {
              c = Hn(u, c, g);
              break e;
            }
            mn(u, c, y, g);
          }
          c = c.child;
        }
        return c;
      case 5:
        return pt(c), u === null && hv(c), y = c.type, C = c.pendingProps, w = u !== null ? u.memoizedProps : null, M = C.children, pf(y, C) ? M = null : w !== null && pf(y, w) && (c.flags |= 32), Rt(u, c), mn(u, c, M, g), c.child;
      case 6:
        return u === null && hv(c), null;
      case 13:
        return Xm(u, c, g);
      case 4:
        return zm(c, c.stateNode.containerInfo), y = c.pendingProps, u === null ? c.child = Tc(c, null, y, g) : mn(u, c, y, g), c.child;
      case 11:
        return y = c.type, C = c.pendingProps, C = c.elementType === y ? C : aa(y, C), al(u, c, y, C, g);
      case 7:
        return mn(u, c, c.pendingProps, g), c.child;
      case 8:
        return mn(u, c, c.pendingProps.children, g), c.child;
      case 12:
        return mn(u, c, c.pendingProps.children, g), c.child;
      case 10:
        e: {
          if (y = c.type._context, C = c.pendingProps, w = c.memoizedProps, M = C.value, ar(yo, y._currentValue), y._currentValue = M, w !== null)
            if (wa(w.value, M)) {
              if (w.children === C.children && !Wr.current) {
                c = Hn(u, c, g);
                break e;
              }
            } else
              for (w = c.child, w !== null && (w.return = c); w !== null; ) {
                var H = w.dependencies;
                if (H !== null) {
                  M = w.child;
                  for (var $ = H.firstContext; $ !== null; ) {
                    if ($.context === y) {
                      if (w.tag === 1) {
                        $ = as(-1, g & -g), $.tag = 2;
                        var ue = w.updateQueue;
                        if (ue !== null) {
                          ue = ue.shared;
                          var Oe = ue.pending;
                          Oe === null ? $.next = $ : ($.next = Oe.next, Oe.next = $), ue.pending = $;
                        }
                      }
                      w.lanes |= g, $ = w.alternate, $ !== null && ($.lanes |= g), pn(
                        w.return,
                        g,
                        c
                      ), H.lanes |= g;
                      break;
                    }
                    $ = $.next;
                  }
                } else if (w.tag === 10)
                  M = w.type === c.type ? null : w.child;
                else if (w.tag === 18) {
                  if (M = w.return, M === null)
                    throw Error(r(341));
                  M.lanes |= g, H = M.alternate, H !== null && (H.lanes |= g), pn(M, g, c), M = w.sibling;
                } else
                  M = w.child;
                if (M !== null)
                  M.return = w;
                else
                  for (M = w; M !== null; ) {
                    if (M === c) {
                      M = null;
                      break;
                    }
                    if (w = M.sibling, w !== null) {
                      w.return = M.return, M = w;
                      break;
                    }
                    M = M.return;
                  }
                w = M;
              }
          mn(u, c, C.children, g), c = c.child;
        }
        return c;
      case 9:
        return C = c.type, y = c.pendingProps.children, Fe(c, g), C = Jr(C), y = y(C), c.flags |= 1, mn(u, c, y, g), c.child;
      case 14:
        return y = c.type, C = aa(y, c.pendingProps), C = aa(y.type, C), zv(u, c, y, C, g);
      case 15:
        return Bi(u, c, c.type, c.pendingProps, g);
      case 17:
        return y = c.type, C = c.pendingProps, C = c.elementType === y ? C : aa(y, C), ii(u, c), c.tag = 1, Pr(y) ? (u = !0, cv(c)) : u = !1, Fe(c, g), Nx(c, y, C), yv(c, y, C, g), jx(null, c, y, !0, u, g);
      case 19:
        return Zm(u, c, g);
      case 22:
        return du(u, c, g);
    }
    throw Error(r(156, c.tag));
  };
  function u0(u, c) {
    return Lr(u, c);
  }
  function M1(u, c, g, y) {
    this.tag = u, this.key = g, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = c, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = y, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Va(u, c, g, y) {
    return new M1(u, c, g, y);
  }
  function c0(u) {
    return u = u.prototype, !(!u || !u.isReactComponent);
  }
  function L1(u) {
    if (typeof u == "function")
      return c0(u) ? 1 : 0;
    if (u != null) {
      if (u = u.$$typeof, u === Re)
        return 11;
      if (u === me)
        return 14;
    }
    return 2;
  }
  function ul(u, c) {
    var g = u.alternate;
    return g === null ? (g = Va(u.tag, c, u.key, u.mode), g.elementType = u.elementType, g.type = u.type, g.stateNode = u.stateNode, g.alternate = u, u.alternate = g) : (g.pendingProps = c, g.type = u.type, g.flags = 0, g.subtreeFlags = 0, g.deletions = null), g.flags = u.flags & 14680064, g.childLanes = u.childLanes, g.lanes = u.lanes, g.child = u.child, g.memoizedProps = u.memoizedProps, g.memoizedState = u.memoizedState, g.updateQueue = u.updateQueue, c = u.dependencies, g.dependencies = c === null ? null : { lanes: c.lanes, firstContext: c.firstContext }, g.sibling = u.sibling, g.index = u.index, g.ref = u.ref, g;
  }
  function Qv(u, c, g, y, C, w) {
    var M = 2;
    if (y = u, typeof u == "function")
      c0(u) && (M = 1);
    else if (typeof u == "string")
      M = 5;
    else
      e:
        switch (u) {
          case Z:
            return xu(g.children, C, w, c);
          case ee:
            M = 8, C |= 8;
            break;
          case J:
            return u = Va(12, g, c, C | 2), u.elementType = J, u.lanes = w, u;
          case Ce:
            return u = Va(13, g, c, C), u.elementType = Ce, u.lanes = w, u;
          case le:
            return u = Va(19, g, c, C), u.elementType = le, u.lanes = w, u;
          case Ee:
            return Vf(g, C, w, c);
          default:
            if (typeof u == "object" && u !== null)
              switch (u.$$typeof) {
                case he:
                  M = 10;
                  break e;
                case de:
                  M = 9;
                  break e;
                case Re:
                  M = 11;
                  break e;
                case me:
                  M = 14;
                  break e;
                case fe:
                  M = 16, y = null;
                  break e;
              }
            throw Error(r(130, u == null ? u : typeof u, ""));
        }
    return c = Va(M, g, c, C), c.elementType = u, c.type = y, c.lanes = w, c;
  }
  function xu(u, c, g, y) {
    return u = Va(7, u, y, c), u.lanes = g, u;
  }
  function Vf(u, c, g, y) {
    return u = Va(22, u, y, c), u.elementType = Ee, u.lanes = g, u.stateNode = { isHidden: !1 }, u;
  }
  function Ff(u, c, g) {
    return u = Va(6, u, null, c), u.lanes = g, u;
  }
  function bu(u, c, g) {
    return c = Va(4, u.children !== null ? u.children : [], u.key, c), c.lanes = g, c.stateNode = { containerInfo: u.containerInfo, pendingChildren: null, implementation: u.implementation }, c;
  }
  function P1(u, c, g, y, C) {
    this.tag = c, this.containerInfo = u, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Jg(0), this.expirationTimes = Jg(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Jg(0), this.identifierPrefix = y, this.onRecoverableError = C, this.mutableSourceEagerHydrationData = null;
  }
  function Jv(u, c, g, y, C, w, M, H, $) {
    return u = new P1(u, c, g, H, $), c === 1 ? (c = 1, w === !0 && (c |= 8)) : c = 0, w = Va(3, null, null, c), u.current = w, w.stateNode = u, w.memoizedState = { element: y, isDehydrated: g, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Vm(w), u;
  }
  function ab(u, c, g) {
    var y = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: j, key: y == null ? null : "" + y, children: u, containerInfo: c, implementation: g };
  }
  function d0(u) {
    if (!u)
      return _o;
    u = u._reactInternals;
    e: {
      if (It(u) !== u || u.tag !== 1)
        throw Error(r(170));
      var c = u;
      do {
        switch (c.tag) {
          case 3:
            c = c.stateNode.context;
            break e;
          case 1:
            if (Pr(c.type)) {
              c = c.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        c = c.return;
      } while (c !== null);
      throw Error(r(171));
    }
    if (u.tag === 1) {
      var g = u.type;
      if (Pr(g))
        return _f(u, g, c);
    }
    return c;
  }
  function ob(u, c, g, y, C, w, M, H, $) {
    return u = Jv(g, y, !0, u, C, w, M, H, $), u.context = d0(null), g = u.current, y = si(), C = ln(g), w = as(y, C), w.callback = c ?? null, el(g, w, C), u.current.lanes = C, Yl(u, C, y), ui(u, y), u;
  }
  function Bf(u, c, g, y) {
    var C = c.current, w = si(), M = ln(C);
    return g = d0(g), c.context === null ? c.context = g : c.pendingContext = g, c = as(w, M), c.payload = { element: u }, y = y === void 0 ? null : y, y !== null && (c.callback = y), u = el(C, c, M), u !== null && (li(u, C, M, w), mv(u, C, M)), M;
  }
  function ep(u) {
    if (u = u.current, !u.child)
      return null;
    switch (u.child.tag) {
      case 5:
        return u.child.stateNode;
      default:
        return u.child.stateNode;
    }
  }
  function sb(u, c) {
    if (u = u.memoizedState, u !== null && u.dehydrated !== null) {
      var g = u.retryLane;
      u.retryLane = g !== 0 && g < c ? g : c;
    }
  }
  function f0(u, c) {
    sb(u, c), (u = u.alternate) && sb(u, c);
  }
  function lb() {
    return null;
  }
  var h0 = typeof reportError == "function" ? reportError : function(u) {
    console.error(u);
  };
  function tp(u) {
    this._internalRoot = u;
  }
  ds.prototype.render = tp.prototype.render = function(u) {
    var c = this._internalRoot;
    if (c === null)
      throw Error(r(409));
    Bf(u, c, null, null);
  }, ds.prototype.unmount = tp.prototype.unmount = function() {
    var u = this._internalRoot;
    if (u !== null) {
      this._internalRoot = null;
      var c = u.containerInfo;
      ll(function() {
        Bf(null, u, null, null);
      }), c[ts] = null;
    }
  };
  function ds(u) {
    this._internalRoot = u;
  }
  ds.prototype.unstable_scheduleHydration = function(u) {
    if (u) {
      var c = Yy();
      u = { blockedOn: null, target: u, priority: c };
      for (var g = 0; g < hr.length && c !== 0 && c < hr[g].priority; g++)
        ;
      hr.splice(g, 0, u), g === 0 && Wy(u);
    }
  };
  function v0(u) {
    return !(!u || u.nodeType !== 1 && u.nodeType !== 9 && u.nodeType !== 11);
  }
  function rp(u) {
    return !(!u || u.nodeType !== 1 && u.nodeType !== 9 && u.nodeType !== 11 && (u.nodeType !== 8 || u.nodeValue !== " react-mount-point-unstable "));
  }
  function ub() {
  }
  function I1(u, c, g, y, C) {
    if (C) {
      if (typeof y == "function") {
        var w = y;
        y = function() {
          var ue = ep(M);
          w.call(ue);
        };
      }
      var M = ob(c, y, u, 0, null, !1, !1, "", ub);
      return u._reactRootContainer = M, u[ts] = M.current, bc(u.nodeType === 8 ? u.parentNode : u), ll(), M;
    }
    for (; C = u.lastChild; )
      u.removeChild(C);
    if (typeof y == "function") {
      var H = y;
      y = function() {
        var ue = ep($);
        H.call(ue);
      };
    }
    var $ = Jv(u, 0, !1, null, null, !1, !1, "", ub);
    return u._reactRootContainer = $, u[ts] = $.current, bc(u.nodeType === 8 ? u.parentNode : u), ll(function() {
      Bf(c, $, g, y);
    }), $;
  }
  function np(u, c, g, y, C) {
    var w = g._reactRootContainer;
    if (w) {
      var M = w;
      if (typeof C == "function") {
        var H = C;
        C = function() {
          var $ = ep(M);
          H.call($);
        };
      }
      Bf(c, M, u, C);
    } else
      M = I1(g, c, u, C, y);
    return ep(M);
  }
  $y = function(u) {
    switch (u.tag) {
      case 3:
        var c = u.stateNode;
        if (c.current.memoizedState.isDehydrated) {
          var g = $l(c.pendingLanes);
          g !== 0 && (Kd(c, g | 1), ui(c, Jt()), !(zt & 6) && (Bc = Jt() + 500, Li()));
        }
        break;
      case 13:
        ll(function() {
          var y = is(u, 1);
          if (y !== null) {
            var C = si();
            li(y, u, 1, C);
          }
        }), f0(u, 1);
    }
  }, Yh = function(u) {
    if (u.tag === 13) {
      var c = is(u, 134217728);
      if (c !== null) {
        var g = si();
        li(c, u, 134217728, g);
      }
      f0(u, 134217728);
    }
  }, yr = function(u) {
    if (u.tag === 13) {
      var c = ln(u), g = is(u, c);
      if (g !== null) {
        var y = si();
        li(g, u, c, y);
      }
      f0(u, c);
    }
  }, Yy = function() {
    return dr;
  }, tm = function(u, c) {
    var g = dr;
    try {
      return dr = u, c();
    } finally {
      dr = g;
    }
  }, Br = function(u, c, g) {
    switch (c) {
      case "input":
        if (Cr(u, g), c = g.name, g.type === "radio" && c != null) {
          for (g = u; g.parentNode; )
            g = g.parentNode;
          for (g = g.querySelectorAll("input[name=" + JSON.stringify("" + c) + '][type="radio"]'), c = 0; c < g.length; c++) {
            var y = g[c];
            if (y !== u && y.form === u.form) {
              var C = dt(y);
              if (!C)
                throw Error(r(90));
              xe(y), Cr(y, C);
            }
          }
        }
        break;
      case "textarea":
        fr(u, g);
        break;
      case "select":
        c = g.value, c != null && pi(u, !!g.multiple, c, !1);
    }
  }, Xd = Gc, Hh = ll;
  var N1 = { usingClientEntryPoint: !1, Events: [mf, Sc, dt, Gl, lc, Gc] }, jc = { findFiberByHostInstance: Aa, bundleType: 0, version: "18.2.0", rendererPackageName: "react-dom" }, V1 = { bundleType: jc.bundleType, version: jc.version, rendererPackageName: jc.rendererPackageName, rendererConfig: jc.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: V.ReactCurrentDispatcher, findHostInstanceByFiber: function(u) {
    return u = On(u), u === null ? null : u.stateNode;
  }, findFiberByHostInstance: jc.findFiberByHostInstance || lb, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.2.0-next-9e3b772b8-20220608" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var ip = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!ip.isDisabled && ip.supportsFiber)
      try {
        qd = ip.inject(V1), Ja = ip;
      } catch {
      }
  }
  return $a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = N1, $a.createPortal = function(u, c) {
    var g = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!v0(c))
      throw Error(r(200));
    return ab(u, c, null, g);
  }, $a.createRoot = function(u, c) {
    if (!v0(u))
      throw Error(r(299));
    var g = !1, y = "", C = h0;
    return c != null && (c.unstable_strictMode === !0 && (g = !0), c.identifierPrefix !== void 0 && (y = c.identifierPrefix), c.onRecoverableError !== void 0 && (C = c.onRecoverableError)), c = Jv(u, 1, !1, null, null, g, !1, y, C), u[ts] = c.current, bc(u.nodeType === 8 ? u.parentNode : u), new tp(c);
  }, $a.findDOMNode = function(u) {
    if (u == null)
      return null;
    if (u.nodeType === 1)
      return u;
    var c = u._reactInternals;
    if (c === void 0)
      throw typeof u.render == "function" ? Error(r(188)) : (u = Object.keys(u).join(","), Error(r(268, u)));
    return u = On(c), u = u === null ? null : u.stateNode, u;
  }, $a.flushSync = function(u) {
    return ll(u);
  }, $a.hydrate = function(u, c, g) {
    if (!rp(c))
      throw Error(r(200));
    return np(null, u, c, !0, g);
  }, $a.hydrateRoot = function(u, c, g) {
    if (!v0(u))
      throw Error(r(405));
    var y = g != null && g.hydratedSources || null, C = !1, w = "", M = h0;
    if (g != null && (g.unstable_strictMode === !0 && (C = !0), g.identifierPrefix !== void 0 && (w = g.identifierPrefix), g.onRecoverableError !== void 0 && (M = g.onRecoverableError)), c = ob(c, null, u, 1, g ?? null, C, !1, w, M), u[ts] = c.current, bc(u), y)
      for (u = 0; u < y.length; u++)
        g = y[u], C = g._getVersion, C = C(g._source), c.mutableSourceEagerHydrationData == null ? c.mutableSourceEagerHydrationData = [g, C] : c.mutableSourceEagerHydrationData.push(
          g,
          C
        );
    return new ds(c);
  }, $a.render = function(u, c, g) {
    if (!rp(c))
      throw Error(r(200));
    return np(null, u, c, !1, g);
  }, $a.unmountComponentAtNode = function(u) {
    if (!rp(u))
      throw Error(r(40));
    return u._reactRootContainer ? (ll(function() {
      np(null, null, u, !1, function() {
        u._reactRootContainer = null, u[ts] = null;
      });
    }), !0) : !1;
  }, $a.unstable_batchedUpdates = Gc, $a.unstable_renderSubtreeIntoContainer = function(u, c, g, y) {
    if (!rp(g))
      throw Error(r(200));
    if (u == null || u._reactInternals === void 0)
      throw Error(r(38));
    return np(u, c, g, !1, y);
  }, $a.version = "18.2.0-next-9e3b772b8-20220608", $a;
}
var Bve = lT.exports;
function Z5() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
    if (process.env.NODE_ENV !== "production")
      throw new Error("^_^");
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(Z5);
    } catch (e) {
      console.error(e);
    }
  }
}
process.env.NODE_ENV === "production" ? (Z5(), lT.exports = Gfe()) : lT.exports = Hfe();
var Q5 = lT.exports;
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Ufe = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i)
        Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), jfe = function(e, t) {
  var r = { label: 0, sent: function() {
    if (s[0] & 1)
      throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, l;
  return l = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function d(p) {
    return function(m) {
      return h([p, m]);
    };
  }
  function h(p) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, i && (s = p[0] & 2 ? i.return : p[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, p[1])).done)
          return s;
        switch (i = 0, s && (p = [p[0] & 2, s.value]), p[0]) {
          case 0:
          case 1:
            s = p;
            break;
          case 4:
            return r.label++, { value: p[1], done: !1 };
          case 5:
            r.label++, i = p[1], p = [0];
            continue;
          case 7:
            p = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (p[0] === 6 || p[0] === 2)) {
              r = 0;
              continue;
            }
            if (p[0] === 3 && (!s || p[1] > s[0] && p[1] < s[3])) {
              r.label = p[1];
              break;
            }
            if (p[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = p;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(p);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        p = t.call(e, r);
      } catch (m) {
        p = [6, m], i = 0;
      } finally {
        n = s = 0;
      }
    if (p[0] & 5)
      throw p[1];
    return { value: p[0] ? p[1] : void 0, done: !0 };
  }
}, lH = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, uH = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, s = [], l;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      s.push(i.value);
  } catch (d) {
    l = { error: d };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (l)
        throw l.error;
    }
  }
  return s;
}, J5 = SH({
  lock: function() {
  },
  unlock: function() {
  }
});
function wR() {
  return Math.random().toString(36).substring(2);
}
var $fe = (
  /** @class */
  function() {
    function e() {
      this._map = /* @__PURE__ */ new Map();
    }
    return e.prototype.set = function(t, r) {
      var n = t.key1, i = t.key2, s = this._map.get(n);
      s || (s = /* @__PURE__ */ new Map(), this._map.set(n, s)), s.set(i, r);
    }, e.prototype.get = function(t) {
      var r = t.key1, n = t.key2, i = this._map.get(r);
      return i ? i.get(n) : void 0;
    }, e.prototype.delete = function(t) {
      var r = t.key1, n = t.key2, i = this._map.get(r);
      i && (i.delete(n), i.size === 0 && this._map.delete(r));
    }, Object.defineProperty(e.prototype, "empty", {
      get: function() {
        return this._map.size === 0;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.shallowCopy = function() {
      var t = new e();
      return t._map = this._map, t;
    }, e.prototype[Symbol.iterator] = function() {
      var t, r, n, i, s, l, d, h, p, m, x, S, T, k, O, D;
      return jfe(this, function(L) {
        switch (L.label) {
          case 0:
            L.trys.push([0, 11, 12, 13]), t = lH(this._map), r = t.next(), L.label = 1;
          case 1:
            if (r.done)
              return [3, 10];
            n = uH(r.value, 2), i = n[0], s = n[1], L.label = 2;
          case 2:
            L.trys.push([2, 7, 8, 9]), l = (O = void 0, lH(s)), d = l.next(), L.label = 3;
          case 3:
            return d.done ? [3, 6] : (h = uH(d.value, 2), p = h[0], m = h[1], [4, [{ key1: i, key2: p }, m]]);
          case 4:
            L.sent(), L.label = 5;
          case 5:
            return d = l.next(), [3, 3];
          case 6:
            return [3, 9];
          case 7:
            return x = L.sent(), O = { error: x }, [3, 9];
          case 8:
            try {
              d && !d.done && (D = l.return) && D.call(l);
            } finally {
              if (O)
                throw O.error;
            }
            return [
              7
              /*endfinally*/
            ];
          case 9:
            return r = t.next(), [3, 1];
          case 10:
            return [3, 13];
          case 11:
            return S = L.sent(), T = { error: S }, [3, 13];
          case 12:
            try {
              r && !r.done && (k = t.return) && k.call(t);
            } finally {
              if (T)
                throw T.error;
            }
            return [
              7
              /*endfinally*/
            ];
          case 13:
            return [
              2
              /*return*/
            ];
        }
      });
    }, e;
  }()
), cH = (
  /** @class */
  function(e) {
    Ufe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }($fe)
);
function Yfe(e) {
  return e.length ? "" + e[0].toUpperCase() + e.substr(1) : "";
}
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Wfe = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, s = [], l;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      s.push(i.value);
  } catch (d) {
    l = { error: d };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (l)
        throw l.error;
    }
  }
  return s;
}, dH = function(e, t, r) {
  var n = { display: "none" };
  switch (e) {
    case "TABLE":
      return Vr.createElement("tbody", { style: n, ref: t });
    case "TBODY":
      return Vr.createElement("tr", { style: n, ref: t });
    default:
      return Vr.createElement(r, { style: n, ref: t });
  }
}, Xfe = function(e) {
  var t = e.templateFactory, r = e.data, n = e.index, i = e.container, s = e.onRemoved, l = e.onRendered, d = Wfe(RR(!1), 2), h = d[0], p = d[1], m = Ya(!1), x = Fd(function() {
    return {
      lock: function() {
        m.current = !0;
      },
      unlock: function() {
        m.current = !1;
      }
    };
  }, []), S = Ya(), T = Ya(), k = Ya(), O = ho(function(F, z) {
    z != null && z.isUnmounting || m.current || (S.current && hg(S.current, Al, O), k.current && hg(k.current, Al, O), s());
  }, [s]);
  bH(function() {
    var F = S.current;
    return F && F.nodeType === Node.ELEMENT_NODE ? (hg(F, Al, O), oM(F, Al, O)) : h ? k.current && (hg(k.current, Al, O), oM(k.current, Al, O)) : p(!0), function() {
      S.current && i.appendChild(S.current), T.current && i.appendChild(T.current), k.current && i.appendChild(k.current), F && hg(F, Al, O);
    };
  }, [O, h, i]), hM(function() {
    l();
  }, [l]);
  var D = dH(i == null ? void 0 : i.nodeName, function(F) {
    T.current = F, S.current = F == null ? void 0 : F.previousSibling;
  }, "div"), L = h ? dH(i == null ? void 0 : i.nodeName, function(F) {
    k.current = F;
  }, "span") : void 0;
  return Q5.createPortal(Vr.createElement(
    Vr.Fragment,
    null,
    Vr.createElement(
      J5.Provider,
      { value: x },
      t({ data: r, index: n, onRendered: l }),
      D,
      L
    )
  ), i);
}, qfe = o7(Xfe);
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Kfe = {
  useLegacyTemplateEngine: !1
};
function Zfe(e) {
  return Kfe[e];
}
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var uT = function() {
  return uT = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, uT.apply(this, arguments);
}, KC = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, s = [], l;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      s.push(i.value);
  } catch (d) {
    l = { error: d };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (l)
        throw l.error;
    }
  }
  return s;
};
function fH(e) {
  if (Zfe("useLegacyTemplateEngine")) {
    var t = e.data;
    return t && Object.prototype.hasOwnProperty.call(t, "key") && (t.dxkey = t.key), t;
  }
  return e;
}
var Qfe = function(e) {
  var t = e.init, r = KC(RR(new cH()), 2), n = r[0], i = r[1], s = KC(RR(), 2), l = s[0], d = s[1], h = Ya(""), p = Ya({}), m = ho(function(D, L) {
    D.nodeType === Node.ELEMENT_NODE && oM(D, Al, L);
  }, []), x = ho(function(D, L) {
    D.nodeType === Node.ELEMENT_NODE && hg(D, Al, L);
  }, []), S = ho(function(D) {
    return D.get ? D.get(0) : D;
  }, []), T = ho(function(D, L) {
    return { key1: D, key2: L };
  }, []), k = ho(function() {
    return "" + wR() + wR() + wR();
  }, []), O = ho(function(D) {
    return function(L) {
      var F = L.model, z = L.index, V = L.container, P = L.onRendered, j = S(V), Z = T(F, j), ee = function() {
        i(function(he) {
          var de = he.get(Z);
          return de ? (he.delete(Z), he.shallowCopy()) : he;
        });
      }, J = h.current;
      return i(function(he) {
        return he.set(Z, {
          templateKey: D,
          index: z,
          componentKey: k(),
          onRendered: function() {
            x(j, ee), J === h.current && (P == null || P());
          },
          onRemoved: ee
        }), he.shallowCopy();
      }), j;
    };
  }, [x, T]);
  return Fd(function() {
    function D(V) {
      switch (V.type) {
        case "children":
          return function() {
            return V.content;
          };
        case "render":
          return function(P) {
            return fH(P), V.content(P.data, P.index);
          };
        case "component":
          return function(P) {
            return P = fH(P), Vr.createElement.bind(null, V.content)(P);
          };
        default:
          return function() {
            return Vr.createElement(Vr.Fragment);
          };
      }
    }
    function L(V) {
      var P = Object.entries(V).reduce(function(Z, ee) {
        var J, he = KC(ee, 2), de = he[0], Re = he[1];
        return uT(uT({}, Z), (J = {}, J[de] = D(Re), J));
      }, {});
      p.current = P;
      var j = Object.keys(P).reduce(function(Z, ee) {
        return Z[ee] = { render: O(ee) }, Z;
      }, {});
      return j;
    }
    function F() {
      h.current = k(), i(new cH());
    }
    function z(V) {
      d({ onUpdated: V });
    }
    t({ createDXTemplates: L, clearInstantiationModels: F, updateTemplates: z });
  }, [t, O]), hM(function() {
    l && l.onUpdated();
  }, [l]), n.empty ? null : Vr.createElement(Vr.Fragment, null, Array.from(n).map(function(D) {
    var L = KC(D, 2), F = L[0], z = F.key1, V = F.key2, P = L[1], j = P.index, Z = P.templateKey, ee = P.componentKey, J = P.onRendered, he = P.onRemoved;
    m(V, he);
    var de = p.current[Z];
    return de ? Vr.createElement(qfe, { key: ee, templateFactory: de, data: z, index: j, container: V, onRemoved: he, onRendered: J }) : null;
  }));
};
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
function Wd() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.filter(function(r) {
    return r;
  }).join(".");
}
function Jfe(e) {
  var t = e.split("[");
  return t.length === 1 ? {
    isCollectionItem: !1,
    name: e
  } : {
    isCollectionItem: !0,
    name: t[0],
    index: Number(t[1].slice(0, -1))
  };
}
var ehe = function() {
  var e, t, r = (t = (e = window == null ? void 0 : window.navigator) === null || e === void 0 ? void 0 : e.userAgent) !== null && t !== void 0 ? t : "", n = r.indexOf("MSIE"), i = r.indexOf("Trident/");
  return n > 0 || i > 0;
}, the = function(e, t) {
  return Object.keys(e).length !== Object.keys(t).length ? !1 : Object.keys(e).every(function(r) {
    return e[r] === t[r];
  });
};
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
function sM(e, t, r) {
  e.templates.forEach(function(n) {
    if (n.isAnonymous) {
      var i = Wd(e.fullName, n.optionName);
      t[n.optionName] = i, r[i] = n;
    } else
      r[n.optionName] = n;
  });
}
function Ig(e, t, r) {
  var n = {};
  return Object.keys(e.predefinedOptions).forEach(function(i) {
    n[i] = e.predefinedOptions[i];
  }), Object.keys(e.configs).forEach(function(i) {
    n[i] = Ig(e.configs[i], t, r);
  }), Object.keys(e.configCollections).forEach(function(i) {
    n[i] = e.configCollections[i].map(function(s) {
      return Ig(s, t, r);
    });
  }), r || Object.keys(e.initialOptions).forEach(function(i) {
    n[i] = e.initialOptions[i];
  }), Object.keys(e.options).forEach(function(i) {
    n[i] = e.options[i];
  }), sM(e, n, t), n;
}
function lM(e, t) {
  var r = {}, n = Ig(e, r, t);
  return {
    templates: r,
    options: n
  };
}
var Vh;
(function(e) {
  e[e.Simple = 0] = "Simple", e[e.Complex = 1] = "Complex", e[e.Array = 2] = "Array";
})(Vh || (Vh = {}));
function e$(e, t) {
  var r = t.shift();
  if (!r)
    return {
      value: e,
      type: Vh.Simple
    };
  if (e instanceof Object && Object.keys(e).includes(r))
    return e$(e[r], t);
}
function iy(e, t) {
  var r = t.shift();
  if (!r)
    return {
      value: lM(e, !0).options,
      type: Vh.Complex
    };
  var n = Jfe(r);
  if (n.name in e.options) {
    var i = n.isCollectionItem ? e.options[n.name][n.index] : e.options[n.name];
    return e$(i, t);
  }
  if (n.isCollectionItem) {
    var s = e.configCollections[n.name];
    if (!s)
      return;
    var l = s[n.index];
    return l ? iy(l, t) : void 0;
  }
  var d = e.configs[n.name];
  if (d)
    return iy(d, t);
  var h = e.configCollections[n.name];
  if (h)
    return t.length !== 0 ? void 0 : {
      value: h.map(function(p) {
        return Ig(p, {}, !0);
      }),
      type: Vh.Array
    };
}
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
function rhe(e, t, r) {
  var n = {}, i = {}, s = {}, l = {};
  sM(e, n, i), sM(t, s, l), r.addRemovedValues(n, s, e.fullName), Object.keys(n).forEach(function(d) {
    n[d] !== s[d] && (r.options[Wd(e.fullName, d)] = n[d]);
  }), Object.keys(i).forEach(function(d) {
    var h = i[d], p = l[d];
    p && h.content === p.content || (r.templates[d] = h);
  });
}
function $L(e, t, r) {
  if (!t) {
    r.options[e.fullName] = Ig(e, r.templates, !0);
    return;
  }
  r.addRemovedValues(e.options, t.options, e.fullName), r.addRemovedValues(e.configCollections, t.configCollections, e.fullName), r.addRemovedValues(e.configs, t.configs, e.fullName), ahe(e, t, r), Object.keys(e.configs).forEach(function(n) {
    $L(e.configs[n], t.configs[n], r);
  }), Object.keys(e.options).forEach(function(n) {
    e.options[n] !== t.options[n] && (r.options[Wd(e.fullName, n)] = e.options[n]);
  }), rhe(e, t, r);
}
function nhe(e, t, r, n) {
  var i = Object.keys(t).filter(function(s) {
    return !Object.keys(e).includes(s);
  });
  i.forEach(function(s) {
    n.push(Wd(r, s));
  });
}
function ihe(e, t) {
  var r = {
    options: {},
    removedOptions: [],
    templates: {},
    addRemovedValues: function(n, i, s) {
      nhe(n, i, s, this.removedOptions);
    }
  };
  return $L(e, t, r), r;
}
function ahe(e, t, r) {
  Object.keys(e.configCollections).forEach(function(n) {
    var i = e.configCollections[n], s = t.configCollections[n] || [];
    if (!i || i.length !== s.length) {
      var l = [];
      i.forEach(function(h) {
        var p = Ig(h, r.templates, !0);
        l.push(p);
      }), r.options[Wd(e.fullName, n)] = l;
      return;
    }
    for (var d = 0; d < i.length; d += 1)
      $L(i[d], s[d], r);
  });
}
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var hH = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, s = [], l;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      s.push(i.value);
  } catch (d) {
    l = { error: d };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (l)
        throw l.error;
    }
  }
  return s;
}, ohe = function(e, t) {
  for (var r = 0, n = t.length, i = e.length; r < n; r++, i++)
    e[i] = t[r];
  return e;
}, uM = /* @__PURE__ */ new Set(), t$ = -1, r$ = -1;
function n$() {
  clearTimeout(t$), clearTimeout(r$);
}
function i$() {
  n$(), t$ = window.setTimeout(function() {
    r$ = window.setTimeout(function() {
      uM.forEach(function(e) {
        return e.execGuards();
      });
    });
  });
}
var she = (
  /** @class */
  function() {
    function e() {
      this.guards = {}, this.isUpdating = !1, uM.add(this), this.onOptionChanged = this.onOptionChanged.bind(this), this.wrapOptionValue = this.wrapOptionValue.bind(this);
    }
    return e.prototype.setInstance = function(t, r, n, i) {
      this.instance = t, this.currentConfig = r, this.subscribableOptions = new Set(n), this.independentEvents = new Set(i);
    }, e.prototype.getInitialOptions = function(t) {
      var r = this, n = lM(t, !1), i = {};
      return Object.keys(n.options).forEach(function(s) {
        i[s] = r.wrapOptionValue(s, n.options[s]);
      }), i;
    }, e.prototype.getTemplateOptions = function(t) {
      var r = lM(t, !1);
      return r.templates;
    }, e.prototype.update = function(t, r) {
      var n = this, i = [], s = function(d) {
        var h = d.value, p = d.fullName;
        i.push([p, h]);
      };
      this.instance.on("optionChanged", s);
      var l = ihe(t, this.currentConfig);
      !l.options && !l.templates && !l.removedOptions.length || (this.instance.beginUpdate(), this.isUpdating = !0, l.removedOptions.forEach(function(d) {
        n.resetOption(d);
      }), Object.keys(r).length > 0 && this.setValue("integrationOptions", {
        templates: r
      }), Object.keys(l.options).forEach(function(d) {
        n.setValue(d, l.options[d]);
      }), this.isUpdating = !1, this.instance.off("optionChanged", s), this.currentConfig = t, i.forEach(function(d) {
        var h = hH(d, 2), p = h[0], m = h[1], x = t.options[p];
        Object.prototype.hasOwnProperty.call(t.options, p) && x !== m && n.setValue(p, x);
      }), this.instance.endUpdate());
    }, e.prototype.onOptionChanged = function(t) {
      var r = this, n;
      if (!this.isUpdating) {
        var i = iy(this.currentConfig, t.fullName.split("."));
        if ((!i || i.value !== t.value) && this.callOptionChangeHandler(t.fullName, t.value), i = iy(this.currentConfig, t.fullName.split(".")), !!i) {
          var s = i.value, l = i.type;
          if (s instanceof Array && l === Vh.Array) {
            for (var d = 0; d < s.length; d += 1)
              if (s[d] !== ((n = t.value) === null || n === void 0 ? void 0 : n[d])) {
                this.addGuard(t.fullName, s);
                return;
              }
          } else if (l === Vh.Complex && s instanceof Object)
            Object.keys(s).forEach(function(m) {
              var x;
              s[m] !== ((x = t.value) === null || x === void 0 ? void 0 : x[m]) && r.addGuard(Wd(t.fullName, m), s[m]);
            });
          else {
            var h = s === t.value, p = !h && s instanceof Object && t.value instanceof Object && the(s, t.value);
            if (h || p || this.instance.skipOptionsRollBack)
              return;
            this.addGuard(t.fullName, s);
          }
        }
      }
    }, e.prototype.dispose = function() {
      var t = this;
      uM.delete(this), Object.keys(this.guards).forEach(function(r) {
        delete t.guards[r];
      });
    }, e.prototype.isOptionSubscribable = function(t) {
      return this.subscribableOptions.has(t);
    }, e.prototype.isIndependentEvent = function(t) {
      return this.independentEvents.has(t);
    }, e.prototype.callOptionChangeHandler = function(t, r) {
      if (this.isOptionSubscribable(t)) {
        var n = t.split("."), i = n[n.length - 1];
        if (!i.startsWith("on")) {
          var s = "on" + Yfe(i) + "Change";
          n[n.length - 1] = s;
          var l = iy(this.currentConfig, n);
          if (l) {
            if (typeof l.value != "function")
              throw new Error("Invalid value for the " + s + ` property.
                ` + s + " must be a function.");
            l.value(r);
          }
        }
      }
    }, e.prototype.wrapOptionValue = function(t, r) {
      var n = this;
      return t.substr(0, 2) === "on" && typeof r == "function" ? function() {
        for (var i = [], s = 0; s < arguments.length; s++)
          i[s] = arguments[s];
        (!n.isUpdating || n.isIndependentEvent(t)) && r.apply(void 0, ohe([], hH(i)));
      } : r;
    }, e.prototype.addGuard = function(t, r) {
      var n = this;
      if (this.guards[t] === void 0) {
        var i = function() {
          n.setValue(t, r), delete n.guards[t];
        };
        this.guards[t] = i, i$();
      }
    }, e.prototype.execGuards = function() {
      Object.values(this.guards).forEach(function(t) {
        return t();
      });
    }, e.prototype.resetOption = function(t) {
      this.instance.resetOption(t);
    }, e.prototype.setValue = function(t, r) {
      this.guards[t] && delete this.guards[t], this.instance.option(t, this.wrapOptionValue(t, r));
    }, e;
  }()
);
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var a$ = ["style", "id"], o$ = "className", lhe = ["dropZone", "dialogTrigger"];
function uhe(e) {
  return e === "children" || e === o$ || a$.includes(e);
}
function che(e, t, r) {
  r = r || [];
  var n = {}, i = {}, s = {}, l = {};
  return r.forEach(function(d) {
    l[d.component] = !0, l[d.render] = !0;
  }), Object.keys(e).forEach(function(d) {
    var h = t ? t[d] : null, p = e[d];
    if (!uhe(d)) {
      if (h) {
        n[h] = p;
        return;
      }
      if (l[d]) {
        s[d] = p;
        return;
      }
      if (lhe.includes(d)) {
        i[d] = p && p.current ? p.current : p;
        return;
      }
      i[d] = e[d];
    }
  }), { options: i, defaults: n, templates: s };
}
function vH(e) {
  return e[o$];
}
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var dhe = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i)
        Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), s$ = (
  /** @class */
  function(e) {
    dhe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      return null;
    }, t;
  }(Vr.PureComponent)
), AR = function(e) {
  return !e.component && !e.render && !e.children ? new Error("The Template component requires 'component' or 'render' property") : null;
};
s$.propTypes = {
  name: re.string.isRequired,
  component: AR,
  render: AR,
  children: AR
};
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Ml;
(function(e) {
  e[e.Option = 0] = "Option", e[e.Template = 1] = "Template", e[e.Unknown = 2] = "Unknown";
})(Ml || (Ml = {}));
function l$(e, t) {
  var r = e;
  if (!r || !r.type)
    return {
      type: Ml.Unknown
    };
  if (r.type === s$)
    return {
      type: Ml.Template,
      props: r.props
    };
  var n = r.type;
  if (n.OptionName) {
    var i = n.OptionName, s = n.IsCollectionItem, l = t && t[i];
    return l && (s = l.isCollectionItem, l.optionName && (i = l.optionName)), {
      type: Ml.Option,
      descriptor: {
        name: i,
        isCollection: s,
        templates: n.TemplateProps || [],
        initialValuesProps: n.DefaultsProps || {},
        predefinedValuesProps: n.PredefinedProps || {},
        expectedChildren: n.ExpectedChildren || {}
      },
      props: r.props
    };
  }
  return {
    type: Ml.Unknown
  };
}
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
function fhe(e, t, r) {
  return t.tmplOption === "template" && r ? {
    optionName: t.tmplOption,
    isAnonymous: !0,
    type: "children",
    content: e.children,
    keyFn: e[t.keyFn]
  } : e[t.render] ? {
    optionName: t.tmplOption,
    isAnonymous: !0,
    type: "render",
    content: e[t.render],
    keyFn: e[t.keyFn]
  } : e[t.component] ? {
    optionName: t.tmplOption,
    isAnonymous: !0,
    type: "component",
    content: e[t.component],
    keyFn: e[t.keyFn]
  } : null;
}
function hhe(e) {
  return e.name ? e.component ? {
    optionName: e.name,
    isAnonymous: !1,
    type: "component",
    content: e.component,
    keyFn: e.keyFn
  } : e.render ? {
    optionName: e.name,
    isAnonymous: !1,
    type: "render",
    content: e.render,
    keyFn: e.keyFn
  } : {
    optionName: e.name,
    isAnonymous: !1,
    type: "children",
    content: e.children,
    keyFn: e.keyFn
  } : null;
}
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var cM = function() {
  return cM = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, cM.apply(this, arguments);
};
function vhe(e, t) {
  var r = [], n = {}, i = {}, s = !1;
  return Vr.Children.map(e.props.children, function(l) {
    var d = l$(l, e.descriptor.expectedChildren);
    if (d.type === Ml.Unknown) {
      l != null && l !== !1 && (s = !0);
      return;
    }
    if (d.type === Ml.Template) {
      var h = hhe(d.props);
      h && r.push(h);
      return;
    }
    if (d.descriptor.isCollection) {
      var p = n[d.descriptor.name];
      p || (p = [], n[d.descriptor.name] = p);
      var m = dM(d, Wd(t, d.descriptor.name) + "[" + p.length + "]");
      p.push(m);
      return;
    }
    var x = dM(d, t);
    i[d.descriptor.name] = x;
  }), {
    configs: i,
    configCollections: n,
    templates: r,
    hasTranscludedContent: s
  };
}
function dM(e, t) {
  var r = e.descriptor.isCollection ? t : Wd(t, e.descriptor.name), n = che(e.props, e.descriptor.initialValuesProps, e.descriptor.templates), i = vhe(e, r);
  return e.descriptor.templates.forEach(function(s) {
    var l = fhe(e.props, s, t.length > 0 ? i.hasTranscludedContent : !1);
    l && i.templates.push(l);
  }), {
    fullName: r,
    predefinedOptions: e.descriptor.predefinedValuesProps,
    initialOptions: n.defaults,
    options: n.options,
    templates: i.templates,
    configCollections: i.configCollections,
    configs: i.configs
  };
}
function phe(e, t) {
  return dM({
    type: Ml.Option,
    descriptor: cM({ name: "", isCollection: !1 }, e),
    props: t
  }, "");
}
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var ghe = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i)
        Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ay = function() {
  return ay = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, ay.apply(this, arguments);
}, ZC = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, s = [], l;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      s.push(i.value);
  } catch (d) {
    l = { error: d };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (l)
        throw l.error;
    }
  }
  return s;
}, OR = function(e, t) {
  for (var r = 0, n = t.length, i = e.length; r < n; r++, i++)
    e[i] = t[r];
  return e;
}, Al = "dxremove", u$ = (
  /** @class */
  function(e) {
    ghe(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n.isPortalComponent = !1, n._templateProps = [], n._childNodes = [], n.useRequestAnimationFrameFlag = !1, n.useDeferUpdateForTemplates = !1, n.guardsUpdateScheduled = !1, n._createWidget = n._createWidget.bind(n), n._setTemplateManagerHooks = n._setTemplateManagerHooks.bind(n), n._optionsManager = new she(), n;
    }
    return t.displayContentsStyle = function() {
      return ehe() ? {
        width: "100%",
        height: "100%",
        padding: 0,
        margin: 0
      } : { display: "contents" };
    }, t.prototype.componentDidMount = function() {
      var r, n, i = this.props.style;
      !((n = this._childNodes) === null || n === void 0) && n.length ? (r = this._element).append.apply(r, OR([], ZC(this._childNodes))) : this._element.childNodes.length && (this._childNodes = Array.from(this._element.childNodes)), this._updateCssClasses(null, this.props), i && this._setInlineStyles(i);
    }, t.prototype.componentDidUpdate = function(r) {
      var n;
      this._updateCssClasses(r, this.props);
      var i = this._getConfig(), s = this._optionsManager.getTemplateOptions(i), l = ((n = this._createDXTemplates) === null || n === void 0 ? void 0 : n.call(this, s)) || {};
      this._optionsManager.update(i, l), this._scheduleTemplatesUpdate();
    }, t.prototype.componentWillUnmount = function() {
      var r;
      if (this._lockParentOnRemoved(), this._instance) {
        var n = { isUnmounting: !0 };
        (r = this._childNodes) === null || r === void 0 || r.forEach(function(i) {
          var s;
          return (s = i.parentNode) === null || s === void 0 ? void 0 : s.removeChild(i);
        }), Ffe(this._element, Al, n), this._instance.dispose();
      }
      this._optionsManager.dispose(), this._unlockParentOnRemoved();
    }, t.prototype._createWidget = function(r) {
      var n, i;
      r = r || this._element;
      var s = this._getConfig(), l = ay({ templatesRenderAsynchronously: !0 }, this._optionsManager.getInitialOptions(s)), d = this._optionsManager.getTemplateOptions(s), h = (n = this._createDXTemplates) === null || n === void 0 ? void 0 : n.call(this, d);
      h && Object.keys(h).length && (l = ay(ay({}, l), { integrationOptions: {
        templates: h
      } })), (i = this._clearInstantiationModels) === null || i === void 0 || i.call(this), this._instance = new this._WidgetClass(r, l), this.useRequestAnimationFrameFlag || (this.useDeferUpdateForTemplates = this._instance.option("integrationOptions.useDeferUpdateForTemplates")), this._optionsManager.setInstance(this._instance, s, this.subscribableOptions, this.independentEvents), this._instance.on("optionChanged", this._optionsManager.onOptionChanged);
    }, t.prototype._scheduleTemplatesUpdate = function() {
      var r = this;
      if (!this.guardsUpdateScheduled) {
        this.guardsUpdateScheduled = !0;
        var n = this.useDeferUpdateForTemplates ? ZH : w3;
        n(function() {
          var i;
          r.guardsUpdateScheduled = !1, (i = r._updateTemplates) === null || i === void 0 || i.call(r, function() {
            return i$();
          });
        }), n$();
      }
    }, t.prototype._getConfig = function() {
      return phe({
        templates: this._templateProps,
        initialValuesProps: this._defaults,
        predefinedValuesProps: {},
        expectedChildren: this._expectedChildren
      }, this.props);
    }, t.prototype._getElementProps = function() {
      var r = this, n = {
        ref: function(i) {
          r._element = i;
        }
      };
      return a$.forEach(function(i) {
        var s = r.props;
        i in s && (n[i] = s[i]);
      }), n;
    }, t.prototype._setInlineStyles = function(r) {
      var n = this;
      Object.entries(r).forEach(function(i) {
        var s = ZC(i, 2), l = s[0], d = s[1];
        n._element.style[l] = d;
      });
    }, t.prototype._updateCssClasses = function(r, n) {
      var i, s, l = r ? vH(r) : void 0, d = vH(n);
      if (l !== d) {
        if (l) {
          var h = l.split(" ").filter(function(p) {
            return p;
          });
          h.length && (i = this._element.classList).remove.apply(i, OR([], ZC(h)));
        }
        if (d) {
          var h = d.split(" ").filter(function(m) {
            return m;
          });
          h.length && (s = this._element.classList).add.apply(s, OR([], ZC(h)));
        }
      }
    }, t.prototype._lockParentOnRemoved = function() {
      var r;
      (r = this.context) === null || r === void 0 || r.lock();
    }, t.prototype._unlockParentOnRemoved = function() {
      var r;
      (r = this.context) === null || r === void 0 || r.unlock();
    }, t.prototype._setTemplateManagerHooks = function(r) {
      var n = r.createDXTemplates, i = r.clearInstantiationModels, s = r.updateTemplates;
      this._createDXTemplates = n, this._clearInstantiationModels = i, this._updateTemplates = s;
    }, t.prototype.renderChildren = function() {
      var r = this.props.children;
      return r;
    }, t.prototype.renderContent = function() {
      var r = this, n = this.props.children;
      return this.isPortalComponent && n ? Vr.createElement("div", {
        ref: function(i) {
          i && r.portalContainer !== i && (r.portalContainer = i, r.forceUpdate());
        },
        style: t.displayContentsStyle()
      }) : this.renderChildren();
    }, t.prototype.renderPortal = function() {
      return this.portalContainer && Q5.createPortal(this.renderChildren(), this.portalContainer);
    }, t.prototype.render = function() {
      return Vr.createElement(Vr.Fragment, {}, Vr.createElement("div", this._getElementProps(), this.renderContent(), Vr.createElement(Qfe, {
        init: this._setTemplateManagerHooks
      })), this.isPortalComponent && this.renderPortal());
    }, t.contextType = J5, t;
  }(Vr.PureComponent)
);
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var mhe = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i)
        Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), _he = (
  /** @class */
  function(e) {
    mhe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.componentDidMount = function() {
      var r = this.props.onMounted;
      r ? r(this._createWidget) : this._createWidget();
    }, t;
  }(u$)
);
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var yhe = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i)
        Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), c$ = (
  /** @class */
  function(e) {
    yhe(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return n._extensionCreators = [], n._registerExtension = n._registerExtension.bind(n), n;
    }
    return t.prototype.componentDidMount = function() {
      e.prototype.componentDidMount.call(this), this._createWidget(), this._createExtensions();
    }, t.prototype.componentWillUnmount = function() {
      e.prototype.componentWillUnmount.call(this), this.clearExtensions();
    }, t.prototype.clearExtensions = function() {
      this._extensionCreators = [];
    }, t.prototype.renderChildren = function() {
      var r = this;
      return Vr.Children.map(
        // @ts-expect-error TS2339
        this.props.children,
        function(n) {
          return n && Object.prototype.isPrototypeOf.call(_he, n.type) ? Vr.cloneElement(n, { onMounted: r._registerExtension }) : n;
        }
      );
    }, t.prototype._registerExtension = function(r) {
      this._extensionCreators.push(r);
    }, t.prototype._createExtensions = function() {
      var r = this;
      this._extensionCreators.forEach(function(n) {
        return n(r._element);
      });
    }, t;
  }(u$)
);
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var xhe = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i)
        Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), _e = (
  /** @class */
  function(e) {
    xhe(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.render = function() {
      var r = this.props.children, n = Vr.Children.map(r, function(i) {
        var s = l$(i);
        return s.type === Ml.Option ? i : null;
      });
      return Vr.createElement(Vr.Fragment, {}, n);
    }, t;
  }(Vr.PureComponent)
);
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Le = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i)
        Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), d$ = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._WidgetClass = Xg, r.useRequestAnimationFrameFlag = !0, r.subscribableOptions = ["argumentAxis", "argumentAxis.categories", "argumentAxis.visualRange", "loadingIndicator", "loadingIndicator.show", "valueAxis", "valueAxis.categories", "valueAxis.visualRange"], r.independentEvents = ["onArgumentAxisClick", "onDisposing", "onDone", "onDrawn", "onExported", "onExporting", "onFileSaving", "onIncidentOccurred", "onInitialized", "onLegendClick", "onPointClick", "onSeriesClick", "onTooltipHidden", "onTooltipShown", "onZoomEnd", "onZoomStart"], r._defaults = {
        defaultArgumentAxis: "argumentAxis",
        defaultLoadingIndicator: "loadingIndicator",
        defaultValueAxis: "valueAxis"
      }, r._expectedChildren = {
        adaptiveLayout: { optionName: "adaptiveLayout", isCollectionItem: !1 },
        animation: { optionName: "animation", isCollectionItem: !1 },
        annotation: { optionName: "annotations", isCollectionItem: !0 },
        argumentAxis: { optionName: "argumentAxis", isCollectionItem: !1 },
        chartTitle: { optionName: "title", isCollectionItem: !1 },
        commonAnnotationSettings: { optionName: "commonAnnotationSettings", isCollectionItem: !1 },
        commonAxisSettings: { optionName: "commonAxisSettings", isCollectionItem: !1 },
        commonPaneSettings: { optionName: "commonPaneSettings", isCollectionItem: !1 },
        commonSeriesSettings: { optionName: "commonSeriesSettings", isCollectionItem: !1 },
        crosshair: { optionName: "crosshair", isCollectionItem: !1 },
        dataPrepareSettings: { optionName: "dataPrepareSettings", isCollectionItem: !1 },
        export: { optionName: "export", isCollectionItem: !1 },
        legend: { optionName: "legend", isCollectionItem: !1 },
        loadingIndicator: { optionName: "loadingIndicator", isCollectionItem: !1 },
        margin: { optionName: "margin", isCollectionItem: !1 },
        pane: { optionName: "panes", isCollectionItem: !0 },
        scrollBar: { optionName: "scrollBar", isCollectionItem: !1 },
        series: { optionName: "series", isCollectionItem: !0 },
        seriesTemplate: { optionName: "seriesTemplate", isCollectionItem: !1 },
        size: { optionName: "size", isCollectionItem: !1 },
        title: { optionName: "title", isCollectionItem: !1 },
        tooltip: { optionName: "tooltip", isCollectionItem: !1 },
        valueAxis: { optionName: "valueAxis", isCollectionItem: !0 },
        zoomAndPan: { optionName: "zoomAndPan", isCollectionItem: !1 }
      }, r;
    }
    return Object.defineProperty(t.prototype, "instance", {
      get: function() {
        return this._instance;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(c$)
);
d$.propTypes = {
  adaptiveLayout: re.object,
  adjustOnZoom: re.bool,
  animation: re.oneOfType([
    re.bool,
    re.object
  ]),
  annotations: re.array,
  argumentAxis: re.object,
  autoHidePointMarkers: re.bool,
  barGroupPadding: re.number,
  barGroupWidth: re.number,
  commonAnnotationSettings: re.object,
  commonAxisSettings: re.object,
  commonPaneSettings: re.object,
  commonSeriesSettings: re.object,
  containerBackgroundColor: re.string,
  crosshair: re.object,
  customizeAnnotation: re.func,
  customizeLabel: re.func,
  customizePoint: re.func,
  dataPrepareSettings: re.object,
  defaultPane: re.string,
  disabled: re.bool,
  elementAttr: re.object,
  export: re.object,
  legend: re.object,
  loadingIndicator: re.object,
  margin: re.object,
  maxBubbleSize: re.number,
  minBubbleSize: re.number,
  negativesAsZeroes: re.bool,
  onArgumentAxisClick: re.func,
  onDisposing: re.func,
  onDone: re.func,
  onDrawn: re.func,
  onExported: re.func,
  onExporting: re.func,
  onFileSaving: re.func,
  onIncidentOccurred: re.func,
  onInitialized: re.func,
  onLegendClick: re.func,
  onOptionChanged: re.func,
  onPointClick: re.func,
  onPointHoverChanged: re.func,
  onPointSelectionChanged: re.func,
  onSeriesClick: re.func,
  onSeriesHoverChanged: re.func,
  onSeriesSelectionChanged: re.func,
  onTooltipHidden: re.func,
  onTooltipShown: re.func,
  onZoomEnd: re.func,
  onZoomStart: re.func,
  palette: re.oneOfType([
    re.array,
    re.oneOfType([
      re.string,
      re.oneOf([
        "Bright",
        "Harmony Light",
        "Ocean",
        "Pastel",
        "Soft",
        "Soft Pastel",
        "Vintage",
        "Violet",
        "Carmine",
        "Dark Moon",
        "Dark Violet",
        "Green Mist",
        "Soft Blue",
        "Material",
        "Office"
      ])
    ])
  ]),
  paletteExtensionMode: re.oneOfType([
    re.string,
    re.oneOf([
      "alternate",
      "blend",
      "extrapolate"
    ])
  ]),
  panes: re.oneOfType([
    re.array,
    re.object
  ]),
  pathModified: re.bool,
  pointSelectionMode: re.oneOfType([
    re.string,
    re.oneOf([
      "single",
      "multiple"
    ])
  ]),
  redrawOnResize: re.bool,
  resizePanesOnZoom: re.bool,
  resolveLabelOverlapping: re.oneOfType([
    re.string,
    re.oneOf([
      "hide",
      "none",
      "stack"
    ])
  ]),
  rotated: re.bool,
  rtlEnabled: re.bool,
  scrollBar: re.object,
  series: re.oneOfType([
    re.array,
    re.object
  ]),
  seriesSelectionMode: re.oneOfType([
    re.string,
    re.oneOf([
      "single",
      "multiple"
    ])
  ]),
  seriesTemplate: re.object,
  size: re.object,
  stickyHovering: re.bool,
  synchronizeMultiAxes: re.bool,
  theme: re.oneOfType([
    re.string,
    re.oneOf([
      "generic.dark",
      "generic.light",
      "generic.contrast",
      "generic.carmine",
      "generic.darkmoon",
      "generic.darkviolet",
      "generic.greenmist",
      "generic.softblue",
      "material.blue.light",
      "material.lime.light",
      "material.orange.light",
      "material.purple.light",
      "material.teal.light"
    ])
  ]),
  title: re.oneOfType([
    re.object,
    re.string
  ]),
  tooltip: re.object,
  valueAxis: re.oneOfType([
    re.array,
    re.object
  ]),
  zoomAndPan: re.object
};
var zve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "adaptiveLayout", t;
  }(_e)
), Hve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "aggregation", t;
  }(_e)
), Gve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "aggregationInterval", t;
  }(_e)
), Uve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "animation", t;
  }(_e)
), jve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "annotations", t.IsCollectionItem = !0, t.ExpectedChildren = {
      annotationBorder: { optionName: "border", isCollectionItem: !1 },
      annotationImage: { optionName: "image", isCollectionItem: !1 },
      border: { optionName: "border", isCollectionItem: !1 },
      font: { optionName: "font", isCollectionItem: !1 },
      image: { optionName: "image", isCollectionItem: !1 },
      shadow: { optionName: "shadow", isCollectionItem: !1 }
    }, t.TemplateProps = [{
      tmplOption: "template",
      render: "render",
      component: "component",
      keyFn: "keyFn"
    }, {
      tmplOption: "tooltipTemplate",
      render: "tooltipRender",
      component: "tooltipComponent",
      keyFn: "tooltipKeyFn"
    }], t;
  }(_e)
), $ve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "border", t;
  }(_e)
), Yve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "image", t;
  }(_e)
), bhe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "argumentAxis", t.DefaultsProps = {
      defaultCategories: "categories",
      defaultVisualRange: "visualRange"
    }, t.ExpectedChildren = {
      aggregationInterval: { optionName: "aggregationInterval", isCollectionItem: !1 },
      axisConstantLineStyle: { optionName: "constantLineStyle", isCollectionItem: !1 },
      axisLabel: { optionName: "label", isCollectionItem: !1 },
      axisTitle: { optionName: "title", isCollectionItem: !1 },
      break: { optionName: "breaks", isCollectionItem: !0 },
      breakStyle: { optionName: "breakStyle", isCollectionItem: !1 },
      constantLine: { optionName: "constantLines", isCollectionItem: !0 },
      constantLineStyle: { optionName: "constantLineStyle", isCollectionItem: !1 },
      grid: { optionName: "grid", isCollectionItem: !1 },
      label: { optionName: "label", isCollectionItem: !1 },
      minorGrid: { optionName: "minorGrid", isCollectionItem: !1 },
      minorTick: { optionName: "minorTick", isCollectionItem: !1 },
      minorTickInterval: { optionName: "minorTickInterval", isCollectionItem: !1 },
      minVisualRangeLength: { optionName: "minVisualRangeLength", isCollectionItem: !1 },
      strip: { optionName: "strips", isCollectionItem: !0 },
      stripStyle: { optionName: "stripStyle", isCollectionItem: !1 },
      tick: { optionName: "tick", isCollectionItem: !1 },
      tickInterval: { optionName: "tickInterval", isCollectionItem: !1 },
      title: { optionName: "title", isCollectionItem: !1 },
      visualRange: { optionName: "visualRange", isCollectionItem: !1 },
      wholeRange: { optionName: "wholeRange", isCollectionItem: !1 }
    }, t;
  }(_e)
), Wve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "argumentFormat", t;
  }(_e)
), Xve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "constantLineStyle", t;
  }(_e)
), qve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "label", t;
  }(_e)
), Kve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "label", t.TemplateProps = [{
      tmplOption: "template",
      render: "render",
      component: "component",
      keyFn: "keyFn"
    }], t;
  }(_e)
), Zve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "title", t;
  }(_e)
), Qve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "backgroundColor", t;
  }(_e)
), Jve = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "border", t;
  }(_e)
), epe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "breaks", t.IsCollectionItem = !0, t;
  }(_e)
), tpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "breakStyle", t;
  }(_e)
), rpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "title", t.ExpectedChildren = {
      chartTitleSubtitle: { optionName: "subtitle", isCollectionItem: !1 },
      font: { optionName: "font", isCollectionItem: !1 },
      margin: { optionName: "margin", isCollectionItem: !1 },
      subtitle: { optionName: "subtitle", isCollectionItem: !1 }
    }, t;
  }(_e)
), npe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "subtitle", t.ExpectedChildren = {
      font: { optionName: "font", isCollectionItem: !1 }
    }, t;
  }(_e)
), ipe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "color", t;
  }(_e)
), ape = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "commonAnnotationSettings", t.TemplateProps = [{
      tmplOption: "template",
      render: "render",
      component: "component",
      keyFn: "keyFn"
    }, {
      tmplOption: "tooltipTemplate",
      render: "tooltipRender",
      component: "tooltipComponent",
      keyFn: "tooltipKeyFn"
    }], t;
  }(_e)
), ope = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "commonAxisSettings", t.ExpectedChildren = {
      commonAxisSettingsConstantLineStyle: { optionName: "constantLineStyle", isCollectionItem: !1 },
      commonAxisSettingsLabel: { optionName: "label", isCollectionItem: !1 },
      commonAxisSettingsTitle: { optionName: "title", isCollectionItem: !1 },
      constantLineStyle: { optionName: "constantLineStyle", isCollectionItem: !1 },
      label: { optionName: "label", isCollectionItem: !1 },
      title: { optionName: "title", isCollectionItem: !1 }
    }, t;
  }(_e)
), spe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "constantLineStyle", t.ExpectedChildren = {
      commonAxisSettingsConstantLineStyleLabel: { optionName: "label", isCollectionItem: !1 },
      label: { optionName: "label", isCollectionItem: !1 }
    }, t;
  }(_e)
), lpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "label", t;
  }(_e)
), upe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "label", t.TemplateProps = [{
      tmplOption: "template",
      render: "render",
      component: "component",
      keyFn: "keyFn"
    }], t;
  }(_e)
), cpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "title", t;
  }(_e)
), dpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "commonPaneSettings", t.ExpectedChildren = {
      backgroundColor: { optionName: "backgroundColor", isCollectionItem: !1 },
      border: { optionName: "border", isCollectionItem: !1 },
      paneBorder: { optionName: "border", isCollectionItem: !1 }
    }, t;
  }(_e)
), She = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "commonSeriesSettings", t.ExpectedChildren = {
      aggregation: { optionName: "aggregation", isCollectionItem: !1 },
      border: { optionName: "border", isCollectionItem: !1 },
      color: { optionName: "color", isCollectionItem: !1 },
      commonSeriesSettingsHoverStyle: { optionName: "hoverStyle", isCollectionItem: !1 },
      commonSeriesSettingsLabel: { optionName: "label", isCollectionItem: !1 },
      commonSeriesSettingsSelectionStyle: { optionName: "selectionStyle", isCollectionItem: !1 },
      hoverStyle: { optionName: "hoverStyle", isCollectionItem: !1 },
      label: { optionName: "label", isCollectionItem: !1 },
      point: { optionName: "point", isCollectionItem: !1 },
      reduction: { optionName: "reduction", isCollectionItem: !1 },
      selectionStyle: { optionName: "selectionStyle", isCollectionItem: !1 },
      seriesBorder: { optionName: "border", isCollectionItem: !1 },
      valueErrorBar: { optionName: "valueErrorBar", isCollectionItem: !1 }
    }, t;
  }(_e)
), fpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "hoverStyle", t.ExpectedChildren = {
      border: { optionName: "border", isCollectionItem: !1 },
      color: { optionName: "color", isCollectionItem: !1 },
      hatching: { optionName: "hatching", isCollectionItem: !1 },
      seriesBorder: { optionName: "border", isCollectionItem: !1 }
    }, t;
  }(_e)
), hpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "label", t.ExpectedChildren = {
      argumentFormat: { optionName: "argumentFormat", isCollectionItem: !1 },
      border: { optionName: "border", isCollectionItem: !1 },
      connector: { optionName: "connector", isCollectionItem: !1 },
      font: { optionName: "font", isCollectionItem: !1 },
      format: { optionName: "format", isCollectionItem: !1 },
      seriesBorder: { optionName: "border", isCollectionItem: !1 }
    }, t;
  }(_e)
), vpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "selectionStyle", t.ExpectedChildren = {
      border: { optionName: "border", isCollectionItem: !1 },
      color: { optionName: "color", isCollectionItem: !1 },
      hatching: { optionName: "hatching", isCollectionItem: !1 },
      seriesBorder: { optionName: "border", isCollectionItem: !1 }
    }, t;
  }(_e)
), ppe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "connector", t;
  }(_e)
), pH = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "constantLines", t.IsCollectionItem = !0, t;
  }(_e)
), gpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "label", t;
  }(_e)
), mpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "constantLineStyle", t;
  }(_e)
), Che = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "crosshair", t.ExpectedChildren = {
      horizontalLine: { optionName: "horizontalLine", isCollectionItem: !1 },
      horizontalLineLabel: { optionName: "label", isCollectionItem: !1 },
      label: { optionName: "label", isCollectionItem: !1 },
      verticalLine: { optionName: "verticalLine", isCollectionItem: !1 }
    }, t;
  }(_e)
), _pe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "dataPrepareSettings", t;
  }(_e)
), ype = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "dragBoxStyle", t;
  }(_e)
), Ehe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "export", t;
  }(_e)
), The = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "font", t;
  }(_e)
), xpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "format", t;
  }(_e)
), whe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "grid", t;
  }(_e)
), bpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "hatching", t;
  }(_e)
), Spe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "height", t;
  }(_e)
), Cpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "horizontalLine", t.ExpectedChildren = {
      horizontalLineLabel: { optionName: "label", isCollectionItem: !1 },
      label: { optionName: "label", isCollectionItem: !1 }
    }, t;
  }(_e)
), Epe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "label", t;
  }(_e)
), Tpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "hoverStyle", t;
  }(_e)
), wpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "image", t;
  }(_e)
), QC = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "label", t.TemplateProps = [{
      tmplOption: "template",
      render: "render",
      component: "component",
      keyFn: "keyFn"
    }], t;
  }(_e)
), Ahe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "legend", t.ExpectedChildren = {
      annotationBorder: { optionName: "border", isCollectionItem: !1 },
      border: { optionName: "border", isCollectionItem: !1 },
      font: { optionName: "font", isCollectionItem: !1 },
      legendTitle: { optionName: "title", isCollectionItem: !1 },
      margin: { optionName: "margin", isCollectionItem: !1 },
      title: { optionName: "title", isCollectionItem: !1 }
    }, t.TemplateProps = [{
      tmplOption: "markerTemplate",
      render: "markerRender",
      component: "markerComponent",
      keyFn: "markerKeyFn"
    }], t;
  }(_e)
), Ape = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "title", t.ExpectedChildren = {
      font: { optionName: "font", isCollectionItem: !1 },
      legendTitleSubtitle: { optionName: "subtitle", isCollectionItem: !1 },
      margin: { optionName: "margin", isCollectionItem: !1 },
      subtitle: { optionName: "subtitle", isCollectionItem: !1 }
    }, t;
  }(_e)
), Ope = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "subtitle", t.ExpectedChildren = {
      font: { optionName: "font", isCollectionItem: !1 }
    }, t;
  }(_e)
), kpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "length", t;
  }(_e)
), Rpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "loadingIndicator", t.DefaultsProps = {
      defaultShow: "show"
    }, t.ExpectedChildren = {
      font: { optionName: "font", isCollectionItem: !1 }
    }, t;
  }(_e)
), Dpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "margin", t;
  }(_e)
), Mpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "minorGrid", t;
  }(_e)
), Lpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "minorTick", t;
  }(_e)
), Ppe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "minorTickInterval", t;
  }(_e)
), Ipe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "minVisualRangeLength", t;
  }(_e)
), Npe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "panes", t.IsCollectionItem = !0, t;
  }(_e)
), Vpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "border", t;
  }(_e)
), Ohe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "point", t.ExpectedChildren = {
      border: { optionName: "border", isCollectionItem: !1 },
      color: { optionName: "color", isCollectionItem: !1 },
      hoverStyle: { optionName: "hoverStyle", isCollectionItem: !1 },
      image: { optionName: "image", isCollectionItem: !1 },
      pointBorder: { optionName: "border", isCollectionItem: !1 },
      pointHoverStyle: { optionName: "hoverStyle", isCollectionItem: !1 },
      pointImage: { optionName: "image", isCollectionItem: !1 },
      pointSelectionStyle: { optionName: "selectionStyle", isCollectionItem: !1 },
      selectionStyle: { optionName: "selectionStyle", isCollectionItem: !1 }
    }, t;
  }(_e)
), Fpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "border", t;
  }(_e)
), Bpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "hoverStyle", t.ExpectedChildren = {
      border: { optionName: "border", isCollectionItem: !1 },
      color: { optionName: "color", isCollectionItem: !1 },
      pointBorder: { optionName: "border", isCollectionItem: !1 }
    }, t;
  }(_e)
), zpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "image", t.ExpectedChildren = {
      height: { optionName: "height", isCollectionItem: !1 },
      url: { optionName: "url", isCollectionItem: !1 },
      width: { optionName: "width", isCollectionItem: !1 }
    }, t;
  }(_e)
), Hpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "selectionStyle", t.ExpectedChildren = {
      border: { optionName: "border", isCollectionItem: !1 },
      color: { optionName: "color", isCollectionItem: !1 },
      pointBorder: { optionName: "border", isCollectionItem: !1 }
    }, t;
  }(_e)
), Gpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "reduction", t;
  }(_e)
), Upe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "scrollBar", t;
  }(_e)
), jpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "selectionStyle", t;
  }(_e)
), khe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "series", t.IsCollectionItem = !0, t;
  }(_e)
), $pe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "border", t;
  }(_e)
), Ype = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "seriesTemplate", t;
  }(_e)
), Wpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "shadow", t;
  }(_e)
), Xpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "size", t;
  }(_e)
), qpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "strips", t.IsCollectionItem = !0, t;
  }(_e)
), Kpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "label", t;
  }(_e)
), Zpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "stripStyle", t.ExpectedChildren = {
      label: { optionName: "label", isCollectionItem: !1 },
      stripStyleLabel: { optionName: "label", isCollectionItem: !1 }
    }, t;
  }(_e)
), Qpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "label", t;
  }(_e)
), Jpe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "subtitle", t;
  }(_e)
), ege = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "tick", t;
  }(_e)
), tge = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "tickInterval", t;
  }(_e)
), Rhe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "title", t;
  }(_e)
), Dhe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "tooltip", t.ExpectedChildren = {
      argumentFormat: { optionName: "argumentFormat", isCollectionItem: !1 },
      border: { optionName: "border", isCollectionItem: !1 },
      font: { optionName: "font", isCollectionItem: !1 },
      format: { optionName: "format", isCollectionItem: !1 },
      shadow: { optionName: "shadow", isCollectionItem: !1 },
      tooltipBorder: { optionName: "border", isCollectionItem: !1 }
    }, t.TemplateProps = [{
      tmplOption: "contentTemplate",
      render: "contentRender",
      component: "contentComponent",
      keyFn: "contentKeyFn"
    }], t;
  }(_e)
), rge = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "border", t;
  }(_e)
), nge = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "url", t;
  }(_e)
), Mhe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "valueAxis", t.IsCollectionItem = !0, t.DefaultsProps = {
      defaultCategories: "categories",
      defaultVisualRange: "visualRange"
    }, t.ExpectedChildren = {
      axisConstantLineStyle: { optionName: "constantLineStyle", isCollectionItem: !1 },
      axisLabel: { optionName: "label", isCollectionItem: !1 },
      axisTitle: { optionName: "title", isCollectionItem: !1 },
      break: { optionName: "breaks", isCollectionItem: !0 },
      constantLine: { optionName: "constantLines", isCollectionItem: !0 },
      constantLineStyle: { optionName: "constantLineStyle", isCollectionItem: !1 },
      label: { optionName: "label", isCollectionItem: !1 },
      minorTickInterval: { optionName: "minorTickInterval", isCollectionItem: !1 },
      minVisualRangeLength: { optionName: "minVisualRangeLength", isCollectionItem: !1 },
      strip: { optionName: "strips", isCollectionItem: !0 },
      tickInterval: { optionName: "tickInterval", isCollectionItem: !1 },
      title: { optionName: "title", isCollectionItem: !1 },
      visualRange: { optionName: "visualRange", isCollectionItem: !1 },
      wholeRange: { optionName: "wholeRange", isCollectionItem: !1 }
    }, t;
  }(_e)
), ige = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "valueErrorBar", t;
  }(_e)
), age = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "verticalLine", t.ExpectedChildren = {
      horizontalLineLabel: { optionName: "label", isCollectionItem: !1 },
      label: { optionName: "label", isCollectionItem: !1 }
    }, t;
  }(_e)
), Lhe = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "visualRange", t.DefaultsProps = {
      defaultEndValue: "endValue",
      defaultStartValue: "startValue"
    }, t;
  }(_e)
), oge = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "wholeRange", t.DefaultsProps = {
      defaultEndValue: "endValue",
      defaultStartValue: "startValue"
    }, t;
  }(_e)
), sge = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "width", t;
  }(_e)
), lge = (
  /** @class */
  function(e) {
    Le(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "zoomAndPan", t.ExpectedChildren = {
      dragBoxStyle: { optionName: "dragBoxStyle", isCollectionItem: !1 }
    }, t;
  }(_e)
);
function Phe(e) {
  const {
    advanced: t = {},
    series: r = []
  } = e, {
    allowCrosshair: n = !1,
    allowExporting: i = !1,
    allowLegend: s = !0,
    allowTooltip: l = !1,
    overlapping: d = "rotate"
  } = t, h = ho(
    (m) => {
      if (!e.limit || !("value" in m))
        return {};
      const x = m.value;
      if (typeof x == "number") {
        if (e.limit.max && x > e.limit.max.value)
          return {
            color: e.limit.max.color,
            hoverStyle: {
              color: e.limit.max.color
            }
          };
        if (e.limit.min && x < e.limit.min.value)
          return {
            color: e.limit.min.color,
            hoverStyle: {
              color: e.limit.min.color
            }
          };
      }
      return {};
    },
    [e.limit]
  ), p = Fd(() => e.type !== "area" && e.type !== "line" && e.type !== "spline", [e.type]);
  return /* @__PURE__ */ At.jsxs(
    d$,
    {
      customizePoint: h,
      dataSource: e.dataSource,
      palette: e.theme,
      children: [
        /* @__PURE__ */ At.jsx(
          She,
          {
            argumentField: t.entity,
            type: e.type,
            children: /* @__PURE__ */ At.jsx(Ohe, { hoverMode: "allArgumentPoints" })
          }
        ),
        r.filter((m) => m.visible !== void 0 && m.visible !== null ? m.visible : !0).map((m) => /* @__PURE__ */ At.jsx(
          khe,
          {
            argumentField: m.field,
            color: m.color,
            name: m.label,
            valueField: m.value
          },
          m.value
        )),
        e.limit && /* @__PURE__ */ At.jsxs(Mhe, { maxValueMargin: 0.01, children: [
          e.limit.start && /* @__PURE__ */ At.jsx(Lhe, { startValue: e.limit.start }),
          e.limit.max && /* @__PURE__ */ At.jsx(
            pH,
            {
              width: 2,
              value: e.limit.max.value,
              color: e.limit.max.color,
              dashStyle: "dash",
              children: /* @__PURE__ */ At.jsx(QC, { text: e.limit.max.title })
            }
          ),
          e.limit.min && /* @__PURE__ */ At.jsx(
            pH,
            {
              width: 2,
              value: e.limit.min.value,
              color: e.limit.min.color,
              dashStyle: "dash",
              children: /* @__PURE__ */ At.jsx(QC, { text: e.limit.min.title })
            }
          )
        ] }),
        n && /* @__PURE__ */ At.jsx(
          Che,
          {
            color: "#949494",
            dashStyle: "dot",
            enabled: !0,
            width: 3,
            children: /* @__PURE__ */ At.jsx(QC, { visible: !0, backgroundColor: "#949494", children: /* @__PURE__ */ At.jsx(The, { color: "#fff", size: 12 }) })
          }
        ),
        /* @__PURE__ */ At.jsxs(
          bhe,
          {
            valueMarginsEnabled: p,
            discreteAxisDivisionMode: "crossLabels",
            children: [
              /* @__PURE__ */ At.jsx(whe, { visible: n }),
              /* @__PURE__ */ At.jsx(QC, { wordWrap: "none", overlappingBehavior: d })
            ]
          }
        ),
        /* @__PURE__ */ At.jsx(Rhe, { text: e.title, subtitle: e.subtitle }),
        /* @__PURE__ */ At.jsx(Ahe, { visible: s }),
        /* @__PURE__ */ At.jsx(Ehe, { enabled: i }),
        /* @__PURE__ */ At.jsx(Dhe, { enabled: l || n })
      ]
    }
  );
}
var gE = {
  name: "center_template_pie_chart",
  init: Y,
  dispose: function() {
    this._centerTemplateGroup.linkOff().dispose();
  },
  extenders: {
    _createHtmlStructure() {
      var e = Oi(this._themeManager._font);
      this._centerTemplateGroup = this._renderer.g().attr({
        class: "dxc-hole-template"
      }).linkOn(this._renderer.root, "center-template").css(e).linkAppend();
    },
    _renderExtraElements() {
      this._requestChange(["CENTER_TEMPLATE"]);
    }
  },
  members: {
    _renderCenterTemplate() {
      var e = this.option("centerTemplate"), t = this._centerTemplateGroup.clear();
      if (e) {
        t.attr({
          visibility: "hidden"
        });
        var r = this._getCenter();
        this._getTemplate(e).render({
          model: this,
          container: t.element,
          onRendered: () => {
            var n = t, i = n.getBBox(), s = i.x + i.width / 2, l = i.y + i.height / 2;
            n.move(r.x - s, r.y - l), n.attr({
              visibility: "visible"
            });
          }
        });
      }
    }
  },
  customize(e) {
    e.addChange({
      code: "CENTER_TEMPLATE",
      handler: function() {
        this._renderCenterTemplate();
      },
      option: "centerTemplate"
    });
  }
}, Ihe = {
  name: "center_template_gauge",
  init: Y,
  dispose: gE.dispose,
  extenders: {
    _initCore() {
      this._createCenterTemplateGroup();
    },
    _renderContent() {
      var e = Oi(this._themeManager._font);
      this._centerTemplateGroup.css(e), this._requestChange(["CENTER_TEMPLATE"]);
    },
    _updateExtraElements() {
      this._requestChange(["CENTER_TEMPLATE"]);
    }
  },
  members: {
    _renderCenterTemplate: gE.members._renderCenterTemplate,
    _createCenterTemplateGroup() {
      this._centerTemplateGroup = this._renderer.g().attr({
        class: "dxg-hole-template"
      }).linkOn(this._renderer.root, "center-template").linkAppend();
    }
  },
  customize: gE.customize
}, Nhe = {
  pieChart: gE,
  gauge: Ihe
}, uh = Number;
function fM() {
  this.setDomain(arguments[0], arguments[1]).setCodomain(arguments[2], arguments[3]).setInverted(!1);
}
fM.prototype = {
  constructor: fM,
  setDomain: function(e, t) {
    return this._domain1 = uh(e), this._domain2 = uh(t), this._domainDelta = this._domain2 - this._domain1, this;
  },
  setCodomain: function(e, t) {
    return this._codomain1 = uh(e), this._codomain2 = uh(t), this._codomainDelta = this._codomain2 - this._codomain1, this;
  },
  setInverted(e) {
    this.inverted = e;
  },
  getDomain: function() {
    return [this._domain1, this._domain2];
  },
  getCodomain: function() {
    return [this._codomain1, this._codomain2];
  },
  getDomainStart: function() {
    return this._domain1;
  },
  getDomainEnd: function() {
    return this._domain2;
  },
  getCodomainStart: function() {
    return this._codomain1;
  },
  getCodomainEnd: function() {
    return this._codomain2;
  },
  getDomainRange: function() {
    return this._domainDelta;
  },
  getCodomainRange: function() {
    return this._codomainDelta;
  },
  translate: function(e) {
    var t = (uh(e) - this._domain1) / this._domainDelta;
    return this.inverted && (t = 1 - t), 0 <= t && t <= 1 ? this._codomain1 + t * this._codomainDelta : NaN;
  },
  adjust: function(e) {
    var t = (uh(e) - this._domain1) / this._domainDelta, r = NaN;
    return t < 0 ? r = this._domain1 : t > 1 ? r = this._domain2 : 0 <= t && t <= 1 && (r = uh(e)), r;
  }
};
var {
  states: Sh
} = Is, gH = Is.pieSeriesSpacing, Vhe = ["startAngle", "innerRadius", "segmentsDirection", "type"], Fhe = Sh.normalMark, Bhe = Sh.hoverMark, zhe = Sh.selectedMark, Hhe = 5, Ghe = [Sh.resetItem, Sh.applyHover, Sh.applySelected, Sh.applySelected];
function mH(e, t) {
  return {
    x: e.x,
    y: e.y - t
  };
}
function _H(e, t) {
  return e.getVisiblePoints().reduce((r, n) => {
    var i = Ll(n.middleAngle);
    return (i <= 90 || i >= 270 ? r.right : r.left).push(n), r;
  }, t || {
    left: [],
    right: []
  });
}
function kR(e, t, r, n) {
  var i;
  return r && (e.left.reverse(), e.right.reverse()), i = aM.resolveLabelOverlappingInOneDirection(e.left, n, !1, !1, t), aM.resolveLabelOverlappingInOneDirection(e.right, n, !1, !1, t) || i;
}
function Uhe(e) {
  var t = Fhe;
  return e.forEach((r) => {
    var n, i = (n = r.series) === null || n === void 0 ? void 0 : n.getOptions(), s = r.fullState;
    (i == null ? void 0 : i.hoverMode) === "none" && (s &= ~Bhe), (i == null ? void 0 : i.selectionMode) === "none" && (s &= ~zhe), t |= s;
  }), Ghe[t];
}
function yH(e) {
  return Sr(e) ? e > 1 ? e = 1 : e < 0 && (e = 0) : e = void 0, e;
}
var xH = /* @__PURE__ */ function() {
  function e(n, i) {
    return n.filter((s) => s !== i);
  }
  var t = [], r = {};
  return {
    queue(n) {
      var i = n.getSizeGroup();
      t = (s = t, l = n, e(s, l).concat(l));
      var s, l;
      clearTimeout(r[i]), r[i] = setTimeout(() => {
        (function(d, h) {
          var p = h.filter((S) => S._isVisible() && S.getSizeGroup() === d), m = Math.min.apply(null, p.map((S) => S.getSizeGroupLayout().radius)), x = p.filter((S) => S.getSizeGroupLayout().radius === m);
          p.forEach((S) => S.render({
            force: !0,
            sizeGroupLayout: x.length ? x[0].getSizeGroupLayout() : {}
          }));
        })(i, t);
      });
    },
    remove(n) {
      t = e(t, n), t.length || (r = {});
    }
  };
}(), qg = Yo.inherit({
  _themeSection: "pie",
  _layoutManagerOptions() {
    return W(!0, {}, this.callBase(), {
      piePercentage: yH(this._themeManager.getOptions("diameter")),
      minPiePercentage: yH(this._themeManager.getOptions("minDiameter"))
    });
  },
  _optionChangesMap: {
    diameter: "REINIT",
    minDiameter: "REINIT",
    sizeGroup: "REINIT"
  },
  _disposeCore() {
    xH.remove(this), this.callBase();
  },
  _groupSeries() {
    var e, {
      series: t
    } = this;
    this._groupsData = {
      groups: [{
        series: t,
        valueOptions: {
          valueType: "numeric"
        }
      }],
      argumentOptions: (e = t[0]) === null || e === void 0 ? void 0 : e.getOptions()
    };
  },
  getArgumentAxis: () => null,
  _getValueAxis() {
    var e = new fM().setCodomain(360, 0);
    return {
      getTranslator: () => e,
      setBusinessRange(t) {
        e.setDomain(t.min, t.max);
      }
    };
  },
  _populateBusinessRange() {
    this.series.map((e) => {
      var t = new _a();
      return t.addRange(e.getRangeData().val), e.getValueAxis().setBusinessRange(t), t;
    });
  },
  _specialProcessSeries() {
    be(this.series, (e, t) => {
      t.arrangePoints();
    });
  },
  _checkPaneName: () => !0,
  _processSingleSeries(e) {
    this.callBase(e), e.arrangePoints();
  },
  _handleSeriesDataUpdated() {
    var e = 0;
    this.series.forEach((t) => {
      e = Math.max(t.getPointsCount(), e);
    }), this.series.forEach((t) => {
      t.setMaxPointsCount(e);
    }), this.callBase();
  },
  _getLegendOptions(e) {
    var t = this.callBase(e), {
      legendData: r
    } = t;
    return r.argument = e.argument, r.argumentIndex = e.argumentIndex, r.points = [e], t;
  },
  _getLegendTargets() {
    var e = {};
    (this.series || []).forEach((r) => {
      r.getPoints().forEach((n) => {
        var i = n.argument.valueOf(), s = r.getPointsByArg(i).indexOf(n), l = i.valueOf().toString() + s;
        e[l] = e[l] || [];
        var d = e[l].push(n);
        n.index = e[l][d - 2] ? e[l][d - 2].index : Object.keys(e).length - 1, n.argumentIndex = s;
      });
    });
    var t = [];
    return be(e, (r, n) => {
      n.forEach((i, s) => {
        if (s === 0) {
          t.push(this._getLegendOptions(i));
          return;
        }
        var l = t[t.length - 1];
        l.legendData.points.push(i), l.visible || (l.visible = i.isVisible());
      });
    }), t;
  },
  _getLayoutTargets() {
    return [{
      canvas: this._canvas
    }];
  },
  _getLayoutSeries(e, t) {
    var r, n = this._canvas, i = !1;
    return r = this.layoutManager.applyPieChartSeriesLayout(n, e, !0), e.forEach((s) => {
      s.correctPosition(r, n), i = s.drawLabelsWOPoints() || i;
    }), i && (r = this.layoutManager.applyPieChartSeriesLayout(n, e, t.hideLayoutLabels)), e.forEach((s) => {
      s.hideLabels();
    }), this._sizeGroupLayout = {
      x: r.centerX,
      y: r.centerY,
      radius: r.radiusOuter,
      drawOptions: t
    }, r;
  },
  _getLayoutSeriesForEqualPies(e, t) {
    var r = this._canvas, n = this.layoutManager.applyEqualPieChartLayout(e, t);
    return e.forEach((i) => {
      i.correctPosition(n, r), i.drawLabelsWOPoints();
    }), this.layoutManager.correctPieLabelRadius(e, n, r), n;
  },
  _updateSeriesDimensions(e) {
    var t = this._getVisibleSeries(), r = t.length, n, i, s, {
      sizeGroupLayout: l
    } = e;
    r && (s = l ? this._getLayoutSeriesForEqualPies(t, l) : this._getLayoutSeries(t, e), i = (s.radiusOuter - s.radiusInner - gH * (r - 1)) / r, n = s.radiusInner, this._setGeometry(s), t.forEach((d) => {
      d.correctRadius({
        radiusInner: n,
        radiusOuter: n + i
      }), n += i + gH;
    }));
  },
  _renderSeries(e, t, r) {
    if (this._calculateSeriesLayout(e, t), !e.sizeGroupLayout && this.getSizeGroup()) {
      xH.queue(this), this._clearCanvas();
      return;
    }
    this._renderSeriesElements(e, r);
  },
  _getCenter() {
    return this._center;
  },
  getInnerRadius() {
    return this._innerRadius;
  },
  _getLegendCallBack() {
    var e = this._legend, t = this._getLegendTargets().map((r) => r.legendData);
    return (r) => {
      t.forEach((n) => {
        var i = [], s = e.getActionCallback({
          index: n.id
        });
        this.series.forEach((l) => {
          var d = l.getPointsByKeys(n.argument, n.argumentIndex);
          i.push.apply(i, d);
        }), r && r.argument === n.argument && r.argumentIndex === n.argumentIndex && i.push(r), s(Uhe(i));
      });
    };
  },
  _locateLabels(e) {
    var t = 0, r, n;
    do
      n = this._adjustSeriesLabels(e === "shift"), r = this._resolveLabelOverlapping(e);
    while ((r || n) && ++t < Hhe);
  },
  _adjustSeriesLabels(e) {
    return this.series.reduce((t, r) => r.adjustLabels(e) || t, !1);
  },
  _applyExtraSettings: Y,
  _resolveLabelOverlappingShift() {
    var e = this.option("segmentsDirection") === "anticlockwise", t = this.series.reduce((i, s) => ((i[s.getOptions().label.position] || i.outside).push(s), i), {
      inside: [],
      columns: [],
      outside: []
    }), r = !1;
    if (t.inside.length > 0) {
      var n = t.inside.reduce((i, s) => {
        var l = s.getVisiblePoints();
        return l.reduce((d, h) => (d.left.push(h), d), i);
      }, {
        left: [],
        right: []
      });
      r = kR(n, mH, e, this._canvas) || r;
    }
    return r = t.columns.reduce((i, s) => kR(_H(s), mH, e, this._canvas) || i, r), t.outside.length > 0 && (r = kR(t.outside.reduce((i, s) => _H(s, i), null), (i, s) => HG(i, -s, this._center), e, this._canvas) || r), r;
  },
  _setGeometry(e) {
    var {
      centerX: t,
      centerY: r,
      radiusInner: n
    } = e;
    this._center = {
      x: t,
      y: r
    }, this._innerRadius = n;
  },
  _disposeSeries() {
    this.callBase.apply(this, arguments), this._abstractSeries = null;
  },
  _legendDataField: "point",
  _legendItemTextField: "argument",
  _applyPointMarkersAutoHiding: Y,
  _renderTrackers: Y,
  _trackerType: "PieTracker",
  _createScrollBar: Y,
  _updateAxesLayout: Y,
  _applyClipRects: Y,
  _appendAdditionalSeriesGroups: Y,
  _prepareToRender: Y,
  _isLegendInside: Y,
  _renderAxes: Y,
  _shrinkAxes: Y,
  _isRotated: Y,
  _seriesPopulatedHandlerCore: Y,
  _reinitAxes: Y,
  _correctAxes: Y,
  _getExtraOptions() {
    return {
      startAngle: this.option("startAngle"),
      innerRadius: this.option("innerRadius"),
      segmentsDirection: this.option("segmentsDirection"),
      type: this.option("type")
    };
  },
  getSizeGroup() {
    return this._themeManager.getOptions("sizeGroup");
  },
  getSizeGroupLayout() {
    return this._sizeGroupLayout || {};
  }
});
be(Vhe, (e, t) => {
  qg.prototype._optionChangesMap[t] = "REFRESH_SERIES_DATA_INIT";
});
qg.addPlugin(Nhe.pieChart);
qg.addPlugin(MT.core);
qg.addPlugin(MT.pieChart);
gG("dxPieChart", qg);
/*!
 * devextreme-react
 * Version: 23.2.4
 * Build date: Mon Jan 29 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */
var Xt = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var s in i)
        Object.prototype.hasOwnProperty.call(i, s) && (n[s] = i[s]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), f$ = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      var r = e !== null && e.apply(this, arguments) || this;
      return r._WidgetClass = qg, r.subscribableOptions = ["loadingIndicator", "loadingIndicator.show"], r.independentEvents = ["onDisposing", "onDone", "onDrawn", "onExported", "onExporting", "onFileSaving", "onIncidentOccurred", "onInitialized", "onLegendClick", "onPointClick", "onTooltipHidden", "onTooltipShown"], r._defaults = {
        defaultLoadingIndicator: "loadingIndicator"
      }, r._expectedChildren = {
        adaptiveLayout: { optionName: "adaptiveLayout", isCollectionItem: !1 },
        animation: { optionName: "animation", isCollectionItem: !1 },
        annotation: { optionName: "annotations", isCollectionItem: !0 },
        commonAnnotationSettings: { optionName: "commonAnnotationSettings", isCollectionItem: !1 },
        commonSeriesSettings: { optionName: "commonSeriesSettings", isCollectionItem: !1 },
        export: { optionName: "export", isCollectionItem: !1 },
        legend: { optionName: "legend", isCollectionItem: !1 },
        loadingIndicator: { optionName: "loadingIndicator", isCollectionItem: !1 },
        margin: { optionName: "margin", isCollectionItem: !1 },
        pieChartTitle: { optionName: "title", isCollectionItem: !1 },
        series: { optionName: "series", isCollectionItem: !0 },
        seriesTemplate: { optionName: "seriesTemplate", isCollectionItem: !1 },
        size: { optionName: "size", isCollectionItem: !1 },
        title: { optionName: "title", isCollectionItem: !1 },
        tooltip: { optionName: "tooltip", isCollectionItem: !1 }
      }, r._templateProps = [{
        tmplOption: "centerTemplate",
        render: "centerRender",
        component: "centerComponent",
        keyFn: "centerKeyFn"
      }], r;
    }
    return Object.defineProperty(t.prototype, "instance", {
      get: function() {
        return this._instance;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(c$)
);
f$.propTypes = {
  adaptiveLayout: re.object,
  animation: re.oneOfType([
    re.bool,
    re.object
  ]),
  annotations: re.array,
  commonAnnotationSettings: re.object,
  customizeAnnotation: re.func,
  customizeLabel: re.func,
  customizePoint: re.func,
  diameter: re.number,
  disabled: re.bool,
  elementAttr: re.object,
  export: re.object,
  innerRadius: re.number,
  legend: re.object,
  loadingIndicator: re.object,
  margin: re.object,
  minDiameter: re.number,
  onDisposing: re.func,
  onDone: re.func,
  onDrawn: re.func,
  onExported: re.func,
  onExporting: re.func,
  onFileSaving: re.func,
  onIncidentOccurred: re.func,
  onInitialized: re.func,
  onLegendClick: re.func,
  onOptionChanged: re.func,
  onPointClick: re.func,
  onPointHoverChanged: re.func,
  onPointSelectionChanged: re.func,
  onTooltipHidden: re.func,
  onTooltipShown: re.func,
  palette: re.oneOfType([
    re.array,
    re.oneOfType([
      re.string,
      re.oneOf([
        "Bright",
        "Harmony Light",
        "Ocean",
        "Pastel",
        "Soft",
        "Soft Pastel",
        "Vintage",
        "Violet",
        "Carmine",
        "Dark Moon",
        "Dark Violet",
        "Green Mist",
        "Soft Blue",
        "Material",
        "Office"
      ])
    ])
  ]),
  paletteExtensionMode: re.oneOfType([
    re.string,
    re.oneOf([
      "alternate",
      "blend",
      "extrapolate"
    ])
  ]),
  pathModified: re.bool,
  pointSelectionMode: re.oneOfType([
    re.string,
    re.oneOf([
      "single",
      "multiple"
    ])
  ]),
  redrawOnResize: re.bool,
  resolveLabelOverlapping: re.oneOfType([
    re.string,
    re.oneOf([
      "hide",
      "none",
      "shift"
    ])
  ]),
  rtlEnabled: re.bool,
  segmentsDirection: re.oneOfType([
    re.string,
    re.oneOf([
      "anticlockwise",
      "clockwise"
    ])
  ]),
  series: re.oneOfType([
    re.array,
    re.object
  ]),
  seriesTemplate: re.object,
  size: re.object,
  sizeGroup: re.string,
  startAngle: re.number,
  theme: re.oneOfType([
    re.string,
    re.oneOf([
      "generic.dark",
      "generic.light",
      "generic.contrast",
      "generic.carmine",
      "generic.darkmoon",
      "generic.darkviolet",
      "generic.greenmist",
      "generic.softblue",
      "material.blue.light",
      "material.lime.light",
      "material.orange.light",
      "material.purple.light",
      "material.teal.light"
    ])
  ]),
  title: re.oneOfType([
    re.object,
    re.string
  ]),
  tooltip: re.object,
  type: re.oneOfType([
    re.string,
    re.oneOf([
      "donut",
      "doughnut",
      "pie"
    ])
  ])
};
var uge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "adaptiveLayout", t;
  }(_e)
), cge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "animation", t;
  }(_e)
), dge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "annotations", t.IsCollectionItem = !0, t.ExpectedChildren = {
      annotationBorder: { optionName: "border", isCollectionItem: !1 },
      border: { optionName: "border", isCollectionItem: !1 },
      font: { optionName: "font", isCollectionItem: !1 },
      image: { optionName: "image", isCollectionItem: !1 },
      shadow: { optionName: "shadow", isCollectionItem: !1 }
    }, t.TemplateProps = [{
      tmplOption: "template",
      render: "render",
      component: "component",
      keyFn: "keyFn"
    }, {
      tmplOption: "tooltipTemplate",
      render: "tooltipRender",
      component: "tooltipComponent",
      keyFn: "tooltipKeyFn"
    }], t;
  }(_e)
), fge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "border", t;
  }(_e)
), hge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "argumentFormat", t;
  }(_e)
), vge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "border", t;
  }(_e)
), pge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "color", t;
  }(_e)
), gge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "commonAnnotationSettings", t.TemplateProps = [{
      tmplOption: "template",
      render: "render",
      component: "component",
      keyFn: "keyFn"
    }, {
      tmplOption: "tooltipTemplate",
      render: "tooltipRender",
      component: "tooltipComponent",
      keyFn: "tooltipKeyFn"
    }], t;
  }(_e)
), mge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "commonSeriesSettings", t.ExpectedChildren = {
      border: { optionName: "border", isCollectionItem: !1 },
      color: { optionName: "color", isCollectionItem: !1 },
      hoverStyle: { optionName: "hoverStyle", isCollectionItem: !1 },
      label: { optionName: "label", isCollectionItem: !1 },
      selectionStyle: { optionName: "selectionStyle", isCollectionItem: !1 },
      seriesBorder: { optionName: "border", isCollectionItem: !1 },
      smallValuesGrouping: { optionName: "smallValuesGrouping", isCollectionItem: !1 }
    }, t;
  }(_e)
), jhe = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "connector", t;
  }(_e)
), $he = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "export", t;
  }(_e)
), _ge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "font", t;
  }(_e)
), Yhe = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "format", t;
  }(_e)
), yge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "hatching", t;
  }(_e)
), xge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "hoverStyle", t.ExpectedChildren = {
      border: { optionName: "border", isCollectionItem: !1 },
      color: { optionName: "color", isCollectionItem: !1 },
      hatching: { optionName: "hatching", isCollectionItem: !1 },
      seriesBorder: { optionName: "border", isCollectionItem: !1 }
    }, t;
  }(_e)
), bge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "image", t;
  }(_e)
), Whe = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "label", t.ExpectedChildren = {
      argumentFormat: { optionName: "argumentFormat", isCollectionItem: !1 },
      border: { optionName: "border", isCollectionItem: !1 },
      connector: { optionName: "connector", isCollectionItem: !1 },
      font: { optionName: "font", isCollectionItem: !1 },
      format: { optionName: "format", isCollectionItem: !1 },
      seriesBorder: { optionName: "border", isCollectionItem: !1 }
    }, t;
  }(_e)
), Xhe = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "legend", t.ExpectedChildren = {
      annotationBorder: { optionName: "border", isCollectionItem: !1 },
      border: { optionName: "border", isCollectionItem: !1 },
      font: { optionName: "font", isCollectionItem: !1 },
      legendTitle: { optionName: "title", isCollectionItem: !1 },
      margin: { optionName: "margin", isCollectionItem: !1 },
      title: { optionName: "title", isCollectionItem: !1 }
    }, t.TemplateProps = [{
      tmplOption: "markerTemplate",
      render: "markerRender",
      component: "markerComponent",
      keyFn: "markerKeyFn"
    }], t;
  }(_e)
), Sge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "title", t.ExpectedChildren = {
      font: { optionName: "font", isCollectionItem: !1 },
      legendTitleSubtitle: { optionName: "subtitle", isCollectionItem: !1 },
      margin: { optionName: "margin", isCollectionItem: !1 },
      subtitle: { optionName: "subtitle", isCollectionItem: !1 }
    }, t;
  }(_e)
), Cge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "subtitle", t.ExpectedChildren = {
      font: { optionName: "font", isCollectionItem: !1 }
    }, t;
  }(_e)
), Ege = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "loadingIndicator", t.DefaultsProps = {
      defaultShow: "show"
    }, t.ExpectedChildren = {
      font: { optionName: "font", isCollectionItem: !1 }
    }, t;
  }(_e)
), Tge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "margin", t;
  }(_e)
), wge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "title", t.ExpectedChildren = {
      font: { optionName: "font", isCollectionItem: !1 },
      margin: { optionName: "margin", isCollectionItem: !1 },
      pieChartTitleSubtitle: { optionName: "subtitle", isCollectionItem: !1 },
      subtitle: { optionName: "subtitle", isCollectionItem: !1 }
    }, t;
  }(_e)
), Age = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "subtitle", t.ExpectedChildren = {
      font: { optionName: "font", isCollectionItem: !1 }
    }, t;
  }(_e)
), Oge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "selectionStyle", t.ExpectedChildren = {
      border: { optionName: "border", isCollectionItem: !1 },
      color: { optionName: "color", isCollectionItem: !1 },
      hatching: { optionName: "hatching", isCollectionItem: !1 },
      seriesBorder: { optionName: "border", isCollectionItem: !1 }
    }, t;
  }(_e)
), qhe = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "series", t.IsCollectionItem = !0, t;
  }(_e)
), kge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "border", t;
  }(_e)
), Rge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "seriesTemplate", t;
  }(_e)
), Dge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "shadow", t;
  }(_e)
), Mge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "size", t;
  }(_e)
), Lge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "smallValuesGrouping", t;
  }(_e)
), Pge = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "subtitle", t;
  }(_e)
), Khe = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "title", t;
  }(_e)
), Zhe = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "tooltip", t.ExpectedChildren = {
      argumentFormat: { optionName: "argumentFormat", isCollectionItem: !1 },
      border: { optionName: "border", isCollectionItem: !1 },
      font: { optionName: "font", isCollectionItem: !1 },
      format: { optionName: "format", isCollectionItem: !1 },
      shadow: { optionName: "shadow", isCollectionItem: !1 },
      tooltipBorder: { optionName: "border", isCollectionItem: !1 }
    }, t.TemplateProps = [{
      tmplOption: "contentTemplate",
      render: "contentRender",
      component: "contentComponent",
      keyFn: "contentKeyFn"
    }], t;
  }(_e)
), Ige = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.OptionName = "border", t;
  }(_e)
);
function Qhe(e) {
  var s, l;
  const {
    advanced: t = {}
  } = e, {
    allowExporting: r = !1,
    allowLegend: n = !0,
    allowTooltip: i = !1
  } = t;
  return /* @__PURE__ */ At.jsxs(
    f$,
    {
      type: e.type,
      palette: e.theme,
      dataSource: e.dataSource,
      children: [
        /* @__PURE__ */ At.jsx(qhe, { argumentField: t.entity, children: /* @__PURE__ */ At.jsx(Whe, { visible: !0, format: (s = e.advanced) == null ? void 0 : s.format, children: /* @__PURE__ */ At.jsx(jhe, { visible: !0 }) }) }),
        /* @__PURE__ */ At.jsx(Khe, { text: e.title, subtitle: e.subtitle }),
        /* @__PURE__ */ At.jsx(Xhe, { visible: n }),
        /* @__PURE__ */ At.jsx($he, { enabled: r }),
        /* @__PURE__ */ At.jsx(Zhe, { enabled: i, children: /* @__PURE__ */ At.jsx(Yhe, { type: (l = e.advanced) == null ? void 0 : l.format }) })
      ]
    }
  );
}
function Jhe(e) {
  const {
    advanced: t = {},
    dataSource: r = [],
    type: n
  } = e, {
    refresh: i = void 0,
    revalidate: s = !0
  } = t, l = {
    refreshInterval: i,
    revalidateOnFocus: s
  }, d = Fd(() => !Array.isArray(r) && !DH.isUndefined(r.url) ? {
    url: r.url,
    args: {
      body: r.parameter,
      headers: r.headers,
      method: r.method,
      namespace: r.namespace,
      pagination: r.pagination
    }
  } : null, [r]), { data: h = [] } = UH(d, LH, l), p = Array.isArray(r) ? r : h;
  return n === "donut" || n === "doughnut" || n === "pie" ? /* @__PURE__ */ At.jsx(Qhe, { ...e, dataSource: p, type: n }) : /* @__PURE__ */ At.jsx(Phe, { ...e, dataSource: p, type: n });
}
Zr({
  licenseKey: "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjJhYTQ1YWUzLTk1YjUtMTFlMy1hZTM3LTAwMjE5YjhiMmNhNyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjMyCn0=.BWxPoCpEdVEvZifc1llI4HZgqr9aws3Vvw6YTu2WnB5JVjprLlcBTZvXaGMIqglhvSeBBtKs3C6ZpfHwNOG+VFZOBM0+s72jpq4jcAPyEtvq50ZbUCEii9rIgR2au5eWuhR2qg=="
});
function Nge(e) {
  var r;
  const t = e.type;
  return t === "card" ? /* @__PURE__ */ At.jsx(
    CX,
    {
      ...e,
      dataSource: Array.isArray(e.dataSource) ? void 0 : e.dataSource,
      type: (r = e.advanced) == null ? void 0 : r.type
    }
  ) : /* @__PURE__ */ At.jsx(Jhe, { ...e, type: t, theme: e.theme });
}
export {
  Nge as default
};
//# sourceMappingURL=kanela-react-chart-adapter.es.js.map
